import 'webrtc-adapter';
import * as sdptransform from 'sdp-transform';
import * as socket_io from 'socket.io-client';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getDefaultExportFromNamespaceIfPresent (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') ? n['default'] : n;
}

function getDefaultExportFromNamespaceIfNotNamed (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
				var args = [null];
				args.push.apply(args, arguments);
				var Ctor = Function.bind.apply(f, args);
				return new Ctor();
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var clientsdkClientcore_jsExports = {};
var clientsdkClientcore_js$1 = {
  get exports(){ return clientsdkClientcore_jsExports; },
  set exports(v){ clientsdkClientcore_jsExports = v; },
};

var kotlinKotlinStdlibExports = {};
var kotlinKotlinStdlib = {
  get exports(){ return kotlinKotlinStdlibExports; },
  set exports(v){ kotlinKotlinStdlibExports = v; },
};

var hasRequiredKotlinKotlinStdlib;

function requireKotlinKotlinStdlib () {
	if (hasRequiredKotlinKotlinStdlib) return kotlinKotlinStdlibExports;
	hasRequiredKotlinKotlinStdlib = 1;
	(function (module, exports) {
		//region block: polyfills
		if (typeof ArrayBuffer.isView === 'undefined') {
		  ArrayBuffer.isView = function (a) {
		    return a != null && a.__proto__ != null && a.__proto__.__proto__ === Int8Array.prototype.__proto__;
		  };
		}
		if (typeof Array.prototype.fill === 'undefined') {
		  // Polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill#Polyfill
		  Object.defineProperty(Array.prototype, 'fill', {value: function (value) {
		    // Steps 1-2.
		    if (this == null) {
		      throw new TypeError('this is null or not defined');
		    }
		    var O = Object(this); // Steps 3-5.
		    var len = O.length >>> 0; // Steps 6-7.
		    var start = arguments[1];
		    var relativeStart = start >> 0; // Step 8.
		    var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len); // Steps 9-10.
		    var end = arguments[2];
		    var relativeEnd = end === undefined ? len : end >> 0; // Step 11.
		    var finalValue = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len); // Step 12.
		    while (k < finalValue) {
		      O[k] = value;
		      k++;
		    }
		    ; // Step 13.
		    return O;
		  }});
		}
		[Int8Array, Int16Array, Uint16Array, Int32Array, Float32Array, Float64Array].forEach(function (TypedArray) {
		  if (typeof TypedArray.prototype.fill === 'undefined') {
		    Object.defineProperty(TypedArray.prototype, 'fill', {value: Array.prototype.fill});
		  }
		});
		if (typeof Math.clz32 === 'undefined') {
		  Math.clz32 = function (log, LN2) {
		    return function (x) {
		      var asUint = x >>> 0;
		      if (asUint === 0) {
		        return 32;
		      }
		      return 31 - (log(asUint) / LN2 | 0) | 0; // the "| 0" acts like math.floor
		    };
		  }(Math.log, Math.LN2);
		}
		if (typeof String.prototype.startsWith === 'undefined') {
		  Object.defineProperty(String.prototype, 'startsWith', {value: function (searchString, position) {
		    position = position || 0;
		    return this.lastIndexOf(searchString, position) === position;
		  }});
		}
		if (typeof Math.imul === 'undefined') {
		  Math.imul = function imul(a, b) {
		    return (a & 4.29490176E9) * (b & 65535) + (a & 65535) * (b | 0) | 0;
		  };
		}
		//endregion
		(function (root, factory) {
		  if (typeof undefined === 'function' && undefined.amd)
		    undefined(['exports'], factory);
		  else if ('object' === 'object')
		    factory(module.exports);
		  else
		    root['kotlin-kotlin-stdlib'] = factory(typeof this['kotlin-kotlin-stdlib'] === 'undefined' ? {} : this['kotlin-kotlin-stdlib']);
		}(commonjsGlobal, function (_) {
		  'use strict';
		  //region block: imports
		  var clz32 = Math.clz32;
		  var imul = Math.imul;
		  var isView = ArrayBuffer.isView;
		  //endregion
		  //region block: pre-declaration
		  setMetadataFor(CharSequence, 'CharSequence', interfaceMeta);
		  setMetadataFor(Number_0, 'Number', classMeta);
		  setMetadataFor(Unit, 'Unit', objectMeta);
		  setMetadataFor(ByteCompanionObject, 'ByteCompanionObject', objectMeta);
		  setMetadataFor(ShortCompanionObject, 'ShortCompanionObject', objectMeta);
		  setMetadataFor(IntCompanionObject, 'IntCompanionObject', objectMeta);
		  setMetadataFor(FloatCompanionObject, 'FloatCompanionObject', objectMeta);
		  setMetadataFor(DoubleCompanionObject, 'DoubleCompanionObject', objectMeta);
		  setMetadataFor(StringCompanionObject, 'StringCompanionObject', objectMeta);
		  setMetadataFor(BooleanCompanionObject, 'BooleanCompanionObject', objectMeta);
		  setMetadataFor(Collection, 'Collection', interfaceMeta);
		  setMetadataFor(AbstractCollection, 'AbstractCollection', classMeta, VOID, [Collection]);
		  setMetadataFor(AbstractMutableCollection, 'AbstractMutableCollection', classMeta, AbstractCollection, [AbstractCollection, Collection]);
		  setMetadataFor(IteratorImpl, 'IteratorImpl', classMeta);
		  setMetadataFor(List, 'List', interfaceMeta, VOID, [Collection]);
		  setMetadataFor(MutableList, 'MutableList', interfaceMeta, VOID, [List, Collection]);
		  setMetadataFor(AbstractMutableList, 'AbstractMutableList', classMeta, AbstractMutableCollection, [AbstractMutableCollection, MutableList]);
		  setMetadataFor(Map_0, 'Map', interfaceMeta);
		  setMetadataFor(AbstractMap, 'AbstractMap', classMeta, VOID, [Map_0]);
		  setMetadataFor(MutableMap, 'MutableMap', interfaceMeta, VOID, [Map_0]);
		  setMetadataFor(AbstractMutableMap, 'AbstractMutableMap', classMeta, AbstractMap, [AbstractMap, MutableMap]);
		  setMetadataFor(Set, 'Set', interfaceMeta, VOID, [Collection]);
		  setMetadataFor(MutableSet, 'MutableSet', interfaceMeta, VOID, [Set, Collection]);
		  setMetadataFor(AbstractMutableSet, 'AbstractMutableSet', classMeta, AbstractMutableCollection, [AbstractMutableCollection, MutableSet]);
		  setMetadataFor(Companion, 'Companion', objectMeta);
		  setMetadataFor(ArrayList, 'ArrayList', classMeta, AbstractMutableList, [AbstractMutableList, MutableList], ArrayList_init_$Create$);
		  setMetadataFor(HashMap, 'HashMap', classMeta, AbstractMutableMap, [AbstractMutableMap, MutableMap], HashMap_init_$Create$);
		  setMetadataFor(HashMapKeys, 'HashMapKeys', classMeta, AbstractMutableSet, [MutableSet, AbstractMutableSet]);
		  setMetadataFor(HashMapValues, 'HashMapValues', classMeta, AbstractMutableCollection, [Collection, AbstractMutableCollection]);
		  setMetadataFor(HashMapEntrySetBase, 'HashMapEntrySetBase', classMeta, AbstractMutableSet, [MutableSet, AbstractMutableSet]);
		  setMetadataFor(HashMapEntrySet, 'HashMapEntrySet', classMeta, HashMapEntrySetBase);
		  setMetadataFor(HashMapKeysDefault$iterator$1, VOID, classMeta);
		  setMetadataFor(HashMapKeysDefault, 'HashMapKeysDefault', classMeta, AbstractMutableSet);
		  setMetadataFor(HashMapValuesDefault$iterator$1, VOID, classMeta);
		  setMetadataFor(HashMapValuesDefault, 'HashMapValuesDefault', classMeta, AbstractMutableCollection);
		  setMetadataFor(HashSet, 'HashSet', classMeta, AbstractMutableSet, [AbstractMutableSet, MutableSet], HashSet_init_$Create$);
		  setMetadataFor(Companion_0, 'Companion', objectMeta);
		  setMetadataFor(Itr, 'Itr', classMeta);
		  setMetadataFor(KeysItr, 'KeysItr', classMeta, Itr);
		  setMetadataFor(ValuesItr, 'ValuesItr', classMeta, Itr);
		  setMetadataFor(EntriesItr, 'EntriesItr', classMeta, Itr);
		  setMetadataFor(Entry, 'Entry', interfaceMeta);
		  setMetadataFor(EntryRef, 'EntryRef', classMeta, VOID, [Entry]);
		  function containsAllEntries(m) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.all' call
		      var tmp;
		      if (isInterface(m, Collection)) {
		        tmp = m.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = true;
		        break $l$block_0;
		      }
		      var tmp0_iterator = m.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.collections.InternalMap.containsAllEntries.<anonymous>' call
		        // Inline function 'kotlin.js.unsafeCast' call
		        // Inline function 'kotlin.js.asDynamic' call
		        var entry = element;
		        var tmp_0;
		        if (!(entry == null) ? isInterface(entry, Entry) : false) {
		          tmp_0 = this.e5(entry);
		        } else {
		          tmp_0 = false;
		        }
		        if (!tmp_0) {
		          tmp$ret$0 = false;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  }
		  setMetadataFor(InternalMap, 'InternalMap', interfaceMeta);
		  setMetadataFor(InternalHashMap, 'InternalHashMap', classMeta, VOID, [InternalMap], InternalHashMap_init_$Create$);
		  setMetadataFor(LinkedHashMap, 'LinkedHashMap', classMeta, HashMap, [HashMap, MutableMap], LinkedHashMap_init_$Create$);
		  setMetadataFor(LinkedHashSet, 'LinkedHashSet', classMeta, HashSet, [HashSet, MutableSet], LinkedHashSet_init_$Create$);
		  setMetadataFor(KClass, 'KClass', interfaceMeta);
		  setMetadataFor(KClassImpl, 'KClassImpl', classMeta, VOID, [KClass]);
		  setMetadataFor(NothingKClassImpl, 'NothingKClassImpl', objectMeta, KClassImpl);
		  setMetadataFor(ErrorKClass, 'ErrorKClass', classMeta, VOID, [KClass], ErrorKClass);
		  setMetadataFor(PrimitiveKClassImpl, 'PrimitiveKClassImpl', classMeta, KClassImpl);
		  setMetadataFor(SimpleKClassImpl, 'SimpleKClassImpl', classMeta, KClassImpl);
		  setMetadataFor(KProperty1, 'KProperty1', interfaceMeta);
		  setMetadataFor(KTypeImpl, 'KTypeImpl', classMeta);
		  setMetadataFor(PrimitiveClasses, 'PrimitiveClasses', objectMeta);
		  setMetadataFor(StringBuilder, 'StringBuilder', classMeta, VOID, [CharSequence], StringBuilder_init_$Create$_0);
		  setMetadataFor(Companion_1, 'Companion', objectMeta);
		  setMetadataFor(Regex, 'Regex', classMeta);
		  setMetadataFor(ExceptionTraceBuilder, 'ExceptionTraceBuilder', classMeta, VOID, VOID, ExceptionTraceBuilder);
		  setMetadataFor(Enum, 'Enum', classMeta);
		  setMetadataFor(DurationUnit, 'DurationUnit', classMeta, Enum);
		  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta);
		  setMetadataFor(Companion_2, 'Companion', objectMeta);
		  setMetadataFor(Char, 'Char', classMeta);
		  setMetadataFor(Companion_3, 'Companion', objectMeta);
		  setMetadataFor(arrayIterator$1, VOID, classMeta);
		  setMetadataFor(Companion_4, 'Companion', objectMeta);
		  setMetadataFor(Long, 'Long', classMeta, Number_0);
		  setMetadataFor(Digit, 'Digit', objectMeta);
		  setMetadataFor(Letter, 'Letter', objectMeta);
		  setMetadataFor(OtherLowercase, 'OtherLowercase', objectMeta);
		  setMetadataFor(Continuation, 'Continuation', interfaceMeta);
		  setMetadataFor(CoroutineImpl, 'CoroutineImpl', classMeta, VOID, [Continuation]);
		  setMetadataFor(CompletedContinuation, 'CompletedContinuation', objectMeta, VOID, [Continuation]);
		  setMetadataFor(Exception, 'Exception', classMeta, Error, VOID, Exception_init_$Create$);
		  setMetadataFor(RuntimeException, 'RuntimeException', classMeta, Exception, VOID, RuntimeException_init_$Create$);
		  setMetadataFor(IllegalArgumentException, 'IllegalArgumentException', classMeta, RuntimeException, VOID, IllegalArgumentException_init_$Create$);
		  setMetadataFor(IndexOutOfBoundsException, 'IndexOutOfBoundsException', classMeta, RuntimeException, VOID, IndexOutOfBoundsException_init_$Create$);
		  setMetadataFor(IllegalStateException, 'IllegalStateException', classMeta, RuntimeException, VOID, IllegalStateException_init_$Create$);
		  setMetadataFor(UnsupportedOperationException, 'UnsupportedOperationException', classMeta, RuntimeException, VOID, UnsupportedOperationException_init_$Create$);
		  setMetadataFor(NoSuchElementException, 'NoSuchElementException', classMeta, RuntimeException, VOID, NoSuchElementException_init_$Create$);
		  setMetadataFor(Error_0, 'Error', classMeta, Error, VOID, Error_init_$Create$);
		  setMetadataFor(AssertionError, 'AssertionError', classMeta, Error_0, VOID, AssertionError_init_$Create$);
		  setMetadataFor(ConcurrentModificationException, 'ConcurrentModificationException', classMeta, RuntimeException, VOID, ConcurrentModificationException_init_$Create$);
		  setMetadataFor(NumberFormatException, 'NumberFormatException', classMeta, IllegalArgumentException, VOID, NumberFormatException_init_$Create$);
		  setMetadataFor(ArithmeticException, 'ArithmeticException', classMeta, RuntimeException, VOID, ArithmeticException_init_$Create$);
		  setMetadataFor(ClassCastException, 'ClassCastException', classMeta, RuntimeException, VOID, ClassCastException_init_$Create$);
		  setMetadataFor(NullPointerException, 'NullPointerException', classMeta, RuntimeException, VOID, NullPointerException_init_$Create$);
		  setMetadataFor(NoWhenBranchMatchedException, 'NoWhenBranchMatchedException', classMeta, RuntimeException, VOID, NoWhenBranchMatchedException_init_$Create$);
		  setMetadataFor(UninitializedPropertyAccessException, 'UninitializedPropertyAccessException', classMeta, RuntimeException, VOID, UninitializedPropertyAccessException_init_$Create$);
		  setMetadataFor(Companion_5, 'Companion', objectMeta);
		  setMetadataFor(AbstractMap$keys$1$iterator$1, VOID, classMeta);
		  setMetadataFor(AbstractMap$values$1$iterator$1, VOID, classMeta);
		  setMetadataFor(Companion_6, 'Companion', objectMeta);
		  setMetadataFor(AbstractSet, 'AbstractSet', classMeta, AbstractCollection, [AbstractCollection, Set]);
		  setMetadataFor(AbstractMap$keys$1, VOID, classMeta, AbstractSet);
		  setMetadataFor(AbstractMap$values$1, VOID, classMeta, AbstractCollection);
		  setMetadataFor(Companion_7, 'Companion', objectMeta);
		  setMetadataFor(EmptyList, 'EmptyList', objectMeta, VOID, [List]);
		  setMetadataFor(EmptyIterator, 'EmptyIterator', objectMeta);
		  setMetadataFor(ArrayAsCollection, 'ArrayAsCollection', classMeta, VOID, [Collection]);
		  setMetadataFor(IndexedValue, 'IndexedValue', classMeta);
		  setMetadataFor(IndexingIterable, 'IndexingIterable', classMeta);
		  setMetadataFor(IndexingIterator, 'IndexingIterator', classMeta);
		  setMetadataFor(MapWithDefault, 'MapWithDefault', interfaceMeta, VOID, [Map_0]);
		  setMetadataFor(EmptyMap, 'EmptyMap', objectMeta, VOID, [Map_0]);
		  setMetadataFor(IntIterator, 'IntIterator', classMeta);
		  setMetadataFor(TransformingSequence$iterator$1, VOID, classMeta);
		  setMetadataFor(TransformingSequence, 'TransformingSequence', classMeta);
		  setMetadataFor(EmptySet, 'EmptySet', objectMeta, VOID, [Set]);
		  setMetadataFor(Key, 'Key', objectMeta);
		  function releaseInterceptedContinuation(continuation) {
		  }
		  setMetadataFor(ContinuationInterceptor, 'ContinuationInterceptor', interfaceMeta);
		  setMetadataFor(EmptyCoroutineContext, 'EmptyCoroutineContext', objectMeta);
		  setMetadataFor(CoroutineSingletons, 'CoroutineSingletons', classMeta, Enum);
		  setMetadataFor(Random, 'Random', classMeta);
		  setMetadataFor(Default, 'Default', objectMeta, Random);
		  setMetadataFor(Companion_8, 'Companion', objectMeta);
		  setMetadataFor(XorWowRandom, 'XorWowRandom', classMeta, Random);
		  setMetadataFor(Companion_9, 'Companion', objectMeta);
		  setMetadataFor(IntProgression, 'IntProgression', classMeta);
		  setMetadataFor(IntRange, 'IntRange', classMeta, IntProgression);
		  setMetadataFor(IntProgressionIterator, 'IntProgressionIterator', classMeta, IntIterator);
		  setMetadataFor(Companion_10, 'Companion', objectMeta);
		  setMetadataFor(KTypeParameter, 'KTypeParameter', interfaceMeta);
		  setMetadataFor(DelimitedRangesSequence$iterator$1, VOID, classMeta);
		  setMetadataFor(DelimitedRangesSequence, 'DelimitedRangesSequence', classMeta);
		  setMetadataFor(Companion_11, 'Companion', objectMeta);
		  setMetadataFor(Duration, 'Duration', classMeta);
		  setMetadataFor(DeepRecursiveScope, 'DeepRecursiveScope', classMeta, VOID, VOID, VOID, VOID, VOID, [1]);
		  setMetadataFor(DeepRecursiveFunction, 'DeepRecursiveFunction', classMeta);
		  setMetadataFor(DeepRecursiveScopeImpl, 'DeepRecursiveScopeImpl', classMeta, DeepRecursiveScope, [DeepRecursiveScope, Continuation], VOID, VOID, VOID, [1]);
		  setMetadataFor(LazyThreadSafetyMode, 'LazyThreadSafetyMode', classMeta, Enum);
		  setMetadataFor(UnsafeLazyImpl, 'UnsafeLazyImpl', classMeta);
		  setMetadataFor(UNINITIALIZED_VALUE, 'UNINITIALIZED_VALUE', objectMeta);
		  setMetadataFor(Companion_12, 'Companion', objectMeta);
		  setMetadataFor(Failure, 'Failure', classMeta);
		  setMetadataFor(Result, 'Result', classMeta);
		  setMetadataFor(NotImplementedError, 'NotImplementedError', classMeta, Error_0, VOID, NotImplementedError);
		  setMetadataFor(Pair, 'Pair', classMeta);
		  setMetadataFor(Triple, 'Triple', classMeta);
		  setMetadataFor(Companion_13, 'Companion', objectMeta);
		  setMetadataFor(UByte, 'UByte', classMeta);
		  setMetadataFor(Iterator, 'Iterator', classMeta);
		  setMetadataFor(UByteArray, 'UByteArray', classMeta, VOID, [Collection]);
		  setMetadataFor(Companion_14, 'Companion', objectMeta);
		  setMetadataFor(UInt, 'UInt', classMeta);
		  setMetadataFor(Iterator_0, 'Iterator', classMeta);
		  setMetadataFor(UIntArray, 'UIntArray', classMeta, VOID, [Collection]);
		  setMetadataFor(Companion_15, 'Companion', objectMeta);
		  setMetadataFor(ULong, 'ULong', classMeta);
		  setMetadataFor(Iterator_1, 'Iterator', classMeta);
		  setMetadataFor(ULongArray, 'ULongArray', classMeta, VOID, [Collection]);
		  setMetadataFor(Companion_16, 'Companion', objectMeta);
		  setMetadataFor(UShort, 'UShort', classMeta);
		  setMetadataFor(Iterator_2, 'Iterator', classMeta);
		  setMetadataFor(UShortArray, 'UShortArray', classMeta, VOID, [Collection]);
		  //endregion
		  function CharSequence() {
		  }
		  function Number_0() {
		  }
		  function Unit() {
		  }
		  protoOf(Unit).toString = function () {
		    return 'kotlin.Unit';
		  };
		  var Unit_instance;
		  function Unit_getInstance() {
		    return Unit_instance;
		  }
		  function ByteCompanionObject() {
		    this.MIN_VALUE = -128;
		    this.MAX_VALUE = 127;
		    this.SIZE_BYTES = 1;
		    this.SIZE_BITS = 8;
		  }
		  protoOf(ByteCompanionObject).d = function () {
		    return this.MIN_VALUE;
		  };
		  protoOf(ByteCompanionObject).e = function () {
		    return this.MAX_VALUE;
		  };
		  protoOf(ByteCompanionObject).f = function () {
		    return this.SIZE_BYTES;
		  };
		  protoOf(ByteCompanionObject).g = function () {
		    return this.SIZE_BITS;
		  };
		  var ByteCompanionObject_instance;
		  function ByteCompanionObject_getInstance() {
		    return ByteCompanionObject_instance;
		  }
		  function ShortCompanionObject() {
		    this.MIN_VALUE = -32768;
		    this.MAX_VALUE = 32767;
		    this.SIZE_BYTES = 2;
		    this.SIZE_BITS = 16;
		  }
		  protoOf(ShortCompanionObject).d = function () {
		    return this.MIN_VALUE;
		  };
		  protoOf(ShortCompanionObject).e = function () {
		    return this.MAX_VALUE;
		  };
		  protoOf(ShortCompanionObject).f = function () {
		    return this.SIZE_BYTES;
		  };
		  protoOf(ShortCompanionObject).g = function () {
		    return this.SIZE_BITS;
		  };
		  var ShortCompanionObject_instance;
		  function ShortCompanionObject_getInstance() {
		    return ShortCompanionObject_instance;
		  }
		  function IntCompanionObject() {
		    this.MIN_VALUE = -2147483648;
		    this.MAX_VALUE = 2147483647;
		    this.SIZE_BYTES = 4;
		    this.SIZE_BITS = 32;
		  }
		  protoOf(IntCompanionObject).d = function () {
		    return this.MIN_VALUE;
		  };
		  protoOf(IntCompanionObject).e = function () {
		    return this.MAX_VALUE;
		  };
		  protoOf(IntCompanionObject).f = function () {
		    return this.SIZE_BYTES;
		  };
		  protoOf(IntCompanionObject).g = function () {
		    return this.SIZE_BITS;
		  };
		  var IntCompanionObject_instance;
		  function IntCompanionObject_getInstance() {
		    return IntCompanionObject_instance;
		  }
		  function FloatCompanionObject() {
		    this.MIN_VALUE = 1.4E-45;
		    this.MAX_VALUE = 3.4028235E38;
		    this.POSITIVE_INFINITY = Infinity;
		    this.NEGATIVE_INFINITY = -Infinity;
		    this.NaN = NaN;
		    this.SIZE_BYTES = 4;
		    this.SIZE_BITS = 32;
		  }
		  protoOf(FloatCompanionObject).d = function () {
		    return this.MIN_VALUE;
		  };
		  protoOf(FloatCompanionObject).e = function () {
		    return this.MAX_VALUE;
		  };
		  protoOf(FloatCompanionObject).h = function () {
		    return this.POSITIVE_INFINITY;
		  };
		  protoOf(FloatCompanionObject).i = function () {
		    return this.NEGATIVE_INFINITY;
		  };
		  protoOf(FloatCompanionObject).j = function () {
		    return this.NaN;
		  };
		  protoOf(FloatCompanionObject).f = function () {
		    return this.SIZE_BYTES;
		  };
		  protoOf(FloatCompanionObject).g = function () {
		    return this.SIZE_BITS;
		  };
		  var FloatCompanionObject_instance;
		  function FloatCompanionObject_getInstance() {
		    return FloatCompanionObject_instance;
		  }
		  function DoubleCompanionObject() {
		    this.MIN_VALUE = 4.9E-324;
		    this.MAX_VALUE = 1.7976931348623157E308;
		    this.POSITIVE_INFINITY = Infinity;
		    this.NEGATIVE_INFINITY = -Infinity;
		    this.NaN = NaN;
		    this.SIZE_BYTES = 8;
		    this.SIZE_BITS = 64;
		  }
		  protoOf(DoubleCompanionObject).d = function () {
		    return this.MIN_VALUE;
		  };
		  protoOf(DoubleCompanionObject).e = function () {
		    return this.MAX_VALUE;
		  };
		  protoOf(DoubleCompanionObject).h = function () {
		    return this.POSITIVE_INFINITY;
		  };
		  protoOf(DoubleCompanionObject).i = function () {
		    return this.NEGATIVE_INFINITY;
		  };
		  protoOf(DoubleCompanionObject).j = function () {
		    return this.NaN;
		  };
		  protoOf(DoubleCompanionObject).f = function () {
		    return this.SIZE_BYTES;
		  };
		  protoOf(DoubleCompanionObject).g = function () {
		    return this.SIZE_BITS;
		  };
		  var DoubleCompanionObject_instance;
		  function DoubleCompanionObject_getInstance() {
		    return DoubleCompanionObject_instance;
		  }
		  function StringCompanionObject() {
		  }
		  var StringCompanionObject_instance;
		  function StringCompanionObject_getInstance() {
		    return StringCompanionObject_instance;
		  }
		  function BooleanCompanionObject() {
		  }
		  var BooleanCompanionObject_instance;
		  function BooleanCompanionObject_getInstance() {
		    return BooleanCompanionObject_instance;
		  }
		  function isNaN_0(_this__u8e3s4) {
		    return !(_this__u8e3s4 === _this__u8e3s4);
		  }
		  function isInfinite(_this__u8e3s4) {
		    var tmp;
		    if (_this__u8e3s4 === Infinity) {
		      tmp = true;
		    } else {
		      tmp = _this__u8e3s4 === -Infinity;
		    }
		    return tmp;
		  }
		  function takeHighestOneBit(_this__u8e3s4) {
		    var tmp;
		    if (_this__u8e3s4 === 0) {
		      tmp = 0;
		    } else {
		      var tmp_0 = 32 - 1 | 0;
		      // Inline function 'kotlin.countLeadingZeroBits' call
		      tmp = 1 << (tmp_0 - clz32(_this__u8e3s4) | 0);
		    }
		    return tmp;
		  }
		  function isFinite(_this__u8e3s4) {
		    return !isInfinite(_this__u8e3s4) ? !isNaN_0(_this__u8e3s4) : false;
		  }
		  function isFinite_0(_this__u8e3s4) {
		    return !isInfinite_0(_this__u8e3s4) ? !isNaN_1(_this__u8e3s4) : false;
		  }
		  function isInfinite_0(_this__u8e3s4) {
		    var tmp;
		    if (_this__u8e3s4 === Infinity) {
		      tmp = true;
		    } else {
		      tmp = _this__u8e3s4 === -Infinity;
		    }
		    return tmp;
		  }
		  function isNaN_1(_this__u8e3s4) {
		    return !(_this__u8e3s4 === _this__u8e3s4);
		  }
		  function countTrailingZeroBits(_this__u8e3s4) {
		    var low = _this__u8e3s4.k_1;
		    var tmp;
		    if (low === 0) {
		      tmp = 32 + countTrailingZeroBits_0(_this__u8e3s4.l_1) | 0;
		    } else {
		      tmp = countTrailingZeroBits_0(low);
		    }
		    return tmp;
		  }
		  function countTrailingZeroBits_0(_this__u8e3s4) {
		    // Inline function 'kotlin.countLeadingZeroBits' call
		    var this_0 = ~(_this__u8e3s4 | (-_this__u8e3s4 | 0));
		    return 32 - clz32(this_0) | 0;
		  }
		  function collectionToArray(collection) {
		    return collectionToArrayCommonImpl(collection);
		  }
		  function mapCapacity(expectedSize) {
		    return expectedSize;
		  }
		  function mapOf(pair) {
		    return hashMapOf([pair]);
		  }
		  function copyToArray(collection) {
		    var tmp;
		    // Inline function 'kotlin.js.asDynamic' call
		    if (collection.toArray !== undefined) {
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = collection.toArray();
		    } else {
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = collectionToArray(collection);
		    }
		    return tmp;
		  }
		  function listOf(element) {
		    return arrayListOf([element]);
		  }
		  function setOf(element) {
		    return hashSetOf([element]);
		  }
		  function checkIndexOverflow(index) {
		    if (index < 0) {
		      throwIndexOverflow();
		    }
		    return index;
		  }
		  function AbstractMutableCollection() {
		    AbstractCollection.call(this);
		  }
		  protoOf(AbstractMutableCollection).n = function (element) {
		    this.o();
		    var iterator = this.p();
		    while (iterator.q()) {
		      if (equals_0(iterator.s(), element)) {
		        iterator.r();
		        return true;
		      }
		    }
		    return false;
		  };
		  protoOf(AbstractMutableCollection).t = function (elements) {
		    this.o();
		    var modified = false;
		    var tmp0_iterator = elements.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      if (this.m(element))
		        modified = true;
		    }
		    return modified;
		  };
		  protoOf(AbstractMutableCollection).toJSON = function () {
		    return this.toArray();
		  };
		  protoOf(AbstractMutableCollection).o = function () {
		  };
		  function IteratorImpl($outer) {
		    this.a1_1 = $outer;
		    this.y_1 = 0;
		    this.z_1 = -1;
		  }
		  protoOf(IteratorImpl).q = function () {
		    return this.y_1 < this.a1_1.u();
		  };
		  protoOf(IteratorImpl).s = function () {
		    if (!this.q())
		      throw NoSuchElementException_init_$Create$();
		    var tmp = this;
		    var tmp1 = this.y_1;
		    this.y_1 = tmp1 + 1 | 0;
		    tmp.z_1 = tmp1;
		    return this.a1_1.b1(this.z_1);
		  };
		  protoOf(IteratorImpl).r = function () {
		    // Inline function 'kotlin.check' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!!(this.z_1 === -1)) {
		      // Inline function 'kotlin.collections.IteratorImpl.remove.<anonymous>' call
		      var message = 'Call next() or previous() before removing element from the iterator.';
		      throw IllegalStateException_init_$Create$_0(toString_1(message));
		    }
		    this.a1_1.d1(this.z_1);
		    this.y_1 = this.z_1;
		    this.z_1 = -1;
		  };
		  function AbstractMutableList() {
		    AbstractMutableCollection.call(this);
		    this.c1_1 = 0;
		  }
		  protoOf(AbstractMutableList).m = function (element) {
		    this.o();
		    this.e1(this.u(), element);
		    return true;
		  };
		  protoOf(AbstractMutableList).p = function () {
		    return new IteratorImpl(this);
		  };
		  protoOf(AbstractMutableList).v = function (element) {
		    return this.g1(element) >= 0;
		  };
		  protoOf(AbstractMutableList).g1 = function (element) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlin.collections.indexOfFirst' call
		      var index = 0;
		      var tmp0_iterator = this.p();
		      while (tmp0_iterator.q()) {
		        var item = tmp0_iterator.s();
		        // Inline function 'kotlin.collections.AbstractMutableList.indexOf.<anonymous>' call
		        if (equals_0(item, element)) {
		          tmp$ret$1 = index;
		          break $l$block;
		        }
		        index = index + 1 | 0;
		      }
		      tmp$ret$1 = -1;
		    }
		    return tmp$ret$1;
		  };
		  protoOf(AbstractMutableList).equals = function (other) {
		    if (other === this)
		      return true;
		    if (!(!(other == null) ? isInterface(other, List) : false))
		      return false;
		    return Companion_instance_5.i1(this, other);
		  };
		  protoOf(AbstractMutableList).hashCode = function () {
		    return Companion_instance_5.j1(this);
		  };
		  function AbstractMutableMap() {
		    AbstractMap.call(this);
		    this.m1_1 = null;
		    this.n1_1 = null;
		  }
		  protoOf(AbstractMutableMap).o1 = function () {
		    return new HashMapKeysDefault(this);
		  };
		  protoOf(AbstractMutableMap).p1 = function () {
		    return new HashMapValuesDefault(this);
		  };
		  protoOf(AbstractMutableMap).q1 = function () {
		    var tmp0_elvis_lhs = this.m1_1;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      // Inline function 'kotlin.also' call
		      var this_0 = this.o1();
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.collections.AbstractMutableMap.<get-keys>.<anonymous>' call
		      this.m1_1 = this_0;
		      tmp = this_0;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  protoOf(AbstractMutableMap).r1 = function () {
		    var tmp0_elvis_lhs = this.n1_1;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      // Inline function 'kotlin.also' call
		      var this_0 = this.p1();
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.collections.AbstractMutableMap.<get-values>.<anonymous>' call
		      this.n1_1 = this_0;
		      tmp = this_0;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  protoOf(AbstractMutableMap).t1 = function (key) {
		    this.o();
		    var iter = this.u1().p();
		    while (iter.q()) {
		      var entry = iter.s();
		      var k = entry.v1();
		      if (equals_0(key, k)) {
		        var value = entry.w1();
		        iter.r();
		        return value;
		      }
		    }
		    return null;
		  };
		  protoOf(AbstractMutableMap).o = function () {
		  };
		  function AbstractMutableSet() {
		    AbstractMutableCollection.call(this);
		  }
		  protoOf(AbstractMutableSet).equals = function (other) {
		    if (other === this)
		      return true;
		    if (!(!(other == null) ? isInterface(other, Set) : false))
		      return false;
		    return Companion_instance_7.d2(this, other);
		  };
		  protoOf(AbstractMutableSet).hashCode = function () {
		    return Companion_instance_7.e2(this);
		  };
		  function arrayOfUninitializedElements(capacity) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(capacity >= 0)) {
		      // Inline function 'kotlin.collections.arrayOfUninitializedElements.<anonymous>' call
		      var message = 'capacity must be non-negative.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.arrayOfNulls' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return fillArrayVal(Array(capacity), null);
		  }
		  function resetAt(_this__u8e3s4, index) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    _this__u8e3s4[index] = null;
		  }
		  function resetRange(_this__u8e3s4, fromIndex, toIndex) {
		    // Inline function 'kotlin.js.nativeFill' call
		    // Inline function 'kotlin.js.asDynamic' call
		    _this__u8e3s4.fill(null, fromIndex, toIndex);
		  }
		  function copyOfUninitializedElements(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return copyOf_7(_this__u8e3s4, newSize);
		  }
		  function Companion() {
		    Companion_instance = this;
		    var tmp = this;
		    // Inline function 'kotlin.also' call
		    var this_0 = ArrayList_init_$Create$_0(0);
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.collections.Companion.Empty.<anonymous>' call
		    this_0.h2_1 = true;
		    tmp.i2_1 = this_0;
		  }
		  var Companion_instance;
		  function Companion_getInstance() {
		    if (Companion_instance == null)
		      new Companion();
		    return Companion_instance;
		  }
		  function ArrayList_init_$Init$($this) {
		    // Inline function 'kotlin.emptyArray' call
		    var tmp$ret$0 = [];
		    ArrayList.call($this, tmp$ret$0);
		    return $this;
		  }
		  function ArrayList_init_$Create$() {
		    return ArrayList_init_$Init$(objectCreate(protoOf(ArrayList)));
		  }
		  function ArrayList_init_$Init$_0(initialCapacity, $this) {
		    // Inline function 'kotlin.emptyArray' call
		    var tmp$ret$0 = [];
		    ArrayList.call($this, tmp$ret$0);
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(initialCapacity >= 0)) {
		      // Inline function 'kotlin.collections.ArrayList.<init>.<anonymous>' call
		      var message = 'Negative initial capacity: ' + initialCapacity;
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return $this;
		  }
		  function ArrayList_init_$Create$_0(initialCapacity) {
		    return ArrayList_init_$Init$_0(initialCapacity, objectCreate(protoOf(ArrayList)));
		  }
		  function ArrayList_init_$Init$_1(elements, $this) {
		    // Inline function 'kotlin.collections.toTypedArray' call
		    var tmp$ret$0 = copyToArray(elements);
		    ArrayList.call($this, tmp$ret$0);
		    return $this;
		  }
		  function ArrayList_init_$Create$_1(elements) {
		    return ArrayList_init_$Init$_1(elements, objectCreate(protoOf(ArrayList)));
		  }
		  function increaseLength($this, amount) {
		    var previous = $this.u();
		    // Inline function 'kotlin.js.asDynamic' call
		    $this.g2_1.length = $this.u() + amount | 0;
		    return previous;
		  }
		  function rangeCheck($this, index) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.collections.ArrayList.rangeCheck.<anonymous>' call
		    Companion_instance_5.j2(index, $this.u());
		    return index;
		  }
		  function insertionRangeCheck($this, index) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.collections.ArrayList.insertionRangeCheck.<anonymous>' call
		    Companion_instance_5.k2(index, $this.u());
		    return index;
		  }
		  function ArrayList(array) {
		    Companion_getInstance();
		    AbstractMutableList.call(this);
		    this.g2_1 = array;
		    this.h2_1 = false;
		  }
		  protoOf(ArrayList).l2 = function (minCapacity) {
		  };
		  protoOf(ArrayList).u = function () {
		    return this.g2_1.length;
		  };
		  protoOf(ArrayList).b1 = function (index) {
		    var tmp = this.g2_1[rangeCheck(this, index)];
		    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
		  };
		  protoOf(ArrayList).f1 = function (index, element) {
		    this.o();
		    rangeCheck(this, index);
		    // Inline function 'kotlin.apply' call
		    var this_0 = this.g2_1[index];
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.collections.ArrayList.set.<anonymous>' call
		    this.g2_1[index] = element;
		    var tmp = this_0;
		    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
		  };
		  protoOf(ArrayList).m = function (element) {
		    this.o();
		    // Inline function 'kotlin.js.asDynamic' call
		    this.g2_1.push(element);
		    this.c1_1 = this.c1_1 + 1 | 0;
		    return true;
		  };
		  protoOf(ArrayList).e1 = function (index, element) {
		    this.o();
		    // Inline function 'kotlin.js.asDynamic' call
		    this.g2_1.splice(insertionRangeCheck(this, index), 0, element);
		    this.c1_1 = this.c1_1 + 1 | 0;
		  };
		  protoOf(ArrayList).t = function (elements) {
		    this.o();
		    if (elements.x())
		      return false;
		    var offset = increaseLength(this, elements.u());
		    // Inline function 'kotlin.collections.forEachIndexed' call
		    var index = 0;
		    var tmp0_iterator = elements.p();
		    while (tmp0_iterator.q()) {
		      var item = tmp0_iterator.s();
		      // Inline function 'kotlin.collections.ArrayList.addAll.<anonymous>' call
		      var tmp1 = index;
		      index = tmp1 + 1 | 0;
		      var index_0 = checkIndexOverflow(tmp1);
		      this.g2_1[offset + index_0 | 0] = item;
		    }
		    this.c1_1 = this.c1_1 + 1 | 0;
		    return true;
		  };
		  protoOf(ArrayList).d1 = function (index) {
		    this.o();
		    rangeCheck(this, index);
		    this.c1_1 = this.c1_1 + 1 | 0;
		    var tmp;
		    if (index === get_lastIndex_2(this)) {
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = this.g2_1.pop();
		    } else {
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = this.g2_1.splice(index, 1)[0];
		    }
		    return tmp;
		  };
		  protoOf(ArrayList).n = function (element) {
		    this.o();
		    var inductionVariable = 0;
		    var last = this.g2_1.length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (equals_0(this.g2_1[index], element)) {
		          // Inline function 'kotlin.js.asDynamic' call
		          this.g2_1.splice(index, 1);
		          this.c1_1 = this.c1_1 + 1 | 0;
		          return true;
		        }
		      }
		       while (inductionVariable <= last);
		    return false;
		  };
		  protoOf(ArrayList).g1 = function (element) {
		    return indexOf(this.g2_1, element);
		  };
		  protoOf(ArrayList).toString = function () {
		    return arrayToString(this.g2_1);
		  };
		  protoOf(ArrayList).m2 = function () {
		    return [].slice.call(this.g2_1);
		  };
		  protoOf(ArrayList).toArray = function () {
		    return this.m2();
		  };
		  protoOf(ArrayList).o = function () {
		    if (this.h2_1)
		      throw UnsupportedOperationException_init_$Create$();
		  };
		  function HashMap_init_$Init$(internalMap, $this) {
		    AbstractMutableMap.call($this);
		    HashMap.call($this);
		    $this.r2_1 = internalMap;
		    return $this;
		  }
		  function HashMap_init_$Init$_0($this) {
		    HashMap_init_$Init$(InternalHashMap_init_$Create$(), $this);
		    return $this;
		  }
		  function HashMap_init_$Create$() {
		    return HashMap_init_$Init$_0(objectCreate(protoOf(HashMap)));
		  }
		  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
		    HashMap_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
		    return $this;
		  }
		  function HashMap_init_$Init$_2(initialCapacity, $this) {
		    HashMap_init_$Init$_1(initialCapacity, 1.0, $this);
		    return $this;
		  }
		  function HashMap_init_$Create$_0(initialCapacity) {
		    return HashMap_init_$Init$_2(initialCapacity, objectCreate(protoOf(HashMap)));
		  }
		  function HashMap_init_$Init$_3(original, $this) {
		    HashMap_init_$Init$(InternalHashMap_init_$Create$_1(original), $this);
		    return $this;
		  }
		  function HashMap_init_$Create$_1(original) {
		    return HashMap_init_$Init$_3(original, objectCreate(protoOf(HashMap)));
		  }
		  protoOf(HashMap).z1 = function (key) {
		    return this.r2_1.t2(key);
		  };
		  protoOf(HashMap).a2 = function (value) {
		    return this.r2_1.a2(value);
		  };
		  protoOf(HashMap).o1 = function () {
		    return new HashMapKeys(this.r2_1);
		  };
		  protoOf(HashMap).p1 = function () {
		    return new HashMapValues(this.r2_1);
		  };
		  protoOf(HashMap).u1 = function () {
		    var tmp0_elvis_lhs = this.s2_1;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      // Inline function 'kotlin.also' call
		      var this_0 = new HashMapEntrySet(this.r2_1);
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.collections.HashMap.<get-entries>.<anonymous>' call
		      this.s2_1 = this_0;
		      tmp = this_0;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  protoOf(HashMap).c2 = function (key) {
		    return this.r2_1.c2(key);
		  };
		  protoOf(HashMap).s1 = function (key, value) {
		    return this.r2_1.s1(key, value);
		  };
		  protoOf(HashMap).t1 = function (key) {
		    return this.r2_1.t1(key);
		  };
		  protoOf(HashMap).u = function () {
		    return this.r2_1.u();
		  };
		  function HashMap() {
		    this.s2_1 = null;
		  }
		  function HashMapKeys(backing) {
		    AbstractMutableSet.call(this);
		    this.u2_1 = backing;
		  }
		  protoOf(HashMapKeys).u = function () {
		    return this.u2_1.u();
		  };
		  protoOf(HashMapKeys).x = function () {
		    return this.u2_1.u() === 0;
		  };
		  protoOf(HashMapKeys).v = function (element) {
		    return this.u2_1.t2(element);
		  };
		  protoOf(HashMapKeys).m = function (element) {
		    throw UnsupportedOperationException_init_$Create$();
		  };
		  protoOf(HashMapKeys).t = function (elements) {
		    throw UnsupportedOperationException_init_$Create$();
		  };
		  protoOf(HashMapKeys).p = function () {
		    return this.u2_1.v2();
		  };
		  protoOf(HashMapKeys).o = function () {
		    return this.u2_1.o();
		  };
		  function HashMapValues(backing) {
		    AbstractMutableCollection.call(this);
		    this.w2_1 = backing;
		  }
		  protoOf(HashMapValues).u = function () {
		    return this.w2_1.u();
		  };
		  protoOf(HashMapValues).x = function () {
		    return this.w2_1.u() === 0;
		  };
		  protoOf(HashMapValues).x2 = function (element) {
		    return this.w2_1.a2(element);
		  };
		  protoOf(HashMapValues).v = function (element) {
		    if (!(element == null ? true : !(element == null)))
		      return false;
		    return this.x2((element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(HashMapValues).y2 = function (element) {
		    throw UnsupportedOperationException_init_$Create$();
		  };
		  protoOf(HashMapValues).m = function (element) {
		    return this.y2((element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(HashMapValues).z2 = function (elements) {
		    throw UnsupportedOperationException_init_$Create$();
		  };
		  protoOf(HashMapValues).t = function (elements) {
		    return this.z2(elements);
		  };
		  protoOf(HashMapValues).p = function () {
		    return this.w2_1.a3();
		  };
		  protoOf(HashMapValues).o = function () {
		    return this.w2_1.o();
		  };
		  function HashMapEntrySet(backing) {
		    HashMapEntrySetBase.call(this, backing);
		  }
		  protoOf(HashMapEntrySet).p = function () {
		    return this.c3_1.d3();
		  };
		  function HashMapEntrySetBase(backing) {
		    AbstractMutableSet.call(this);
		    this.c3_1 = backing;
		  }
		  protoOf(HashMapEntrySetBase).u = function () {
		    return this.c3_1.u();
		  };
		  protoOf(HashMapEntrySetBase).x = function () {
		    return this.c3_1.u() === 0;
		  };
		  protoOf(HashMapEntrySetBase).e3 = function (element) {
		    return this.c3_1.g3(element);
		  };
		  protoOf(HashMapEntrySetBase).v = function (element) {
		    if (!(!(element == null) ? isInterface(element, Entry) : false))
		      return false;
		    return this.e3((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
		  };
		  protoOf(HashMapEntrySetBase).f3 = function (element) {
		    throw UnsupportedOperationException_init_$Create$();
		  };
		  protoOf(HashMapEntrySetBase).m = function (element) {
		    return this.f3((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
		  };
		  protoOf(HashMapEntrySetBase).t = function (elements) {
		    throw UnsupportedOperationException_init_$Create$();
		  };
		  protoOf(HashMapEntrySetBase).w = function (elements) {
		    return this.c3_1.h3(elements);
		  };
		  protoOf(HashMapEntrySetBase).o = function () {
		    return this.c3_1.o();
		  };
		  function HashMapKeysDefault$iterator$1($entryIterator) {
		    this.i3_1 = $entryIterator;
		  }
		  protoOf(HashMapKeysDefault$iterator$1).q = function () {
		    return this.i3_1.q();
		  };
		  protoOf(HashMapKeysDefault$iterator$1).s = function () {
		    return this.i3_1.s().v1();
		  };
		  protoOf(HashMapKeysDefault$iterator$1).r = function () {
		    return this.i3_1.r();
		  };
		  function HashMapKeysDefault(backingMap) {
		    AbstractMutableSet.call(this);
		    this.j3_1 = backingMap;
		  }
		  protoOf(HashMapKeysDefault).k3 = function (element) {
		    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
		  };
		  protoOf(HashMapKeysDefault).m = function (element) {
		    return this.k3((element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(HashMapKeysDefault).t2 = function (element) {
		    return this.j3_1.z1(element);
		  };
		  protoOf(HashMapKeysDefault).v = function (element) {
		    if (!(element == null ? true : !(element == null)))
		      return false;
		    return this.t2((element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(HashMapKeysDefault).p = function () {
		    var entryIterator = this.j3_1.u1().p();
		    return new HashMapKeysDefault$iterator$1(entryIterator);
		  };
		  protoOf(HashMapKeysDefault).u = function () {
		    return this.j3_1.u();
		  };
		  protoOf(HashMapKeysDefault).o = function () {
		    return this.j3_1.o();
		  };
		  function HashMapValuesDefault$iterator$1($entryIterator) {
		    this.l3_1 = $entryIterator;
		  }
		  protoOf(HashMapValuesDefault$iterator$1).q = function () {
		    return this.l3_1.q();
		  };
		  protoOf(HashMapValuesDefault$iterator$1).s = function () {
		    return this.l3_1.s().w1();
		  };
		  protoOf(HashMapValuesDefault$iterator$1).r = function () {
		    return this.l3_1.r();
		  };
		  function HashMapValuesDefault(backingMap) {
		    AbstractMutableCollection.call(this);
		    this.m3_1 = backingMap;
		  }
		  protoOf(HashMapValuesDefault).y2 = function (element) {
		    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
		  };
		  protoOf(HashMapValuesDefault).m = function (element) {
		    return this.y2((element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(HashMapValuesDefault).x2 = function (element) {
		    return this.m3_1.a2(element);
		  };
		  protoOf(HashMapValuesDefault).v = function (element) {
		    if (!(element == null ? true : !(element == null)))
		      return false;
		    return this.x2((element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(HashMapValuesDefault).p = function () {
		    var entryIterator = this.m3_1.u1().p();
		    return new HashMapValuesDefault$iterator$1(entryIterator);
		  };
		  protoOf(HashMapValuesDefault).u = function () {
		    return this.m3_1.u();
		  };
		  protoOf(HashMapValuesDefault).o = function () {
		    return this.m3_1.o();
		  };
		  function HashSet_init_$Init$(map, $this) {
		    AbstractMutableSet.call($this);
		    HashSet.call($this);
		    $this.n3_1 = map;
		    return $this;
		  }
		  function HashSet_init_$Init$_0($this) {
		    HashSet_init_$Init$(InternalHashMap_init_$Create$(), $this);
		    return $this;
		  }
		  function HashSet_init_$Create$() {
		    return HashSet_init_$Init$_0(objectCreate(protoOf(HashSet)));
		  }
		  function HashSet_init_$Init$_1(elements, $this) {
		    HashSet_init_$Init$(InternalHashMap_init_$Create$_0(elements.u()), $this);
		    var tmp0_iterator = elements.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      $this.n3_1.s1(element, true);
		    }
		    return $this;
		  }
		  function HashSet_init_$Create$_0(elements) {
		    return HashSet_init_$Init$_1(elements, objectCreate(protoOf(HashSet)));
		  }
		  function HashSet_init_$Init$_2(initialCapacity, loadFactor, $this) {
		    HashSet_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
		    return $this;
		  }
		  function HashSet_init_$Init$_3(initialCapacity, $this) {
		    HashSet_init_$Init$_2(initialCapacity, 1.0, $this);
		    return $this;
		  }
		  function HashSet_init_$Create$_1(initialCapacity) {
		    return HashSet_init_$Init$_3(initialCapacity, objectCreate(protoOf(HashSet)));
		  }
		  protoOf(HashSet).m = function (element) {
		    return this.n3_1.s1(element, true) == null;
		  };
		  protoOf(HashSet).v = function (element) {
		    return this.n3_1.t2(element);
		  };
		  protoOf(HashSet).x = function () {
		    return this.n3_1.u() === 0;
		  };
		  protoOf(HashSet).p = function () {
		    return this.n3_1.v2();
		  };
		  protoOf(HashSet).u = function () {
		    return this.n3_1.u();
		  };
		  function HashSet() {
		  }
		  function computeHashSize($this, capacity) {
		    return takeHighestOneBit(imul(coerceAtLeast(capacity, 1), 3));
		  }
		  function computeShift($this, hashSize) {
		    // Inline function 'kotlin.countLeadingZeroBits' call
		    return clz32(hashSize) + 1 | 0;
		  }
		  function InternalHashMap_init_$Init$($this) {
		    InternalHashMap_init_$Init$_0(8, $this);
		    return $this;
		  }
		  function InternalHashMap_init_$Create$() {
		    return InternalHashMap_init_$Init$(objectCreate(protoOf(InternalHashMap)));
		  }
		  function InternalHashMap_init_$Init$_0(initialCapacity, $this) {
		    InternalHashMap.call($this, arrayOfUninitializedElements(initialCapacity), null, new Int32Array(initialCapacity), new Int32Array(computeHashSize(Companion_instance_0, initialCapacity)), 2, 0);
		    return $this;
		  }
		  function InternalHashMap_init_$Create$_0(initialCapacity) {
		    return InternalHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(InternalHashMap)));
		  }
		  function InternalHashMap_init_$Init$_1(original, $this) {
		    InternalHashMap_init_$Init$_0(original.u(), $this);
		    $this.y3(original);
		    return $this;
		  }
		  function InternalHashMap_init_$Create$_1(original) {
		    return InternalHashMap_init_$Init$_1(original, objectCreate(protoOf(InternalHashMap)));
		  }
		  function InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, $this) {
		    InternalHashMap_init_$Init$_0(initialCapacity, $this);
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(loadFactor > 0.0)) {
		      // Inline function 'kotlin.collections.InternalHashMap.<init>.<anonymous>' call
		      var message = 'Non-positive load factor: ' + loadFactor;
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return $this;
		  }
		  function InternalHashMap_init_$Create$_2(initialCapacity, loadFactor) {
		    return InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, objectCreate(protoOf(InternalHashMap)));
		  }
		  function _get_capacity__a9k9f3($this) {
		    return $this.o3_1.length;
		  }
		  function _get_hashSize__tftcho($this) {
		    return $this.r3_1.length;
		  }
		  function registerModification($this) {
		    $this.v3_1 = $this.v3_1 + 1 | 0;
		  }
		  function ensureExtraCapacity($this, n) {
		    if (shouldCompact($this, n)) {
		      rehash($this, _get_hashSize__tftcho($this));
		    } else {
		      ensureCapacity($this, $this.t3_1 + n | 0);
		    }
		  }
		  function shouldCompact($this, extraCapacity) {
		    var spareCapacity = _get_capacity__a9k9f3($this) - $this.t3_1 | 0;
		    var gaps = $this.t3_1 - $this.u() | 0;
		    return (spareCapacity < extraCapacity ? (gaps + spareCapacity | 0) >= extraCapacity : false) ? gaps >= (_get_capacity__a9k9f3($this) / 4 | 0) : false;
		  }
		  function ensureCapacity($this, minCapacity) {
		    if (minCapacity < 0)
		      throw RuntimeException_init_$Create$_0('too many elements');
		    if (minCapacity > _get_capacity__a9k9f3($this)) {
		      var newSize = Companion_instance_5.z3(_get_capacity__a9k9f3($this), minCapacity);
		      $this.o3_1 = copyOfUninitializedElements($this.o3_1, newSize);
		      var tmp = $this;
		      var tmp0_safe_receiver = $this.p3_1;
		      tmp.p3_1 = tmp0_safe_receiver == null ? null : copyOfUninitializedElements(tmp0_safe_receiver, newSize);
		      $this.q3_1 = copyOf_3($this.q3_1, newSize);
		      var newHashSize = computeHashSize(Companion_instance_0, newSize);
		      if (newHashSize > _get_hashSize__tftcho($this)) {
		        rehash($this, newHashSize);
		      }
		    }
		  }
		  function allocateValuesArray($this) {
		    var curValuesArray = $this.p3_1;
		    if (!(curValuesArray == null))
		      return curValuesArray;
		    var newValuesArray = arrayOfUninitializedElements(_get_capacity__a9k9f3($this));
		    $this.p3_1 = newValuesArray;
		    return newValuesArray;
		  }
		  function hash($this, key) {
		    return key == null ? 0 : imul(hashCode(key), -1640531527) >>> $this.u3_1 | 0;
		  }
		  function compact($this) {
		    var i = 0;
		    var j = 0;
		    var valuesArray = $this.p3_1;
		    while (i < $this.t3_1) {
		      if ($this.q3_1[i] >= 0) {
		        $this.o3_1[j] = $this.o3_1[i];
		        if (!(valuesArray == null)) {
		          valuesArray[j] = valuesArray[i];
		        }
		        j = j + 1 | 0;
		      }
		      i = i + 1 | 0;
		    }
		    resetRange($this.o3_1, j, $this.t3_1);
		    if (valuesArray == null)
		      null;
		    else {
		      resetRange(valuesArray, j, $this.t3_1);
		    }
		    $this.t3_1 = j;
		  }
		  function rehash($this, newHashSize) {
		    registerModification($this);
		    if ($this.t3_1 > $this.w3_1) {
		      compact($this);
		    }
		    if (!(newHashSize === _get_hashSize__tftcho($this))) {
		      $this.r3_1 = new Int32Array(newHashSize);
		      $this.u3_1 = computeShift(Companion_instance_0, newHashSize);
		    } else {
		      fill($this.r3_1, 0, 0, _get_hashSize__tftcho($this));
		    }
		    var i = 0;
		    while (i < $this.t3_1) {
		      var tmp0 = i;
		      i = tmp0 + 1 | 0;
		      if (!putRehash($this, tmp0)) {
		        throw IllegalStateException_init_$Create$_0('This cannot happen with fixed magic multiplier and grow-only hash array. Have object hashCodes changed?');
		      }
		    }
		  }
		  function putRehash($this, i) {
		    var hash_0 = hash($this, $this.o3_1[i]);
		    var probesLeft = $this.s3_1;
		    while (true) {
		      var index = $this.r3_1[hash_0];
		      if (index === 0) {
		        $this.r3_1[hash_0] = i + 1 | 0;
		        $this.q3_1[i] = hash_0;
		        return true;
		      }
		      probesLeft = probesLeft - 1 | 0;
		      if (probesLeft < 0)
		        return false;
		      var tmp0 = hash_0;
		      hash_0 = tmp0 - 1 | 0;
		      if (tmp0 === 0)
		        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
		    }
		  }
		  function findKey($this, key) {
		    var hash_0 = hash($this, key);
		    var probesLeft = $this.s3_1;
		    while (true) {
		      var index = $this.r3_1[hash_0];
		      if (index === 0)
		        return -1;
		      if (index > 0 ? equals_0($this.o3_1[index - 1 | 0], key) : false)
		        return index - 1 | 0;
		      probesLeft = probesLeft - 1 | 0;
		      if (probesLeft < 0)
		        return -1;
		      var tmp0 = hash_0;
		      hash_0 = tmp0 - 1 | 0;
		      if (tmp0 === 0)
		        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
		    }
		  }
		  function findValue($this, value) {
		    var i = $this.t3_1;
		    $l$loop: while (true) {
		      i = i - 1 | 0;
		      if (!(i >= 0)) {
		        break $l$loop;
		      }
		      if ($this.q3_1[i] >= 0 ? equals_0(ensureNotNull($this.p3_1)[i], value) : false)
		        return i;
		    }
		    return -1;
		  }
		  function addKey($this, key) {
		    $this.o();
		    retry: while (true) {
		      var hash_0 = hash($this, key);
		      var tentativeMaxProbeDistance = coerceAtMost(imul($this.s3_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
		      var probeDistance = 0;
		      while (true) {
		        var index = $this.r3_1[hash_0];
		        if (index <= 0) {
		          if ($this.t3_1 >= _get_capacity__a9k9f3($this)) {
		            ensureExtraCapacity($this, 1);
		            continue retry;
		          }
		          var tmp1 = $this.t3_1;
		          $this.t3_1 = tmp1 + 1 | 0;
		          var putIndex = tmp1;
		          $this.o3_1[putIndex] = key;
		          $this.q3_1[putIndex] = hash_0;
		          $this.r3_1[hash_0] = putIndex + 1 | 0;
		          $this.w3_1 = $this.w3_1 + 1 | 0;
		          registerModification($this);
		          if (probeDistance > $this.s3_1)
		            $this.s3_1 = probeDistance;
		          return putIndex;
		        }
		        if (equals_0($this.o3_1[index - 1 | 0], key)) {
		          return -index | 0;
		        }
		        probeDistance = probeDistance + 1 | 0;
		        if (probeDistance > tentativeMaxProbeDistance) {
		          rehash($this, imul(_get_hashSize__tftcho($this), 2));
		          continue retry;
		        }
		        var tmp4 = hash_0;
		        hash_0 = tmp4 - 1 | 0;
		        if (tmp4 === 0)
		          hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
		      }
		    }
		  }
		  function removeKey($this, key) {
		    $this.o();
		    var index = findKey($this, key);
		    if (index < 0)
		      return -1;
		    removeKeyAt($this, index);
		    return index;
		  }
		  function removeKeyAt($this, index) {
		    resetAt($this.o3_1, index);
		    removeHashAt($this, $this.q3_1[index]);
		    $this.q3_1[index] = -1;
		    $this.w3_1 = $this.w3_1 - 1 | 0;
		    registerModification($this);
		  }
		  function removeHashAt($this, removedHash) {
		    var hash_0 = removedHash;
		    var hole = removedHash;
		    var probeDistance = 0;
		    var patchAttemptsLeft = coerceAtMost(imul($this.s3_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
		    while (true) {
		      var tmp0 = hash_0;
		      hash_0 = tmp0 - 1 | 0;
		      if (tmp0 === 0)
		        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
		      probeDistance = probeDistance + 1 | 0;
		      if (probeDistance > $this.s3_1) {
		        $this.r3_1[hole] = 0;
		        return Unit_instance;
		      }
		      var index = $this.r3_1[hash_0];
		      if (index === 0) {
		        $this.r3_1[hole] = 0;
		        return Unit_instance;
		      }
		      if (index < 0) {
		        $this.r3_1[hole] = -1;
		        hole = hash_0;
		        probeDistance = 0;
		      } else {
		        var otherHash = hash($this, $this.o3_1[index - 1 | 0]);
		        if (((otherHash - hash_0 | 0) & (_get_hashSize__tftcho($this) - 1 | 0)) >= probeDistance) {
		          $this.r3_1[hole] = index;
		          $this.q3_1[index - 1 | 0] = hole;
		          hole = hash_0;
		          probeDistance = 0;
		        }
		      }
		      patchAttemptsLeft = patchAttemptsLeft - 1 | 0;
		      if (patchAttemptsLeft < 0) {
		        $this.r3_1[hole] = -1;
		        return Unit_instance;
		      }
		    }
		  }
		  function contentEquals($this, other) {
		    return $this.w3_1 === other.u() ? $this.h3(other.u1()) : false;
		  }
		  function putEntry($this, entry) {
		    var index = addKey($this, entry.v1());
		    var valuesArray = allocateValuesArray($this);
		    if (index >= 0) {
		      valuesArray[index] = entry.w1();
		      return true;
		    }
		    var oldValue = valuesArray[(-index | 0) - 1 | 0];
		    if (!equals_0(entry.w1(), oldValue)) {
		      valuesArray[(-index | 0) - 1 | 0] = entry.w1();
		      return true;
		    }
		    return false;
		  }
		  function putAllEntries($this, from) {
		    if (from.x())
		      return false;
		    ensureExtraCapacity($this, from.u());
		    var it = from.p();
		    var updated = false;
		    while (it.q()) {
		      if (putEntry($this, it.s()))
		        updated = true;
		    }
		    return updated;
		  }
		  function Companion_0() {
		    this.a4_1 = -1640531527;
		    this.b4_1 = 8;
		    this.c4_1 = 2;
		    this.d4_1 = -1;
		  }
		  var Companion_instance_0;
		  function Companion_getInstance_0() {
		    return Companion_instance_0;
		  }
		  function Itr(map) {
		    this.e4_1 = map;
		    this.f4_1 = 0;
		    this.g4_1 = -1;
		    this.h4_1 = this.e4_1.v3_1;
		    this.i4();
		  }
		  protoOf(Itr).i4 = function () {
		    while (this.f4_1 < this.e4_1.t3_1 ? this.e4_1.q3_1[this.f4_1] < 0 : false) {
		      this.f4_1 = this.f4_1 + 1 | 0;
		    }
		  };
		  protoOf(Itr).q = function () {
		    return this.f4_1 < this.e4_1.t3_1;
		  };
		  protoOf(Itr).r = function () {
		    this.j4();
		    // Inline function 'kotlin.check' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!!(this.g4_1 === -1)) {
		      // Inline function 'kotlin.collections.Itr.remove.<anonymous>' call
		      var message = 'Call next() before removing element from the iterator.';
		      throw IllegalStateException_init_$Create$_0(toString_1(message));
		    }
		    this.e4_1.o();
		    removeKeyAt(this.e4_1, this.g4_1);
		    this.g4_1 = -1;
		    this.h4_1 = this.e4_1.v3_1;
		  };
		  protoOf(Itr).j4 = function () {
		    if (!(this.e4_1.v3_1 === this.h4_1))
		      throw ConcurrentModificationException_init_$Create$();
		  };
		  function KeysItr(map) {
		    Itr.call(this, map);
		  }
		  protoOf(KeysItr).s = function () {
		    this.j4();
		    if (this.f4_1 >= this.e4_1.t3_1)
		      throw NoSuchElementException_init_$Create$();
		    var tmp = this;
		    var tmp1 = this.f4_1;
		    this.f4_1 = tmp1 + 1 | 0;
		    tmp.g4_1 = tmp1;
		    var result = this.e4_1.o3_1[this.g4_1];
		    this.i4();
		    return result;
		  };
		  function ValuesItr(map) {
		    Itr.call(this, map);
		  }
		  protoOf(ValuesItr).s = function () {
		    this.j4();
		    if (this.f4_1 >= this.e4_1.t3_1)
		      throw NoSuchElementException_init_$Create$();
		    var tmp = this;
		    var tmp1 = this.f4_1;
		    this.f4_1 = tmp1 + 1 | 0;
		    tmp.g4_1 = tmp1;
		    var result = ensureNotNull(this.e4_1.p3_1)[this.g4_1];
		    this.i4();
		    return result;
		  };
		  function EntriesItr(map) {
		    Itr.call(this, map);
		  }
		  protoOf(EntriesItr).s = function () {
		    this.j4();
		    if (this.f4_1 >= this.e4_1.t3_1)
		      throw NoSuchElementException_init_$Create$();
		    var tmp = this;
		    var tmp1 = this.f4_1;
		    this.f4_1 = tmp1 + 1 | 0;
		    tmp.g4_1 = tmp1;
		    var result = new EntryRef(this.e4_1, this.g4_1);
		    this.i4();
		    return result;
		  };
		  protoOf(EntriesItr).w4 = function () {
		    if (this.f4_1 >= this.e4_1.t3_1)
		      throw NoSuchElementException_init_$Create$();
		    var tmp = this;
		    var tmp1 = this.f4_1;
		    this.f4_1 = tmp1 + 1 | 0;
		    tmp.g4_1 = tmp1;
		    // Inline function 'kotlin.hashCode' call
		    var tmp0_safe_receiver = this.e4_1.o3_1[this.g4_1];
		    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
		    var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
		    // Inline function 'kotlin.hashCode' call
		    var tmp0_safe_receiver_0 = ensureNotNull(this.e4_1.p3_1)[this.g4_1];
		    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
		    var result = tmp_0 ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
		    this.i4();
		    return result;
		  };
		  protoOf(EntriesItr).x4 = function (sb) {
		    if (this.f4_1 >= this.e4_1.t3_1)
		      throw NoSuchElementException_init_$Create$();
		    var tmp = this;
		    var tmp1 = this.f4_1;
		    this.f4_1 = tmp1 + 1 | 0;
		    tmp.g4_1 = tmp1;
		    var key = this.e4_1.o3_1[this.g4_1];
		    if (equals_0(key, this.e4_1)) {
		      sb.a5('(this Map)');
		    } else {
		      sb.z4(key);
		    }
		    sb.b5(_Char___init__impl__6a9atx(61));
		    var value = ensureNotNull(this.e4_1.p3_1)[this.g4_1];
		    if (equals_0(value, this.e4_1)) {
		      sb.a5('(this Map)');
		    } else {
		      sb.z4(value);
		    }
		    this.i4();
		  };
		  function EntryRef(map, index) {
		    this.c5_1 = map;
		    this.d5_1 = index;
		  }
		  protoOf(EntryRef).v1 = function () {
		    return this.c5_1.o3_1[this.d5_1];
		  };
		  protoOf(EntryRef).w1 = function () {
		    return ensureNotNull(this.c5_1.p3_1)[this.d5_1];
		  };
		  protoOf(EntryRef).equals = function (other) {
		    var tmp;
		    var tmp_0;
		    if (!(other == null) ? isInterface(other, Entry) : false) {
		      tmp_0 = equals_0(other.v1(), this.v1());
		    } else {
		      tmp_0 = false;
		    }
		    if (tmp_0) {
		      tmp = equals_0(other.w1(), this.w1());
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(EntryRef).hashCode = function () {
		    // Inline function 'kotlin.hashCode' call
		    var tmp0_safe_receiver = this.v1();
		    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
		    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
		    // Inline function 'kotlin.hashCode' call
		    var tmp0_safe_receiver_0 = this.w1();
		    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
		    return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
		  };
		  protoOf(EntryRef).toString = function () {
		    return '' + this.v1() + '=' + this.w1();
		  };
		  function InternalHashMap(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
		    this.o3_1 = keysArray;
		    this.p3_1 = valuesArray;
		    this.q3_1 = presenceArray;
		    this.r3_1 = hashArray;
		    this.s3_1 = maxProbeDistance;
		    this.t3_1 = length;
		    this.u3_1 = computeShift(Companion_instance_0, _get_hashSize__tftcho(this));
		    this.v3_1 = 0;
		    this.w3_1 = 0;
		    this.x3_1 = false;
		  }
		  protoOf(InternalHashMap).u = function () {
		    return this.w3_1;
		  };
		  protoOf(InternalHashMap).a2 = function (value) {
		    return findValue(this, value) >= 0;
		  };
		  protoOf(InternalHashMap).c2 = function (key) {
		    var index = findKey(this, key);
		    if (index < 0)
		      return null;
		    return ensureNotNull(this.p3_1)[index];
		  };
		  protoOf(InternalHashMap).t2 = function (key) {
		    return findKey(this, key) >= 0;
		  };
		  protoOf(InternalHashMap).s1 = function (key, value) {
		    var index = addKey(this, key);
		    var valuesArray = allocateValuesArray(this);
		    if (index < 0) {
		      var oldValue = valuesArray[(-index | 0) - 1 | 0];
		      valuesArray[(-index | 0) - 1 | 0] = value;
		      return oldValue;
		    } else {
		      valuesArray[index] = value;
		      return null;
		    }
		  };
		  protoOf(InternalHashMap).y3 = function (from) {
		    this.o();
		    putAllEntries(this, from.u1());
		  };
		  protoOf(InternalHashMap).t1 = function (key) {
		    var index = removeKey(this, key);
		    if (index < 0)
		      return null;
		    var valuesArray = ensureNotNull(this.p3_1);
		    var oldValue = valuesArray[index];
		    resetAt(valuesArray, index);
		    return oldValue;
		  };
		  protoOf(InternalHashMap).equals = function (other) {
		    var tmp;
		    if (other === this) {
		      tmp = true;
		    } else {
		      var tmp_0;
		      if (!(other == null) ? isInterface(other, Map_0) : false) {
		        tmp_0 = contentEquals(this, other);
		      } else {
		        tmp_0 = false;
		      }
		      tmp = tmp_0;
		    }
		    return tmp;
		  };
		  protoOf(InternalHashMap).hashCode = function () {
		    var result = 0;
		    var it = this.d3();
		    while (it.q()) {
		      result = result + it.w4() | 0;
		    }
		    return result;
		  };
		  protoOf(InternalHashMap).toString = function () {
		    var sb = StringBuilder_init_$Create$(2 + imul(this.w3_1, 3) | 0);
		    sb.a5('{');
		    var i = 0;
		    var it = this.d3();
		    while (it.q()) {
		      if (i > 0) {
		        sb.a5(', ');
		      }
		      it.x4(sb);
		      i = i + 1 | 0;
		    }
		    sb.a5('}');
		    return sb.toString();
		  };
		  protoOf(InternalHashMap).o = function () {
		    if (this.x3_1)
		      throw UnsupportedOperationException_init_$Create$();
		  };
		  protoOf(InternalHashMap).g3 = function (entry) {
		    var index = findKey(this, entry.v1());
		    if (index < 0)
		      return false;
		    return equals_0(ensureNotNull(this.p3_1)[index], entry.w1());
		  };
		  protoOf(InternalHashMap).e5 = function (entry) {
		    return this.g3(isInterface(entry, Entry) ? entry : THROW_CCE());
		  };
		  protoOf(InternalHashMap).v2 = function () {
		    return new KeysItr(this);
		  };
		  protoOf(InternalHashMap).a3 = function () {
		    return new ValuesItr(this);
		  };
		  protoOf(InternalHashMap).d3 = function () {
		    return new EntriesItr(this);
		  };
		  function InternalMap() {
		  }
		  function LinkedHashMap_init_$Init$($this) {
		    HashMap_init_$Init$_0($this);
		    LinkedHashMap.call($this);
		    return $this;
		  }
		  function LinkedHashMap_init_$Create$() {
		    return LinkedHashMap_init_$Init$(objectCreate(protoOf(LinkedHashMap)));
		  }
		  function LinkedHashMap_init_$Init$_0(initialCapacity, $this) {
		    HashMap_init_$Init$_2(initialCapacity, $this);
		    LinkedHashMap.call($this);
		    return $this;
		  }
		  function LinkedHashMap_init_$Create$_0(initialCapacity) {
		    return LinkedHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(LinkedHashMap)));
		  }
		  function LinkedHashMap_init_$Init$_1(original, $this) {
		    HashMap_init_$Init$_3(original, $this);
		    LinkedHashMap.call($this);
		    return $this;
		  }
		  function LinkedHashMap_init_$Create$_1(original) {
		    return LinkedHashMap_init_$Init$_1(original, objectCreate(protoOf(LinkedHashMap)));
		  }
		  protoOf(LinkedHashMap).o = function () {
		    return this.r2_1.o();
		  };
		  function LinkedHashMap() {
		  }
		  function LinkedHashSet_init_$Init$($this) {
		    HashSet_init_$Init$_0($this);
		    LinkedHashSet.call($this);
		    return $this;
		  }
		  function LinkedHashSet_init_$Create$() {
		    return LinkedHashSet_init_$Init$(objectCreate(protoOf(LinkedHashSet)));
		  }
		  function LinkedHashSet_init_$Init$_0(elements, $this) {
		    HashSet_init_$Init$_1(elements, $this);
		    LinkedHashSet.call($this);
		    return $this;
		  }
		  function LinkedHashSet_init_$Create$_0(elements) {
		    return LinkedHashSet_init_$Init$_0(elements, objectCreate(protoOf(LinkedHashSet)));
		  }
		  function LinkedHashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
		    HashSet_init_$Init$_2(initialCapacity, loadFactor, $this);
		    LinkedHashSet.call($this);
		    return $this;
		  }
		  function LinkedHashSet_init_$Init$_2(initialCapacity, $this) {
		    LinkedHashSet_init_$Init$_1(initialCapacity, 1.0, $this);
		    return $this;
		  }
		  function LinkedHashSet_init_$Create$_1(initialCapacity) {
		    return LinkedHashSet_init_$Init$_2(initialCapacity, objectCreate(protoOf(LinkedHashSet)));
		  }
		  protoOf(LinkedHashSet).o = function () {
		    return this.n3_1.o();
		  };
		  function LinkedHashSet() {
		  }
		  function json(pairs) {
		    var res = {};
		    var inductionVariable = 0;
		    var last = pairs.length;
		    while (inductionVariable < last) {
		      var tmp1_loop_parameter = pairs[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      var name = tmp1_loop_parameter.o5();
		      var value = tmp1_loop_parameter.p5();
		      res[name] = value;
		    }
		    return res;
		  }
		  function roundToLong(_this__u8e3s4) {
		    var tmp;
		    if (isNaN_0(_this__u8e3s4)) {
		      throw IllegalArgumentException_init_$Create$_0('Cannot round NaN value.');
		    } else {
		      Companion_getInstance_4();
		      if (_this__u8e3s4 > (new Long(-1, 2147483647)).q5()) {
		        Companion_getInstance_4();
		        tmp = new Long(-1, 2147483647);
		      } else {
		        Companion_getInstance_4();
		        if (_this__u8e3s4 < (new Long(0, -2147483648)).q5()) {
		          Companion_getInstance_4();
		          tmp = new Long(0, -2147483648);
		        } else {
		          tmp = numberToLong(Math.round(_this__u8e3s4));
		        }
		      }
		    }
		    return tmp;
		  }
		  var INV_2_26;
		  var INV_2_53;
		  function defaultPlatformRandom() {
		    _init_properties_PlatformRandom_kt__6kjv62();
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp$ret$0 = Math.random() * Math.pow(2, 32) | 0;
		    return Random_0(tmp$ret$0);
		  }
		  var properties_initialized_PlatformRandom_kt_uibhw8;
		  function _init_properties_PlatformRandom_kt__6kjv62() {
		    if (!properties_initialized_PlatformRandom_kt_uibhw8) {
		      properties_initialized_PlatformRandom_kt_uibhw8 = true;
		      // Inline function 'kotlin.math.pow' call
		      INV_2_26 = Math.pow(2.0, -26);
		      // Inline function 'kotlin.math.pow' call
		      INV_2_53 = Math.pow(2.0, -53);
		    }
		  }
		  function get_js(_this__u8e3s4) {
		    return (_this__u8e3s4 instanceof KClassImpl ? _this__u8e3s4 : THROW_CCE()).s5();
		  }
		  function KClass() {
		  }
		  function KClassImpl(jClass) {
		    this.r5_1 = jClass;
		  }
		  protoOf(KClassImpl).s5 = function () {
		    return this.r5_1;
		  };
		  protoOf(KClassImpl).equals = function (other) {
		    var tmp;
		    if (other instanceof NothingKClassImpl) {
		      tmp = false;
		    } else {
		      if (other instanceof ErrorKClass) {
		        tmp = false;
		      } else {
		        if (other instanceof KClassImpl) {
		          tmp = equals_0(this.s5(), other.s5());
		        } else {
		          tmp = false;
		        }
		      }
		    }
		    return tmp;
		  };
		  protoOf(KClassImpl).hashCode = function () {
		    var tmp0_safe_receiver = this.t5();
		    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
		    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
		  };
		  protoOf(KClassImpl).toString = function () {
		    return 'class ' + this.t5();
		  };
		  function NothingKClassImpl() {
		    NothingKClassImpl_instance = this;
		    KClassImpl.call(this, Object);
		    this.w5_1 = 'Nothing';
		  }
		  protoOf(NothingKClassImpl).t5 = function () {
		    return this.w5_1;
		  };
		  protoOf(NothingKClassImpl).u5 = function (value) {
		    return false;
		  };
		  protoOf(NothingKClassImpl).s5 = function () {
		    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
		  };
		  protoOf(NothingKClassImpl).equals = function (other) {
		    return other === this;
		  };
		  protoOf(NothingKClassImpl).hashCode = function () {
		    return 0;
		  };
		  var NothingKClassImpl_instance;
		  function NothingKClassImpl_getInstance() {
		    if (NothingKClassImpl_instance == null)
		      new NothingKClassImpl();
		    return NothingKClassImpl_instance;
		  }
		  function ErrorKClass() {
		  }
		  protoOf(ErrorKClass).t5 = function () {
		    var message = 'Unknown simpleName for ErrorKClass';
		    throw IllegalStateException_init_$Create$_0(toString_1(message));
		  };
		  protoOf(ErrorKClass).u5 = function (value) {
		    var message = "Can's check isInstance on ErrorKClass";
		    throw IllegalStateException_init_$Create$_0(toString_1(message));
		  };
		  protoOf(ErrorKClass).equals = function (other) {
		    return other === this;
		  };
		  protoOf(ErrorKClass).hashCode = function () {
		    return 0;
		  };
		  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
		    KClassImpl.call(this, jClass);
		    this.y5_1 = givenSimpleName;
		    this.z5_1 = isInstanceFunction;
		  }
		  protoOf(PrimitiveKClassImpl).equals = function (other) {
		    if (!(other instanceof PrimitiveKClassImpl))
		      return false;
		    return protoOf(KClassImpl).equals.call(this, other) ? this.y5_1 === other.y5_1 : false;
		  };
		  protoOf(PrimitiveKClassImpl).t5 = function () {
		    return this.y5_1;
		  };
		  protoOf(PrimitiveKClassImpl).u5 = function (value) {
		    return this.z5_1(value);
		  };
		  function SimpleKClassImpl(jClass) {
		    KClassImpl.call(this, jClass);
		    var tmp = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp0_safe_receiver = jClass.$metadata$;
		    tmp.b6_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
		  }
		  protoOf(SimpleKClassImpl).t5 = function () {
		    return this.b6_1;
		  };
		  protoOf(SimpleKClassImpl).u5 = function (value) {
		    return jsIsType(value, this.s5());
		  };
		  function KProperty1() {
		  }
		  function createKType(classifier, arguments_0, isMarkedNullable) {
		    return new KTypeImpl(classifier, asList(arguments_0), isMarkedNullable);
		  }
		  function KTypeImpl(classifier, arguments_0, isMarkedNullable) {
		    this.c6_1 = classifier;
		    this.d6_1 = arguments_0;
		    this.e6_1 = isMarkedNullable;
		  }
		  protoOf(KTypeImpl).f6 = function () {
		    return this.c6_1;
		  };
		  protoOf(KTypeImpl).g6 = function () {
		    return this.d6_1;
		  };
		  protoOf(KTypeImpl).h6 = function () {
		    return this.e6_1;
		  };
		  protoOf(KTypeImpl).equals = function (other) {
		    var tmp;
		    var tmp_0;
		    var tmp_1;
		    if (other instanceof KTypeImpl) {
		      tmp_1 = equals_0(this.c6_1, other.c6_1);
		    } else {
		      tmp_1 = false;
		    }
		    if (tmp_1) {
		      tmp_0 = equals_0(this.d6_1, other.d6_1);
		    } else {
		      tmp_0 = false;
		    }
		    if (tmp_0) {
		      tmp = this.e6_1 === other.e6_1;
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(KTypeImpl).hashCode = function () {
		    return imul(imul(hashCode(this.c6_1), 31) + hashCode(this.d6_1) | 0, 31) + getBooleanHashCode(this.e6_1) | 0;
		  };
		  protoOf(KTypeImpl).toString = function () {
		    var tmp = this.c6_1;
		    var kClass = isInterface(tmp, KClass) ? tmp : null;
		    var classifierName = kClass == null ? toString_1(this.c6_1) : !(kClass.t5() == null) ? kClass.t5() : '(non-denotable type)';
		    var args = this.d6_1.x() ? '' : joinToString_0(this.d6_1, ', ', '<', '>');
		    var nullable = this.e6_1 ? '?' : '';
		    return plus_0(classifierName, args) + nullable;
		  };
		  function get_functionClasses() {
		    _init_properties_primitives_kt__3fums4();
		    return functionClasses;
		  }
		  var functionClasses;
		  function PrimitiveClasses$anyClass$lambda(it) {
		    return !(it == null);
		  }
		  function PrimitiveClasses$numberClass$lambda(it) {
		    return isNumber(it);
		  }
		  function PrimitiveClasses$booleanClass$lambda(it) {
		    return !(it == null) ? typeof it === 'boolean' : false;
		  }
		  function PrimitiveClasses$byteClass$lambda(it) {
		    return !(it == null) ? typeof it === 'number' : false;
		  }
		  function PrimitiveClasses$shortClass$lambda(it) {
		    return !(it == null) ? typeof it === 'number' : false;
		  }
		  function PrimitiveClasses$intClass$lambda(it) {
		    return !(it == null) ? typeof it === 'number' : false;
		  }
		  function PrimitiveClasses$floatClass$lambda(it) {
		    return !(it == null) ? typeof it === 'number' : false;
		  }
		  function PrimitiveClasses$doubleClass$lambda(it) {
		    return !(it == null) ? typeof it === 'number' : false;
		  }
		  function PrimitiveClasses$arrayClass$lambda(it) {
		    return !(it == null) ? isArray(it) : false;
		  }
		  function PrimitiveClasses$stringClass$lambda(it) {
		    return !(it == null) ? typeof it === 'string' : false;
		  }
		  function PrimitiveClasses$throwableClass$lambda(it) {
		    return it instanceof Error;
		  }
		  function PrimitiveClasses$booleanArrayClass$lambda(it) {
		    return !(it == null) ? isBooleanArray(it) : false;
		  }
		  function PrimitiveClasses$charArrayClass$lambda(it) {
		    return !(it == null) ? isCharArray(it) : false;
		  }
		  function PrimitiveClasses$byteArrayClass$lambda(it) {
		    return !(it == null) ? isByteArray(it) : false;
		  }
		  function PrimitiveClasses$shortArrayClass$lambda(it) {
		    return !(it == null) ? isShortArray(it) : false;
		  }
		  function PrimitiveClasses$intArrayClass$lambda(it) {
		    return !(it == null) ? isIntArray(it) : false;
		  }
		  function PrimitiveClasses$longArrayClass$lambda(it) {
		    return !(it == null) ? isLongArray(it) : false;
		  }
		  function PrimitiveClasses$floatArrayClass$lambda(it) {
		    return !(it == null) ? isFloatArray(it) : false;
		  }
		  function PrimitiveClasses$doubleArrayClass$lambda(it) {
		    return !(it == null) ? isDoubleArray(it) : false;
		  }
		  function PrimitiveClasses$functionClass$lambda($arity) {
		    return function (it) {
		      var tmp;
		      if (typeof it === 'function') {
		        // Inline function 'kotlin.js.asDynamic' call
		        tmp = it.length === $arity;
		      } else {
		        tmp = false;
		      }
		      return tmp;
		    };
		  }
		  function PrimitiveClasses() {
		    PrimitiveClasses_instance = this;
		    var tmp = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_0 = Object;
		    tmp.anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', PrimitiveClasses$anyClass$lambda);
		    var tmp_1 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_2 = Number;
		    tmp_1.numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', PrimitiveClasses$numberClass$lambda);
		    this.nothingClass = NothingKClassImpl_getInstance();
		    var tmp_3 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_4 = Boolean;
		    tmp_3.booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', PrimitiveClasses$booleanClass$lambda);
		    var tmp_5 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_6 = Number;
		    tmp_5.byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', PrimitiveClasses$byteClass$lambda);
		    var tmp_7 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_8 = Number;
		    tmp_7.shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', PrimitiveClasses$shortClass$lambda);
		    var tmp_9 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_10 = Number;
		    tmp_9.intClass = new PrimitiveKClassImpl(tmp_10, 'Int', PrimitiveClasses$intClass$lambda);
		    var tmp_11 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_12 = Number;
		    tmp_11.floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', PrimitiveClasses$floatClass$lambda);
		    var tmp_13 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_14 = Number;
		    tmp_13.doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', PrimitiveClasses$doubleClass$lambda);
		    var tmp_15 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_16 = Array;
		    tmp_15.arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', PrimitiveClasses$arrayClass$lambda);
		    var tmp_17 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_18 = String;
		    tmp_17.stringClass = new PrimitiveKClassImpl(tmp_18, 'String', PrimitiveClasses$stringClass$lambda);
		    var tmp_19 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_20 = Error;
		    tmp_19.throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', PrimitiveClasses$throwableClass$lambda);
		    var tmp_21 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_22 = Array;
		    tmp_21.booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', PrimitiveClasses$booleanArrayClass$lambda);
		    var tmp_23 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_24 = Uint16Array;
		    tmp_23.charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', PrimitiveClasses$charArrayClass$lambda);
		    var tmp_25 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_26 = Int8Array;
		    tmp_25.byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', PrimitiveClasses$byteArrayClass$lambda);
		    var tmp_27 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_28 = Int16Array;
		    tmp_27.shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', PrimitiveClasses$shortArrayClass$lambda);
		    var tmp_29 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_30 = Int32Array;
		    tmp_29.intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', PrimitiveClasses$intArrayClass$lambda);
		    var tmp_31 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_32 = Array;
		    tmp_31.longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', PrimitiveClasses$longArrayClass$lambda);
		    var tmp_33 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_34 = Float32Array;
		    tmp_33.floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', PrimitiveClasses$floatArrayClass$lambda);
		    var tmp_35 = this;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp_36 = Float64Array;
		    tmp_35.doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', PrimitiveClasses$doubleArrayClass$lambda);
		  }
		  protoOf(PrimitiveClasses).i6 = function () {
		    return this.anyClass;
		  };
		  protoOf(PrimitiveClasses).j6 = function () {
		    return this.numberClass;
		  };
		  protoOf(PrimitiveClasses).k6 = function () {
		    return this.nothingClass;
		  };
		  protoOf(PrimitiveClasses).l6 = function () {
		    return this.booleanClass;
		  };
		  protoOf(PrimitiveClasses).m6 = function () {
		    return this.byteClass;
		  };
		  protoOf(PrimitiveClasses).n6 = function () {
		    return this.shortClass;
		  };
		  protoOf(PrimitiveClasses).o6 = function () {
		    return this.intClass;
		  };
		  protoOf(PrimitiveClasses).p6 = function () {
		    return this.floatClass;
		  };
		  protoOf(PrimitiveClasses).q6 = function () {
		    return this.doubleClass;
		  };
		  protoOf(PrimitiveClasses).r6 = function () {
		    return this.arrayClass;
		  };
		  protoOf(PrimitiveClasses).s6 = function () {
		    return this.stringClass;
		  };
		  protoOf(PrimitiveClasses).t6 = function () {
		    return this.throwableClass;
		  };
		  protoOf(PrimitiveClasses).u6 = function () {
		    return this.booleanArrayClass;
		  };
		  protoOf(PrimitiveClasses).v6 = function () {
		    return this.charArrayClass;
		  };
		  protoOf(PrimitiveClasses).w6 = function () {
		    return this.byteArrayClass;
		  };
		  protoOf(PrimitiveClasses).x6 = function () {
		    return this.shortArrayClass;
		  };
		  protoOf(PrimitiveClasses).y6 = function () {
		    return this.intArrayClass;
		  };
		  protoOf(PrimitiveClasses).z6 = function () {
		    return this.longArrayClass;
		  };
		  protoOf(PrimitiveClasses).a7 = function () {
		    return this.floatArrayClass;
		  };
		  protoOf(PrimitiveClasses).b7 = function () {
		    return this.doubleArrayClass;
		  };
		  protoOf(PrimitiveClasses).functionClass = function (arity) {
		    var tmp0_elvis_lhs = get_functionClasses()[arity];
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      // Inline function 'kotlin.run' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.reflect.js.internal.PrimitiveClasses.functionClass.<anonymous>' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      var tmp_0 = Function;
		      var tmp_1 = 'Function' + arity;
		      var result = new PrimitiveKClassImpl(tmp_0, tmp_1, PrimitiveClasses$functionClass$lambda(arity));
		      // Inline function 'kotlin.js.asDynamic' call
		      get_functionClasses()[arity] = result;
		      tmp = result;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  var PrimitiveClasses_instance;
		  function PrimitiveClasses_getInstance() {
		    if (PrimitiveClasses_instance == null)
		      new PrimitiveClasses();
		    return PrimitiveClasses_instance;
		  }
		  var properties_initialized_primitives_kt_jle18u;
		  function _init_properties_primitives_kt__3fums4() {
		    if (!properties_initialized_primitives_kt_jle18u) {
		      properties_initialized_primitives_kt_jle18u = true;
		      // Inline function 'kotlin.arrayOfNulls' call
		      functionClasses = fillArrayVal(Array(0), null);
		    }
		  }
		  function getKClass(jClass) {
		    var tmp;
		    if (Array.isArray(jClass)) {
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = getKClassM(jClass);
		    } else {
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = getKClass1(jClass);
		    }
		    return tmp;
		  }
		  function getKClassM(jClasses) {
		    var tmp;
		    switch (jClasses.length) {
		      case 1:
		        tmp = getKClass1(jClasses[0]);
		        break;
		      case 0:
		        // Inline function 'kotlin.js.unsafeCast' call

		        // Inline function 'kotlin.js.asDynamic' call

		        tmp = NothingKClassImpl_getInstance();
		        break;
		      default:
		        // Inline function 'kotlin.js.unsafeCast' call

		        // Inline function 'kotlin.js.asDynamic' call

		        tmp = new ErrorKClass();
		        break;
		    }
		    return tmp;
		  }
		  function getKClass1(jClass) {
		    if (jClass === String) {
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      return PrimitiveClasses_getInstance().stringClass;
		    }
		    // Inline function 'kotlin.js.asDynamic' call
		    var metadata = jClass.$metadata$;
		    var tmp;
		    if (metadata != null) {
		      var tmp_0;
		      if (metadata.$kClass$ == null) {
		        var kClass = new SimpleKClassImpl(jClass);
		        metadata.$kClass$ = kClass;
		        tmp_0 = kClass;
		      } else {
		        tmp_0 = metadata.$kClass$;
		      }
		      tmp = tmp_0;
		    } else {
		      tmp = new SimpleKClassImpl(jClass);
		    }
		    return tmp;
		  }
		  function getKClassFromExpression(e) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp;
		    switch (typeof e) {
		      case 'string':
		        tmp = PrimitiveClasses_getInstance().stringClass;
		        break;
		      case 'number':
		        var tmp_0;
		        // Inline function 'kotlin.js.asDynamic' call

		        // Inline function 'kotlin.js.jsBitwiseOr' call

		        if ((e | 0) === e) {
		          tmp_0 = PrimitiveClasses_getInstance().intClass;
		        } else {
		          tmp_0 = PrimitiveClasses_getInstance().doubleClass;
		        }

		        tmp = tmp_0;
		        break;
		      case 'boolean':
		        tmp = PrimitiveClasses_getInstance().booleanClass;
		        break;
		      case 'function':
		        var tmp_1 = PrimitiveClasses_getInstance();
		        // Inline function 'kotlin.js.asDynamic' call

		        tmp = tmp_1.functionClass(e.length);
		        break;
		      default:
		        var tmp_2;
		        if (isBooleanArray(e)) {
		          tmp_2 = PrimitiveClasses_getInstance().booleanArrayClass;
		        } else {
		          if (isCharArray(e)) {
		            tmp_2 = PrimitiveClasses_getInstance().charArrayClass;
		          } else {
		            if (isByteArray(e)) {
		              tmp_2 = PrimitiveClasses_getInstance().byteArrayClass;
		            } else {
		              if (isShortArray(e)) {
		                tmp_2 = PrimitiveClasses_getInstance().shortArrayClass;
		              } else {
		                if (isIntArray(e)) {
		                  tmp_2 = PrimitiveClasses_getInstance().intArrayClass;
		                } else {
		                  if (isLongArray(e)) {
		                    tmp_2 = PrimitiveClasses_getInstance().longArrayClass;
		                  } else {
		                    if (isFloatArray(e)) {
		                      tmp_2 = PrimitiveClasses_getInstance().floatArrayClass;
		                    } else {
		                      if (isDoubleArray(e)) {
		                        tmp_2 = PrimitiveClasses_getInstance().doubleArrayClass;
		                      } else {
		                        if (isInterface(e, KClass)) {
		                          tmp_2 = getKClass(KClass);
		                        } else {
		                          if (isArray(e)) {
		                            tmp_2 = PrimitiveClasses_getInstance().arrayClass;
		                          } else {
		                            var constructor = Object.getPrototypeOf(e).constructor;
		                            var tmp_3;
		                            if (constructor === Object) {
		                              tmp_3 = PrimitiveClasses_getInstance().anyClass;
		                            } else if (constructor === Error) {
		                              tmp_3 = PrimitiveClasses_getInstance().throwableClass;
		                            } else {
		                              var jsClass = constructor;
		                              tmp_3 = getKClass1(jsClass);
		                            }
		                            tmp_2 = tmp_3;
		                          }
		                        }
		                      }
		                    }
		                  }
		                }
		              }
		            }
		          }
		        }

		        tmp = tmp_2;
		        break;
		    }
		    // Inline function 'kotlin.js.asDynamic' call
		    return tmp;
		  }
		  function reset(_this__u8e3s4) {
		    _this__u8e3s4.lastIndex = 0;
		  }
		  function StringBuilder_init_$Init$(capacity, $this) {
		    StringBuilder_init_$Init$_0($this);
		    return $this;
		  }
		  function StringBuilder_init_$Create$(capacity) {
		    return StringBuilder_init_$Init$(capacity, objectCreate(protoOf(StringBuilder)));
		  }
		  function StringBuilder_init_$Init$_0($this) {
		    StringBuilder.call($this, '');
		    return $this;
		  }
		  function StringBuilder_init_$Create$_0() {
		    return StringBuilder_init_$Init$_0(objectCreate(protoOf(StringBuilder)));
		  }
		  function StringBuilder(content) {
		    this.y4_1 = !(content === undefined) ? content : '';
		  }
		  protoOf(StringBuilder).a = function () {
		    // Inline function 'kotlin.js.asDynamic' call
		    return this.y4_1.length;
		  };
		  protoOf(StringBuilder).b = function (index) {
		    // Inline function 'kotlin.text.getOrElse' call
		    var this_0 = this.y4_1;
		    var tmp;
		    if (index >= 0 ? index <= get_lastIndex_3(this_0) : false) {
		      tmp = charSequenceGet(this_0, index);
		    } else {
		      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', length: ' + this.a() + '}');
		    }
		    return tmp;
		  };
		  protoOf(StringBuilder).c = function (startIndex, endIndex) {
		    // Inline function 'kotlin.text.substring' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return this.y4_1.substring(startIndex, endIndex);
		  };
		  protoOf(StringBuilder).b5 = function (value) {
		    this.y4_1 = this.y4_1 + toString(value);
		    return this;
		  };
		  protoOf(StringBuilder).c7 = function (value) {
		    this.y4_1 = this.y4_1 + toString_0(value);
		    return this;
		  };
		  protoOf(StringBuilder).d7 = function (value, startIndex, endIndex) {
		    return this.e7(value == null ? 'null' : value, startIndex, endIndex);
		  };
		  protoOf(StringBuilder).z4 = function (value) {
		    this.y4_1 = this.y4_1 + toString_0(value);
		    return this;
		  };
		  protoOf(StringBuilder).f7 = function (value) {
		    return this.a5(value.toString());
		  };
		  protoOf(StringBuilder).g7 = function (value) {
		    return this.a5(value.toString());
		  };
		  protoOf(StringBuilder).a5 = function (value) {
		    var tmp = this;
		    var tmp_0 = this.y4_1;
		    tmp.y4_1 = tmp_0 + (value == null ? 'null' : value);
		    return this;
		  };
		  protoOf(StringBuilder).h7 = function (index, value) {
		    Companion_instance_5.k2(index, this.a());
		    var tmp = this;
		    // Inline function 'kotlin.text.substring' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp_0 = this.y4_1.substring(0, index) + toString(value);
		    // Inline function 'kotlin.text.substring' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.y4_1 = tmp_0 + this.y4_1.substring(index);
		    return this;
		  };
		  protoOf(StringBuilder).i7 = function (newLength) {
		    if (newLength < 0) {
		      throw IllegalArgumentException_init_$Create$_0('Negative new length: ' + newLength + '.');
		    }
		    if (newLength <= this.a()) {
		      var tmp = this;
		      // Inline function 'kotlin.text.substring' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp.y4_1 = this.y4_1.substring(0, newLength);
		    } else {
		      var inductionVariable = this.a();
		      if (inductionVariable < newLength)
		        do {
		          var i = inductionVariable;
		          inductionVariable = inductionVariable + 1 | 0;
		          this.y4_1 = this.y4_1 + toString(_Char___init__impl__6a9atx(0));
		        }
		         while (inductionVariable < newLength);
		    }
		  };
		  protoOf(StringBuilder).toString = function () {
		    return this.y4_1;
		  };
		  protoOf(StringBuilder).j7 = function () {
		    this.y4_1 = '';
		    return this;
		  };
		  protoOf(StringBuilder).e7 = function (value, startIndex, endIndex) {
		    var stringCsq = toString_1(value);
		    Companion_instance_5.k7(startIndex, endIndex, stringCsq.length);
		    var tmp = this;
		    var tmp_0 = this.y4_1;
		    // Inline function 'kotlin.text.substring' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.y4_1 = tmp_0 + stringCsq.substring(startIndex, endIndex);
		    return this;
		  };
		  function uppercaseChar(_this__u8e3s4) {
		    // Inline function 'kotlin.text.uppercase' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var uppercase = toString(_this__u8e3s4).toUpperCase();
		    return uppercase.length > 1 ? _this__u8e3s4 : charSequenceGet(uppercase, 0);
		  }
		  function isWhitespace(_this__u8e3s4) {
		    return isWhitespaceImpl(_this__u8e3s4);
		  }
		  function isLowerCase(_this__u8e3s4) {
		    if (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) {
		      return true;
		    }
		    if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(128)) < 0) {
		      return false;
		    }
		    return isLowerCaseImpl(_this__u8e3s4);
		  }
		  function titlecaseChar(_this__u8e3s4) {
		    return titlecaseCharImpl(_this__u8e3s4);
		  }
		  function checkRadix(radix) {
		    if (!(2 <= radix ? radix <= 36 : false)) {
		      throw IllegalArgumentException_init_$Create$_0('radix ' + radix + ' was not in valid range 2..36');
		    }
		    return radix;
		  }
		  function toDouble(_this__u8e3s4) {
		    // Inline function 'kotlin.also' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var this_0 = +_this__u8e3s4;
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.text.toDouble.<anonymous>' call
		    if ((isNaN_0(this_0) ? !isNaN_2(_this__u8e3s4) : false) ? true : this_0 === 0.0 ? isBlank(_this__u8e3s4) : false) {
		      numberFormatError(_this__u8e3s4);
		    }
		    return this_0;
		  }
		  function toLong(_this__u8e3s4) {
		    var tmp0_elvis_lhs = toLongOrNull(_this__u8e3s4);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      numberFormatError(_this__u8e3s4);
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function digitOf(char, radix) {
		    // Inline function 'kotlin.let' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.text.digitOf.<anonymous>' call
		    var it = (Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(48)) >= 0 ? Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(57)) <= 0 : false) ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(48)) : (Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65)) >= 0 ? Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(90)) <= 0 : false) ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65)) + 10 | 0 : (Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(97)) >= 0 ? Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(122)) <= 0 : false) ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(97)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(128)) < 0 ? -1 : (Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65313)) >= 0 ? Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65338)) <= 0 : false) ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65313)) + 10 | 0 : (Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65345)) >= 0 ? Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65370)) <= 0 : false) ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65345)) + 10 | 0 : digitToIntImpl(char);
		    return it >= radix ? -1 : it;
		  }
		  function isNaN_2(_this__u8e3s4) {
		    // Inline function 'kotlin.text.lowercase' call
		    // Inline function 'kotlin.js.asDynamic' call
		    switch (_this__u8e3s4.toLowerCase()) {
		      case 'nan':
		      case '+nan':
		      case '-nan':
		        return true;
		      default:
		        return false;
		    }
		  }
		  function toInt(_this__u8e3s4) {
		    var tmp0_elvis_lhs = toIntOrNull(_this__u8e3s4);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      numberFormatError(_this__u8e3s4);
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function toDoubleOrNull(_this__u8e3s4) {
		    // Inline function 'kotlin.takeIf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var this_0 = +_this__u8e3s4;
		    // Inline function 'kotlin.contracts.contract' call
		    var tmp;
		    // Inline function 'kotlin.text.toDoubleOrNull.<anonymous>' call
		    if (!((isNaN_0(this_0) ? !isNaN_2(_this__u8e3s4) : false) ? true : this_0 === 0.0 ? isBlank(_this__u8e3s4) : false)) {
		      tmp = this_0;
		    } else {
		      tmp = null;
		    }
		    return tmp;
		  }
		  function Regex_init_$Init$(pattern, $this) {
		    Regex.call($this, pattern, emptySet());
		    return $this;
		  }
		  function Regex_init_$Create$(pattern) {
		    return Regex_init_$Init$(pattern, objectCreate(protoOf(Regex)));
		  }
		  function Companion_1() {
		    Companion_instance_1 = this;
		    this.l7_1 = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
		    this.m7_1 = new RegExp('[\\\\$]', 'g');
		    this.n7_1 = new RegExp('\\$', 'g');
		  }
		  protoOf(Companion_1).o7 = function (literal) {
		    // Inline function 'kotlin.text.nativeReplace' call
		    var pattern = this.l7_1;
		    // Inline function 'kotlin.js.asDynamic' call
		    return literal.replace(pattern, '\\$&');
		  };
		  protoOf(Companion_1).p7 = function (literal) {
		    // Inline function 'kotlin.text.nativeReplace' call
		    var pattern = this.n7_1;
		    // Inline function 'kotlin.js.asDynamic' call
		    return literal.replace(pattern, '$$$$');
		  };
		  var Companion_instance_1;
		  function Companion_getInstance_1() {
		    if (Companion_instance_1 == null)
		      new Companion_1();
		    return Companion_instance_1;
		  }
		  function Regex(pattern, options) {
		    Companion_getInstance_1();
		    this.q7_1 = pattern;
		    this.r7_1 = toSet_0(options);
		    this.s7_1 = new RegExp(pattern, toFlags(options, 'gu'));
		    this.t7_1 = null;
		    this.u7_1 = null;
		  }
		  protoOf(Regex).v7 = function (input) {
		    reset(this.s7_1);
		    return this.s7_1.test(toString_1(input));
		  };
		  protoOf(Regex).toString = function () {
		    return this.s7_1.toString();
		  };
		  function toFlags(_this__u8e3s4, prepend) {
		    return joinToString_0(_this__u8e3s4, '', prepend, VOID, VOID, VOID, toFlags$lambda);
		  }
		  function toFlags$lambda(it) {
		    return it.y7_1;
		  }
		  function regionMatches(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    return regionMatchesImpl(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase);
		  }
		  function startsWith(_this__u8e3s4, prefix, ignoreCase) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    if (!ignoreCase) {
		      // Inline function 'kotlin.text.nativeStartsWith' call
		      // Inline function 'kotlin.js.asDynamic' call
		      return _this__u8e3s4.startsWith(prefix, 0);
		    } else
		      return regionMatches(_this__u8e3s4, 0, prefix, 0, prefix.length, ignoreCase);
		  }
		  function isBlank(_this__u8e3s4) {
		    var tmp;
		    if (charSequenceLength(_this__u8e3s4) === 0) {
		      tmp = true;
		    } else {
		      var tmp$ret$0;
		      $l$block_0: {
		        // Inline function 'kotlin.collections.all' call
		        var this_0 = get_indices_1(_this__u8e3s4);
		        var tmp_0;
		        if (isInterface(this_0, Collection)) {
		          tmp_0 = this_0.x();
		        } else {
		          tmp_0 = false;
		        }
		        if (tmp_0) {
		          tmp$ret$0 = true;
		          break $l$block_0;
		        }
		        var tmp0_iterator = this_0.p();
		        while (tmp0_iterator.q()) {
		          var element = tmp0_iterator.s();
		          // Inline function 'kotlin.text.isBlank.<anonymous>' call
		          if (!isWhitespace(charSequenceGet(_this__u8e3s4, element))) {
		            tmp$ret$0 = false;
		            break $l$block_0;
		          }
		        }
		        tmp$ret$0 = true;
		      }
		      tmp = tmp$ret$0;
		    }
		    return tmp;
		  }
		  function equals(_this__u8e3s4, other, ignoreCase) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    if (_this__u8e3s4 == null)
		      return other == null;
		    if (other == null)
		      return false;
		    if (!ignoreCase)
		      return _this__u8e3s4 == other;
		    if (!(_this__u8e3s4.length === other.length))
		      return false;
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length;
		    if (inductionVariable < last)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var thisChar = charSequenceGet(_this__u8e3s4, index);
		        var otherChar = charSequenceGet(other, index);
		        if (!equals_1(thisChar, otherChar, ignoreCase)) {
		          return false;
		        }
		      }
		       while (inductionVariable < last);
		    return true;
		  }
		  function replaceFirst(_this__u8e3s4, oldValue, newValue, ignoreCase) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    // Inline function 'kotlin.text.nativeReplace' call
		    var pattern = new RegExp(Companion_getInstance_1().o7(oldValue), ignoreCase ? 'ui' : 'u');
		    var replacement = Companion_getInstance_1().p7(newValue);
		    // Inline function 'kotlin.js.asDynamic' call
		    return _this__u8e3s4.replace(pattern, replacement);
		  }
		  function stackTraceToString(_this__u8e3s4) {
		    return (new ExceptionTraceBuilder()).d8(_this__u8e3s4);
		  }
		  function hasSeen($this, exception) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlin.collections.any' call
		      var indexedObject = $this.a8_1;
		      var inductionVariable = 0;
		      var last = indexedObject.length;
		      while (inductionVariable < last) {
		        var element = indexedObject[inductionVariable];
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.ExceptionTraceBuilder.hasSeen.<anonymous>' call
		        if (element === exception) {
		          tmp$ret$1 = true;
		          break $l$block;
		        }
		      }
		      tmp$ret$1 = false;
		    }
		    return tmp$ret$1;
		  }
		  function dumpFullTrace(_this__u8e3s4, $this, indent, qualifier) {
		    if (dumpSelfTrace(_this__u8e3s4, $this, indent, qualifier))
		      true;
		    else
		      return Unit_instance;
		    var cause = _this__u8e3s4.cause;
		    while (!(cause == null)) {
		      if (dumpSelfTrace(cause, $this, indent, 'Caused by: '))
		        true;
		      else
		        return Unit_instance;
		      cause = cause.cause;
		    }
		  }
		  function dumpSelfTrace(_this__u8e3s4, $this, indent, qualifier) {
		    $this.z7_1.a5(indent).a5(qualifier);
		    var shortInfo = _this__u8e3s4.toString();
		    if (hasSeen($this, _this__u8e3s4)) {
		      $this.z7_1.a5('[CIRCULAR REFERENCE, SEE ABOVE: ').a5(shortInfo).a5(']\n');
		      return false;
		    }
		    // Inline function 'kotlin.js.asDynamic' call
		    $this.a8_1.push(_this__u8e3s4);
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp = _this__u8e3s4.stack;
		    var stack = (tmp == null ? true : typeof tmp === 'string') ? tmp : THROW_CCE();
		    if (!(stack == null)) {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.ExceptionTraceBuilder.dumpSelfTrace.<anonymous>' call
		      var it = indexOf_6(stack, shortInfo);
		      var stackStart = it < 0 ? 0 : it + shortInfo.length | 0;
		      if (stackStart === 0) {
		        $this.z7_1.a5(shortInfo).a5('\n');
		      }
		      // Inline function 'kotlin.text.isEmpty' call
		      var this_0 = $this.b8_1;
		      if (charSequenceLength(this_0) === 0) {
		        $this.b8_1 = stack;
		        $this.c8_1 = stackStart;
		      } else {
		        stack = dropCommonFrames($this, stack, stackStart);
		      }
		      // Inline function 'kotlin.text.isNotEmpty' call
		      if (charSequenceLength(indent) > 0) {
		        var tmp_0;
		        if (stackStart === 0) {
		          tmp_0 = 0;
		        } else {
		          // Inline function 'kotlin.text.count' call
		          var count = 0;
		          var inductionVariable = 0;
		          while (inductionVariable < charSequenceLength(shortInfo)) {
		            var element = charSequenceGet(shortInfo, inductionVariable);
		            inductionVariable = inductionVariable + 1 | 0;
		            // Inline function 'kotlin.ExceptionTraceBuilder.dumpSelfTrace.<anonymous>' call
		            if (element === _Char___init__impl__6a9atx(10)) {
		              count = count + 1 | 0;
		            }
		          }
		          tmp_0 = 1 + count | 0;
		        }
		        var messageLines = tmp_0;
		        // Inline function 'kotlin.sequences.forEachIndexed' call
		        var index = 0;
		        var tmp0_iterator = lineSequence(stack).p();
		        while (tmp0_iterator.q()) {
		          var item = tmp0_iterator.s();
		          // Inline function 'kotlin.ExceptionTraceBuilder.dumpSelfTrace.<anonymous>' call
		          var tmp1 = index;
		          index = tmp1 + 1 | 0;
		          if (checkIndexOverflow(tmp1) >= messageLines) {
		            $this.z7_1.a5(indent);
		          }
		          $this.z7_1.a5(item).a5('\n');
		        }
		      } else {
		        $this.z7_1.a5(stack).a5('\n');
		      }
		    } else {
		      $this.z7_1.a5(shortInfo).a5('\n');
		    }
		    var suppressed = get_suppressedExceptions(_this__u8e3s4);
		    // Inline function 'kotlin.collections.isNotEmpty' call
		    if (!suppressed.x()) {
		      var suppressedIndent = indent + '    ';
		      var tmp0_iterator_0 = suppressed.p();
		      while (tmp0_iterator_0.q()) {
		        var s = tmp0_iterator_0.s();
		        dumpFullTrace(s, $this, suppressedIndent, 'Suppressed: ');
		      }
		    }
		    return true;
		  }
		  function dropCommonFrames($this, stack, stackStart) {
		    var commonFrames = 0;
		    var lastBreak = 0;
		    var preLastBreak = 0;
		    var inductionVariable = 0;
		    // Inline function 'kotlin.comparisons.minOf' call
		    var a = $this.b8_1.length - $this.c8_1 | 0;
		    var b = stack.length - stackStart | 0;
		    var last = Math.min(a, b);
		    if (inductionVariable < last)
		      $l$loop: do {
		        var pos = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var c = charSequenceGet(stack, get_lastIndex_3(stack) - pos | 0);
		        if (!(c === charSequenceGet($this.b8_1, get_lastIndex_3($this.b8_1) - pos | 0)))
		          break $l$loop;
		        if (c === _Char___init__impl__6a9atx(10)) {
		          commonFrames = commonFrames + 1 | 0;
		          preLastBreak = lastBreak;
		          lastBreak = pos;
		        }
		      }
		       while (inductionVariable < last);
		    if (commonFrames <= 1)
		      return stack;
		    while (preLastBreak > 0 ? charSequenceGet(stack, get_lastIndex_3(stack) - (preLastBreak - 1 | 0) | 0) === _Char___init__impl__6a9atx(32) : false)
		      preLastBreak = preLastBreak - 1 | 0;
		    return dropLast(stack, preLastBreak) + ('... and ' + (commonFrames - 1 | 0) + ' more common stack frames skipped');
		  }
		  function ExceptionTraceBuilder() {
		    this.z7_1 = StringBuilder_init_$Create$_0();
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.a8_1 = [];
		    this.b8_1 = '';
		    this.c8_1 = 0;
		  }
		  protoOf(ExceptionTraceBuilder).d8 = function (exception) {
		    dumpFullTrace(exception, this, '', '');
		    return this.z7_1.toString();
		  };
		  function get_suppressedExceptions(_this__u8e3s4) {
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp0_safe_receiver = _this__u8e3s4._suppressed;
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.js.unsafeCast' call
		      tmp = tmp0_safe_receiver;
		    }
		    var tmp1_elvis_lhs = tmp;
		    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
		  }
		  var DurationUnit_NANOSECONDS_instance;
		  var DurationUnit_MICROSECONDS_instance;
		  var DurationUnit_MILLISECONDS_instance;
		  var DurationUnit_SECONDS_instance;
		  var DurationUnit_MINUTES_instance;
		  var DurationUnit_HOURS_instance;
		  var DurationUnit_DAYS_instance;
		  var DurationUnit_entriesInitialized;
		  function DurationUnit_initEntries() {
		    if (DurationUnit_entriesInitialized)
		      return Unit_instance;
		    DurationUnit_entriesInitialized = true;
		    DurationUnit_NANOSECONDS_instance = new DurationUnit('NANOSECONDS', 0, 1.0);
		    DurationUnit_MICROSECONDS_instance = new DurationUnit('MICROSECONDS', 1, 1000.0);
		    DurationUnit_MILLISECONDS_instance = new DurationUnit('MILLISECONDS', 2, 1000000.0);
		    DurationUnit_SECONDS_instance = new DurationUnit('SECONDS', 3, 1.0E9);
		    DurationUnit_MINUTES_instance = new DurationUnit('MINUTES', 4, 6.0E10);
		    DurationUnit_HOURS_instance = new DurationUnit('HOURS', 5, 3.6E12);
		    DurationUnit_DAYS_instance = new DurationUnit('DAYS', 6, 8.64E13);
		  }
		  function DurationUnit(name, ordinal, scale) {
		    Enum.call(this, name, ordinal);
		    this.g8_1 = scale;
		  }
		  function convertDurationUnit(value, sourceUnit, targetUnit) {
		    var sourceCompareTarget = compareTo(sourceUnit.g8_1, targetUnit.g8_1);
		    return sourceCompareTarget > 0 ? value * (sourceUnit.g8_1 / targetUnit.g8_1) : sourceCompareTarget < 0 ? value / (targetUnit.g8_1 / sourceUnit.g8_1) : value;
		  }
		  function convertDurationUnit_0(value, sourceUnit, targetUnit) {
		    var sourceCompareTarget = compareTo(sourceUnit.g8_1, targetUnit.g8_1);
		    var tmp;
		    if (sourceCompareTarget > 0) {
		      var scale = numberToLong(sourceUnit.g8_1 / targetUnit.g8_1);
		      var result = value.l8(scale);
		      var tmp_0;
		      if (result.k8(scale).equals(value)) {
		        tmp_0 = result;
		      } else if (value.m8(new Long(0, 0)) > 0) {
		        Companion_getInstance_4();
		        tmp_0 = new Long(-1, 2147483647);
		      } else {
		        Companion_getInstance_4();
		        tmp_0 = new Long(0, -2147483648);
		      }
		      tmp = tmp_0;
		    } else if (sourceCompareTarget < 0) {
		      tmp = value.k8(numberToLong(targetUnit.g8_1 / sourceUnit.g8_1));
		    } else {
		      tmp = value;
		    }
		    return tmp;
		  }
		  function convertDurationUnitOverflow(value, sourceUnit, targetUnit) {
		    var sourceCompareTarget = compareTo(sourceUnit.g8_1, targetUnit.g8_1);
		    return sourceCompareTarget > 0 ? value.l8(numberToLong(sourceUnit.g8_1 / targetUnit.g8_1)) : sourceCompareTarget < 0 ? value.k8(numberToLong(targetUnit.g8_1 / sourceUnit.g8_1)) : value;
		  }
		  function DurationUnit_NANOSECONDS_getInstance() {
		    DurationUnit_initEntries();
		    return DurationUnit_NANOSECONDS_instance;
		  }
		  function DurationUnit_MICROSECONDS_getInstance() {
		    DurationUnit_initEntries();
		    return DurationUnit_MICROSECONDS_instance;
		  }
		  function DurationUnit_MILLISECONDS_getInstance() {
		    DurationUnit_initEntries();
		    return DurationUnit_MILLISECONDS_instance;
		  }
		  function DurationUnit_SECONDS_getInstance() {
		    DurationUnit_initEntries();
		    return DurationUnit_SECONDS_instance;
		  }
		  function DurationUnit_MINUTES_getInstance() {
		    DurationUnit_initEntries();
		    return DurationUnit_MINUTES_instance;
		  }
		  function DurationUnit_HOURS_getInstance() {
		    DurationUnit_initEntries();
		    return DurationUnit_HOURS_instance;
		  }
		  function DurationUnit_DAYS_getInstance() {
		    DurationUnit_initEntries();
		    return DurationUnit_DAYS_instance;
		  }
		  function toList(_this__u8e3s4) {
		    switch (_this__u8e3s4.length) {
		      case 0:
		        return emptyList();
		      case 1:
		        return listOf(_this__u8e3s4[0]);
		      default:
		        return toMutableList(_this__u8e3s4);
		    }
		  }
		  function withIndex(_this__u8e3s4) {
		    return new IndexingIterable(withIndex$lambda(_this__u8e3s4));
		  }
		  function get_indices(_this__u8e3s4) {
		    return new IntRange(0, get_lastIndex(_this__u8e3s4));
		  }
		  function get_indices_0(_this__u8e3s4) {
		    return new IntRange(0, get_lastIndex_0(_this__u8e3s4));
		  }
		  function contains(_this__u8e3s4, element) {
		    return indexOf_0(_this__u8e3s4, element) >= 0;
		  }
		  function contains_0(_this__u8e3s4, element) {
		    return indexOf_1(_this__u8e3s4, element) >= 0;
		  }
		  function contains_1(_this__u8e3s4, element) {
		    return indexOf_2(_this__u8e3s4, element) >= 0;
		  }
		  function contains_2(_this__u8e3s4, element) {
		    return indexOf_3(_this__u8e3s4, element) >= 0;
		  }
		  function indexOf(_this__u8e3s4, element) {
		    if (element == null) {
		      var inductionVariable = 0;
		      var last = _this__u8e3s4.length - 1 | 0;
		      if (inductionVariable <= last)
		        do {
		          var index = inductionVariable;
		          inductionVariable = inductionVariable + 1 | 0;
		          if (_this__u8e3s4[index] == null) {
		            return index;
		          }
		        }
		         while (inductionVariable <= last);
		    } else {
		      var inductionVariable_0 = 0;
		      var last_0 = _this__u8e3s4.length - 1 | 0;
		      if (inductionVariable_0 <= last_0)
		        do {
		          var index_0 = inductionVariable_0;
		          inductionVariable_0 = inductionVariable_0 + 1 | 0;
		          if (equals_0(element, _this__u8e3s4[index_0])) {
		            return index_0;
		          }
		        }
		         while (inductionVariable_0 <= last_0);
		    }
		    return -1;
		  }
		  function toSet(_this__u8e3s4) {
		    switch (_this__u8e3s4.length) {
		      case 0:
		        return emptySet();
		      case 1:
		        return setOf(_this__u8e3s4[0]);
		      default:
		        return toCollection(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.length)));
		    }
		  }
		  function single(_this__u8e3s4) {
		    var tmp;
		    switch (_this__u8e3s4.length) {
		      case 0:
		        throw NoSuchElementException_init_$Create$_0('Array is empty.');
		      case 1:
		        tmp = _this__u8e3s4[0];
		        break;
		      default:
		        throw IllegalArgumentException_init_$Create$_0('Array has more than one element.');
		    }
		    return tmp;
		  }
		  function toMutableList(_this__u8e3s4) {
		    return ArrayList_init_$Create$_1(asCollection(_this__u8e3s4));
		  }
		  function get_lastIndex(_this__u8e3s4) {
		    return _this__u8e3s4.length - 1 | 0;
		  }
		  function get_lastIndex_0(_this__u8e3s4) {
		    return _this__u8e3s4.length - 1 | 0;
		  }
		  function indexOf_0(_this__u8e3s4, element) {
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (element.equals(_this__u8e3s4[index])) {
		          return index;
		        }
		      }
		       while (inductionVariable <= last);
		    return -1;
		  }
		  function indexOf_1(_this__u8e3s4, element) {
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (element === _this__u8e3s4[index]) {
		          return index;
		        }
		      }
		       while (inductionVariable <= last);
		    return -1;
		  }
		  function indexOf_2(_this__u8e3s4, element) {
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (element === _this__u8e3s4[index]) {
		          return index;
		        }
		      }
		       while (inductionVariable <= last);
		    return -1;
		  }
		  function indexOf_3(_this__u8e3s4, element) {
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (element === _this__u8e3s4[index]) {
		          return index;
		        }
		      }
		       while (inductionVariable <= last);
		    return -1;
		  }
		  function toCollection(_this__u8e3s4, destination) {
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length;
		    while (inductionVariable < last) {
		      var item = _this__u8e3s4[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      destination.m(item);
		    }
		    return destination;
		  }
		  function get_lastIndex_1(_this__u8e3s4) {
		    return _this__u8e3s4.length - 1 | 0;
		  }
		  function contains_3(_this__u8e3s4, element) {
		    return indexOf(_this__u8e3s4, element) >= 0;
		  }
		  function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
		    separator = separator === VOID ? ', ' : separator;
		    prefix = prefix === VOID ? '' : prefix;
		    postfix = postfix === VOID ? '' : postfix;
		    limit = limit === VOID ? -1 : limit;
		    truncated = truncated === VOID ? '...' : truncated;
		    transform = transform === VOID ? null : transform;
		    return joinTo(_this__u8e3s4, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
		  }
		  function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
		    separator = separator === VOID ? ', ' : separator;
		    prefix = prefix === VOID ? '' : prefix;
		    postfix = postfix === VOID ? '' : postfix;
		    limit = limit === VOID ? -1 : limit;
		    truncated = truncated === VOID ? '...' : truncated;
		    transform = transform === VOID ? null : transform;
		    buffer.c7(prefix);
		    var count = 0;
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length;
		    $l$loop: while (inductionVariable < last) {
		      var element = _this__u8e3s4[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      count = count + 1 | 0;
		      if (count > 1) {
		        buffer.c7(separator);
		      }
		      if (limit < 0 ? true : count <= limit) {
		        appendElement(buffer, element, transform);
		      } else
		        break $l$loop;
		    }
		    if (limit >= 0 ? count > limit : false) {
		      buffer.c7(truncated);
		    }
		    buffer.c7(postfix);
		    return buffer;
		  }
		  function reversed(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.isEmpty' call
		    if (_this__u8e3s4.length === 0)
		      return emptyList();
		    var list = toMutableList(_this__u8e3s4);
		    reverse(list);
		    return list;
		  }
		  function filterNotNull(_this__u8e3s4) {
		    return filterNotNullTo(_this__u8e3s4, ArrayList_init_$Create$());
		  }
		  function filterNotNullTo(_this__u8e3s4, destination) {
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length;
		    while (inductionVariable < last) {
		      var element = _this__u8e3s4[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      if (!(element == null)) {
		        destination.m(element);
		      }
		    }
		    return destination;
		  }
		  function distinct(_this__u8e3s4) {
		    return toList_0(toMutableSet(_this__u8e3s4));
		  }
		  function zip(_this__u8e3s4, other) {
		    // Inline function 'kotlin.collections.zip' call
		    // Inline function 'kotlin.comparisons.minOf' call
		    var a = _this__u8e3s4.length;
		    var b = other.length;
		    var size = Math.min(a, b);
		    var list = ArrayList_init_$Create$_0(size);
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.collections.zip.<anonymous>' call
		        var t1 = _this__u8e3s4[i];
		        var t2 = other[i];
		        var tmp$ret$1 = to(t1, t2);
		        list.m(tmp$ret$1);
		      }
		       while (inductionVariable < size);
		    return list;
		  }
		  function toMutableSet(_this__u8e3s4) {
		    return toCollection(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.length)));
		  }
		  function withIndex$lambda($this_withIndex) {
		    return function () {
		      return arrayIterator($this_withIndex);
		    };
		  }
		  function joinToString_0(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
		    separator = separator === VOID ? ', ' : separator;
		    prefix = prefix === VOID ? '' : prefix;
		    postfix = postfix === VOID ? '' : postfix;
		    limit = limit === VOID ? -1 : limit;
		    truncated = truncated === VOID ? '...' : truncated;
		    transform = transform === VOID ? null : transform;
		    return joinTo_0(_this__u8e3s4, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
		  }
		  function joinTo_0(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
		    separator = separator === VOID ? ', ' : separator;
		    prefix = prefix === VOID ? '' : prefix;
		    postfix = postfix === VOID ? '' : postfix;
		    limit = limit === VOID ? -1 : limit;
		    truncated = truncated === VOID ? '...' : truncated;
		    transform = transform === VOID ? null : transform;
		    buffer.c7(prefix);
		    var count = 0;
		    var tmp0_iterator = _this__u8e3s4.p();
		    $l$loop: while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      count = count + 1 | 0;
		      if (count > 1) {
		        buffer.c7(separator);
		      }
		      if (limit < 0 ? true : count <= limit) {
		        appendElement(buffer, element, transform);
		      } else
		        break $l$loop;
		    }
		    if (limit >= 0 ? count > limit : false) {
		      buffer.c7(truncated);
		    }
		    buffer.c7(postfix);
		    return buffer;
		  }
		  function toHashSet(_this__u8e3s4) {
		    return toCollection_0(_this__u8e3s4, HashSet_init_$Create$_1(mapCapacity(collectionSizeOrDefault(_this__u8e3s4, 12))));
		  }
		  function toBooleanArray(_this__u8e3s4) {
		    var result = booleanArray(_this__u8e3s4.u());
		    var index = 0;
		    var tmp0_iterator = _this__u8e3s4.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      var tmp1 = index;
		      index = tmp1 + 1 | 0;
		      result[tmp1] = element;
		    }
		    return result;
		  }
		  function toCollection_0(_this__u8e3s4, destination) {
		    var tmp0_iterator = _this__u8e3s4.p();
		    while (tmp0_iterator.q()) {
		      var item = tmp0_iterator.s();
		      destination.m(item);
		    }
		    return destination;
		  }
		  function toList_0(_this__u8e3s4) {
		    if (isInterface(_this__u8e3s4, Collection)) {
		      var tmp;
		      switch (_this__u8e3s4.u()) {
		        case 0:
		          tmp = emptyList();
		          break;
		        case 1:
		          var tmp_0;
		          if (isInterface(_this__u8e3s4, List)) {
		            tmp_0 = _this__u8e3s4.b1(0);
		          } else {
		            tmp_0 = _this__u8e3s4.p().s();
		          }

		          tmp = listOf(tmp_0);
		          break;
		        default:
		          tmp = toMutableList_0(_this__u8e3s4);
		          break;
		      }
		      return tmp;
		    }
		    return optimizeReadOnlyList(toMutableList_1(_this__u8e3s4));
		  }
		  function last(_this__u8e3s4) {
		    if (_this__u8e3s4.x())
		      throw NoSuchElementException_init_$Create$_0('List is empty.');
		    return _this__u8e3s4.b1(get_lastIndex_2(_this__u8e3s4));
		  }
		  function singleOrNull(_this__u8e3s4) {
		    return _this__u8e3s4.u() === 1 ? _this__u8e3s4.b1(0) : null;
		  }
		  function filterNotNull_0(_this__u8e3s4) {
		    return filterNotNullTo_0(_this__u8e3s4, ArrayList_init_$Create$());
		  }
		  function single_0(_this__u8e3s4) {
		    if (isInterface(_this__u8e3s4, List))
		      return single_1(_this__u8e3s4);
		    else {
		      var iterator = _this__u8e3s4.p();
		      if (!iterator.q())
		        throw NoSuchElementException_init_$Create$_0('Collection is empty.');
		      var single = iterator.s();
		      if (iterator.q())
		        throw IllegalArgumentException_init_$Create$_0('Collection has more than one element.');
		      return single;
		    }
		  }
		  function toMutableList_0(_this__u8e3s4) {
		    return ArrayList_init_$Create$_1(_this__u8e3s4);
		  }
		  function toMutableList_1(_this__u8e3s4) {
		    if (isInterface(_this__u8e3s4, Collection))
		      return toMutableList_0(_this__u8e3s4);
		    return toCollection_0(_this__u8e3s4, ArrayList_init_$Create$());
		  }
		  function filterNotNullTo_0(_this__u8e3s4, destination) {
		    var tmp0_iterator = _this__u8e3s4.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      if (!(element == null)) {
		        destination.m(element);
		      }
		    }
		    return destination;
		  }
		  function single_1(_this__u8e3s4) {
		    var tmp;
		    switch (_this__u8e3s4.u()) {
		      case 0:
		        throw NoSuchElementException_init_$Create$_0('List is empty.');
		      case 1:
		        tmp = _this__u8e3s4.b1(0);
		        break;
		      default:
		        throw IllegalArgumentException_init_$Create$_0('List has more than one element.');
		    }
		    return tmp;
		  }
		  function toSet_0(_this__u8e3s4) {
		    if (isInterface(_this__u8e3s4, Collection)) {
		      var tmp;
		      switch (_this__u8e3s4.u()) {
		        case 0:
		          tmp = emptySet();
		          break;
		        case 1:
		          var tmp_0;
		          if (isInterface(_this__u8e3s4, List)) {
		            tmp_0 = _this__u8e3s4.b1(0);
		          } else {
		            tmp_0 = _this__u8e3s4.p().s();
		          }

		          tmp = setOf(tmp_0);
		          break;
		        default:
		          tmp = toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.u())));
		          break;
		      }
		      return tmp;
		    }
		    return optimizeReadOnlySet(toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$()));
		  }
		  function lastOrNull(_this__u8e3s4) {
		    return _this__u8e3s4.x() ? null : _this__u8e3s4.b1(_this__u8e3s4.u() - 1 | 0);
		  }
		  function minOrNull(_this__u8e3s4) {
		    var iterator = _this__u8e3s4.p();
		    if (!iterator.q())
		      return null;
		    var min = iterator.s();
		    while (iterator.q()) {
		      var e = iterator.s();
		      if (compareTo(min, e) > 0)
		        min = e;
		    }
		    return min;
		  }
		  function titlecaseImpl(_this__u8e3s4) {
		    // Inline function 'kotlin.text.uppercase' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var uppercase = toString(_this__u8e3s4).toUpperCase();
		    if (uppercase.length > 1) {
		      var tmp;
		      if (_this__u8e3s4 === _Char___init__impl__6a9atx(329)) {
		        tmp = uppercase;
		      } else {
		        // Inline function 'kotlin.text.plus' call
		        var this_0 = charSequenceGet(uppercase, 0);
		        // Inline function 'kotlin.text.lowercase' call
		        // Inline function 'kotlin.text.substring' call
		        // Inline function 'kotlin.js.asDynamic' call
		        // Inline function 'kotlin.js.asDynamic' call
		        var other = uppercase.substring(1).toLowerCase();
		        tmp = toString(this_0) + other;
		      }
		      return tmp;
		    }
		    return toString(titlecaseChar(_this__u8e3s4));
		  }
		  function until(_this__u8e3s4, to) {
		    if (to <= IntCompanionObject_instance.MIN_VALUE)
		      return Companion_getInstance_9().n8_1;
		    return numberRangeToNumber(_this__u8e3s4, to - 1 | 0);
		  }
		  function step(_this__u8e3s4, step) {
		    checkStepIsPositive(step > 0, step);
		    return Companion_instance_10.r8(_this__u8e3s4.o8_1, _this__u8e3s4.p8_1, _this__u8e3s4.q8_1 > 0 ? step : -step | 0);
		  }
		  function coerceAtLeast(_this__u8e3s4, minimumValue) {
		    return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
		  }
		  function random(_this__u8e3s4, random) {
		    try {
		      return nextInt(random, _this__u8e3s4);
		    } catch ($p) {
		      if ($p instanceof IllegalArgumentException) {
		        var e = $p;
		        throw NoSuchElementException_init_$Create$_0(e.message);
		      } else {
		        throw $p;
		      }
		    }
		  }
		  function coerceIn(_this__u8e3s4, minimumValue, maximumValue) {
		    if (minimumValue.m8(maximumValue) > 0)
		      throw IllegalArgumentException_init_$Create$_0('Cannot coerce value to an empty range: maximum ' + maximumValue.toString() + ' is less than minimum ' + minimumValue.toString() + '.');
		    if (_this__u8e3s4.m8(minimumValue) < 0)
		      return minimumValue;
		    if (_this__u8e3s4.m8(maximumValue) > 0)
		      return maximumValue;
		    return _this__u8e3s4;
		  }
		  function coerceAtMost(_this__u8e3s4, maximumValue) {
		    return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
		  }
		  function downTo(_this__u8e3s4, to) {
		    return Companion_instance_10.r8(_this__u8e3s4, to, -1);
		  }
		  function coerceIn_0(_this__u8e3s4, minimumValue, maximumValue) {
		    if (minimumValue > maximumValue)
		      throw IllegalArgumentException_init_$Create$_0('Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
		    if (_this__u8e3s4 < minimumValue)
		      return minimumValue;
		    if (_this__u8e3s4 > maximumValue)
		      return maximumValue;
		    return _this__u8e3s4;
		  }
		  function asIterable(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.Iterable' call
		    return new _no_name_provided__qut3iv(_this__u8e3s4);
		  }
		  function map(_this__u8e3s4, transform) {
		    return new TransformingSequence(_this__u8e3s4, transform);
		  }
		  function toList_1(_this__u8e3s4) {
		    var it = _this__u8e3s4.p();
		    if (!it.q())
		      return emptyList();
		    var element = it.s();
		    if (!it.q())
		      return listOf(element);
		    var dst = ArrayList_init_$Create$();
		    dst.m(element);
		    while (it.q()) {
		      dst.m(it.s());
		    }
		    return dst;
		  }
		  function _no_name_provided__qut3iv($this_asIterable) {
		    this.s8_1 = $this_asIterable;
		  }
		  protoOf(_no_name_provided__qut3iv).p = function () {
		    // Inline function 'kotlin.sequences.asIterable.<anonymous>' call
		    return this.s8_1.p();
		  };
		  function plus(_this__u8e3s4, elements) {
		    var tmp0_safe_receiver = collectionSizeOrNull(elements);
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.collections.plus.<anonymous>' call
		      tmp = _this__u8e3s4.u() + tmp0_safe_receiver | 0;
		    }
		    var tmp1_elvis_lhs = tmp;
		    var result = LinkedHashSet_init_$Create$_1(mapCapacity(tmp1_elvis_lhs == null ? imul(_this__u8e3s4.u(), 2) : tmp1_elvis_lhs));
		    result.t(_this__u8e3s4);
		    addAll(result, elements);
		    return result;
		  }
		  function last_0(_this__u8e3s4) {
		    // Inline function 'kotlin.text.isEmpty' call
		    if (charSequenceLength(_this__u8e3s4) === 0)
		      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
		    return charSequenceGet(_this__u8e3s4, get_lastIndex_3(_this__u8e3s4));
		  }
		  function drop(_this__u8e3s4, n) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(n >= 0)) {
		      // Inline function 'kotlin.text.drop.<anonymous>' call
		      var message = 'Requested character count ' + n + ' is less than zero.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    // Inline function 'kotlin.text.substring' call
		    var startIndex = coerceAtMost(n, _this__u8e3s4.length);
		    // Inline function 'kotlin.js.asDynamic' call
		    return _this__u8e3s4.substring(startIndex);
		  }
		  function single_2(_this__u8e3s4) {
		    var tmp;
		    switch (charSequenceLength(_this__u8e3s4)) {
		      case 0:
		        throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
		      case 1:
		        tmp = charSequenceGet(_this__u8e3s4, 0);
		        break;
		      default:
		        throw IllegalArgumentException_init_$Create$_0('Char sequence has more than one element.');
		    }
		    return tmp;
		  }
		  function slice(_this__u8e3s4, indices) {
		    if (indices.x())
		      return '';
		    return substring(_this__u8e3s4, indices);
		  }
		  function dropLast(_this__u8e3s4, n) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(n >= 0)) {
		      // Inline function 'kotlin.text.dropLast.<anonymous>' call
		      var message = 'Requested character count ' + n + ' is less than zero.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return take(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.length - n | 0, 0));
		  }
		  function take(_this__u8e3s4, n) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(n >= 0)) {
		      // Inline function 'kotlin.text.take.<anonymous>' call
		      var message = 'Requested character count ' + n + ' is less than zero.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    // Inline function 'kotlin.text.substring' call
		    var endIndex = coerceAtMost(n, _this__u8e3s4.length);
		    // Inline function 'kotlin.js.asDynamic' call
		    return _this__u8e3s4.substring(0, endIndex);
		  }
		  function _Char___init__impl__6a9atx(value) {
		    return value;
		  }
		  function _get_value__a43j40($this) {
		    return $this;
		  }
		  function _Char___init__impl__6a9atx_0(code) {
		    // Inline function 'kotlin.UShort.toInt' call
		    var tmp$ret$0 = _UShort___get_data__impl__g0245(code) & 65535;
		    return _Char___init__impl__6a9atx(tmp$ret$0);
		  }
		  function Char__compareTo_impl_ypi4mb($this, other) {
		    return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
		  }
		  function Char__compareTo_impl_ypi4mb_0($this, other) {
		    return Char__compareTo_impl_ypi4mb($this.w8_1, other instanceof Char ? other.w8_1 : THROW_CCE());
		  }
		  function Char__minus_impl_a2frrh($this, other) {
		    return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
		  }
		  function Char__toInt_impl_vasixd($this) {
		    return _get_value__a43j40($this);
		  }
		  function Char__equals_impl_x6719k($this, other) {
		    if (!(other instanceof Char))
		      return false;
		    return _get_value__a43j40($this) === _get_value__a43j40(other.w8_1);
		  }
		  function Char__hashCode_impl_otmys($this) {
		    return _get_value__a43j40($this);
		  }
		  function toString($this) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    return String.fromCharCode(_get_value__a43j40($this));
		  }
		  function Companion_2() {
		    Companion_instance_2 = this;
		    this.x8_1 = _Char___init__impl__6a9atx(0);
		    this.y8_1 = _Char___init__impl__6a9atx(65535);
		    this.z8_1 = _Char___init__impl__6a9atx(55296);
		    this.a9_1 = _Char___init__impl__6a9atx(56319);
		    this.b9_1 = _Char___init__impl__6a9atx(56320);
		    this.c9_1 = _Char___init__impl__6a9atx(57343);
		    this.d9_1 = _Char___init__impl__6a9atx(55296);
		    this.e9_1 = _Char___init__impl__6a9atx(57343);
		    this.f9_1 = 2;
		    this.g9_1 = 16;
		  }
		  var Companion_instance_2;
		  function Companion_getInstance_2() {
		    if (Companion_instance_2 == null)
		      new Companion_2();
		    return Companion_instance_2;
		  }
		  function Char(value) {
		    Companion_getInstance_2();
		    this.w8_1 = value;
		  }
		  protoOf(Char).h9 = function (other) {
		    return Char__compareTo_impl_ypi4mb(this.w8_1, other);
		  };
		  protoOf(Char).i9 = function (other) {
		    return Char__compareTo_impl_ypi4mb_0(this, other);
		  };
		  protoOf(Char).equals = function (other) {
		    return Char__equals_impl_x6719k(this.w8_1, other);
		  };
		  protoOf(Char).hashCode = function () {
		    return Char__hashCode_impl_otmys(this.w8_1);
		  };
		  protoOf(Char).toString = function () {
		    return toString(this.w8_1);
		  };
		  function List() {
		  }
		  function Collection() {
		  }
		  function Set() {
		  }
		  function Entry() {
		  }
		  function Map_0() {
		  }
		  function MutableList() {
		  }
		  function MutableSet() {
		  }
		  function MutableMap() {
		  }
		  function Companion_3() {
		  }
		  var Companion_instance_3;
		  function Companion_getInstance_3() {
		    return Companion_instance_3;
		  }
		  function Enum(name, ordinal) {
		    this.h8_1 = name;
		    this.i8_1 = ordinal;
		  }
		  protoOf(Enum).j9 = function () {
		    return this.h8_1;
		  };
		  protoOf(Enum).k9 = function () {
		    return this.i8_1;
		  };
		  protoOf(Enum).j8 = function (other) {
		    return compareTo(this.i8_1, other.i8_1);
		  };
		  protoOf(Enum).i9 = function (other) {
		    return this.j8(other instanceof Enum ? other : THROW_CCE());
		  };
		  protoOf(Enum).equals = function (other) {
		    return this === other;
		  };
		  protoOf(Enum).hashCode = function () {
		    return identityHashCode(this);
		  };
		  protoOf(Enum).toString = function () {
		    return this.h8_1;
		  };
		  function arrayOf(elements) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return elements;
		  }
		  function toString_0(_this__u8e3s4) {
		    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
		    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
		  }
		  function plus_0(_this__u8e3s4, other) {
		    var tmp3_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
		    var tmp = tmp3_elvis_lhs == null ? 'null' : tmp3_elvis_lhs;
		    var tmp1_elvis_lhs = other == null ? null : toString_1(other);
		    return tmp + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
		  }
		  function implement(interfaces) {
		    var maxSize = 1;
		    var masks = [];
		    var inductionVariable = 0;
		    var last = interfaces.length;
		    while (inductionVariable < last) {
		      var i = interfaces[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      var currentSize = maxSize;
		      var tmp1_elvis_lhs = i.prototype.$imask$;
		      var imask = tmp1_elvis_lhs == null ? i.$imask$ : tmp1_elvis_lhs;
		      if (!(imask == null)) {
		        masks.push(imask);
		        currentSize = imask.length;
		      }
		      var iid = i.$metadata$.iid;
		      var tmp;
		      if (iid == null) {
		        tmp = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'kotlin.js.implement.<anonymous>' call
		        tmp = bitMaskWith(iid);
		      }
		      var iidImask = tmp;
		      if (!(iidImask == null)) {
		        masks.push(iidImask);
		        currentSize = Math.max(currentSize, iidImask.length);
		      }
		      if (currentSize > maxSize) {
		        maxSize = currentSize;
		      }
		    }
		    return compositeBitMask(maxSize, masks);
		  }
		  function bitMaskWith(activeBit) {
		    var numberIndex = activeBit >> 5;
		    var intArray = new Int32Array(numberIndex + 1 | 0);
		    var positionInNumber = activeBit & 31;
		    var numberWithSettledBit = 1 << positionInNumber;
		    intArray[numberIndex] = intArray[numberIndex] | numberWithSettledBit;
		    return intArray;
		  }
		  function compositeBitMask(capacity, masks) {
		    var tmp = 0;
		    var tmp_0 = new Int32Array(capacity);
		    while (tmp < capacity) {
		      var tmp_1 = tmp;
		      var result = 0;
		      var inductionVariable = 0;
		      var last = masks.length;
		      while (inductionVariable < last) {
		        var mask = masks[inductionVariable];
		        inductionVariable = inductionVariable + 1 | 0;
		        if (tmp_1 < mask.length) {
		          result = result | mask[tmp_1];
		        }
		      }
		      tmp_0[tmp_1] = result;
		      tmp = tmp + 1 | 0;
		    }
		    return tmp_0;
		  }
		  function isBitSet(_this__u8e3s4, possibleActiveBit) {
		    var numberIndex = possibleActiveBit >> 5;
		    if (numberIndex > _this__u8e3s4.length)
		      return false;
		    var positionInNumber = possibleActiveBit & 31;
		    var numberWithSettledBit = 1 << positionInNumber;
		    return !((_this__u8e3s4[numberIndex] & numberWithSettledBit) === 0);
		  }
		  function fillArrayVal(array, initValue) {
		    var inductionVariable = 0;
		    var last = array.length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        array[i] = initValue;
		      }
		       while (!(i === last));
		    return array;
		  }
		  function arrayIterator(array) {
		    return new arrayIterator$1(array);
		  }
		  function booleanArray(size) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'withType' call
		    var type = 'BooleanArray';
		    var array = fillArrayVal(Array(size), false);
		    array.$type$ = type;
		    return array;
		  }
		  function charArray(size) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'withType' call
		    var type = 'CharArray';
		    var array = new Uint16Array(size);
		    array.$type$ = type;
		    return array;
		  }
		  function longArray(size) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'withType' call
		    var type = 'LongArray';
		    var array = fillArrayVal(Array(size), new Long(0, 0));
		    array.$type$ = type;
		    return array;
		  }
		  function charArrayOf(arr) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'withType' call
		    var type = 'CharArray';
		    var array = new Uint16Array(arr);
		    array.$type$ = type;
		    return array;
		  }
		  function arrayIterator$1($array) {
		    this.m9_1 = $array;
		    this.l9_1 = 0;
		  }
		  protoOf(arrayIterator$1).q = function () {
		    return !(this.l9_1 === this.m9_1.length);
		  };
		  protoOf(arrayIterator$1).s = function () {
		    var tmp;
		    if (!(this.l9_1 === this.m9_1.length)) {
		      var tmp1 = this.l9_1;
		      this.l9_1 = tmp1 + 1 | 0;
		      tmp = this.m9_1[tmp1];
		    } else {
		      throw NoSuchElementException_init_$Create$_0('' + this.l9_1);
		    }
		    return tmp;
		  };
		  function get_buf() {
		    _init_properties_bitUtils_kt__nfcg4k();
		    return buf;
		  }
		  var buf;
		  function get_bufFloat64() {
		    _init_properties_bitUtils_kt__nfcg4k();
		    return bufFloat64;
		  }
		  var bufFloat64;
		  var bufFloat32;
		  function get_bufInt32() {
		    _init_properties_bitUtils_kt__nfcg4k();
		    return bufInt32;
		  }
		  var bufInt32;
		  function get_lowIndex() {
		    _init_properties_bitUtils_kt__nfcg4k();
		    return lowIndex;
		  }
		  var lowIndex;
		  function get_highIndex() {
		    _init_properties_bitUtils_kt__nfcg4k();
		    return highIndex;
		  }
		  var highIndex;
		  function getNumberHashCode(obj) {
		    _init_properties_bitUtils_kt__nfcg4k();
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.jsBitwiseOr' call
		    // Inline function 'kotlin.js.asDynamic' call
		    if ((obj | 0) === obj) {
		      return numberToInt(obj);
		    }
		    get_bufFloat64()[0] = obj;
		    return imul(get_bufInt32()[get_highIndex()], 31) + get_bufInt32()[get_lowIndex()] | 0;
		  }
		  var properties_initialized_bitUtils_kt_i2bo3e;
		  function _init_properties_bitUtils_kt__nfcg4k() {
		    if (!properties_initialized_bitUtils_kt_i2bo3e) {
		      properties_initialized_bitUtils_kt_i2bo3e = true;
		      buf = new ArrayBuffer(8);
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      bufFloat64 = new Float64Array(get_buf());
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      bufFloat32 = new Float32Array(get_buf());
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      bufInt32 = new Int32Array(get_buf());
		      // Inline function 'kotlin.run' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.js.lowIndex.<anonymous>' call
		      get_bufFloat64()[0] = -1.0;
		      lowIndex = !(get_bufInt32()[0] === 0) ? 1 : 0;
		      highIndex = 1 - get_lowIndex() | 0;
		    }
		  }
		  function charSequenceGet(a, index) {
		    var tmp;
		    if (isString(a)) {
		      // Inline function 'kotlin.Char' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      var code = a.charCodeAt(index);
		      var tmp_0;
		      // Inline function 'kotlin.code' call
		      Companion_getInstance_2();
		      var this_0 = _Char___init__impl__6a9atx(0);
		      if (code < Char__toInt_impl_vasixd(this_0)) {
		        tmp_0 = true;
		      } else {
		        // Inline function 'kotlin.code' call
		        Companion_getInstance_2();
		        var this_1 = _Char___init__impl__6a9atx(65535);
		        tmp_0 = code > Char__toInt_impl_vasixd(this_1);
		      }
		      if (tmp_0) {
		        throw IllegalArgumentException_init_$Create$_0('Invalid Char code: ' + code);
		      }
		      tmp = numberToChar(code);
		    } else {
		      tmp = a.b(index);
		    }
		    return tmp;
		  }
		  function isString(a) {
		    return typeof a === 'string';
		  }
		  function charSequenceLength(a) {
		    var tmp;
		    if (isString(a)) {
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = a.length;
		    } else {
		      tmp = a.a();
		    }
		    return tmp;
		  }
		  function charSequenceSubSequence(a, startIndex, endIndex) {
		    var tmp;
		    if (isString(a)) {
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = a.substring(startIndex, endIndex);
		    } else {
		      tmp = a.c(startIndex, endIndex);
		    }
		    return tmp;
		  }
		  function arrayToString(array) {
		    return joinToString(array, ', ', '[', ']', VOID, VOID, arrayToString$lambda);
		  }
		  function contentEqualsInternal(_this__u8e3s4, other) {
		    // Inline function 'kotlin.js.asDynamic' call
		    var a = _this__u8e3s4;
		    // Inline function 'kotlin.js.asDynamic' call
		    var b = other;
		    if (a === b)
		      return true;
		    if (((a == null ? true : b == null) ? true : !isArrayish(b)) ? true : a.length != b.length)
		      return false;
		    var inductionVariable = 0;
		    var last = a.length;
		    if (inductionVariable < last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (!equals_0(a[i], b[i])) {
		          return false;
		        }
		      }
		       while (inductionVariable < last);
		    return true;
		  }
		  function contentHashCodeInternal(_this__u8e3s4) {
		    // Inline function 'kotlin.js.asDynamic' call
		    var a = _this__u8e3s4;
		    if (a == null)
		      return 0;
		    var result = 1;
		    var inductionVariable = 0;
		    var last = a.length;
		    if (inductionVariable < last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        result = imul(result, 31) + hashCode(a[i]) | 0;
		      }
		       while (inductionVariable < last);
		    return result;
		  }
		  function arrayToString$lambda(it) {
		    return toString_1(it);
		  }
		  function compareTo(a, b) {
		    var tmp;
		    switch (typeof a) {
		      case 'number':
		        var tmp_0;
		        if (typeof b === 'number') {
		          tmp_0 = doubleCompareTo(a, b);
		        } else {
		          if (b instanceof Long) {
		            tmp_0 = doubleCompareTo(a, b.q5());
		          } else {
		            tmp_0 = primitiveCompareTo(a, b);
		          }
		        }

		        tmp = tmp_0;
		        break;
		      case 'string':
		      case 'boolean':
		        tmp = primitiveCompareTo(a, b);
		        break;
		      default:
		        tmp = compareToDoNotIntrinsicify(a, b);
		        break;
		    }
		    return tmp;
		  }
		  function doubleCompareTo(a, b) {
		    var tmp;
		    if (a < b) {
		      tmp = -1;
		    } else if (a > b) {
		      tmp = 1;
		    } else if (a === b) {
		      var tmp_0;
		      if (a !== 0) {
		        tmp_0 = 0;
		      } else {
		        // Inline function 'kotlin.js.asDynamic' call
		        var ia = 1 / a;
		        var tmp_1;
		        // Inline function 'kotlin.js.asDynamic' call
		        if (ia === 1 / b) {
		          tmp_1 = 0;
		        } else {
		          if (ia < 0) {
		            tmp_1 = -1;
		          } else {
		            tmp_1 = 1;
		          }
		        }
		        tmp_0 = tmp_1;
		      }
		      tmp = tmp_0;
		    } else if (a !== a) {
		      tmp = b !== b ? 0 : 1;
		    } else {
		      tmp = -1;
		    }
		    return tmp;
		  }
		  function primitiveCompareTo(a, b) {
		    return a < b ? -1 : a > b ? 1 : 0;
		  }
		  function compareToDoNotIntrinsicify(a, b) {
		    return a.i9(b);
		  }
		  function identityHashCode(obj) {
		    return getObjectHashCode(obj);
		  }
		  function getObjectHashCode(obj) {
		    // Inline function 'kotlin.js.jsIn' call
		    if (!('kotlinHashCodeValue$' in obj)) {
		      var hash = calculateRandomHash();
		      var descriptor = new Object();
		      descriptor.value = hash;
		      descriptor.enumerable = false;
		      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
		    }
		    // Inline function 'kotlin.js.unsafeCast' call
		    return obj['kotlinHashCodeValue$'];
		  }
		  function calculateRandomHash() {
		    // Inline function 'kotlin.js.jsBitwiseOr' call
		    return Math.random() * 4.294967296E9 | 0;
		  }
		  function toString_1(o) {
		    var tmp;
		    if (o == null) {
		      tmp = 'null';
		    } else if (isArrayish(o)) {
		      tmp = '[...]';
		    } else if (!(typeof o.toString === 'function')) {
		      tmp = anyToString(o);
		    } else {
		      // Inline function 'kotlin.js.unsafeCast' call
		      tmp = o.toString();
		    }
		    return tmp;
		  }
		  function equals_0(obj1, obj2) {
		    if (obj1 == null) {
		      return obj2 == null;
		    }
		    if (obj2 == null) {
		      return false;
		    }
		    if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
		      return obj1.equals(obj2);
		    }
		    if (obj1 !== obj1) {
		      return obj2 !== obj2;
		    }
		    if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
		      var tmp;
		      if (obj1 === obj2) {
		        var tmp_0;
		        if (obj1 !== 0) {
		          tmp_0 = true;
		        } else {
		          // Inline function 'kotlin.js.asDynamic' call
		          var tmp_1 = 1 / obj1;
		          // Inline function 'kotlin.js.asDynamic' call
		          tmp_0 = tmp_1 === 1 / obj2;
		        }
		        tmp = tmp_0;
		      } else {
		        tmp = false;
		      }
		      return tmp;
		    }
		    return obj1 === obj2;
		  }
		  function hashCode(obj) {
		    if (obj == null)
		      return 0;
		    var typeOf = typeof obj;
		    var tmp;
		    switch (typeOf) {
		      case 'object':
		        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
		        break;
		      case 'function':
		        tmp = getObjectHashCode(obj);
		        break;
		      case 'number':
		        tmp = getNumberHashCode(obj);
		        break;
		      case 'boolean':
		        // Inline function 'kotlin.js.unsafeCast' call

		        tmp = getBooleanHashCode(obj);
		        break;
		      case 'string':
		        tmp = getStringHashCode(String(obj));
		        break;
		      case 'bigint':
		        tmp = getBigIntHashCode(obj);
		        break;
		      case 'symbol':
		        tmp = getSymbolHashCode(obj);
		        break;
		      default:
		        tmp = function () {
		          throw new Error('Unexpected typeof `' + typeOf + '`');
		        }();
		        break;
		    }
		    return tmp;
		  }
		  function anyToString(o) {
		    return Object.prototype.toString.call(o);
		  }
		  function getBooleanHashCode(value) {
		    return value ? 1231 : 1237;
		  }
		  function getStringHashCode(str) {
		    var hash = 0;
		    var length = str.length;
		    var inductionVariable = 0;
		    var last = length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.js.asDynamic' call
		        var code = str.charCodeAt(i);
		        hash = imul(hash, 31) + code | 0;
		      }
		       while (!(i === last));
		    return hash;
		  }
		  function getBigIntHashCode(value) {
		    var shiftNumber = BigInt(32);
		    var MASK = BigInt(4.294967295E9);
		    var bigNumber = value < 0 ? -value : value;
		    var hashCode = 0;
		    var signum = value < 0 ? -1 : 1;
		    while (bigNumber != 0) {
		      // Inline function 'kotlin.js.unsafeCast' call
		      var chunk = Number(bigNumber & MASK);
		      hashCode = imul(31, hashCode) + chunk | 0;
		      bigNumber = bigNumber >> shiftNumber;
		    }
		    return imul(hashCode, signum);
		  }
		  function getSymbolHashCode(value) {
		    var hashCodeMap = symbolIsSharable(value) ? getSymbolMap() : getSymbolWeakMap();
		    var cachedHashCode = hashCodeMap.get(value);
		    if (cachedHashCode !== VOID)
		      return cachedHashCode;
		    var hash = calculateRandomHash();
		    hashCodeMap.set(value, hash);
		    return hash;
		  }
		  function symbolIsSharable(symbol) {
		    return Symbol.keyFor(symbol) != VOID;
		  }
		  function getSymbolMap() {
		    if (symbolMap === VOID) {
		      symbolMap = new Map();
		    }
		    return symbolMap;
		  }
		  function getSymbolWeakMap() {
		    if (symbolWeakMap === VOID) {
		      symbolWeakMap = new WeakMap();
		    }
		    return symbolWeakMap;
		  }
		  var symbolMap;
		  var symbolWeakMap;
		  function boxIntrinsic(x) {
		    var message = 'Should be lowered';
		    throw IllegalStateException_init_$Create$_0(toString_1(message));
		  }
		  function unboxIntrinsic(x) {
		    var message = 'Should be lowered';
		    throw IllegalStateException_init_$Create$_0(toString_1(message));
		  }
		  function captureStack(instance, constructorFunction) {
		    if (Error.captureStackTrace != null) {
		      Error.captureStackTrace(instance, constructorFunction);
		    } else {
		      // Inline function 'kotlin.js.asDynamic' call
		      instance.stack = (new Error()).stack;
		    }
		  }
		  function protoOf(constructor) {
		    return constructor.prototype;
		  }
		  function defineProp(obj, name, getter, setter) {
		    return Object.defineProperty(obj, name, {configurable: true, get: getter, set: setter});
		  }
		  function objectCreate(proto) {
		    return Object.create(proto);
		  }
		  function newThrowable(message, cause) {
		    var throwable = new Error();
		    var tmp;
		    if (isUndefined(message)) {
		      var tmp_0;
		      if (isUndefined(cause)) {
		        tmp_0 = message;
		      } else {
		        var tmp1_elvis_lhs = cause == null ? null : cause.toString();
		        tmp_0 = tmp1_elvis_lhs == null ? VOID : tmp1_elvis_lhs;
		      }
		      tmp = tmp_0;
		    } else {
		      tmp = message == null ? VOID : message;
		    }
		    throwable.message = tmp;
		    throwable.cause = cause;
		    throwable.name = 'Throwable';
		    // Inline function 'kotlin.js.unsafeCast' call
		    return throwable;
		  }
		  function isUndefined(value) {
		    return value === VOID;
		  }
		  function extendThrowable(this_, message, cause) {
		    Error.call(this_);
		    setPropertiesToThrowableInstance(this_, message, cause);
		  }
		  function setPropertiesToThrowableInstance(this_, message, cause) {
		    var errorInfo = calculateErrorInfo(Object.getPrototypeOf(this_));
		    if ((errorInfo & 1) === 0) {
		      var tmp;
		      if (message == null) {
		        var tmp_0;
		        if (!(message === null)) {
		          var tmp1_elvis_lhs = cause == null ? null : cause.toString();
		          tmp_0 = tmp1_elvis_lhs == null ? VOID : tmp1_elvis_lhs;
		        } else {
		          tmp_0 = VOID;
		        }
		        tmp = tmp_0;
		      } else {
		        tmp = message;
		      }
		      this_.message = tmp;
		    }
		    if ((errorInfo & 2) === 0) {
		      this_.cause = cause;
		    }
		    this_.name = Object.getPrototypeOf(this_).constructor.name;
		  }
		  function ensureNotNull(v) {
		    var tmp;
		    if (v == null) {
		      THROW_NPE();
		    } else {
		      tmp = v;
		    }
		    return tmp;
		  }
		  function THROW_NPE() {
		    throw NullPointerException_init_$Create$();
		  }
		  function noWhenBranchMatchedException() {
		    throw NoWhenBranchMatchedException_init_$Create$();
		  }
		  function THROW_CCE() {
		    throw ClassCastException_init_$Create$();
		  }
		  function throwUninitializedPropertyAccessException(name) {
		    throw UninitializedPropertyAccessException_init_$Create$_0('lateinit property ' + name + ' has not been initialized');
		  }
		  function THROW_IAE(msg) {
		    throw IllegalArgumentException_init_$Create$_0(msg);
		  }
		  function lazy(mode, initializer) {
		    return new UnsafeLazyImpl(initializer);
		  }
		  function lazy_0(initializer) {
		    return new UnsafeLazyImpl(initializer);
		  }
		  function fillFrom(src, dst) {
		    var srcLen = src.length;
		    var dstLen = dst.length;
		    var index = 0;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var arr = dst;
		    while (index < srcLen ? index < dstLen : false) {
		      var tmp = index;
		      var tmp0 = index;
		      index = tmp0 + 1 | 0;
		      arr[tmp] = src[tmp0];
		    }
		    return dst;
		  }
		  function arrayCopyResize(source, newSize, defaultValue) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    var result = source.slice(0, newSize);
		    // Inline function 'kotlin.copyArrayType' call
		    if (source.$type$ !== undefined) {
		      result.$type$ = source.$type$;
		    }
		    var index = source.length;
		    if (newSize > index) {
		      // Inline function 'kotlin.js.asDynamic' call
		      result.length = newSize;
		      while (index < newSize) {
		        var tmp0 = index;
		        index = tmp0 + 1 | 0;
		        result[tmp0] = defaultValue;
		      }
		    }
		    return result;
		  }
		  function Companion_4() {
		    Companion_instance_4 = this;
		    this.n9_1 = new Long(0, -2147483648);
		    this.o9_1 = new Long(-1, 2147483647);
		    this.p9_1 = 8;
		    this.q9_1 = 64;
		  }
		  var Companion_instance_4;
		  function Companion_getInstance_4() {
		    if (Companion_instance_4 == null)
		      new Companion_4();
		    return Companion_instance_4;
		  }
		  function Long(low, high) {
		    Companion_getInstance_4();
		    Number_0.call(this);
		    this.k_1 = low;
		    this.l_1 = high;
		  }
		  protoOf(Long).m8 = function (other) {
		    return compare(this, other);
		  };
		  protoOf(Long).i9 = function (other) {
		    return this.m8(other instanceof Long ? other : THROW_CCE());
		  };
		  protoOf(Long).r9 = function (other) {
		    return add(this, other);
		  };
		  protoOf(Long).s9 = function (other) {
		    return subtract(this, other);
		  };
		  protoOf(Long).l8 = function (other) {
		    return multiply(this, other);
		  };
		  protoOf(Long).k8 = function (other) {
		    return divide(this, other);
		  };
		  protoOf(Long).t9 = function (other) {
		    return modulo(this, other);
		  };
		  protoOf(Long).u9 = function () {
		    return this.v9().r9(new Long(1, 0));
		  };
		  protoOf(Long).w9 = function (bitCount) {
		    return shiftLeft(this, bitCount);
		  };
		  protoOf(Long).x9 = function (bitCount) {
		    return shiftRight(this, bitCount);
		  };
		  protoOf(Long).y9 = function (bitCount) {
		    return shiftRightUnsigned(this, bitCount);
		  };
		  protoOf(Long).z9 = function (other) {
		    return new Long(this.k_1 & other.k_1, this.l_1 & other.l_1);
		  };
		  protoOf(Long).aa = function (other) {
		    return new Long(this.k_1 | other.k_1, this.l_1 | other.l_1);
		  };
		  protoOf(Long).ba = function (other) {
		    return new Long(this.k_1 ^ other.k_1, this.l_1 ^ other.l_1);
		  };
		  protoOf(Long).v9 = function () {
		    return new Long(~this.k_1, ~this.l_1);
		  };
		  protoOf(Long).ca = function () {
		    return toByte(this.k_1);
		  };
		  protoOf(Long).da = function () {
		    return toShort(this.k_1);
		  };
		  protoOf(Long).ea = function () {
		    return this.k_1;
		  };
		  protoOf(Long).q5 = function () {
		    return toNumber(this);
		  };
		  protoOf(Long).valueOf = function () {
		    return this.q5();
		  };
		  protoOf(Long).equals = function (other) {
		    var tmp;
		    if (other instanceof Long) {
		      tmp = equalsLong(this, other);
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(Long).hashCode = function () {
		    return hashCode_0(this);
		  };
		  protoOf(Long).toString = function () {
		    return toStringImpl(this, 10);
		  };
		  function get_ZERO() {
		    _init_properties_longjs_kt__tqrzid();
		    return ZERO;
		  }
		  var ZERO;
		  function get_ONE() {
		    _init_properties_longjs_kt__tqrzid();
		    return ONE;
		  }
		  var ONE;
		  function get_NEG_ONE() {
		    _init_properties_longjs_kt__tqrzid();
		    return NEG_ONE;
		  }
		  var NEG_ONE;
		  function get_MAX_VALUE() {
		    _init_properties_longjs_kt__tqrzid();
		    return MAX_VALUE;
		  }
		  var MAX_VALUE;
		  function get_MIN_VALUE() {
		    _init_properties_longjs_kt__tqrzid();
		    return MIN_VALUE;
		  }
		  var MIN_VALUE;
		  function get_TWO_PWR_24_() {
		    _init_properties_longjs_kt__tqrzid();
		    return TWO_PWR_24_;
		  }
		  var TWO_PWR_24_;
		  function compare(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    if (equalsLong(_this__u8e3s4, other)) {
		      return 0;
		    }
		    var thisNeg = isNegative(_this__u8e3s4);
		    var otherNeg = isNegative(other);
		    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this__u8e3s4, other)) ? -1 : 1;
		  }
		  function add(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    var a48 = _this__u8e3s4.l_1 >>> 16 | 0;
		    var a32 = _this__u8e3s4.l_1 & 65535;
		    var a16 = _this__u8e3s4.k_1 >>> 16 | 0;
		    var a00 = _this__u8e3s4.k_1 & 65535;
		    var b48 = other.l_1 >>> 16 | 0;
		    var b32 = other.l_1 & 65535;
		    var b16 = other.k_1 >>> 16 | 0;
		    var b00 = other.k_1 & 65535;
		    var c48 = 0;
		    var c32 = 0;
		    var c16 = 0;
		    var c00 = 0;
		    c00 = c00 + (a00 + b00 | 0) | 0;
		    c16 = c16 + (c00 >>> 16 | 0) | 0;
		    c00 = c00 & 65535;
		    c16 = c16 + (a16 + b16 | 0) | 0;
		    c32 = c32 + (c16 >>> 16 | 0) | 0;
		    c16 = c16 & 65535;
		    c32 = c32 + (a32 + b32 | 0) | 0;
		    c48 = c48 + (c32 >>> 16 | 0) | 0;
		    c32 = c32 & 65535;
		    c48 = c48 + (a48 + b48 | 0) | 0;
		    c48 = c48 & 65535;
		    return new Long(c16 << 16 | c00, c48 << 16 | c32);
		  }
		  function subtract(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    return add(_this__u8e3s4, other.u9());
		  }
		  function multiply(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    if (isZero(_this__u8e3s4)) {
		      return get_ZERO();
		    } else if (isZero(other)) {
		      return get_ZERO();
		    }
		    if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
		      return isOdd(other) ? get_MIN_VALUE() : get_ZERO();
		    } else if (equalsLong(other, get_MIN_VALUE())) {
		      return isOdd(_this__u8e3s4) ? get_MIN_VALUE() : get_ZERO();
		    }
		    if (isNegative(_this__u8e3s4)) {
		      var tmp;
		      if (isNegative(other)) {
		        tmp = multiply(negate(_this__u8e3s4), negate(other));
		      } else {
		        tmp = negate(multiply(negate(_this__u8e3s4), other));
		      }
		      return tmp;
		    } else if (isNegative(other)) {
		      return negate(multiply(_this__u8e3s4, negate(other)));
		    }
		    if (lessThan(_this__u8e3s4, get_TWO_PWR_24_()) ? lessThan(other, get_TWO_PWR_24_()) : false) {
		      return fromNumber(toNumber(_this__u8e3s4) * toNumber(other));
		    }
		    var a48 = _this__u8e3s4.l_1 >>> 16 | 0;
		    var a32 = _this__u8e3s4.l_1 & 65535;
		    var a16 = _this__u8e3s4.k_1 >>> 16 | 0;
		    var a00 = _this__u8e3s4.k_1 & 65535;
		    var b48 = other.l_1 >>> 16 | 0;
		    var b32 = other.l_1 & 65535;
		    var b16 = other.k_1 >>> 16 | 0;
		    var b00 = other.k_1 & 65535;
		    var c48 = 0;
		    var c32 = 0;
		    var c16 = 0;
		    var c00 = 0;
		    c00 = c00 + imul(a00, b00) | 0;
		    c16 = c16 + (c00 >>> 16 | 0) | 0;
		    c00 = c00 & 65535;
		    c16 = c16 + imul(a16, b00) | 0;
		    c32 = c32 + (c16 >>> 16 | 0) | 0;
		    c16 = c16 & 65535;
		    c16 = c16 + imul(a00, b16) | 0;
		    c32 = c32 + (c16 >>> 16 | 0) | 0;
		    c16 = c16 & 65535;
		    c32 = c32 + imul(a32, b00) | 0;
		    c48 = c48 + (c32 >>> 16 | 0) | 0;
		    c32 = c32 & 65535;
		    c32 = c32 + imul(a16, b16) | 0;
		    c48 = c48 + (c32 >>> 16 | 0) | 0;
		    c32 = c32 & 65535;
		    c32 = c32 + imul(a00, b32) | 0;
		    c48 = c48 + (c32 >>> 16 | 0) | 0;
		    c32 = c32 & 65535;
		    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
		    c48 = c48 & 65535;
		    return new Long(c16 << 16 | c00, c48 << 16 | c32);
		  }
		  function divide(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    if (isZero(other)) {
		      throw Exception_init_$Create$_0('division by zero');
		    } else if (isZero(_this__u8e3s4)) {
		      return get_ZERO();
		    }
		    if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
		      if (equalsLong(other, get_ONE()) ? true : equalsLong(other, get_NEG_ONE())) {
		        return get_MIN_VALUE();
		      } else if (equalsLong(other, get_MIN_VALUE())) {
		        return get_ONE();
		      } else {
		        var halfThis = shiftRight(_this__u8e3s4, 1);
		        var approx = shiftLeft(halfThis.k8(other), 1);
		        if (equalsLong(approx, get_ZERO())) {
		          return isNegative(other) ? get_ONE() : get_NEG_ONE();
		        } else {
		          var rem = subtract(_this__u8e3s4, multiply(other, approx));
		          return add(approx, rem.k8(other));
		        }
		      }
		    } else if (equalsLong(other, get_MIN_VALUE())) {
		      return get_ZERO();
		    }
		    if (isNegative(_this__u8e3s4)) {
		      var tmp;
		      if (isNegative(other)) {
		        tmp = negate(_this__u8e3s4).k8(negate(other));
		      } else {
		        tmp = negate(negate(_this__u8e3s4).k8(other));
		      }
		      return tmp;
		    } else if (isNegative(other)) {
		      return negate(_this__u8e3s4.k8(negate(other)));
		    }
		    var res = get_ZERO();
		    var rem_0 = _this__u8e3s4;
		    while (greaterThanOrEqual(rem_0, other)) {
		      var approxDouble = toNumber(rem_0) / toNumber(other);
		      var approx2 = Math.max(1.0, Math.floor(approxDouble));
		      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
		      var delta = log2 <= 48.0 ? 1.0 : Math.pow(2.0, log2 - 48);
		      var approxRes = fromNumber(approx2);
		      var approxRem = multiply(approxRes, other);
		      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
		        approx2 = approx2 - delta;
		        approxRes = fromNumber(approx2);
		        approxRem = multiply(approxRes, other);
		      }
		      if (isZero(approxRes)) {
		        approxRes = get_ONE();
		      }
		      res = add(res, approxRes);
		      rem_0 = subtract(rem_0, approxRem);
		    }
		    return res;
		  }
		  function modulo(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    return subtract(_this__u8e3s4, multiply(_this__u8e3s4.k8(other), other));
		  }
		  function shiftLeft(_this__u8e3s4, numBits) {
		    _init_properties_longjs_kt__tqrzid();
		    var numBits_0 = numBits & 63;
		    if (numBits_0 === 0) {
		      return _this__u8e3s4;
		    } else {
		      if (numBits_0 < 32) {
		        return new Long(_this__u8e3s4.k_1 << numBits_0, _this__u8e3s4.l_1 << numBits_0 | (_this__u8e3s4.k_1 >>> (32 - numBits_0 | 0) | 0));
		      } else {
		        return new Long(0, _this__u8e3s4.k_1 << (numBits_0 - 32 | 0));
		      }
		    }
		  }
		  function shiftRight(_this__u8e3s4, numBits) {
		    _init_properties_longjs_kt__tqrzid();
		    var numBits_0 = numBits & 63;
		    if (numBits_0 === 0) {
		      return _this__u8e3s4;
		    } else {
		      if (numBits_0 < 32) {
		        return new Long(_this__u8e3s4.k_1 >>> numBits_0 | 0 | _this__u8e3s4.l_1 << (32 - numBits_0 | 0), _this__u8e3s4.l_1 >> numBits_0);
		      } else {
		        return new Long(_this__u8e3s4.l_1 >> (numBits_0 - 32 | 0), _this__u8e3s4.l_1 >= 0 ? 0 : -1);
		      }
		    }
		  }
		  function shiftRightUnsigned(_this__u8e3s4, numBits) {
		    _init_properties_longjs_kt__tqrzid();
		    var numBits_0 = numBits & 63;
		    if (numBits_0 === 0) {
		      return _this__u8e3s4;
		    } else {
		      if (numBits_0 < 32) {
		        return new Long(_this__u8e3s4.k_1 >>> numBits_0 | 0 | _this__u8e3s4.l_1 << (32 - numBits_0 | 0), _this__u8e3s4.l_1 >>> numBits_0 | 0);
		      } else {
		        var tmp;
		        if (numBits_0 === 32) {
		          tmp = new Long(_this__u8e3s4.l_1, 0);
		        } else {
		          tmp = new Long(_this__u8e3s4.l_1 >>> (numBits_0 - 32 | 0) | 0, 0);
		        }
		        return tmp;
		      }
		    }
		  }
		  function toNumber(_this__u8e3s4) {
		    _init_properties_longjs_kt__tqrzid();
		    return _this__u8e3s4.l_1 * 4.294967296E9 + getLowBitsUnsigned(_this__u8e3s4);
		  }
		  function equalsLong(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    return _this__u8e3s4.l_1 === other.l_1 ? _this__u8e3s4.k_1 === other.k_1 : false;
		  }
		  function hashCode_0(l) {
		    _init_properties_longjs_kt__tqrzid();
		    return l.k_1 ^ l.l_1;
		  }
		  function toStringImpl(_this__u8e3s4, radix) {
		    _init_properties_longjs_kt__tqrzid();
		    if (radix < 2 ? true : 36 < radix) {
		      throw Exception_init_$Create$_0('radix out of range: ' + radix);
		    }
		    if (isZero(_this__u8e3s4)) {
		      return '0';
		    }
		    if (isNegative(_this__u8e3s4)) {
		      if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
		        var radixLong = fromInt(radix);
		        var div = _this__u8e3s4.k8(radixLong);
		        var rem = subtract(multiply(div, radixLong), _this__u8e3s4).ea();
		        var tmp = toStringImpl(div, radix);
		        // Inline function 'kotlin.js.unsafeCast' call
		        // Inline function 'kotlin.js.asDynamic' call
		        return tmp + rem.toString(radix);
		      } else {
		        return '-' + toStringImpl(negate(_this__u8e3s4), radix);
		      }
		    }
		    var digitsPerTime = radix === 2 ? 31 : radix <= 10 ? 9 : radix <= 21 ? 7 : radix <= 35 ? 6 : 5;
		    var radixToPower = fromNumber(Math.pow(radix, digitsPerTime));
		    var rem_0 = _this__u8e3s4;
		    var result = '';
		    while (true) {
		      var remDiv = rem_0.k8(radixToPower);
		      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).ea();
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      var digits = intval.toString(radix);
		      rem_0 = remDiv;
		      if (isZero(rem_0)) {
		        return digits + result;
		      } else {
		        while (digits.length < digitsPerTime) {
		          digits = '0' + digits;
		        }
		        result = digits + result;
		      }
		    }
		  }
		  function fromInt(value) {
		    _init_properties_longjs_kt__tqrzid();
		    return new Long(value, value < 0 ? -1 : 0);
		  }
		  function isNegative(_this__u8e3s4) {
		    _init_properties_longjs_kt__tqrzid();
		    return _this__u8e3s4.l_1 < 0;
		  }
		  function isZero(_this__u8e3s4) {
		    _init_properties_longjs_kt__tqrzid();
		    return _this__u8e3s4.l_1 === 0 ? _this__u8e3s4.k_1 === 0 : false;
		  }
		  function isOdd(_this__u8e3s4) {
		    _init_properties_longjs_kt__tqrzid();
		    return (_this__u8e3s4.k_1 & 1) === 1;
		  }
		  function negate(_this__u8e3s4) {
		    _init_properties_longjs_kt__tqrzid();
		    return _this__u8e3s4.u9();
		  }
		  function lessThan(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    return compare(_this__u8e3s4, other) < 0;
		  }
		  function fromNumber(value) {
		    _init_properties_longjs_kt__tqrzid();
		    if (isNaN_0(value)) {
		      return get_ZERO();
		    } else if (value <= -9.223372036854776E18) {
		      return get_MIN_VALUE();
		    } else if (value + 1 >= 9.223372036854776E18) {
		      return get_MAX_VALUE();
		    } else if (value < 0.0) {
		      return negate(fromNumber(-value));
		    } else {
		      var twoPwr32 = 4.294967296E9;
		      // Inline function 'kotlin.js.jsBitwiseOr' call
		      var tmp = value % twoPwr32 | 0;
		      // Inline function 'kotlin.js.jsBitwiseOr' call
		      var tmp$ret$1 = value / twoPwr32 | 0;
		      return new Long(tmp, tmp$ret$1);
		    }
		  }
		  function greaterThan(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    return compare(_this__u8e3s4, other) > 0;
		  }
		  function greaterThanOrEqual(_this__u8e3s4, other) {
		    _init_properties_longjs_kt__tqrzid();
		    return compare(_this__u8e3s4, other) >= 0;
		  }
		  function getLowBitsUnsigned(_this__u8e3s4) {
		    _init_properties_longjs_kt__tqrzid();
		    return _this__u8e3s4.k_1 >= 0 ? _this__u8e3s4.k_1 : 4.294967296E9 + _this__u8e3s4.k_1;
		  }
		  var properties_initialized_longjs_kt_5aju7t;
		  function _init_properties_longjs_kt__tqrzid() {
		    if (!properties_initialized_longjs_kt_5aju7t) {
		      properties_initialized_longjs_kt_5aju7t = true;
		      ZERO = fromInt(0);
		      ONE = fromInt(1);
		      NEG_ONE = fromInt(-1);
		      MAX_VALUE = new Long(-1, 2147483647);
		      MIN_VALUE = new Long(0, -2147483648);
		      TWO_PWR_24_ = fromInt(16777216);
		    }
		  }
		  function classMeta(name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
		    return createMetadata('class', name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity, null);
		  }
		  function createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity, iid) {
		    var undef = VOID;
		    return {kind: kind, simpleName: name, associatedObjectKey: associatedObjectKey, associatedObjects: associatedObjects, suspendArity: suspendArity, $kClass$: undef, defaultConstructor: defaultConstructor, iid: iid};
		  }
		  function setMetadataFor(ctor, name, metadataConstructor, parent, interfaces, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
		    if (!(parent == null)) {
		      ctor.prototype = Object.create(parent.prototype);
		      ctor.prototype.constructor = ctor;
		    }
		    var metadata = metadataConstructor(name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity == null ? [] : suspendArity);
		    ctor.$metadata$ = metadata;
		    if (!(interfaces == null)) {
		      var receiver = !(metadata.iid == null) ? ctor : ctor.prototype;
		      receiver.$imask$ = implement(interfaces);
		    }
		  }
		  function interfaceMeta(name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
		    return createMetadata('interface', name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity, generateInterfaceId());
		  }
		  function generateInterfaceId() {
		    if (iid === VOID) {
		      iid = 0;
		    }
		    // Inline function 'kotlin.js.unsafeCast' call
		    iid = iid + 1 | 0;
		    // Inline function 'kotlin.js.unsafeCast' call
		    return iid;
		  }
		  var iid;
		  function objectMeta(name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
		    return createMetadata('object', name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity, null);
		  }
		  function arrayConcat(args) {
		    var len = args.length;
		    // Inline function 'kotlin.js.unsafeCast' call
		    var typed = Array(len);
		    var inductionVariable = 0;
		    var last = len - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var arr = args[i];
		        if (!(!(arr == null) ? isArray(arr) : false)) {
		          typed[i] = [].slice.call(arr);
		        } else {
		          typed[i] = arr;
		        }
		      }
		       while (!(i === last));
		    return [].concat.apply([], typed);
		  }
		  function toByte(a) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    return a << 24 >> 24;
		  }
		  function numberToInt(a) {
		    var tmp;
		    if (a instanceof Long) {
		      tmp = a.ea();
		    } else {
		      tmp = doubleToInt(a);
		    }
		    return tmp;
		  }
		  function doubleToInt(a) {
		    var tmp;
		    if (a > 2.147483647E9) {
		      tmp = 2147483647;
		    } else if (a < -2.147483648E9) {
		      tmp = -2147483648;
		    } else {
		      // Inline function 'kotlin.js.jsBitwiseOr' call
		      tmp = a | 0;
		    }
		    return tmp;
		  }
		  function numberToDouble(a) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    return +a;
		  }
		  function toShort(a) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    return a << 16 >> 16;
		  }
		  function numberToLong(a) {
		    var tmp;
		    if (a instanceof Long) {
		      tmp = a;
		    } else {
		      tmp = fromNumber(a);
		    }
		    return tmp;
		  }
		  function numberToChar(a) {
		    // Inline function 'kotlin.toUShort' call
		    var this_0 = numberToInt(a);
		    var tmp$ret$0 = _UShort___init__impl__jigrne(toShort(this_0));
		    return _Char___init__impl__6a9atx_0(tmp$ret$0);
		  }
		  function toLong_0(a) {
		    return fromInt(a);
		  }
		  function numberRangeToNumber(start, endInclusive) {
		    return new IntRange(start, endInclusive);
		  }
		  function get_propertyRefClassMetadataCache() {
		    _init_properties_reflectRuntime_kt__5r4uu3();
		    return propertyRefClassMetadataCache;
		  }
		  var propertyRefClassMetadataCache;
		  function metadataObject() {
		    _init_properties_reflectRuntime_kt__5r4uu3();
		    return classMeta(VOID, VOID, VOID, VOID, VOID);
		  }
		  function getPropertyCallableRef(name, paramCount, superType, getter, setter) {
		    _init_properties_reflectRuntime_kt__5r4uu3();
		    getter.get = getter;
		    getter.set = setter;
		    getter.callableName = name;
		    // Inline function 'kotlin.js.unsafeCast' call
		    return getPropertyRefClass(getter, getKPropMetadata(paramCount, setter), getInterfaceMaskFor(getter, superType));
		  }
		  function getPropertyRefClass(obj, metadata, imask) {
		    _init_properties_reflectRuntime_kt__5r4uu3();
		    obj.$metadata$ = metadata;
		    obj.constructor = obj;
		    obj.$imask$ = imask;
		    return obj;
		  }
		  function getKPropMetadata(paramCount, setter) {
		    _init_properties_reflectRuntime_kt__5r4uu3();
		    return get_propertyRefClassMetadataCache()[paramCount][setter == null ? 0 : 1];
		  }
		  function getInterfaceMaskFor(obj, superType) {
		    _init_properties_reflectRuntime_kt__5r4uu3();
		    var tmp0_elvis_lhs = obj.$imask$;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      // Inline function 'kotlin.arrayOf' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp$ret$2 = [superType];
		      tmp = implement(tmp$ret$2);
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  var properties_initialized_reflectRuntime_kt_inkhwd;
		  function _init_properties_reflectRuntime_kt__5r4uu3() {
		    if (!properties_initialized_reflectRuntime_kt_inkhwd) {
		      properties_initialized_reflectRuntime_kt_inkhwd = true;
		      // Inline function 'kotlin.arrayOf' call
		      // Inline function 'kotlin.arrayOf' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp = [metadataObject(), metadataObject()];
		      // Inline function 'kotlin.arrayOf' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp_0 = [metadataObject(), metadataObject()];
		      // Inline function 'kotlin.arrayOf' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      propertyRefClassMetadataCache = [tmp, tmp_0, [metadataObject(), metadataObject()]];
		    }
		  }
		  function isArrayish(o) {
		    return isJsArray(o) ? true : isView(o);
		  }
		  function isJsArray(obj) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    return Array.isArray(obj);
		  }
		  function isInterface(obj, iface) {
		    return isInterfaceImpl(obj, iface.$metadata$.iid);
		  }
		  function isInterfaceImpl(obj, iface) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp0_elvis_lhs = obj.$imask$;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return false;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var mask = tmp;
		    return isBitSet(mask, iface);
		  }
		  function isArray(obj) {
		    var tmp;
		    if (isJsArray(obj)) {
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = !obj.$type$;
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  }
		  function isSuspendFunction(obj, arity) {
		    var objTypeOf = typeof obj;
		    if (objTypeOf === 'function') {
		      // Inline function 'kotlin.js.unsafeCast' call
		      return obj.$arity === arity;
		    }
		    // Inline function 'kotlin.js.unsafeCast' call
		    var tmp1_safe_receiver = obj == null ? null : obj.constructor;
		    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.$metadata$;
		    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.suspendArity;
		    var tmp;
		    if (tmp3_elvis_lhs == null) {
		      return false;
		    } else {
		      tmp = tmp3_elvis_lhs;
		    }
		    var suspendArity = tmp;
		    var result = false;
		    var inductionVariable = 0;
		    var last = suspendArity.length;
		    $l$loop: while (inductionVariable < last) {
		      var item = suspendArity[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      if (arity === item) {
		        result = true;
		        break $l$loop;
		      }
		    }
		    return result;
		  }
		  function isNumber(a) {
		    var tmp;
		    if (typeof a === 'number') {
		      tmp = true;
		    } else {
		      tmp = a instanceof Long;
		    }
		    return tmp;
		  }
		  function isCharSequence(value) {
		    return typeof value === 'string' ? true : isInterface(value, CharSequence);
		  }
		  function isBooleanArray(a) {
		    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
		  }
		  function isByteArray(a) {
		    // Inline function 'kotlin.js.jsInstanceOf' call
		    return a instanceof Int8Array;
		  }
		  function isShortArray(a) {
		    // Inline function 'kotlin.js.jsInstanceOf' call
		    return a instanceof Int16Array;
		  }
		  function isCharArray(a) {
		    var tmp;
		    // Inline function 'kotlin.js.jsInstanceOf' call
		    if (a instanceof Uint16Array) {
		      tmp = a.$type$ === 'CharArray';
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  }
		  function isIntArray(a) {
		    // Inline function 'kotlin.js.jsInstanceOf' call
		    return a instanceof Int32Array;
		  }
		  function isFloatArray(a) {
		    // Inline function 'kotlin.js.jsInstanceOf' call
		    return a instanceof Float32Array;
		  }
		  function isLongArray(a) {
		    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
		  }
		  function isDoubleArray(a) {
		    // Inline function 'kotlin.js.jsInstanceOf' call
		    return a instanceof Float64Array;
		  }
		  function jsIsType(obj, jsClass) {
		    if (jsClass === Object) {
		      return obj != null;
		    }
		    var objType = typeof obj;
		    var jsClassType = typeof jsClass;
		    if ((obj == null ? true : jsClass == null) ? true : !(objType === 'object') ? !(objType === 'function') : false) {
		      return false;
		    }
		    var constructor = jsClassType === 'object' ? jsGetPrototypeOf(jsClass) : jsClass;
		    var klassMetadata = constructor.$metadata$;
		    if ((klassMetadata == null ? null : klassMetadata.kind) === 'interface') {
		      // Inline function 'kotlin.js.unsafeCast' call
		      var tmp1_elvis_lhs = klassMetadata.iid;
		      var tmp;
		      if (tmp1_elvis_lhs == null) {
		        return false;
		      } else {
		        tmp = tmp1_elvis_lhs;
		      }
		      var iid = tmp;
		      return isInterfaceImpl(obj, iid);
		    }
		    // Inline function 'kotlin.js.jsInstanceOf' call
		    return obj instanceof constructor;
		  }
		  function jsGetPrototypeOf(jsClass) {
		    return Object.getPrototypeOf(jsClass);
		  }
		  function calculateErrorInfo(proto) {
		    var tmp0_safe_receiver = proto.constructor;
		    var metadata = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.$metadata$;
		    var tmp2_safe_receiver = metadata == null ? null : metadata.errorInfo;
		    if (tmp2_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      return tmp2_safe_receiver;
		    }
		    var result = 0;
		    if (hasProp(proto, 'message'))
		      result = result | 1;
		    if (hasProp(proto, 'cause'))
		      result = result | 2;
		    if (!(result === 3)) {
		      var parentProto = getPrototypeOf(proto);
		      if (parentProto != Error.prototype) {
		        result = result | calculateErrorInfo(parentProto);
		      }
		    }
		    if (!(metadata == null)) {
		      metadata.errorInfo = result;
		    }
		    return result;
		  }
		  function hasProp(proto, propName) {
		    return proto.hasOwnProperty(propName);
		  }
		  function getPrototypeOf(obj) {
		    return Object.getPrototypeOf(obj);
		  }
		  function get_VOID() {
		    _init_properties_void_kt__3zg9as();
		    return VOID;
		  }
		  var VOID;
		  var properties_initialized_void_kt_e4ret2;
		  function _init_properties_void_kt__3zg9as() {
		    if (!properties_initialized_void_kt_e4ret2) {
		      properties_initialized_void_kt_e4ret2 = true;
		      VOID = void 0;
		    }
		  }
		  function fill(_this__u8e3s4, element, fromIndex, toIndex) {
		    fromIndex = fromIndex === VOID ? 0 : fromIndex;
		    toIndex = toIndex === VOID ? _this__u8e3s4.length : toIndex;
		    Companion_instance_5.fa(fromIndex, toIndex, _this__u8e3s4.length);
		    // Inline function 'kotlin.js.nativeFill' call
		    // Inline function 'kotlin.js.asDynamic' call
		    _this__u8e3s4.fill(element, fromIndex, toIndex);
		  }
		  function asList(_this__u8e3s4) {
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return new ArrayList(_this__u8e3s4);
		  }
		  function copyOf(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    // Inline function 'withType' call
		    var type = 'CharArray';
		    var array = fillFrom(_this__u8e3s4, charArray(newSize));
		    array.$type$ = type;
		    return array;
		  }
		  function copyOf_0(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return fillFrom(_this__u8e3s4, new Float64Array(newSize));
		  }
		  function copyOf_1(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return fillFrom(_this__u8e3s4, new Float32Array(newSize));
		  }
		  function copyOf_2(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    // Inline function 'withType' call
		    var type = 'LongArray';
		    var array = arrayCopyResize(_this__u8e3s4, newSize, new Long(0, 0));
		    array.$type$ = type;
		    return array;
		  }
		  function copyOf_3(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return fillFrom(_this__u8e3s4, new Int32Array(newSize));
		  }
		  function copyOf_4(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return fillFrom(_this__u8e3s4, new Int16Array(newSize));
		  }
		  function copyOf_5(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return fillFrom(_this__u8e3s4, new Int8Array(newSize));
		  }
		  function copyOf_6(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    // Inline function 'withType' call
		    var type = 'BooleanArray';
		    var array = arrayCopyResize(_this__u8e3s4, newSize, false);
		    array.$type$ = type;
		    return array;
		  }
		  function contentEquals_0(_this__u8e3s4, other) {
		    return contentEqualsInternal(_this__u8e3s4, other);
		  }
		  function contentHashCode(_this__u8e3s4) {
		    return contentHashCodeInternal(_this__u8e3s4);
		  }
		  function copyOf_7(_this__u8e3s4, newSize) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(newSize >= 0)) {
		      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
		      var message = 'Invalid new array size: ' + newSize + '.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return arrayCopyResize(_this__u8e3s4, newSize, null);
		  }
		  function contentToString(_this__u8e3s4) {
		    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : joinToString(_this__u8e3s4, ', ', '[', ']');
		    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
		  }
		  function decodeVarLenBase64(base64, fromBase64, resultLength) {
		    var result = new Int32Array(resultLength);
		    var index = 0;
		    var int = 0;
		    var shift = 0;
		    var inductionVariable = 0;
		    var last = base64.length;
		    while (inductionVariable < last) {
		      var char = charSequenceGet(base64, inductionVariable);
		      inductionVariable = inductionVariable + 1 | 0;
		      // Inline function 'kotlin.code' call
		      var sixBit = fromBase64[Char__toInt_impl_vasixd(char)];
		      int = int | (sixBit & 31) << shift;
		      if (sixBit < 32) {
		        var tmp1 = index;
		        index = tmp1 + 1 | 0;
		        result[tmp1] = int;
		        int = 0;
		        shift = 0;
		      } else {
		        shift = shift + 5 | 0;
		      }
		    }
		    return result;
		  }
		  function reverse(_this__u8e3s4) {
		    var midPoint = (_this__u8e3s4.u() / 2 | 0) - 1 | 0;
		    if (midPoint < 0)
		      return Unit_instance;
		    var reverseIndex = get_lastIndex_2(_this__u8e3s4);
		    var inductionVariable = 0;
		    if (inductionVariable <= midPoint)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var tmp = _this__u8e3s4.b1(index);
		        _this__u8e3s4.f1(index, _this__u8e3s4.b1(reverseIndex));
		        _this__u8e3s4.f1(reverseIndex, tmp);
		        reverseIndex = reverseIndex - 1 | 0;
		      }
		       while (!(index === midPoint));
		  }
		  function digitToIntImpl(_this__u8e3s4) {
		    // Inline function 'kotlin.code' call
		    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
		    var index = binarySearchRange(Digit_getInstance().ga_1, ch);
		    var diff = ch - Digit_getInstance().ga_1[index] | 0;
		    return diff < 10 ? diff : -1;
		  }
		  function binarySearchRange(array, needle) {
		    var bottom = 0;
		    var top = array.length - 1 | 0;
		    var middle = -1;
		    var value = 0;
		    while (bottom <= top) {
		      middle = (bottom + top | 0) / 2 | 0;
		      value = array[middle];
		      if (needle > value)
		        bottom = middle + 1 | 0;
		      else if (needle === value)
		        return middle;
		      else
		        top = middle - 1 | 0;
		    }
		    return middle - (needle < value ? 1 : 0) | 0;
		  }
		  function Digit() {
		    Digit_instance = this;
		    var tmp = this;
		    // Inline function 'kotlin.intArrayOf' call
		    tmp.ga_1 = new Int32Array([48, 1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3558, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43504, 43600, 44016, 65296]);
		  }
		  var Digit_instance;
		  function Digit_getInstance() {
		    if (Digit_instance == null)
		      new Digit();
		    return Digit_instance;
		  }
		  function isLowerCaseImpl(_this__u8e3s4) {
		    var tmp;
		    if (getLetterType(_this__u8e3s4) === 1) {
		      tmp = true;
		    } else {
		      // Inline function 'kotlin.code' call
		      var tmp$ret$0 = Char__toInt_impl_vasixd(_this__u8e3s4);
		      tmp = isOtherLowercase(tmp$ret$0);
		    }
		    return tmp;
		  }
		  function getLetterType(_this__u8e3s4) {
		    // Inline function 'kotlin.code' call
		    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
		    var index = binarySearchRange(Letter_getInstance().ha_1, ch);
		    var rangeStart = Letter_getInstance().ha_1[index];
		    var rangeEnd = (rangeStart + Letter_getInstance().ia_1[index] | 0) - 1 | 0;
		    var code = Letter_getInstance().ja_1[index];
		    if (ch > rangeEnd) {
		      return 0;
		    }
		    var lastTwoBits = code & 3;
		    if (lastTwoBits === 0) {
		      var shift = 2;
		      var threshold = rangeStart;
		      var inductionVariable = 0;
		      if (inductionVariable <= 1)
		        do {
		          var i = inductionVariable;
		          inductionVariable = inductionVariable + 1 | 0;
		          threshold = threshold + (code >> shift & 127) | 0;
		          if (threshold > ch) {
		            return 3;
		          }
		          shift = shift + 7 | 0;
		          threshold = threshold + (code >> shift & 127) | 0;
		          if (threshold > ch) {
		            return 0;
		          }
		          shift = shift + 7 | 0;
		        }
		         while (inductionVariable <= 1);
		      return 3;
		    }
		    if (code <= 7) {
		      return lastTwoBits;
		    }
		    var distance = ch - rangeStart | 0;
		    var shift_0 = code <= 31 ? distance % 2 | 0 : distance;
		    return code >> imul(2, shift_0) & 3;
		  }
		  function Letter() {
		    Letter_instance = this;
		    var toBase64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		    var fromBase64 = new Int32Array(128);
		    var inductionVariable = 0;
		    var last = charSequenceLength(toBase64) - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.code' call
		        var this_0 = charSequenceGet(toBase64, i);
		        fromBase64[Char__toInt_impl_vasixd(this_0)] = i;
		      }
		       while (inductionVariable <= last);
		    var rangeStartDiff = 'hCgBpCQGYHZH5BRpBPPPPPPRMP5BPPlCPP6BkEPPPPcPXPzBvBrB3BOiDoBHwD+E3DauCnFmBmB2D6E1BlBTiBmBlBP5BhBiBrBvBjBqBnBPRtBiCmCtBlB0BmB5BiB7BmBgEmChBZgCoEoGVpBSfRhBPqKQ2BwBYoFgB4CJuTiEvBuCuDrF5DgEgFlJ1DgFmBQtBsBRGsB+BPiBlD1EIjDPRPPPQPPPPPGQSQS/DxENVNU+B9zCwBwBPPCkDPNnBPqDYY1R8B7FkFgTgwGgwUwmBgKwBuBScmEP/BPPPPPPrBP8B7F1B/ErBqC6B7BiBmBfQsBUwCw/KwqIwLwETPcPjQgJxFgBlBsD';
		    var diff = decodeVarLenBase64(rangeStartDiff, fromBase64, 222);
		    var start = new Int32Array(diff.length);
		    var inductionVariable_0 = 0;
		    var last_0 = diff.length - 1 | 0;
		    if (inductionVariable_0 <= last_0)
		      do {
		        var i_0 = inductionVariable_0;
		        inductionVariable_0 = inductionVariable_0 + 1 | 0;
		        if (i_0 === 0) {
		          start[i_0] = diff[i_0];
		        } else {
		          start[i_0] = start[i_0 - 1 | 0] + diff[i_0] | 0;
		        }
		      }
		       while (inductionVariable_0 <= last_0);
		    this.ha_1 = start;
		    var rangeLength = 'aaMBXHYH5BRpBPPPPPPRMP5BPPlCPPzBDOOPPcPXPzBvBjB3BOhDmBBpB7DoDYxB+EiBP1DoExBkBQhBekBPmBgBhBctBiBMWOOXhCsBpBkBUV3Ba4BkB0DlCgBXgBtD4FSdBfPhBPpKP0BvBXjEQ2CGsT8DhBtCqDpFvD1D3E0IrD2EkBJrBDOBsB+BPiBlB1EIjDPPPPPPPPPPPGPPMNLsBNPNPKCvBvBPPCkDPBmBPhDXXgD4B6FzEgDguG9vUtkB9JcuBSckEP/BPPPPPPBPf4FrBjEhBpC3B5BKaWPrBOwCk/KsCuLqDHPbPxPsFtEaaqDL';
		    this.ia_1 = decodeVarLenBase64(rangeLength, fromBase64, 222);
		    var rangeCategory = 'GFjgggUHGGFFZZZmzpz5qB6s6020B60ptltB6smt2sB60mz22B1+vv+8BZZ5s2850BW5q1ymtB506smzBF3q1q1qB1q1q1+Bgii4wDTm74g3KiggxqM60q1q1Bq1o1q1BF1qlrqrBZ2q5wprBGFZWWZGHFsjiooLowgmOowjkwCkgoiIk7ligGogiioBkwkiYkzj2oNoi+sbkwj04DghhkQ8wgiYkgoioDsgnkwC4gikQ//v+85BkwvoIsgoyI4yguI0whiwEowri4CoghsJowgqYowgm4DkwgsY/nwnzPowhmYkg6wI8yggZswikwHgxgmIoxgqYkwgk4DkxgmIkgoioBsgssoBgzgyI8g9gL8g9kI0wgwJoxgkoC0wgioFkw/wI0w53iF4gioYowjmgBHGq1qkgwBF1q1q8qBHwghuIwghyKk0goQkwgoQk3goQHGFHkyg0pBgxj6IoinkxDswno7Ikwhz9Bo0gioB8z48Rwli0xN0mpjoX8w78pDwltoqKHFGGwwgsIHFH3q1q16BFHWFZ1q10q1B2qlwq1B1q10q1B2q1yq1B6q1gq1Biq1qhxBir1qp1Bqt1q1qB1g1q1+B//3q16B///q1qBH/qlqq9Bholqq9B1i00a1q10qD1op1HkwmigEigiy6Cptogq1Bixo1kDq7/j00B2qgoBWGFm1lz50B6s5q1+BGWhggzhwBFFhgk4//Bo2jigE8wguI8wguI8wgugUog1qoB4qjmIwwi2KgkYHHH4lBgiFWkgIWoghssMmz5smrBZ3q1y50B5sm7gzBtz1smzB5smz50BqzqtmzB5sgzqzBF2/9//5BowgoIwmnkzPkwgk4C8ys65BkgoqI0wgy6FghquZo2giY0ghiIsgh24B4ghsQ8QF/v1q1OFs0O8iCHHF1qggz/B8wg6Iznv+//B08QgohsjK0QGFk7hsQ4gB';
		    this.ja_1 = decodeVarLenBase64(rangeCategory, fromBase64, 222);
		  }
		  var Letter_instance;
		  function Letter_getInstance() {
		    if (Letter_instance == null)
		      new Letter();
		    return Letter_instance;
		  }
		  function isOtherLowercase(_this__u8e3s4) {
		    var index = binarySearchRange(OtherLowercase_getInstance().ka_1, _this__u8e3s4);
		    return index >= 0 ? _this__u8e3s4 < (OtherLowercase_getInstance().ka_1[index] + OtherLowercase_getInstance().la_1[index] | 0) : false;
		  }
		  function OtherLowercase() {
		    OtherLowercase_instance = this;
		    var tmp = this;
		    // Inline function 'kotlin.intArrayOf' call
		    tmp.ka_1 = new Int32Array([170, 186, 688, 704, 736, 837, 890, 7468, 7544, 7579, 8305, 8319, 8336, 8560, 9424, 11388, 42652, 42864, 43000, 43868]);
		    var tmp_0 = this;
		    // Inline function 'kotlin.intArrayOf' call
		    tmp_0.la_1 = new Int32Array([1, 1, 9, 2, 5, 1, 1, 63, 1, 37, 1, 1, 13, 16, 26, 2, 2, 1, 2, 4]);
		  }
		  var OtherLowercase_instance;
		  function OtherLowercase_getInstance() {
		    if (OtherLowercase_instance == null)
		      new OtherLowercase();
		    return OtherLowercase_instance;
		  }
		  function titlecaseCharImpl(_this__u8e3s4) {
		    // Inline function 'kotlin.code' call
		    var code = Char__toInt_impl_vasixd(_this__u8e3s4);
		    if ((452 <= code ? code <= 460 : false) ? true : 497 <= code ? code <= 499 : false) {
		      return numberToChar(imul(3, (code + 1 | 0) / 3 | 0));
		    }
		    if ((4304 <= code ? code <= 4346 : false) ? true : 4349 <= code ? code <= 4351 : false) {
		      return _this__u8e3s4;
		    }
		    return uppercaseChar(_this__u8e3s4);
		  }
		  function isWhitespaceImpl(_this__u8e3s4) {
		    // Inline function 'kotlin.code' call
		    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
		    return (((9 <= ch ? ch <= 13 : false) ? true : 28 <= ch ? ch <= 32 : false) ? true : ch === 160) ? true : ch > 4096 ? (((((ch === 5760 ? true : 8192 <= ch ? ch <= 8202 : false) ? true : ch === 8232) ? true : ch === 8233) ? true : ch === 8239) ? true : ch === 8287) ? true : ch === 12288 : false;
		  }
		  function releaseIntercepted($this) {
		    var intercepted = $this.ta_1;
		    if (!(intercepted == null) ? !(intercepted === $this) : false) {
		      ensureNotNull($this.ua().va(Key_instance)).wa(intercepted);
		    }
		    $this.ta_1 = CompletedContinuation_instance;
		  }
		  function CoroutineImpl(resultContinuation) {
		    this.ma_1 = resultContinuation;
		    this.na_1 = 0;
		    this.oa_1 = 0;
		    this.pa_1 = null;
		    this.qa_1 = null;
		    this.ra_1 = null;
		    var tmp = this;
		    var tmp0_safe_receiver = this.ma_1;
		    tmp.sa_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ua();
		    this.ta_1 = null;
		  }
		  protoOf(CoroutineImpl).ua = function () {
		    return ensureNotNull(this.sa_1);
		  };
		  protoOf(CoroutineImpl).xa = function (result) {
		    var current = this;
		    // Inline function 'kotlin.Result.getOrNull' call
		    var tmp;
		    if (_Result___get_isFailure__impl__jpiriv(result)) {
		      tmp = null;
		    } else {
		      var tmp_0 = _Result___get_value__impl__bjfvqg(result);
		      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
		    }
		    var currentResult = tmp;
		    var currentException = Result__exceptionOrNull_impl_p6xea9(result);
		    while (true) {
		      // Inline function 'kotlin.with' call
		      // Inline function 'kotlin.contracts.contract' call
		      var $this$with = current;
		      if (currentException == null) {
		        $this$with.pa_1 = currentResult;
		      } else {
		        $this$with.na_1 = $this$with.oa_1;
		        $this$with.qa_1 = currentException;
		      }
		      try {
		        var outcome = $this$with.ya();
		        if (outcome === get_COROUTINE_SUSPENDED())
		          return Unit_instance;
		        currentResult = outcome;
		        currentException = null;
		      } catch ($p) {
		        var exception = $p;
		        currentResult = null;
		        // Inline function 'kotlin.js.unsafeCast' call
		        currentException = exception;
		      }
		      releaseIntercepted($this$with);
		      var completion = ensureNotNull($this$with.ma_1);
		      var tmp_1;
		      if (completion instanceof CoroutineImpl) {
		        current = completion;
		        tmp_1 = Unit_instance;
		      } else {
		        if (!(currentException == null)) {
		          // Inline function 'kotlin.coroutines.resumeWithException' call
		          // Inline function 'kotlin.Companion.failure' call
		          var exception_0 = ensureNotNull(currentException);
		          var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception_0));
		          completion.za(tmp$ret$2);
		        } else {
		          // Inline function 'kotlin.coroutines.resume' call
		          // Inline function 'kotlin.Companion.success' call
		          var value = currentResult;
		          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
		          completion.za(tmp$ret$4);
		        }
		        return Unit_instance;
		      }
		    }
		  };
		  protoOf(CoroutineImpl).za = function (result) {
		    return this.xa(result);
		  };
		  function CompletedContinuation() {
		  }
		  protoOf(CompletedContinuation).ua = function () {
		    var message = 'This continuation is already complete';
		    throw IllegalStateException_init_$Create$_0(toString_1(message));
		  };
		  protoOf(CompletedContinuation).xa = function (result) {
		    // Inline function 'kotlin.error' call
		    var message = 'This continuation is already complete';
		    throw IllegalStateException_init_$Create$_0(toString_1(message));
		  };
		  protoOf(CompletedContinuation).za = function (result) {
		    return this.xa(result);
		  };
		  protoOf(CompletedContinuation).toString = function () {
		    return 'This continuation is already complete';
		  };
		  var CompletedContinuation_instance;
		  function CompletedContinuation_getInstance() {
		    return CompletedContinuation_instance;
		  }
		  function invokeSuspendSuperTypeWithReceiverAndParam(_this__u8e3s4, receiver, param, completion) {
		    throw new NotImplementedError('It is intrinsic method');
		  }
		  function Exception_init_$Init$($this) {
		    extendThrowable($this);
		    Exception.call($this);
		    return $this;
		  }
		  function Exception_init_$Create$() {
		    var tmp = Exception_init_$Init$(objectCreate(protoOf(Exception)));
		    captureStack(tmp, Exception_init_$Create$);
		    return tmp;
		  }
		  function Exception_init_$Init$_0(message, $this) {
		    extendThrowable($this, message);
		    Exception.call($this);
		    return $this;
		  }
		  function Exception_init_$Create$_0(message) {
		    var tmp = Exception_init_$Init$_0(message, objectCreate(protoOf(Exception)));
		    captureStack(tmp, Exception_init_$Create$_0);
		    return tmp;
		  }
		  function Exception_init_$Init$_1(message, cause, $this) {
		    extendThrowable($this, message, cause);
		    Exception.call($this);
		    return $this;
		  }
		  function Exception_init_$Init$_2(cause, $this) {
		    extendThrowable($this, VOID, cause);
		    Exception.call($this);
		    return $this;
		  }
		  function Exception_init_$Create$_1(cause) {
		    var tmp = Exception_init_$Init$_2(cause, objectCreate(protoOf(Exception)));
		    captureStack(tmp, Exception_init_$Create$_1);
		    return tmp;
		  }
		  function Exception() {
		    captureStack(this, Exception);
		  }
		  function IllegalArgumentException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    IllegalArgumentException.call($this);
		    return $this;
		  }
		  function IllegalArgumentException_init_$Create$() {
		    var tmp = IllegalArgumentException_init_$Init$(objectCreate(protoOf(IllegalArgumentException)));
		    captureStack(tmp, IllegalArgumentException_init_$Create$);
		    return tmp;
		  }
		  function IllegalArgumentException_init_$Init$_0(message, $this) {
		    RuntimeException_init_$Init$_0(message, $this);
		    IllegalArgumentException.call($this);
		    return $this;
		  }
		  function IllegalArgumentException_init_$Create$_0(message) {
		    var tmp = IllegalArgumentException_init_$Init$_0(message, objectCreate(protoOf(IllegalArgumentException)));
		    captureStack(tmp, IllegalArgumentException_init_$Create$_0);
		    return tmp;
		  }
		  function IllegalArgumentException_init_$Init$_1(message, cause, $this) {
		    RuntimeException_init_$Init$_1(message, cause, $this);
		    IllegalArgumentException.call($this);
		    return $this;
		  }
		  function IllegalArgumentException_init_$Create$_1(message, cause) {
		    var tmp = IllegalArgumentException_init_$Init$_1(message, cause, objectCreate(protoOf(IllegalArgumentException)));
		    captureStack(tmp, IllegalArgumentException_init_$Create$_1);
		    return tmp;
		  }
		  function IllegalArgumentException_init_$Init$_2(cause, $this) {
		    RuntimeException_init_$Init$_2(cause, $this);
		    IllegalArgumentException.call($this);
		    return $this;
		  }
		  function IllegalArgumentException() {
		    captureStack(this, IllegalArgumentException);
		  }
		  function IndexOutOfBoundsException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    IndexOutOfBoundsException.call($this);
		    return $this;
		  }
		  function IndexOutOfBoundsException_init_$Create$() {
		    var tmp = IndexOutOfBoundsException_init_$Init$(objectCreate(protoOf(IndexOutOfBoundsException)));
		    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
		    return tmp;
		  }
		  function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
		    RuntimeException_init_$Init$_0(message, $this);
		    IndexOutOfBoundsException.call($this);
		    return $this;
		  }
		  function IndexOutOfBoundsException_init_$Create$_0(message) {
		    var tmp = IndexOutOfBoundsException_init_$Init$_0(message, objectCreate(protoOf(IndexOutOfBoundsException)));
		    captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
		    return tmp;
		  }
		  function IndexOutOfBoundsException() {
		    captureStack(this, IndexOutOfBoundsException);
		  }
		  function IllegalStateException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    IllegalStateException.call($this);
		    return $this;
		  }
		  function IllegalStateException_init_$Create$() {
		    var tmp = IllegalStateException_init_$Init$(objectCreate(protoOf(IllegalStateException)));
		    captureStack(tmp, IllegalStateException_init_$Create$);
		    return tmp;
		  }
		  function IllegalStateException_init_$Init$_0(message, $this) {
		    RuntimeException_init_$Init$_0(message, $this);
		    IllegalStateException.call($this);
		    return $this;
		  }
		  function IllegalStateException_init_$Create$_0(message) {
		    var tmp = IllegalStateException_init_$Init$_0(message, objectCreate(protoOf(IllegalStateException)));
		    captureStack(tmp, IllegalStateException_init_$Create$_0);
		    return tmp;
		  }
		  function IllegalStateException() {
		    captureStack(this, IllegalStateException);
		  }
		  function UnsupportedOperationException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    UnsupportedOperationException.call($this);
		    return $this;
		  }
		  function UnsupportedOperationException_init_$Create$() {
		    var tmp = UnsupportedOperationException_init_$Init$(objectCreate(protoOf(UnsupportedOperationException)));
		    captureStack(tmp, UnsupportedOperationException_init_$Create$);
		    return tmp;
		  }
		  function UnsupportedOperationException_init_$Init$_0(message, $this) {
		    RuntimeException_init_$Init$_0(message, $this);
		    UnsupportedOperationException.call($this);
		    return $this;
		  }
		  function UnsupportedOperationException_init_$Create$_0(message) {
		    var tmp = UnsupportedOperationException_init_$Init$_0(message, objectCreate(protoOf(UnsupportedOperationException)));
		    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
		    return tmp;
		  }
		  function UnsupportedOperationException() {
		    captureStack(this, UnsupportedOperationException);
		  }
		  function RuntimeException_init_$Init$($this) {
		    Exception_init_$Init$($this);
		    RuntimeException.call($this);
		    return $this;
		  }
		  function RuntimeException_init_$Create$() {
		    var tmp = RuntimeException_init_$Init$(objectCreate(protoOf(RuntimeException)));
		    captureStack(tmp, RuntimeException_init_$Create$);
		    return tmp;
		  }
		  function RuntimeException_init_$Init$_0(message, $this) {
		    Exception_init_$Init$_0(message, $this);
		    RuntimeException.call($this);
		    return $this;
		  }
		  function RuntimeException_init_$Create$_0(message) {
		    var tmp = RuntimeException_init_$Init$_0(message, objectCreate(protoOf(RuntimeException)));
		    captureStack(tmp, RuntimeException_init_$Create$_0);
		    return tmp;
		  }
		  function RuntimeException_init_$Init$_1(message, cause, $this) {
		    Exception_init_$Init$_1(message, cause, $this);
		    RuntimeException.call($this);
		    return $this;
		  }
		  function RuntimeException_init_$Init$_2(cause, $this) {
		    Exception_init_$Init$_2(cause, $this);
		    RuntimeException.call($this);
		    return $this;
		  }
		  function RuntimeException() {
		    captureStack(this, RuntimeException);
		  }
		  function NoSuchElementException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    NoSuchElementException.call($this);
		    return $this;
		  }
		  function NoSuchElementException_init_$Create$() {
		    var tmp = NoSuchElementException_init_$Init$(objectCreate(protoOf(NoSuchElementException)));
		    captureStack(tmp, NoSuchElementException_init_$Create$);
		    return tmp;
		  }
		  function NoSuchElementException_init_$Init$_0(message, $this) {
		    RuntimeException_init_$Init$_0(message, $this);
		    NoSuchElementException.call($this);
		    return $this;
		  }
		  function NoSuchElementException_init_$Create$_0(message) {
		    var tmp = NoSuchElementException_init_$Init$_0(message, objectCreate(protoOf(NoSuchElementException)));
		    captureStack(tmp, NoSuchElementException_init_$Create$_0);
		    return tmp;
		  }
		  function NoSuchElementException() {
		    captureStack(this, NoSuchElementException);
		  }
		  function Error_init_$Init$($this) {
		    extendThrowable($this);
		    Error_0.call($this);
		    return $this;
		  }
		  function Error_init_$Create$() {
		    var tmp = Error_init_$Init$(objectCreate(protoOf(Error_0)));
		    captureStack(tmp, Error_init_$Create$);
		    return tmp;
		  }
		  function Error_init_$Init$_0(message, $this) {
		    extendThrowable($this, message);
		    Error_0.call($this);
		    return $this;
		  }
		  function Error_0() {
		    captureStack(this, Error_0);
		  }
		  function AssertionError_init_$Init$($this) {
		    Error_init_$Init$($this);
		    AssertionError.call($this);
		    return $this;
		  }
		  function AssertionError_init_$Create$() {
		    var tmp = AssertionError_init_$Init$(objectCreate(protoOf(AssertionError)));
		    captureStack(tmp, AssertionError_init_$Create$);
		    return tmp;
		  }
		  function AssertionError_init_$Init$_0(message, $this) {
		    Error_init_$Init$_0(message, $this);
		    AssertionError.call($this);
		    return $this;
		  }
		  function AssertionError_init_$Create$_0(message) {
		    var tmp = AssertionError_init_$Init$_0(message, objectCreate(protoOf(AssertionError)));
		    captureStack(tmp, AssertionError_init_$Create$_0);
		    return tmp;
		  }
		  function AssertionError() {
		    captureStack(this, AssertionError);
		  }
		  function ConcurrentModificationException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    ConcurrentModificationException.call($this);
		    return $this;
		  }
		  function ConcurrentModificationException_init_$Create$() {
		    var tmp = ConcurrentModificationException_init_$Init$(objectCreate(protoOf(ConcurrentModificationException)));
		    captureStack(tmp, ConcurrentModificationException_init_$Create$);
		    return tmp;
		  }
		  function ConcurrentModificationException() {
		    captureStack(this, ConcurrentModificationException);
		  }
		  function NumberFormatException_init_$Init$($this) {
		    IllegalArgumentException_init_$Init$($this);
		    NumberFormatException.call($this);
		    return $this;
		  }
		  function NumberFormatException_init_$Create$() {
		    var tmp = NumberFormatException_init_$Init$(objectCreate(protoOf(NumberFormatException)));
		    captureStack(tmp, NumberFormatException_init_$Create$);
		    return tmp;
		  }
		  function NumberFormatException_init_$Init$_0(message, $this) {
		    IllegalArgumentException_init_$Init$_0(message, $this);
		    NumberFormatException.call($this);
		    return $this;
		  }
		  function NumberFormatException_init_$Create$_0(message) {
		    var tmp = NumberFormatException_init_$Init$_0(message, objectCreate(protoOf(NumberFormatException)));
		    captureStack(tmp, NumberFormatException_init_$Create$_0);
		    return tmp;
		  }
		  function NumberFormatException() {
		    captureStack(this, NumberFormatException);
		  }
		  function ArithmeticException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    ArithmeticException.call($this);
		    return $this;
		  }
		  function ArithmeticException_init_$Create$() {
		    var tmp = ArithmeticException_init_$Init$(objectCreate(protoOf(ArithmeticException)));
		    captureStack(tmp, ArithmeticException_init_$Create$);
		    return tmp;
		  }
		  function ArithmeticException_init_$Init$_0(message, $this) {
		    RuntimeException_init_$Init$_0(message, $this);
		    ArithmeticException.call($this);
		    return $this;
		  }
		  function ArithmeticException_init_$Create$_0(message) {
		    var tmp = ArithmeticException_init_$Init$_0(message, objectCreate(protoOf(ArithmeticException)));
		    captureStack(tmp, ArithmeticException_init_$Create$_0);
		    return tmp;
		  }
		  function ArithmeticException() {
		    captureStack(this, ArithmeticException);
		  }
		  function ClassCastException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    ClassCastException.call($this);
		    return $this;
		  }
		  function ClassCastException_init_$Create$() {
		    var tmp = ClassCastException_init_$Init$(objectCreate(protoOf(ClassCastException)));
		    captureStack(tmp, ClassCastException_init_$Create$);
		    return tmp;
		  }
		  function ClassCastException_init_$Init$_0(message, $this) {
		    RuntimeException_init_$Init$_0(message, $this);
		    ClassCastException.call($this);
		    return $this;
		  }
		  function ClassCastException_init_$Create$_0(message) {
		    var tmp = ClassCastException_init_$Init$_0(message, objectCreate(protoOf(ClassCastException)));
		    captureStack(tmp, ClassCastException_init_$Create$_0);
		    return tmp;
		  }
		  function ClassCastException() {
		    captureStack(this, ClassCastException);
		  }
		  function NullPointerException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    NullPointerException.call($this);
		    return $this;
		  }
		  function NullPointerException_init_$Create$() {
		    var tmp = NullPointerException_init_$Init$(objectCreate(protoOf(NullPointerException)));
		    captureStack(tmp, NullPointerException_init_$Create$);
		    return tmp;
		  }
		  function NullPointerException() {
		    captureStack(this, NullPointerException);
		  }
		  function NoWhenBranchMatchedException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    NoWhenBranchMatchedException.call($this);
		    return $this;
		  }
		  function NoWhenBranchMatchedException_init_$Create$() {
		    var tmp = NoWhenBranchMatchedException_init_$Init$(objectCreate(protoOf(NoWhenBranchMatchedException)));
		    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
		    return tmp;
		  }
		  function NoWhenBranchMatchedException() {
		    captureStack(this, NoWhenBranchMatchedException);
		  }
		  function UninitializedPropertyAccessException_init_$Init$($this) {
		    RuntimeException_init_$Init$($this);
		    UninitializedPropertyAccessException.call($this);
		    return $this;
		  }
		  function UninitializedPropertyAccessException_init_$Create$() {
		    var tmp = UninitializedPropertyAccessException_init_$Init$(objectCreate(protoOf(UninitializedPropertyAccessException)));
		    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
		    return tmp;
		  }
		  function UninitializedPropertyAccessException_init_$Init$_0(message, $this) {
		    RuntimeException_init_$Init$_0(message, $this);
		    UninitializedPropertyAccessException.call($this);
		    return $this;
		  }
		  function UninitializedPropertyAccessException_init_$Create$_0(message) {
		    var tmp = UninitializedPropertyAccessException_init_$Init$_0(message, objectCreate(protoOf(UninitializedPropertyAccessException)));
		    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$_0);
		    return tmp;
		  }
		  function UninitializedPropertyAccessException() {
		    captureStack(this, UninitializedPropertyAccessException);
		  }
		  function findAssociatedObject(_this__u8e3s4, annotationClass) {
		    var tmp;
		    var tmp_0;
		    if (_this__u8e3s4 instanceof KClassImpl) {
		      tmp_0 = annotationClass instanceof KClassImpl;
		    } else {
		      tmp_0 = false;
		    }
		    if (tmp_0) {
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp0_safe_receiver = annotationClass.s5().$metadata$;
		      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.associatedObjectKey;
		      var tmp_1;
		      if (tmp1_safe_receiver == null) {
		        tmp_1 = null;
		      } else {
		        // Inline function 'kotlin.js.unsafeCast' call
		        tmp_1 = tmp1_safe_receiver;
		      }
		      var tmp2_elvis_lhs = tmp_1;
		      var tmp_2;
		      if (tmp2_elvis_lhs == null) {
		        return null;
		      } else {
		        tmp_2 = tmp2_elvis_lhs;
		      }
		      var key = tmp_2;
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp3_safe_receiver = _this__u8e3s4.s5().$metadata$;
		      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.associatedObjects;
		      var tmp_3;
		      if (tmp4_elvis_lhs == null) {
		        return null;
		      } else {
		        tmp_3 = tmp4_elvis_lhs;
		      }
		      var map = tmp_3;
		      var tmp5_elvis_lhs = map[key];
		      var tmp_4;
		      if (tmp5_elvis_lhs == null) {
		        return null;
		      } else {
		        tmp_4 = tmp5_elvis_lhs;
		      }
		      var factory = tmp_4;
		      return factory();
		    } else {
		      tmp = null;
		    }
		    return tmp;
		  }
		  function toString_2(_this__u8e3s4, radix) {
		    return toStringImpl(_this__u8e3s4, checkRadix(radix));
		  }
		  function AbstractCollection$toString$lambda(this$0) {
		    return function (it) {
		      return it === this$0 ? '(this Collection)' : toString_0(it);
		    };
		  }
		  function AbstractCollection() {
		  }
		  protoOf(AbstractCollection).v = function (element) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.any' call
		      var tmp;
		      if (isInterface(this, Collection)) {
		        tmp = this.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = false;
		        break $l$block_0;
		      }
		      var tmp0_iterator = this.p();
		      while (tmp0_iterator.q()) {
		        var element_0 = tmp0_iterator.s();
		        // Inline function 'kotlin.collections.AbstractCollection.contains.<anonymous>' call
		        if (equals_0(element_0, element)) {
		          tmp$ret$0 = true;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = false;
		    }
		    return tmp$ret$0;
		  };
		  protoOf(AbstractCollection).w = function (elements) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.all' call
		      var tmp;
		      if (isInterface(elements, Collection)) {
		        tmp = elements.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = true;
		        break $l$block_0;
		      }
		      var tmp0_iterator = elements.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.collections.AbstractCollection.containsAll.<anonymous>' call
		        if (!this.v(element)) {
		          tmp$ret$0 = false;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  };
		  protoOf(AbstractCollection).x = function () {
		    return this.u() === 0;
		  };
		  protoOf(AbstractCollection).toString = function () {
		    return joinToString_0(this, ', ', '[', ']', VOID, VOID, AbstractCollection$toString$lambda(this));
		  };
		  protoOf(AbstractCollection).toArray = function () {
		    return collectionToArray(this);
		  };
		  function Companion_5() {
		    this.h1_1 = 2147483639;
		  }
		  protoOf(Companion_5).j2 = function (index, size) {
		    if (index < 0 ? true : index >= size) {
		      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
		    }
		  };
		  protoOf(Companion_5).k2 = function (index, size) {
		    if (index < 0 ? true : index > size) {
		      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
		    }
		  };
		  protoOf(Companion_5).fa = function (fromIndex, toIndex, size) {
		    if (fromIndex < 0 ? true : toIndex > size) {
		      throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
		    }
		    if (fromIndex > toIndex) {
		      throw IllegalArgumentException_init_$Create$_0('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
		    }
		  };
		  protoOf(Companion_5).k7 = function (startIndex, endIndex, size) {
		    if (startIndex < 0 ? true : endIndex > size) {
		      throw IndexOutOfBoundsException_init_$Create$_0('startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size);
		    }
		    if (startIndex > endIndex) {
		      throw IllegalArgumentException_init_$Create$_0('startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
		    }
		  };
		  protoOf(Companion_5).z3 = function (oldCapacity, minCapacity) {
		    var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
		    if ((newCapacity - minCapacity | 0) < 0)
		      newCapacity = minCapacity;
		    if ((newCapacity - 2147483639 | 0) > 0)
		      newCapacity = minCapacity > 2147483639 ? IntCompanionObject_instance.MAX_VALUE : 2147483639;
		    return newCapacity;
		  };
		  protoOf(Companion_5).j1 = function (c) {
		    var hashCode_0 = 1;
		    var tmp0_iterator = c.p();
		    while (tmp0_iterator.q()) {
		      var e = tmp0_iterator.s();
		      var tmp = imul(31, hashCode_0);
		      var tmp2_elvis_lhs = e == null ? null : hashCode(e);
		      hashCode_0 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
		    }
		    return hashCode_0;
		  };
		  protoOf(Companion_5).i1 = function (c, other) {
		    if (!(c.u() === other.u()))
		      return false;
		    var otherIterator = other.p();
		    var tmp0_iterator = c.p();
		    while (tmp0_iterator.q()) {
		      var elem = tmp0_iterator.s();
		      var elemOther = otherIterator.s();
		      if (!equals_0(elem, elemOther)) {
		        return false;
		      }
		    }
		    return true;
		  };
		  var Companion_instance_5;
		  function Companion_getInstance_5() {
		    return Companion_instance_5;
		  }
		  function AbstractMap$keys$1$iterator$1($entryIterator) {
		    this.cb_1 = $entryIterator;
		  }
		  protoOf(AbstractMap$keys$1$iterator$1).q = function () {
		    return this.cb_1.q();
		  };
		  protoOf(AbstractMap$keys$1$iterator$1).s = function () {
		    return this.cb_1.s().v1();
		  };
		  function AbstractMap$values$1$iterator$1($entryIterator) {
		    this.db_1 = $entryIterator;
		  }
		  protoOf(AbstractMap$values$1$iterator$1).q = function () {
		    return this.db_1.q();
		  };
		  protoOf(AbstractMap$values$1$iterator$1).s = function () {
		    return this.db_1.s().w1();
		  };
		  function toString_3($this, o) {
		    return o === $this ? '(this Map)' : toString_0(o);
		  }
		  function implFindEntry($this, key) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlin.collections.firstOrNull' call
		      var tmp0_iterator = $this.u1().p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.collections.AbstractMap.implFindEntry.<anonymous>' call
		        if (equals_0(element.v1(), key)) {
		          tmp$ret$1 = element;
		          break $l$block;
		        }
		      }
		      tmp$ret$1 = null;
		    }
		    return tmp$ret$1;
		  }
		  function Companion_6() {
		  }
		  var Companion_instance_6;
		  function Companion_getInstance_6() {
		    return Companion_instance_6;
		  }
		  function AbstractMap$keys$1(this$0) {
		    this.eb_1 = this$0;
		    AbstractSet.call(this);
		  }
		  protoOf(AbstractMap$keys$1).t2 = function (element) {
		    return this.eb_1.z1(element);
		  };
		  protoOf(AbstractMap$keys$1).v = function (element) {
		    if (!(element == null ? true : !(element == null)))
		      return false;
		    return this.t2((element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(AbstractMap$keys$1).p = function () {
		    var entryIterator = this.eb_1.u1().p();
		    return new AbstractMap$keys$1$iterator$1(entryIterator);
		  };
		  protoOf(AbstractMap$keys$1).u = function () {
		    return this.eb_1.u();
		  };
		  function AbstractMap$toString$lambda(this$0) {
		    return function (it) {
		      return this$0.fb(it);
		    };
		  }
		  function AbstractMap$values$1(this$0) {
		    this.gb_1 = this$0;
		    AbstractCollection.call(this);
		  }
		  protoOf(AbstractMap$values$1).x2 = function (element) {
		    return this.gb_1.a2(element);
		  };
		  protoOf(AbstractMap$values$1).v = function (element) {
		    if (!(element == null ? true : !(element == null)))
		      return false;
		    return this.x2((element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(AbstractMap$values$1).p = function () {
		    var entryIterator = this.gb_1.u1().p();
		    return new AbstractMap$values$1$iterator$1(entryIterator);
		  };
		  protoOf(AbstractMap$values$1).u = function () {
		    return this.gb_1.u();
		  };
		  function AbstractMap() {
		    this.x1_1 = null;
		    this.y1_1 = null;
		  }
		  protoOf(AbstractMap).z1 = function (key) {
		    return !(implFindEntry(this, key) == null);
		  };
		  protoOf(AbstractMap).a2 = function (value) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.any' call
		      var this_0 = this.u1();
		      var tmp;
		      if (isInterface(this_0, Collection)) {
		        tmp = this_0.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = false;
		        break $l$block_0;
		      }
		      var tmp0_iterator = this_0.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.collections.AbstractMap.containsValue.<anonymous>' call
		        if (equals_0(element.w1(), value)) {
		          tmp$ret$0 = true;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = false;
		    }
		    return tmp$ret$0;
		  };
		  protoOf(AbstractMap).b2 = function (entry) {
		    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
		      return false;
		    var key = entry.v1();
		    var value = entry.w1();
		    // Inline function 'kotlin.collections.get' call
		    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).c2(key);
		    if (!equals_0(value, ourValue)) {
		      return false;
		    }
		    var tmp;
		    if (ourValue == null) {
		      // Inline function 'kotlin.collections.containsKey' call
		      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).z1(key);
		    } else {
		      tmp = false;
		    }
		    if (tmp) {
		      return false;
		    }
		    return true;
		  };
		  protoOf(AbstractMap).equals = function (other) {
		    if (other === this)
		      return true;
		    if (!(!(other == null) ? isInterface(other, Map_0) : false))
		      return false;
		    if (!(this.u() === other.u()))
		      return false;
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.all' call
		      var this_0 = other.u1();
		      var tmp;
		      if (isInterface(this_0, Collection)) {
		        tmp = this_0.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = true;
		        break $l$block_0;
		      }
		      var tmp0_iterator = this_0.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.collections.AbstractMap.equals.<anonymous>' call
		        if (!this.b2(element)) {
		          tmp$ret$0 = false;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  };
		  protoOf(AbstractMap).c2 = function (key) {
		    var tmp0_safe_receiver = implFindEntry(this, key);
		    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1();
		  };
		  protoOf(AbstractMap).hashCode = function () {
		    return hashCode(this.u1());
		  };
		  protoOf(AbstractMap).x = function () {
		    return this.u() === 0;
		  };
		  protoOf(AbstractMap).u = function () {
		    return this.u1().u();
		  };
		  protoOf(AbstractMap).q1 = function () {
		    if (this.x1_1 == null) {
		      var tmp = this;
		      tmp.x1_1 = new AbstractMap$keys$1(this);
		    }
		    return ensureNotNull(this.x1_1);
		  };
		  protoOf(AbstractMap).toString = function () {
		    var tmp = this.u1();
		    return joinToString_0(tmp, ', ', '{', '}', VOID, VOID, AbstractMap$toString$lambda(this));
		  };
		  protoOf(AbstractMap).fb = function (entry) {
		    return toString_3(this, entry.v1()) + '=' + toString_3(this, entry.w1());
		  };
		  protoOf(AbstractMap).r1 = function () {
		    if (this.y1_1 == null) {
		      var tmp = this;
		      tmp.y1_1 = new AbstractMap$values$1(this);
		    }
		    return ensureNotNull(this.y1_1);
		  };
		  function Companion_7() {
		  }
		  protoOf(Companion_7).e2 = function (c) {
		    var hashCode_0 = 0;
		    var tmp0_iterator = c.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      var tmp = hashCode_0;
		      var tmp2_elvis_lhs = element == null ? null : hashCode(element);
		      hashCode_0 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
		    }
		    return hashCode_0;
		  };
		  protoOf(Companion_7).d2 = function (c, other) {
		    if (!(c.u() === other.u()))
		      return false;
		    // Inline function 'kotlin.collections.containsAll' call
		    return c.w(other);
		  };
		  var Companion_instance_7;
		  function Companion_getInstance_7() {
		    return Companion_instance_7;
		  }
		  function AbstractSet() {
		    AbstractCollection.call(this);
		  }
		  protoOf(AbstractSet).equals = function (other) {
		    if (other === this)
		      return true;
		    if (!(!(other == null) ? isInterface(other, Set) : false))
		      return false;
		    return Companion_instance_7.d2(this, other);
		  };
		  protoOf(AbstractSet).hashCode = function () {
		    return Companion_instance_7.e2(this);
		  };
		  function collectionToArrayCommonImpl(collection) {
		    if (collection.x()) {
		      // Inline function 'kotlin.emptyArray' call
		      return [];
		    }
		    // Inline function 'kotlin.arrayOfNulls' call
		    var size = collection.u();
		    var destination = fillArrayVal(Array(size), null);
		    var iterator = collection.p();
		    var index = 0;
		    while (iterator.q()) {
		      var tmp0 = index;
		      index = tmp0 + 1 | 0;
		      destination[tmp0] = iterator.s();
		    }
		    return destination;
		  }
		  function emptyList() {
		    return EmptyList_getInstance();
		  }
		  function listOf_0(elements) {
		    return elements.length > 0 ? asList(elements) : emptyList();
		  }
		  function EmptyList() {
		    EmptyList_instance = this;
		    this.hb_1 = new Long(-1478467534, -1720727600);
		  }
		  protoOf(EmptyList).equals = function (other) {
		    var tmp;
		    if (!(other == null) ? isInterface(other, List) : false) {
		      tmp = other.x();
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(EmptyList).hashCode = function () {
		    return 1;
		  };
		  protoOf(EmptyList).toString = function () {
		    return '[]';
		  };
		  protoOf(EmptyList).u = function () {
		    return 0;
		  };
		  protoOf(EmptyList).x = function () {
		    return true;
		  };
		  protoOf(EmptyList).ib = function (element) {
		    return false;
		  };
		  protoOf(EmptyList).v = function (element) {
		    if (!false)
		      return false;
		    var tmp;
		    if (false) {
		      tmp = element;
		    } else {
		      tmp = THROW_CCE();
		    }
		    return this.ib(tmp);
		  };
		  protoOf(EmptyList).jb = function (elements) {
		    return elements.x();
		  };
		  protoOf(EmptyList).w = function (elements) {
		    return this.jb(elements);
		  };
		  protoOf(EmptyList).b1 = function (index) {
		    throw IndexOutOfBoundsException_init_$Create$_0("Empty list doesn't contain element at index " + index + '.');
		  };
		  protoOf(EmptyList).p = function () {
		    return EmptyIterator_instance;
		  };
		  var EmptyList_instance;
		  function EmptyList_getInstance() {
		    if (EmptyList_instance == null)
		      new EmptyList();
		    return EmptyList_instance;
		  }
		  function EmptyIterator() {
		  }
		  protoOf(EmptyIterator).q = function () {
		    return false;
		  };
		  protoOf(EmptyIterator).s = function () {
		    throw NoSuchElementException_init_$Create$();
		  };
		  var EmptyIterator_instance;
		  function EmptyIterator_getInstance() {
		    return EmptyIterator_instance;
		  }
		  function get_lastIndex_2(_this__u8e3s4) {
		    return _this__u8e3s4.u() - 1 | 0;
		  }
		  function asCollection(_this__u8e3s4) {
		    return new ArrayAsCollection(_this__u8e3s4, false);
		  }
		  function ArrayAsCollection(values, isVarargs) {
		    this.kb_1 = values;
		    this.lb_1 = isVarargs;
		  }
		  protoOf(ArrayAsCollection).u = function () {
		    return this.kb_1.length;
		  };
		  protoOf(ArrayAsCollection).x = function () {
		    // Inline function 'kotlin.collections.isEmpty' call
		    return this.kb_1.length === 0;
		  };
		  protoOf(ArrayAsCollection).mb = function (element) {
		    return contains_3(this.kb_1, element);
		  };
		  protoOf(ArrayAsCollection).nb = function (elements) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.all' call
		      var tmp;
		      if (isInterface(elements, Collection)) {
		        tmp = elements.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = true;
		        break $l$block_0;
		      }
		      var tmp0_iterator = elements.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.collections.ArrayAsCollection.containsAll.<anonymous>' call
		        if (!this.mb(element)) {
		          tmp$ret$0 = false;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  };
		  protoOf(ArrayAsCollection).w = function (elements) {
		    return this.nb(elements);
		  };
		  protoOf(ArrayAsCollection).p = function () {
		    return arrayIterator(this.kb_1);
		  };
		  function arrayListOf(elements) {
		    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
		  }
		  function throwIndexOverflow() {
		    throw ArithmeticException_init_$Create$_0('Index overflow has happened.');
		  }
		  function listOfNotNull(elements) {
		    return filterNotNull(elements);
		  }
		  function optimizeReadOnlyList(_this__u8e3s4) {
		    switch (_this__u8e3s4.u()) {
		      case 0:
		        return emptyList();
		      case 1:
		        return listOf(_this__u8e3s4.b1(0));
		      default:
		        return _this__u8e3s4;
		    }
		  }
		  function IndexedValue(index, value) {
		    this.ob_1 = index;
		    this.pb_1 = value;
		  }
		  protoOf(IndexedValue).toString = function () {
		    return 'IndexedValue(index=' + this.ob_1 + ', value=' + this.pb_1 + ')';
		  };
		  protoOf(IndexedValue).hashCode = function () {
		    var result = this.ob_1;
		    result = imul(result, 31) + (this.pb_1 == null ? 0 : hashCode(this.pb_1)) | 0;
		    return result;
		  };
		  protoOf(IndexedValue).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof IndexedValue))
		      return false;
		    var tmp0_other_with_cast = other instanceof IndexedValue ? other : THROW_CCE();
		    if (!(this.ob_1 === tmp0_other_with_cast.ob_1))
		      return false;
		    if (!equals_0(this.pb_1, tmp0_other_with_cast.pb_1))
		      return false;
		    return true;
		  };
		  function collectionSizeOrDefault(_this__u8e3s4, default_0) {
		    var tmp;
		    if (isInterface(_this__u8e3s4, Collection)) {
		      tmp = _this__u8e3s4.u();
		    } else {
		      tmp = default_0;
		    }
		    return tmp;
		  }
		  function IndexingIterable(iteratorFactory) {
		    this.qb_1 = iteratorFactory;
		  }
		  protoOf(IndexingIterable).p = function () {
		    return new IndexingIterator(this.qb_1());
		  };
		  function flatten(_this__u8e3s4) {
		    var result = ArrayList_init_$Create$();
		    var tmp0_iterator = _this__u8e3s4.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      addAll(result, element);
		    }
		    return result;
		  }
		  function collectionSizeOrNull(_this__u8e3s4) {
		    var tmp;
		    if (isInterface(_this__u8e3s4, Collection)) {
		      tmp = _this__u8e3s4.u();
		    } else {
		      tmp = null;
		    }
		    return tmp;
		  }
		  function IndexingIterator(iterator) {
		    this.rb_1 = iterator;
		    this.sb_1 = 0;
		  }
		  protoOf(IndexingIterator).q = function () {
		    return this.rb_1.q();
		  };
		  protoOf(IndexingIterator).s = function () {
		    var tmp1 = this.sb_1;
		    this.sb_1 = tmp1 + 1 | 0;
		    return new IndexedValue(checkIndexOverflow(tmp1), this.rb_1.s());
		  };
		  function getOrImplicitDefault(_this__u8e3s4, key) {
		    if (isInterface(_this__u8e3s4, MapWithDefault))
		      return _this__u8e3s4.tb(key);
		    var tmp$ret$0;
		    $l$block: {
		      // Inline function 'kotlin.collections.getOrElseNullable' call
		      var value = _this__u8e3s4.c2(key);
		      if (value == null ? !_this__u8e3s4.z1(key) : false) {
		        throw NoSuchElementException_init_$Create$_0('Key ' + key + ' is missing in the map.');
		      } else {
		        tmp$ret$0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
		        break $l$block;
		      }
		    }
		    return tmp$ret$0;
		  }
		  function MapWithDefault() {
		  }
		  function mapOf_0(pairs) {
		    return pairs.length > 0 ? toMap_0(pairs, LinkedHashMap_init_$Create$_0(mapCapacity(pairs.length))) : emptyMap();
		  }
		  function emptyMap() {
		    var tmp = EmptyMap_getInstance();
		    return isInterface(tmp, Map_0) ? tmp : THROW_CCE();
		  }
		  function getValue(_this__u8e3s4, key) {
		    return getOrImplicitDefault(_this__u8e3s4, key);
		  }
		  function toMap(_this__u8e3s4) {
		    if (isInterface(_this__u8e3s4, Collection)) {
		      var tmp;
		      switch (_this__u8e3s4.u()) {
		        case 0:
		          tmp = emptyMap();
		          break;
		        case 1:
		          var tmp_0;
		          if (isInterface(_this__u8e3s4, List)) {
		            tmp_0 = _this__u8e3s4.b1(0);
		          } else {
		            tmp_0 = _this__u8e3s4.p().s();
		          }

		          tmp = mapOf(tmp_0);
		          break;
		        default:
		          tmp = toMap_1(_this__u8e3s4, LinkedHashMap_init_$Create$_0(mapCapacity(_this__u8e3s4.u())));
		          break;
		      }
		      return tmp;
		    }
		    return optimizeReadOnlyMap(toMap_1(_this__u8e3s4, LinkedHashMap_init_$Create$()));
		  }
		  function toMap_0(_this__u8e3s4, destination) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.collections.toMap.<anonymous>' call
		    putAll(destination, _this__u8e3s4);
		    return destination;
		  }
		  function EmptyMap() {
		    EmptyMap_instance = this;
		    this.ub_1 = new Long(-888910638, 1920087921);
		  }
		  protoOf(EmptyMap).equals = function (other) {
		    var tmp;
		    if (!(other == null) ? isInterface(other, Map_0) : false) {
		      tmp = other.x();
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(EmptyMap).hashCode = function () {
		    return 0;
		  };
		  protoOf(EmptyMap).toString = function () {
		    return '{}';
		  };
		  protoOf(EmptyMap).u = function () {
		    return 0;
		  };
		  protoOf(EmptyMap).x = function () {
		    return true;
		  };
		  protoOf(EmptyMap).vb = function (key) {
		    return false;
		  };
		  protoOf(EmptyMap).z1 = function (key) {
		    if (!(key == null ? true : !(key == null)))
		      return false;
		    return this.vb((key == null ? true : !(key == null)) ? key : THROW_CCE());
		  };
		  protoOf(EmptyMap).wb = function (key) {
		    return null;
		  };
		  protoOf(EmptyMap).c2 = function (key) {
		    if (!(key == null ? true : !(key == null)))
		      return null;
		    return this.wb((key == null ? true : !(key == null)) ? key : THROW_CCE());
		  };
		  protoOf(EmptyMap).u1 = function () {
		    return EmptySet_getInstance();
		  };
		  protoOf(EmptyMap).q1 = function () {
		    return EmptySet_getInstance();
		  };
		  protoOf(EmptyMap).r1 = function () {
		    return EmptyList_getInstance();
		  };
		  var EmptyMap_instance;
		  function EmptyMap_getInstance() {
		    if (EmptyMap_instance == null)
		      new EmptyMap();
		    return EmptyMap_instance;
		  }
		  function toMap_1(_this__u8e3s4, destination) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.collections.toMap.<anonymous>' call
		    putAll_0(destination, _this__u8e3s4);
		    return destination;
		  }
		  function optimizeReadOnlyMap(_this__u8e3s4) {
		    var tmp;
		    switch (_this__u8e3s4.u()) {
		      case 0:
		        tmp = emptyMap();
		        break;
		      case 1:
		        // Inline function 'kotlin.collections.toSingletonMapOrSelf' call

		        tmp = _this__u8e3s4;
		        break;
		      default:
		        tmp = _this__u8e3s4;
		        break;
		    }
		    return tmp;
		  }
		  function putAll(_this__u8e3s4, pairs) {
		    var inductionVariable = 0;
		    var last = pairs.length;
		    while (inductionVariable < last) {
		      var tmp1_loop_parameter = pairs[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      var key = tmp1_loop_parameter.o5();
		      var value = tmp1_loop_parameter.p5();
		      _this__u8e3s4.s1(key, value);
		    }
		  }
		  function putAll_0(_this__u8e3s4, pairs) {
		    var tmp0_iterator = pairs.p();
		    while (tmp0_iterator.q()) {
		      var tmp1_loop_parameter = tmp0_iterator.s();
		      var key = tmp1_loop_parameter.o5();
		      var value = tmp1_loop_parameter.p5();
		      _this__u8e3s4.s1(key, value);
		    }
		  }
		  function hashMapOf(pairs) {
		    // Inline function 'kotlin.apply' call
		    var this_0 = HashMap_init_$Create$_0(mapCapacity(pairs.length));
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.collections.hashMapOf.<anonymous>' call
		    putAll(this_0, pairs);
		    return this_0;
		  }
		  function addAll(_this__u8e3s4, elements) {
		    if (isInterface(elements, Collection))
		      return _this__u8e3s4.t(elements);
		    else {
		      var result = false;
		      var tmp1_iterator = elements.p();
		      while (tmp1_iterator.q()) {
		        var item = tmp1_iterator.s();
		        if (_this__u8e3s4.m(item))
		          result = true;
		      }
		      return result;
		    }
		  }
		  function removeLast(_this__u8e3s4) {
		    var tmp;
		    if (_this__u8e3s4.x()) {
		      throw NoSuchElementException_init_$Create$_0('List is empty.');
		    } else {
		      tmp = _this__u8e3s4.d1(get_lastIndex_2(_this__u8e3s4));
		    }
		    return tmp;
		  }
		  function IntIterator() {
		  }
		  protoOf(IntIterator).s = function () {
		    return this.xb();
		  };
		  function TransformingSequence$iterator$1(this$0) {
		    this.zb_1 = this$0;
		    this.yb_1 = this$0.ac_1.p();
		  }
		  protoOf(TransformingSequence$iterator$1).s = function () {
		    return this.zb_1.bc_1(this.yb_1.s());
		  };
		  protoOf(TransformingSequence$iterator$1).q = function () {
		    return this.yb_1.q();
		  };
		  function TransformingSequence(sequence, transformer) {
		    this.ac_1 = sequence;
		    this.bc_1 = transformer;
		  }
		  protoOf(TransformingSequence).p = function () {
		    return new TransformingSequence$iterator$1(this);
		  };
		  function setOf_0(elements) {
		    return elements.length > 0 ? toSet(elements) : emptySet();
		  }
		  function EmptySet() {
		    EmptySet_instance = this;
		    this.cc_1 = new Long(1993859828, 793161749);
		  }
		  protoOf(EmptySet).equals = function (other) {
		    var tmp;
		    if (!(other == null) ? isInterface(other, Set) : false) {
		      tmp = other.x();
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(EmptySet).hashCode = function () {
		    return 0;
		  };
		  protoOf(EmptySet).toString = function () {
		    return '[]';
		  };
		  protoOf(EmptySet).u = function () {
		    return 0;
		  };
		  protoOf(EmptySet).x = function () {
		    return true;
		  };
		  protoOf(EmptySet).ib = function (element) {
		    return false;
		  };
		  protoOf(EmptySet).v = function (element) {
		    if (!false)
		      return false;
		    var tmp;
		    if (false) {
		      tmp = element;
		    } else {
		      tmp = THROW_CCE();
		    }
		    return this.ib(tmp);
		  };
		  protoOf(EmptySet).jb = function (elements) {
		    return elements.x();
		  };
		  protoOf(EmptySet).w = function (elements) {
		    return this.jb(elements);
		  };
		  protoOf(EmptySet).p = function () {
		    return EmptyIterator_instance;
		  };
		  var EmptySet_instance;
		  function EmptySet_getInstance() {
		    if (EmptySet_instance == null)
		      new EmptySet();
		    return EmptySet_instance;
		  }
		  function emptySet() {
		    return EmptySet_getInstance();
		  }
		  function hashSetOf(elements) {
		    return toCollection(elements, HashSet_init_$Create$_1(mapCapacity(elements.length)));
		  }
		  function optimizeReadOnlySet(_this__u8e3s4) {
		    switch (_this__u8e3s4.u()) {
		      case 0:
		        return emptySet();
		      case 1:
		        return setOf(_this__u8e3s4.p().s());
		      default:
		        return _this__u8e3s4;
		    }
		  }
		  function Continuation() {
		  }
		  function Key() {
		  }
		  var Key_instance;
		  function Key_getInstance() {
		    return Key_instance;
		  }
		  function ContinuationInterceptor() {
		  }
		  function EmptyCoroutineContext() {
		    EmptyCoroutineContext_instance = this;
		    this.dc_1 = new Long(0, 0);
		  }
		  protoOf(EmptyCoroutineContext).va = function (key) {
		    return null;
		  };
		  protoOf(EmptyCoroutineContext).hashCode = function () {
		    return 0;
		  };
		  protoOf(EmptyCoroutineContext).toString = function () {
		    return 'EmptyCoroutineContext';
		  };
		  var EmptyCoroutineContext_instance;
		  function EmptyCoroutineContext_getInstance() {
		    if (EmptyCoroutineContext_instance == null)
		      new EmptyCoroutineContext();
		    return EmptyCoroutineContext_instance;
		  }
		  function get_COROUTINE_SUSPENDED() {
		    return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
		  }
		  var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
		  var CoroutineSingletons_UNDECIDED_instance;
		  var CoroutineSingletons_RESUMED_instance;
		  var CoroutineSingletons_entriesInitialized;
		  function CoroutineSingletons_initEntries() {
		    if (CoroutineSingletons_entriesInitialized)
		      return Unit_instance;
		    CoroutineSingletons_entriesInitialized = true;
		    CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons('COROUTINE_SUSPENDED', 0);
		    CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons('UNDECIDED', 1);
		    CoroutineSingletons_RESUMED_instance = new CoroutineSingletons('RESUMED', 2);
		  }
		  function CoroutineSingletons(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
		    CoroutineSingletons_initEntries();
		    return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
		  }
		  function getProgressionLastElement(start, end, step) {
		    var tmp;
		    if (step > 0) {
		      tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
		    } else if (step < 0) {
		      tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
		    } else {
		      throw IllegalArgumentException_init_$Create$_0('Step is zero.');
		    }
		    return tmp;
		  }
		  function differenceModulo(a, b, c) {
		    return mod(mod(a, c) - mod(b, c) | 0, c);
		  }
		  function mod(a, b) {
		    var mod = a % b | 0;
		    return mod >= 0 ? mod : mod + b | 0;
		  }
		  function Default() {
		    Default_instance = this;
		    Random.call(this);
		    this.ec_1 = defaultPlatformRandom();
		  }
		  protoOf(Default).fc = function (bitCount) {
		    return this.ec_1.fc(bitCount);
		  };
		  protoOf(Default).xb = function () {
		    return this.ec_1.xb();
		  };
		  protoOf(Default).gc = function (from, until) {
		    return this.ec_1.gc(from, until);
		  };
		  var Default_instance;
		  function Default_getInstance() {
		    if (Default_instance == null)
		      new Default();
		    return Default_instance;
		  }
		  function Random() {
		    Default_getInstance();
		  }
		  protoOf(Random).xb = function () {
		    return this.fc(32);
		  };
		  protoOf(Random).gc = function (from, until) {
		    checkRangeBounds(from, until);
		    var n = until - from | 0;
		    if (n > 0 ? true : n === IntCompanionObject_instance.MIN_VALUE) {
		      var tmp;
		      if ((n & (-n | 0)) === n) {
		        var bitCount = fastLog2(n);
		        tmp = this.fc(bitCount);
		      } else {
		        var v;
		        do {
		          var bits = this.xb() >>> 1 | 0;
		          v = bits % n | 0;
		        }
		         while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
		        tmp = v;
		      }
		      var rnd = tmp;
		      return from + rnd | 0;
		    } else {
		      while (true) {
		        var rnd_0 = this.xb();
		        if (from <= rnd_0 ? rnd_0 < until : false)
		          return rnd_0;
		      }
		    }
		  };
		  function nextInt(_this__u8e3s4, range) {
		    var tmp;
		    if (range.x()) {
		      throw IllegalArgumentException_init_$Create$_0('Cannot get random in empty range: ' + range);
		    } else if (range.p8_1 < IntCompanionObject_instance.MAX_VALUE) {
		      tmp = _this__u8e3s4.gc(range.o8_1, range.p8_1 + 1 | 0);
		    } else if (range.o8_1 > IntCompanionObject_instance.MIN_VALUE) {
		      tmp = _this__u8e3s4.gc(range.o8_1 - 1 | 0, range.p8_1) + 1 | 0;
		    } else {
		      tmp = _this__u8e3s4.xb();
		    }
		    return tmp;
		  }
		  function checkRangeBounds(from, until) {
		    // Inline function 'kotlin.contracts.contract' call
		    var tmp;
		    if (!(until > from)) {
		      // Inline function 'kotlin.random.checkRangeBounds.<anonymous>' call
		      var message = boundsErrorMessage(from, until);
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return tmp;
		  }
		  function fastLog2(value) {
		    // Inline function 'kotlin.countLeadingZeroBits' call
		    return 31 - clz32(value) | 0;
		  }
		  function boundsErrorMessage(from, until) {
		    return 'Random range is empty: [' + toString_1(from) + ', ' + toString_1(until) + ').';
		  }
		  function Random_0(seed) {
		    return XorWowRandom_init_$Create$(seed, seed >> 31);
		  }
		  function takeUpperBits(_this__u8e3s4, bitCount) {
		    return (_this__u8e3s4 >>> (32 - bitCount | 0) | 0) & (-bitCount | 0) >> 31;
		  }
		  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
		    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ (seed2 >>> 4 | 0));
		    return $this;
		  }
		  function XorWowRandom_init_$Create$(seed1, seed2) {
		    return XorWowRandom_init_$Init$(seed1, seed2, objectCreate(protoOf(XorWowRandom)));
		  }
		  function Companion_8() {
		    Companion_instance_8 = this;
		    this.hc_1 = new Long(0, 0);
		  }
		  var Companion_instance_8;
		  function Companion_getInstance_8() {
		    if (Companion_instance_8 == null)
		      new Companion_8();
		    return Companion_instance_8;
		  }
		  function XorWowRandom(x, y, z, w, v, addend) {
		    Companion_getInstance_8();
		    Random.call(this);
		    this.ic_1 = x;
		    this.jc_1 = y;
		    this.kc_1 = z;
		    this.lc_1 = w;
		    this.mc_1 = v;
		    this.nc_1 = addend;
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!!((this.ic_1 | this.jc_1 | this.kc_1 | this.lc_1 | this.mc_1) === 0)) {
		      // Inline function 'kotlin.random.XorWowRandom.<anonymous>' call
		      var message = 'Initial state must have at least one non-zero element.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    // Inline function 'kotlin.repeat' call
		    // Inline function 'kotlin.contracts.contract' call
		    var inductionVariable = 0;
		    if (inductionVariable < 64)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.random.XorWowRandom.<anonymous>' call
		        this.xb();
		      }
		       while (inductionVariable < 64);
		  }
		  protoOf(XorWowRandom).xb = function () {
		    var t = this.ic_1;
		    t = t ^ (t >>> 2 | 0);
		    this.ic_1 = this.jc_1;
		    this.jc_1 = this.kc_1;
		    this.kc_1 = this.lc_1;
		    var v0 = this.mc_1;
		    this.lc_1 = v0;
		    t = t ^ t << 1 ^ v0 ^ v0 << 4;
		    this.mc_1 = t;
		    this.nc_1 = this.nc_1 + 362437 | 0;
		    return t + this.nc_1 | 0;
		  };
		  protoOf(XorWowRandom).fc = function (bitCount) {
		    return takeUpperBits(this.xb(), bitCount);
		  };
		  function Companion_9() {
		    Companion_instance_9 = this;
		    this.n8_1 = new IntRange(1, 0);
		  }
		  var Companion_instance_9;
		  function Companion_getInstance_9() {
		    if (Companion_instance_9 == null)
		      new Companion_9();
		    return Companion_instance_9;
		  }
		  function IntRange(start, endInclusive) {
		    Companion_getInstance_9();
		    IntProgression.call(this, start, endInclusive, 1);
		  }
		  protoOf(IntRange).oc = function () {
		    return this.o8_1;
		  };
		  protoOf(IntRange).pc = function () {
		    return this.p8_1;
		  };
		  protoOf(IntRange).x = function () {
		    return this.o8_1 > this.p8_1;
		  };
		  protoOf(IntRange).equals = function (other) {
		    var tmp;
		    if (other instanceof IntRange) {
		      tmp = (this.x() ? other.x() : false) ? true : this.o8_1 === other.o8_1 ? this.p8_1 === other.p8_1 : false;
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(IntRange).hashCode = function () {
		    return this.x() ? -1 : imul(31, this.o8_1) + this.p8_1 | 0;
		  };
		  protoOf(IntRange).toString = function () {
		    return '' + this.o8_1 + '..' + this.p8_1;
		  };
		  function IntProgressionIterator(first, last, step) {
		    IntIterator.call(this);
		    this.qc_1 = step;
		    this.rc_1 = last;
		    this.sc_1 = this.qc_1 > 0 ? first <= last : first >= last;
		    this.tc_1 = this.sc_1 ? first : this.rc_1;
		  }
		  protoOf(IntProgressionIterator).q = function () {
		    return this.sc_1;
		  };
		  protoOf(IntProgressionIterator).xb = function () {
		    var value = this.tc_1;
		    if (value === this.rc_1) {
		      if (!this.sc_1)
		        throw NoSuchElementException_init_$Create$();
		      this.sc_1 = false;
		    } else {
		      this.tc_1 = this.tc_1 + this.qc_1 | 0;
		    }
		    return value;
		  };
		  function Companion_10() {
		  }
		  protoOf(Companion_10).r8 = function (rangeStart, rangeEnd, step) {
		    return new IntProgression(rangeStart, rangeEnd, step);
		  };
		  var Companion_instance_10;
		  function Companion_getInstance_10() {
		    return Companion_instance_10;
		  }
		  function IntProgression(start, endInclusive, step) {
		    if (step === 0)
		      throw IllegalArgumentException_init_$Create$_0('Step must be non-zero.');
		    if (step === IntCompanionObject_instance.MIN_VALUE)
		      throw IllegalArgumentException_init_$Create$_0('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
		    this.o8_1 = start;
		    this.p8_1 = getProgressionLastElement(start, endInclusive, step);
		    this.q8_1 = step;
		  }
		  protoOf(IntProgression).p = function () {
		    return new IntProgressionIterator(this.o8_1, this.p8_1, this.q8_1);
		  };
		  protoOf(IntProgression).x = function () {
		    return this.q8_1 > 0 ? this.o8_1 > this.p8_1 : this.o8_1 < this.p8_1;
		  };
		  protoOf(IntProgression).equals = function (other) {
		    var tmp;
		    if (other instanceof IntProgression) {
		      tmp = (this.x() ? other.x() : false) ? true : (this.o8_1 === other.o8_1 ? this.p8_1 === other.p8_1 : false) ? this.q8_1 === other.q8_1 : false;
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(IntProgression).hashCode = function () {
		    return this.x() ? -1 : imul(31, imul(31, this.o8_1) + this.p8_1 | 0) + this.q8_1 | 0;
		  };
		  protoOf(IntProgression).toString = function () {
		    return this.q8_1 > 0 ? '' + this.o8_1 + '..' + this.p8_1 + ' step ' + this.q8_1 : '' + this.o8_1 + ' downTo ' + this.p8_1 + ' step ' + (-this.q8_1 | 0);
		  };
		  function checkStepIsPositive(isPositive, step) {
		    if (!isPositive)
		      throw IllegalArgumentException_init_$Create$_0('Step must be positive, was: ' + toString_1(step) + '.');
		  }
		  function cast(_this__u8e3s4, value) {
		    if (!_this__u8e3s4.u5(value)) {
		      // Inline function 'kotlin.reflect.qualifiedOrSimpleName' call
		      var tmp$ret$0 = _this__u8e3s4.t5();
		      throw ClassCastException_init_$Create$_0('Value cannot be cast to ' + tmp$ret$0);
		    }
		    return !(value == null) ? value : THROW_CCE();
		  }
		  function KTypeParameter() {
		  }
		  function appendElement(_this__u8e3s4, element, transform) {
		    if (!(transform == null)) {
		      _this__u8e3s4.c7(transform(element));
		    } else {
		      if (element == null ? true : isCharSequence(element)) {
		        _this__u8e3s4.c7(element);
		      } else {
		        if (element instanceof Char) {
		          _this__u8e3s4.b5(element.w8_1);
		        } else {
		          _this__u8e3s4.c7(toString_0(element));
		        }
		      }
		    }
		  }
		  function equals_1(_this__u8e3s4, other, ignoreCase) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    if (_this__u8e3s4 === other)
		      return true;
		    if (!ignoreCase)
		      return false;
		    var thisUpper = uppercaseChar(_this__u8e3s4);
		    var otherUpper = uppercaseChar(other);
		    var tmp;
		    if (thisUpper === otherUpper) {
		      tmp = true;
		    } else {
		      // Inline function 'kotlin.text.lowercaseChar' call
		      // Inline function 'kotlin.text.lowercase' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp$ret$2 = toString(thisUpper).toLowerCase();
		      var tmp_0 = charSequenceGet(tmp$ret$2, 0);
		      // Inline function 'kotlin.text.lowercaseChar' call
		      // Inline function 'kotlin.text.lowercase' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp$ret$6 = toString(otherUpper).toLowerCase();
		      tmp = tmp_0 === charSequenceGet(tmp$ret$6, 0);
		    }
		    return tmp;
		  }
		  function titlecase(_this__u8e3s4) {
		    return titlecaseImpl(_this__u8e3s4);
		  }
		  function trimIndent(_this__u8e3s4) {
		    return replaceIndent(_this__u8e3s4, '');
		  }
		  function replaceIndent(_this__u8e3s4, newIndent) {
		    newIndent = newIndent === VOID ? '' : newIndent;
		    var lines_0 = lines(_this__u8e3s4);
		    // Inline function 'kotlin.collections.map' call
		    // Inline function 'kotlin.collections.filter' call
		    // Inline function 'kotlin.collections.filterTo' call
		    var destination = ArrayList_init_$Create$();
		    var tmp0_iterator = lines_0.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'kotlin.text.isNotBlank' call
		      if (!isBlank(element)) {
		        destination.m(element);
		      }
		    }
		    // Inline function 'kotlin.collections.mapTo' call
		    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
		    var tmp0_iterator_0 = destination.p();
		    while (tmp0_iterator_0.q()) {
		      var item = tmp0_iterator_0.s();
		      var tmp$ret$3 = indentWidth(item);
		      destination_0.m(tmp$ret$3);
		    }
		    var tmp0_elvis_lhs = minOrNull(destination_0);
		    var minCommonIndent = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
		    // Inline function 'kotlin.text.reindent' call
		    var resultSizeEstimate = _this__u8e3s4.length + imul(newIndent.length, lines_0.u()) | 0;
		    var indentAddFunction = getIndentFunction(newIndent);
		    var lastIndex = get_lastIndex_2(lines_0);
		    // Inline function 'kotlin.collections.mapIndexedNotNull' call
		    // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
		    var destination_1 = ArrayList_init_$Create$();
		    // Inline function 'kotlin.collections.forEachIndexed' call
		    var index = 0;
		    var tmp0_iterator_1 = lines_0.p();
		    while (tmp0_iterator_1.q()) {
		      var item_0 = tmp0_iterator_1.s();
		      // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
		      var tmp1 = index;
		      index = tmp1 + 1 | 0;
		      // Inline function 'kotlin.text.reindent.<anonymous>' call
		      var index_0 = checkIndexOverflow(tmp1);
		      var tmp;
		      if ((index_0 === 0 ? true : index_0 === lastIndex) ? isBlank(item_0) : false) {
		        tmp = null;
		      } else {
		        // Inline function 'kotlin.text.replaceIndent.<anonymous>' call
		        var tmp0_safe_receiver = drop(item_0, minCommonIndent);
		        var tmp_0;
		        if (tmp0_safe_receiver == null) {
		          tmp_0 = null;
		        } else {
		          // Inline function 'kotlin.let' call
		          // Inline function 'kotlin.contracts.contract' call
		          tmp_0 = indentAddFunction(tmp0_safe_receiver);
		        }
		        var tmp1_elvis_lhs = tmp_0;
		        tmp = tmp1_elvis_lhs == null ? item_0 : tmp1_elvis_lhs;
		      }
		      var tmp0_safe_receiver_0 = tmp;
		      if (tmp0_safe_receiver_0 == null)
		        null;
		      else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        destination_1.m(tmp0_safe_receiver_0);
		      }
		    }
		    return joinTo_0(destination_1, StringBuilder_init_$Create$(resultSizeEstimate), '\n').toString();
		  }
		  function indentWidth(_this__u8e3s4) {
		    // Inline function 'kotlin.let' call
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlin.text.indexOfFirst' call
		      var inductionVariable = 0;
		      var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
		      if (inductionVariable <= last)
		        do {
		          var index = inductionVariable;
		          inductionVariable = inductionVariable + 1 | 0;
		          // Inline function 'kotlin.text.indentWidth.<anonymous>' call
		          var it = charSequenceGet(_this__u8e3s4, index);
		          if (!isWhitespace(it)) {
		            tmp$ret$1 = index;
		            break $l$block;
		          }
		        }
		         while (inductionVariable <= last);
		      tmp$ret$1 = -1;
		    }
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.text.indentWidth.<anonymous>' call
		    var it_0 = tmp$ret$1;
		    return it_0 === -1 ? _this__u8e3s4.length : it_0;
		  }
		  function getIndentFunction(indent) {
		    var tmp;
		    // Inline function 'kotlin.text.isEmpty' call
		    if (charSequenceLength(indent) === 0) {
		      tmp = getIndentFunction$lambda;
		    } else {
		      tmp = getIndentFunction$lambda_0(indent);
		    }
		    return tmp;
		  }
		  function getIndentFunction$lambda(line) {
		    return line;
		  }
		  function getIndentFunction$lambda_0($indent) {
		    return function (line) {
		      return $indent + line;
		    };
		  }
		  function toIntOrNull(_this__u8e3s4) {
		    return toIntOrNull_0(_this__u8e3s4, 10);
		  }
		  function toIntOrNull_0(_this__u8e3s4, radix) {
		    checkRadix(radix);
		    var length = _this__u8e3s4.length;
		    if (length === 0)
		      return null;
		    var start;
		    var isNegative;
		    var limit;
		    var firstChar = charSequenceGet(_this__u8e3s4, 0);
		    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
		      if (length === 1)
		        return null;
		      start = 1;
		      if (firstChar === _Char___init__impl__6a9atx(45)) {
		        isNegative = true;
		        limit = IntCompanionObject_instance.MIN_VALUE;
		      } else if (firstChar === _Char___init__impl__6a9atx(43)) {
		        isNegative = false;
		        limit = -IntCompanionObject_instance.MAX_VALUE | 0;
		      } else
		        return null;
		    } else {
		      start = 0;
		      isNegative = false;
		      limit = -IntCompanionObject_instance.MAX_VALUE | 0;
		    }
		    var limitForMaxRadix = (-IntCompanionObject_instance.MAX_VALUE | 0) / 36 | 0;
		    var limitBeforeMul = limitForMaxRadix;
		    var result = 0;
		    var inductionVariable = start;
		    if (inductionVariable < length)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
		        if (digit < 0)
		          return null;
		        if (result < limitBeforeMul) {
		          if (limitBeforeMul === limitForMaxRadix) {
		            limitBeforeMul = limit / radix | 0;
		            if (result < limitBeforeMul) {
		              return null;
		            }
		          } else {
		            return null;
		          }
		        }
		        result = imul(result, radix);
		        if (result < (limit + digit | 0))
		          return null;
		        result = result - digit | 0;
		      }
		       while (inductionVariable < length);
		    return isNegative ? result : -result | 0;
		  }
		  function numberFormatError(input) {
		    throw NumberFormatException_init_$Create$_0("Invalid number format: '" + input + "'");
		  }
		  function toLongOrNull(_this__u8e3s4) {
		    return toLongOrNull_0(_this__u8e3s4, 10);
		  }
		  function toLongOrNull_0(_this__u8e3s4, radix) {
		    checkRadix(radix);
		    var length = _this__u8e3s4.length;
		    if (length === 0)
		      return null;
		    var start;
		    var isNegative;
		    var limit;
		    var firstChar = charSequenceGet(_this__u8e3s4, 0);
		    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
		      if (length === 1)
		        return null;
		      start = 1;
		      if (firstChar === _Char___init__impl__6a9atx(45)) {
		        isNegative = true;
		        Companion_getInstance_4();
		        limit = new Long(0, -2147483648);
		      } else if (firstChar === _Char___init__impl__6a9atx(43)) {
		        isNegative = false;
		        Companion_getInstance_4();
		        limit = (new Long(-1, 2147483647)).u9();
		      } else
		        return null;
		    } else {
		      start = 0;
		      isNegative = false;
		      Companion_getInstance_4();
		      limit = (new Long(-1, 2147483647)).u9();
		    }
		    // Inline function 'kotlin.Long.div' call
		    Companion_getInstance_4();
		    var limitForMaxRadix = (new Long(-1, 2147483647)).u9().k8(toLong_0(36));
		    var limitBeforeMul = limitForMaxRadix;
		    var result = new Long(0, 0);
		    var inductionVariable = start;
		    if (inductionVariable < length)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
		        if (digit < 0)
		          return null;
		        if (result.m8(limitBeforeMul) < 0) {
		          if (limitBeforeMul.equals(limitForMaxRadix)) {
		            // Inline function 'kotlin.Long.div' call
		            limitBeforeMul = limit.k8(toLong_0(radix));
		            if (result.m8(limitBeforeMul) < 0) {
		              return null;
		            }
		          } else {
		            return null;
		          }
		        }
		        // Inline function 'kotlin.Long.times' call
		        result = result.l8(toLong_0(radix));
		        var tmp = result;
		        // Inline function 'kotlin.Long.plus' call
		        var tmp$ret$3 = limit.r9(toLong_0(digit));
		        if (tmp.m8(tmp$ret$3) < 0)
		          return null;
		        // Inline function 'kotlin.Long.minus' call
		        result = result.s9(toLong_0(digit));
		      }
		       while (inductionVariable < length);
		    return isNegative ? result : result.u9();
		  }
		  function get_lastIndex_3(_this__u8e3s4) {
		    return charSequenceLength(_this__u8e3s4) - 1 | 0;
		  }
		  function padStart(_this__u8e3s4, length, padChar) {
		    padChar = padChar === VOID ? _Char___init__impl__6a9atx(32) : padChar;
		    return toString_1(padStart_0(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE(), length, padChar));
		  }
		  function startsWith_0(_this__u8e3s4, char, ignoreCase) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    return charSequenceLength(_this__u8e3s4) > 0 ? equals_1(charSequenceGet(_this__u8e3s4, 0), char, ignoreCase) : false;
		  }
		  function contains_4(_this__u8e3s4, char, ignoreCase) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    return indexOf_4(_this__u8e3s4, char, VOID, ignoreCase) >= 0;
		  }
		  function indexOf_4(_this__u8e3s4, char, startIndex, ignoreCase) {
		    startIndex = startIndex === VOID ? 0 : startIndex;
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    var tmp;
		    var tmp_0;
		    if (ignoreCase) {
		      tmp_0 = true;
		    } else {
		      tmp_0 = !(typeof _this__u8e3s4 === 'string');
		    }
		    if (tmp_0) {
		      // Inline function 'kotlin.charArrayOf' call
		      var tmp$ret$0 = charArrayOf([char]);
		      tmp = indexOfAny(_this__u8e3s4, tmp$ret$0, startIndex, ignoreCase);
		    } else {
		      // Inline function 'kotlin.text.nativeIndexOf' call
		      // Inline function 'kotlin.text.nativeIndexOf' call
		      var str = toString(char);
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = _this__u8e3s4.indexOf(str, startIndex);
		    }
		    return tmp;
		  }
		  function padStart_0(_this__u8e3s4, length, padChar) {
		    padChar = padChar === VOID ? _Char___init__impl__6a9atx(32) : padChar;
		    if (length < 0)
		      throw IllegalArgumentException_init_$Create$_0('Desired length ' + length + ' is less than zero.');
		    if (length <= charSequenceLength(_this__u8e3s4))
		      return charSequenceSubSequence(_this__u8e3s4, 0, charSequenceLength(_this__u8e3s4));
		    var sb = StringBuilder_init_$Create$(length);
		    var inductionVariable = 1;
		    var last = length - charSequenceLength(_this__u8e3s4) | 0;
		    if (inductionVariable <= last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        sb.b5(padChar);
		      }
		       while (!(i === last));
		    sb.c7(_this__u8e3s4);
		    return sb;
		  }
		  function indexOfAny(_this__u8e3s4, chars, startIndex, ignoreCase) {
		    startIndex = startIndex === VOID ? 0 : startIndex;
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    var tmp;
		    if (!ignoreCase ? chars.length === 1 : false) {
		      tmp = typeof _this__u8e3s4 === 'string';
		    } else {
		      tmp = false;
		    }
		    if (tmp) {
		      var char = single(chars);
		      // Inline function 'kotlin.text.nativeIndexOf' call
		      // Inline function 'kotlin.text.nativeIndexOf' call
		      var str = toString(char);
		      // Inline function 'kotlin.js.asDynamic' call
		      return _this__u8e3s4.indexOf(str, startIndex);
		    }
		    var inductionVariable = coerceAtLeast(startIndex, 0);
		    var last = get_lastIndex_3(_this__u8e3s4);
		    if (inductionVariable <= last)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var charAtIndex = charSequenceGet(_this__u8e3s4, index);
		        var tmp$ret$4;
		        $l$block: {
		          // Inline function 'kotlin.collections.any' call
		          var inductionVariable_0 = 0;
		          var last_0 = chars.length;
		          while (inductionVariable_0 < last_0) {
		            var element = chars[inductionVariable_0];
		            inductionVariable_0 = inductionVariable_0 + 1 | 0;
		            // Inline function 'kotlin.text.indexOfAny.<anonymous>' call
		            if (equals_1(element, charAtIndex, ignoreCase)) {
		              tmp$ret$4 = true;
		              break $l$block;
		            }
		          }
		          tmp$ret$4 = false;
		        }
		        if (tmp$ret$4)
		          return index;
		      }
		       while (!(index === last));
		    return -1;
		  }
		  function get_indices_1(_this__u8e3s4) {
		    return numberRangeToNumber(0, charSequenceLength(_this__u8e3s4) - 1 | 0);
		  }
		  function regionMatchesImpl(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase) {
		    if (((otherOffset < 0 ? true : thisOffset < 0) ? true : thisOffset > (charSequenceLength(_this__u8e3s4) - length | 0)) ? true : otherOffset > (charSequenceLength(other) - length | 0)) {
		      return false;
		    }
		    var inductionVariable = 0;
		    if (inductionVariable < length)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (!equals_1(charSequenceGet(_this__u8e3s4, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase))
		          return false;
		      }
		       while (inductionVariable < length);
		    return true;
		  }
		  function lastIndexOf(_this__u8e3s4, string, startIndex, ignoreCase) {
		    startIndex = startIndex === VOID ? get_lastIndex_3(_this__u8e3s4) : startIndex;
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    var tmp;
		    var tmp_0;
		    if (ignoreCase) {
		      tmp_0 = true;
		    } else {
		      tmp_0 = !(typeof _this__u8e3s4 === 'string');
		    }
		    if (tmp_0) {
		      tmp = indexOf_5(_this__u8e3s4, string, startIndex, 0, ignoreCase, true);
		    } else {
		      // Inline function 'kotlin.text.nativeLastIndexOf' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = _this__u8e3s4.lastIndexOf(string, startIndex);
		    }
		    return tmp;
		  }
		  function removePrefix(_this__u8e3s4, prefix) {
		    if (startsWith_1(_this__u8e3s4, prefix)) {
		      // Inline function 'kotlin.text.substring' call
		      var startIndex = charSequenceLength(prefix);
		      // Inline function 'kotlin.js.asDynamic' call
		      return _this__u8e3s4.substring(startIndex);
		    }
		    return _this__u8e3s4;
		  }
		  function substringAfter(_this__u8e3s4, delimiter, missingDelimiterValue) {
		    missingDelimiterValue = missingDelimiterValue === VOID ? _this__u8e3s4 : missingDelimiterValue;
		    var index = indexOf_6(_this__u8e3s4, delimiter);
		    var tmp;
		    if (index === -1) {
		      tmp = missingDelimiterValue;
		    } else {
		      // Inline function 'kotlin.text.substring' call
		      var startIndex = index + delimiter.length | 0;
		      var endIndex = _this__u8e3s4.length;
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = _this__u8e3s4.substring(startIndex, endIndex);
		    }
		    return tmp;
		  }
		  function split(_this__u8e3s4, delimiters, ignoreCase, limit) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    limit = limit === VOID ? 0 : limit;
		    if (delimiters.length === 1) {
		      var delimiter = delimiters[0];
		      // Inline function 'kotlin.text.isEmpty' call
		      if (!(charSequenceLength(delimiter) === 0)) {
		        return split_0(_this__u8e3s4, delimiter, ignoreCase, limit);
		      }
		    }
		    // Inline function 'kotlin.collections.map' call
		    var this_0 = asIterable(rangesDelimitedBy(_this__u8e3s4, delimiters, VOID, ignoreCase, limit));
		    // Inline function 'kotlin.collections.mapTo' call
		    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
		    var tmp0_iterator = this_0.p();
		    while (tmp0_iterator.q()) {
		      var item = tmp0_iterator.s();
		      // Inline function 'kotlin.text.split.<anonymous>' call
		      var tmp$ret$1 = substring_0(_this__u8e3s4, item);
		      destination.m(tmp$ret$1);
		    }
		    return destination;
		  }
		  function substring(_this__u8e3s4, range) {
		    // Inline function 'kotlin.text.substring' call
		    var startIndex = range.oc();
		    var endIndex = range.pc() + 1 | 0;
		    // Inline function 'kotlin.js.asDynamic' call
		    return _this__u8e3s4.substring(startIndex, endIndex);
		  }
		  function indexOf_5(_this__u8e3s4, other, startIndex, endIndex, ignoreCase, last) {
		    last = last === VOID ? false : last;
		    var indices = !last ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this__u8e3s4))) : downTo(coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4)), coerceAtLeast(endIndex, 0));
		    var tmp;
		    if (typeof _this__u8e3s4 === 'string') {
		      tmp = typeof other === 'string';
		    } else {
		      tmp = false;
		    }
		    if (tmp) {
		      var inductionVariable = indices.o8_1;
		      var last_0 = indices.p8_1;
		      var step = indices.q8_1;
		      if ((step > 0 ? inductionVariable <= last_0 : false) ? true : step < 0 ? last_0 <= inductionVariable : false)
		        do {
		          var index = inductionVariable;
		          inductionVariable = inductionVariable + step | 0;
		          if (regionMatches(other, 0, _this__u8e3s4, index, charSequenceLength(other), ignoreCase))
		            return index;
		        }
		         while (!(index === last_0));
		    } else {
		      var inductionVariable_0 = indices.o8_1;
		      var last_1 = indices.p8_1;
		      var step_0 = indices.q8_1;
		      if ((step_0 > 0 ? inductionVariable_0 <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable_0 : false)
		        do {
		          var index_0 = inductionVariable_0;
		          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
		          if (regionMatchesImpl(other, 0, _this__u8e3s4, index_0, charSequenceLength(other), ignoreCase))
		            return index_0;
		        }
		         while (!(index_0 === last_1));
		    }
		    return -1;
		  }
		  function startsWith_1(_this__u8e3s4, prefix, ignoreCase) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    var tmp;
		    var tmp_0;
		    if (!ignoreCase) {
		      tmp_0 = typeof _this__u8e3s4 === 'string';
		    } else {
		      tmp_0 = false;
		    }
		    if (tmp_0) {
		      tmp = typeof prefix === 'string';
		    } else {
		      tmp = false;
		    }
		    if (tmp)
		      return startsWith(_this__u8e3s4, prefix);
		    else {
		      return regionMatchesImpl(_this__u8e3s4, 0, prefix, 0, charSequenceLength(prefix), ignoreCase);
		    }
		  }
		  function indexOf_6(_this__u8e3s4, string, startIndex, ignoreCase) {
		    startIndex = startIndex === VOID ? 0 : startIndex;
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    var tmp;
		    var tmp_0;
		    if (ignoreCase) {
		      tmp_0 = true;
		    } else {
		      tmp_0 = !(typeof _this__u8e3s4 === 'string');
		    }
		    if (tmp_0) {
		      tmp = indexOf_5(_this__u8e3s4, string, startIndex, charSequenceLength(_this__u8e3s4), ignoreCase);
		    } else {
		      // Inline function 'kotlin.text.nativeIndexOf' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = _this__u8e3s4.indexOf(string, startIndex);
		    }
		    return tmp;
		  }
		  function split_0(_this__u8e3s4, delimiter, ignoreCase, limit) {
		    requireNonNegativeLimit(limit);
		    var currentOffset = 0;
		    var nextIndex = indexOf_6(_this__u8e3s4, delimiter, currentOffset, ignoreCase);
		    if (nextIndex === -1 ? true : limit === 1) {
		      return listOf(toString_1(_this__u8e3s4));
		    }
		    var isLimited = limit > 0;
		    var result = ArrayList_init_$Create$_0(isLimited ? coerceAtMost(limit, 10) : 10);
		    $l$loop: do {
		      // Inline function 'kotlin.text.substring' call
		      var startIndex = currentOffset;
		      var endIndex = nextIndex;
		      var tmp$ret$0 = toString_1(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex));
		      result.m(tmp$ret$0);
		      currentOffset = nextIndex + delimiter.length | 0;
		      if (isLimited ? result.u() === (limit - 1 | 0) : false)
		        break $l$loop;
		      nextIndex = indexOf_6(_this__u8e3s4, delimiter, currentOffset, ignoreCase);
		    }
		     while (!(nextIndex === -1));
		    // Inline function 'kotlin.text.substring' call
		    var startIndex_0 = currentOffset;
		    var endIndex_0 = charSequenceLength(_this__u8e3s4);
		    var tmp$ret$1 = toString_1(charSequenceSubSequence(_this__u8e3s4, startIndex_0, endIndex_0));
		    result.m(tmp$ret$1);
		    return result;
		  }
		  function substring_0(_this__u8e3s4, range) {
		    return toString_1(charSequenceSubSequence(_this__u8e3s4, range.oc(), range.pc() + 1 | 0));
		  }
		  function rangesDelimitedBy(_this__u8e3s4, delimiters, startIndex, ignoreCase, limit) {
		    startIndex = startIndex === VOID ? 0 : startIndex;
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    limit = limit === VOID ? 0 : limit;
		    requireNonNegativeLimit(limit);
		    var delimitersList = asList(delimiters);
		    return new DelimitedRangesSequence(_this__u8e3s4, startIndex, limit, rangesDelimitedBy$lambda(delimitersList, ignoreCase));
		  }
		  function requireNonNegativeLimit(limit) {
		    // Inline function 'kotlin.contracts.contract' call
		    var tmp;
		    if (!(limit >= 0)) {
		      // Inline function 'kotlin.text.requireNonNegativeLimit.<anonymous>' call
		      var message = 'Limit must be non-negative, but was ' + limit;
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    return tmp;
		  }
		  function calcNext($this) {
		    if ($this.wc_1 < 0) {
		      $this.uc_1 = 0;
		      $this.xc_1 = null;
		    } else {
		      var tmp;
		      var tmp_0;
		      if ($this.zc_1.cd_1 > 0) {
		        $this.yc_1 = $this.yc_1 + 1 | 0;
		        tmp_0 = $this.yc_1 >= $this.zc_1.cd_1;
		      } else {
		        tmp_0 = false;
		      }
		      if (tmp_0) {
		        tmp = true;
		      } else {
		        tmp = $this.wc_1 > charSequenceLength($this.zc_1.ad_1);
		      }
		      if (tmp) {
		        $this.xc_1 = numberRangeToNumber($this.vc_1, get_lastIndex_3($this.zc_1.ad_1));
		        $this.wc_1 = -1;
		      } else {
		        var match = $this.zc_1.dd_1($this.zc_1.ad_1, $this.wc_1);
		        if (match == null) {
		          $this.xc_1 = numberRangeToNumber($this.vc_1, get_lastIndex_3($this.zc_1.ad_1));
		          $this.wc_1 = -1;
		        } else {
		          var index = match.o5();
		          var length = match.p5();
		          $this.xc_1 = until($this.vc_1, index);
		          $this.vc_1 = index + length | 0;
		          $this.wc_1 = $this.vc_1 + (length === 0 ? 1 : 0) | 0;
		        }
		      }
		      $this.uc_1 = 1;
		    }
		  }
		  function DelimitedRangesSequence$iterator$1(this$0) {
		    this.zc_1 = this$0;
		    this.uc_1 = -1;
		    this.vc_1 = coerceIn_0(this$0.bd_1, 0, charSequenceLength(this$0.ad_1));
		    this.wc_1 = this.vc_1;
		    this.xc_1 = null;
		    this.yc_1 = 0;
		  }
		  protoOf(DelimitedRangesSequence$iterator$1).s = function () {
		    if (this.uc_1 === -1) {
		      calcNext(this);
		    }
		    if (this.uc_1 === 0)
		      throw NoSuchElementException_init_$Create$();
		    var tmp = this.xc_1;
		    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
		    this.xc_1 = null;
		    this.uc_1 = -1;
		    return result;
		  };
		  protoOf(DelimitedRangesSequence$iterator$1).q = function () {
		    if (this.uc_1 === -1) {
		      calcNext(this);
		    }
		    return this.uc_1 === 1;
		  };
		  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
		    this.ad_1 = input;
		    this.bd_1 = startIndex;
		    this.cd_1 = limit;
		    this.dd_1 = getNextMatch;
		  }
		  protoOf(DelimitedRangesSequence).p = function () {
		    return new DelimitedRangesSequence$iterator$1(this);
		  };
		  function findAnyOf(_this__u8e3s4, strings, startIndex, ignoreCase, last) {
		    if (!ignoreCase ? strings.u() === 1 : false) {
		      var string = single_0(strings);
		      var index = !last ? indexOf_6(_this__u8e3s4, string, startIndex) : lastIndexOf(_this__u8e3s4, string, startIndex);
		      return index < 0 ? null : to(index, string);
		    }
		    var indices = !last ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this__u8e3s4)) : downTo(coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4)), 0);
		    if (typeof _this__u8e3s4 === 'string') {
		      var inductionVariable = indices.o8_1;
		      var last_0 = indices.p8_1;
		      var step = indices.q8_1;
		      if ((step > 0 ? inductionVariable <= last_0 : false) ? true : step < 0 ? last_0 <= inductionVariable : false)
		        do {
		          var index_0 = inductionVariable;
		          inductionVariable = inductionVariable + step | 0;
		          var tmp$ret$1;
		          $l$block: {
		            // Inline function 'kotlin.collections.firstOrNull' call
		            var tmp0_iterator = strings.p();
		            while (tmp0_iterator.q()) {
		              var element = tmp0_iterator.s();
		              // Inline function 'kotlin.text.findAnyOf.<anonymous>' call
		              if (regionMatches(element, 0, _this__u8e3s4, index_0, element.length, ignoreCase)) {
		                tmp$ret$1 = element;
		                break $l$block;
		              }
		            }
		            tmp$ret$1 = null;
		          }
		          var matchingString = tmp$ret$1;
		          if (!(matchingString == null))
		            return to(index_0, matchingString);
		        }
		         while (!(index_0 === last_0));
		    } else {
		      var inductionVariable_0 = indices.o8_1;
		      var last_1 = indices.p8_1;
		      var step_0 = indices.q8_1;
		      if ((step_0 > 0 ? inductionVariable_0 <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable_0 : false)
		        do {
		          var index_1 = inductionVariable_0;
		          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
		          var tmp$ret$3;
		          $l$block_0: {
		            // Inline function 'kotlin.collections.firstOrNull' call
		            var tmp0_iterator_0 = strings.p();
		            while (tmp0_iterator_0.q()) {
		              var element_0 = tmp0_iterator_0.s();
		              // Inline function 'kotlin.text.findAnyOf.<anonymous>' call
		              if (regionMatchesImpl(element_0, 0, _this__u8e3s4, index_1, element_0.length, ignoreCase)) {
		                tmp$ret$3 = element_0;
		                break $l$block_0;
		              }
		            }
		            tmp$ret$3 = null;
		          }
		          var matchingString_0 = tmp$ret$3;
		          if (!(matchingString_0 == null))
		            return to(index_1, matchingString_0);
		        }
		         while (!(index_1 === last_1));
		    }
		    return null;
		  }
		  function lines(_this__u8e3s4) {
		    return toList_1(lineSequence(_this__u8e3s4));
		  }
		  function lineSequence(_this__u8e3s4) {
		    return splitToSequence(_this__u8e3s4, ['\r\n', '\n', '\r']);
		  }
		  function splitToSequence(_this__u8e3s4, delimiters, ignoreCase, limit) {
		    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
		    limit = limit === VOID ? 0 : limit;
		    var tmp = rangesDelimitedBy(_this__u8e3s4, delimiters, VOID, ignoreCase, limit);
		    return map(tmp, splitToSequence$lambda(_this__u8e3s4));
		  }
		  function rangesDelimitedBy$lambda($delimitersList, $ignoreCase) {
		    return function ($this$$receiver, currentIndex) {
		      var tmp0_safe_receiver = findAnyOf($this$$receiver, $delimitersList, currentIndex, $ignoreCase, false);
		      var tmp;
		      if (tmp0_safe_receiver == null) {
		        tmp = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'kotlin.text.rangesDelimitedBy.<anonymous>.<anonymous>' call
		        tmp = to(tmp0_safe_receiver.m5_1, tmp0_safe_receiver.n5_1.length);
		      }
		      return tmp;
		    };
		  }
		  function splitToSequence$lambda($this_splitToSequence) {
		    return function (it) {
		      return substring_0($this_splitToSequence, it);
		    };
		  }
		  function _Duration___init__impl__kdtzql(rawValue) {
		    // Inline function 'kotlin.time.durationAssertionsEnabled' call
		    if (true) {
		      if (isInNanos(rawValue)) {
		        var containsArg = _get_value__a43j40_0(rawValue);
		        if (!((new Long(387905, -1073741824)).m8(containsArg) <= 0 ? containsArg.m8(new Long(-387905, 1073741823)) <= 0 : false))
		          throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + ' ns is out of nanoseconds range');
		      } else {
		        var containsArg_0 = _get_value__a43j40_0(rawValue);
		        if (!((new Long(1, -1073741824)).m8(containsArg_0) <= 0 ? containsArg_0.m8(new Long(-1, 1073741823)) <= 0 : false))
		          throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + ' ms is out of milliseconds range');
		        var containsArg_1 = _get_value__a43j40_0(rawValue);
		        if ((new Long(1108857478, -1074)).m8(containsArg_1) <= 0 ? containsArg_1.m8(new Long(-1108857478, 1073)) <= 0 : false)
		          throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + ' ms is denormalized');
		      }
		    }
		    return rawValue;
		  }
		  function _get_rawValue__5zfu4e($this) {
		    return $this;
		  }
		  function _get_value__a43j40_0($this) {
		    return _get_rawValue__5zfu4e($this).x9(1);
		  }
		  function isInNanos($this) {
		    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
		    return (_get_rawValue__5zfu4e($this).ea() & 1) === 0;
		  }
		  function isInMillis($this) {
		    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
		    return (_get_rawValue__5zfu4e($this).ea() & 1) === 1;
		  }
		  function _get_storageUnit__szjgha($this) {
		    return isInNanos($this) ? DurationUnit_NANOSECONDS_getInstance() : DurationUnit_MILLISECONDS_getInstance();
		  }
		  function Companion_11() {
		    Companion_instance_11 = this;
		    this.ed_1 = _Duration___init__impl__kdtzql(new Long(0, 0));
		    this.fd_1 = durationOfMillis(new Long(-1, 1073741823));
		    this.gd_1 = durationOfMillis(new Long(1, -1073741824));
		  }
		  protoOf(Companion_11).hd = function (value) {
		    var tmp;
		    try {
		      tmp = parseDuration(value, true);
		    } catch ($p) {
		      var tmp_0;
		      if ($p instanceof IllegalArgumentException) {
		        var e = $p;
		        throw IllegalArgumentException_init_$Create$_1("Invalid ISO duration string format: '" + value + "'.", e);
		      } else {
		        throw $p;
		      }
		    }
		    return tmp;
		  };
		  var Companion_instance_11;
		  function Companion_getInstance_11() {
		    if (Companion_instance_11 == null)
		      new Companion_11();
		    return Companion_instance_11;
		  }
		  function Duration__unaryMinus_impl_x2k1y0($this) {
		    var tmp = _get_value__a43j40_0($this).u9();
		    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
		    var tmp$ret$0 = _get_rawValue__5zfu4e($this).ea() & 1;
		    return durationOf(tmp, tmp$ret$0);
		  }
		  function Duration__plus_impl_yu9v8f($this, other) {
		    if (Duration__isInfinite_impl_tsn9y3($this)) {
		      if (Duration__isFinite_impl_rzjsps(other) ? true : _get_rawValue__5zfu4e($this).ba(_get_rawValue__5zfu4e(other)).m8(new Long(0, 0)) >= 0)
		        return $this;
		      else
		        throw IllegalArgumentException_init_$Create$_0('Summing infinite durations of different signs yields an undefined result.');
		    } else if (Duration__isInfinite_impl_tsn9y3(other))
		      return other;
		    var tmp;
		    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
		    var tmp_0 = _get_rawValue__5zfu4e($this).ea() & 1;
		    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
		    if (tmp_0 === (_get_rawValue__5zfu4e(other).ea() & 1)) {
		      var result = _get_value__a43j40_0($this).r9(_get_value__a43j40_0(other));
		      tmp = isInNanos($this) ? durationOfNanosNormalized(result) : durationOfMillisNormalized(result);
		    } else {
		      if (isInMillis($this)) {
		        tmp = addValuesMixedRanges($this, _get_value__a43j40_0($this), _get_value__a43j40_0(other));
		      } else {
		        tmp = addValuesMixedRanges($this, _get_value__a43j40_0(other), _get_value__a43j40_0($this));
		      }
		    }
		    return tmp;
		  }
		  function addValuesMixedRanges($this, thisMillis, otherNanos) {
		    var otherMillis = nanosToMillis(otherNanos);
		    var resultMillis = thisMillis.r9(otherMillis);
		    var tmp;
		    if ((new Long(1108857478, -1074)).m8(resultMillis) <= 0 ? resultMillis.m8(new Long(-1108857478, 1073)) <= 0 : false) {
		      var otherNanoRemainder = otherNanos.s9(millisToNanos(otherMillis));
		      tmp = durationOfNanos(millisToNanos(resultMillis).r9(otherNanoRemainder));
		    } else {
		      tmp = durationOfMillis(coerceIn(resultMillis, new Long(1, -1073741824), new Long(-1, 1073741823)));
		    }
		    return tmp;
		  }
		  function Duration__isNegative_impl_pbysfa($this) {
		    return _get_rawValue__5zfu4e($this).m8(new Long(0, 0)) < 0;
		  }
		  function Duration__isInfinite_impl_tsn9y3($this) {
		    return _get_rawValue__5zfu4e($this).equals(_get_rawValue__5zfu4e(Companion_getInstance_11().fd_1)) ? true : _get_rawValue__5zfu4e($this).equals(_get_rawValue__5zfu4e(Companion_getInstance_11().gd_1));
		  }
		  function Duration__isFinite_impl_rzjsps($this) {
		    return !Duration__isInfinite_impl_tsn9y3($this);
		  }
		  function _Duration___get_absoluteValue__impl__vr7i6w($this) {
		    return Duration__isNegative_impl_pbysfa($this) ? Duration__unaryMinus_impl_x2k1y0($this) : $this;
		  }
		  function Duration__compareTo_impl_pchp0f($this, other) {
		    var compareBits = _get_rawValue__5zfu4e($this).ba(_get_rawValue__5zfu4e(other));
		    if (compareBits.m8(new Long(0, 0)) < 0 ? true : (compareBits.ea() & 1) === 0)
		      return _get_rawValue__5zfu4e($this).m8(_get_rawValue__5zfu4e(other));
		    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
		    var tmp = _get_rawValue__5zfu4e($this).ea() & 1;
		    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
		    var r = tmp - (_get_rawValue__5zfu4e(other).ea() & 1) | 0;
		    return Duration__isNegative_impl_pbysfa($this) ? -r | 0 : r;
		  }
		  function Duration__compareTo_impl_pchp0f_0($this, other) {
		    return Duration__compareTo_impl_pchp0f($this.id_1, other instanceof Duration ? other.id_1 : THROW_CCE());
		  }
		  function _Duration___get_hoursComponent__impl__7hllxa($this) {
		    var tmp;
		    if (Duration__isInfinite_impl_tsn9y3($this)) {
		      tmp = 0;
		    } else {
		      // Inline function 'kotlin.Long.rem' call
		      tmp = _Duration___get_inWholeHours__impl__kb9f3j($this).t9(toLong_0(24)).ea();
		    }
		    return tmp;
		  }
		  function _Duration___get_minutesComponent__impl__ctvd8u($this) {
		    var tmp;
		    if (Duration__isInfinite_impl_tsn9y3($this)) {
		      tmp = 0;
		    } else {
		      // Inline function 'kotlin.Long.rem' call
		      tmp = _Duration___get_inWholeMinutes__impl__dognoh($this).t9(toLong_0(60)).ea();
		    }
		    return tmp;
		  }
		  function _Duration___get_secondsComponent__impl__if34a6($this) {
		    var tmp;
		    if (Duration__isInfinite_impl_tsn9y3($this)) {
		      tmp = 0;
		    } else {
		      // Inline function 'kotlin.Long.rem' call
		      tmp = _Duration___get_inWholeSeconds__impl__hpy7b3($this).t9(toLong_0(60)).ea();
		    }
		    return tmp;
		  }
		  function _Duration___get_nanosecondsComponent__impl__nh19kq($this) {
		    var tmp;
		    if (Duration__isInfinite_impl_tsn9y3($this)) {
		      tmp = 0;
		    } else if (isInMillis($this)) {
		      // Inline function 'kotlin.Long.rem' call
		      var tmp$ret$0 = _get_value__a43j40_0($this).t9(toLong_0(1000));
		      tmp = millisToNanos(tmp$ret$0).ea();
		    } else {
		      // Inline function 'kotlin.Long.rem' call
		      var this_0 = _get_value__a43j40_0($this);
		      var other = 1000000000;
		      tmp = this_0.t9(toLong_0(other)).ea();
		    }
		    return tmp;
		  }
		  function Duration__toLong_impl_shr43i($this, unit) {
		    var tmp0_subject = _get_rawValue__5zfu4e($this);
		    var tmp;
		    if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_11().fd_1))) {
		      Companion_getInstance_4();
		      tmp = new Long(-1, 2147483647);
		    } else if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_11().gd_1))) {
		      Companion_getInstance_4();
		      tmp = new Long(0, -2147483648);
		    } else {
		      tmp = convertDurationUnit_0(_get_value__a43j40_0($this), _get_storageUnit__szjgha($this), unit);
		    }
		    return tmp;
		  }
		  function _Duration___get_inWholeDays__impl__7bvpxz($this) {
		    return Duration__toLong_impl_shr43i($this, DurationUnit_DAYS_getInstance());
		  }
		  function _Duration___get_inWholeHours__impl__kb9f3j($this) {
		    return Duration__toLong_impl_shr43i($this, DurationUnit_HOURS_getInstance());
		  }
		  function _Duration___get_inWholeMinutes__impl__dognoh($this) {
		    return Duration__toLong_impl_shr43i($this, DurationUnit_MINUTES_getInstance());
		  }
		  function _Duration___get_inWholeSeconds__impl__hpy7b3($this) {
		    return Duration__toLong_impl_shr43i($this, DurationUnit_SECONDS_getInstance());
		  }
		  function Duration__toString_impl_8d916b($this) {
		    var tmp0_subject = _get_rawValue__5zfu4e($this);
		    var tmp;
		    if (tmp0_subject.equals(new Long(0, 0))) {
		      tmp = '0s';
		    } else if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_11().fd_1))) {
		      tmp = 'Infinity';
		    } else if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_11().gd_1))) {
		      tmp = '-Infinity';
		    } else {
		      var isNegative = Duration__isNegative_impl_pbysfa($this);
		      // Inline function 'kotlin.text.buildString' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.apply' call
		      var this_0 = StringBuilder_init_$Create$_0();
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.time.Duration.toString.<anonymous>' call
		      if (isNegative) {
		        this_0.b5(_Char___init__impl__6a9atx(45));
		      }
		      // Inline function 'kotlin.time.Duration.toComponents' call
		      var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
		      // Inline function 'kotlin.contracts.contract' call
		      var days = _Duration___get_inWholeDays__impl__7bvpxz(this_1);
		      var hours = _Duration___get_hoursComponent__impl__7hllxa(this_1);
		      var minutes = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
		      var seconds = _Duration___get_secondsComponent__impl__if34a6(this_1);
		      var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
		      var hasDays = !days.equals(new Long(0, 0));
		      var hasHours = !(hours === 0);
		      var hasMinutes = !(minutes === 0);
		      var hasSeconds = !(seconds === 0) ? true : !(nanoseconds === 0);
		      var components = 0;
		      if (hasDays) {
		        this_0.g7(days).b5(_Char___init__impl__6a9atx(100));
		        components = components + 1 | 0;
		      }
		      if (hasHours ? true : hasDays ? hasMinutes ? true : hasSeconds : false) {
		        var tmp1 = components;
		        components = tmp1 + 1 | 0;
		        if (tmp1 > 0) {
		          this_0.b5(_Char___init__impl__6a9atx(32));
		        }
		        this_0.f7(hours).b5(_Char___init__impl__6a9atx(104));
		      }
		      if (hasMinutes ? true : hasSeconds ? hasHours ? true : hasDays : false) {
		        var tmp2 = components;
		        components = tmp2 + 1 | 0;
		        if (tmp2 > 0) {
		          this_0.b5(_Char___init__impl__6a9atx(32));
		        }
		        this_0.f7(minutes).b5(_Char___init__impl__6a9atx(109));
		      }
		      if (hasSeconds) {
		        var tmp3 = components;
		        components = tmp3 + 1 | 0;
		        if (tmp3 > 0) {
		          this_0.b5(_Char___init__impl__6a9atx(32));
		        }
		        if (((!(seconds === 0) ? true : hasDays) ? true : hasHours) ? true : hasMinutes) {
		          appendFractional(this_0, $this, seconds, nanoseconds, 9, 's', false);
		        } else if (nanoseconds >= 1000000) {
		          appendFractional(this_0, $this, nanoseconds / 1000000 | 0, nanoseconds % 1000000 | 0, 6, 'ms', false);
		        } else if (nanoseconds >= 1000) {
		          appendFractional(this_0, $this, nanoseconds / 1000 | 0, nanoseconds % 1000 | 0, 3, 'us', false);
		        } else {
		          this_0.f7(nanoseconds).a5('ns');
		        }
		      }
		      var tmp_0;
		      if (isNegative ? components > 1 : false) {
		        this_0.h7(1, _Char___init__impl__6a9atx(40)).b5(_Char___init__impl__6a9atx(41));
		        tmp_0 = Unit_instance;
		      }
		      tmp = this_0.toString();
		    }
		    return tmp;
		  }
		  function appendFractional(_this__u8e3s4, $this, whole, fractional, fractionalSize, unit, isoZeroes) {
		    _this__u8e3s4.f7(whole);
		    if (!(fractional === 0)) {
		      _this__u8e3s4.b5(_Char___init__impl__6a9atx(46));
		      var fracString = padStart(fractional.toString(), fractionalSize, _Char___init__impl__6a9atx(48));
		      var tmp$ret$1;
		      $l$block: {
		        // Inline function 'kotlin.text.indexOfLast' call
		        var inductionVariable = charSequenceLength(fracString) - 1 | 0;
		        if (0 <= inductionVariable)
		          do {
		            var index = inductionVariable;
		            inductionVariable = inductionVariable + -1 | 0;
		            // Inline function 'kotlin.time.Duration.appendFractional.<anonymous>' call
		            if (!(charSequenceGet(fracString, index) === _Char___init__impl__6a9atx(48))) {
		              tmp$ret$1 = index;
		              break $l$block;
		            }
		          }
		           while (0 <= inductionVariable);
		        tmp$ret$1 = -1;
		      }
		      var nonZeroDigits = tmp$ret$1 + 1 | 0;
		      if (!isoZeroes ? nonZeroDigits < 3 : false) {
		        _this__u8e3s4.e7(fracString, 0, nonZeroDigits);
		      } else {
		        _this__u8e3s4.e7(fracString, 0, imul((nonZeroDigits + 2 | 0) / 3 | 0, 3));
		      }
		    }
		    _this__u8e3s4.a5(unit);
		  }
		  function Duration__toIsoString_impl_9h6wsm($this) {
		    // Inline function 'kotlin.text.buildString' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.apply' call
		    var this_0 = StringBuilder_init_$Create$_0();
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.time.Duration.toIsoString.<anonymous>' call
		    if (Duration__isNegative_impl_pbysfa($this)) {
		      this_0.b5(_Char___init__impl__6a9atx(45));
		    }
		    this_0.a5('PT');
		    // Inline function 'kotlin.time.Duration.toComponents' call
		    var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
		    // Inline function 'kotlin.contracts.contract' call
		    var hours = _Duration___get_inWholeHours__impl__kb9f3j(this_1);
		    var minutes = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
		    var seconds = _Duration___get_secondsComponent__impl__if34a6(this_1);
		    var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
		    var hours_0 = hours;
		    if (Duration__isInfinite_impl_tsn9y3($this)) {
		      hours_0 = new Long(1316134911, 2328);
		    }
		    var hasHours = !hours_0.equals(new Long(0, 0));
		    var hasSeconds = !(seconds === 0) ? true : !(nanoseconds === 0);
		    var hasMinutes = !(minutes === 0) ? true : hasSeconds ? hasHours : false;
		    if (hasHours) {
		      this_0.g7(hours_0).b5(_Char___init__impl__6a9atx(72));
		    }
		    if (hasMinutes) {
		      this_0.f7(minutes).b5(_Char___init__impl__6a9atx(77));
		    }
		    var tmp;
		    if (hasSeconds ? true : !hasHours ? !hasMinutes : false) {
		      appendFractional(this_0, $this, seconds, nanoseconds, 9, 'S', true);
		      tmp = Unit_instance;
		    }
		    return this_0.toString();
		  }
		  function Duration__hashCode_impl_u4exz6($this) {
		    return $this.hashCode();
		  }
		  function Duration__equals_impl_ygj6w6($this, other) {
		    if (!(other instanceof Duration))
		      return false;
		    var tmp0_other_with_cast = other instanceof Duration ? other.id_1 : THROW_CCE();
		    if (!$this.equals(tmp0_other_with_cast))
		      return false;
		    return true;
		  }
		  function Duration(rawValue) {
		    Companion_getInstance_11();
		    this.id_1 = rawValue;
		  }
		  protoOf(Duration).jd = function (other) {
		    return Duration__compareTo_impl_pchp0f(this.id_1, other);
		  };
		  protoOf(Duration).i9 = function (other) {
		    return Duration__compareTo_impl_pchp0f_0(this, other);
		  };
		  protoOf(Duration).toString = function () {
		    return Duration__toString_impl_8d916b(this.id_1);
		  };
		  protoOf(Duration).hashCode = function () {
		    return Duration__hashCode_impl_u4exz6(this.id_1);
		  };
		  protoOf(Duration).equals = function (other) {
		    return Duration__equals_impl_ygj6w6(this.id_1, other);
		  };
		  function durationOfMillis(normalMillis) {
		    // Inline function 'kotlin.Long.plus' call
		    var tmp$ret$0 = normalMillis.w9(1).r9(toLong_0(1));
		    return _Duration___init__impl__kdtzql(tmp$ret$0);
		  }
		  function toDuration(_this__u8e3s4, unit) {
		    var maxNsInUnit = convertDurationUnitOverflow(new Long(-387905, 1073741823), DurationUnit_NANOSECONDS_getInstance(), unit);
		    if (maxNsInUnit.u9().m8(_this__u8e3s4) <= 0 ? _this__u8e3s4.m8(maxNsInUnit) <= 0 : false) {
		      return durationOfNanos(convertDurationUnitOverflow(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance()));
		    } else {
		      var millis = convertDurationUnit_0(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance());
		      return durationOfMillis(coerceIn(millis, new Long(1, -1073741824), new Long(-1, 1073741823)));
		    }
		  }
		  function toDuration_0(_this__u8e3s4, unit) {
		    var valueInNs = convertDurationUnit(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance());
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!!isNaN_0(valueInNs)) {
		      // Inline function 'kotlin.time.toDuration.<anonymous>' call
		      var message = 'Duration value cannot be NaN.';
		      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
		    }
		    var nanos = roundToLong(valueInNs);
		    var tmp;
		    if ((new Long(387905, -1073741824)).m8(nanos) <= 0 ? nanos.m8(new Long(-387905, 1073741823)) <= 0 : false) {
		      tmp = durationOfNanos(nanos);
		    } else {
		      var millis = roundToLong(convertDurationUnit(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance()));
		      tmp = durationOfMillisNormalized(millis);
		    }
		    return tmp;
		  }
		  function parseDuration(value, strictIso) {
		    var length = value.length;
		    if (length === 0)
		      throw IllegalArgumentException_init_$Create$_0('The string is empty');
		    var index = 0;
		    var result = Companion_getInstance_11().ed_1;
		    var infinityString = 'Infinity';
		    var tmp0_subject = charSequenceGet(value, index);
		    if (tmp0_subject === _Char___init__impl__6a9atx(43) ? true : tmp0_subject === _Char___init__impl__6a9atx(45)) {
		      index = index + 1 | 0;
		    }
		    var hasSign = index > 0;
		    var isNegative = hasSign ? startsWith_0(value, _Char___init__impl__6a9atx(45)) : false;
		    if (length <= index)
		      throw IllegalArgumentException_init_$Create$_0('No components');
		    else {
		      if (charSequenceGet(value, index) === _Char___init__impl__6a9atx(80)) {
		        index = index + 1 | 0;
		        if (index === length)
		          throw IllegalArgumentException_init_$Create$();
		        var nonDigitSymbols = '+-.';
		        var isTimeComponent = false;
		        var prevUnit = null;
		        $l$loop: while (index < length) {
		          if (charSequenceGet(value, index) === _Char___init__impl__6a9atx(84)) {
		            var tmp;
		            if (isTimeComponent) {
		              tmp = true;
		            } else {
		              index = index + 1 | 0;
		              tmp = index === length;
		            }
		            if (tmp)
		              throw IllegalArgumentException_init_$Create$();
		            isTimeComponent = true;
		            continue $l$loop;
		          }
		          // Inline function 'kotlin.time.substringWhile' call
		          var startIndex = index;
		          // Inline function 'kotlin.text.substring' call
		          // Inline function 'kotlin.time.skipWhile' call
		          var i = startIndex;
		          $l$loop_0: while (true) {
		            var tmp_0;
		            if (i < value.length) {
		              // Inline function 'kotlin.time.parseDuration.<anonymous>' call
		              var it = charSequenceGet(value, i);
		              tmp_0 = (_Char___init__impl__6a9atx(48) <= it ? it <= _Char___init__impl__6a9atx(57) : false) ? true : contains_4(nonDigitSymbols, it);
		            } else {
		              tmp_0 = false;
		            }
		            if (!tmp_0) {
		              break $l$loop_0;
		            }
		            i = i + 1 | 0;
		          }
		          var endIndex = i;
		          // Inline function 'kotlin.js.asDynamic' call
		          var component = value.substring(startIndex, endIndex);
		          // Inline function 'kotlin.text.isEmpty' call
		          if (charSequenceLength(component) === 0)
		            throw IllegalArgumentException_init_$Create$();
		          index = index + component.length | 0;
		          // Inline function 'kotlin.text.getOrElse' call
		          var index_0 = index;
		          var tmp_1;
		          if (index_0 >= 0 ? index_0 <= get_lastIndex_3(value) : false) {
		            tmp_1 = charSequenceGet(value, index_0);
		          } else {
		            throw IllegalArgumentException_init_$Create$_0('Missing unit for value ' + component);
		          }
		          var unitChar = tmp_1;
		          index = index + 1 | 0;
		          var unit = durationUnitByIsoChar(unitChar, isTimeComponent);
		          if (!(prevUnit == null) ? prevUnit.j8(unit) <= 0 : false)
		            throw IllegalArgumentException_init_$Create$_0('Unexpected order of duration components');
		          prevUnit = unit;
		          var dotIndex = indexOf_4(component, _Char___init__impl__6a9atx(46));
		          if (unit.equals(DurationUnit_SECONDS_getInstance()) ? dotIndex > 0 : false) {
		            // Inline function 'kotlin.text.substring' call
		            // Inline function 'kotlin.js.asDynamic' call
		            var whole = component.substring(0, dotIndex);
		            result = Duration__plus_impl_yu9v8f(result, toDuration(parseOverLongIsoComponent(whole), unit));
		            var tmp_2 = result;
		            // Inline function 'kotlin.text.substring' call
		            // Inline function 'kotlin.js.asDynamic' call
		            var tmp$ret$10 = component.substring(dotIndex);
		            result = Duration__plus_impl_yu9v8f(tmp_2, toDuration_0(toDouble(tmp$ret$10), unit));
		          } else {
		            result = Duration__plus_impl_yu9v8f(result, toDuration(parseOverLongIsoComponent(component), unit));
		          }
		        }
		      } else {
		        if (strictIso)
		          throw IllegalArgumentException_init_$Create$();
		        else {
		          var tmp_3 = index;
		          // Inline function 'kotlin.comparisons.maxOf' call
		          var a = length - index | 0;
		          var b = infinityString.length;
		          var tmp$ret$11 = Math.max(a, b);
		          if (regionMatches(value, tmp_3, infinityString, 0, tmp$ret$11, true)) {
		            result = Companion_getInstance_11().fd_1;
		          } else {
		            var prevUnit_0 = null;
		            var afterFirst = false;
		            var allowSpaces = !hasSign;
		            if ((hasSign ? charSequenceGet(value, index) === _Char___init__impl__6a9atx(40) : false) ? last_0(value) === _Char___init__impl__6a9atx(41) : false) {
		              allowSpaces = true;
		              index = index + 1 | 0;
		              var tmp_4 = index;
		              length = length - 1 | 0;
		              if (tmp_4 === length)
		                throw IllegalArgumentException_init_$Create$_0('No components');
		            }
		            while (index < length) {
		              if (afterFirst ? allowSpaces : false) {
		                // Inline function 'kotlin.time.skipWhile' call
		                var i_0 = index;
		                $l$loop_1: while (true) {
		                  var tmp_5;
		                  if (i_0 < value.length) {
		                    // Inline function 'kotlin.time.parseDuration.<anonymous>' call
		                    tmp_5 = charSequenceGet(value, i_0) === _Char___init__impl__6a9atx(32);
		                  } else {
		                    tmp_5 = false;
		                  }
		                  if (!tmp_5) {
		                    break $l$loop_1;
		                  }
		                  i_0 = i_0 + 1 | 0;
		                }
		                index = i_0;
		              }
		              afterFirst = true;
		              // Inline function 'kotlin.time.substringWhile' call
		              var startIndex_0 = index;
		              // Inline function 'kotlin.text.substring' call
		              // Inline function 'kotlin.time.skipWhile' call
		              var i_1 = startIndex_0;
		              $l$loop_2: while (true) {
		                var tmp_6;
		                if (i_1 < value.length) {
		                  // Inline function 'kotlin.time.parseDuration.<anonymous>' call
		                  var it_0 = charSequenceGet(value, i_1);
		                  tmp_6 = (_Char___init__impl__6a9atx(48) <= it_0 ? it_0 <= _Char___init__impl__6a9atx(57) : false) ? true : it_0 === _Char___init__impl__6a9atx(46);
		                } else {
		                  tmp_6 = false;
		                }
		                if (!tmp_6) {
		                  break $l$loop_2;
		                }
		                i_1 = i_1 + 1 | 0;
		              }
		              var endIndex_0 = i_1;
		              // Inline function 'kotlin.js.asDynamic' call
		              var component_0 = value.substring(startIndex_0, endIndex_0);
		              // Inline function 'kotlin.text.isEmpty' call
		              if (charSequenceLength(component_0) === 0)
		                throw IllegalArgumentException_init_$Create$();
		              index = index + component_0.length | 0;
		              // Inline function 'kotlin.time.substringWhile' call
		              var startIndex_1 = index;
		              // Inline function 'kotlin.text.substring' call
		              // Inline function 'kotlin.time.skipWhile' call
		              var i_2 = startIndex_1;
		              $l$loop_3: while (true) {
		                var tmp_7;
		                if (i_2 < value.length) {
		                  // Inline function 'kotlin.time.parseDuration.<anonymous>' call
		                  var it_1 = charSequenceGet(value, i_2);
		                  tmp_7 = _Char___init__impl__6a9atx(97) <= it_1 ? it_1 <= _Char___init__impl__6a9atx(122) : false;
		                } else {
		                  tmp_7 = false;
		                }
		                if (!tmp_7) {
		                  break $l$loop_3;
		                }
		                i_2 = i_2 + 1 | 0;
		              }
		              var endIndex_1 = i_2;
		              // Inline function 'kotlin.js.asDynamic' call
		              var unitName = value.substring(startIndex_1, endIndex_1);
		              index = index + unitName.length | 0;
		              var unit_0 = durationUnitByShortName(unitName);
		              if (!(prevUnit_0 == null) ? prevUnit_0.j8(unit_0) <= 0 : false)
		                throw IllegalArgumentException_init_$Create$_0('Unexpected order of duration components');
		              prevUnit_0 = unit_0;
		              var dotIndex_0 = indexOf_4(component_0, _Char___init__impl__6a9atx(46));
		              if (dotIndex_0 > 0) {
		                // Inline function 'kotlin.text.substring' call
		                // Inline function 'kotlin.js.asDynamic' call
		                var whole_0 = component_0.substring(0, dotIndex_0);
		                result = Duration__plus_impl_yu9v8f(result, toDuration(toLong(whole_0), unit_0));
		                var tmp_8 = result;
		                // Inline function 'kotlin.text.substring' call
		                // Inline function 'kotlin.js.asDynamic' call
		                var tmp$ret$28 = component_0.substring(dotIndex_0);
		                result = Duration__plus_impl_yu9v8f(tmp_8, toDuration_0(toDouble(tmp$ret$28), unit_0));
		                if (index < length)
		                  throw IllegalArgumentException_init_$Create$_0('Fractional component must be last');
		              } else {
		                result = Duration__plus_impl_yu9v8f(result, toDuration(toLong(component_0), unit_0));
		              }
		            }
		          }
		        }
		      }
		    }
		    return isNegative ? Duration__unaryMinus_impl_x2k1y0(result) : result;
		  }
		  function durationOf(normalValue, unitDiscriminator) {
		    // Inline function 'kotlin.Long.plus' call
		    var tmp$ret$0 = normalValue.w9(1).r9(toLong_0(unitDiscriminator));
		    return _Duration___init__impl__kdtzql(tmp$ret$0);
		  }
		  function durationOfNanosNormalized(nanos) {
		    var tmp;
		    if ((new Long(387905, -1073741824)).m8(nanos) <= 0 ? nanos.m8(new Long(-387905, 1073741823)) <= 0 : false) {
		      tmp = durationOfNanos(nanos);
		    } else {
		      tmp = durationOfMillis(nanosToMillis(nanos));
		    }
		    return tmp;
		  }
		  function durationOfMillisNormalized(millis) {
		    var tmp;
		    if ((new Long(1108857478, -1074)).m8(millis) <= 0 ? millis.m8(new Long(-1108857478, 1073)) <= 0 : false) {
		      tmp = durationOfNanos(millisToNanos(millis));
		    } else {
		      tmp = durationOfMillis(coerceIn(millis, new Long(1, -1073741824), new Long(-1, 1073741823)));
		    }
		    return tmp;
		  }
		  function nanosToMillis(nanos) {
		    // Inline function 'kotlin.Long.div' call
		    return nanos.k8(toLong_0(1000000));
		  }
		  function millisToNanos(millis) {
		    // Inline function 'kotlin.Long.times' call
		    return millis.l8(toLong_0(1000000));
		  }
		  function durationOfNanos(normalNanos) {
		    return _Duration___init__impl__kdtzql(normalNanos.w9(1));
		  }
		  function parseOverLongIsoComponent(value) {
		    var length = value.length;
		    var startIndex = 0;
		    if (length > 0 ? contains_4('+-', charSequenceGet(value, 0)) : false) {
		      startIndex = startIndex + 1 | 0;
		    }
		    var tmp;
		    if ((length - startIndex | 0) > 16) {
		      var tmp$ret$0;
		      $l$block_0: {
		        // Inline function 'kotlin.collections.all' call
		        var this_0 = numberRangeToNumber(startIndex, get_lastIndex_3(value));
		        var tmp_0;
		        if (isInterface(this_0, Collection)) {
		          tmp_0 = this_0.x();
		        } else {
		          tmp_0 = false;
		        }
		        if (tmp_0) {
		          tmp$ret$0 = true;
		          break $l$block_0;
		        }
		        var tmp0_iterator = this_0.p();
		        while (tmp0_iterator.q()) {
		          var element = tmp0_iterator.s();
		          // Inline function 'kotlin.time.parseOverLongIsoComponent.<anonymous>' call
		          var containsArg = charSequenceGet(value, element);
		          if (!(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false)) {
		            tmp$ret$0 = false;
		            break $l$block_0;
		          }
		        }
		        tmp$ret$0 = true;
		      }
		      tmp = tmp$ret$0;
		    } else {
		      tmp = false;
		    }
		    if (tmp) {
		      var tmp_1;
		      if (charSequenceGet(value, 0) === _Char___init__impl__6a9atx(45)) {
		        Companion_getInstance_4();
		        tmp_1 = new Long(0, -2147483648);
		      } else {
		        Companion_getInstance_4();
		        tmp_1 = new Long(-1, 2147483647);
		      }
		      return tmp_1;
		    }
		    return startsWith(value, '+') ? toLong(drop(value, 1)) : toLong(value);
		  }
		  function durationUnitByIsoChar(isoChar, isTimeComponent) {
		    var tmp;
		    if (!isTimeComponent) {
		      var tmp_0;
		      if (isoChar === _Char___init__impl__6a9atx(68)) {
		        tmp_0 = DurationUnit_DAYS_getInstance();
		      } else {
		        throw IllegalArgumentException_init_$Create$_0('Invalid or unsupported duration ISO non-time unit: ' + toString(isoChar));
		      }
		      tmp = tmp_0;
		    } else {
		      var tmp_1;
		      if (isoChar === _Char___init__impl__6a9atx(72)) {
		        tmp_1 = DurationUnit_HOURS_getInstance();
		      } else if (isoChar === _Char___init__impl__6a9atx(77)) {
		        tmp_1 = DurationUnit_MINUTES_getInstance();
		      } else if (isoChar === _Char___init__impl__6a9atx(83)) {
		        tmp_1 = DurationUnit_SECONDS_getInstance();
		      } else {
		        throw IllegalArgumentException_init_$Create$_0('Invalid duration ISO time unit: ' + toString(isoChar));
		      }
		      tmp = tmp_1;
		    }
		    return tmp;
		  }
		  function durationUnitByShortName(shortName) {
		    var tmp;
		    switch (shortName) {
		      case 'ns':
		        tmp = DurationUnit_NANOSECONDS_getInstance();
		        break;
		      case 'us':
		        tmp = DurationUnit_MICROSECONDS_getInstance();
		        break;
		      case 'ms':
		        tmp = DurationUnit_MILLISECONDS_getInstance();
		        break;
		      case 's':
		        tmp = DurationUnit_SECONDS_getInstance();
		        break;
		      case 'm':
		        tmp = DurationUnit_MINUTES_getInstance();
		        break;
		      case 'h':
		        tmp = DurationUnit_HOURS_getInstance();
		        break;
		      case 'd':
		        tmp = DurationUnit_DAYS_getInstance();
		        break;
		      default:
		        throw IllegalArgumentException_init_$Create$_0('Unknown duration unit short name: ' + shortName);
		    }
		    return tmp;
		  }
		  function get_UNDEFINED_RESULT() {
		    _init_properties_DeepRecursive_kt__zbwcac();
		    return UNDEFINED_RESULT;
		  }
		  var UNDEFINED_RESULT;
		  function DeepRecursiveScope() {
		  }
		  function invoke(_this__u8e3s4, value) {
		    _init_properties_DeepRecursive_kt__zbwcac();
		    return (new DeepRecursiveScopeImpl(_this__u8e3s4.ld_1, value)).qd();
		  }
		  function DeepRecursiveFunction(block) {
		    this.ld_1 = block;
		  }
		  function DeepRecursiveScopeImpl(block, value) {
		    DeepRecursiveScope.call(this);
		    var tmp = this;
		    tmp.md_1 = isSuspendFunction(block, 2) ? block : THROW_CCE();
		    this.nd_1 = value;
		    var tmp_0 = this;
		    tmp_0.od_1 = isInterface(this, Continuation) ? this : THROW_CCE();
		    this.pd_1 = get_UNDEFINED_RESULT();
		  }
		  protoOf(DeepRecursiveScopeImpl).ua = function () {
		    return EmptyCoroutineContext_getInstance();
		  };
		  protoOf(DeepRecursiveScopeImpl).rd = function (result) {
		    this.od_1 = null;
		    this.pd_1 = result;
		  };
		  protoOf(DeepRecursiveScopeImpl).za = function (result) {
		    return this.rd(result);
		  };
		  protoOf(DeepRecursiveScopeImpl).kd = function (value, $completion) {
		    // Inline function 'kotlin.DeepRecursiveScopeImpl.callRecursive.<anonymous>' call
		    var tmp = this;
		    tmp.od_1 = isInterface($completion, Continuation) ? $completion : THROW_CCE();
		    this.nd_1 = value;
		    return get_COROUTINE_SUSPENDED();
		  };
		  protoOf(DeepRecursiveScopeImpl).qd = function () {
		    $l$loop: while (true) {
		      var result = this.pd_1;
		      var tmp0_elvis_lhs = this.od_1;
		      var tmp;
		      if (tmp0_elvis_lhs == null) {
		        // Inline function 'kotlin.getOrThrow' call
		        var this_0 = new Result(result) instanceof Result ? result : THROW_CCE();
		        throwOnFailure(this_0);
		        var tmp_0 = _Result___get_value__impl__bjfvqg(this_0);
		        return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
		      } else {
		        tmp = tmp0_elvis_lhs;
		      }
		      var cont = tmp;
		      if (equals_0(get_UNDEFINED_RESULT(), result)) {
		        var tmp_1;
		        try {
		          // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
		          var this_1 = this.md_1;
		          var param = this.nd_1;
		          // Inline function 'kotlin.js.asDynamic' call
		          var a = this_1;
		          tmp_1 = typeof a === 'function' ? a(this, param, cont) : this_1.sd(this, param, cont);
		        } catch ($p) {
		          var tmp_2;
		          if ($p instanceof Error) {
		            var e = $p;
		            // Inline function 'kotlin.coroutines.resumeWithException' call
		            // Inline function 'kotlin.Companion.failure' call
		            var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(e));
		            cont.za(tmp$ret$3);
		            continue $l$loop;
		          } else {
		            throw $p;
		          }
		        }
		        var r = tmp_1;
		        if (!(r === get_COROUTINE_SUSPENDED())) {
		          // Inline function 'kotlin.coroutines.resume' call
		          // Inline function 'kotlin.Companion.success' call
		          var value = (r == null ? true : !(r == null)) ? r : THROW_CCE();
		          var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
		          cont.za(tmp$ret$5);
		        }
		      } else {
		        this.pd_1 = get_UNDEFINED_RESULT();
		        cont.za(result);
		      }
		    }
		  };
		  var properties_initialized_DeepRecursive_kt_5z0al2;
		  function _init_properties_DeepRecursive_kt__zbwcac() {
		    if (!properties_initialized_DeepRecursive_kt_5z0al2) {
		      properties_initialized_DeepRecursive_kt_5z0al2 = true;
		      // Inline function 'kotlin.Companion.success' call
		      var value = get_COROUTINE_SUSPENDED();
		      UNDEFINED_RESULT = _Result___init__impl__xyqfz8(value);
		    }
		  }
		  var LazyThreadSafetyMode_SYNCHRONIZED_instance;
		  var LazyThreadSafetyMode_PUBLICATION_instance;
		  var LazyThreadSafetyMode_NONE_instance;
		  var LazyThreadSafetyMode_entriesInitialized;
		  function LazyThreadSafetyMode_initEntries() {
		    if (LazyThreadSafetyMode_entriesInitialized)
		      return Unit_instance;
		    LazyThreadSafetyMode_entriesInitialized = true;
		    LazyThreadSafetyMode_SYNCHRONIZED_instance = new LazyThreadSafetyMode('SYNCHRONIZED', 0);
		    LazyThreadSafetyMode_PUBLICATION_instance = new LazyThreadSafetyMode('PUBLICATION', 1);
		    LazyThreadSafetyMode_NONE_instance = new LazyThreadSafetyMode('NONE', 2);
		  }
		  function LazyThreadSafetyMode(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function UnsafeLazyImpl(initializer) {
		    this.td_1 = initializer;
		    this.ud_1 = UNINITIALIZED_VALUE_instance;
		  }
		  protoOf(UnsafeLazyImpl).w1 = function () {
		    if (this.ud_1 === UNINITIALIZED_VALUE_instance) {
		      this.ud_1 = ensureNotNull(this.td_1)();
		      this.td_1 = null;
		    }
		    var tmp = this.ud_1;
		    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
		  };
		  protoOf(UnsafeLazyImpl).vd = function () {
		    return !(this.ud_1 === UNINITIALIZED_VALUE_instance);
		  };
		  protoOf(UnsafeLazyImpl).toString = function () {
		    return this.vd() ? toString_0(this.w1()) : 'Lazy value not initialized yet.';
		  };
		  function UNINITIALIZED_VALUE() {
		  }
		  var UNINITIALIZED_VALUE_instance;
		  function UNINITIALIZED_VALUE_getInstance() {
		    return UNINITIALIZED_VALUE_instance;
		  }
		  function LazyThreadSafetyMode_PUBLICATION_getInstance() {
		    LazyThreadSafetyMode_initEntries();
		    return LazyThreadSafetyMode_PUBLICATION_instance;
		  }
		  function _Result___init__impl__xyqfz8(value) {
		    return value;
		  }
		  function _Result___get_value__impl__bjfvqg($this) {
		    return $this;
		  }
		  function _Result___get_isFailure__impl__jpiriv($this) {
		    var tmp = _Result___get_value__impl__bjfvqg($this);
		    return tmp instanceof Failure;
		  }
		  function Result__exceptionOrNull_impl_p6xea9($this) {
		    var tmp;
		    if (_Result___get_value__impl__bjfvqg($this) instanceof Failure) {
		      tmp = _Result___get_value__impl__bjfvqg($this).wd_1;
		    } else {
		      tmp = null;
		    }
		    return tmp;
		  }
		  function Result__toString_impl_yu5r8k($this) {
		    var tmp;
		    if (_Result___get_value__impl__bjfvqg($this) instanceof Failure) {
		      tmp = toString_1(_Result___get_value__impl__bjfvqg($this));
		    } else {
		      tmp = 'Success(' + toString_0(_Result___get_value__impl__bjfvqg($this)) + ')';
		    }
		    return tmp;
		  }
		  function Companion_12() {
		  }
		  var Companion_instance_12;
		  function Companion_getInstance_12() {
		    return Companion_instance_12;
		  }
		  function Failure(exception) {
		    this.wd_1 = exception;
		  }
		  protoOf(Failure).equals = function (other) {
		    var tmp;
		    if (other instanceof Failure) {
		      tmp = equals_0(this.wd_1, other.wd_1);
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(Failure).hashCode = function () {
		    return hashCode(this.wd_1);
		  };
		  protoOf(Failure).toString = function () {
		    return 'Failure(' + this.wd_1 + ')';
		  };
		  function Result__hashCode_impl_d2zufp($this) {
		    return $this == null ? 0 : hashCode($this);
		  }
		  function Result__equals_impl_bxgmep($this, other) {
		    if (!(other instanceof Result))
		      return false;
		    var tmp0_other_with_cast = other instanceof Result ? other.xd_1 : THROW_CCE();
		    if (!equals_0($this, tmp0_other_with_cast))
		      return false;
		    return true;
		  }
		  function Result(value) {
		    this.xd_1 = value;
		  }
		  protoOf(Result).toString = function () {
		    return Result__toString_impl_yu5r8k(this.xd_1);
		  };
		  protoOf(Result).hashCode = function () {
		    return Result__hashCode_impl_d2zufp(this.xd_1);
		  };
		  protoOf(Result).equals = function (other) {
		    return Result__equals_impl_bxgmep(this.xd_1, other);
		  };
		  function createFailure(exception) {
		    return new Failure(exception);
		  }
		  function throwOnFailure(_this__u8e3s4) {
		    var tmp = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
		    if (tmp instanceof Failure)
		      throw _Result___get_value__impl__bjfvqg(_this__u8e3s4).wd_1;
		  }
		  function NotImplementedError(message) {
		    message = message === VOID ? 'An operation is not implemented.' : message;
		    Error_init_$Init$_0(message, this);
		    captureStack(this, NotImplementedError);
		  }
		  function Pair(first, second) {
		    this.m5_1 = first;
		    this.n5_1 = second;
		  }
		  protoOf(Pair).toString = function () {
		    return '(' + this.m5_1 + ', ' + this.n5_1 + ')';
		  };
		  protoOf(Pair).o5 = function () {
		    return this.m5_1;
		  };
		  protoOf(Pair).p5 = function () {
		    return this.n5_1;
		  };
		  protoOf(Pair).hashCode = function () {
		    var result = this.m5_1 == null ? 0 : hashCode(this.m5_1);
		    result = imul(result, 31) + (this.n5_1 == null ? 0 : hashCode(this.n5_1)) | 0;
		    return result;
		  };
		  protoOf(Pair).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Pair))
		      return false;
		    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
		    if (!equals_0(this.m5_1, tmp0_other_with_cast.m5_1))
		      return false;
		    if (!equals_0(this.n5_1, tmp0_other_with_cast.n5_1))
		      return false;
		    return true;
		  };
		  function to(_this__u8e3s4, that) {
		    return new Pair(_this__u8e3s4, that);
		  }
		  function Triple(first, second, third) {
		    this.yd_1 = first;
		    this.zd_1 = second;
		    this.ae_1 = third;
		  }
		  protoOf(Triple).toString = function () {
		    return '(' + this.yd_1 + ', ' + this.zd_1 + ', ' + this.ae_1 + ')';
		  };
		  protoOf(Triple).hashCode = function () {
		    var result = this.yd_1 == null ? 0 : hashCode(this.yd_1);
		    result = imul(result, 31) + (this.zd_1 == null ? 0 : hashCode(this.zd_1)) | 0;
		    result = imul(result, 31) + (this.ae_1 == null ? 0 : hashCode(this.ae_1)) | 0;
		    return result;
		  };
		  protoOf(Triple).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Triple))
		      return false;
		    var tmp0_other_with_cast = other instanceof Triple ? other : THROW_CCE();
		    if (!equals_0(this.yd_1, tmp0_other_with_cast.yd_1))
		      return false;
		    if (!equals_0(this.zd_1, tmp0_other_with_cast.zd_1))
		      return false;
		    if (!equals_0(this.ae_1, tmp0_other_with_cast.ae_1))
		      return false;
		    return true;
		  };
		  function _UByte___init__impl__g9hnc4(data) {
		    return data;
		  }
		  function _UByte___get_data__impl__jof9qr($this) {
		    return $this;
		  }
		  function Companion_13() {
		    Companion_instance_13 = this;
		    this.be_1 = _UByte___init__impl__g9hnc4(0);
		    this.ce_1 = _UByte___init__impl__g9hnc4(-1);
		    this.de_1 = 1;
		    this.ee_1 = 8;
		  }
		  var Companion_instance_13;
		  function Companion_getInstance_13() {
		    if (Companion_instance_13 == null)
		      new Companion_13();
		    return Companion_instance_13;
		  }
		  function UByte__compareTo_impl_5w5192($this, other) {
		    // Inline function 'kotlin.UByte.toInt' call
		    var tmp = _UByte___get_data__impl__jof9qr($this) & 255;
		    // Inline function 'kotlin.UByte.toInt' call
		    var tmp$ret$1 = _UByte___get_data__impl__jof9qr(other) & 255;
		    return compareTo(tmp, tmp$ret$1);
		  }
		  function UByte__compareTo_impl_5w5192_0($this, other) {
		    return UByte__compareTo_impl_5w5192($this.fe_1, other instanceof UByte ? other.fe_1 : THROW_CCE());
		  }
		  function UByte__toString_impl_v72jg($this) {
		    // Inline function 'kotlin.UByte.toInt' call
		    return (_UByte___get_data__impl__jof9qr($this) & 255).toString();
		  }
		  function UByte__hashCode_impl_mmczcb($this) {
		    return $this;
		  }
		  function UByte__equals_impl_nvqtsf($this, other) {
		    if (!(other instanceof UByte))
		      return false;
		    if (!($this === (other instanceof UByte ? other.fe_1 : THROW_CCE())))
		      return false;
		    return true;
		  }
		  function UByte(data) {
		    Companion_getInstance_13();
		    this.fe_1 = data;
		  }
		  protoOf(UByte).ge = function (other) {
		    return UByte__compareTo_impl_5w5192(this.fe_1, other);
		  };
		  protoOf(UByte).i9 = function (other) {
		    return UByte__compareTo_impl_5w5192_0(this, other);
		  };
		  protoOf(UByte).toString = function () {
		    return UByte__toString_impl_v72jg(this.fe_1);
		  };
		  protoOf(UByte).hashCode = function () {
		    return UByte__hashCode_impl_mmczcb(this.fe_1);
		  };
		  protoOf(UByte).equals = function (other) {
		    return UByte__equals_impl_nvqtsf(this.fe_1, other);
		  };
		  function _UByteArray___init__impl__ip4y9n(storage) {
		    return storage;
		  }
		  function _UByteArray___get_storage__impl__d4kctt($this) {
		    return $this;
		  }
		  function _UByteArray___init__impl__ip4y9n_0(size) {
		    return _UByteArray___init__impl__ip4y9n(new Int8Array(size));
		  }
		  function UByteArray__get_impl_t5f3hv($this, index) {
		    // Inline function 'kotlin.toUByte' call
		    var this_0 = _UByteArray___get_storage__impl__d4kctt($this)[index];
		    return _UByte___init__impl__g9hnc4(this_0);
		  }
		  function UByteArray__set_impl_jvcicn($this, index, value) {
		    var tmp = _UByteArray___get_storage__impl__d4kctt($this);
		    // Inline function 'kotlin.UByte.toByte' call
		    tmp[index] = _UByte___get_data__impl__jof9qr(value);
		  }
		  function _UByteArray___get_size__impl__h6pkdv($this) {
		    return _UByteArray___get_storage__impl__d4kctt($this).length;
		  }
		  function UByteArray__iterator_impl_509y1p($this) {
		    return new Iterator(_UByteArray___get_storage__impl__d4kctt($this));
		  }
		  function Iterator(array) {
		    this.he_1 = array;
		    this.ie_1 = 0;
		  }
		  protoOf(Iterator).q = function () {
		    return this.ie_1 < this.he_1.length;
		  };
		  protoOf(Iterator).je = function () {
		    var tmp;
		    if (this.ie_1 < this.he_1.length) {
		      // Inline function 'kotlin.toUByte' call
		      var tmp1 = this.ie_1;
		      this.ie_1 = tmp1 + 1 | 0;
		      var this_0 = this.he_1[tmp1];
		      tmp = _UByte___init__impl__g9hnc4(this_0);
		    } else {
		      throw NoSuchElementException_init_$Create$_0(this.ie_1.toString());
		    }
		    return tmp;
		  };
		  protoOf(Iterator).s = function () {
		    return new UByte(this.je());
		  };
		  function UByteArray__containsAll_impl_v9s6dj($this, elements) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.all' call
		      var this_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
		      var tmp;
		      if (isInterface(this_0, Collection)) {
		        tmp = this_0.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = true;
		        break $l$block_0;
		      }
		      var tmp0_iterator = this_0.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.UByteArray.containsAll.<anonymous>' call
		        var tmp_0;
		        if (element instanceof UByte) {
		          var tmp_1 = _UByteArray___get_storage__impl__d4kctt($this);
		          // Inline function 'kotlin.UByte.toByte' call
		          var this_1 = element.fe_1;
		          var tmp$ret$1 = _UByte___get_data__impl__jof9qr(this_1);
		          tmp_0 = contains_2(tmp_1, tmp$ret$1);
		        } else {
		          tmp_0 = false;
		        }
		        if (!tmp_0) {
		          tmp$ret$0 = false;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  }
		  function UByteArray__containsAll_impl_v9s6dj_0($this, elements) {
		    return UByteArray__containsAll_impl_v9s6dj($this.ke_1, elements);
		  }
		  function UByteArray__isEmpty_impl_nbfqsa($this) {
		    return _UByteArray___get_storage__impl__d4kctt($this).length === 0;
		  }
		  function UByteArray__toString_impl_ukpl97($this) {
		    return 'UByteArray(storage=' + toString_1($this) + ')';
		  }
		  function UByteArray__hashCode_impl_ip8jx2($this) {
		    return hashCode($this);
		  }
		  function UByteArray__equals_impl_roka4u($this, other) {
		    if (!(other instanceof UByteArray))
		      return false;
		    var tmp0_other_with_cast = other instanceof UByteArray ? other.ke_1 : THROW_CCE();
		    if (!equals_0($this, tmp0_other_with_cast))
		      return false;
		    return true;
		  }
		  function UByteArray(storage) {
		    this.ke_1 = storage;
		  }
		  protoOf(UByteArray).u = function () {
		    return _UByteArray___get_size__impl__h6pkdv(this.ke_1);
		  };
		  protoOf(UByteArray).p = function () {
		    return UByteArray__iterator_impl_509y1p(this.ke_1);
		  };
		  protoOf(UByteArray).le = function (elements) {
		    return UByteArray__containsAll_impl_v9s6dj(this.ke_1, elements);
		  };
		  protoOf(UByteArray).w = function (elements) {
		    return UByteArray__containsAll_impl_v9s6dj_0(this, elements);
		  };
		  protoOf(UByteArray).x = function () {
		    return UByteArray__isEmpty_impl_nbfqsa(this.ke_1);
		  };
		  protoOf(UByteArray).toString = function () {
		    return UByteArray__toString_impl_ukpl97(this.ke_1);
		  };
		  protoOf(UByteArray).hashCode = function () {
		    return UByteArray__hashCode_impl_ip8jx2(this.ke_1);
		  };
		  protoOf(UByteArray).equals = function (other) {
		    return UByteArray__equals_impl_roka4u(this.ke_1, other);
		  };
		  function _UInt___init__impl__l7qpdl(data) {
		    return data;
		  }
		  function _UInt___get_data__impl__f0vqqw($this) {
		    return $this;
		  }
		  function Companion_14() {
		    Companion_instance_14 = this;
		    this.me_1 = _UInt___init__impl__l7qpdl(0);
		    this.ne_1 = _UInt___init__impl__l7qpdl(-1);
		    this.oe_1 = 4;
		    this.pe_1 = 32;
		  }
		  var Companion_instance_14;
		  function Companion_getInstance_14() {
		    if (Companion_instance_14 == null)
		      new Companion_14();
		    return Companion_instance_14;
		  }
		  function UInt__compareTo_impl_yacclj($this, other) {
		    return uintCompare(_UInt___get_data__impl__f0vqqw($this), _UInt___get_data__impl__f0vqqw(other));
		  }
		  function UInt__compareTo_impl_yacclj_0($this, other) {
		    return UInt__compareTo_impl_yacclj($this.qe_1, other instanceof UInt ? other.qe_1 : THROW_CCE());
		  }
		  function UInt__toString_impl_dbgl21($this) {
		    // Inline function 'kotlin.UInt.toLong' call
		    return toLong_0(_UInt___get_data__impl__f0vqqw($this)).z9(new Long(-1, 0)).toString();
		  }
		  function UInt__hashCode_impl_z2mhuw($this) {
		    return $this;
		  }
		  function UInt__equals_impl_ffdoxg($this, other) {
		    if (!(other instanceof UInt))
		      return false;
		    if (!($this === (other instanceof UInt ? other.qe_1 : THROW_CCE())))
		      return false;
		    return true;
		  }
		  function UInt(data) {
		    Companion_getInstance_14();
		    this.qe_1 = data;
		  }
		  protoOf(UInt).re = function (other) {
		    return UInt__compareTo_impl_yacclj(this.qe_1, other);
		  };
		  protoOf(UInt).i9 = function (other) {
		    return UInt__compareTo_impl_yacclj_0(this, other);
		  };
		  protoOf(UInt).toString = function () {
		    return UInt__toString_impl_dbgl21(this.qe_1);
		  };
		  protoOf(UInt).hashCode = function () {
		    return UInt__hashCode_impl_z2mhuw(this.qe_1);
		  };
		  protoOf(UInt).equals = function (other) {
		    return UInt__equals_impl_ffdoxg(this.qe_1, other);
		  };
		  function _UIntArray___init__impl__ghjpc6(storage) {
		    return storage;
		  }
		  function _UIntArray___get_storage__impl__92a0v0($this) {
		    return $this;
		  }
		  function _UIntArray___init__impl__ghjpc6_0(size) {
		    return _UIntArray___init__impl__ghjpc6(new Int32Array(size));
		  }
		  function UIntArray__get_impl_gp5kza($this, index) {
		    // Inline function 'kotlin.toUInt' call
		    var this_0 = _UIntArray___get_storage__impl__92a0v0($this)[index];
		    return _UInt___init__impl__l7qpdl(this_0);
		  }
		  function UIntArray__set_impl_7f2zu2($this, index, value) {
		    var tmp = _UIntArray___get_storage__impl__92a0v0($this);
		    // Inline function 'kotlin.UInt.toInt' call
		    tmp[index] = _UInt___get_data__impl__f0vqqw(value);
		  }
		  function _UIntArray___get_size__impl__r6l8ci($this) {
		    return _UIntArray___get_storage__impl__92a0v0($this).length;
		  }
		  function UIntArray__iterator_impl_tkdv7k($this) {
		    return new Iterator_0(_UIntArray___get_storage__impl__92a0v0($this));
		  }
		  function Iterator_0(array) {
		    this.se_1 = array;
		    this.te_1 = 0;
		  }
		  protoOf(Iterator_0).q = function () {
		    return this.te_1 < this.se_1.length;
		  };
		  protoOf(Iterator_0).ue = function () {
		    var tmp;
		    if (this.te_1 < this.se_1.length) {
		      // Inline function 'kotlin.toUInt' call
		      var tmp1 = this.te_1;
		      this.te_1 = tmp1 + 1 | 0;
		      var this_0 = this.se_1[tmp1];
		      tmp = _UInt___init__impl__l7qpdl(this_0);
		    } else {
		      throw NoSuchElementException_init_$Create$_0(this.te_1.toString());
		    }
		    return tmp;
		  };
		  protoOf(Iterator_0).s = function () {
		    return new UInt(this.ue());
		  };
		  function UIntArray__containsAll_impl_414g22($this, elements) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.all' call
		      var this_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
		      var tmp;
		      if (isInterface(this_0, Collection)) {
		        tmp = this_0.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = true;
		        break $l$block_0;
		      }
		      var tmp0_iterator = this_0.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.UIntArray.containsAll.<anonymous>' call
		        var tmp_0;
		        if (element instanceof UInt) {
		          var tmp_1 = _UIntArray___get_storage__impl__92a0v0($this);
		          // Inline function 'kotlin.UInt.toInt' call
		          var this_1 = element.qe_1;
		          var tmp$ret$1 = _UInt___get_data__impl__f0vqqw(this_1);
		          tmp_0 = contains_0(tmp_1, tmp$ret$1);
		        } else {
		          tmp_0 = false;
		        }
		        if (!tmp_0) {
		          tmp$ret$0 = false;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  }
		  function UIntArray__containsAll_impl_414g22_0($this, elements) {
		    return UIntArray__containsAll_impl_414g22($this.ve_1, elements);
		  }
		  function UIntArray__isEmpty_impl_vd8j4n($this) {
		    return _UIntArray___get_storage__impl__92a0v0($this).length === 0;
		  }
		  function UIntArray__toString_impl_3zy802($this) {
		    return 'UIntArray(storage=' + toString_1($this) + ')';
		  }
		  function UIntArray__hashCode_impl_hr7ost($this) {
		    return hashCode($this);
		  }
		  function UIntArray__equals_impl_flcmof($this, other) {
		    if (!(other instanceof UIntArray))
		      return false;
		    var tmp0_other_with_cast = other instanceof UIntArray ? other.ve_1 : THROW_CCE();
		    if (!equals_0($this, tmp0_other_with_cast))
		      return false;
		    return true;
		  }
		  function UIntArray(storage) {
		    this.ve_1 = storage;
		  }
		  protoOf(UIntArray).u = function () {
		    return _UIntArray___get_size__impl__r6l8ci(this.ve_1);
		  };
		  protoOf(UIntArray).p = function () {
		    return UIntArray__iterator_impl_tkdv7k(this.ve_1);
		  };
		  protoOf(UIntArray).we = function (elements) {
		    return UIntArray__containsAll_impl_414g22(this.ve_1, elements);
		  };
		  protoOf(UIntArray).w = function (elements) {
		    return UIntArray__containsAll_impl_414g22_0(this, elements);
		  };
		  protoOf(UIntArray).x = function () {
		    return UIntArray__isEmpty_impl_vd8j4n(this.ve_1);
		  };
		  protoOf(UIntArray).toString = function () {
		    return UIntArray__toString_impl_3zy802(this.ve_1);
		  };
		  protoOf(UIntArray).hashCode = function () {
		    return UIntArray__hashCode_impl_hr7ost(this.ve_1);
		  };
		  protoOf(UIntArray).equals = function (other) {
		    return UIntArray__equals_impl_flcmof(this.ve_1, other);
		  };
		  function _ULong___init__impl__c78o9k(data) {
		    return data;
		  }
		  function _ULong___get_data__impl__fggpzb($this) {
		    return $this;
		  }
		  function Companion_15() {
		    Companion_instance_15 = this;
		    this.xe_1 = _ULong___init__impl__c78o9k(new Long(0, 0));
		    this.ye_1 = _ULong___init__impl__c78o9k(new Long(-1, -1));
		    this.ze_1 = 8;
		    this.af_1 = 64;
		  }
		  var Companion_instance_15;
		  function Companion_getInstance_15() {
		    if (Companion_instance_15 == null)
		      new Companion_15();
		    return Companion_instance_15;
		  }
		  function ULong__compareTo_impl_38i7tu($this, other) {
		    return ulongCompare(_ULong___get_data__impl__fggpzb($this), _ULong___get_data__impl__fggpzb(other));
		  }
		  function ULong__compareTo_impl_38i7tu_0($this, other) {
		    return ULong__compareTo_impl_38i7tu($this.bf_1, other instanceof ULong ? other.bf_1 : THROW_CCE());
		  }
		  function ULong__toString_impl_f9au7k($this) {
		    return ulongToString(_ULong___get_data__impl__fggpzb($this));
		  }
		  function ULong__hashCode_impl_6hv2lb($this) {
		    return $this.hashCode();
		  }
		  function ULong__equals_impl_o0gnyb($this, other) {
		    if (!(other instanceof ULong))
		      return false;
		    var tmp0_other_with_cast = other instanceof ULong ? other.bf_1 : THROW_CCE();
		    if (!$this.equals(tmp0_other_with_cast))
		      return false;
		    return true;
		  }
		  function ULong(data) {
		    Companion_getInstance_15();
		    this.bf_1 = data;
		  }
		  protoOf(ULong).cf = function (other) {
		    return ULong__compareTo_impl_38i7tu(this.bf_1, other);
		  };
		  protoOf(ULong).i9 = function (other) {
		    return ULong__compareTo_impl_38i7tu_0(this, other);
		  };
		  protoOf(ULong).toString = function () {
		    return ULong__toString_impl_f9au7k(this.bf_1);
		  };
		  protoOf(ULong).hashCode = function () {
		    return ULong__hashCode_impl_6hv2lb(this.bf_1);
		  };
		  protoOf(ULong).equals = function (other) {
		    return ULong__equals_impl_o0gnyb(this.bf_1, other);
		  };
		  function _ULongArray___init__impl__twm1l3(storage) {
		    return storage;
		  }
		  function _ULongArray___get_storage__impl__28e64j($this) {
		    return $this;
		  }
		  function _ULongArray___init__impl__twm1l3_0(size) {
		    return _ULongArray___init__impl__twm1l3(longArray(size));
		  }
		  function ULongArray__get_impl_pr71q9($this, index) {
		    // Inline function 'kotlin.toULong' call
		    var this_0 = _ULongArray___get_storage__impl__28e64j($this)[index];
		    return _ULong___init__impl__c78o9k(this_0);
		  }
		  function ULongArray__set_impl_z19mvh($this, index, value) {
		    var tmp = _ULongArray___get_storage__impl__28e64j($this);
		    // Inline function 'kotlin.ULong.toLong' call
		    tmp[index] = _ULong___get_data__impl__fggpzb(value);
		  }
		  function _ULongArray___get_size__impl__ju6dtr($this) {
		    return _ULongArray___get_storage__impl__28e64j($this).length;
		  }
		  function ULongArray__iterator_impl_cq4d2h($this) {
		    return new Iterator_1(_ULongArray___get_storage__impl__28e64j($this));
		  }
		  function Iterator_1(array) {
		    this.df_1 = array;
		    this.ef_1 = 0;
		  }
		  protoOf(Iterator_1).q = function () {
		    return this.ef_1 < this.df_1.length;
		  };
		  protoOf(Iterator_1).ff = function () {
		    var tmp;
		    if (this.ef_1 < this.df_1.length) {
		      // Inline function 'kotlin.toULong' call
		      var tmp1 = this.ef_1;
		      this.ef_1 = tmp1 + 1 | 0;
		      var this_0 = this.df_1[tmp1];
		      tmp = _ULong___init__impl__c78o9k(this_0);
		    } else {
		      throw NoSuchElementException_init_$Create$_0(this.ef_1.toString());
		    }
		    return tmp;
		  };
		  protoOf(Iterator_1).s = function () {
		    return new ULong(this.ff());
		  };
		  function ULongArray__containsAll_impl_xx8ztf($this, elements) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.all' call
		      var this_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
		      var tmp;
		      if (isInterface(this_0, Collection)) {
		        tmp = this_0.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = true;
		        break $l$block_0;
		      }
		      var tmp0_iterator = this_0.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.ULongArray.containsAll.<anonymous>' call
		        var tmp_0;
		        if (element instanceof ULong) {
		          var tmp_1 = _ULongArray___get_storage__impl__28e64j($this);
		          // Inline function 'kotlin.ULong.toLong' call
		          var this_1 = element.bf_1;
		          var tmp$ret$1 = _ULong___get_data__impl__fggpzb(this_1);
		          tmp_0 = contains(tmp_1, tmp$ret$1);
		        } else {
		          tmp_0 = false;
		        }
		        if (!tmp_0) {
		          tmp$ret$0 = false;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  }
		  function ULongArray__containsAll_impl_xx8ztf_0($this, elements) {
		    return ULongArray__containsAll_impl_xx8ztf($this.gf_1, elements);
		  }
		  function ULongArray__isEmpty_impl_c3yngu($this) {
		    return _ULongArray___get_storage__impl__28e64j($this).length === 0;
		  }
		  function ULongArray__toString_impl_wqk1p5($this) {
		    return 'ULongArray(storage=' + toString_1($this) + ')';
		  }
		  function ULongArray__hashCode_impl_aze4wa($this) {
		    return hashCode($this);
		  }
		  function ULongArray__equals_impl_vwitwa($this, other) {
		    if (!(other instanceof ULongArray))
		      return false;
		    var tmp0_other_with_cast = other instanceof ULongArray ? other.gf_1 : THROW_CCE();
		    if (!equals_0($this, tmp0_other_with_cast))
		      return false;
		    return true;
		  }
		  function ULongArray(storage) {
		    this.gf_1 = storage;
		  }
		  protoOf(ULongArray).u = function () {
		    return _ULongArray___get_size__impl__ju6dtr(this.gf_1);
		  };
		  protoOf(ULongArray).p = function () {
		    return ULongArray__iterator_impl_cq4d2h(this.gf_1);
		  };
		  protoOf(ULongArray).hf = function (elements) {
		    return ULongArray__containsAll_impl_xx8ztf(this.gf_1, elements);
		  };
		  protoOf(ULongArray).w = function (elements) {
		    return ULongArray__containsAll_impl_xx8ztf_0(this, elements);
		  };
		  protoOf(ULongArray).x = function () {
		    return ULongArray__isEmpty_impl_c3yngu(this.gf_1);
		  };
		  protoOf(ULongArray).toString = function () {
		    return ULongArray__toString_impl_wqk1p5(this.gf_1);
		  };
		  protoOf(ULongArray).hashCode = function () {
		    return ULongArray__hashCode_impl_aze4wa(this.gf_1);
		  };
		  protoOf(ULongArray).equals = function (other) {
		    return ULongArray__equals_impl_vwitwa(this.gf_1, other);
		  };
		  function _UShort___init__impl__jigrne(data) {
		    return data;
		  }
		  function _UShort___get_data__impl__g0245($this) {
		    return $this;
		  }
		  function Companion_16() {
		    Companion_instance_16 = this;
		    this.if_1 = _UShort___init__impl__jigrne(0);
		    this.jf_1 = _UShort___init__impl__jigrne(-1);
		    this.kf_1 = 2;
		    this.lf_1 = 16;
		  }
		  var Companion_instance_16;
		  function Companion_getInstance_16() {
		    if (Companion_instance_16 == null)
		      new Companion_16();
		    return Companion_instance_16;
		  }
		  function UShort__compareTo_impl_1pfgyc($this, other) {
		    // Inline function 'kotlin.UShort.toInt' call
		    var tmp = _UShort___get_data__impl__g0245($this) & 65535;
		    // Inline function 'kotlin.UShort.toInt' call
		    var tmp$ret$1 = _UShort___get_data__impl__g0245(other) & 65535;
		    return compareTo(tmp, tmp$ret$1);
		  }
		  function UShort__compareTo_impl_1pfgyc_0($this, other) {
		    return UShort__compareTo_impl_1pfgyc($this.mf_1, other instanceof UShort ? other.mf_1 : THROW_CCE());
		  }
		  function UShort__toString_impl_edaoee($this) {
		    // Inline function 'kotlin.UShort.toInt' call
		    return (_UShort___get_data__impl__g0245($this) & 65535).toString();
		  }
		  function UShort__hashCode_impl_ywngrv($this) {
		    return $this;
		  }
		  function UShort__equals_impl_7t9pdz($this, other) {
		    if (!(other instanceof UShort))
		      return false;
		    if (!($this === (other instanceof UShort ? other.mf_1 : THROW_CCE())))
		      return false;
		    return true;
		  }
		  function UShort(data) {
		    Companion_getInstance_16();
		    this.mf_1 = data;
		  }
		  protoOf(UShort).nf = function (other) {
		    return UShort__compareTo_impl_1pfgyc(this.mf_1, other);
		  };
		  protoOf(UShort).i9 = function (other) {
		    return UShort__compareTo_impl_1pfgyc_0(this, other);
		  };
		  protoOf(UShort).toString = function () {
		    return UShort__toString_impl_edaoee(this.mf_1);
		  };
		  protoOf(UShort).hashCode = function () {
		    return UShort__hashCode_impl_ywngrv(this.mf_1);
		  };
		  protoOf(UShort).equals = function (other) {
		    return UShort__equals_impl_7t9pdz(this.mf_1, other);
		  };
		  function _UShortArray___init__impl__9b26ef(storage) {
		    return storage;
		  }
		  function _UShortArray___get_storage__impl__t2jpv5($this) {
		    return $this;
		  }
		  function _UShortArray___init__impl__9b26ef_0(size) {
		    return _UShortArray___init__impl__9b26ef(new Int16Array(size));
		  }
		  function UShortArray__get_impl_fnbhmx($this, index) {
		    // Inline function 'kotlin.toUShort' call
		    var this_0 = _UShortArray___get_storage__impl__t2jpv5($this)[index];
		    return _UShort___init__impl__jigrne(this_0);
		  }
		  function UShortArray__set_impl_6d8whp($this, index, value) {
		    var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
		    // Inline function 'kotlin.UShort.toShort' call
		    tmp[index] = _UShort___get_data__impl__g0245(value);
		  }
		  function _UShortArray___get_size__impl__jqto1b($this) {
		    return _UShortArray___get_storage__impl__t2jpv5($this).length;
		  }
		  function UShortArray__iterator_impl_ktpenn($this) {
		    return new Iterator_2(_UShortArray___get_storage__impl__t2jpv5($this));
		  }
		  function Iterator_2(array) {
		    this.of_1 = array;
		    this.pf_1 = 0;
		  }
		  protoOf(Iterator_2).q = function () {
		    return this.pf_1 < this.of_1.length;
		  };
		  protoOf(Iterator_2).qf = function () {
		    var tmp;
		    if (this.pf_1 < this.of_1.length) {
		      // Inline function 'kotlin.toUShort' call
		      var tmp1 = this.pf_1;
		      this.pf_1 = tmp1 + 1 | 0;
		      var this_0 = this.of_1[tmp1];
		      tmp = _UShort___init__impl__jigrne(this_0);
		    } else {
		      throw NoSuchElementException_init_$Create$_0(this.pf_1.toString());
		    }
		    return tmp;
		  };
		  protoOf(Iterator_2).s = function () {
		    return new UShort(this.qf());
		  };
		  function UShortArray__containsAll_impl_vlaaxp($this, elements) {
		    var tmp$ret$0;
		    $l$block_0: {
		      // Inline function 'kotlin.collections.all' call
		      var this_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
		      var tmp;
		      if (isInterface(this_0, Collection)) {
		        tmp = this_0.x();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$0 = true;
		        break $l$block_0;
		      }
		      var tmp0_iterator = this_0.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlin.UShortArray.containsAll.<anonymous>' call
		        var tmp_0;
		        if (element instanceof UShort) {
		          var tmp_1 = _UShortArray___get_storage__impl__t2jpv5($this);
		          // Inline function 'kotlin.UShort.toShort' call
		          var this_1 = element.mf_1;
		          var tmp$ret$1 = _UShort___get_data__impl__g0245(this_1);
		          tmp_0 = contains_1(tmp_1, tmp$ret$1);
		        } else {
		          tmp_0 = false;
		        }
		        if (!tmp_0) {
		          tmp$ret$0 = false;
		          break $l$block_0;
		        }
		      }
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  }
		  function UShortArray__containsAll_impl_vlaaxp_0($this, elements) {
		    return UShortArray__containsAll_impl_vlaaxp($this.rf_1, elements);
		  }
		  function UShortArray__isEmpty_impl_cdd9l0($this) {
		    return _UShortArray___get_storage__impl__t2jpv5($this).length === 0;
		  }
		  function UShortArray__toString_impl_omz03z($this) {
		    return 'UShortArray(storage=' + toString_1($this) + ')';
		  }
		  function UShortArray__hashCode_impl_2vt3b4($this) {
		    return hashCode($this);
		  }
		  function UShortArray__equals_impl_tyc3mk($this, other) {
		    if (!(other instanceof UShortArray))
		      return false;
		    var tmp0_other_with_cast = other instanceof UShortArray ? other.rf_1 : THROW_CCE();
		    if (!equals_0($this, tmp0_other_with_cast))
		      return false;
		    return true;
		  }
		  function UShortArray(storage) {
		    this.rf_1 = storage;
		  }
		  protoOf(UShortArray).u = function () {
		    return _UShortArray___get_size__impl__jqto1b(this.rf_1);
		  };
		  protoOf(UShortArray).p = function () {
		    return UShortArray__iterator_impl_ktpenn(this.rf_1);
		  };
		  protoOf(UShortArray).sf = function (elements) {
		    return UShortArray__containsAll_impl_vlaaxp(this.rf_1, elements);
		  };
		  protoOf(UShortArray).w = function (elements) {
		    return UShortArray__containsAll_impl_vlaaxp_0(this, elements);
		  };
		  protoOf(UShortArray).x = function () {
		    return UShortArray__isEmpty_impl_cdd9l0(this.rf_1);
		  };
		  protoOf(UShortArray).toString = function () {
		    return UShortArray__toString_impl_omz03z(this.rf_1);
		  };
		  protoOf(UShortArray).hashCode = function () {
		    return UShortArray__hashCode_impl_2vt3b4(this.rf_1);
		  };
		  protoOf(UShortArray).equals = function (other) {
		    return UShortArray__equals_impl_tyc3mk(this.rf_1, other);
		  };
		  function toUInt(_this__u8e3s4) {
		    var tmp0_elvis_lhs = toUIntOrNull(_this__u8e3s4);
		    var tmp;
		    var tmp_0 = tmp0_elvis_lhs;
		    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
		      numberFormatError(_this__u8e3s4);
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function toULong(_this__u8e3s4) {
		    var tmp0_elvis_lhs = toULongOrNull(_this__u8e3s4);
		    var tmp;
		    var tmp_0 = tmp0_elvis_lhs;
		    if ((tmp_0 == null ? null : new ULong(tmp_0)) == null) {
		      numberFormatError(_this__u8e3s4);
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function toUByte(_this__u8e3s4) {
		    var tmp0_elvis_lhs = toUByteOrNull(_this__u8e3s4);
		    var tmp;
		    var tmp_0 = tmp0_elvis_lhs;
		    if ((tmp_0 == null ? null : new UByte(tmp_0)) == null) {
		      numberFormatError(_this__u8e3s4);
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function toUShort(_this__u8e3s4) {
		    var tmp0_elvis_lhs = toUShortOrNull(_this__u8e3s4);
		    var tmp;
		    var tmp_0 = tmp0_elvis_lhs;
		    if ((tmp_0 == null ? null : new UShort(tmp_0)) == null) {
		      numberFormatError(_this__u8e3s4);
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function toULongOrNull(_this__u8e3s4) {
		    return toULongOrNull_0(_this__u8e3s4, 10);
		  }
		  function toUIntOrNull(_this__u8e3s4) {
		    return toUIntOrNull_0(_this__u8e3s4, 10);
		  }
		  function toUByteOrNull(_this__u8e3s4) {
		    return toUByteOrNull_0(_this__u8e3s4, 10);
		  }
		  function toUShortOrNull(_this__u8e3s4) {
		    return toUShortOrNull_0(_this__u8e3s4, 10);
		  }
		  function toULongOrNull_0(_this__u8e3s4, radix) {
		    checkRadix(radix);
		    var length = _this__u8e3s4.length;
		    if (length === 0)
		      return null;
		    Companion_getInstance_15();
		    var limit = _ULong___init__impl__c78o9k(new Long(-1, -1));
		    var start;
		    var firstChar = charSequenceGet(_this__u8e3s4, 0);
		    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
		      if (length === 1 ? true : !(firstChar === _Char___init__impl__6a9atx(43)))
		        return null;
		      start = 1;
		    } else {
		      start = 0;
		    }
		    var limitForMaxRadix = _ULong___init__impl__c78o9k(new Long(477218588, 119304647));
		    var limitBeforeMul = limitForMaxRadix;
		    // Inline function 'kotlin.toULong' call
		    var uradix = _ULong___init__impl__c78o9k(toLong_0(radix));
		    var result = _ULong___init__impl__c78o9k(new Long(0, 0));
		    var inductionVariable = start;
		    if (inductionVariable < length)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
		        if (digit < 0)
		          return null;
		        // Inline function 'kotlin.ULong.compareTo' call
		        var this_0 = result;
		        var other = limitBeforeMul;
		        if (ulongCompare(_ULong___get_data__impl__fggpzb(this_0), _ULong___get_data__impl__fggpzb(other)) > 0) {
		          if (equals_0(limitBeforeMul, limitForMaxRadix)) {
		            // Inline function 'kotlin.ULong.div' call
		            limitBeforeMul = ulongDivide(limit, uradix);
		            // Inline function 'kotlin.ULong.compareTo' call
		            var this_1 = result;
		            var other_0 = limitBeforeMul;
		            if (ulongCompare(_ULong___get_data__impl__fggpzb(this_1), _ULong___get_data__impl__fggpzb(other_0)) > 0) {
		              return null;
		            }
		          } else {
		            return null;
		          }
		        }
		        // Inline function 'kotlin.ULong.times' call
		        var this_2 = result;
		        result = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_2).l8(_ULong___get_data__impl__fggpzb(uradix)));
		        var beforeAdding = result;
		        // Inline function 'kotlin.ULong.plus' call
		        var this_3 = result;
		        // Inline function 'kotlin.toUInt' call
		        // Inline function 'kotlin.ULong.plus' call
		        // Inline function 'kotlin.UInt.toULong' call
		        var this_4 = _UInt___init__impl__l7qpdl(digit);
		        var other_1 = _ULong___init__impl__c78o9k(toLong_0(_UInt___get_data__impl__f0vqqw(this_4)).z9(new Long(-1, 0)));
		        result = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_3).r9(_ULong___get_data__impl__fggpzb(other_1)));
		        // Inline function 'kotlin.ULong.compareTo' call
		        var this_5 = result;
		        if (ulongCompare(_ULong___get_data__impl__fggpzb(this_5), _ULong___get_data__impl__fggpzb(beforeAdding)) < 0)
		          return null;
		      }
		       while (inductionVariable < length);
		    return result;
		  }
		  function toUIntOrNull_0(_this__u8e3s4, radix) {
		    checkRadix(radix);
		    var length = _this__u8e3s4.length;
		    if (length === 0)
		      return null;
		    Companion_getInstance_14();
		    var limit = _UInt___init__impl__l7qpdl(-1);
		    var start;
		    var firstChar = charSequenceGet(_this__u8e3s4, 0);
		    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
		      if (length === 1 ? true : !(firstChar === _Char___init__impl__6a9atx(43)))
		        return null;
		      start = 1;
		    } else {
		      start = 0;
		    }
		    var limitForMaxRadix = _UInt___init__impl__l7qpdl(119304647);
		    var limitBeforeMul = limitForMaxRadix;
		    // Inline function 'kotlin.toUInt' call
		    var uradix = _UInt___init__impl__l7qpdl(radix);
		    var result = _UInt___init__impl__l7qpdl(0);
		    var inductionVariable = start;
		    if (inductionVariable < length)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
		        if (digit < 0)
		          return null;
		        // Inline function 'kotlin.UInt.compareTo' call
		        var this_0 = result;
		        var other = limitBeforeMul;
		        if (uintCompare(_UInt___get_data__impl__f0vqqw(this_0), _UInt___get_data__impl__f0vqqw(other)) > 0) {
		          if (limitBeforeMul === limitForMaxRadix) {
		            // Inline function 'kotlin.UInt.div' call
		            limitBeforeMul = uintDivide(limit, uradix);
		            // Inline function 'kotlin.UInt.compareTo' call
		            var this_1 = result;
		            var other_0 = limitBeforeMul;
		            if (uintCompare(_UInt___get_data__impl__f0vqqw(this_1), _UInt___get_data__impl__f0vqqw(other_0)) > 0) {
		              return null;
		            }
		          } else {
		            return null;
		          }
		        }
		        // Inline function 'kotlin.UInt.times' call
		        var this_2 = result;
		        result = _UInt___init__impl__l7qpdl(imul(_UInt___get_data__impl__f0vqqw(this_2), _UInt___get_data__impl__f0vqqw(uradix)));
		        var beforeAdding = result;
		        // Inline function 'kotlin.UInt.plus' call
		        var this_3 = result;
		        // Inline function 'kotlin.toUInt' call
		        var other_1 = _UInt___init__impl__l7qpdl(digit);
		        result = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_3) + _UInt___get_data__impl__f0vqqw(other_1) | 0);
		        // Inline function 'kotlin.UInt.compareTo' call
		        var this_4 = result;
		        if (uintCompare(_UInt___get_data__impl__f0vqqw(this_4), _UInt___get_data__impl__f0vqqw(beforeAdding)) < 0)
		          return null;
		      }
		       while (inductionVariable < length);
		    return result;
		  }
		  function toUByteOrNull_0(_this__u8e3s4, radix) {
		    var tmp0_elvis_lhs = toUIntOrNull_0(_this__u8e3s4, radix);
		    var tmp;
		    var tmp_0 = tmp0_elvis_lhs;
		    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
		      return null;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var int = tmp;
		    // Inline function 'kotlin.UInt.compareTo' call
		    Companion_getInstance_13();
		    // Inline function 'kotlin.UInt.compareTo' call
		    // Inline function 'kotlin.UByte.toUInt' call
		    var this_0 = _UByte___init__impl__g9hnc4(-1);
		    var other = _UInt___init__impl__l7qpdl(_UByte___get_data__impl__jof9qr(this_0) & 255);
		    if (uintCompare(_UInt___get_data__impl__f0vqqw(int), _UInt___get_data__impl__f0vqqw(other)) > 0)
		      return null;
		    // Inline function 'kotlin.UInt.toUByte' call
		    // Inline function 'kotlin.toUByte' call
		    var this_1 = _UInt___get_data__impl__f0vqqw(int);
		    return _UByte___init__impl__g9hnc4(toByte(this_1));
		  }
		  function toUShortOrNull_0(_this__u8e3s4, radix) {
		    var tmp0_elvis_lhs = toUIntOrNull_0(_this__u8e3s4, radix);
		    var tmp;
		    var tmp_0 = tmp0_elvis_lhs;
		    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
		      return null;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var int = tmp;
		    // Inline function 'kotlin.UInt.compareTo' call
		    Companion_getInstance_16();
		    // Inline function 'kotlin.UInt.compareTo' call
		    // Inline function 'kotlin.UShort.toUInt' call
		    var this_0 = _UShort___init__impl__jigrne(-1);
		    var other = _UInt___init__impl__l7qpdl(_UShort___get_data__impl__g0245(this_0) & 65535);
		    if (uintCompare(_UInt___get_data__impl__f0vqqw(int), _UInt___get_data__impl__f0vqqw(other)) > 0)
		      return null;
		    // Inline function 'kotlin.UInt.toUShort' call
		    // Inline function 'kotlin.toUShort' call
		    var this_1 = _UInt___get_data__impl__f0vqqw(int);
		    return _UShort___init__impl__jigrne(toShort(this_1));
		  }
		  function uintCompare(v1, v2) {
		    return compareTo(v1 ^ IntCompanionObject_instance.MIN_VALUE, v2 ^ IntCompanionObject_instance.MIN_VALUE);
		  }
		  function uintDivide(v1, v2) {
		    // Inline function 'kotlin.toUInt' call
		    // Inline function 'kotlin.UInt.toLong' call
		    var tmp = toLong_0(_UInt___get_data__impl__f0vqqw(v1)).z9(new Long(-1, 0));
		    // Inline function 'kotlin.UInt.toLong' call
		    var tmp$ret$1 = toLong_0(_UInt___get_data__impl__f0vqqw(v2)).z9(new Long(-1, 0));
		    var this_0 = tmp.k8(tmp$ret$1);
		    return _UInt___init__impl__l7qpdl(this_0.ea());
		  }
		  function ulongCompare(v1, v2) {
		    Companion_getInstance_4();
		    var tmp = v1.ba(new Long(0, -2147483648));
		    Companion_getInstance_4();
		    return tmp.m8(v2.ba(new Long(0, -2147483648)));
		  }
		  function ulongDivide(v1, v2) {
		    // Inline function 'kotlin.ULong.toLong' call
		    var dividend = _ULong___get_data__impl__fggpzb(v1);
		    // Inline function 'kotlin.ULong.toLong' call
		    var divisor = _ULong___get_data__impl__fggpzb(v2);
		    if (divisor.m8(new Long(0, 0)) < 0) {
		      var tmp;
		      // Inline function 'kotlin.ULong.compareTo' call
		      if (ulongCompare(_ULong___get_data__impl__fggpzb(v1), _ULong___get_data__impl__fggpzb(v2)) < 0) {
		        tmp = _ULong___init__impl__c78o9k(new Long(0, 0));
		      } else {
		        tmp = _ULong___init__impl__c78o9k(new Long(1, 0));
		      }
		      return tmp;
		    }
		    if (dividend.m8(new Long(0, 0)) >= 0) {
		      return _ULong___init__impl__c78o9k(dividend.k8(divisor));
		    }
		    var quotient = dividend.y9(1).k8(divisor).w9(1);
		    var rem = dividend.s9(quotient.l8(divisor));
		    // Inline function 'kotlin.Long.plus' call
		    var tmp_0;
		    // Inline function 'kotlin.ULong.compareTo' call
		    var this_0 = _ULong___init__impl__c78o9k(rem);
		    var other = _ULong___init__impl__c78o9k(divisor);
		    if (ulongCompare(_ULong___get_data__impl__fggpzb(this_0), _ULong___get_data__impl__fggpzb(other)) >= 0) {
		      tmp_0 = 1;
		    } else {
		      tmp_0 = 0;
		    }
		    var other_0 = tmp_0;
		    var tmp$ret$4 = quotient.r9(toLong_0(other_0));
		    return _ULong___init__impl__c78o9k(tmp$ret$4);
		  }
		  function ulongToString(v) {
		    return ulongToString_0(v, 10);
		  }
		  function ulongToString_0(v, base) {
		    if (v.m8(new Long(0, 0)) >= 0)
		      return toString_2(v, base);
		    // Inline function 'kotlin.Long.div' call
		    var quotient = v.y9(1).k8(toLong_0(base)).w9(1);
		    // Inline function 'kotlin.Long.times' call
		    var tmp$ret$1 = quotient.l8(toLong_0(base));
		    var rem = v.s9(tmp$ret$1);
		    if (rem.m8(toLong_0(base)) >= 0) {
		      // Inline function 'kotlin.Long.minus' call
		      rem = rem.s9(toLong_0(base));
		      // Inline function 'kotlin.Long.plus' call
		      quotient = quotient.r9(toLong_0(1));
		    }
		    return toString_2(quotient, base) + toString_2(rem, base);
		  }
		  //region block: post-declaration
		  protoOf(InternalHashMap).h3 = containsAllEntries;
		  //endregion
		  //region block: init
		  Unit_instance = new Unit();
		  ByteCompanionObject_instance = new ByteCompanionObject();
		  ShortCompanionObject_instance = new ShortCompanionObject();
		  IntCompanionObject_instance = new IntCompanionObject();
		  FloatCompanionObject_instance = new FloatCompanionObject();
		  DoubleCompanionObject_instance = new DoubleCompanionObject();
		  StringCompanionObject_instance = new StringCompanionObject();
		  BooleanCompanionObject_instance = new BooleanCompanionObject();
		  Companion_instance_0 = new Companion_0();
		  Companion_instance_3 = new Companion_3();
		  CompletedContinuation_instance = new CompletedContinuation();
		  Companion_instance_5 = new Companion_5();
		  Companion_instance_6 = new Companion_6();
		  Companion_instance_7 = new Companion_7();
		  EmptyIterator_instance = new EmptyIterator();
		  Key_instance = new Key();
		  Companion_instance_10 = new Companion_10();
		  UNINITIALIZED_VALUE_instance = new UNINITIALIZED_VALUE();
		  Companion_instance_12 = new Companion_12();
		  //endregion
		  //region block: exports
		  _.$_$ = _.$_$ || {};
		  _.$_$.a = arrayConcat;
		  _.$_$.b = createKType;
		  _.$_$.c = findAssociatedObject;
		  _.$_$.d = getKClassFromExpression;
		  _.$_$.e = getKClass;
		  _.$_$.f = VOID;
		  _.$_$.g = LazyThreadSafetyMode_PUBLICATION_getInstance;
		  _.$_$.h = ArrayList_init_$Create$_0;
		  _.$_$.i = ArrayList_init_$Create$;
		  _.$_$.j = ArrayList_init_$Create$_1;
		  _.$_$.k = HashMap_init_$Create$_0;
		  _.$_$.l = HashMap_init_$Create$;
		  _.$_$.m = HashMap_init_$Create$_1;
		  _.$_$.n = HashSet_init_$Create$_1;
		  _.$_$.o = HashSet_init_$Create$;
		  _.$_$.p = HashSet_init_$Create$_0;
		  _.$_$.q = LinkedHashMap_init_$Create$_0;
		  _.$_$.r = LinkedHashMap_init_$Create$;
		  _.$_$.s = LinkedHashMap_init_$Create$_1;
		  _.$_$.t = LinkedHashSet_init_$Create$;
		  _.$_$.u = LinkedHashSet_init_$Create$_0;
		  _.$_$.v = Regex_init_$Create$;
		  _.$_$.w = StringBuilder_init_$Create$;
		  _.$_$.x = StringBuilder_init_$Create$_0;
		  _.$_$.y = Exception_init_$Create$_1;
		  _.$_$.z = Exception_init_$Init$;
		  _.$_$.a1 = Exception_init_$Init$_0;
		  _.$_$.b1 = Exception_init_$Create$_0;
		  _.$_$.c1 = Exception_init_$Init$_1;
		  _.$_$.d1 = IllegalArgumentException_init_$Init$_2;
		  _.$_$.e1 = IllegalArgumentException_init_$Init$;
		  _.$_$.f1 = IllegalArgumentException_init_$Create$;
		  _.$_$.g1 = IllegalArgumentException_init_$Init$_0;
		  _.$_$.h1 = IllegalArgumentException_init_$Create$_0;
		  _.$_$.i1 = IllegalArgumentException_init_$Init$_1;
		  _.$_$.j1 = IllegalStateException_init_$Create$_0;
		  _.$_$.k1 = IndexOutOfBoundsException_init_$Create$_0;
		  _.$_$.l1 = UnsupportedOperationException_init_$Create$_0;
		  _.$_$.m1 = Duration__toIsoString_impl_9h6wsm;
		  _.$_$.n1 = _Char___init__impl__6a9atx;
		  _.$_$.o1 = Char__minus_impl_a2frrh;
		  _.$_$.p1 = Char__toInt_impl_vasixd;
		  _.$_$.q1 = toString;
		  _.$_$.r1 = _Result___init__impl__xyqfz8;
		  _.$_$.s1 = Result__exceptionOrNull_impl_p6xea9;
		  _.$_$.t1 = _Result___get_isFailure__impl__jpiriv;
		  _.$_$.u1 = _Result___get_value__impl__bjfvqg;
		  _.$_$.v1 = _UByte___init__impl__g9hnc4;
		  _.$_$.w1 = _UByte___get_data__impl__jof9qr;
		  _.$_$.x1 = UByte__toString_impl_v72jg;
		  _.$_$.y1 = _UByteArray___init__impl__ip4y9n;
		  _.$_$.z1 = _UByteArray___init__impl__ip4y9n_0;
		  _.$_$.a2 = UByteArray__get_impl_t5f3hv;
		  _.$_$.b2 = UByteArray__set_impl_jvcicn;
		  _.$_$.c2 = _UByteArray___get_size__impl__h6pkdv;
		  _.$_$.d2 = _UByteArray___get_storage__impl__d4kctt;
		  _.$_$.e2 = _UInt___init__impl__l7qpdl;
		  _.$_$.f2 = _UInt___get_data__impl__f0vqqw;
		  _.$_$.g2 = UInt__toString_impl_dbgl21;
		  _.$_$.h2 = _UIntArray___init__impl__ghjpc6_0;
		  _.$_$.i2 = _UIntArray___init__impl__ghjpc6;
		  _.$_$.j2 = UIntArray__get_impl_gp5kza;
		  _.$_$.k2 = UIntArray__set_impl_7f2zu2;
		  _.$_$.l2 = _UIntArray___get_size__impl__r6l8ci;
		  _.$_$.m2 = _UIntArray___get_storage__impl__92a0v0;
		  _.$_$.n2 = _ULong___init__impl__c78o9k;
		  _.$_$.o2 = _ULong___get_data__impl__fggpzb;
		  _.$_$.p2 = ULong__toString_impl_f9au7k;
		  _.$_$.q2 = _ULongArray___init__impl__twm1l3_0;
		  _.$_$.r2 = _ULongArray___init__impl__twm1l3;
		  _.$_$.s2 = ULongArray__get_impl_pr71q9;
		  _.$_$.t2 = ULongArray__set_impl_z19mvh;
		  _.$_$.u2 = _ULongArray___get_size__impl__ju6dtr;
		  _.$_$.v2 = _ULongArray___get_storage__impl__28e64j;
		  _.$_$.w2 = _UShort___init__impl__jigrne;
		  _.$_$.x2 = _UShort___get_data__impl__g0245;
		  _.$_$.y2 = UShort__toString_impl_edaoee;
		  _.$_$.z2 = _UShortArray___init__impl__9b26ef_0;
		  _.$_$.a3 = _UShortArray___init__impl__9b26ef;
		  _.$_$.b3 = UShortArray__get_impl_fnbhmx;
		  _.$_$.c3 = UShortArray__set_impl_6d8whp;
		  _.$_$.d3 = _UShortArray___get_size__impl__jqto1b;
		  _.$_$.e3 = _UShortArray___get_storage__impl__t2jpv5;
		  _.$_$.f3 = BooleanCompanionObject_instance;
		  _.$_$.g3 = ByteCompanionObject_instance;
		  _.$_$.h3 = DoubleCompanionObject_instance;
		  _.$_$.i3 = FloatCompanionObject_instance;
		  _.$_$.j3 = IntCompanionObject_instance;
		  _.$_$.k3 = ShortCompanionObject_instance;
		  _.$_$.l3 = StringCompanionObject_instance;
		  _.$_$.m3 = Default_getInstance;
		  _.$_$.n3 = PrimitiveClasses_getInstance;
		  _.$_$.o3 = Companion_getInstance_11;
		  _.$_$.p3 = Companion_getInstance_2;
		  _.$_$.q3 = Companion_getInstance_4;
		  _.$_$.r3 = Companion_instance_12;
		  _.$_$.s3 = Companion_getInstance_13;
		  _.$_$.t3 = Companion_getInstance_14;
		  _.$_$.u3 = Companion_getInstance_15;
		  _.$_$.v3 = Companion_getInstance_16;
		  _.$_$.w3 = Unit_instance;
		  _.$_$.x3 = ArrayList;
		  _.$_$.y3 = Collection;
		  _.$_$.z3 = HashMap;
		  _.$_$.a4 = HashSet;
		  _.$_$.b4 = LinkedHashMap;
		  _.$_$.c4 = LinkedHashSet;
		  _.$_$.d4 = List;
		  _.$_$.e4 = Entry;
		  _.$_$.f4 = Map_0;
		  _.$_$.g4 = MutableList;
		  _.$_$.h4 = MutableMap;
		  _.$_$.i4 = MutableSet;
		  _.$_$.j4 = Set;
		  _.$_$.k4 = addAll;
		  _.$_$.l4 = asList;
		  _.$_$.m4 = collectionSizeOrDefault;
		  _.$_$.n4 = contentEquals_0;
		  _.$_$.o4 = contentHashCode;
		  _.$_$.p4 = contentToString;
		  _.$_$.q4 = copyOf_4;
		  _.$_$.r4 = copyOf_2;
		  _.$_$.s4 = copyOf_6;
		  _.$_$.t4 = copyOf;
		  _.$_$.u4 = copyOf_5;
		  _.$_$.v4 = copyOf_0;
		  _.$_$.w4 = copyOf_1;
		  _.$_$.x4 = copyOf_7;
		  _.$_$.y4 = copyOf_3;
		  _.$_$.z4 = copyToArray;
		  _.$_$.a5 = distinct;
		  _.$_$.b5 = emptyList;
		  _.$_$.c5 = emptyMap;
		  _.$_$.d5 = emptySet;
		  _.$_$.e5 = filterNotNull_0;
		  _.$_$.f5 = flatten;
		  _.$_$.g5 = getValue;
		  _.$_$.h5 = indexOf;
		  _.$_$.i5 = get_indices_0;
		  _.$_$.j5 = get_indices;
		  _.$_$.k5 = joinToString_0;
		  _.$_$.l5 = get_lastIndex_1;
		  _.$_$.m5 = get_lastIndex_2;
		  _.$_$.n5 = lastOrNull;
		  _.$_$.o5 = last;
		  _.$_$.p5 = listOfNotNull;
		  _.$_$.q5 = listOf;
		  _.$_$.r5 = listOf_0;
		  _.$_$.s5 = mapCapacity;
		  _.$_$.t5 = mapOf;
		  _.$_$.u5 = mapOf_0;
		  _.$_$.v5 = plus;
		  _.$_$.w5 = removeLast;
		  _.$_$.x5 = reversed;
		  _.$_$.y5 = setOf_0;
		  _.$_$.z5 = singleOrNull;
		  _.$_$.a6 = toBooleanArray;
		  _.$_$.b6 = toHashSet;
		  _.$_$.c6 = toList_0;
		  _.$_$.d6 = toList;
		  _.$_$.e6 = toMap;
		  _.$_$.f6 = withIndex;
		  _.$_$.g6 = zip;
		  _.$_$.h6 = get_COROUTINE_SUSPENDED;
		  _.$_$.i6 = CoroutineImpl;
		  _.$_$.j6 = arrayIterator;
		  _.$_$.k6 = booleanArray;
		  _.$_$.l6 = captureStack;
		  _.$_$.m6 = charArray;
		  _.$_$.n6 = charSequenceGet;
		  _.$_$.o6 = charSequenceLength;
		  _.$_$.p6 = charSequenceSubSequence;
		  _.$_$.q6 = classMeta;
		  _.$_$.r6 = defineProp;
		  _.$_$.s6 = equals_0;
		  _.$_$.t6 = extendThrowable;
		  _.$_$.u6 = fillArrayVal;
		  _.$_$.v6 = getBooleanHashCode;
		  _.$_$.w6 = getNumberHashCode;
		  _.$_$.x6 = getPropertyCallableRef;
		  _.$_$.y6 = getStringHashCode;
		  _.$_$.z6 = hashCode;
		  _.$_$.a7 = interfaceMeta;
		  _.$_$.b7 = isArray;
		  _.$_$.c7 = isBooleanArray;
		  _.$_$.d7 = isByteArray;
		  _.$_$.e7 = isCharArray;
		  _.$_$.f7 = isDoubleArray;
		  _.$_$.g7 = isFloatArray;
		  _.$_$.h7 = isIntArray;
		  _.$_$.i7 = isInterface;
		  _.$_$.j7 = isLongArray;
		  _.$_$.k7 = isNumber;
		  _.$_$.l7 = isShortArray;
		  _.$_$.m7 = get_js;
		  _.$_$.n7 = json;
		  _.$_$.o7 = longArray;
		  _.$_$.p7 = newThrowable;
		  _.$_$.q7 = numberRangeToNumber;
		  _.$_$.r7 = numberToChar;
		  _.$_$.s7 = numberToDouble;
		  _.$_$.t7 = numberToInt;
		  _.$_$.u7 = numberToLong;
		  _.$_$.v7 = objectCreate;
		  _.$_$.w7 = objectMeta;
		  _.$_$.x7 = protoOf;
		  _.$_$.y7 = setMetadataFor;
		  _.$_$.z7 = toByte;
		  _.$_$.a8 = toLong_0;
		  _.$_$.b8 = toShort;
		  _.$_$.c8 = toString_1;
		  _.$_$.d8 = coerceAtLeast;
		  _.$_$.e8 = coerceAtMost;
		  _.$_$.f8 = random;
		  _.$_$.g8 = step;
		  _.$_$.h8 = until;
		  _.$_$.i8 = KClass;
		  _.$_$.j8 = KProperty1;
		  _.$_$.k8 = KTypeParameter;
		  _.$_$.l8 = cast;
		  _.$_$.m8 = equals;
		  _.$_$.n8 = indexOf_4;
		  _.$_$.o8 = isBlank;
		  _.$_$.p8 = isLowerCase;
		  _.$_$.q8 = lastIndexOf;
		  _.$_$.r8 = removePrefix;
		  _.$_$.s8 = replaceFirst;
		  _.$_$.t8 = single_2;
		  _.$_$.u8 = slice;
		  _.$_$.v8 = split;
		  _.$_$.w8 = startsWith;
		  _.$_$.x8 = substringAfter;
		  _.$_$.y8 = titlecase;
		  _.$_$.z8 = toDoubleOrNull;
		  _.$_$.a9 = toDouble;
		  _.$_$.b9 = toIntOrNull;
		  _.$_$.c9 = toInt;
		  _.$_$.d9 = toLongOrNull;
		  _.$_$.e9 = toLong;
		  _.$_$.f9 = toUByte;
		  _.$_$.g9 = toUInt;
		  _.$_$.h9 = toULongOrNull;
		  _.$_$.i9 = toULong;
		  _.$_$.j9 = toUShort;
		  _.$_$.k9 = trimIndent;
		  _.$_$.l9 = Duration;
		  _.$_$.m9 = Char;
		  _.$_$.n9 = DeepRecursiveFunction;
		  _.$_$.o9 = DeepRecursiveScope;
		  _.$_$.p9 = Enum;
		  _.$_$.q9 = Exception;
		  _.$_$.r9 = IllegalArgumentException;
		  _.$_$.s9 = Long;
		  _.$_$.t9 = NotImplementedError;
		  _.$_$.u9 = Pair;
		  _.$_$.v9 = Result;
		  _.$_$.w9 = THROW_CCE;
		  _.$_$.x9 = THROW_IAE;
		  _.$_$.y9 = Triple;
		  _.$_$.z9 = UByteArray;
		  _.$_$.aa = UByte;
		  _.$_$.ba = UIntArray;
		  _.$_$.ca = UInt;
		  _.$_$.da = ULongArray;
		  _.$_$.ea = ULong;
		  _.$_$.fa = UShortArray;
		  _.$_$.ga = UShort;
		  _.$_$.ha = Unit;
		  _.$_$.ia = arrayOf;
		  _.$_$.ja = countTrailingZeroBits;
		  _.$_$.ka = createFailure;
		  _.$_$.la = ensureNotNull;
		  _.$_$.ma = invoke;
		  _.$_$.na = isFinite;
		  _.$_$.oa = isFinite_0;
		  _.$_$.pa = lazy;
		  _.$_$.qa = lazy_0;
		  _.$_$.ra = noWhenBranchMatchedException;
		  _.$_$.sa = plus_0;
		  _.$_$.ta = stackTraceToString;
		  _.$_$.ua = throwUninitializedPropertyAccessException;
		  _.$_$.va = toString_0;
		  _.$_$.wa = to;
		  //endregion
		  return _;
		}));

		
} (kotlinKotlinStdlib, kotlinKotlinStdlibExports));
	return kotlinKotlinStdlibExports;
}

var clientsdkClientcoreExports = {};
var clientsdkClientcore = {
  get exports(){ return clientsdkClientcoreExports; },
  set exports(v){ clientsdkClientcoreExports = v; },
};

var kotlinxSerializationKotlinxSerializationCoreJsIrExports = {};
var kotlinxSerializationKotlinxSerializationCoreJsIr = {
  get exports(){ return kotlinxSerializationKotlinxSerializationCoreJsIrExports; },
  set exports(v){ kotlinxSerializationKotlinxSerializationCoreJsIrExports = v; },
};

var hasRequiredKotlinxSerializationKotlinxSerializationCoreJsIr;

function requireKotlinxSerializationKotlinxSerializationCoreJsIr () {
	if (hasRequiredKotlinxSerializationKotlinxSerializationCoreJsIr) return kotlinxSerializationKotlinxSerializationCoreJsIrExports;
	hasRequiredKotlinxSerializationKotlinxSerializationCoreJsIr = 1;
	(function (module, exports) {
		(function (root, factory) {
		  if (typeof undefined === 'function' && undefined.amd)
		    undefined(['exports', './kotlin-kotlin-stdlib.js'], factory);
		  else if ('object' === 'object')
		    factory(module.exports, requireKotlinKotlinStdlib());
		  else {
		    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
		      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-core-js-ir'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-core-js-ir'.");
		    }
		    root['kotlinx-serialization-kotlinx-serialization-core-js-ir'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-core-js-ir'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-core-js-ir'], this['kotlin-kotlin-stdlib']);
		  }
		}(commonjsGlobal, function (_, kotlin_kotlin) {
		  'use strict';
		  //region block: imports
		  var imul = Math.imul;
		  var getKClass = kotlin_kotlin.$_$.e;
		  var VOID = kotlin_kotlin.$_$.f;
		  var protoOf = kotlin_kotlin.$_$.x7;
		  var THROW_CCE = kotlin_kotlin.$_$.w9;
		  var getStringHashCode = kotlin_kotlin.$_$.y6;
		  var classMeta = kotlin_kotlin.$_$.q6;
		  var setMetadataFor = kotlin_kotlin.$_$.y7;
		  var interfaceMeta = kotlin_kotlin.$_$.a7;
		  var StringCompanionObject_instance = kotlin_kotlin.$_$.l3;
		  var Unit_instance = kotlin_kotlin.$_$.w3;
		  var emptyList = kotlin_kotlin.$_$.b5;
		  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.g;
		  var lazy = kotlin_kotlin.$_$.pa;
		  var getKClassFromExpression = kotlin_kotlin.$_$.d;
		  var KProperty1 = kotlin_kotlin.$_$.j8;
		  var getPropertyCallableRef = kotlin_kotlin.$_$.x6;
		  var asList = kotlin_kotlin.$_$.l4;
		  var objectCreate = kotlin_kotlin.$_$.v7;
		  var distinct = kotlin_kotlin.$_$.a5;
		  var Entry = kotlin_kotlin.$_$.e4;
		  var isInterface = kotlin_kotlin.$_$.i7;
		  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.h1;
		  var zip = kotlin_kotlin.$_$.g6;
		  var toMap = kotlin_kotlin.$_$.e6;
		  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.r;
		  var toString = kotlin_kotlin.$_$.c8;
		  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.j1;
		  var mapCapacity = kotlin_kotlin.$_$.s5;
		  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.q;
		  var Map = kotlin_kotlin.$_$.f4;
		  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.e1;
		  var captureStack = kotlin_kotlin.$_$.l6;
		  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.g1;
		  var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.i1;
		  var IllegalArgumentException = kotlin_kotlin.$_$.r9;
		  var collectionSizeOrDefault = kotlin_kotlin.$_$.m4;
		  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
		  var KClass = kotlin_kotlin.$_$.i8;
		  var Triple = kotlin_kotlin.$_$.y9;
		  var Pair = kotlin_kotlin.$_$.u9;
		  var LinkedHashMap = kotlin_kotlin.$_$.b4;
		  var MutableMap = kotlin_kotlin.$_$.h4;
		  var HashMap = kotlin_kotlin.$_$.z3;
		  var LinkedHashSet = kotlin_kotlin.$_$.c4;
		  var MutableSet = kotlin_kotlin.$_$.i4;
		  var Set = kotlin_kotlin.$_$.j4;
		  var HashSet = kotlin_kotlin.$_$.a4;
		  var ArrayList = kotlin_kotlin.$_$.x3;
		  var MutableList = kotlin_kotlin.$_$.g4;
		  var List = kotlin_kotlin.$_$.d4;
		  var Collection = kotlin_kotlin.$_$.y3;
		  var copyToArray = kotlin_kotlin.$_$.z4;
		  var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.s1;
		  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.u1;
		  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.t1;
		  var Result = kotlin_kotlin.$_$.v9;
		  var ensureNotNull = kotlin_kotlin.$_$.la;
		  var equals = kotlin_kotlin.$_$.s6;
		  var isBlank = kotlin_kotlin.$_$.o8;
		  var toList = kotlin_kotlin.$_$.d6;
		  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.i;
		  var HashSet_init_$Create$ = kotlin_kotlin.$_$.o;
		  var toHashSet = kotlin_kotlin.$_$.b6;
		  var toBooleanArray = kotlin_kotlin.$_$.a6;
		  var withIndex = kotlin_kotlin.$_$.f6;
		  var to = kotlin_kotlin.$_$.wa;
		  var lazy_0 = kotlin_kotlin.$_$.qa;
		  var contentEquals = kotlin_kotlin.$_$.n4;
		  var until = kotlin_kotlin.$_$.h8;
		  var joinToString = kotlin_kotlin.$_$.k5;
		  var objectMeta = kotlin_kotlin.$_$.w7;
		  var Long = kotlin_kotlin.$_$.s9;
		  var Char = kotlin_kotlin.$_$.m9;
		  var Duration__toIsoString_impl_9h6wsm = kotlin_kotlin.$_$.m1;
		  var Duration = kotlin_kotlin.$_$.l9;
		  var Companion_getInstance = kotlin_kotlin.$_$.o3;
		  var toIntOrNull = kotlin_kotlin.$_$.b9;
		  var hashCode = kotlin_kotlin.$_$.z6;
		  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.j;
		  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.p;
		  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.t;
		  var LinkedHashSet_init_$Create$_0 = kotlin_kotlin.$_$.u;
		  var HashMap_init_$Create$ = kotlin_kotlin.$_$.l;
		  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.m;
		  var LinkedHashMap_init_$Create$_1 = kotlin_kotlin.$_$.s;
		  var isArray = kotlin_kotlin.$_$.b7;
		  var arrayIterator = kotlin_kotlin.$_$.j6;
		  var step = kotlin_kotlin.$_$.g8;
		  var getValue = kotlin_kotlin.$_$.g5;
		  var longArray = kotlin_kotlin.$_$.o7;
		  var Companion_getInstance_0 = kotlin_kotlin.$_$.q3;
		  var get_lastIndex = kotlin_kotlin.$_$.l5;
		  var countTrailingZeroBits = kotlin_kotlin.$_$.ja;
		  var indexOf = kotlin_kotlin.$_$.h5;
		  var contentToString = kotlin_kotlin.$_$.p4;
		  var Enum = kotlin_kotlin.$_$.p9;
		  var fillArrayVal = kotlin_kotlin.$_$.u6;
		  var HashSet_init_$Create$_1 = kotlin_kotlin.$_$.n;
		  var KTypeParameter = kotlin_kotlin.$_$.k8;
		  var booleanArray = kotlin_kotlin.$_$.k6;
		  var emptyMap = kotlin_kotlin.$_$.c5;
		  var contentHashCode = kotlin_kotlin.$_$.o4;
		  var Companion_getInstance_1 = kotlin_kotlin.$_$.p3;
		  var isCharArray = kotlin_kotlin.$_$.e7;
		  var charArray = kotlin_kotlin.$_$.m6;
		  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.h3;
		  var isDoubleArray = kotlin_kotlin.$_$.f7;
		  var FloatCompanionObject_instance = kotlin_kotlin.$_$.i3;
		  var isFloatArray = kotlin_kotlin.$_$.g7;
		  var isLongArray = kotlin_kotlin.$_$.j7;
		  var Companion_getInstance_2 = kotlin_kotlin.$_$.u3;
		  var _ULongArray___get_size__impl__ju6dtr = kotlin_kotlin.$_$.u2;
		  var ULongArray = kotlin_kotlin.$_$.da;
		  var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.q2;
		  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.n2;
		  var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.s2;
		  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.o2;
		  var IntCompanionObject_instance = kotlin_kotlin.$_$.j3;
		  var isIntArray = kotlin_kotlin.$_$.h7;
		  var Companion_getInstance_3 = kotlin_kotlin.$_$.t3;
		  var _UIntArray___get_size__impl__r6l8ci = kotlin_kotlin.$_$.l2;
		  var UIntArray = kotlin_kotlin.$_$.ba;
		  var _UIntArray___init__impl__ghjpc6 = kotlin_kotlin.$_$.h2;
		  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.e2;
		  var UIntArray__get_impl_gp5kza = kotlin_kotlin.$_$.j2;
		  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.f2;
		  var ShortCompanionObject_instance = kotlin_kotlin.$_$.k3;
		  var isShortArray = kotlin_kotlin.$_$.l7;
		  var Companion_getInstance_4 = kotlin_kotlin.$_$.v3;
		  var _UShortArray___get_size__impl__jqto1b = kotlin_kotlin.$_$.d3;
		  var UShortArray = kotlin_kotlin.$_$.fa;
		  var _UShortArray___init__impl__9b26ef = kotlin_kotlin.$_$.z2;
		  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.w2;
		  var UShortArray__get_impl_fnbhmx = kotlin_kotlin.$_$.b3;
		  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.x2;
		  var ByteCompanionObject_instance = kotlin_kotlin.$_$.g3;
		  var isByteArray = kotlin_kotlin.$_$.d7;
		  var Companion_getInstance_5 = kotlin_kotlin.$_$.s3;
		  var _UByteArray___get_size__impl__h6pkdv = kotlin_kotlin.$_$.c2;
		  var UByteArray = kotlin_kotlin.$_$.z9;
		  var _UByteArray___init__impl__ip4y9n = kotlin_kotlin.$_$.z1;
		  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.v1;
		  var UByteArray__get_impl_t5f3hv = kotlin_kotlin.$_$.a2;
		  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.w1;
		  var BooleanCompanionObject_instance = kotlin_kotlin.$_$.f3;
		  var isBooleanArray = kotlin_kotlin.$_$.c7;
		  var coerceAtLeast = kotlin_kotlin.$_$.d8;
		  var copyOf = kotlin_kotlin.$_$.t4;
		  var copyOf_0 = kotlin_kotlin.$_$.v4;
		  var copyOf_1 = kotlin_kotlin.$_$.w4;
		  var copyOf_2 = kotlin_kotlin.$_$.r4;
		  var _ULongArray___get_storage__impl__28e64j = kotlin_kotlin.$_$.v2;
		  var _ULongArray___init__impl__twm1l3_0 = kotlin_kotlin.$_$.r2;
		  var ULongArray__set_impl_z19mvh = kotlin_kotlin.$_$.t2;
		  var copyOf_3 = kotlin_kotlin.$_$.y4;
		  var _UIntArray___get_storage__impl__92a0v0 = kotlin_kotlin.$_$.m2;
		  var _UIntArray___init__impl__ghjpc6_0 = kotlin_kotlin.$_$.i2;
		  var UIntArray__set_impl_7f2zu2 = kotlin_kotlin.$_$.k2;
		  var copyOf_4 = kotlin_kotlin.$_$.q4;
		  var _UShortArray___get_storage__impl__t2jpv5 = kotlin_kotlin.$_$.e3;
		  var _UShortArray___init__impl__9b26ef_0 = kotlin_kotlin.$_$.a3;
		  var UShortArray__set_impl_6d8whp = kotlin_kotlin.$_$.c3;
		  var copyOf_5 = kotlin_kotlin.$_$.u4;
		  var _UByteArray___get_storage__impl__d4kctt = kotlin_kotlin.$_$.d2;
		  var _UByteArray___init__impl__ip4y9n_0 = kotlin_kotlin.$_$.y1;
		  var UByteArray__set_impl_jvcicn = kotlin_kotlin.$_$.b2;
		  var copyOf_6 = kotlin_kotlin.$_$.s4;
		  var Unit = kotlin_kotlin.$_$.ha;
		  var trimIndent = kotlin_kotlin.$_$.k9;
		  var equals_0 = kotlin_kotlin.$_$.m8;
		  var charSequenceLength = kotlin_kotlin.$_$.o6;
		  var charSequenceGet = kotlin_kotlin.$_$.n6;
		  var toString_0 = kotlin_kotlin.$_$.q1;
		  var titlecase = kotlin_kotlin.$_$.y8;
		  var isLowerCase = kotlin_kotlin.$_$.p8;
		  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.n3;
		  var ULong = kotlin_kotlin.$_$.ea;
		  var UInt = kotlin_kotlin.$_$.ca;
		  var UShort = kotlin_kotlin.$_$.ga;
		  var UByte = kotlin_kotlin.$_$.aa;
		  var mapOf = kotlin_kotlin.$_$.u5;
		  var last = kotlin_kotlin.$_$.o5;
		  var lastOrNull = kotlin_kotlin.$_$.n5;
		  var get_lastIndex_0 = kotlin_kotlin.$_$.m5;
		  var get_js = kotlin_kotlin.$_$.m7;
		  var findAssociatedObject = kotlin_kotlin.$_$.c;
		  var get_indices = kotlin_kotlin.$_$.j5;
		  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.k1;
		  var get_indices_0 = kotlin_kotlin.$_$.i5;
		  var Companion_instance = kotlin_kotlin.$_$.r3;
		  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.r1;
		  var createFailure = kotlin_kotlin.$_$.ka;
		  //endregion
		  //region block: pre-declaration
		  setMetadataFor(Serializable, 'Serializable', classMeta);
		  setMetadataFor(SerializationStrategy, 'SerializationStrategy', interfaceMeta);
		  setMetadataFor(DeserializationStrategy, 'DeserializationStrategy', interfaceMeta);
		  setMetadataFor(KSerializer, 'KSerializer', interfaceMeta, VOID, [SerializationStrategy, DeserializationStrategy]);
		  setMetadataFor(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(PolymorphicSerializer, 'PolymorphicSerializer', classMeta, AbstractPolymorphicSerializer);
		  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta);
		  setMetadataFor(SealedClassSerializer, 'SealedClassSerializer', classMeta, AbstractPolymorphicSerializer);
		  setMetadataFor(SerializationException, 'SerializationException', classMeta, IllegalArgumentException, VOID, SerializationException_init_$Create$);
		  setMetadataFor(MissingFieldException, 'MissingFieldException', classMeta, SerializationException);
		  setMetadataFor(UnknownFieldException, 'UnknownFieldException', classMeta, SerializationException);
		  function get_isNullable() {
		    return false;
		  }
		  function get_isInline() {
		    return false;
		  }
		  function get_annotations() {
		    return emptyList();
		  }
		  setMetadataFor(SerialDescriptor, 'SerialDescriptor', interfaceMeta);
		  setMetadataFor(ContextDescriptor, 'ContextDescriptor', classMeta, VOID, [SerialDescriptor]);
		  setMetadataFor(elementDescriptors$1$1, VOID, classMeta);
		  setMetadataFor(_no_name_provided__qut3iv_0, VOID, classMeta);
		  setMetadataFor(elementNames$1$1, VOID, classMeta);
		  setMetadataFor(_no_name_provided__qut3iv_1, VOID, classMeta);
		  setMetadataFor(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder', classMeta);
		  setMetadataFor(CachedNames, 'CachedNames', interfaceMeta);
		  setMetadataFor(SerialDescriptorImpl, 'SerialDescriptorImpl', classMeta, VOID, [SerialDescriptor, CachedNames]);
		  setMetadataFor(SerialKind, 'SerialKind', classMeta);
		  setMetadataFor(ENUM, 'ENUM', objectMeta, SerialKind);
		  setMetadataFor(CONTEXTUAL, 'CONTEXTUAL', objectMeta, SerialKind);
		  setMetadataFor(PrimitiveKind, 'PrimitiveKind', classMeta, SerialKind);
		  setMetadataFor(BOOLEAN, 'BOOLEAN', objectMeta, PrimitiveKind);
		  setMetadataFor(BYTE, 'BYTE', objectMeta, PrimitiveKind);
		  setMetadataFor(CHAR, 'CHAR', objectMeta, PrimitiveKind);
		  setMetadataFor(SHORT, 'SHORT', objectMeta, PrimitiveKind);
		  setMetadataFor(INT, 'INT', objectMeta, PrimitiveKind);
		  setMetadataFor(LONG, 'LONG', objectMeta, PrimitiveKind);
		  setMetadataFor(FLOAT, 'FLOAT', objectMeta, PrimitiveKind);
		  setMetadataFor(DOUBLE, 'DOUBLE', objectMeta, PrimitiveKind);
		  setMetadataFor(STRING, 'STRING', objectMeta, PrimitiveKind);
		  setMetadataFor(StructureKind, 'StructureKind', classMeta, SerialKind);
		  setMetadataFor(CLASS, 'CLASS', objectMeta, StructureKind);
		  setMetadataFor(LIST, 'LIST', objectMeta, StructureKind);
		  setMetadataFor(MAP, 'MAP', objectMeta, StructureKind);
		  setMetadataFor(OBJECT, 'OBJECT', objectMeta, StructureKind);
		  setMetadataFor(PolymorphicKind, 'PolymorphicKind', classMeta, SerialKind);
		  setMetadataFor(SEALED, 'SEALED', objectMeta, PolymorphicKind);
		  setMetadataFor(OPEN, 'OPEN', objectMeta, PolymorphicKind);
		  function decodeSerializableValue(deserializer) {
		    return deserializer.wf(this);
		  }
		  setMetadataFor(Decoder, 'Decoder', interfaceMeta);
		  function decodeSequentially() {
		    return false;
		  }
		  function decodeCollectionSize(descriptor) {
		    return -1;
		  }
		  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
		    previousValue = previousValue === VOID ? null : previousValue;
		    return $super === VOID ? this.qj(descriptor, index, deserializer, previousValue) : $super.qj.call(this, descriptor, index, deserializer, previousValue);
		  }
		  setMetadataFor(CompositeDecoder, 'CompositeDecoder', interfaceMeta);
		  setMetadataFor(AbstractDecoder, 'AbstractDecoder', classMeta, VOID, [Decoder, CompositeDecoder]);
		  function encodeNotNullMark() {
		  }
		  function beginCollection(descriptor, collectionSize) {
		    return this.ej(descriptor);
		  }
		  function encodeSerializableValue(serializer, value) {
		    serializer.vf(this, value);
		  }
		  function encodeNullableSerializableValue(serializer, value) {
		    var isNullabilitySupported = serializer.uf().eh();
		    if (isNullabilitySupported) {
		      return this.wk(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
		    }
		    if (value == null) {
		      this.zj();
		    } else {
		      this.zk();
		      this.wk(serializer, value);
		    }
		  }
		  setMetadataFor(Encoder, 'Encoder', interfaceMeta);
		  function shouldEncodeElementDefault(descriptor, index) {
		    return true;
		  }
		  setMetadataFor(CompositeEncoder, 'CompositeEncoder', interfaceMeta);
		  setMetadataFor(AbstractEncoder, 'AbstractEncoder', classMeta, VOID, [Encoder, CompositeEncoder]);
		  setMetadataFor(Companion, 'Companion', objectMeta);
		  setMetadataFor(DurationSerializer, 'DurationSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(ListLikeDescriptor, 'ListLikeDescriptor', classMeta, VOID, [SerialDescriptor]);
		  setMetadataFor(ArrayListClassDesc, 'ArrayListClassDesc', classMeta, ListLikeDescriptor);
		  setMetadataFor(HashSetClassDesc, 'HashSetClassDesc', classMeta, ListLikeDescriptor);
		  setMetadataFor(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', classMeta, ListLikeDescriptor);
		  setMetadataFor(MapLikeDescriptor, 'MapLikeDescriptor', classMeta, VOID, [SerialDescriptor]);
		  setMetadataFor(HashMapClassDesc, 'HashMapClassDesc', classMeta, MapLikeDescriptor);
		  setMetadataFor(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', classMeta, MapLikeDescriptor);
		  setMetadataFor(ArrayClassDesc, 'ArrayClassDesc', classMeta, ListLikeDescriptor);
		  setMetadataFor(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', classMeta, ListLikeDescriptor);
		  setMetadataFor(AbstractCollectionSerializer, 'AbstractCollectionSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(CollectionLikeSerializer, 'CollectionLikeSerializer', classMeta, AbstractCollectionSerializer);
		  setMetadataFor(CollectionSerializer, 'CollectionSerializer', classMeta, CollectionLikeSerializer);
		  setMetadataFor(ArrayListSerializer, 'ArrayListSerializer', classMeta, CollectionSerializer);
		  setMetadataFor(HashSetSerializer, 'HashSetSerializer', classMeta, CollectionSerializer);
		  setMetadataFor(LinkedHashSetSerializer, 'LinkedHashSetSerializer', classMeta, CollectionSerializer);
		  setMetadataFor(MapLikeSerializer, 'MapLikeSerializer', classMeta, AbstractCollectionSerializer);
		  setMetadataFor(HashMapSerializer, 'HashMapSerializer', classMeta, MapLikeSerializer);
		  setMetadataFor(LinkedHashMapSerializer, 'LinkedHashMapSerializer', classMeta, MapLikeSerializer);
		  setMetadataFor(ReferenceArraySerializer, 'ReferenceArraySerializer', classMeta, CollectionLikeSerializer);
		  setMetadataFor(PrimitiveArraySerializer, 'PrimitiveArraySerializer', classMeta, CollectionLikeSerializer);
		  setMetadataFor(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder', classMeta);
		  setMetadataFor(Companion_0, 'Companion', objectMeta);
		  setMetadataFor(ElementMarker, 'ElementMarker', classMeta);
		  setMetadataFor(EnumSerializer, 'EnumSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', classMeta, VOID, [SerialDescriptor, CachedNames]);
		  setMetadataFor(EnumDescriptor, 'EnumDescriptor', classMeta, PluginGeneratedSerialDescriptor);
		  setMetadataFor(InlineClassDescriptor, 'InlineClassDescriptor', classMeta, PluginGeneratedSerialDescriptor);
		  function typeParametersSerializers() {
		    return get_EMPTY_SERIALIZER_ARRAY();
		  }
		  setMetadataFor(GeneratedSerializer, 'GeneratedSerializer', interfaceMeta, VOID, [KSerializer]);
		  setMetadataFor(InlinePrimitiveDescriptor$1, VOID, classMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(NoOpEncoder, 'NoOpEncoder', objectMeta, AbstractEncoder);
		  setMetadataFor(NullableSerializer, 'NullableSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(SerialDescriptorForNullable, 'SerialDescriptorForNullable', classMeta, VOID, [SerialDescriptor, CachedNames]);
		  setMetadataFor(ObjectSerializer, 'ObjectSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(SerializerFactory, 'SerializerFactory', interfaceMeta);
		  setMetadataFor(CharArraySerializer_0, 'CharArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(DoubleArraySerializer_0, 'DoubleArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(FloatArraySerializer_0, 'FloatArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(LongArraySerializer_0, 'LongArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(ULongArraySerializer_0, 'ULongArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(IntArraySerializer_0, 'IntArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(UIntArraySerializer_0, 'UIntArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(ShortArraySerializer_0, 'ShortArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(UShortArraySerializer_0, 'UShortArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(ByteArraySerializer_0, 'ByteArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(UByteArraySerializer_0, 'UByteArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(BooleanArraySerializer_0, 'BooleanArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
		  setMetadataFor(CharArrayBuilder, 'CharArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(DoubleArrayBuilder, 'DoubleArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(FloatArrayBuilder, 'FloatArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(LongArrayBuilder, 'LongArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(ULongArrayBuilder, 'ULongArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(IntArrayBuilder, 'IntArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(UIntArrayBuilder, 'UIntArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(ShortArrayBuilder, 'ShortArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(UShortArrayBuilder, 'UShortArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(ByteArrayBuilder, 'ByteArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(UByteArrayBuilder, 'UByteArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(BooleanArrayBuilder, 'BooleanArrayBuilder', classMeta, PrimitiveArrayBuilder);
		  setMetadataFor(StringSerializer, 'StringSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(CharSerializer, 'CharSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(DoubleSerializer, 'DoubleSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(FloatSerializer, 'FloatSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(LongSerializer, 'LongSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(IntSerializer, 'IntSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(ShortSerializer, 'ShortSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(ByteSerializer, 'ByteSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(BooleanSerializer, 'BooleanSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(UnitSerializer, 'UnitSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', classMeta, VOID, [SerialDescriptor]);
		  setMetadataFor(TaggedEncoder, 'TaggedEncoder', classMeta, VOID, [Encoder, CompositeEncoder]);
		  setMetadataFor(NamedValueEncoder, 'NamedValueEncoder', classMeta, TaggedEncoder);
		  setMetadataFor(TaggedDecoder, 'TaggedDecoder', classMeta, VOID, [Decoder, CompositeDecoder]);
		  setMetadataFor(NamedValueDecoder, 'NamedValueDecoder', classMeta, TaggedDecoder);
		  setMetadataFor(MapEntry, 'MapEntry', classMeta, VOID, [Entry]);
		  setMetadataFor(KeyValueSerializer, 'KeyValueSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(MapEntrySerializer_0, 'MapEntrySerializer', classMeta, KeyValueSerializer);
		  setMetadataFor(PairSerializer_0, 'PairSerializer', classMeta, KeyValueSerializer);
		  setMetadataFor(TripleSerializer_0, 'TripleSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(ULongSerializer, 'ULongSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(UIntSerializer, 'UIntSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(UShortSerializer, 'UShortSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(UByteSerializer, 'UByteSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(SerializersModule, 'SerializersModule', classMeta);
		  setMetadataFor(SerialModuleImpl, 'SerialModuleImpl', classMeta, SerializersModule);
		  setMetadataFor(ContextualProvider, 'ContextualProvider', classMeta);
		  setMetadataFor(Argless, 'Argless', classMeta, ContextualProvider);
		  setMetadataFor(WithTypeArguments, 'WithTypeArguments', classMeta, ContextualProvider);
		  function contextual(kClass, serializer) {
		    return this.f10(kClass, SerializersModuleCollector$contextual$lambda(serializer));
		  }
		  setMetadataFor(SerializersModuleCollector, 'SerializersModuleCollector', interfaceMeta);
		  setMetadataFor(SerializableWith, 'SerializableWith', classMeta, VOID, VOID, VOID, 0);
		  setMetadataFor(createCache$1, VOID, classMeta);
		  setMetadataFor(createParametrizedCache$1, VOID, classMeta);
		  //endregion
		  function Serializable(with_0) {
		    with_0 = with_0 === VOID ? getKClass(KSerializer) : with_0;
		    this.tf_1 = with_0;
		  }
		  protoOf(Serializable).equals = function (other) {
		    if (!(other instanceof Serializable))
		      return false;
		    var tmp0_other_with_cast = other instanceof Serializable ? other : THROW_CCE();
		    if (!this.tf_1.equals(tmp0_other_with_cast.tf_1))
		      return false;
		    return true;
		  };
		  protoOf(Serializable).hashCode = function () {
		    return imul(getStringHashCode('with'), 127) ^ this.tf_1.hashCode();
		  };
		  protoOf(Serializable).toString = function () {
		    return '@kotlinx.serialization.Serializable(with=' + this.tf_1 + ')';
		  };
		  function KSerializer() {
		  }
		  function SerializationStrategy() {
		  }
		  function DeserializationStrategy() {
		  }
		  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
		    return function ($this$buildSerialDescriptor) {
		      $this$buildSerialDescriptor.fg('type', serializer_0(StringCompanionObject_instance).uf());
		      $this$buildSerialDescriptor.fg('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.gg_1.t5() + '>', CONTEXTUAL_getInstance(), []));
		      $this$buildSerialDescriptor.zf_1 = this$0.hg_1;
		      return Unit_instance;
		    };
		  }
		  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
		    return function () {
		      var tmp = OPEN_getInstance();
		      return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.gg_1);
		    };
		  }
		  function PolymorphicSerializer(baseClass) {
		    AbstractPolymorphicSerializer.call(this);
		    this.gg_1 = baseClass;
		    this.hg_1 = emptyList();
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.ig_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
		  }
		  protoOf(PolymorphicSerializer).jg = function () {
		    return this.gg_1;
		  };
		  protoOf(PolymorphicSerializer).uf = function () {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = this.ig_1;
		    descriptor$factory();
		    return this_0.w1();
		  };
		  protoOf(PolymorphicSerializer).toString = function () {
		    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + this.gg_1 + ')';
		  };
		  function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
		    var tmp0_elvis_lhs = _this__u8e3s4.mg(encoder, value);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.jg());
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
		    var tmp0_elvis_lhs = _this__u8e3s4.lg(decoder, klassName);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.jg());
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function descriptor$factory() {
		    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
		      return receiver.uf();
		    }, null);
		  }
		  function SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, $this) {
		    SealedClassSerializer.call($this, serialName, baseClass, subclasses, subclassSerializers);
		    $this.og_1 = asList(classAnnotations);
		    return $this;
		  }
		  function SealedClassSerializer_init_$Create$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
		    return SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, objectCreate(protoOf(SealedClassSerializer)));
		  }
		  function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda($subclassSerializers) {
		    return function ($this$buildSerialDescriptor) {
		      var tmp0_iterator = distinct($subclassSerializers).p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlinx.serialization.SealedClassSerializer.descriptor$delegate.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
		        var d = element.uf();
		        $this$buildSerialDescriptor.fg(d.sg(), d);
		      }
		      return Unit_instance;
		    };
		  }
		  function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0, $subclassSerializers) {
		    return function ($this$buildSerialDescriptor) {
		      $this$buildSerialDescriptor.fg('type', serializer_0(StringCompanionObject_instance).uf());
		      var tmp = 'kotlinx.serialization.Sealed<' + this$0.ng_1.t5() + '>';
		      var tmp_0 = CONTEXTUAL_getInstance();
		      var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda($subclassSerializers));
		      $this$buildSerialDescriptor.fg('value', elementDescriptor);
		      $this$buildSerialDescriptor.zf_1 = this$0.og_1;
		      return Unit_instance;
		    };
		  }
		  function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0, $subclassSerializers) {
		    return function () {
		      var tmp = SEALED_getInstance();
		      return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0, $subclassSerializers));
		    };
		  }
		  function _no_name_provided__qut3iv($this) {
		    this.tg_1 = $this;
		  }
		  protoOf(_no_name_provided__qut3iv).ug = function () {
		    return this.tg_1.p();
		  };
		  protoOf(_no_name_provided__qut3iv).vg = function (element) {
		    // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
		    return element.w1().uf().sg();
		  };
		  protoOf(_no_name_provided__qut3iv).wg = function (element) {
		    return this.vg((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
		  };
		  function SealedClassSerializer(serialName, baseClass, subclasses, subclassSerializers) {
		    AbstractPolymorphicSerializer.call(this);
		    this.ng_1 = baseClass;
		    this.og_1 = emptyList();
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.pg_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, this, subclassSerializers));
		    if (!(subclasses.length === subclassSerializers.length)) {
		      throw IllegalArgumentException_init_$Create$('All subclasses of sealed class ' + this.ng_1.t5() + ' should be marked @Serializable');
		    }
		    this.qg_1 = toMap(zip(subclasses, subclassSerializers));
		    var tmp_1 = this;
		    // Inline function 'kotlin.collections.mapValues' call
		    // Inline function 'kotlin.collections.aggregate' call
		    // Inline function 'kotlin.collections.groupingBy' call
		    var this_0 = this.qg_1.u1();
		    // Inline function 'kotlin.collections.aggregateTo' call
		    var this_1 = new _no_name_provided__qut3iv(this_0);
		    // Inline function 'kotlin.collections.mutableMapOf' call
		    var destination = LinkedHashMap_init_$Create$();
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator = this_1.ug();
		    while (tmp0_iterator.q()) {
		      var e = tmp0_iterator.s();
		      var key = this_1.wg(e);
		      var accumulator = destination.c2(key);
		      // Inline function 'kotlin.collections.set' call
		      // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
		      accumulator == null && !destination.z1(key);
		      if (!(accumulator == null)) {
		        // Inline function 'kotlin.error' call
		        var message = "Multiple sealed subclasses of '" + this.ng_1 + "' have the same serial name '" + key + "':" + (" '" + accumulator.v1() + "', '" + e.v1() + "'");
		        throw IllegalStateException_init_$Create$(toString(message));
		      }
		      destination.s1(key, e);
		    }
		    // Inline function 'kotlin.collections.mapValuesTo' call
		    var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.u()));
		    // Inline function 'kotlin.collections.associateByTo' call
		    var tmp0_iterator_0 = destination.u1().p();
		    while (tmp0_iterator_0.q()) {
		      var element = tmp0_iterator_0.s();
		      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
		      var tmp_2 = element.v1();
		      // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
		      var tmp$ret$7 = element.w1().w1();
		      destination_0.s1(tmp_2, tmp$ret$7);
		    }
		    tmp_1.rg_1 = destination_0;
		  }
		  protoOf(SealedClassSerializer).jg = function () {
		    return this.ng_1;
		  };
		  protoOf(SealedClassSerializer).uf = function () {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = this.pg_1;
		    descriptor$factory_0();
		    return this_0.w1();
		  };
		  protoOf(SealedClassSerializer).lg = function (decoder, klassName) {
		    // Inline function 'kotlin.collections.get' call
		    var this_0 = this.rg_1;
		    var tmp0_elvis_lhs = (isInterface(this_0, Map) ? this_0 : THROW_CCE()).c2(klassName);
		    return tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).lg.call(this, decoder, klassName) : tmp0_elvis_lhs;
		  };
		  protoOf(SealedClassSerializer).mg = function (encoder, value) {
		    var tmp0_elvis_lhs = this.qg_1.c2(getKClassFromExpression(value));
		    var tmp1_safe_receiver = tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).mg.call(this, encoder, value) : tmp0_elvis_lhs;
		    var tmp;
		    if (tmp1_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlinx.serialization.internal.cast' call
		      tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
		    }
		    return tmp;
		  };
		  function descriptor$factory_0() {
		    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
		      return receiver.uf();
		    }, null);
		  }
		  function SerializationException_init_$Init$($this) {
		    IllegalArgumentException_init_$Init$($this);
		    SerializationException.call($this);
		    return $this;
		  }
		  function SerializationException_init_$Create$() {
		    var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
		    captureStack(tmp, SerializationException_init_$Create$);
		    return tmp;
		  }
		  function SerializationException_init_$Init$_0(message, $this) {
		    IllegalArgumentException_init_$Init$_0(message, $this);
		    SerializationException.call($this);
		    return $this;
		  }
		  function SerializationException_init_$Create$_0(message) {
		    var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
		    captureStack(tmp, SerializationException_init_$Create$_0);
		    return tmp;
		  }
		  function SerializationException_init_$Init$_1(message, cause, $this) {
		    IllegalArgumentException_init_$Init$_1(message, cause, $this);
		    SerializationException.call($this);
		    return $this;
		  }
		  function SerializationException() {
		    captureStack(this, SerializationException);
		  }
		  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
		    MissingFieldException.call($this, missingFields, missingFields.u() === 1 ? "Field '" + missingFields.b1(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + missingFields + " are required for type with serial name '" + serialName + "', but they were missing", null);
		    return $this;
		  }
		  function MissingFieldException_init_$Create$(missingFields, serialName) {
		    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
		    captureStack(tmp, MissingFieldException_init_$Create$);
		    return tmp;
		  }
		  function MissingFieldException(missingFields, message, cause) {
		    SerializationException_init_$Init$_1(message, cause, this);
		    captureStack(this, MissingFieldException);
		    this.xg_1 = missingFields;
		  }
		  function UnknownFieldException_init_$Init$(index, $this) {
		    UnknownFieldException.call($this, 'An unknown field for index ' + index);
		    return $this;
		  }
		  function UnknownFieldException_init_$Create$(index) {
		    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
		    captureStack(tmp, UnknownFieldException_init_$Create$);
		    return tmp;
		  }
		  function UnknownFieldException(message) {
		    SerializationException_init_$Init$_0(message, this);
		    captureStack(this, UnknownFieldException);
		  }
		  function serializerOrNull(_this__u8e3s4) {
		    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
		    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
		  }
		  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
		    var tmp;
		    if (failOnMissingTypeArgSerializer) {
		      // Inline function 'kotlin.collections.map' call
		      // Inline function 'kotlin.collections.mapTo' call
		      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
		      var tmp0_iterator = typeArguments.p();
		      while (tmp0_iterator.q()) {
		        var item = tmp0_iterator.s();
		        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
		        var tmp$ret$0 = serializer(_this__u8e3s4, item);
		        destination.m(tmp$ret$0);
		      }
		      tmp = destination;
		    } else {
		      // Inline function 'kotlin.collections.map' call
		      // Inline function 'kotlin.collections.mapTo' call
		      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
		      var tmp0_iterator_0 = typeArguments.p();
		      while (tmp0_iterator_0.q()) {
		        var item_0 = tmp0_iterator_0.s();
		        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
		        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
		        var tmp_0;
		        if (tmp0_elvis_lhs == null) {
		          return null;
		        } else {
		          tmp_0 = tmp0_elvis_lhs;
		        }
		        var tmp$ret$3 = tmp_0;
		        destination_0.m(tmp$ret$3);
		      }
		      tmp = destination_0;
		    }
		    var serializers = tmp;
		    return serializers;
		  }
		  function parametrizedSerializerOrNull(_this__u8e3s4, types, serializers) {
		    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, types, serializers);
		    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
		  }
		  function serializer(_this__u8e3s4, type) {
		    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      platformSpecificSerializerNotRegistered(kclass(type));
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function serializerOrNull_0(_this__u8e3s4, type) {
		    return serializerByKTypeImpl(_this__u8e3s4, type, false);
		  }
		  function builtinParametrizedSerializer(_this__u8e3s4, typeArguments, serializers) {
		    var tmp;
		    if (((_this__u8e3s4.equals(getKClass(Collection)) ? true : _this__u8e3s4.equals(getKClass(List))) ? true : _this__u8e3s4.equals(getKClass(MutableList))) ? true : _this__u8e3s4.equals(getKClass(ArrayList))) {
		      tmp = new ArrayListSerializer(serializers.b1(0));
		    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
		      tmp = new HashSetSerializer(serializers.b1(0));
		    } else if ((_this__u8e3s4.equals(getKClass(Set)) ? true : _this__u8e3s4.equals(getKClass(MutableSet))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashSet))) {
		      tmp = new LinkedHashSetSerializer(serializers.b1(0));
		    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
		      tmp = new HashMapSerializer(serializers.b1(0), serializers.b1(1));
		    } else if ((_this__u8e3s4.equals(getKClass(Map)) ? true : _this__u8e3s4.equals(getKClass(MutableMap))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashMap))) {
		      tmp = new LinkedHashMapSerializer(serializers.b1(0), serializers.b1(1));
		    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
		      tmp = MapEntrySerializer(serializers.b1(0), serializers.b1(1));
		    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
		      tmp = PairSerializer(serializers.b1(0), serializers.b1(1));
		    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
		      tmp = TripleSerializer(serializers.b1(0), serializers.b1(1), serializers.b1(2));
		    } else {
		      var tmp_0;
		      if (isReferenceArray(_this__u8e3s4)) {
		        var tmp_1 = typeArguments.b1(0).f6();
		        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.b1(0));
		      } else {
		        tmp_0 = null;
		      }
		      tmp = tmp_0;
		    }
		    return tmp;
		  }
		  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
		    // Inline function 'kotlin.collections.toTypedArray' call
		    var tmp$ret$0 = copyToArray(serializers);
		    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
		  }
		  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
		    var rootClass = kclass(type);
		    var isNullable = type.h6();
		    // Inline function 'kotlin.collections.map' call
		    var this_0 = type.g6();
		    // Inline function 'kotlin.collections.mapTo' call
		    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
		    var tmp0_iterator = this_0.p();
		    while (tmp0_iterator.q()) {
		      var item = tmp0_iterator.s();
		      // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>' call
		      var tmp$ret$1;
		      $l$block: {
		        // Inline function 'kotlin.requireNotNull' call
		        var value = item.zg_1;
		        // Inline function 'kotlin.contracts.contract' call
		        if (value == null) {
		          // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>.<anonymous>' call
		          var message = 'Star projections in type arguments are not allowed, but had ' + type;
		          throw IllegalArgumentException_init_$Create$(toString(message));
		        } else {
		          tmp$ret$1 = value;
		          break $l$block;
		        }
		      }
		      var tmp$ret$2 = tmp$ret$1;
		      destination.m(tmp$ret$2);
		    }
		    var typeArguments = destination;
		    var tmp;
		    if (typeArguments.x()) {
		      tmp = findCachedSerializer(rootClass, isNullable);
		    } else {
		      var cachedResult = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
		      var tmp_0;
		      if (failOnMissingTypeArgSerializer) {
		        // Inline function 'kotlin.Result.getOrNull' call
		        var tmp_1;
		        if (_Result___get_isFailure__impl__jpiriv(cachedResult)) {
		          tmp_1 = null;
		        } else {
		          var tmp_2 = _Result___get_value__impl__bjfvqg(cachedResult);
		          tmp_1 = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
		        }
		        tmp_0 = tmp_1;
		      } else {
		        // Inline function 'kotlin.getOrElse' call
		        // Inline function 'kotlin.contracts.contract' call
		        var exception = Result__exceptionOrNull_impl_p6xea9(cachedResult);
		        var tmp_3;
		        if (exception == null) {
		          var tmp_4 = _Result___get_value__impl__bjfvqg(cachedResult);
		          tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
		        } else {
		          return null;
		        }
		        tmp_0 = tmp_3;
		      }
		      tmp = tmp_0;
		    }
		    var cachedSerializer = tmp;
		    if (cachedSerializer == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      return cachedSerializer;
		    }
		    var tmp_5;
		    if (typeArguments.x()) {
		      tmp_5 = _this__u8e3s4.bh(rootClass);
		    } else {
		      var tmp1_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
		      var tmp_6;
		      if (tmp1_elvis_lhs == null) {
		        return null;
		      } else {
		        tmp_6 = tmp1_elvis_lhs;
		      }
		      var serializers = tmp_6;
		      var tmp2_elvis_lhs = parametrizedSerializerOrNull(rootClass, typeArguments, serializers);
		      tmp_5 = tmp2_elvis_lhs == null ? _this__u8e3s4.ah(rootClass, serializers) : tmp2_elvis_lhs;
		    }
		    var contextualSerializer = tmp_5;
		    var tmp_7;
		    if (contextualSerializer == null) {
		      tmp_7 = null;
		    } else {
		      // Inline function 'kotlinx.serialization.internal.cast' call
		      tmp_7 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
		    }
		    var tmp4_safe_receiver = tmp_7;
		    return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
		  }
		  function nullable(_this__u8e3s4, shouldBeNullable) {
		    if (shouldBeNullable)
		      return get_nullable(_this__u8e3s4);
		    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
		  }
		  function get_SERIALIZERS_CACHE() {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    return SERIALIZERS_CACHE;
		  }
		  var SERIALIZERS_CACHE;
		  function get_SERIALIZERS_CACHE_NULLABLE() {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    return SERIALIZERS_CACHE_NULLABLE;
		  }
		  var SERIALIZERS_CACHE_NULLABLE;
		  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    return PARAMETRIZED_SERIALIZERS_CACHE;
		  }
		  var PARAMETRIZED_SERIALIZERS_CACHE;
		  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
		  }
		  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
		  function findCachedSerializer(clazz, isNullable) {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    var tmp;
		    if (!isNullable) {
		      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().ch(clazz);
		      var tmp_0;
		      if (tmp0_safe_receiver == null) {
		        tmp_0 = null;
		      } else {
		        // Inline function 'kotlinx.serialization.internal.cast' call
		        tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
		      }
		      tmp = tmp_0;
		    } else {
		      tmp = get_SERIALIZERS_CACHE_NULLABLE().ch(clazz);
		    }
		    return tmp;
		  }
		  function findParametrizedCachedSerializer(clazz, types, isNullable) {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    var tmp;
		    if (!isNullable) {
		      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().dh(clazz, types);
		      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
		    } else {
		      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().dh(clazz, types);
		    }
		    return tmp;
		  }
		  function SERIALIZERS_CACHE$lambda(it) {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    return serializerOrNull(it);
		  }
		  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    var tmp0_safe_receiver = serializerOrNull(it);
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
		    var tmp;
		    if (tmp1_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlinx.serialization.internal.cast' call
		      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
		    }
		    return tmp;
		  }
		  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
		    return parametrizedSerializerOrNull(clazz, types, serializers);
		  }
		  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
		    _init_properties_SerializersCache_kt__hgwi2p();
		    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
		    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, types, serializers);
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
		    var tmp;
		    if (tmp1_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlinx.serialization.internal.cast' call
		      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
		    }
		    return tmp;
		  }
		  var properties_initialized_SerializersCache_kt_q8kf25;
		  function _init_properties_SerializersCache_kt__hgwi2p() {
		    if (!properties_initialized_SerializersCache_kt_q8kf25) {
		      properties_initialized_SerializersCache_kt_q8kf25 = true;
		      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
		      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
		      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
		      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
		    }
		  }
		  function get_nullable(_this__u8e3s4) {
		    var tmp;
		    if (_this__u8e3s4.uf().eh()) {
		      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
		    } else {
		      tmp = new NullableSerializer(_this__u8e3s4);
		    }
		    return tmp;
		  }
		  function serializer_0(_this__u8e3s4) {
		    return StringSerializer_getInstance();
		  }
		  function serializer_1(_this__u8e3s4) {
		    return CharSerializer_getInstance();
		  }
		  function CharArraySerializer() {
		    return CharArraySerializer_getInstance();
		  }
		  function serializer_2(_this__u8e3s4) {
		    return DoubleSerializer_getInstance();
		  }
		  function DoubleArraySerializer() {
		    return DoubleArraySerializer_getInstance();
		  }
		  function serializer_3(_this__u8e3s4) {
		    return FloatSerializer_getInstance();
		  }
		  function FloatArraySerializer() {
		    return FloatArraySerializer_getInstance();
		  }
		  function serializer_4(_this__u8e3s4) {
		    return LongSerializer_getInstance();
		  }
		  function LongArraySerializer() {
		    return LongArraySerializer_getInstance();
		  }
		  function serializer_5(_this__u8e3s4) {
		    return ULongSerializer_getInstance();
		  }
		  function ULongArraySerializer() {
		    return ULongArraySerializer_getInstance();
		  }
		  function serializer_6(_this__u8e3s4) {
		    return IntSerializer_getInstance();
		  }
		  function IntArraySerializer() {
		    return IntArraySerializer_getInstance();
		  }
		  function serializer_7(_this__u8e3s4) {
		    return UIntSerializer_getInstance();
		  }
		  function UIntArraySerializer() {
		    return UIntArraySerializer_getInstance();
		  }
		  function serializer_8(_this__u8e3s4) {
		    return ShortSerializer_getInstance();
		  }
		  function ShortArraySerializer() {
		    return ShortArraySerializer_getInstance();
		  }
		  function serializer_9(_this__u8e3s4) {
		    return UShortSerializer_getInstance();
		  }
		  function UShortArraySerializer() {
		    return UShortArraySerializer_getInstance();
		  }
		  function serializer_10(_this__u8e3s4) {
		    return ByteSerializer_getInstance();
		  }
		  function ByteArraySerializer() {
		    return ByteArraySerializer_getInstance();
		  }
		  function serializer_11(_this__u8e3s4) {
		    return UByteSerializer_getInstance();
		  }
		  function UByteArraySerializer() {
		    return UByteArraySerializer_getInstance();
		  }
		  function serializer_12(_this__u8e3s4) {
		    return BooleanSerializer_getInstance();
		  }
		  function BooleanArraySerializer() {
		    return BooleanArraySerializer_getInstance();
		  }
		  function serializer_13(_this__u8e3s4) {
		    return UnitSerializer_getInstance();
		  }
		  function serializer_14(_this__u8e3s4) {
		    return DurationSerializer_getInstance();
		  }
		  function MapEntrySerializer(keySerializer, valueSerializer) {
		    return new MapEntrySerializer_0(keySerializer, valueSerializer);
		  }
		  function PairSerializer(keySerializer, valueSerializer) {
		    return new PairSerializer_0(keySerializer, valueSerializer);
		  }
		  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
		    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
		  }
		  function ArraySerializer(kClass, elementSerializer) {
		    return new ReferenceArraySerializer(kClass, elementSerializer);
		  }
		  function MapSerializer(keySerializer, valueSerializer) {
		    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
		  }
		  function ListSerializer(elementSerializer) {
		    return new ArrayListSerializer(elementSerializer);
		  }
		  function withContext(_this__u8e3s4, context) {
		    return new ContextDescriptor(_this__u8e3s4, context);
		  }
		  function ContextDescriptor(original, kClass) {
		    this.fh_1 = original;
		    this.gh_1 = kClass;
		    this.hh_1 = this.fh_1.sg() + '<' + this.gh_1.t5() + '>';
		  }
		  protoOf(ContextDescriptor).ih = function () {
		    return this.fh_1.ih();
		  };
		  protoOf(ContextDescriptor).jh = function () {
		    return this.fh_1.jh();
		  };
		  protoOf(ContextDescriptor).kh = function () {
		    return this.fh_1.kh();
		  };
		  protoOf(ContextDescriptor).eh = function () {
		    return this.fh_1.eh();
		  };
		  protoOf(ContextDescriptor).lh = function () {
		    return this.fh_1.lh();
		  };
		  protoOf(ContextDescriptor).mh = function (index) {
		    return this.fh_1.mh(index);
		  };
		  protoOf(ContextDescriptor).nh = function (index) {
		    return this.fh_1.nh(index);
		  };
		  protoOf(ContextDescriptor).oh = function (name) {
		    return this.fh_1.oh(name);
		  };
		  protoOf(ContextDescriptor).ph = function (index) {
		    return this.fh_1.ph(index);
		  };
		  protoOf(ContextDescriptor).qh = function (index) {
		    return this.fh_1.qh(index);
		  };
		  protoOf(ContextDescriptor).sg = function () {
		    return this.hh_1;
		  };
		  protoOf(ContextDescriptor).equals = function (other) {
		    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return false;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var another = tmp;
		    return equals(this.fh_1, another.fh_1) ? another.gh_1.equals(this.gh_1) : false;
		  };
		  protoOf(ContextDescriptor).hashCode = function () {
		    var result = this.gh_1.hashCode();
		    result = imul(31, result) + getStringHashCode(this.hh_1) | 0;
		    return result;
		  };
		  protoOf(ContextDescriptor).toString = function () {
		    return 'ContextDescriptor(kClass: ' + this.gh_1 + ', original: ' + this.fh_1 + ')';
		  };
		  function getContextualDescriptor(_this__u8e3s4, descriptor) {
		    var tmp0_safe_receiver = get_capturedKClass(descriptor);
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
		      var tmp0_safe_receiver_0 = _this__u8e3s4.bh(tmp0_safe_receiver);
		      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.uf();
		    }
		    return tmp;
		  }
		  function get_capturedKClass(_this__u8e3s4) {
		    var tmp;
		    if (_this__u8e3s4 instanceof ContextDescriptor) {
		      tmp = _this__u8e3s4.gh_1;
		    } else {
		      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
		        tmp = get_capturedKClass(_this__u8e3s4.rh_1);
		      } else {
		        tmp = null;
		      }
		    }
		    return tmp;
		  }
		  function SerialDescriptor() {
		  }
		  function get_elementDescriptors(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.Iterable' call
		    return new _no_name_provided__qut3iv_0(_this__u8e3s4);
		  }
		  function get_elementNames(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.Iterable' call
		    return new _no_name_provided__qut3iv_1(_this__u8e3s4);
		  }
		  function elementDescriptors$1$1($this_elementDescriptors) {
		    this.vh_1 = $this_elementDescriptors;
		    this.uh_1 = $this_elementDescriptors.jh();
		  }
		  protoOf(elementDescriptors$1$1).q = function () {
		    return this.uh_1 > 0;
		  };
		  protoOf(elementDescriptors$1$1).s = function () {
		    var tmp = this.vh_1.jh();
		    var tmp1 = this.uh_1;
		    this.uh_1 = tmp1 - 1 | 0;
		    return this.vh_1.nh(tmp - tmp1 | 0);
		  };
		  function _no_name_provided__qut3iv_0($this_elementDescriptors) {
		    this.wh_1 = $this_elementDescriptors;
		  }
		  protoOf(_no_name_provided__qut3iv_0).p = function () {
		    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
		    return new elementDescriptors$1$1(this.wh_1);
		  };
		  function elementNames$1$1($this_elementNames) {
		    this.yh_1 = $this_elementNames;
		    this.xh_1 = $this_elementNames.jh();
		  }
		  protoOf(elementNames$1$1).q = function () {
		    return this.xh_1 > 0;
		  };
		  protoOf(elementNames$1$1).s = function () {
		    var tmp = this.yh_1.jh();
		    var tmp1 = this.xh_1;
		    this.xh_1 = tmp1 - 1 | 0;
		    return this.yh_1.ph(tmp - tmp1 | 0);
		  };
		  function _no_name_provided__qut3iv_1($this_elementNames) {
		    this.zh_1 = $this_elementNames;
		  }
		  protoOf(_no_name_provided__qut3iv_1).p = function () {
		    // Inline function 'kotlinx.serialization.descriptors.<get-elementNames>.<anonymous>' call
		    return new elementNames$1$1(this.zh_1);
		  };
		  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
		    var tmp;
		    if (builder === VOID) {
		      tmp = buildSerialDescriptor$lambda;
		    } else {
		      tmp = builder;
		    }
		    builder = tmp;
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.text.isNotBlank' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!!isBlank(serialName)) {
		      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
		      var message = 'Blank serial names are prohibited';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!!equals(kind, CLASS_getInstance())) {
		      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
		      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
		      throw IllegalArgumentException_init_$Create$(toString(message_0));
		    }
		    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
		    builder(sdBuilder);
		    return new SerialDescriptorImpl(serialName, kind, sdBuilder.ag_1.u(), toList(typeParameters), sdBuilder);
		  }
		  function ClassSerialDescriptorBuilder(serialName) {
		    this.xf_1 = serialName;
		    this.yf_1 = false;
		    this.zf_1 = emptyList();
		    this.ag_1 = ArrayList_init_$Create$_0();
		    this.bg_1 = HashSet_init_$Create$();
		    this.cg_1 = ArrayList_init_$Create$_0();
		    this.dg_1 = ArrayList_init_$Create$_0();
		    this.eg_1 = ArrayList_init_$Create$_0();
		  }
		  protoOf(ClassSerialDescriptorBuilder).ai = function (elementName, descriptor, annotations, isOptional) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!this.bg_1.m(elementName)) {
		      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
		      var message = "Element with name '" + elementName + "' is already registered";
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    // Inline function 'kotlin.collections.plusAssign' call
		    this.ag_1.m(elementName);
		    // Inline function 'kotlin.collections.plusAssign' call
		    this.cg_1.m(descriptor);
		    // Inline function 'kotlin.collections.plusAssign' call
		    this.dg_1.m(annotations);
		    // Inline function 'kotlin.collections.plusAssign' call
		    this.eg_1.m(isOptional);
		  };
		  protoOf(ClassSerialDescriptorBuilder).fg = function (elementName, descriptor, annotations, isOptional, $super) {
		    annotations = annotations === VOID ? emptyList() : annotations;
		    isOptional = isOptional === VOID ? false : isOptional;
		    var tmp;
		    if ($super === VOID) {
		      this.ai(elementName, descriptor, annotations, isOptional);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.ai.call(this, elementName, descriptor, annotations, isOptional);
		    }
		    return tmp;
		  };
		  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
		    var tmp;
		    if (builderAction === VOID) {
		      tmp = buildClassSerialDescriptor$lambda;
		    } else {
		      tmp = builderAction;
		    }
		    builderAction = tmp;
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.text.isNotBlank' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!!isBlank(serialName)) {
		      // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
		      var message = 'Blank serial names are prohibited';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
		    builderAction(sdBuilder);
		    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.ag_1.u(), toList(typeParameters), sdBuilder);
		  }
		  function _get__hashCode__tgwhef($this) {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = $this.mi_1;
		    _hashCode$factory();
		    return this_0.w1();
		  }
		  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
		    return function () {
		      return hashCodeImpl(this$0, this$0.li_1);
		    };
		  }
		  function SerialDescriptorImpl$toString$lambda(this$0) {
		    return function (it) {
		      return this$0.ph(it) + ': ' + this$0.nh(it).sg();
		    };
		  }
		  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
		    this.bi_1 = serialName;
		    this.ci_1 = kind;
		    this.di_1 = elementsCount;
		    this.ei_1 = builder.zf_1;
		    this.fi_1 = toHashSet(builder.ag_1);
		    var tmp = this;
		    // Inline function 'kotlin.collections.toTypedArray' call
		    var this_0 = builder.ag_1;
		    tmp.gi_1 = copyToArray(this_0);
		    this.hi_1 = compactArray(builder.cg_1);
		    var tmp_0 = this;
		    // Inline function 'kotlin.collections.toTypedArray' call
		    var this_1 = builder.dg_1;
		    tmp_0.ii_1 = copyToArray(this_1);
		    this.ji_1 = toBooleanArray(builder.eg_1);
		    var tmp_1 = this;
		    // Inline function 'kotlin.collections.map' call
		    var this_2 = withIndex(this.gi_1);
		    // Inline function 'kotlin.collections.mapTo' call
		    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
		    var tmp0_iterator = this_2.p();
		    while (tmp0_iterator.q()) {
		      var item = tmp0_iterator.s();
		      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
		      var tmp$ret$2 = to(item.pb_1, item.ob_1);
		      destination.m(tmp$ret$2);
		    }
		    tmp_1.ki_1 = toMap(destination);
		    this.li_1 = compactArray(typeParameters);
		    var tmp_2 = this;
		    tmp_2.mi_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
		  }
		  protoOf(SerialDescriptorImpl).sg = function () {
		    return this.bi_1;
		  };
		  protoOf(SerialDescriptorImpl).lh = function () {
		    return this.ci_1;
		  };
		  protoOf(SerialDescriptorImpl).jh = function () {
		    return this.di_1;
		  };
		  protoOf(SerialDescriptorImpl).ih = function () {
		    return this.ei_1;
		  };
		  protoOf(SerialDescriptorImpl).ni = function () {
		    return this.fi_1;
		  };
		  protoOf(SerialDescriptorImpl).ph = function (index) {
		    return getChecked(this.gi_1, index);
		  };
		  protoOf(SerialDescriptorImpl).oh = function (name) {
		    var tmp0_elvis_lhs = this.ki_1.c2(name);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      tmp = -3;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  protoOf(SerialDescriptorImpl).mh = function (index) {
		    return getChecked(this.ii_1, index);
		  };
		  protoOf(SerialDescriptorImpl).nh = function (index) {
		    return getChecked(this.hi_1, index);
		  };
		  protoOf(SerialDescriptorImpl).qh = function (index) {
		    return getChecked_0(this.ji_1, index);
		  };
		  protoOf(SerialDescriptorImpl).equals = function (other) {
		    var tmp$ret$0;
		    $l$block_5: {
		      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
		      if (this === other) {
		        tmp$ret$0 = true;
		        break $l$block_5;
		      }
		      if (!(other instanceof SerialDescriptorImpl)) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      if (!(this.sg() === other.sg())) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
		      if (!contentEquals(this.li_1, other.li_1)) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      if (!(this.jh() === other.jh())) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      var inductionVariable = 0;
		      var last = this.jh();
		      if (inductionVariable < last)
		        do {
		          var index = inductionVariable;
		          inductionVariable = inductionVariable + 1 | 0;
		          if (!(this.nh(index).sg() === other.nh(index).sg())) {
		            tmp$ret$0 = false;
		            break $l$block_5;
		          }
		          if (!equals(this.nh(index).lh(), other.nh(index).lh())) {
		            tmp$ret$0 = false;
		            break $l$block_5;
		          }
		        }
		         while (inductionVariable < last);
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  };
		  protoOf(SerialDescriptorImpl).hashCode = function () {
		    return _get__hashCode__tgwhef(this);
		  };
		  protoOf(SerialDescriptorImpl).toString = function () {
		    var tmp = until(0, this.di_1);
		    var tmp_0 = this.bi_1 + '(';
		    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
		  };
		  function PrimitiveSerialDescriptor(serialName, kind) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.text.isNotBlank' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!!isBlank(serialName)) {
		      // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
		      var message = 'Blank serial names are prohibited';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    return PrimitiveDescriptorSafe(serialName, kind);
		  }
		  function buildSerialDescriptor$lambda($this$null) {
		    return Unit_instance;
		  }
		  function buildClassSerialDescriptor$lambda($this$null) {
		    return Unit_instance;
		  }
		  function _hashCode$factory() {
		    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
		      return _get__hashCode__tgwhef(receiver);
		    }, null);
		  }
		  function ENUM() {
		    ENUM_instance = this;
		    SerialKind.call(this);
		  }
		  var ENUM_instance;
		  function ENUM_getInstance() {
		    if (ENUM_instance == null)
		      new ENUM();
		    return ENUM_instance;
		  }
		  function CONTEXTUAL() {
		    CONTEXTUAL_instance = this;
		    SerialKind.call(this);
		  }
		  var CONTEXTUAL_instance;
		  function CONTEXTUAL_getInstance() {
		    if (CONTEXTUAL_instance == null)
		      new CONTEXTUAL();
		    return CONTEXTUAL_instance;
		  }
		  function SerialKind() {
		  }
		  protoOf(SerialKind).toString = function () {
		    return ensureNotNull(getKClassFromExpression(this).t5());
		  };
		  protoOf(SerialKind).hashCode = function () {
		    return getStringHashCode(this.toString());
		  };
		  function BOOLEAN() {
		    BOOLEAN_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var BOOLEAN_instance;
		  function BOOLEAN_getInstance() {
		    if (BOOLEAN_instance == null)
		      new BOOLEAN();
		    return BOOLEAN_instance;
		  }
		  function BYTE() {
		    BYTE_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var BYTE_instance;
		  function BYTE_getInstance() {
		    if (BYTE_instance == null)
		      new BYTE();
		    return BYTE_instance;
		  }
		  function CHAR() {
		    CHAR_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var CHAR_instance;
		  function CHAR_getInstance() {
		    if (CHAR_instance == null)
		      new CHAR();
		    return CHAR_instance;
		  }
		  function SHORT() {
		    SHORT_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var SHORT_instance;
		  function SHORT_getInstance() {
		    if (SHORT_instance == null)
		      new SHORT();
		    return SHORT_instance;
		  }
		  function INT() {
		    INT_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var INT_instance;
		  function INT_getInstance() {
		    if (INT_instance == null)
		      new INT();
		    return INT_instance;
		  }
		  function LONG() {
		    LONG_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var LONG_instance;
		  function LONG_getInstance() {
		    if (LONG_instance == null)
		      new LONG();
		    return LONG_instance;
		  }
		  function FLOAT() {
		    FLOAT_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var FLOAT_instance;
		  function FLOAT_getInstance() {
		    if (FLOAT_instance == null)
		      new FLOAT();
		    return FLOAT_instance;
		  }
		  function DOUBLE() {
		    DOUBLE_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var DOUBLE_instance;
		  function DOUBLE_getInstance() {
		    if (DOUBLE_instance == null)
		      new DOUBLE();
		    return DOUBLE_instance;
		  }
		  function STRING() {
		    STRING_instance = this;
		    PrimitiveKind.call(this);
		  }
		  var STRING_instance;
		  function STRING_getInstance() {
		    if (STRING_instance == null)
		      new STRING();
		    return STRING_instance;
		  }
		  function PrimitiveKind() {
		    SerialKind.call(this);
		  }
		  function CLASS() {
		    CLASS_instance = this;
		    StructureKind.call(this);
		  }
		  var CLASS_instance;
		  function CLASS_getInstance() {
		    if (CLASS_instance == null)
		      new CLASS();
		    return CLASS_instance;
		  }
		  function LIST() {
		    LIST_instance = this;
		    StructureKind.call(this);
		  }
		  var LIST_instance;
		  function LIST_getInstance() {
		    if (LIST_instance == null)
		      new LIST();
		    return LIST_instance;
		  }
		  function MAP() {
		    MAP_instance = this;
		    StructureKind.call(this);
		  }
		  var MAP_instance;
		  function MAP_getInstance() {
		    if (MAP_instance == null)
		      new MAP();
		    return MAP_instance;
		  }
		  function OBJECT() {
		    OBJECT_instance = this;
		    StructureKind.call(this);
		  }
		  var OBJECT_instance;
		  function OBJECT_getInstance() {
		    if (OBJECT_instance == null)
		      new OBJECT();
		    return OBJECT_instance;
		  }
		  function StructureKind() {
		    SerialKind.call(this);
		  }
		  function SEALED() {
		    SEALED_instance = this;
		    PolymorphicKind.call(this);
		  }
		  var SEALED_instance;
		  function SEALED_getInstance() {
		    if (SEALED_instance == null)
		      new SEALED();
		    return SEALED_instance;
		  }
		  function OPEN() {
		    OPEN_instance = this;
		    PolymorphicKind.call(this);
		  }
		  var OPEN_instance;
		  function OPEN_getInstance() {
		    if (OPEN_instance == null)
		      new OPEN();
		    return OPEN_instance;
		  }
		  function PolymorphicKind() {
		    SerialKind.call(this);
		  }
		  function AbstractDecoder() {
		  }
		  protoOf(AbstractDecoder).oi = function () {
		    throw SerializationException_init_$Create$_0('' + getKClassFromExpression(this) + " can't retrieve untyped values");
		  };
		  protoOf(AbstractDecoder).pi = function () {
		    return true;
		  };
		  protoOf(AbstractDecoder).qi = function () {
		    return null;
		  };
		  protoOf(AbstractDecoder).ri = function () {
		    var tmp = this.oi();
		    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).si = function () {
		    var tmp = this.oi();
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).ti = function () {
		    var tmp = this.oi();
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).ui = function () {
		    var tmp = this.oi();
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).vi = function () {
		    var tmp = this.oi();
		    return tmp instanceof Long ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).wi = function () {
		    var tmp = this.oi();
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).xi = function () {
		    var tmp = this.oi();
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).yi = function () {
		    var tmp = this.oi();
		    return tmp instanceof Char ? tmp.w8_1 : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).zi = function () {
		    var tmp = this.oi();
		    return typeof tmp === 'string' ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).aj = function (enumDescriptor) {
		    var tmp = this.oi();
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(AbstractDecoder).bj = function (descriptor) {
		    return this;
		  };
		  protoOf(AbstractDecoder).cj = function (deserializer, previousValue) {
		    return this.dj(deserializer);
		  };
		  protoOf(AbstractDecoder).ej = function (descriptor) {
		    return this;
		  };
		  protoOf(AbstractDecoder).fj = function (descriptor) {
		  };
		  protoOf(AbstractDecoder).gj = function (descriptor, index) {
		    return this.ri();
		  };
		  protoOf(AbstractDecoder).hj = function (descriptor, index) {
		    return this.si();
		  };
		  protoOf(AbstractDecoder).ij = function (descriptor, index) {
		    return this.ti();
		  };
		  protoOf(AbstractDecoder).jj = function (descriptor, index) {
		    return this.ui();
		  };
		  protoOf(AbstractDecoder).kj = function (descriptor, index) {
		    return this.vi();
		  };
		  protoOf(AbstractDecoder).lj = function (descriptor, index) {
		    return this.wi();
		  };
		  protoOf(AbstractDecoder).mj = function (descriptor, index) {
		    return this.xi();
		  };
		  protoOf(AbstractDecoder).nj = function (descriptor, index) {
		    return this.yi();
		  };
		  protoOf(AbstractDecoder).oj = function (descriptor, index) {
		    return this.zi();
		  };
		  protoOf(AbstractDecoder).pj = function (descriptor, index) {
		    return this.bj(descriptor.nh(index));
		  };
		  protoOf(AbstractDecoder).qj = function (descriptor, index, deserializer, previousValue) {
		    return this.cj(deserializer, previousValue);
		  };
		  protoOf(AbstractDecoder).sj = function (descriptor, index, deserializer, previousValue) {
		    var isNullabilitySupported = deserializer.uf().eh();
		    return (isNullabilitySupported ? true : this.pi()) ? this.cj(deserializer, previousValue) : this.qi();
		  };
		  function AbstractEncoder() {
		  }
		  protoOf(AbstractEncoder).ej = function (descriptor) {
		    return this;
		  };
		  protoOf(AbstractEncoder).fj = function (descriptor) {
		  };
		  protoOf(AbstractEncoder).xj = function (descriptor, index) {
		    return true;
		  };
		  protoOf(AbstractEncoder).yj = function (value) {
		    throw SerializationException_init_$Create$_0('Non-serializable ' + getKClassFromExpression(value) + ' is not supported by ' + getKClassFromExpression(this) + ' encoder');
		  };
		  protoOf(AbstractEncoder).zj = function () {
		    throw SerializationException_init_$Create$_0("'null' is not supported by default");
		  };
		  protoOf(AbstractEncoder).ak = function (value) {
		    return this.yj(value);
		  };
		  protoOf(AbstractEncoder).bk = function (value) {
		    return this.yj(value);
		  };
		  protoOf(AbstractEncoder).ck = function (value) {
		    return this.yj(value);
		  };
		  protoOf(AbstractEncoder).dk = function (value) {
		    return this.yj(value);
		  };
		  protoOf(AbstractEncoder).ek = function (value) {
		    return this.yj(value);
		  };
		  protoOf(AbstractEncoder).fk = function (value) {
		    return this.yj(value);
		  };
		  protoOf(AbstractEncoder).gk = function (value) {
		    return this.yj(value);
		  };
		  protoOf(AbstractEncoder).hk = function (value) {
		    return this.yj(new Char(value));
		  };
		  protoOf(AbstractEncoder).ik = function (value) {
		    return this.yj(value);
		  };
		  protoOf(AbstractEncoder).jk = function (enumDescriptor, index) {
		    return this.yj(index);
		  };
		  protoOf(AbstractEncoder).kk = function (descriptor) {
		    return this;
		  };
		  protoOf(AbstractEncoder).lk = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.ak(value);
		    }
		  };
		  protoOf(AbstractEncoder).mk = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.bk(value);
		    }
		  };
		  protoOf(AbstractEncoder).nk = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.ck(value);
		    }
		  };
		  protoOf(AbstractEncoder).ok = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.dk(value);
		    }
		  };
		  protoOf(AbstractEncoder).pk = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.ek(value);
		    }
		  };
		  protoOf(AbstractEncoder).qk = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.fk(value);
		    }
		  };
		  protoOf(AbstractEncoder).rk = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.gk(value);
		    }
		  };
		  protoOf(AbstractEncoder).sk = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.hk(value);
		    }
		  };
		  protoOf(AbstractEncoder).tk = function (descriptor, index, value) {
		    if (this.xj(descriptor, index)) {
		      this.ik(value);
		    }
		  };
		  protoOf(AbstractEncoder).uk = function (descriptor, index) {
		    return this.xj(descriptor, index) ? this.kk(descriptor.nh(index)) : NoOpEncoder_getInstance();
		  };
		  protoOf(AbstractEncoder).vk = function (descriptor, index, serializer, value) {
		    if (this.xj(descriptor, index)) {
		      this.wk(serializer, value);
		    }
		  };
		  protoOf(AbstractEncoder).xk = function (descriptor, index, serializer, value) {
		    if (this.xj(descriptor, index)) {
		      this.yk(serializer, value);
		    }
		  };
		  function Decoder() {
		  }
		  function Companion() {
		    this.cl_1 = -1;
		    this.dl_1 = -3;
		  }
		  var Companion_instance_0;
		  function Companion_getInstance_6() {
		    return Companion_instance_0;
		  }
		  function CompositeDecoder() {
		  }
		  function Encoder() {
		  }
		  function CompositeEncoder() {
		  }
		  function decodeSequentially_0($this, compositeDecoder) {
		    var klassName = compositeDecoder.oj($this.uf(), 0);
		    var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
		    return compositeDecoder.rj($this.uf(), 1, serializer);
		  }
		  function AbstractPolymorphicSerializer() {
		  }
		  protoOf(AbstractPolymorphicSerializer).kg = function (encoder, value) {
		    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
		    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
		    var descriptor = this.uf();
		    var composite = encoder.ej(descriptor);
		    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
		    composite.tk(this.uf(), 0, actualSerializer.uf().sg());
		    var tmp = this.uf();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
		    composite.vk(tmp, 1, tmp$ret$0, value);
		    composite.fj(descriptor);
		  };
		  protoOf(AbstractPolymorphicSerializer).vf = function (encoder, value) {
		    return this.kg(encoder, !(value == null) ? value : THROW_CCE());
		  };
		  protoOf(AbstractPolymorphicSerializer).wf = function (decoder) {
		    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
		    var descriptor = this.uf();
		    var composite = decoder.ej(descriptor);
		    var tmp$ret$0;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
		      var klassName = null;
		      var value = null;
		      if (composite.uj()) {
		        tmp$ret$0 = decodeSequentially_0(this, composite);
		        break $l$block;
		      }
		      mainLoop: while (true) {
		        var index = composite.vj(this.uf());
		        if (index === -1) {
		          break mainLoop;
		        } else {
		          if (index === 0) {
		            klassName = composite.oj(this.uf(), index);
		          } else {
		            if (index === 1) {
		              var tmp$ret$2;
		              $l$block_0: {
		                // Inline function 'kotlin.requireNotNull' call
		                var value_0 = klassName;
		                // Inline function 'kotlin.contracts.contract' call
		                if (value_0 == null) {
		                  // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
		                  var message = 'Cannot read polymorphic value before its type token';
		                  throw IllegalArgumentException_init_$Create$(toString(message));
		                } else {
		                  tmp$ret$2 = value_0;
		                  break $l$block_0;
		                }
		              }
		              klassName = tmp$ret$2;
		              var serializer = findPolymorphicSerializer_0(this, composite, klassName);
		              value = composite.rj(this.uf(), index, serializer);
		            } else {
		              var tmp0_elvis_lhs = klassName;
		              throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
		            }
		          }
		        }
		      }
		      var tmp$ret$4;
		      $l$block_1: {
		        // Inline function 'kotlin.requireNotNull' call
		        var value_1 = value;
		        // Inline function 'kotlin.contracts.contract' call
		        if (value_1 == null) {
		          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
		          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
		          throw IllegalArgumentException_init_$Create$(toString(message_0));
		        } else {
		          tmp$ret$4 = value_1;
		          break $l$block_1;
		        }
		      }
		      var tmp = tmp$ret$4;
		      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
		    }
		    var result = tmp$ret$0;
		    composite.fj(descriptor);
		    return result;
		  };
		  protoOf(AbstractPolymorphicSerializer).lg = function (decoder, klassName) {
		    return decoder.tj().el(this.jg(), klassName);
		  };
		  protoOf(AbstractPolymorphicSerializer).mg = function (encoder, value) {
		    return encoder.tj().fl(this.jg(), value);
		  };
		  function throwSubtypeNotRegistered(subClass, baseClass) {
		    var tmp0_elvis_lhs = subClass.t5();
		    throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? '' + subClass : tmp0_elvis_lhs, baseClass);
		  }
		  function throwSubtypeNotRegistered_0(subClassName, baseClass) {
		    var scope = "in the scope of '" + baseClass.t5() + "'";
		    throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default polymorphic serializers were registered ' + scope : "Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + '.\n' + "Mark the base class as 'sealed' or register the serializer explicitly.");
		  }
		  function DurationSerializer() {
		    DurationSerializer_instance = this;
		    this.gl_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
		  }
		  protoOf(DurationSerializer).uf = function () {
		    return this.gl_1;
		  };
		  protoOf(DurationSerializer).hl = function (encoder, value) {
		    encoder.ik(Duration__toIsoString_impl_9h6wsm(value));
		  };
		  protoOf(DurationSerializer).vf = function (encoder, value) {
		    return this.hl(encoder, value instanceof Duration ? value.id_1 : THROW_CCE());
		  };
		  protoOf(DurationSerializer).il = function (decoder) {
		    return Companion_getInstance().hd(decoder.zi());
		  };
		  protoOf(DurationSerializer).wf = function (decoder) {
		    return new Duration(this.il(decoder));
		  };
		  var DurationSerializer_instance;
		  function DurationSerializer_getInstance() {
		    if (DurationSerializer_instance == null)
		      new DurationSerializer();
		    return DurationSerializer_instance;
		  }
		  function CachedNames() {
		  }
		  function ArrayListClassDesc(elementDesc) {
		    ListLikeDescriptor.call(this, elementDesc);
		  }
		  protoOf(ArrayListClassDesc).sg = function () {
		    return 'kotlin.collections.ArrayList';
		  };
		  function HashSetClassDesc(elementDesc) {
		    ListLikeDescriptor.call(this, elementDesc);
		  }
		  protoOf(HashSetClassDesc).sg = function () {
		    return 'kotlin.collections.HashSet';
		  };
		  function LinkedHashSetClassDesc(elementDesc) {
		    ListLikeDescriptor.call(this, elementDesc);
		  }
		  protoOf(LinkedHashSetClassDesc).sg = function () {
		    return 'kotlin.collections.LinkedHashSet';
		  };
		  function HashMapClassDesc(keyDesc, valueDesc) {
		    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
		  }
		  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
		    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
		  }
		  function ArrayClassDesc(elementDesc) {
		    ListLikeDescriptor.call(this, elementDesc);
		  }
		  protoOf(ArrayClassDesc).sg = function () {
		    return 'kotlin.Array';
		  };
		  function ListLikeDescriptor(elementDescriptor) {
		    this.ll_1 = elementDescriptor;
		    this.ml_1 = 1;
		  }
		  protoOf(ListLikeDescriptor).lh = function () {
		    return LIST_getInstance();
		  };
		  protoOf(ListLikeDescriptor).jh = function () {
		    return this.ml_1;
		  };
		  protoOf(ListLikeDescriptor).ph = function (index) {
		    return index.toString();
		  };
		  protoOf(ListLikeDescriptor).oh = function (name) {
		    var tmp0_elvis_lhs = toIntOrNull(name);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  protoOf(ListLikeDescriptor).qh = function (index) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(index >= 0)) {
		      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
		      var message = 'Illegal index ' + index + ', ' + this.sg() + ' expects only non-negative indices';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    return false;
		  };
		  protoOf(ListLikeDescriptor).mh = function (index) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(index >= 0)) {
		      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
		      var message = 'Illegal index ' + index + ', ' + this.sg() + ' expects only non-negative indices';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    return emptyList();
		  };
		  protoOf(ListLikeDescriptor).nh = function (index) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(index >= 0)) {
		      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
		      var message = 'Illegal index ' + index + ', ' + this.sg() + ' expects only non-negative indices';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    return this.ll_1;
		  };
		  protoOf(ListLikeDescriptor).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ListLikeDescriptor))
		      return false;
		    if (equals(this.ll_1, other.ll_1) ? this.sg() === other.sg() : false)
		      return true;
		    return false;
		  };
		  protoOf(ListLikeDescriptor).hashCode = function () {
		    return imul(hashCode(this.ll_1), 31) + getStringHashCode(this.sg()) | 0;
		  };
		  protoOf(ListLikeDescriptor).toString = function () {
		    return this.sg() + '(' + this.ll_1 + ')';
		  };
		  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
		    this.rl_1 = serialName;
		    this.sl_1 = keyDescriptor;
		    this.tl_1 = valueDescriptor;
		    this.ul_1 = 2;
		  }
		  protoOf(MapLikeDescriptor).sg = function () {
		    return this.rl_1;
		  };
		  protoOf(MapLikeDescriptor).lh = function () {
		    return MAP_getInstance();
		  };
		  protoOf(MapLikeDescriptor).jh = function () {
		    return this.ul_1;
		  };
		  protoOf(MapLikeDescriptor).ph = function (index) {
		    return index.toString();
		  };
		  protoOf(MapLikeDescriptor).oh = function (name) {
		    var tmp0_elvis_lhs = toIntOrNull(name);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  protoOf(MapLikeDescriptor).qh = function (index) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(index >= 0)) {
		      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
		      var message = 'Illegal index ' + index + ', ' + this.sg() + ' expects only non-negative indices';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    return false;
		  };
		  protoOf(MapLikeDescriptor).mh = function (index) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(index >= 0)) {
		      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
		      var message = 'Illegal index ' + index + ', ' + this.sg() + ' expects only non-negative indices';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    return emptyList();
		  };
		  protoOf(MapLikeDescriptor).nh = function (index) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(index >= 0)) {
		      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
		      var message = 'Illegal index ' + index + ', ' + this.sg() + ' expects only non-negative indices';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    var tmp;
		    switch (index % 2 | 0) {
		      case 0:
		        tmp = this.sl_1;
		        break;
		      case 1:
		        tmp = this.tl_1;
		        break;
		      default:
		        var message_0 = 'Unreached';
		        throw IllegalStateException_init_$Create$(toString(message_0));
		    }
		    return tmp;
		  };
		  protoOf(MapLikeDescriptor).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MapLikeDescriptor))
		      return false;
		    if (!(this.sg() === other.sg()))
		      return false;
		    if (!equals(this.sl_1, other.sl_1))
		      return false;
		    if (!equals(this.tl_1, other.tl_1))
		      return false;
		    return true;
		  };
		  protoOf(MapLikeDescriptor).hashCode = function () {
		    var result = getStringHashCode(this.sg());
		    result = imul(31, result) + hashCode(this.sl_1) | 0;
		    result = imul(31, result) + hashCode(this.tl_1) | 0;
		    return result;
		  };
		  protoOf(MapLikeDescriptor).toString = function () {
		    return this.sg() + '(' + this.sl_1 + ', ' + this.tl_1 + ')';
		  };
		  function PrimitiveArrayDescriptor(primitive) {
		    ListLikeDescriptor.call(this, primitive);
		    this.zl_1 = primitive.sg() + 'Array';
		  }
		  protoOf(PrimitiveArrayDescriptor).sg = function () {
		    return this.zl_1;
		  };
		  function ArrayListSerializer(element) {
		    CollectionSerializer.call(this, element);
		    this.bm_1 = new ArrayListClassDesc(element.uf());
		  }
		  protoOf(ArrayListSerializer).uf = function () {
		    return this.bm_1;
		  };
		  protoOf(ArrayListSerializer).cm = function () {
		    // Inline function 'kotlin.collections.arrayListOf' call
		    return ArrayList_init_$Create$_0();
		  };
		  protoOf(ArrayListSerializer).dm = function (_this__u8e3s4) {
		    return _this__u8e3s4.u();
		  };
		  protoOf(ArrayListSerializer).em = function (_this__u8e3s4) {
		    return this.dm(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ArrayListSerializer).fm = function (_this__u8e3s4) {
		    return _this__u8e3s4;
		  };
		  protoOf(ArrayListSerializer).gm = function (_this__u8e3s4) {
		    return this.fm(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ArrayListSerializer).hm = function (_this__u8e3s4) {
		    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
		    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
		  };
		  protoOf(ArrayListSerializer).im = function (_this__u8e3s4) {
		    return this.hm((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, List) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ArrayListSerializer).jm = function (_this__u8e3s4, size) {
		    return _this__u8e3s4.l2(size);
		  };
		  protoOf(ArrayListSerializer).km = function (_this__u8e3s4, size) {
		    return this.jm(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
		  };
		  protoOf(ArrayListSerializer).lm = function (_this__u8e3s4, index, element) {
		    _this__u8e3s4.e1(index, element);
		  };
		  protoOf(ArrayListSerializer).mm = function (_this__u8e3s4, index, element) {
		    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
		    return this.lm(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  function HashSetSerializer(eSerializer) {
		    CollectionSerializer.call(this, eSerializer);
		    this.xm_1 = new HashSetClassDesc(eSerializer.uf());
		  }
		  protoOf(HashSetSerializer).uf = function () {
		    return this.xm_1;
		  };
		  protoOf(HashSetSerializer).cm = function () {
		    return HashSet_init_$Create$();
		  };
		  protoOf(HashSetSerializer).ym = function (_this__u8e3s4) {
		    return _this__u8e3s4.u();
		  };
		  protoOf(HashSetSerializer).em = function (_this__u8e3s4) {
		    return this.ym(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(HashSetSerializer).zm = function (_this__u8e3s4) {
		    return _this__u8e3s4;
		  };
		  protoOf(HashSetSerializer).gm = function (_this__u8e3s4) {
		    return this.zm(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(HashSetSerializer).an = function (_this__u8e3s4) {
		    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
		    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
		  };
		  protoOf(HashSetSerializer).im = function (_this__u8e3s4) {
		    return this.an((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Set) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(HashSetSerializer).bn = function (_this__u8e3s4, size) {
		  };
		  protoOf(HashSetSerializer).km = function (_this__u8e3s4, size) {
		    return this.bn(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
		  };
		  protoOf(HashSetSerializer).cn = function (_this__u8e3s4, index, element) {
		    _this__u8e3s4.m(element);
		  };
		  protoOf(HashSetSerializer).mm = function (_this__u8e3s4, index, element) {
		    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
		    return this.cn(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  function LinkedHashSetSerializer(eSerializer) {
		    CollectionSerializer.call(this, eSerializer);
		    this.en_1 = new LinkedHashSetClassDesc(eSerializer.uf());
		  }
		  protoOf(LinkedHashSetSerializer).uf = function () {
		    return this.en_1;
		  };
		  protoOf(LinkedHashSetSerializer).cm = function () {
		    // Inline function 'kotlin.collections.linkedSetOf' call
		    return LinkedHashSet_init_$Create$();
		  };
		  protoOf(LinkedHashSetSerializer).fn = function (_this__u8e3s4) {
		    return _this__u8e3s4.u();
		  };
		  protoOf(LinkedHashSetSerializer).em = function (_this__u8e3s4) {
		    return this.fn(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LinkedHashSetSerializer).gn = function (_this__u8e3s4) {
		    return _this__u8e3s4;
		  };
		  protoOf(LinkedHashSetSerializer).gm = function (_this__u8e3s4) {
		    return this.gn(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LinkedHashSetSerializer).an = function (_this__u8e3s4) {
		    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
		    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
		  };
		  protoOf(LinkedHashSetSerializer).im = function (_this__u8e3s4) {
		    return this.an((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Set) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LinkedHashSetSerializer).hn = function (_this__u8e3s4, size) {
		  };
		  protoOf(LinkedHashSetSerializer).km = function (_this__u8e3s4, size) {
		    return this.hn(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
		  };
		  protoOf(LinkedHashSetSerializer).in = function (_this__u8e3s4, index, element) {
		    _this__u8e3s4.m(element);
		  };
		  protoOf(LinkedHashSetSerializer).mm = function (_this__u8e3s4, index, element) {
		    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
		    return this.in(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  function HashMapSerializer(kSerializer, vSerializer) {
		    MapLikeSerializer.call(this, kSerializer, vSerializer);
		    this.ln_1 = new HashMapClassDesc(kSerializer.uf(), vSerializer.uf());
		  }
		  protoOf(HashMapSerializer).uf = function () {
		    return this.ln_1;
		  };
		  protoOf(HashMapSerializer).mn = function (_this__u8e3s4) {
		    return _this__u8e3s4.u();
		  };
		  protoOf(HashMapSerializer).nn = function (_this__u8e3s4) {
		    return this.mn((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(HashMapSerializer).on = function (_this__u8e3s4) {
		    // Inline function 'kotlin.collections.iterator' call
		    return _this__u8e3s4.u1().p();
		  };
		  protoOf(HashMapSerializer).pn = function (_this__u8e3s4) {
		    return this.on((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(HashMapSerializer).cm = function () {
		    return HashMap_init_$Create$();
		  };
		  protoOf(HashMapSerializer).qn = function (_this__u8e3s4) {
		    return imul(_this__u8e3s4.u(), 2);
		  };
		  protoOf(HashMapSerializer).em = function (_this__u8e3s4) {
		    return this.qn(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(HashMapSerializer).rn = function (_this__u8e3s4) {
		    return _this__u8e3s4;
		  };
		  protoOf(HashMapSerializer).gm = function (_this__u8e3s4) {
		    return this.rn(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(HashMapSerializer).sn = function (_this__u8e3s4) {
		    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
		    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
		  };
		  protoOf(HashMapSerializer).im = function (_this__u8e3s4) {
		    return this.sn((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(HashMapSerializer).tn = function (_this__u8e3s4, size) {
		  };
		  protoOf(HashMapSerializer).km = function (_this__u8e3s4, size) {
		    return this.tn(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
		  };
		  function LinkedHashMapSerializer(kSerializer, vSerializer) {
		    MapLikeSerializer.call(this, kSerializer, vSerializer);
		    this.ao_1 = new LinkedHashMapClassDesc(kSerializer.uf(), vSerializer.uf());
		  }
		  protoOf(LinkedHashMapSerializer).uf = function () {
		    return this.ao_1;
		  };
		  protoOf(LinkedHashMapSerializer).mn = function (_this__u8e3s4) {
		    return _this__u8e3s4.u();
		  };
		  protoOf(LinkedHashMapSerializer).nn = function (_this__u8e3s4) {
		    return this.mn((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LinkedHashMapSerializer).on = function (_this__u8e3s4) {
		    // Inline function 'kotlin.collections.iterator' call
		    return _this__u8e3s4.u1().p();
		  };
		  protoOf(LinkedHashMapSerializer).pn = function (_this__u8e3s4) {
		    return this.on((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LinkedHashMapSerializer).cm = function () {
		    return LinkedHashMap_init_$Create$();
		  };
		  protoOf(LinkedHashMapSerializer).bo = function (_this__u8e3s4) {
		    return imul(_this__u8e3s4.u(), 2);
		  };
		  protoOf(LinkedHashMapSerializer).em = function (_this__u8e3s4) {
		    return this.bo(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LinkedHashMapSerializer).co = function (_this__u8e3s4) {
		    return _this__u8e3s4;
		  };
		  protoOf(LinkedHashMapSerializer).gm = function (_this__u8e3s4) {
		    return this.co(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LinkedHashMapSerializer).sn = function (_this__u8e3s4) {
		    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
		    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
		  };
		  protoOf(LinkedHashMapSerializer).im = function (_this__u8e3s4) {
		    return this.sn((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LinkedHashMapSerializer).do = function (_this__u8e3s4, size) {
		  };
		  protoOf(LinkedHashMapSerializer).km = function (_this__u8e3s4, size) {
		    return this.do(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
		  };
		  function ReferenceArraySerializer(kClass, eSerializer) {
		    CollectionLikeSerializer.call(this, eSerializer);
		    this.fo_1 = kClass;
		    this.go_1 = new ArrayClassDesc(eSerializer.uf());
		  }
		  protoOf(ReferenceArraySerializer).uf = function () {
		    return this.go_1;
		  };
		  protoOf(ReferenceArraySerializer).ho = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(ReferenceArraySerializer).nn = function (_this__u8e3s4) {
		    return this.ho((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ReferenceArraySerializer).io = function (_this__u8e3s4) {
		    return arrayIterator(_this__u8e3s4);
		  };
		  protoOf(ReferenceArraySerializer).pn = function (_this__u8e3s4) {
		    return this.io((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ReferenceArraySerializer).cm = function () {
		    // Inline function 'kotlin.collections.arrayListOf' call
		    return ArrayList_init_$Create$_0();
		  };
		  protoOf(ReferenceArraySerializer).jo = function (_this__u8e3s4) {
		    return _this__u8e3s4.u();
		  };
		  protoOf(ReferenceArraySerializer).em = function (_this__u8e3s4) {
		    return this.jo(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ReferenceArraySerializer).ko = function (_this__u8e3s4) {
		    return toNativeArrayImpl(_this__u8e3s4, this.fo_1);
		  };
		  protoOf(ReferenceArraySerializer).gm = function (_this__u8e3s4) {
		    return this.ko(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ReferenceArraySerializer).lo = function (_this__u8e3s4) {
		    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
		  };
		  protoOf(ReferenceArraySerializer).im = function (_this__u8e3s4) {
		    return this.lo((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ReferenceArraySerializer).mo = function (_this__u8e3s4, size) {
		    return _this__u8e3s4.l2(size);
		  };
		  protoOf(ReferenceArraySerializer).km = function (_this__u8e3s4, size) {
		    return this.mo(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
		  };
		  protoOf(ReferenceArraySerializer).no = function (_this__u8e3s4, index, element) {
		    _this__u8e3s4.e1(index, element);
		  };
		  protoOf(ReferenceArraySerializer).mm = function (_this__u8e3s4, index, element) {
		    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
		    return this.no(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  function CollectionSerializer(element) {
		    CollectionLikeSerializer.call(this, element);
		  }
		  protoOf(CollectionSerializer).om = function (_this__u8e3s4) {
		    return _this__u8e3s4.u();
		  };
		  protoOf(CollectionSerializer).nn = function (_this__u8e3s4) {
		    return this.om((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(CollectionSerializer).pm = function (_this__u8e3s4) {
		    return _this__u8e3s4.p();
		  };
		  protoOf(CollectionSerializer).pn = function (_this__u8e3s4) {
		    return this.pm((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  function MapLikeSerializer(keySerializer, valueSerializer) {
		    AbstractCollectionSerializer.call(this);
		    this.un_1 = keySerializer;
		    this.vn_1 = valueSerializer;
		  }
		  protoOf(MapLikeSerializer).wn = function (decoder, builder, startIndex, size) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(size >= 0)) {
		      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
		      var message = 'Size must be known in advance when using READ_ALL';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    var progression = step(until(0, imul(size, 2)), 2);
		    var inductionVariable = progression.o8_1;
		    var last = progression.p8_1;
		    var step_0 = progression.q8_1;
		    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + step_0 | 0;
		        this.xn(decoder, startIndex + index | 0, builder, false);
		      }
		       while (!(index === last));
		  };
		  protoOf(MapLikeSerializer).sm = function (decoder, builder, startIndex, size) {
		    return this.wn(decoder, (!(builder == null) ? isInterface(builder, MutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
		  };
		  protoOf(MapLikeSerializer).xn = function (decoder, index, builder, checkIndex) {
		    var key = decoder.rj(this.uf(), index, this.un_1);
		    var tmp;
		    if (checkIndex) {
		      // Inline function 'kotlin.also' call
		      var this_0 = decoder.vj(this.uf());
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
		      // Inline function 'kotlin.require' call
		      // Inline function 'kotlin.contracts.contract' call
		      if (!(this_0 === (index + 1 | 0))) {
		        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
		        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
		        throw IllegalArgumentException_init_$Create$(toString(message));
		      }
		      tmp = this_0;
		    } else {
		      tmp = index + 1 | 0;
		    }
		    var vIndex = tmp;
		    var tmp_0;
		    var tmp_1;
		    if (builder.z1(key)) {
		      var tmp_2 = this.vn_1.uf().lh();
		      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
		    } else {
		      tmp_1 = false;
		    }
		    if (tmp_1) {
		      tmp_0 = decoder.qj(this.uf(), vIndex, this.vn_1, getValue(builder, key));
		    } else {
		      tmp_0 = decoder.rj(this.uf(), vIndex, this.vn_1);
		    }
		    var value = tmp_0;
		    // Inline function 'kotlin.collections.set' call
		    builder.s1(key, value);
		  };
		  protoOf(MapLikeSerializer).tm = function (decoder, index, builder, checkIndex) {
		    return this.xn(decoder, index, (!(builder == null) ? isInterface(builder, MutableMap) : false) ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(MapLikeSerializer).rm = function (encoder, value) {
		    var size = this.nn(value);
		    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
		    var descriptor = this.uf();
		    var composite = encoder.al(descriptor, size);
		    // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
		    var iterator = this.pn(value);
		    var index = 0;
		    // Inline function 'kotlin.collections.forEach' call
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator = iterator;
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var k = element.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var v = element.w1();
		      var tmp = this.uf();
		      var tmp0 = index;
		      index = tmp0 + 1 | 0;
		      composite.vk(tmp, tmp0, this.un_1, k);
		      var tmp_0 = this.uf();
		      var tmp1 = index;
		      index = tmp1 + 1 | 0;
		      composite.vk(tmp_0, tmp1, this.vn_1, v);
		    }
		    composite.fj(descriptor);
		  };
		  protoOf(MapLikeSerializer).vf = function (encoder, value) {
		    return this.rm(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
		  };
		  function CollectionLikeSerializer(elementSerializer) {
		    AbstractCollectionSerializer.call(this);
		    this.qm_1 = elementSerializer;
		  }
		  protoOf(CollectionLikeSerializer).rm = function (encoder, value) {
		    var size = this.nn(value);
		    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
		    var descriptor = this.uf();
		    var composite = encoder.al(descriptor, size);
		    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
		    var iterator = this.pn(value);
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        composite.vk(this.uf(), index, this.qm_1, iterator.s());
		      }
		       while (inductionVariable < size);
		    composite.fj(descriptor);
		  };
		  protoOf(CollectionLikeSerializer).vf = function (encoder, value) {
		    return this.rm(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
		  };
		  protoOf(CollectionLikeSerializer).sm = function (decoder, builder, startIndex, size) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(size >= 0)) {
		      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
		      var message = 'Size must be known in advance when using READ_ALL';
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        this.tm(decoder, startIndex + index | 0, builder, false);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(CollectionLikeSerializer).tm = function (decoder, index, builder, checkIndex) {
		    this.mm(builder, index, decoder.rj(this.uf(), index, this.qm_1));
		  };
		  function readSize($this, decoder, builder) {
		    var size = decoder.wj($this.uf());
		    $this.km(builder, size);
		    return size;
		  }
		  function AbstractCollectionSerializer() {
		  }
		  protoOf(AbstractCollectionSerializer).vm = function (decoder, previous) {
		    var tmp1_elvis_lhs = previous == null ? null : this.im(previous);
		    var builder = tmp1_elvis_lhs == null ? this.cm() : tmp1_elvis_lhs;
		    var startIndex = this.em(builder);
		    var compositeDecoder = decoder.ej(this.uf());
		    if (compositeDecoder.uj()) {
		      this.sm(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
		    } else {
		      $l$loop: while (true) {
		        var index = compositeDecoder.vj(this.uf());
		        if (index === -1)
		          break $l$loop;
		        this.um(compositeDecoder, startIndex + index | 0, builder);
		      }
		    }
		    compositeDecoder.fj(this.uf());
		    return this.gm(builder);
		  };
		  protoOf(AbstractCollectionSerializer).wf = function (decoder) {
		    return this.vm(decoder, null);
		  };
		  protoOf(AbstractCollectionSerializer).um = function (decoder, index, builder, checkIndex, $super) {
		    checkIndex = checkIndex === VOID ? true : checkIndex;
		    var tmp;
		    if ($super === VOID) {
		      this.tm(decoder, index, builder, checkIndex);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.tm.call(this, decoder, index, builder, checkIndex);
		    }
		    return tmp;
		  };
		  function PrimitiveArraySerializer(primitiveSerializer) {
		    CollectionLikeSerializer.call(this, primitiveSerializer);
		    this.po_1 = new PrimitiveArrayDescriptor(primitiveSerializer.uf());
		  }
		  protoOf(PrimitiveArraySerializer).uf = function () {
		    return this.po_1;
		  };
		  protoOf(PrimitiveArraySerializer).qo = function (_this__u8e3s4) {
		    return _this__u8e3s4.ro();
		  };
		  protoOf(PrimitiveArraySerializer).em = function (_this__u8e3s4) {
		    return this.qo(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(PrimitiveArraySerializer).so = function (_this__u8e3s4) {
		    return _this__u8e3s4.to();
		  };
		  protoOf(PrimitiveArraySerializer).gm = function (_this__u8e3s4) {
		    return this.so(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(PrimitiveArraySerializer).uo = function (_this__u8e3s4, size) {
		    return _this__u8e3s4.l2(size);
		  };
		  protoOf(PrimitiveArraySerializer).km = function (_this__u8e3s4, size) {
		    return this.uo(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
		  };
		  protoOf(PrimitiveArraySerializer).vo = function (_this__u8e3s4) {
		    var message = 'This method lead to boxing and must not be used, use writeContents instead';
		    throw IllegalStateException_init_$Create$(toString(message));
		  };
		  protoOf(PrimitiveArraySerializer).pn = function (_this__u8e3s4) {
		    return this.vo((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(PrimitiveArraySerializer).wo = function (_this__u8e3s4, index, element) {
		    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
		    throw IllegalStateException_init_$Create$(toString(message));
		  };
		  protoOf(PrimitiveArraySerializer).mm = function (_this__u8e3s4, index, element) {
		    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
		    return this.wo(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
		  };
		  protoOf(PrimitiveArraySerializer).cm = function () {
		    return this.im(this.xo());
		  };
		  protoOf(PrimitiveArraySerializer).ap = function (encoder, value) {
		    var size = this.nn(value);
		    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
		    var descriptor = this.po_1;
		    var composite = encoder.al(descriptor, size);
		    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
		    this.zo(composite, value, size);
		    composite.fj(descriptor);
		  };
		  protoOf(PrimitiveArraySerializer).vf = function (encoder, value) {
		    return this.ap(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
		  };
		  protoOf(PrimitiveArraySerializer).rm = function (encoder, value) {
		    return this.ap(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
		  };
		  protoOf(PrimitiveArraySerializer).wf = function (decoder) {
		    return this.vm(decoder, null);
		  };
		  function PrimitiveArrayBuilder() {
		  }
		  protoOf(PrimitiveArrayBuilder).bp = function (requiredCapacity, $super) {
		    requiredCapacity = requiredCapacity === VOID ? this.ro() + 1 | 0 : requiredCapacity;
		    var tmp;
		    if ($super === VOID) {
		      this.l2(requiredCapacity);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.l2.call(this, requiredCapacity);
		    }
		    return tmp;
		  };
		  function Companion_0() {
		    Companion_instance_1 = this;
		    this.cp_1 = longArray(0);
		  }
		  var Companion_instance_1;
		  function Companion_getInstance_7() {
		    if (Companion_instance_1 == null)
		      new Companion_0();
		    return Companion_instance_1;
		  }
		  function prepareHighMarksArray($this, elementsCount) {
		    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
		    Companion_getInstance_0();
		    var elementsInLastSlot = elementsCount & (64 - 1 | 0);
		    var highMarks = longArray(slotsCount);
		    if (!(elementsInLastSlot === 0)) {
		      highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).w9(elementsCount);
		    }
		    return highMarks;
		  }
		  function markHigh($this, index) {
		    var slot = (index >>> 6 | 0) - 1 | 0;
		    Companion_getInstance_0();
		    var offsetInSlot = index & (64 - 1 | 0);
		    $this.gp_1[slot] = $this.gp_1[slot].aa((new Long(1, 0)).w9(offsetInSlot));
		  }
		  function nextUnmarkedHighIndex($this) {
		    var inductionVariable = 0;
		    var last = $this.gp_1.length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var slot = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var tmp = slot + 1 | 0;
		        Companion_getInstance_0();
		        var slotOffset = imul(tmp, 64);
		        var slotMarks = $this.gp_1[slot];
		        while (!slotMarks.equals(new Long(-1, -1))) {
		          var indexInSlot = countTrailingZeroBits(slotMarks.v9());
		          slotMarks = slotMarks.aa((new Long(1, 0)).w9(indexInSlot));
		          var index = slotOffset + indexInSlot | 0;
		          if ($this.ep_1($this.dp_1, index)) {
		            $this.gp_1[slot] = slotMarks;
		            return index;
		          }
		        }
		        $this.gp_1[slot] = slotMarks;
		      }
		       while (inductionVariable <= last);
		    return -1;
		  }
		  function ElementMarker(descriptor, readIfAbsent) {
		    Companion_getInstance_7();
		    this.dp_1 = descriptor;
		    this.ep_1 = readIfAbsent;
		    var elementsCount = this.dp_1.jh();
		    Companion_getInstance_0();
		    if (elementsCount <= 64) {
		      var tmp = this;
		      var tmp_0;
		      Companion_getInstance_0();
		      if (elementsCount === 64) {
		        tmp_0 = new Long(0, 0);
		      } else {
		        tmp_0 = (new Long(-1, -1)).w9(elementsCount);
		      }
		      tmp.fp_1 = tmp_0;
		      this.gp_1 = Companion_getInstance_7().cp_1;
		    } else {
		      this.fp_1 = new Long(0, 0);
		      this.gp_1 = prepareHighMarksArray(this, elementsCount);
		    }
		  }
		  protoOf(ElementMarker).hp = function (index) {
		    Companion_getInstance_0();
		    if (index < 64) {
		      this.fp_1 = this.fp_1.aa((new Long(1, 0)).w9(index));
		    } else {
		      markHigh(this, index);
		    }
		  };
		  protoOf(ElementMarker).ip = function () {
		    var elementsCount = this.dp_1.jh();
		    while (!this.fp_1.equals(new Long(-1, -1))) {
		      var index = countTrailingZeroBits(this.fp_1.v9());
		      this.fp_1 = this.fp_1.aa((new Long(1, 0)).w9(index));
		      if (this.ep_1(this.dp_1, index)) {
		        return index;
		      }
		    }
		    Companion_getInstance_0();
		    if (elementsCount > 64) {
		      return nextUnmarkedHighIndex(this);
		    }
		    return -1;
		  };
		  function createUnmarkedDescriptor($this, serialName) {
		    var d = new EnumDescriptor(serialName, $this.jp_1.length);
		    // Inline function 'kotlin.collections.forEach' call
		    var indexedObject = $this.jp_1;
		    var inductionVariable = 0;
		    var last = indexedObject.length;
		    while (inductionVariable < last) {
		      var element = indexedObject[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      // Inline function 'kotlinx.serialization.internal.EnumSerializer.createUnmarkedDescriptor.<anonymous>' call
		      d.yp(element.h8_1);
		    }
		    return d;
		  }
		  function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
		    return function () {
		      var tmp0_elvis_lhs = this$0.kp_1;
		      return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
		    };
		  }
		  function EnumSerializer(serialName, values) {
		    this.jp_1 = values;
		    this.kp_1 = null;
		    var tmp = this;
		    tmp.lp_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
		  }
		  protoOf(EnumSerializer).uf = function () {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = this.lp_1;
		    descriptor$factory_1();
		    return this_0.w1();
		  };
		  protoOf(EnumSerializer).zp = function (encoder, value) {
		    var index = indexOf(this.jp_1, value);
		    if (index === -1) {
		      throw SerializationException_init_$Create$_0('' + value + ' is not a valid enum ' + this.uf().sg() + ', ' + ('must be one of ' + contentToString(this.jp_1)));
		    }
		    encoder.jk(this.uf(), index);
		  };
		  protoOf(EnumSerializer).vf = function (encoder, value) {
		    return this.zp(encoder, value instanceof Enum ? value : THROW_CCE());
		  };
		  protoOf(EnumSerializer).wf = function (decoder) {
		    var index = decoder.aj(this.uf());
		    if (!(0 <= index ? index <= (this.jp_1.length - 1 | 0) : false)) {
		      throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.uf().sg() + ' enum values, ' + ('values size is ' + this.jp_1.length));
		    }
		    return this.jp_1[index];
		  };
		  protoOf(EnumSerializer).toString = function () {
		    return 'kotlinx.serialization.internal.EnumSerializer<' + this.uf().sg() + '>';
		  };
		  function _get_elementDescriptors__y23q9p($this) {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = $this.nq_1;
		    elementDescriptors$factory();
		    return this_0.w1();
		  }
		  function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
		    return function () {
		      var tmp = 0;
		      var tmp_0 = $elementsCount;
		      // Inline function 'kotlin.arrayOfNulls' call
		      var tmp_1 = fillArrayVal(Array(tmp_0), null);
		      while (tmp < tmp_0) {
		        var tmp_2 = tmp;
		        tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.ph(tmp_2), OBJECT_getInstance(), []);
		        tmp = tmp + 1 | 0;
		      }
		      return tmp_1;
		    };
		  }
		  function EnumDescriptor(name, elementsCount) {
		    PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
		    this.mq_1 = ENUM_getInstance();
		    var tmp = this;
		    tmp.nq_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
		  }
		  protoOf(EnumDescriptor).lh = function () {
		    return this.mq_1;
		  };
		  protoOf(EnumDescriptor).nh = function (index) {
		    return getChecked(_get_elementDescriptors__y23q9p(this), index);
		  };
		  protoOf(EnumDescriptor).equals = function (other) {
		    if (this === other)
		      return true;
		    if (other == null)
		      return false;
		    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
		      return false;
		    if (!(other.lh() === ENUM_getInstance()))
		      return false;
		    if (!(this.sg() === other.sg()))
		      return false;
		    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
		      return false;
		    return true;
		  };
		  protoOf(EnumDescriptor).toString = function () {
		    return joinToString(get_elementNames(this), ', ', this.sg() + '(', ')');
		  };
		  protoOf(EnumDescriptor).hashCode = function () {
		    var result = getStringHashCode(this.sg());
		    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
		    // Inline function 'kotlin.collections.fold' call
		    var accumulator = 1;
		    var tmp0_iterator = get_elementNames(this).p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
		      var hash = accumulator;
		      var tmp = imul(31, hash);
		      // Inline function 'kotlin.hashCode' call
		      // Inline function 'kotlinx.serialization.internal.EnumDescriptor.hashCode.<anonymous>' call
		      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
		      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
		    }
		    var elementsHashCode = accumulator;
		    result = imul(31, result) + elementsHashCode | 0;
		    return result;
		  };
		  function descriptor$factory_1() {
		    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
		      return receiver.uf();
		    }, null);
		  }
		  function elementDescriptors$factory() {
		    return getPropertyCallableRef('elementDescriptors', 1, KProperty1, function (receiver) {
		      return _get_elementDescriptors__y23q9p(receiver);
		    }, null);
		  }
		  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
		    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
		  }
		  function InlineClassDescriptor(name, generatedSerializer) {
		    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
		    this.cr_1 = true;
		  }
		  protoOf(InlineClassDescriptor).kh = function () {
		    return this.cr_1;
		  };
		  protoOf(InlineClassDescriptor).hashCode = function () {
		    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
		  };
		  protoOf(InlineClassDescriptor).equals = function (other) {
		    var tmp$ret$0;
		    $l$block_5: {
		      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
		      if (this === other) {
		        tmp$ret$0 = true;
		        break $l$block_5;
		      }
		      if (!(other instanceof InlineClassDescriptor)) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      if (!(this.sg() === other.sg())) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
		      if (!(other.cr_1 ? contentEquals(this.oq(), other.oq()) : false)) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      if (!(this.jh() === other.jh())) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      var inductionVariable = 0;
		      var last = this.jh();
		      if (inductionVariable < last)
		        do {
		          var index = inductionVariable;
		          inductionVariable = inductionVariable + 1 | 0;
		          if (!(this.nh(index).sg() === other.nh(index).sg())) {
		            tmp$ret$0 = false;
		            break $l$block_5;
		          }
		          if (!equals(this.nh(index).lh(), other.nh(index).lh())) {
		            tmp$ret$0 = false;
		            break $l$block_5;
		          }
		        }
		         while (inductionVariable < last);
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  };
		  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
		    this.dr_1 = $primitiveSerializer;
		  }
		  protoOf(InlinePrimitiveDescriptor$1).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [this.dr_1];
		  };
		  protoOf(InlinePrimitiveDescriptor$1).uf = function () {
		    var message = 'unsupported';
		    throw IllegalStateException_init_$Create$(toString(message));
		  };
		  protoOf(InlinePrimitiveDescriptor$1).vf = function (encoder, value) {
		    // Inline function 'kotlin.error' call
		    var message = 'unsupported';
		    throw IllegalStateException_init_$Create$(toString(message));
		  };
		  protoOf(InlinePrimitiveDescriptor$1).wf = function (decoder) {
		    // Inline function 'kotlin.error' call
		    var message = 'unsupported';
		    throw IllegalStateException_init_$Create$(toString(message));
		  };
		  function jsonCachedSerialNames(_this__u8e3s4) {
		    return cachedSerialNames(_this__u8e3s4);
		  }
		  function NoOpEncoder() {
		    NoOpEncoder_instance = this;
		    AbstractEncoder.call(this);
		    this.gr_1 = EmptySerializersModule_0();
		  }
		  protoOf(NoOpEncoder).tj = function () {
		    return this.gr_1;
		  };
		  protoOf(NoOpEncoder).yj = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).zj = function () {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).ak = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).bk = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).ck = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).dk = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).ek = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).fk = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).gk = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).hk = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).ik = function (value) {
		    return Unit_instance;
		  };
		  protoOf(NoOpEncoder).jk = function (enumDescriptor, index) {
		    return Unit_instance;
		  };
		  var NoOpEncoder_instance;
		  function NoOpEncoder_getInstance() {
		    if (NoOpEncoder_instance == null)
		      new NoOpEncoder();
		    return NoOpEncoder_instance;
		  }
		  function NullableSerializer(serializer) {
		    this.hr_1 = serializer;
		    this.ir_1 = new SerialDescriptorForNullable(this.hr_1.uf());
		  }
		  protoOf(NullableSerializer).uf = function () {
		    return this.ir_1;
		  };
		  protoOf(NullableSerializer).jr = function (encoder, value) {
		    if (!(value == null)) {
		      encoder.zk();
		      encoder.wk(this.hr_1, value);
		    } else {
		      encoder.zj();
		    }
		  };
		  protoOf(NullableSerializer).vf = function (encoder, value) {
		    return this.jr(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
		  };
		  protoOf(NullableSerializer).wf = function (decoder) {
		    return decoder.pi() ? decoder.dj(this.hr_1) : decoder.qi();
		  };
		  protoOf(NullableSerializer).equals = function (other) {
		    if (this === other)
		      return true;
		    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
		      return false;
		    if (!(other instanceof NullableSerializer))
		      THROW_CCE();
		    if (!equals(this.hr_1, other.hr_1))
		      return false;
		    return true;
		  };
		  protoOf(NullableSerializer).hashCode = function () {
		    return hashCode(this.hr_1);
		  };
		  function SerialDescriptorForNullable(original) {
		    this.rh_1 = original;
		    this.sh_1 = this.rh_1.sg() + '?';
		    this.th_1 = cachedSerialNames(this.rh_1);
		  }
		  protoOf(SerialDescriptorForNullable).ih = function () {
		    return this.rh_1.ih();
		  };
		  protoOf(SerialDescriptorForNullable).jh = function () {
		    return this.rh_1.jh();
		  };
		  protoOf(SerialDescriptorForNullable).kh = function () {
		    return this.rh_1.kh();
		  };
		  protoOf(SerialDescriptorForNullable).lh = function () {
		    return this.rh_1.lh();
		  };
		  protoOf(SerialDescriptorForNullable).mh = function (index) {
		    return this.rh_1.mh(index);
		  };
		  protoOf(SerialDescriptorForNullable).nh = function (index) {
		    return this.rh_1.nh(index);
		  };
		  protoOf(SerialDescriptorForNullable).oh = function (name) {
		    return this.rh_1.oh(name);
		  };
		  protoOf(SerialDescriptorForNullable).ph = function (index) {
		    return this.rh_1.ph(index);
		  };
		  protoOf(SerialDescriptorForNullable).qh = function (index) {
		    return this.rh_1.qh(index);
		  };
		  protoOf(SerialDescriptorForNullable).sg = function () {
		    return this.sh_1;
		  };
		  protoOf(SerialDescriptorForNullable).ni = function () {
		    return this.th_1;
		  };
		  protoOf(SerialDescriptorForNullable).eh = function () {
		    return true;
		  };
		  protoOf(SerialDescriptorForNullable).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SerialDescriptorForNullable))
		      return false;
		    if (!equals(this.rh_1, other.rh_1))
		      return false;
		    return true;
		  };
		  protoOf(SerialDescriptorForNullable).toString = function () {
		    return '' + this.rh_1 + '?';
		  };
		  protoOf(SerialDescriptorForNullable).hashCode = function () {
		    return imul(hashCode(this.rh_1), 31);
		  };
		  function ObjectSerializer_init_$Init$(serialName, objectInstance, classAnnotations, $this) {
		    ObjectSerializer.call($this, serialName, objectInstance);
		    $this.lr_1 = asList(classAnnotations);
		    return $this;
		  }
		  function ObjectSerializer_init_$Create$(serialName, objectInstance, classAnnotations) {
		    return ObjectSerializer_init_$Init$(serialName, objectInstance, classAnnotations, objectCreate(protoOf(ObjectSerializer)));
		  }
		  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
		    return function ($this$buildSerialDescriptor) {
		      $this$buildSerialDescriptor.zf_1 = this$0.lr_1;
		      return Unit_instance;
		    };
		  }
		  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
		    return function () {
		      var tmp = OBJECT_getInstance();
		      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
		    };
		  }
		  function ObjectSerializer(serialName, objectInstance) {
		    this.kr_1 = objectInstance;
		    this.lr_1 = emptyList();
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.mr_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
		  }
		  protoOf(ObjectSerializer).uf = function () {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = this.mr_1;
		    descriptor$factory_2();
		    return this_0.w1();
		  };
		  protoOf(ObjectSerializer).kg = function (encoder, value) {
		    encoder.ej(this.uf()).fj(this.uf());
		  };
		  protoOf(ObjectSerializer).vf = function (encoder, value) {
		    return this.kg(encoder, !(value == null) ? value : THROW_CCE());
		  };
		  protoOf(ObjectSerializer).wf = function (decoder) {
		    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
		    var descriptor = this.uf();
		    var composite = decoder.ej(descriptor);
		    var tmp$ret$0;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
		      var index = composite.vj(this.uf());
		      if (index === -1) {
		        tmp$ret$0 = Unit_instance;
		        break $l$block;
		      } else {
		        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
		      }
		    }
		    var result = tmp$ret$0;
		    composite.fj(descriptor);
		    return this.kr_1;
		  };
		  function descriptor$factory_2() {
		    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
		      return receiver.uf();
		    }, null);
		  }
		  function get_EMPTY_DESCRIPTOR_ARRAY() {
		    _init_properties_Platform_common_kt__3qzecs();
		    return EMPTY_DESCRIPTOR_ARRAY;
		  }
		  var EMPTY_DESCRIPTOR_ARRAY;
		  function cachedSerialNames(_this__u8e3s4) {
		    _init_properties_Platform_common_kt__3qzecs();
		    if (isInterface(_this__u8e3s4, CachedNames))
		      return _this__u8e3s4.ni();
		    var result = HashSet_init_$Create$_1(_this__u8e3s4.jh());
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.jh();
		    if (inductionVariable < last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.collections.plusAssign' call
		        var element = _this__u8e3s4.ph(i);
		        result.m(element);
		      }
		       while (inductionVariable < last);
		    return result;
		  }
		  function kclass(_this__u8e3s4) {
		    _init_properties_Platform_common_kt__3qzecs();
		    var t = _this__u8e3s4.f6();
		    var tmp;
		    if (!(t == null) ? isInterface(t, KClass) : false) {
		      tmp = t;
		    } else {
		      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
		        var message = 'Captured type paramerer ' + t + ' from generic non-reified function. ' + ('Such functionality cannot be supported as ' + t + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + t);
		        throw IllegalStateException_init_$Create$(toString(message));
		      } else {
		        var message_0 = 'Only KClass supported as classifier, got ' + t;
		        throw IllegalStateException_init_$Create$(toString(message_0));
		      }
		    }
		    var tmp_0 = tmp;
		    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
		  }
		  function compactArray(_this__u8e3s4) {
		    _init_properties_Platform_common_kt__3qzecs();
		    // Inline function 'kotlin.takeUnless' call
		    // Inline function 'kotlin.contracts.contract' call
		    var tmp;
		    // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
		    // Inline function 'kotlin.collections.isNullOrEmpty' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(_this__u8e3s4 == null ? true : _this__u8e3s4.x())) {
		      tmp = _this__u8e3s4;
		    } else {
		      tmp = null;
		    }
		    var tmp0_safe_receiver = tmp;
		    var tmp_0;
		    if (tmp0_safe_receiver == null) {
		      tmp_0 = null;
		    } else {
		      // Inline function 'kotlin.collections.toTypedArray' call
		      tmp_0 = copyToArray(tmp0_safe_receiver);
		    }
		    var tmp1_elvis_lhs = tmp_0;
		    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
		  }
		  var properties_initialized_Platform_common_kt_i7q4ty;
		  function _init_properties_Platform_common_kt__3qzecs() {
		    if (!properties_initialized_Platform_common_kt_i7q4ty) {
		      properties_initialized_Platform_common_kt_i7q4ty = true;
		      // Inline function 'kotlin.arrayOf' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      EMPTY_DESCRIPTOR_ARRAY = [];
		    }
		  }
		  function throwMissingFieldException(seen, goldenMask, descriptor) {
		    // Inline function 'kotlin.collections.mutableListOf' call
		    var missingFields = ArrayList_init_$Create$_0();
		    var missingFieldsBits = goldenMask & ~seen;
		    var inductionVariable = 0;
		    if (inductionVariable < 32)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (!((missingFieldsBits & 1) === 0)) {
		          // Inline function 'kotlin.collections.plusAssign' call
		          var element = descriptor.ph(i);
		          missingFields.m(element);
		        }
		        missingFieldsBits = missingFieldsBits >>> 1 | 0;
		      }
		       while (inductionVariable < 32);
		    throw MissingFieldException_init_$Create$(missingFields, descriptor.sg());
		  }
		  function _get_childSerializers__7vnyfa($this) {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = $this.vp_1;
		    childSerializers$factory();
		    return this_0.w1();
		  }
		  function _get__hashCode__tgwhef_0($this) {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = $this.xp_1;
		    _hashCode$factory_0();
		    return this_0.w1();
		  }
		  function buildIndices($this) {
		    var indices = HashMap_init_$Create$();
		    var inductionVariable = 0;
		    var last = $this.qp_1.length - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.collections.set' call
		        var key = $this.qp_1[i];
		        indices.s1(key, i);
		      }
		       while (inductionVariable <= last);
		    return indices;
		  }
		  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
		    return function () {
		      var tmp0_safe_receiver = this$0.np_1;
		      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.er();
		      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
		    };
		  }
		  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
		    return function () {
		      var tmp0_safe_receiver = this$0.np_1;
		      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fr();
		      var tmp;
		      if (tmp1_safe_receiver == null) {
		        tmp = null;
		      } else {
		        // Inline function 'kotlin.collections.map' call
		        // Inline function 'kotlin.collections.mapTo' call
		        var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
		        var inductionVariable = 0;
		        var last = tmp1_safe_receiver.length;
		        while (inductionVariable < last) {
		          var item = tmp1_safe_receiver[inductionVariable];
		          inductionVariable = inductionVariable + 1 | 0;
		          // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
		          var tmp$ret$0 = item.uf();
		          destination.m(tmp$ret$0);
		        }
		        tmp = destination;
		      }
		      return compactArray(tmp);
		    };
		  }
		  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
		    return function () {
		      return hashCodeImpl(this$0, this$0.oq());
		    };
		  }
		  function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
		    return function (i) {
		      return this$0.ph(i) + ': ' + this$0.nh(i).sg();
		    };
		  }
		  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
		    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
		    this.mp_1 = serialName;
		    this.np_1 = generatedSerializer;
		    this.op_1 = elementsCount;
		    this.pp_1 = -1;
		    var tmp = this;
		    var tmp_0 = 0;
		    var tmp_1 = this.op_1;
		    // Inline function 'kotlin.arrayOfNulls' call
		    var tmp_2 = fillArrayVal(Array(tmp_1), null);
		    while (tmp_0 < tmp_1) {
		      tmp_2[tmp_0] = '[UNINITIALIZED]';
		      tmp_0 = tmp_0 + 1 | 0;
		    }
		    tmp.qp_1 = tmp_2;
		    var tmp_3 = this;
		    // Inline function 'kotlin.arrayOfNulls' call
		    var size = this.op_1;
		    tmp_3.rp_1 = fillArrayVal(Array(size), null);
		    this.sp_1 = null;
		    this.tp_1 = booleanArray(this.op_1);
		    this.up_1 = emptyMap();
		    var tmp_4 = this;
		    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp_4.vp_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
		    var tmp_6 = this;
		    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp_6.wp_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
		    var tmp_8 = this;
		    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp_8.xp_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
		  }
		  protoOf(PluginGeneratedSerialDescriptor).sg = function () {
		    return this.mp_1;
		  };
		  protoOf(PluginGeneratedSerialDescriptor).jh = function () {
		    return this.op_1;
		  };
		  protoOf(PluginGeneratedSerialDescriptor).lh = function () {
		    return CLASS_getInstance();
		  };
		  protoOf(PluginGeneratedSerialDescriptor).ih = function () {
		    var tmp0_elvis_lhs = this.sp_1;
		    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
		  };
		  protoOf(PluginGeneratedSerialDescriptor).ni = function () {
		    return this.up_1.q1();
		  };
		  protoOf(PluginGeneratedSerialDescriptor).oq = function () {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = this.wp_1;
		    typeParameterDescriptors$factory();
		    return this_0.w1();
		  };
		  protoOf(PluginGeneratedSerialDescriptor).pq = function (name, isOptional) {
		    this.pp_1 = this.pp_1 + 1 | 0;
		    this.qp_1[this.pp_1] = name;
		    this.tp_1[this.pp_1] = isOptional;
		    this.rp_1[this.pp_1] = null;
		    if (this.pp_1 === (this.op_1 - 1 | 0)) {
		      this.up_1 = buildIndices(this);
		    }
		  };
		  protoOf(PluginGeneratedSerialDescriptor).yp = function (name, isOptional, $super) {
		    isOptional = isOptional === VOID ? false : isOptional;
		    var tmp;
		    if ($super === VOID) {
		      this.pq(name, isOptional);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.pq.call(this, name, isOptional);
		    }
		    return tmp;
		  };
		  protoOf(PluginGeneratedSerialDescriptor).nh = function (index) {
		    return getChecked(_get_childSerializers__7vnyfa(this), index).uf();
		  };
		  protoOf(PluginGeneratedSerialDescriptor).qh = function (index) {
		    return getChecked_0(this.tp_1, index);
		  };
		  protoOf(PluginGeneratedSerialDescriptor).mh = function (index) {
		    var tmp0_elvis_lhs = getChecked(this.rp_1, index);
		    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
		  };
		  protoOf(PluginGeneratedSerialDescriptor).ph = function (index) {
		    return getChecked(this.qp_1, index);
		  };
		  protoOf(PluginGeneratedSerialDescriptor).oh = function (name) {
		    var tmp0_elvis_lhs = this.up_1.c2(name);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      tmp = -3;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
		    var tmp$ret$0;
		    $l$block_5: {
		      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
		      if (this === other) {
		        tmp$ret$0 = true;
		        break $l$block_5;
		      }
		      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      if (!(this.sg() === other.sg())) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
		      if (!contentEquals(this.oq(), other.oq())) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      if (!(this.jh() === other.jh())) {
		        tmp$ret$0 = false;
		        break $l$block_5;
		      }
		      var inductionVariable = 0;
		      var last = this.jh();
		      if (inductionVariable < last)
		        do {
		          var index = inductionVariable;
		          inductionVariable = inductionVariable + 1 | 0;
		          if (!(this.nh(index).sg() === other.nh(index).sg())) {
		            tmp$ret$0 = false;
		            break $l$block_5;
		          }
		          if (!equals(this.nh(index).lh(), other.nh(index).lh())) {
		            tmp$ret$0 = false;
		            break $l$block_5;
		          }
		        }
		         while (inductionVariable < last);
		      tmp$ret$0 = true;
		    }
		    return tmp$ret$0;
		  };
		  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
		    return _get__hashCode__tgwhef_0(this);
		  };
		  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
		    var tmp = until(0, this.op_1);
		    var tmp_0 = this.sg() + '(';
		    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
		  };
		  function hashCodeImpl(_this__u8e3s4, typeParams) {
		    var result = getStringHashCode(_this__u8e3s4.sg());
		    result = imul(31, result) + contentHashCode(typeParams) | 0;
		    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
		    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
		    // Inline function 'kotlin.collections.fold' call
		    var accumulator = 1;
		    var tmp0_iterator = elementDescriptors.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
		      var hash = accumulator;
		      var tmp = imul(31, hash);
		      // Inline function 'kotlin.hashCode' call
		      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
		      var tmp0_safe_receiver = element.sg();
		      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
		      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
		    }
		    var namesHash = accumulator;
		    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
		    // Inline function 'kotlin.collections.fold' call
		    var accumulator_0 = 1;
		    var tmp0_iterator_0 = elementDescriptors.p();
		    while (tmp0_iterator_0.q()) {
		      var element_0 = tmp0_iterator_0.s();
		      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
		      var hash_0 = accumulator_0;
		      var tmp_0 = imul(31, hash_0);
		      // Inline function 'kotlin.hashCode' call
		      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
		      var tmp0_safe_receiver_0 = element_0.lh();
		      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
		      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
		    }
		    var kindHash = accumulator_0;
		    result = imul(31, result) + namesHash | 0;
		    result = imul(31, result) + kindHash | 0;
		    return result;
		  }
		  function childSerializers$factory() {
		    return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
		      return _get_childSerializers__7vnyfa(receiver);
		    }, null);
		  }
		  function typeParameterDescriptors$factory() {
		    return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
		      return receiver.oq();
		    }, null);
		  }
		  function _hashCode$factory_0() {
		    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
		      return _get__hashCode__tgwhef_0(receiver);
		    }, null);
		  }
		  function get_EMPTY_SERIALIZER_ARRAY() {
		    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
		    return EMPTY_SERIALIZER_ARRAY;
		  }
		  var EMPTY_SERIALIZER_ARRAY;
		  function SerializerFactory() {
		  }
		  function GeneratedSerializer() {
		  }
		  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
		  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
		    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
		      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
		      // Inline function 'kotlin.arrayOf' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      EMPTY_SERIALIZER_ARRAY = [];
		    }
		  }
		  function CharArraySerializer_0() {
		    CharArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_1(Companion_getInstance_1()));
		  }
		  protoOf(CharArraySerializer_0).qr = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(CharArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.qr((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(CharArraySerializer_0).rr = function (_this__u8e3s4) {
		    return new CharArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(CharArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.rr((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(CharArraySerializer_0).xo = function () {
		    return charArray(0);
		  };
		  protoOf(CharArraySerializer_0).sr = function (decoder, index, builder, checkIndex) {
		    builder.vr(decoder.nj(this.po_1, index));
		  };
		  protoOf(CharArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.sr(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(CharArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.sr(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(CharArraySerializer_0).wr = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        encoder.sk(this.po_1, i, content[i]);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(CharArraySerializer_0).zo = function (encoder, content, size) {
		    return this.wr(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
		  };
		  var CharArraySerializer_instance;
		  function CharArraySerializer_getInstance() {
		    if (CharArraySerializer_instance == null)
		      new CharArraySerializer_0();
		    return CharArraySerializer_instance;
		  }
		  function DoubleArraySerializer_0() {
		    DoubleArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_2(DoubleCompanionObject_instance));
		  }
		  protoOf(DoubleArraySerializer_0).zr = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(DoubleArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.zr((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(DoubleArraySerializer_0).as = function (_this__u8e3s4) {
		    return new DoubleArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(DoubleArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.as((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(DoubleArraySerializer_0).xo = function () {
		    return new Float64Array(0);
		  };
		  protoOf(DoubleArraySerializer_0).bs = function (decoder, index, builder, checkIndex) {
		    builder.es(decoder.mj(this.po_1, index));
		  };
		  protoOf(DoubleArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.bs(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(DoubleArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.bs(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(DoubleArraySerializer_0).fs = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        encoder.rk(this.po_1, i, content[i]);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(DoubleArraySerializer_0).zo = function (encoder, content, size) {
		    return this.fs(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
		  };
		  var DoubleArraySerializer_instance;
		  function DoubleArraySerializer_getInstance() {
		    if (DoubleArraySerializer_instance == null)
		      new DoubleArraySerializer_0();
		    return DoubleArraySerializer_instance;
		  }
		  function FloatArraySerializer_0() {
		    FloatArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_3(FloatCompanionObject_instance));
		  }
		  protoOf(FloatArraySerializer_0).is = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(FloatArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.is((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(FloatArraySerializer_0).js = function (_this__u8e3s4) {
		    return new FloatArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(FloatArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.js((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(FloatArraySerializer_0).xo = function () {
		    return new Float32Array(0);
		  };
		  protoOf(FloatArraySerializer_0).ks = function (decoder, index, builder, checkIndex) {
		    builder.ns(decoder.lj(this.po_1, index));
		  };
		  protoOf(FloatArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.ks(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(FloatArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.ks(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(FloatArraySerializer_0).os = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        encoder.qk(this.po_1, i, content[i]);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(FloatArraySerializer_0).zo = function (encoder, content, size) {
		    return this.os(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
		  };
		  var FloatArraySerializer_instance;
		  function FloatArraySerializer_getInstance() {
		    if (FloatArraySerializer_instance == null)
		      new FloatArraySerializer_0();
		    return FloatArraySerializer_instance;
		  }
		  function LongArraySerializer_0() {
		    LongArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_4(Companion_getInstance_0()));
		  }
		  protoOf(LongArraySerializer_0).rs = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(LongArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.rs((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LongArraySerializer_0).ss = function (_this__u8e3s4) {
		    return new LongArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(LongArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.ss((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(LongArraySerializer_0).xo = function () {
		    return longArray(0);
		  };
		  protoOf(LongArraySerializer_0).ts = function (decoder, index, builder, checkIndex) {
		    builder.ws(decoder.kj(this.po_1, index));
		  };
		  protoOf(LongArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.ts(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(LongArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.ts(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(LongArraySerializer_0).xs = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        encoder.pk(this.po_1, i, content[i]);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(LongArraySerializer_0).zo = function (encoder, content, size) {
		    return this.xs(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
		  };
		  var LongArraySerializer_instance;
		  function LongArraySerializer_getInstance() {
		    if (LongArraySerializer_instance == null)
		      new LongArraySerializer_0();
		    return LongArraySerializer_instance;
		  }
		  function ULongArraySerializer_0() {
		    ULongArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_2()));
		  }
		  protoOf(ULongArraySerializer_0).at = function (_this__u8e3s4) {
		    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
		  };
		  protoOf(ULongArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.at(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.gf_1 : THROW_CCE());
		  };
		  protoOf(ULongArraySerializer_0).bt = function (_this__u8e3s4) {
		    return new ULongArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(ULongArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.bt(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.gf_1 : THROW_CCE());
		  };
		  protoOf(ULongArraySerializer_0).ct = function () {
		    return _ULongArray___init__impl__twm1l3(0);
		  };
		  protoOf(ULongArraySerializer_0).xo = function () {
		    return new ULongArray(this.ct());
		  };
		  protoOf(ULongArraySerializer_0).dt = function (decoder, index, builder, checkIndex) {
		    // Inline function 'kotlin.toULong' call
		    var this_0 = decoder.pj(this.po_1, index).vi();
		    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
		    builder.gt(tmp$ret$0);
		  };
		  protoOf(ULongArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.dt(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(ULongArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.dt(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(ULongArraySerializer_0).ht = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var tmp = encoder.uk(this.po_1, i);
		        // Inline function 'kotlin.ULong.toLong' call
		        var this_0 = ULongArray__get_impl_pr71q9(content, i);
		        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
		        tmp.ek(tmp$ret$0);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(ULongArraySerializer_0).zo = function (encoder, content, size) {
		    return this.ht(encoder, content instanceof ULongArray ? content.gf_1 : THROW_CCE(), size);
		  };
		  var ULongArraySerializer_instance;
		  function ULongArraySerializer_getInstance() {
		    if (ULongArraySerializer_instance == null)
		      new ULongArraySerializer_0();
		    return ULongArraySerializer_instance;
		  }
		  function IntArraySerializer_0() {
		    IntArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_6(IntCompanionObject_instance));
		  }
		  protoOf(IntArraySerializer_0).kt = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(IntArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.kt((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(IntArraySerializer_0).lt = function (_this__u8e3s4) {
		    return new IntArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(IntArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.lt((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(IntArraySerializer_0).xo = function () {
		    return new Int32Array(0);
		  };
		  protoOf(IntArraySerializer_0).mt = function (decoder, index, builder, checkIndex) {
		    builder.pt(decoder.jj(this.po_1, index));
		  };
		  protoOf(IntArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.mt(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(IntArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.mt(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(IntArraySerializer_0).qt = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        encoder.ok(this.po_1, i, content[i]);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(IntArraySerializer_0).zo = function (encoder, content, size) {
		    return this.qt(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
		  };
		  var IntArraySerializer_instance;
		  function IntArraySerializer_getInstance() {
		    if (IntArraySerializer_instance == null)
		      new IntArraySerializer_0();
		    return IntArraySerializer_instance;
		  }
		  function UIntArraySerializer_0() {
		    UIntArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_7(Companion_getInstance_3()));
		  }
		  protoOf(UIntArraySerializer_0).tt = function (_this__u8e3s4) {
		    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
		  };
		  protoOf(UIntArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.tt(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.ve_1 : THROW_CCE());
		  };
		  protoOf(UIntArraySerializer_0).ut = function (_this__u8e3s4) {
		    return new UIntArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(UIntArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.ut(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.ve_1 : THROW_CCE());
		  };
		  protoOf(UIntArraySerializer_0).vt = function () {
		    return _UIntArray___init__impl__ghjpc6(0);
		  };
		  protoOf(UIntArraySerializer_0).xo = function () {
		    return new UIntArray(this.vt());
		  };
		  protoOf(UIntArraySerializer_0).wt = function (decoder, index, builder, checkIndex) {
		    // Inline function 'kotlin.toUInt' call
		    var this_0 = decoder.pj(this.po_1, index).ui();
		    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
		    builder.zt(tmp$ret$0);
		  };
		  protoOf(UIntArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.wt(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(UIntArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.wt(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(UIntArraySerializer_0).au = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var tmp = encoder.uk(this.po_1, i);
		        // Inline function 'kotlin.UInt.toInt' call
		        var this_0 = UIntArray__get_impl_gp5kza(content, i);
		        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
		        tmp.dk(tmp$ret$0);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(UIntArraySerializer_0).zo = function (encoder, content, size) {
		    return this.au(encoder, content instanceof UIntArray ? content.ve_1 : THROW_CCE(), size);
		  };
		  var UIntArraySerializer_instance;
		  function UIntArraySerializer_getInstance() {
		    if (UIntArraySerializer_instance == null)
		      new UIntArraySerializer_0();
		    return UIntArraySerializer_instance;
		  }
		  function ShortArraySerializer_0() {
		    ShortArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_8(ShortCompanionObject_instance));
		  }
		  protoOf(ShortArraySerializer_0).du = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(ShortArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.du((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ShortArraySerializer_0).eu = function (_this__u8e3s4) {
		    return new ShortArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(ShortArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.eu((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ShortArraySerializer_0).xo = function () {
		    return new Int16Array(0);
		  };
		  protoOf(ShortArraySerializer_0).fu = function (decoder, index, builder, checkIndex) {
		    builder.iu(decoder.ij(this.po_1, index));
		  };
		  protoOf(ShortArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.fu(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(ShortArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.fu(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(ShortArraySerializer_0).ju = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        encoder.nk(this.po_1, i, content[i]);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(ShortArraySerializer_0).zo = function (encoder, content, size) {
		    return this.ju(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
		  };
		  var ShortArraySerializer_instance;
		  function ShortArraySerializer_getInstance() {
		    if (ShortArraySerializer_instance == null)
		      new ShortArraySerializer_0();
		    return ShortArraySerializer_instance;
		  }
		  function UShortArraySerializer_0() {
		    UShortArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_9(Companion_getInstance_4()));
		  }
		  protoOf(UShortArraySerializer_0).mu = function (_this__u8e3s4) {
		    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
		  };
		  protoOf(UShortArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.mu(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.rf_1 : THROW_CCE());
		  };
		  protoOf(UShortArraySerializer_0).nu = function (_this__u8e3s4) {
		    return new UShortArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(UShortArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.nu(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.rf_1 : THROW_CCE());
		  };
		  protoOf(UShortArraySerializer_0).ou = function () {
		    return _UShortArray___init__impl__9b26ef(0);
		  };
		  protoOf(UShortArraySerializer_0).xo = function () {
		    return new UShortArray(this.ou());
		  };
		  protoOf(UShortArraySerializer_0).pu = function (decoder, index, builder, checkIndex) {
		    // Inline function 'kotlin.toUShort' call
		    var this_0 = decoder.pj(this.po_1, index).ti();
		    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
		    builder.su(tmp$ret$0);
		  };
		  protoOf(UShortArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.pu(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(UShortArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.pu(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(UShortArraySerializer_0).tu = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var tmp = encoder.uk(this.po_1, i);
		        // Inline function 'kotlin.UShort.toShort' call
		        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
		        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
		        tmp.ck(tmp$ret$0);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(UShortArraySerializer_0).zo = function (encoder, content, size) {
		    return this.tu(encoder, content instanceof UShortArray ? content.rf_1 : THROW_CCE(), size);
		  };
		  var UShortArraySerializer_instance;
		  function UShortArraySerializer_getInstance() {
		    if (UShortArraySerializer_instance == null)
		      new UShortArraySerializer_0();
		    return UShortArraySerializer_instance;
		  }
		  function ByteArraySerializer_0() {
		    ByteArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_10(ByteCompanionObject_instance));
		  }
		  protoOf(ByteArraySerializer_0).wu = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(ByteArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.wu((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ByteArraySerializer_0).xu = function (_this__u8e3s4) {
		    return new ByteArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(ByteArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.xu((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(ByteArraySerializer_0).xo = function () {
		    return new Int8Array(0);
		  };
		  protoOf(ByteArraySerializer_0).yu = function (decoder, index, builder, checkIndex) {
		    builder.bv(decoder.hj(this.po_1, index));
		  };
		  protoOf(ByteArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.yu(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(ByteArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.yu(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(ByteArraySerializer_0).cv = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        encoder.mk(this.po_1, i, content[i]);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(ByteArraySerializer_0).zo = function (encoder, content, size) {
		    return this.cv(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
		  };
		  var ByteArraySerializer_instance;
		  function ByteArraySerializer_getInstance() {
		    if (ByteArraySerializer_instance == null)
		      new ByteArraySerializer_0();
		    return ByteArraySerializer_instance;
		  }
		  function UByteArraySerializer_0() {
		    UByteArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_11(Companion_getInstance_5()));
		  }
		  protoOf(UByteArraySerializer_0).fv = function (_this__u8e3s4) {
		    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
		  };
		  protoOf(UByteArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.fv(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.ke_1 : THROW_CCE());
		  };
		  protoOf(UByteArraySerializer_0).gv = function (_this__u8e3s4) {
		    return new UByteArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(UByteArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.gv(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.ke_1 : THROW_CCE());
		  };
		  protoOf(UByteArraySerializer_0).hv = function () {
		    return _UByteArray___init__impl__ip4y9n(0);
		  };
		  protoOf(UByteArraySerializer_0).xo = function () {
		    return new UByteArray(this.hv());
		  };
		  protoOf(UByteArraySerializer_0).iv = function (decoder, index, builder, checkIndex) {
		    // Inline function 'kotlin.toUByte' call
		    var this_0 = decoder.pj(this.po_1, index).si();
		    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
		    builder.lv(tmp$ret$0);
		  };
		  protoOf(UByteArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.iv(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(UByteArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.iv(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(UByteArraySerializer_0).mv = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var tmp = encoder.uk(this.po_1, i);
		        // Inline function 'kotlin.UByte.toByte' call
		        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
		        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
		        tmp.bk(tmp$ret$0);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(UByteArraySerializer_0).zo = function (encoder, content, size) {
		    return this.mv(encoder, content instanceof UByteArray ? content.ke_1 : THROW_CCE(), size);
		  };
		  var UByteArraySerializer_instance;
		  function UByteArraySerializer_getInstance() {
		    if (UByteArraySerializer_instance == null)
		      new UByteArraySerializer_0();
		    return UByteArraySerializer_instance;
		  }
		  function BooleanArraySerializer_0() {
		    BooleanArraySerializer_instance = this;
		    PrimitiveArraySerializer.call(this, serializer_12(BooleanCompanionObject_instance));
		  }
		  protoOf(BooleanArraySerializer_0).pv = function (_this__u8e3s4) {
		    return _this__u8e3s4.length;
		  };
		  protoOf(BooleanArraySerializer_0).nn = function (_this__u8e3s4) {
		    return this.pv((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(BooleanArraySerializer_0).qv = function (_this__u8e3s4) {
		    return new BooleanArrayBuilder(_this__u8e3s4);
		  };
		  protoOf(BooleanArraySerializer_0).im = function (_this__u8e3s4) {
		    return this.qv((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(BooleanArraySerializer_0).xo = function () {
		    return booleanArray(0);
		  };
		  protoOf(BooleanArraySerializer_0).rv = function (decoder, index, builder, checkIndex) {
		    builder.uv(decoder.gj(this.po_1, index));
		  };
		  protoOf(BooleanArraySerializer_0).tm = function (decoder, index, builder, checkIndex) {
		    return this.rv(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(BooleanArraySerializer_0).yo = function (decoder, index, builder, checkIndex) {
		    return this.rv(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
		  };
		  protoOf(BooleanArraySerializer_0).vv = function (encoder, content, size) {
		    var inductionVariable = 0;
		    if (inductionVariable < size)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        encoder.lk(this.po_1, i, content[i]);
		      }
		       while (inductionVariable < size);
		  };
		  protoOf(BooleanArraySerializer_0).zo = function (encoder, content, size) {
		    return this.vv(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
		  };
		  var BooleanArraySerializer_instance;
		  function BooleanArraySerializer_getInstance() {
		    if (BooleanArraySerializer_instance == null)
		      new BooleanArraySerializer_0();
		    return BooleanArraySerializer_instance;
		  }
		  function CharArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.tr_1 = bufferWithData;
		    this.ur_1 = bufferWithData.length;
		    this.l2(10);
		  }
		  protoOf(CharArrayBuilder).ro = function () {
		    return this.ur_1;
		  };
		  protoOf(CharArrayBuilder).l2 = function (requiredCapacity) {
		    if (this.tr_1.length < requiredCapacity)
		      this.tr_1 = copyOf(this.tr_1, coerceAtLeast(requiredCapacity, imul(this.tr_1.length, 2)));
		  };
		  protoOf(CharArrayBuilder).vr = function (c) {
		    this.bp();
		    var tmp = this.tr_1;
		    var tmp1 = this.ur_1;
		    this.ur_1 = tmp1 + 1 | 0;
		    tmp[tmp1] = c;
		  };
		  protoOf(CharArrayBuilder).to = function () {
		    return copyOf(this.tr_1, this.ur_1);
		  };
		  function DoubleArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.cs_1 = bufferWithData;
		    this.ds_1 = bufferWithData.length;
		    this.l2(10);
		  }
		  protoOf(DoubleArrayBuilder).ro = function () {
		    return this.ds_1;
		  };
		  protoOf(DoubleArrayBuilder).l2 = function (requiredCapacity) {
		    if (this.cs_1.length < requiredCapacity)
		      this.cs_1 = copyOf_0(this.cs_1, coerceAtLeast(requiredCapacity, imul(this.cs_1.length, 2)));
		  };
		  protoOf(DoubleArrayBuilder).es = function (c) {
		    this.bp();
		    var tmp = this.cs_1;
		    var tmp1 = this.ds_1;
		    this.ds_1 = tmp1 + 1 | 0;
		    tmp[tmp1] = c;
		  };
		  protoOf(DoubleArrayBuilder).to = function () {
		    return copyOf_0(this.cs_1, this.ds_1);
		  };
		  function FloatArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.ls_1 = bufferWithData;
		    this.ms_1 = bufferWithData.length;
		    this.l2(10);
		  }
		  protoOf(FloatArrayBuilder).ro = function () {
		    return this.ms_1;
		  };
		  protoOf(FloatArrayBuilder).l2 = function (requiredCapacity) {
		    if (this.ls_1.length < requiredCapacity)
		      this.ls_1 = copyOf_1(this.ls_1, coerceAtLeast(requiredCapacity, imul(this.ls_1.length, 2)));
		  };
		  protoOf(FloatArrayBuilder).ns = function (c) {
		    this.bp();
		    var tmp = this.ls_1;
		    var tmp1 = this.ms_1;
		    this.ms_1 = tmp1 + 1 | 0;
		    tmp[tmp1] = c;
		  };
		  protoOf(FloatArrayBuilder).to = function () {
		    return copyOf_1(this.ls_1, this.ms_1);
		  };
		  function LongArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.us_1 = bufferWithData;
		    this.vs_1 = bufferWithData.length;
		    this.l2(10);
		  }
		  protoOf(LongArrayBuilder).ro = function () {
		    return this.vs_1;
		  };
		  protoOf(LongArrayBuilder).l2 = function (requiredCapacity) {
		    if (this.us_1.length < requiredCapacity)
		      this.us_1 = copyOf_2(this.us_1, coerceAtLeast(requiredCapacity, imul(this.us_1.length, 2)));
		  };
		  protoOf(LongArrayBuilder).ws = function (c) {
		    this.bp();
		    var tmp = this.us_1;
		    var tmp1 = this.vs_1;
		    this.vs_1 = tmp1 + 1 | 0;
		    tmp[tmp1] = c;
		  };
		  protoOf(LongArrayBuilder).to = function () {
		    return copyOf_2(this.us_1, this.vs_1);
		  };
		  function ULongArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.et_1 = bufferWithData;
		    this.ft_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
		    this.l2(10);
		  }
		  protoOf(ULongArrayBuilder).ro = function () {
		    return this.ft_1;
		  };
		  protoOf(ULongArrayBuilder).l2 = function (requiredCapacity) {
		    if (_ULongArray___get_size__impl__ju6dtr(this.et_1) < requiredCapacity) {
		      var tmp = this;
		      // Inline function 'kotlin.collections.copyOf' call
		      var this_0 = this.et_1;
		      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.et_1), 2));
		      tmp.et_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
		    }
		  };
		  protoOf(ULongArrayBuilder).gt = function (c) {
		    this.bp();
		    var tmp = this.et_1;
		    var tmp1 = this.ft_1;
		    this.ft_1 = tmp1 + 1 | 0;
		    ULongArray__set_impl_z19mvh(tmp, tmp1, c);
		  };
		  protoOf(ULongArrayBuilder).wv = function () {
		    // Inline function 'kotlin.collections.copyOf' call
		    var this_0 = this.et_1;
		    var newSize = this.ft_1;
		    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
		  };
		  protoOf(ULongArrayBuilder).to = function () {
		    return new ULongArray(this.wv());
		  };
		  function IntArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.nt_1 = bufferWithData;
		    this.ot_1 = bufferWithData.length;
		    this.l2(10);
		  }
		  protoOf(IntArrayBuilder).ro = function () {
		    return this.ot_1;
		  };
		  protoOf(IntArrayBuilder).l2 = function (requiredCapacity) {
		    if (this.nt_1.length < requiredCapacity)
		      this.nt_1 = copyOf_3(this.nt_1, coerceAtLeast(requiredCapacity, imul(this.nt_1.length, 2)));
		  };
		  protoOf(IntArrayBuilder).pt = function (c) {
		    this.bp();
		    var tmp = this.nt_1;
		    var tmp1 = this.ot_1;
		    this.ot_1 = tmp1 + 1 | 0;
		    tmp[tmp1] = c;
		  };
		  protoOf(IntArrayBuilder).to = function () {
		    return copyOf_3(this.nt_1, this.ot_1);
		  };
		  function UIntArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.xt_1 = bufferWithData;
		    this.yt_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
		    this.l2(10);
		  }
		  protoOf(UIntArrayBuilder).ro = function () {
		    return this.yt_1;
		  };
		  protoOf(UIntArrayBuilder).l2 = function (requiredCapacity) {
		    if (_UIntArray___get_size__impl__r6l8ci(this.xt_1) < requiredCapacity) {
		      var tmp = this;
		      // Inline function 'kotlin.collections.copyOf' call
		      var this_0 = this.xt_1;
		      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.xt_1), 2));
		      tmp.xt_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
		    }
		  };
		  protoOf(UIntArrayBuilder).zt = function (c) {
		    this.bp();
		    var tmp = this.xt_1;
		    var tmp1 = this.yt_1;
		    this.yt_1 = tmp1 + 1 | 0;
		    UIntArray__set_impl_7f2zu2(tmp, tmp1, c);
		  };
		  protoOf(UIntArrayBuilder).xv = function () {
		    // Inline function 'kotlin.collections.copyOf' call
		    var this_0 = this.xt_1;
		    var newSize = this.yt_1;
		    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
		  };
		  protoOf(UIntArrayBuilder).to = function () {
		    return new UIntArray(this.xv());
		  };
		  function ShortArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.gu_1 = bufferWithData;
		    this.hu_1 = bufferWithData.length;
		    this.l2(10);
		  }
		  protoOf(ShortArrayBuilder).ro = function () {
		    return this.hu_1;
		  };
		  protoOf(ShortArrayBuilder).l2 = function (requiredCapacity) {
		    if (this.gu_1.length < requiredCapacity)
		      this.gu_1 = copyOf_4(this.gu_1, coerceAtLeast(requiredCapacity, imul(this.gu_1.length, 2)));
		  };
		  protoOf(ShortArrayBuilder).iu = function (c) {
		    this.bp();
		    var tmp = this.gu_1;
		    var tmp1 = this.hu_1;
		    this.hu_1 = tmp1 + 1 | 0;
		    tmp[tmp1] = c;
		  };
		  protoOf(ShortArrayBuilder).to = function () {
		    return copyOf_4(this.gu_1, this.hu_1);
		  };
		  function UShortArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.qu_1 = bufferWithData;
		    this.ru_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
		    this.l2(10);
		  }
		  protoOf(UShortArrayBuilder).ro = function () {
		    return this.ru_1;
		  };
		  protoOf(UShortArrayBuilder).l2 = function (requiredCapacity) {
		    if (_UShortArray___get_size__impl__jqto1b(this.qu_1) < requiredCapacity) {
		      var tmp = this;
		      // Inline function 'kotlin.collections.copyOf' call
		      var this_0 = this.qu_1;
		      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.qu_1), 2));
		      tmp.qu_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
		    }
		  };
		  protoOf(UShortArrayBuilder).su = function (c) {
		    this.bp();
		    var tmp = this.qu_1;
		    var tmp1 = this.ru_1;
		    this.ru_1 = tmp1 + 1 | 0;
		    UShortArray__set_impl_6d8whp(tmp, tmp1, c);
		  };
		  protoOf(UShortArrayBuilder).yv = function () {
		    // Inline function 'kotlin.collections.copyOf' call
		    var this_0 = this.qu_1;
		    var newSize = this.ru_1;
		    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
		  };
		  protoOf(UShortArrayBuilder).to = function () {
		    return new UShortArray(this.yv());
		  };
		  function ByteArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.zu_1 = bufferWithData;
		    this.av_1 = bufferWithData.length;
		    this.l2(10);
		  }
		  protoOf(ByteArrayBuilder).ro = function () {
		    return this.av_1;
		  };
		  protoOf(ByteArrayBuilder).l2 = function (requiredCapacity) {
		    if (this.zu_1.length < requiredCapacity)
		      this.zu_1 = copyOf_5(this.zu_1, coerceAtLeast(requiredCapacity, imul(this.zu_1.length, 2)));
		  };
		  protoOf(ByteArrayBuilder).bv = function (c) {
		    this.bp();
		    var tmp = this.zu_1;
		    var tmp1 = this.av_1;
		    this.av_1 = tmp1 + 1 | 0;
		    tmp[tmp1] = c;
		  };
		  protoOf(ByteArrayBuilder).to = function () {
		    return copyOf_5(this.zu_1, this.av_1);
		  };
		  function UByteArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.jv_1 = bufferWithData;
		    this.kv_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
		    this.l2(10);
		  }
		  protoOf(UByteArrayBuilder).ro = function () {
		    return this.kv_1;
		  };
		  protoOf(UByteArrayBuilder).l2 = function (requiredCapacity) {
		    if (_UByteArray___get_size__impl__h6pkdv(this.jv_1) < requiredCapacity) {
		      var tmp = this;
		      // Inline function 'kotlin.collections.copyOf' call
		      var this_0 = this.jv_1;
		      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.jv_1), 2));
		      tmp.jv_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
		    }
		  };
		  protoOf(UByteArrayBuilder).lv = function (c) {
		    this.bp();
		    var tmp = this.jv_1;
		    var tmp1 = this.kv_1;
		    this.kv_1 = tmp1 + 1 | 0;
		    UByteArray__set_impl_jvcicn(tmp, tmp1, c);
		  };
		  protoOf(UByteArrayBuilder).zv = function () {
		    // Inline function 'kotlin.collections.copyOf' call
		    var this_0 = this.jv_1;
		    var newSize = this.kv_1;
		    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
		  };
		  protoOf(UByteArrayBuilder).to = function () {
		    return new UByteArray(this.zv());
		  };
		  function BooleanArrayBuilder(bufferWithData) {
		    PrimitiveArrayBuilder.call(this);
		    this.sv_1 = bufferWithData;
		    this.tv_1 = bufferWithData.length;
		    this.l2(10);
		  }
		  protoOf(BooleanArrayBuilder).ro = function () {
		    return this.tv_1;
		  };
		  protoOf(BooleanArrayBuilder).l2 = function (requiredCapacity) {
		    if (this.sv_1.length < requiredCapacity)
		      this.sv_1 = copyOf_6(this.sv_1, coerceAtLeast(requiredCapacity, imul(this.sv_1.length, 2)));
		  };
		  protoOf(BooleanArrayBuilder).uv = function (c) {
		    this.bp();
		    var tmp = this.sv_1;
		    var tmp1 = this.tv_1;
		    this.tv_1 = tmp1 + 1 | 0;
		    tmp[tmp1] = c;
		  };
		  protoOf(BooleanArrayBuilder).to = function () {
		    return copyOf_6(this.sv_1, this.tv_1);
		  };
		  function get_BUILTIN_SERIALIZERS() {
		    _init_properties_Primitives_kt__k0eto4();
		    return BUILTIN_SERIALIZERS;
		  }
		  var BUILTIN_SERIALIZERS;
		  function builtinSerializerOrNull(_this__u8e3s4) {
		    _init_properties_Primitives_kt__k0eto4();
		    var tmp = get_BUILTIN_SERIALIZERS().c2(_this__u8e3s4);
		    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
		  }
		  function StringSerializer() {
		    StringSerializer_instance = this;
		    this.aw_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
		  }
		  protoOf(StringSerializer).uf = function () {
		    return this.aw_1;
		  };
		  protoOf(StringSerializer).bw = function (encoder, value) {
		    return encoder.ik(value);
		  };
		  protoOf(StringSerializer).vf = function (encoder, value) {
		    return this.bw(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
		  };
		  protoOf(StringSerializer).wf = function (decoder) {
		    return decoder.zi();
		  };
		  var StringSerializer_instance;
		  function StringSerializer_getInstance() {
		    if (StringSerializer_instance == null)
		      new StringSerializer();
		    return StringSerializer_instance;
		  }
		  function CharSerializer() {
		    CharSerializer_instance = this;
		    this.cw_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
		  }
		  protoOf(CharSerializer).uf = function () {
		    return this.cw_1;
		  };
		  protoOf(CharSerializer).dw = function (encoder, value) {
		    return encoder.hk(value);
		  };
		  protoOf(CharSerializer).vf = function (encoder, value) {
		    return this.dw(encoder, value instanceof Char ? value.w8_1 : THROW_CCE());
		  };
		  protoOf(CharSerializer).ew = function (decoder) {
		    return decoder.yi();
		  };
		  protoOf(CharSerializer).wf = function (decoder) {
		    return new Char(this.ew(decoder));
		  };
		  var CharSerializer_instance;
		  function CharSerializer_getInstance() {
		    if (CharSerializer_instance == null)
		      new CharSerializer();
		    return CharSerializer_instance;
		  }
		  function DoubleSerializer() {
		    DoubleSerializer_instance = this;
		    this.fw_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
		  }
		  protoOf(DoubleSerializer).uf = function () {
		    return this.fw_1;
		  };
		  protoOf(DoubleSerializer).gw = function (encoder, value) {
		    return encoder.gk(value);
		  };
		  protoOf(DoubleSerializer).vf = function (encoder, value) {
		    return this.gw(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
		  };
		  protoOf(DoubleSerializer).wf = function (decoder) {
		    return decoder.xi();
		  };
		  var DoubleSerializer_instance;
		  function DoubleSerializer_getInstance() {
		    if (DoubleSerializer_instance == null)
		      new DoubleSerializer();
		    return DoubleSerializer_instance;
		  }
		  function FloatSerializer() {
		    FloatSerializer_instance = this;
		    this.hw_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
		  }
		  protoOf(FloatSerializer).uf = function () {
		    return this.hw_1;
		  };
		  protoOf(FloatSerializer).iw = function (encoder, value) {
		    return encoder.fk(value);
		  };
		  protoOf(FloatSerializer).vf = function (encoder, value) {
		    return this.iw(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
		  };
		  protoOf(FloatSerializer).wf = function (decoder) {
		    return decoder.wi();
		  };
		  var FloatSerializer_instance;
		  function FloatSerializer_getInstance() {
		    if (FloatSerializer_instance == null)
		      new FloatSerializer();
		    return FloatSerializer_instance;
		  }
		  function LongSerializer() {
		    LongSerializer_instance = this;
		    this.jw_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
		  }
		  protoOf(LongSerializer).uf = function () {
		    return this.jw_1;
		  };
		  protoOf(LongSerializer).kw = function (encoder, value) {
		    return encoder.ek(value);
		  };
		  protoOf(LongSerializer).vf = function (encoder, value) {
		    return this.kw(encoder, value instanceof Long ? value : THROW_CCE());
		  };
		  protoOf(LongSerializer).wf = function (decoder) {
		    return decoder.vi();
		  };
		  var LongSerializer_instance;
		  function LongSerializer_getInstance() {
		    if (LongSerializer_instance == null)
		      new LongSerializer();
		    return LongSerializer_instance;
		  }
		  function IntSerializer() {
		    IntSerializer_instance = this;
		    this.lw_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
		  }
		  protoOf(IntSerializer).uf = function () {
		    return this.lw_1;
		  };
		  protoOf(IntSerializer).mw = function (encoder, value) {
		    return encoder.dk(value);
		  };
		  protoOf(IntSerializer).vf = function (encoder, value) {
		    return this.mw(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
		  };
		  protoOf(IntSerializer).wf = function (decoder) {
		    return decoder.ui();
		  };
		  var IntSerializer_instance;
		  function IntSerializer_getInstance() {
		    if (IntSerializer_instance == null)
		      new IntSerializer();
		    return IntSerializer_instance;
		  }
		  function ShortSerializer() {
		    ShortSerializer_instance = this;
		    this.nw_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
		  }
		  protoOf(ShortSerializer).uf = function () {
		    return this.nw_1;
		  };
		  protoOf(ShortSerializer).ow = function (encoder, value) {
		    return encoder.ck(value);
		  };
		  protoOf(ShortSerializer).vf = function (encoder, value) {
		    return this.ow(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
		  };
		  protoOf(ShortSerializer).wf = function (decoder) {
		    return decoder.ti();
		  };
		  var ShortSerializer_instance;
		  function ShortSerializer_getInstance() {
		    if (ShortSerializer_instance == null)
		      new ShortSerializer();
		    return ShortSerializer_instance;
		  }
		  function ByteSerializer() {
		    ByteSerializer_instance = this;
		    this.pw_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
		  }
		  protoOf(ByteSerializer).uf = function () {
		    return this.pw_1;
		  };
		  protoOf(ByteSerializer).qw = function (encoder, value) {
		    return encoder.bk(value);
		  };
		  protoOf(ByteSerializer).vf = function (encoder, value) {
		    return this.qw(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
		  };
		  protoOf(ByteSerializer).wf = function (decoder) {
		    return decoder.si();
		  };
		  var ByteSerializer_instance;
		  function ByteSerializer_getInstance() {
		    if (ByteSerializer_instance == null)
		      new ByteSerializer();
		    return ByteSerializer_instance;
		  }
		  function BooleanSerializer() {
		    BooleanSerializer_instance = this;
		    this.rw_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
		  }
		  protoOf(BooleanSerializer).uf = function () {
		    return this.rw_1;
		  };
		  protoOf(BooleanSerializer).sw = function (encoder, value) {
		    return encoder.ak(value);
		  };
		  protoOf(BooleanSerializer).vf = function (encoder, value) {
		    return this.sw(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
		  };
		  protoOf(BooleanSerializer).wf = function (decoder) {
		    return decoder.ri();
		  };
		  var BooleanSerializer_instance;
		  function BooleanSerializer_getInstance() {
		    if (BooleanSerializer_instance == null)
		      new BooleanSerializer();
		    return BooleanSerializer_instance;
		  }
		  function UnitSerializer() {
		    UnitSerializer_instance = this;
		    this.tw_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
		  }
		  protoOf(UnitSerializer).uf = function () {
		    return this.tw_1.uf();
		  };
		  protoOf(UnitSerializer).uw = function (decoder) {
		    this.tw_1.wf(decoder);
		  };
		  protoOf(UnitSerializer).wf = function (decoder) {
		    this.uw(decoder);
		    return Unit_instance;
		  };
		  protoOf(UnitSerializer).vw = function (encoder, value) {
		    this.tw_1.kg(encoder, Unit_instance);
		  };
		  protoOf(UnitSerializer).vf = function (encoder, value) {
		    return this.vw(encoder, value instanceof Unit ? value : THROW_CCE());
		  };
		  var UnitSerializer_instance;
		  function UnitSerializer_getInstance() {
		    if (UnitSerializer_instance == null)
		      new UnitSerializer();
		    return UnitSerializer_instance;
		  }
		  function error($this) {
		    throw IllegalStateException_init_$Create$('Primitive descriptor does not have elements');
		  }
		  function PrimitiveSerialDescriptor_0(serialName, kind) {
		    this.ww_1 = serialName;
		    this.xw_1 = kind;
		  }
		  protoOf(PrimitiveSerialDescriptor_0).sg = function () {
		    return this.ww_1;
		  };
		  protoOf(PrimitiveSerialDescriptor_0).lh = function () {
		    return this.xw_1;
		  };
		  protoOf(PrimitiveSerialDescriptor_0).jh = function () {
		    return 0;
		  };
		  protoOf(PrimitiveSerialDescriptor_0).ph = function (index) {
		    error(this);
		  };
		  protoOf(PrimitiveSerialDescriptor_0).oh = function (name) {
		    error(this);
		  };
		  protoOf(PrimitiveSerialDescriptor_0).qh = function (index) {
		    error(this);
		  };
		  protoOf(PrimitiveSerialDescriptor_0).nh = function (index) {
		    error(this);
		  };
		  protoOf(PrimitiveSerialDescriptor_0).mh = function (index) {
		    error(this);
		  };
		  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
		    return 'PrimitiveDescriptor(' + this.ww_1 + ')';
		  };
		  function PrimitiveDescriptorSafe(serialName, kind) {
		    _init_properties_Primitives_kt__k0eto4();
		    checkName(serialName);
		    return new PrimitiveSerialDescriptor_0(serialName, kind);
		  }
		  function checkName(serialName) {
		    _init_properties_Primitives_kt__k0eto4();
		    var keys = get_BUILTIN_SERIALIZERS().q1();
		    var tmp0_iterator = keys.p();
		    while (tmp0_iterator.q()) {
		      var primitive = tmp0_iterator.s();
		      var simpleName = capitalize(ensureNotNull(primitive.t5()));
		      var qualifiedName = 'kotlin.' + simpleName;
		      if (equals_0(serialName, qualifiedName, true) ? true : equals_0(serialName, simpleName, true)) {
		        throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
		      }
		    }
		  }
		  function capitalize(_this__u8e3s4) {
		    _init_properties_Primitives_kt__k0eto4();
		    // Inline function 'kotlin.text.replaceFirstChar' call
		    var tmp;
		    // Inline function 'kotlin.text.isNotEmpty' call
		    if (charSequenceLength(_this__u8e3s4) > 0) {
		      // Inline function 'kotlinx.serialization.internal.capitalize.<anonymous>' call
		      var it = charSequenceGet(_this__u8e3s4, 0);
		      var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString_0(it);
		      var tmp_0 = toString(tmp$ret$1);
		      // Inline function 'kotlin.text.substring' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = tmp_0 + _this__u8e3s4.substring(1);
		    } else {
		      tmp = _this__u8e3s4;
		    }
		    return tmp;
		  }
		  var properties_initialized_Primitives_kt_6dpii6;
		  function _init_properties_Primitives_kt__k0eto4() {
		    if (!properties_initialized_Primitives_kt_6dpii6) {
		      properties_initialized_Primitives_kt_6dpii6 = true;
		      BUILTIN_SERIALIZERS = mapOf([to(PrimitiveClasses_getInstance().s6(), serializer_0(StringCompanionObject_instance)), to(getKClass(Char), serializer_1(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().v6(), CharArraySerializer()), to(PrimitiveClasses_getInstance().q6(), serializer_2(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().b7(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().p6(), serializer_3(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().a7(), FloatArraySerializer()), to(getKClass(Long), serializer_4(Companion_getInstance_0())), to(PrimitiveClasses_getInstance().z6(), LongArraySerializer()), to(getKClass(ULong), serializer_5(Companion_getInstance_2())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().o6(), serializer_6(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().y6(), IntArraySerializer()), to(getKClass(UInt), serializer_7(Companion_getInstance_3())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().n6(), serializer_8(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().x6(), ShortArraySerializer()), to(getKClass(UShort), serializer_9(Companion_getInstance_4())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().m6(), serializer_10(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().w6(), ByteArraySerializer()), to(getKClass(UByte), serializer_11(Companion_getInstance_5())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().l6(), serializer_12(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().u6(), BooleanArraySerializer()), to(getKClass(Unit), serializer_13(Unit_instance)), to(getKClass(Duration), serializer_14(Companion_getInstance()))]);
		    }
		  }
		  function NamedValueEncoder() {
		    TaggedEncoder.call(this);
		  }
		  protoOf(NamedValueEncoder).zw = function (_this__u8e3s4, index) {
		    return this.bx(this.ax(_this__u8e3s4, index));
		  };
		  protoOf(NamedValueEncoder).bx = function (nestedName) {
		    var tmp0_elvis_lhs = this.dx();
		    return this.ex(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
		  };
		  protoOf(NamedValueEncoder).ax = function (descriptor, index) {
		    return descriptor.ph(index);
		  };
		  protoOf(NamedValueEncoder).ex = function (parentName, childName) {
		    var tmp;
		    // Inline function 'kotlin.text.isEmpty' call
		    if (charSequenceLength(parentName) === 0) {
		      tmp = childName;
		    } else {
		      tmp = parentName + '.' + childName;
		    }
		    return tmp;
		  };
		  function NamedValueDecoder() {
		    TaggedDecoder.call(this);
		  }
		  protoOf(NamedValueDecoder).zw = function (_this__u8e3s4, index) {
		    return this.bx(this.ax(_this__u8e3s4, index));
		  };
		  protoOf(NamedValueDecoder).bx = function (nestedName) {
		    var tmp0_elvis_lhs = this.dx();
		    return this.ex(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
		  };
		  protoOf(NamedValueDecoder).ax = function (desc, index) {
		    return desc.ph(index);
		  };
		  protoOf(NamedValueDecoder).ex = function (parentName, childName) {
		    var tmp;
		    // Inline function 'kotlin.text.isEmpty' call
		    if (charSequenceLength(parentName) === 0) {
		      tmp = childName;
		    } else {
		      tmp = parentName + '.' + childName;
		    }
		    return tmp;
		  };
		  function encodeElement($this, desc, index) {
		    var tag = $this.zw(desc, index);
		    $this.vx(tag);
		    return true;
		  }
		  function TaggedEncoder() {
		    var tmp = this;
		    // Inline function 'kotlin.collections.arrayListOf' call
		    tmp.cx_1 = ArrayList_init_$Create$_0();
		  }
		  protoOf(TaggedEncoder).tj = function () {
		    return EmptySerializersModule_0();
		  };
		  protoOf(TaggedEncoder).fx = function (tag, value) {
		    throw SerializationException_init_$Create$_0('Non-serializable ' + getKClassFromExpression(value) + ' is not supported by ' + getKClassFromExpression(this) + ' encoder');
		  };
		  protoOf(TaggedEncoder).gx = function (tag) {
		  };
		  protoOf(TaggedEncoder).hx = function (tag) {
		    throw SerializationException_init_$Create$_0('null is not supported');
		  };
		  protoOf(TaggedEncoder).ix = function (tag, value) {
		    return this.fx(tag, value);
		  };
		  protoOf(TaggedEncoder).jx = function (tag, value) {
		    return this.fx(tag, value);
		  };
		  protoOf(TaggedEncoder).kx = function (tag, value) {
		    return this.fx(tag, value);
		  };
		  protoOf(TaggedEncoder).lx = function (tag, value) {
		    return this.fx(tag, value);
		  };
		  protoOf(TaggedEncoder).mx = function (tag, value) {
		    return this.fx(tag, value);
		  };
		  protoOf(TaggedEncoder).nx = function (tag, value) {
		    return this.fx(tag, value);
		  };
		  protoOf(TaggedEncoder).ox = function (tag, value) {
		    return this.fx(tag, value);
		  };
		  protoOf(TaggedEncoder).px = function (tag, value) {
		    return this.fx(tag, new Char(value));
		  };
		  protoOf(TaggedEncoder).qx = function (tag, value) {
		    return this.fx(tag, value);
		  };
		  protoOf(TaggedEncoder).rx = function (tag, enumDescriptor, ordinal) {
		    return this.fx(tag, ordinal);
		  };
		  protoOf(TaggedEncoder).sx = function (tag, inlineDescriptor) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlinx.serialization.internal.TaggedEncoder.encodeTaggedInline.<anonymous>' call
		    this.vx(tag);
		    return this;
		  };
		  protoOf(TaggedEncoder).kk = function (descriptor) {
		    return this.sx(this.wx(), descriptor);
		  };
		  protoOf(TaggedEncoder).zk = function () {
		    return this.gx(this.ux());
		  };
		  protoOf(TaggedEncoder).zj = function () {
		    return this.hx(this.wx());
		  };
		  protoOf(TaggedEncoder).ak = function (value) {
		    return this.ox(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).bk = function (value) {
		    return this.jx(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).ck = function (value) {
		    return this.kx(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).dk = function (value) {
		    return this.ix(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).ek = function (value) {
		    return this.lx(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).fk = function (value) {
		    return this.mx(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).gk = function (value) {
		    return this.nx(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).hk = function (value) {
		    return this.px(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).ik = function (value) {
		    return this.qx(this.wx(), value);
		  };
		  protoOf(TaggedEncoder).jk = function (enumDescriptor, index) {
		    return this.rx(this.wx(), enumDescriptor, index);
		  };
		  protoOf(TaggedEncoder).ej = function (descriptor) {
		    return this;
		  };
		  protoOf(TaggedEncoder).fj = function (descriptor) {
		    // Inline function 'kotlin.collections.isNotEmpty' call
		    if (!this.cx_1.x()) {
		      this.wx();
		    }
		    this.tx(descriptor);
		  };
		  protoOf(TaggedEncoder).tx = function (descriptor) {
		  };
		  protoOf(TaggedEncoder).lk = function (descriptor, index, value) {
		    return this.ox(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).mk = function (descriptor, index, value) {
		    return this.jx(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).nk = function (descriptor, index, value) {
		    return this.kx(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).ok = function (descriptor, index, value) {
		    return this.ix(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).pk = function (descriptor, index, value) {
		    return this.lx(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).qk = function (descriptor, index, value) {
		    return this.mx(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).rk = function (descriptor, index, value) {
		    return this.nx(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).sk = function (descriptor, index, value) {
		    return this.px(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).tk = function (descriptor, index, value) {
		    return this.qx(this.zw(descriptor, index), value);
		  };
		  protoOf(TaggedEncoder).uk = function (descriptor, index) {
		    return this.sx(this.zw(descriptor, index), descriptor.nh(index));
		  };
		  protoOf(TaggedEncoder).vk = function (descriptor, index, serializer, value) {
		    if (encodeElement(this, descriptor, index)) {
		      this.wk(serializer, value);
		    }
		  };
		  protoOf(TaggedEncoder).xk = function (descriptor, index, serializer, value) {
		    if (encodeElement(this, descriptor, index)) {
		      this.yk(serializer, value);
		    }
		  };
		  protoOf(TaggedEncoder).ux = function () {
		    return last(this.cx_1);
		  };
		  protoOf(TaggedEncoder).dx = function () {
		    return lastOrNull(this.cx_1);
		  };
		  protoOf(TaggedEncoder).vx = function (name) {
		    this.cx_1.m(name);
		  };
		  protoOf(TaggedEncoder).wx = function () {
		    var tmp;
		    // Inline function 'kotlin.collections.isNotEmpty' call
		    if (!this.cx_1.x()) {
		      tmp = this.cx_1.d1(get_lastIndex_0(this.cx_1));
		    } else {
		      throw SerializationException_init_$Create$_0('No tag in stack for requested element');
		    }
		    return tmp;
		  };
		  function tagBlock($this, tag, block) {
		    $this.vx(tag);
		    var r = block();
		    if (!$this.ay_1) {
		      $this.wx();
		    }
		    $this.ay_1 = false;
		    return r;
		  }
		  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
		    return function () {
		      return this$0.cj($deserializer, $previousValue);
		    };
		  }
		  function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
		    return function () {
		      return this$0.pi() ? this$0.cj($deserializer, $previousValue) : this$0.qi();
		    };
		  }
		  function TaggedDecoder() {
		    var tmp = this;
		    // Inline function 'kotlin.collections.arrayListOf' call
		    tmp.zx_1 = ArrayList_init_$Create$_0();
		    this.ay_1 = false;
		  }
		  protoOf(TaggedDecoder).tj = function () {
		    return EmptySerializersModule_0();
		  };
		  protoOf(TaggedDecoder).by = function (tag) {
		    throw SerializationException_init_$Create$_0('' + getKClassFromExpression(this) + " can't retrieve untyped values");
		  };
		  protoOf(TaggedDecoder).cy = function (tag) {
		    return true;
		  };
		  protoOf(TaggedDecoder).dy = function (tag) {
		    var tmp = this.by(tag);
		    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).ey = function (tag) {
		    var tmp = this.by(tag);
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).fy = function (tag) {
		    var tmp = this.by(tag);
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).gy = function (tag) {
		    var tmp = this.by(tag);
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).hy = function (tag) {
		    var tmp = this.by(tag);
		    return tmp instanceof Long ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).iy = function (tag) {
		    var tmp = this.by(tag);
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).jy = function (tag) {
		    var tmp = this.by(tag);
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).ky = function (tag) {
		    var tmp = this.by(tag);
		    return tmp instanceof Char ? tmp.w8_1 : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).ly = function (tag) {
		    var tmp = this.by(tag);
		    return typeof tmp === 'string' ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).my = function (tag, enumDescriptor) {
		    var tmp = this.by(tag);
		    return typeof tmp === 'number' ? tmp : THROW_CCE();
		  };
		  protoOf(TaggedDecoder).ny = function (tag, inlineDescriptor) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
		    this.vx(tag);
		    return this;
		  };
		  protoOf(TaggedDecoder).cj = function (deserializer, previousValue) {
		    return this.dj(deserializer);
		  };
		  protoOf(TaggedDecoder).bj = function (descriptor) {
		    return this.ny(this.wx(), descriptor);
		  };
		  protoOf(TaggedDecoder).pi = function () {
		    var tmp0_elvis_lhs = this.dx();
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return false;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var currentTag = tmp;
		    return this.cy(currentTag);
		  };
		  protoOf(TaggedDecoder).qi = function () {
		    return null;
		  };
		  protoOf(TaggedDecoder).ri = function () {
		    return this.dy(this.wx());
		  };
		  protoOf(TaggedDecoder).si = function () {
		    return this.ey(this.wx());
		  };
		  protoOf(TaggedDecoder).ti = function () {
		    return this.fy(this.wx());
		  };
		  protoOf(TaggedDecoder).ui = function () {
		    return this.gy(this.wx());
		  };
		  protoOf(TaggedDecoder).vi = function () {
		    return this.hy(this.wx());
		  };
		  protoOf(TaggedDecoder).wi = function () {
		    return this.iy(this.wx());
		  };
		  protoOf(TaggedDecoder).xi = function () {
		    return this.jy(this.wx());
		  };
		  protoOf(TaggedDecoder).yi = function () {
		    return this.ky(this.wx());
		  };
		  protoOf(TaggedDecoder).zi = function () {
		    return this.ly(this.wx());
		  };
		  protoOf(TaggedDecoder).aj = function (enumDescriptor) {
		    return this.my(this.wx(), enumDescriptor);
		  };
		  protoOf(TaggedDecoder).ej = function (descriptor) {
		    return this;
		  };
		  protoOf(TaggedDecoder).fj = function (descriptor) {
		  };
		  protoOf(TaggedDecoder).gj = function (descriptor, index) {
		    return this.dy(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).hj = function (descriptor, index) {
		    return this.ey(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).ij = function (descriptor, index) {
		    return this.fy(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).jj = function (descriptor, index) {
		    return this.gy(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).kj = function (descriptor, index) {
		    return this.hy(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).lj = function (descriptor, index) {
		    return this.iy(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).mj = function (descriptor, index) {
		    return this.jy(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).nj = function (descriptor, index) {
		    return this.ky(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).oj = function (descriptor, index) {
		    return this.ly(this.zw(descriptor, index));
		  };
		  protoOf(TaggedDecoder).pj = function (descriptor, index) {
		    return this.ny(this.zw(descriptor, index), descriptor.nh(index));
		  };
		  protoOf(TaggedDecoder).qj = function (descriptor, index, deserializer, previousValue) {
		    var tmp = this.zw(descriptor, index);
		    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
		  };
		  protoOf(TaggedDecoder).sj = function (descriptor, index, deserializer, previousValue) {
		    var tmp = this.zw(descriptor, index);
		    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
		  };
		  protoOf(TaggedDecoder).dx = function () {
		    return lastOrNull(this.zx_1);
		  };
		  protoOf(TaggedDecoder).vx = function (name) {
		    this.zx_1.m(name);
		  };
		  protoOf(TaggedDecoder).wx = function () {
		    var r = this.zx_1.d1(get_lastIndex_0(this.zx_1));
		    this.ay_1 = true;
		    return r;
		  };
		  function get_NULL() {
		    _init_properties_Tuples_kt__dz0qyd();
		    return NULL;
		  }
		  var NULL;
		  function MapEntry(key, value) {
		    this.oy_1 = key;
		    this.py_1 = value;
		  }
		  protoOf(MapEntry).v1 = function () {
		    return this.oy_1;
		  };
		  protoOf(MapEntry).w1 = function () {
		    return this.py_1;
		  };
		  protoOf(MapEntry).toString = function () {
		    return 'MapEntry(key=' + this.oy_1 + ', value=' + this.py_1 + ')';
		  };
		  protoOf(MapEntry).hashCode = function () {
		    var result = this.oy_1 == null ? 0 : hashCode(this.oy_1);
		    result = imul(result, 31) + (this.py_1 == null ? 0 : hashCode(this.py_1)) | 0;
		    return result;
		  };
		  protoOf(MapEntry).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MapEntry))
		      return false;
		    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
		    if (!equals(this.oy_1, tmp0_other_with_cast.oy_1))
		      return false;
		    if (!equals(this.py_1, tmp0_other_with_cast.py_1))
		      return false;
		    return true;
		  };
		  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
		    return function ($this$buildSerialDescriptor) {
		      $this$buildSerialDescriptor.fg('key', $keySerializer.uf());
		      $this$buildSerialDescriptor.fg('value', $valueSerializer.uf());
		      return Unit_instance;
		    };
		  }
		  function MapEntrySerializer_0(keySerializer, valueSerializer) {
		    KeyValueSerializer.call(this, keySerializer, valueSerializer);
		    var tmp = this;
		    var tmp_0 = MAP_getInstance();
		    tmp.sy_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
		  }
		  protoOf(MapEntrySerializer_0).uf = function () {
		    return this.sy_1;
		  };
		  protoOf(MapEntrySerializer_0).ty = function (_this__u8e3s4) {
		    return _this__u8e3s4.v1();
		  };
		  protoOf(MapEntrySerializer_0).uy = function (_this__u8e3s4) {
		    return this.ty((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(MapEntrySerializer_0).vy = function (_this__u8e3s4) {
		    return _this__u8e3s4.w1();
		  };
		  protoOf(MapEntrySerializer_0).wy = function (_this__u8e3s4) {
		    return this.vy((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(MapEntrySerializer_0).xy = function (key, value) {
		    return new MapEntry(key, value);
		  };
		  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
		    return function ($this$buildClassSerialDescriptor) {
		      $this$buildClassSerialDescriptor.fg('first', $keySerializer.uf());
		      $this$buildClassSerialDescriptor.fg('second', $valueSerializer.uf());
		      return Unit_instance;
		    };
		  }
		  function PairSerializer_0(keySerializer, valueSerializer) {
		    KeyValueSerializer.call(this, keySerializer, valueSerializer);
		    var tmp = this;
		    tmp.dz_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
		  }
		  protoOf(PairSerializer_0).uf = function () {
		    return this.dz_1;
		  };
		  protoOf(PairSerializer_0).ez = function (_this__u8e3s4) {
		    return _this__u8e3s4.m5_1;
		  };
		  protoOf(PairSerializer_0).uy = function (_this__u8e3s4) {
		    return this.ez(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(PairSerializer_0).fz = function (_this__u8e3s4) {
		    return _this__u8e3s4.n5_1;
		  };
		  protoOf(PairSerializer_0).wy = function (_this__u8e3s4) {
		    return this.fz(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
		  };
		  protoOf(PairSerializer_0).xy = function (key, value) {
		    return to(key, value);
		  };
		  function decodeSequentially_1($this, composite) {
		    var a = composite.rj($this.jz_1, 0, $this.gz_1);
		    var b = composite.rj($this.jz_1, 1, $this.hz_1);
		    var c = composite.rj($this.jz_1, 2, $this.iz_1);
		    composite.fj($this.jz_1);
		    return new Triple(a, b, c);
		  }
		  function decodeStructure($this, composite) {
		    var a = get_NULL();
		    var b = get_NULL();
		    var c = get_NULL();
		    mainLoop: while (true) {
		      var index = composite.vj($this.jz_1);
		      if (index === -1) {
		        break mainLoop;
		      } else {
		        if (index === 0) {
		          a = composite.rj($this.jz_1, 0, $this.gz_1);
		        } else {
		          if (index === 1) {
		            b = composite.rj($this.jz_1, 1, $this.hz_1);
		          } else {
		            if (index === 2) {
		              c = composite.rj($this.jz_1, 2, $this.iz_1);
		            } else {
		              throw SerializationException_init_$Create$_0('Unexpected index ' + index);
		            }
		          }
		        }
		      }
		    }
		    composite.fj($this.jz_1);
		    if (a === get_NULL())
		      throw SerializationException_init_$Create$_0("Element 'first' is missing");
		    if (b === get_NULL())
		      throw SerializationException_init_$Create$_0("Element 'second' is missing");
		    if (c === get_NULL())
		      throw SerializationException_init_$Create$_0("Element 'third' is missing");
		    var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
		    var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
		    return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
		  }
		  function TripleSerializer$descriptor$lambda(this$0) {
		    return function ($this$buildClassSerialDescriptor) {
		      $this$buildClassSerialDescriptor.fg('first', this$0.gz_1.uf());
		      $this$buildClassSerialDescriptor.fg('second', this$0.hz_1.uf());
		      $this$buildClassSerialDescriptor.fg('third', this$0.iz_1.uf());
		      return Unit_instance;
		    };
		  }
		  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
		    this.gz_1 = aSerializer;
		    this.hz_1 = bSerializer;
		    this.iz_1 = cSerializer;
		    var tmp = this;
		    tmp.jz_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
		  }
		  protoOf(TripleSerializer_0).uf = function () {
		    return this.jz_1;
		  };
		  protoOf(TripleSerializer_0).kz = function (encoder, value) {
		    var structuredEncoder = encoder.ej(this.jz_1);
		    structuredEncoder.vk(this.jz_1, 0, this.gz_1, value.yd_1);
		    structuredEncoder.vk(this.jz_1, 1, this.hz_1, value.zd_1);
		    structuredEncoder.vk(this.jz_1, 2, this.iz_1, value.ae_1);
		    structuredEncoder.fj(this.jz_1);
		  };
		  protoOf(TripleSerializer_0).vf = function (encoder, value) {
		    return this.kz(encoder, value instanceof Triple ? value : THROW_CCE());
		  };
		  protoOf(TripleSerializer_0).wf = function (decoder) {
		    var composite = decoder.ej(this.jz_1);
		    if (composite.uj()) {
		      return decodeSequentially_1(this, composite);
		    }
		    return decodeStructure(this, composite);
		  };
		  function KeyValueSerializer(keySerializer, valueSerializer) {
		    this.yy_1 = keySerializer;
		    this.zy_1 = valueSerializer;
		  }
		  protoOf(KeyValueSerializer).az = function (encoder, value) {
		    var structuredEncoder = encoder.ej(this.uf());
		    structuredEncoder.vk(this.uf(), 0, this.yy_1, this.uy(value));
		    structuredEncoder.vk(this.uf(), 1, this.zy_1, this.wy(value));
		    structuredEncoder.fj(this.uf());
		  };
		  protoOf(KeyValueSerializer).vf = function (encoder, value) {
		    return this.az(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
		  };
		  protoOf(KeyValueSerializer).wf = function (decoder) {
		    var composite = decoder.ej(this.uf());
		    if (composite.uj()) {
		      var key = composite.rj(this.uf(), 0, this.yy_1);
		      var value = composite.rj(this.uf(), 1, this.zy_1);
		      return this.xy(key, value);
		    }
		    var key_0 = get_NULL();
		    var value_0 = get_NULL();
		    mainLoop: while (true) {
		      var idx = composite.vj(this.uf());
		      if (idx === -1) {
		        break mainLoop;
		      } else {
		        if (idx === 0) {
		          key_0 = composite.rj(this.uf(), 0, this.yy_1);
		        } else {
		          if (idx === 1) {
		            value_0 = composite.rj(this.uf(), 1, this.zy_1);
		          } else {
		            throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
		          }
		        }
		      }
		    }
		    composite.fj(this.uf());
		    if (key_0 === get_NULL())
		      throw SerializationException_init_$Create$_0("Element 'key' is missing");
		    if (value_0 === get_NULL())
		      throw SerializationException_init_$Create$_0("Element 'value' is missing");
		    var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
		    return this.xy(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
		  };
		  var properties_initialized_Tuples_kt_3vs7ar;
		  function _init_properties_Tuples_kt__dz0qyd() {
		    if (!properties_initialized_Tuples_kt_3vs7ar) {
		      properties_initialized_Tuples_kt_3vs7ar = true;
		      NULL = new Object();
		    }
		  }
		  function ULongSerializer() {
		    ULongSerializer_instance = this;
		    this.lz_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_4(Companion_getInstance_0()));
		  }
		  protoOf(ULongSerializer).uf = function () {
		    return this.lz_1;
		  };
		  protoOf(ULongSerializer).mz = function (encoder, value) {
		    var tmp = encoder.kk(this.lz_1);
		    // Inline function 'kotlin.ULong.toLong' call
		    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
		    tmp.ek(tmp$ret$0);
		  };
		  protoOf(ULongSerializer).vf = function (encoder, value) {
		    return this.mz(encoder, value instanceof ULong ? value.bf_1 : THROW_CCE());
		  };
		  protoOf(ULongSerializer).nz = function (decoder) {
		    // Inline function 'kotlin.toULong' call
		    var this_0 = decoder.bj(this.lz_1).vi();
		    return _ULong___init__impl__c78o9k(this_0);
		  };
		  protoOf(ULongSerializer).wf = function (decoder) {
		    return new ULong(this.nz(decoder));
		  };
		  var ULongSerializer_instance;
		  function ULongSerializer_getInstance() {
		    if (ULongSerializer_instance == null)
		      new ULongSerializer();
		    return ULongSerializer_instance;
		  }
		  function UIntSerializer() {
		    UIntSerializer_instance = this;
		    this.oz_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_6(IntCompanionObject_instance));
		  }
		  protoOf(UIntSerializer).uf = function () {
		    return this.oz_1;
		  };
		  protoOf(UIntSerializer).pz = function (encoder, value) {
		    var tmp = encoder.kk(this.oz_1);
		    // Inline function 'kotlin.UInt.toInt' call
		    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
		    tmp.dk(tmp$ret$0);
		  };
		  protoOf(UIntSerializer).vf = function (encoder, value) {
		    return this.pz(encoder, value instanceof UInt ? value.qe_1 : THROW_CCE());
		  };
		  protoOf(UIntSerializer).qz = function (decoder) {
		    // Inline function 'kotlin.toUInt' call
		    var this_0 = decoder.bj(this.oz_1).ui();
		    return _UInt___init__impl__l7qpdl(this_0);
		  };
		  protoOf(UIntSerializer).wf = function (decoder) {
		    return new UInt(this.qz(decoder));
		  };
		  var UIntSerializer_instance;
		  function UIntSerializer_getInstance() {
		    if (UIntSerializer_instance == null)
		      new UIntSerializer();
		    return UIntSerializer_instance;
		  }
		  function UShortSerializer() {
		    UShortSerializer_instance = this;
		    this.rz_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_8(ShortCompanionObject_instance));
		  }
		  protoOf(UShortSerializer).uf = function () {
		    return this.rz_1;
		  };
		  protoOf(UShortSerializer).sz = function (encoder, value) {
		    var tmp = encoder.kk(this.rz_1);
		    // Inline function 'kotlin.UShort.toShort' call
		    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
		    tmp.ck(tmp$ret$0);
		  };
		  protoOf(UShortSerializer).vf = function (encoder, value) {
		    return this.sz(encoder, value instanceof UShort ? value.mf_1 : THROW_CCE());
		  };
		  protoOf(UShortSerializer).tz = function (decoder) {
		    // Inline function 'kotlin.toUShort' call
		    var this_0 = decoder.bj(this.rz_1).ti();
		    return _UShort___init__impl__jigrne(this_0);
		  };
		  protoOf(UShortSerializer).wf = function (decoder) {
		    return new UShort(this.tz(decoder));
		  };
		  var UShortSerializer_instance;
		  function UShortSerializer_getInstance() {
		    if (UShortSerializer_instance == null)
		      new UShortSerializer();
		    return UShortSerializer_instance;
		  }
		  function UByteSerializer() {
		    UByteSerializer_instance = this;
		    this.uz_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_10(ByteCompanionObject_instance));
		  }
		  protoOf(UByteSerializer).uf = function () {
		    return this.uz_1;
		  };
		  protoOf(UByteSerializer).vz = function (encoder, value) {
		    var tmp = encoder.kk(this.uz_1);
		    // Inline function 'kotlin.UByte.toByte' call
		    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
		    tmp.bk(tmp$ret$0);
		  };
		  protoOf(UByteSerializer).vf = function (encoder, value) {
		    return this.vz(encoder, value instanceof UByte ? value.fe_1 : THROW_CCE());
		  };
		  protoOf(UByteSerializer).wz = function (decoder) {
		    // Inline function 'kotlin.toUByte' call
		    var this_0 = decoder.bj(this.uz_1).si();
		    return _UByte___init__impl__g9hnc4(this_0);
		  };
		  protoOf(UByteSerializer).wf = function (decoder) {
		    return new UByte(this.wz(decoder));
		  };
		  var UByteSerializer_instance;
		  function UByteSerializer_getInstance() {
		    if (UByteSerializer_instance == null)
		      new UByteSerializer();
		    return UByteSerializer_instance;
		  }
		  function get_EmptySerializersModuleLegacyJs() {
		    _init_properties_SerializersModule_kt__u78ha3();
		    return EmptySerializersModule;
		  }
		  var EmptySerializersModule;
		  function SerializersModule() {
		  }
		  protoOf(SerializersModule).bh = function (kClass, typeArgumentsSerializers, $super) {
		    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
		    return $super === VOID ? this.ah(kClass, typeArgumentsSerializers) : $super.ah.call(this, kClass, typeArgumentsSerializers);
		  };
		  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider) {
		    SerializersModule.call(this);
		    this.yz_1 = class2ContextualFactory;
		    this.zz_1 = polyBase2Serializers;
		    this.a10_1 = polyBase2DefaultSerializerProvider;
		    this.b10_1 = polyBase2NamedSerializers;
		    this.c10_1 = polyBase2DefaultDeserializerProvider;
		  }
		  protoOf(SerialModuleImpl).fl = function (baseClass, value) {
		    if (!isInstanceOf(value, baseClass))
		      return null;
		    var tmp0_safe_receiver = this.zz_1.c2(baseClass);
		    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c2(getKClassFromExpression(value));
		    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
		    if (!(registered == null))
		      return registered;
		    var tmp_0 = this.a10_1.c2(baseClass);
		    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
		    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
		  };
		  protoOf(SerialModuleImpl).el = function (baseClass, serializedClassName) {
		    var tmp0_safe_receiver = this.b10_1.c2(baseClass);
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.collections.get' call
		      tmp = (isInterface(tmp0_safe_receiver, Map) ? tmp0_safe_receiver : THROW_CCE()).c2(serializedClassName);
		    }
		    var tmp_0 = tmp;
		    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
		    if (!(registered == null))
		      return registered;
		    var tmp_1 = this.c10_1.c2(baseClass);
		    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
		    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
		  };
		  protoOf(SerialModuleImpl).ah = function (kClass, typeArgumentsSerializers) {
		    var tmp0_safe_receiver = this.yz_1.c2(kClass);
		    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d10(typeArgumentsSerializers);
		    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
		  };
		  protoOf(SerialModuleImpl).xz = function (collector) {
		    // Inline function 'kotlin.collections.forEach' call
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator = this.yz_1.u1().p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var kclass = element.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var serial = element.w1();
		      if (serial instanceof Argless) {
		        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
		        var tmp_0 = serial.g10_1;
		        collector.h10(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
		      } else {
		        if (serial instanceof WithTypeArguments) {
		          collector.f10(kclass, serial.e10_1);
		        }
		      }
		    }
		    // Inline function 'kotlin.collections.forEach' call
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator_0 = this.zz_1.u1().p();
		    while (tmp0_iterator_0.q()) {
		      var element_0 = tmp0_iterator_0.s();
		      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var baseClass = element_0.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var classMap = element_0.w1();
		      // Inline function 'kotlin.collections.forEach' call
		      // Inline function 'kotlin.collections.iterator' call
		      var tmp0_iterator_1 = classMap.u1().p();
		      while (tmp0_iterator_1.q()) {
		        var element_1 = tmp0_iterator_1.s();
		        // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>.<anonymous>' call
		        // Inline function 'kotlin.collections.component1' call
		        var actualClass = element_1.v1();
		        // Inline function 'kotlin.collections.component2' call
		        var serializer = element_1.w1();
		        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
		        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
		        // Inline function 'kotlinx.serialization.internal.cast' call
		        var tmp$ret$9 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
		        collector.i10(tmp_1, tmp_2, tmp$ret$9);
		      }
		    }
		    // Inline function 'kotlin.collections.forEach' call
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator_2 = this.a10_1.u1().p();
		    while (tmp0_iterator_2.q()) {
		      var element_2 = tmp0_iterator_2.s();
		      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var baseClass_0 = element_2.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var provider = element_2.w1();
		      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
		      collector.j10(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
		    }
		    // Inline function 'kotlin.collections.forEach' call
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator_3 = this.c10_1.u1().p();
		    while (tmp0_iterator_3.q()) {
		      var element_3 = tmp0_iterator_3.s();
		      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var baseClass_1 = element_3.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var provider_0 = element_3.w1();
		      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
		      collector.k10(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
		    }
		  };
		  function Argless() {
		  }
		  function WithTypeArguments() {
		  }
		  function ContextualProvider() {
		  }
		  var properties_initialized_SerializersModule_kt_fjigjn;
		  function _init_properties_SerializersModule_kt__u78ha3() {
		    if (!properties_initialized_SerializersModule_kt_fjigjn) {
		      properties_initialized_SerializersModule_kt_fjigjn = true;
		      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap());
		    }
		  }
		  function EmptySerializersModule_0() {
		    return get_EmptySerializersModuleLegacyJs();
		  }
		  function SerializersModuleCollector$contextual$lambda($serializer) {
		    return function (it) {
		      return $serializer;
		    };
		  }
		  function SerializersModuleCollector() {
		  }
		  function SerializableWith(serializer) {
		    this.l10_1 = serializer;
		  }
		  protoOf(SerializableWith).equals = function (other) {
		    if (!(other instanceof SerializableWith))
		      return false;
		    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
		    if (!this.l10_1.equals(tmp0_other_with_cast.l10_1))
		      return false;
		    return true;
		  };
		  protoOf(SerializableWith).hashCode = function () {
		    return imul(getStringHashCode('serializer'), 127) ^ this.l10_1.hashCode();
		  };
		  protoOf(SerializableWith).toString = function () {
		    return '@kotlinx.serialization.SerializableWith(serializer=' + this.l10_1 + ')';
		  };
		  function createCache(factory) {
		    return new createCache$1(factory);
		  }
		  function createParametrizedCache(factory) {
		    return new createParametrizedCache$1(factory);
		  }
		  function isInstanceOf(_this__u8e3s4, kclass) {
		    return kclass.u5(_this__u8e3s4);
		  }
		  function compiledSerializerImpl(_this__u8e3s4) {
		    var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
		    var tmp;
		    if (tmp1_elvis_lhs == null) {
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
		      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
		      tmp = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
		    } else {
		      tmp = tmp1_elvis_lhs;
		    }
		    return tmp;
		  }
		  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
		    throw SerializationException_init_$Create$_0("Serializer for class '" + _this__u8e3s4.t5() + "' is not found.\n" + 'Mark the class as @Serializable or provide the serializer explicitly.\n' + 'On Kotlin/JS explicitly declared serializer should be used for interfaces and enums without @Serializable annotation');
		  }
		  function isReferenceArray(rootClass) {
		    return rootClass.equals(PrimitiveClasses_getInstance().r6());
		  }
		  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
		    var tmp;
		    try {
		      // Inline function 'kotlin.reflect.findAssociatedObject' call
		      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
		      var tmp_0;
		      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
		        tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
		      } else {
		        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
		          var tmp_1 = assocObject.nr(args.slice());
		          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
		        } else {
		          if (get_isInterface(_this__u8e3s4)) {
		            tmp_0 = new PolymorphicSerializer(_this__u8e3s4);
		          } else {
		            tmp_0 = null;
		          }
		        }
		      }
		      tmp = tmp_0;
		    } catch ($p) {
		      var tmp_2;
		      var e = $p;
		      tmp_2 = null;
		      tmp = tmp_2;
		    }
		    return tmp;
		  }
		  function get_isInterface(_this__u8e3s4) {
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
		    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
		  }
		  function toNativeArrayImpl(_this__u8e3s4, eClass) {
		    // Inline function 'kotlin.collections.toTypedArray' call
		    return copyToArray(_this__u8e3s4);
		  }
		  function getChecked(_this__u8e3s4, index) {
		    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
		      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4));
		    return _this__u8e3s4[index];
		  }
		  function getChecked_0(_this__u8e3s4, index) {
		    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
		      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4));
		    return _this__u8e3s4[index];
		  }
		  function createCache$1($factory) {
		    this.m10_1 = $factory;
		  }
		  protoOf(createCache$1).ch = function (key) {
		    return this.m10_1(key);
		  };
		  function createParametrizedCache$1($factory) {
		    this.n10_1 = $factory;
		  }
		  protoOf(createParametrizedCache$1).dh = function (key, types) {
		    // Inline function 'kotlin.runCatching' call
		    var tmp;
		    try {
		      // Inline function 'kotlin.Companion.success' call
		      // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
		      var value = this.n10_1(key, types);
		      tmp = _Result___init__impl__xyqfz8(value);
		    } catch ($p) {
		      var tmp_0;
		      if ($p instanceof Error) {
		        var e = $p;
		        // Inline function 'kotlin.Companion.failure' call
		        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
		      } else {
		        throw $p;
		      }
		      tmp = tmp_0;
		    }
		    return tmp;
		  };
		  //region block: post-declaration
		  protoOf(SerialDescriptorImpl).eh = get_isNullable;
		  protoOf(SerialDescriptorImpl).kh = get_isInline;
		  protoOf(AbstractDecoder).rj = decodeSerializableElement$default;
		  protoOf(AbstractDecoder).dj = decodeSerializableValue;
		  protoOf(AbstractDecoder).uj = decodeSequentially;
		  protoOf(AbstractDecoder).wj = decodeCollectionSize;
		  protoOf(AbstractEncoder).zk = encodeNotNullMark;
		  protoOf(AbstractEncoder).al = beginCollection;
		  protoOf(AbstractEncoder).wk = encodeSerializableValue;
		  protoOf(AbstractEncoder).yk = encodeNullableSerializableValue;
		  protoOf(AbstractEncoder).bl = shouldEncodeElementDefault;
		  protoOf(ListLikeDescriptor).eh = get_isNullable;
		  protoOf(ListLikeDescriptor).kh = get_isInline;
		  protoOf(ListLikeDescriptor).ih = get_annotations;
		  protoOf(MapLikeDescriptor).eh = get_isNullable;
		  protoOf(MapLikeDescriptor).kh = get_isInline;
		  protoOf(MapLikeDescriptor).ih = get_annotations;
		  protoOf(PluginGeneratedSerialDescriptor).eh = get_isNullable;
		  protoOf(PluginGeneratedSerialDescriptor).kh = get_isInline;
		  protoOf(InlinePrimitiveDescriptor$1).fr = typeParametersSerializers;
		  protoOf(PrimitiveSerialDescriptor_0).eh = get_isNullable;
		  protoOf(PrimitiveSerialDescriptor_0).kh = get_isInline;
		  protoOf(PrimitiveSerialDescriptor_0).ih = get_annotations;
		  protoOf(TaggedEncoder).al = beginCollection;
		  protoOf(TaggedEncoder).wk = encodeSerializableValue;
		  protoOf(TaggedEncoder).yk = encodeNullableSerializableValue;
		  protoOf(TaggedEncoder).bl = shouldEncodeElementDefault;
		  protoOf(TaggedDecoder).rj = decodeSerializableElement$default;
		  protoOf(TaggedDecoder).dj = decodeSerializableValue;
		  protoOf(TaggedDecoder).uj = decodeSequentially;
		  protoOf(TaggedDecoder).wj = decodeCollectionSize;
		  //endregion
		  //region block: init
		  Companion_instance_0 = new Companion();
		  //endregion
		  //region block: exports
		  _.$_$ = _.$_$ || {};
		  _.$_$.a = ObjectSerializer_init_$Create$;
		  _.$_$.b = SealedClassSerializer_init_$Create$;
		  _.$_$.c = SerializationException_init_$Init$_0;
		  _.$_$.d = SerializationException_init_$Create$_0;
		  _.$_$.e = UnknownFieldException_init_$Create$;
		  _.$_$.f = SEALED_getInstance;
		  _.$_$.g = STRING_getInstance;
		  _.$_$.h = CONTEXTUAL_getInstance;
		  _.$_$.i = ENUM_getInstance;
		  _.$_$.j = LIST_getInstance;
		  _.$_$.k = MAP_getInstance;
		  _.$_$.l = Companion_instance_0;
		  _.$_$.m = BooleanSerializer_getInstance;
		  _.$_$.n = DoubleSerializer_getInstance;
		  _.$_$.o = FloatSerializer_getInstance;
		  _.$_$.p = IntSerializer_getInstance;
		  _.$_$.q = LongSerializer_getInstance;
		  _.$_$.r = StringSerializer_getInstance;
		  _.$_$.s = UnitSerializer_getInstance;
		  _.$_$.t = ListSerializer;
		  _.$_$.u = MapSerializer;
		  _.$_$.v = get_nullable;
		  _.$_$.w = serializer_0;
		  _.$_$.x = serializer_9;
		  _.$_$.y = serializer_7;
		  _.$_$.z = serializer_11;
		  _.$_$.a1 = serializer_5;
		  _.$_$.b1 = PolymorphicKind;
		  _.$_$.c1 = PrimitiveKind;
		  _.$_$.d1 = PrimitiveSerialDescriptor;
		  _.$_$.e1 = get_annotations;
		  _.$_$.f1 = get_isInline;
		  _.$_$.g1 = get_isNullable;
		  _.$_$.h1 = SerialDescriptor;
		  _.$_$.i1 = ENUM;
		  _.$_$.j1 = buildSerialDescriptor;
		  _.$_$.k1 = getContextualDescriptor;
		  _.$_$.l1 = AbstractDecoder;
		  _.$_$.m1 = AbstractEncoder;
		  _.$_$.n1 = CompositeDecoder;
		  _.$_$.o1 = CompositeEncoder;
		  _.$_$.p1 = Decoder;
		  _.$_$.q1 = Encoder;
		  _.$_$.r1 = AbstractPolymorphicSerializer;
		  _.$_$.s1 = ArrayListSerializer;
		  _.$_$.t1 = ElementMarker;
		  _.$_$.u1 = EnumDescriptor;
		  _.$_$.v1 = EnumSerializer;
		  _.$_$.w1 = typeParametersSerializers;
		  _.$_$.x1 = GeneratedSerializer;
		  _.$_$.y1 = LinkedHashMapSerializer;
		  _.$_$.z1 = NamedValueDecoder;
		  _.$_$.a2 = NamedValueEncoder;
		  _.$_$.b2 = PluginGeneratedSerialDescriptor;
		  _.$_$.c2 = ReferenceArraySerializer;
		  _.$_$.d2 = SerializerFactory;
		  _.$_$.e2 = jsonCachedSerialNames;
		  _.$_$.f2 = throwMissingFieldException;
		  _.$_$.g2 = EmptySerializersModule_0;
		  _.$_$.h2 = contextual;
		  _.$_$.i2 = SerializersModuleCollector;
		  _.$_$.j2 = DeserializationStrategy;
		  _.$_$.k2 = KSerializer;
		  _.$_$.l2 = MissingFieldException;
		  _.$_$.m2 = SealedClassSerializer;
		  _.$_$.n2 = Serializable;
		  _.$_$.o2 = SerializationException;
		  _.$_$.p2 = findPolymorphicSerializer;
		  _.$_$.q2 = serializerOrNull;
		  _.$_$.r2 = serializer;
		  //endregion
		  return _;
		}));

		
} (kotlinxSerializationKotlinxSerializationCoreJsIr, kotlinxSerializationKotlinxSerializationCoreJsIrExports));
	return kotlinxSerializationKotlinxSerializationCoreJsIrExports;
}

var kotlinxSerializationKotlinxSerializationJsonJsIrExports = {};
var kotlinxSerializationKotlinxSerializationJsonJsIr = {
  get exports(){ return kotlinxSerializationKotlinxSerializationJsonJsIrExports; },
  set exports(v){ kotlinxSerializationKotlinxSerializationJsonJsIrExports = v; },
};

var hasRequiredKotlinxSerializationKotlinxSerializationJsonJsIr;

function requireKotlinxSerializationKotlinxSerializationJsonJsIr () {
	if (hasRequiredKotlinxSerializationKotlinxSerializationJsonJsIr) return kotlinxSerializationKotlinxSerializationJsonJsIrExports;
	hasRequiredKotlinxSerializationKotlinxSerializationJsonJsIr = 1;
	(function (module, exports) {
		(function (root, factory) {
		  if (typeof undefined === 'function' && undefined.amd)
		    undefined(['exports', './kotlinx-serialization-kotlinx-serialization-core-js-ir.js', './kotlin-kotlin-stdlib.js'], factory);
		  else if ('object' === 'object')
		    factory(module.exports, requireKotlinxSerializationKotlinxSerializationCoreJsIr(), requireKotlinKotlinStdlib());
		  else {
		    if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-ir'] === 'undefined') {
		      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json-js-ir'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-ir' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-ir' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json-js-ir'.");
		    }
		    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
		      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json-js-ir'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json-js-ir'.");
		    }
		    root['kotlinx-serialization-kotlinx-serialization-json-js-ir'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-json-js-ir'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-json-js-ir'], this['kotlinx-serialization-kotlinx-serialization-core-js-ir'], this['kotlin-kotlin-stdlib']);
		  }
		}(commonjsGlobal, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
		  'use strict';
		  //region block: imports
		  var imul = Math.imul;
		  var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
		  var protoOf = kotlin_kotlin.$_$.x7;
		  var objectMeta = kotlin_kotlin.$_$.w7;
		  var setMetadataFor = kotlin_kotlin.$_$.y7;
		  var Unit_instance = kotlin_kotlin.$_$.w3;
		  var classMeta = kotlin_kotlin.$_$.q6;
		  var VOID = kotlin_kotlin.$_$.f;
		  var toString = kotlin_kotlin.$_$.c8;
		  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.h1;
		  var charSequenceLength = kotlin_kotlin.$_$.o6;
		  var charSequenceGet = kotlin_kotlin.$_$.n6;
		  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.n1;
		  var equals = kotlin_kotlin.$_$.s6;
		  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
		  var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
		  var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
		  var getKClassFromExpression = kotlin_kotlin.$_$.d;
		  var serializerOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q2;
		  var THROW_CCE = kotlin_kotlin.$_$.w9;
		  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
		  var isInterface = kotlin_kotlin.$_$.i7;
		  var Decoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
		  var CompositeDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
		  var interfaceMeta = kotlin_kotlin.$_$.a7;
		  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.x;
		  var hashCode = kotlin_kotlin.$_$.z6;
		  var joinToString = kotlin_kotlin.$_$.k5;
		  var Map = kotlin_kotlin.$_$.f4;
		  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.g;
		  var lazy = kotlin_kotlin.$_$.pa;
		  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d2;
		  var getBooleanHashCode = kotlin_kotlin.$_$.v6;
		  var getStringHashCode = kotlin_kotlin.$_$.y6;
		  var List = kotlin_kotlin.$_$.d4;
		  var toInt = kotlin_kotlin.$_$.c9;
		  var toLong = kotlin_kotlin.$_$.e9;
		  var toDouble = kotlin_kotlin.$_$.a9;
		  var toLongOrNull = kotlin_kotlin.$_$.d9;
		  var toDoubleOrNull = kotlin_kotlin.$_$.z8;
		  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.r;
		  var StringCompanionObject_instance = kotlin_kotlin.$_$.l3;
		  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
		  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
		  var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
		  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
		  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
		  var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
		  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
		  var toULongOrNull = kotlin_kotlin.$_$.h9;
		  var ULong = kotlin_kotlin.$_$.ea;
		  var Companion_getInstance = kotlin_kotlin.$_$.u3;
		  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
		  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.o2;
		  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.j1;
		  var lazy_0 = kotlin_kotlin.$_$.qa;
		  var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
		  var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
		  var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
		  var KProperty1 = kotlin_kotlin.$_$.j8;
		  var getPropertyCallableRef = kotlin_kotlin.$_$.x6;
		  var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
		  var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
		  var toLong_0 = kotlin_kotlin.$_$.a8;
		  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.e2;
		  var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.g2;
		  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.n2;
		  var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.p2;
		  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.v1;
		  var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.x1;
		  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.w2;
		  var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.y2;
		  var ElementMarker = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
		  var captureStack = kotlin_kotlin.$_$.l6;
		  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
		  var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
		  var charSequenceSubSequence = kotlin_kotlin.$_$.p6;
		  var coerceAtLeast = kotlin_kotlin.$_$.d8;
		  var coerceAtMost = kotlin_kotlin.$_$.e8;
		  var Companion_instance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
		  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.i;
		  var singleOrNull = kotlin_kotlin.$_$.z5;
		  var ensureNotNull = kotlin_kotlin.$_$.la;
		  var emptyMap = kotlin_kotlin.$_$.c5;
		  var getValue = kotlin_kotlin.$_$.g5;
		  var copyOf = kotlin_kotlin.$_$.x4;
		  var copyOf_0 = kotlin_kotlin.$_$.y4;
		  var fillArrayVal = kotlin_kotlin.$_$.u6;
		  var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
		  var DeepRecursiveFunction = kotlin_kotlin.$_$.n9;
		  var invoke = kotlin_kotlin.$_$.ma;
		  var CoroutineImpl = kotlin_kotlin.$_$.i6;
		  var DeepRecursiveScope = kotlin_kotlin.$_$.o9;
		  var Unit = kotlin_kotlin.$_$.ha;
		  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.h6;
		  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
		  var getKClass = kotlin_kotlin.$_$.e;
		  var DeserializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
		  var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m2;
		  var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
		  var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
		  var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
		  var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
		  var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
		  var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
		  var contextual = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
		  var SerializersModuleCollector = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
		  var AbstractDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
		  var plus = kotlin_kotlin.$_$.sa;
		  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
		  var IllegalArgumentException = kotlin_kotlin.$_$.r9;
		  var isFinite = kotlin_kotlin.$_$.oa;
		  var isFinite_0 = kotlin_kotlin.$_$.na;
		  var toUInt = kotlin_kotlin.$_$.g9;
		  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.f2;
		  var toULong = kotlin_kotlin.$_$.i9;
		  var toUByte = kotlin_kotlin.$_$.f9;
		  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.w1;
		  var toUShort = kotlin_kotlin.$_$.j9;
		  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.x2;
		  var objectCreate = kotlin_kotlin.$_$.v7;
		  var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
		  var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p2;
		  var toString_0 = kotlin_kotlin.$_$.q1;
		  var Companion_getInstance_0 = kotlin_kotlin.$_$.t3;
		  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
		  var Companion_getInstance_1 = kotlin_kotlin.$_$.s3;
		  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
		  var Companion_getInstance_2 = kotlin_kotlin.$_$.v3;
		  var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
		  var setOf = kotlin_kotlin.$_$.y5;
		  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.p1;
		  var numberToChar = kotlin_kotlin.$_$.r7;
		  var equals_0 = kotlin_kotlin.$_$.m8;
		  var noWhenBranchMatchedException = kotlin_kotlin.$_$.ra;
		  var NamedValueDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
		  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.f1;
		  var ByteCompanionObject_instance = kotlin_kotlin.$_$.g3;
		  var toByte = kotlin_kotlin.$_$.z7;
		  var ShortCompanionObject_instance = kotlin_kotlin.$_$.k3;
		  var toShort = kotlin_kotlin.$_$.b8;
		  var single = kotlin_kotlin.$_$.t8;
		  var Char = kotlin_kotlin.$_$.m9;
		  var emptySet = kotlin_kotlin.$_$.d5;
		  var plus_0 = kotlin_kotlin.$_$.v5;
		  var toList = kotlin_kotlin.$_$.c6;
		  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ua;
		  var NamedValueEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
		  var Enum = kotlin_kotlin.$_$.p9;
		  var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
		  var last = kotlin_kotlin.$_$.o5;
		  var removeLast = kotlin_kotlin.$_$.w5;
		  var lastIndexOf = kotlin_kotlin.$_$.q8;
		  var Long = kotlin_kotlin.$_$.s9;
		  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.o1;
		  var Companion_getInstance_3 = kotlin_kotlin.$_$.q3;
		  var charArray = kotlin_kotlin.$_$.m6;
		  var indexOf = kotlin_kotlin.$_$.n8;
		  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.w;
		  var HashMap_init_$Create$ = kotlin_kotlin.$_$.k;
		  //endregion
		  //region block: pre-declaration
		  setMetadataFor(Json, 'Json', classMeta);
		  setMetadataFor(Default, 'Default', objectMeta, Json);
		  setMetadataFor(JsonBuilder, 'JsonBuilder', classMeta);
		  setMetadataFor(JsonImpl, 'JsonImpl', classMeta, Json);
		  setMetadataFor(JsonClassDiscriminator, 'JsonClassDiscriminator', classMeta);
		  setMetadataFor(JsonNames, 'JsonNames', classMeta);
		  setMetadataFor(JsonConfiguration, 'JsonConfiguration', classMeta);
		  setMetadataFor(JsonContentPolymorphicSerializer, 'JsonContentPolymorphicSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(JsonDecoder, 'JsonDecoder', interfaceMeta, VOID, [Decoder, CompositeDecoder]);
		  setMetadataFor(Companion, 'Companion', objectMeta);
		  setMetadataFor(JsonElement, 'JsonElement', classMeta, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
		  setMetadataFor(Companion_0, 'Companion', objectMeta);
		  setMetadataFor(JsonObject, 'JsonObject', classMeta, JsonElement, [JsonElement, Map], VOID, VOID, {0: JsonObjectSerializer_getInstance});
		  setMetadataFor(JsonPrimitive, 'JsonPrimitive', classMeta, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
		  setMetadataFor(JsonNull, 'JsonNull', objectMeta, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNullSerializer_getInstance});
		  setMetadataFor(Companion_1, 'Companion', objectMeta);
		  setMetadataFor(JsonLiteral, 'JsonLiteral', classMeta, JsonPrimitive);
		  setMetadataFor(Companion_2, 'Companion', objectMeta);
		  setMetadataFor(JsonArray, 'JsonArray', classMeta, JsonElement, [JsonElement, List], VOID, VOID, {0: JsonArraySerializer_getInstance});
		  setMetadataFor(JsonObjectBuilder, 'JsonObjectBuilder', classMeta);
		  setMetadataFor(JsonElementSerializer, 'JsonElementSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(JsonObjectDescriptor, 'JsonObjectDescriptor', objectMeta, VOID, [SerialDescriptor]);
		  setMetadataFor(JsonObjectSerializer, 'JsonObjectSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(JsonArrayDescriptor, 'JsonArrayDescriptor', objectMeta, VOID, [SerialDescriptor]);
		  setMetadataFor(JsonArraySerializer, 'JsonArraySerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(JsonNullSerializer, 'JsonNullSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(JsonLiteralSerializer, 'JsonLiteralSerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(defer$1, VOID, classMeta, VOID, [SerialDescriptor]);
		  setMetadataFor(JsonEncoder, 'JsonEncoder', interfaceMeta, VOID, [Encoder, CompositeEncoder]);
		  setMetadataFor(Composer, 'Composer', classMeta);
		  setMetadataFor(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', classMeta, Composer);
		  setMetadataFor(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', classMeta, Composer);
		  setMetadataFor(JsonElementMarker, 'JsonElementMarker', classMeta);
		  setMetadataFor(JsonException, 'JsonException', classMeta, SerializationException);
		  setMetadataFor(JsonEncodingException, 'JsonEncodingException', classMeta, JsonException);
		  setMetadataFor(JsonDecodingException, 'JsonDecodingException', classMeta, JsonException);
		  setMetadataFor(Tombstone, 'Tombstone', objectMeta);
		  setMetadataFor(JsonPath, 'JsonPath', classMeta, VOID, VOID, JsonPath);
		  setMetadataFor(JsonTreeReader$readDeepRecursive$slambda, 'JsonTreeReader$readDeepRecursive$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [2]);
		  setMetadataFor($readObjectCOROUTINE$0, '$readObjectCOROUTINE$0', classMeta, CoroutineImpl);
		  setMetadataFor(JsonTreeReader, 'JsonTreeReader', classMeta, VOID, VOID, VOID, VOID, VOID, [0]);
		  setMetadataFor(PolymorphismValidator, 'PolymorphismValidator', classMeta, VOID, [SerializersModuleCollector]);
		  setMetadataFor(Key, 'Key', classMeta, VOID, VOID, Key);
		  setMetadataFor(DescriptorSchemaCache, 'DescriptorSchemaCache', classMeta, VOID, VOID, DescriptorSchemaCache);
		  setMetadataFor(DiscriminatorHolder, 'DiscriminatorHolder', classMeta);
		  setMetadataFor(StreamingJsonDecoder, 'StreamingJsonDecoder', classMeta, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
		  setMetadataFor(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', classMeta, AbstractDecoder);
		  setMetadataFor(StreamingJsonEncoder, 'StreamingJsonEncoder', classMeta, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
		  setMetadataFor(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', classMeta, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
		  setMetadataFor(JsonTreeDecoder, 'JsonTreeDecoder', classMeta, AbstractJsonTreeDecoder);
		  setMetadataFor(JsonTreeListDecoder, 'JsonTreeListDecoder', classMeta, AbstractJsonTreeDecoder);
		  setMetadataFor(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', classMeta, AbstractJsonTreeDecoder);
		  setMetadataFor(JsonTreeMapDecoder, 'JsonTreeMapDecoder', classMeta, JsonTreeDecoder);
		  setMetadataFor(AbstractJsonTreeEncoder, 'AbstractJsonTreeEncoder', classMeta, NamedValueEncoder, [NamedValueEncoder, JsonEncoder]);
		  setMetadataFor(JsonTreeEncoder, 'JsonTreeEncoder', classMeta, AbstractJsonTreeEncoder);
		  setMetadataFor(AbstractJsonTreeEncoder$encodeTaggedInline$1, VOID, classMeta, AbstractEncoder);
		  setMetadataFor(JsonPrimitiveEncoder, 'JsonPrimitiveEncoder', classMeta, AbstractJsonTreeEncoder);
		  setMetadataFor(JsonTreeListEncoder, 'JsonTreeListEncoder', classMeta, AbstractJsonTreeEncoder);
		  setMetadataFor(JsonTreeMapEncoder, 'JsonTreeMapEncoder', classMeta, JsonTreeEncoder);
		  setMetadataFor(WriteMode, 'WriteMode', classMeta, Enum);
		  setMetadataFor(AbstractJsonLexer, 'AbstractJsonLexer', classMeta);
		  setMetadataFor(CharMappings, 'CharMappings', objectMeta);
		  setMetadataFor(StringJsonLexer, 'StringJsonLexer', classMeta, AbstractJsonLexer);
		  setMetadataFor(JsonToStringWriter, 'JsonToStringWriter', classMeta, VOID, VOID, JsonToStringWriter);
		  //endregion
		  function Default() {
		    Default_instance = this;
		    Json.call(this, new JsonConfiguration(), EmptySerializersModule());
		  }
		  var Default_instance;
		  function Default_getInstance() {
		    if (Default_instance == null)
		      new Default();
		    return Default_instance;
		  }
		  function Json(configuration, serializersModule) {
		    Default_getInstance();
		    this.x10_1 = configuration;
		    this.y10_1 = serializersModule;
		    this.z10_1 = new DescriptorSchemaCache();
		  }
		  protoOf(Json).tj = function () {
		    return this.y10_1;
		  };
		  protoOf(Json).a11 = function (serializer, value) {
		    var result = new JsonToStringWriter();
		    try {
		      encodeByWriter(this, result, serializer, value);
		      return result.toString();
		    }finally {
		      result.g11();
		    }
		  };
		  protoOf(Json).b11 = function (deserializer, string) {
		    var lexer = new StringJsonLexer(string);
		    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.uf(), null);
		    var result = input.dj(deserializer);
		    lexer.t11();
		    return result;
		  };
		  protoOf(Json).c11 = function (serializer, value) {
		    return writeJson(this, value, serializer);
		  };
		  protoOf(Json).d11 = function (deserializer, element) {
		    return readJson(this, element, deserializer);
		  };
		  protoOf(Json).e11 = function (string) {
		    return this.b11(JsonElementSerializer_getInstance(), string);
		  };
		  function Json_0(from, builderAction) {
		    from = from === VOID ? Default_getInstance() : from;
		    var builder = new JsonBuilder(from);
		    builderAction(builder);
		    var conf = builder.to();
		    return new JsonImpl(conf, builder.g12_1);
		  }
		  function JsonBuilder(json) {
		    this.u11_1 = json.x10_1.h12_1;
		    this.v11_1 = json.x10_1.m12_1;
		    this.w11_1 = json.x10_1.i12_1;
		    this.x11_1 = json.x10_1.j12_1;
		    this.y11_1 = json.x10_1.k12_1;
		    this.z11_1 = json.x10_1.l12_1;
		    this.a12_1 = json.x10_1.n12_1;
		    this.b12_1 = json.x10_1.o12_1;
		    this.c12_1 = json.x10_1.p12_1;
		    this.d12_1 = json.x10_1.q12_1;
		    this.e12_1 = json.x10_1.r12_1;
		    this.f12_1 = json.x10_1.s12_1;
		    this.g12_1 = json.tj();
		  }
		  protoOf(JsonBuilder).to = function () {
		    if (this.c12_1) {
		      // Inline function 'kotlin.require' call
		      // Inline function 'kotlin.contracts.contract' call
		      if (!(this.d12_1 === 'type')) {
		        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
		        var message = 'Class discriminator should not be specified when array polymorphism is specified';
		        throw IllegalArgumentException_init_$Create$(toString(message));
		      }
		    }
		    if (!this.z11_1) {
		      // Inline function 'kotlin.require' call
		      // Inline function 'kotlin.contracts.contract' call
		      if (!(this.a12_1 === '    ')) {
		        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
		        var message_0 = 'Indent should not be specified when default printing mode is used';
		        throw IllegalArgumentException_init_$Create$(toString(message_0));
		      }
		    } else if (!(this.a12_1 === '    ')) {
		      var tmp$ret$3;
		      $l$block: {
		        // Inline function 'kotlin.text.all' call
		        var indexedObject = this.a12_1;
		        var inductionVariable = 0;
		        while (inductionVariable < charSequenceLength(indexedObject)) {
		          var element = charSequenceGet(indexedObject, inductionVariable);
		          inductionVariable = inductionVariable + 1 | 0;
		          // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
		          if (!(((element === _Char___init__impl__6a9atx(32) ? true : element === _Char___init__impl__6a9atx(9)) ? true : element === _Char___init__impl__6a9atx(13)) ? true : element === _Char___init__impl__6a9atx(10))) {
		            tmp$ret$3 = false;
		            break $l$block;
		          }
		        }
		        tmp$ret$3 = true;
		      }
		      var allWhitespaces = tmp$ret$3;
		      // Inline function 'kotlin.require' call
		      // Inline function 'kotlin.contracts.contract' call
		      if (!allWhitespaces) {
		        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
		        var message_1 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.a12_1;
		        throw IllegalArgumentException_init_$Create$(toString(message_1));
		      }
		    }
		    return new JsonConfiguration(this.u11_1, this.w11_1, this.x11_1, this.y11_1, this.z11_1, this.v11_1, this.a12_1, this.b12_1, this.c12_1, this.d12_1, this.e12_1, this.f12_1);
		  };
		  function validateConfiguration($this) {
		    if (equals($this.tj(), EmptySerializersModule()))
		      return Unit_instance;
		    var collector = new PolymorphismValidator($this.x10_1.p12_1, $this.x10_1.q12_1);
		    $this.tj().xz(collector);
		  }
		  function JsonImpl(configuration, module_0) {
		    Json.call(this, configuration, module_0);
		    validateConfiguration(this);
		  }
		  function JsonClassDiscriminator() {
		  }
		  function JsonNames() {
		  }
		  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames) {
		    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
		    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
		    isLenient = isLenient === VOID ? false : isLenient;
		    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
		    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
		    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
		    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
		    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
		    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
		    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
		    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
		    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
		    this.h12_1 = encodeDefaults;
		    this.i12_1 = ignoreUnknownKeys;
		    this.j12_1 = isLenient;
		    this.k12_1 = allowStructuredMapKeys;
		    this.l12_1 = prettyPrint;
		    this.m12_1 = explicitNulls;
		    this.n12_1 = prettyPrintIndent;
		    this.o12_1 = coerceInputValues;
		    this.p12_1 = useArrayPolymorphism;
		    this.q12_1 = classDiscriminator;
		    this.r12_1 = allowSpecialFloatingPointValues;
		    this.s12_1 = useAlternativeNames;
		  }
		  protoOf(JsonConfiguration).toString = function () {
		    return 'JsonConfiguration(encodeDefaults=' + this.h12_1 + ', ignoreUnknownKeys=' + this.i12_1 + ', isLenient=' + this.j12_1 + ', ' + ('allowStructuredMapKeys=' + this.k12_1 + ', prettyPrint=' + this.l12_1 + ', explicitNulls=' + this.m12_1 + ', ') + ("prettyPrintIndent='" + this.n12_1 + "', coerceInputValues=" + this.o12_1 + ', useArrayPolymorphism=' + this.p12_1 + ', ') + ("classDiscriminator='" + this.q12_1 + "', allowSpecialFloatingPointValues=" + this.r12_1 + ')');
		  };
		  function throwSubtypeNotRegistered($this, subClass, baseClass) {
		    var tmp0_elvis_lhs = subClass.t5();
		    var subClassName = tmp0_elvis_lhs == null ? '' + subClass : tmp0_elvis_lhs;
		    var scope = "in the scope of '" + baseClass.t5() + "'";
		    throw SerializationException_init_$Create$("Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + '.\n' + "Mark the base class as 'sealed' or register the serializer explicitly.");
		  }
		  function JsonContentPolymorphicSerializer(baseClass) {
		    this.t12_1 = baseClass;
		    this.u12_1 = buildSerialDescriptor('JsonContentPolymorphicSerializer<' + this.t12_1.t5() + '>', SEALED_getInstance(), []);
		  }
		  protoOf(JsonContentPolymorphicSerializer).uf = function () {
		    return this.u12_1;
		  };
		  protoOf(JsonContentPolymorphicSerializer).kg = function (encoder, value) {
		    var tmp0_elvis_lhs = encoder.tj().fl(this.t12_1, value);
		    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? serializerOrNull(getKClassFromExpression(value)) : tmp0_elvis_lhs;
		    var tmp;
		    if (tmp1_elvis_lhs == null) {
		      throwSubtypeNotRegistered(this, getKClassFromExpression(value), this.t12_1);
		    } else {
		      tmp = tmp1_elvis_lhs;
		    }
		    var actualSerializer = tmp;
		    (isInterface(actualSerializer, KSerializer) ? actualSerializer : THROW_CCE()).vf(encoder, value);
		  };
		  protoOf(JsonContentPolymorphicSerializer).vf = function (encoder, value) {
		    return this.kg(encoder, !(value == null) ? value : THROW_CCE());
		  };
		  protoOf(JsonContentPolymorphicSerializer).wf = function (decoder) {
		    var input = asJsonDecoder(decoder);
		    var tree = input.v12();
		    var tmp = this.w12(tree);
		    var actualSerializer = isInterface(tmp, KSerializer) ? tmp : THROW_CCE();
		    return input.x12().d11(actualSerializer, tree);
		  };
		  function JsonDecoder() {
		  }
		  function Companion() {
		  }
		  var Companion_instance_0;
		  function Companion_getInstance_4() {
		    return Companion_instance_0;
		  }
		  function JsonElement() {
		  }
		  function Companion_0() {
		  }
		  protoOf(Companion_0).y12 = function () {
		    return JsonObjectSerializer_getInstance();
		  };
		  var Companion_instance_1;
		  function Companion_getInstance_5() {
		    return Companion_instance_1;
		  }
		  function JsonObject$toString$lambda(_name_for_destructuring_parameter_0__wldtmu) {
		    // Inline function 'kotlin.collections.component1' call
		    var k = _name_for_destructuring_parameter_0__wldtmu.v1();
		    // Inline function 'kotlin.collections.component2' call
		    var v = _name_for_destructuring_parameter_0__wldtmu.w1();
		    // Inline function 'kotlin.text.buildString' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.apply' call
		    var this_0 = StringBuilder_init_$Create$();
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
		    printQuoted(this_0, k);
		    this_0.b5(_Char___init__impl__6a9atx(58));
		    this_0.z4(v);
		    return this_0.toString();
		  }
		  function JsonObject(content) {
		    JsonElement.call(this);
		    this.z12_1 = content;
		  }
		  protoOf(JsonObject).u1 = function () {
		    return this.z12_1.u1();
		  };
		  protoOf(JsonObject).q1 = function () {
		    return this.z12_1.q1();
		  };
		  protoOf(JsonObject).u = function () {
		    return this.z12_1.u();
		  };
		  protoOf(JsonObject).r1 = function () {
		    return this.z12_1.r1();
		  };
		  protoOf(JsonObject).a13 = function (key) {
		    return this.z12_1.z1(key);
		  };
		  protoOf(JsonObject).z1 = function (key) {
		    if (!(!(key == null) ? typeof key === 'string' : false))
		      return false;
		    return this.a13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
		  };
		  protoOf(JsonObject).b13 = function (key) {
		    return this.z12_1.c2(key);
		  };
		  protoOf(JsonObject).c2 = function (key) {
		    if (!(!(key == null) ? typeof key === 'string' : false))
		      return null;
		    return this.b13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
		  };
		  protoOf(JsonObject).x = function () {
		    return this.z12_1.x();
		  };
		  protoOf(JsonObject).equals = function (other) {
		    return equals(this.z12_1, other);
		  };
		  protoOf(JsonObject).hashCode = function () {
		    return hashCode(this.z12_1);
		  };
		  protoOf(JsonObject).toString = function () {
		    var tmp = this.z12_1.u1();
		    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
		  };
		  function JsonNull$$cachedSerializer$delegate$_anonymous__7w2ks1() {
		    return JsonNullSerializer_getInstance();
		  }
		  function JsonNull() {
		    JsonNull_instance = this;
		    JsonPrimitive.call(this);
		    this.c13_1 = 'null';
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.d13_1 = lazy(tmp_0, JsonNull$$cachedSerializer$delegate$_anonymous__7w2ks1);
		  }
		  protoOf(JsonNull).e13 = function () {
		    return this.c13_1;
		  };
		  protoOf(JsonNull).y12 = function () {
		    return this.d13_1.w1();
		  };
		  protoOf(JsonNull).nr = function (typeParamsSerializers) {
		    return this.y12();
		  };
		  var JsonNull_instance;
		  function JsonNull_getInstance() {
		    if (JsonNull_instance == null)
		      new JsonNull();
		    return JsonNull_instance;
		  }
		  function Companion_1() {
		  }
		  var Companion_instance_2;
		  function Companion_getInstance_6() {
		    return Companion_instance_2;
		  }
		  function JsonPrimitive() {
		    JsonElement.call(this);
		  }
		  protoOf(JsonPrimitive).toString = function () {
		    return this.e13();
		  };
		  function JsonPrimitive_0(value) {
		    if (value == null)
		      return JsonNull_getInstance();
		    return new JsonLiteral(value, false);
		  }
		  function JsonPrimitive_1(value) {
		    if (value == null)
		      return JsonNull_getInstance();
		    return new JsonLiteral(value, false);
		  }
		  function JsonPrimitive_2(value) {
		    if (value == null)
		      return JsonNull_getInstance();
		    return new JsonLiteral(value, true);
		  }
		  function JsonLiteral(body, isString) {
		    JsonPrimitive.call(this);
		    this.f13_1 = isString;
		    this.g13_1 = toString(body);
		  }
		  protoOf(JsonLiteral).e13 = function () {
		    return this.g13_1;
		  };
		  protoOf(JsonLiteral).toString = function () {
		    var tmp;
		    if (this.f13_1) {
		      // Inline function 'kotlin.text.buildString' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlin.apply' call
		      var this_0 = StringBuilder_init_$Create$();
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
		      printQuoted(this_0, this.g13_1);
		      tmp = this_0.toString();
		    } else {
		      tmp = this.g13_1;
		    }
		    return tmp;
		  };
		  protoOf(JsonLiteral).equals = function (other) {
		    if (this === other)
		      return true;
		    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
		      return false;
		    if (!(other instanceof JsonLiteral))
		      THROW_CCE();
		    if (!(this.f13_1 === other.f13_1))
		      return false;
		    if (!(this.g13_1 === other.g13_1))
		      return false;
		    return true;
		  };
		  protoOf(JsonLiteral).hashCode = function () {
		    var result = getBooleanHashCode(this.f13_1);
		    result = imul(31, result) + getStringHashCode(this.g13_1) | 0;
		    return result;
		  };
		  function Companion_2() {
		  }
		  var Companion_instance_3;
		  function Companion_getInstance_7() {
		    return Companion_instance_3;
		  }
		  function JsonArray(content) {
		    JsonElement.call(this);
		    this.h13_1 = content;
		  }
		  protoOf(JsonArray).u = function () {
		    return this.h13_1.u();
		  };
		  protoOf(JsonArray).i13 = function (element) {
		    return this.h13_1.v(element);
		  };
		  protoOf(JsonArray).v = function (element) {
		    if (!(element instanceof JsonElement))
		      return false;
		    return this.i13(element instanceof JsonElement ? element : THROW_CCE());
		  };
		  protoOf(JsonArray).j13 = function (elements) {
		    return this.h13_1.w(elements);
		  };
		  protoOf(JsonArray).w = function (elements) {
		    return this.j13(elements);
		  };
		  protoOf(JsonArray).b1 = function (index) {
		    return this.h13_1.b1(index);
		  };
		  protoOf(JsonArray).x = function () {
		    return this.h13_1.x();
		  };
		  protoOf(JsonArray).p = function () {
		    return this.h13_1.p();
		  };
		  protoOf(JsonArray).equals = function (other) {
		    return equals(this.h13_1, other);
		  };
		  protoOf(JsonArray).hashCode = function () {
		    return hashCode(this.h13_1);
		  };
		  protoOf(JsonArray).toString = function () {
		    return joinToString(this.h13_1, ',', '[', ']');
		  };
		  function get_booleanOrNull(_this__u8e3s4) {
		    return toBooleanStrictOrNull(_this__u8e3s4.e13());
		  }
		  function get_int(_this__u8e3s4) {
		    return toInt(_this__u8e3s4.e13());
		  }
		  function get_long(_this__u8e3s4) {
		    return toLong(_this__u8e3s4.e13());
		  }
		  function get_float(_this__u8e3s4) {
		    // Inline function 'kotlin.text.toFloat' call
		    var this_0 = _this__u8e3s4.e13();
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return toDouble(this_0);
		  }
		  function get_double(_this__u8e3s4) {
		    return toDouble(_this__u8e3s4.e13());
		  }
		  function get_contentOrNull(_this__u8e3s4) {
		    var tmp;
		    if (_this__u8e3s4 instanceof JsonNull) {
		      tmp = null;
		    } else {
		      tmp = _this__u8e3s4.e13();
		    }
		    return tmp;
		  }
		  function get_longOrNull(_this__u8e3s4) {
		    return toLongOrNull(_this__u8e3s4.e13());
		  }
		  function get_doubleOrNull(_this__u8e3s4) {
		    return toDoubleOrNull(_this__u8e3s4.e13());
		  }
		  function get_jsonPrimitive(_this__u8e3s4) {
		    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      error(_this__u8e3s4, 'JsonPrimitive');
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function error(_this__u8e3s4, element) {
		    throw IllegalArgumentException_init_$Create$('Element ' + getKClassFromExpression(_this__u8e3s4) + ' is not a ' + element);
		  }
		  function get_jsonObject(_this__u8e3s4) {
		    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonObject ? _this__u8e3s4 : null;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      error(_this__u8e3s4, 'JsonObject');
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function JsonObjectBuilder() {
		    var tmp = this;
		    // Inline function 'kotlin.collections.linkedMapOf' call
		    tmp.k13_1 = LinkedHashMap_init_$Create$();
		  }
		  protoOf(JsonObjectBuilder).l13 = function (key, element) {
		    return this.k13_1.s1(key, element);
		  };
		  protoOf(JsonObjectBuilder).to = function () {
		    return new JsonObject(this.k13_1);
		  };
		  function put(_this__u8e3s4, key, value) {
		    return _this__u8e3s4.l13(key, JsonPrimitive_2(value));
		  }
		  function putJsonObject(_this__u8e3s4, key, builderAction) {
		    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
		    // Inline function 'kotlin.contracts.contract' call
		    var builder = new JsonObjectBuilder();
		    builderAction(builder);
		    var tmp$ret$0 = builder.to();
		    return _this__u8e3s4.l13(key, tmp$ret$0);
		  }
		  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
		    $this$buildSerialDescriptor.fg('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
		    $this$buildSerialDescriptor.fg('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
		    $this$buildSerialDescriptor.fg('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
		    $this$buildSerialDescriptor.fg('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
		    $this$buildSerialDescriptor.fg('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
		    return Unit_instance;
		  }
		  function JsonElementSerializer$descriptor$lambda$lambda() {
		    return JsonPrimitiveSerializer_getInstance().m13_1;
		  }
		  function JsonElementSerializer$descriptor$lambda$lambda_0() {
		    return JsonNullSerializer_getInstance().n13_1;
		  }
		  function JsonElementSerializer$descriptor$lambda$lambda_1() {
		    return JsonLiteralSerializer_getInstance().o13_1;
		  }
		  function JsonElementSerializer$descriptor$lambda$lambda_2() {
		    return JsonObjectSerializer_getInstance().p13_1;
		  }
		  function JsonElementSerializer$descriptor$lambda$lambda_3() {
		    return JsonArraySerializer_getInstance().q13_1;
		  }
		  function JsonElementSerializer() {
		    JsonElementSerializer_instance = this;
		    var tmp = this;
		    var tmp_0 = SEALED_getInstance();
		    tmp.r13_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
		  }
		  protoOf(JsonElementSerializer).uf = function () {
		    return this.r13_1;
		  };
		  protoOf(JsonElementSerializer).s13 = function (encoder, value) {
		    verify(encoder);
		    if (value instanceof JsonPrimitive) {
		      encoder.wk(JsonPrimitiveSerializer_getInstance(), value);
		    } else {
		      if (value instanceof JsonObject) {
		        encoder.wk(JsonObjectSerializer_getInstance(), value);
		      } else {
		        if (value instanceof JsonArray) {
		          encoder.wk(JsonArraySerializer_getInstance(), value);
		        }
		      }
		    }
		  };
		  protoOf(JsonElementSerializer).vf = function (encoder, value) {
		    return this.s13(encoder, value instanceof JsonElement ? value : THROW_CCE());
		  };
		  protoOf(JsonElementSerializer).wf = function (decoder) {
		    var input = asJsonDecoder(decoder);
		    return input.v12();
		  };
		  var JsonElementSerializer_instance;
		  function JsonElementSerializer_getInstance() {
		    if (JsonElementSerializer_instance == null)
		      new JsonElementSerializer();
		    return JsonElementSerializer_instance;
		  }
		  function JsonObjectDescriptor() {
		    JsonObjectDescriptor_instance = this;
		    this.t13_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).uf();
		    this.u13_1 = 'kotlinx.serialization.json.JsonObject';
		  }
		  protoOf(JsonObjectDescriptor).ih = function () {
		    return this.t13_1.ih();
		  };
		  protoOf(JsonObjectDescriptor).jh = function () {
		    return this.t13_1.jh();
		  };
		  protoOf(JsonObjectDescriptor).kh = function () {
		    return this.t13_1.kh();
		  };
		  protoOf(JsonObjectDescriptor).eh = function () {
		    return this.t13_1.eh();
		  };
		  protoOf(JsonObjectDescriptor).lh = function () {
		    return this.t13_1.lh();
		  };
		  protoOf(JsonObjectDescriptor).mh = function (index) {
		    return this.t13_1.mh(index);
		  };
		  protoOf(JsonObjectDescriptor).nh = function (index) {
		    return this.t13_1.nh(index);
		  };
		  protoOf(JsonObjectDescriptor).oh = function (name) {
		    return this.t13_1.oh(name);
		  };
		  protoOf(JsonObjectDescriptor).ph = function (index) {
		    return this.t13_1.ph(index);
		  };
		  protoOf(JsonObjectDescriptor).qh = function (index) {
		    return this.t13_1.qh(index);
		  };
		  protoOf(JsonObjectDescriptor).sg = function () {
		    return this.u13_1;
		  };
		  var JsonObjectDescriptor_instance;
		  function JsonObjectDescriptor_getInstance() {
		    if (JsonObjectDescriptor_instance == null)
		      new JsonObjectDescriptor();
		    return JsonObjectDescriptor_instance;
		  }
		  function JsonObjectSerializer() {
		    JsonObjectSerializer_instance = this;
		    this.p13_1 = JsonObjectDescriptor_getInstance();
		  }
		  protoOf(JsonObjectSerializer).uf = function () {
		    return this.p13_1;
		  };
		  protoOf(JsonObjectSerializer).v13 = function (encoder, value) {
		    verify(encoder);
		    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).vf(encoder, value);
		  };
		  protoOf(JsonObjectSerializer).vf = function (encoder, value) {
		    return this.v13(encoder, value instanceof JsonObject ? value : THROW_CCE());
		  };
		  protoOf(JsonObjectSerializer).wf = function (decoder) {
		    verify_0(decoder);
		    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).wf(decoder));
		  };
		  var JsonObjectSerializer_instance;
		  function JsonObjectSerializer_getInstance() {
		    if (JsonObjectSerializer_instance == null)
		      new JsonObjectSerializer();
		    return JsonObjectSerializer_instance;
		  }
		  function JsonArrayDescriptor() {
		    JsonArrayDescriptor_instance = this;
		    this.w13_1 = ListSerializer(JsonElementSerializer_getInstance()).uf();
		    this.x13_1 = 'kotlinx.serialization.json.JsonArray';
		  }
		  protoOf(JsonArrayDescriptor).ih = function () {
		    return this.w13_1.ih();
		  };
		  protoOf(JsonArrayDescriptor).jh = function () {
		    return this.w13_1.jh();
		  };
		  protoOf(JsonArrayDescriptor).kh = function () {
		    return this.w13_1.kh();
		  };
		  protoOf(JsonArrayDescriptor).eh = function () {
		    return this.w13_1.eh();
		  };
		  protoOf(JsonArrayDescriptor).lh = function () {
		    return this.w13_1.lh();
		  };
		  protoOf(JsonArrayDescriptor).mh = function (index) {
		    return this.w13_1.mh(index);
		  };
		  protoOf(JsonArrayDescriptor).nh = function (index) {
		    return this.w13_1.nh(index);
		  };
		  protoOf(JsonArrayDescriptor).oh = function (name) {
		    return this.w13_1.oh(name);
		  };
		  protoOf(JsonArrayDescriptor).ph = function (index) {
		    return this.w13_1.ph(index);
		  };
		  protoOf(JsonArrayDescriptor).qh = function (index) {
		    return this.w13_1.qh(index);
		  };
		  protoOf(JsonArrayDescriptor).sg = function () {
		    return this.x13_1;
		  };
		  var JsonArrayDescriptor_instance;
		  function JsonArrayDescriptor_getInstance() {
		    if (JsonArrayDescriptor_instance == null)
		      new JsonArrayDescriptor();
		    return JsonArrayDescriptor_instance;
		  }
		  function JsonArraySerializer() {
		    JsonArraySerializer_instance = this;
		    this.q13_1 = JsonArrayDescriptor_getInstance();
		  }
		  protoOf(JsonArraySerializer).uf = function () {
		    return this.q13_1;
		  };
		  protoOf(JsonArraySerializer).y13 = function (encoder, value) {
		    verify(encoder);
		    ListSerializer(JsonElementSerializer_getInstance()).vf(encoder, value);
		  };
		  protoOf(JsonArraySerializer).vf = function (encoder, value) {
		    return this.y13(encoder, value instanceof JsonArray ? value : THROW_CCE());
		  };
		  protoOf(JsonArraySerializer).wf = function (decoder) {
		    verify_0(decoder);
		    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).wf(decoder));
		  };
		  var JsonArraySerializer_instance;
		  function JsonArraySerializer_getInstance() {
		    if (JsonArraySerializer_instance == null)
		      new JsonArraySerializer();
		    return JsonArraySerializer_instance;
		  }
		  function defer(deferred) {
		    return new defer$1(deferred);
		  }
		  function JsonPrimitiveSerializer() {
		    JsonPrimitiveSerializer_instance = this;
		    this.m13_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
		  }
		  protoOf(JsonPrimitiveSerializer).uf = function () {
		    return this.m13_1;
		  };
		  protoOf(JsonPrimitiveSerializer).z13 = function (encoder, value) {
		    verify(encoder);
		    var tmp;
		    if (value instanceof JsonNull) {
		      encoder.wk(JsonNullSerializer_getInstance(), JsonNull_getInstance());
		      tmp = Unit_instance;
		    } else {
		      var tmp_0 = JsonLiteralSerializer_getInstance();
		      encoder.wk(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
		      tmp = Unit_instance;
		    }
		    return tmp;
		  };
		  protoOf(JsonPrimitiveSerializer).vf = function (encoder, value) {
		    return this.z13(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
		  };
		  protoOf(JsonPrimitiveSerializer).wf = function (decoder) {
		    var result = asJsonDecoder(decoder).v12();
		    if (!(result instanceof JsonPrimitive))
		      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + getKClassFromExpression(result), toString(result));
		    return result;
		  };
		  var JsonPrimitiveSerializer_instance;
		  function JsonPrimitiveSerializer_getInstance() {
		    if (JsonPrimitiveSerializer_instance == null)
		      new JsonPrimitiveSerializer();
		    return JsonPrimitiveSerializer_instance;
		  }
		  function JsonNullSerializer() {
		    JsonNullSerializer_instance = this;
		    this.n13_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
		  }
		  protoOf(JsonNullSerializer).uf = function () {
		    return this.n13_1;
		  };
		  protoOf(JsonNullSerializer).a14 = function (encoder, value) {
		    verify(encoder);
		    encoder.zj();
		  };
		  protoOf(JsonNullSerializer).vf = function (encoder, value) {
		    return this.a14(encoder, value instanceof JsonNull ? value : THROW_CCE());
		  };
		  protoOf(JsonNullSerializer).wf = function (decoder) {
		    verify_0(decoder);
		    if (decoder.pi()) {
		      throw new JsonDecodingException("Expected 'null' literal");
		    }
		    decoder.qi();
		    return JsonNull_getInstance();
		  };
		  var JsonNullSerializer_instance;
		  function JsonNullSerializer_getInstance() {
		    if (JsonNullSerializer_instance == null)
		      new JsonNullSerializer();
		    return JsonNullSerializer_instance;
		  }
		  function JsonLiteralSerializer() {
		    JsonLiteralSerializer_instance = this;
		    this.o13_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
		  }
		  protoOf(JsonLiteralSerializer).uf = function () {
		    return this.o13_1;
		  };
		  protoOf(JsonLiteralSerializer).b14 = function (encoder, value) {
		    verify(encoder);
		    if (value.f13_1) {
		      return encoder.ik(value.g13_1);
		    }
		    var tmp0_safe_receiver = get_longOrNull(value);
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      return encoder.ek(tmp0_safe_receiver);
		    }
		    var tmp1_safe_receiver = toULongOrNull(value.g13_1);
		    var tmp = tmp1_safe_receiver;
		    if ((tmp == null ? null : new ULong(tmp)) == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      var tmp_0 = tmp1_safe_receiver;
		      // Inline function 'kotlin.contracts.contract' call
		      var it = (tmp_0 == null ? null : new ULong(tmp_0)).bf_1;
		      var tmp_1 = encoder.kk(serializer_0(Companion_getInstance()).uf());
		      // Inline function 'kotlin.ULong.toLong' call
		      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
		      tmp_1.ek(tmp$ret$1);
		      return Unit_instance;
		    }
		    var tmp2_safe_receiver = get_doubleOrNull(value);
		    if (tmp2_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      return encoder.gk(tmp2_safe_receiver);
		    }
		    var tmp3_safe_receiver = get_booleanOrNull(value);
		    if (tmp3_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      return encoder.ak(tmp3_safe_receiver);
		    }
		    encoder.ik(value.g13_1);
		  };
		  protoOf(JsonLiteralSerializer).vf = function (encoder, value) {
		    return this.b14(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
		  };
		  protoOf(JsonLiteralSerializer).wf = function (decoder) {
		    var result = asJsonDecoder(decoder).v12();
		    if (!(result instanceof JsonLiteral))
		      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + getKClassFromExpression(result), toString(result));
		    return result;
		  };
		  var JsonLiteralSerializer_instance;
		  function JsonLiteralSerializer_getInstance() {
		    if (JsonLiteralSerializer_instance == null)
		      new JsonLiteralSerializer();
		    return JsonLiteralSerializer_instance;
		  }
		  function verify(encoder) {
		    asJsonEncoder(encoder);
		  }
		  function asJsonDecoder(_this__u8e3s4) {
		    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + getKClassFromExpression(_this__u8e3s4)));
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function verify_0(decoder) {
		    asJsonDecoder(decoder);
		  }
		  function asJsonEncoder(_this__u8e3s4) {
		    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + getKClassFromExpression(_this__u8e3s4)));
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function _get_original__l7ku1m($this) {
		    // Inline function 'kotlin.getValue' call
		    var this_0 = $this.c14_1;
		    original$factory();
		    return this_0.w1();
		  }
		  function defer$1($deferred) {
		    this.c14_1 = lazy_0($deferred);
		  }
		  protoOf(defer$1).sg = function () {
		    return _get_original__l7ku1m(this).sg();
		  };
		  protoOf(defer$1).lh = function () {
		    return _get_original__l7ku1m(this).lh();
		  };
		  protoOf(defer$1).jh = function () {
		    return _get_original__l7ku1m(this).jh();
		  };
		  protoOf(defer$1).ph = function (index) {
		    return _get_original__l7ku1m(this).ph(index);
		  };
		  protoOf(defer$1).oh = function (name) {
		    return _get_original__l7ku1m(this).oh(name);
		  };
		  protoOf(defer$1).mh = function (index) {
		    return _get_original__l7ku1m(this).mh(index);
		  };
		  protoOf(defer$1).nh = function (index) {
		    return _get_original__l7ku1m(this).nh(index);
		  };
		  protoOf(defer$1).qh = function (index) {
		    return _get_original__l7ku1m(this).qh(index);
		  };
		  function original$factory() {
		    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
		      return _get_original__l7ku1m(receiver);
		    }, null);
		  }
		  function JsonEncoder() {
		  }
		  function Composer(writer) {
		    this.d14_1 = writer;
		    this.e14_1 = true;
		  }
		  protoOf(Composer).f14 = function () {
		    this.e14_1 = true;
		  };
		  protoOf(Composer).g14 = function () {
		    return Unit_instance;
		  };
		  protoOf(Composer).h14 = function () {
		    this.e14_1 = false;
		  };
		  protoOf(Composer).i14 = function () {
		    return Unit_instance;
		  };
		  protoOf(Composer).j14 = function (v) {
		    return this.d14_1.k14(v);
		  };
		  protoOf(Composer).l14 = function (v) {
		    return this.d14_1.m14(v);
		  };
		  protoOf(Composer).n14 = function (v) {
		    return this.d14_1.m14(v.toString());
		  };
		  protoOf(Composer).o14 = function (v) {
		    return this.d14_1.m14(v.toString());
		  };
		  protoOf(Composer).p14 = function (v) {
		    return this.d14_1.q14(toLong_0(v));
		  };
		  protoOf(Composer).r14 = function (v) {
		    return this.d14_1.q14(toLong_0(v));
		  };
		  protoOf(Composer).s14 = function (v) {
		    return this.d14_1.q14(toLong_0(v));
		  };
		  protoOf(Composer).t14 = function (v) {
		    return this.d14_1.q14(v);
		  };
		  protoOf(Composer).u14 = function (v) {
		    return this.d14_1.m14(v.toString());
		  };
		  protoOf(Composer).v14 = function (value) {
		    return this.d14_1.w14(value);
		  };
		  function Composer_0(sb, json) {
		    return json.x10_1.l12_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
		  }
		  function ComposerForUnsignedNumbers(writer, forceQuoting) {
		    Composer.call(this, writer);
		    this.z14_1 = forceQuoting;
		  }
		  protoOf(ComposerForUnsignedNumbers).s14 = function (v) {
		    if (this.z14_1) {
		      // Inline function 'kotlin.toUInt' call
		      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
		      this.v14(UInt__toString_impl_dbgl21(tmp$ret$0));
		    } else {
		      // Inline function 'kotlin.toUInt' call
		      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
		      this.l14(UInt__toString_impl_dbgl21(tmp$ret$1));
		    }
		  };
		  protoOf(ComposerForUnsignedNumbers).t14 = function (v) {
		    if (this.z14_1) {
		      // Inline function 'kotlin.toULong' call
		      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
		      this.v14(ULong__toString_impl_f9au7k(tmp$ret$0));
		    } else {
		      // Inline function 'kotlin.toULong' call
		      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
		      this.l14(ULong__toString_impl_f9au7k(tmp$ret$1));
		    }
		  };
		  protoOf(ComposerForUnsignedNumbers).p14 = function (v) {
		    if (this.z14_1) {
		      // Inline function 'kotlin.toUByte' call
		      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
		      this.v14(UByte__toString_impl_v72jg(tmp$ret$0));
		    } else {
		      // Inline function 'kotlin.toUByte' call
		      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
		      this.l14(UByte__toString_impl_v72jg(tmp$ret$1));
		    }
		  };
		  protoOf(ComposerForUnsignedNumbers).r14 = function (v) {
		    if (this.z14_1) {
		      // Inline function 'kotlin.toUShort' call
		      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
		      this.v14(UShort__toString_impl_edaoee(tmp$ret$0));
		    } else {
		      // Inline function 'kotlin.toUShort' call
		      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
		      this.l14(UShort__toString_impl_edaoee(tmp$ret$1));
		    }
		  };
		  function ComposerWithPrettyPrint(writer, json) {
		    Composer.call(this, writer);
		    this.c15_1 = json;
		    this.d15_1 = 0;
		  }
		  protoOf(ComposerWithPrettyPrint).f14 = function () {
		    this.e14_1 = true;
		    this.d15_1 = this.d15_1 + 1 | 0;
		  };
		  protoOf(ComposerWithPrettyPrint).g14 = function () {
		    this.d15_1 = this.d15_1 - 1 | 0;
		  };
		  protoOf(ComposerWithPrettyPrint).h14 = function () {
		    this.e14_1 = false;
		    this.l14('\n');
		    // Inline function 'kotlin.repeat' call
		    var times = this.d15_1;
		    // Inline function 'kotlin.contracts.contract' call
		    var inductionVariable = 0;
		    if (inductionVariable < times)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
		        this.l14(this.c15_1.x10_1.n12_1);
		      }
		       while (inductionVariable < times);
		  };
		  protoOf(ComposerWithPrettyPrint).i14 = function () {
		    this.j14(_Char___init__impl__6a9atx(32));
		  };
		  function readIfAbsent($this, descriptor, index) {
		    $this.f15_1 = !descriptor.qh(index) ? descriptor.nh(index).eh() : false;
		    return $this.f15_1;
		  }
		  function JsonElementMarker$readIfAbsent$ref($boundThis) {
		    var l = function (p0, p1) {
		      return readIfAbsent($boundThis, p0, p1);
		    };
		    l.callableName = 'readIfAbsent';
		    return l;
		  }
		  function JsonElementMarker(descriptor) {
		    var tmp = this;
		    tmp.e15_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
		    this.f15_1 = false;
		  }
		  protoOf(JsonElementMarker).hp = function (index) {
		    this.e15_1.hp(index);
		  };
		  protoOf(JsonElementMarker).ip = function () {
		    return this.e15_1.ip();
		  };
		  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
		    _this__u8e3s4.g15('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, get_specialFlowingValuesHint());
		  }
		  function JsonEncodingException(message) {
		    JsonException.call(this, message);
		    captureStack(this, JsonEncodingException);
		  }
		  function InvalidKeyKindException(keyDescriptor) {
		    return new JsonEncodingException("Value of type '" + keyDescriptor.sg() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.lh() + "'.\n") + get_allowStructuredMapKeysHint());
		  }
		  function InvalidFloatingPointEncoded(value, key, output) {
		    return new JsonEncodingException(unexpectedFpErrorMessage(value, key, output));
		  }
		  function JsonDecodingException(message) {
		    JsonException.call(this, message);
		    captureStack(this, JsonDecodingException);
		  }
		  function JsonDecodingException_0(offset, message, input) {
		    return JsonDecodingException_1(offset, message + '\nJSON input: ' + minify(input, offset));
		  }
		  function InvalidFloatingPointDecoded(value, key, output) {
		    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
		  }
		  function JsonDecodingException_1(offset, message) {
		    return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
		  }
		  function UnknownKeyException(key, input) {
		    return JsonDecodingException_1(-1, "Encountered unknown key '" + key + "'.\n" + (get_ignoreUnknownKeysHint() + '\n') + ('Current input: ' + minify(input)));
		  }
		  function InvalidFloatingPointEncoded_0(value, output) {
		    return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + (get_specialFlowingValuesHint() + '\n') + ('Current output: ' + minify(output)));
		  }
		  function JsonException(message) {
		    SerializationException_init_$Init$(message, this);
		    captureStack(this, JsonException);
		  }
		  function unexpectedFpErrorMessage(value, key, output) {
		    return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + (get_specialFlowingValuesHint() + '\n') + ('Current output: ' + minify(output));
		  }
		  function minify(_this__u8e3s4, offset) {
		    offset = offset === VOID ? -1 : offset;
		    if (charSequenceLength(_this__u8e3s4) < 200)
		      return _this__u8e3s4;
		    if (offset === -1) {
		      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
		      if (start <= 0)
		        return _this__u8e3s4;
		      // Inline function 'kotlin.text.substring' call
		      var endIndex = charSequenceLength(_this__u8e3s4);
		      return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
		    }
		    var start_0 = offset - 30 | 0;
		    var end = offset + 30 | 0;
		    var prefix = start_0 <= 0 ? '' : '.....';
		    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
		    // Inline function 'kotlin.text.substring' call
		    var startIndex = coerceAtLeast(start_0, 0);
		    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
		    return prefix + toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0)) + suffix;
		  }
		  function get_JsonAlternativeNamesKey() {
		    _init_properties_JsonNamesMap_kt__cbbp0k();
		    return JsonAlternativeNamesKey;
		  }
		  var JsonAlternativeNamesKey;
		  function getJsonNameIndex(_this__u8e3s4, json, name) {
		    _init_properties_JsonNamesMap_kt__cbbp0k();
		    var index = _this__u8e3s4.oh(name);
		    if (!(index === -3))
		      return index;
		    if (!json.x10_1.s12_1)
		      return index;
		    var tmp = get_schemaCache(json);
		    var tmp_0 = get_JsonAlternativeNamesKey();
		    var alternativeNamesMap = tmp.i15(_this__u8e3s4, tmp_0, buildAlternativeNamesMap$ref(_this__u8e3s4));
		    var tmp0_elvis_lhs = alternativeNamesMap.c2(name);
		    var tmp_1;
		    if (tmp0_elvis_lhs == null) {
		      tmp_1 = -3;
		    } else {
		      tmp_1 = tmp0_elvis_lhs;
		    }
		    return tmp_1;
		  }
		  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
		    suffix = suffix === VOID ? '' : suffix;
		    _init_properties_JsonNamesMap_kt__cbbp0k();
		    var index = getJsonNameIndex(_this__u8e3s4, json, name);
		    if (index === -3)
		      throw SerializationException_init_$Create$(_this__u8e3s4.sg() + " does not contain element with name '" + name + "'" + suffix);
		    return index;
		  }
		  function buildAlternativeNamesMap(_this__u8e3s4) {
		    _init_properties_JsonNamesMap_kt__cbbp0k();
		    var builder = null;
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.jh();
		    if (inductionVariable < last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.collections.filterIsInstance' call
		        // Inline function 'kotlin.collections.filterIsInstanceTo' call
		        var this_0 = _this__u8e3s4.mh(i);
		        var destination = ArrayList_init_$Create$();
		        var tmp0_iterator = this_0.p();
		        while (tmp0_iterator.q()) {
		          var element = tmp0_iterator.s();
		          if (element instanceof JsonNames) {
		            destination.m(element);
		          }
		        }
		        var tmp1_safe_receiver = singleOrNull(destination);
		        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j15_1;
		        if (tmp2_safe_receiver == null)
		          null;
		        else {
		          // Inline function 'kotlin.collections.forEach' call
		          var inductionVariable_0 = 0;
		          var last_0 = tmp2_safe_receiver.length;
		          while (inductionVariable_0 < last_0) {
		            var element_0 = tmp2_safe_receiver[inductionVariable_0];
		            inductionVariable_0 = inductionVariable_0 + 1 | 0;
		            // Inline function 'kotlinx.serialization.json.internal.buildAlternativeNamesMap.<anonymous>' call
		            if (builder == null)
		              builder = createMapForCache(_this__u8e3s4.jh());
		            buildAlternativeNamesMap$putOrThrow(ensureNotNull(builder), _this__u8e3s4, element_0, i);
		          }
		        }
		      }
		       while (inductionVariable < last);
		    var tmp3_elvis_lhs = builder;
		    return tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs;
		  }
		  function buildAlternativeNamesMap$putOrThrow(_this__u8e3s4, $this_buildAlternativeNamesMap, name, index) {
		    // Inline function 'kotlin.collections.contains' call
		    // Inline function 'kotlin.collections.containsKey' call
		    if ((isInterface(_this__u8e3s4, Map) ? _this__u8e3s4 : THROW_CCE()).z1(name)) {
		      throw new JsonException("The suggested name '" + name + "' for property " + $this_buildAlternativeNamesMap.ph(index) + ' is already one of the names for property ' + ($this_buildAlternativeNamesMap.ph(getValue(_this__u8e3s4, name)) + ' in ' + $this_buildAlternativeNamesMap));
		    }
		    // Inline function 'kotlin.collections.set' call
		    _this__u8e3s4.s1(name, index);
		  }
		  function buildAlternativeNamesMap$ref($boundThis) {
		    var l = function () {
		      return buildAlternativeNamesMap($boundThis);
		    };
		    l.callableName = 'buildAlternativeNamesMap';
		    return l;
		  }
		  var properties_initialized_JsonNamesMap_kt_ljpf42;
		  function _init_properties_JsonNamesMap_kt__cbbp0k() {
		    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
		      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
		      JsonAlternativeNamesKey = new Key();
		    }
		  }
		  function Tombstone() {
		  }
		  var Tombstone_instance;
		  function Tombstone_getInstance() {
		    return Tombstone_instance;
		  }
		  function resize($this) {
		    var newSize = imul($this.m15_1, 2);
		    $this.k15_1 = copyOf($this.k15_1, newSize);
		    $this.l15_1 = copyOf_0($this.l15_1, newSize);
		  }
		  function JsonPath() {
		    var tmp = this;
		    // Inline function 'kotlin.arrayOfNulls' call
		    tmp.k15_1 = fillArrayVal(Array(8), null);
		    var tmp_0 = this;
		    var tmp_1 = 0;
		    var tmp_2 = new Int32Array(8);
		    while (tmp_1 < 8) {
		      tmp_2[tmp_1] = -1;
		      tmp_1 = tmp_1 + 1 | 0;
		    }
		    tmp_0.l15_1 = tmp_2;
		    this.m15_1 = -1;
		  }
		  protoOf(JsonPath).n15 = function (sd) {
		    this.m15_1 = this.m15_1 + 1 | 0;
		    var depth = this.m15_1;
		    if (depth === this.k15_1.length) {
		      resize(this);
		    }
		    this.k15_1[depth] = sd;
		  };
		  protoOf(JsonPath).o15 = function (index) {
		    this.l15_1[this.m15_1] = index;
		  };
		  protoOf(JsonPath).p15 = function (key) {
		    var tmp;
		    if (!(this.l15_1[this.m15_1] === -2)) {
		      this.m15_1 = this.m15_1 + 1 | 0;
		      tmp = this.m15_1 === this.k15_1.length;
		    } else {
		      tmp = false;
		    }
		    if (tmp) {
		      resize(this);
		    }
		    this.k15_1[this.m15_1] = key;
		    this.l15_1[this.m15_1] = -2;
		  };
		  protoOf(JsonPath).q15 = function () {
		    if (this.l15_1[this.m15_1] === -2) {
		      this.k15_1[this.m15_1] = Tombstone_instance;
		    }
		  };
		  protoOf(JsonPath).r15 = function () {
		    var depth = this.m15_1;
		    if (this.l15_1[depth] === -2) {
		      this.l15_1[depth] = -1;
		      this.m15_1 = this.m15_1 - 1 | 0;
		    }
		    if (!(this.m15_1 === -1)) {
		      this.m15_1 = this.m15_1 - 1 | 0;
		    }
		  };
		  protoOf(JsonPath).s15 = function () {
		    // Inline function 'kotlin.text.buildString' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.apply' call
		    var this_0 = StringBuilder_init_$Create$();
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
		    this_0.a5('$');
		    // Inline function 'kotlin.repeat' call
		    var times = this.m15_1 + 1 | 0;
		    // Inline function 'kotlin.contracts.contract' call
		    var inductionVariable = 0;
		    if (inductionVariable < times)
		      do {
		        var index = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
		        var element = this.k15_1[index];
		        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
		          if (equals(element.lh(), LIST_getInstance())) {
		            if (!(this.l15_1[index] === -1)) {
		              this_0.a5('[');
		              this_0.z4(this.l15_1[index]);
		              this_0.a5(']');
		            }
		          } else {
		            var idx = this.l15_1[index];
		            if (idx >= 0) {
		              this_0.a5('.');
		              this_0.a5(element.ph(idx));
		            }
		          }
		        } else {
		          if (!(element === Tombstone_instance)) {
		            this_0.a5('[');
		            this_0.a5("'");
		            this_0.z4(element);
		            this_0.a5("'");
		            this_0.a5(']');
		          }
		        }
		      }
		       while (inductionVariable < times);
		    return this_0.toString();
		  };
		  protoOf(JsonPath).toString = function () {
		    return this.s15();
		  };
		  function encodeByWriter(_this__u8e3s4, writer, serializer, value) {
		    var tmp = WriteMode_OBJ_getInstance();
		    // Inline function 'kotlin.arrayOfNulls' call
		    var size = values().length;
		    var tmp$ret$0 = fillArrayVal(Array(size), null);
		    var encoder = StreamingJsonEncoder_init_$Create$(writer, _this__u8e3s4, tmp, tmp$ret$0);
		    encoder.wk(serializer, value);
		  }
		  function readObject($this) {
		    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
		    var lastToken = $this.b16_1.e16(get_TC_BEGIN_OBJ());
		    if ($this.b16_1.f16() === get_TC_COMMA()) {
		      $this.b16_1.g15('Unexpected leading comma');
		    }
		    // Inline function 'kotlin.collections.linkedMapOf' call
		    var result = LinkedHashMap_init_$Create$();
		    $l$loop: while ($this.b16_1.g16()) {
		      var key = $this.c16_1 ? $this.b16_1.i16() : $this.b16_1.h16();
		      $this.b16_1.e16(get_TC_COLON());
		      // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
		      var element = $this.j16();
		      // Inline function 'kotlin.collections.set' call
		      result.s1(key, element);
		      lastToken = $this.b16_1.k16();
		      var tmp0_subject = lastToken;
		      if (tmp0_subject !== get_TC_COMMA())
		        if (tmp0_subject === get_TC_END_OBJ())
		          break $l$loop;
		        else {
		          $this.b16_1.g15('Expected end of the object or comma');
		        }
		    }
		    if (lastToken === get_TC_BEGIN_OBJ()) {
		      $this.b16_1.e16(get_TC_END_OBJ());
		    } else if (lastToken === get_TC_COMMA()) {
		      $this.b16_1.g15('Unexpected trailing comma');
		    }
		    return new JsonObject(result);
		  }
		  function readObject_0(_this__u8e3s4, $this, $completion) {
		    var tmp = new $readObjectCOROUTINE$0($this, _this__u8e3s4, $completion);
		    tmp.pa_1 = Unit_instance;
		    tmp.qa_1 = null;
		    return tmp.ya();
		  }
		  function readArray($this) {
		    var lastToken = $this.b16_1.k16();
		    if ($this.b16_1.f16() === get_TC_COMMA()) {
		      $this.b16_1.g15('Unexpected leading comma');
		    }
		    // Inline function 'kotlin.collections.arrayListOf' call
		    var result = ArrayList_init_$Create$();
		    while ($this.b16_1.g16()) {
		      var element = $this.j16();
		      result.m(element);
		      lastToken = $this.b16_1.k16();
		      if (!(lastToken === get_TC_COMMA())) {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
		        var this_0 = $this.b16_1;
		        var condition = lastToken === get_TC_END_LIST();
		        var position = this_0.p11_1;
		        if (!condition) {
		          // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
		          var tmp$ret$1 = 'Expected end of the array or comma';
		          this_0.g15(tmp$ret$1, position);
		        }
		      }
		    }
		    if (lastToken === get_TC_BEGIN_LIST()) {
		      $this.b16_1.e16(get_TC_END_LIST());
		    } else if (lastToken === get_TC_COMMA()) {
		      $this.b16_1.g15('Unexpected trailing comma');
		    }
		    return new JsonArray(result);
		  }
		  function readValue($this, isString) {
		    var tmp;
		    if ($this.c16_1 ? true : !isString) {
		      tmp = $this.b16_1.i16();
		    } else {
		      tmp = $this.b16_1.h16();
		    }
		    var string = tmp;
		    if (!isString ? string === get_NULL() : false)
		      return JsonNull_getInstance();
		    return new JsonLiteral(string, isString);
		  }
		  function readDeepRecursive($this) {
		    return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
		  }
		  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
		    this.h17_1 = this$0;
		    CoroutineImpl.call(this, resultContinuation);
		  }
		  protoOf(JsonTreeReader$readDeepRecursive$slambda).m17 = function ($this$$receiver, it, $completion) {
		    var tmp = this.n17($this$$receiver, it, $completion);
		    tmp.pa_1 = Unit_instance;
		    tmp.qa_1 = null;
		    return tmp.ya();
		  };
		  protoOf(JsonTreeReader$readDeepRecursive$slambda).sd = function (p1, p2, $completion) {
		    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
		    return this.m17(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
		  };
		  protoOf(JsonTreeReader$readDeepRecursive$slambda).ya = function () {
		    var suspendResult = this.pa_1;
		    $sm: do
		      try {
		        var tmp = this.na_1;
		        switch (tmp) {
		          case 0:
		            this.oa_1 = 3;
		            this.k17_1 = this.h17_1.b16_1.f16();
		            if (this.k17_1 === get_TC_STRING()) {
		              this.l17_1 = readValue(this.h17_1, true);
		              this.na_1 = 2;
		              continue $sm;
		            } else {
		              if (this.k17_1 === get_TC_OTHER()) {
		                this.l17_1 = readValue(this.h17_1, false);
		                this.na_1 = 2;
		                continue $sm;
		              } else {
		                if (this.k17_1 === get_TC_BEGIN_OBJ()) {
		                  this.na_1 = 1;
		                  suspendResult = readObject_0(this.i17_1, this.h17_1, this);
		                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
		                    return suspendResult;
		                  }
		                  continue $sm;
		                } else {
		                  if (this.k17_1 === get_TC_BEGIN_LIST()) {
		                    this.l17_1 = readArray(this.h17_1);
		                    this.na_1 = 2;
		                    continue $sm;
		                  } else {
		                    var tmp_0 = this;
		                    this.h17_1.b16_1.g15("Can't begin reading element, unexpected token");
		                  }
		                }
		              }
		            }

		            break;
		          case 1:
		            this.l17_1 = suspendResult;
		            this.na_1 = 2;
		            continue $sm;
		          case 2:
		            return this.l17_1;
		          case 3:
		            throw this.qa_1;
		        }
		      } catch ($p) {
		        var e = $p;
		        if (this.oa_1 === 3) {
		          throw e;
		        } else {
		          this.na_1 = this.oa_1;
		          this.qa_1 = e;
		        }
		      }
		     while (true);
		  };
		  protoOf(JsonTreeReader$readDeepRecursive$slambda).n17 = function ($this$$receiver, it, completion) {
		    var i = new JsonTreeReader$readDeepRecursive$slambda(this.h17_1, completion);
		    i.i17_1 = $this$$receiver;
		    i.j17_1 = it;
		    return i;
		  };
		  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
		    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
		    var l = function ($this$$receiver, it, $completion) {
		      return i.m17($this$$receiver, it, $completion);
		    };
		    l.$arity = 2;
		    return l;
		  }
		  function $readObjectCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
		    CoroutineImpl.call(this, resultContinuation);
		    this.t16_1 = _this__u8e3s4;
		    this.u16_1 = _this__u8e3s4_0;
		  }
		  protoOf($readObjectCOROUTINE$0).ya = function () {
		    var suspendResult = this.pa_1;
		    $sm: do
		      try {
		        var tmp = this.na_1;
		        switch (tmp) {
		          case 0:
		            this.oa_1 = 5;
		            var tmp_0 = this;
		            tmp_0.v16_1 = this.t16_1;
		            this.w16_1 = this.v16_1.b16_1.e16(get_TC_BEGIN_OBJ());
		            if (this.v16_1.b16_1.f16() === get_TC_COMMA()) {
		              this.v16_1.b16_1.g15('Unexpected leading comma');
		            }

		            var tmp_1 = this;
		            tmp_1.x16_1 = LinkedHashMap_init_$Create$();
		            this.na_1 = 1;
		            continue $sm;
		          case 1:
		            if (!this.v16_1.b16_1.g16()) {
		              this.na_1 = 4;
		              continue $sm;
		            }

		            this.y16_1 = this.v16_1.c16_1 ? this.v16_1.b16_1.i16() : this.v16_1.b16_1.h16();
		            this.v16_1.b16_1.e16(get_TC_COLON());
		            this.na_1 = 2;
		            suspendResult = this.u16_1.kd(Unit_instance, this);
		            if (suspendResult === get_COROUTINE_SUSPENDED()) {
		              return suspendResult;
		            }

		            continue $sm;
		          case 2:
		            var element = suspendResult;
		            var this_0 = this.x16_1;
		            var key = this.y16_1;
		            this_0.s1(key, element);
		            this.w16_1 = this.v16_1.b16_1.k16();
		            var tmp0_subject = this.w16_1;
		            if (tmp0_subject === get_TC_COMMA()) {
		              this.na_1 = 3;
		              continue $sm;
		            } else {
		              if (tmp0_subject === get_TC_END_OBJ()) {
		                this.na_1 = 4;
		                continue $sm;
		              } else {
		                this.v16_1.b16_1.g15('Expected end of the object or comma');
		              }
		            }

		            break;
		          case 3:
		            this.na_1 = 1;
		            continue $sm;
		          case 4:
		            if (this.w16_1 === get_TC_BEGIN_OBJ()) {
		              this.v16_1.b16_1.e16(get_TC_END_OBJ());
		            } else if (this.w16_1 === get_TC_COMMA()) {
		              this.v16_1.b16_1.g15('Unexpected trailing comma');
		            }

		            return new JsonObject(this.x16_1);
		          case 5:
		            throw this.qa_1;
		        }
		      } catch ($p) {
		        var e = $p;
		        if (this.oa_1 === 5) {
		          throw e;
		        } else {
		          this.na_1 = this.oa_1;
		          this.qa_1 = e;
		        }
		      }
		     while (true);
		  };
		  function JsonTreeReader(configuration, lexer) {
		    this.b16_1 = lexer;
		    this.c16_1 = configuration.j12_1;
		    this.d16_1 = 0;
		  }
		  protoOf(JsonTreeReader).j16 = function () {
		    var token = this.b16_1.f16();
		    var tmp;
		    if (token === get_TC_STRING()) {
		      tmp = readValue(this, true);
		    } else if (token === get_TC_OTHER()) {
		      tmp = readValue(this, false);
		    } else if (token === get_TC_BEGIN_OBJ()) {
		      var tmp_0;
		      this.d16_1 = this.d16_1 + 1 | 0;
		      if (this.d16_1 === 200) {
		        tmp_0 = readDeepRecursive(this);
		      } else {
		        tmp_0 = readObject(this);
		      }
		      var result = tmp_0;
		      this.d16_1 = this.d16_1 - 1 | 0;
		      tmp = result;
		    } else if (token === get_TC_BEGIN_LIST()) {
		      tmp = readArray(this);
		    } else {
		      this.b16_1.g15('Cannot begin reading element, unexpected token: ' + token);
		    }
		    return tmp;
		  };
		  function classDiscriminator(_this__u8e3s4, json) {
		    var tmp0_iterator = _this__u8e3s4.ih().p();
		    while (tmp0_iterator.q()) {
		      var annotation = tmp0_iterator.s();
		      if (annotation instanceof JsonClassDiscriminator)
		        return annotation.o17_1;
		    }
		    return json.x10_1.q12_1;
		  }
		  function decodeSerializableValuePolymorphic(_this__u8e3s4, deserializer) {
		    var tmp;
		    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
		      tmp = true;
		    } else {
		      tmp = _this__u8e3s4.x12().x10_1.p12_1;
		    }
		    if (tmp) {
		      return deserializer.wf(_this__u8e3s4);
		    }
		    var discriminator = classDiscriminator(deserializer.uf(), _this__u8e3s4.x12());
		    // Inline function 'kotlinx.serialization.json.internal.cast' call
		    var value = _this__u8e3s4.v12();
		    var descriptor = deserializer.uf();
		    if (!(value instanceof JsonObject)) {
		      throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor.sg() + ', but had ' + getKClassFromExpression(value));
		    }
		    var jsonTree = value;
		    var tmp0_safe_receiver = jsonTree.b13(discriminator);
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
		    var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e13();
		    var tmp2_elvis_lhs = deserializer.lg(_this__u8e3s4, type);
		    var tmp_0;
		    if (tmp2_elvis_lhs == null) {
		      throwSerializerNotFound(type, jsonTree);
		    } else {
		      tmp_0 = tmp2_elvis_lhs;
		    }
		    var actualSerializer = tmp_0;
		    var tmp_1 = _this__u8e3s4.x12();
		    return readPolymorphicJson(tmp_1, discriminator, jsonTree, isInterface(actualSerializer, DeserializationStrategy) ? actualSerializer : THROW_CCE());
		  }
		  function throwSerializerNotFound(type, jsonTree) {
		    var suffix = type == null ? "missing class discriminator ('null')" : "class discriminator '" + type + "'";
		    throw JsonDecodingException_0(-1, 'Polymorphic serializer was not found for ' + suffix, jsonTree.toString());
		  }
		  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
		    if (!(serializer instanceof SealedClassSerializer))
		      return Unit_instance;
		    if (jsonCachedSerialNames(actualSerializer.uf()).v(classDiscriminator)) {
		      var baseName = serializer.uf().sg();
		      var actualName = actualSerializer.uf().sg();
		      // Inline function 'kotlin.error' call
		      var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
		      throw IllegalStateException_init_$Create$(toString(message));
		    }
		  }
		  function checkKind(kind) {
		    if (kind instanceof ENUM) {
		      // Inline function 'kotlin.error' call
		      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
		      throw IllegalStateException_init_$Create$(toString(message));
		    }
		    if (kind instanceof PrimitiveKind) {
		      // Inline function 'kotlin.error' call
		      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
		      throw IllegalStateException_init_$Create$(toString(message_0));
		    }
		    if (kind instanceof PolymorphicKind) {
		      // Inline function 'kotlin.error' call
		      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
		      throw IllegalStateException_init_$Create$(toString(message_1));
		    }
		  }
		  function validateIfSealed$accessor$1ad0flx(serializer, actualSerializer, classDiscriminator) {
		    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
		  }
		  function checkKind_0($this, descriptor, actualClass) {
		    var kind = descriptor.lh();
		    var tmp;
		    if (kind instanceof PolymorphicKind) {
		      tmp = true;
		    } else {
		      tmp = equals(kind, CONTEXTUAL_getInstance());
		    }
		    if (tmp) {
		      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.t5() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
		    }
		    if ($this.p17_1)
		      return Unit_instance;
		    var tmp_0;
		    var tmp_1;
		    if (equals(kind, LIST_getInstance()) ? true : equals(kind, MAP_getInstance())) {
		      tmp_1 = true;
		    } else {
		      tmp_1 = kind instanceof PrimitiveKind;
		    }
		    if (tmp_1) {
		      tmp_0 = true;
		    } else {
		      tmp_0 = kind instanceof ENUM;
		    }
		    if (tmp_0) {
		      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.t5() + ' of kind ' + kind + ' cannot be serialized polymorphically with class discriminator.');
		    }
		  }
		  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
		    var inductionVariable = 0;
		    var last = descriptor.jh();
		    if (inductionVariable < last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var name = descriptor.ph(i);
		        if (name === $this.q17_1) {
		          throw IllegalArgumentException_init_$Create$('Polymorphic serializer for ' + actualClass + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
		        }
		      }
		       while (inductionVariable < last);
		  }
		  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
		    this.p17_1 = useArrayPolymorphism;
		    this.q17_1 = discriminator;
		  }
		  protoOf(PolymorphismValidator).f10 = function (kClass, provider) {
		  };
		  protoOf(PolymorphismValidator).i10 = function (baseClass, actualClass, actualSerializer) {
		    var descriptor = actualSerializer.uf();
		    checkKind_0(this, descriptor, actualClass);
		    if (!this.p17_1) {
		      checkDiscriminatorCollisions(this, descriptor, actualClass);
		    }
		  };
		  protoOf(PolymorphismValidator).j10 = function (baseClass, defaultSerializerProvider) {
		  };
		  protoOf(PolymorphismValidator).k10 = function (baseClass, defaultDeserializerProvider) {
		  };
		  function Key() {
		  }
		  function DescriptorSchemaCache() {
		    this.h15_1 = createMapForCache(1);
		  }
		  protoOf(DescriptorSchemaCache).r17 = function (descriptor, key, value) {
		    // Inline function 'kotlin.collections.set' call
		    // Inline function 'kotlin.collections.getOrPut' call
		    var this_0 = this.h15_1;
		    var value_0 = this_0.c2(descriptor);
		    var tmp;
		    if (value_0 == null) {
		      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
		      var answer = createMapForCache(1);
		      this_0.s1(descriptor, answer);
		      tmp = answer;
		    } else {
		      tmp = value_0;
		    }
		    var this_1 = tmp;
		    var key_0 = key instanceof Key ? key : THROW_CCE();
		    var value_1 = !(value == null) ? value : THROW_CCE();
		    this_1.s1(key_0, value_1);
		  };
		  protoOf(DescriptorSchemaCache).i15 = function (descriptor, key, defaultValue) {
		    var tmp0_safe_receiver = this.s17(descriptor, key);
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      return tmp0_safe_receiver;
		    }
		    var value = defaultValue();
		    this.r17(descriptor, key, value);
		    return value;
		  };
		  protoOf(DescriptorSchemaCache).s17 = function (descriptor, key) {
		    var tmp0_safe_receiver = this.h15_1.c2(descriptor);
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      tmp = tmp0_safe_receiver.c2(key instanceof Key ? key : THROW_CCE());
		    }
		    var tmp_0 = tmp;
		    return !(tmp_0 == null) ? tmp_0 : null;
		  };
		  function DiscriminatorHolder(discriminatorToSkip) {
		    this.t17_1 = discriminatorToSkip;
		  }
		  function trySkip(_this__u8e3s4, $this, unknownKey) {
		    if (_this__u8e3s4 == null)
		      return false;
		    if (_this__u8e3s4.t17_1 === unknownKey) {
		      _this__u8e3s4.t17_1 = null;
		      return true;
		    }
		    return false;
		  }
		  function skipLeftoverElements($this, descriptor) {
		    $l$loop: while (true) {
		      var tmp = $this.vj(descriptor);
		      if (!!(tmp === -1)) {
		        break $l$loop;
		      }
		    }
		  }
		  function checkLeadingComma($this) {
		    if ($this.j11_1.f16() === get_TC_COMMA()) {
		      $this.j11_1.g15('Unexpected leading comma');
		    }
		  }
		  function decodeMapIndex($this) {
		    var hasComma = false;
		    var decodingKey = !(($this.l11_1 % 2 | 0) === 0);
		    if (decodingKey) {
		      if (!($this.l11_1 === -1)) {
		        hasComma = $this.j11_1.v17();
		      }
		    } else {
		      $this.j11_1.u17(get_COLON());
		    }
		    var tmp;
		    if ($this.j11_1.g16()) {
		      if (decodingKey) {
		        if ($this.l11_1 === -1) {
		          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
		          var this_0 = $this.j11_1;
		          var condition = !hasComma;
		          var position = this_0.p11_1;
		          if (!condition) {
		            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
		            var tmp$ret$0 = 'Unexpected trailing comma';
		            this_0.g15(tmp$ret$0, position);
		          }
		        } else {
		          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
		          var this_1 = $this.j11_1;
		          var condition_0 = hasComma;
		          var position_0 = this_1.p11_1;
		          if (!condition_0) {
		            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
		            var tmp$ret$1 = 'Expected comma after the key-value pair';
		            this_1.g15(tmp$ret$1, position_0);
		          }
		        }
		      }
		      $this.l11_1 = $this.l11_1 + 1 | 0;
		      tmp = $this.l11_1;
		    } else {
		      if (hasComma) {
		        $this.j11_1.g15("Expected '}', but had ',' instead");
		      }
		      tmp = -1;
		    }
		    return tmp;
		  }
		  function coerceInputValue($this, descriptor, index) {
		    var tmp$ret$1;
		    $l$block_1: {
		      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
		      var this_0 = $this.h11_1;
		      var elementDescriptor = descriptor.nh(index);
		      var tmp;
		      if (!elementDescriptor.eh()) {
		        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
		        tmp = !$this.j11_1.w17();
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$1 = true;
		        break $l$block_1;
		      }
		      if (equals(elementDescriptor.lh(), ENUM_getInstance())) {
		        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
		        var tmp0_elvis_lhs = $this.j11_1.x17($this.n11_1.j12_1);
		        var tmp_0;
		        if (tmp0_elvis_lhs == null) {
		          tmp$ret$1 = false;
		          break $l$block_1;
		        } else {
		          tmp_0 = tmp0_elvis_lhs;
		        }
		        var enumValue = tmp_0;
		        var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
		        if (enumIndex === -3) {
		          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
		          $this.j11_1.h16();
		          tmp$ret$1 = true;
		          break $l$block_1;
		        }
		      }
		      tmp$ret$1 = false;
		    }
		    return tmp$ret$1;
		  }
		  function decodeObjectIndex($this, descriptor) {
		    var hasComma = $this.j11_1.v17();
		    while ($this.j11_1.g16()) {
		      hasComma = false;
		      var key = decodeStringKey($this);
		      $this.j11_1.u17(get_COLON());
		      var index = getJsonNameIndex(descriptor, $this.h11_1, key);
		      var tmp;
		      if (!(index === -3)) {
		        var tmp_0;
		        if ($this.n11_1.o12_1 ? coerceInputValue($this, descriptor, index) : false) {
		          hasComma = $this.j11_1.v17();
		          tmp_0 = false;
		        } else {
		          var tmp0_safe_receiver = $this.o11_1;
		          if (tmp0_safe_receiver == null)
		            null;
		          else {
		            tmp0_safe_receiver.hp(index);
		          }
		          return index;
		        }
		        tmp = tmp_0;
		      } else {
		        tmp = true;
		      }
		      var isUnknown = tmp;
		      if (isUnknown) {
		        hasComma = handleUnknown($this, key);
		      }
		    }
		    if (hasComma) {
		      $this.j11_1.g15('Unexpected trailing comma');
		    }
		    var tmp1_safe_receiver = $this.o11_1;
		    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ip();
		    var tmp_1;
		    if (tmp2_elvis_lhs == null) {
		      tmp_1 = -1;
		    } else {
		      tmp_1 = tmp2_elvis_lhs;
		    }
		    return tmp_1;
		  }
		  function handleUnknown($this, key) {
		    if ($this.n11_1.i12_1 ? true : trySkip($this.m11_1, $this, key)) {
		      $this.j11_1.z17($this.n11_1.j12_1);
		    } else {
		      $this.j11_1.y17(key);
		    }
		    return $this.j11_1.v17();
		  }
		  function decodeListIndex($this) {
		    var hasComma = $this.j11_1.v17();
		    var tmp;
		    if ($this.j11_1.g16()) {
		      if (!($this.l11_1 === -1) ? !hasComma : false) {
		        $this.j11_1.g15('Expected end of the array or comma');
		      }
		      $this.l11_1 = $this.l11_1 + 1 | 0;
		      tmp = $this.l11_1;
		    } else {
		      if (hasComma) {
		        $this.j11_1.g15('Unexpected trailing comma');
		      }
		      tmp = -1;
		    }
		    return tmp;
		  }
		  function decodeStringKey($this) {
		    var tmp;
		    if ($this.n11_1.j12_1) {
		      tmp = $this.j11_1.b18();
		    } else {
		      tmp = $this.j11_1.a18();
		    }
		    return tmp;
		  }
		  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
		    AbstractDecoder.call(this);
		    this.h11_1 = json;
		    this.i11_1 = mode;
		    this.j11_1 = lexer;
		    this.k11_1 = this.h11_1.tj();
		    this.l11_1 = -1;
		    this.m11_1 = discriminatorHolder;
		    this.n11_1 = this.h11_1.x10_1;
		    this.o11_1 = this.n11_1.m12_1 ? null : new JsonElementMarker(descriptor);
		  }
		  protoOf(StreamingJsonDecoder).x12 = function () {
		    return this.h11_1;
		  };
		  protoOf(StreamingJsonDecoder).tj = function () {
		    return this.k11_1;
		  };
		  protoOf(StreamingJsonDecoder).v12 = function () {
		    return (new JsonTreeReader(this.h11_1.x10_1, this.j11_1)).j16();
		  };
		  protoOf(StreamingJsonDecoder).dj = function (deserializer) {
		    try {
		      var tmp;
		      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
		        tmp = true;
		      } else {
		        tmp = this.h11_1.x10_1.p12_1;
		      }
		      if (tmp) {
		        return deserializer.wf(this);
		      }
		      var discriminator = classDiscriminator(deserializer.uf(), this.h11_1);
		      var type = this.j11_1.c18(discriminator, this.n11_1.j12_1);
		      var actualSerializer = null;
		      if (!(type == null)) {
		        actualSerializer = deserializer.lg(this, type);
		      }
		      if (actualSerializer == null) {
		        return decodeSerializableValuePolymorphic(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE());
		      }
		      this.m11_1 = new DiscriminatorHolder(discriminator);
		      var tmp_0 = actualSerializer.wf(this);
		      var result = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
		      return result;
		    } catch ($p) {
		      if ($p instanceof MissingFieldException) {
		        var e = $p;
		        throw new MissingFieldException(e.xg_1, plus(e.message, ' at path: ') + this.j11_1.q11_1.s15(), e);
		      } else {
		        throw $p;
		      }
		    }
		  };
		  protoOf(StreamingJsonDecoder).ej = function (descriptor) {
		    var newMode = switchMode(this.h11_1, descriptor);
		    this.j11_1.q11_1.n15(descriptor);
		    this.j11_1.u17(newMode.f18_1);
		    checkLeadingComma(this);
		    var tmp;
		    switch (newMode.i8_1) {
		      case 1:
		      case 2:
		      case 3:
		        tmp = new StreamingJsonDecoder(this.h11_1, newMode, this.j11_1, descriptor, this.m11_1);
		        break;
		      default:
		        var tmp_0;
		        if (this.i11_1.equals(newMode) ? this.h11_1.x10_1.m12_1 : false) {
		          tmp_0 = this;
		        } else {
		          tmp_0 = new StreamingJsonDecoder(this.h11_1, newMode, this.j11_1, descriptor, this.m11_1);
		        }

		        tmp = tmp_0;
		        break;
		    }
		    return tmp;
		  };
		  protoOf(StreamingJsonDecoder).fj = function (descriptor) {
		    if (this.h11_1.x10_1.i12_1 ? descriptor.jh() === 0 : false) {
		      skipLeftoverElements(this, descriptor);
		    }
		    this.j11_1.u17(this.i11_1.g18_1);
		    this.j11_1.q11_1.r15();
		  };
		  protoOf(StreamingJsonDecoder).pi = function () {
		    var tmp;
		    var tmp0_safe_receiver = this.o11_1;
		    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f15_1;
		    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
		      tmp = this.j11_1.w17();
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(StreamingJsonDecoder).qi = function () {
		    return null;
		  };
		  protoOf(StreamingJsonDecoder).qj = function (descriptor, index, deserializer, previousValue) {
		    var isMapKey = this.i11_1.equals(WriteMode_MAP_getInstance()) ? (index & 1) === 0 : false;
		    if (isMapKey) {
		      this.j11_1.q11_1.q15();
		    }
		    var value = protoOf(AbstractDecoder).qj.call(this, descriptor, index, deserializer, previousValue);
		    if (isMapKey) {
		      this.j11_1.q11_1.p15(value);
		    }
		    return value;
		  };
		  protoOf(StreamingJsonDecoder).vj = function (descriptor) {
		    var index;
		    switch (this.i11_1.i8_1) {
		      case 0:
		        index = decodeObjectIndex(this, descriptor);
		        break;
		      case 2:
		        index = decodeMapIndex(this);
		        break;
		      default:
		        index = decodeListIndex(this);
		        break;
		    }
		    if (!this.i11_1.equals(WriteMode_MAP_getInstance())) {
		      this.j11_1.q11_1.o15(index);
		    }
		    return index;
		  };
		  protoOf(StreamingJsonDecoder).ri = function () {
		    var tmp;
		    if (this.n11_1.j12_1) {
		      tmp = this.j11_1.i18();
		    } else {
		      tmp = this.j11_1.h18();
		    }
		    return tmp;
		  };
		  protoOf(StreamingJsonDecoder).si = function () {
		    var value = this.j11_1.j18();
		    if (!value.equals(toLong_0(value.ca()))) {
		      this.j11_1.g15("Failed to parse byte for input '" + value.toString() + "'");
		    }
		    return value.ca();
		  };
		  protoOf(StreamingJsonDecoder).ti = function () {
		    var value = this.j11_1.j18();
		    if (!value.equals(toLong_0(value.da()))) {
		      this.j11_1.g15("Failed to parse short for input '" + value.toString() + "'");
		    }
		    return value.da();
		  };
		  protoOf(StreamingJsonDecoder).ui = function () {
		    var value = this.j11_1.j18();
		    if (!value.equals(toLong_0(value.ea()))) {
		      this.j11_1.g15("Failed to parse int for input '" + value.toString() + "'");
		    }
		    return value.ea();
		  };
		  protoOf(StreamingJsonDecoder).vi = function () {
		    return this.j11_1.j18();
		  };
		  protoOf(StreamingJsonDecoder).wi = function () {
		    var tmp$ret$4;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.parseString' call
		      var this_0 = this.j11_1;
		      var input = this_0.i16();
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
		        // Inline function 'kotlin.text.toFloat' call
		        // Inline function 'kotlin.js.unsafeCast' call
		        // Inline function 'kotlin.js.asDynamic' call
		        tmp$ret$4 = toDouble(input);
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          this_0.g15("Failed to parse type '" + 'float' + "' for input '" + input + "'");
		        } else {
		          throw $p;
		        }
		      }
		    }
		    var result = tmp$ret$4;
		    var specialFp = this.h11_1.x10_1.r12_1;
		    if (specialFp ? true : isFinite(result))
		      return result;
		    throwInvalidFloatingPointDecoded(this.j11_1, result);
		  };
		  protoOf(StreamingJsonDecoder).xi = function () {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.parseString' call
		      var this_0 = this.j11_1;
		      var input = this_0.i16();
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
		        tmp$ret$1 = toDouble(input);
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          this_0.g15("Failed to parse type '" + 'double' + "' for input '" + input + "'");
		        } else {
		          throw $p;
		        }
		      }
		    }
		    var result = tmp$ret$1;
		    var specialFp = this.h11_1.x10_1.r12_1;
		    if (specialFp ? true : isFinite_0(result))
		      return result;
		    throwInvalidFloatingPointDecoded(this.j11_1, result);
		  };
		  protoOf(StreamingJsonDecoder).yi = function () {
		    var string = this.j11_1.i16();
		    if (!(string.length === 1)) {
		      this.j11_1.g15("Expected single char, but got '" + string + "'");
		    }
		    return charSequenceGet(string, 0);
		  };
		  protoOf(StreamingJsonDecoder).zi = function () {
		    var tmp;
		    if (this.n11_1.j12_1) {
		      tmp = this.j11_1.b18();
		    } else {
		      tmp = this.j11_1.h16();
		    }
		    return tmp;
		  };
		  protoOf(StreamingJsonDecoder).bj = function (descriptor) {
		    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.j11_1, this.h11_1) : protoOf(AbstractDecoder).bj.call(this, descriptor);
		  };
		  protoOf(StreamingJsonDecoder).aj = function (enumDescriptor) {
		    return getJsonNameIndexOrThrow(enumDescriptor, this.h11_1, this.zi(), ' at path ' + this.j11_1.q11_1.s15());
		  };
		  function JsonDecoderForUnsignedTypes(lexer, json) {
		    AbstractDecoder.call(this);
		    this.k18_1 = lexer;
		    this.l18_1 = json.tj();
		  }
		  protoOf(JsonDecoderForUnsignedTypes).tj = function () {
		    return this.l18_1;
		  };
		  protoOf(JsonDecoderForUnsignedTypes).vj = function (descriptor) {
		    var message = 'unsupported';
		    throw IllegalStateException_init_$Create$(toString(message));
		  };
		  protoOf(JsonDecoderForUnsignedTypes).ui = function () {
		    var tmp$ret$2;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.parseString' call
		      var this_0 = this.k18_1;
		      var input = this_0.i16();
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
		        // Inline function 'kotlin.UInt.toInt' call
		        var this_1 = toUInt(input);
		        tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_1);
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          this_0.g15("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$2;
		  };
		  protoOf(JsonDecoderForUnsignedTypes).vi = function () {
		    var tmp$ret$2;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.parseString' call
		      var this_0 = this.k18_1;
		      var input = this_0.i16();
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
		        // Inline function 'kotlin.ULong.toLong' call
		        var this_1 = toULong(input);
		        tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_1);
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          this_0.g15("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$2;
		  };
		  protoOf(JsonDecoderForUnsignedTypes).si = function () {
		    var tmp$ret$2;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.parseString' call
		      var this_0 = this.k18_1;
		      var input = this_0.i16();
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
		        // Inline function 'kotlin.UByte.toByte' call
		        var this_1 = toUByte(input);
		        tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_1);
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          this_0.g15("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$2;
		  };
		  protoOf(JsonDecoderForUnsignedTypes).ti = function () {
		    var tmp$ret$2;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.parseString' call
		      var this_0 = this.k18_1;
		      var input = this_0.i16();
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
		        // Inline function 'kotlin.UShort.toShort' call
		        var this_1 = toUShort(input);
		        tmp$ret$2 = _UShort___get_data__impl__g0245(this_1);
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          this_0.g15("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$2;
		  };
		  function get_unsignedNumberDescriptors() {
		    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
		    return unsignedNumberDescriptors;
		  }
		  var unsignedNumberDescriptors;
		  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
		    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
		    return $this;
		  }
		  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
		    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
		  }
		  function encodeTypeInfo($this, descriptor) {
		    $this.t15_1.h14();
		    $this.ik(ensureNotNull($this.a16_1));
		    $this.t15_1.j14(get_COLON());
		    $this.t15_1.i14();
		    $this.ik(descriptor.sg());
		  }
		  function composerForUnsignedNumbers($this) {
		    var tmp;
		    var tmp_0 = $this.t15_1;
		    if (tmp_0 instanceof ComposerForUnsignedNumbers) {
		      tmp = $this.t15_1;
		    } else {
		      tmp = new ComposerForUnsignedNumbers($this.t15_1.d14_1, $this.z15_1);
		    }
		    return tmp;
		  }
		  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
		    AbstractEncoder.call(this);
		    this.t15_1 = composer;
		    this.u15_1 = json;
		    this.v15_1 = mode;
		    this.w15_1 = modeReuseCache;
		    this.x15_1 = this.u15_1.tj();
		    this.y15_1 = this.u15_1.x10_1;
		    this.z15_1 = false;
		    this.a16_1 = null;
		    var i = this.v15_1.i8_1;
		    if (!(this.w15_1 == null)) {
		      if (!(this.w15_1[i] === null) ? true : !(this.w15_1[i] === this)) {
		        this.w15_1[i] = this;
		      }
		    }
		  }
		  protoOf(StreamingJsonEncoder).x12 = function () {
		    return this.u15_1;
		  };
		  protoOf(StreamingJsonEncoder).tj = function () {
		    return this.x15_1;
		  };
		  protoOf(StreamingJsonEncoder).bl = function (descriptor, index) {
		    return this.y15_1.h12_1;
		  };
		  protoOf(StreamingJsonEncoder).wk = function (serializer, value) {
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
		      var tmp;
		      if (!(serializer instanceof AbstractPolymorphicSerializer)) {
		        tmp = true;
		      } else {
		        tmp = this.x12().x10_1.p12_1;
		      }
		      if (tmp) {
		        serializer.vf(this, value);
		        break $l$block;
		      }
		      var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
		      var baseClassDiscriminator = classDiscriminator(serializer.uf(), this.x12());
		      var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
		      validateIfSealed$accessor$1ad0flx(casted, actualSerializer, baseClassDiscriminator);
		      checkKind(actualSerializer.uf().lh());
		      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
		      this.a16_1 = baseClassDiscriminator;
		      actualSerializer.vf(this, value);
		    }
		  };
		  protoOf(StreamingJsonEncoder).ej = function (descriptor) {
		    var newMode = switchMode(this.u15_1, descriptor);
		    if (!(newMode.f18_1 === get_INVALID())) {
		      this.t15_1.j14(newMode.f18_1);
		      this.t15_1.f14();
		    }
		    if (!(this.a16_1 == null)) {
		      encodeTypeInfo(this, descriptor);
		      this.a16_1 = null;
		    }
		    if (this.v15_1.equals(newMode)) {
		      return this;
		    }
		    var tmp0_safe_receiver = this.w15_1;
		    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode.i8_1];
		    return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this.t15_1, this.u15_1, newMode, this.w15_1) : tmp1_elvis_lhs;
		  };
		  protoOf(StreamingJsonEncoder).fj = function (descriptor) {
		    if (!(this.v15_1.g18_1 === get_INVALID())) {
		      this.t15_1.g14();
		      this.t15_1.h14();
		      this.t15_1.j14(this.v15_1.g18_1);
		    }
		  };
		  protoOf(StreamingJsonEncoder).xj = function (descriptor, index) {
		    switch (this.v15_1.i8_1) {
		      case 1:
		        if (!this.t15_1.e14_1) {
		          this.t15_1.j14(get_COMMA());
		        }

		        this.t15_1.h14();
		        break;
		      case 2:
		        if (!this.t15_1.e14_1) {
		          var tmp = this;
		          var tmp_0;
		          if ((index % 2 | 0) === 0) {
		            this.t15_1.j14(get_COMMA());
		            this.t15_1.h14();
		            tmp_0 = true;
		          } else {
		            this.t15_1.j14(get_COLON());
		            this.t15_1.i14();
		            tmp_0 = false;
		          }
		          tmp.z15_1 = tmp_0;
		        } else {
		          this.z15_1 = true;
		          this.t15_1.h14();
		        }

		        break;
		      case 3:
		        if (index === 0)
		          this.z15_1 = true;
		        if (index === 1) {
		          this.t15_1.j14(get_COMMA());
		          this.t15_1.i14();
		          this.z15_1 = false;
		        }

		        break;
		      default:
		        if (!this.t15_1.e14_1) {
		          this.t15_1.j14(get_COMMA());
		        }

		        this.t15_1.h14();
		        this.ik(descriptor.ph(index));
		        this.t15_1.j14(get_COLON());
		        this.t15_1.i14();
		        break;
		    }
		    return true;
		  };
		  protoOf(StreamingJsonEncoder).xk = function (descriptor, index, serializer, value) {
		    if (!(value == null) ? true : this.y15_1.m12_1) {
		      protoOf(AbstractEncoder).xk.call(this, descriptor, index, serializer, value);
		    }
		  };
		  protoOf(StreamingJsonEncoder).kk = function (descriptor) {
		    return get_isUnsignedNumber(descriptor) ? new StreamingJsonEncoder(composerForUnsignedNumbers(this), this.u15_1, this.v15_1, null) : protoOf(AbstractEncoder).kk.call(this, descriptor);
		  };
		  protoOf(StreamingJsonEncoder).zj = function () {
		    this.t15_1.l14(get_NULL());
		  };
		  protoOf(StreamingJsonEncoder).ak = function (value) {
		    if (this.z15_1) {
		      this.ik(value.toString());
		    } else {
		      this.t15_1.u14(value);
		    }
		  };
		  protoOf(StreamingJsonEncoder).bk = function (value) {
		    if (this.z15_1) {
		      this.ik(value.toString());
		    } else {
		      this.t15_1.p14(value);
		    }
		  };
		  protoOf(StreamingJsonEncoder).ck = function (value) {
		    if (this.z15_1) {
		      this.ik(value.toString());
		    } else {
		      this.t15_1.r14(value);
		    }
		  };
		  protoOf(StreamingJsonEncoder).dk = function (value) {
		    if (this.z15_1) {
		      this.ik(value.toString());
		    } else {
		      this.t15_1.s14(value);
		    }
		  };
		  protoOf(StreamingJsonEncoder).ek = function (value) {
		    if (this.z15_1) {
		      this.ik(value.toString());
		    } else {
		      this.t15_1.t14(value);
		    }
		  };
		  protoOf(StreamingJsonEncoder).fk = function (value) {
		    if (this.z15_1) {
		      this.ik(value.toString());
		    } else {
		      this.t15_1.n14(value);
		    }
		    if (!this.y15_1.r12_1 ? !isFinite(value) : false) {
		      throw InvalidFloatingPointEncoded_0(value, toString(this.t15_1.d14_1));
		    }
		  };
		  protoOf(StreamingJsonEncoder).gk = function (value) {
		    if (this.z15_1) {
		      this.ik(value.toString());
		    } else {
		      this.t15_1.o14(value);
		    }
		    if (!this.y15_1.r12_1 ? !isFinite_0(value) : false) {
		      throw InvalidFloatingPointEncoded_0(value, toString(this.t15_1.d14_1));
		    }
		  };
		  protoOf(StreamingJsonEncoder).hk = function (value) {
		    this.ik(toString_0(value));
		  };
		  protoOf(StreamingJsonEncoder).ik = function (value) {
		    return this.t15_1.v14(value);
		  };
		  protoOf(StreamingJsonEncoder).jk = function (enumDescriptor, index) {
		    this.ik(enumDescriptor.ph(index));
		  };
		  function get_isUnsignedNumber(_this__u8e3s4) {
		    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
		    return _this__u8e3s4.kh() ? get_unsignedNumberDescriptors().v(_this__u8e3s4) : false;
		  }
		  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
		  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
		    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
		      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
		      unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).uf(), serializer_0(Companion_getInstance()).uf(), serializer_2(Companion_getInstance_1()).uf(), serializer_3(Companion_getInstance_2()).uf()]);
		    }
		  }
		  function get_ESCAPE_STRINGS() {
		    _init_properties_StringOps_kt__fcy1db();
		    return ESCAPE_STRINGS;
		  }
		  var ESCAPE_STRINGS;
		  var ESCAPE_MARKERS;
		  function toHexChar(i) {
		    _init_properties_StringOps_kt__fcy1db();
		    var d = i & 15;
		    var tmp;
		    if (d < 10) {
		      // Inline function 'kotlin.code' call
		      var this_0 = _Char___init__impl__6a9atx(48);
		      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
		      tmp = numberToChar(d + tmp$ret$0 | 0);
		    } else {
		      var tmp_0 = d - 10 | 0;
		      // Inline function 'kotlin.code' call
		      var this_1 = _Char___init__impl__6a9atx(97);
		      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
		      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
		    }
		    return tmp;
		  }
		  function printQuoted(_this__u8e3s4, value) {
		    _init_properties_StringOps_kt__fcy1db();
		    _this__u8e3s4.b5(get_STRING());
		    var lastPos = 0;
		    var inductionVariable = 0;
		    var last = charSequenceLength(value) - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.code' call
		        var this_0 = charSequenceGet(value, i);
		        var c = Char__toInt_impl_vasixd(this_0);
		        if (c < get_ESCAPE_STRINGS().length ? !(get_ESCAPE_STRINGS()[c] == null) : false) {
		          _this__u8e3s4.d7(value, lastPos, i);
		          _this__u8e3s4.a5(get_ESCAPE_STRINGS()[c]);
		          lastPos = i + 1 | 0;
		        }
		      }
		       while (inductionVariable <= last);
		    if (!(lastPos === 0)) {
		      _this__u8e3s4.d7(value, lastPos, value.length);
		    } else {
		      _this__u8e3s4.a5(value);
		    }
		    _this__u8e3s4.b5(get_STRING());
		  }
		  function toBooleanStrictOrNull(_this__u8e3s4) {
		    _init_properties_StringOps_kt__fcy1db();
		    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
		  }
		  var properties_initialized_StringOps_kt_wzaea7;
		  function _init_properties_StringOps_kt__fcy1db() {
		    if (!properties_initialized_StringOps_kt_wzaea7) {
		      properties_initialized_StringOps_kt_wzaea7 = true;
		      // Inline function 'kotlin.apply' call
		      // Inline function 'kotlin.arrayOfNulls' call
		      var this_0 = fillArrayVal(Array(93), null);
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
		      var inductionVariable = 0;
		      if (inductionVariable <= 31)
		        do {
		          var c = inductionVariable;
		          inductionVariable = inductionVariable + 1 | 0;
		          var c1 = toHexChar(c >> 12);
		          var c2 = toHexChar(c >> 8);
		          var c3 = toHexChar(c >> 4);
		          var c4 = toHexChar(c);
		          this_0[c] = '\\u' + toString_0(c1) + toString_0(c2) + toString_0(c3) + toString_0(c4);
		        }
		         while (inductionVariable <= 31);
		      // Inline function 'kotlin.code' call
		      var this_1 = _Char___init__impl__6a9atx(34);
		      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
		      // Inline function 'kotlin.code' call
		      var this_2 = _Char___init__impl__6a9atx(92);
		      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
		      // Inline function 'kotlin.code' call
		      var this_3 = _Char___init__impl__6a9atx(9);
		      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
		      // Inline function 'kotlin.code' call
		      var this_4 = _Char___init__impl__6a9atx(8);
		      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
		      // Inline function 'kotlin.code' call
		      var this_5 = _Char___init__impl__6a9atx(10);
		      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
		      // Inline function 'kotlin.code' call
		      var this_6 = _Char___init__impl__6a9atx(13);
		      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
		      this_0[12] = '\\f';
		      ESCAPE_STRINGS = this_0;
		      // Inline function 'kotlin.apply' call
		      var this_7 = new Int8Array(93);
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
		      var inductionVariable_0 = 0;
		      if (inductionVariable_0 <= 31)
		        do {
		          var c_0 = inductionVariable_0;
		          inductionVariable_0 = inductionVariable_0 + 1 | 0;
		          this_7[c_0] = 1;
		        }
		         while (inductionVariable_0 <= 31);
		      // Inline function 'kotlin.code' call
		      var this_8 = _Char___init__impl__6a9atx(34);
		      this_7[Char__toInt_impl_vasixd(this_8)] = 34;
		      // Inline function 'kotlin.code' call
		      var this_9 = _Char___init__impl__6a9atx(92);
		      this_7[Char__toInt_impl_vasixd(this_9)] = 92;
		      // Inline function 'kotlin.code' call
		      var this_10 = _Char___init__impl__6a9atx(9);
		      this_7[Char__toInt_impl_vasixd(this_10)] = 116;
		      // Inline function 'kotlin.code' call
		      var this_11 = _Char___init__impl__6a9atx(8);
		      this_7[Char__toInt_impl_vasixd(this_11)] = 98;
		      // Inline function 'kotlin.code' call
		      var this_12 = _Char___init__impl__6a9atx(10);
		      this_7[Char__toInt_impl_vasixd(this_12)] = 110;
		      // Inline function 'kotlin.code' call
		      var this_13 = _Char___init__impl__6a9atx(13);
		      this_7[Char__toInt_impl_vasixd(this_13)] = 114;
		      this_7[12] = 102;
		      ESCAPE_MARKERS = this_7;
		    }
		  }
		  function readJson(_this__u8e3s4, element, deserializer) {
		    var tmp;
		    if (element instanceof JsonObject) {
		      tmp = new JsonTreeDecoder(_this__u8e3s4, element);
		    } else {
		      if (element instanceof JsonArray) {
		        tmp = new JsonTreeListDecoder(_this__u8e3s4, element);
		      } else {
		        var tmp_0;
		        if (element instanceof JsonLiteral) {
		          tmp_0 = true;
		        } else {
		          tmp_0 = equals(element, JsonNull_getInstance());
		        }
		        if (tmp_0) {
		          tmp = new JsonPrimitiveDecoder(_this__u8e3s4, element instanceof JsonPrimitive ? element : THROW_CCE());
		        } else {
		          noWhenBranchMatchedException();
		        }
		      }
		    }
		    var input = tmp;
		    return input.dj(deserializer);
		  }
		  function currentObject($this) {
		    var tmp0_safe_receiver = $this.dx();
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
		      tmp = $this.r18(tmp0_safe_receiver);
		    }
		    var tmp1_elvis_lhs = tmp;
		    return tmp1_elvis_lhs == null ? $this.w1() : tmp1_elvis_lhs;
		  }
		  function unparsedPrimitive($this, primitive) {
		    throw JsonDecodingException_0(-1, "Failed to parse '" + primitive + "'", toString(currentObject($this)));
		  }
		  function asLiteral(_this__u8e3s4, $this, type) {
		    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonLiteral ? _this__u8e3s4 : null;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      throw JsonDecodingException_1(-1, "Unexpected 'null' when " + type + ' was expected');
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  }
		  function AbstractJsonTreeDecoder(json, value) {
		    NamedValueDecoder.call(this);
		    this.o18_1 = json;
		    this.p18_1 = value;
		    this.q18_1 = this.x12().x10_1;
		  }
		  protoOf(AbstractJsonTreeDecoder).x12 = function () {
		    return this.o18_1;
		  };
		  protoOf(AbstractJsonTreeDecoder).w1 = function () {
		    return this.p18_1;
		  };
		  protoOf(AbstractJsonTreeDecoder).tj = function () {
		    return this.x12().tj();
		  };
		  protoOf(AbstractJsonTreeDecoder).v12 = function () {
		    return currentObject(this);
		  };
		  protoOf(AbstractJsonTreeDecoder).dj = function (deserializer) {
		    return decodeSerializableValuePolymorphic(this, deserializer);
		  };
		  protoOf(AbstractJsonTreeDecoder).ex = function (parentName, childName) {
		    return childName;
		  };
		  protoOf(AbstractJsonTreeDecoder).ej = function (descriptor) {
		    var currentObject_0 = currentObject(this);
		    var tmp0_subject = descriptor.lh();
		    var tmp;
		    var tmp_0;
		    if (equals(tmp0_subject, LIST_getInstance())) {
		      tmp_0 = true;
		    } else {
		      tmp_0 = tmp0_subject instanceof PolymorphicKind;
		    }
		    if (tmp_0) {
		      var tmp_1 = this.x12();
		      // Inline function 'kotlinx.serialization.json.internal.cast' call
		      if (!(currentObject_0 instanceof JsonArray)) {
		        throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonArray) + ' as the serialized body of ' + descriptor.sg() + ', but had ' + getKClassFromExpression(currentObject_0));
		      }
		      tmp = new JsonTreeListDecoder(tmp_1, currentObject_0);
		    } else {
		      if (equals(tmp0_subject, MAP_getInstance())) {
		        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
		        var this_0 = this.x12();
		        var keyDescriptor = carrierDescriptor(descriptor.nh(0), this_0.tj());
		        var keyKind = keyDescriptor.lh();
		        var tmp_2;
		        var tmp_3;
		        if (keyKind instanceof PrimitiveKind) {
		          tmp_3 = true;
		        } else {
		          tmp_3 = equals(keyKind, ENUM_getInstance());
		        }
		        if (tmp_3) {
		          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
		          var tmp_4 = this.x12();
		          // Inline function 'kotlinx.serialization.json.internal.cast' call
		          if (!(currentObject_0 instanceof JsonObject)) {
		            throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor.sg() + ', but had ' + getKClassFromExpression(currentObject_0));
		          }
		          tmp_2 = new JsonTreeMapDecoder(tmp_4, currentObject_0);
		        } else {
		          if (this_0.x10_1.k12_1) {
		            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
		            var tmp_5 = this.x12();
		            // Inline function 'kotlinx.serialization.json.internal.cast' call
		            if (!(currentObject_0 instanceof JsonArray)) {
		              throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonArray) + ' as the serialized body of ' + descriptor.sg() + ', but had ' + getKClassFromExpression(currentObject_0));
		            }
		            tmp_2 = new JsonTreeListDecoder(tmp_5, currentObject_0);
		          } else {
		            throw InvalidKeyKindException(keyDescriptor);
		          }
		        }
		        tmp = tmp_2;
		      } else {
		        var tmp_6 = this.x12();
		        // Inline function 'kotlinx.serialization.json.internal.cast' call
		        if (!(currentObject_0 instanceof JsonObject)) {
		          throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor.sg() + ', but had ' + getKClassFromExpression(currentObject_0));
		        }
		        tmp = new JsonTreeDecoder(tmp_6, currentObject_0);
		      }
		    }
		    return tmp;
		  };
		  protoOf(AbstractJsonTreeDecoder).fj = function (descriptor) {
		  };
		  protoOf(AbstractJsonTreeDecoder).pi = function () {
		    var tmp = currentObject(this);
		    return !(tmp instanceof JsonNull);
		  };
		  protoOf(AbstractJsonTreeDecoder).s18 = function (tag) {
		    var currentElement = this.r18(tag);
		    var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      throw JsonDecodingException_0(-1, 'Expected JsonPrimitive at ' + tag + ', found ' + currentElement, toString(currentObject(this)));
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    return tmp;
		  };
		  protoOf(AbstractJsonTreeDecoder).t18 = function (tag, enumDescriptor) {
		    return getJsonNameIndexOrThrow(enumDescriptor, this.x12(), this.s18(tag).e13());
		  };
		  protoOf(AbstractJsonTreeDecoder).my = function (tag, enumDescriptor) {
		    return this.t18((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
		  };
		  protoOf(AbstractJsonTreeDecoder).u18 = function (tag) {
		    return !(this.r18(tag) === JsonNull_getInstance());
		  };
		  protoOf(AbstractJsonTreeDecoder).cy = function (tag) {
		    return this.u18((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).v18 = function (tag) {
		    var value = this.s18(tag);
		    if (!this.x12().x10_1.j12_1) {
		      var literal = asLiteral(value, this, 'boolean');
		      if (literal.f13_1)
		        throw JsonDecodingException_0(-1, "Boolean literal for key '" + tag + "' should be unquoted.\n" + get_lenientHint(), toString(currentObject(this)));
		    }
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedBoolean.<anonymous>' call
		        var tmp0_elvis_lhs = get_booleanOrNull(value);
		        var tmp;
		        if (tmp0_elvis_lhs == null) {
		          throw IllegalArgumentException_init_$Create$_0();
		        } else {
		          tmp = tmp0_elvis_lhs;
		        }
		        var tmp0_elvis_lhs_0 = tmp;
		        var tmp_0;
		        if (tmp0_elvis_lhs_0 == null) {
		          unparsedPrimitive(this, 'boolean');
		        } else {
		          tmp_0 = tmp0_elvis_lhs_0;
		        }
		        tmp$ret$1 = tmp_0;
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          unparsedPrimitive(this, 'boolean');
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$1;
		  };
		  protoOf(AbstractJsonTreeDecoder).dy = function (tag) {
		    return this.v18((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).w18 = function (tag) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
		      var this_0 = this.s18(tag);
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
		        var result = get_int(this_0);
		        var tmp;
		        var containsLower = ByteCompanionObject_instance.MIN_VALUE;
		        if (result <= ByteCompanionObject_instance.MAX_VALUE ? containsLower <= result : false) {
		          tmp = toByte(result);
		        } else {
		          tmp = null;
		        }
		        var tmp0_elvis_lhs = tmp;
		        var tmp_0;
		        if (tmp0_elvis_lhs == null) {
		          unparsedPrimitive(this, 'byte');
		        } else {
		          tmp_0 = tmp0_elvis_lhs;
		        }
		        tmp$ret$1 = tmp_0;
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          unparsedPrimitive(this, 'byte');
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$1;
		  };
		  protoOf(AbstractJsonTreeDecoder).ey = function (tag) {
		    return this.w18((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).x18 = function (tag) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
		      var this_0 = this.s18(tag);
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
		        var result = get_int(this_0);
		        var tmp;
		        var containsLower = ShortCompanionObject_instance.MIN_VALUE;
		        if (result <= ShortCompanionObject_instance.MAX_VALUE ? containsLower <= result : false) {
		          tmp = toShort(result);
		        } else {
		          tmp = null;
		        }
		        var tmp0_elvis_lhs = tmp;
		        var tmp_0;
		        if (tmp0_elvis_lhs == null) {
		          unparsedPrimitive(this, 'short');
		        } else {
		          tmp_0 = tmp0_elvis_lhs;
		        }
		        tmp$ret$1 = tmp_0;
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          unparsedPrimitive(this, 'short');
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$1;
		  };
		  protoOf(AbstractJsonTreeDecoder).fy = function (tag) {
		    return this.x18((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).y18 = function (tag) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
		      var this_0 = this.s18(tag);
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
		        var tmp0_elvis_lhs = get_int(this_0);
		        var tmp;
		        if (tmp0_elvis_lhs == null) {
		          unparsedPrimitive(this, 'int');
		        } else {
		          tmp = tmp0_elvis_lhs;
		        }
		        tmp$ret$1 = tmp;
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          unparsedPrimitive(this, 'int');
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$1;
		  };
		  protoOf(AbstractJsonTreeDecoder).gy = function (tag) {
		    return this.y18((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).z18 = function (tag) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
		      var this_0 = this.s18(tag);
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
		        var tmp0_elvis_lhs = get_long(this_0);
		        var tmp;
		        if (tmp0_elvis_lhs == null) {
		          unparsedPrimitive(this, 'long');
		        } else {
		          tmp = tmp0_elvis_lhs;
		        }
		        tmp$ret$1 = tmp;
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          unparsedPrimitive(this, 'long');
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$1;
		  };
		  protoOf(AbstractJsonTreeDecoder).hy = function (tag) {
		    return this.z18((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).a19 = function (tag) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
		      var this_0 = this.s18(tag);
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
		        var tmp0_elvis_lhs = get_float(this_0);
		        var tmp;
		        if (tmp0_elvis_lhs == null) {
		          unparsedPrimitive(this, 'float');
		        } else {
		          tmp = tmp0_elvis_lhs;
		        }
		        tmp$ret$1 = tmp;
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          unparsedPrimitive(this, 'float');
		        } else {
		          throw $p;
		        }
		      }
		    }
		    var result = tmp$ret$1;
		    var specialFp = this.x12().x10_1.r12_1;
		    if (specialFp ? true : isFinite(result))
		      return result;
		    throw InvalidFloatingPointDecoded(result, tag, toString(currentObject(this)));
		  };
		  protoOf(AbstractJsonTreeDecoder).iy = function (tag) {
		    return this.a19((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).b19 = function (tag) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
		      var this_0 = this.s18(tag);
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
		        var tmp0_elvis_lhs = get_double(this_0);
		        var tmp;
		        if (tmp0_elvis_lhs == null) {
		          unparsedPrimitive(this, 'double');
		        } else {
		          tmp = tmp0_elvis_lhs;
		        }
		        tmp$ret$1 = tmp;
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          unparsedPrimitive(this, 'double');
		        } else {
		          throw $p;
		        }
		      }
		    }
		    var result = tmp$ret$1;
		    var specialFp = this.x12().x10_1.r12_1;
		    if (specialFp ? true : isFinite_0(result))
		      return result;
		    throw InvalidFloatingPointDecoded(result, tag, toString(currentObject(this)));
		  };
		  protoOf(AbstractJsonTreeDecoder).jy = function (tag) {
		    return this.b19((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).c19 = function (tag) {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
		      var this_0 = this.s18(tag);
		      try {
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
		        var tmp0_elvis_lhs = single(this_0.e13());
		        var tmp;
		        var tmp_0 = tmp0_elvis_lhs;
		        if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
		          unparsedPrimitive(this, 'char');
		        } else {
		          tmp = tmp0_elvis_lhs;
		        }
		        tmp$ret$1 = tmp;
		        break $l$block;
		      } catch ($p) {
		        if ($p instanceof IllegalArgumentException) {
		          var e = $p;
		          unparsedPrimitive(this, 'char');
		        } else {
		          throw $p;
		        }
		      }
		    }
		    return tmp$ret$1;
		  };
		  protoOf(AbstractJsonTreeDecoder).ky = function (tag) {
		    return this.c19((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).d19 = function (tag) {
		    var value = this.s18(tag);
		    if (!this.x12().x10_1.j12_1) {
		      var literal = asLiteral(value, this, 'string');
		      if (!literal.f13_1)
		        throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted.\n" + get_lenientHint(), toString(currentObject(this)));
		    }
		    if (value instanceof JsonNull)
		      throw JsonDecodingException_0(-1, "Unexpected 'null' value instead of string literal", toString(currentObject(this)));
		    return value.e13();
		  };
		  protoOf(AbstractJsonTreeDecoder).ly = function (tag) {
		    return this.d19((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeDecoder).e19 = function (tag, inlineDescriptor) {
		    return get_isUnsignedNumber(inlineDescriptor) ? new JsonDecoderForUnsignedTypes(new StringJsonLexer(this.s18(tag).e13()), this.x12()) : protoOf(NamedValueDecoder).ny.call(this, tag, inlineDescriptor);
		  };
		  protoOf(AbstractJsonTreeDecoder).ny = function (tag, inlineDescriptor) {
		    return this.e19((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
		  };
		  function coerceInputValue_0($this, descriptor, index, tag) {
		    var tmp$ret$1;
		    $l$block_1: {
		      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
		      var this_0 = $this.x12();
		      var elementDescriptor = descriptor.nh(index);
		      var tmp;
		      if (!elementDescriptor.eh()) {
		        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
		        var tmp_0 = $this.r18(tag);
		        tmp = tmp_0 instanceof JsonNull;
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        tmp$ret$1 = true;
		        break $l$block_1;
		      }
		      if (equals(elementDescriptor.lh(), ENUM_getInstance())) {
		        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
		        var tmp_1 = $this.r18(tag);
		        var tmp0_safe_receiver = tmp_1 instanceof JsonPrimitive ? tmp_1 : null;
		        var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
		        var tmp_2;
		        if (tmp0_elvis_lhs == null) {
		          tmp$ret$1 = false;
		          break $l$block_1;
		        } else {
		          tmp_2 = tmp0_elvis_lhs;
		        }
		        var enumValue = tmp_2;
		        var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
		        if (enumIndex === -3) {
		          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
		          tmp$ret$1 = true;
		          break $l$block_1;
		        }
		      }
		      tmp$ret$1 = false;
		    }
		    return tmp$ret$1;
		  }
		  function absenceIsNull($this, descriptor, index) {
		    $this.o19_1 = (!$this.x12().x10_1.m12_1 ? !descriptor.qh(index) : false) ? descriptor.nh(index).eh() : false;
		    return $this.o19_1;
		  }
		  function buildAlternativeNamesMap$ref_0($boundThis) {
		    var l = function () {
		      return buildAlternativeNamesMap($boundThis);
		    };
		    l.callableName = 'buildAlternativeNamesMap';
		    return l;
		  }
		  function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
		    polyDiscriminator = polyDiscriminator === VOID ? null : polyDiscriminator;
		    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
		    AbstractJsonTreeDecoder.call(this, json, value);
		    this.k19_1 = value;
		    this.l19_1 = polyDiscriminator;
		    this.m19_1 = polyDescriptor;
		    this.n19_1 = 0;
		    this.o19_1 = false;
		  }
		  protoOf(JsonTreeDecoder).w1 = function () {
		    return this.k19_1;
		  };
		  protoOf(JsonTreeDecoder).vj = function (descriptor) {
		    while (this.n19_1 < descriptor.jh()) {
		      var tmp1 = this.n19_1;
		      this.n19_1 = tmp1 + 1 | 0;
		      var name = this.zw(descriptor, tmp1);
		      var index = this.n19_1 - 1 | 0;
		      this.o19_1 = false;
		      var tmp;
		      var tmp_0;
		      // Inline function 'kotlin.collections.contains' call
		      // Inline function 'kotlin.collections.containsKey' call
		      var this_0 = this.w1();
		      if ((isInterface(this_0, Map) ? this_0 : THROW_CCE()).z1(name)) {
		        tmp_0 = true;
		      } else {
		        tmp_0 = absenceIsNull(this, descriptor, index);
		      }
		      if (tmp_0) {
		        tmp = !this.q18_1.o12_1 ? true : !coerceInputValue_0(this, descriptor, index, name);
		      } else {
		        tmp = false;
		      }
		      if (tmp) {
		        return index;
		      }
		    }
		    return -1;
		  };
		  protoOf(JsonTreeDecoder).pi = function () {
		    return !this.o19_1 ? protoOf(AbstractJsonTreeDecoder).pi.call(this) : false;
		  };
		  protoOf(JsonTreeDecoder).ax = function (desc, index) {
		    var mainName = desc.ph(index);
		    if (!this.q18_1.s12_1)
		      return mainName;
		    if (this.w1().q1().v(mainName))
		      return mainName;
		    var tmp = get_schemaCache(this.x12());
		    var tmp_0 = get_JsonAlternativeNamesKey();
		    var alternativeNamesMap = tmp.i15(desc, tmp_0, buildAlternativeNamesMap$ref_0(desc));
		    // Inline function 'kotlin.collections.find' call
		    var this_0 = this.w1().q1();
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlin.collections.firstOrNull' call
		      var tmp0_iterator = this_0.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
		        if (alternativeNamesMap.c2(element) === index) {
		          tmp$ret$1 = element;
		          break $l$block;
		        }
		      }
		      tmp$ret$1 = null;
		    }
		    var nameInObject = tmp$ret$1;
		    return nameInObject == null ? mainName : nameInObject;
		  };
		  protoOf(JsonTreeDecoder).r18 = function (tag) {
		    return getValue(this.w1(), tag);
		  };
		  protoOf(JsonTreeDecoder).ej = function (descriptor) {
		    if (descriptor === this.m19_1)
		      return this;
		    return protoOf(AbstractJsonTreeDecoder).ej.call(this, descriptor);
		  };
		  protoOf(JsonTreeDecoder).fj = function (descriptor) {
		    var tmp;
		    if (this.q18_1.i12_1) {
		      tmp = true;
		    } else {
		      var tmp_0 = descriptor.lh();
		      tmp = tmp_0 instanceof PolymorphicKind;
		    }
		    if (tmp)
		      return Unit_instance;
		    var tmp_1;
		    if (!this.q18_1.s12_1) {
		      tmp_1 = jsonCachedSerialNames(descriptor);
		    } else {
		      var tmp_2 = jsonCachedSerialNames(descriptor);
		      // Inline function 'kotlin.collections.orEmpty' call
		      var tmp0_safe_receiver = get_schemaCache(this.x12()).s17(descriptor, get_JsonAlternativeNamesKey());
		      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q1();
		      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
		      tmp_1 = plus_0(tmp_2, tmp$ret$0);
		    }
		    var names = tmp_1;
		    var tmp1_iterator = this.w1().q1().p();
		    while (tmp1_iterator.q()) {
		      var key = tmp1_iterator.s();
		      if (!names.v(key) ? !(key === this.l19_1) : false) {
		        throw UnknownKeyException(key, this.w1().toString());
		      }
		    }
		  };
		  function JsonTreeListDecoder(json, value) {
		    AbstractJsonTreeDecoder.call(this, json, value);
		    this.u19_1 = value;
		    this.v19_1 = this.u19_1.u();
		    this.w19_1 = -1;
		  }
		  protoOf(JsonTreeListDecoder).w1 = function () {
		    return this.u19_1;
		  };
		  protoOf(JsonTreeListDecoder).ax = function (desc, index) {
		    return index.toString();
		  };
		  protoOf(JsonTreeListDecoder).r18 = function (tag) {
		    return this.u19_1.b1(toInt(tag));
		  };
		  protoOf(JsonTreeListDecoder).vj = function (descriptor) {
		    while (this.w19_1 < (this.v19_1 - 1 | 0)) {
		      this.w19_1 = this.w19_1 + 1 | 0;
		      return this.w19_1;
		    }
		    return -1;
		  };
		  function JsonPrimitiveDecoder(json, value) {
		    AbstractJsonTreeDecoder.call(this, json, value);
		    this.c1a_1 = value;
		    this.vx(get_PRIMITIVE_TAG());
		  }
		  protoOf(JsonPrimitiveDecoder).w1 = function () {
		    return this.c1a_1;
		  };
		  protoOf(JsonPrimitiveDecoder).vj = function (descriptor) {
		    return 0;
		  };
		  protoOf(JsonPrimitiveDecoder).r18 = function (tag) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(tag === get_PRIMITIVE_TAG())) {
		      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
		      var message = "This input can only handle primitives with '" + get_PRIMITIVE_TAG() + "' tag";
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    return this.c1a_1;
		  };
		  function JsonTreeMapDecoder(json, value) {
		    JsonTreeDecoder.call(this, json, value);
		    this.n1a_1 = value;
		    this.o1a_1 = toList(this.n1a_1.q1());
		    this.p1a_1 = imul(this.o1a_1.u(), 2);
		    this.q1a_1 = -1;
		  }
		  protoOf(JsonTreeMapDecoder).w1 = function () {
		    return this.n1a_1;
		  };
		  protoOf(JsonTreeMapDecoder).ax = function (desc, index) {
		    var i = index / 2 | 0;
		    return this.o1a_1.b1(i);
		  };
		  protoOf(JsonTreeMapDecoder).vj = function (descriptor) {
		    while (this.q1a_1 < (this.p1a_1 - 1 | 0)) {
		      this.q1a_1 = this.q1a_1 + 1 | 0;
		      return this.q1a_1;
		    }
		    return -1;
		  };
		  protoOf(JsonTreeMapDecoder).r18 = function (tag) {
		    return (this.q1a_1 % 2 | 0) === 0 ? JsonPrimitive_2(tag) : getValue(this.n1a_1, tag);
		  };
		  protoOf(JsonTreeMapDecoder).fj = function (descriptor) {
		  };
		  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
		    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.uf())).dj(deserializer);
		  }
		  function writeJson(_this__u8e3s4, value, serializer) {
		    var result = {_v: null};
		    var encoder = new JsonTreeEncoder(_this__u8e3s4, writeJson$lambda(result));
		    encoder.wk(serializer, value);
		    var tmp;
		    if (result._v == null) {
		      throwUninitializedPropertyAccessException('result');
		    } else {
		      tmp = result._v;
		    }
		    return tmp;
		  }
		  function JsonTreeEncoder(json, nodeConsumer) {
		    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
		    var tmp = this;
		    // Inline function 'kotlin.collections.linkedMapOf' call
		    tmp.b1b_1 = LinkedHashMap_init_$Create$();
		  }
		  protoOf(JsonTreeEncoder).c1b = function (key, element) {
		    // Inline function 'kotlin.collections.set' call
		    this.b1b_1.s1(key, element);
		  };
		  protoOf(JsonTreeEncoder).xk = function (descriptor, index, serializer, value) {
		    if (!(value == null) ? true : this.u1a_1.m12_1) {
		      protoOf(AbstractJsonTreeEncoder).xk.call(this, descriptor, index, serializer, value);
		    }
		  };
		  protoOf(JsonTreeEncoder).d1b = function () {
		    return new JsonObject(this.b1b_1);
		  };
		  function AbstractJsonTreeEncoder$encodeTaggedInline$1(this$0, $tag) {
		    this.s1b_1 = this$0;
		    this.t1b_1 = $tag;
		    AbstractEncoder.call(this);
		    this.r1b_1 = this$0.s1a_1.tj();
		  }
		  protoOf(AbstractJsonTreeEncoder$encodeTaggedInline$1).tj = function () {
		    return this.r1b_1;
		  };
		  protoOf(AbstractJsonTreeEncoder$encodeTaggedInline$1).u1b = function (s) {
		    return this.s1b_1.c1b(this.t1b_1, new JsonLiteral(s, false));
		  };
		  protoOf(AbstractJsonTreeEncoder$encodeTaggedInline$1).dk = function (value) {
		    // Inline function 'kotlin.toUInt' call
		    var tmp$ret$0 = _UInt___init__impl__l7qpdl(value);
		    return this.u1b(UInt__toString_impl_dbgl21(tmp$ret$0));
		  };
		  protoOf(AbstractJsonTreeEncoder$encodeTaggedInline$1).ek = function (value) {
		    // Inline function 'kotlin.toULong' call
		    var tmp$ret$0 = _ULong___init__impl__c78o9k(value);
		    return this.u1b(ULong__toString_impl_f9au7k(tmp$ret$0));
		  };
		  protoOf(AbstractJsonTreeEncoder$encodeTaggedInline$1).bk = function (value) {
		    // Inline function 'kotlin.toUByte' call
		    var tmp$ret$0 = _UByte___init__impl__g9hnc4(value);
		    return this.u1b(UByte__toString_impl_v72jg(tmp$ret$0));
		  };
		  protoOf(AbstractJsonTreeEncoder$encodeTaggedInline$1).ck = function (value) {
		    // Inline function 'kotlin.toUShort' call
		    var tmp$ret$0 = _UShort___init__impl__jigrne(value);
		    return this.u1b(UShort__toString_impl_edaoee(tmp$ret$0));
		  };
		  function AbstractJsonTreeEncoder$beginStructure$lambda(this$0) {
		    return function (node) {
		      this$0.c1b(this$0.ux(), node);
		      return Unit_instance;
		    };
		  }
		  function AbstractJsonTreeEncoder(json, nodeConsumer) {
		    NamedValueEncoder.call(this);
		    this.s1a_1 = json;
		    this.t1a_1 = nodeConsumer;
		    this.u1a_1 = this.s1a_1.x10_1;
		    this.v1a_1 = null;
		  }
		  protoOf(AbstractJsonTreeEncoder).x12 = function () {
		    return this.s1a_1;
		  };
		  protoOf(AbstractJsonTreeEncoder).tj = function () {
		    return this.s1a_1.tj();
		  };
		  protoOf(AbstractJsonTreeEncoder).bl = function (descriptor, index) {
		    return this.u1a_1.h12_1;
		  };
		  protoOf(AbstractJsonTreeEncoder).ex = function (parentName, childName) {
		    return childName;
		  };
		  protoOf(AbstractJsonTreeEncoder).zk = function () {
		  };
		  protoOf(AbstractJsonTreeEncoder).zj = function () {
		    var tmp0_elvis_lhs = this.dx();
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return this.t1a_1(JsonNull_getInstance());
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var tag = tmp;
		    this.e1b(tag);
		  };
		  protoOf(AbstractJsonTreeEncoder).e1b = function (tag) {
		    return this.c1b(tag, JsonNull_getInstance());
		  };
		  protoOf(AbstractJsonTreeEncoder).hx = function (tag) {
		    return this.e1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
		  };
		  protoOf(AbstractJsonTreeEncoder).f1b = function (tag, value) {
		    return this.c1b(tag, JsonPrimitive_0(value));
		  };
		  protoOf(AbstractJsonTreeEncoder).ix = function (tag, value) {
		    return this.f1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).g1b = function (tag, value) {
		    return this.c1b(tag, JsonPrimitive_0(value));
		  };
		  protoOf(AbstractJsonTreeEncoder).jx = function (tag, value) {
		    return this.g1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).h1b = function (tag, value) {
		    return this.c1b(tag, JsonPrimitive_0(value));
		  };
		  protoOf(AbstractJsonTreeEncoder).kx = function (tag, value) {
		    return this.h1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).i1b = function (tag, value) {
		    return this.c1b(tag, JsonPrimitive_0(value));
		  };
		  protoOf(AbstractJsonTreeEncoder).lx = function (tag, value) {
		    return this.i1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).j1b = function (tag, value) {
		    this.c1b(tag, JsonPrimitive_0(value));
		    if (!this.u1a_1.r12_1 ? !isFinite(value) : false) {
		      throw InvalidFloatingPointEncoded(value, tag, toString(this.d1b()));
		    }
		  };
		  protoOf(AbstractJsonTreeEncoder).mx = function (tag, value) {
		    return this.j1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).wk = function (serializer, value) {
		    if (!(this.dx() == null) ? true : !get_requiresTopLevelTag(carrierDescriptor(serializer.uf(), this.tj()))) {
		      $l$block: {
		        // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
		        var tmp;
		        if (!(serializer instanceof AbstractPolymorphicSerializer)) {
		          tmp = true;
		        } else {
		          tmp = this.x12().x10_1.p12_1;
		        }
		        if (tmp) {
		          serializer.vf(this, value);
		          break $l$block;
		        }
		        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
		        var baseClassDiscriminator = classDiscriminator(serializer.uf(), this.x12());
		        var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
		        validateIfSealed$accessor$1ad0flx(casted, actualSerializer, baseClassDiscriminator);
		        checkKind(actualSerializer.uf().lh());
		        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.encodeSerializableValue.<anonymous>' call
		        this.v1a_1 = baseClassDiscriminator;
		        actualSerializer.vf(this, value);
		      }
		    } else {
		      // Inline function 'kotlin.apply' call
		      var this_0 = new JsonPrimitiveEncoder(this.s1a_1, this.t1a_1);
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.encodeSerializableValue.<anonymous>' call
		      this_0.wk(serializer, value);
		      this_0.tx(serializer.uf());
		    }
		  };
		  protoOf(AbstractJsonTreeEncoder).k1b = function (tag, value) {
		    this.c1b(tag, JsonPrimitive_0(value));
		    if (!this.u1a_1.r12_1 ? !isFinite_0(value) : false) {
		      throw InvalidFloatingPointEncoded(value, tag, toString(this.d1b()));
		    }
		  };
		  protoOf(AbstractJsonTreeEncoder).nx = function (tag, value) {
		    return this.k1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).l1b = function (tag, value) {
		    return this.c1b(tag, JsonPrimitive_1(value));
		  };
		  protoOf(AbstractJsonTreeEncoder).ox = function (tag, value) {
		    return this.l1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).m1b = function (tag, value) {
		    return this.c1b(tag, JsonPrimitive_2(toString_0(value)));
		  };
		  protoOf(AbstractJsonTreeEncoder).px = function (tag, value) {
		    return this.m1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).n1b = function (tag, value) {
		    return this.c1b(tag, JsonPrimitive_2(value));
		  };
		  protoOf(AbstractJsonTreeEncoder).qx = function (tag, value) {
		    return this.n1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).o1b = function (tag, enumDescriptor, ordinal) {
		    return this.c1b(tag, JsonPrimitive_2(enumDescriptor.ph(ordinal)));
		  };
		  protoOf(AbstractJsonTreeEncoder).rx = function (tag, enumDescriptor, ordinal) {
		    return this.o1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor, ordinal);
		  };
		  protoOf(AbstractJsonTreeEncoder).p1b = function (tag, value) {
		    this.c1b(tag, JsonPrimitive_2(toString(value)));
		  };
		  protoOf(AbstractJsonTreeEncoder).fx = function (tag, value) {
		    return this.p1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
		  };
		  protoOf(AbstractJsonTreeEncoder).q1b = function (tag, inlineDescriptor) {
		    var tmp;
		    if (get_isUnsignedNumber(inlineDescriptor)) {
		      tmp = new AbstractJsonTreeEncoder$encodeTaggedInline$1(this, tag);
		    } else {
		      tmp = protoOf(NamedValueEncoder).sx.call(this, tag, inlineDescriptor);
		    }
		    return tmp;
		  };
		  protoOf(AbstractJsonTreeEncoder).sx = function (tag, inlineDescriptor) {
		    return this.q1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
		  };
		  protoOf(AbstractJsonTreeEncoder).ej = function (descriptor) {
		    var tmp;
		    if (this.dx() == null) {
		      tmp = this.t1a_1;
		    } else {
		      tmp = AbstractJsonTreeEncoder$beginStructure$lambda(this);
		    }
		    var consumer = tmp;
		    var tmp0_subject = descriptor.lh();
		    var tmp_0;
		    var tmp_1;
		    if (equals(tmp0_subject, LIST_getInstance())) {
		      tmp_1 = true;
		    } else {
		      tmp_1 = tmp0_subject instanceof PolymorphicKind;
		    }
		    if (tmp_1) {
		      tmp_0 = new JsonTreeListEncoder(this.s1a_1, consumer);
		    } else {
		      if (equals(tmp0_subject, MAP_getInstance())) {
		        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
		        var this_0 = this.s1a_1;
		        var keyDescriptor = carrierDescriptor(descriptor.nh(0), this_0.tj());
		        var keyKind = keyDescriptor.lh();
		        var tmp_2;
		        var tmp_3;
		        if (keyKind instanceof PrimitiveKind) {
		          tmp_3 = true;
		        } else {
		          tmp_3 = equals(keyKind, ENUM_getInstance());
		        }
		        if (tmp_3) {
		          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.beginStructure.<anonymous>' call
		          tmp_2 = new JsonTreeMapEncoder(this.s1a_1, consumer);
		        } else {
		          if (this_0.x10_1.k12_1) {
		            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.beginStructure.<anonymous>' call
		            tmp_2 = new JsonTreeListEncoder(this.s1a_1, consumer);
		          } else {
		            throw InvalidKeyKindException(keyDescriptor);
		          }
		        }
		        tmp_0 = tmp_2;
		      } else {
		        tmp_0 = new JsonTreeEncoder(this.s1a_1, consumer);
		      }
		    }
		    var encoder = tmp_0;
		    if (!(this.v1a_1 == null)) {
		      encoder.c1b(ensureNotNull(this.v1a_1), JsonPrimitive_2(descriptor.sg()));
		      this.v1a_1 = null;
		    }
		    return encoder;
		  };
		  protoOf(AbstractJsonTreeEncoder).tx = function (descriptor) {
		    this.t1a_1(this.d1b());
		  };
		  function get_requiresTopLevelTag(_this__u8e3s4) {
		    var tmp;
		    var tmp_0 = _this__u8e3s4.lh();
		    if (tmp_0 instanceof PrimitiveKind) {
		      tmp = true;
		    } else {
		      tmp = _this__u8e3s4.lh() === ENUM_getInstance();
		    }
		    return tmp;
		  }
		  function JsonPrimitiveEncoder(json, nodeConsumer) {
		    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
		    this.a1c_1 = null;
		    this.vx('primitive');
		  }
		  protoOf(JsonPrimitiveEncoder).c1b = function (key, element) {
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(key === 'primitive')) {
		      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.putElement.<anonymous>' call
		      var message = "This output can only consume primitives with 'primitive' tag";
		      throw IllegalArgumentException_init_$Create$(toString(message));
		    }
		    // Inline function 'kotlin.require' call
		    // Inline function 'kotlin.contracts.contract' call
		    if (!(this.a1c_1 == null)) {
		      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.putElement.<anonymous>' call
		      var message_0 = 'Primitive element was already recorded. Does call to .encodeXxx happen more than once?';
		      throw IllegalArgumentException_init_$Create$(toString(message_0));
		    }
		    this.a1c_1 = element;
		  };
		  protoOf(JsonPrimitiveEncoder).d1b = function () {
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlin.requireNotNull' call
		      var value = this.a1c_1;
		      // Inline function 'kotlin.contracts.contract' call
		      if (value == null) {
		        // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.getCurrent.<anonymous>' call
		        var message = 'Primitive element has not been recorded. Is call to .encodeXxx is missing in serializer?';
		        throw IllegalArgumentException_init_$Create$(toString(message));
		      } else {
		        tmp$ret$1 = value;
		        break $l$block;
		      }
		    }
		    return tmp$ret$1;
		  };
		  function JsonTreeListEncoder(json, nodeConsumer) {
		    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
		    var tmp = this;
		    // Inline function 'kotlin.collections.arrayListOf' call
		    tmp.g1c_1 = ArrayList_init_$Create$();
		  }
		  protoOf(JsonTreeListEncoder).ax = function (descriptor, index) {
		    return index.toString();
		  };
		  protoOf(JsonTreeListEncoder).c1b = function (key, element) {
		    var idx = toInt(key);
		    this.g1c_1.e1(idx, element);
		  };
		  protoOf(JsonTreeListEncoder).d1b = function () {
		    return new JsonArray(this.g1c_1);
		  };
		  function _get_tag__e6h4qf($this) {
		    var tmp = $this.n1c_1;
		    if (!(tmp == null))
		      return tmp;
		    else {
		      throwUninitializedPropertyAccessException('tag');
		    }
		  }
		  function JsonTreeMapEncoder(json, nodeConsumer) {
		    JsonTreeEncoder.call(this, json, nodeConsumer);
		    this.o1c_1 = true;
		  }
		  protoOf(JsonTreeMapEncoder).c1b = function (key, element) {
		    if (this.o1c_1) {
		      var tmp = this;
		      var tmp_0;
		      if (element instanceof JsonPrimitive) {
		        tmp_0 = element.e13();
		      } else {
		        if (element instanceof JsonObject) {
		          throw InvalidKeyKindException(JsonObjectSerializer_getInstance().p13_1);
		        } else {
		          if (element instanceof JsonArray) {
		            throw InvalidKeyKindException(JsonArraySerializer_getInstance().q13_1);
		          } else {
		            noWhenBranchMatchedException();
		          }
		        }
		      }
		      tmp.n1c_1 = tmp_0;
		      this.o1c_1 = false;
		    } else {
		      // Inline function 'kotlin.collections.set' call
		      var this_0 = this.b1b_1;
		      var key_0 = _get_tag__e6h4qf(this);
		      this_0.s1(key_0, element);
		      this.o1c_1 = true;
		    }
		  };
		  protoOf(JsonTreeMapEncoder).d1b = function () {
		    return new JsonObject(this.b1b_1);
		  };
		  function get_PRIMITIVE_TAG() {
		    return PRIMITIVE_TAG;
		  }
		  var PRIMITIVE_TAG;
		  function writeJson$lambda($result) {
		    return function (it) {
		      $result._v = it;
		      return Unit_instance;
		    };
		  }
		  var WriteMode_OBJ_instance;
		  var WriteMode_LIST_instance;
		  var WriteMode_MAP_instance;
		  var WriteMode_POLY_OBJ_instance;
		  function values() {
		    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
		  }
		  var WriteMode_entriesInitialized;
		  function WriteMode_initEntries() {
		    if (WriteMode_entriesInitialized)
		      return Unit_instance;
		    WriteMode_entriesInitialized = true;
		    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, get_BEGIN_OBJ(), get_END_OBJ());
		    WriteMode_LIST_instance = new WriteMode('LIST', 1, get_BEGIN_LIST(), get_END_LIST());
		    WriteMode_MAP_instance = new WriteMode('MAP', 2, get_BEGIN_OBJ(), get_END_OBJ());
		    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, get_BEGIN_LIST(), get_END_LIST());
		  }
		  function WriteMode(name, ordinal, begin, end) {
		    Enum.call(this, name, ordinal);
		    this.f18_1 = begin;
		    this.g18_1 = end;
		  }
		  function switchMode(_this__u8e3s4, desc) {
		    var tmp0_subject = desc.lh();
		    var tmp;
		    if (tmp0_subject instanceof PolymorphicKind) {
		      tmp = WriteMode_POLY_OBJ_getInstance();
		    } else {
		      if (equals(tmp0_subject, LIST_getInstance())) {
		        tmp = WriteMode_LIST_getInstance();
		      } else {
		        if (equals(tmp0_subject, MAP_getInstance())) {
		          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
		          var keyDescriptor = carrierDescriptor(desc.nh(0), _this__u8e3s4.tj());
		          var keyKind = keyDescriptor.lh();
		          var tmp_0;
		          var tmp_1;
		          if (keyKind instanceof PrimitiveKind) {
		            tmp_1 = true;
		          } else {
		            tmp_1 = equals(keyKind, ENUM_getInstance());
		          }
		          if (tmp_1) {
		            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
		            tmp_0 = WriteMode_MAP_getInstance();
		          } else {
		            if (_this__u8e3s4.x10_1.k12_1) {
		              // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
		              tmp_0 = WriteMode_LIST_getInstance();
		            } else {
		              throw InvalidKeyKindException(keyDescriptor);
		            }
		          }
		          tmp = tmp_0;
		        } else {
		          tmp = WriteMode_OBJ_getInstance();
		        }
		      }
		    }
		    return tmp;
		  }
		  function carrierDescriptor(_this__u8e3s4, module_0) {
		    var tmp;
		    if (equals(_this__u8e3s4.lh(), CONTEXTUAL_getInstance())) {
		      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
		      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
		      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
		    } else if (_this__u8e3s4.kh()) {
		      tmp = carrierDescriptor(_this__u8e3s4.nh(0), module_0);
		    } else {
		      tmp = _this__u8e3s4;
		    }
		    return tmp;
		  }
		  function WriteMode_OBJ_getInstance() {
		    WriteMode_initEntries();
		    return WriteMode_OBJ_instance;
		  }
		  function WriteMode_LIST_getInstance() {
		    WriteMode_initEntries();
		    return WriteMode_LIST_instance;
		  }
		  function WriteMode_MAP_getInstance() {
		    WriteMode_initEntries();
		    return WriteMode_MAP_instance;
		  }
		  function WriteMode_POLY_OBJ_getInstance() {
		    WriteMode_initEntries();
		    return WriteMode_POLY_OBJ_instance;
		  }
		  function appendEscape($this, lastPosition, current) {
		    $this.p1c(lastPosition, current);
		    return appendEsc($this, current + 1 | 0);
		  }
		  function decodedString($this, lastPosition, currentPosition) {
		    $this.p1c(lastPosition, currentPosition);
		    var result = $this.s11_1.toString();
		    $this.s11_1.i7(0);
		    return result;
		  }
		  function takePeeked($this) {
		    // Inline function 'kotlin.also' call
		    var this_0 = ensureNotNull($this.r11_1);
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
		    $this.r11_1 = null;
		    return this_0;
		  }
		  function wasUnquotedString($this) {
		    return !(charSequenceGet($this.q1c(), $this.p11_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
		  }
		  function appendEsc($this, startPosition) {
		    var currentPosition = startPosition;
		    currentPosition = $this.r1c(currentPosition);
		    if (currentPosition === -1) {
		      $this.g15('Expected escape sequence to continue, got EOF');
		    }
		    var tmp = $this.q1c();
		    var tmp0 = currentPosition;
		    currentPosition = tmp0 + 1 | 0;
		    var currentChar = charSequenceGet(tmp, tmp0);
		    if (currentChar === _Char___init__impl__6a9atx(117)) {
		      return appendHex($this, $this.q1c(), currentPosition);
		    }
		    // Inline function 'kotlin.code' call
		    var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
		    var c = escapeToChar(tmp$ret$0);
		    if (c === _Char___init__impl__6a9atx(0)) {
		      $this.g15("Invalid escaped char '" + toString_0(currentChar) + "'");
		    }
		    $this.s11_1.b5(c);
		    return currentPosition;
		  }
		  function appendHex($this, source, startPos) {
		    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
		      $this.p11_1 = startPos;
		      $this.s1c();
		      if (($this.p11_1 + 4 | 0) >= charSequenceLength(source)) {
		        $this.g15('Unexpected EOF during unicode escape');
		      }
		      return appendHex($this, source, $this.p11_1);
		    }
		    $this.s11_1.b5(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
		    return startPos + 4 | 0;
		  }
		  function fromHexChar($this, source, currentPosition) {
		    var character = charSequenceGet(source, currentPosition);
		    var tmp;
		    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
		      // Inline function 'kotlin.code' call
		      var tmp_0 = Char__toInt_impl_vasixd(character);
		      // Inline function 'kotlin.code' call
		      var this_0 = _Char___init__impl__6a9atx(48);
		      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
		    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
		      // Inline function 'kotlin.code' call
		      var tmp_1 = Char__toInt_impl_vasixd(character);
		      // Inline function 'kotlin.code' call
		      var this_1 = _Char___init__impl__6a9atx(97);
		      tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
		    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
		      // Inline function 'kotlin.code' call
		      var tmp_2 = Char__toInt_impl_vasixd(character);
		      // Inline function 'kotlin.code' call
		      var this_2 = _Char___init__impl__6a9atx(65);
		      tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
		    } else {
		      $this.g15("Invalid toHexChar char '" + toString_0(character) + "' in unicode escape");
		    }
		    return tmp;
		  }
		  function consumeBoolean($this, start) {
		    var current = $this.r1c(start);
		    if (current >= charSequenceLength($this.q1c()) ? true : current === -1) {
		      $this.g15('EOF');
		    }
		    // Inline function 'kotlin.code' call
		    var tmp = $this.q1c();
		    var tmp0 = current;
		    current = tmp0 + 1 | 0;
		    var this_0 = charSequenceGet(tmp, tmp0);
		    var tmp1_subject = Char__toInt_impl_vasixd(this_0) | 32;
		    var tmp_0;
		    // Inline function 'kotlin.code' call
		    var this_1 = _Char___init__impl__6a9atx(116);
		    if (tmp1_subject === Char__toInt_impl_vasixd(this_1)) {
		      consumeBooleanLiteral($this, 'rue', current);
		      tmp_0 = true;
		    } else {
		      // Inline function 'kotlin.code' call
		      var this_2 = _Char___init__impl__6a9atx(102);
		      if (tmp1_subject === Char__toInt_impl_vasixd(this_2)) {
		        consumeBooleanLiteral($this, 'alse', current);
		        tmp_0 = false;
		      } else {
		        $this.g15("Expected valid boolean literal prefix, but had '" + $this.i16() + "'");
		      }
		    }
		    return tmp_0;
		  }
		  function consumeBooleanLiteral($this, literalSuffix, current) {
		    if ((charSequenceLength($this.q1c()) - current | 0) < literalSuffix.length) {
		      $this.g15('Unexpected end of boolean literal');
		    }
		    var inductionVariable = 0;
		    var last = charSequenceLength(literalSuffix) - 1 | 0;
		    if (inductionVariable <= last)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        var expected = charSequenceGet(literalSuffix, i);
		        var actual = charSequenceGet($this.q1c(), current + i | 0);
		        // Inline function 'kotlin.code' call
		        var tmp = Char__toInt_impl_vasixd(expected);
		        // Inline function 'kotlin.code' call
		        if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
		          $this.g15("Expected valid boolean literal prefix, but had '" + $this.i16() + "'");
		        }
		      }
		       while (inductionVariable <= last);
		    $this.p11_1 = current + literalSuffix.length | 0;
		  }
		  function AbstractJsonLexer() {
		    this.p11_1 = 0;
		    this.q11_1 = new JsonPath();
		    this.r11_1 = null;
		    this.s11_1 = StringBuilder_init_$Create$();
		  }
		  protoOf(AbstractJsonLexer).s1c = function () {
		  };
		  protoOf(AbstractJsonLexer).t1c = function (c) {
		    return (((c === _Char___init__impl__6a9atx(125) ? true : c === _Char___init__impl__6a9atx(93)) ? true : c === _Char___init__impl__6a9atx(58)) ? true : c === _Char___init__impl__6a9atx(44)) ? false : true;
		  };
		  protoOf(AbstractJsonLexer).t11 = function () {
		    var nextToken = this.k16();
		    if (!(nextToken === 10)) {
		      this.g15('Expected EOF after parsing, but had ' + toString_0(charSequenceGet(this.q1c(), this.p11_1 - 1 | 0)) + ' instead');
		    }
		  };
		  protoOf(AbstractJsonLexer).e16 = function (expected) {
		    var token = this.k16();
		    if (!(token === expected)) {
		      this.u1c(expected);
		    }
		    return token;
		  };
		  protoOf(AbstractJsonLexer).u17 = function (expected) {
		    this.s1c();
		    var source = this.q1c();
		    var cpos = this.p11_1;
		    $l$loop_0: while (true) {
		      cpos = this.r1c(cpos);
		      if (cpos === -1)
		        break $l$loop_0;
		      var tmp0 = cpos;
		      cpos = tmp0 + 1 | 0;
		      var c = charSequenceGet(source, tmp0);
		      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9))
		        continue $l$loop_0;
		      this.p11_1 = cpos;
		      if (c === expected)
		        return Unit_instance;
		      this.v1c(expected);
		    }
		    this.p11_1 = cpos;
		    this.v1c(expected);
		  };
		  protoOf(AbstractJsonLexer).v1c = function (expected) {
		    this.p11_1 = this.p11_1 - 1 | 0;
		    if ((this.p11_1 >= 0 ? expected === _Char___init__impl__6a9atx(34) : false) ? this.i16() === 'null' : false) {
		      this.w1c("Expected string literal but 'null' literal was found", this.p11_1 - 4 | 0, "Use 'coerceInputValues = true' in 'Json {}` builder to coerce nulls to default values.");
		    }
		    this.u1c(charToTokenClass(expected));
		  };
		  protoOf(AbstractJsonLexer).u1c = function (expectedToken) {
		    var expected = expectedToken === 1 ? "quotation mark '\"'" : expectedToken === 4 ? "comma ','" : expectedToken === 5 ? "colon ':'" : expectedToken === 6 ? "start of the object '{'" : expectedToken === 7 ? "end of the object '}'" : expectedToken === 8 ? "start of the array '['" : expectedToken === 9 ? "end of the array ']'" : 'valid token';
		    var s = (this.p11_1 === charSequenceLength(this.q1c()) ? true : this.p11_1 <= 0) ? 'EOF' : toString_0(charSequenceGet(this.q1c(), this.p11_1 - 1 | 0));
		    this.g15('Expected ' + expected + ", but had '" + s + "' instead", this.p11_1 - 1 | 0);
		  };
		  protoOf(AbstractJsonLexer).f16 = function () {
		    var source = this.q1c();
		    var cpos = this.p11_1;
		    $l$loop_0: while (true) {
		      cpos = this.r1c(cpos);
		      if (cpos === -1)
		        break $l$loop_0;
		      var ch = charSequenceGet(source, cpos);
		      if (((ch === _Char___init__impl__6a9atx(32) ? true : ch === _Char___init__impl__6a9atx(10)) ? true : ch === _Char___init__impl__6a9atx(13)) ? true : ch === _Char___init__impl__6a9atx(9)) {
		        cpos = cpos + 1 | 0;
		        continue $l$loop_0;
		      }
		      this.p11_1 = cpos;
		      return charToTokenClass(ch);
		    }
		    this.p11_1 = cpos;
		    return 10;
		  };
		  protoOf(AbstractJsonLexer).w17 = function () {
		    var current = this.x1c();
		    current = this.r1c(current);
		    var len = charSequenceLength(this.q1c()) - current | 0;
		    if (len < 4 ? true : current === -1)
		      return true;
		    var inductionVariable = 0;
		    if (inductionVariable <= 3)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (!(charSequenceGet('null', i) === charSequenceGet(this.q1c(), current + i | 0)))
		          return true;
		      }
		       while (inductionVariable <= 3);
		    if (len > 4 ? charToTokenClass(charSequenceGet(this.q1c(), current + 4 | 0)) === 0 : false)
		      return true;
		    this.p11_1 = current + 4 | 0;
		    return false;
		  };
		  protoOf(AbstractJsonLexer).x1c = function () {
		    var current = this.p11_1;
		    $l$loop_0: while (true) {
		      current = this.r1c(current);
		      if (current === -1)
		        break $l$loop_0;
		      var c = charSequenceGet(this.q1c(), current);
		      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9)) {
		        current = current + 1 | 0;
		      } else {
		        break $l$loop_0;
		      }
		    }
		    this.p11_1 = current;
		    return current;
		  };
		  protoOf(AbstractJsonLexer).x17 = function (isLenient) {
		    var token = this.f16();
		    var tmp;
		    if (isLenient) {
		      if (!(token === 1) ? !(token === 0) : false)
		        return null;
		      tmp = this.i16();
		    } else {
		      if (!(token === 1))
		        return null;
		      tmp = this.h16();
		    }
		    var string = tmp;
		    this.r11_1 = string;
		    return string;
		  };
		  protoOf(AbstractJsonLexer).y1c = function (startPos, endPos) {
		    // Inline function 'kotlin.text.substring' call
		    var this_0 = this.q1c();
		    return toString(charSequenceSubSequence(this_0, startPos, endPos));
		  };
		  protoOf(AbstractJsonLexer).h16 = function () {
		    if (!(this.r11_1 == null)) {
		      return takePeeked(this);
		    }
		    return this.a18();
		  };
		  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
		    var currentPosition = current;
		    var lastPosition = startPosition;
		    var char = charSequenceGet(source, currentPosition);
		    var usedAppend = false;
		    while (!(char === _Char___init__impl__6a9atx(34))) {
		      if (char === _Char___init__impl__6a9atx(92)) {
		        usedAppend = true;
		        currentPosition = this.r1c(appendEscape(this, lastPosition, currentPosition));
		        if (currentPosition === -1) {
		          this.g15('EOF', currentPosition);
		        }
		        lastPosition = currentPosition;
		      } else {
		        currentPosition = currentPosition + 1 | 0;
		        if (currentPosition >= charSequenceLength(source)) {
		          usedAppend = true;
		          this.p1c(lastPosition, currentPosition);
		          currentPosition = this.r1c(currentPosition);
		          if (currentPosition === -1) {
		            this.g15('EOF', currentPosition);
		          }
		          lastPosition = currentPosition;
		        }
		      }
		      char = charSequenceGet(source, currentPosition);
		    }
		    var tmp;
		    if (!usedAppend) {
		      tmp = this.y1c(lastPosition, currentPosition);
		    } else {
		      tmp = decodedString(this, lastPosition, currentPosition);
		    }
		    var string = tmp;
		    this.p11_1 = currentPosition + 1 | 0;
		    return string;
		  };
		  protoOf(AbstractJsonLexer).b18 = function () {
		    var result = this.i16();
		    if (result === 'null' ? wasUnquotedString(this) : false) {
		      this.g15("Unexpected 'null' value instead of string literal");
		    }
		    return result;
		  };
		  protoOf(AbstractJsonLexer).i16 = function () {
		    if (!(this.r11_1 == null)) {
		      return takePeeked(this);
		    }
		    var current = this.x1c();
		    if (current >= charSequenceLength(this.q1c()) ? true : current === -1) {
		      this.g15('EOF', current);
		    }
		    var token = charToTokenClass(charSequenceGet(this.q1c(), current));
		    if (token === 1) {
		      return this.h16();
		    }
		    if (!(token === 0)) {
		      this.g15('Expected beginning of the string, but got ' + toString_0(charSequenceGet(this.q1c(), current)));
		    }
		    var usedAppend = false;
		    while (charToTokenClass(charSequenceGet(this.q1c(), current)) === 0) {
		      current = current + 1 | 0;
		      if (current >= charSequenceLength(this.q1c())) {
		        usedAppend = true;
		        this.p1c(this.p11_1, current);
		        var eof = this.r1c(current);
		        if (eof === -1) {
		          this.p11_1 = current;
		          return decodedString(this, 0, 0);
		        } else {
		          current = eof;
		        }
		      }
		    }
		    var tmp;
		    if (!usedAppend) {
		      tmp = this.y1c(this.p11_1, current);
		    } else {
		      tmp = decodedString(this, this.p11_1, current);
		    }
		    var result = tmp;
		    this.p11_1 = current;
		    return result;
		  };
		  protoOf(AbstractJsonLexer).p1c = function (fromIndex, toIndex) {
		    this.s11_1.d7(this.q1c(), fromIndex, toIndex);
		  };
		  protoOf(AbstractJsonLexer).z17 = function (allowLenientStrings) {
		    // Inline function 'kotlin.collections.mutableListOf' call
		    var tokenStack = ArrayList_init_$Create$();
		    var lastToken = this.f16();
		    if (!(lastToken === 8) ? !(lastToken === 6) : false) {
		      this.i16();
		      return Unit_instance;
		    }
		    $l$loop: while (true) {
		      lastToken = this.f16();
		      if (lastToken === 1) {
		        if (allowLenientStrings) {
		          this.i16();
		        } else {
		          this.a18();
		        }
		        continue $l$loop;
		      }
		      var tmp0_subject = lastToken;
		      if (tmp0_subject === 8 ? true : tmp0_subject === 6) {
		        tokenStack.m(lastToken);
		      } else if (tmp0_subject === 9) {
		        if (!(last(tokenStack) === 8))
		          throw JsonDecodingException_0(this.p11_1, 'found ] instead of } at path: ' + this.q11_1, this.q1c());
		        removeLast(tokenStack);
		      } else if (tmp0_subject === 7) {
		        if (!(last(tokenStack) === 6))
		          throw JsonDecodingException_0(this.p11_1, 'found } instead of ] at path: ' + this.q11_1, this.q1c());
		        removeLast(tokenStack);
		      } else if (tmp0_subject === 10) {
		        this.g15('Unexpected end of input due to malformed JSON during ignoring unknown keys');
		      }
		      this.k16();
		      if (tokenStack.u() === 0)
		        return Unit_instance;
		    }
		  };
		  protoOf(AbstractJsonLexer).toString = function () {
		    return "JsonReader(source='" + this.q1c() + "', currentPosition=" + this.p11_1 + ')';
		  };
		  protoOf(AbstractJsonLexer).y17 = function (key) {
		    var processed = this.y1c(0, this.p11_1);
		    var lastIndexOf_0 = lastIndexOf(processed, key);
		    this.w1c("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
		  };
		  protoOf(AbstractJsonLexer).w1c = function (message, position, hint) {
		    var tmp;
		    // Inline function 'kotlin.text.isEmpty' call
		    if (charSequenceLength(hint) === 0) {
		      tmp = '';
		    } else {
		      tmp = '\n' + hint;
		    }
		    var hintMessage = tmp;
		    throw JsonDecodingException_0(position, message + ' at path: ' + this.q11_1.s15() + hintMessage, this.q1c());
		  };
		  protoOf(AbstractJsonLexer).g15 = function (message, position, hint, $super) {
		    position = position === VOID ? this.p11_1 : position;
		    hint = hint === VOID ? '' : hint;
		    return $super === VOID ? this.w1c(message, position, hint) : $super.w1c.call(this, message, position, hint);
		  };
		  protoOf(AbstractJsonLexer).j18 = function () {
		    var current = this.x1c();
		    current = this.r1c(current);
		    if (current >= charSequenceLength(this.q1c()) ? true : current === -1) {
		      this.g15('EOF');
		    }
		    var tmp;
		    if (charSequenceGet(this.q1c(), current) === _Char___init__impl__6a9atx(34)) {
		      current = current + 1 | 0;
		      if (current === charSequenceLength(this.q1c())) {
		        this.g15('EOF');
		      }
		      tmp = true;
		    } else {
		      tmp = false;
		    }
		    var hasQuotation = tmp;
		    var accumulator = new Long(0, 0);
		    var isNegative = false;
		    var start = current;
		    var hasChars = true;
		    $l$loop_0: while (hasChars) {
		      var ch = charSequenceGet(this.q1c(), current);
		      if (ch === _Char___init__impl__6a9atx(45)) {
		        if (!(current === start)) {
		          this.g15("Unexpected symbol '-' in numeric literal");
		        }
		        isNegative = true;
		        current = current + 1 | 0;
		        continue $l$loop_0;
		      }
		      var token = charToTokenClass(ch);
		      if (!(token === 0))
		        break $l$loop_0;
		      current = current + 1 | 0;
		      hasChars = !(current === charSequenceLength(this.q1c()));
		      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
		      if (!(0 <= digit ? digit <= 9 : false)) {
		        this.g15("Unexpected symbol '" + toString_0(ch) + "' in numeric literal");
		      }
		      // Inline function 'kotlin.Long.minus' call
		      // Inline function 'kotlin.Long.times' call
		      accumulator = accumulator.l8(toLong_0(10)).s9(toLong_0(digit));
		      if (accumulator.m8(new Long(0, 0)) > 0) {
		        this.g15('Numeric value overflow');
		      }
		    }
		    if (start === current ? true : isNegative ? start === (current - 1 | 0) : false) {
		      this.g15('Expected numeric literal');
		    }
		    if (hasQuotation) {
		      if (!hasChars) {
		        this.g15('EOF');
		      }
		      if (!(charSequenceGet(this.q1c(), current) === _Char___init__impl__6a9atx(34))) {
		        this.g15('Expected closing quotation mark');
		      }
		      current = current + 1 | 0;
		    }
		    this.p11_1 = current;
		    var tmp_0;
		    if (isNegative) {
		      tmp_0 = accumulator;
		    } else {
		      var tmp_1 = accumulator;
		      Companion_getInstance_3();
		      if (!tmp_1.equals(new Long(0, -2147483648))) {
		        tmp_0 = accumulator.u9();
		      } else {
		        this.g15('Numeric value overflow');
		      }
		    }
		    return tmp_0;
		  };
		  protoOf(AbstractJsonLexer).h18 = function () {
		    return consumeBoolean(this, this.x1c());
		  };
		  protoOf(AbstractJsonLexer).i18 = function () {
		    var current = this.x1c();
		    if (current === charSequenceLength(this.q1c())) {
		      this.g15('EOF');
		    }
		    var tmp;
		    if (charSequenceGet(this.q1c(), current) === _Char___init__impl__6a9atx(34)) {
		      current = current + 1 | 0;
		      tmp = true;
		    } else {
		      tmp = false;
		    }
		    var hasQuotation = tmp;
		    var result = consumeBoolean(this, current);
		    if (hasQuotation) {
		      if (this.p11_1 === charSequenceLength(this.q1c())) {
		        this.g15('EOF');
		      }
		      if (!(charSequenceGet(this.q1c(), this.p11_1) === _Char___init__impl__6a9atx(34))) {
		        this.g15('Expected closing quotation mark');
		      }
		      this.p11_1 = this.p11_1 + 1 | 0;
		    }
		    return result;
		  };
		  function charToTokenClass(c) {
		    var tmp;
		    // Inline function 'kotlin.code' call
		    if (Char__toInt_impl_vasixd(c) < 126) {
		      var tmp_0 = CharMappings_getInstance().a1d_1;
		      // Inline function 'kotlin.code' call
		      tmp = tmp_0[Char__toInt_impl_vasixd(c)];
		    } else {
		      tmp = 0;
		    }
		    return tmp;
		  }
		  function get_TC_WHITESPACE() {
		    return TC_WHITESPACE;
		  }
		  var TC_WHITESPACE;
		  function get_TC_EOF() {
		    return TC_EOF;
		  }
		  var TC_EOF;
		  function get_STRING() {
		    return STRING;
		  }
		  var STRING;
		  function get_TC_STRING() {
		    return TC_STRING;
		  }
		  var TC_STRING;
		  function get_STRING_ESC() {
		    return STRING_ESC;
		  }
		  var STRING_ESC;
		  function get_TC_BEGIN_OBJ() {
		    return TC_BEGIN_OBJ;
		  }
		  var TC_BEGIN_OBJ;
		  function get_TC_COLON() {
		    return TC_COLON;
		  }
		  var TC_COLON;
		  function get_TC_COMMA() {
		    return TC_COMMA;
		  }
		  var TC_COMMA;
		  function get_COLON() {
		    return COLON;
		  }
		  var COLON;
		  function get_BEGIN_OBJ() {
		    return BEGIN_OBJ;
		  }
		  var BEGIN_OBJ;
		  function get_END_OBJ() {
		    return END_OBJ;
		  }
		  var END_OBJ;
		  function get_BEGIN_LIST() {
		    return BEGIN_LIST;
		  }
		  var BEGIN_LIST;
		  function get_END_LIST() {
		    return END_LIST;
		  }
		  var END_LIST;
		  function get_lenientHint() {
		    return lenientHint;
		  }
		  var lenientHint;
		  function get_INVALID() {
		    return INVALID;
		  }
		  var INVALID;
		  function get_COMMA() {
		    return COMMA;
		  }
		  var COMMA;
		  function get_NULL() {
		    return NULL;
		  }
		  var NULL;
		  function get_TC_END_OBJ() {
		    return TC_END_OBJ;
		  }
		  var TC_END_OBJ;
		  function get_TC_BEGIN_LIST() {
		    return TC_BEGIN_LIST;
		  }
		  var TC_BEGIN_LIST;
		  function get_TC_END_LIST() {
		    return TC_END_LIST;
		  }
		  var TC_END_LIST;
		  function get_TC_OTHER() {
		    return TC_OTHER;
		  }
		  var TC_OTHER;
		  function escapeToChar(c) {
		    return c < 117 ? CharMappings_getInstance().z1c_1[c] : _Char___init__impl__6a9atx(0);
		  }
		  function get_ignoreUnknownKeysHint() {
		    return ignoreUnknownKeysHint;
		  }
		  var ignoreUnknownKeysHint;
		  function initEscape($this) {
		    var inductionVariable = 0;
		    if (inductionVariable <= 31)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
		      }
		       while (inductionVariable <= 31);
		    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
		    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
		    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
		    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
		    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
		    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
		    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
		    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
		  }
		  function initCharToToken($this) {
		    var inductionVariable = 0;
		    if (inductionVariable <= 32)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        initC2TC($this, i, 127);
		      }
		       while (inductionVariable <= 32);
		    initC2TC($this, 9, 3);
		    initC2TC($this, 10, 3);
		    initC2TC($this, 13, 3);
		    initC2TC($this, 32, 3);
		    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
		    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
		    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
		    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
		    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
		    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
		    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
		    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
		  }
		  function initC2ESC($this, c, esc) {
		    if (!(esc === _Char___init__impl__6a9atx(117))) {
		      // Inline function 'kotlin.code' call
		      var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
		      $this.z1c_1[tmp$ret$0] = numberToChar(c);
		    }
		  }
		  function initC2ESC_0($this, c, esc) {
		    // Inline function 'kotlin.code' call
		    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
		    return initC2ESC($this, tmp$ret$0, esc);
		  }
		  function initC2TC($this, c, cl) {
		    $this.a1d_1[c] = cl;
		  }
		  function initC2TC_0($this, c, cl) {
		    // Inline function 'kotlin.code' call
		    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
		    return initC2TC($this, tmp$ret$0, cl);
		  }
		  function CharMappings() {
		    CharMappings_instance = this;
		    this.z1c_1 = charArray(117);
		    this.a1d_1 = new Int8Array(126);
		    initEscape(this);
		    initCharToToken(this);
		  }
		  var CharMappings_instance;
		  function CharMappings_getInstance() {
		    if (CharMappings_instance == null)
		      new CharMappings();
		    return CharMappings_instance;
		  }
		  function get_specialFlowingValuesHint() {
		    return specialFlowingValuesHint;
		  }
		  var specialFlowingValuesHint;
		  function get_allowStructuredMapKeysHint() {
		    return allowStructuredMapKeysHint;
		  }
		  var allowStructuredMapKeysHint;
		  function StringJsonLexer(source) {
		    AbstractJsonLexer.call(this);
		    this.f1d_1 = source;
		  }
		  protoOf(StringJsonLexer).q1c = function () {
		    return this.f1d_1;
		  };
		  protoOf(StringJsonLexer).r1c = function (position) {
		    return position < this.f1d_1.length ? position : -1;
		  };
		  protoOf(StringJsonLexer).k16 = function () {
		    var source = this.f1d_1;
		    $l$loop: while (!(this.p11_1 === -1) ? this.p11_1 < source.length : false) {
		      var tmp1 = this.p11_1;
		      this.p11_1 = tmp1 + 1 | 0;
		      var ch = charSequenceGet(source, tmp1);
		      var tc = charToTokenClass(ch);
		      var tmp;
		      if (tc === get_TC_WHITESPACE()) {
		        continue $l$loop;
		      } else {
		        tmp = tc;
		      }
		      return tmp;
		    }
		    return get_TC_EOF();
		  };
		  protoOf(StringJsonLexer).v17 = function () {
		    var current = this.x1c();
		    if (current === this.f1d_1.length ? true : current === -1)
		      return false;
		    if (charSequenceGet(this.f1d_1, current) === _Char___init__impl__6a9atx(44)) {
		      this.p11_1 = this.p11_1 + 1 | 0;
		      return true;
		    }
		    return false;
		  };
		  protoOf(StringJsonLexer).g16 = function () {
		    var current = this.p11_1;
		    if (current === -1)
		      return false;
		    $l$loop: while (current < this.f1d_1.length) {
		      var c = charSequenceGet(this.f1d_1, current);
		      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9)) {
		        current = current + 1 | 0;
		        continue $l$loop;
		      }
		      this.p11_1 = current;
		      return this.t1c(c);
		    }
		    this.p11_1 = current;
		    return false;
		  };
		  protoOf(StringJsonLexer).x1c = function () {
		    var current = this.p11_1;
		    if (current === -1)
		      return current;
		    $l$loop: while (current < this.f1d_1.length) {
		      var c = charSequenceGet(this.f1d_1, current);
		      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9)) {
		        current = current + 1 | 0;
		      } else {
		        break $l$loop;
		      }
		    }
		    this.p11_1 = current;
		    return current;
		  };
		  protoOf(StringJsonLexer).u17 = function (expected) {
		    if (this.p11_1 === -1) {
		      this.v1c(expected);
		    }
		    var source = this.f1d_1;
		    $l$loop: while (this.p11_1 < source.length) {
		      var tmp1 = this.p11_1;
		      this.p11_1 = tmp1 + 1 | 0;
		      var c = charSequenceGet(source, tmp1);
		      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9))
		        continue $l$loop;
		      if (c === expected)
		        return Unit_instance;
		      this.v1c(expected);
		    }
		    this.v1c(expected);
		  };
		  protoOf(StringJsonLexer).a18 = function () {
		    this.u17(get_STRING());
		    var current = this.p11_1;
		    var closingQuote = indexOf(this.f1d_1, _Char___init__impl__6a9atx(34), current);
		    if (closingQuote === -1) {
		      this.u1c(get_TC_STRING());
		    }
		    var inductionVariable = current;
		    if (inductionVariable < closingQuote)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        if (charSequenceGet(this.f1d_1, i) === get_STRING_ESC()) {
		          return this.consumeString2(this.f1d_1, this.p11_1, i);
		        }
		      }
		       while (inductionVariable < closingQuote);
		    this.p11_1 = closingQuote + 1 | 0;
		    // Inline function 'kotlin.text.substring' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return this.f1d_1.substring(current, closingQuote);
		  };
		  protoOf(StringJsonLexer).c18 = function (keyToMatch, isLenient) {
		    var positionSnapshot = this.p11_1;
		    try {
		      if (!(this.k16() === get_TC_BEGIN_OBJ()))
		        return null;
		      var firstKey = isLenient ? this.a18() : this.b18();
		      if (firstKey === keyToMatch) {
		        if (!(this.k16() === get_TC_COLON()))
		          return null;
		        var result = isLenient ? this.h16() : this.b18();
		        return result;
		      }
		      return null;
		    }finally {
		      this.p11_1 = positionSnapshot;
		    }
		  };
		  function get_schemaCache(_this__u8e3s4) {
		    return _this__u8e3s4.z10_1;
		  }
		  function JsonToStringWriter() {
		    this.f11_1 = StringBuilder_init_$Create$_0(128);
		  }
		  protoOf(JsonToStringWriter).q14 = function (value) {
		    this.f11_1.z4(value);
		  };
		  protoOf(JsonToStringWriter).k14 = function (char) {
		    this.f11_1.b5(char);
		  };
		  protoOf(JsonToStringWriter).m14 = function (text) {
		    this.f11_1.a5(text);
		  };
		  protoOf(JsonToStringWriter).w14 = function (text) {
		    printQuoted(this.f11_1, text);
		  };
		  protoOf(JsonToStringWriter).g11 = function () {
		    this.f11_1.j7();
		  };
		  protoOf(JsonToStringWriter).toString = function () {
		    return this.f11_1.toString();
		  };
		  function createMapForCache(initialCapacity) {
		    return HashMap_init_$Create$(initialCapacity);
		  }
		  //region block: post-declaration
		  protoOf(defer$1).eh = get_isNullable;
		  protoOf(defer$1).kh = get_isInline;
		  protoOf(defer$1).ih = get_annotations;
		  protoOf(PolymorphismValidator).h10 = contextual;
		  //endregion
		  //region block: init
		  Companion_instance_0 = new Companion();
		  Companion_instance_1 = new Companion_0();
		  Companion_instance_2 = new Companion_1();
		  Companion_instance_3 = new Companion_2();
		  Tombstone_instance = new Tombstone();
		  PRIMITIVE_TAG = 'primitive';
		  TC_WHITESPACE = 3;
		  TC_EOF = 10;
		  STRING = _Char___init__impl__6a9atx(34);
		  TC_STRING = 1;
		  STRING_ESC = _Char___init__impl__6a9atx(92);
		  TC_BEGIN_OBJ = 6;
		  TC_COLON = 5;
		  TC_COMMA = 4;
		  COLON = _Char___init__impl__6a9atx(58);
		  BEGIN_OBJ = _Char___init__impl__6a9atx(123);
		  END_OBJ = _Char___init__impl__6a9atx(125);
		  BEGIN_LIST = _Char___init__impl__6a9atx(91);
		  END_LIST = _Char___init__impl__6a9atx(93);
		  lenientHint = "Use 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.";
		  INVALID = _Char___init__impl__6a9atx(0);
		  COMMA = _Char___init__impl__6a9atx(44);
		  NULL = 'null';
		  TC_END_OBJ = 7;
		  TC_BEGIN_LIST = 8;
		  TC_END_LIST = 9;
		  TC_OTHER = 0;
		  ignoreUnknownKeysHint = "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.";
		  specialFlowingValuesHint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
		  allowStructuredMapKeysHint = "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.";
		  //endregion
		  //region block: exports
		  _.$_$ = _.$_$ || {};
		  _.$_$.a = Default_getInstance;
		  _.$_$.b = JsonNull_getInstance;
		  _.$_$.c = Companion_instance_1;
		  _.$_$.d = JsonObjectSerializer_getInstance;
		  _.$_$.e = JsonArray;
		  _.$_$.f = JsonContentPolymorphicSerializer;
		  _.$_$.g = JsonElement;
		  _.$_$.h = JsonObjectBuilder;
		  _.$_$.i = JsonObject;
		  _.$_$.j = JsonPrimitive_2;
		  _.$_$.k = JsonPrimitive_0;
		  _.$_$.l = JsonPrimitive_1;
		  _.$_$.m = Json_0;
		  _.$_$.n = get_jsonObject;
		  _.$_$.o = get_jsonPrimitive;
		  _.$_$.p = putJsonObject;
		  _.$_$.q = put;
		  //endregion
		  return _;
		}));

		
} (kotlinxSerializationKotlinxSerializationJsonJsIr, kotlinxSerializationKotlinxSerializationJsonJsIrExports));
	return kotlinxSerializationKotlinxSerializationJsonJsIrExports;
}

var KotlinDateTimeLibraryKotlinxDatetimeJsIrExports = {};
var KotlinDateTimeLibraryKotlinxDatetimeJsIr = {
  get exports(){ return KotlinDateTimeLibraryKotlinxDatetimeJsIrExports; },
  set exports(v){ KotlinDateTimeLibraryKotlinxDatetimeJsIrExports = v; },
};

//! @version @js-joda/core - 5.6.1
//! @copyright (c) 2015-present, Philipp Thürwächter, Pattrick Hüper & js-joda contributors
//! @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
//! @license BSD-3-Clause (see LICENSE in the root directory of this source tree)

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */

function createErrorType(name, init, superErrorClass) {
  if (superErrorClass === void 0) {
    superErrorClass = Error;
  }
  function JsJodaException(message) {
    if (!Error.captureStackTrace) {
      this.stack = new Error().stack;
    } else {
      Error.captureStackTrace(this, this.constructor);
    }
    this.message = message;
    init && init.apply(this, arguments);
    this.toString = function () {
      return this.name + ": " + this.message;
    };
  }
  JsJodaException.prototype = Object.create(superErrorClass.prototype);
  JsJodaException.prototype.name = name;
  JsJodaException.prototype.constructor = JsJodaException;
  return JsJodaException;
}
var DateTimeException = createErrorType('DateTimeException', messageWithCause);
var DateTimeParseException = createErrorType('DateTimeParseException', messageForDateTimeParseException);
var UnsupportedTemporalTypeException = createErrorType('UnsupportedTemporalTypeException', null, DateTimeException);
var ArithmeticException = createErrorType('ArithmeticException');
var IllegalArgumentException = createErrorType('IllegalArgumentException');
var IllegalStateException = createErrorType('IllegalStateException');
var NullPointerException = createErrorType('NullPointerException');
function messageWithCause(message, cause) {
  if (cause === void 0) {
    cause = null;
  }
  var msg = message || this.name;
  if (cause !== null && cause instanceof Error) {
    msg += "\n-------\nCaused by: " + cause.stack + "\n-------\n";
  }
  this.message = msg;
}
function messageForDateTimeParseException(message, text, index, cause) {
  if (text === void 0) {
    text = '';
  }
  if (index === void 0) {
    index = 0;
  }
  if (cause === void 0) {
    cause = null;
  }
  var msg = message || this.name;
  msg += ": " + text + ", at index: " + index;
  if (cause !== null && cause instanceof Error) {
    msg += "\n-------\nCaused by: " + cause.stack + "\n-------\n";
  }
  this.message = msg;
  this.parsedString = function () {
    return text;
  };
  this.errorIndex = function () {
    return index;
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
function assert(assertion, msg, error) {
  if (!assertion) {
    if (error) {
      throw new error(msg);
    } else {
      throw new Error(msg);
    }
  }
}
function requireNonNull(value, parameterName) {
  if (value == null) {
    throw new NullPointerException(parameterName + " must not be null");
  }
  return value;
}
function requireInstance(value, _class, parameterName) {
  if (!(value instanceof _class)) {
    throw new IllegalArgumentException(parameterName + " must be an instance of " + (_class.name ? _class.name : _class) + (value && value.constructor && value.constructor.name ? ", but is " + value.constructor.name : ''));
  }
  return value;
}
function abstractMethodFail(methodName) {
  throw new TypeError("abstract method \"" + methodName + "\" is not implemented");
}

var assert$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    assert: assert,
    requireNonNull: requireNonNull,
    requireInstance: requireInstance,
    abstractMethodFail: abstractMethodFail
});

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var MAX_SAFE_INTEGER = 9007199254740991;
var MIN_SAFE_INTEGER = -9007199254740991;
var MathUtil = function () {
  function MathUtil() {}
  MathUtil.intDiv = function intDiv(x, y) {
    var r = x / y;
    r = MathUtil.roundDown(r);
    return MathUtil.safeZero(r);
  };
  MathUtil.intMod = function intMod(x, y) {
    var r = x - MathUtil.intDiv(x, y) * y;
    r = MathUtil.roundDown(r);
    return MathUtil.safeZero(r);
  };
  MathUtil.roundDown = function roundDown(r) {
    if (r < 0) {
      return Math.ceil(r);
    } else {
      return Math.floor(r);
    }
  };
  MathUtil.floorDiv = function floorDiv(x, y) {
    var r = Math.floor(x / y);
    return MathUtil.safeZero(r);
  };
  MathUtil.floorMod = function floorMod(x, y) {
    var r = x - MathUtil.floorDiv(x, y) * y;
    return MathUtil.safeZero(r);
  };
  MathUtil.safeAdd = function safeAdd(x, y) {
    MathUtil.verifyInt(x);
    MathUtil.verifyInt(y);
    if (x === 0) {
      return MathUtil.safeZero(y);
    }
    if (y === 0) {
      return MathUtil.safeZero(x);
    }
    var r = MathUtil.safeToInt(x + y);
    if (r === x || r === y) {
      throw new ArithmeticException('Invalid addition beyond MAX_SAFE_INTEGER!');
    }
    return r;
  };
  MathUtil.safeSubtract = function safeSubtract(x, y) {
    MathUtil.verifyInt(x);
    MathUtil.verifyInt(y);
    if (x === 0 && y === 0) {
      return 0;
    } else if (x === 0) {
      return MathUtil.safeZero(-1 * y);
    } else if (y === 0) {
      return MathUtil.safeZero(x);
    }
    return MathUtil.safeToInt(x - y);
  };
  MathUtil.safeMultiply = function safeMultiply(x, y) {
    MathUtil.verifyInt(x);
    MathUtil.verifyInt(y);
    if (x === 1) {
      return MathUtil.safeZero(y);
    }
    if (y === 1) {
      return MathUtil.safeZero(x);
    }
    if (x === 0 || y === 0) {
      return 0;
    }
    var r = MathUtil.safeToInt(x * y);
    if (r / y !== x || x === MIN_SAFE_INTEGER && y === -1 || y === MIN_SAFE_INTEGER && x === -1) {
      throw new ArithmeticException("Multiplication overflows: " + x + " * " + y);
    }
    return r;
  };
  MathUtil.parseInt = function (_parseInt) {
    function parseInt(_x) {
      return _parseInt.apply(this, arguments);
    }
    parseInt.toString = function () {
      return _parseInt.toString();
    };
    return parseInt;
  }(function (value) {
    var r = parseInt(value);
    return MathUtil.safeToInt(r);
  });
  MathUtil.safeToInt = function safeToInt(value) {
    MathUtil.verifyInt(value);
    return MathUtil.safeZero(value);
  };
  MathUtil.verifyInt = function verifyInt(value) {
    if (value == null) {
      throw new ArithmeticException("Invalid value: '" + value + "', using null or undefined as argument");
    }
    if (isNaN(value)) {
      throw new ArithmeticException('Invalid int value, using NaN as argument');
    }
    if (value % 1 !== 0) {
      throw new ArithmeticException("Invalid value: '" + value + "' is a float");
    }
    if (value > MAX_SAFE_INTEGER || value < MIN_SAFE_INTEGER) {
      throw new ArithmeticException("Calculation overflows an int: " + value);
    }
  };
  MathUtil.safeZero = function safeZero(value) {
    return value === 0 ? 0 : +value;
  };
  MathUtil.compareNumbers = function compareNumbers(a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };
  MathUtil.smi = function smi(int) {
    return int >>> 1 & 0x40000000 | int & 0xBFFFFFFF;
  };
  MathUtil.hash = function hash(number) {
    if (number !== number || number === Infinity) {
      return 0;
    }
    var result = number;
    while (number > 0xFFFFFFFF) {
      number /= 0xFFFFFFFF;
      result ^= number;
    }
    return MathUtil.smi(result);
  };
  MathUtil.hashCode = function hashCode() {
    var result = 17;
    for (var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++) {
      numbers[_key] = arguments[_key];
    }
    for (var _i = 0, _numbers = numbers; _i < _numbers.length; _i++) {
      var n = _numbers[_i];
      result = (result << 5) - result + MathUtil.hash(n);
    }
    return MathUtil.hash(result);
  };
  return MathUtil;
}();
MathUtil.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
MathUtil.MIN_SAFE_INTEGER = MIN_SAFE_INTEGER;

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */var Enum = function () {
  function Enum(name) {
    this._name = name;
  }
  var _proto = Enum.prototype;
  _proto.equals = function equals(other) {
    return this === other;
  };
  _proto.toString = function toString() {
    return this._name;
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  return Enum;
}();

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var TemporalAmount = function () {
  function TemporalAmount() {}
  var _proto = TemporalAmount.prototype;
  _proto.get = function get(unit) {
    abstractMethodFail('get');
  };
  _proto.units = function units() {
    abstractMethodFail('units');
  };
  _proto.addTo = function addTo(temporal) {
    abstractMethodFail('addTo');
  };
  _proto.subtractFrom = function subtractFrom(temporal) {
    abstractMethodFail('subtractFrom');
  };
  return TemporalAmount;
}();
if (typeof Symbol !== 'undefined' && Symbol.toPrimitive) {
  TemporalAmount.prototype[Symbol.toPrimitive] = function (hint) {
    if (hint !== 'number') {
      return this.toString();
    }
    throw new TypeError('A conversion from TemporalAmount to a number is not allowed. ' + 'To compare use the methods .equals(), .compareTo(), .isBefore() ' + 'or one that is more suitable to your use case.');
  };
}

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var TemporalUnit = function () {
  function TemporalUnit() {}
  var _proto = TemporalUnit.prototype;
  _proto.duration = function duration() {
    abstractMethodFail('duration');
  };
  _proto.isDurationEstimated = function isDurationEstimated() {
    abstractMethodFail('isDurationEstimated');
  };
  _proto.isDateBased = function isDateBased() {
    abstractMethodFail('isDateBased');
  };
  _proto.isTimeBased = function isTimeBased() {
    abstractMethodFail('isTimeBased');
  };
  _proto.isSupportedBy = function isSupportedBy(temporal) {
    abstractMethodFail('isSupportedBy');
  };
  _proto.addTo = function addTo(dateTime, periodToAdd) {
    abstractMethodFail('addTo');
  };
  _proto.between = function between(temporal1, temporal2) {
    abstractMethodFail('between');
  };
  return TemporalUnit;
}();

var Duration = function (_TemporalAmount) {
  _inheritsLoose(Duration, _TemporalAmount);
  function Duration(seconds, nanos) {
    var _this;
    _this = _TemporalAmount.call(this) || this;
    _this._seconds = MathUtil.safeToInt(seconds);
    _this._nanos = MathUtil.safeToInt(nanos);
    return _this;
  }
  Duration.ofDays = function ofDays(days) {
    return Duration._create(MathUtil.safeMultiply(days, LocalTime.SECONDS_PER_DAY), 0);
  };
  Duration.ofHours = function ofHours(hours) {
    return Duration._create(MathUtil.safeMultiply(hours, LocalTime.SECONDS_PER_HOUR), 0);
  };
  Duration.ofMinutes = function ofMinutes(minutes) {
    return Duration._create(MathUtil.safeMultiply(minutes, LocalTime.SECONDS_PER_MINUTE), 0);
  };
  Duration.ofSeconds = function ofSeconds(seconds, nanoAdjustment) {
    if (nanoAdjustment === void 0) {
      nanoAdjustment = 0;
    }
    var secs = MathUtil.safeAdd(seconds, MathUtil.floorDiv(nanoAdjustment, LocalTime.NANOS_PER_SECOND));
    var nos = MathUtil.floorMod(nanoAdjustment, LocalTime.NANOS_PER_SECOND);
    return Duration._create(secs, nos);
  };
  Duration.ofMillis = function ofMillis(millis) {
    var secs = MathUtil.intDiv(millis, 1000);
    var mos = MathUtil.intMod(millis, 1000);
    if (mos < 0) {
      mos += 1000;
      secs--;
    }
    return Duration._create(secs, mos * 1000000);
  };
  Duration.ofNanos = function ofNanos(nanos) {
    var secs = MathUtil.intDiv(nanos, LocalTime.NANOS_PER_SECOND);
    var nos = MathUtil.intMod(nanos, LocalTime.NANOS_PER_SECOND);
    if (nos < 0) {
      nos += LocalTime.NANOS_PER_SECOND;
      secs--;
    }
    return this._create(secs, nos);
  };
  Duration.of = function of(amount, unit) {
    return Duration.ZERO.plus(amount, unit);
  };
  Duration.from = function from(amount) {
    requireNonNull(amount, 'amount');
    requireInstance(amount, TemporalAmount);
    var duration = Duration.ZERO;
    amount.units().forEach(function (unit) {
      duration = duration.plus(amount.get(unit), unit);
    });
    return duration;
  };
  Duration.between = function between(startInclusive, endExclusive) {
    requireNonNull(startInclusive, 'startInclusive');
    requireNonNull(endExclusive, 'endExclusive');
    var secs = startInclusive.until(endExclusive, ChronoUnit.SECONDS);
    var nanos = 0;
    if (startInclusive.isSupported(ChronoField.NANO_OF_SECOND) && endExclusive.isSupported(ChronoField.NANO_OF_SECOND)) {
      try {
        var startNos = startInclusive.getLong(ChronoField.NANO_OF_SECOND);
        nanos = endExclusive.getLong(ChronoField.NANO_OF_SECOND) - startNos;
        if (secs > 0 && nanos < 0) {
          nanos += LocalTime.NANOS_PER_SECOND;
        } else if (secs < 0 && nanos > 0) {
          nanos -= LocalTime.NANOS_PER_SECOND;
        } else if (secs === 0 && nanos !== 0) {
          var adjustedEnd = endExclusive.with(ChronoField.NANO_OF_SECOND, startNos);
          secs = startInclusive.until(adjustedEnd, ChronoUnit.SECONDS);
        }
      } catch (e) {}
    }
    return this.ofSeconds(secs, nanos);
  };
  Duration.parse = function parse(text) {
    requireNonNull(text, 'text');
    var PATTERN = new RegExp('([-+]?)P(?:([-+]?[0-9]+)D)?(T(?:([-+]?[0-9]+)H)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)(?:[.,]([0-9]{0,9}))?S)?)?', 'i');
    var matches = PATTERN.exec(text);
    if (matches !== null) {
      if ('T' === matches[3] === false) {
        var negate = '-' === matches[1];
        var dayMatch = matches[2];
        var hourMatch = matches[4];
        var minuteMatch = matches[5];
        var secondMatch = matches[6];
        var fractionMatch = matches[7];
        if (dayMatch != null || hourMatch != null || minuteMatch != null || secondMatch != null) {
          var daysAsSecs = Duration._parseNumber(text, dayMatch, LocalTime.SECONDS_PER_DAY, 'days');
          var hoursAsSecs = Duration._parseNumber(text, hourMatch, LocalTime.SECONDS_PER_HOUR, 'hours');
          var minsAsSecs = Duration._parseNumber(text, minuteMatch, LocalTime.SECONDS_PER_MINUTE, 'minutes');
          var seconds = Duration._parseNumber(text, secondMatch, 1, 'seconds');
          var negativeSecs = secondMatch != null && secondMatch.charAt(0) === '-';
          var nanos = Duration._parseFraction(text, fractionMatch, negativeSecs ? -1 : 1);
          try {
            return Duration._create(negate, daysAsSecs, hoursAsSecs, minsAsSecs, seconds, nanos);
          } catch (ex) {
            throw new DateTimeParseException('Text cannot be parsed to a Duration: overflow', text, 0, ex);
          }
        }
      }
    }
    throw new DateTimeParseException('Text cannot be parsed to a Duration', text, 0);
  };
  Duration._parseNumber = function _parseNumber(text, parsed, multiplier, errorText) {
    if (parsed == null) {
      return 0;
    }
    try {
      if (parsed[0] === '+') {
        parsed = parsed.substring(1);
      }
      return MathUtil.safeMultiply(parseFloat(parsed), multiplier);
    } catch (ex) {
      throw new DateTimeParseException("Text cannot be parsed to a Duration: " + errorText, text, 0, ex);
    }
  };
  Duration._parseFraction = function _parseFraction(text, parsed, negate) {
    if (parsed == null || parsed.length === 0) {
      return 0;
    }
    parsed = (parsed + "000000000").substring(0, 9);
    return parseFloat(parsed) * negate;
  };
  Duration._create = function _create() {
    if (arguments.length <= 2) {
      return Duration._createSecondsNanos(arguments[0], arguments[1]);
    } else {
      return Duration._createNegateDaysHoursMinutesSecondsNanos(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    }
  };
  Duration._createNegateDaysHoursMinutesSecondsNanos = function _createNegateDaysHoursMinutesSecondsNanos(negate, daysAsSecs, hoursAsSecs, minsAsSecs, secs, nanos) {
    var seconds = MathUtil.safeAdd(daysAsSecs, MathUtil.safeAdd(hoursAsSecs, MathUtil.safeAdd(minsAsSecs, secs)));
    if (negate) {
      return Duration.ofSeconds(seconds, nanos).negated();
    }
    return Duration.ofSeconds(seconds, nanos);
  };
  Duration._createSecondsNanos = function _createSecondsNanos(seconds, nanoAdjustment) {
    if (seconds === void 0) {
      seconds = 0;
    }
    if (nanoAdjustment === void 0) {
      nanoAdjustment = 0;
    }
    if (seconds === 0 && nanoAdjustment === 0) {
      return Duration.ZERO;
    }
    return new Duration(seconds, nanoAdjustment);
  };
  var _proto = Duration.prototype;
  _proto.get = function get(unit) {
    if (unit === ChronoUnit.SECONDS) {
      return this._seconds;
    } else if (unit === ChronoUnit.NANOS) {
      return this._nanos;
    } else {
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
  };
  _proto.units = function units() {
    return [ChronoUnit.SECONDS, ChronoUnit.NANOS];
  };
  _proto.isZero = function isZero() {
    return this._seconds === 0 && this._nanos === 0;
  };
  _proto.isNegative = function isNegative() {
    return this._seconds < 0;
  };
  _proto.seconds = function seconds() {
    return this._seconds;
  };
  _proto.nano = function nano() {
    return this._nanos;
  };
  _proto.withSeconds = function withSeconds(seconds) {
    return Duration._create(seconds, this._nanos);
  };
  _proto.withNanos = function withNanos(nanoOfSecond) {
    ChronoField.NANO_OF_SECOND.checkValidIntValue(nanoOfSecond);
    return Duration._create(this._seconds, nanoOfSecond);
  };
  _proto.plusDuration = function plusDuration(duration) {
    requireNonNull(duration, 'duration');
    return this.plus(duration.seconds(), duration.nano());
  };
  _proto.plus = function plus(durationOrNumber, unitOrNumber) {
    if (arguments.length === 1) {
      return this.plusDuration(durationOrNumber);
    } else if (arguments.length === 2 && unitOrNumber instanceof TemporalUnit) {
      return this.plusAmountUnit(durationOrNumber, unitOrNumber);
    } else {
      return this.plusSecondsNanos(durationOrNumber, unitOrNumber);
    }
  };
  _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
    requireNonNull(amountToAdd, 'amountToAdd');
    requireNonNull(unit, 'unit');
    if (unit === ChronoUnit.DAYS) {
      return this.plusSecondsNanos(MathUtil.safeMultiply(amountToAdd, LocalTime.SECONDS_PER_DAY), 0);
    }
    if (unit.isDurationEstimated()) {
      throw new UnsupportedTemporalTypeException('Unit must not have an estimated duration');
    }
    if (amountToAdd === 0) {
      return this;
    }
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.NANOS:
          return this.plusNanos(amountToAdd);
        case ChronoUnit.MICROS:
          return this.plusSecondsNanos(MathUtil.intDiv(amountToAdd, 1000000 * 1000) * 1000, MathUtil.intMod(amountToAdd, 1000000 * 1000) * 1000);
        case ChronoUnit.MILLIS:
          return this.plusMillis(amountToAdd);
        case ChronoUnit.SECONDS:
          return this.plusSeconds(amountToAdd);
      }
      return this.plusSecondsNanos(MathUtil.safeMultiply(unit.duration().seconds(), amountToAdd), 0);
    }
    var duration = unit.duration().multipliedBy(amountToAdd);
    return this.plusSecondsNanos(duration.seconds(), duration.nano());
  };
  _proto.plusDays = function plusDays(daysToAdd) {
    return this.plusSecondsNanos(MathUtil.safeMultiply(daysToAdd, LocalTime.SECONDS_PER_DAY), 0);
  };
  _proto.plusHours = function plusHours(hoursToAdd) {
    return this.plusSecondsNanos(MathUtil.safeMultiply(hoursToAdd, LocalTime.SECONDS_PER_HOUR), 0);
  };
  _proto.plusMinutes = function plusMinutes(minutesToAdd) {
    return this.plusSecondsNanos(MathUtil.safeMultiply(minutesToAdd, LocalTime.SECONDS_PER_MINUTE), 0);
  };
  _proto.plusSeconds = function plusSeconds(secondsToAdd) {
    return this.plusSecondsNanos(secondsToAdd, 0);
  };
  _proto.plusMillis = function plusMillis(millisToAdd) {
    return this.plusSecondsNanos(MathUtil.intDiv(millisToAdd, 1000), MathUtil.intMod(millisToAdd, 1000) * 1000000);
  };
  _proto.plusNanos = function plusNanos(nanosToAdd) {
    return this.plusSecondsNanos(0, nanosToAdd);
  };
  _proto.plusSecondsNanos = function plusSecondsNanos(secondsToAdd, nanosToAdd) {
    requireNonNull(secondsToAdd, 'secondsToAdd');
    requireNonNull(nanosToAdd, 'nanosToAdd');
    if (secondsToAdd === 0 && nanosToAdd === 0) {
      return this;
    }
    var epochSec = MathUtil.safeAdd(this._seconds, secondsToAdd);
    epochSec = MathUtil.safeAdd(epochSec, MathUtil.intDiv(nanosToAdd, LocalTime.NANOS_PER_SECOND));
    nanosToAdd = MathUtil.intMod(nanosToAdd, LocalTime.NANOS_PER_SECOND);
    var nanoAdjustment = MathUtil.safeAdd(this._nanos, nanosToAdd);
    return Duration.ofSeconds(epochSec, nanoAdjustment);
  };
  _proto.minus = function minus(durationOrNumber, unit) {
    if (arguments.length === 1) {
      return this.minusDuration(durationOrNumber);
    } else {
      return this.minusAmountUnit(durationOrNumber, unit);
    }
  };
  _proto.minusDuration = function minusDuration(duration) {
    requireNonNull(duration, 'duration');
    var secsToSubtract = duration.seconds();
    var nanosToSubtract = duration.nano();
    if (secsToSubtract === MIN_SAFE_INTEGER) {
      return this.plus(MAX_SAFE_INTEGER, -nanosToSubtract);
    }
    return this.plus(-secsToSubtract, -nanosToSubtract);
  };
  _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
    requireNonNull(amountToSubtract, 'amountToSubtract');
    requireNonNull(unit, 'unit');
    return amountToSubtract === MIN_SAFE_INTEGER ? this.plusAmountUnit(MAX_SAFE_INTEGER, unit) : this.plusAmountUnit(-amountToSubtract, unit);
  };
  _proto.minusDays = function minusDays(daysToSubtract) {
    return daysToSubtract === MIN_SAFE_INTEGER ? this.plusDays(MAX_SAFE_INTEGER) : this.plusDays(-daysToSubtract);
  };
  _proto.minusHours = function minusHours(hoursToSubtract) {
    return hoursToSubtract === MIN_SAFE_INTEGER ? this.plusHours(MAX_SAFE_INTEGER) : this.plusHours(-hoursToSubtract);
  };
  _proto.minusMinutes = function minusMinutes(minutesToSubtract) {
    return minutesToSubtract === MIN_SAFE_INTEGER ? this.plusMinutes(MAX_SAFE_INTEGER) : this.plusMinutes(-minutesToSubtract);
  };
  _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
    return secondsToSubtract === MIN_SAFE_INTEGER ? this.plusSeconds(MAX_SAFE_INTEGER) : this.plusSeconds(-secondsToSubtract);
  };
  _proto.minusMillis = function minusMillis(millisToSubtract) {
    return millisToSubtract === MIN_SAFE_INTEGER ? this.plusMillis(MAX_SAFE_INTEGER) : this.plusMillis(-millisToSubtract);
  };
  _proto.minusNanos = function minusNanos(nanosToSubtract) {
    return nanosToSubtract === MIN_SAFE_INTEGER ? this.plusNanos(MAX_SAFE_INTEGER) : this.plusNanos(-nanosToSubtract);
  };
  _proto.multipliedBy = function multipliedBy(multiplicand) {
    if (multiplicand === 0) {
      return Duration.ZERO;
    }
    if (multiplicand === 1) {
      return this;
    }
    var secs = MathUtil.safeMultiply(this._seconds, multiplicand);
    var nos = MathUtil.safeMultiply(this._nanos, multiplicand);
    secs = secs + MathUtil.intDiv(nos, LocalTime.NANOS_PER_SECOND);
    nos = MathUtil.intMod(nos, LocalTime.NANOS_PER_SECOND);
    return Duration.ofSeconds(secs, nos);
  };
  _proto.dividedBy = function dividedBy(divisor) {
    if (divisor === 0) {
      throw new ArithmeticException('Cannot divide by zero');
    }
    if (divisor === 1) {
      return this;
    }
    var secs = MathUtil.intDiv(this._seconds, divisor);
    var secsMod = MathUtil.roundDown((this._seconds / divisor - secs) * LocalTime.NANOS_PER_SECOND);
    var nos = MathUtil.intDiv(this._nanos, divisor);
    nos = secsMod + nos;
    return Duration.ofSeconds(secs, nos);
  };
  _proto.negated = function negated() {
    return this.multipliedBy(-1);
  };
  _proto.abs = function abs() {
    return this.isNegative() ? this.negated() : this;
  };
  _proto.addTo = function addTo(temporal) {
    requireNonNull(temporal, 'temporal');
    if (this._seconds !== 0) {
      temporal = temporal.plus(this._seconds, ChronoUnit.SECONDS);
    }
    if (this._nanos !== 0) {
      temporal = temporal.plus(this._nanos, ChronoUnit.NANOS);
    }
    return temporal;
  };
  _proto.subtractFrom = function subtractFrom(temporal) {
    requireNonNull(temporal, 'temporal');
    if (this._seconds !== 0) {
      temporal = temporal.minus(this._seconds, ChronoUnit.SECONDS);
    }
    if (this._nanos !== 0) {
      temporal = temporal.minus(this._nanos, ChronoUnit.NANOS);
    }
    return temporal;
  };
  _proto.toDays = function toDays() {
    return MathUtil.intDiv(this._seconds, LocalTime.SECONDS_PER_DAY);
  };
  _proto.toHours = function toHours() {
    return MathUtil.intDiv(this._seconds, LocalTime.SECONDS_PER_HOUR);
  };
  _proto.toMinutes = function toMinutes() {
    return MathUtil.intDiv(this._seconds, LocalTime.SECONDS_PER_MINUTE);
  };
  _proto.toMillis = function toMillis() {
    var millis = Math.round(MathUtil.safeMultiply(this._seconds, 1000));
    millis = MathUtil.safeAdd(millis, MathUtil.intDiv(this._nanos, 1000000));
    return millis;
  };
  _proto.toNanos = function toNanos() {
    var totalNanos = MathUtil.safeMultiply(this._seconds, LocalTime.NANOS_PER_SECOND);
    totalNanos = MathUtil.safeAdd(totalNanos, this._nanos);
    return totalNanos;
  };
  _proto.compareTo = function compareTo(otherDuration) {
    requireNonNull(otherDuration, 'otherDuration');
    requireInstance(otherDuration, Duration, 'otherDuration');
    var cmp = MathUtil.compareNumbers(this._seconds, otherDuration.seconds());
    if (cmp !== 0) {
      return cmp;
    }
    return this._nanos - otherDuration.nano();
  };
  _proto.equals = function equals(otherDuration) {
    if (this === otherDuration) {
      return true;
    }
    if (otherDuration instanceof Duration) {
      return this.seconds() === otherDuration.seconds() && this.nano() === otherDuration.nano();
    }
    return false;
  };
  _proto.toString = function toString() {
    if (this === Duration.ZERO) {
      return 'PT0S';
    }
    var hours = MathUtil.intDiv(this._seconds, LocalTime.SECONDS_PER_HOUR);
    var minutes = MathUtil.intDiv(MathUtil.intMod(this._seconds, LocalTime.SECONDS_PER_HOUR), LocalTime.SECONDS_PER_MINUTE);
    var secs = MathUtil.intMod(this._seconds, LocalTime.SECONDS_PER_MINUTE);
    var rval = 'PT';
    if (hours !== 0) {
      rval += hours + "H";
    }
    if (minutes !== 0) {
      rval += minutes + "M";
    }
    if (secs === 0 && this._nanos === 0 && rval.length > 2) {
      return rval;
    }
    if (secs < 0 && this._nanos > 0) {
      if (secs === -1) {
        rval += '-0';
      } else {
        rval += secs + 1;
      }
    } else {
      rval += secs;
    }
    if (this._nanos > 0) {
      rval += '.';
      var nanoString;
      if (secs < 0) {
        nanoString = "" + (2 * LocalTime.NANOS_PER_SECOND - this._nanos);
      } else {
        nanoString = "" + (LocalTime.NANOS_PER_SECOND + this._nanos);
      }
      nanoString = nanoString.slice(1, nanoString.length);
      rval += nanoString;
      while (rval.charAt(rval.length - 1) === '0') {
        rval = rval.slice(0, rval.length - 1);
      }
    }
    rval += 'S';
    return rval;
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  return Duration;
}(TemporalAmount);
function _init$n() {
  Duration.ZERO = new Duration(0, 0);
}

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE.md in the root directory of this source tree)
 */var YearConstants = function YearConstants() {};
function _init$m() {
  YearConstants.MIN_VALUE = -999999;
  YearConstants.MAX_VALUE = 999999;
}

var ChronoUnit = function (_TemporalUnit) {
  _inheritsLoose(ChronoUnit, _TemporalUnit);
  function ChronoUnit(name, estimatedDuration) {
    var _this;
    _this = _TemporalUnit.call(this) || this;
    _this._name = name;
    _this._duration = estimatedDuration;
    return _this;
  }
  var _proto = ChronoUnit.prototype;
  _proto.duration = function duration() {
    return this._duration;
  };
  _proto.isDurationEstimated = function isDurationEstimated() {
    return this.isDateBased() || this === ChronoUnit.FOREVER;
  };
  _proto.isDateBased = function isDateBased() {
    return this.compareTo(ChronoUnit.DAYS) >= 0 && this !== ChronoUnit.FOREVER;
  };
  _proto.isTimeBased = function isTimeBased() {
    return this.compareTo(ChronoUnit.DAYS) < 0;
  };
  _proto.isSupportedBy = function isSupportedBy(temporal) {
    if (this === ChronoUnit.FOREVER) {
      return false;
    }
    try {
      temporal.plus(1, this);
      return true;
    } catch (e) {
      try {
        temporal.plus(-1, this);
        return true;
      } catch (e2) {
        return false;
      }
    }
  };
  _proto.addTo = function addTo(temporal, amount) {
    return temporal.plus(amount, this);
  };
  _proto.between = function between(temporal1, temporal2) {
    return temporal1.until(temporal2, this);
  };
  _proto.toString = function toString() {
    return this._name;
  };
  _proto.compareTo = function compareTo(other) {
    return this.duration().compareTo(other.duration());
  };
  return ChronoUnit;
}(TemporalUnit);
function _init$l() {
  ChronoUnit.NANOS = new ChronoUnit('Nanos', Duration.ofNanos(1));
  ChronoUnit.MICROS = new ChronoUnit('Micros', Duration.ofNanos(1000));
  ChronoUnit.MILLIS = new ChronoUnit('Millis', Duration.ofNanos(1000000));
  ChronoUnit.SECONDS = new ChronoUnit('Seconds', Duration.ofSeconds(1));
  ChronoUnit.MINUTES = new ChronoUnit('Minutes', Duration.ofSeconds(60));
  ChronoUnit.HOURS = new ChronoUnit('Hours', Duration.ofSeconds(3600));
  ChronoUnit.HALF_DAYS = new ChronoUnit('HalfDays', Duration.ofSeconds(43200));
  ChronoUnit.DAYS = new ChronoUnit('Days', Duration.ofSeconds(86400));
  ChronoUnit.WEEKS = new ChronoUnit('Weeks', Duration.ofSeconds(7 * 86400));
  ChronoUnit.MONTHS = new ChronoUnit('Months', Duration.ofSeconds(31556952 / 12));
  ChronoUnit.YEARS = new ChronoUnit('Years', Duration.ofSeconds(31556952));
  ChronoUnit.DECADES = new ChronoUnit('Decades', Duration.ofSeconds(31556952 * 10));
  ChronoUnit.CENTURIES = new ChronoUnit('Centuries', Duration.ofSeconds(31556952 * 100));
  ChronoUnit.MILLENNIA = new ChronoUnit('Millennia', Duration.ofSeconds(31556952 * 1000));
  ChronoUnit.ERAS = new ChronoUnit('Eras', Duration.ofSeconds(31556952 * (YearConstants.MAX_VALUE + 1)));
  ChronoUnit.FOREVER = new ChronoUnit('Forever', Duration.ofSeconds(MathUtil.MAX_SAFE_INTEGER, 999999999));
}

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var TemporalField = function () {
  function TemporalField() {}
  var _proto = TemporalField.prototype;
  _proto.isDateBased = function isDateBased() {
    abstractMethodFail('isDateBased');
  };
  _proto.isTimeBased = function isTimeBased() {
    abstractMethodFail('isTimeBased');
  };
  _proto.baseUnit = function baseUnit() {
    abstractMethodFail('baseUnit');
  };
  _proto.rangeUnit = function rangeUnit() {
    abstractMethodFail('rangeUnit');
  };
  _proto.range = function range() {
    abstractMethodFail('range');
  };
  _proto.rangeRefinedBy = function rangeRefinedBy(temporal) {
    abstractMethodFail('rangeRefinedBy');
  };
  _proto.getFrom = function getFrom(temporal) {
    abstractMethodFail('getFrom');
  };
  _proto.adjustInto = function adjustInto(temporal, newValue) {
    abstractMethodFail('adjustInto');
  };
  _proto.isSupportedBy = function isSupportedBy(temporal) {
    abstractMethodFail('isSupportedBy');
  };
  _proto.displayName = function displayName() {
    abstractMethodFail('displayName');
  };
  _proto.equals = function equals(other) {
    abstractMethodFail('equals');
  };
  _proto.name = function name() {
    abstractMethodFail('name');
  };
  return TemporalField;
}();

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var ValueRange = function () {
  function ValueRange(minSmallest, minLargest, maxSmallest, maxLargest) {
    assert(!(minSmallest > minLargest), "Smallest minimum value '" + minSmallest + "' must be less than largest minimum value '" + minLargest + "'", IllegalArgumentException);
    assert(!(maxSmallest > maxLargest), "Smallest maximum value '" + maxSmallest + "' must be less than largest maximum value '" + maxLargest + "'", IllegalArgumentException);
    assert(!(minLargest > maxLargest), "Minimum value '" + minLargest + "' must be less than maximum value '" + maxLargest + "'", IllegalArgumentException);
    this._minSmallest = minSmallest;
    this._minLargest = minLargest;
    this._maxLargest = maxLargest;
    this._maxSmallest = maxSmallest;
  }
  var _proto = ValueRange.prototype;
  _proto.isFixed = function isFixed() {
    return this._minSmallest === this._minLargest && this._maxSmallest === this._maxLargest;
  };
  _proto.minimum = function minimum() {
    return this._minSmallest;
  };
  _proto.largestMinimum = function largestMinimum() {
    return this._minLargest;
  };
  _proto.maximum = function maximum() {
    return this._maxLargest;
  };
  _proto.smallestMaximum = function smallestMaximum() {
    return this._maxSmallest;
  };
  _proto.isValidValue = function isValidValue(value) {
    return this.minimum() <= value && value <= this.maximum();
  };
  _proto.checkValidValue = function checkValidValue(value, field) {
    var msg;
    if (!this.isValidValue(value)) {
      if (field != null) {
        msg = "Invalid value for " + field + " (valid values " + this.toString() + "): " + value;
      } else {
        msg = "Invalid value (valid values " + this.toString() + "): " + value;
      }
      return assert(false, msg, DateTimeException);
    }
    return value;
  };
  _proto.checkValidIntValue = function checkValidIntValue(value, field) {
    if (this.isValidIntValue(value) === false) {
      throw new DateTimeException("Invalid int value for " + field + ": " + value);
    }
    return value;
  };
  _proto.isValidIntValue = function isValidIntValue(value) {
    return this.isIntValue() && this.isValidValue(value);
  };
  _proto.isIntValue = function isIntValue() {
    return this.minimum() >= MathUtil.MIN_SAFE_INTEGER && this.maximum() <= MathUtil.MAX_SAFE_INTEGER;
  };
  _proto.equals = function equals(other) {
    if (other === this) {
      return true;
    }
    if (other instanceof ValueRange) {
      return this._minSmallest === other._minSmallest && this._minLargest === other._minLargest && this._maxSmallest === other._maxSmallest && this._maxLargest === other._maxLargest;
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return MathUtil.hashCode(this._minSmallest, this._minLargest, this._maxSmallest, this._maxLargest);
  };
  _proto.toString = function toString() {
    var str = this.minimum() + (this.minimum() !== this.largestMinimum() ? "/" + this.largestMinimum() : '');
    str += ' - ';
    str += this.smallestMaximum() + (this.smallestMaximum() !== this.maximum() ? "/" + this.maximum() : '');
    return str;
  };
  ValueRange.of = function of() {
    if (arguments.length === 2) {
      return new ValueRange(arguments[0], arguments[0], arguments[1], arguments[1]);
    } else if (arguments.length === 3) {
      return new ValueRange(arguments[0], arguments[0], arguments[1], arguments[2]);
    } else if (arguments.length === 4) {
      return new ValueRange(arguments[0], arguments[1], arguments[2], arguments[3]);
    } else {
      return assert(false, "Invalid number of arguments " + arguments.length, IllegalArgumentException);
    }
  };
  return ValueRange;
}();

var ChronoField = function (_TemporalField) {
  _inheritsLoose(ChronoField, _TemporalField);
  ChronoField.byName = function byName(fieldName) {
    for (var prop in ChronoField) {
      if (ChronoField[prop]) {
        if (ChronoField[prop] instanceof ChronoField && ChronoField[prop].name() === fieldName) {
          return ChronoField[prop];
        }
      }
    }
  };
  function ChronoField(name, baseUnit, rangeUnit, range) {
    var _this;
    _this = _TemporalField.call(this) || this;
    _this._name = name;
    _this._baseUnit = baseUnit;
    _this._rangeUnit = rangeUnit;
    _this._range = range;
    return _this;
  }
  var _proto = ChronoField.prototype;
  _proto.name = function name() {
    return this._name;
  };
  _proto.baseUnit = function baseUnit() {
    return this._baseUnit;
  };
  _proto.rangeUnit = function rangeUnit() {
    return this._rangeUnit;
  };
  _proto.range = function range() {
    return this._range;
  };
  _proto.displayName = function displayName() {
    return this.toString();
  };
  _proto.checkValidValue = function checkValidValue(value) {
    return this.range().checkValidValue(value, this);
  };
  _proto.checkValidIntValue = function checkValidIntValue(value) {
    return this.range().checkValidIntValue(value, this);
  };
  _proto.isDateBased = function isDateBased() {
    var dateBased = this === ChronoField.DAY_OF_WEEK || this === ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH || this === ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR || this === ChronoField.DAY_OF_MONTH || this === ChronoField.DAY_OF_YEAR || this === ChronoField.EPOCH_DAY || this === ChronoField.ALIGNED_WEEK_OF_MONTH || this === ChronoField.ALIGNED_WEEK_OF_YEAR || this === ChronoField.MONTH_OF_YEAR || this === ChronoField.PROLEPTIC_MONTH || this === ChronoField.YEAR_OF_ERA || this === ChronoField.YEAR || this === ChronoField.ERA;
    return dateBased;
  };
  _proto.isTimeBased = function isTimeBased() {
    var timeBased = this === ChronoField.NANO_OF_SECOND || this === ChronoField.NANO_OF_DAY || this === ChronoField.MICRO_OF_SECOND || this === ChronoField.MICRO_OF_DAY || this === ChronoField.MILLI_OF_SECOND || this === ChronoField.MILLI_OF_DAY || this === ChronoField.SECOND_OF_MINUTE || this === ChronoField.SECOND_OF_DAY || this === ChronoField.MINUTE_OF_HOUR || this === ChronoField.MINUTE_OF_DAY || this === ChronoField.HOUR_OF_AMPM || this === ChronoField.CLOCK_HOUR_OF_AMPM || this === ChronoField.HOUR_OF_DAY || this === ChronoField.CLOCK_HOUR_OF_DAY || this === ChronoField.AMPM_OF_DAY;
    return timeBased;
  };
  _proto.rangeRefinedBy = function rangeRefinedBy(temporal) {
    return temporal.range(this);
  };
  _proto.getFrom = function getFrom(temporal) {
    return temporal.getLong(this);
  };
  _proto.toString = function toString() {
    return this.name();
  };
  _proto.equals = function equals(other) {
    return this === other;
  };
  _proto.adjustInto = function adjustInto(temporal, newValue) {
    return temporal.with(this, newValue);
  };
  _proto.isSupportedBy = function isSupportedBy(temporal) {
    return temporal.isSupported(this);
  };
  return ChronoField;
}(TemporalField);
function _init$k() {
  ChronoField.NANO_OF_SECOND = new ChronoField('NanoOfSecond', ChronoUnit.NANOS, ChronoUnit.SECONDS, ValueRange.of(0, 999999999));
  ChronoField.NANO_OF_DAY = new ChronoField('NanoOfDay', ChronoUnit.NANOS, ChronoUnit.DAYS, ValueRange.of(0, 86400 * 1000000000 - 1));
  ChronoField.MICRO_OF_SECOND = new ChronoField('MicroOfSecond', ChronoUnit.MICROS, ChronoUnit.SECONDS, ValueRange.of(0, 999999));
  ChronoField.MICRO_OF_DAY = new ChronoField('MicroOfDay', ChronoUnit.MICROS, ChronoUnit.DAYS, ValueRange.of(0, 86400 * 1000000 - 1));
  ChronoField.MILLI_OF_SECOND = new ChronoField('MilliOfSecond', ChronoUnit.MILLIS, ChronoUnit.SECONDS, ValueRange.of(0, 999));
  ChronoField.MILLI_OF_DAY = new ChronoField('MilliOfDay', ChronoUnit.MILLIS, ChronoUnit.DAYS, ValueRange.of(0, 86400 * 1000 - 1));
  ChronoField.SECOND_OF_MINUTE = new ChronoField('SecondOfMinute', ChronoUnit.SECONDS, ChronoUnit.MINUTES, ValueRange.of(0, 59));
  ChronoField.SECOND_OF_DAY = new ChronoField('SecondOfDay', ChronoUnit.SECONDS, ChronoUnit.DAYS, ValueRange.of(0, 86400 - 1));
  ChronoField.MINUTE_OF_HOUR = new ChronoField('MinuteOfHour', ChronoUnit.MINUTES, ChronoUnit.HOURS, ValueRange.of(0, 59));
  ChronoField.MINUTE_OF_DAY = new ChronoField('MinuteOfDay', ChronoUnit.MINUTES, ChronoUnit.DAYS, ValueRange.of(0, 24 * 60 - 1));
  ChronoField.HOUR_OF_AMPM = new ChronoField('HourOfAmPm', ChronoUnit.HOURS, ChronoUnit.HALF_DAYS, ValueRange.of(0, 11));
  ChronoField.CLOCK_HOUR_OF_AMPM = new ChronoField('ClockHourOfAmPm', ChronoUnit.HOURS, ChronoUnit.HALF_DAYS, ValueRange.of(1, 12));
  ChronoField.HOUR_OF_DAY = new ChronoField('HourOfDay', ChronoUnit.HOURS, ChronoUnit.DAYS, ValueRange.of(0, 23));
  ChronoField.CLOCK_HOUR_OF_DAY = new ChronoField('ClockHourOfDay', ChronoUnit.HOURS, ChronoUnit.DAYS, ValueRange.of(1, 24));
  ChronoField.AMPM_OF_DAY = new ChronoField('AmPmOfDay', ChronoUnit.HALF_DAYS, ChronoUnit.DAYS, ValueRange.of(0, 1));
  ChronoField.DAY_OF_WEEK = new ChronoField('DayOfWeek', ChronoUnit.DAYS, ChronoUnit.WEEKS, ValueRange.of(1, 7));
  ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH = new ChronoField('AlignedDayOfWeekInMonth', ChronoUnit.DAYS, ChronoUnit.WEEKS, ValueRange.of(1, 7));
  ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR = new ChronoField('AlignedDayOfWeekInYear', ChronoUnit.DAYS, ChronoUnit.WEEKS, ValueRange.of(1, 7));
  ChronoField.DAY_OF_MONTH = new ChronoField('DayOfMonth', ChronoUnit.DAYS, ChronoUnit.MONTHS, ValueRange.of(1, 28, 31), 'day');
  ChronoField.DAY_OF_YEAR = new ChronoField('DayOfYear', ChronoUnit.DAYS, ChronoUnit.YEARS, ValueRange.of(1, 365, 366));
  ChronoField.EPOCH_DAY = new ChronoField('EpochDay', ChronoUnit.DAYS, ChronoUnit.FOREVER, ValueRange.of(-365961662, 364522971));
  ChronoField.ALIGNED_WEEK_OF_MONTH = new ChronoField('AlignedWeekOfMonth', ChronoUnit.WEEKS, ChronoUnit.MONTHS, ValueRange.of(1, 4, 5));
  ChronoField.ALIGNED_WEEK_OF_YEAR = new ChronoField('AlignedWeekOfYear', ChronoUnit.WEEKS, ChronoUnit.YEARS, ValueRange.of(1, 53));
  ChronoField.MONTH_OF_YEAR = new ChronoField('MonthOfYear', ChronoUnit.MONTHS, ChronoUnit.YEARS, ValueRange.of(1, 12), 'month');
  ChronoField.PROLEPTIC_MONTH = new ChronoField('ProlepticMonth', ChronoUnit.MONTHS, ChronoUnit.FOREVER, ValueRange.of(YearConstants.MIN_VALUE * 12, YearConstants.MAX_VALUE * 12 + 11));
  ChronoField.YEAR_OF_ERA = new ChronoField('YearOfEra', ChronoUnit.YEARS, ChronoUnit.FOREVER, ValueRange.of(1, YearConstants.MAX_VALUE, YearConstants.MAX_VALUE + 1));
  ChronoField.YEAR = new ChronoField('Year', ChronoUnit.YEARS, ChronoUnit.FOREVER, ValueRange.of(YearConstants.MIN_VALUE, YearConstants.MAX_VALUE), 'year');
  ChronoField.ERA = new ChronoField('Era', ChronoUnit.ERAS, ChronoUnit.FOREVER, ValueRange.of(0, 1));
  ChronoField.INSTANT_SECONDS = new ChronoField('InstantSeconds', ChronoUnit.SECONDS, ChronoUnit.FOREVER, ValueRange.of(MIN_SAFE_INTEGER, MAX_SAFE_INTEGER));
  ChronoField.OFFSET_SECONDS = new ChronoField('OffsetSeconds', ChronoUnit.SECONDS, ChronoUnit.FOREVER, ValueRange.of(-18 * 3600, 18 * 3600));
}

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */var TemporalQueries = function () {
  function TemporalQueries() {}
  TemporalQueries.zoneId = function zoneId() {
    return TemporalQueries.ZONE_ID;
  };
  TemporalQueries.chronology = function chronology() {
    return TemporalQueries.CHRONO;
  };
  TemporalQueries.precision = function precision() {
    return TemporalQueries.PRECISION;
  };
  TemporalQueries.zone = function zone() {
    return TemporalQueries.ZONE;
  };
  TemporalQueries.offset = function offset() {
    return TemporalQueries.OFFSET;
  };
  TemporalQueries.localDate = function localDate() {
    return TemporalQueries.LOCAL_DATE;
  };
  TemporalQueries.localTime = function localTime() {
    return TemporalQueries.LOCAL_TIME;
  };
  return TemporalQueries;
}();

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var TemporalAccessor = function () {
  function TemporalAccessor() {}
  var _proto = TemporalAccessor.prototype;
  _proto.query = function query(_query) {
    if (_query === TemporalQueries.zoneId() || _query === TemporalQueries.chronology() || _query === TemporalQueries.precision()) {
      return null;
    }
    return _query.queryFrom(this);
  };
  _proto.get = function get(field) {
    return this.range(field).checkValidIntValue(this.getLong(field), field);
  };
  _proto.getLong = function getLong(field) {
    abstractMethodFail('getLong');
  };
  _proto.range = function range(field) {
    if (field instanceof ChronoField) {
      if (this.isSupported(field)) {
        return field.range();
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.rangeRefinedBy(this);
  };
  _proto.isSupported = function isSupported(field) {
    abstractMethodFail('isSupported');
  };
  return TemporalAccessor;
}();

var TemporalQuery = function (_Enum) {
  _inheritsLoose(TemporalQuery, _Enum);
  function TemporalQuery() {
    return _Enum.apply(this, arguments) || this;
  }
  var _proto = TemporalQuery.prototype;
  _proto.queryFrom = function queryFrom(temporal) {
    abstractMethodFail('queryFrom');
  };
  return TemporalQuery;
}(Enum);
function createTemporalQuery(name, queryFromFunction) {
  var ExtendedTemporalQuery = function (_TemporalQuery) {
    _inheritsLoose(ExtendedTemporalQuery, _TemporalQuery);
    function ExtendedTemporalQuery() {
      return _TemporalQuery.apply(this, arguments) || this;
    }
    return ExtendedTemporalQuery;
  }(TemporalQuery);
  ExtendedTemporalQuery.prototype.queryFrom = queryFromFunction;
  return new ExtendedTemporalQuery(name);
}

var DayOfWeek = function (_TemporalAccessor) {
  _inheritsLoose(DayOfWeek, _TemporalAccessor);
  function DayOfWeek(ordinal, name) {
    var _this;
    _this = _TemporalAccessor.call(this) || this;
    _this._ordinal = ordinal;
    _this._name = name;
    return _this;
  }
  var _proto = DayOfWeek.prototype;
  _proto.ordinal = function ordinal() {
    return this._ordinal;
  };
  _proto.name = function name() {
    return this._name;
  };
  DayOfWeek.values = function values() {
    return ENUMS.slice();
  };
  DayOfWeek.valueOf = function valueOf(name) {
    var ordinal = 0;
    for (ordinal; ordinal < ENUMS.length; ordinal++) {
      if (ENUMS[ordinal].name() === name) {
        break;
      }
    }
    return DayOfWeek.of(ordinal + 1);
  };
  DayOfWeek.of = function of(dayOfWeek) {
    if (dayOfWeek < 1 || dayOfWeek > 7) {
      throw new DateTimeException("Invalid value for DayOfWeek: " + dayOfWeek);
    }
    return ENUMS[dayOfWeek - 1];
  };
  DayOfWeek.from = function from(temporal) {
    assert(temporal != null, 'temporal', NullPointerException);
    if (temporal instanceof DayOfWeek) {
      return temporal;
    }
    try {
      return DayOfWeek.of(temporal.get(ChronoField.DAY_OF_WEEK));
    } catch (ex) {
      if (ex instanceof DateTimeException) {
        throw new DateTimeException("Unable to obtain DayOfWeek from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''), ex);
      } else {
        throw ex;
      }
    }
  };
  _proto.value = function value() {
    return this._ordinal + 1;
  };
  _proto.displayName = function displayName(style, locale) {
    throw new IllegalArgumentException('Pattern using (localized) text not implemented yet!');
  };
  _proto.isSupported = function isSupported(field) {
    if (field instanceof ChronoField) {
      return field === ChronoField.DAY_OF_WEEK;
    }
    return field != null && field.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    if (field === ChronoField.DAY_OF_WEEK) {
      return field.range();
    } else if (field instanceof ChronoField) {
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.rangeRefinedBy(this);
  };
  _proto.get = function get(field) {
    if (field === ChronoField.DAY_OF_WEEK) {
      return this.value();
    }
    return this.range(field).checkValidIntValue(this.getLong(field), field);
  };
  _proto.getLong = function getLong(field) {
    if (field === ChronoField.DAY_OF_WEEK) {
      return this.value();
    } else if (field instanceof ChronoField) {
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.getFrom(this);
  };
  _proto.plus = function plus(days) {
    var amount = MathUtil.floorMod(days, 7);
    return ENUMS[MathUtil.floorMod(this._ordinal + (amount + 7), 7)];
  };
  _proto.minus = function minus(days) {
    return this.plus(-1 * MathUtil.floorMod(days, 7));
  };
  _proto.query = function query(_query) {
    if (_query === TemporalQueries.precision()) {
      return ChronoUnit.DAYS;
    } else if (_query === TemporalQueries.localDate() || _query === TemporalQueries.localTime() || _query === TemporalQueries.chronology() || _query === TemporalQueries.zone() || _query === TemporalQueries.zoneId() || _query === TemporalQueries.offset()) {
      return null;
    }
    assert(_query != null, 'query', NullPointerException);
    return _query.queryFrom(this);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    requireNonNull(temporal, 'temporal');
    return temporal.with(ChronoField.DAY_OF_WEEK, this.value());
  };
  _proto.equals = function equals(other) {
    return this === other;
  };
  _proto.toString = function toString() {
    return this._name;
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, DayOfWeek, 'other');
    return this._ordinal - other._ordinal;
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  return DayOfWeek;
}(TemporalAccessor);
var ENUMS;
function _init$j() {
  DayOfWeek.MONDAY = new DayOfWeek(0, 'MONDAY');
  DayOfWeek.TUESDAY = new DayOfWeek(1, 'TUESDAY');
  DayOfWeek.WEDNESDAY = new DayOfWeek(2, 'WEDNESDAY');
  DayOfWeek.THURSDAY = new DayOfWeek(3, 'THURSDAY');
  DayOfWeek.FRIDAY = new DayOfWeek(4, 'FRIDAY');
  DayOfWeek.SATURDAY = new DayOfWeek(5, 'SATURDAY');
  DayOfWeek.SUNDAY = new DayOfWeek(6, 'SUNDAY');
  DayOfWeek.FROM = createTemporalQuery('DayOfWeek.FROM', function (temporal) {
    return DayOfWeek.from(temporal);
  });
  ENUMS = [DayOfWeek.MONDAY, DayOfWeek.TUESDAY, DayOfWeek.WEDNESDAY, DayOfWeek.THURSDAY, DayOfWeek.FRIDAY, DayOfWeek.SATURDAY, DayOfWeek.SUNDAY];
}

var Month = function (_TemporalAccessor) {
  _inheritsLoose(Month, _TemporalAccessor);
  function Month(value, name) {
    var _this;
    _this = _TemporalAccessor.call(this) || this;
    _this._value = MathUtil.safeToInt(value);
    _this._name = name;
    return _this;
  }
  var _proto = Month.prototype;
  _proto.value = function value() {
    return this._value;
  };
  _proto.ordinal = function ordinal() {
    return this._value - 1;
  };
  _proto.name = function name() {
    return this._name;
  };
  _proto.displayName = function displayName(style, locale) {
    throw new IllegalArgumentException('Pattern using (localized) text not implemented yet!');
  };
  _proto.isSupported = function isSupported(field) {
    if (null === field) {
      return false;
    }
    if (field instanceof ChronoField) {
      return field === ChronoField.MONTH_OF_YEAR;
    }
    return field != null && field.isSupportedBy(this);
  };
  _proto.get = function get(field) {
    if (field === ChronoField.MONTH_OF_YEAR) {
      return this.value();
    }
    return this.range(field).checkValidIntValue(this.getLong(field), field);
  };
  _proto.getLong = function getLong(field) {
    if (field === ChronoField.MONTH_OF_YEAR) {
      return this.value();
    } else if (field instanceof ChronoField) {
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.getFrom(this);
  };
  _proto.plus = function plus(months) {
    var amount = MathUtil.intMod(months, 12) + 12;
    var newMonthVal = MathUtil.intMod(this.value() + amount, 12);
    newMonthVal = newMonthVal === 0 ? 12 : newMonthVal;
    return Month.of(newMonthVal);
  };
  _proto.minus = function minus(months) {
    return this.plus(-1 * MathUtil.intMod(months, 12));
  };
  _proto.length = function length(leapYear) {
    switch (this) {
      case Month.FEBRUARY:
        return leapYear ? 29 : 28;
      case Month.APRIL:
      case Month.JUNE:
      case Month.SEPTEMBER:
      case Month.NOVEMBER:
        return 30;
      default:
        return 31;
    }
  };
  _proto.minLength = function minLength() {
    switch (this) {
      case Month.FEBRUARY:
        return 28;
      case Month.APRIL:
      case Month.JUNE:
      case Month.SEPTEMBER:
      case Month.NOVEMBER:
        return 30;
      default:
        return 31;
    }
  };
  _proto.maxLength = function maxLength() {
    switch (this) {
      case Month.FEBRUARY:
        return 29;
      case Month.APRIL:
      case Month.JUNE:
      case Month.SEPTEMBER:
      case Month.NOVEMBER:
        return 30;
      default:
        return 31;
    }
  };
  _proto.firstDayOfYear = function firstDayOfYear(leapYear) {
    var leap = leapYear ? 1 : 0;
    switch (this) {
      case Month.JANUARY:
        return 1;
      case Month.FEBRUARY:
        return 32;
      case Month.MARCH:
        return 60 + leap;
      case Month.APRIL:
        return 91 + leap;
      case Month.MAY:
        return 121 + leap;
      case Month.JUNE:
        return 152 + leap;
      case Month.JULY:
        return 182 + leap;
      case Month.AUGUST:
        return 213 + leap;
      case Month.SEPTEMBER:
        return 244 + leap;
      case Month.OCTOBER:
        return 274 + leap;
      case Month.NOVEMBER:
        return 305 + leap;
      case Month.DECEMBER:
      default:
        return 335 + leap;
    }
  };
  _proto.firstMonthOfQuarter = function firstMonthOfQuarter() {
    switch (this) {
      case Month.JANUARY:
      case Month.FEBRUARY:
      case Month.MARCH:
        return Month.JANUARY;
      case Month.APRIL:
      case Month.MAY:
      case Month.JUNE:
        return Month.APRIL;
      case Month.JULY:
      case Month.AUGUST:
      case Month.SEPTEMBER:
        return Month.JULY;
      case Month.OCTOBER:
      case Month.NOVEMBER:
      case Month.DECEMBER:
      default:
        return Month.OCTOBER;
    }
  };
  _proto.query = function query(_query) {
    assert(_query != null, 'query() parameter must not be null', DateTimeException);
    if (_query === TemporalQueries.chronology()) {
      return IsoChronology.INSTANCE;
    } else if (_query === TemporalQueries.precision()) {
      return ChronoUnit.MONTHS;
    }
    return _TemporalAccessor.prototype.query.call(this, _query);
  };
  _proto.toString = function toString() {
    switch (this) {
      case Month.JANUARY:
        return 'JANUARY';
      case Month.FEBRUARY:
        return 'FEBRUARY';
      case Month.MARCH:
        return 'MARCH';
      case Month.APRIL:
        return 'APRIL';
      case Month.MAY:
        return 'MAY';
      case Month.JUNE:
        return 'JUNE';
      case Month.JULY:
        return 'JULY';
      case Month.AUGUST:
        return 'AUGUST';
      case Month.SEPTEMBER:
        return 'SEPTEMBER';
      case Month.OCTOBER:
        return 'OCTOBER';
      case Month.NOVEMBER:
        return 'NOVEMBER';
      case Month.DECEMBER:
        return 'DECEMBER';
      default:
        return "unknown Month, value: " + this.value();
    }
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.adjustInto = function adjustInto(temporal) {
    return temporal.with(ChronoField.MONTH_OF_YEAR, this.value());
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, Month, 'other');
    return this._value - other._value;
  };
  _proto.equals = function equals(other) {
    return this === other;
  };
  Month.valueOf = function valueOf(name) {
    var ordinal = 0;
    for (ordinal; ordinal < MONTHS.length; ordinal++) {
      if (MONTHS[ordinal].name() === name) {
        break;
      }
    }
    return Month.of(ordinal + 1);
  };
  Month.values = function values() {
    return MONTHS.slice();
  };
  Month.of = function of(month) {
    if (month < 1 || month > 12) {
      assert(false, "Invalid value for MonthOfYear: " + month, DateTimeException);
    }
    return MONTHS[month - 1];
  };
  Month.from = function from(temporal) {
    if (temporal instanceof Month) {
      return temporal;
    }
    try {
      return Month.of(temporal.get(ChronoField.MONTH_OF_YEAR));
    } catch (ex) {
      throw new DateTimeException("Unable to obtain Month from TemporalAccessor: " + temporal + " of type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ''), ex);
    }
  };
  return Month;
}(TemporalAccessor);
var MONTHS;
function _init$i() {
  Month.JANUARY = new Month(1, 'JANUARY');
  Month.FEBRUARY = new Month(2, 'FEBRUARY');
  Month.MARCH = new Month(3, 'MARCH');
  Month.APRIL = new Month(4, 'APRIL');
  Month.MAY = new Month(5, 'MAY');
  Month.JUNE = new Month(6, 'JUNE');
  Month.JULY = new Month(7, 'JULY');
  Month.AUGUST = new Month(8, 'AUGUST');
  Month.SEPTEMBER = new Month(9, 'SEPTEMBER');
  Month.OCTOBER = new Month(10, 'OCTOBER');
  Month.NOVEMBER = new Month(11, 'NOVEMBER');
  Month.DECEMBER = new Month(12, 'DECEMBER');
  MONTHS = [Month.JANUARY, Month.FEBRUARY, Month.MARCH, Month.APRIL, Month.MAY, Month.JUNE, Month.JULY, Month.AUGUST, Month.SEPTEMBER, Month.OCTOBER, Month.NOVEMBER, Month.DECEMBER];
}

var PATTERN = /([-+]?)P(?:([-+]?[0-9]+)Y)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)W)?(?:([-+]?[0-9]+)D)?/;
var Period = function (_TemporalAmount) {
  _inheritsLoose(Period, _TemporalAmount);
  function Period(years, months, days) {
    var _this;
    _this = _TemporalAmount.call(this) || this;
    var _years = MathUtil.safeToInt(years);
    var _months = MathUtil.safeToInt(months);
    var _days = MathUtil.safeToInt(days);
    if (_years === 0 && _months === 0 && _days === 0) {
      if (!Period.ZERO) {
        _this._years = _years;
        _this._months = _months;
        _this._days = _days;
        Period.ZERO = _assertThisInitialized(_this);
      }
      return Period.ZERO || _assertThisInitialized(_this);
    }
    _this._years = _years;
    _this._months = _months;
    _this._days = _days;
    return _this;
  }
  Period.ofYears = function ofYears(years) {
    return Period.create(years, 0, 0);
  };
  Period.ofMonths = function ofMonths(months) {
    return Period.create(0, months, 0);
  };
  Period.ofWeeks = function ofWeeks(weeks) {
    return Period.create(0, 0, MathUtil.safeMultiply(weeks, 7));
  };
  Period.ofDays = function ofDays(days) {
    return Period.create(0, 0, days);
  };
  Period.of = function of(years, months, days) {
    return Period.create(years, months, days);
  };
  Period.from = function from(amount) {
    if (amount instanceof Period) {
      return amount;
    }
    requireNonNull(amount, 'amount');
    var years = 0;
    var months = 0;
    var days = 0;
    var units = amount.units();
    for (var i = 0; i < units.length; i++) {
      var unit = units[i];
      var unitAmount = amount.get(unit);
      if (unit === ChronoUnit.YEARS) {
        years = MathUtil.safeToInt(unitAmount);
      } else if (unit === ChronoUnit.MONTHS) {
        months = MathUtil.safeToInt(unitAmount);
      } else if (unit === ChronoUnit.DAYS) {
        days = MathUtil.safeToInt(unitAmount);
      } else {
        throw new DateTimeException("Unit must be Years, Months or Days, but was " + unit);
      }
    }
    return Period.create(years, months, days);
  };
  Period.between = function between(startDate, endDate) {
    requireNonNull(startDate, 'startDate');
    requireNonNull(endDate, 'endDate');
    requireInstance(startDate, LocalDate, 'startDate');
    requireInstance(endDate, LocalDate, 'endDate');
    return startDate.until(endDate);
  };
  Period.parse = function parse(text) {
    requireNonNull(text, 'text');
    try {
      return Period._parse(text);
    } catch (ex) {
      if (ex instanceof ArithmeticException) {
        throw new DateTimeParseException('Text cannot be parsed to a Period', text, 0, ex);
      } else {
        throw ex;
      }
    }
  };
  Period._parse = function _parse(text) {
    var matches = PATTERN.exec(text);
    if (matches != null) {
      var negate = '-' === matches[1] ? -1 : 1;
      var yearMatch = matches[2];
      var monthMatch = matches[3];
      var weekMatch = matches[4];
      var dayMatch = matches[5];
      if (yearMatch != null || monthMatch != null || weekMatch != null || dayMatch != null) {
        var years = Period._parseNumber(text, yearMatch, negate);
        var months = Period._parseNumber(text, monthMatch, negate);
        var weeks = Period._parseNumber(text, weekMatch, negate);
        var days = Period._parseNumber(text, dayMatch, negate);
        days = MathUtil.safeAdd(days, MathUtil.safeMultiply(weeks, 7));
        return Period.create(years, months, days);
      }
    }
    throw new DateTimeParseException('Text cannot be parsed to a Period', text, 0);
  };
  Period._parseNumber = function _parseNumber(text, str, negate) {
    if (str == null) {
      return 0;
    }
    var val = MathUtil.parseInt(str);
    return MathUtil.safeMultiply(val, negate);
  };
  Period.create = function create(years, months, days) {
    return new Period(years, months, days);
  };
  var _proto = Period.prototype;
  _proto.units = function units() {
    return [ChronoUnit.YEARS, ChronoUnit.MONTHS, ChronoUnit.DAYS];
  };
  _proto.chronology = function chronology() {
    return IsoChronology.INSTANCE;
  };
  _proto.get = function get(unit) {
    if (unit === ChronoUnit.YEARS) {
      return this._years;
    }
    if (unit === ChronoUnit.MONTHS) {
      return this._months;
    }
    if (unit === ChronoUnit.DAYS) {
      return this._days;
    }
    throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
  };
  _proto.isZero = function isZero() {
    return this === Period.ZERO;
  };
  _proto.isNegative = function isNegative() {
    return this._years < 0 || this._months < 0 || this._days < 0;
  };
  _proto.years = function years() {
    return this._years;
  };
  _proto.months = function months() {
    return this._months;
  };
  _proto.days = function days() {
    return this._days;
  };
  _proto.withYears = function withYears(years) {
    if (years === this._years) {
      return this;
    }
    return Period.create(years, this._months, this._days);
  };
  _proto.withMonths = function withMonths(months) {
    if (months === this._months) {
      return this;
    }
    return Period.create(this._years, months, this._days);
  };
  _proto.withDays = function withDays(days) {
    if (days === this._days) {
      return this;
    }
    return Period.create(this._years, this._months, days);
  };
  _proto.plus = function plus(amountToAdd) {
    var amount = Period.from(amountToAdd);
    return Period.create(MathUtil.safeAdd(this._years, amount._years), MathUtil.safeAdd(this._months, amount._months), MathUtil.safeAdd(this._days, amount._days));
  };
  _proto.plusYears = function plusYears(yearsToAdd) {
    if (yearsToAdd === 0) {
      return this;
    }
    return Period.create(MathUtil.safeToInt(MathUtil.safeAdd(this._years, yearsToAdd)), this._months, this._days);
  };
  _proto.plusMonths = function plusMonths(monthsToAdd) {
    if (monthsToAdd === 0) {
      return this;
    }
    return Period.create(this._years, MathUtil.safeToInt(MathUtil.safeAdd(this._months, monthsToAdd)), this._days);
  };
  _proto.plusDays = function plusDays(daysToAdd) {
    if (daysToAdd === 0) {
      return this;
    }
    return Period.create(this._years, this._months, MathUtil.safeToInt(MathUtil.safeAdd(this._days, daysToAdd)));
  };
  _proto.minus = function minus(amountToSubtract) {
    var amount = Period.from(amountToSubtract);
    return Period.create(MathUtil.safeSubtract(this._years, amount._years), MathUtil.safeSubtract(this._months, amount._months), MathUtil.safeSubtract(this._days, amount._days));
  };
  _proto.minusYears = function minusYears(yearsToSubtract) {
    return this.plusYears(-1 * yearsToSubtract);
  };
  _proto.minusMonths = function minusMonths(monthsToSubtract) {
    return this.plusMonths(-1 * monthsToSubtract);
  };
  _proto.minusDays = function minusDays(daysToSubtract) {
    return this.plusDays(-1 * daysToSubtract);
  };
  _proto.multipliedBy = function multipliedBy(scalar) {
    if (this === Period.ZERO || scalar === 1) {
      return this;
    }
    return Period.create(MathUtil.safeMultiply(this._years, scalar), MathUtil.safeMultiply(this._months, scalar), MathUtil.safeMultiply(this._days, scalar));
  };
  _proto.negated = function negated() {
    return this.multipliedBy(-1);
  };
  _proto.normalized = function normalized() {
    var totalMonths = this.toTotalMonths();
    var splitYears = MathUtil.intDiv(totalMonths, 12);
    var splitMonths = MathUtil.intMod(totalMonths, 12);
    if (splitYears === this._years && splitMonths === this._months) {
      return this;
    }
    return Period.create(MathUtil.safeToInt(splitYears), splitMonths, this._days);
  };
  _proto.toTotalMonths = function toTotalMonths() {
    return this._years * 12 + this._months;
  };
  _proto.addTo = function addTo(temporal) {
    requireNonNull(temporal, 'temporal');
    if (this._years !== 0) {
      if (this._months !== 0) {
        temporal = temporal.plus(this.toTotalMonths(), ChronoUnit.MONTHS);
      } else {
        temporal = temporal.plus(this._years, ChronoUnit.YEARS);
      }
    } else if (this._months !== 0) {
      temporal = temporal.plus(this._months, ChronoUnit.MONTHS);
    }
    if (this._days !== 0) {
      temporal = temporal.plus(this._days, ChronoUnit.DAYS);
    }
    return temporal;
  };
  _proto.subtractFrom = function subtractFrom(temporal) {
    requireNonNull(temporal, 'temporal');
    if (this._years !== 0) {
      if (this._months !== 0) {
        temporal = temporal.minus(this.toTotalMonths(), ChronoUnit.MONTHS);
      } else {
        temporal = temporal.minus(this._years, ChronoUnit.YEARS);
      }
    } else if (this._months !== 0) {
      temporal = temporal.minus(this._months, ChronoUnit.MONTHS);
    }
    if (this._days !== 0) {
      temporal = temporal.minus(this._days, ChronoUnit.DAYS);
    }
    return temporal;
  };
  _proto.equals = function equals(obj) {
    if (this === obj) {
      return true;
    }
    if (obj instanceof Period) {
      var other = obj;
      return this._years === other._years && this._months === other._months && this._days === other._days;
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return MathUtil.hashCode(this._years, this._months, this._days);
  };
  _proto.toString = function toString() {
    if (this === Period.ZERO) {
      return 'P0D';
    } else {
      var buf = 'P';
      if (this._years !== 0) {
        buf += this._years + "Y";
      }
      if (this._months !== 0) {
        buf += this._months + "M";
      }
      if (this._days !== 0) {
        buf += this._days + "D";
      }
      return buf;
    }
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  return Period;
}(TemporalAmount);
function _init$h() {
  Period.ofDays(0);
}

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */var ParsePosition = function () {
  function ParsePosition(index) {
    this._index = index;
    this._errorIndex = -1;
  }
  var _proto = ParsePosition.prototype;
  _proto.getIndex = function getIndex() {
    return this._index;
  };
  _proto.setIndex = function setIndex(index) {
    this._index = index;
  };
  _proto.getErrorIndex = function getErrorIndex() {
    return this._errorIndex;
  };
  _proto.setErrorIndex = function setErrorIndex(errorIndex) {
    this._errorIndex = errorIndex;
  };
  return ParsePosition;
}();

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */var EnumMap = function () {
  function EnumMap() {
    this._map = {};
  }
  var _proto = EnumMap.prototype;
  _proto.putAll = function putAll(otherMap) {
    for (var key in otherMap._map) {
      this._map[key] = otherMap._map[key];
    }
    return this;
  };
  _proto.containsKey = function containsKey(key) {
    return this._map.hasOwnProperty(key.name()) && this.get(key) !== undefined;
  };
  _proto.get = function get(key) {
    return this._map[key.name()];
  };
  _proto.put = function put(key, val) {
    return this.set(key, val);
  };
  _proto.set = function set(key, val) {
    this._map[key.name()] = val;
    return this;
  };
  _proto.retainAll = function retainAll(keyList) {
    var map = {};
    for (var i = 0; i < keyList.length; i++) {
      var key = keyList[i].name();
      map[key] = this._map[key];
    }
    this._map = map;
    return this;
  };
  _proto.remove = function remove(key) {
    var keyName = key.name();
    var val = this._map[keyName];
    this._map[keyName] = undefined;
    return val;
  };
  _proto.keySet = function keySet() {
    return this._map;
  };
  _proto.clear = function clear() {
    this._map = {};
  };
  return EnumMap;
}();

var ResolverStyle = function (_Enum) {
  _inheritsLoose(ResolverStyle, _Enum);
  function ResolverStyle() {
    return _Enum.apply(this, arguments) || this;
  }
  return ResolverStyle;
}(Enum);
ResolverStyle.STRICT = new ResolverStyle('STRICT');
ResolverStyle.SMART = new ResolverStyle('SMART');
ResolverStyle.LENIENT = new ResolverStyle('LENIENT');

var Temporal = function (_TemporalAccessor) {
  _inheritsLoose(Temporal, _TemporalAccessor);
  function Temporal() {
    return _TemporalAccessor.apply(this, arguments) || this;
  }
  var _proto = Temporal.prototype;
  _proto.isSupported = function isSupported(fieldOrUnit) {
    abstractMethodFail('isSupported');
  };
  _proto.minus = function minus(amount, unit) {
    if (arguments.length < 2) {
      return this._minusAmount(amount);
    } else {
      return this._minusUnit(amount, unit);
    }
  };
  _proto._minusAmount = function _minusAmount(amount) {
    requireNonNull(amount, 'amount');
    requireInstance(amount, TemporalAmount, 'amount');
    return amount.subtractFrom(this);
  };
  _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
    requireNonNull(amountToSubtract, 'amountToSubtract');
    requireNonNull(unit, 'unit');
    requireInstance(unit, TemporalUnit, 'unit');
    return this._plusUnit(-amountToSubtract, unit);
  };
  _proto.plus = function plus(amount, unit) {
    if (arguments.length < 2) {
      return this._plusAmount(amount);
    } else {
      return this._plusUnit(amount, unit);
    }
  };
  _proto._plusAmount = function _plusAmount(amount) {
    requireNonNull(amount, 'amount');
    requireInstance(amount, TemporalAmount, 'amount');
    return amount.addTo(this);
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    abstractMethodFail('_plusUnit');
  };
  _proto.until = function until(endTemporal, unit) {
    abstractMethodFail('until');
  };
  _proto.with = function _with(adjusterOrField, newValue) {
    if (arguments.length < 2) {
      return this._withAdjuster(adjusterOrField);
    } else {
      return this._withField(adjusterOrField, newValue);
    }
  };
  _proto._withAdjuster = function _withAdjuster(adjuster) {
    requireNonNull(adjuster, 'adjuster');
    assert(typeof adjuster.adjustInto === 'function', 'adjuster must be a TemporalAdjuster', IllegalArgumentException);
    return adjuster.adjustInto(this);
  };
  _proto._withField = function _withField(field, newValue) {
    abstractMethodFail('_withField');
  };
  return Temporal;
}(TemporalAccessor);
if (typeof Symbol !== 'undefined' && Symbol.toPrimitive) {
  Temporal.prototype[Symbol.toPrimitive] = function (hint) {
    if (hint !== 'number') {
      return this.toString();
    }
    throw new TypeError('A conversion from Temporal to a number is not allowed. ' + 'To compare use the methods .equals(), .compareTo(), .isBefore() ' + 'or one that is more suitable to your use case.');
  };
}

var ChronoLocalDate = function (_Temporal) {
  _inheritsLoose(ChronoLocalDate, _Temporal);
  function ChronoLocalDate() {
    return _Temporal.apply(this, arguments) || this;
  }
  var _proto = ChronoLocalDate.prototype;
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (fieldOrUnit instanceof ChronoField) {
      return fieldOrUnit.isDateBased();
    } else if (fieldOrUnit instanceof ChronoUnit) {
      return fieldOrUnit.isDateBased();
    }
    return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
  };
  _proto.query = function query(_query) {
    if (_query === TemporalQueries.chronology()) {
      return this.chronology();
    } else if (_query === TemporalQueries.precision()) {
      return ChronoUnit.DAYS;
    } else if (_query === TemporalQueries.localDate()) {
      return LocalDate.ofEpochDay(this.toEpochDay());
    } else if (_query === TemporalQueries.localTime() || _query === TemporalQueries.zone() || _query === TemporalQueries.zoneId() || _query === TemporalQueries.offset()) {
      return null;
    }
    return _Temporal.prototype.query.call(this, _query);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    return temporal.with(ChronoField.EPOCH_DAY, this.toEpochDay());
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    requireInstance(formatter, DateTimeFormatter, 'formatter');
    return formatter.format(this);
  };
  return ChronoLocalDate;
}(Temporal);

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var StringUtil = function () {
  function StringUtil() {}
  StringUtil.startsWith = function startsWith(text, pattern) {
    return text.indexOf(pattern) === 0;
  };
  StringUtil.hashCode = function hashCode(text) {
    var len = text.length;
    if (len === 0) {
      return 0;
    }
    var hash = 0;
    for (var i = 0; i < len; i++) {
      var chr = text.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0;
    }
    return MathUtil.smi(hash);
  };
  return StringUtil;
}();

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var ZoneId = function () {
  function ZoneId() {}
  ZoneId.systemDefault = function systemDefault() {
    throw new DateTimeException('not supported operation');
  };
  ZoneId.getAvailableZoneIds = function getAvailableZoneIds() {
    throw new DateTimeException('not supported operation');
  };
  ZoneId.of = function of(zoneId) {
    throw new DateTimeException("not supported operation" + zoneId);
  };
  ZoneId.ofOffset = function ofOffset(prefix, offset) {
    throw new DateTimeException("not supported operation" + prefix + offset);
  };
  ZoneId.from = function from(temporal) {
    throw new DateTimeException("not supported operation" + temporal);
  };
  var _proto = ZoneId.prototype;
  _proto.id = function id() {
    abstractMethodFail('ZoneId.id');
  };
  _proto.rules = function rules() {
    abstractMethodFail('ZoneId.rules');
  };
  _proto.normalized = function normalized() {
    var rules = this.rules();
    if (rules.isFixedOffset()) {
      return rules.offset(Instant.EPOCH);
    }
    return this;
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof ZoneId) {
      return this.id() === other.id();
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return StringUtil.hashCode(this.id());
  };
  _proto.toString = function toString() {
    return this.id();
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  return ZoneId;
}();

var ZoneRules = function () {
  function ZoneRules() {}
  ZoneRules.of = function of(offset) {
    requireNonNull(offset, 'offset');
    return new Fixed(offset);
  };
  var _proto = ZoneRules.prototype;
  _proto.isFixedOffset = function isFixedOffset() {
    abstractMethodFail('ZoneRules.isFixedOffset');
  };
  _proto.offset = function offset(instantOrLocalDateTime) {
    if (instantOrLocalDateTime instanceof Instant) {
      return this.offsetOfInstant(instantOrLocalDateTime);
    } else {
      return this.offsetOfLocalDateTime(instantOrLocalDateTime);
    }
  };
  _proto.offsetOfInstant = function offsetOfInstant(instant) {
    abstractMethodFail('ZoneRules.offsetInstant');
  };
  _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
    abstractMethodFail('ZoneRules.offsetOfEpochMilli');
  };
  _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
    abstractMethodFail('ZoneRules.offsetLocalDateTime');
  };
  _proto.validOffsets = function validOffsets(localDateTime) {
    abstractMethodFail('ZoneRules.validOffsets');
  };
  _proto.transition = function transition(localDateTime) {
    abstractMethodFail('ZoneRules.transition');
  };
  _proto.standardOffset = function standardOffset(instant) {
    abstractMethodFail('ZoneRules.standardOffset');
  };
  _proto.daylightSavings = function daylightSavings(instant) {
    abstractMethodFail('ZoneRules.daylightSavings');
  };
  _proto.isDaylightSavings = function isDaylightSavings(instant) {
    abstractMethodFail('ZoneRules.isDaylightSavings');
  };
  _proto.isValidOffset = function isValidOffset(localDateTime, offset) {
    abstractMethodFail('ZoneRules.isValidOffset');
  };
  _proto.nextTransition = function nextTransition(instant) {
    abstractMethodFail('ZoneRules.nextTransition');
  };
  _proto.previousTransition = function previousTransition(instant) {
    abstractMethodFail('ZoneRules.previousTransition');
  };
  _proto.transitions = function transitions() {
    abstractMethodFail('ZoneRules.transitions');
  };
  _proto.transitionRules = function transitionRules() {
    abstractMethodFail('ZoneRules.transitionRules');
  };
  _proto.toString = function toString() {
    abstractMethodFail('ZoneRules.toString');
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  return ZoneRules;
}();
var Fixed = function (_ZoneRules) {
  _inheritsLoose(Fixed, _ZoneRules);
  function Fixed(offset) {
    var _this;
    _this = _ZoneRules.call(this) || this;
    _this._offset = offset;
    return _this;
  }
  var _proto2 = Fixed.prototype;
  _proto2.isFixedOffset = function isFixedOffset() {
    return true;
  };
  _proto2.offsetOfInstant = function offsetOfInstant() {
    return this._offset;
  };
  _proto2.offsetOfEpochMilli = function offsetOfEpochMilli() {
    return this._offset;
  };
  _proto2.offsetOfLocalDateTime = function offsetOfLocalDateTime() {
    return this._offset;
  };
  _proto2.validOffsets = function validOffsets() {
    return [this._offset];
  };
  _proto2.transition = function transition() {
    return null;
  };
  _proto2.standardOffset = function standardOffset() {
    return this._offset;
  };
  _proto2.daylightSavings = function daylightSavings() {
    return Duration.ZERO;
  };
  _proto2.isDaylightSavings = function isDaylightSavings() {
    return false;
  };
  _proto2.isValidOffset = function isValidOffset(localDateTime, offset) {
    return this._offset.equals(offset);
  };
  _proto2.nextTransition = function nextTransition() {
    return null;
  };
  _proto2.previousTransition = function previousTransition() {
    return null;
  };
  _proto2.transitions = function transitions() {
    return [];
  };
  _proto2.transitionRules = function transitionRules() {
    return [];
  };
  _proto2.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof Fixed) {
      return this._offset.equals(other._offset);
    }
    return false;
  };
  _proto2.toString = function toString() {
    return "FixedRules:" + this._offset.toString();
  };
  return Fixed;
}(ZoneRules);

var SECONDS_CACHE = {};
var ID_CACHE = {};
var ZoneOffset = function (_ZoneId) {
  _inheritsLoose(ZoneOffset, _ZoneId);
  function ZoneOffset(totalSeconds) {
    var _this;
    _this = _ZoneId.call(this) || this;
    ZoneOffset._validateTotalSeconds(totalSeconds);
    _this._totalSeconds = MathUtil.safeToInt(totalSeconds);
    _this._rules = ZoneRules.of(_assertThisInitialized(_this));
    _this._id = ZoneOffset._buildId(totalSeconds);
    return _this;
  }
  var _proto = ZoneOffset.prototype;
  _proto.totalSeconds = function totalSeconds() {
    return this._totalSeconds;
  };
  _proto.id = function id() {
    return this._id;
  };
  ZoneOffset._buildId = function _buildId(totalSeconds) {
    if (totalSeconds === 0) {
      return 'Z';
    } else {
      var absTotalSeconds = Math.abs(totalSeconds);
      var absHours = MathUtil.intDiv(absTotalSeconds, LocalTime.SECONDS_PER_HOUR);
      var absMinutes = MathUtil.intMod(MathUtil.intDiv(absTotalSeconds, LocalTime.SECONDS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
      var buf = "" + (totalSeconds < 0 ? '-' : '+') + (absHours < 10 ? '0' : '') + absHours + (absMinutes < 10 ? ':0' : ':') + absMinutes;
      var absSeconds = MathUtil.intMod(absTotalSeconds, LocalTime.SECONDS_PER_MINUTE);
      if (absSeconds !== 0) {
        buf += (absSeconds < 10 ? ':0' : ':') + absSeconds;
      }
      return buf;
    }
  };
  ZoneOffset._validateTotalSeconds = function _validateTotalSeconds(totalSeconds) {
    if (Math.abs(totalSeconds) > ZoneOffset.MAX_SECONDS) {
      throw new DateTimeException('Zone offset not in valid range: -18:00 to +18:00');
    }
  };
  ZoneOffset._validate = function _validate(hours, minutes, seconds) {
    if (hours < -18 || hours > 18) {
      throw new DateTimeException("Zone offset hours not in valid range: value " + hours + " is not in the range -18 to 18");
    }
    if (hours > 0) {
      if (minutes < 0 || seconds < 0) {
        throw new DateTimeException('Zone offset minutes and seconds must be positive because hours is positive');
      }
    } else if (hours < 0) {
      if (minutes > 0 || seconds > 0) {
        throw new DateTimeException('Zone offset minutes and seconds must be negative because hours is negative');
      }
    } else if (minutes > 0 && seconds < 0 || minutes < 0 && seconds > 0) {
      throw new DateTimeException('Zone offset minutes and seconds must have the same sign');
    }
    if (Math.abs(minutes) > 59) {
      throw new DateTimeException("Zone offset minutes not in valid range: abs(value) " + Math.abs(minutes) + " is not in the range 0 to 59");
    }
    if (Math.abs(seconds) > 59) {
      throw new DateTimeException("Zone offset seconds not in valid range: abs(value) " + Math.abs(seconds) + " is not in the range 0 to 59");
    }
    if (Math.abs(hours) === 18 && (Math.abs(minutes) > 0 || Math.abs(seconds) > 0)) {
      throw new DateTimeException('Zone offset not in valid range: -18:00 to +18:00');
    }
  };
  ZoneOffset.of = function of(offsetId) {
    requireNonNull(offsetId, 'offsetId');
    var offset = ID_CACHE[offsetId];
    if (offset != null) {
      return offset;
    }
    var hours, minutes, seconds;
    switch (offsetId.length) {
      case 2:
        offsetId = offsetId[0] + "0" + offsetId[1];
      case 3:
        hours = ZoneOffset._parseNumber(offsetId, 1, false);
        minutes = 0;
        seconds = 0;
        break;
      case 5:
        hours = ZoneOffset._parseNumber(offsetId, 1, false);
        minutes = ZoneOffset._parseNumber(offsetId, 3, false);
        seconds = 0;
        break;
      case 6:
        hours = ZoneOffset._parseNumber(offsetId, 1, false);
        minutes = ZoneOffset._parseNumber(offsetId, 4, true);
        seconds = 0;
        break;
      case 7:
        hours = ZoneOffset._parseNumber(offsetId, 1, false);
        minutes = ZoneOffset._parseNumber(offsetId, 3, false);
        seconds = ZoneOffset._parseNumber(offsetId, 5, false);
        break;
      case 9:
        hours = ZoneOffset._parseNumber(offsetId, 1, false);
        minutes = ZoneOffset._parseNumber(offsetId, 4, true);
        seconds = ZoneOffset._parseNumber(offsetId, 7, true);
        break;
      default:
        throw new DateTimeException("Invalid ID for ZoneOffset, invalid format: " + offsetId);
    }
    var first = offsetId[0];
    if (first !== '+' && first !== '-') {
      throw new DateTimeException("Invalid ID for ZoneOffset, plus/minus not found when expected: " + offsetId);
    }
    if (first === '-') {
      return ZoneOffset.ofHoursMinutesSeconds(-hours, -minutes, -seconds);
    } else {
      return ZoneOffset.ofHoursMinutesSeconds(hours, minutes, seconds);
    }
  };
  ZoneOffset._parseNumber = function _parseNumber(offsetId, pos, precededByColon) {
    if (precededByColon && offsetId[pos - 1] !== ':') {
      throw new DateTimeException("Invalid ID for ZoneOffset, colon not found when expected: " + offsetId);
    }
    var ch1 = offsetId[pos];
    var ch2 = offsetId[pos + 1];
    if (ch1 < '0' || ch1 > '9' || ch2 < '0' || ch2 > '9') {
      throw new DateTimeException("Invalid ID for ZoneOffset, non numeric characters found: " + offsetId);
    }
    return (ch1.charCodeAt(0) - 48) * 10 + (ch2.charCodeAt(0) - 48);
  };
  ZoneOffset.ofHours = function ofHours(hours) {
    return ZoneOffset.ofHoursMinutesSeconds(hours, 0, 0);
  };
  ZoneOffset.ofHoursMinutes = function ofHoursMinutes(hours, minutes) {
    return ZoneOffset.ofHoursMinutesSeconds(hours, minutes, 0);
  };
  ZoneOffset.ofHoursMinutesSeconds = function ofHoursMinutesSeconds(hours, minutes, seconds) {
    ZoneOffset._validate(hours, minutes, seconds);
    var totalSeconds = hours * LocalTime.SECONDS_PER_HOUR + minutes * LocalTime.SECONDS_PER_MINUTE + seconds;
    return ZoneOffset.ofTotalSeconds(totalSeconds);
  };
  ZoneOffset.ofTotalMinutes = function ofTotalMinutes(totalMinutes) {
    var totalSeconds = totalMinutes * LocalTime.SECONDS_PER_MINUTE;
    return ZoneOffset.ofTotalSeconds(totalSeconds);
  };
  ZoneOffset.ofTotalSeconds = function ofTotalSeconds(totalSeconds) {
    if (totalSeconds % (15 * LocalTime.SECONDS_PER_MINUTE) === 0) {
      var totalSecs = totalSeconds;
      var result = SECONDS_CACHE[totalSecs];
      if (result == null) {
        result = new ZoneOffset(totalSeconds);
        SECONDS_CACHE[totalSecs] = result;
        ID_CACHE[result.id()] = result;
      }
      return result;
    } else {
      return new ZoneOffset(totalSeconds);
    }
  };
  _proto.rules = function rules() {
    return this._rules;
  };
  _proto.get = function get(field) {
    return this.getLong(field);
  };
  _proto.getLong = function getLong(field) {
    if (field === ChronoField.OFFSET_SECONDS) {
      return this._totalSeconds;
    } else if (field instanceof ChronoField) {
      throw new DateTimeException("Unsupported field: " + field);
    }
    return field.getFrom(this);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    if (_query === TemporalQueries.offset() || _query === TemporalQueries.zone()) {
      return this;
    } else if (_query === TemporalQueries.localDate() || _query === TemporalQueries.localTime() || _query === TemporalQueries.precision() || _query === TemporalQueries.chronology() || _query === TemporalQueries.zoneId()) {
      return null;
    }
    return _query.queryFrom(this);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    return temporal.with(ChronoField.OFFSET_SECONDS, this._totalSeconds);
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    return other._totalSeconds - this._totalSeconds;
  };
  _proto.equals = function equals(obj) {
    if (this === obj) {
      return true;
    }
    if (obj instanceof ZoneOffset) {
      return this._totalSeconds === obj._totalSeconds;
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return this._totalSeconds;
  };
  _proto.toString = function toString() {
    return this._id;
  };
  return ZoneOffset;
}(ZoneId);
function _init$g() {
  ZoneOffset.MAX_SECONDS = 18 * LocalTime.SECONDS_PER_HOUR;
  ZoneOffset.UTC = ZoneOffset.ofTotalSeconds(0);
  ZoneOffset.MIN = ZoneOffset.ofTotalSeconds(-ZoneOffset.MAX_SECONDS);
  ZoneOffset.MAX = ZoneOffset.ofTotalSeconds(ZoneOffset.MAX_SECONDS);
}

var DateTimeBuilder = function (_TemporalAccessor) {
  _inheritsLoose(DateTimeBuilder, _TemporalAccessor);
  DateTimeBuilder.create = function create(field, value) {
    var dtb = new DateTimeBuilder();
    dtb._addFieldValue(field, value);
    return dtb;
  };
  function DateTimeBuilder() {
    var _this;
    _this = _TemporalAccessor.call(this) || this;
    _this.fieldValues = new EnumMap();
    _this.chrono = null;
    _this.zone = null;
    _this.date = null;
    _this.time = null;
    _this.leapSecond = false;
    _this.excessDays = null;
    return _this;
  }
  var _proto = DateTimeBuilder.prototype;
  _proto.getFieldValue0 = function getFieldValue0(field) {
    return this.fieldValues.get(field);
  };
  _proto._addFieldValue = function _addFieldValue(field, value) {
    requireNonNull(field, 'field');
    var old = this.getFieldValue0(field);
    if (old != null && old !== value) {
      throw new DateTimeException("Conflict found: " + field + " " + old + " differs from " + field + " " + value + ": " + this);
    }
    return this._putFieldValue0(field, value);
  };
  _proto._putFieldValue0 = function _putFieldValue0(field, value) {
    this.fieldValues.put(field, value);
    return this;
  };
  _proto.resolve = function resolve(resolverStyle, resolverFields) {
    if (resolverFields != null) {
      this.fieldValues.retainAll(resolverFields);
    }
    this._mergeDate(resolverStyle);
    this._mergeTime(resolverStyle);
    this._resolveTimeInferZeroes(resolverStyle);
    if (this.excessDays != null && this.excessDays.isZero() === false && this.date != null && this.time != null) {
      this.date = this.date.plus(this.excessDays);
      this.excessDays = Period.ZERO;
    }
    this._resolveInstant();
    return this;
  };
  _proto._mergeDate = function _mergeDate(resolverStyle) {
    this._checkDate(IsoChronology.INSTANCE.resolveDate(this.fieldValues, resolverStyle));
  };
  _proto._checkDate = function _checkDate(date) {
    if (date != null) {
      this._addObject(date);
      for (var fieldName in this.fieldValues.keySet()) {
        var field = ChronoField.byName(fieldName);
        if (field) {
          if (this.fieldValues.get(field) !== undefined) {
            if (field.isDateBased()) {
              var val1 = void 0;
              try {
                val1 = date.getLong(field);
              } catch (ex) {
                if (ex instanceof DateTimeException) {
                  continue;
                } else {
                  throw ex;
                }
              }
              var val2 = this.fieldValues.get(field);
              if (val1 !== val2) {
                throw new DateTimeException("Conflict found: Field " + field + " " + val1 + " differs from " + field + " " + val2 + " derived from " + date);
              }
            }
          }
        }
      }
    }
  };
  _proto._mergeTime = function _mergeTime(resolverStyle) {
    if (this.fieldValues.containsKey(ChronoField.CLOCK_HOUR_OF_DAY)) {
      var ch = this.fieldValues.remove(ChronoField.CLOCK_HOUR_OF_DAY);
      if (resolverStyle !== ResolverStyle.LENIENT) {
        if (resolverStyle === ResolverStyle.SMART && ch === 0) ; else {
          ChronoField.CLOCK_HOUR_OF_DAY.checkValidValue(ch);
        }
      }
      this._addFieldValue(ChronoField.HOUR_OF_DAY, ch === 24 ? 0 : ch);
    }
    if (this.fieldValues.containsKey(ChronoField.CLOCK_HOUR_OF_AMPM)) {
      var _ch = this.fieldValues.remove(ChronoField.CLOCK_HOUR_OF_AMPM);
      if (resolverStyle !== ResolverStyle.LENIENT) {
        if (resolverStyle === ResolverStyle.SMART && _ch === 0) ; else {
          ChronoField.CLOCK_HOUR_OF_AMPM.checkValidValue(_ch);
        }
      }
      this._addFieldValue(ChronoField.HOUR_OF_AMPM, _ch === 12 ? 0 : _ch);
    }
    if (resolverStyle !== ResolverStyle.LENIENT) {
      if (this.fieldValues.containsKey(ChronoField.AMPM_OF_DAY)) {
        ChronoField.AMPM_OF_DAY.checkValidValue(this.fieldValues.get(ChronoField.AMPM_OF_DAY));
      }
      if (this.fieldValues.containsKey(ChronoField.HOUR_OF_AMPM)) {
        ChronoField.HOUR_OF_AMPM.checkValidValue(this.fieldValues.get(ChronoField.HOUR_OF_AMPM));
      }
    }
    if (this.fieldValues.containsKey(ChronoField.AMPM_OF_DAY) && this.fieldValues.containsKey(ChronoField.HOUR_OF_AMPM)) {
      var ap = this.fieldValues.remove(ChronoField.AMPM_OF_DAY);
      var hap = this.fieldValues.remove(ChronoField.HOUR_OF_AMPM);
      this._addFieldValue(ChronoField.HOUR_OF_DAY, ap * 12 + hap);
    }
    if (this.fieldValues.containsKey(ChronoField.NANO_OF_DAY)) {
      var nod = this.fieldValues.remove(ChronoField.NANO_OF_DAY);
      if (resolverStyle !== ResolverStyle.LENIENT) {
        ChronoField.NANO_OF_DAY.checkValidValue(nod);
      }
      this._addFieldValue(ChronoField.SECOND_OF_DAY, MathUtil.intDiv(nod, 1000000000));
      this._addFieldValue(ChronoField.NANO_OF_SECOND, MathUtil.intMod(nod, 1000000000));
    }
    if (this.fieldValues.containsKey(ChronoField.MICRO_OF_DAY)) {
      var cod = this.fieldValues.remove(ChronoField.MICRO_OF_DAY);
      if (resolverStyle !== ResolverStyle.LENIENT) {
        ChronoField.MICRO_OF_DAY.checkValidValue(cod);
      }
      this._addFieldValue(ChronoField.SECOND_OF_DAY, MathUtil.intDiv(cod, 1000000));
      this._addFieldValue(ChronoField.MICRO_OF_SECOND, MathUtil.intMod(cod, 1000000));
    }
    if (this.fieldValues.containsKey(ChronoField.MILLI_OF_DAY)) {
      var lod = this.fieldValues.remove(ChronoField.MILLI_OF_DAY);
      if (resolverStyle !== ResolverStyle.LENIENT) {
        ChronoField.MILLI_OF_DAY.checkValidValue(lod);
      }
      this._addFieldValue(ChronoField.SECOND_OF_DAY, MathUtil.intDiv(lod, 1000));
      this._addFieldValue(ChronoField.MILLI_OF_SECOND, MathUtil.intMod(lod, 1000));
    }
    if (this.fieldValues.containsKey(ChronoField.SECOND_OF_DAY)) {
      var sod = this.fieldValues.remove(ChronoField.SECOND_OF_DAY);
      if (resolverStyle !== ResolverStyle.LENIENT) {
        ChronoField.SECOND_OF_DAY.checkValidValue(sod);
      }
      this._addFieldValue(ChronoField.HOUR_OF_DAY, MathUtil.intDiv(sod, 3600));
      this._addFieldValue(ChronoField.MINUTE_OF_HOUR, MathUtil.intMod(MathUtil.intDiv(sod, 60), 60));
      this._addFieldValue(ChronoField.SECOND_OF_MINUTE, MathUtil.intMod(sod, 60));
    }
    if (this.fieldValues.containsKey(ChronoField.MINUTE_OF_DAY)) {
      var mod = this.fieldValues.remove(ChronoField.MINUTE_OF_DAY);
      if (resolverStyle !== ResolverStyle.LENIENT) {
        ChronoField.MINUTE_OF_DAY.checkValidValue(mod);
      }
      this._addFieldValue(ChronoField.HOUR_OF_DAY, MathUtil.intDiv(mod, 60));
      this._addFieldValue(ChronoField.MINUTE_OF_HOUR, MathUtil.intMod(mod, 60));
    }
    if (resolverStyle !== ResolverStyle.LENIENT) {
      if (this.fieldValues.containsKey(ChronoField.MILLI_OF_SECOND)) {
        ChronoField.MILLI_OF_SECOND.checkValidValue(this.fieldValues.get(ChronoField.MILLI_OF_SECOND));
      }
      if (this.fieldValues.containsKey(ChronoField.MICRO_OF_SECOND)) {
        ChronoField.MICRO_OF_SECOND.checkValidValue(this.fieldValues.get(ChronoField.MICRO_OF_SECOND));
      }
    }
    if (this.fieldValues.containsKey(ChronoField.MILLI_OF_SECOND) && this.fieldValues.containsKey(ChronoField.MICRO_OF_SECOND)) {
      var los = this.fieldValues.remove(ChronoField.MILLI_OF_SECOND);
      var cos = this.fieldValues.get(ChronoField.MICRO_OF_SECOND);
      this._putFieldValue0(ChronoField.MICRO_OF_SECOND, los * 1000 + MathUtil.intMod(cos, 1000));
    }
    if (this.fieldValues.containsKey(ChronoField.MICRO_OF_SECOND) && this.fieldValues.containsKey(ChronoField.NANO_OF_SECOND)) {
      var nos = this.fieldValues.get(ChronoField.NANO_OF_SECOND);
      this._putFieldValue0(ChronoField.MICRO_OF_SECOND, MathUtil.intDiv(nos, 1000));
      this.fieldValues.remove(ChronoField.MICRO_OF_SECOND);
    }
    if (this.fieldValues.containsKey(ChronoField.MILLI_OF_SECOND) && this.fieldValues.containsKey(ChronoField.NANO_OF_SECOND)) {
      var _nos = this.fieldValues.get(ChronoField.NANO_OF_SECOND);
      this._putFieldValue0(ChronoField.MILLI_OF_SECOND, MathUtil.intDiv(_nos, 1000000));
      this.fieldValues.remove(ChronoField.MILLI_OF_SECOND);
    }
    if (this.fieldValues.containsKey(ChronoField.MICRO_OF_SECOND)) {
      var _cos = this.fieldValues.remove(ChronoField.MICRO_OF_SECOND);
      this._putFieldValue0(ChronoField.NANO_OF_SECOND, _cos * 1000);
    } else if (this.fieldValues.containsKey(ChronoField.MILLI_OF_SECOND)) {
      var _los = this.fieldValues.remove(ChronoField.MILLI_OF_SECOND);
      this._putFieldValue0(ChronoField.NANO_OF_SECOND, _los * 1000000);
    }
  };
  _proto._resolveTimeInferZeroes = function _resolveTimeInferZeroes(resolverStyle) {
    var hod = this.fieldValues.get(ChronoField.HOUR_OF_DAY);
    var moh = this.fieldValues.get(ChronoField.MINUTE_OF_HOUR);
    var som = this.fieldValues.get(ChronoField.SECOND_OF_MINUTE);
    var nos = this.fieldValues.get(ChronoField.NANO_OF_SECOND);
    if (hod == null) {
      return;
    }
    if (moh == null && (som != null || nos != null)) {
      return;
    }
    if (moh != null && som == null && nos != null) {
      return;
    }
    if (resolverStyle !== ResolverStyle.LENIENT) {
      if (hod != null) {
        if (resolverStyle === ResolverStyle.SMART && hod === 24 && (moh == null || moh === 0) && (som == null || som === 0) && (nos == null || nos === 0)) {
          hod = 0;
          this.excessDays = Period.ofDays(1);
        }
        var hodVal = ChronoField.HOUR_OF_DAY.checkValidIntValue(hod);
        if (moh != null) {
          var mohVal = ChronoField.MINUTE_OF_HOUR.checkValidIntValue(moh);
          if (som != null) {
            var somVal = ChronoField.SECOND_OF_MINUTE.checkValidIntValue(som);
            if (nos != null) {
              var nosVal = ChronoField.NANO_OF_SECOND.checkValidIntValue(nos);
              this._addObject(LocalTime.of(hodVal, mohVal, somVal, nosVal));
            } else {
              this._addObject(LocalTime.of(hodVal, mohVal, somVal));
            }
          } else {
            if (nos == null) {
              this._addObject(LocalTime.of(hodVal, mohVal));
            }
          }
        } else {
          if (som == null && nos == null) {
            this._addObject(LocalTime.of(hodVal, 0));
          }
        }
      }
    } else {
      if (hod != null) {
        var _hodVal = hod;
        if (moh != null) {
          if (som != null) {
            if (nos == null) {
              nos = 0;
            }
            var totalNanos = MathUtil.safeMultiply(_hodVal, 3600000000000);
            totalNanos = MathUtil.safeAdd(totalNanos, MathUtil.safeMultiply(moh, 60000000000));
            totalNanos = MathUtil.safeAdd(totalNanos, MathUtil.safeMultiply(som, 1000000000));
            totalNanos = MathUtil.safeAdd(totalNanos, nos);
            var excessDays = MathUtil.floorDiv(totalNanos, 86400000000000);
            var nod = MathUtil.floorMod(totalNanos, 86400000000000);
            this._addObject(LocalTime.ofNanoOfDay(nod));
            this.excessDays = Period.ofDays(excessDays);
          } else {
            var totalSecs = MathUtil.safeMultiply(_hodVal, 3600);
            totalSecs = MathUtil.safeAdd(totalSecs, MathUtil.safeMultiply(moh, 60));
            var _excessDays = MathUtil.floorDiv(totalSecs, 86400);
            var sod = MathUtil.floorMod(totalSecs, 86400);
            this._addObject(LocalTime.ofSecondOfDay(sod));
            this.excessDays = Period.ofDays(_excessDays);
          }
        } else {
          var _excessDays2 = MathUtil.safeToInt(MathUtil.floorDiv(_hodVal, 24));
          _hodVal = MathUtil.floorMod(_hodVal, 24);
          this._addObject(LocalTime.of(_hodVal, 0));
          this.excessDays = Period.ofDays(_excessDays2);
        }
      }
    }
    this.fieldValues.remove(ChronoField.HOUR_OF_DAY);
    this.fieldValues.remove(ChronoField.MINUTE_OF_HOUR);
    this.fieldValues.remove(ChronoField.SECOND_OF_MINUTE);
    this.fieldValues.remove(ChronoField.NANO_OF_SECOND);
  };
  _proto._addObject = function _addObject(dateOrTime) {
    if (dateOrTime instanceof ChronoLocalDate) {
      this.date = dateOrTime;
    } else if (dateOrTime instanceof LocalTime) {
      this.time = dateOrTime;
    }
  };
  _proto._resolveInstant = function _resolveInstant() {
    if (this.date != null && this.time != null) {
      var offsetSecs = this.fieldValues.get(ChronoField.OFFSET_SECONDS);
      if (offsetSecs != null) {
        var offset = ZoneOffset.ofTotalSeconds(offsetSecs);
        var instant = this.date.atTime(this.time).atZone(offset).getLong(ChronoField.INSTANT_SECONDS);
        this.fieldValues.put(ChronoField.INSTANT_SECONDS, instant);
      } else if (this.zone != null) {
        var _instant = this.date.atTime(this.time).atZone(this.zone).getLong(ChronoField.INSTANT_SECONDS);
        this.fieldValues.put(ChronoField.INSTANT_SECONDS, _instant);
      }
    }
  };
  _proto.build = function build(type) {
    return type.queryFrom(this);
  };
  _proto.isSupported = function isSupported(field) {
    if (field == null) {
      return false;
    }
    return this.fieldValues.containsKey(field) && this.fieldValues.get(field) !== undefined || this.date != null && this.date.isSupported(field) || this.time != null && this.time.isSupported(field);
  };
  _proto.getLong = function getLong(field) {
    requireNonNull(field, 'field');
    var value = this.getFieldValue0(field);
    if (value == null) {
      if (this.date != null && this.date.isSupported(field)) {
        return this.date.getLong(field);
      }
      if (this.time != null && this.time.isSupported(field)) {
        return this.time.getLong(field);
      }
      throw new DateTimeException("Field not found: " + field);
    }
    return value;
  };
  _proto.query = function query(_query) {
    if (_query === TemporalQueries.zoneId()) {
      return this.zone;
    } else if (_query === TemporalQueries.chronology()) {
      return this.chrono;
    } else if (_query === TemporalQueries.localDate()) {
      return this.date != null ? LocalDate.from(this.date) : null;
    } else if (_query === TemporalQueries.localTime()) {
      return this.time;
    } else if (_query === TemporalQueries.zone() || _query === TemporalQueries.offset()) {
      return _query.queryFrom(this);
    } else if (_query === TemporalQueries.precision()) {
      return null;
    }
    return _query.queryFrom(this);
  };
  return DateTimeBuilder;
}(TemporalAccessor);

var DateTimeParseContext = function () {
  function DateTimeParseContext() {
    if (arguments.length === 1) {
      if (arguments[0] instanceof DateTimeParseContext) {
        this._constructorSelf.apply(this, arguments);
        return;
      } else {
        this._constructorFormatter.apply(this, arguments);
      }
    } else {
      this._constructorParam.apply(this, arguments);
    }
    this._caseSensitive = true;
    this._strict = true;
    this._parsed = [new Parsed(this)];
  }
  var _proto = DateTimeParseContext.prototype;
  _proto._constructorParam = function _constructorParam(locale, symbols, chronology) {
    this._locale = locale;
    this._symbols = symbols;
    this._overrideChronology = chronology;
  };
  _proto._constructorFormatter = function _constructorFormatter(formatter) {
    this._locale = formatter.locale();
    this._symbols = formatter.decimalStyle();
    this._overrideChronology = formatter.chronology();
  };
  _proto._constructorSelf = function _constructorSelf(other) {
    this._locale = other._locale;
    this._symbols = other._symbols;
    this._overrideChronology = other._overrideChronology;
    this._overrideZone = other._overrideZone;
    this._caseSensitive = other._caseSensitive;
    this._strict = other._strict;
    this._parsed = [new Parsed(this)];
  };
  _proto.copy = function copy() {
    return new DateTimeParseContext(this);
  };
  _proto.symbols = function symbols() {
    return this._symbols;
  };
  _proto.isStrict = function isStrict() {
    return this._strict;
  };
  _proto.setStrict = function setStrict(strict) {
    this._strict = strict;
  };
  _proto.locale = function locale() {
    return this._locale;
  };
  _proto.setLocale = function setLocale(locale) {
    this._locale = locale;
  };
  _proto.startOptional = function startOptional() {
    this._parsed.push(this.currentParsed().copy());
  };
  _proto.endOptional = function endOptional(successful) {
    if (successful) {
      this._parsed.splice(this._parsed.length - 2, 1);
    } else {
      this._parsed.splice(this._parsed.length - 1, 1);
    }
  };
  _proto.isCaseSensitive = function isCaseSensitive() {
    return this._caseSensitive;
  };
  _proto.setCaseSensitive = function setCaseSensitive(caseSensitive) {
    this._caseSensitive = caseSensitive;
  };
  _proto.subSequenceEquals = function subSequenceEquals(cs1, offset1, cs2, offset2, length) {
    if (offset1 + length > cs1.length || offset2 + length > cs2.length) {
      return false;
    }
    if (!this.isCaseSensitive()) {
      cs1 = cs1.toLowerCase();
      cs2 = cs2.toLowerCase();
    }
    for (var i = 0; i < length; i++) {
      var ch1 = cs1[offset1 + i];
      var ch2 = cs2[offset2 + i];
      if (ch1 !== ch2) {
        return false;
      }
    }
    return true;
  };
  _proto.charEquals = function charEquals(ch1, ch2) {
    if (this.isCaseSensitive()) {
      return ch1 === ch2;
    }
    return this.charEqualsIgnoreCase(ch1, ch2);
  };
  _proto.charEqualsIgnoreCase = function charEqualsIgnoreCase(c1, c2) {
    return c1 === c2 || c1.toLowerCase() === c2.toLowerCase();
  };
  _proto.setParsedField = function setParsedField(field, value, errorPos, successPos) {
    var currentParsedFieldValues = this.currentParsed().fieldValues;
    var old = currentParsedFieldValues.get(field);
    currentParsedFieldValues.set(field, value);
    return old != null && old !== value ? ~errorPos : successPos;
  };
  _proto.setParsedZone = function setParsedZone(zone) {
    requireNonNull(zone, 'zone');
    this.currentParsed().zone = zone;
  };
  _proto.getParsed = function getParsed(field) {
    return this.currentParsed().fieldValues.get(field);
  };
  _proto.toParsed = function toParsed() {
    return this.currentParsed();
  };
  _proto.currentParsed = function currentParsed() {
    return this._parsed[this._parsed.length - 1];
  };
  _proto.setParsedLeapSecond = function setParsedLeapSecond() {
    this.currentParsed().leapSecond = true;
  };
  _proto.getEffectiveChronology = function getEffectiveChronology() {
    var chrono = this.currentParsed().chrono;
    if (chrono == null) {
      chrono = this._overrideChronology;
      if (chrono == null) {
        chrono = IsoChronology.INSTANCE;
      }
    }
    return chrono;
  };
  return DateTimeParseContext;
}();
var Parsed = function (_Temporal) {
  _inheritsLoose(Parsed, _Temporal);
  function Parsed(dateTimeParseContext) {
    var _this;
    _this = _Temporal.call(this) || this;
    _this.chrono = null;
    _this.zone = null;
    _this.fieldValues = new EnumMap();
    _this.leapSecond = false;
    _this.dateTimeParseContext = dateTimeParseContext;
    return _this;
  }
  var _proto2 = Parsed.prototype;
  _proto2.copy = function copy() {
    var cloned = new Parsed();
    cloned.chrono = this.chrono;
    cloned.zone = this.zone;
    cloned.fieldValues.putAll(this.fieldValues);
    cloned.leapSecond = this.leapSecond;
    cloned.dateTimeParseContext = this.dateTimeParseContext;
    return cloned;
  };
  _proto2.toString = function toString() {
    return this.fieldValues + ", " + this.chrono + ", " + this.zone;
  };
  _proto2.isSupported = function isSupported(field) {
    return this.fieldValues.containsKey(field);
  };
  _proto2.get = function get(field) {
    var val = this.fieldValues.get(field);
    assert(val != null);
    return val;
  };
  _proto2.query = function query(_query) {
    if (_query === TemporalQueries.chronology()) {
      return this.chrono;
    }
    if (_query === TemporalQueries.zoneId() || _query === TemporalQueries.zone()) {
      return this.zone;
    }
    return _Temporal.prototype.query.call(this, _query);
  };
  _proto2.toBuilder = function toBuilder() {
    var builder = new DateTimeBuilder();
    builder.fieldValues.putAll(this.fieldValues);
    builder.chrono = this.dateTimeParseContext.getEffectiveChronology();
    if (this.zone != null) {
      builder.zone = this.zone;
    } else {
      builder.zone = this.overrideZone;
    }
    builder.leapSecond = this.leapSecond;
    builder.excessDays = this.excessDays;
    return builder;
  };
  return Parsed;
}(Temporal);

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var DateTimePrintContext = function () {
  function DateTimePrintContext(temporal, localeOrFormatter, symbols) {
    if (arguments.length === 2 && arguments[1] instanceof DateTimeFormatter) {
      this._temporal = DateTimePrintContext.adjust(temporal, localeOrFormatter);
      this._locale = localeOrFormatter.locale();
      this._symbols = localeOrFormatter.decimalStyle();
    } else {
      this._temporal = temporal;
      this._locale = localeOrFormatter;
      this._symbols = symbols;
    }
    this._optional = 0;
  }
  DateTimePrintContext.adjust = function adjust(temporal, formatter) {
    return temporal;
  };
  var _proto = DateTimePrintContext.prototype;
  _proto.symbols = function symbols() {
    return this._symbols;
  };
  _proto.startOptional = function startOptional() {
    this._optional++;
  };
  _proto.endOptional = function endOptional() {
    this._optional--;
  };
  _proto.getValueQuery = function getValueQuery(query) {
    var result = this._temporal.query(query);
    if (result == null && this._optional === 0) {
      throw new DateTimeException("Unable to extract value: " + this._temporal);
    }
    return result;
  };
  _proto.getValue = function getValue(field) {
    try {
      return this._temporal.getLong(field);
    } catch (ex) {
      if (ex instanceof DateTimeException && this._optional > 0) {
        return null;
      }
      throw ex;
    }
  };
  _proto.temporal = function temporal() {
    return this._temporal;
  };
  _proto.locale = function locale() {
    return this._locale;
  };
  _proto.setDateTime = function setDateTime(temporal) {
    this._temporal = temporal;
  };
  _proto.setLocale = function setLocale(locale) {
    this._locale = locale;
  };
  return DateTimePrintContext;
}();

var IsoFields = {};
var QUARTER_DAYS = [0, 90, 181, 273, 0, 91, 182, 274];
var Field = function (_TemporalField) {
  _inheritsLoose(Field, _TemporalField);
  function Field() {
    return _TemporalField.apply(this, arguments) || this;
  }
  var _proto = Field.prototype;
  _proto.isDateBased = function isDateBased() {
    return true;
  };
  _proto.isTimeBased = function isTimeBased() {
    return false;
  };
  _proto._isIso = function _isIso() {
    return true;
  };
  Field._getWeekRangeByLocalDate = function _getWeekRangeByLocalDate(date) {
    var wby = Field._getWeekBasedYear(date);
    return ValueRange.of(1, Field._getWeekRangeByYear(wby));
  };
  Field._getWeekRangeByYear = function _getWeekRangeByYear(wby) {
    var date = LocalDate.of(wby, 1, 1);
    if (date.dayOfWeek() === DayOfWeek.THURSDAY || date.dayOfWeek() === DayOfWeek.WEDNESDAY && date.isLeapYear()) {
      return 53;
    }
    return 52;
  };
  Field._getWeek = function _getWeek(date) {
    var dow0 = date.dayOfWeek().ordinal();
    var doy0 = date.dayOfYear() - 1;
    var doyThu0 = doy0 + (3 - dow0);
    var alignedWeek = MathUtil.intDiv(doyThu0, 7);
    var firstThuDoy0 = doyThu0 - alignedWeek * 7;
    var firstMonDoy0 = firstThuDoy0 - 3;
    if (firstMonDoy0 < -3) {
      firstMonDoy0 += 7;
    }
    if (doy0 < firstMonDoy0) {
      return Field._getWeekRangeByLocalDate(date.withDayOfYear(180).minusYears(1)).maximum();
    }
    var week = MathUtil.intDiv(doy0 - firstMonDoy0, 7) + 1;
    if (week === 53) {
      if ((firstMonDoy0 === -3 || firstMonDoy0 === -2 && date.isLeapYear()) === false) {
        week = 1;
      }
    }
    return week;
  };
  Field._getWeekBasedYear = function _getWeekBasedYear(date) {
    var year = date.year();
    var doy = date.dayOfYear();
    if (doy <= 3) {
      var dow = date.dayOfWeek().ordinal();
      if (doy - dow < -2) {
        year--;
      }
    } else if (doy >= 363) {
      var _dow = date.dayOfWeek().ordinal();
      doy = doy - 363 - (date.isLeapYear() ? 1 : 0);
      if (doy - _dow >= 0) {
        year++;
      }
    }
    return year;
  };
  _proto.displayName = function displayName() {
    return this.toString();
  };
  _proto.resolve = function resolve() {
    return null;
  };
  _proto.name = function name() {
    return this.toString();
  };
  return Field;
}(TemporalField);
var DAY_OF_QUARTER_FIELD = function (_Field) {
  _inheritsLoose(DAY_OF_QUARTER_FIELD, _Field);
  function DAY_OF_QUARTER_FIELD() {
    return _Field.apply(this, arguments) || this;
  }
  var _proto2 = DAY_OF_QUARTER_FIELD.prototype;
  _proto2.toString = function toString() {
    return 'DayOfQuarter';
  };
  _proto2.baseUnit = function baseUnit() {
    return ChronoUnit.DAYS;
  };
  _proto2.rangeUnit = function rangeUnit() {
    return QUARTER_YEARS;
  };
  _proto2.range = function range() {
    return ValueRange.of(1, 90, 92);
  };
  _proto2.isSupportedBy = function isSupportedBy(temporal) {
    return temporal.isSupported(ChronoField.DAY_OF_YEAR) && temporal.isSupported(ChronoField.MONTH_OF_YEAR) && temporal.isSupported(ChronoField.YEAR) && this._isIso(temporal);
  };
  _proto2.rangeRefinedBy = function rangeRefinedBy(temporal) {
    if (temporal.isSupported(this) === false) {
      throw new UnsupportedTemporalTypeException('Unsupported field: DayOfQuarter');
    }
    var qoy = temporal.getLong(QUARTER_OF_YEAR);
    if (qoy === 1) {
      var year = temporal.getLong(ChronoField.YEAR);
      return IsoChronology.isLeapYear(year) ? ValueRange.of(1, 91) : ValueRange.of(1, 90);
    } else if (qoy === 2) {
      return ValueRange.of(1, 91);
    } else if (qoy === 3 || qoy === 4) {
      return ValueRange.of(1, 92);
    }
    return this.range();
  };
  _proto2.getFrom = function getFrom(temporal) {
    if (temporal.isSupported(this) === false) {
      throw new UnsupportedTemporalTypeException('Unsupported field: DayOfQuarter');
    }
    var doy = temporal.get(ChronoField.DAY_OF_YEAR);
    var moy = temporal.get(ChronoField.MONTH_OF_YEAR);
    var year = temporal.getLong(ChronoField.YEAR);
    return doy - QUARTER_DAYS[MathUtil.intDiv(moy - 1, 3) + (IsoChronology.isLeapYear(year) ? 4 : 0)];
  };
  _proto2.adjustInto = function adjustInto(temporal, newValue) {
    var curValue = this.getFrom(temporal);
    this.range().checkValidValue(newValue, this);
    return temporal.with(ChronoField.DAY_OF_YEAR, temporal.getLong(ChronoField.DAY_OF_YEAR) + (newValue - curValue));
  };
  _proto2.resolve = function resolve(fieldValues, partialTemporal, resolverStyle) {
    var yearLong = fieldValues.get(ChronoField.YEAR);
    var qoyLong = fieldValues.get(QUARTER_OF_YEAR);
    if (yearLong == null || qoyLong == null) {
      return null;
    }
    var y = ChronoField.YEAR.checkValidIntValue(yearLong);
    var doq = fieldValues.get(DAY_OF_QUARTER);
    var date;
    if (resolverStyle === ResolverStyle.LENIENT) {
      var qoy = qoyLong;
      date = LocalDate.of(y, 1, 1);
      date = date.plusMonths(MathUtil.safeMultiply(MathUtil.safeSubtract(qoy, 1), 3));
      date = date.plusDays(MathUtil.safeSubtract(doq, 1));
    } else {
      var _qoy = QUARTER_OF_YEAR.range().checkValidIntValue(qoyLong, QUARTER_OF_YEAR);
      if (resolverStyle === ResolverStyle.STRICT) {
        var max = 92;
        if (_qoy === 1) {
          max = IsoChronology.isLeapYear(y) ? 91 : 90;
        } else if (_qoy === 2) {
          max = 91;
        }
        ValueRange.of(1, max).checkValidValue(doq, this);
      } else {
        this.range().checkValidValue(doq, this);
      }
      date = LocalDate.of(y, (_qoy - 1) * 3 + 1, 1).plusDays(doq - 1);
    }
    fieldValues.remove(this);
    fieldValues.remove(ChronoField.YEAR);
    fieldValues.remove(QUARTER_OF_YEAR);
    return date;
  };
  return DAY_OF_QUARTER_FIELD;
}(Field);
var QUARTER_OF_YEAR_FIELD = function (_Field2) {
  _inheritsLoose(QUARTER_OF_YEAR_FIELD, _Field2);
  function QUARTER_OF_YEAR_FIELD() {
    return _Field2.apply(this, arguments) || this;
  }
  var _proto3 = QUARTER_OF_YEAR_FIELD.prototype;
  _proto3.toString = function toString() {
    return 'QuarterOfYear';
  };
  _proto3.baseUnit = function baseUnit() {
    return QUARTER_YEARS;
  };
  _proto3.rangeUnit = function rangeUnit() {
    return ChronoUnit.YEARS;
  };
  _proto3.range = function range() {
    return ValueRange.of(1, 4);
  };
  _proto3.isSupportedBy = function isSupportedBy(temporal) {
    return temporal.isSupported(ChronoField.MONTH_OF_YEAR) && this._isIso(temporal);
  };
  _proto3.rangeRefinedBy = function rangeRefinedBy(temporal) {
    return this.range();
  };
  _proto3.getFrom = function getFrom(temporal) {
    if (temporal.isSupported(this) === false) {
      throw new UnsupportedTemporalTypeException('Unsupported field: QuarterOfYear');
    }
    var moy = temporal.getLong(ChronoField.MONTH_OF_YEAR);
    return MathUtil.intDiv(moy + 2, 3);
  };
  _proto3.adjustInto = function adjustInto(temporal, newValue) {
    var curValue = this.getFrom(temporal);
    this.range().checkValidValue(newValue, this);
    return temporal.with(ChronoField.MONTH_OF_YEAR, temporal.getLong(ChronoField.MONTH_OF_YEAR) + (newValue - curValue) * 3);
  };
  return QUARTER_OF_YEAR_FIELD;
}(Field);
var WEEK_OF_WEEK_BASED_YEAR_FIELD = function (_Field3) {
  _inheritsLoose(WEEK_OF_WEEK_BASED_YEAR_FIELD, _Field3);
  function WEEK_OF_WEEK_BASED_YEAR_FIELD() {
    return _Field3.apply(this, arguments) || this;
  }
  var _proto4 = WEEK_OF_WEEK_BASED_YEAR_FIELD.prototype;
  _proto4.toString = function toString() {
    return 'WeekOfWeekBasedYear';
  };
  _proto4.baseUnit = function baseUnit() {
    return ChronoUnit.WEEKS;
  };
  _proto4.rangeUnit = function rangeUnit() {
    return WEEK_BASED_YEARS;
  };
  _proto4.range = function range() {
    return ValueRange.of(1, 52, 53);
  };
  _proto4.isSupportedBy = function isSupportedBy(temporal) {
    return temporal.isSupported(ChronoField.EPOCH_DAY) && this._isIso(temporal);
  };
  _proto4.rangeRefinedBy = function rangeRefinedBy(temporal) {
    if (temporal.isSupported(this) === false) {
      throw new UnsupportedTemporalTypeException('Unsupported field: WeekOfWeekBasedYear');
    }
    return Field._getWeekRangeByLocalDate(LocalDate.from(temporal));
  };
  _proto4.getFrom = function getFrom(temporal) {
    if (temporal.isSupported(this) === false) {
      throw new UnsupportedTemporalTypeException('Unsupported field: WeekOfWeekBasedYear');
    }
    return Field._getWeek(LocalDate.from(temporal));
  };
  _proto4.adjustInto = function adjustInto(temporal, newValue) {
    this.range().checkValidValue(newValue, this);
    return temporal.plus(MathUtil.safeSubtract(newValue, this.getFrom(temporal)), ChronoUnit.WEEKS);
  };
  _proto4.resolve = function resolve(fieldValues, partialTemporal, resolverStyle) {
    var wbyLong = fieldValues.get(WEEK_BASED_YEAR);
    var dowLong = fieldValues.get(ChronoField.DAY_OF_WEEK);
    if (wbyLong == null || dowLong == null) {
      return null;
    }
    var wby = WEEK_BASED_YEAR.range().checkValidIntValue(wbyLong, WEEK_BASED_YEAR);
    var wowby = fieldValues.get(WEEK_OF_WEEK_BASED_YEAR);
    var date;
    if (resolverStyle === ResolverStyle.LENIENT) {
      var dow = dowLong;
      var weeks = 0;
      if (dow > 7) {
        weeks = MathUtil.intDiv(dow - 1, 7);
        dow = MathUtil.intMod(dow - 1, 7) + 1;
      } else if (dow < 1) {
        weeks = MathUtil.intDiv(dow, 7) - 1;
        dow = MathUtil.intMod(dow, 7) + 7;
      }
      date = LocalDate.of(wby, 1, 4).plusWeeks(wowby - 1).plusWeeks(weeks).with(ChronoField.DAY_OF_WEEK, dow);
    } else {
      var _dow2 = ChronoField.DAY_OF_WEEK.checkValidIntValue(dowLong);
      if (resolverStyle === ResolverStyle.STRICT) {
        var temp = LocalDate.of(wby, 1, 4);
        var range = Field._getWeekRangeByLocalDate(temp);
        range.checkValidValue(wowby, this);
      } else {
        this.range().checkValidValue(wowby, this);
      }
      date = LocalDate.of(wby, 1, 4).plusWeeks(wowby - 1).with(ChronoField.DAY_OF_WEEK, _dow2);
    }
    fieldValues.remove(this);
    fieldValues.remove(WEEK_BASED_YEAR);
    fieldValues.remove(ChronoField.DAY_OF_WEEK);
    return date;
  };
  _proto4.displayName = function displayName() {
    return 'Week';
  };
  return WEEK_OF_WEEK_BASED_YEAR_FIELD;
}(Field);
var WEEK_BASED_YEAR_FIELD = function (_Field4) {
  _inheritsLoose(WEEK_BASED_YEAR_FIELD, _Field4);
  function WEEK_BASED_YEAR_FIELD() {
    return _Field4.apply(this, arguments) || this;
  }
  var _proto5 = WEEK_BASED_YEAR_FIELD.prototype;
  _proto5.toString = function toString() {
    return 'WeekBasedYear';
  };
  _proto5.baseUnit = function baseUnit() {
    return WEEK_BASED_YEARS;
  };
  _proto5.rangeUnit = function rangeUnit() {
    return ChronoUnit.FOREVER;
  };
  _proto5.range = function range() {
    return ChronoField.YEAR.range();
  };
  _proto5.isSupportedBy = function isSupportedBy(temporal) {
    return temporal.isSupported(ChronoField.EPOCH_DAY) && this._isIso(temporal);
  };
  _proto5.rangeRefinedBy = function rangeRefinedBy(temporal) {
    return ChronoField.YEAR.range();
  };
  _proto5.getFrom = function getFrom(temporal) {
    if (temporal.isSupported(this) === false) {
      throw new UnsupportedTemporalTypeException('Unsupported field: WeekBasedYear');
    }
    return Field._getWeekBasedYear(LocalDate.from(temporal));
  };
  _proto5.adjustInto = function adjustInto(temporal, newValue) {
    if (this.isSupportedBy(temporal) === false) {
      throw new UnsupportedTemporalTypeException('Unsupported field: WeekBasedYear');
    }
    var newWby = this.range().checkValidIntValue(newValue, WEEK_BASED_YEAR);
    var date = LocalDate.from(temporal);
    var dow = date.get(ChronoField.DAY_OF_WEEK);
    var week = Field._getWeek(date);
    if (week === 53 && Field._getWeekRangeByYear(newWby) === 52) {
      week = 52;
    }
    var resolved = LocalDate.of(newWby, 1, 4);
    var days = dow - resolved.get(ChronoField.DAY_OF_WEEK) + (week - 1) * 7;
    resolved = resolved.plusDays(days);
    return temporal.with(resolved);
  };
  return WEEK_BASED_YEAR_FIELD;
}(Field);
var Unit = function (_TemporalUnit) {
  _inheritsLoose(Unit, _TemporalUnit);
  function Unit(name, estimatedDuration) {
    var _this;
    _this = _TemporalUnit.call(this) || this;
    _this._name = name;
    _this._duration = estimatedDuration;
    return _this;
  }
  var _proto6 = Unit.prototype;
  _proto6.duration = function duration() {
    return this._duration;
  };
  _proto6.isDurationEstimated = function isDurationEstimated() {
    return true;
  };
  _proto6.isDateBased = function isDateBased() {
    return true;
  };
  _proto6.isTimeBased = function isTimeBased() {
    return false;
  };
  _proto6.isSupportedBy = function isSupportedBy(temporal) {
    return temporal.isSupported(ChronoField.EPOCH_DAY);
  };
  _proto6.addTo = function addTo(temporal, periodToAdd) {
    switch (this) {
      case WEEK_BASED_YEARS:
        {
          var added = MathUtil.safeAdd(temporal.get(WEEK_BASED_YEAR), periodToAdd);
          return temporal.with(WEEK_BASED_YEAR, added);
        }
      case QUARTER_YEARS:
        return temporal.plus(MathUtil.intDiv(periodToAdd, 256), ChronoUnit.YEARS).plus(MathUtil.intMod(periodToAdd, 256) * 3, ChronoUnit.MONTHS);
      default:
        throw new IllegalStateException('Unreachable');
    }
  };
  _proto6.between = function between(temporal1, temporal2) {
    switch (this) {
      case WEEK_BASED_YEARS:
        return MathUtil.safeSubtract(temporal2.getLong(WEEK_BASED_YEAR), temporal1.getLong(WEEK_BASED_YEAR));
      case QUARTER_YEARS:
        return MathUtil.intDiv(temporal1.until(temporal2, ChronoUnit.MONTHS), 3);
      default:
        throw new IllegalStateException('Unreachable');
    }
  };
  _proto6.toString = function toString() {
    return this._name;
  };
  return Unit;
}(TemporalUnit);
var DAY_OF_QUARTER = null;
var QUARTER_OF_YEAR = null;
var WEEK_OF_WEEK_BASED_YEAR = null;
var WEEK_BASED_YEAR = null;
var WEEK_BASED_YEARS = null;
var QUARTER_YEARS = null;
function _init$f() {
  DAY_OF_QUARTER = new DAY_OF_QUARTER_FIELD();
  QUARTER_OF_YEAR = new QUARTER_OF_YEAR_FIELD();
  WEEK_OF_WEEK_BASED_YEAR = new WEEK_OF_WEEK_BASED_YEAR_FIELD();
  WEEK_BASED_YEAR = new WEEK_BASED_YEAR_FIELD();
  WEEK_BASED_YEARS = new Unit('WeekBasedYears', Duration.ofSeconds(31556952));
  QUARTER_YEARS = new Unit('QuarterYears', Duration.ofSeconds(31556952 / 4));
  IsoFields.DAY_OF_QUARTER = DAY_OF_QUARTER;
  IsoFields.QUARTER_OF_YEAR = QUARTER_OF_YEAR;
  IsoFields.WEEK_OF_WEEK_BASED_YEAR = WEEK_OF_WEEK_BASED_YEAR;
  IsoFields.WEEK_BASED_YEAR = WEEK_BASED_YEAR;
  IsoFields.WEEK_BASED_YEARS = WEEK_BASED_YEARS;
  IsoFields.QUARTER_YEARS = QUARTER_YEARS;
  LocalDate.prototype.isoWeekOfWeekyear = function () {
    return this.get(IsoFields.WEEK_OF_WEEK_BASED_YEAR);
  };
  LocalDate.prototype.isoWeekyear = function () {
    return this.get(IsoFields.WEEK_BASED_YEAR);
  };
}

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */

var DecimalStyle = function () {
  function DecimalStyle(zeroChar, positiveSignChar, negativeSignChar, decimalPointChar) {
    this._zeroDigit = zeroChar;
    this._zeroDigitCharCode = zeroChar.charCodeAt(0);
    this._positiveSign = positiveSignChar;
    this._negativeSign = negativeSignChar;
    this._decimalSeparator = decimalPointChar;
  }
  var _proto = DecimalStyle.prototype;
  _proto.positiveSign = function positiveSign() {
    return this._positiveSign;
  };
  _proto.withPositiveSign = function withPositiveSign(positiveSign) {
    if (positiveSign === this._positiveSign) {
      return this;
    }
    return new DecimalStyle(this._zeroDigit, positiveSign, this._negativeSign, this._decimalSeparator);
  };
  _proto.negativeSign = function negativeSign() {
    return this._negativeSign;
  };
  _proto.withNegativeSign = function withNegativeSign(negativeSign) {
    if (negativeSign === this._negativeSign) {
      return this;
    }
    return new DecimalStyle(this._zeroDigit, this._positiveSign, negativeSign, this._decimalSeparator);
  };
  _proto.zeroDigit = function zeroDigit() {
    return this._zeroDigit;
  };
  _proto.withZeroDigit = function withZeroDigit(zeroDigit) {
    if (zeroDigit === this._zeroDigit) {
      return this;
    }
    return new DecimalStyle(zeroDigit, this._positiveSign, this._negativeSign, this._decimalSeparator);
  };
  _proto.decimalSeparator = function decimalSeparator() {
    return this._decimalSeparator;
  };
  _proto.withDecimalSeparator = function withDecimalSeparator(decimalSeparator) {
    if (decimalSeparator === this._decimalSeparator) {
      return this;
    }
    return new DecimalStyle(this._zeroDigit, this._positiveSign, this._negativeSign, decimalSeparator);
  };
  _proto.convertToDigit = function convertToDigit(char) {
    var val = char.charCodeAt(0) - this._zeroDigitCharCode;
    return val >= 0 && val <= 9 ? val : -1;
  };
  _proto.convertNumberToI18N = function convertNumberToI18N(numericText) {
    if (this._zeroDigit === '0') {
      return numericText;
    }
    var diff = this._zeroDigitCharCode - '0'.charCodeAt(0);
    var convertedText = '';
    for (var i = 0; i < numericText.length; i++) {
      convertedText += String.fromCharCode(numericText.charCodeAt(i) + diff);
    }
    return convertedText;
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof DecimalStyle) {
      return this._zeroDigit === other._zeroDigit && this._positiveSign === other._positiveSign && this._negativeSign === other._negativeSign && this._decimalSeparator === other._decimalSeparator;
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator;
  };
  _proto.toString = function toString() {
    return "DecimalStyle[" + this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator + "]";
  };
  DecimalStyle.of = function of() {
    throw new Error('not yet supported');
  };
  DecimalStyle.availableLocales = function availableLocales() {
    throw new Error('not yet supported');
  };
  return DecimalStyle;
}();
DecimalStyle.STANDARD = new DecimalStyle('0', '+', '-', '.');

var SignStyle = function (_Enum) {
  _inheritsLoose(SignStyle, _Enum);
  function SignStyle() {
    return _Enum.apply(this, arguments) || this;
  }
  var _proto = SignStyle.prototype;
  _proto.parse = function parse(positive, strict, fixedWidth) {
    switch (this) {
      case SignStyle.NORMAL:
        return !positive || !strict;
      case SignStyle.ALWAYS:
      case SignStyle.EXCEEDS_PAD:
        return true;
      default:
        return !strict && !fixedWidth;
    }
  };
  return SignStyle;
}(Enum);
SignStyle.NORMAL = new SignStyle('NORMAL');
SignStyle.NEVER = new SignStyle('NEVER');
SignStyle.ALWAYS = new SignStyle('ALWAYS');
SignStyle.EXCEEDS_PAD = new SignStyle('EXCEEDS_PAD');
SignStyle.NOT_NEGATIVE = new SignStyle('NOT_NEGATIVE');

var TextStyle = function (_Enum) {
  _inheritsLoose(TextStyle, _Enum);
  function TextStyle() {
    return _Enum.apply(this, arguments) || this;
  }
  var _proto = TextStyle.prototype;
  _proto.isStandalone = function isStandalone() {
    switch (this) {
      case TextStyle.FULL_STANDALONE:
      case TextStyle.SHORT_STANDALONE:
      case TextStyle.NARROW_STANDALONE:
        return true;
      default:
        return false;
    }
  };
  _proto.asStandalone = function asStandalone() {
    switch (this) {
      case TextStyle.FULL:
        return TextStyle.FULL_STANDALONE;
      case TextStyle.SHORT:
        return TextStyle.SHORT_STANDALONE;
      case TextStyle.NARROW:
        return TextStyle.NARROW_STANDALONE;
      default:
        return this;
    }
  };
  _proto.asNormal = function asNormal() {
    switch (this) {
      case TextStyle.FULL_STANDALONE:
        return TextStyle.FULL;
      case TextStyle.SHORT_STANDALONE:
        return TextStyle.SHORT;
      case TextStyle.NARROW_STANDALONE:
        return TextStyle.NARROW;
      default:
        return this;
    }
  };
  return TextStyle;
}(Enum);
TextStyle.FULL = new TextStyle('FULL');
TextStyle.FULL_STANDALONE = new TextStyle('FULL_STANDALONE');
TextStyle.SHORT = new TextStyle('SHORT');
TextStyle.SHORT_STANDALONE = new TextStyle('SHORT_STANDALONE');
TextStyle.NARROW = new TextStyle('NARROW');
TextStyle.NARROW_STANDALONE = new TextStyle('NARROW_STANDALONE');

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var CharLiteralPrinterParser = function () {
  function CharLiteralPrinterParser(literal) {
    if (literal.length > 1) {
      throw new IllegalArgumentException("invalid literal, too long: \"" + literal + "\"");
    }
    this._literal = literal;
  }
  var _proto = CharLiteralPrinterParser.prototype;
  _proto.print = function print(context, buf) {
    buf.append(this._literal);
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    var length = text.length;
    if (position === length) {
      return ~position;
    }
    var ch = text.charAt(position);
    if (context.charEquals(this._literal, ch) === false) {
      return ~position;
    }
    return position + this._literal.length;
  };
  _proto.toString = function toString() {
    if (this._literal === '\'') {
      return "''";
    }
    return "'" + this._literal + "'";
  };
  return CharLiteralPrinterParser;
}();

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */var CompositePrinterParser = function () {
  function CompositePrinterParser(printerParsers, optional) {
    this._printerParsers = printerParsers;
    this._optional = optional;
  }
  var _proto = CompositePrinterParser.prototype;
  _proto.withOptional = function withOptional(optional) {
    if (optional === this._optional) {
      return this;
    }
    return new CompositePrinterParser(this._printerParsers, optional);
  };
  _proto.print = function print(context, buf) {
    var length = buf.length();
    if (this._optional) {
      context.startOptional();
    }
    try {
      for (var i = 0; i < this._printerParsers.length; i++) {
        var pp = this._printerParsers[i];
        if (pp.print(context, buf) === false) {
          buf.setLength(length);
          return true;
        }
      }
    } finally {
      if (this._optional) {
        context.endOptional();
      }
    }
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    if (this._optional) {
      context.startOptional();
      var pos = position;
      for (var i = 0; i < this._printerParsers.length; i++) {
        var pp = this._printerParsers[i];
        pos = pp.parse(context, text, pos);
        if (pos < 0) {
          context.endOptional(false);
          return position;
        }
      }
      context.endOptional(true);
      return pos;
    } else {
      for (var _i = 0; _i < this._printerParsers.length; _i++) {
        var _pp = this._printerParsers[_i];
        position = _pp.parse(context, text, position);
        if (position < 0) {
          break;
        }
      }
      return position;
    }
  };
  _proto.toString = function toString() {
    var buf = '';
    if (this._printerParsers != null) {
      buf += this._optional ? '[' : '(';
      for (var i = 0; i < this._printerParsers.length; i++) {
        var pp = this._printerParsers[i];
        buf += pp.toString();
      }
      buf += this._optional ? ']' : ')';
    }
    return buf;
  };
  return CompositePrinterParser;
}();

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var FractionPrinterParser = function () {
  function FractionPrinterParser(field, minWidth, maxWidth, decimalPoint) {
    requireNonNull(field, 'field');
    if (field.range().isFixed() === false) {
      throw new IllegalArgumentException("Field must have a fixed set of values: " + field);
    }
    if (minWidth < 0 || minWidth > 9) {
      throw new IllegalArgumentException("Minimum width must be from 0 to 9 inclusive but was " + minWidth);
    }
    if (maxWidth < 1 || maxWidth > 9) {
      throw new IllegalArgumentException("Maximum width must be from 1 to 9 inclusive but was " + maxWidth);
    }
    if (maxWidth < minWidth) {
      throw new IllegalArgumentException("Maximum width must exceed or equal the minimum width but " + maxWidth + " < " + minWidth);
    }
    this.field = field;
    this.minWidth = minWidth;
    this.maxWidth = maxWidth;
    this.decimalPoint = decimalPoint;
  }
  var _proto = FractionPrinterParser.prototype;
  _proto.print = function print(context, buf) {
    var value = context.getValue(this.field);
    if (value === null) {
      return false;
    }
    var symbols = context.symbols();
    if (value === 0) {
      if (this.minWidth > 0) {
        if (this.decimalPoint) {
          buf.append(symbols.decimalSeparator());
        }
        for (var i = 0; i < this.minWidth; i++) {
          buf.append(symbols.zeroDigit());
        }
      }
    } else {
      var fraction = this.convertToFraction(value, symbols.zeroDigit());
      var outputScale = Math.min(Math.max(fraction.length, this.minWidth), this.maxWidth);
      fraction = fraction.substr(0, outputScale);
      if (fraction * 1 > 0) {
        while (fraction.length > this.minWidth && fraction[fraction.length - 1] === '0') {
          fraction = fraction.substr(0, fraction.length - 1);
        }
      }
      var str = fraction;
      str = symbols.convertNumberToI18N(str);
      if (this.decimalPoint) {
        buf.append(symbols.decimalSeparator());
      }
      buf.append(str);
    }
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    var effectiveMin = context.isStrict() ? this.minWidth : 0;
    var effectiveMax = context.isStrict() ? this.maxWidth : 9;
    var length = text.length;
    if (position === length) {
      return effectiveMin > 0 ? ~position : position;
    }
    if (this.decimalPoint) {
      if (text[position] !== context.symbols().decimalSeparator()) {
        return effectiveMin > 0 ? ~position : position;
      }
      position++;
    }
    var minEndPos = position + effectiveMin;
    if (minEndPos > length) {
      return ~position;
    }
    var maxEndPos = Math.min(position + effectiveMax, length);
    var total = 0;
    var pos = position;
    while (pos < maxEndPos) {
      var ch = text.charAt(pos++);
      var digit = context.symbols().convertToDigit(ch);
      if (digit < 0) {
        if (pos < minEndPos) {
          return ~position;
        }
        pos--;
        break;
      }
      total = total * 10 + digit;
    }
    var moveLeft = pos - position;
    var scale = Math.pow(10, moveLeft);
    var value = this.convertFromFraction(total, scale);
    return context.setParsedField(this.field, value, position, pos);
  };
  _proto.convertToFraction = function convertToFraction(value, zeroDigit) {
    var range = this.field.range();
    range.checkValidValue(value, this.field);
    var _min = range.minimum();
    var _range = range.maximum() - _min + 1;
    var _value = value - _min;
    var _scaled = MathUtil.intDiv(_value * 1000000000, _range);
    var fraction = "" + _scaled;
    while (fraction.length < 9) {
      fraction = zeroDigit + fraction;
    }
    return fraction;
  };
  _proto.convertFromFraction = function convertFromFraction(total, scale) {
    var range = this.field.range();
    var _min = range.minimum();
    var _range = range.maximum() - _min + 1;
    var _value = MathUtil.intDiv(total * _range, scale);
    return _value;
  };
  _proto.toString = function toString() {
    var decimal = this.decimalPoint ? ',DecimalPoint' : '';
    return "Fraction(" + this.field + "," + this.minWidth + "," + this.maxWidth + decimal + ")";
  };
  return FractionPrinterParser;
}();

var MAX_WIDTH$1 = 15;
var EXCEED_POINTS = [0, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000];
var NumberPrinterParser = function () {
  function NumberPrinterParser(field, minWidth, maxWidth, signStyle, subsequentWidth) {
    if (subsequentWidth === void 0) {
      subsequentWidth = 0;
    }
    this._field = field;
    this._minWidth = minWidth;
    this._maxWidth = maxWidth;
    this._signStyle = signStyle;
    this._subsequentWidth = subsequentWidth;
  }
  var _proto = NumberPrinterParser.prototype;
  _proto.field = function field() {
    return this._field;
  };
  _proto.minWidth = function minWidth() {
    return this._minWidth;
  };
  _proto.maxWidth = function maxWidth() {
    return this._maxWidth;
  };
  _proto.signStyle = function signStyle() {
    return this._signStyle;
  };
  _proto.withFixedWidth = function withFixedWidth() {
    if (this._subsequentWidth === -1) {
      return this;
    }
    return new NumberPrinterParser(this._field, this._minWidth, this._maxWidth, this._signStyle, -1);
  };
  _proto.withSubsequentWidth = function withSubsequentWidth(subsequentWidth) {
    return new NumberPrinterParser(this._field, this._minWidth, this._maxWidth, this._signStyle, this._subsequentWidth + subsequentWidth);
  };
  _proto._isFixedWidth = function _isFixedWidth() {
    return this._subsequentWidth === -1 || this._subsequentWidth > 0 && this._minWidth === this._maxWidth && this._signStyle === SignStyle.NOT_NEGATIVE;
  };
  _proto.print = function print(context, buf) {
    var contextValue = context.getValue(this._field);
    if (contextValue == null) {
      return false;
    }
    var value = this._getValue(context, contextValue);
    var symbols = context.symbols();
    var str = "" + Math.abs(value);
    if (str.length > this._maxWidth) {
      throw new DateTimeException("Field " + this._field + " cannot be printed as the value " + value + " exceeds the maximum print width of " + this._maxWidth);
    }
    str = symbols.convertNumberToI18N(str);
    if (value >= 0) {
      switch (this._signStyle) {
        case SignStyle.EXCEEDS_PAD:
          if (this._minWidth < MAX_WIDTH$1 && value >= EXCEED_POINTS[this._minWidth]) {
            buf.append(symbols.positiveSign());
          }
          break;
        case SignStyle.ALWAYS:
          buf.append(symbols.positiveSign());
          break;
      }
    } else {
      switch (this._signStyle) {
        case SignStyle.NORMAL:
        case SignStyle.EXCEEDS_PAD:
        case SignStyle.ALWAYS:
          buf.append(symbols.negativeSign());
          break;
        case SignStyle.NOT_NEGATIVE:
          throw new DateTimeException("Field " + this._field + " cannot be printed as the value " + value + " cannot be negative according to the SignStyle");
      }
    }
    for (var i = 0; i < this._minWidth - str.length; i++) {
      buf.append(symbols.zeroDigit());
    }
    buf.append(str);
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    var length = text.length;
    if (position === length) {
      return ~position;
    }
    assert(position >= 0 && position < length);
    var sign = text.charAt(position);
    var negative = false;
    var positive = false;
    if (sign === context.symbols().positiveSign()) {
      if (this._signStyle.parse(true, context.isStrict(), this._minWidth === this._maxWidth) === false) {
        return ~position;
      }
      positive = true;
      position++;
    } else if (sign === context.symbols().negativeSign()) {
      if (this._signStyle.parse(false, context.isStrict(), this._minWidth === this._maxWidth) === false) {
        return ~position;
      }
      negative = true;
      position++;
    } else {
      if (this._signStyle === SignStyle.ALWAYS && context.isStrict()) {
        return ~position;
      }
    }
    var effMinWidth = context.isStrict() || this._isFixedWidth() ? this._minWidth : 1;
    var minEndPos = position + effMinWidth;
    if (minEndPos > length) {
      return ~position;
    }
    var effMaxWidth = (context.isStrict() || this._isFixedWidth() ? this._maxWidth : 9) + Math.max(this._subsequentWidth, 0);
    var total = 0;
    var pos = position;
    for (var pass = 0; pass < 2; pass++) {
      var maxEndPos = Math.min(pos + effMaxWidth, length);
      while (pos < maxEndPos) {
        var ch = text.charAt(pos++);
        var digit = context.symbols().convertToDigit(ch);
        if (digit < 0) {
          pos--;
          if (pos < minEndPos) {
            return ~position;
          }
          break;
        }
        if (pos - position > MAX_WIDTH$1) {
          throw new ArithmeticException('number text exceeds length');
        } else {
          total = total * 10 + digit;
        }
      }
      if (this._subsequentWidth > 0 && pass === 0) {
        var parseLen = pos - position;
        effMaxWidth = Math.max(effMinWidth, parseLen - this._subsequentWidth);
        pos = position;
        total = 0;
      } else {
        break;
      }
    }
    if (negative) {
      if (total === 0 && context.isStrict()) {
        return ~(position - 1);
      }
      if (total !== 0) {
        total = -total;
      }
    } else if (this._signStyle === SignStyle.EXCEEDS_PAD && context.isStrict()) {
      var _parseLen = pos - position;
      if (positive) {
        if (_parseLen <= this._minWidth) {
          return ~(position - 1);
        }
      } else {
        if (_parseLen > this._minWidth) {
          return ~position;
        }
      }
    }
    return this._setValue(context, total, position, pos);
  };
  _proto._getValue = function _getValue(context, value) {
    return value;
  };
  _proto._setValue = function _setValue(context, value, errorPos, successPos) {
    return context.setParsedField(this._field, value, errorPos, successPos);
  };
  _proto.toString = function toString() {
    if (this._minWidth === 1 && this._maxWidth === MAX_WIDTH$1 && this._signStyle === SignStyle.NORMAL) {
      return "Value(" + this._field + ")";
    }
    if (this._minWidth === this._maxWidth && this._signStyle === SignStyle.NOT_NEGATIVE) {
      return "Value(" + this._field + "," + this._minWidth + ")";
    }
    return "Value(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + this._signStyle + ")";
  };
  return NumberPrinterParser;
}();
var ReducedPrinterParser = function (_NumberPrinterParser) {
  _inheritsLoose(ReducedPrinterParser, _NumberPrinterParser);
  function ReducedPrinterParser(field, width, maxWidth, baseValue, baseDate) {
    var _this;
    _this = _NumberPrinterParser.call(this, field, width, maxWidth, SignStyle.NOT_NEGATIVE) || this;
    if (width < 1 || width > 10) {
      throw new IllegalArgumentException("The width must be from 1 to 10 inclusive but was " + width);
    }
    if (maxWidth < 1 || maxWidth > 10) {
      throw new IllegalArgumentException("The maxWidth must be from 1 to 10 inclusive but was " + maxWidth);
    }
    if (maxWidth < width) {
      throw new IllegalArgumentException('The maxWidth must be greater than the width');
    }
    if (baseDate === null) {
      if (field.range().isValidValue(baseValue) === false) {
        throw new IllegalArgumentException('The base value must be within the range of the field');
      }
      if (baseValue + EXCEED_POINTS[width] > MathUtil.MAX_SAFE_INTEGER) {
        throw new DateTimeException('Unable to add printer-parser as the range exceeds the capacity of an int');
      }
    }
    _this._baseValue = baseValue;
    _this._baseDate = baseDate;
    return _this;
  }
  var _proto2 = ReducedPrinterParser.prototype;
  _proto2._getValue = function _getValue(context, value) {
    var absValue = Math.abs(value);
    var baseValue = this._baseValue;
    if (this._baseDate !== null) {
      context.temporal();
      var chrono = IsoChronology.INSTANCE;
      baseValue = chrono.date(this._baseDate).get(this._field);
    }
    if (value >= baseValue && value < baseValue + EXCEED_POINTS[this._minWidth]) {
      return absValue % EXCEED_POINTS[this._minWidth];
    }
    return absValue % EXCEED_POINTS[this._maxWidth];
  };
  _proto2._setValue = function _setValue(context, value, errorPos, successPos) {
    var baseValue = this._baseValue;
    if (this._baseDate != null) {
      var chrono = context.getEffectiveChronology();
      baseValue = chrono.date(this._baseDate).get(this._field);
    }
    var parseLen = successPos - errorPos;
    if (parseLen === this._minWidth && value >= 0) {
      var range = EXCEED_POINTS[this._minWidth];
      var lastPart = baseValue % range;
      var basePart = baseValue - lastPart;
      if (baseValue > 0) {
        value = basePart + value;
      } else {
        value = basePart - value;
      }
      if (value < baseValue) {
        value += range;
      }
    }
    return context.setParsedField(this._field, value, errorPos, successPos);
  };
  _proto2.withFixedWidth = function withFixedWidth() {
    if (this._subsequentWidth === -1) {
      return this;
    }
    return new ReducedPrinterParser(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate);
  };
  _proto2.withSubsequentWidth = function withSubsequentWidth(subsequentWidth) {
    return new ReducedPrinterParser(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate, this._subsequentWidth + subsequentWidth);
  };
  _proto2.isFixedWidth = function isFixedWidth(context) {
    if (context.isStrict() === false) {
      return false;
    }
    return _NumberPrinterParser.prototype.isFixedWidth.call(this, context);
  };
  _proto2.toString = function toString() {
    return "ReducedValue(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + (this._baseDate != null ? this._baseDate : this._baseValue) + ")";
  };
  return ReducedPrinterParser;
}(NumberPrinterParser);

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var PATTERNS = ['+HH', '+HHmm', '+HH:mm', '+HHMM', '+HH:MM', '+HHMMss', '+HH:MM:ss', '+HHMMSS', '+HH:MM:SS'];
var OffsetIdPrinterParser = function () {
  function OffsetIdPrinterParser(noOffsetText, pattern) {
    requireNonNull(noOffsetText, 'noOffsetText');
    requireNonNull(pattern, 'pattern');
    this.noOffsetText = noOffsetText;
    this.type = this._checkPattern(pattern);
  }
  var _proto = OffsetIdPrinterParser.prototype;
  _proto._checkPattern = function _checkPattern(pattern) {
    for (var i = 0; i < PATTERNS.length; i++) {
      if (PATTERNS[i] === pattern) {
        return i;
      }
    }
    throw new IllegalArgumentException("Invalid zone offset pattern: " + pattern);
  };
  _proto.print = function print(context, buf) {
    var offsetSecs = context.getValue(ChronoField.OFFSET_SECONDS);
    if (offsetSecs == null) {
      return false;
    }
    var totalSecs = MathUtil.safeToInt(offsetSecs);
    if (totalSecs === 0) {
      buf.append(this.noOffsetText);
    } else {
      var absHours = Math.abs(MathUtil.intMod(MathUtil.intDiv(totalSecs, 3600), 100));
      var absMinutes = Math.abs(MathUtil.intMod(MathUtil.intDiv(totalSecs, 60), 60));
      var absSeconds = Math.abs(MathUtil.intMod(totalSecs, 60));
      var bufPos = buf.length();
      var output = absHours;
      buf.append(totalSecs < 0 ? '-' : '+').appendChar(MathUtil.intDiv(absHours, 10) + "0").appendChar(MathUtil.intMod(absHours, 10) + "0");
      if (this.type >= 3 || this.type >= 1 && absMinutes > 0) {
        buf.append(this.type % 2 === 0 ? ':' : '').appendChar(MathUtil.intDiv(absMinutes, 10) + "0").appendChar(absMinutes % 10 + "0");
        output += absMinutes;
        if (this.type >= 7 || this.type >= 5 && absSeconds > 0) {
          buf.append(this.type % 2 === 0 ? ':' : '').appendChar(MathUtil.intDiv(absSeconds, 10) + "0").appendChar(absSeconds % 10 + "0");
          output += absSeconds;
        }
      }
      if (output === 0) {
        buf.setLength(bufPos);
        buf.append(this.noOffsetText);
      }
    }
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    var length = text.length;
    var noOffsetLen = this.noOffsetText.length;
    if (noOffsetLen === 0) {
      if (position === length) {
        return context.setParsedField(ChronoField.OFFSET_SECONDS, 0, position, position);
      }
    } else {
      if (position === length) {
        return ~position;
      }
      if (context.subSequenceEquals(text, position, this.noOffsetText, 0, noOffsetLen)) {
        return context.setParsedField(ChronoField.OFFSET_SECONDS, 0, position, position + noOffsetLen);
      }
    }
    var sign = text[position];
    if (sign === '+' || sign === '-') {
      var negative = sign === '-' ? -1 : 1;
      var array = [0, 0, 0, 0];
      array[0] = position + 1;
      if ((this._parseNumber(array, 1, text, true) || this._parseNumber(array, 2, text, this.type >= 3) || this._parseNumber(array, 3, text, false)) === false) {
        var offsetSecs = MathUtil.safeZero(negative * (array[1] * 3600 + array[2] * 60 + array[3]));
        return context.setParsedField(ChronoField.OFFSET_SECONDS, offsetSecs, position, array[0]);
      }
    }
    if (noOffsetLen === 0) {
      return context.setParsedField(ChronoField.OFFSET_SECONDS, 0, position, position + noOffsetLen);
    }
    return ~position;
  };
  _proto._parseNumber = function _parseNumber(array, arrayIndex, parseText, required) {
    if ((this.type + 3) / 2 < arrayIndex) {
      return false;
    }
    var pos = array[0];
    if (this.type % 2 === 0 && arrayIndex > 1) {
      if (pos + 1 > parseText.length || parseText[pos] !== ':') {
        return required;
      }
      pos++;
    }
    if (pos + 2 > parseText.length) {
      return required;
    }
    var ch1 = parseText[pos++];
    var ch2 = parseText[pos++];
    if (ch1 < '0' || ch1 > '9' || ch2 < '0' || ch2 > '9') {
      return required;
    }
    var value = (ch1.charCodeAt(0) - 48) * 10 + (ch2.charCodeAt(0) - 48);
    if (value < 0 || value > 59) {
      return required;
    }
    array[arrayIndex] = value;
    array[0] = pos;
    return false;
  };
  _proto.toString = function toString() {
    var converted = this.noOffsetText.replace('\'', '\'\'');
    return "Offset(" + PATTERNS[this.type] + ",'" + converted + "')";
  };
  return OffsetIdPrinterParser;
}();
OffsetIdPrinterParser.INSTANCE_ID = new OffsetIdPrinterParser('Z', '+HH:MM:ss');
OffsetIdPrinterParser.PATTERNS = PATTERNS;

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var PadPrinterParserDecorator = function () {
  function PadPrinterParserDecorator(printerParser, padWidth, padChar) {
    this._printerParser = printerParser;
    this._padWidth = padWidth;
    this._padChar = padChar;
  }
  var _proto = PadPrinterParserDecorator.prototype;
  _proto.print = function print(context, buf) {
    var preLen = buf.length();
    if (this._printerParser.print(context, buf) === false) {
      return false;
    }
    var len = buf.length() - preLen;
    if (len > this._padWidth) {
      throw new DateTimeException("Cannot print as output of " + len + " characters exceeds pad width of " + this._padWidth);
    }
    for (var i = 0; i < this._padWidth - len; i++) {
      buf.insert(preLen, this._padChar);
    }
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    var strict = context.isStrict();
    var caseSensitive = context.isCaseSensitive();
    assert(!(position > text.length));
    assert(position >= 0);
    if (position === text.length) {
      return ~position;
    }
    var endPos = position + this._padWidth;
    if (endPos > text.length) {
      if (strict) {
        return ~position;
      }
      endPos = text.length;
    }
    var pos = position;
    while (pos < endPos && (caseSensitive ? text[pos] === this._padChar : context.charEquals(text[pos], this._padChar))) {
      pos++;
    }
    text = text.substring(0, endPos);
    var resultPos = this._printerParser.parse(context, text, pos);
    if (resultPos !== endPos && strict) {
      return ~(position + pos);
    }
    return resultPos;
  };
  _proto.toString = function toString() {
    return "Pad(" + this._printerParser + "," + this._padWidth + (this._padChar === ' ' ? ')' : ",'" + this._padChar + "')");
  };
  return PadPrinterParserDecorator;
}();

var SettingsParser = function (_Enum) {
  _inheritsLoose(SettingsParser, _Enum);
  function SettingsParser() {
    return _Enum.apply(this, arguments) || this;
  }
  var _proto = SettingsParser.prototype;
  _proto.print = function print() {
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    switch (this) {
      case SettingsParser.SENSITIVE:
        context.setCaseSensitive(true);
        break;
      case SettingsParser.INSENSITIVE:
        context.setCaseSensitive(false);
        break;
      case SettingsParser.STRICT:
        context.setStrict(true);
        break;
      case SettingsParser.LENIENT:
        context.setStrict(false);
        break;
    }
    return position;
  };
  _proto.toString = function toString() {
    switch (this) {
      case SettingsParser.SENSITIVE:
        return 'ParseCaseSensitive(true)';
      case SettingsParser.INSENSITIVE:
        return 'ParseCaseSensitive(false)';
      case SettingsParser.STRICT:
        return 'ParseStrict(true)';
      case SettingsParser.LENIENT:
        return 'ParseStrict(false)';
    }
  };
  return SettingsParser;
}(Enum);
SettingsParser.SENSITIVE = new SettingsParser('SENSITIVE');
SettingsParser.INSENSITIVE = new SettingsParser('INSENSITIVE');
SettingsParser.STRICT = new SettingsParser('STRICT');
SettingsParser.LENIENT = new SettingsParser('LENIENT');

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var StringLiteralPrinterParser = function () {
  function StringLiteralPrinterParser(literal) {
    this._literal = literal;
  }
  var _proto = StringLiteralPrinterParser.prototype;
  _proto.print = function print(context, buf) {
    buf.append(this._literal);
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    var length = text.length;
    assert(!(position > length || position < 0));
    if (context.subSequenceEquals(text, position, this._literal, 0, this._literal.length) === false) {
      return ~position;
    }
    return position + this._literal.length;
  };
  _proto.toString = function toString() {
    var converted = this._literal.replace("'", "''");
    return "'" + converted + "'";
  };
  return StringLiteralPrinterParser;
}();

/*
 * @copyright (c) 2016, Philipp Thürwächter, Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var ZoneRulesProvider = function () {
  function ZoneRulesProvider() {}
  ZoneRulesProvider.getRules = function getRules(zoneId) {
    throw new DateTimeException("unsupported ZoneId:" + zoneId);
  };
  ZoneRulesProvider.getAvailableZoneIds = function getAvailableZoneIds() {
    return [];
  };
  return ZoneRulesProvider;
}();

var ZoneRegion = function (_ZoneId) {
  _inheritsLoose(ZoneRegion, _ZoneId);
  ZoneRegion.ofId = function ofId(zoneId) {
    var rules = ZoneRulesProvider.getRules(zoneId);
    return new ZoneRegion(zoneId, rules);
  };
  function ZoneRegion(id, rules) {
    var _this;
    _this = _ZoneId.call(this) || this;
    _this._id = id;
    _this._rules = rules;
    return _this;
  }
  var _proto = ZoneRegion.prototype;
  _proto.id = function id() {
    return this._id;
  };
  _proto.rules = function rules() {
    return this._rules;
  };
  return ZoneRegion;
}(ZoneId);

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var ZoneIdPrinterParser = function () {
  function ZoneIdPrinterParser(query, description) {
    this.query = query;
    this.description = description;
  }
  var _proto = ZoneIdPrinterParser.prototype;
  _proto.print = function print(context, buf) {
    var zone = context.getValueQuery(this.query);
    if (zone == null) {
      return false;
    }
    buf.append(zone.id());
    return true;
  };
  _proto.parse = function parse(context, text, position) {
    var length = text.length;
    if (position > length) {
      return ~position;
    }
    if (position === length) {
      return ~position;
    }
    var nextChar = text.charAt(position);
    if (nextChar === '+' || nextChar === '-') {
      var newContext = context.copy();
      var endPos = OffsetIdPrinterParser.INSTANCE_ID.parse(newContext, text, position);
      if (endPos < 0) {
        return endPos;
      }
      var offset = newContext.getParsed(ChronoField.OFFSET_SECONDS);
      var zone = ZoneOffset.ofTotalSeconds(offset);
      context.setParsedZone(zone);
      return endPos;
    } else if (length >= position + 2) {
      var nextNextChar = text.charAt(position + 1);
      if (context.charEquals(nextChar, 'U') && context.charEquals(nextNextChar, 'T')) {
        if (length >= position + 3 && context.charEquals(text.charAt(position + 2), 'C')) {
          return this._parsePrefixedOffset(context, text, position, position + 3);
        }
        return this._parsePrefixedOffset(context, text, position, position + 2);
      } else if (context.charEquals(nextChar, 'G') && length >= position + 3 && context.charEquals(nextNextChar, 'M') && context.charEquals(text.charAt(position + 2), 'T')) {
        return this._parsePrefixedOffset(context, text, position, position + 3);
      }
    }
    if (text.substr(position, 6) === 'SYSTEM') {
      context.setParsedZone(ZoneId.systemDefault());
      return position + 6;
    }
    if (context.charEquals(nextChar, 'Z')) {
      context.setParsedZone(ZoneOffset.UTC);
      return position + 1;
    }
    var availableZoneIds = ZoneRulesProvider.getAvailableZoneIds();
    if (zoneIdTree.size !== availableZoneIds.length) {
      zoneIdTree = ZoneIdTree.createTreeMap(availableZoneIds);
    }
    var maxParseLength = length - position;
    var treeMap = zoneIdTree.treeMap;
    var parsedZoneId = null;
    var parseLength = 0;
    while (treeMap != null) {
      var parsedSubZoneId = text.substr(position, Math.min(treeMap.length, maxParseLength));
      treeMap = treeMap.get(parsedSubZoneId);
      if (treeMap != null && treeMap.isLeaf) {
        parsedZoneId = parsedSubZoneId;
        parseLength = treeMap.length;
      }
    }
    if (parsedZoneId != null) {
      context.setParsedZone(ZoneRegion.ofId(parsedZoneId));
      return position + parseLength;
    }
    return ~position;
  };
  _proto._parsePrefixedOffset = function _parsePrefixedOffset(context, text, prefixPos, position) {
    var prefix = text.substring(prefixPos, position).toUpperCase();
    var newContext = context.copy();
    if (position < text.length && context.charEquals(text.charAt(position), 'Z')) {
      context.setParsedZone(ZoneId.ofOffset(prefix, ZoneOffset.UTC));
      return position;
    }
    var endPos = OffsetIdPrinterParser.INSTANCE_ID.parse(newContext, text, position);
    if (endPos < 0) {
      context.setParsedZone(ZoneId.ofOffset(prefix, ZoneOffset.UTC));
      return position;
    }
    var offsetSecs = newContext.getParsed(ChronoField.OFFSET_SECONDS);
    var offset = ZoneOffset.ofTotalSeconds(offsetSecs);
    context.setParsedZone(ZoneId.ofOffset(prefix, offset));
    return endPos;
  };
  _proto.toString = function toString() {
    return this.description;
  };
  return ZoneIdPrinterParser;
}();
var ZoneIdTree = function () {
  ZoneIdTree.createTreeMap = function createTreeMap(availableZoneIds) {
    var sortedZoneIds = availableZoneIds.sort(function (a, b) {
      return a.length - b.length;
    });
    var treeMap = new ZoneIdTreeMap(sortedZoneIds[0].length, false);
    for (var i = 0; i < sortedZoneIds.length; i++) {
      treeMap.add(sortedZoneIds[i]);
    }
    return new ZoneIdTree(sortedZoneIds.length, treeMap);
  };
  function ZoneIdTree(size, treeMap) {
    this.size = size;
    this.treeMap = treeMap;
  }
  return ZoneIdTree;
}();
var ZoneIdTreeMap = function () {
  function ZoneIdTreeMap(length, isLeaf) {
    if (length === void 0) {
      length = 0;
    }
    if (isLeaf === void 0) {
      isLeaf = false;
    }
    this.length = length;
    this.isLeaf = isLeaf;
    this._treeMap = {};
  }
  var _proto2 = ZoneIdTreeMap.prototype;
  _proto2.add = function add(zoneId) {
    var idLength = zoneId.length;
    if (idLength === this.length) {
      this._treeMap[zoneId] = new ZoneIdTreeMap(idLength, true);
    } else if (idLength > this.length) {
      var subZoneId = zoneId.substr(0, this.length);
      var subTreeMap = this._treeMap[subZoneId];
      if (subTreeMap == null) {
        subTreeMap = new ZoneIdTreeMap(idLength, false);
        this._treeMap[subZoneId] = subTreeMap;
      }
      subTreeMap.add(zoneId);
    }
  };
  _proto2.get = function get(zoneId) {
    return this._treeMap[zoneId];
  };
  return ZoneIdTreeMap;
}();
var zoneIdTree = new ZoneIdTree([]);

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var MAX_WIDTH = 15;
var DateTimeFormatterBuilder = function () {
  function DateTimeFormatterBuilder() {
    this._active = this;
    this._parent = null;
    this._printerParsers = [];
    this._optional = false;
    this._padNextWidth = 0;
    this._padNextChar = null;
    this._valueParserIndex = -1;
  }
  DateTimeFormatterBuilder._of = function _of(parent, optional) {
    requireNonNull(parent, 'parent');
    requireNonNull(optional, 'optional');
    var dtFormatterBuilder = new DateTimeFormatterBuilder();
    dtFormatterBuilder._parent = parent;
    dtFormatterBuilder._optional = optional;
    return dtFormatterBuilder;
  };
  var _proto = DateTimeFormatterBuilder.prototype;
  _proto.parseCaseSensitive = function parseCaseSensitive() {
    this._appendInternalPrinterParser(SettingsParser.SENSITIVE);
    return this;
  };
  _proto.parseCaseInsensitive = function parseCaseInsensitive() {
    this._appendInternalPrinterParser(SettingsParser.INSENSITIVE);
    return this;
  };
  _proto.parseStrict = function parseStrict() {
    this._appendInternalPrinterParser(SettingsParser.STRICT);
    return this;
  };
  _proto.parseLenient = function parseLenient() {
    this._appendInternalPrinterParser(SettingsParser.LENIENT);
    return this;
  };
  _proto.parseDefaulting = function parseDefaulting(field, value) {
    requireNonNull(field);
    this._appendInternal(new DefaultingParser(field, value));
    return this;
  };
  _proto.appendValue = function appendValue() {
    if (arguments.length === 1) {
      return this._appendValue1.apply(this, arguments);
    } else if (arguments.length === 2) {
      return this._appendValue2.apply(this, arguments);
    } else {
      return this._appendValue4.apply(this, arguments);
    }
  };
  _proto._appendValue1 = function _appendValue1(field) {
    requireNonNull(field);
    this._appendValuePrinterParser(new NumberPrinterParser(field, 1, MAX_WIDTH, SignStyle.NORMAL));
    return this;
  };
  _proto._appendValue2 = function _appendValue2(field, width) {
    requireNonNull(field);
    if (width < 1 || width > MAX_WIDTH) {
      throw new IllegalArgumentException("The width must be from 1 to " + MAX_WIDTH + " inclusive but was " + width);
    }
    var pp = new NumberPrinterParser(field, width, width, SignStyle.NOT_NEGATIVE);
    this._appendValuePrinterParser(pp);
    return this;
  };
  _proto._appendValue4 = function _appendValue4(field, minWidth, maxWidth, signStyle) {
    requireNonNull(field);
    requireNonNull(signStyle);
    if (minWidth === maxWidth && signStyle === SignStyle.NOT_NEGATIVE) {
      return this._appendValue2(field, maxWidth);
    }
    if (minWidth < 1 || minWidth > MAX_WIDTH) {
      throw new IllegalArgumentException("The minimum width must be from 1 to " + MAX_WIDTH + " inclusive but was " + minWidth);
    }
    if (maxWidth < 1 || maxWidth > MAX_WIDTH) {
      throw new IllegalArgumentException("The minimum width must be from 1 to " + MAX_WIDTH + " inclusive but was " + maxWidth);
    }
    if (maxWidth < minWidth) {
      throw new IllegalArgumentException("The maximum width must exceed or equal the minimum width but " + maxWidth + " < " + minWidth);
    }
    var pp = new NumberPrinterParser(field, minWidth, maxWidth, signStyle);
    this._appendValuePrinterParser(pp);
    return this;
  };
  _proto.appendValueReduced = function appendValueReduced() {
    if (arguments.length === 4 && arguments[3] instanceof ChronoLocalDate) {
      return this._appendValueReducedFieldWidthMaxWidthBaseDate.apply(this, arguments);
    } else {
      return this._appendValueReducedFieldWidthMaxWidthBaseValue.apply(this, arguments);
    }
  };
  _proto._appendValueReducedFieldWidthMaxWidthBaseValue = function _appendValueReducedFieldWidthMaxWidthBaseValue(field, width, maxWidth, baseValue) {
    requireNonNull(field, 'field');
    var pp = new ReducedPrinterParser(field, width, maxWidth, baseValue, null);
    this._appendValuePrinterParser(pp);
    return this;
  };
  _proto._appendValueReducedFieldWidthMaxWidthBaseDate = function _appendValueReducedFieldWidthMaxWidthBaseDate(field, width, maxWidth, baseDate) {
    requireNonNull(field, 'field');
    requireNonNull(baseDate, 'baseDate');
    requireInstance(baseDate, ChronoLocalDate, 'baseDate');
    var pp = new ReducedPrinterParser(field, width, maxWidth, 0, baseDate);
    this._appendValuePrinterParser(pp);
    return this;
  };
  _proto._appendValuePrinterParser = function _appendValuePrinterParser(pp) {
    assert(pp != null);
    if (this._active._valueParserIndex >= 0 && this._active._printerParsers[this._active._valueParserIndex] instanceof NumberPrinterParser) {
      var activeValueParser = this._active._valueParserIndex;
      var basePP = this._active._printerParsers[activeValueParser];
      if (pp.minWidth() === pp.maxWidth() && pp.signStyle() === SignStyle.NOT_NEGATIVE) {
        basePP = basePP.withSubsequentWidth(pp.maxWidth());
        this._appendInternal(pp.withFixedWidth());
        this._active._valueParserIndex = activeValueParser;
      } else {
        basePP = basePP.withFixedWidth();
        this._active._valueParserIndex = this._appendInternal(pp);
      }
      this._active._printerParsers[activeValueParser] = basePP;
    } else {
      this._active._valueParserIndex = this._appendInternal(pp);
    }
    return this;
  };
  _proto.appendFraction = function appendFraction(field, minWidth, maxWidth, decimalPoint) {
    this._appendInternal(new FractionPrinterParser(field, minWidth, maxWidth, decimalPoint));
    return this;
  };
  _proto.appendInstant = function appendInstant(fractionalDigits) {
    if (fractionalDigits === void 0) {
      fractionalDigits = -2;
    }
    if (fractionalDigits < -2 || fractionalDigits > 9) {
      throw new IllegalArgumentException("Invalid fractional digits: " + fractionalDigits);
    }
    this._appendInternal(new InstantPrinterParser(fractionalDigits));
    return this;
  };
  _proto.appendOffsetId = function appendOffsetId() {
    this._appendInternal(OffsetIdPrinterParser.INSTANCE_ID);
    return this;
  };
  _proto.appendOffset = function appendOffset(pattern, noOffsetText) {
    this._appendInternalPrinterParser(new OffsetIdPrinterParser(noOffsetText, pattern));
    return this;
  };
  _proto.appendZoneId = function appendZoneId() {
    this._appendInternal(new ZoneIdPrinterParser(TemporalQueries.zoneId(), 'ZoneId()'));
    return this;
  };
  _proto.appendPattern = function appendPattern(pattern) {
    requireNonNull(pattern, 'pattern');
    this._parsePattern(pattern);
    return this;
  };
  _proto.appendZoneText = function appendZoneText() {
    throw new IllegalArgumentException('Pattern using (localized) text not implemented, use @js-joda/locale plugin!');
  };
  _proto.appendText = function appendText() {
    throw new IllegalArgumentException('Pattern using (localized) text not implemented, use @js-joda/locale plugin!');
  };
  _proto.appendLocalizedOffset = function appendLocalizedOffset() {
    throw new IllegalArgumentException('Pattern using (localized) text not implemented, use @js-joda/locale plugin!');
  };
  _proto.appendWeekField = function appendWeekField() {
    throw new IllegalArgumentException('Pattern using (localized) text not implemented, use @js-joda/locale plugin!');
  };
  _proto._parsePattern = function _parsePattern(pattern) {
    var FIELD_MAP = {
      'G': ChronoField.ERA,
      'y': ChronoField.YEAR_OF_ERA,
      'u': ChronoField.YEAR,
      'Q': IsoFields.QUARTER_OF_YEAR,
      'q': IsoFields.QUARTER_OF_YEAR,
      'M': ChronoField.MONTH_OF_YEAR,
      'L': ChronoField.MONTH_OF_YEAR,
      'D': ChronoField.DAY_OF_YEAR,
      'd': ChronoField.DAY_OF_MONTH,
      'F': ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH,
      'E': ChronoField.DAY_OF_WEEK,
      'c': ChronoField.DAY_OF_WEEK,
      'e': ChronoField.DAY_OF_WEEK,
      'a': ChronoField.AMPM_OF_DAY,
      'H': ChronoField.HOUR_OF_DAY,
      'k': ChronoField.CLOCK_HOUR_OF_DAY,
      'K': ChronoField.HOUR_OF_AMPM,
      'h': ChronoField.CLOCK_HOUR_OF_AMPM,
      'm': ChronoField.MINUTE_OF_HOUR,
      's': ChronoField.SECOND_OF_MINUTE,
      'S': ChronoField.NANO_OF_SECOND,
      'A': ChronoField.MILLI_OF_DAY,
      'n': ChronoField.NANO_OF_SECOND,
      'N': ChronoField.NANO_OF_DAY
    };
    for (var pos = 0; pos < pattern.length; pos++) {
      var cur = pattern.charAt(pos);
      if (cur >= 'A' && cur <= 'Z' || cur >= 'a' && cur <= 'z') {
        var start = pos++;
        for (; pos < pattern.length && pattern.charAt(pos) === cur; pos++);
        var count = pos - start;
        if (cur === 'p') {
          var pad = 0;
          if (pos < pattern.length) {
            cur = pattern.charAt(pos);
            if (cur >= 'A' && cur <= 'Z' || cur >= 'a' && cur <= 'z') {
              pad = count;
              start = pos++;
              for (; pos < pattern.length && pattern.charAt(pos) === cur; pos++);
              count = pos - start;
            }
          }
          if (pad === 0) {
            throw new IllegalArgumentException("Pad letter 'p' must be followed by valid pad pattern: " + pattern);
          }
          this.padNext(pad);
        }
        var field = FIELD_MAP[cur];
        if (field != null) {
          this._parseField(cur, count, field);
        } else if (cur === 'z') {
          if (count > 4) {
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
          } else if (count === 4) {
            this.appendZoneText(TextStyle.FULL);
          } else {
            this.appendZoneText(TextStyle.SHORT);
          }
        } else if (cur === 'V') {
          if (count !== 2) {
            throw new IllegalArgumentException("Pattern letter count must be 2: " + cur);
          }
          this.appendZoneId();
        } else if (cur === 'Z') {
          if (count < 4) {
            this.appendOffset('+HHMM', '+0000');
          } else if (count === 4) {
            this.appendLocalizedOffset(TextStyle.FULL);
          } else if (count === 5) {
            this.appendOffset('+HH:MM:ss', 'Z');
          } else {
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
          }
        } else if (cur === 'O') {
          if (count === 1) {
            this.appendLocalizedOffset(TextStyle.SHORT);
          } else if (count === 4) {
            this.appendLocalizedOffset(TextStyle.FULL);
          } else {
            throw new IllegalArgumentException("Pattern letter count must be 1 or 4: " + cur);
          }
        } else if (cur === 'X') {
          if (count > 5) {
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
          }
          this.appendOffset(OffsetIdPrinterParser.PATTERNS[count + (count === 1 ? 0 : 1)], 'Z');
        } else if (cur === 'x') {
          if (count > 5) {
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
          }
          var zero = count === 1 ? '+00' : count % 2 === 0 ? '+0000' : '+00:00';
          this.appendOffset(OffsetIdPrinterParser.PATTERNS[count + (count === 1 ? 0 : 1)], zero);
        } else if (cur === 'W') {
          if (count > 1) {
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
          }
          this.appendWeekField('W', count);
        } else if (cur === 'w') {
          if (count > 2) {
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
          }
          this.appendWeekField('w', count);
        } else if (cur === 'Y') {
          this.appendWeekField('Y', count);
        } else {
          throw new IllegalArgumentException("Unknown pattern letter: " + cur);
        }
        pos--;
      } else if (cur === '\'') {
        var _start = pos++;
        for (; pos < pattern.length; pos++) {
          if (pattern.charAt(pos) === '\'') {
            if (pos + 1 < pattern.length && pattern.charAt(pos + 1) === '\'') {
              pos++;
            } else {
              break;
            }
          }
        }
        if (pos >= pattern.length) {
          throw new IllegalArgumentException("Pattern ends with an incomplete string literal: " + pattern);
        }
        var str = pattern.substring(_start + 1, pos);
        if (str.length === 0) {
          this.appendLiteral('\'');
        } else {
          this.appendLiteral(str.replace('\'\'', '\''));
        }
      } else if (cur === '[') {
        this.optionalStart();
      } else if (cur === ']') {
        if (this._active._parent === null) {
          throw new IllegalArgumentException('Pattern invalid as it contains ] without previous [');
        }
        this.optionalEnd();
      } else if (cur === '{' || cur === '}' || cur === '#') {
        throw new IllegalArgumentException("Pattern includes reserved character: '" + cur + "'");
      } else {
        this.appendLiteral(cur);
      }
    }
  };
  _proto._parseField = function _parseField(cur, count, field) {
    switch (cur) {
      case 'u':
      case 'y':
        if (count === 2) {
          this.appendValueReduced(field, 2, 2, ReducedPrinterParser.BASE_DATE);
        } else if (count < 4) {
          this.appendValue(field, count, MAX_WIDTH, SignStyle.NORMAL);
        } else {
          this.appendValue(field, count, MAX_WIDTH, SignStyle.EXCEEDS_PAD);
        }
        break;
      case 'M':
      case 'Q':
        switch (count) {
          case 1:
            this.appendValue(field);
            break;
          case 2:
            this.appendValue(field, 2);
            break;
          case 3:
            this.appendText(field, TextStyle.SHORT);
            break;
          case 4:
            this.appendText(field, TextStyle.FULL);
            break;
          case 5:
            this.appendText(field, TextStyle.NARROW);
            break;
          default:
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      case 'L':
      case 'q':
        switch (count) {
          case 1:
            this.appendValue(field);
            break;
          case 2:
            this.appendValue(field, 2);
            break;
          case 3:
            this.appendText(field, TextStyle.SHORT_STANDALONE);
            break;
          case 4:
            this.appendText(field, TextStyle.FULL_STANDALONE);
            break;
          case 5:
            this.appendText(field, TextStyle.NARROW_STANDALONE);
            break;
          default:
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      case 'e':
        switch (count) {
          case 1:
          case 2:
            this.appendWeekField('e', count);
            break;
          case 3:
            this.appendText(field, TextStyle.SHORT);
            break;
          case 4:
            this.appendText(field, TextStyle.FULL);
            break;
          case 5:
            this.appendText(field, TextStyle.NARROW);
            break;
          default:
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      case 'c':
        switch (count) {
          case 1:
            this.appendWeekField('c', count);
            break;
          case 2:
            throw new IllegalArgumentException("Invalid number of pattern letters: " + cur);
          case 3:
            this.appendText(field, TextStyle.SHORT_STANDALONE);
            break;
          case 4:
            this.appendText(field, TextStyle.FULL_STANDALONE);
            break;
          case 5:
            this.appendText(field, TextStyle.NARROW_STANDALONE);
            break;
          default:
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      case 'a':
        if (count === 1) {
          this.appendText(field, TextStyle.SHORT);
        } else {
          throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      case 'E':
      case 'G':
        switch (count) {
          case 1:
          case 2:
          case 3:
            this.appendText(field, TextStyle.SHORT);
            break;
          case 4:
            this.appendText(field, TextStyle.FULL);
            break;
          case 5:
            this.appendText(field, TextStyle.NARROW);
            break;
          default:
            throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      case 'S':
        this.appendFraction(ChronoField.NANO_OF_SECOND, count, count, false);
        break;
      case 'F':
        if (count === 1) {
          this.appendValue(field);
        } else {
          throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      case 'd':
      case 'h':
      case 'H':
      case 'k':
      case 'K':
      case 'm':
      case 's':
        if (count === 1) {
          this.appendValue(field);
        } else if (count === 2) {
          this.appendValue(field, count);
        } else {
          throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      case 'D':
        if (count === 1) {
          this.appendValue(field);
        } else if (count <= 3) {
          this.appendValue(field, count);
        } else {
          throw new IllegalArgumentException("Too many pattern letters: " + cur);
        }
        break;
      default:
        if (count === 1) {
          this.appendValue(field);
        } else {
          this.appendValue(field, count);
        }
        break;
    }
  };
  _proto.padNext = function padNext() {
    if (arguments.length === 1) {
      return this._padNext1.apply(this, arguments);
    } else {
      return this._padNext2.apply(this, arguments);
    }
  };
  _proto._padNext1 = function _padNext1(padWidth) {
    return this._padNext2(padWidth, ' ');
  };
  _proto._padNext2 = function _padNext2(padWidth, padChar) {
    if (padWidth < 1) {
      throw new IllegalArgumentException("The pad width must be at least one but was " + padWidth);
    }
    this._active._padNextWidth = padWidth;
    this._active._padNextChar = padChar;
    this._active._valueParserIndex = -1;
    return this;
  };
  _proto.optionalStart = function optionalStart() {
    this._active._valueParserIndex = -1;
    this._active = DateTimeFormatterBuilder._of(this._active, true);
    return this;
  };
  _proto.optionalEnd = function optionalEnd() {
    if (this._active._parent == null) {
      throw new IllegalStateException('Cannot call optionalEnd() as there was no previous call to optionalStart()');
    }
    if (this._active._printerParsers.length > 0) {
      var cpp = new CompositePrinterParser(this._active._printerParsers, this._active._optional);
      this._active = this._active._parent;
      this._appendInternal(cpp);
    } else {
      this._active = this._active._parent;
    }
    return this;
  };
  _proto._appendInternal = function _appendInternal(pp) {
    assert(pp != null);
    if (this._active._padNextWidth > 0) {
      if (pp != null) {
        pp = new PadPrinterParserDecorator(pp, this._active._padNextWidth, this._active._padNextChar);
      }
      this._active._padNextWidth = 0;
      this._active._padNextChar = 0;
    }
    this._active._printerParsers.push(pp);
    this._active._valueParserIndex = -1;
    return this._active._printerParsers.length - 1;
  };
  _proto.appendLiteral = function appendLiteral(literal) {
    assert(literal != null);
    if (literal.length > 0) {
      if (literal.length === 1) {
        this._appendInternalPrinterParser(new CharLiteralPrinterParser(literal.charAt(0)));
      } else {
        this._appendInternalPrinterParser(new StringLiteralPrinterParser(literal));
      }
    }
    return this;
  };
  _proto._appendInternalPrinterParser = function _appendInternalPrinterParser(pp) {
    assert(pp != null);
    if (this._active._padNextWidth > 0) {
      if (pp != null) {
        pp = new PadPrinterParserDecorator(pp, this._active._padNextWidth, this._active._padNextChar);
      }
      this._active._padNextWidth = 0;
      this._active._padNextChar = 0;
    }
    this._active._printerParsers.push(pp);
    this._active._valueParserIndex = -1;
    return this._active._printerParsers.length - 1;
  };
  _proto.append = function append(formatter) {
    requireNonNull(formatter, 'formatter');
    this._appendInternal(formatter._toPrinterParser(false));
    return this;
  };
  _proto.toFormatter = function toFormatter(resolverStyle) {
    if (resolverStyle === void 0) {
      resolverStyle = ResolverStyle.SMART;
    }
    while (this._active._parent != null) {
      this.optionalEnd();
    }
    var pp = new CompositePrinterParser(this._printerParsers, false);
    return new DateTimeFormatter(pp, null, DecimalStyle.STANDARD, resolverStyle, null, null, null);
  };
  return DateTimeFormatterBuilder;
}();
var SECONDS_PER_10000_YEARS = 146097 * 25 * 86400;
var SECONDS_0000_TO_1970 = (146097 * 5 - (30 * 365 + 7)) * 86400;
var InstantPrinterParser = function () {
  function InstantPrinterParser(fractionalDigits) {
    this.fractionalDigits = fractionalDigits;
  }
  var _proto2 = InstantPrinterParser.prototype;
  _proto2.print = function print(context, buf) {
    var inSecs = context.getValue(ChronoField.INSTANT_SECONDS);
    var inNanos = 0;
    if (context.temporal().isSupported(ChronoField.NANO_OF_SECOND)) {
      inNanos = context.temporal().getLong(ChronoField.NANO_OF_SECOND);
    }
    if (inSecs == null) {
      return false;
    }
    var inSec = inSecs;
    var inNano = ChronoField.NANO_OF_SECOND.checkValidIntValue(inNanos);
    if (inSec >= -SECONDS_0000_TO_1970) {
      var zeroSecs = inSec - SECONDS_PER_10000_YEARS + SECONDS_0000_TO_1970;
      var hi = MathUtil.floorDiv(zeroSecs, SECONDS_PER_10000_YEARS) + 1;
      var lo = MathUtil.floorMod(zeroSecs, SECONDS_PER_10000_YEARS);
      var ldt = LocalDateTime.ofEpochSecond(lo - SECONDS_0000_TO_1970, 0, ZoneOffset.UTC);
      if (hi > 0) {
        buf.append('+').append(hi);
      }
      buf.append(ldt.toString());
      if (ldt.second() === 0) {
        buf.append(':00');
      }
    } else {
      var _zeroSecs = inSec + SECONDS_0000_TO_1970;
      var _hi = MathUtil.intDiv(_zeroSecs, SECONDS_PER_10000_YEARS);
      var _lo = MathUtil.intMod(_zeroSecs, SECONDS_PER_10000_YEARS);
      var _ldt = LocalDateTime.ofEpochSecond(_lo - SECONDS_0000_TO_1970, 0, ZoneOffset.UTC);
      var pos = buf.length();
      buf.append(_ldt.toString());
      if (_ldt.second() === 0) {
        buf.append(':00');
      }
      if (_hi < 0) {
        if (_ldt.year() === -10000) {
          buf.replace(pos, pos + 2, "" + (_hi - 1));
        } else if (_lo === 0) {
          buf.insert(pos, _hi);
        } else {
          buf.insert(pos + 1, Math.abs(_hi));
        }
      }
    }
    if (this.fractionalDigits === -2) {
      if (inNano !== 0) {
        buf.append('.');
        if (MathUtil.intMod(inNano, 1000000) === 0) {
          buf.append(("" + (MathUtil.intDiv(inNano, 1000000) + 1000)).substring(1));
        } else if (MathUtil.intMod(inNano, 1000) === 0) {
          buf.append(("" + (MathUtil.intDiv(inNano, 1000) + 1000000)).substring(1));
        } else {
          buf.append(("" + (inNano + 1000000000)).substring(1));
        }
      }
    } else if (this.fractionalDigits > 0 || this.fractionalDigits === -1 && inNano > 0) {
      buf.append('.');
      var div = 100000000;
      for (var i = 0; this.fractionalDigits === -1 && inNano > 0 || i < this.fractionalDigits; i++) {
        var digit = MathUtil.intDiv(inNano, div);
        buf.append(digit);
        inNano = inNano - digit * div;
        div = MathUtil.intDiv(div, 10);
      }
    }
    buf.append('Z');
    return true;
  };
  _proto2.parse = function parse(context, text, position) {
    var newContext = context.copy();
    var minDigits = this.fractionalDigits < 0 ? 0 : this.fractionalDigits;
    var maxDigits = this.fractionalDigits < 0 ? 9 : this.fractionalDigits;
    var parser = new DateTimeFormatterBuilder().append(DateTimeFormatter.ISO_LOCAL_DATE).appendLiteral('T').appendValue(ChronoField.HOUR_OF_DAY, 2).appendLiteral(':').appendValue(ChronoField.MINUTE_OF_HOUR, 2).appendLiteral(':').appendValue(ChronoField.SECOND_OF_MINUTE, 2).appendFraction(ChronoField.NANO_OF_SECOND, minDigits, maxDigits, true).appendLiteral('Z').toFormatter()._toPrinterParser(false);
    var pos = parser.parse(newContext, text, position);
    if (pos < 0) {
      return pos;
    }
    var yearParsed = newContext.getParsed(ChronoField.YEAR);
    var month = newContext.getParsed(ChronoField.MONTH_OF_YEAR);
    var day = newContext.getParsed(ChronoField.DAY_OF_MONTH);
    var hour = newContext.getParsed(ChronoField.HOUR_OF_DAY);
    var min = newContext.getParsed(ChronoField.MINUTE_OF_HOUR);
    var secVal = newContext.getParsed(ChronoField.SECOND_OF_MINUTE);
    var nanoVal = newContext.getParsed(ChronoField.NANO_OF_SECOND);
    var sec = secVal != null ? secVal : 0;
    var nano = nanoVal != null ? nanoVal : 0;
    var year = MathUtil.intMod(yearParsed, 10000);
    var days = 0;
    if (hour === 24 && min === 0 && sec === 0 && nano === 0) {
      hour = 0;
      days = 1;
    } else if (hour === 23 && min === 59 && sec === 60) {
      context.setParsedLeapSecond();
      sec = 59;
    }
    var instantSecs;
    try {
      var ldt = LocalDateTime.of(year, month, day, hour, min, sec, 0).plusDays(days);
      instantSecs = ldt.toEpochSecond(ZoneOffset.UTC);
      instantSecs += MathUtil.safeMultiply(MathUtil.intDiv(yearParsed, 10000), SECONDS_PER_10000_YEARS);
    } catch (ex) {
      return ~position;
    }
    var successPos = pos;
    successPos = context.setParsedField(ChronoField.INSTANT_SECONDS, instantSecs, position, successPos);
    return context.setParsedField(ChronoField.NANO_OF_SECOND, nano, position, successPos);
  };
  _proto2.toString = function toString() {
    return 'Instant()';
  };
  return InstantPrinterParser;
}();
var DefaultingParser = function () {
  function DefaultingParser(field, value) {
    this._field = field;
    this._value = value;
  }
  var _proto3 = DefaultingParser.prototype;
  _proto3.print = function print() {
    return true;
  };
  _proto3.parse = function parse(context, text, position) {
    if (context.getParsed(this._field) == null) {
      context.setParsedField(this._field, this._value, position, position);
    }
    return position;
  };
  return DefaultingParser;
}();
function _init$e() {
  ReducedPrinterParser.BASE_DATE = LocalDate.of(2000, 1, 1);
  DateTimeFormatterBuilder.CompositePrinterParser = CompositePrinterParser;
  DateTimeFormatterBuilder.PadPrinterParserDecorator = PadPrinterParserDecorator;
  DateTimeFormatterBuilder.SettingsParser = SettingsParser;
  DateTimeFormatterBuilder.CharLiteralPrinterParser = StringLiteralPrinterParser;
  DateTimeFormatterBuilder.StringLiteralPrinterParser = StringLiteralPrinterParser;
  DateTimeFormatterBuilder.CharLiteralPrinterParser = CharLiteralPrinterParser;
  DateTimeFormatterBuilder.NumberPrinterParser = NumberPrinterParser;
  DateTimeFormatterBuilder.ReducedPrinterParser = ReducedPrinterParser;
  DateTimeFormatterBuilder.FractionPrinterParser = FractionPrinterParser;
  DateTimeFormatterBuilder.OffsetIdPrinterParser = OffsetIdPrinterParser;
  DateTimeFormatterBuilder.ZoneIdPrinterParser = ZoneIdPrinterParser;
}

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */var StringBuilder = function () {
  function StringBuilder() {
    this._str = '';
  }
  var _proto = StringBuilder.prototype;
  _proto.append = function append(str) {
    this._str += str;
    return this;
  };
  _proto.appendChar = function appendChar(str) {
    this._str += str[0];
    return this;
  };
  _proto.insert = function insert(offset, str) {
    this._str = this._str.slice(0, offset) + str + this._str.slice(offset);
    return this;
  };
  _proto.replace = function replace(start, end, str) {
    this._str = this._str.slice(0, start) + str + this._str.slice(end);
    return this;
  };
  _proto.length = function length() {
    return this._str.length;
  };
  _proto.setLength = function setLength(length) {
    this._str = this._str.slice(0, length);
    return this;
  };
  _proto.toString = function toString() {
    return this._str;
  };
  return StringBuilder;
}();

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var DateTimeFormatter = function () {
  DateTimeFormatter.parsedExcessDays = function parsedExcessDays() {
    return DateTimeFormatter.PARSED_EXCESS_DAYS;
  };
  DateTimeFormatter.parsedLeapSecond = function parsedLeapSecond() {
    return DateTimeFormatter.PARSED_LEAP_SECOND;
  };
  DateTimeFormatter.ofPattern = function ofPattern(pattern) {
    return new DateTimeFormatterBuilder().appendPattern(pattern).toFormatter();
  };
  function DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
    if (chrono === void 0) {
      chrono = IsoChronology.INSTANCE;
    }
    assert(printerParser != null);
    assert(decimalStyle != null);
    assert(resolverStyle != null);
    this._printerParser = printerParser;
    this._locale = locale;
    this._decimalStyle = decimalStyle;
    this._resolverStyle = resolverStyle;
    this._resolverFields = resolverFields;
    this._chrono = chrono;
    this._zone = zone;
  }
  var _proto = DateTimeFormatter.prototype;
  _proto.locale = function locale() {
    return this._locale;
  };
  _proto.decimalStyle = function decimalStyle() {
    return this._decimalStyle;
  };
  _proto.chronology = function chronology() {
    return this._chrono;
  };
  _proto.withChronology = function withChronology(chrono) {
    if (this._chrono != null && this._chrono.equals(chrono)) {
      return this;
    }
    return new DateTimeFormatter(this._printerParser, this._locale, this._decimalStyle, this._resolverStyle, this._resolverFields, chrono, this._zone);
  };
  _proto.withLocale = function withLocale() {
    return this;
  };
  _proto.withResolverStyle = function withResolverStyle(resolverStyle) {
    requireNonNull(resolverStyle, 'resolverStyle');
    if (resolverStyle.equals(this._resolverStyle)) {
      return this;
    }
    return new DateTimeFormatter(this._printerParser, this._locale, this._decimalStyle, resolverStyle, this._resolverFields, this._chrono, this._zone);
  };
  _proto.format = function format(temporal) {
    var buf = new StringBuilder(32);
    this._formatTo(temporal, buf);
    return buf.toString();
  };
  _proto._formatTo = function _formatTo(temporal, appendable) {
    requireNonNull(temporal, 'temporal');
    requireNonNull(appendable, 'appendable');
    var context = new DateTimePrintContext(temporal, this);
    this._printerParser.print(context, appendable);
  };
  _proto.parse = function parse(text, type) {
    if (arguments.length === 1) {
      return this.parse1(text);
    } else {
      return this.parse2(text, type);
    }
  };
  _proto.parse1 = function parse1(text) {
    requireNonNull(text, 'text');
    try {
      return this._parseToBuilder(text, null).resolve(this._resolverStyle, this._resolverFields);
    } catch (ex) {
      if (ex instanceof DateTimeParseException) {
        throw ex;
      } else {
        throw this._createError(text, ex);
      }
    }
  };
  _proto.parse2 = function parse2(text, type) {
    requireNonNull(text, 'text');
    requireNonNull(type, 'type');
    try {
      var builder = this._parseToBuilder(text, null).resolve(this._resolverStyle, this._resolverFields);
      return builder.build(type);
    } catch (ex) {
      if (ex instanceof DateTimeParseException) {
        throw ex;
      } else {
        throw this._createError(text, ex);
      }
    }
  };
  _proto._createError = function _createError(text, ex) {
    var abbr = '';
    if (text.length > 64) {
      abbr = text.substring(0, 64) + "...";
    } else {
      abbr = text;
    }
    return new DateTimeParseException("Text '" + abbr + "' could not be parsed: " + ex.message, text, 0, ex);
  };
  _proto._parseToBuilder = function _parseToBuilder(text, position) {
    var pos = position != null ? position : new ParsePosition(0);
    var result = this._parseUnresolved0(text, pos);
    if (result == null || pos.getErrorIndex() >= 0 || position == null && pos.getIndex() < text.length) {
      var abbr = '';
      if (text.length > 64) {
        abbr = text.substr(0, 64).toString() + "...";
      } else {
        abbr = text;
      }
      if (pos.getErrorIndex() >= 0) {
        throw new DateTimeParseException("Text '" + abbr + "' could not be parsed at index " + pos.getErrorIndex(), text, pos.getErrorIndex());
      } else {
        throw new DateTimeParseException("Text '" + abbr + "' could not be parsed, unparsed text found at index " + pos.getIndex(), text, pos.getIndex());
      }
    }
    return result.toBuilder();
  };
  _proto.parseUnresolved = function parseUnresolved(text, position) {
    return this._parseUnresolved0(text, position);
  };
  _proto._parseUnresolved0 = function _parseUnresolved0(text, position) {
    assert(text != null, 'text', NullPointerException);
    assert(position != null, 'position', NullPointerException);
    var context = new DateTimeParseContext(this);
    var pos = position.getIndex();
    pos = this._printerParser.parse(context, text, pos);
    if (pos < 0) {
      position.setErrorIndex(~pos);
      return null;
    }
    position.setIndex(pos);
    return context.toParsed();
  };
  _proto._toPrinterParser = function _toPrinterParser(optional) {
    return this._printerParser.withOptional(optional);
  };
  _proto.toString = function toString() {
    var pattern = this._printerParser.toString();
    return pattern.indexOf('[') === 0 ? pattern : pattern.substring(1, pattern.length - 1);
  };
  return DateTimeFormatter;
}();
function _init$d() {
  DateTimeFormatter.ISO_LOCAL_DATE = new DateTimeFormatterBuilder().appendValue(ChronoField.YEAR, 4, 10, SignStyle.EXCEEDS_PAD).appendLiteral('-').appendValue(ChronoField.MONTH_OF_YEAR, 2).appendLiteral('-').appendValue(ChronoField.DAY_OF_MONTH, 2).toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.ISO_LOCAL_TIME = new DateTimeFormatterBuilder().appendValue(ChronoField.HOUR_OF_DAY, 2).appendLiteral(':').appendValue(ChronoField.MINUTE_OF_HOUR, 2).optionalStart().appendLiteral(':').appendValue(ChronoField.SECOND_OF_MINUTE, 2).optionalStart().appendFraction(ChronoField.NANO_OF_SECOND, 0, 9, true).toFormatter(ResolverStyle.STRICT);
  DateTimeFormatter.ISO_LOCAL_DATE_TIME = new DateTimeFormatterBuilder().parseCaseInsensitive().append(DateTimeFormatter.ISO_LOCAL_DATE).appendLiteral('T').append(DateTimeFormatter.ISO_LOCAL_TIME).toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.ISO_INSTANT = new DateTimeFormatterBuilder().parseCaseInsensitive().appendInstant().toFormatter(ResolverStyle.STRICT);
  DateTimeFormatter.ISO_OFFSET_DATE_TIME = new DateTimeFormatterBuilder().parseCaseInsensitive().append(DateTimeFormatter.ISO_LOCAL_DATE_TIME).appendOffsetId().toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.ISO_ZONED_DATE_TIME = new DateTimeFormatterBuilder().append(DateTimeFormatter.ISO_OFFSET_DATE_TIME).optionalStart().appendLiteral('[').parseCaseSensitive().appendZoneId().appendLiteral(']').toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.BASIC_ISO_DATE = new DateTimeFormatterBuilder().appendValue(ChronoField.YEAR, 4, 10, SignStyle.EXCEEDS_PAD).appendValue(ChronoField.MONTH_OF_YEAR, 2).appendValue(ChronoField.DAY_OF_MONTH, 2).toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.ISO_OFFSET_DATE = new DateTimeFormatterBuilder().parseCaseInsensitive().append(DateTimeFormatter.ISO_LOCAL_DATE).appendOffsetId().toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.ISO_OFFSET_TIME = new DateTimeFormatterBuilder().parseCaseInsensitive().append(DateTimeFormatter.ISO_LOCAL_TIME).appendOffsetId().toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.ISO_ORDINAL_DATE = new DateTimeFormatterBuilder().appendValue(ChronoField.YEAR, 4, 10, SignStyle.EXCEEDS_PAD).appendLiteral('-').appendValue(ChronoField.DAY_OF_YEAR).toFormatter(ResolverStyle.STRICT);
  DateTimeFormatter.ISO_WEEK_DATE = new DateTimeFormatterBuilder().appendValue(ChronoField.YEAR, 4, 10, SignStyle.EXCEEDS_PAD).appendLiteral('-W').appendValue(ChronoField.ALIGNED_WEEK_OF_YEAR).appendLiteral('-').appendValue(ChronoField.DAY_OF_WEEK).toFormatter(ResolverStyle.STRICT);
  DateTimeFormatter.ISO_DATE = new DateTimeFormatterBuilder().parseCaseInsensitive().append(DateTimeFormatter.ISO_LOCAL_DATE).optionalStart().appendOffsetId().optionalEnd().toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.ISO_TIME = new DateTimeFormatterBuilder().parseCaseInsensitive().append(DateTimeFormatter.ISO_LOCAL_TIME).optionalStart().appendOffsetId().optionalEnd().toFormatter(ResolverStyle.STRICT);
  DateTimeFormatter.ISO_DATE_TIME = new DateTimeFormatterBuilder().append(DateTimeFormatter.ISO_LOCAL_DATE_TIME).optionalStart().appendOffsetId().optionalEnd().toFormatter(ResolverStyle.STRICT).withChronology(IsoChronology.INSTANCE);
  DateTimeFormatter.PARSED_EXCESS_DAYS = createTemporalQuery('PARSED_EXCESS_DAYS', function (temporal) {
    if (temporal instanceof DateTimeBuilder) {
      return temporal.excessDays;
    } else {
      return Period.ZERO;
    }
  });
  DateTimeFormatter.PARSED_LEAP_SECOND = createTemporalQuery('PARSED_LEAP_SECOND', function (temporal) {
    if (temporal instanceof DateTimeBuilder) {
      return temporal.leapSecond;
    } else {
      return false;
    }
  });
}

var MonthDay = function (_TemporalAccessor) {
  _inheritsLoose(MonthDay, _TemporalAccessor);
  MonthDay.now = function now(zoneIdOrClock) {
    if (arguments.length === 0) {
      return MonthDay.now0();
    } else if (arguments.length === 1 && zoneIdOrClock instanceof ZoneId) {
      return MonthDay.nowZoneId(zoneIdOrClock);
    } else {
      return MonthDay.nowClock(zoneIdOrClock);
    }
  };
  MonthDay.now0 = function now0() {
    return this.nowClock(Clock.systemDefaultZone());
  };
  MonthDay.nowZoneId = function nowZoneId(zone) {
    requireNonNull(zone, 'zone');
    return this.nowClock(Clock.system(zone));
  };
  MonthDay.nowClock = function nowClock(clock) {
    requireNonNull(clock, 'clock');
    var now = LocalDate.now(clock);
    return MonthDay.of(now.month(), now.dayOfMonth());
  };
  MonthDay.of = function of(monthOrNumber, number) {
    if (arguments.length === 2 && monthOrNumber instanceof Month) {
      return MonthDay.ofMonthNumber(monthOrNumber, number);
    } else {
      return MonthDay.ofNumberNumber(monthOrNumber, number);
    }
  };
  MonthDay.ofMonthNumber = function ofMonthNumber(month, dayOfMonth) {
    requireNonNull(month, 'month');
    ChronoField.DAY_OF_MONTH.checkValidValue(dayOfMonth);
    if (dayOfMonth > month.maxLength()) {
      throw new DateTimeException("Illegal value for DayOfMonth field, value " + dayOfMonth + " is not valid for month " + month.toString());
    }
    return new MonthDay(month.value(), dayOfMonth);
  };
  MonthDay.ofNumberNumber = function ofNumberNumber(month, dayOfMonth) {
    requireNonNull(month, 'month');
    requireNonNull(dayOfMonth, 'dayOfMonth');
    return MonthDay.of(Month.of(month), dayOfMonth);
  };
  MonthDay.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    requireInstance(temporal, TemporalAccessor, 'temporal');
    if (temporal instanceof MonthDay) {
      return temporal;
    }
    try {
      return MonthDay.of(temporal.get(ChronoField.MONTH_OF_YEAR), temporal.get(ChronoField.DAY_OF_MONTH));
    } catch (ex) {
      throw new DateTimeException("Unable to obtain MonthDay from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ''));
    }
  };
  MonthDay.parse = function parse(text, formatter) {
    if (arguments.length === 1) {
      return MonthDay.parseString(text);
    } else {
      return MonthDay.parseStringFormatter(text, formatter);
    }
  };
  MonthDay.parseString = function parseString(text) {
    return MonthDay.parseStringFormatter(text, PARSER$2);
  };
  MonthDay.parseStringFormatter = function parseStringFormatter(text, formatter) {
    requireNonNull(text, 'text');
    requireNonNull(formatter, 'formatter');
    requireInstance(formatter, DateTimeFormatter, 'formatter');
    return formatter.parse(text, MonthDay.FROM);
  };
  function MonthDay(month, dayOfMonth) {
    var _this;
    _this = _TemporalAccessor.call(this) || this;
    _this._month = MathUtil.safeToInt(month);
    _this._day = MathUtil.safeToInt(dayOfMonth);
    return _this;
  }
  var _proto = MonthDay.prototype;
  _proto.monthValue = function monthValue() {
    return this._month;
  };
  _proto.month = function month() {
    return Month.of(this._month);
  };
  _proto.dayOfMonth = function dayOfMonth() {
    return this._day;
  };
  _proto.isSupported = function isSupported(field) {
    if (field instanceof ChronoField) {
      return field === ChronoField.MONTH_OF_YEAR || field === ChronoField.DAY_OF_MONTH;
    }
    return field != null && field.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    if (field === ChronoField.MONTH_OF_YEAR) {
      return field.range();
    } else if (field === ChronoField.DAY_OF_MONTH) {
      return ValueRange.of(1, this.month().minLength(), this.month().maxLength());
    }
    return _TemporalAccessor.prototype.range.call(this, field);
  };
  _proto.get = function get(field) {
    return this.range(field).checkValidIntValue(this.getLong(field), field);
  };
  _proto.getLong = function getLong(field) {
    requireNonNull(field, 'field');
    if (field instanceof ChronoField) {
      switch (field) {
        case ChronoField.DAY_OF_MONTH:
          return this._day;
        case ChronoField.MONTH_OF_YEAR:
          return this._month;
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.getFrom(this);
  };
  _proto.isValidYear = function isValidYear(year) {
    return (this._day === 29 && this._month === 2 && Year.isLeap(year) === false) === false;
  };
  _proto.withMonth = function withMonth(month) {
    return this.with(Month.of(month));
  };
  _proto.with = function _with(month) {
    requireNonNull(month, 'month');
    if (month.value() === this._month) {
      return this;
    }
    var day = Math.min(this._day, month.maxLength());
    return new MonthDay(month.value(), day);
  };
  _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
    if (dayOfMonth === this._day) {
      return this;
    }
    return MonthDay.of(this._month, dayOfMonth);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    requireInstance(_query, TemporalQuery, 'query');
    if (_query === TemporalQueries.chronology()) {
      return IsoChronology.INSTANCE;
    }
    return _TemporalAccessor.prototype.query.call(this, _query);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    requireNonNull(temporal, 'temporal');
    temporal = temporal.with(ChronoField.MONTH_OF_YEAR, this._month);
    return temporal.with(ChronoField.DAY_OF_MONTH, Math.min(temporal.range(ChronoField.DAY_OF_MONTH).maximum(), this._day));
  };
  _proto.atYear = function atYear(year) {
    return LocalDate.of(year, this._month, this.isValidYear(year) ? this._day : 28);
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, MonthDay, 'other');
    var cmp = this._month - other.monthValue();
    if (cmp === 0) {
      cmp = this._day - other.dayOfMonth();
    }
    return cmp;
  };
  _proto.isAfter = function isAfter(other) {
    requireNonNull(other, 'other');
    requireInstance(other, MonthDay, 'other');
    return this.compareTo(other) > 0;
  };
  _proto.isBefore = function isBefore(other) {
    requireNonNull(other, 'other');
    requireInstance(other, MonthDay, 'other');
    return this.compareTo(other) < 0;
  };
  _proto.equals = function equals(obj) {
    if (this === obj) {
      return true;
    }
    if (obj instanceof MonthDay) {
      var other = obj;
      return this.monthValue() === other.monthValue() && this.dayOfMonth() === other.dayOfMonth();
    }
    return false;
  };
  _proto.toString = function toString() {
    return "--" + (this._month < 10 ? '0' : '') + this._month + (this._day < 10 ? '-0' : '-') + this._day;
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    requireInstance(formatter, DateTimeFormatter, 'formatter');
    return formatter.format(this);
  };
  return MonthDay;
}(TemporalAccessor);
var PARSER$2;
function _init$c() {
  PARSER$2 = new DateTimeFormatterBuilder().appendLiteral('--').appendValue(ChronoField.MONTH_OF_YEAR, 2).appendLiteral('-').appendValue(ChronoField.DAY_OF_MONTH, 2).toFormatter();
  MonthDay.FROM = createTemporalQuery('MonthDay.FROM', function (temporal) {
    return MonthDay.from(temporal);
  });
}

var YearMonth = function (_Temporal) {
  _inheritsLoose(YearMonth, _Temporal);
  YearMonth.now = function now(zoneIdOrClock) {
    if (arguments.length === 0) {
      return YearMonth.now0();
    } else if (arguments.length === 1 && zoneIdOrClock instanceof ZoneId) {
      return YearMonth.nowZoneId(zoneIdOrClock);
    } else {
      return YearMonth.nowClock(zoneIdOrClock);
    }
  };
  YearMonth.now0 = function now0() {
    return YearMonth.nowClock(Clock.systemDefaultZone());
  };
  YearMonth.nowZoneId = function nowZoneId(zone) {
    return YearMonth.nowClock(Clock.system(zone));
  };
  YearMonth.nowClock = function nowClock(clock) {
    var now = LocalDate.now(clock);
    return YearMonth.of(now.year(), now.month());
  };
  YearMonth.of = function of(year, monthOrNumber) {
    if (arguments.length === 2 && monthOrNumber instanceof Month) {
      return YearMonth.ofNumberMonth(year, monthOrNumber);
    } else {
      return YearMonth.ofNumberNumber(year, monthOrNumber);
    }
  };
  YearMonth.ofNumberMonth = function ofNumberMonth(year, month) {
    requireNonNull(month, 'month');
    requireInstance(month, Month, 'month');
    return YearMonth.ofNumberNumber(year, month.value());
  };
  YearMonth.ofNumberNumber = function ofNumberNumber(year, month) {
    requireNonNull(year, 'year');
    requireNonNull(month, 'month');
    ChronoField.YEAR.checkValidValue(year);
    ChronoField.MONTH_OF_YEAR.checkValidValue(month);
    return new YearMonth(year, month);
  };
  YearMonth.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    if (temporal instanceof YearMonth) {
      return temporal;
    }
    try {
      return YearMonth.of(temporal.get(ChronoField.YEAR), temporal.get(ChronoField.MONTH_OF_YEAR));
    } catch (ex) {
      throw new DateTimeException("Unable to obtain YearMonth from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ''));
    }
  };
  YearMonth.parse = function parse(text, formatter) {
    if (arguments.length === 1) {
      return YearMonth.parseString(text);
    } else {
      return YearMonth.parseStringFormatter(text, formatter);
    }
  };
  YearMonth.parseString = function parseString(text) {
    return YearMonth.parseStringFormatter(text, PARSER$1);
  };
  YearMonth.parseStringFormatter = function parseStringFormatter(text, formatter) {
    requireNonNull(formatter, 'formatter');
    return formatter.parse(text, YearMonth.FROM);
  };
  function YearMonth(year, month) {
    var _this;
    _this = _Temporal.call(this) || this;
    _this._year = MathUtil.safeToInt(year);
    _this._month = MathUtil.safeToInt(month);
    return _this;
  }
  var _proto = YearMonth.prototype;
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (arguments.length === 1 && fieldOrUnit instanceof TemporalField) {
      return this.isSupportedField(fieldOrUnit);
    } else {
      return this.isSupportedUnit(fieldOrUnit);
    }
  };
  _proto.isSupportedField = function isSupportedField(field) {
    if (field instanceof ChronoField) {
      return field === ChronoField.YEAR || field === ChronoField.MONTH_OF_YEAR || field === ChronoField.PROLEPTIC_MONTH || field === ChronoField.YEAR_OF_ERA || field === ChronoField.ERA;
    }
    return field != null && field.isSupportedBy(this);
  };
  _proto.isSupportedUnit = function isSupportedUnit(unit) {
    if (unit instanceof ChronoUnit) {
      return unit === ChronoUnit.MONTHS || unit === ChronoUnit.YEARS || unit === ChronoUnit.DECADES || unit === ChronoUnit.CENTURIES || unit === ChronoUnit.MILLENNIA || unit === ChronoUnit.ERAS;
    }
    return unit != null && unit.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    if (field === ChronoField.YEAR_OF_ERA) {
      return this.year() <= 0 ? ValueRange.of(1, Year.MAX_VALUE + 1) : ValueRange.of(1, Year.MAX_VALUE);
    }
    return _Temporal.prototype.range.call(this, field);
  };
  _proto.get = function get(field) {
    requireNonNull(field, 'field');
    requireInstance(field, TemporalField, 'field');
    return this.range(field).checkValidIntValue(this.getLong(field), field);
  };
  _proto.getLong = function getLong(field) {
    requireNonNull(field, 'field');
    requireInstance(field, TemporalField, 'field');
    if (field instanceof ChronoField) {
      switch (field) {
        case ChronoField.MONTH_OF_YEAR:
          return this._month;
        case ChronoField.PROLEPTIC_MONTH:
          return this._getProlepticMonth();
        case ChronoField.YEAR_OF_ERA:
          return this._year < 1 ? 1 - this._year : this._year;
        case ChronoField.YEAR:
          return this._year;
        case ChronoField.ERA:
          return this._year < 1 ? 0 : 1;
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.getFrom(this);
  };
  _proto._getProlepticMonth = function _getProlepticMonth() {
    return MathUtil.safeAdd(MathUtil.safeMultiply(this._year, 12), this._month - 1);
  };
  _proto.year = function year() {
    return this._year;
  };
  _proto.monthValue = function monthValue() {
    return this._month;
  };
  _proto.month = function month() {
    return Month.of(this._month);
  };
  _proto.isLeapYear = function isLeapYear() {
    return IsoChronology.isLeapYear(this._year);
  };
  _proto.isValidDay = function isValidDay(dayOfMonth) {
    return dayOfMonth >= 1 && dayOfMonth <= this.lengthOfMonth();
  };
  _proto.lengthOfMonth = function lengthOfMonth() {
    return this.month().length(this.isLeapYear());
  };
  _proto.lengthOfYear = function lengthOfYear() {
    return this.isLeapYear() ? 366 : 365;
  };
  _proto.with = function _with(adjusterOrField, value) {
    if (arguments.length === 1) {
      return this._withAdjuster(adjusterOrField);
    } else {
      return this._withField(adjusterOrField, value);
    }
  };
  _proto._withField = function _withField(field, newValue) {
    requireNonNull(field, 'field');
    requireInstance(field, TemporalField, 'field');
    if (field instanceof ChronoField) {
      var f = field;
      f.checkValidValue(newValue);
      switch (f) {
        case ChronoField.MONTH_OF_YEAR:
          return this.withMonth(newValue);
        case ChronoField.PROLEPTIC_MONTH:
          return this.plusMonths(newValue - this.getLong(ChronoField.PROLEPTIC_MONTH));
        case ChronoField.YEAR_OF_ERA:
          return this.withYear(this._year < 1 ? 1 - newValue : newValue);
        case ChronoField.YEAR:
          return this.withYear(newValue);
        case ChronoField.ERA:
          return this.getLong(ChronoField.ERA) === newValue ? this : this.withYear(1 - this._year);
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.adjustInto(this, newValue);
  };
  _proto.withYear = function withYear(year) {
    ChronoField.YEAR.checkValidValue(year);
    return new YearMonth(year, this._month);
  };
  _proto.withMonth = function withMonth(month) {
    ChronoField.MONTH_OF_YEAR.checkValidValue(month);
    return new YearMonth(this._year, month);
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    requireNonNull(unit, 'unit');
    requireInstance(unit, TemporalUnit, 'unit');
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.MONTHS:
          return this.plusMonths(amountToAdd);
        case ChronoUnit.YEARS:
          return this.plusYears(amountToAdd);
        case ChronoUnit.DECADES:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 10));
        case ChronoUnit.CENTURIES:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 100));
        case ChronoUnit.MILLENNIA:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 1000));
        case ChronoUnit.ERAS:
          return this.with(ChronoField.ERA, MathUtil.safeAdd(this.getLong(ChronoField.ERA), amountToAdd));
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusYears = function plusYears(yearsToAdd) {
    if (yearsToAdd === 0) {
      return this;
    }
    var newYear = ChronoField.YEAR.checkValidIntValue(this._year + yearsToAdd);
    return this.withYear(newYear);
  };
  _proto.plusMonths = function plusMonths(monthsToAdd) {
    if (monthsToAdd === 0) {
      return this;
    }
    var monthCount = this._year * 12 + (this._month - 1);
    var calcMonths = monthCount + monthsToAdd;
    var newYear = ChronoField.YEAR.checkValidIntValue(MathUtil.floorDiv(calcMonths, 12));
    var newMonth = MathUtil.floorMod(calcMonths, 12) + 1;
    return new YearMonth(newYear, newMonth);
  };
  _proto.minusYears = function minusYears(yearsToSubtract) {
    return yearsToSubtract === MathUtil.MIN_SAFE_INTEGER ? this.plusYears(MathUtil.MIN_SAFE_INTEGER).plusYears(1) : this.plusYears(-yearsToSubtract);
  };
  _proto.minusMonths = function minusMonths(monthsToSubtract) {
    return monthsToSubtract === MathUtil.MIN_SAFE_INTEGER ? this.plusMonths(Math.MAX_SAFE_INTEGER).plusMonths(1) : this.plusMonths(-monthsToSubtract);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    requireInstance(_query, TemporalQuery, 'query');
    if (_query === TemporalQueries.chronology()) {
      return IsoChronology.INSTANCE;
    } else if (_query === TemporalQueries.precision()) {
      return ChronoUnit.MONTHS;
    } else if (_query === TemporalQueries.localDate() || _query === TemporalQueries.localTime() || _query === TemporalQueries.zone() || _query === TemporalQueries.zoneId() || _query === TemporalQueries.offset()) {
      return null;
    }
    return _Temporal.prototype.query.call(this, _query);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    requireNonNull(temporal, 'temporal');
    requireInstance(temporal, Temporal, 'temporal');
    return temporal.with(ChronoField.PROLEPTIC_MONTH, this._getProlepticMonth());
  };
  _proto.until = function until(endExclusive, unit) {
    requireNonNull(endExclusive, 'endExclusive');
    requireNonNull(unit, 'unit');
    requireInstance(endExclusive, Temporal, 'endExclusive');
    requireInstance(unit, TemporalUnit, 'unit');
    var end = YearMonth.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      var monthsUntil = end._getProlepticMonth() - this._getProlepticMonth();
      switch (unit) {
        case ChronoUnit.MONTHS:
          return monthsUntil;
        case ChronoUnit.YEARS:
          return MathUtil.intDiv(monthsUntil, 12);
        case ChronoUnit.DECADES:
          return MathUtil.intDiv(monthsUntil, 120);
        case ChronoUnit.CENTURIES:
          return MathUtil.intDiv(monthsUntil, 1200);
        case ChronoUnit.MILLENNIA:
          return MathUtil.intDiv(monthsUntil, 12000);
        case ChronoUnit.ERAS:
          return end.getLong(ChronoField.ERA) - this.getLong(ChronoField.ERA);
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.between(this, end);
  };
  _proto.atDay = function atDay(dayOfMonth) {
    requireNonNull(dayOfMonth, 'dayOfMonth');
    return LocalDate.of(this._year, this._month, dayOfMonth);
  };
  _proto.atEndOfMonth = function atEndOfMonth() {
    return LocalDate.of(this._year, this._month, this.lengthOfMonth());
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, YearMonth, 'other');
    var cmp = this._year - other.year();
    if (cmp === 0) {
      cmp = this._month - other.monthValue();
    }
    return cmp;
  };
  _proto.isAfter = function isAfter(other) {
    return this.compareTo(other) > 0;
  };
  _proto.isBefore = function isBefore(other) {
    return this.compareTo(other) < 0;
  };
  _proto.equals = function equals(obj) {
    if (this === obj) {
      return true;
    }
    if (obj instanceof YearMonth) {
      var other = obj;
      return this.year() === other.year() && this.monthValue() === other.monthValue();
    }
    return false;
  };
  _proto.toString = function toString() {
    return PARSER$1.format(this);
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    return formatter.format(this);
  };
  return YearMonth;
}(Temporal);
var PARSER$1;
function _init$b() {
  PARSER$1 = new DateTimeFormatterBuilder().appendValue(ChronoField.YEAR, 4, 10, SignStyle.EXCEEDS_PAD).appendLiteral('-').appendValue(ChronoField.MONTH_OF_YEAR, 2).toFormatter();
  YearMonth.FROM = createTemporalQuery('YearMonth.FROM', function (temporal) {
    return YearMonth.from(temporal);
  });
}

var Year = function (_Temporal) {
  _inheritsLoose(Year, _Temporal);
  function Year(value) {
    var _this;
    _this = _Temporal.call(this) || this;
    _this._year = MathUtil.safeToInt(value);
    return _this;
  }
  var _proto = Year.prototype;
  _proto.value = function value() {
    return this._year;
  };
  Year.now = function now(zoneIdOrClock) {
    if (zoneIdOrClock === void 0) {
      zoneIdOrClock = undefined;
    }
    if (zoneIdOrClock === undefined) {
      return Year.now0();
    } else if (zoneIdOrClock instanceof ZoneId) {
      return Year.nowZoneId(zoneIdOrClock);
    } else {
      return Year.nowClock(zoneIdOrClock);
    }
  };
  Year.now0 = function now0() {
    return Year.nowClock(Clock.systemDefaultZone());
  };
  Year.nowZoneId = function nowZoneId(zone) {
    requireNonNull(zone, 'zone');
    requireInstance(zone, ZoneId, 'zone');
    return Year.nowClock(Clock.system(zone));
  };
  Year.nowClock = function nowClock(clock) {
    requireNonNull(clock, 'clock');
    requireInstance(clock, Clock, 'clock');
    var now = LocalDate.now(clock);
    return Year.of(now.year());
  };
  Year.of = function of(isoYear) {
    requireNonNull(isoYear, 'isoYear');
    ChronoField.YEAR.checkValidValue(isoYear);
    return new Year(isoYear);
  };
  Year.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    requireInstance(temporal, TemporalAccessor, 'temporal');
    if (temporal instanceof Year) {
      return temporal;
    }
    try {
      return Year.of(temporal.get(ChronoField.YEAR));
    } catch (ex) {
      throw new DateTimeException("Unable to obtain Year from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ''));
    }
  };
  Year.parse = function parse(text, formatter) {
    if (arguments.length <= 1) {
      return Year.parseText(text);
    } else {
      return Year.parseTextFormatter(text, formatter);
    }
  };
  Year.parseText = function parseText(text) {
    requireNonNull(text, 'text');
    return Year.parse(text, PARSER);
  };
  Year.parseTextFormatter = function parseTextFormatter(text, formatter) {
    if (formatter === void 0) {
      formatter = PARSER;
    }
    requireNonNull(text, 'text');
    requireNonNull(formatter, 'formatter');
    requireInstance(formatter, DateTimeFormatter, 'formatter');
    return formatter.parse(text, Year.FROM);
  };
  Year.isLeap = function isLeap(year) {
    return MathUtil.intMod(year, 4) === 0 && (MathUtil.intMod(year, 100) !== 0 || MathUtil.intMod(year, 400) === 0);
  };
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (arguments.length === 1 && fieldOrUnit instanceof TemporalField) {
      return this.isSupportedField(fieldOrUnit);
    } else {
      return this.isSupportedUnit(fieldOrUnit);
    }
  };
  _proto.isSupportedField = function isSupportedField(field) {
    if (field instanceof ChronoField) {
      return field === ChronoField.YEAR || field === ChronoField.YEAR_OF_ERA || field === ChronoField.ERA;
    }
    return field != null && field.isSupportedBy(this);
  };
  _proto.isSupportedUnit = function isSupportedUnit(unit) {
    if (unit instanceof ChronoUnit) {
      return unit === ChronoUnit.YEARS || unit === ChronoUnit.DECADES || unit === ChronoUnit.CENTURIES || unit === ChronoUnit.MILLENNIA || unit === ChronoUnit.ERAS;
    }
    return unit != null && unit.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    if (this.isSupported(field)) {
      return field.range();
    } else if (field instanceof ChronoField) {
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return _Temporal.prototype.range.call(this, field);
  };
  _proto.get = function get(field) {
    return this.range(field).checkValidIntValue(this.getLong(field), field);
  };
  _proto.getLong = function getLong(field) {
    requireNonNull(field, 'field');
    if (field instanceof ChronoField) {
      switch (field) {
        case ChronoField.YEAR_OF_ERA:
          return this._year < 1 ? 1 - this._year : this._year;
        case ChronoField.YEAR:
          return this._year;
        case ChronoField.ERA:
          return this._year < 1 ? 0 : 1;
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.getFrom(this);
  };
  _proto.isLeap = function isLeap() {
    return Year.isLeap(this._year);
  };
  _proto._withField = function _withField(field, newValue) {
    requireNonNull(field, 'field');
    requireInstance(field, TemporalField, 'field');
    if (field instanceof ChronoField) {
      field.checkValidValue(newValue);
      switch (field) {
        case ChronoField.YEAR_OF_ERA:
          return Year.of(this._year < 1 ? 1 - newValue : newValue);
        case ChronoField.YEAR:
          return Year.of(newValue);
        case ChronoField.ERA:
          return this.getLong(ChronoField.ERA) === newValue ? this : Year.of(1 - this._year);
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.adjustInto(this, newValue);
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    requireNonNull(amountToAdd, 'amountToAdd');
    requireNonNull(unit, 'unit');
    requireInstance(unit, TemporalUnit, 'unit');
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.YEARS:
          return this.plusYears(amountToAdd);
        case ChronoUnit.DECADES:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 10));
        case ChronoUnit.CENTURIES:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 100));
        case ChronoUnit.MILLENNIA:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 1000));
        case ChronoUnit.ERAS:
          return this.with(ChronoField.ERA, MathUtil.safeAdd(this.getLong(ChronoField.ERA), amountToAdd));
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusYears = function plusYears(yearsToAdd) {
    if (yearsToAdd === 0) {
      return this;
    }
    return Year.of(ChronoField.YEAR.checkValidIntValue(MathUtil.safeAdd(this._year, yearsToAdd)));
  };
  _proto.minusYears = function minusYears(yearsToSubtract) {
    return yearsToSubtract === MathUtil.MIN_SAFE_INTEGER ? this.plusYears(MathUtil.MAX_SAFE_INTEGER).plusYears(1) : this.plusYears(-yearsToSubtract);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    requireNonNull(temporal, 'temporal');
    return temporal.with(ChronoField.YEAR, this._year);
  };
  _proto.isValidMonthDay = function isValidMonthDay(monthDay) {
    return monthDay != null && monthDay.isValidYear(this._year);
  };
  _proto.length = function length() {
    return this.isLeap() ? 366 : 365;
  };
  _proto.atDay = function atDay(dayOfYear) {
    return LocalDate.ofYearDay(this._year, dayOfYear);
  };
  _proto.atMonth = function atMonth(monthOrNumber) {
    if (arguments.length === 1 && monthOrNumber instanceof Month) {
      return this.atMonthMonth(monthOrNumber);
    } else {
      return this.atMonthNumber(monthOrNumber);
    }
  };
  _proto.atMonthMonth = function atMonthMonth(month) {
    requireNonNull(month, 'month');
    requireInstance(month, Month, 'month');
    return YearMonth.of(this._year, month);
  };
  _proto.atMonthNumber = function atMonthNumber(month) {
    requireNonNull(month, 'month');
    return YearMonth.of(this._year, month);
  };
  _proto.atMonthDay = function atMonthDay(monthDay) {
    requireNonNull(monthDay, 'monthDay');
    requireInstance(monthDay, MonthDay, 'monthDay');
    return monthDay.atYear(this._year);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query()');
    requireInstance(_query, TemporalQuery, 'query()');
    if (_query === TemporalQueries.chronology()) {
      return IsoChronology.INSTANCE;
    } else if (_query === TemporalQueries.precision()) {
      return ChronoUnit.YEARS;
    } else if (_query === TemporalQueries.localDate() || _query === TemporalQueries.localTime() || _query === TemporalQueries.zone() || _query === TemporalQueries.zoneId() || _query === TemporalQueries.offset()) {
      return null;
    }
    return _Temporal.prototype.query.call(this, _query);
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, Year, 'other');
    return this._year - other._year;
  };
  _proto.isAfter = function isAfter(other) {
    requireNonNull(other, 'other');
    requireInstance(other, Year, 'other');
    return this._year > other._year;
  };
  _proto.isBefore = function isBefore(other) {
    requireNonNull(other, 'other');
    requireInstance(other, Year, 'other');
    return this._year < other._year;
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    requireInstance(formatter, DateTimeFormatter, 'formatter');
    return formatter.format(this);
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof Year) {
      return this.value() === other.value();
    }
    return false;
  };
  _proto.toString = function toString() {
    return "" + this._year;
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.until = function until(endExclusive, unit) {
    var end = Year.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      var yearsUntil = end.value() - this.value();
      switch (unit) {
        case ChronoUnit.YEARS:
          return yearsUntil;
        case ChronoUnit.DECADES:
          return MathUtil.intDiv(yearsUntil, 10);
        case ChronoUnit.CENTURIES:
          return MathUtil.intDiv(yearsUntil, 100);
        case ChronoUnit.MILLENNIA:
          return MathUtil.intDiv(yearsUntil, 1000);
        case ChronoUnit.ERAS:
          return end.getLong(ChronoField.ERA) - this.getLong(ChronoField.ERA);
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.between(this, end);
  };
  return Year;
}(Temporal);
var PARSER;
function _init$a() {
  Year.MIN_VALUE = YearConstants.MIN_VALUE;
  Year.MAX_VALUE = YearConstants.MAX_VALUE;
  PARSER = new DateTimeFormatterBuilder().appendValue(ChronoField.YEAR, 4, 10, SignStyle.EXCEEDS_PAD).toFormatter();
  Year.FROM = createTemporalQuery('Year.FROM', function (temporal) {
    return Year.from(temporal);
  });
}

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var TemporalAdjuster = function () {
  function TemporalAdjuster() {}
  var _proto = TemporalAdjuster.prototype;
  _proto.adjustInto = function adjustInto(temporal) {
    abstractMethodFail('adjustInto');
  };
  return TemporalAdjuster;
}();

var TemporalAdjusters = function () {
  function TemporalAdjusters() {}
  TemporalAdjusters.firstDayOfMonth = function firstDayOfMonth() {
    return Impl.FIRST_DAY_OF_MONTH;
  };
  TemporalAdjusters.lastDayOfMonth = function lastDayOfMonth() {
    return Impl.LAST_DAY_OF_MONTH;
  };
  TemporalAdjusters.firstDayOfNextMonth = function firstDayOfNextMonth() {
    return Impl.FIRST_DAY_OF_NEXT_MONTH;
  };
  TemporalAdjusters.firstDayOfYear = function firstDayOfYear() {
    return Impl.FIRST_DAY_OF_YEAR;
  };
  TemporalAdjusters.lastDayOfYear = function lastDayOfYear() {
    return Impl.LAST_DAY_OF_YEAR;
  };
  TemporalAdjusters.firstDayOfNextYear = function firstDayOfNextYear() {
    return Impl.FIRST_DAY_OF_NEXT_YEAR;
  };
  TemporalAdjusters.firstInMonth = function firstInMonth(dayOfWeek) {
    requireNonNull(dayOfWeek, 'dayOfWeek');
    return new DayOfWeekInMonth(1, dayOfWeek);
  };
  TemporalAdjusters.lastInMonth = function lastInMonth(dayOfWeek) {
    requireNonNull(dayOfWeek, 'dayOfWeek');
    return new DayOfWeekInMonth(-1, dayOfWeek);
  };
  TemporalAdjusters.dayOfWeekInMonth = function dayOfWeekInMonth(ordinal, dayOfWeek) {
    requireNonNull(dayOfWeek, 'dayOfWeek');
    return new DayOfWeekInMonth(ordinal, dayOfWeek);
  };
  TemporalAdjusters.next = function next(dayOfWeek) {
    return new RelativeDayOfWeek(2, dayOfWeek);
  };
  TemporalAdjusters.nextOrSame = function nextOrSame(dayOfWeek) {
    return new RelativeDayOfWeek(0, dayOfWeek);
  };
  TemporalAdjusters.previous = function previous(dayOfWeek) {
    return new RelativeDayOfWeek(3, dayOfWeek);
  };
  TemporalAdjusters.previousOrSame = function previousOrSame(dayOfWeek) {
    return new RelativeDayOfWeek(1, dayOfWeek);
  };
  return TemporalAdjusters;
}();
var Impl = function (_TemporalAdjuster) {
  _inheritsLoose(Impl, _TemporalAdjuster);
  function Impl(ordinal) {
    var _this;
    _this = _TemporalAdjuster.call(this) || this;
    _this._ordinal = ordinal;
    return _this;
  }
  var _proto = Impl.prototype;
  _proto.adjustInto = function adjustInto(temporal) {
    switch (this._ordinal) {
      case 0:
        return temporal.with(ChronoField.DAY_OF_MONTH, 1);
      case 1:
        return temporal.with(ChronoField.DAY_OF_MONTH, temporal.range(ChronoField.DAY_OF_MONTH).maximum());
      case 2:
        return temporal.with(ChronoField.DAY_OF_MONTH, 1).plus(1, ChronoUnit.MONTHS);
      case 3:
        return temporal.with(ChronoField.DAY_OF_YEAR, 1);
      case 4:
        return temporal.with(ChronoField.DAY_OF_YEAR, temporal.range(ChronoField.DAY_OF_YEAR).maximum());
      case 5:
        return temporal.with(ChronoField.DAY_OF_YEAR, 1).plus(1, ChronoUnit.YEARS);
    }
    throw new IllegalStateException('Unreachable');
  };
  return Impl;
}(TemporalAdjuster);
Impl.FIRST_DAY_OF_MONTH = new Impl(0);
Impl.LAST_DAY_OF_MONTH = new Impl(1);
Impl.FIRST_DAY_OF_NEXT_MONTH = new Impl(2);
Impl.FIRST_DAY_OF_YEAR = new Impl(3);
Impl.LAST_DAY_OF_YEAR = new Impl(4);
Impl.FIRST_DAY_OF_NEXT_YEAR = new Impl(5);
var DayOfWeekInMonth = function (_TemporalAdjuster2) {
  _inheritsLoose(DayOfWeekInMonth, _TemporalAdjuster2);
  function DayOfWeekInMonth(ordinal, dow) {
    var _this2;
    _this2 = _TemporalAdjuster2.call(this) || this;
    _this2._ordinal = ordinal;
    _this2._dowValue = dow.value();
    return _this2;
  }
  var _proto2 = DayOfWeekInMonth.prototype;
  _proto2.adjustInto = function adjustInto(temporal) {
    if (this._ordinal >= 0) {
      var temp = temporal.with(ChronoField.DAY_OF_MONTH, 1);
      var curDow = temp.get(ChronoField.DAY_OF_WEEK);
      var dowDiff = MathUtil.intMod(this._dowValue - curDow + 7, 7);
      dowDiff += (this._ordinal - 1) * 7;
      return temp.plus(dowDiff, ChronoUnit.DAYS);
    } else {
      var _temp = temporal.with(ChronoField.DAY_OF_MONTH, temporal.range(ChronoField.DAY_OF_MONTH).maximum());
      var _curDow = _temp.get(ChronoField.DAY_OF_WEEK);
      var daysDiff = this._dowValue - _curDow;
      daysDiff = daysDiff === 0 ? 0 : daysDiff > 0 ? daysDiff - 7 : daysDiff;
      daysDiff -= (-this._ordinal - 1) * 7;
      return _temp.plus(daysDiff, ChronoUnit.DAYS);
    }
  };
  return DayOfWeekInMonth;
}(TemporalAdjuster);
var RelativeDayOfWeek = function (_TemporalAdjuster3) {
  _inheritsLoose(RelativeDayOfWeek, _TemporalAdjuster3);
  function RelativeDayOfWeek(relative, dayOfWeek) {
    var _this3;
    _this3 = _TemporalAdjuster3.call(this) || this;
    requireNonNull(dayOfWeek, 'dayOfWeek');
    _this3._relative = relative;
    _this3._dowValue = dayOfWeek.value();
    return _this3;
  }
  var _proto3 = RelativeDayOfWeek.prototype;
  _proto3.adjustInto = function adjustInto(temporal) {
    var calDow = temporal.get(ChronoField.DAY_OF_WEEK);
    if (this._relative < 2 && calDow === this._dowValue) {
      return temporal;
    }
    if ((this._relative & 1) === 0) {
      var daysDiff = calDow - this._dowValue;
      return temporal.plus(daysDiff >= 0 ? 7 - daysDiff : -daysDiff, ChronoUnit.DAYS);
    } else {
      var _daysDiff = this._dowValue - calDow;
      return temporal.minus(_daysDiff >= 0 ? 7 - _daysDiff : -_daysDiff, ChronoUnit.DAYS);
    }
  };
  return RelativeDayOfWeek;
}(TemporalAdjuster);

var IsoChronology = function (_Enum) {
  _inheritsLoose(IsoChronology, _Enum);
  function IsoChronology() {
    return _Enum.apply(this, arguments) || this;
  }
  IsoChronology.isLeapYear = function isLeapYear(prolepticYear) {
    return (prolepticYear & 3) === 0 && (prolepticYear % 100 !== 0 || prolepticYear % 400 === 0);
  };
  var _proto = IsoChronology.prototype;
  _proto._updateResolveMap = function _updateResolveMap(fieldValues, field, value) {
    requireNonNull(fieldValues, 'fieldValues');
    requireNonNull(field, 'field');
    var current = fieldValues.get(field);
    if (current != null && current !== value) {
      throw new DateTimeException("Invalid state, field: " + field + " " + current + " conflicts with " + field + " " + value);
    }
    fieldValues.put(field, value);
  };
  _proto.resolveDate = function resolveDate(fieldValues, resolverStyle) {
    if (fieldValues.containsKey(ChronoField.EPOCH_DAY)) {
      return LocalDate.ofEpochDay(fieldValues.remove(ChronoField.EPOCH_DAY));
    }
    var prolepticMonth = fieldValues.remove(ChronoField.PROLEPTIC_MONTH);
    if (prolepticMonth != null) {
      if (resolverStyle !== ResolverStyle.LENIENT) {
        ChronoField.PROLEPTIC_MONTH.checkValidValue(prolepticMonth);
      }
      this._updateResolveMap(fieldValues, ChronoField.MONTH_OF_YEAR, MathUtil.floorMod(prolepticMonth, 12) + 1);
      this._updateResolveMap(fieldValues, ChronoField.YEAR, MathUtil.floorDiv(prolepticMonth, 12));
    }
    var yoeLong = fieldValues.remove(ChronoField.YEAR_OF_ERA);
    if (yoeLong != null) {
      if (resolverStyle !== ResolverStyle.LENIENT) {
        ChronoField.YEAR_OF_ERA.checkValidValue(yoeLong);
      }
      var era = fieldValues.remove(ChronoField.ERA);
      if (era == null) {
        var year = fieldValues.get(ChronoField.YEAR);
        if (resolverStyle === ResolverStyle.STRICT) {
          if (year != null) {
            this._updateResolveMap(fieldValues, ChronoField.YEAR, year > 0 ? yoeLong : MathUtil.safeSubtract(1, yoeLong));
          } else {
            fieldValues.put(ChronoField.YEAR_OF_ERA, yoeLong);
          }
        } else {
          this._updateResolveMap(fieldValues, ChronoField.YEAR, year == null || year > 0 ? yoeLong : MathUtil.safeSubtract(1, yoeLong));
        }
      } else if (era === 1) {
        this._updateResolveMap(fieldValues, ChronoField.YEAR, yoeLong);
      } else if (era === 0) {
        this._updateResolveMap(fieldValues, ChronoField.YEAR, MathUtil.safeSubtract(1, yoeLong));
      } else {
        throw new DateTimeException("Invalid value for era: " + era);
      }
    } else if (fieldValues.containsKey(ChronoField.ERA)) {
      ChronoField.ERA.checkValidValue(fieldValues.get(ChronoField.ERA));
    }
    if (fieldValues.containsKey(ChronoField.YEAR)) {
      if (fieldValues.containsKey(ChronoField.MONTH_OF_YEAR)) {
        if (fieldValues.containsKey(ChronoField.DAY_OF_MONTH)) {
          var y = ChronoField.YEAR.checkValidIntValue(fieldValues.remove(ChronoField.YEAR));
          var moy = fieldValues.remove(ChronoField.MONTH_OF_YEAR);
          var dom = fieldValues.remove(ChronoField.DAY_OF_MONTH);
          if (resolverStyle === ResolverStyle.LENIENT) {
            var months = moy - 1;
            var days = dom - 1;
            return LocalDate.of(y, 1, 1).plusMonths(months).plusDays(days);
          } else if (resolverStyle === ResolverStyle.SMART) {
            ChronoField.DAY_OF_MONTH.checkValidValue(dom);
            if (moy === 4 || moy === 6 || moy === 9 || moy === 11) {
              dom = Math.min(dom, 30);
            } else if (moy === 2) {
              dom = Math.min(dom, Month.FEBRUARY.length(Year.isLeap(y)));
            }
            return LocalDate.of(y, moy, dom);
          } else {
            return LocalDate.of(y, moy, dom);
          }
        }
      }
      if (fieldValues.containsKey(ChronoField.DAY_OF_YEAR)) {
        var _y = ChronoField.YEAR.checkValidIntValue(fieldValues.remove(ChronoField.YEAR));
        if (resolverStyle === ResolverStyle.LENIENT) {
          var _days = MathUtil.safeSubtract(fieldValues.remove(ChronoField.DAY_OF_YEAR), 1);
          return LocalDate.ofYearDay(_y, 1).plusDays(_days);
        }
        var doy = ChronoField.DAY_OF_YEAR.checkValidIntValue(fieldValues.remove(ChronoField.DAY_OF_YEAR));
        return LocalDate.ofYearDay(_y, doy);
      }
      if (fieldValues.containsKey(ChronoField.ALIGNED_WEEK_OF_YEAR)) {
        if (fieldValues.containsKey(ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR)) {
          var _y2 = ChronoField.YEAR.checkValidIntValue(fieldValues.remove(ChronoField.YEAR));
          if (resolverStyle === ResolverStyle.LENIENT) {
            var weeks = MathUtil.safeSubtract(fieldValues.remove(ChronoField.ALIGNED_WEEK_OF_YEAR), 1);
            var _days2 = MathUtil.safeSubtract(fieldValues.remove(ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR), 1);
            return LocalDate.of(_y2, 1, 1).plusWeeks(weeks).plusDays(_days2);
          }
          var aw = ChronoField.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(fieldValues.remove(ChronoField.ALIGNED_WEEK_OF_YEAR));
          var ad = ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR.checkValidIntValue(fieldValues.remove(ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR));
          var date = LocalDate.of(_y2, 1, 1).plusDays((aw - 1) * 7 + (ad - 1));
          if (resolverStyle === ResolverStyle.STRICT && date.get(ChronoField.YEAR) !== _y2) {
            throw new DateTimeException('Strict mode rejected date parsed to a different year');
          }
          return date;
        }
        if (fieldValues.containsKey(ChronoField.DAY_OF_WEEK)) {
          var _y3 = ChronoField.YEAR.checkValidIntValue(fieldValues.remove(ChronoField.YEAR));
          if (resolverStyle === ResolverStyle.LENIENT) {
            var _weeks = MathUtil.safeSubtract(fieldValues.remove(ChronoField.ALIGNED_WEEK_OF_YEAR), 1);
            var _days3 = MathUtil.safeSubtract(fieldValues.remove(ChronoField.DAY_OF_WEEK), 1);
            return LocalDate.of(_y3, 1, 1).plusWeeks(_weeks).plusDays(_days3);
          }
          var _aw = ChronoField.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(fieldValues.remove(ChronoField.ALIGNED_WEEK_OF_YEAR));
          var dow = ChronoField.DAY_OF_WEEK.checkValidIntValue(fieldValues.remove(ChronoField.DAY_OF_WEEK));
          var _date = LocalDate.of(_y3, 1, 1).plusWeeks(_aw - 1).with(TemporalAdjusters.nextOrSame(DayOfWeek.of(dow)));
          if (resolverStyle === ResolverStyle.STRICT && _date.get(ChronoField.YEAR) !== _y3) {
            throw new DateTimeException('Strict mode rejected date parsed to a different month');
          }
          return _date;
        }
      }
    }
    return null;
  };
  _proto.date = function date(temporal) {
    return LocalDate.from(temporal);
  };
  return IsoChronology;
}(Enum);
function _init$9() {
  IsoChronology.INSTANCE = new IsoChronology('IsoChronology');
}

var OffsetTime = function (_Temporal) {
  _inheritsLoose(OffsetTime, _Temporal);
  OffsetTime.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    if (temporal instanceof OffsetTime) {
      return temporal;
    } else if (temporal instanceof OffsetDateTime) {
      return temporal.toOffsetTime();
    }
    try {
      var time = LocalTime.from(temporal);
      var offset = ZoneOffset.from(temporal);
      return new OffsetTime(time, offset);
    } catch (ex) {
      throw new DateTimeException("Unable to obtain OffsetTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
    }
  };
  OffsetTime.now = function now(clockOrZone) {
    if (arguments.length === 0) {
      return OffsetTime._now(Clock.systemDefaultZone());
    } else if (clockOrZone instanceof Clock) {
      return OffsetTime._now(clockOrZone);
    } else {
      return OffsetTime._now(Clock.system(clockOrZone));
    }
  };
  OffsetTime._now = function _now(clock) {
    requireNonNull(clock, 'clock');
    var now = clock.instant();
    return OffsetTime.ofInstant(now, clock.zone().rules().offset(now));
  };
  OffsetTime.of = function of() {
    if (arguments.length <= 2) {
      return OffsetTime.ofTimeAndOffset.apply(this, arguments);
    } else {
      return OffsetTime.ofNumbers.apply(this, arguments);
    }
  };
  OffsetTime.ofNumbers = function ofNumbers(hour, minute, second, nanoOfSecond, offset) {
    var time = LocalTime.of(hour, minute, second, nanoOfSecond);
    return new OffsetTime(time, offset);
  };
  OffsetTime.ofTimeAndOffset = function ofTimeAndOffset(time, offset) {
    return new OffsetTime(time, offset);
  };
  OffsetTime.ofInstant = function ofInstant(instant, zone) {
    requireNonNull(instant, 'instant');
    requireInstance(instant, Instant, 'instant');
    requireNonNull(zone, 'zone');
    requireInstance(zone, ZoneId, 'zone');
    var rules = zone.rules();
    var offset = rules.offset(instant);
    var secsOfDay = instant.epochSecond() % LocalTime.SECONDS_PER_DAY;
    secsOfDay = (secsOfDay + offset.totalSeconds()) % LocalTime.SECONDS_PER_DAY;
    if (secsOfDay < 0) {
      secsOfDay += LocalTime.SECONDS_PER_DAY;
    }
    var time = LocalTime.ofSecondOfDay(secsOfDay, instant.nano());
    return new OffsetTime(time, offset);
  };
  OffsetTime.parse = function parse(text, formatter) {
    if (formatter === void 0) {
      formatter = DateTimeFormatter.ISO_OFFSET_TIME;
    }
    requireNonNull(formatter, 'formatter');
    return formatter.parse(text, OffsetTime.FROM);
  };
  function OffsetTime(time, offset) {
    var _this;
    _this = _Temporal.call(this) || this;
    requireNonNull(time, 'time');
    requireInstance(time, LocalTime, 'time');
    requireNonNull(offset, 'offset');
    requireInstance(offset, ZoneOffset, 'offset');
    _this._time = time;
    _this._offset = offset;
    return _this;
  }
  var _proto = OffsetTime.prototype;
  _proto.adjustInto = function adjustInto(temporal) {
    return temporal.with(ChronoField.NANO_OF_DAY, this._time.toNanoOfDay()).with(ChronoField.OFFSET_SECONDS, this.offset().totalSeconds());
  };
  _proto.atDate = function atDate(date) {
    return OffsetDateTime.of(date, this._time, this._offset);
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    return formatter.format(this, OffsetTime.FROM);
  };
  _proto.get = function get(field) {
    return _Temporal.prototype.get.call(this, field);
  };
  _proto.getLong = function getLong(field) {
    if (field instanceof ChronoField) {
      if (field === ChronoField.OFFSET_SECONDS) {
        return this._offset.totalSeconds();
      }
      return this._time.getLong(field);
    }
    return field.getFrom(this);
  };
  _proto.hour = function hour() {
    return this._time.hour();
  };
  _proto.minute = function minute() {
    return this._time.minute();
  };
  _proto.second = function second() {
    return this._time.second();
  };
  _proto.nano = function nano() {
    return this._time.nano();
  };
  _proto.offset = function offset() {
    return this._offset;
  };
  _proto.isAfter = function isAfter(other) {
    requireNonNull(other, 'other');
    return this._toEpochNano() > other._toEpochNano();
  };
  _proto.isBefore = function isBefore(other) {
    requireNonNull(other, 'other');
    return this._toEpochNano() < other._toEpochNano();
  };
  _proto.isEqual = function isEqual(other) {
    requireNonNull(other, 'other');
    return this._toEpochNano() === other._toEpochNano();
  };
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (fieldOrUnit instanceof ChronoField) {
      return fieldOrUnit.isTimeBased() || fieldOrUnit === ChronoField.OFFSET_SECONDS;
    } else if (fieldOrUnit instanceof ChronoUnit) {
      return fieldOrUnit.isTimeBased();
    }
    return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
  };
  _proto.minusHours = function minusHours(hours) {
    return this._withLocalTimeOffset(this._time.minusHours(hours), this._offset);
  };
  _proto.minusMinutes = function minusMinutes(minutes) {
    return this._withLocalTimeOffset(this._time.minusMinutes(minutes), this._offset);
  };
  _proto.minusSeconds = function minusSeconds(seconds) {
    return this._withLocalTimeOffset(this._time.minusSeconds(seconds), this._offset);
  };
  _proto.minusNanos = function minusNanos(nanos) {
    return this._withLocalTimeOffset(this._time.minusNanos(nanos), this._offset);
  };
  _proto._minusAmount = function _minusAmount(amount) {
    requireNonNull(amount);
    return amount.subtractFrom(this);
  };
  _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
    return this.plus(-1 * amountToSubtract, unit);
  };
  _proto._plusAmount = function _plusAmount(amount) {
    requireNonNull(amount);
    return amount.addTo(this);
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    if (unit instanceof ChronoUnit) {
      return this._withLocalTimeOffset(this._time.plus(amountToAdd, unit), this._offset);
    }
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusHours = function plusHours(hours) {
    return this._withLocalTimeOffset(this._time.plusHours(hours), this._offset);
  };
  _proto.plusMinutes = function plusMinutes(minutes) {
    return this._withLocalTimeOffset(this._time.plusMinutes(minutes), this._offset);
  };
  _proto.plusSeconds = function plusSeconds(seconds) {
    return this._withLocalTimeOffset(this._time.plusSeconds(seconds), this._offset);
  };
  _proto.plusNanos = function plusNanos(nanos) {
    return this._withLocalTimeOffset(this._time.plusNanos(nanos), this._offset);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    if (_query === TemporalQueries.precision()) {
      return ChronoUnit.NANOS;
    } else if (_query === TemporalQueries.offset() || _query === TemporalQueries.zone()) {
      return this.offset();
    } else if (_query === TemporalQueries.localTime()) {
      return this._time;
    } else if (_query === TemporalQueries.chronology() || _query === TemporalQueries.localDate() || _query === TemporalQueries.zoneId()) {
      return null;
    }
    return _Temporal.prototype.query.call(this, _query);
  };
  _proto.range = function range(field) {
    if (field instanceof ChronoField) {
      if (field === ChronoField.OFFSET_SECONDS) {
        return field.range();
      }
      return this._time.range(field);
    }
    return field.rangeRefinedBy(this);
  };
  _proto.toLocalTime = function toLocalTime() {
    return this._time;
  };
  _proto.truncatedTo = function truncatedTo(unit) {
    return this._withLocalTimeOffset(this._time.truncatedTo(unit), this._offset);
  };
  _proto.until = function until(endExclusive, unit) {
    requireNonNull(endExclusive, 'endExclusive');
    requireNonNull(unit, 'unit');
    var end = OffsetTime.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      var nanosUntil = end._toEpochNano() - this._toEpochNano();
      switch (unit) {
        case ChronoUnit.NANOS:
          return nanosUntil;
        case ChronoUnit.MICROS:
          return MathUtil.intDiv(nanosUntil, 1000);
        case ChronoUnit.MILLIS:
          return MathUtil.intDiv(nanosUntil, 1000000);
        case ChronoUnit.SECONDS:
          return MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_SECOND);
        case ChronoUnit.MINUTES:
          return MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_MINUTE);
        case ChronoUnit.HOURS:
          return MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_HOUR);
        case ChronoUnit.HALF_DAYS:
          return MathUtil.intDiv(nanosUntil, 12 * LocalTime.NANOS_PER_HOUR);
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.between(this, end);
  };
  _proto.withHour = function withHour(hour) {
    return this._withLocalTimeOffset(this._time.withHour(hour), this._offset);
  };
  _proto.withMinute = function withMinute(minute) {
    return this._withLocalTimeOffset(this._time.withMinute(minute), this._offset);
  };
  _proto.withSecond = function withSecond(second) {
    return this._withLocalTimeOffset(this._time.withSecond(second), this._offset);
  };
  _proto.withNano = function withNano(nano) {
    return this._withLocalTimeOffset(this._time.withNano(nano), this._offset);
  };
  _proto.withOffsetSameInstant = function withOffsetSameInstant(offset) {
    requireNonNull(offset, 'offset');
    if (offset.equals(this._offset)) {
      return this;
    }
    var difference = offset.totalSeconds() - this._offset.totalSeconds();
    var adjusted = this._time.plusSeconds(difference);
    return new OffsetTime(adjusted, offset);
  };
  _proto.withOffsetSameLocal = function withOffsetSameLocal(offset) {
    return offset != null && offset.equals(this._offset) ? this : new OffsetTime(this._time, offset);
  };
  _proto._toEpochNano = function _toEpochNano() {
    var nod = this._time.toNanoOfDay();
    var offsetNanos = this._offset.totalSeconds() * LocalTime.NANOS_PER_SECOND;
    return nod - offsetNanos;
  };
  _proto._withAdjuster = function _withAdjuster(adjuster) {
    requireNonNull(adjuster, 'adjuster');
    if (adjuster instanceof LocalTime) {
      return this._withLocalTimeOffset(adjuster, this._offset);
    } else if (adjuster instanceof ZoneOffset) {
      return this._withLocalTimeOffset(this._time, adjuster);
    } else if (adjuster instanceof OffsetTime) {
      return adjuster;
    }
    return adjuster.adjustInto(this);
  };
  _proto._withField = function _withField(field, newValue) {
    requireNonNull(field, 'field');
    if (field instanceof ChronoField) {
      if (field === ChronoField.OFFSET_SECONDS) {
        return this._withLocalTimeOffset(this._time, ZoneOffset.ofTotalSeconds(field.checkValidIntValue(newValue)));
      }
      return this._withLocalTimeOffset(this._time.with(field, newValue), this._offset);
    }
    return field.adjustInto(this, newValue);
  };
  _proto._withLocalTimeOffset = function _withLocalTimeOffset(time, offset) {
    if (this._time === time && this._offset.equals(offset)) {
      return this;
    }
    return new OffsetTime(time, offset);
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, OffsetTime, 'other');
    if (this._offset.equals(other._offset)) {
      return this._time.compareTo(other._time);
    }
    var compare = MathUtil.compareNumbers(this._toEpochNano(), other._toEpochNano());
    if (compare === 0) {
      return this._time.compareTo(other._time);
    }
    return compare;
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof OffsetTime) {
      return this._time.equals(other._time) && this._offset.equals(other._offset);
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return this._time.hashCode() ^ this._offset.hashCode();
  };
  _proto.toString = function toString() {
    return this._time.toString() + this._offset.toString();
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  return OffsetTime;
}(Temporal);
function _init$8() {
  OffsetTime.MIN = OffsetTime.ofNumbers(0, 0, 0, 0, ZoneOffset.MAX);
  OffsetTime.MAX = OffsetTime.ofNumbers(23, 59, 59, 999999999, ZoneOffset.MIN);
  OffsetTime.FROM = createTemporalQuery('OffsetTime.FROM', function (temporal) {
    return OffsetTime.from(temporal);
  });
}

var ChronoZonedDateTime = function (_Temporal) {
  _inheritsLoose(ChronoZonedDateTime, _Temporal);
  function ChronoZonedDateTime() {
    return _Temporal.apply(this, arguments) || this;
  }
  var _proto = ChronoZonedDateTime.prototype;
  _proto.query = function query(_query) {
    if (_query === TemporalQueries.zoneId() || _query === TemporalQueries.zone()) {
      return this.zone();
    } else if (_query === TemporalQueries.chronology()) {
      return this.toLocalDate().chronology();
    } else if (_query === TemporalQueries.precision()) {
      return ChronoUnit.NANOS;
    } else if (_query === TemporalQueries.offset()) {
      return this.offset();
    } else if (_query === TemporalQueries.localDate()) {
      return LocalDate.ofEpochDay(this.toLocalDate().toEpochDay());
    } else if (_query === TemporalQueries.localTime()) {
      return this.toLocalTime();
    }
    return _Temporal.prototype.query.call(this, _query);
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    return formatter.format(this);
  };
  _proto.toInstant = function toInstant() {
    return Instant.ofEpochSecond(this.toEpochSecond(), this.toLocalTime().nano());
  };
  _proto.toEpochSecond = function toEpochSecond() {
    var epochDay = this.toLocalDate().toEpochDay();
    var secs = epochDay * 86400 + this.toLocalTime().toSecondOfDay();
    secs -= this.offset().totalSeconds();
    return secs;
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    var cmp = MathUtil.compareNumbers(this.toEpochSecond(), other.toEpochSecond());
    if (cmp === 0) {
      cmp = this.toLocalTime().nano() - other.toLocalTime().nano();
      if (cmp === 0) {
        cmp = this.toLocalDateTime().compareTo(other.toLocalDateTime());
        if (cmp === 0) {
          cmp = strcmp(this.zone().id(), other.zone().id());
        }
      }
    }
    return cmp;
  };
  _proto.isAfter = function isAfter(other) {
    requireNonNull(other, 'other');
    var thisEpochSec = this.toEpochSecond();
    var otherEpochSec = other.toEpochSecond();
    return thisEpochSec > otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() > other.toLocalTime().nano();
  };
  _proto.isBefore = function isBefore(other) {
    requireNonNull(other, 'other');
    var thisEpochSec = this.toEpochSecond();
    var otherEpochSec = other.toEpochSecond();
    return thisEpochSec < otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() < other.toLocalTime().nano();
  };
  _proto.isEqual = function isEqual(other) {
    requireNonNull(other, 'other');
    return this.toEpochSecond() === other.toEpochSecond() && this.toLocalTime().nano() === other.toLocalTime().nano();
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof ChronoZonedDateTime) {
      return this.compareTo(other) === 0;
    }
    return false;
  };
  return ChronoZonedDateTime;
}(Temporal);
function strcmp(a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

var ZonedDateTime = function (_ChronoZonedDateTime) {
  _inheritsLoose(ZonedDateTime, _ChronoZonedDateTime);
  ZonedDateTime.now = function now(clockOrZone) {
    var clock;
    if (clockOrZone instanceof ZoneId) {
      clock = Clock.system(clockOrZone);
    } else {
      clock = clockOrZone == null ? Clock.systemDefaultZone() : clockOrZone;
    }
    return ZonedDateTime.ofInstant(clock.instant(), clock.zone());
  };
  ZonedDateTime.of = function of() {
    if (arguments.length <= 2) {
      return ZonedDateTime.of2.apply(this, arguments);
    } else if (arguments.length === 3 && arguments[0] instanceof LocalDate) {
      return ZonedDateTime.of3.apply(this, arguments);
    } else {
      return ZonedDateTime.of8.apply(this, arguments);
    }
  };
  ZonedDateTime.of3 = function of3(date, time, zone) {
    return ZonedDateTime.of2(LocalDateTime.of(date, time), zone);
  };
  ZonedDateTime.of2 = function of2(localDateTime, zone) {
    return ZonedDateTime.ofLocal(localDateTime, zone, null);
  };
  ZonedDateTime.of8 = function of8(year, month, dayOfMonth, hour, minute, second, nanoOfSecond, zone) {
    var dt = LocalDateTime.of(year, month, dayOfMonth, hour, minute, second, nanoOfSecond);
    return ZonedDateTime.ofLocal(dt, zone, null);
  };
  ZonedDateTime.ofLocal = function ofLocal(localDateTime, zone, preferredOffset) {
    requireNonNull(localDateTime, 'localDateTime');
    requireNonNull(zone, 'zone');
    if (zone instanceof ZoneOffset) {
      return new ZonedDateTime(localDateTime, zone, zone);
    }
    var offset = null;
    var rules = zone.rules();
    var validOffsets = rules.validOffsets(localDateTime);
    if (validOffsets.length === 1) {
      offset = validOffsets[0];
    } else if (validOffsets.length === 0) {
      var trans = rules.transition(localDateTime);
      localDateTime = localDateTime.plusSeconds(trans.duration().seconds());
      offset = trans.offsetAfter();
    } else {
      if (preferredOffset != null && validOffsets.some(function (validOffset) {
        return validOffset.equals(preferredOffset);
      })) {
        offset = preferredOffset;
      } else {
        offset = requireNonNull(validOffsets[0], 'offset');
      }
    }
    return new ZonedDateTime(localDateTime, offset, zone);
  };
  ZonedDateTime.ofInstant = function ofInstant() {
    if (arguments.length === 2) {
      return ZonedDateTime.ofInstant2.apply(this, arguments);
    } else {
      return ZonedDateTime.ofInstant3.apply(this, arguments);
    }
  };
  ZonedDateTime.ofInstant2 = function ofInstant2(instant, zone) {
    requireNonNull(instant, 'instant');
    requireNonNull(zone, 'zone');
    return ZonedDateTime._create(instant.epochSecond(), instant.nano(), zone);
  };
  ZonedDateTime.ofInstant3 = function ofInstant3(localDateTime, offset, zone) {
    requireNonNull(localDateTime, 'localDateTime');
    requireNonNull(offset, 'offset');
    requireNonNull(zone, 'zone');
    return ZonedDateTime._create(localDateTime.toEpochSecond(offset), localDateTime.nano(), zone);
  };
  ZonedDateTime._create = function _create(epochSecond, nanoOfSecond, zone) {
    var rules = zone.rules();
    var instant = Instant.ofEpochSecond(epochSecond, nanoOfSecond);
    var offset = rules.offset(instant);
    var ldt = LocalDateTime.ofEpochSecond(epochSecond, nanoOfSecond, offset);
    return new ZonedDateTime(ldt, offset, zone);
  };
  ZonedDateTime.ofStrict = function ofStrict(localDateTime, offset, zone) {
    requireNonNull(localDateTime, 'localDateTime');
    requireNonNull(offset, 'offset');
    requireNonNull(zone, 'zone');
    var rules = zone.rules();
    if (rules.isValidOffset(localDateTime, offset) === false) {
      var trans = rules.transition(localDateTime);
      if (trans != null && trans.isGap()) {
        throw new DateTimeException("LocalDateTime " + localDateTime + " does not exist in zone " + zone + " due to a gap in the local time-line, typically caused by daylight savings");
      }
      throw new DateTimeException("ZoneOffset \"" + offset + "\" is not valid for LocalDateTime \"" + localDateTime + "\" in zone \"" + zone + "\"");
    }
    return new ZonedDateTime(localDateTime, offset, zone);
  };
  ZonedDateTime.ofLenient = function ofLenient(localDateTime, offset, zone) {
    requireNonNull(localDateTime, 'localDateTime');
    requireNonNull(offset, 'offset');
    requireNonNull(zone, 'zone');
    if (zone instanceof ZoneOffset && offset.equals(zone) === false) {
      throw new IllegalArgumentException('ZoneId must match ZoneOffset');
    }
    return new ZonedDateTime(localDateTime, offset, zone);
  };
  ZonedDateTime.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    if (temporal instanceof ZonedDateTime) {
      return temporal;
    }
    var zone = ZoneId.from(temporal);
    if (temporal.isSupported(ChronoField.INSTANT_SECONDS)) {
      var zdt = ZonedDateTime._from(temporal, zone);
      if (zdt != null) return zdt;
    }
    var ldt = LocalDateTime.from(temporal);
    return ZonedDateTime.of2(ldt, zone);
  };
  ZonedDateTime._from = function _from(temporal, zone) {
    try {
      return ZonedDateTime.__from(temporal, zone);
    } catch (ex) {
      if (!(ex instanceof DateTimeException)) throw ex;
    }
  };
  ZonedDateTime.__from = function __from(temporal, zone) {
    var epochSecond = temporal.getLong(ChronoField.INSTANT_SECONDS);
    var nanoOfSecond = temporal.get(ChronoField.NANO_OF_SECOND);
    return ZonedDateTime._create(epochSecond, nanoOfSecond, zone);
  };
  ZonedDateTime.parse = function parse(text, formatter) {
    if (formatter === void 0) {
      formatter = DateTimeFormatter.ISO_ZONED_DATE_TIME;
    }
    requireNonNull(formatter, 'formatter');
    return formatter.parse(text, ZonedDateTime.FROM);
  };
  function ZonedDateTime(dateTime, offset, zone) {
    var _this;
    requireNonNull(dateTime, 'dateTime');
    requireNonNull(offset, 'offset');
    requireNonNull(zone, 'zone');
    _this = _ChronoZonedDateTime.call(this) || this;
    _this._dateTime = dateTime;
    _this._offset = offset;
    _this._zone = zone;
    return _this;
  }
  var _proto = ZonedDateTime.prototype;
  _proto._resolveLocal = function _resolveLocal(newDateTime) {
    requireNonNull(newDateTime, 'newDateTime');
    return ZonedDateTime.ofLocal(newDateTime, this._zone, this._offset);
  };
  _proto._resolveInstant = function _resolveInstant(newDateTime) {
    return ZonedDateTime.ofInstant3(newDateTime, this._offset, this._zone);
  };
  _proto._resolveOffset = function _resolveOffset(offset) {
    if (offset.equals(this._offset) === false && this._zone.rules().isValidOffset(this._dateTime, offset)) {
      return new ZonedDateTime(this._dateTime, offset, this._zone);
    }
    return this;
  };
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (fieldOrUnit instanceof ChronoField) {
      return true;
    } else if (fieldOrUnit instanceof ChronoUnit) {
      return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
    }
    return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    if (field instanceof ChronoField) {
      if (field === ChronoField.INSTANT_SECONDS || field === ChronoField.OFFSET_SECONDS) {
        return field.range();
      }
      return this._dateTime.range(field);
    }
    return field.rangeRefinedBy(this);
  };
  _proto.get = function get(field) {
    return this.getLong(field);
  };
  _proto.getLong = function getLong(field) {
    if (field instanceof ChronoField) {
      switch (field) {
        case ChronoField.INSTANT_SECONDS:
          return this.toEpochSecond();
        case ChronoField.OFFSET_SECONDS:
          return this._offset.totalSeconds();
      }
      return this._dateTime.getLong(field);
    }
    requireNonNull(field, 'field');
    return field.getFrom(this);
  };
  _proto.offset = function offset() {
    return this._offset;
  };
  _proto.withEarlierOffsetAtOverlap = function withEarlierOffsetAtOverlap() {
    var trans = this._zone.rules().transition(this._dateTime);
    if (trans != null && trans.isOverlap()) {
      var earlierOffset = trans.offsetBefore();
      if (earlierOffset.equals(this._offset) === false) {
        return new ZonedDateTime(this._dateTime, earlierOffset, this._zone);
      }
    }
    return this;
  };
  _proto.withLaterOffsetAtOverlap = function withLaterOffsetAtOverlap() {
    var trans = this._zone.rules().transition(this.toLocalDateTime());
    if (trans != null) {
      var laterOffset = trans.offsetAfter();
      if (laterOffset.equals(this._offset) === false) {
        return new ZonedDateTime(this._dateTime, laterOffset, this._zone);
      }
    }
    return this;
  };
  _proto.zone = function zone() {
    return this._zone;
  };
  _proto.withZoneSameLocal = function withZoneSameLocal(zone) {
    requireNonNull(zone, 'zone');
    return this._zone.equals(zone) ? this : ZonedDateTime.ofLocal(this._dateTime, zone, this._offset);
  };
  _proto.withZoneSameInstant = function withZoneSameInstant(zone) {
    requireNonNull(zone, 'zone');
    return this._zone.equals(zone) ? this : ZonedDateTime._create(this._dateTime.toEpochSecond(this._offset), this._dateTime.nano(), zone);
  };
  _proto.withFixedOffsetZone = function withFixedOffsetZone() {
    return this._zone.equals(this._offset) ? this : new ZonedDateTime(this._dateTime, this._offset, this._offset);
  };
  _proto.year = function year() {
    return this._dateTime.year();
  };
  _proto.monthValue = function monthValue() {
    return this._dateTime.monthValue();
  };
  _proto.month = function month() {
    return this._dateTime.month();
  };
  _proto.dayOfMonth = function dayOfMonth() {
    return this._dateTime.dayOfMonth();
  };
  _proto.dayOfYear = function dayOfYear() {
    return this._dateTime.dayOfYear();
  };
  _proto.dayOfWeek = function dayOfWeek() {
    return this._dateTime.dayOfWeek();
  };
  _proto.hour = function hour() {
    return this._dateTime.hour();
  };
  _proto.minute = function minute() {
    return this._dateTime.minute();
  };
  _proto.second = function second() {
    return this._dateTime.second();
  };
  _proto.nano = function nano() {
    return this._dateTime.nano();
  };
  _proto._withAdjuster = function _withAdjuster(adjuster) {
    if (adjuster instanceof LocalDate) {
      return this._resolveLocal(LocalDateTime.of(adjuster, this._dateTime.toLocalTime()));
    } else if (adjuster instanceof LocalTime) {
      return this._resolveLocal(LocalDateTime.of(this._dateTime.toLocalDate(), adjuster));
    } else if (adjuster instanceof LocalDateTime) {
      return this._resolveLocal(adjuster);
    } else if (adjuster instanceof Instant) {
      var instant = adjuster;
      return ZonedDateTime._create(instant.epochSecond(), instant.nano(), this._zone);
    } else if (adjuster instanceof ZoneOffset) {
      return this._resolveOffset(adjuster);
    }
    return _ChronoZonedDateTime.prototype._withAdjuster.call(this, adjuster);
  };
  _proto._withField = function _withField(field, newValue) {
    if (field instanceof ChronoField) {
      switch (field) {
        case ChronoField.INSTANT_SECONDS:
          return ZonedDateTime._create(newValue, this.nano(), this._zone);
        case ChronoField.OFFSET_SECONDS:
          {
            var offset = ZoneOffset.ofTotalSeconds(field.checkValidIntValue(newValue));
            return this._resolveOffset(offset);
          }
      }
      return this._resolveLocal(this._dateTime.with(field, newValue));
    }
    return field.adjustInto(this, newValue);
  };
  _proto.withYear = function withYear(year) {
    return this._resolveLocal(this._dateTime.withYear(year));
  };
  _proto.withMonth = function withMonth(month) {
    return this._resolveLocal(this._dateTime.withMonth(month));
  };
  _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
    return this._resolveLocal(this._dateTime.withDayOfMonth(dayOfMonth));
  };
  _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
    return this._resolveLocal(this._dateTime.withDayOfYear(dayOfYear));
  };
  _proto.withHour = function withHour(hour) {
    return this._resolveLocal(this._dateTime.withHour(hour));
  };
  _proto.withMinute = function withMinute(minute) {
    return this._resolveLocal(this._dateTime.withMinute(minute));
  };
  _proto.withSecond = function withSecond(second) {
    return this._resolveLocal(this._dateTime.withSecond(second));
  };
  _proto.withNano = function withNano(nanoOfSecond) {
    return this._resolveLocal(this._dateTime.withNano(nanoOfSecond));
  };
  _proto.truncatedTo = function truncatedTo(unit) {
    return this._resolveLocal(this._dateTime.truncatedTo(unit));
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    if (unit instanceof ChronoUnit) {
      if (unit.isDateBased()) {
        return this._resolveLocal(this._dateTime.plus(amountToAdd, unit));
      } else {
        return this._resolveInstant(this._dateTime.plus(amountToAdd, unit));
      }
    }
    requireNonNull(unit, 'unit');
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusYears = function plusYears(years) {
    return this._resolveLocal(this._dateTime.plusYears(years));
  };
  _proto.plusMonths = function plusMonths(months) {
    return this._resolveLocal(this._dateTime.plusMonths(months));
  };
  _proto.plusWeeks = function plusWeeks(weeks) {
    return this._resolveLocal(this._dateTime.plusWeeks(weeks));
  };
  _proto.plusDays = function plusDays(days) {
    return this._resolveLocal(this._dateTime.plusDays(days));
  };
  _proto.plusHours = function plusHours(hours) {
    return this._resolveInstant(this._dateTime.plusHours(hours));
  };
  _proto.plusMinutes = function plusMinutes(minutes) {
    return this._resolveInstant(this._dateTime.plusMinutes(minutes));
  };
  _proto.plusSeconds = function plusSeconds(seconds) {
    return this._resolveInstant(this._dateTime.plusSeconds(seconds));
  };
  _proto.plusNanos = function plusNanos(nanos) {
    return this._resolveInstant(this._dateTime.plusNanos(nanos));
  };
  _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
    return this._plusUnit(-1 * amountToSubtract, unit);
  };
  _proto.minusYears = function minusYears(years) {
    return this.plusYears(-1 * years);
  };
  _proto.minusMonths = function minusMonths(months) {
    return this.plusMonths(-1 * months);
  };
  _proto.minusWeeks = function minusWeeks(weeks) {
    return this.plusWeeks(-1 * weeks);
  };
  _proto.minusDays = function minusDays(days) {
    return this.plusDays(-1 * days);
  };
  _proto.minusHours = function minusHours(hours) {
    return this.plusHours(-1 * hours);
  };
  _proto.minusMinutes = function minusMinutes(minutes) {
    return this.plusMinutes(-1 * minutes);
  };
  _proto.minusSeconds = function minusSeconds(seconds) {
    return this.plusSeconds(-1 * seconds);
  };
  _proto.minusNanos = function minusNanos(nanos) {
    return this.plusNanos(-1 * nanos);
  };
  _proto.query = function query(_query) {
    if (_query === TemporalQueries.localDate()) {
      return this.toLocalDate();
    }
    requireNonNull(_query, 'query');
    return _ChronoZonedDateTime.prototype.query.call(this, _query);
  };
  _proto.until = function until(endExclusive, unit) {
    var end = ZonedDateTime.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      end = end.withZoneSameInstant(this._zone);
      if (unit.isDateBased()) {
        return this._dateTime.until(end._dateTime, unit);
      } else {
        var difference = this._offset.totalSeconds() - end._offset.totalSeconds();
        var adjustedEnd = end._dateTime.plusSeconds(difference);
        return this._dateTime.until(adjustedEnd, unit);
      }
    }
    return unit.between(this, end);
  };
  _proto.toLocalDateTime = function toLocalDateTime() {
    return this._dateTime;
  };
  _proto.toLocalDate = function toLocalDate() {
    return this._dateTime.toLocalDate();
  };
  _proto.toLocalTime = function toLocalTime() {
    return this._dateTime.toLocalTime();
  };
  _proto.toOffsetDateTime = function toOffsetDateTime() {
    return OffsetDateTime.of(this._dateTime, this._offset);
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof ZonedDateTime) {
      return this._dateTime.equals(other._dateTime) && this._offset.equals(other._offset) && this._zone.equals(other._zone);
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return MathUtil.hashCode(this._dateTime.hashCode(), this._offset.hashCode(), this._zone.hashCode());
  };
  _proto.toString = function toString() {
    var str = this._dateTime.toString() + this._offset.toString();
    if (this._offset !== this._zone) {
      str += "[" + this._zone.toString() + "]";
    }
    return str;
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.format = function format(formatter) {
    return _ChronoZonedDateTime.prototype.format.call(this, formatter);
  };
  return ZonedDateTime;
}(ChronoZonedDateTime);
function _init$7() {
  ZonedDateTime.FROM = createTemporalQuery('ZonedDateTime.FROM', function (temporal) {
    return ZonedDateTime.from(temporal);
  });
}

var OffsetDateTime = function (_Temporal) {
  _inheritsLoose(OffsetDateTime, _Temporal);
  OffsetDateTime.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    if (temporal instanceof OffsetDateTime) {
      return temporal;
    }
    try {
      var offset = ZoneOffset.from(temporal);
      try {
        var ldt = LocalDateTime.from(temporal);
        return OffsetDateTime.of(ldt, offset);
      } catch (_) {
        var instant = Instant.from(temporal);
        return OffsetDateTime.ofInstant(instant, offset);
      }
    } catch (ex) {
      throw new DateTimeException("Unable to obtain OffsetDateTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
    }
  };
  OffsetDateTime.now = function now(clockOrZone) {
    if (arguments.length === 0) {
      return OffsetDateTime.now(Clock.systemDefaultZone());
    } else {
      requireNonNull(clockOrZone, 'clockOrZone');
      if (clockOrZone instanceof ZoneId) {
        return OffsetDateTime.now(Clock.system(clockOrZone));
      } else if (clockOrZone instanceof Clock) {
        var now = clockOrZone.instant();
        return OffsetDateTime.ofInstant(now, clockOrZone.zone().rules().offset(now));
      } else {
        throw new IllegalArgumentException('clockOrZone must be an instance of ZoneId or Clock');
      }
    }
  };
  OffsetDateTime.of = function of() {
    if (arguments.length <= 2) {
      return OffsetDateTime.ofDateTime.apply(this, arguments);
    } else if (arguments.length === 3) {
      return OffsetDateTime.ofDateAndTime.apply(this, arguments);
    } else {
      return OffsetDateTime.ofNumbers.apply(this, arguments);
    }
  };
  OffsetDateTime.ofDateTime = function ofDateTime(dateTime, offset) {
    return new OffsetDateTime(dateTime, offset);
  };
  OffsetDateTime.ofDateAndTime = function ofDateAndTime(date, time, offset) {
    var dt = LocalDateTime.of(date, time);
    return new OffsetDateTime(dt, offset);
  };
  OffsetDateTime.ofNumbers = function ofNumbers(year, month, dayOfMonth, hour, minute, second, nanoOfSecond, offset) {
    if (hour === void 0) {
      hour = 0;
    }
    if (minute === void 0) {
      minute = 0;
    }
    if (second === void 0) {
      second = 0;
    }
    if (nanoOfSecond === void 0) {
      nanoOfSecond = 0;
    }
    var dt = LocalDateTime.of(year, month, dayOfMonth, hour, minute, second, nanoOfSecond);
    return new OffsetDateTime(dt, offset);
  };
  OffsetDateTime.ofInstant = function ofInstant(instant, zone) {
    requireNonNull(instant, 'instant');
    requireNonNull(zone, 'zone');
    var rules = zone.rules();
    var offset = rules.offset(instant);
    var ldt = LocalDateTime.ofEpochSecond(instant.epochSecond(), instant.nano(), offset);
    return new OffsetDateTime(ldt, offset);
  };
  OffsetDateTime.parse = function parse(text, formatter) {
    if (formatter === void 0) {
      formatter = DateTimeFormatter.ISO_OFFSET_DATE_TIME;
    }
    requireNonNull(formatter, 'formatter');
    return formatter.parse(text, OffsetDateTime.FROM);
  };
  function OffsetDateTime(dateTime, offset) {
    var _this;
    _this = _Temporal.call(this) || this;
    requireNonNull(dateTime, 'dateTime');
    requireInstance(dateTime, LocalDateTime, 'dateTime');
    requireNonNull(offset, 'offset');
    requireInstance(offset, ZoneOffset, 'offset');
    _this._dateTime = dateTime;
    _this._offset = offset;
    return _this;
  }
  var _proto = OffsetDateTime.prototype;
  _proto.adjustInto = function adjustInto(temporal) {
    return temporal.with(ChronoField.EPOCH_DAY, this.toLocalDate().toEpochDay()).with(ChronoField.NANO_OF_DAY, this.toLocalTime().toNanoOfDay()).with(ChronoField.OFFSET_SECONDS, this.offset().totalSeconds());
  };
  _proto.until = function until(endExclusive, unit) {
    var end = OffsetDateTime.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      end = end.withOffsetSameInstant(this._offset);
      return this._dateTime.until(end._dateTime, unit);
    }
    return unit.between(this, end);
  };
  _proto.atZoneSameInstant = function atZoneSameInstant(zone) {
    return ZonedDateTime.ofInstant(this._dateTime, this._offset, zone);
  };
  _proto.atZoneSimilarLocal = function atZoneSimilarLocal(zone) {
    return ZonedDateTime.ofLocal(this._dateTime, zone, this._offset);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    if (_query === TemporalQueries.chronology()) {
      return IsoChronology.INSTANCE;
    } else if (_query === TemporalQueries.precision()) {
      return ChronoUnit.NANOS;
    } else if (_query === TemporalQueries.offset() || _query === TemporalQueries.zone()) {
      return this.offset();
    } else if (_query === TemporalQueries.localDate()) {
      return this.toLocalDate();
    } else if (_query === TemporalQueries.localTime()) {
      return this.toLocalTime();
    } else if (_query === TemporalQueries.zoneId()) {
      return null;
    }
    return _Temporal.prototype.query.call(this, _query);
  };
  _proto.get = function get(field) {
    if (field instanceof ChronoField) {
      switch (field) {
        case ChronoField.INSTANT_SECONDS:
          throw new DateTimeException("Field too large for an int: " + field);
        case ChronoField.OFFSET_SECONDS:
          return this.offset().totalSeconds();
      }
      return this._dateTime.get(field);
    }
    return _Temporal.prototype.get.call(this, field);
  };
  _proto.getLong = function getLong(field) {
    if (field instanceof ChronoField) {
      switch (field) {
        case ChronoField.INSTANT_SECONDS:
          return this.toEpochSecond();
        case ChronoField.OFFSET_SECONDS:
          return this.offset().totalSeconds();
      }
      return this._dateTime.getLong(field);
    }
    return field.getFrom(this);
  };
  _proto.offset = function offset() {
    return this._offset;
  };
  _proto.year = function year() {
    return this._dateTime.year();
  };
  _proto.monthValue = function monthValue() {
    return this._dateTime.monthValue();
  };
  _proto.month = function month() {
    return this._dateTime.month();
  };
  _proto.dayOfMonth = function dayOfMonth() {
    return this._dateTime.dayOfMonth();
  };
  _proto.dayOfYear = function dayOfYear() {
    return this._dateTime.dayOfYear();
  };
  _proto.dayOfWeek = function dayOfWeek() {
    return this._dateTime.dayOfWeek();
  };
  _proto.hour = function hour() {
    return this._dateTime.hour();
  };
  _proto.minute = function minute() {
    return this._dateTime.minute();
  };
  _proto.second = function second() {
    return this._dateTime.second();
  };
  _proto.nano = function nano() {
    return this._dateTime.nano();
  };
  _proto.toLocalDateTime = function toLocalDateTime() {
    return this._dateTime;
  };
  _proto.toLocalDate = function toLocalDate() {
    return this._dateTime.toLocalDate();
  };
  _proto.toLocalTime = function toLocalTime() {
    return this._dateTime.toLocalTime();
  };
  _proto.toOffsetTime = function toOffsetTime() {
    return OffsetTime.of(this._dateTime.toLocalTime(), this._offset);
  };
  _proto.toZonedDateTime = function toZonedDateTime() {
    return ZonedDateTime.of(this._dateTime, this._offset);
  };
  _proto.toInstant = function toInstant() {
    return this._dateTime.toInstant(this._offset);
  };
  _proto.toEpochSecond = function toEpochSecond() {
    return this._dateTime.toEpochSecond(this._offset);
  };
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (fieldOrUnit instanceof ChronoField) {
      return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
    }
    if (fieldOrUnit instanceof ChronoUnit) {
      return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
    }
    return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    if (field instanceof ChronoField) {
      if (field === ChronoField.INSTANT_SECONDS || field === ChronoField.OFFSET_SECONDS) {
        return field.range();
      }
      return this._dateTime.range(field);
    }
    return field.rangeRefinedBy(this);
  };
  _proto._withAdjuster = function _withAdjuster(adjuster) {
    requireNonNull(adjuster);
    if (adjuster instanceof LocalDate || adjuster instanceof LocalTime || adjuster instanceof LocalDateTime) {
      return this._withDateTimeOffset(this._dateTime.with(adjuster), this._offset);
    } else if (adjuster instanceof Instant) {
      return OffsetDateTime.ofInstant(adjuster, this._offset);
    } else if (adjuster instanceof ZoneOffset) {
      return this._withDateTimeOffset(this._dateTime, adjuster);
    } else if (adjuster instanceof OffsetDateTime) {
      return adjuster;
    }
    return adjuster.adjustInto(this);
  };
  _proto._withField = function _withField(field, newValue) {
    requireNonNull(field);
    if (field instanceof ChronoField) {
      var f = field;
      switch (f) {
        case ChronoField.INSTANT_SECONDS:
          return OffsetDateTime.ofInstant(Instant.ofEpochSecond(newValue, this.nano()), this._offset);
        case ChronoField.OFFSET_SECONDS:
          {
            return this._withDateTimeOffset(this._dateTime, ZoneOffset.ofTotalSeconds(f.checkValidIntValue(newValue)));
          }
      }
      return this._withDateTimeOffset(this._dateTime.with(field, newValue), this._offset);
    }
    return field.adjustInto(this, newValue);
  };
  _proto._withDateTimeOffset = function _withDateTimeOffset(dateTime, offset) {
    if (this._dateTime === dateTime && this._offset.equals(offset)) {
      return this;
    }
    return new OffsetDateTime(dateTime, offset);
  };
  _proto.withYear = function withYear(year) {
    return this._withDateTimeOffset(this._dateTime.withYear(year), this._offset);
  };
  _proto.withMonth = function withMonth(month) {
    return this._withDateTimeOffset(this._dateTime.withMonth(month), this._offset);
  };
  _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
    return this._withDateTimeOffset(this._dateTime.withDayOfMonth(dayOfMonth), this._offset);
  };
  _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
    return this._withDateTimeOffset(this._dateTime.withDayOfYear(dayOfYear), this._offset);
  };
  _proto.withHour = function withHour(hour) {
    return this._withDateTimeOffset(this._dateTime.withHour(hour), this._offset);
  };
  _proto.withMinute = function withMinute(minute) {
    return this._withDateTimeOffset(this._dateTime.withMinute(minute), this._offset);
  };
  _proto.withSecond = function withSecond(second) {
    return this._withDateTimeOffset(this._dateTime.withSecond(second), this._offset);
  };
  _proto.withNano = function withNano(nanoOfSecond) {
    return this._withDateTimeOffset(this._dateTime.withNano(nanoOfSecond), this._offset);
  };
  _proto.withOffsetSameLocal = function withOffsetSameLocal(offset) {
    requireNonNull(offset, 'offset');
    return this._withDateTimeOffset(this._dateTime, offset);
  };
  _proto.withOffsetSameInstant = function withOffsetSameInstant(offset) {
    requireNonNull(offset, 'offset');
    if (offset.equals(this._offset)) {
      return this;
    }
    var difference = offset.totalSeconds() - this._offset.totalSeconds();
    var adjusted = this._dateTime.plusSeconds(difference);
    return new OffsetDateTime(adjusted, offset);
  };
  _proto.truncatedTo = function truncatedTo(unit) {
    return this._withDateTimeOffset(this._dateTime.truncatedTo(unit), this._offset);
  };
  _proto._plusAmount = function _plusAmount(amount) {
    requireNonNull(amount, 'amount');
    return amount.addTo(this);
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    if (unit instanceof ChronoUnit) {
      return this._withDateTimeOffset(this._dateTime.plus(amountToAdd, unit), this._offset);
    }
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusYears = function plusYears(years) {
    return this._withDateTimeOffset(this._dateTime.plusYears(years), this._offset);
  };
  _proto.plusMonths = function plusMonths(months) {
    return this._withDateTimeOffset(this._dateTime.plusMonths(months), this._offset);
  };
  _proto.plusWeeks = function plusWeeks(weeks) {
    return this._withDateTimeOffset(this._dateTime.plusWeeks(weeks), this._offset);
  };
  _proto.plusDays = function plusDays(days) {
    return this._withDateTimeOffset(this._dateTime.plusDays(days), this._offset);
  };
  _proto.plusHours = function plusHours(hours) {
    return this._withDateTimeOffset(this._dateTime.plusHours(hours), this._offset);
  };
  _proto.plusMinutes = function plusMinutes(minutes) {
    return this._withDateTimeOffset(this._dateTime.plusMinutes(minutes), this._offset);
  };
  _proto.plusSeconds = function plusSeconds(seconds) {
    return this._withDateTimeOffset(this._dateTime.plusSeconds(seconds), this._offset);
  };
  _proto.plusNanos = function plusNanos(nanos) {
    return this._withDateTimeOffset(this._dateTime.plusNanos(nanos), this._offset);
  };
  _proto._minusAmount = function _minusAmount(amount) {
    requireNonNull(amount);
    return amount.subtractFrom(this);
  };
  _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
    return this.plus(-1 * amountToSubtract, unit);
  };
  _proto.minusYears = function minusYears(years) {
    return this._withDateTimeOffset(this._dateTime.minusYears(years), this._offset);
  };
  _proto.minusMonths = function minusMonths(months) {
    return this._withDateTimeOffset(this._dateTime.minusMonths(months), this._offset);
  };
  _proto.minusWeeks = function minusWeeks(weeks) {
    return this._withDateTimeOffset(this._dateTime.minusWeeks(weeks), this._offset);
  };
  _proto.minusDays = function minusDays(days) {
    return this._withDateTimeOffset(this._dateTime.minusDays(days), this._offset);
  };
  _proto.minusHours = function minusHours(hours) {
    return this._withDateTimeOffset(this._dateTime.minusHours(hours), this._offset);
  };
  _proto.minusMinutes = function minusMinutes(minutes) {
    return this._withDateTimeOffset(this._dateTime.minusMinutes(minutes), this._offset);
  };
  _proto.minusSeconds = function minusSeconds(seconds) {
    return this._withDateTimeOffset(this._dateTime.minusSeconds(seconds), this._offset);
  };
  _proto.minusNanos = function minusNanos(nanos) {
    return this._withDateTimeOffset(this._dateTime.minusNanos(nanos), this._offset);
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, OffsetDateTime, 'other');
    if (this.offset().equals(other.offset())) {
      return this.toLocalDateTime().compareTo(other.toLocalDateTime());
    }
    var cmp = MathUtil.compareNumbers(this.toEpochSecond(), other.toEpochSecond());
    if (cmp === 0) {
      cmp = this.toLocalTime().nano() - other.toLocalTime().nano();
      if (cmp === 0) {
        cmp = this.toLocalDateTime().compareTo(other.toLocalDateTime());
      }
    }
    return cmp;
  };
  _proto.isAfter = function isAfter(other) {
    requireNonNull(other, 'other');
    var thisEpochSec = this.toEpochSecond();
    var otherEpochSec = other.toEpochSecond();
    return thisEpochSec > otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() > other.toLocalTime().nano();
  };
  _proto.isBefore = function isBefore(other) {
    requireNonNull(other, 'other');
    var thisEpochSec = this.toEpochSecond();
    var otherEpochSec = other.toEpochSecond();
    return thisEpochSec < otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() < other.toLocalTime().nano();
  };
  _proto.isEqual = function isEqual(other) {
    requireNonNull(other, 'other');
    return this.toEpochSecond() === other.toEpochSecond() && this.toLocalTime().nano() === other.toLocalTime().nano();
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof OffsetDateTime) {
      return this._dateTime.equals(other._dateTime) && this._offset.equals(other._offset);
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return this._dateTime.hashCode() ^ this._offset.hashCode();
  };
  _proto.toString = function toString() {
    return this._dateTime.toString() + this._offset.toString();
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    return formatter.format(this);
  };
  return OffsetDateTime;
}(Temporal);
function _init$6() {
  OffsetDateTime.MIN = LocalDateTime.MIN.atOffset(ZoneOffset.MAX);
  OffsetDateTime.MAX = LocalDateTime.MAX.atOffset(ZoneOffset.MIN);
  OffsetDateTime.FROM = createTemporalQuery('OffsetDateTime.FROM', function (temporal) {
    return OffsetDateTime.from(temporal);
  });
}

var DAYS_PER_CYCLE = 146097;
var DAYS_0000_TO_1970 = DAYS_PER_CYCLE * 5 - (30 * 365 + 7);
var LocalDate = function (_ChronoLocalDate) {
  _inheritsLoose(LocalDate, _ChronoLocalDate);
  LocalDate.now = function now(clockOrZone) {
    var clock;
    if (clockOrZone == null) {
      clock = Clock.systemDefaultZone();
    } else if (clockOrZone instanceof ZoneId) {
      clock = Clock.system(clockOrZone);
    } else {
      clock = clockOrZone;
    }
    return LocalDate.ofInstant(clock.instant(), clock.zone());
  };
  LocalDate.ofInstant = function ofInstant(instant, zone) {
    if (zone === void 0) {
      zone = ZoneId.systemDefault();
    }
    requireNonNull(instant, 'instant');
    var offset = zone.rules().offset(instant);
    var epochSec = instant.epochSecond() + offset.totalSeconds();
    var epochDay = MathUtil.floorDiv(epochSec, LocalTime.SECONDS_PER_DAY);
    return LocalDate.ofEpochDay(epochDay);
  };
  LocalDate.of = function of(year, month, dayOfMonth) {
    return new LocalDate(year, month, dayOfMonth);
  };
  LocalDate.ofYearDay = function ofYearDay(year, dayOfYear) {
    ChronoField.YEAR.checkValidValue(year);
    var leap = IsoChronology.isLeapYear(year);
    if (dayOfYear === 366 && leap === false) {
      assert(false, "Invalid date 'DayOfYear 366' as '" + year + "' is not a leap year", DateTimeException);
    }
    var moy = Month.of(Math.floor((dayOfYear - 1) / 31 + 1));
    var monthEnd = moy.firstDayOfYear(leap) + moy.length(leap) - 1;
    if (dayOfYear > monthEnd) {
      moy = moy.plus(1);
    }
    var dom = dayOfYear - moy.firstDayOfYear(leap) + 1;
    return new LocalDate(year, moy.value(), dom);
  };
  LocalDate.ofEpochDay = function ofEpochDay(epochDay) {
    if (epochDay === void 0) {
      epochDay = 0;
    }
    var adjust, adjustCycles, doyEst, yearEst, zeroDay;
    zeroDay = epochDay + DAYS_0000_TO_1970;
    zeroDay -= 60;
    adjust = 0;
    if (zeroDay < 0) {
      adjustCycles = MathUtil.intDiv(zeroDay + 1, DAYS_PER_CYCLE) - 1;
      adjust = adjustCycles * 400;
      zeroDay += -adjustCycles * DAYS_PER_CYCLE;
    }
    yearEst = MathUtil.intDiv(400 * zeroDay + 591, DAYS_PER_CYCLE);
    doyEst = zeroDay - (365 * yearEst + MathUtil.intDiv(yearEst, 4) - MathUtil.intDiv(yearEst, 100) + MathUtil.intDiv(yearEst, 400));
    if (doyEst < 0) {
      yearEst--;
      doyEst = zeroDay - (365 * yearEst + MathUtil.intDiv(yearEst, 4) - MathUtil.intDiv(yearEst, 100) + MathUtil.intDiv(yearEst, 400));
    }
    yearEst += adjust;
    var marchDoy0 = doyEst;
    var marchMonth0 = MathUtil.intDiv(marchDoy0 * 5 + 2, 153);
    var month = (marchMonth0 + 2) % 12 + 1;
    var dom = marchDoy0 - MathUtil.intDiv(marchMonth0 * 306 + 5, 10) + 1;
    yearEst += MathUtil.intDiv(marchMonth0, 10);
    var year = yearEst;
    return new LocalDate(year, month, dom);
  };
  LocalDate.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    var date = temporal.query(TemporalQueries.localDate());
    if (date == null) {
      throw new DateTimeException("Unable to obtain LocalDate from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
    }
    return date;
  };
  LocalDate.parse = function parse(text, formatter) {
    if (formatter === void 0) {
      formatter = DateTimeFormatter.ISO_LOCAL_DATE;
    }
    assert(formatter != null, 'formatter', NullPointerException);
    return formatter.parse(text, LocalDate.FROM);
  };
  LocalDate._resolvePreviousValid = function _resolvePreviousValid(year, month, day) {
    switch (month) {
      case 2:
        day = Math.min(day, IsoChronology.isLeapYear(year) ? 29 : 28);
        break;
      case 4:
      case 6:
      case 9:
      case 11:
        day = Math.min(day, 30);
        break;
    }
    return LocalDate.of(year, month, day);
  };
  function LocalDate(year, month, dayOfMonth) {
    var _this;
    _this = _ChronoLocalDate.call(this) || this;
    requireNonNull(year, 'year');
    requireNonNull(month, 'month');
    requireNonNull(dayOfMonth, 'dayOfMonth');
    if (month instanceof Month) {
      month = month.value();
    }
    _this._year = MathUtil.safeToInt(year);
    _this._month = MathUtil.safeToInt(month);
    _this._day = MathUtil.safeToInt(dayOfMonth);
    LocalDate._validate(_this._year, _this._month, _this._day);
    return _this;
  }
  LocalDate._validate = function _validate(year, month, dayOfMonth) {
    var dom;
    ChronoField.YEAR.checkValidValue(year);
    ChronoField.MONTH_OF_YEAR.checkValidValue(month);
    ChronoField.DAY_OF_MONTH.checkValidValue(dayOfMonth);
    if (dayOfMonth > 28) {
      dom = 31;
      switch (month) {
        case 2:
          dom = IsoChronology.isLeapYear(year) ? 29 : 28;
          break;
        case 4:
        case 6:
        case 9:
        case 11:
          dom = 30;
      }
      if (dayOfMonth > dom) {
        if (dayOfMonth === 29) {
          assert(false, "Invalid date 'February 29' as '" + year + "' is not a leap year", DateTimeException);
        } else {
          assert(false, "Invalid date '" + year + "' '" + month + "' '" + dayOfMonth + "'", DateTimeException);
        }
      }
    }
  };
  var _proto = LocalDate.prototype;
  _proto.isSupported = function isSupported(field) {
    return _ChronoLocalDate.prototype.isSupported.call(this, field);
  };
  _proto.range = function range(field) {
    if (field instanceof ChronoField) {
      if (field.isDateBased()) {
        switch (field) {
          case ChronoField.DAY_OF_MONTH:
            return ValueRange.of(1, this.lengthOfMonth());
          case ChronoField.DAY_OF_YEAR:
            return ValueRange.of(1, this.lengthOfYear());
          case ChronoField.ALIGNED_WEEK_OF_MONTH:
            return ValueRange.of(1, this.month() === Month.FEBRUARY && this.isLeapYear() === false ? 4 : 5);
          case ChronoField.YEAR_OF_ERA:
            return this._year <= 0 ? ValueRange.of(1, Year.MAX_VALUE + 1) : ValueRange.of(1, Year.MAX_VALUE);
        }
        return field.range();
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.rangeRefinedBy(this);
  };
  _proto.get = function get(field) {
    return this.getLong(field);
  };
  _proto.getLong = function getLong(field) {
    assert(field != null, '', NullPointerException);
    if (field instanceof ChronoField) {
      return this._get0(field);
    }
    return field.getFrom(this);
  };
  _proto._get0 = function _get0(field) {
    switch (field) {
      case ChronoField.DAY_OF_WEEK:
        return this.dayOfWeek().value();
      case ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH:
        return MathUtil.intMod(this._day - 1, 7) + 1;
      case ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR:
        return MathUtil.intMod(this.dayOfYear() - 1, 7) + 1;
      case ChronoField.DAY_OF_MONTH:
        return this._day;
      case ChronoField.DAY_OF_YEAR:
        return this.dayOfYear();
      case ChronoField.EPOCH_DAY:
        return this.toEpochDay();
      case ChronoField.ALIGNED_WEEK_OF_MONTH:
        return MathUtil.intDiv(this._day - 1, 7) + 1;
      case ChronoField.ALIGNED_WEEK_OF_YEAR:
        return MathUtil.intDiv(this.dayOfYear() - 1, 7) + 1;
      case ChronoField.MONTH_OF_YEAR:
        return this._month;
      case ChronoField.PROLEPTIC_MONTH:
        return this._prolepticMonth();
      case ChronoField.YEAR_OF_ERA:
        return this._year >= 1 ? this._year : 1 - this._year;
      case ChronoField.YEAR:
        return this._year;
      case ChronoField.ERA:
        return this._year >= 1 ? 1 : 0;
    }
    throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
  };
  _proto._prolepticMonth = function _prolepticMonth() {
    return this._year * 12 + (this._month - 1);
  };
  _proto.chronology = function chronology() {
    return IsoChronology.INSTANCE;
  };
  _proto.year = function year() {
    return this._year;
  };
  _proto.monthValue = function monthValue() {
    return this._month;
  };
  _proto.month = function month() {
    return Month.of(this._month);
  };
  _proto.dayOfMonth = function dayOfMonth() {
    return this._day;
  };
  _proto.dayOfYear = function dayOfYear() {
    return this.month().firstDayOfYear(this.isLeapYear()) + this._day - 1;
  };
  _proto.dayOfWeek = function dayOfWeek() {
    var dow0 = MathUtil.floorMod(this.toEpochDay() + 3, 7);
    return DayOfWeek.of(dow0 + 1);
  };
  _proto.isLeapYear = function isLeapYear() {
    return IsoChronology.isLeapYear(this._year);
  };
  _proto.lengthOfMonth = function lengthOfMonth() {
    switch (this._month) {
      case 2:
        return this.isLeapYear() ? 29 : 28;
      case 4:
      case 6:
      case 9:
      case 11:
        return 30;
      default:
        return 31;
    }
  };
  _proto.lengthOfYear = function lengthOfYear() {
    return this.isLeapYear() ? 366 : 365;
  };
  _proto._withAdjuster = function _withAdjuster(adjuster) {
    requireNonNull(adjuster, 'adjuster');
    if (adjuster instanceof LocalDate) {
      return adjuster;
    }
    return _ChronoLocalDate.prototype._withAdjuster.call(this, adjuster);
  };
  _proto._withField = function _withField(field, newValue) {
    assert(field != null, 'field', NullPointerException);
    if (field instanceof ChronoField) {
      var f = field;
      f.checkValidValue(newValue);
      switch (f) {
        case ChronoField.DAY_OF_WEEK:
          return this.plusDays(newValue - this.dayOfWeek().value());
        case ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH:
          return this.plusDays(newValue - this.getLong(ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH));
        case ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR:
          return this.plusDays(newValue - this.getLong(ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR));
        case ChronoField.DAY_OF_MONTH:
          return this.withDayOfMonth(newValue);
        case ChronoField.DAY_OF_YEAR:
          return this.withDayOfYear(newValue);
        case ChronoField.EPOCH_DAY:
          return LocalDate.ofEpochDay(newValue);
        case ChronoField.ALIGNED_WEEK_OF_MONTH:
          return this.plusWeeks(newValue - this.getLong(ChronoField.ALIGNED_WEEK_OF_MONTH));
        case ChronoField.ALIGNED_WEEK_OF_YEAR:
          return this.plusWeeks(newValue - this.getLong(ChronoField.ALIGNED_WEEK_OF_YEAR));
        case ChronoField.MONTH_OF_YEAR:
          return this.withMonth(newValue);
        case ChronoField.PROLEPTIC_MONTH:
          return this.plusMonths(newValue - this.getLong(ChronoField.PROLEPTIC_MONTH));
        case ChronoField.YEAR_OF_ERA:
          return this.withYear(this._year >= 1 ? newValue : 1 - newValue);
        case ChronoField.YEAR:
          return this.withYear(newValue);
        case ChronoField.ERA:
          return this.getLong(ChronoField.ERA) === newValue ? this : this.withYear(1 - this._year);
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.adjustInto(this, newValue);
  };
  _proto.withYear = function withYear(year) {
    if (this._year === year) {
      return this;
    }
    ChronoField.YEAR.checkValidValue(year);
    return LocalDate._resolvePreviousValid(year, this._month, this._day);
  };
  _proto.withMonth = function withMonth(month) {
    var m = month instanceof Month ? month.value() : month;
    if (this._month === m) {
      return this;
    }
    ChronoField.MONTH_OF_YEAR.checkValidValue(m);
    return LocalDate._resolvePreviousValid(this._year, m, this._day);
  };
  _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
    if (this._day === dayOfMonth) {
      return this;
    }
    return LocalDate.of(this._year, this._month, dayOfMonth);
  };
  _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
    if (this.dayOfYear() === dayOfYear) {
      return this;
    }
    return LocalDate.ofYearDay(this._year, dayOfYear);
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    requireNonNull(amountToAdd, 'amountToAdd');
    requireNonNull(unit, 'unit');
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.DAYS:
          return this.plusDays(amountToAdd);
        case ChronoUnit.WEEKS:
          return this.plusWeeks(amountToAdd);
        case ChronoUnit.MONTHS:
          return this.plusMonths(amountToAdd);
        case ChronoUnit.YEARS:
          return this.plusYears(amountToAdd);
        case ChronoUnit.DECADES:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 10));
        case ChronoUnit.CENTURIES:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 100));
        case ChronoUnit.MILLENNIA:
          return this.plusYears(MathUtil.safeMultiply(amountToAdd, 1000));
        case ChronoUnit.ERAS:
          return this.with(ChronoField.ERA, MathUtil.safeAdd(this.getLong(ChronoField.ERA), amountToAdd));
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusYears = function plusYears(yearsToAdd) {
    if (yearsToAdd === 0) {
      return this;
    }
    var newYear = ChronoField.YEAR.checkValidIntValue(this._year + yearsToAdd);
    return LocalDate._resolvePreviousValid(newYear, this._month, this._day);
  };
  _proto.plusMonths = function plusMonths(monthsToAdd) {
    if (monthsToAdd === 0) {
      return this;
    }
    var monthCount = this._year * 12 + (this._month - 1);
    var calcMonths = monthCount + monthsToAdd;
    var newYear = ChronoField.YEAR.checkValidIntValue(MathUtil.floorDiv(calcMonths, 12));
    var newMonth = MathUtil.floorMod(calcMonths, 12) + 1;
    return LocalDate._resolvePreviousValid(newYear, newMonth, this._day);
  };
  _proto.plusWeeks = function plusWeeks(weeksToAdd) {
    return this.plusDays(MathUtil.safeMultiply(weeksToAdd, 7));
  };
  _proto.plusDays = function plusDays(daysToAdd) {
    if (daysToAdd === 0) {
      return this;
    }
    var mjDay = MathUtil.safeAdd(this.toEpochDay(), daysToAdd);
    return LocalDate.ofEpochDay(mjDay);
  };
  _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
    requireNonNull(amountToSubtract, 'amountToSubtract');
    requireNonNull(unit, 'unit');
    return this._plusUnit(-1 * amountToSubtract, unit);
  };
  _proto.minusYears = function minusYears(yearsToSubtract) {
    return this.plusYears(yearsToSubtract * -1);
  };
  _proto.minusMonths = function minusMonths(monthsToSubtract) {
    return this.plusMonths(monthsToSubtract * -1);
  };
  _proto.minusWeeks = function minusWeeks(weeksToSubtract) {
    return this.plusWeeks(weeksToSubtract * -1);
  };
  _proto.minusDays = function minusDays(daysToSubtract) {
    return this.plusDays(daysToSubtract * -1);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    if (_query === TemporalQueries.localDate()) {
      return this;
    }
    return _ChronoLocalDate.prototype.query.call(this, _query);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    return _ChronoLocalDate.prototype.adjustInto.call(this, temporal);
  };
  _proto.until = function until(p1, p2) {
    if (arguments.length < 2) {
      return this.until1(p1);
    } else {
      return this.until2(p1, p2);
    }
  };
  _proto.until2 = function until2(endExclusive, unit) {
    var end = LocalDate.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.DAYS:
          return this.daysUntil(end);
        case ChronoUnit.WEEKS:
          return MathUtil.intDiv(this.daysUntil(end), 7);
        case ChronoUnit.MONTHS:
          return this._monthsUntil(end);
        case ChronoUnit.YEARS:
          return MathUtil.intDiv(this._monthsUntil(end), 12);
        case ChronoUnit.DECADES:
          return MathUtil.intDiv(this._monthsUntil(end), 120);
        case ChronoUnit.CENTURIES:
          return MathUtil.intDiv(this._monthsUntil(end), 1200);
        case ChronoUnit.MILLENNIA:
          return MathUtil.intDiv(this._monthsUntil(end), 12000);
        case ChronoUnit.ERAS:
          return end.getLong(ChronoField.ERA) - this.getLong(ChronoField.ERA);
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.between(this, end);
  };
  _proto.daysUntil = function daysUntil(end) {
    return end.toEpochDay() - this.toEpochDay();
  };
  _proto._monthsUntil = function _monthsUntil(end) {
    var packed1 = this._prolepticMonth() * 32 + this.dayOfMonth();
    var packed2 = end._prolepticMonth() * 32 + end.dayOfMonth();
    return MathUtil.intDiv(packed2 - packed1, 32);
  };
  _proto.until1 = function until1(endDate) {
    var end = LocalDate.from(endDate);
    var totalMonths = end._prolepticMonth() - this._prolepticMonth();
    var days = end._day - this._day;
    if (totalMonths > 0 && days < 0) {
      totalMonths--;
      var calcDate = this.plusMonths(totalMonths);
      days = end.toEpochDay() - calcDate.toEpochDay();
    } else if (totalMonths < 0 && days > 0) {
      totalMonths++;
      days -= end.lengthOfMonth();
    }
    var years = MathUtil.intDiv(totalMonths, 12);
    var months = MathUtil.intMod(totalMonths, 12);
    return Period.of(years, months, days);
  };
  _proto.atTime = function atTime() {
    if (arguments.length === 1) {
      return this.atTime1.apply(this, arguments);
    } else {
      return this.atTime4.apply(this, arguments);
    }
  };
  _proto.atTime1 = function atTime1(time) {
    requireNonNull(time, 'time');
    if (time instanceof LocalTime) {
      return LocalDateTime.of(this, time);
    } else if (time instanceof OffsetTime) {
      return this._atTimeOffsetTime(time);
    } else {
      throw new IllegalArgumentException("time must be an instance of LocalTime or OffsetTime" + (time && time.constructor && time.constructor.name ? ", but is " + time.constructor.name : ''));
    }
  };
  _proto.atTime4 = function atTime4(hour, minute, second, nanoOfSecond) {
    if (second === void 0) {
      second = 0;
    }
    if (nanoOfSecond === void 0) {
      nanoOfSecond = 0;
    }
    return this.atTime1(LocalTime.of(hour, minute, second, nanoOfSecond));
  };
  _proto._atTimeOffsetTime = function _atTimeOffsetTime(time) {
    return OffsetDateTime.of(LocalDateTime.of(this, time.toLocalTime()), time.offset());
  };
  _proto.atStartOfDay = function atStartOfDay(zone) {
    if (zone != null) {
      return this._atStartOfDayWithZone(zone);
    } else {
      return LocalDateTime.of(this, LocalTime.MIDNIGHT);
    }
  };
  _proto._atStartOfDayWithZone = function _atStartOfDayWithZone(zone) {
    requireNonNull(zone, 'zone');
    var ldt = this.atTime(LocalTime.MIDNIGHT);
    if (zone instanceof ZoneOffset === false) {
      var trans = zone.rules().transition(ldt);
      if (trans != null && trans.isGap()) {
        ldt = trans.dateTimeAfter();
      }
    }
    return ZonedDateTime.of(ldt, zone);
  };
  _proto.toEpochDay = function toEpochDay() {
    var y = this._year;
    var m = this._month;
    var total = 0;
    total += 365 * y;
    if (y >= 0) {
      total += MathUtil.intDiv(y + 3, 4) - MathUtil.intDiv(y + 99, 100) + MathUtil.intDiv(y + 399, 400);
    } else {
      total -= MathUtil.intDiv(y, -4) - MathUtil.intDiv(y, -100) + MathUtil.intDiv(y, -400);
    }
    total += MathUtil.intDiv(367 * m - 362, 12);
    total += this.dayOfMonth() - 1;
    if (m > 2) {
      total--;
      if (!IsoChronology.isLeapYear(y)) {
        total--;
      }
    }
    return total - DAYS_0000_TO_1970;
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, LocalDate, 'other');
    return this._compareTo0(other);
  };
  _proto._compareTo0 = function _compareTo0(otherDate) {
    var cmp = this._year - otherDate._year;
    if (cmp === 0) {
      cmp = this._month - otherDate._month;
      if (cmp === 0) {
        cmp = this._day - otherDate._day;
      }
    }
    return cmp;
  };
  _proto.isAfter = function isAfter(other) {
    return this.compareTo(other) > 0;
  };
  _proto.isBefore = function isBefore(other) {
    return this.compareTo(other) < 0;
  };
  _proto.isEqual = function isEqual(other) {
    return this.compareTo(other) === 0;
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof LocalDate) {
      return this._compareTo0(other) === 0;
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    var yearValue = this._year;
    var monthValue = this._month;
    var dayValue = this._day;
    return MathUtil.hash(yearValue & 0xFFFFF800 ^ (yearValue << 11) + (monthValue << 6) + dayValue);
  };
  _proto.toString = function toString() {
    var dayString, monthString, yearString;
    var yearValue = this._year;
    var monthValue = this._month;
    var dayValue = this._day;
    var absYear = Math.abs(yearValue);
    if (absYear < 1000) {
      if (yearValue < 0) {
        yearString = "-" + ("" + (yearValue - 10000)).slice(-4);
      } else {
        yearString = ("" + (yearValue + 10000)).slice(-4);
      }
    } else {
      if (yearValue > 9999) {
        yearString = "+" + yearValue;
      } else {
        yearString = "" + yearValue;
      }
    }
    if (monthValue < 10) {
      monthString = "-0" + monthValue;
    } else {
      monthString = "-" + monthValue;
    }
    if (dayValue < 10) {
      dayString = "-0" + dayValue;
    } else {
      dayString = "-" + dayValue;
    }
    return yearString + monthString + dayString;
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    requireInstance(formatter, DateTimeFormatter, 'formatter');
    return _ChronoLocalDate.prototype.format.call(this, formatter);
  };
  return LocalDate;
}(ChronoLocalDate);
function _init$5() {
  LocalDate.MIN = LocalDate.of(YearConstants.MIN_VALUE, 1, 1);
  LocalDate.MAX = LocalDate.of(YearConstants.MAX_VALUE, 12, 31);
  LocalDate.EPOCH_0 = LocalDate.ofEpochDay(0);
  LocalDate.FROM = createTemporalQuery('LocalDate.FROM', function (temporal) {
    return LocalDate.from(temporal);
  });
}

var ChronoLocalDateTime = function (_Temporal) {
  _inheritsLoose(ChronoLocalDateTime, _Temporal);
  function ChronoLocalDateTime() {
    return _Temporal.apply(this, arguments) || this;
  }
  var _proto = ChronoLocalDateTime.prototype;
  _proto.chronology = function chronology() {
    return this.toLocalDate().chronology();
  };
  _proto.query = function query(_query) {
    if (_query === TemporalQueries.chronology()) {
      return this.chronology();
    } else if (_query === TemporalQueries.precision()) {
      return ChronoUnit.NANOS;
    } else if (_query === TemporalQueries.localDate()) {
      return LocalDate.ofEpochDay(this.toLocalDate().toEpochDay());
    } else if (_query === TemporalQueries.localTime()) {
      return this.toLocalTime();
    } else if (_query === TemporalQueries.zone() || _query === TemporalQueries.zoneId() || _query === TemporalQueries.offset()) {
      return null;
    }
    return _Temporal.prototype.query.call(this, _query);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    return temporal.with(ChronoField.EPOCH_DAY, this.toLocalDate().toEpochDay()).with(ChronoField.NANO_OF_DAY, this.toLocalTime().toNanoOfDay());
  };
  _proto.toInstant = function toInstant(offset) {
    requireInstance(offset, ZoneOffset, 'zoneId');
    return Instant.ofEpochSecond(this.toEpochSecond(offset), this.toLocalTime().nano());
  };
  _proto.toEpochSecond = function toEpochSecond(offset) {
    requireNonNull(offset, 'offset');
    var epochDay = this.toLocalDate().toEpochDay();
    var secs = epochDay * 86400 + this.toLocalTime().toSecondOfDay();
    secs -= offset.totalSeconds();
    return MathUtil.safeToInt(secs);
  };
  return ChronoLocalDateTime;
}(Temporal);

var LocalDateTime = function (_ChronoLocalDateTime) {
  _inheritsLoose(LocalDateTime, _ChronoLocalDateTime);
  LocalDateTime.now = function now(clockOrZone) {
    if (clockOrZone == null) {
      return LocalDateTime._now(Clock.systemDefaultZone());
    } else if (clockOrZone instanceof Clock) {
      return LocalDateTime._now(clockOrZone);
    } else {
      return LocalDateTime._now(Clock.system(clockOrZone));
    }
  };
  LocalDateTime._now = function _now(clock) {
    requireNonNull(clock, 'clock');
    return LocalDateTime.ofInstant(clock.instant(), clock.zone());
  };
  LocalDateTime._ofEpochMillis = function _ofEpochMillis(epochMilli, offset) {
    var localSecond = MathUtil.floorDiv(epochMilli, 1000) + offset.totalSeconds();
    var localEpochDay = MathUtil.floorDiv(localSecond, LocalTime.SECONDS_PER_DAY);
    var secsOfDay = MathUtil.floorMod(localSecond, LocalTime.SECONDS_PER_DAY);
    var nanoOfSecond = MathUtil.floorMod(epochMilli, 1000) * 1000000;
    var date = LocalDate.ofEpochDay(localEpochDay);
    var time = LocalTime.ofSecondOfDay(secsOfDay, nanoOfSecond);
    return new LocalDateTime(date, time);
  };
  LocalDateTime.of = function of() {
    if (arguments.length <= 2) {
      return LocalDateTime.ofDateAndTime.apply(this, arguments);
    } else {
      return LocalDateTime.ofNumbers.apply(this, arguments);
    }
  };
  LocalDateTime.ofNumbers = function ofNumbers(year, month, dayOfMonth, hour, minute, second, nanoOfSecond) {
    if (hour === void 0) {
      hour = 0;
    }
    if (minute === void 0) {
      minute = 0;
    }
    if (second === void 0) {
      second = 0;
    }
    if (nanoOfSecond === void 0) {
      nanoOfSecond = 0;
    }
    var date = LocalDate.of(year, month, dayOfMonth);
    var time = LocalTime.of(hour, minute, second, nanoOfSecond);
    return new LocalDateTime(date, time);
  };
  LocalDateTime.ofDateAndTime = function ofDateAndTime(date, time) {
    requireNonNull(date, 'date');
    requireNonNull(time, 'time');
    return new LocalDateTime(date, time);
  };
  LocalDateTime.ofInstant = function ofInstant(instant, zone) {
    if (zone === void 0) {
      zone = ZoneId.systemDefault();
    }
    requireNonNull(instant, 'instant');
    requireInstance(instant, Instant, 'instant');
    requireNonNull(zone, 'zone');
    var offset = zone.rules().offset(instant);
    return LocalDateTime.ofEpochSecond(instant.epochSecond(), instant.nano(), offset);
  };
  LocalDateTime.ofEpochSecond = function ofEpochSecond(epochSecond, nanoOfSecond, offset) {
    if (epochSecond === void 0) {
      epochSecond = 0;
    }
    if (nanoOfSecond === void 0) {
      nanoOfSecond = 0;
    }
    if (arguments.length === 2 && nanoOfSecond instanceof ZoneOffset) {
      offset = nanoOfSecond;
      nanoOfSecond = 0;
    }
    requireNonNull(offset, 'offset');
    var localSecond = epochSecond + offset.totalSeconds();
    var localEpochDay = MathUtil.floorDiv(localSecond, LocalTime.SECONDS_PER_DAY);
    var secsOfDay = MathUtil.floorMod(localSecond, LocalTime.SECONDS_PER_DAY);
    var date = LocalDate.ofEpochDay(localEpochDay);
    var time = LocalTime.ofSecondOfDay(secsOfDay, nanoOfSecond);
    return new LocalDateTime(date, time);
  };
  LocalDateTime.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    if (temporal instanceof LocalDateTime) {
      return temporal;
    } else if (temporal instanceof ZonedDateTime) {
      return temporal.toLocalDateTime();
    }
    try {
      var date = LocalDate.from(temporal);
      var time = LocalTime.from(temporal);
      return new LocalDateTime(date, time);
    } catch (ex) {
      throw new DateTimeException("Unable to obtain LocalDateTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
    }
  };
  LocalDateTime.parse = function parse(text, formatter) {
    if (formatter === void 0) {
      formatter = DateTimeFormatter.ISO_LOCAL_DATE_TIME;
    }
    requireNonNull(formatter, 'formatter');
    return formatter.parse(text, LocalDateTime.FROM);
  };
  function LocalDateTime(date, time) {
    var _this;
    _this = _ChronoLocalDateTime.call(this) || this;
    requireInstance(date, LocalDate, 'date');
    requireInstance(time, LocalTime, 'time');
    _this._date = date;
    _this._time = time;
    return _this;
  }
  var _proto = LocalDateTime.prototype;
  _proto._withDateTime = function _withDateTime(newDate, newTime) {
    if (this._date.equals(newDate) && this._time.equals(newTime)) {
      return this;
    }
    return new LocalDateTime(newDate, newTime);
  };
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (fieldOrUnit instanceof ChronoField) {
      return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
    } else if (fieldOrUnit instanceof ChronoUnit) {
      return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
    }
    return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    if (field instanceof ChronoField) {
      return field.isTimeBased() ? this._time.range(field) : this._date.range(field);
    }
    return field.rangeRefinedBy(this);
  };
  _proto.get = function get(field) {
    if (field instanceof ChronoField) {
      return field.isTimeBased() ? this._time.get(field) : this._date.get(field);
    }
    return _ChronoLocalDateTime.prototype.get.call(this, field);
  };
  _proto.getLong = function getLong(field) {
    requireNonNull(field, 'field');
    if (field instanceof ChronoField) {
      return field.isTimeBased() ? this._time.getLong(field) : this._date.getLong(field);
    }
    return field.getFrom(this);
  };
  _proto.year = function year() {
    return this._date.year();
  };
  _proto.monthValue = function monthValue() {
    return this._date.monthValue();
  };
  _proto.month = function month() {
    return this._date.month();
  };
  _proto.dayOfMonth = function dayOfMonth() {
    return this._date.dayOfMonth();
  };
  _proto.dayOfYear = function dayOfYear() {
    return this._date.dayOfYear();
  };
  _proto.dayOfWeek = function dayOfWeek() {
    return this._date.dayOfWeek();
  };
  _proto.hour = function hour() {
    return this._time.hour();
  };
  _proto.minute = function minute() {
    return this._time.minute();
  };
  _proto.second = function second() {
    return this._time.second();
  };
  _proto.nano = function nano() {
    return this._time.nano();
  };
  _proto._withAdjuster = function _withAdjuster(adjuster) {
    requireNonNull(adjuster, 'adjuster');
    if (adjuster instanceof LocalDate) {
      return this._withDateTime(adjuster, this._time);
    } else if (adjuster instanceof LocalTime) {
      return this._withDateTime(this._date, adjuster);
    } else if (adjuster instanceof LocalDateTime) {
      return adjuster;
    }
    return _ChronoLocalDateTime.prototype._withAdjuster.call(this, adjuster);
  };
  _proto._withField = function _withField(field, newValue) {
    requireNonNull(field, 'field');
    if (field instanceof ChronoField) {
      if (field.isTimeBased()) {
        return this._withDateTime(this._date, this._time.with(field, newValue));
      } else {
        return this._withDateTime(this._date.with(field, newValue), this._time);
      }
    }
    return field.adjustInto(this, newValue);
  };
  _proto.withYear = function withYear(year) {
    return this._withDateTime(this._date.withYear(year), this._time);
  };
  _proto.withMonth = function withMonth(month) {
    return this._withDateTime(this._date.withMonth(month), this._time);
  };
  _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
    return this._withDateTime(this._date.withDayOfMonth(dayOfMonth), this._time);
  };
  _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
    return this._withDateTime(this._date.withDayOfYear(dayOfYear), this._time);
  };
  _proto.withHour = function withHour(hour) {
    var newTime = this._time.withHour(hour);
    return this._withDateTime(this._date, newTime);
  };
  _proto.withMinute = function withMinute(minute) {
    var newTime = this._time.withMinute(minute);
    return this._withDateTime(this._date, newTime);
  };
  _proto.withSecond = function withSecond(second) {
    var newTime = this._time.withSecond(second);
    return this._withDateTime(this._date, newTime);
  };
  _proto.withNano = function withNano(nanoOfSecond) {
    var newTime = this._time.withNano(nanoOfSecond);
    return this._withDateTime(this._date, newTime);
  };
  _proto.truncatedTo = function truncatedTo(unit) {
    return this._withDateTime(this._date, this._time.truncatedTo(unit));
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    requireNonNull(unit, 'unit');
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.NANOS:
          return this.plusNanos(amountToAdd);
        case ChronoUnit.MICROS:
          return this.plusDays(MathUtil.intDiv(amountToAdd, LocalTime.MICROS_PER_DAY)).plusNanos(MathUtil.intMod(amountToAdd, LocalTime.MICROS_PER_DAY) * 1000);
        case ChronoUnit.MILLIS:
          return this.plusDays(MathUtil.intDiv(amountToAdd, LocalTime.MILLIS_PER_DAY)).plusNanos(MathUtil.intMod(amountToAdd, LocalTime.MILLIS_PER_DAY) * 1000000);
        case ChronoUnit.SECONDS:
          return this.plusSeconds(amountToAdd);
        case ChronoUnit.MINUTES:
          return this.plusMinutes(amountToAdd);
        case ChronoUnit.HOURS:
          return this.plusHours(amountToAdd);
        case ChronoUnit.HALF_DAYS:
          return this.plusDays(MathUtil.intDiv(amountToAdd, 256)).plusHours(MathUtil.intMod(amountToAdd, 256) * 12);
      }
      return this._withDateTime(this._date.plus(amountToAdd, unit), this._time);
    }
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusYears = function plusYears(years) {
    var newDate = this._date.plusYears(years);
    return this._withDateTime(newDate, this._time);
  };
  _proto.plusMonths = function plusMonths(months) {
    var newDate = this._date.plusMonths(months);
    return this._withDateTime(newDate, this._time);
  };
  _proto.plusWeeks = function plusWeeks(weeks) {
    var newDate = this._date.plusWeeks(weeks);
    return this._withDateTime(newDate, this._time);
  };
  _proto.plusDays = function plusDays(days) {
    var newDate = this._date.plusDays(days);
    return this._withDateTime(newDate, this._time);
  };
  _proto.plusHours = function plusHours(hours) {
    return this._plusWithOverflow(this._date, hours, 0, 0, 0, 1);
  };
  _proto.plusMinutes = function plusMinutes(minutes) {
    return this._plusWithOverflow(this._date, 0, minutes, 0, 0, 1);
  };
  _proto.plusSeconds = function plusSeconds(seconds) {
    return this._plusWithOverflow(this._date, 0, 0, seconds, 0, 1);
  };
  _proto.plusNanos = function plusNanos(nanos) {
    return this._plusWithOverflow(this._date, 0, 0, 0, nanos, 1);
  };
  _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
    requireNonNull(unit, 'unit');
    return this._plusUnit(-1 * amountToSubtract, unit);
  };
  _proto.minusYears = function minusYears(years) {
    return this.plusYears(-1 * years);
  };
  _proto.minusMonths = function minusMonths(months) {
    return this.plusMonths(-1 * months);
  };
  _proto.minusWeeks = function minusWeeks(weeks) {
    return this.plusWeeks(-1 * weeks);
  };
  _proto.minusDays = function minusDays(days) {
    return this.plusDays(-1 * days);
  };
  _proto.minusHours = function minusHours(hours) {
    return this._plusWithOverflow(this._date, hours, 0, 0, 0, -1);
  };
  _proto.minusMinutes = function minusMinutes(minutes) {
    return this._plusWithOverflow(this._date, 0, minutes, 0, 0, -1);
  };
  _proto.minusSeconds = function minusSeconds(seconds) {
    return this._plusWithOverflow(this._date, 0, 0, seconds, 0, -1);
  };
  _proto.minusNanos = function minusNanos(nanos) {
    return this._plusWithOverflow(this._date, 0, 0, 0, nanos, -1);
  };
  _proto._plusWithOverflow = function _plusWithOverflow(newDate, hours, minutes, seconds, nanos, sign) {
    if (hours === 0 && minutes === 0 && seconds === 0 && nanos === 0) {
      return this._withDateTime(newDate, this._time);
    }
    var totDays = MathUtil.intDiv(nanos, LocalTime.NANOS_PER_DAY) + MathUtil.intDiv(seconds, LocalTime.SECONDS_PER_DAY) + MathUtil.intDiv(minutes, LocalTime.MINUTES_PER_DAY) + MathUtil.intDiv(hours, LocalTime.HOURS_PER_DAY);
    totDays *= sign;
    var totNanos = MathUtil.intMod(nanos, LocalTime.NANOS_PER_DAY) + MathUtil.intMod(seconds, LocalTime.SECONDS_PER_DAY) * LocalTime.NANOS_PER_SECOND + MathUtil.intMod(minutes, LocalTime.MINUTES_PER_DAY) * LocalTime.NANOS_PER_MINUTE + MathUtil.intMod(hours, LocalTime.HOURS_PER_DAY) * LocalTime.NANOS_PER_HOUR;
    var curNoD = this._time.toNanoOfDay();
    totNanos = totNanos * sign + curNoD;
    totDays += MathUtil.floorDiv(totNanos, LocalTime.NANOS_PER_DAY);
    var newNoD = MathUtil.floorMod(totNanos, LocalTime.NANOS_PER_DAY);
    var newTime = newNoD === curNoD ? this._time : LocalTime.ofNanoOfDay(newNoD);
    return this._withDateTime(newDate.plusDays(totDays), newTime);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    if (_query === TemporalQueries.localDate()) {
      return this.toLocalDate();
    }
    return _ChronoLocalDateTime.prototype.query.call(this, _query);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    return _ChronoLocalDateTime.prototype.adjustInto.call(this, temporal);
  };
  _proto.until = function until(endExclusive, unit) {
    requireNonNull(endExclusive, 'endExclusive');
    requireNonNull(unit, 'unit');
    var end = LocalDateTime.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      if (unit.isTimeBased()) {
        var daysUntil = this._date.daysUntil(end._date);
        var timeUntil = end._time.toNanoOfDay() - this._time.toNanoOfDay();
        if (daysUntil > 0 && timeUntil < 0) {
          daysUntil--;
          timeUntil += LocalTime.NANOS_PER_DAY;
        } else if (daysUntil < 0 && timeUntil > 0) {
          daysUntil++;
          timeUntil -= LocalTime.NANOS_PER_DAY;
        }
        var amount = daysUntil;
        switch (unit) {
          case ChronoUnit.NANOS:
            amount = MathUtil.safeMultiply(amount, LocalTime.NANOS_PER_DAY);
            return MathUtil.safeAdd(amount, timeUntil);
          case ChronoUnit.MICROS:
            amount = MathUtil.safeMultiply(amount, LocalTime.MICROS_PER_DAY);
            return MathUtil.safeAdd(amount, MathUtil.intDiv(timeUntil, 1000));
          case ChronoUnit.MILLIS:
            amount = MathUtil.safeMultiply(amount, LocalTime.MILLIS_PER_DAY);
            return MathUtil.safeAdd(amount, MathUtil.intDiv(timeUntil, 1000000));
          case ChronoUnit.SECONDS:
            amount = MathUtil.safeMultiply(amount, LocalTime.SECONDS_PER_DAY);
            return MathUtil.safeAdd(amount, MathUtil.intDiv(timeUntil, LocalTime.NANOS_PER_SECOND));
          case ChronoUnit.MINUTES:
            amount = MathUtil.safeMultiply(amount, LocalTime.MINUTES_PER_DAY);
            return MathUtil.safeAdd(amount, MathUtil.intDiv(timeUntil, LocalTime.NANOS_PER_MINUTE));
          case ChronoUnit.HOURS:
            amount = MathUtil.safeMultiply(amount, LocalTime.HOURS_PER_DAY);
            return MathUtil.safeAdd(amount, MathUtil.intDiv(timeUntil, LocalTime.NANOS_PER_HOUR));
          case ChronoUnit.HALF_DAYS:
            amount = MathUtil.safeMultiply(amount, 2);
            return MathUtil.safeAdd(amount, MathUtil.intDiv(timeUntil, LocalTime.NANOS_PER_HOUR * 12));
        }
        throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
      }
      var endDate = end._date;
      var endTime = end._time;
      if (endDate.isAfter(this._date) && endTime.isBefore(this._time)) {
        endDate = endDate.minusDays(1);
      } else if (endDate.isBefore(this._date) && endTime.isAfter(this._time)) {
        endDate = endDate.plusDays(1);
      }
      return this._date.until(endDate, unit);
    }
    return unit.between(this, end);
  };
  _proto.atOffset = function atOffset(offset) {
    return OffsetDateTime.of(this, offset);
  };
  _proto.atZone = function atZone(zone) {
    return ZonedDateTime.of(this, zone);
  };
  _proto.toLocalDate = function toLocalDate() {
    return this._date;
  };
  _proto.toLocalTime = function toLocalTime() {
    return this._time;
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, LocalDateTime, 'other');
    return this._compareTo0(other);
  };
  _proto._compareTo0 = function _compareTo0(other) {
    var cmp = this._date.compareTo(other.toLocalDate());
    if (cmp === 0) {
      cmp = this._time.compareTo(other.toLocalTime());
    }
    return cmp;
  };
  _proto.isAfter = function isAfter(other) {
    return this.compareTo(other) > 0;
  };
  _proto.isBefore = function isBefore(other) {
    return this.compareTo(other) < 0;
  };
  _proto.isEqual = function isEqual(other) {
    return this.compareTo(other) === 0;
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof LocalDateTime) {
      return this._date.equals(other._date) && this._time.equals(other._time);
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return this._date.hashCode() ^ this._time.hashCode();
  };
  _proto.toString = function toString() {
    return this._date.toString() + "T" + this._time.toString();
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    return formatter.format(this);
  };
  return LocalDateTime;
}(ChronoLocalDateTime);
function _init$4() {
  LocalDateTime.MIN = LocalDateTime.of(LocalDate.MIN, LocalTime.MIN);
  LocalDateTime.MAX = LocalDateTime.of(LocalDate.MAX, LocalTime.MAX);
  LocalDateTime.FROM = createTemporalQuery('LocalDateTime.FROM', function (temporal) {
    return LocalDateTime.from(temporal);
  });
}

var LocalTime = function (_Temporal) {
  _inheritsLoose(LocalTime, _Temporal);
  LocalTime.now = function now(clockOrZone) {
    if (clockOrZone == null) {
      return LocalTime._now(Clock.systemDefaultZone());
    } else if (clockOrZone instanceof Clock) {
      return LocalTime._now(clockOrZone);
    } else {
      return LocalTime._now(Clock.system(clockOrZone));
    }
  };
  LocalTime._now = function _now(clock) {
    if (clock === void 0) {
      clock = Clock.systemDefaultZone();
    }
    requireNonNull(clock, 'clock');
    return LocalTime.ofInstant(clock.instant(), clock.zone());
  };
  LocalTime.ofInstant = function ofInstant(instant, zone) {
    if (zone === void 0) {
      zone = ZoneId.systemDefault();
    }
    var offset = zone.rules().offset(instant);
    var secsOfDay = MathUtil.intMod(instant.epochSecond(), LocalTime.SECONDS_PER_DAY);
    secsOfDay = MathUtil.intMod(secsOfDay + offset.totalSeconds(), LocalTime.SECONDS_PER_DAY);
    if (secsOfDay < 0) {
      secsOfDay += LocalTime.SECONDS_PER_DAY;
    }
    return LocalTime.ofSecondOfDay(secsOfDay, instant.nano());
  };
  LocalTime.of = function of(hour, minute, second, nanoOfSecond) {
    return new LocalTime(hour, minute, second, nanoOfSecond);
  };
  LocalTime.ofSecondOfDay = function ofSecondOfDay(secondOfDay, nanoOfSecond) {
    if (secondOfDay === void 0) {
      secondOfDay = 0;
    }
    if (nanoOfSecond === void 0) {
      nanoOfSecond = 0;
    }
    ChronoField.SECOND_OF_DAY.checkValidValue(secondOfDay);
    ChronoField.NANO_OF_SECOND.checkValidValue(nanoOfSecond);
    var hours = MathUtil.intDiv(secondOfDay, LocalTime.SECONDS_PER_HOUR);
    secondOfDay -= hours * LocalTime.SECONDS_PER_HOUR;
    var minutes = MathUtil.intDiv(secondOfDay, LocalTime.SECONDS_PER_MINUTE);
    secondOfDay -= minutes * LocalTime.SECONDS_PER_MINUTE;
    return new LocalTime(hours, minutes, secondOfDay, nanoOfSecond);
  };
  LocalTime.ofNanoOfDay = function ofNanoOfDay(nanoOfDay) {
    if (nanoOfDay === void 0) {
      nanoOfDay = 0;
    }
    ChronoField.NANO_OF_DAY.checkValidValue(nanoOfDay);
    var hours = MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_HOUR);
    nanoOfDay -= hours * LocalTime.NANOS_PER_HOUR;
    var minutes = MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_MINUTE);
    nanoOfDay -= minutes * LocalTime.NANOS_PER_MINUTE;
    var seconds = MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_SECOND);
    nanoOfDay -= seconds * LocalTime.NANOS_PER_SECOND;
    return new LocalTime(hours, minutes, seconds, nanoOfDay);
  };
  LocalTime.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    var time = temporal.query(TemporalQueries.localTime());
    if (time == null) {
      throw new DateTimeException("Unable to obtain LocalTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
    }
    return time;
  };
  LocalTime.parse = function parse(text, formatter) {
    if (formatter === void 0) {
      formatter = DateTimeFormatter.ISO_LOCAL_TIME;
    }
    requireNonNull(formatter, 'formatter');
    return formatter.parse(text, LocalTime.FROM);
  };
  function LocalTime(hour, minute, second, nanoOfSecond) {
    var _this;
    if (hour === void 0) {
      hour = 0;
    }
    if (minute === void 0) {
      minute = 0;
    }
    if (second === void 0) {
      second = 0;
    }
    if (nanoOfSecond === void 0) {
      nanoOfSecond = 0;
    }
    _this = _Temporal.call(this) || this;
    var _hour = MathUtil.safeToInt(hour);
    var _minute = MathUtil.safeToInt(minute);
    var _second = MathUtil.safeToInt(second);
    var _nanoOfSecond = MathUtil.safeToInt(nanoOfSecond);
    LocalTime._validate(_hour, _minute, _second, _nanoOfSecond);
    if (_minute === 0 && _second === 0 && _nanoOfSecond === 0) {
      if (!LocalTime.HOURS[_hour]) {
        _this._hour = _hour;
        _this._minute = _minute;
        _this._second = _second;
        _this._nano = _nanoOfSecond;
        LocalTime.HOURS[_hour] = _assertThisInitialized(_this);
      }
      return LocalTime.HOURS[_hour] || _assertThisInitialized(_this);
    }
    _this._hour = _hour;
    _this._minute = _minute;
    _this._second = _second;
    _this._nano = _nanoOfSecond;
    return _this;
  }
  LocalTime._validate = function _validate(hour, minute, second, nanoOfSecond) {
    ChronoField.HOUR_OF_DAY.checkValidValue(hour);
    ChronoField.MINUTE_OF_HOUR.checkValidValue(minute);
    ChronoField.SECOND_OF_MINUTE.checkValidValue(second);
    ChronoField.NANO_OF_SECOND.checkValidValue(nanoOfSecond);
  };
  var _proto = LocalTime.prototype;
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (fieldOrUnit instanceof ChronoField) {
      return fieldOrUnit.isTimeBased();
    } else if (fieldOrUnit instanceof ChronoUnit) {
      return fieldOrUnit.isTimeBased();
    }
    return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    requireNonNull(field);
    return _Temporal.prototype.range.call(this, field);
  };
  _proto.get = function get(field) {
    return this.getLong(field);
  };
  _proto.getLong = function getLong(field) {
    requireNonNull(field, 'field');
    if (field instanceof ChronoField) {
      return this._get0(field);
    }
    return field.getFrom(this);
  };
  _proto._get0 = function _get0(field) {
    switch (field) {
      case ChronoField.NANO_OF_SECOND:
        return this._nano;
      case ChronoField.NANO_OF_DAY:
        return this.toNanoOfDay();
      case ChronoField.MICRO_OF_SECOND:
        return MathUtil.intDiv(this._nano, 1000);
      case ChronoField.MICRO_OF_DAY:
        return MathUtil.intDiv(this.toNanoOfDay(), 1000);
      case ChronoField.MILLI_OF_SECOND:
        return MathUtil.intDiv(this._nano, 1000000);
      case ChronoField.MILLI_OF_DAY:
        return MathUtil.intDiv(this.toNanoOfDay(), 1000000);
      case ChronoField.SECOND_OF_MINUTE:
        return this._second;
      case ChronoField.SECOND_OF_DAY:
        return this.toSecondOfDay();
      case ChronoField.MINUTE_OF_HOUR:
        return this._minute;
      case ChronoField.MINUTE_OF_DAY:
        return this._hour * 60 + this._minute;
      case ChronoField.HOUR_OF_AMPM:
        return MathUtil.intMod(this._hour, 12);
      case ChronoField.CLOCK_HOUR_OF_AMPM:
        {
          var ham = MathUtil.intMod(this._hour, 12);
          return ham % 12 === 0 ? 12 : ham;
        }
      case ChronoField.HOUR_OF_DAY:
        return this._hour;
      case ChronoField.CLOCK_HOUR_OF_DAY:
        return this._hour === 0 ? 24 : this._hour;
      case ChronoField.AMPM_OF_DAY:
        return MathUtil.intDiv(this._hour, 12);
    }
    throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
  };
  _proto.hour = function hour() {
    return this._hour;
  };
  _proto.minute = function minute() {
    return this._minute;
  };
  _proto.second = function second() {
    return this._second;
  };
  _proto.nano = function nano() {
    return this._nano;
  };
  _proto._withAdjuster = function _withAdjuster(adjuster) {
    requireNonNull(adjuster, 'adjuster');
    if (adjuster instanceof LocalTime) {
      return adjuster;
    }
    return _Temporal.prototype._withAdjuster.call(this, adjuster);
  };
  _proto._withField = function _withField(field, newValue) {
    requireNonNull(field, 'field');
    requireInstance(field, TemporalField, 'field');
    if (field instanceof ChronoField) {
      field.checkValidValue(newValue);
      switch (field) {
        case ChronoField.NANO_OF_SECOND:
          return this.withNano(newValue);
        case ChronoField.NANO_OF_DAY:
          return LocalTime.ofNanoOfDay(newValue);
        case ChronoField.MICRO_OF_SECOND:
          return this.withNano(newValue * 1000);
        case ChronoField.MICRO_OF_DAY:
          return LocalTime.ofNanoOfDay(newValue * 1000);
        case ChronoField.MILLI_OF_SECOND:
          return this.withNano(newValue * 1000000);
        case ChronoField.MILLI_OF_DAY:
          return LocalTime.ofNanoOfDay(newValue * 1000000);
        case ChronoField.SECOND_OF_MINUTE:
          return this.withSecond(newValue);
        case ChronoField.SECOND_OF_DAY:
          return this.plusSeconds(newValue - this.toSecondOfDay());
        case ChronoField.MINUTE_OF_HOUR:
          return this.withMinute(newValue);
        case ChronoField.MINUTE_OF_DAY:
          return this.plusMinutes(newValue - (this._hour * 60 + this._minute));
        case ChronoField.HOUR_OF_AMPM:
          return this.plusHours(newValue - MathUtil.intMod(this._hour, 12));
        case ChronoField.CLOCK_HOUR_OF_AMPM:
          return this.plusHours((newValue === 12 ? 0 : newValue) - MathUtil.intMod(this._hour, 12));
        case ChronoField.HOUR_OF_DAY:
          return this.withHour(newValue);
        case ChronoField.CLOCK_HOUR_OF_DAY:
          return this.withHour(newValue === 24 ? 0 : newValue);
        case ChronoField.AMPM_OF_DAY:
          return this.plusHours((newValue - MathUtil.intDiv(this._hour, 12)) * 12);
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.adjustInto(this, newValue);
  };
  _proto.withHour = function withHour(hour) {
    if (hour === void 0) {
      hour = 0;
    }
    if (this._hour === hour) {
      return this;
    }
    return new LocalTime(hour, this._minute, this._second, this._nano);
  };
  _proto.withMinute = function withMinute(minute) {
    if (minute === void 0) {
      minute = 0;
    }
    if (this._minute === minute) {
      return this;
    }
    return new LocalTime(this._hour, minute, this._second, this._nano);
  };
  _proto.withSecond = function withSecond(second) {
    if (second === void 0) {
      second = 0;
    }
    if (this._second === second) {
      return this;
    }
    return new LocalTime(this._hour, this._minute, second, this._nano);
  };
  _proto.withNano = function withNano(nanoOfSecond) {
    if (nanoOfSecond === void 0) {
      nanoOfSecond = 0;
    }
    if (this._nano === nanoOfSecond) {
      return this;
    }
    return new LocalTime(this._hour, this._minute, this._second, nanoOfSecond);
  };
  _proto.truncatedTo = function truncatedTo(unit) {
    requireNonNull(unit, 'unit');
    if (unit === ChronoUnit.NANOS) {
      return this;
    }
    var unitDur = unit.duration();
    if (unitDur.seconds() > LocalTime.SECONDS_PER_DAY) {
      throw new DateTimeException('Unit is too large to be used for truncation');
    }
    var dur = unitDur.toNanos();
    if (MathUtil.intMod(LocalTime.NANOS_PER_DAY, dur) !== 0) {
      throw new DateTimeException('Unit must divide into a standard day without remainder');
    }
    var nod = this.toNanoOfDay();
    return LocalTime.ofNanoOfDay(MathUtil.intDiv(nod, dur) * dur);
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    requireNonNull(unit, 'unit');
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.NANOS:
          return this.plusNanos(amountToAdd);
        case ChronoUnit.MICROS:
          return this.plusNanos(MathUtil.intMod(amountToAdd, LocalTime.MICROS_PER_DAY) * 1000);
        case ChronoUnit.MILLIS:
          return this.plusNanos(MathUtil.intMod(amountToAdd, LocalTime.MILLIS_PER_DAY) * 1000000);
        case ChronoUnit.SECONDS:
          return this.plusSeconds(amountToAdd);
        case ChronoUnit.MINUTES:
          return this.plusMinutes(amountToAdd);
        case ChronoUnit.HOURS:
          return this.plusHours(amountToAdd);
        case ChronoUnit.HALF_DAYS:
          return this.plusHours(MathUtil.intMod(amountToAdd, 2) * 12);
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusHours = function plusHours(hoursToAdd) {
    if (hoursToAdd === 0) {
      return this;
    }
    var newHour = MathUtil.intMod(MathUtil.intMod(hoursToAdd, LocalTime.HOURS_PER_DAY) + this._hour + LocalTime.HOURS_PER_DAY, LocalTime.HOURS_PER_DAY);
    return new LocalTime(newHour, this._minute, this._second, this._nano);
  };
  _proto.plusMinutes = function plusMinutes(minutesToAdd) {
    if (minutesToAdd === 0) {
      return this;
    }
    var mofd = this._hour * LocalTime.MINUTES_PER_HOUR + this._minute;
    var newMofd = MathUtil.intMod(MathUtil.intMod(minutesToAdd, LocalTime.MINUTES_PER_DAY) + mofd + LocalTime.MINUTES_PER_DAY, LocalTime.MINUTES_PER_DAY);
    if (mofd === newMofd) {
      return this;
    }
    var newHour = MathUtil.intDiv(newMofd, LocalTime.MINUTES_PER_HOUR);
    var newMinute = MathUtil.intMod(newMofd, LocalTime.MINUTES_PER_HOUR);
    return new LocalTime(newHour, newMinute, this._second, this._nano);
  };
  _proto.plusSeconds = function plusSeconds(secondsToAdd) {
    if (secondsToAdd === 0) {
      return this;
    }
    var sofd = this._hour * LocalTime.SECONDS_PER_HOUR + this._minute * LocalTime.SECONDS_PER_MINUTE + this._second;
    var newSofd = MathUtil.intMod(MathUtil.intMod(secondsToAdd, LocalTime.SECONDS_PER_DAY) + sofd + LocalTime.SECONDS_PER_DAY, LocalTime.SECONDS_PER_DAY);
    if (sofd === newSofd) {
      return this;
    }
    var newHour = MathUtil.intDiv(newSofd, LocalTime.SECONDS_PER_HOUR);
    var newMinute = MathUtil.intMod(MathUtil.intDiv(newSofd, LocalTime.SECONDS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
    var newSecond = MathUtil.intMod(newSofd, LocalTime.SECONDS_PER_MINUTE);
    return new LocalTime(newHour, newMinute, newSecond, this._nano);
  };
  _proto.plusNanos = function plusNanos(nanosToAdd) {
    if (nanosToAdd === 0) {
      return this;
    }
    var nofd = this.toNanoOfDay();
    var newNofd = MathUtil.intMod(MathUtil.intMod(nanosToAdd, LocalTime.NANOS_PER_DAY) + nofd + LocalTime.NANOS_PER_DAY, LocalTime.NANOS_PER_DAY);
    if (nofd === newNofd) {
      return this;
    }
    var newHour = MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_HOUR);
    var newMinute = MathUtil.intMod(MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
    var newSecond = MathUtil.intMod(MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_SECOND), LocalTime.SECONDS_PER_MINUTE);
    var newNano = MathUtil.intMod(newNofd, LocalTime.NANOS_PER_SECOND);
    return new LocalTime(newHour, newMinute, newSecond, newNano);
  };
  _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
    requireNonNull(unit, 'unit');
    return this._plusUnit(-1 * amountToSubtract, unit);
  };
  _proto.minusHours = function minusHours(hoursToSubtract) {
    return this.plusHours(-1 * MathUtil.intMod(hoursToSubtract, LocalTime.HOURS_PER_DAY));
  };
  _proto.minusMinutes = function minusMinutes(minutesToSubtract) {
    return this.plusMinutes(-1 * MathUtil.intMod(minutesToSubtract, LocalTime.MINUTES_PER_DAY));
  };
  _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
    return this.plusSeconds(-1 * MathUtil.intMod(secondsToSubtract, LocalTime.SECONDS_PER_DAY));
  };
  _proto.minusNanos = function minusNanos(nanosToSubtract) {
    return this.plusNanos(-1 * MathUtil.intMod(nanosToSubtract, LocalTime.NANOS_PER_DAY));
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    if (_query === TemporalQueries.precision()) {
      return ChronoUnit.NANOS;
    } else if (_query === TemporalQueries.localTime()) {
      return this;
    }
    if (_query === TemporalQueries.chronology() || _query === TemporalQueries.zoneId() || _query === TemporalQueries.zone() || _query === TemporalQueries.offset() || _query === TemporalQueries.localDate()) {
      return null;
    }
    return _query.queryFrom(this);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    return temporal.with(LocalTime.NANO_OF_DAY, this.toNanoOfDay());
  };
  _proto.until = function until(endExclusive, unit) {
    requireNonNull(endExclusive, 'endExclusive');
    requireNonNull(unit, 'unit');
    var end = LocalTime.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      var nanosUntil = end.toNanoOfDay() - this.toNanoOfDay();
      switch (unit) {
        case ChronoUnit.NANOS:
          return nanosUntil;
        case ChronoUnit.MICROS:
          return MathUtil.intDiv(nanosUntil, 1000);
        case ChronoUnit.MILLIS:
          return MathUtil.intDiv(nanosUntil, 1000000);
        case ChronoUnit.SECONDS:
          return MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_SECOND);
        case ChronoUnit.MINUTES:
          return MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_MINUTE);
        case ChronoUnit.HOURS:
          return MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_HOUR);
        case ChronoUnit.HALF_DAYS:
          return MathUtil.intDiv(nanosUntil, 12 * LocalTime.NANOS_PER_HOUR);
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.between(this, end);
  };
  _proto.atDate = function atDate(date) {
    return LocalDateTime.of(date, this);
  };
  _proto.atOffset = function atOffset(offset) {
    return OffsetTime.of(this, offset);
  };
  _proto.toSecondOfDay = function toSecondOfDay() {
    var total = this._hour * LocalTime.SECONDS_PER_HOUR;
    total += this._minute * LocalTime.SECONDS_PER_MINUTE;
    total += this._second;
    return total;
  };
  _proto.toNanoOfDay = function toNanoOfDay() {
    var total = this._hour * LocalTime.NANOS_PER_HOUR;
    total += this._minute * LocalTime.NANOS_PER_MINUTE;
    total += this._second * LocalTime.NANOS_PER_SECOND;
    total += this._nano;
    return total;
  };
  _proto.compareTo = function compareTo(other) {
    requireNonNull(other, 'other');
    requireInstance(other, LocalTime, 'other');
    var cmp = MathUtil.compareNumbers(this._hour, other._hour);
    if (cmp === 0) {
      cmp = MathUtil.compareNumbers(this._minute, other._minute);
      if (cmp === 0) {
        cmp = MathUtil.compareNumbers(this._second, other._second);
        if (cmp === 0) {
          cmp = MathUtil.compareNumbers(this._nano, other._nano);
        }
      }
    }
    return cmp;
  };
  _proto.isAfter = function isAfter(other) {
    return this.compareTo(other) > 0;
  };
  _proto.isBefore = function isBefore(other) {
    return this.compareTo(other) < 0;
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof LocalTime) {
      return this._hour === other._hour && this._minute === other._minute && this._second === other._second && this._nano === other._nano;
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    var nod = this.toNanoOfDay();
    return MathUtil.hash(nod);
  };
  _proto.toString = function toString() {
    var buf = '';
    var hourValue = this._hour;
    var minuteValue = this._minute;
    var secondValue = this._second;
    var nanoValue = this._nano;
    buf += hourValue < 10 ? '0' : '';
    buf += hourValue;
    buf += minuteValue < 10 ? ':0' : ':';
    buf += minuteValue;
    if (secondValue > 0 || nanoValue > 0) {
      buf += secondValue < 10 ? ':0' : ':';
      buf += secondValue;
      if (nanoValue > 0) {
        buf += '.';
        if (MathUtil.intMod(nanoValue, 1000000) === 0) {
          buf += ("" + (MathUtil.intDiv(nanoValue, 1000000) + 1000)).substring(1);
        } else if (MathUtil.intMod(nanoValue, 1000) === 0) {
          buf += ("" + (MathUtil.intDiv(nanoValue, 1000) + 1000000)).substring(1);
        } else {
          buf += ("" + (nanoValue + 1000000000)).substring(1);
        }
      }
    }
    return buf;
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  _proto.format = function format(formatter) {
    requireNonNull(formatter, 'formatter');
    return formatter.format(this);
  };
  return LocalTime;
}(Temporal);
function _init$3() {
  LocalTime.HOURS = [];
  for (var hour = 0; hour < 24; hour++) {
    LocalTime.of(hour, 0, 0, 0);
  }
  LocalTime.MIN = LocalTime.HOURS[0];
  LocalTime.MAX = new LocalTime(23, 59, 59, 999999999);
  LocalTime.MIDNIGHT = LocalTime.HOURS[0];
  LocalTime.NOON = LocalTime.HOURS[12];
  LocalTime.FROM = createTemporalQuery('LocalTime.FROM', function (temporal) {
    return LocalTime.from(temporal);
  });
}
LocalTime.HOURS_PER_DAY = 24;
LocalTime.MINUTES_PER_HOUR = 60;
LocalTime.MINUTES_PER_DAY = LocalTime.MINUTES_PER_HOUR * LocalTime.HOURS_PER_DAY;
LocalTime.SECONDS_PER_MINUTE = 60;
LocalTime.SECONDS_PER_HOUR = LocalTime.SECONDS_PER_MINUTE * LocalTime.MINUTES_PER_HOUR;
LocalTime.SECONDS_PER_DAY = LocalTime.SECONDS_PER_HOUR * LocalTime.HOURS_PER_DAY;
LocalTime.MILLIS_PER_DAY = LocalTime.SECONDS_PER_DAY * 1000;
LocalTime.MICROS_PER_DAY = LocalTime.SECONDS_PER_DAY * 1000000;
LocalTime.NANOS_PER_SECOND = 1000000000;
LocalTime.NANOS_PER_MINUTE = LocalTime.NANOS_PER_SECOND * LocalTime.SECONDS_PER_MINUTE;
LocalTime.NANOS_PER_HOUR = LocalTime.NANOS_PER_MINUTE * LocalTime.MINUTES_PER_HOUR;
LocalTime.NANOS_PER_DAY = LocalTime.NANOS_PER_HOUR * LocalTime.HOURS_PER_DAY;

var NANOS_PER_MILLI = 1000000;
var Instant = function (_Temporal) {
  _inheritsLoose(Instant, _Temporal);
  Instant.now = function now(clock) {
    if (clock === void 0) {
      clock = Clock.systemUTC();
    }
    return clock.instant();
  };
  Instant.ofEpochSecond = function ofEpochSecond(epochSecond, nanoAdjustment) {
    if (nanoAdjustment === void 0) {
      nanoAdjustment = 0;
    }
    var secs = epochSecond + MathUtil.floorDiv(nanoAdjustment, LocalTime.NANOS_PER_SECOND);
    var nos = MathUtil.floorMod(nanoAdjustment, LocalTime.NANOS_PER_SECOND);
    return Instant._create(secs, nos);
  };
  Instant.ofEpochMilli = function ofEpochMilli(epochMilli) {
    var secs = MathUtil.floorDiv(epochMilli, 1000);
    var mos = MathUtil.floorMod(epochMilli, 1000);
    return Instant._create(secs, mos * 1000000);
  };
  Instant.ofEpochMicro = function ofEpochMicro(epochMicro) {
    var secs = MathUtil.floorDiv(epochMicro, 1000000);
    var mos = MathUtil.floorMod(epochMicro, 1000000);
    return Instant._create(secs, mos * 1000);
  };
  Instant.from = function from(temporal) {
    try {
      var instantSecs = temporal.getLong(ChronoField.INSTANT_SECONDS);
      var nanoOfSecond = temporal.get(ChronoField.NANO_OF_SECOND);
      return Instant.ofEpochSecond(instantSecs, nanoOfSecond);
    } catch (ex) {
      throw new DateTimeException("Unable to obtain Instant from TemporalAccessor: " + temporal + ", type " + typeof temporal, ex);
    }
  };
  Instant.parse = function parse(text) {
    return DateTimeFormatter.ISO_INSTANT.parse(text, Instant.FROM);
  };
  Instant._create = function _create(seconds, nanoOfSecond) {
    if (seconds === 0 && nanoOfSecond === 0) {
      return Instant.EPOCH;
    }
    return new Instant(seconds, nanoOfSecond);
  };
  Instant._validate = function _validate(seconds, nanoOfSecond) {
    if (seconds < Instant.MIN_SECONDS || seconds > Instant.MAX_SECONDS) {
      throw new DateTimeException('Instant exceeds minimum or maximum instant');
    }
    if (nanoOfSecond < 0 || nanoOfSecond > LocalTime.NANOS_PER_SECOND) {
      throw new DateTimeException('Instant exceeds minimum or maximum instant');
    }
  };
  function Instant(seconds, nanoOfSecond) {
    var _this;
    _this = _Temporal.call(this) || this;
    Instant._validate(seconds, nanoOfSecond);
    _this._seconds = MathUtil.safeToInt(seconds);
    _this._nanos = MathUtil.safeToInt(nanoOfSecond);
    return _this;
  }
  var _proto = Instant.prototype;
  _proto.isSupported = function isSupported(fieldOrUnit) {
    if (fieldOrUnit instanceof ChronoField) {
      return fieldOrUnit === ChronoField.INSTANT_SECONDS || fieldOrUnit === ChronoField.NANO_OF_SECOND || fieldOrUnit === ChronoField.MICRO_OF_SECOND || fieldOrUnit === ChronoField.MILLI_OF_SECOND;
    }
    if (fieldOrUnit instanceof ChronoUnit) {
      return fieldOrUnit.isTimeBased() || fieldOrUnit === ChronoUnit.DAYS;
    }
    return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
  };
  _proto.range = function range(field) {
    return _Temporal.prototype.range.call(this, field);
  };
  _proto.get = function get(field) {
    return this.getLong(field);
  };
  _proto.getLong = function getLong(field) {
    if (field instanceof ChronoField) {
      switch (field) {
        case ChronoField.NANO_OF_SECOND:
          return this._nanos;
        case ChronoField.MICRO_OF_SECOND:
          return MathUtil.intDiv(this._nanos, 1000);
        case ChronoField.MILLI_OF_SECOND:
          return MathUtil.intDiv(this._nanos, NANOS_PER_MILLI);
        case ChronoField.INSTANT_SECONDS:
          return this._seconds;
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.getFrom(this);
  };
  _proto.epochSecond = function epochSecond() {
    return this._seconds;
  };
  _proto.nano = function nano() {
    return this._nanos;
  };
  _proto._withField = function _withField(field, newValue) {
    requireNonNull(field, 'field');
    if (field instanceof ChronoField) {
      field.checkValidValue(newValue);
      switch (field) {
        case ChronoField.MILLI_OF_SECOND:
          {
            var nval = newValue * NANOS_PER_MILLI;
            return nval !== this._nanos ? Instant._create(this._seconds, nval) : this;
          }
        case ChronoField.MICRO_OF_SECOND:
          {
            var _nval = newValue * 1000;
            return _nval !== this._nanos ? Instant._create(this._seconds, _nval) : this;
          }
        case ChronoField.NANO_OF_SECOND:
          return newValue !== this._nanos ? Instant._create(this._seconds, newValue) : this;
        case ChronoField.INSTANT_SECONDS:
          return newValue !== this._seconds ? Instant._create(newValue, this._nanos) : this;
      }
      throw new UnsupportedTemporalTypeException("Unsupported field: " + field);
    }
    return field.adjustInto(this, newValue);
  };
  _proto.truncatedTo = function truncatedTo(unit) {
    requireNonNull(unit, 'unit');
    if (unit === ChronoUnit.NANOS) {
      return this;
    }
    var unitDur = unit.duration();
    if (unitDur.seconds() > LocalTime.SECONDS_PER_DAY) {
      throw new DateTimeException('Unit is too large to be used for truncation');
    }
    var dur = unitDur.toNanos();
    if (MathUtil.intMod(LocalTime.NANOS_PER_DAY, dur) !== 0) {
      throw new DateTimeException('Unit must divide into a standard day without remainder');
    }
    var nod = MathUtil.intMod(this._seconds, LocalTime.SECONDS_PER_DAY) * LocalTime.NANOS_PER_SECOND + this._nanos;
    var result = MathUtil.intDiv(nod, dur) * dur;
    return this.plusNanos(result - nod);
  };
  _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
    requireNonNull(amountToAdd, 'amountToAdd');
    requireNonNull(unit, 'unit');
    requireInstance(unit, TemporalUnit);
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.NANOS:
          return this.plusNanos(amountToAdd);
        case ChronoUnit.MICROS:
          return this.plusMicros(amountToAdd);
        case ChronoUnit.MILLIS:
          return this.plusMillis(amountToAdd);
        case ChronoUnit.SECONDS:
          return this.plusSeconds(amountToAdd);
        case ChronoUnit.MINUTES:
          return this.plusSeconds(MathUtil.safeMultiply(amountToAdd, LocalTime.SECONDS_PER_MINUTE));
        case ChronoUnit.HOURS:
          return this.plusSeconds(MathUtil.safeMultiply(amountToAdd, LocalTime.SECONDS_PER_HOUR));
        case ChronoUnit.HALF_DAYS:
          return this.plusSeconds(MathUtil.safeMultiply(amountToAdd, LocalTime.SECONDS_PER_DAY / 2));
        case ChronoUnit.DAYS:
          return this.plusSeconds(MathUtil.safeMultiply(amountToAdd, LocalTime.SECONDS_PER_DAY));
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.addTo(this, amountToAdd);
  };
  _proto.plusSeconds = function plusSeconds(secondsToAdd) {
    return this._plus(secondsToAdd, 0);
  };
  _proto.plusMillis = function plusMillis(millisToAdd) {
    return this._plus(MathUtil.intDiv(millisToAdd, 1000), MathUtil.intMod(millisToAdd, 1000) * NANOS_PER_MILLI);
  };
  _proto.plusNanos = function plusNanos(nanosToAdd) {
    return this._plus(0, nanosToAdd);
  };
  _proto.plusMicros = function plusMicros(microsToAdd) {
    return this._plus(MathUtil.intDiv(microsToAdd, 1000000), MathUtil.intMod(microsToAdd, 1000000) * 1000);
  };
  _proto._plus = function _plus(secondsToAdd, nanosToAdd) {
    if (secondsToAdd === 0 && nanosToAdd === 0) {
      return this;
    }
    var epochSec = this._seconds + secondsToAdd;
    epochSec = epochSec + MathUtil.intDiv(nanosToAdd, LocalTime.NANOS_PER_SECOND);
    var nanoAdjustment = this._nanos + nanosToAdd % LocalTime.NANOS_PER_SECOND;
    return Instant.ofEpochSecond(epochSec, nanoAdjustment);
  };
  _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
    return this._plusUnit(-1 * amountToSubtract, unit);
  };
  _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
    return this.plusSeconds(secondsToSubtract * -1);
  };
  _proto.minusMillis = function minusMillis(millisToSubtract) {
    return this.plusMillis(-1 * millisToSubtract);
  };
  _proto.minusNanos = function minusNanos(nanosToSubtract) {
    return this.plusNanos(-1 * nanosToSubtract);
  };
  _proto.minusMicros = function minusMicros(microsToSubtract) {
    return this.plusMicros(-1 * microsToSubtract);
  };
  _proto.query = function query(_query) {
    requireNonNull(_query, 'query');
    if (_query === TemporalQueries.precision()) {
      return ChronoUnit.NANOS;
    }
    if (_query === TemporalQueries.localDate() || _query === TemporalQueries.localTime() || _query === TemporalQueries.chronology() || _query === TemporalQueries.zoneId() || _query === TemporalQueries.zone() || _query === TemporalQueries.offset()) {
      return null;
    }
    return _query.queryFrom(this);
  };
  _proto.adjustInto = function adjustInto(temporal) {
    requireNonNull(temporal, 'temporal');
    return temporal.with(ChronoField.INSTANT_SECONDS, this._seconds).with(ChronoField.NANO_OF_SECOND, this._nanos);
  };
  _proto.until = function until(endExclusive, unit) {
    requireNonNull(endExclusive, 'endExclusive');
    requireNonNull(unit, 'unit');
    var end = Instant.from(endExclusive);
    if (unit instanceof ChronoUnit) {
      switch (unit) {
        case ChronoUnit.NANOS:
          return this._nanosUntil(end);
        case ChronoUnit.MICROS:
          return this._microsUntil(end);
        case ChronoUnit.MILLIS:
          return MathUtil.safeSubtract(end.toEpochMilli(), this.toEpochMilli());
        case ChronoUnit.SECONDS:
          return this._secondsUntil(end);
        case ChronoUnit.MINUTES:
          return MathUtil.intDiv(this._secondsUntil(end), LocalTime.SECONDS_PER_MINUTE);
        case ChronoUnit.HOURS:
          return MathUtil.intDiv(this._secondsUntil(end), LocalTime.SECONDS_PER_HOUR);
        case ChronoUnit.HALF_DAYS:
          return MathUtil.intDiv(this._secondsUntil(end), 12 * LocalTime.SECONDS_PER_HOUR);
        case ChronoUnit.DAYS:
          return MathUtil.intDiv(this._secondsUntil(end), LocalTime.SECONDS_PER_DAY);
      }
      throw new UnsupportedTemporalTypeException("Unsupported unit: " + unit);
    }
    return unit.between(this, end);
  };
  _proto._microsUntil = function _microsUntil(end) {
    var secsDiff = MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
    var totalMicros = MathUtil.safeMultiply(secsDiff, 1000000);
    return MathUtil.safeAdd(totalMicros, MathUtil.intDiv(end.nano() - this.nano(), 1000));
  };
  _proto._nanosUntil = function _nanosUntil(end) {
    var secsDiff = MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
    var totalNanos = MathUtil.safeMultiply(secsDiff, LocalTime.NANOS_PER_SECOND);
    return MathUtil.safeAdd(totalNanos, end.nano() - this.nano());
  };
  _proto._secondsUntil = function _secondsUntil(end) {
    var secsDiff = MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
    var nanosDiff = end.nano() - this.nano();
    if (secsDiff > 0 && nanosDiff < 0) {
      secsDiff--;
    } else if (secsDiff < 0 && nanosDiff > 0) {
      secsDiff++;
    }
    return secsDiff;
  };
  _proto.atOffset = function atOffset(offset) {
    return OffsetDateTime.ofInstant(this, offset);
  };
  _proto.atZone = function atZone(zone) {
    return ZonedDateTime.ofInstant(this, zone);
  };
  _proto.toEpochMilli = function toEpochMilli() {
    var millis = MathUtil.safeMultiply(this._seconds, 1000);
    return millis + MathUtil.intDiv(this._nanos, NANOS_PER_MILLI);
  };
  _proto.compareTo = function compareTo(otherInstant) {
    requireNonNull(otherInstant, 'otherInstant');
    requireInstance(otherInstant, Instant, 'otherInstant');
    var cmp = MathUtil.compareNumbers(this._seconds, otherInstant._seconds);
    if (cmp !== 0) {
      return cmp;
    }
    return this._nanos - otherInstant._nanos;
  };
  _proto.isAfter = function isAfter(otherInstant) {
    return this.compareTo(otherInstant) > 0;
  };
  _proto.isBefore = function isBefore(otherInstant) {
    return this.compareTo(otherInstant) < 0;
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    if (other instanceof Instant) {
      return this.epochSecond() === other.epochSecond() && this.nano() === other.nano();
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return MathUtil.hashCode(this._seconds, this._nanos);
  };
  _proto.toString = function toString() {
    return DateTimeFormatter.ISO_INSTANT.format(this);
  };
  _proto.toJSON = function toJSON() {
    return this.toString();
  };
  return Instant;
}(Temporal);
function _init$2() {
  Instant.MIN_SECONDS = -31619119219200;
  Instant.MAX_SECONDS = 31494816403199;
  Instant.EPOCH = new Instant(0, 0);
  Instant.MIN = Instant.ofEpochSecond(Instant.MIN_SECONDS, 0);
  Instant.MAX = Instant.ofEpochSecond(Instant.MAX_SECONDS, 999999999);
  Instant.FROM = createTemporalQuery('Instant.FROM', function (temporal) {
    return Instant.from(temporal);
  });
}

var Clock = function () {
  function Clock() {}
  Clock.systemUTC = function systemUTC() {
    return new SystemClock(ZoneOffset.UTC);
  };
  Clock.systemDefaultZone = function systemDefaultZone() {
    return new SystemClock(ZoneId.systemDefault());
  };
  Clock.system = function system(zone) {
    return new SystemClock(zone);
  };
  Clock.fixed = function fixed(fixedInstant, zoneId) {
    return new FixedClock(fixedInstant, zoneId);
  };
  Clock.offset = function offset(baseClock, duration) {
    return new OffsetClock(baseClock, duration);
  };
  var _proto = Clock.prototype;
  _proto.millis = function millis() {
    abstractMethodFail('Clock.millis');
  };
  _proto.instant = function instant() {
    abstractMethodFail('Clock.instant');
  };
  _proto.zone = function zone() {
    abstractMethodFail('Clock.zone');
  };
  _proto.withZone = function withZone() {
    abstractMethodFail('Clock.withZone');
  };
  return Clock;
}();
var SystemClock = function (_Clock) {
  _inheritsLoose(SystemClock, _Clock);
  function SystemClock(zone) {
    var _this;
    requireNonNull(zone, 'zone');
    _this = _Clock.call(this) || this;
    _this._zone = zone;
    return _this;
  }
  var _proto2 = SystemClock.prototype;
  _proto2.zone = function zone() {
    return this._zone;
  };
  _proto2.millis = function millis() {
    return new Date().getTime();
  };
  _proto2.instant = function instant() {
    return Instant.ofEpochMilli(this.millis());
  };
  _proto2.equals = function equals(obj) {
    if (obj instanceof SystemClock) {
      return this._zone.equals(obj._zone);
    }
    return false;
  };
  _proto2.withZone = function withZone(zone) {
    if (zone.equals(this._zone)) {
      return this;
    }
    return new SystemClock(zone);
  };
  _proto2.toString = function toString() {
    return "SystemClock[" + this._zone.toString() + "]";
  };
  return SystemClock;
}(Clock);
var FixedClock = function (_Clock2) {
  _inheritsLoose(FixedClock, _Clock2);
  function FixedClock(fixedInstant, zoneId) {
    var _this2;
    _this2 = _Clock2.call(this) || this;
    _this2._instant = fixedInstant;
    _this2._zoneId = zoneId;
    return _this2;
  }
  var _proto3 = FixedClock.prototype;
  _proto3.instant = function instant() {
    return this._instant;
  };
  _proto3.millis = function millis() {
    return this._instant.toEpochMilli();
  };
  _proto3.zone = function zone() {
    return this._zoneId;
  };
  _proto3.toString = function toString() {
    return 'FixedClock[]';
  };
  _proto3.equals = function equals(obj) {
    if (obj instanceof FixedClock) {
      return this._instant.equals(obj._instant) && this._zoneId.equals(obj._zoneId);
    }
    return false;
  };
  _proto3.withZone = function withZone(zone) {
    if (zone.equals(this._zoneId)) {
      return this;
    }
    return new FixedClock(this._instant, zone);
  };
  return FixedClock;
}(Clock);
var OffsetClock = function (_Clock3) {
  _inheritsLoose(OffsetClock, _Clock3);
  function OffsetClock(baseClock, offset) {
    var _this3;
    _this3 = _Clock3.call(this) || this;
    _this3._baseClock = baseClock;
    _this3._offset = offset;
    return _this3;
  }
  var _proto4 = OffsetClock.prototype;
  _proto4.zone = function zone() {
    return this._baseClock.zone();
  };
  _proto4.withZone = function withZone(zone) {
    if (zone.equals(this._baseClock.zone())) {
      return this;
    }
    return new OffsetClock(this._baseClock.withZone(zone), this._offset);
  };
  _proto4.millis = function millis() {
    return this._baseClock.millis() + this._offset.toMillis();
  };
  _proto4.instant = function instant() {
    return this._baseClock.instant().plus(this._offset);
  };
  _proto4.equals = function equals(obj) {
    if (obj instanceof OffsetClock) {
      return this._baseClock.equals(obj._baseClock) && this._offset.equals(obj._offset);
    }
    return false;
  };
  _proto4.toString = function toString() {
    return "OffsetClock[" + this._baseClock + "," + this._offset + "]";
  };
  return OffsetClock;
}(Clock);

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var ZoneOffsetTransition = function () {
  ZoneOffsetTransition.of = function of(transition, offsetBefore, offsetAfter) {
    return new ZoneOffsetTransition(transition, offsetBefore, offsetAfter);
  };
  function ZoneOffsetTransition(transition, offsetBefore, offsetAfter) {
    requireNonNull(transition, 'transition');
    requireNonNull(offsetBefore, 'offsetBefore');
    requireNonNull(offsetAfter, 'offsetAfter');
    if (offsetBefore.equals(offsetAfter)) {
      throw new IllegalArgumentException('Offsets must not be equal');
    }
    if (transition.nano() !== 0) {
      throw new IllegalArgumentException('Nano-of-second must be zero');
    }
    if (transition instanceof LocalDateTime) {
      this._transition = transition;
    } else {
      this._transition = LocalDateTime.ofEpochSecond(transition, 0, offsetBefore);
    }
    this._offsetBefore = offsetBefore;
    this._offsetAfter = offsetAfter;
  }
  var _proto = ZoneOffsetTransition.prototype;
  _proto.instant = function instant() {
    return this._transition.toInstant(this._offsetBefore);
  };
  _proto.toEpochSecond = function toEpochSecond() {
    return this._transition.toEpochSecond(this._offsetBefore);
  };
  _proto.dateTimeBefore = function dateTimeBefore() {
    return this._transition;
  };
  _proto.dateTimeAfter = function dateTimeAfter() {
    return this._transition.plusSeconds(this.durationSeconds());
  };
  _proto.offsetBefore = function offsetBefore() {
    return this._offsetBefore;
  };
  _proto.offsetAfter = function offsetAfter() {
    return this._offsetAfter;
  };
  _proto.duration = function duration() {
    return Duration.ofSeconds(this.durationSeconds());
  };
  _proto.durationSeconds = function durationSeconds() {
    return this._offsetAfter.totalSeconds() - this._offsetBefore.totalSeconds();
  };
  _proto.isGap = function isGap() {
    return this._offsetAfter.totalSeconds() > this._offsetBefore.totalSeconds();
  };
  _proto.isOverlap = function isOverlap() {
    return this._offsetAfter.totalSeconds() < this._offsetBefore.totalSeconds();
  };
  _proto.isValidOffset = function isValidOffset(offset) {
    return this.isGap() ? false : this._offsetBefore.equals(offset) || this._offsetAfter.equals(offset);
  };
  _proto.validOffsets = function validOffsets() {
    if (this.isGap()) {
      return [];
    } else {
      return [this._offsetBefore, this._offsetAfter];
    }
  };
  _proto.compareTo = function compareTo(transition) {
    return this.instant().compareTo(transition.instant());
  };
  _proto.equals = function equals(other) {
    if (other === this) {
      return true;
    }
    if (other instanceof ZoneOffsetTransition) {
      var d = other;
      return this._transition.equals(d._transition) && this._offsetBefore.equals(d.offsetBefore()) && this._offsetAfter.equals(d.offsetAfter());
    }
    return false;
  };
  _proto.hashCode = function hashCode() {
    return this._transition.hashCode() ^ this._offsetBefore.hashCode() ^ this._offsetAfter.hashCode() >>> 16;
  };
  _proto.toString = function toString() {
    return "Transition[" + (this.isGap() ? 'Gap' : 'Overlap') + " at " + this._transition.toString() + this._offsetBefore.toString() + " to " + this._offsetAfter + "]";
  };
  return ZoneOffsetTransition;
}();

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
function _init$1() {
  TemporalQueries.ZONE_ID = createTemporalQuery('ZONE_ID', function (temporal) {
    return temporal.query(TemporalQueries.ZONE_ID);
  });
  TemporalQueries.CHRONO = createTemporalQuery('CHRONO', function (temporal) {
    return temporal.query(TemporalQueries.CHRONO);
  });
  TemporalQueries.PRECISION = createTemporalQuery('PRECISION', function (temporal) {
    return temporal.query(TemporalQueries.PRECISION);
  });
  TemporalQueries.OFFSET = createTemporalQuery('OFFSET', function (temporal) {
    if (temporal.isSupported(ChronoField.OFFSET_SECONDS)) {
      return ZoneOffset.ofTotalSeconds(temporal.get(ChronoField.OFFSET_SECONDS));
    }
    return null;
  });
  TemporalQueries.ZONE = createTemporalQuery('ZONE', function (temporal) {
    var zone = temporal.query(TemporalQueries.ZONE_ID);
    return zone != null ? zone : temporal.query(TemporalQueries.OFFSET);
  });
  TemporalQueries.LOCAL_DATE = createTemporalQuery('LOCAL_DATE', function (temporal) {
    if (temporal.isSupported(ChronoField.EPOCH_DAY)) {
      return LocalDate.ofEpochDay(temporal.getLong(ChronoField.EPOCH_DAY));
    }
    return null;
  });
  TemporalQueries.LOCAL_TIME = createTemporalQuery('LOCAL_TIME', function (temporal) {
    if (temporal.isSupported(ChronoField.NANO_OF_DAY)) {
      return LocalTime.ofNanoOfDay(temporal.getLong(ChronoField.NANO_OF_DAY));
    }
    return null;
  });
}

var SystemDefaultZoneRules = function (_ZoneRules) {
  _inheritsLoose(SystemDefaultZoneRules, _ZoneRules);
  function SystemDefaultZoneRules() {
    return _ZoneRules.apply(this, arguments) || this;
  }
  var _proto = SystemDefaultZoneRules.prototype;
  _proto.isFixedOffset = function isFixedOffset() {
    return false;
  };
  _proto.offsetOfInstant = function offsetOfInstant(instant) {
    var offsetInMinutes = new Date(instant.toEpochMilli()).getTimezoneOffset();
    return ZoneOffset.ofTotalMinutes(offsetInMinutes * -1);
  };
  _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
    var offsetInMinutes = new Date(epochMilli).getTimezoneOffset();
    return ZoneOffset.ofTotalMinutes(offsetInMinutes * -1);
  };
  _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
    var epochMilli = localDateTime.toEpochSecond(ZoneOffset.UTC) * 1000;
    var offsetInMinutesBeforePossibleTransition = new Date(epochMilli).getTimezoneOffset();
    var epochMilliSystemZone = epochMilli + offsetInMinutesBeforePossibleTransition * 60000;
    var offsetInMinutesAfterPossibleTransition = new Date(epochMilliSystemZone).getTimezoneOffset();
    return ZoneOffset.ofTotalMinutes(offsetInMinutesAfterPossibleTransition * -1);
  };
  _proto.validOffsets = function validOffsets(localDateTime) {
    return [this.offsetOfLocalDateTime(localDateTime)];
  };
  _proto.transition = function transition() {
    return null;
  };
  _proto.standardOffset = function standardOffset(instant) {
    return this.offsetOfInstant(instant);
  };
  _proto.daylightSavings = function daylightSavings() {
    this._throwNotSupported();
  };
  _proto.isDaylightSavings = function isDaylightSavings() {
    this._throwNotSupported();
  };
  _proto.isValidOffset = function isValidOffset(dateTime, offset) {
    return this.offsetOfLocalDateTime(dateTime).equals(offset);
  };
  _proto.nextTransition = function nextTransition() {
    this._throwNotSupported();
  };
  _proto.previousTransition = function previousTransition() {
    this._throwNotSupported();
  };
  _proto.transitions = function transitions() {
    this._throwNotSupported();
  };
  _proto.transitionRules = function transitionRules() {
    this._throwNotSupported();
  };
  _proto._throwNotSupported = function _throwNotSupported() {
    throw new DateTimeException('not supported operation');
  };
  _proto.equals = function equals(other) {
    if (this === other || other instanceof SystemDefaultZoneRules) {
      return true;
    } else {
      return false;
    }
  };
  _proto.toString = function toString() {
    return 'SYSTEM';
  };
  return SystemDefaultZoneRules;
}(ZoneRules);

var SystemDefaultZoneId = function (_ZoneId) {
  _inheritsLoose(SystemDefaultZoneId, _ZoneId);
  function SystemDefaultZoneId() {
    var _this;
    _this = _ZoneId.call(this) || this;
    _this._rules = new SystemDefaultZoneRules();
    return _this;
  }
  var _proto = SystemDefaultZoneId.prototype;
  _proto.rules = function rules() {
    return this._rules;
  };
  _proto.equals = function equals(other) {
    if (this === other) {
      return true;
    }
    return false;
  };
  _proto.id = function id() {
    return 'SYSTEM';
  };
  return SystemDefaultZoneId;
}(ZoneId);

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var ZoneIdFactory = function () {
  function ZoneIdFactory() {}
  ZoneIdFactory.systemDefault = function systemDefault() {
    return SYSTEM_DEFAULT_ZONE_ID_INSTANCE;
  };
  ZoneIdFactory.getAvailableZoneIds = function getAvailableZoneIds() {
    return ZoneRulesProvider.getAvailableZoneIds();
  };
  ZoneIdFactory.of = function of(zoneId) {
    requireNonNull(zoneId, 'zoneId');
    if (zoneId === 'Z') {
      return ZoneOffset.UTC;
    }
    if (zoneId.length === 1) {
      throw new DateTimeException("Invalid zone: " + zoneId);
    }
    if (StringUtil.startsWith(zoneId, '+') || StringUtil.startsWith(zoneId, '-')) {
      return ZoneOffset.of(zoneId);
    }
    if (zoneId === 'UTC' || zoneId === 'GMT' || zoneId === 'GMT0' || zoneId === 'UT') {
      return new ZoneRegion(zoneId, ZoneOffset.UTC.rules());
    }
    if (StringUtil.startsWith(zoneId, 'UTC+') || StringUtil.startsWith(zoneId, 'GMT+') || StringUtil.startsWith(zoneId, 'UTC-') || StringUtil.startsWith(zoneId, 'GMT-')) {
      var offset = ZoneOffset.of(zoneId.substring(3));
      if (offset.totalSeconds() === 0) {
        return new ZoneRegion(zoneId.substring(0, 3), offset.rules());
      }
      return new ZoneRegion(zoneId.substring(0, 3) + offset.id(), offset.rules());
    }
    if (StringUtil.startsWith(zoneId, 'UT+') || StringUtil.startsWith(zoneId, 'UT-')) {
      var _offset = ZoneOffset.of(zoneId.substring(2));
      if (_offset.totalSeconds() === 0) {
        return new ZoneRegion('UT', _offset.rules());
      }
      return new ZoneRegion("UT" + _offset.id(), _offset.rules());
    }
    if (zoneId === 'SYSTEM') {
      return ZoneId.systemDefault();
    }
    return ZoneRegion.ofId(zoneId);
  };
  ZoneIdFactory.ofOffset = function ofOffset(prefix, offset) {
    requireNonNull(prefix, 'prefix');
    requireNonNull(offset, 'offset');
    if (prefix.length === 0) {
      return offset;
    }
    if (prefix === 'GMT' || prefix === 'UTC' || prefix === 'UT') {
      if (offset.totalSeconds() === 0) {
        return new ZoneRegion(prefix, offset.rules());
      }
      return new ZoneRegion(prefix + offset.id(), offset.rules());
    }
    throw new IllegalArgumentException("Invalid prefix, must be GMT, UTC or UT: " + prefix);
  };
  ZoneIdFactory.from = function from(temporal) {
    requireNonNull(temporal, 'temporal');
    var obj = temporal.query(TemporalQueries.zone());
    if (obj == null) {
      throw new DateTimeException("Unable to obtain ZoneId from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
    }
    return obj;
  };
  return ZoneIdFactory;
}();
var SYSTEM_DEFAULT_ZONE_ID_INSTANCE = null;
function _init() {
  SYSTEM_DEFAULT_ZONE_ID_INSTANCE = new SystemDefaultZoneId();
  ZoneId.systemDefault = ZoneIdFactory.systemDefault;
  ZoneId.getAvailableZoneIds = ZoneIdFactory.getAvailableZoneIds;
  ZoneId.of = ZoneIdFactory.of;
  ZoneId.ofOffset = ZoneIdFactory.ofOffset;
  ZoneId.from = ZoneIdFactory.from;
  ZoneOffset.from = ZoneIdFactory.from;
  ZoneId.SYSTEM = SYSTEM_DEFAULT_ZONE_ID_INSTANCE;
  ZoneId.UTC = ZoneOffset.ofTotalSeconds(0);
}

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var isInit = false;
function init() {
  if (isInit) {
    return;
  }
  isInit = true;
  _init$m();
  _init$n();
  _init$l();
  _init$k();
  _init$3();
  _init$f();
  _init$1();
  _init$j();
  _init$2();
  _init$5();
  _init$4();
  _init$a();
  _init$i();
  _init$b();
  _init$c();
  _init$h();
  _init$g();
  _init$7();
  _init();
  _init$9();
  _init$d();
  _init$e();
  _init$6();
  _init$8();
}
init();

/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var ToNativeJsConverter = function () {
  function ToNativeJsConverter(temporal, zone) {
    var zonedDateTime;
    if (temporal instanceof Instant) {
      this.instant = temporal;
      return;
    } else if (temporal instanceof LocalDate) {
      zone = zone == null ? ZoneId.systemDefault() : zone;
      zonedDateTime = temporal.atStartOfDay(zone);
    } else if (temporal instanceof LocalDateTime) {
      zone = zone == null ? ZoneId.systemDefault() : zone;
      zonedDateTime = temporal.atZone(zone);
    } else if (temporal instanceof ZonedDateTime) {
      if (zone == null) {
        zonedDateTime = temporal;
      } else {
        zonedDateTime = temporal.withZoneSameInstant(zone);
      }
    } else {
      throw new IllegalArgumentException("unsupported instance for convert operation:" + temporal);
    }
    this.instant = zonedDateTime.toInstant();
  }
  var _proto = ToNativeJsConverter.prototype;
  _proto.toDate = function toDate() {
    return new Date(this.instant.toEpochMilli());
  };
  _proto.toEpochMilli = function toEpochMilli() {
    return this.instant.toEpochMilli();
  };
  return ToNativeJsConverter;
}();
function convert(temporal, zone) {
  return new ToNativeJsConverter(temporal, zone);
}

/*
 * @copyright (c) 2015-present, Philipp Thürwächter, Pattrick Hüper & js-joda contributors
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
function nativeJs(date, zone) {
  if (zone === void 0) {
    zone = ZoneId.systemDefault();
  }
  requireNonNull(date, 'date');
  requireNonNull(zone, 'zone');
  if (date instanceof Date) {
    return Instant.ofEpochMilli(date.getTime()).atZone(zone);
  } else if (typeof date.toDate === 'function' && date.toDate() instanceof Date) {
    return Instant.ofEpochMilli(date.toDate().getTime()).atZone(zone);
  }
  throw new IllegalArgumentException('date must be a javascript Date or a moment instance');
}

function bindUse(jsJoda) {
  var used = [];
  return function use(fn) {
    if (!~used.indexOf(fn)) {
      fn(jsJoda);
      used.push(fn);
    }
    return jsJoda;
  };
}

/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */
var _ = {
  assert: assert$1,
  DateTimeBuilder: DateTimeBuilder,
  DateTimeParseContext: DateTimeParseContext,
  DateTimePrintContext: DateTimePrintContext,
  MathUtil: MathUtil,
  StringUtil: StringUtil,
  StringBuilder: StringBuilder
};
var jsJodaExports = {
  _: _,
  convert: convert,
  nativeJs: nativeJs,
  ArithmeticException: ArithmeticException,
  DateTimeException: DateTimeException,
  DateTimeParseException: DateTimeParseException,
  IllegalArgumentException: IllegalArgumentException,
  IllegalStateException: IllegalStateException,
  UnsupportedTemporalTypeException: UnsupportedTemporalTypeException,
  NullPointerException: NullPointerException,
  Clock: Clock,
  DayOfWeek: DayOfWeek,
  Duration: Duration,
  Instant: Instant,
  LocalDate: LocalDate,
  LocalTime: LocalTime,
  LocalDateTime: LocalDateTime,
  OffsetTime: OffsetTime,
  OffsetDateTime: OffsetDateTime,
  Month: Month,
  MonthDay: MonthDay,
  ParsePosition: ParsePosition,
  Period: Period,
  Year: Year,
  YearConstants: YearConstants,
  YearMonth: YearMonth,
  ZonedDateTime: ZonedDateTime,
  ZoneOffset: ZoneOffset,
  ZoneId: ZoneId,
  ZoneRegion: ZoneRegion,
  ZoneOffsetTransition: ZoneOffsetTransition,
  ZoneRules: ZoneRules,
  ZoneRulesProvider: ZoneRulesProvider,
  ChronoLocalDate: ChronoLocalDate,
  ChronoLocalDateTime: ChronoLocalDateTime,
  ChronoZonedDateTime: ChronoZonedDateTime,
  IsoChronology: IsoChronology,
  ChronoField: ChronoField,
  ChronoUnit: ChronoUnit,
  IsoFields: IsoFields,
  Temporal: Temporal,
  TemporalAccessor: TemporalAccessor,
  TemporalAdjuster: TemporalAdjuster,
  TemporalAdjusters: TemporalAdjusters,
  TemporalAmount: TemporalAmount,
  TemporalField: TemporalField,
  TemporalQueries: TemporalQueries,
  TemporalQuery: TemporalQuery,
  TemporalUnit: TemporalUnit,
  ValueRange: ValueRange,
  DateTimeFormatter: DateTimeFormatter,
  DateTimeFormatterBuilder: DateTimeFormatterBuilder,
  DecimalStyle: DecimalStyle,
  ResolverStyle: ResolverStyle,
  SignStyle: SignStyle,
  TextStyle: TextStyle
};
var use = bindUse(jsJodaExports);
jsJodaExports.use = use;

var jsJoda_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ArithmeticException: ArithmeticException,
    ChronoField: ChronoField,
    ChronoLocalDate: ChronoLocalDate,
    ChronoLocalDateTime: ChronoLocalDateTime,
    ChronoUnit: ChronoUnit,
    ChronoZonedDateTime: ChronoZonedDateTime,
    Clock: Clock,
    DateTimeException: DateTimeException,
    DateTimeFormatter: DateTimeFormatter,
    DateTimeFormatterBuilder: DateTimeFormatterBuilder,
    DateTimeParseException: DateTimeParseException,
    DayOfWeek: DayOfWeek,
    DecimalStyle: DecimalStyle,
    Duration: Duration,
    IllegalArgumentException: IllegalArgumentException,
    IllegalStateException: IllegalStateException,
    Instant: Instant,
    IsoChronology: IsoChronology,
    IsoFields: IsoFields,
    LocalDate: LocalDate,
    LocalDateTime: LocalDateTime,
    LocalTime: LocalTime,
    Month: Month,
    MonthDay: MonthDay,
    NullPointerException: NullPointerException,
    OffsetDateTime: OffsetDateTime,
    OffsetTime: OffsetTime,
    ParsePosition: ParsePosition,
    Period: Period,
    ResolverStyle: ResolverStyle,
    SignStyle: SignStyle,
    Temporal: Temporal,
    TemporalAccessor: TemporalAccessor,
    TemporalAdjuster: TemporalAdjuster,
    TemporalAdjusters: TemporalAdjusters,
    TemporalAmount: TemporalAmount,
    TemporalField: TemporalField,
    TemporalQueries: TemporalQueries,
    TemporalQuery: TemporalQuery,
    TemporalUnit: TemporalUnit,
    TextStyle: TextStyle,
    UnsupportedTemporalTypeException: UnsupportedTemporalTypeException,
    ValueRange: ValueRange,
    Year: Year,
    YearConstants: YearConstants,
    YearMonth: YearMonth,
    ZoneId: ZoneId,
    ZoneOffset: ZoneOffset,
    ZoneOffsetTransition: ZoneOffsetTransition,
    ZoneRegion: ZoneRegion,
    ZoneRules: ZoneRules,
    ZoneRulesProvider: ZoneRulesProvider,
    ZonedDateTime: ZonedDateTime,
    _: _,
    convert: convert,
    nativeJs: nativeJs,
    use: use
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(jsJoda_esm);

var hasRequiredKotlinDateTimeLibraryKotlinxDatetimeJsIr;

function requireKotlinDateTimeLibraryKotlinxDatetimeJsIr () {
	if (hasRequiredKotlinDateTimeLibraryKotlinxDatetimeJsIr) return KotlinDateTimeLibraryKotlinxDatetimeJsIrExports;
	hasRequiredKotlinDateTimeLibraryKotlinxDatetimeJsIr = 1;
	(function (module, exports) {
		(function (root, factory) {
		  if (typeof undefined === 'function' && undefined.amd)
		    undefined(['exports', '@js-joda/core', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core-js-ir.js'], factory);
		  else if ('object' === 'object')
		    factory(module.exports, require$$0, requireKotlinKotlinStdlib(), requireKotlinxSerializationKotlinxSerializationCoreJsIr());
		  else {
		    if (typeof this['@js-joda/core'] === 'undefined') {
		      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime-js-ir'. Its dependency '@js-joda/core' was not found. Please, check whether '@js-joda/core' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime-js-ir'.");
		    }
		    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
		      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime-js-ir'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime-js-ir'.");
		    }
		    if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-ir'] === 'undefined') {
		      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime-js-ir'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-ir' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-ir' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime-js-ir'.");
		    }
		    root['Kotlin-DateTime-library-kotlinx-datetime-js-ir'] = factory(typeof this['Kotlin-DateTime-library-kotlinx-datetime-js-ir'] === 'undefined' ? {} : this['Kotlin-DateTime-library-kotlinx-datetime-js-ir'], this['@js-joda/core'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core-js-ir']);
		  }
		}(commonjsGlobal, function (_, $module$_js_joda_core_gcv2k, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
		  'use strict';
		  //region block: imports
		  var Instant = $module$_js_joda_core_gcv2k.Instant;
		  var OffsetDateTime = $module$_js_joda_core_gcv2k.OffsetDateTime;
		  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.e1;
		  var protoOf = kotlin_kotlin.$_$.x7;
		  var objectCreate = kotlin_kotlin.$_$.v7;
		  var captureStack = kotlin_kotlin.$_$.l6;
		  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.d1;
		  var IllegalArgumentException = kotlin_kotlin.$_$.r9;
		  var classMeta = kotlin_kotlin.$_$.q6;
		  var setMetadataFor = kotlin_kotlin.$_$.y7;
		  var VOID = kotlin_kotlin.$_$.f;
		  var Long = kotlin_kotlin.$_$.s9;
		  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
		  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
		  var THROW_CCE = kotlin_kotlin.$_$.w9;
		  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
		  var objectMeta = kotlin_kotlin.$_$.w7;
		  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.n1;
		  var indexOf = kotlin_kotlin.$_$.n8;
		  var charSequenceLength = kotlin_kotlin.$_$.o6;
		  var charSequenceGet = kotlin_kotlin.$_$.n6;
		  var numberToInt = kotlin_kotlin.$_$.t7;
		  var equals = kotlin_kotlin.$_$.s6;
		  //endregion
		  //region block: pre-declaration
		  setMetadataFor(DateTimeFormatException, 'DateTimeFormatException', classMeta, IllegalArgumentException, VOID, DateTimeFormatException_init_$Create$);
		  setMetadataFor(InstantIso8601Serializer, 'InstantIso8601Serializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(Companion, 'Companion', objectMeta);
		  setMetadataFor(Instant_0, 'Instant', classMeta, VOID, VOID, VOID, VOID, {0: InstantIso8601Serializer_getInstance});
		  //endregion
		  function DateTimeFormatException_init_$Init$($this) {
		    IllegalArgumentException_init_$Init$($this);
		    DateTimeFormatException.call($this);
		    return $this;
		  }
		  function DateTimeFormatException_init_$Create$() {
		    var tmp = DateTimeFormatException_init_$Init$(objectCreate(protoOf(DateTimeFormatException)));
		    captureStack(tmp, DateTimeFormatException_init_$Create$);
		    return tmp;
		  }
		  function DateTimeFormatException_init_$Init$_0(cause, $this) {
		    IllegalArgumentException_init_$Init$_0(cause, $this);
		    DateTimeFormatException.call($this);
		    return $this;
		  }
		  function DateTimeFormatException_init_$Create$_0(cause) {
		    var tmp = DateTimeFormatException_init_$Init$_0(cause, objectCreate(protoOf(DateTimeFormatException)));
		    captureStack(tmp, DateTimeFormatException_init_$Create$_0);
		    return tmp;
		  }
		  function DateTimeFormatException() {
		    captureStack(this, DateTimeFormatException);
		  }
		  function get_DISTANT_PAST_SECONDS() {
		    return DISTANT_PAST_SECONDS;
		  }
		  var DISTANT_PAST_SECONDS;
		  function get_DISTANT_FUTURE_SECONDS() {
		    return DISTANT_FUTURE_SECONDS;
		  }
		  var DISTANT_FUTURE_SECONDS;
		  function InstantIso8601Serializer() {
		    InstantIso8601Serializer_instance = this;
		    this.o10_1 = PrimitiveSerialDescriptor('Instant', STRING_getInstance());
		  }
		  protoOf(InstantIso8601Serializer).uf = function () {
		    return this.o10_1;
		  };
		  protoOf(InstantIso8601Serializer).wf = function (decoder) {
		    return Companion_getInstance().t10(decoder.zi());
		  };
		  protoOf(InstantIso8601Serializer).u10 = function (encoder, value) {
		    encoder.ik(value.toString());
		  };
		  protoOf(InstantIso8601Serializer).vf = function (encoder, value) {
		    return this.u10(encoder, value instanceof Instant_0 ? value : THROW_CCE());
		  };
		  var InstantIso8601Serializer_instance;
		  function InstantIso8601Serializer_getInstance() {
		    if (InstantIso8601Serializer_instance == null)
		      new InstantIso8601Serializer();
		    return InstantIso8601Serializer_instance;
		  }
		  function fixOffsetRepresentation($this, isoString) {
		    var time = indexOf(isoString, _Char___init__impl__6a9atx(84), VOID, true);
		    if (time === -1)
		      return isoString;
		    var tmp$ret$1;
		    $l$block: {
		      // Inline function 'kotlin.text.indexOfLast' call
		      var inductionVariable = charSequenceLength(isoString) - 1 | 0;
		      if (0 <= inductionVariable)
		        do {
		          var index = inductionVariable;
		          inductionVariable = inductionVariable + -1 | 0;
		          // Inline function 'kotlinx.datetime.Companion.fixOffsetRepresentation.<anonymous>' call
		          var c = charSequenceGet(isoString, index);
		          if (c === _Char___init__impl__6a9atx(43) ? true : c === _Char___init__impl__6a9atx(45)) {
		            tmp$ret$1 = index;
		            break $l$block;
		          }
		        }
		         while (0 <= inductionVariable);
		      tmp$ret$1 = -1;
		    }
		    var offset = tmp$ret$1;
		    if (offset < time)
		      return isoString;
		    var separator = indexOf(isoString, _Char___init__impl__6a9atx(58), offset);
		    return !(separator === -1) ? isoString : isoString + ':00';
		  }
		  function Companion() {
		    Companion_instance = this;
		    this.p10_1 = new Instant_0(Instant.ofEpochSecond(get_DISTANT_PAST_SECONDS(), 999999999));
		    this.q10_1 = new Instant_0(Instant.ofEpochSecond(get_DISTANT_FUTURE_SECONDS(), 0));
		    this.r10_1 = new Instant_0(Instant.MIN);
		    this.s10_1 = new Instant_0(Instant.MAX);
		  }
		  protoOf(Companion).t10 = function (isoString) {
		    var tmp;
		    try {
		      tmp = new Instant_0(OffsetDateTime.parse(fixOffsetRepresentation(this, isoString)).toInstant());
		    } catch ($p) {
		      var tmp_0;
		      if ($p instanceof Error) {
		        var e = $p;
		        if (isJodaDateTimeParseException(e))
		          throw DateTimeFormatException_init_$Create$_0(e);
		        throw e;
		      } else {
		        throw $p;
		      }
		    }
		    return tmp;
		  };
		  var Companion_instance;
		  function Companion_getInstance() {
		    if (Companion_instance == null)
		      new Companion();
		    return Companion_instance;
		  }
		  function Instant_0(value) {
		    Companion_getInstance();
		    this.v10_1 = value;
		  }
		  protoOf(Instant_0).w10 = function (other) {
		    return numberToInt(this.v10_1.compareTo(other.v10_1));
		  };
		  protoOf(Instant_0).i9 = function (other) {
		    return this.w10(other instanceof Instant_0 ? other : THROW_CCE());
		  };
		  protoOf(Instant_0).equals = function (other) {
		    var tmp;
		    if (this === other) {
		      tmp = true;
		    } else {
		      var tmp_0;
		      if (other instanceof Instant_0) {
		        tmp_0 = equals(this.v10_1, other.v10_1);
		      } else {
		        tmp_0 = false;
		      }
		      tmp = tmp_0;
		    }
		    return tmp;
		  };
		  protoOf(Instant_0).hashCode = function () {
		    return numberToInt(this.v10_1.hashCode());
		  };
		  protoOf(Instant_0).toString = function () {
		    return this.v10_1.toString();
		  };
		  function isJodaDateTimeParseException(_this__u8e3s4) {
		    // Inline function 'kotlin.js.asDynamic' call
		    return _this__u8e3s4.name == 'DateTimeParseException';
		  }
		  //region block: init
		  DISTANT_PAST_SECONDS = new Long(-931914497, -750);
		  DISTANT_FUTURE_SECONDS = new Long(1151527680, 720);
		  //endregion
		  //region block: exports
		  _.$_$ = _.$_$ || {};
		  _.$_$.a = Companion_getInstance;
		  //endregion
		  return _;
		}));

		
} (KotlinDateTimeLibraryKotlinxDatetimeJsIr, KotlinDateTimeLibraryKotlinxDatetimeJsIrExports));
	return KotlinDateTimeLibraryKotlinxDatetimeJsIrExports;
}

var KermitKermitJsIrExports = {};
var KermitKermitJsIr = {
  get exports(){ return KermitKermitJsIrExports; },
  set exports(v){ KermitKermitJsIrExports = v; },
};

var hasRequiredKermitKermitJsIr;

function requireKermitKermitJsIr () {
	if (hasRequiredKermitKermitJsIr) return KermitKermitJsIrExports;
	hasRequiredKermitKermitJsIr = 1;
	(function (module, exports) {
		(function (root, factory) {
		  if (typeof undefined === 'function' && undefined.amd)
		    undefined(['exports', './kotlin-kotlin-stdlib.js'], factory);
		  else if ('object' === 'object')
		    factory(module.exports, requireKotlinKotlinStdlib());
		  else {
		    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
		      throw new Error("Error loading module 'Kermit-kermit-js-ir'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Kermit-kermit-js-ir'.");
		    }
		    root['Kermit-kermit-js-ir'] = factory(typeof this['Kermit-kermit-js-ir'] === 'undefined' ? {} : this['Kermit-kermit-js-ir'], this['kotlin-kotlin-stdlib']);
		  }
		}(commonjsGlobal, function (_, kotlin_kotlin) {
		  'use strict';
		  //region block: imports
		  var protoOf = kotlin_kotlin.$_$.x7;
		  var classMeta = kotlin_kotlin.$_$.q6;
		  var setMetadataFor = kotlin_kotlin.$_$.y7;
		  var objectMeta = kotlin_kotlin.$_$.w7;
		  var VOID = kotlin_kotlin.$_$.f;
		  var Unit_instance = kotlin_kotlin.$_$.w3;
		  var listOf = kotlin_kotlin.$_$.q5;
		  var THROW_IAE = kotlin_kotlin.$_$.x9;
		  var Enum = kotlin_kotlin.$_$.p9;
		  var stackTraceToString = kotlin_kotlin.$_$.ta;
		  //endregion
		  //region block: pre-declaration
		  setMetadataFor(LogWriter, 'LogWriter', classMeta);
		  setMetadataFor(Logger, 'Logger', classMeta);
		  setMetadataFor(Companion, 'Companion', objectMeta, Logger);
		  setMetadataFor(LoggerGlobal, 'LoggerGlobal', objectMeta);
		  setMetadataFor(Severity, 'Severity', classMeta, Enum);
		  setMetadataFor(ConsoleWriter, 'ConsoleWriter', classMeta, LogWriter, VOID, ConsoleWriter);
		  setMetadataFor(JsMutableLoggerConfig, 'JsMutableLoggerConfig', classMeta);
		  //endregion
		  function LogWriter() {
		  }
		  protoOf(LogWriter).g1d = function (severity) {
		    return true;
		  };
		  function get_DEFAULT_MIN_SEVERITY() {
		    _init_properties_Logger_kt__mpqsw();
		    return DEFAULT_MIN_SEVERITY;
		  }
		  var DEFAULT_MIN_SEVERITY;
		  function get_DEFAULT_TAG() {
		    return DEFAULT_TAG;
		  }
		  var DEFAULT_TAG;
		  function Companion() {
		    Companion_instance = this;
		    Logger.call(this, LoggerGlobal_getInstance().i1d_1);
		  }
		  var Companion_instance;
		  function Companion_getInstance() {
		    if (Companion_instance == null)
		      new Companion();
		    return Companion_instance;
		  }
		  function Logger(config, tag) {
		    Companion_getInstance();
		    tag = tag === VOID ? 'Kermit' : tag;
		    this.j1d_1 = config;
		    this.k1d_1 = tag;
		  }
		  protoOf(Logger).l1d = function (severity, tag, throwable, message) {
		    // Inline function 'co.touchlab.kermit.Logger.processLog' call
		    // Inline function 'kotlin.collections.forEach' call
		    var tmp0_iterator = this.j1d_1.m1d().p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'co.touchlab.kermit.Logger.processLog.<anonymous>' call
		      if (element.g1d(severity)) {
		        // Inline function 'co.touchlab.kermit.Logger.log.<anonymous>' call
		        element.h1d(severity, message, tag, throwable);
		      }
		    }
		  };
		  function LoggerGlobal() {
		    LoggerGlobal_instance = this;
		    this.i1d_1 = mutableKermitConfigInit(listOf(platformLogWriter()));
		  }
		  var LoggerGlobal_instance;
		  function LoggerGlobal_getInstance() {
		    if (LoggerGlobal_instance == null)
		      new LoggerGlobal();
		    return LoggerGlobal_instance;
		  }
		  var properties_initialized_Logger_kt_6n8a9a;
		  function _init_properties_Logger_kt__mpqsw() {
		    if (!properties_initialized_Logger_kt_6n8a9a) {
		      properties_initialized_Logger_kt_6n8a9a = true;
		      DEFAULT_MIN_SEVERITY = Severity_Verbose_getInstance();
		    }
		  }
		  var Severity_Verbose_instance;
		  var Severity_Debug_instance;
		  var Severity_Info_instance;
		  var Severity_Warn_instance;
		  var Severity_Error_instance;
		  var Severity_Assert_instance;
		  function valueOf(value) {
		    switch (value) {
		      case 'Verbose':
		        return Severity_Verbose_getInstance();
		      case 'Debug':
		        return Severity_Debug_getInstance();
		      case 'Info':
		        return Severity_Info_getInstance();
		      case 'Warn':
		        return Severity_Warn_getInstance();
		      case 'Error':
		        return Severity_Error_getInstance();
		      case 'Assert':
		        return Severity_Assert_getInstance();
		      default:
		        Severity_initEntries();
		        THROW_IAE('No enum constant value.');
		        break;
		    }
		  }
		  var Severity_entriesInitialized;
		  function Severity_initEntries() {
		    if (Severity_entriesInitialized)
		      return Unit_instance;
		    Severity_entriesInitialized = true;
		    Severity_Verbose_instance = new Severity('Verbose', 0);
		    Severity_Debug_instance = new Severity('Debug', 1);
		    Severity_Info_instance = new Severity('Info', 2);
		    Severity_Warn_instance = new Severity('Warn', 3);
		    Severity_Error_instance = new Severity('Error', 4);
		    Severity_Assert_instance = new Severity('Assert', 5);
		  }
		  function Severity(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function Severity_Verbose_getInstance() {
		    Severity_initEntries();
		    return Severity_Verbose_instance;
		  }
		  function Severity_Debug_getInstance() {
		    Severity_initEntries();
		    return Severity_Debug_instance;
		  }
		  function Severity_Info_getInstance() {
		    Severity_initEntries();
		    return Severity_Info_instance;
		  }
		  function Severity_Warn_getInstance() {
		    Severity_initEntries();
		    return Severity_Warn_instance;
		  }
		  function Severity_Error_getInstance() {
		    Severity_initEntries();
		    return Severity_Error_instance;
		  }
		  function Severity_Assert_getInstance() {
		    Severity_initEntries();
		    return Severity_Assert_instance;
		  }
		  function ConsoleWriter() {
		    LogWriter.call(this);
		  }
		  protoOf(ConsoleWriter).h1d = function (severity, message, tag, throwable) {
		    var output = '[' + tag + '] ' + message;
		    if (throwable == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      output = output + (' ' + stackTraceToString(throwable));
		    }
		    switch (severity.i8_1) {
		      case 5:
		      case 4:
		        console.error(output);
		        break;
		      case 3:
		        console.warn(output);
		        break;
		      case 2:
		        console.info(output);
		        break;
		      case 1:
		      case 0:
		        console.log(output);
		        break;
		    }
		  };
		  function JsMutableLoggerConfig(logWriters) {
		    this.n1d_1 = get_DEFAULT_MIN_SEVERITY();
		    this.o1d_1 = logWriters;
		  }
		  protoOf(JsMutableLoggerConfig).m1d = function () {
		    return this.o1d_1;
		  };
		  var defaultTag;
		  function mutableKermitConfigInit(logWriters) {
		    _init_properties_KermitConfig_kt__jdpx4y();
		    return new JsMutableLoggerConfig(logWriters);
		  }
		  var properties_initialized_KermitConfig_kt_gdrujo;
		  function _init_properties_KermitConfig_kt__jdpx4y() {
		    if (!properties_initialized_KermitConfig_kt_gdrujo) {
		      properties_initialized_KermitConfig_kt_gdrujo = true;
		      defaultTag = get_DEFAULT_TAG();
		    }
		  }
		  function platformLogWriter() {
		    return new ConsoleWriter();
		  }
		  //region block: init
		  DEFAULT_TAG = 'Kermit';
		  //endregion
		  //region block: exports
		  _.$_$ = _.$_$ || {};
		  _.$_$.a = Logger;
		  _.$_$.b = valueOf;
		  _.$_$.c = Companion_getInstance;
		  //endregion
		  return _;
		}));

		
} (KermitKermitJsIr, KermitKermitJsIrExports));
	return KermitKermitJsIrExports;
}

var hasRequiredClientsdkClientcore;

function requireClientsdkClientcore () {
	if (hasRequiredClientsdkClientcore) return clientsdkClientcoreExports;
	hasRequiredClientsdkClientcore = 1;
	(function (module, exports) {
		(function (root, factory) {
		  if (typeof undefined === 'function' && undefined.amd)
		    undefined(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core-js-ir.js', './kotlinx-serialization-kotlinx-serialization-json-js-ir.js', './Kotlin-DateTime-library-kotlinx-datetime-js-ir.js', './Kermit-kermit-js-ir.js'], factory);
		  else if ('object' === 'object')
		    factory(module.exports, requireKotlinKotlinStdlib(), requireKotlinxSerializationKotlinxSerializationCoreJsIr(), requireKotlinxSerializationKotlinxSerializationJsonJsIr(), requireKotlinDateTimeLibraryKotlinxDatetimeJsIr(), requireKermitKermitJsIr());
		  else {
		    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
		      throw new Error("Error loading module 'clientsdk-clientcore'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'clientsdk-clientcore'.");
		    }
		    if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-ir'] === 'undefined') {
		      throw new Error("Error loading module 'clientsdk-clientcore'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-ir' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-ir' is loaded prior to 'clientsdk-clientcore'.");
		    }
		    if (typeof this['kotlinx-serialization-kotlinx-serialization-json-js-ir'] === 'undefined') {
		      throw new Error("Error loading module 'clientsdk-clientcore'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json-js-ir' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json-js-ir' is loaded prior to 'clientsdk-clientcore'.");
		    }
		    if (typeof this['Kotlin-DateTime-library-kotlinx-datetime-js-ir'] === 'undefined') {
		      throw new Error("Error loading module 'clientsdk-clientcore'. Its dependency 'Kotlin-DateTime-library-kotlinx-datetime-js-ir' was not found. Please, check whether 'Kotlin-DateTime-library-kotlinx-datetime-js-ir' is loaded prior to 'clientsdk-clientcore'.");
		    }
		    if (typeof this['Kermit-kermit-js-ir'] === 'undefined') {
		      throw new Error("Error loading module 'clientsdk-clientcore'. Its dependency 'Kermit-kermit-js-ir' was not found. Please, check whether 'Kermit-kermit-js-ir' is loaded prior to 'clientsdk-clientcore'.");
		    }
		    root['clientsdk-clientcore'] = factory(typeof this['clientsdk-clientcore'] === 'undefined' ? {} : this['clientsdk-clientcore'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core-js-ir'], this['kotlinx-serialization-kotlinx-serialization-json-js-ir'], this['Kotlin-DateTime-library-kotlinx-datetime-js-ir'], this['Kermit-kermit-js-ir']);
		  }
		}(commonjsGlobal, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_co_touchlab_kermit) {
		  'use strict';
		  //region block: imports
		  var imul = Math.imul;
		  var protoOf = kotlin_kotlin.$_$.x7;
		  var objectMeta = kotlin_kotlin.$_$.w7;
		  var setMetadataFor = kotlin_kotlin.$_$.y7;
		  var interfaceMeta = kotlin_kotlin.$_$.a7;
		  var VOID = kotlin_kotlin.$_$.f;
		  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ua;
		  var Unit_instance = kotlin_kotlin.$_$.w3;
		  var THROW_CCE = kotlin_kotlin.$_$.w9;
		  var isInterface = kotlin_kotlin.$_$.i7;
		  var classMeta = kotlin_kotlin.$_$.q6;
		  var listOfNotNull = kotlin_kotlin.$_$.p5;
		  var hashCode = kotlin_kotlin.$_$.z6;
		  var equals = kotlin_kotlin.$_$.s6;
		  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.n3;
		  var arrayOf = kotlin_kotlin.$_$.ia;
		  var createKType = kotlin_kotlin.$_$.b;
		  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r2;
		  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
		  var getKClass = kotlin_kotlin.$_$.e;
		  var getStringHashCode = kotlin_kotlin.$_$.y6;
		  var ReferenceArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
		  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
		  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
		  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
		  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
		  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
		  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
		  var objectCreate = kotlin_kotlin.$_$.v7;
		  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
		  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
		  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
		  var toString = kotlin_kotlin.$_$.c8;
		  var toString_0 = kotlin_kotlin.$_$.va;
		  var EnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
		  var to = kotlin_kotlin.$_$.wa;
		  var mapOf = kotlin_kotlin.$_$.u5;
		  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
		  var put = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.q;
		  var putJsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.p;
		  var emptyMap = kotlin_kotlin.$_$.c5;
		  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
		  var JsonObjectBuilder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
		  var removePrefix = kotlin_kotlin.$_$.r8;
		  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
		  var getBooleanHashCode = kotlin_kotlin.$_$.v6;
		  var Exception_init_$Init$ = kotlin_kotlin.$_$.z;
		  var captureStack = kotlin_kotlin.$_$.l6;
		  var Exception = kotlin_kotlin.$_$.q9;
		  var defineProp = kotlin_kotlin.$_$.r6;
		  var JsonObjectSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
		  var Regex_init_$Create$ = kotlin_kotlin.$_$.v;
		  var mapOf_0 = kotlin_kotlin.$_$.t5;
		  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
		  var Long = kotlin_kotlin.$_$.s9;
		  var getNumberHashCode = kotlin_kotlin.$_$.w6;
		  var JsonContentPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
		  var NotImplementedError = kotlin_kotlin.$_$.t9;
		  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y1;
		  var Enum = kotlin_kotlin.$_$.p9;
		  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d2;
		  var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.n;
		  var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.o;
		  var startsWith = kotlin_kotlin.$_$.w8;
		  var Companion_instance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
		  var emptySet = kotlin_kotlin.$_$.d5;
		  var plus = kotlin_kotlin.$_$.v5;
		  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.r;
		  var noWhenBranchMatchedException = kotlin_kotlin.$_$.ra;
		  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.g;
		  var lazy = kotlin_kotlin.$_$.pa;
		  var EnumDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
		  var THROW_IAE = kotlin_kotlin.$_$.x9;
		  var Exception_init_$Init$_0 = kotlin_kotlin.$_$.c1;
		  var UnitSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
		  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
		  var collectionSizeOrDefault = kotlin_kotlin.$_$.m4;
		  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
		  var IllegalArgumentException = kotlin_kotlin.$_$.r9;
		  var joinToString = kotlin_kotlin.$_$.k5;
		  var Companion_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.a;
		  var Pair = kotlin_kotlin.$_$.u9;
		  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.l1;
		  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
		  var numberToLong = kotlin_kotlin.$_$.u7;
		  var Map = kotlin_kotlin.$_$.f4;
		  var MutableMap = kotlin_kotlin.$_$.h4;
		  var getKClassFromExpression = kotlin_kotlin.$_$.d;
		  var ObjectSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
		  var SealedClassSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
		  var FloatSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
		  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
		  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
		  var flatten = kotlin_kotlin.$_$.f5;
		  var Companion_getInstance_0 = kotlin_co_touchlab_kermit.$_$.c;
		  var numberRangeToNumber = kotlin_kotlin.$_$.q7;
		  var slice = kotlin_kotlin.$_$.u8;
		  var Logger = kotlin_co_touchlab_kermit.$_$.a;
		  var valueOf = kotlin_co_touchlab_kermit.$_$.b;
		  var copyToArray = kotlin_kotlin.$_$.z4;
		  var arrayConcat = kotlin_kotlin.$_$.a;
		  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.i;
		  var listOf = kotlin_kotlin.$_$.r5;
		  var listOf_0 = kotlin_kotlin.$_$.q5;
		  var Exception_init_$Create$ = kotlin_kotlin.$_$.b1;
		  var replaceFirst = kotlin_kotlin.$_$.s8;
		  var charSequenceLength = kotlin_kotlin.$_$.o6;
		  var Exception_init_$Init$_1 = kotlin_kotlin.$_$.a1;
		  var reversed = kotlin_kotlin.$_$.x5;
		  var filterNotNull = kotlin_kotlin.$_$.e5;
		  var cast = kotlin_kotlin.$_$.l8;
		  var substringAfter = kotlin_kotlin.$_$.x8;
		  var split = kotlin_kotlin.$_$.v8;
		  var mapCapacity = kotlin_kotlin.$_$.s5;
		  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.q;
		  var JsonNull_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
		  var Serializable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
		  var JsonElement = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.g;
		  var List = kotlin_kotlin.$_$.d4;
		  var isArray = kotlin_kotlin.$_$.b7;
		  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
		  var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.l;
		  var JsonPrimitive_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.k;
		  var isNumber = kotlin_kotlin.$_$.k7;
		  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.e;
		  var toLong = kotlin_kotlin.$_$.a8;
		  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.n1;
		  var Char = kotlin_kotlin.$_$.m9;
		  var Default_getInstance_0 = kotlin_kotlin.$_$.m3;
		  var random = kotlin_kotlin.$_$.f8;
		  //endregion
		  //region block: pre-declaration
		  setMetadataFor(BuildKonfig, 'BuildKonfig', objectMeta);
		  function getConversationEvents$default(cid, parameters, filterGroup, filterGroupVersion, callback, $super) {
		    parameters = parameters === VOID ? null : parameters;
		    var tmp;
		    if (filterGroup === VOID) {
		      tmp = 'ChatEvents';
		    } else {
		      tmp = filterGroup;
		    }
		    filterGroup = tmp;
		    var tmp_0;
		    if (filterGroupVersion === VOID) {
		      tmp_0 = 3;
		    } else {
		      tmp_0 = filterGroupVersion;
		    }
		    filterGroupVersion = tmp_0;
		    var tmp_1;
		    if ($super === VOID) {
		      this.h1f(cid, parameters, filterGroup, filterGroupVersion, callback);
		      tmp_1 = Unit_instance;
		    } else {
		      tmp_1 = $super.h1f.call(this, cid, parameters, filterGroup, filterGroupVersion, callback);
		    }
		    return tmp_1;
		  }
		  function sendMessageEvent$default(cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callback, $super) {
		    text = text === VOID ? null : text;
		    imageUrl = imageUrl === VOID ? null : imageUrl;
		    videoUrl = videoUrl === VOID ? null : videoUrl;
		    audioUrl = audioUrl === VOID ? null : audioUrl;
		    fileUrl = fileUrl === VOID ? null : fileUrl;
		    vCardUrl = vCardUrl === VOID ? null : vCardUrl;
		    customBody = customBody === VOID ? null : customBody;
		    location = location === VOID ? null : location;
		    template = template === VOID ? null : template;
		    var tmp;
		    if ($super === VOID) {
		      this.q1f(cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callback);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.q1f.call(this, cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callback);
		    }
		    return tmp;
		  }
		  setMetadataFor(ChatAPI, 'ChatAPI', interfaceMeta);
		  setMetadataFor(CoreClientWithMedia, 'CoreClientWithMedia', interfaceMeta, VOID, [ChatAPI]);
		  setMetadataFor(Builder, 'Builder', classMeta, VOID, VOID, Builder);
		  setMetadataFor(CoreClientImpl, 'CoreClientImpl', classMeta, VOID, [ChatAPI, CoreClientWithMedia]);
		  setMetadataFor(SdkInfo, 'SdkInfo', objectMeta);
		  setMetadataFor(StaticConfig, 'StaticConfig', objectMeta);
		  setMetadataFor(ErrorReport, 'ErrorReport', classMeta);
		  function queryParams() {
		    return null;
		  }
		  function encode(encoder, originatingSessionId) {
		    return '';
		  }
		  function isSanitized() {
		    return true;
		  }
		  setMetadataFor(ApiRequest, 'ApiRequest', interfaceMeta);
		  setMetadataFor(UpdateSessionRequest, 'UpdateSessionRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion, 'Companion', objectMeta);
		  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_0, 'Companion', objectMeta);
		  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_1, 'Companion', objectMeta);
		  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MetricsWsReconnectionTimeBody, 'MetricsWsReconnectionTimeBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
		  setMetadataFor(MetricsBody, 'MetricsBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
		  setMetadataFor(Body, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
		  setMetadataFor(MetricsWsReconnectionTimeReq, 'MetricsWsReconnectionTimeReq', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_2, 'Companion', objectMeta);
		  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ApiResponse, 'ApiResponse', interfaceMeta);
		  setMetadataFor(MetricsWsReconnectionTime, 'MetricsWsReconnectionTime', classMeta, VOID, [ApiResponse], MetricsWsReconnectionTime, VOID, {0: $serializer_getInstance_2});
		  setMetadataFor(GetLegRequest, 'GetLegRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_3, 'Companion', objectMeta);
		  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(GetLeg, 'GetLeg', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_3});
		  setMetadataFor(GetConversationRequest, 'GetConversationRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(EmbeddedMember, 'EmbeddedMember', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
		  setMetadataFor(Companion_4, 'Companion', objectMeta);
		  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(GetConversation, 'GetConversation', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_5});
		  setMetadataFor(GetConversationLegsRequest, 'GetConversationLegsRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_5, 'Companion', objectMeta);
		  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationLegsEmbedded, 'ConversationLegsEmbedded', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
		  setMetadataFor(Companion_6, 'Companion', objectMeta);
		  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(GetConversationLegs, 'GetConversationLegs', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_7});
		  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(PageNavigationLink, 'PageNavigationLink', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
		  setMetadataFor(Companion_7, 'Companion', objectMeta);
		  setMetadataFor($serializer_9, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(PageNavigationLinks, 'PageNavigationLinks', classMeta, VOID, VOID, PageNavigationLinks, VOID, {0: $serializer_getInstance_9});
		  setMetadataFor(AppKnockingRequest, 'AppKnockingRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(MemberKickRequest, 'MemberKickRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_8, 'Companion', objectMeta);
		  setMetadataFor($serializer_10, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_9, 'Companion', objectMeta);
		  setMetadataFor($serializer_11, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberJoinChannel, 'MemberJoinChannel', classMeta, VOID, VOID, MemberJoinChannel, VOID, {0: $serializer_getInstance_10});
		  setMetadataFor(Body_0, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
		  setMetadataFor(MemberJoinRequest, 'MemberJoinRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(DeleteKnockerRequest, 'DeleteKnockerRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_10, 'Companion', objectMeta);
		  setMetadataFor($serializer_12, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_11, 'Companion', objectMeta);
		  setMetadataFor($serializer_13, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegMuteBody, 'LegMuteBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
		  setMetadataFor(Body_1, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
		  setMetadataFor(LegMuteRequest, 'LegMuteRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_12, 'Companion', objectMeta);
		  setMetadataFor($serializer_14, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_13, 'Companion', objectMeta);
		  setMetadataFor($serializer_15, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegUnmuteBody, 'LegUnmuteBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
		  setMetadataFor(Body_2, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
		  setMetadataFor(LegUnmuteRequest, 'LegUnmuteRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_14, 'Companion', objectMeta);
		  setMetadataFor($serializer_16, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_15, 'Companion', objectMeta);
		  setMetadataFor($serializer_17, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegEarmuffEnableBody, 'LegEarmuffEnableBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
		  setMetadataFor(Body_3, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
		  setMetadataFor(LegEarmuffEnableRequest, 'LegEarmuffEnableRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_16, 'Companion', objectMeta);
		  setMetadataFor($serializer_18, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_17, 'Companion', objectMeta);
		  setMetadataFor($serializer_19, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegEarmuffDisableBody, 'LegEarmuffDisableBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
		  setMetadataFor(Body_4, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
		  setMetadataFor(LegEarmuffDisableRequest, 'LegEarmuffDisableRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_18, 'Companion', objectMeta);
		  setMetadataFor($serializer_20, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_19, 'Companion', objectMeta);
		  setMetadataFor($serializer_21, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegDTMFBody, 'LegDTMFBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
		  setMetadataFor(Body_5, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
		  setMetadataFor(LegDTMFRequest, 'LegDTMFRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_20, 'Companion', objectMeta);
		  setMetadataFor($serializer_22, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_21, 'Companion', objectMeta);
		  setMetadataFor($serializer_23, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioSayBody, 'AudioSayBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
		  setMetadataFor(Body_6, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
		  setMetadataFor(AudioSayRequest, 'AudioSayRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor($serializer_24, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(InvalidParameter, 'InvalidParameter', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
		  setMetadataFor(Companion_22, 'Companion', objectMeta);
		  setMetadataFor($serializer_25, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSError, 'CSError', classMeta, Exception, VOID, CSError, VOID, {0: $serializer_getInstance_25});
		  setMetadataFor(GetMyMemberRequest, 'GetMyMemberRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor($serializer_26, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(EmbeddedUser, 'EmbeddedUser', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
		  setMetadataFor(Companion_23, 'Companion', objectMeta);
		  setMetadataFor($serializer_27, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(GetMember, 'GetMember', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_27});
		  setMetadataFor(Companion_24, 'Companion', objectMeta);
		  setMetadataFor($serializer_28, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Properties, 'Properties', classMeta, VOID, VOID, Properties, VOID, {0: $serializer_getInstance_28});
		  setMetadataFor(Companion_25, 'Companion', objectMeta);
		  setMetadataFor($serializer_29, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(PostedEvent, 'PostedEvent', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
		  setMetadataFor(PostConversationEventRequest, 'PostConversationEventRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_26, 'Companion', objectMeta);
		  setMetadataFor($serializer_30, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  function isSanitized_0() {
		    return true;
		  }
		  setMetadataFor(PostConversationEventRequestBody, 'PostConversationEventRequestBody', interfaceMeta, VOID, VOID, VOID, VOID, {0: EmptySerializer_getInstance});
		  setMetadataFor(UpdateEventStateRequestBody, 'UpdateEventStateRequestBody', classMeta, VOID, [PostConversationEventRequestBody], VOID, VOID, {0: $serializer_getInstance_30});
		  setMetadataFor(Companion_27, 'Companion', objectMeta);
		  setMetadataFor($serializer_31, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Body_7, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_31});
		  setMetadataFor(CreateConversationRequest, 'CreateConversationRequest', classMeta, VOID, [ApiRequest], CreateConversationRequest);
		  setMetadataFor(Companion_28, 'Companion', objectMeta);
		  setMetadataFor($serializer_32, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationCreate, 'ConversationCreate', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_32});
		  setMetadataFor(Companion_29, 'Companion', objectMeta);
		  setMetadataFor($serializer_33, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_30, 'Companion', objectMeta);
		  setMetadataFor($serializer_34, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Body_8, 'Body', classMeta, VOID, VOID, Body_8, VOID, {0: $serializer_getInstance_33});
		  setMetadataFor(Properties_0, 'Properties', classMeta, VOID, VOID, Properties_0, VOID, {0: $serializer_getInstance_34});
		  setMetadataFor(UpdateConversationRequest, 'UpdateConversationRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_31, 'Companion', objectMeta);
		  setMetadataFor($serializer_35, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_32, 'Companion', objectMeta);
		  setMetadataFor($serializer_36, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_33, 'Companion', objectMeta);
		  setMetadataFor($serializer_37, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberJoinChannel_0, 'MemberJoinChannel', classMeta, VOID, VOID, MemberJoinChannel_0, VOID, {0: $serializer_getInstance_35});
		  setMetadataFor(JoinUser, 'JoinUser', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_36});
		  setMetadataFor(Body_9, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_37});
		  setMetadataFor(ConversationJoinRequest, 'ConversationJoinRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_34, 'Companion', objectMeta);
		  setMetadataFor($serializer_38, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationJoin, 'ConversationJoin', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_38});
		  setMetadataFor(Companion_35, 'Companion', objectMeta);
		  setMetadataFor($serializer_39, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_36, 'Companion', objectMeta);
		  setMetadataFor($serializer_40, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_37, 'Companion', objectMeta);
		  setMetadataFor($serializer_41, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_38, 'Companion', objectMeta);
		  setMetadataFor($serializer_42, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_39, 'Companion', objectMeta);
		  setMetadataFor($serializer_43, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationInviteTo, 'ConversationInviteTo', classMeta, VOID, VOID, ConversationInviteTo, VOID, {0: $serializer_getInstance_39});
		  setMetadataFor(ConversationInviteFrom, 'ConversationInviteFrom', classMeta, VOID, VOID, ConversationInviteFrom, VOID, {0: $serializer_getInstance_40});
		  setMetadataFor(ConversationInviteChannel, 'ConversationInviteChannel', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_41});
		  setMetadataFor(ConversationInviteUser, 'ConversationInviteUser', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_42});
		  setMetadataFor(Body_10, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_43});
		  setMetadataFor(ConversationInviteRequest, 'ConversationInviteRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_40, 'Companion', objectMeta);
		  setMetadataFor($serializer_44, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationInvite, 'ConversationInvite', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_44});
		  setMetadataFor(MemberLeft, 'MemberLeft', classMeta, VOID, [ApiResponse]);
		  setMetadataFor(ConversationDeleteRequest, 'ConversationDeleteRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(ConversationDelete, 'ConversationDelete', classMeta, VOID, [ApiResponse]);
		  setMetadataFor(GetUserConversationsRequest, 'GetUserConversationsRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_41, 'Companion', objectMeta);
		  setMetadataFor($serializer_45, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(UserConversationsEmbedded, 'UserConversationsEmbedded', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_45});
		  setMetadataFor(Companion_42, 'Companion', objectMeta);
		  setMetadataFor($serializer_46, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(GetUserConversations, 'GetUserConversations', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_46});
		  setMetadataFor(GetConversationEventsRequest, 'GetConversationEventsRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_43, 'Companion', objectMeta);
		  setMetadataFor($serializer_47, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationEventsEmbedded, 'ConversationEventsEmbedded', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_47});
		  setMetadataFor(Companion_44, 'Companion', objectMeta);
		  setMetadataFor($serializer_48, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(GetConversationEvents, 'GetConversationEvents', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_48});
		  setMetadataFor(GetConversationMembersRequest, 'GetConversationMembersRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_45, 'Companion', objectMeta);
		  setMetadataFor($serializer_49, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationMembersEmbedded, 'ConversationMembersEmbedded', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_49});
		  setMetadataFor(Companion_46, 'Companion', objectMeta);
		  setMetadataFor($serializer_50, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(GetConversationMembers, 'GetConversationMembers', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_50});
		  setMetadataFor(GetConversationMemberRequest, 'GetConversationMemberRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_47, 'Companion', objectMeta);
		  setMetadataFor($serializer_51, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(GetUser, 'GetUser', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_51});
		  setMetadataFor(Companion_48, 'Companion', objectMeta);
		  setMetadataFor($serializer_52, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(PostConversationEvent, 'PostConversationEvent', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_52});
		  setMetadataFor(DeleteConversationEventRequest, 'DeleteConversationEventRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_49, 'Companion', objectMeta);
		  setMetadataFor($serializer_53, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(DeleteConversationEvent, 'DeleteConversationEvent', classMeta, VOID, [ApiResponse], DeleteConversationEvent, VOID, {0: $serializer_getInstance_53});
		  setMetadataFor(Companion_50, 'Companion', objectMeta);
		  setMetadataFor($serializer_54, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Embedded, 'Embedded', classMeta, VOID, VOID, Embedded, VOID, {0: $serializer_getInstance_54});
		  setMetadataFor($serializer_55, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(FromUser, 'FromUser', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_55});
		  setMetadataFor($serializer_56, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(FromMember, 'FromMember', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_56});
		  setMetadataFor(OptionSerializer, 'OptionSerializer', classMeta, VOID, [KSerializer]);
		  setMetadataFor(GetUserRequest, 'GetUserRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_51, 'Companion', objectMeta);
		  setMetadataFor(Companion_52, 'Companion', objectMeta);
		  setMetadataFor($serializer_57, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCUpdateStatsReport, 'RTCUpdateStatsReport', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_57});
		  setMetadataFor(RTCStatsReportRequest, 'RTCStatsReportRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_53, 'Companion', objectMeta);
		  setMetadataFor($serializer_58, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_54, 'Companion', objectMeta);
		  setMetadataFor($serializer_59, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_55, 'Companion', objectMeta);
		  setMetadataFor($serializer_60, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(PostLegBody, 'PostLegBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_58});
		  setMetadataFor(PostLegOffer, 'PostLegOffer', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_59});
		  setMetadataFor(Body_11, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_60});
		  setMetadataFor(PostLegRequest, 'PostLegRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_56, 'Companion', objectMeta);
		  setMetadataFor($serializer_61, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(PostLeg, 'PostLeg', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_61});
		  setMetadataFor(Companion_57, 'Companion', objectMeta);
		  setMetadataFor($serializer_62, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_58, 'Companion', objectMeta);
		  setMetadataFor($serializer_63, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RtcAnswerBody, 'RtcAnswerBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_62});
		  setMetadataFor(Body_12, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_63});
		  setMetadataFor(RTCAnswerRequest, 'RTCAnswerRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_59, 'Companion', objectMeta);
		  setMetadataFor($serializer_64, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_60, 'Companion', objectMeta);
		  setMetadataFor($serializer_65, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_61, 'Companion', objectMeta);
		  setMetadataFor($serializer_66, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RtcReconnectBody, 'RtcReconnectBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_64});
		  setMetadataFor(RtcReconnectOffer, 'RtcReconnectOffer', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_65});
		  setMetadataFor(Body_13, 'Body', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_66});
		  setMetadataFor(RTCReconnectRequest, 'RTCReconnectRequest', classMeta, VOID, [ApiRequest]);
		  setMetadataFor(Companion_62, 'Companion', objectMeta);
		  setMetadataFor($serializer_67, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AppKnocking, 'AppKnocking', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_67});
		  setMetadataFor(Companion_63, 'Companion', objectMeta);
		  setMetadataFor($serializer_68, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCReconnect, 'RTCReconnect', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_68});
		  setMetadataFor(DeletedKnocker, 'DeletedKnocker', classMeta, VOID, [ApiResponse]);
		  setMetadataFor(Companion_64, 'Companion', objectMeta);
		  setMetadataFor($serializer_69, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(UpdateSession, 'UpdateSession', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_69});
		  setMetadataFor(Companion_65, 'Companion', objectMeta);
		  setMetadataFor($serializer_70, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberJoin, 'MemberJoin', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_70});
		  setMetadataFor(Companion_66, 'Companion', objectMeta);
		  setMetadataFor($serializer_71, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegMute, 'LegMute', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_71});
		  setMetadataFor(Companion_67, 'Companion', objectMeta);
		  setMetadataFor($serializer_72, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegUnmute, 'LegUnmute', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_72});
		  setMetadataFor(Companion_68, 'Companion', objectMeta);
		  setMetadataFor($serializer_73, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegEarmuffEnable, 'LegEarmuffEnable', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_73});
		  setMetadataFor(Companion_69, 'Companion', objectMeta);
		  setMetadataFor($serializer_74, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegEarmuffDisable, 'LegEarmuffDisable', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_74});
		  setMetadataFor(Companion_70, 'Companion', objectMeta);
		  setMetadataFor($serializer_75, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegDTMF, 'LegDTMF', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_75});
		  setMetadataFor(Companion_71, 'Companion', objectMeta);
		  setMetadataFor($serializer_76, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioSay, 'AudioSay', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_76});
		  setMetadataFor(EmptySerializer, 'EmptySerializer', objectMeta, JsonContentPolymorphicSerializer);
		  setMetadataFor(Companion_72, 'Companion', objectMeta);
		  setMetadataFor($serializer_77, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCStatsReportResponse, 'RTCStatsReportResponse', classMeta, VOID, [ApiResponse], RTCStatsReportResponse, VOID, {0: $serializer_getInstance_77});
		  setMetadataFor(Companion_73, 'Companion', objectMeta);
		  setMetadataFor($serializer_78, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCAnswerResponse, 'RTCAnswerResponse', classMeta, VOID, [ApiResponse], VOID, VOID, {0: $serializer_getInstance_78});
		  setMetadataFor(Companion_74, 'Companion', objectMeta);
		  setMetadataFor($serializer_79, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Links, 'Links', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_79});
		  setMetadataFor(CSConversationEventType, 'CSConversationEventType', classMeta, Enum);
		  setMetadataFor(Companion_75, 'Companion', objectMeta, VOID, [SerializerFactory]);
		  setMetadataFor(CSConversationEvent, 'CSConversationEvent', interfaceMeta, VOID, VOID, VOID, VOID, {0: CSConversationEventsSerializer_getInstance});
		  setMetadataFor(Companion_76, 'Companion', objectMeta);
		  setMetadataFor(CSConversationEventJsonBody, 'CSConversationEventJsonBody', classMeta, VOID, [PostConversationEventRequestBody], VOID, VOID, {0: CSConversationEventJsonBodySerializer_getInstance});
		  setMetadataFor(CSConversationEventsSerializer, 'CSConversationEventsSerializer', objectMeta, JsonContentPolymorphicSerializer);
		  setMetadataFor(CSConversationEventJsonBodySerializer, 'CSConversationEventJsonBodySerializer', objectMeta, VOID, [KSerializer]);
		  setMetadataFor(Companion_77, 'Companion', objectMeta);
		  setMetadataFor($serializer_80, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSCustomEvent, 'CSCustomEvent', classMeta, VOID, [CSConversationEvent], VOID, VOID, {0: $serializer_getInstance_80});
		  setMetadataFor(Companion_78, 'Companion', objectMeta);
		  setMetadataFor($serializer_81, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSMemberInvitedEvent, 'CSMemberInvitedEvent', classMeta, VOID, [CSConversationEvent], VOID, VOID, {0: $serializer_getInstance_81});
		  setMetadataFor(Companion_79, 'Companion', objectMeta);
		  setMetadataFor($serializer_82, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSMemberJoinedEvent, 'CSMemberJoinedEvent', classMeta, VOID, [CSConversationEvent], VOID, VOID, {0: $serializer_getInstance_82});
		  setMetadataFor(Companion_80, 'Companion', objectMeta);
		  setMetadataFor($serializer_83, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSMemberLeftEvent, 'CSMemberLeftEvent', classMeta, VOID, [CSConversationEvent], VOID, VOID, {0: $serializer_getInstance_83});
		  setMetadataFor(Companion_81, 'Companion', objectMeta);
		  setMetadataFor($serializer_84, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSEventDelete, 'CSEventDelete', classMeta, VOID, [CSConversationEvent], VOID, VOID, {0: $serializer_getInstance_84});
		  setMetadataFor($serializer_85, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSMemberEventBody, 'CSMemberEventBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_85});
		  setMetadataFor(Companion_82, 'Companion', objectMeta);
		  setMetadataFor($serializer_86, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSEventState, 'CSEventState', classMeta, VOID, VOID, CSEventState, VOID, {0: $serializer_getInstance_86});
		  setMetadataFor($serializer_87, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSEventTimestamp, 'CSEventTimestamp', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_87});
		  setMetadataFor($serializer_88, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCHangup, 'RTCHangup', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_88});
		  setMetadataFor(Companion_83, 'Companion', objectMeta);
		  setMetadataFor($serializer_89, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SocketEvent, 'SocketEvent', interfaceMeta, VOID, VOID, VOID, VOID, {0: SocketEventSerializer_getInstance});
		  setMetadataFor(AudioSayEvent, 'AudioSayEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_89});
		  setMetadataFor(Companion_84, 'Companion', objectMeta);
		  setMetadataFor($serializer_90, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegStatusUpdateEvent, 'LegStatusUpdateEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_90});
		  setMetadataFor(Companion_85, 'Companion', objectMeta);
		  setMetadataFor($serializer_91, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegStatusUpdate, 'LegStatusUpdate', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_91});
		  setMetadataFor(Companion_86, 'Companion', objectMeta);
		  setMetadataFor($serializer_92, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioMuteOnEvent, 'AudioMuteOnEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_92});
		  setMetadataFor($serializer_93, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioMuteBody, 'AudioMuteBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_93});
		  setMetadataFor(Companion_87, 'Companion', objectMeta);
		  setMetadataFor($serializer_94, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioMuteOffEvent, 'AudioMuteOffEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_94});
		  setMetadataFor(Companion_88, 'Companion', objectMeta);
		  setMetadataFor($serializer_95, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioEarmuffOnEvent, 'AudioEarmuffOnEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_95});
		  setMetadataFor($serializer_96, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioEarmuffBody, 'AudioEarmuffBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_96});
		  setMetadataFor(Companion_89, 'Companion', objectMeta);
		  setMetadataFor($serializer_97, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioEarmuffOffEvent, 'AudioEarmuffOffEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_97});
		  setMetadataFor(Companion_90, 'Companion', objectMeta);
		  setMetadataFor($serializer_98, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioDTMFEvent, 'AudioDTMFEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_98});
		  setMetadataFor($serializer_99, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioDTMFBody, 'AudioDTMFBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_99});
		  setMetadataFor(Companion_91, 'Companion', objectMeta);
		  setMetadataFor($serializer_100, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCHangupEvent, 'RTCHangupEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_100});
		  setMetadataFor(Companion_92, 'Companion', objectMeta);
		  setMetadataFor($serializer_101, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCTransferEvent, 'RTCTransferEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_101});
		  setMetadataFor($serializer_102, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCTransfer, 'RTCTransfer', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_102});
		  setMetadataFor($serializer_103, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberInvited, 'MemberInvited', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_103});
		  setMetadataFor($serializer_104, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(PushMemberInvitedEvent, 'PushMemberInvitedEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_104});
		  setMetadataFor(Companion_93, 'Companion', objectMeta);
		  setMetadataFor($serializer_105, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionSuccessEvent, 'SessionSuccessEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_105});
		  setMetadataFor(Companion_94, 'Companion', objectMeta);
		  setMetadataFor($serializer_106, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionSuccess, 'SessionSuccess', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_106});
		  setMetadataFor(Companion_95, 'Companion', objectMeta);
		  setMetadataFor($serializer_107, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SocketConversationEvent, 'SocketConversationEvent', interfaceMeta, VOID, [SocketEvent]);
		  setMetadataFor(MemberJoinedEvent, 'MemberJoinedEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_107});
		  setMetadataFor($serializer_108, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberJoined, 'MemberJoined', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_108});
		  setMetadataFor(Companion_96, 'Companion', objectMeta);
		  setMetadataFor($serializer_109, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCAnswerEvent, 'RTCAnswerEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_109});
		  setMetadataFor($serializer_110, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCAnswer, 'RTCAnswer', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_110});
		  setMetadataFor(Companion_97, 'Companion', objectMeta);
		  setMetadataFor($serializer_111, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberInvitedEvent, 'MemberInvitedEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_111});
		  setMetadataFor(Companion_98, 'Companion', objectMeta);
		  setMetadataFor($serializer_112, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberMediaEvent, 'MemberMediaEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_112});
		  setMetadataFor($serializer_113, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberMedia, 'MemberMedia', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_113});
		  setMetadataFor(Companion_99, 'Companion', objectMeta);
		  setMetadataFor($serializer_114, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberLeftEvent, 'MemberLeftEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_114});
		  setMetadataFor($serializer_115, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberLeftBody, 'MemberLeftBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_115});
		  setMetadataFor(Companion_100, 'Companion', objectMeta);
		  setMetadataFor($serializer_116, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberLeftReason, 'MemberLeftReason', classMeta, VOID, VOID, MemberLeftReason, VOID, {0: $serializer_getInstance_116});
		  setMetadataFor($serializer_117, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioSayBody_0, 'AudioSayBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_117});
		  setMetadataFor($serializer_118, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LegStatusHistory, 'LegStatusHistory', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_118});
		  setMetadataFor($serializer_119, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSEventStateBody, 'CSEventStateBody', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_119});
		  setMetadataFor(Companion_101, 'Companion', objectMeta);
		  setMetadataFor($serializer_120, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MessageEvent, 'MessageEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_120});
		  setMetadataFor(Companion_102, 'Companion', objectMeta);
		  setMetadataFor($serializer_121, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(EphemeralEvent, 'EphemeralEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_121});
		  setMetadataFor(Companion_103, 'Companion', objectMeta);
		  setMetadataFor($serializer_122, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(DeleteEvent, 'DeleteEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_122});
		  setMetadataFor(Companion_104, 'Companion', objectMeta);
		  setMetadataFor($serializer_123, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MessageDeliveredSocketEvent, 'MessageDeliveredSocketEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_123});
		  setMetadataFor(Companion_105, 'Companion', objectMeta);
		  setMetadataFor($serializer_124, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MessageRejectedSocketEvent, 'MessageRejectedSocketEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_124});
		  setMetadataFor(Companion_106, 'Companion', objectMeta);
		  setMetadataFor($serializer_125, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MessageSubmittedSocketEvent, 'MessageSubmittedSocketEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_125});
		  setMetadataFor(Companion_107, 'Companion', objectMeta);
		  setMetadataFor($serializer_126, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MessageUndeliverableSocketEvent, 'MessageUndeliverableSocketEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_126});
		  setMetadataFor(Companion_108, 'Companion', objectMeta);
		  setMetadataFor($serializer_127, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MessageSeenSocketEvent, 'MessageSeenSocketEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_127});
		  setMetadataFor(Companion_109, 'Companion', objectMeta);
		  setMetadataFor($serializer_128, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioSayDoneEvent, 'AudioSayDoneEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_128});
		  setMetadataFor(Companion_110, 'Companion', objectMeta);
		  setMetadataFor($serializer_129, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CustomEvent, 'CustomEvent', classMeta, VOID, [SocketConversationEvent], VOID, VOID, {0: $serializer_getInstance_129});
		  setMetadataFor($serializer_130, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AudioSayDone, 'AudioSayDone', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_130});
		  setMetadataFor(Companion_111, 'Companion', objectMeta);
		  setMetadataFor($serializer_131, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_112, 'Companion', objectMeta);
		  setMetadataFor($serializer_132, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_113, 'Companion', objectMeta);
		  setMetadataFor($serializer_133, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_114, 'Companion', objectMeta);
		  setMetadataFor($serializer_134, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_115, 'Companion', objectMeta);
		  setMetadataFor($serializer_135, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_116, 'Companion', objectMeta);
		  setMetadataFor($serializer_136, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_117, 'Companion', objectMeta);
		  setMetadataFor($serializer_137, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_118, 'Companion', objectMeta);
		  setMetadataFor($serializer_138, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Companion_119, 'Companion', objectMeta);
		  setMetadataFor($serializer_139, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Body_14, 'Body', interfaceMeta, VOID, [PostConversationEventRequestBody], VOID, VOID, {0: CSMessageEventBodySerializer_getInstance});
		  setMetadataFor(TextBody, 'TextBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_131});
		  setMetadataFor(ImageBody, 'ImageBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_132});
		  setMetadataFor(VideoBody, 'VideoBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_133});
		  setMetadataFor(AudioBody, 'AudioBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_134});
		  setMetadataFor(FileBody, 'FileBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_135});
		  setMetadataFor(VCardBody, 'VCardBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_136});
		  setMetadataFor(CustomBody, 'CustomBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_137});
		  setMetadataFor(TemplateBody, 'TemplateBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_138});
		  setMetadataFor(LocationBody, 'LocationBody', classMeta, VOID, [Body_14], VOID, VOID, {0: $serializer_getInstance_139});
		  setMetadataFor(Companion_120, 'Companion', objectMeta);
		  setMetadataFor($serializer_140, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSMessageEvent, 'CSMessageEvent', classMeta, VOID, [CSConversationEvent], VOID, VOID, {0: $serializer_getInstance_140});
		  setMetadataFor(Companion_121, 'Companion', objectMeta);
		  setMetadataFor($serializer_141, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(UrlObject, 'UrlObject', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_141});
		  setMetadataFor(Companion_122, 'Companion', objectMeta, VOID, [SerializerFactory]);
		  setMetadataFor($serializer_142, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CSMessageType, 'CSMessageType', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_124});
		  setMetadataFor(CSMessageEventBodySerializer, 'CSMessageEventBodySerializer', objectMeta, JsonContentPolymorphicSerializer);
		  setMetadataFor(Companion_123, 'Companion', objectMeta);
		  setMetadataFor($serializer_143, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(TemplateObject, 'TemplateObject', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_143});
		  setMetadataFor(Companion_124, 'Companion', objectMeta);
		  setMetadataFor($serializer_144, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(WhatsappObject, 'WhatsappObject', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_144});
		  setMetadataFor(Companion_125, 'Companion', objectMeta);
		  setMetadataFor($serializer_145, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(LocationObject, 'LocationObject', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_145});
		  setMetadataFor(TimeoutAction, 'TimeoutAction', classMeta);
		  setMetadataFor(MediaEvent, 'MediaEvent', interfaceMeta);
		  setMetadataFor(MediaDisable, 'MediaDisable', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(Mute, 'Mute', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(Unmute, 'Unmute', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(EnableEarmuff, 'EnableEarmuff', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(DisableEarmuff, 'DisableEarmuff', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(EnableNoiseSuppression, 'EnableNoiseSuppression', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(DisableNoiseSuppression, 'DisableNoiseSuppression', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(CallReconnectionRetry, 'CallReconnectionRetry', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(MediaErrorEvent, 'MediaErrorEvent', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(RTCStatsUpdate, 'RTCStatsUpdate', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(MediaConnectionStateUpdate, 'MediaConnectionStateUpdate', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(MediaOffer, 'MediaOffer', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(MediaAnswer, 'MediaAnswer', classMeta, VOID, [MediaEvent]);
		  setMetadataFor(UnknownSocketEvent, 'UnknownSocketEvent', classMeta);
		  setMetadataFor(SocketConnectionStatus, 'SocketConnectionStatus', classMeta, Enum);
		  setMetadataFor(SocketConnectionFailedReason, 'SocketConnectionFailedReason', classMeta, Enum);
		  setMetadataFor(SessionStatus, 'SessionStatus', classMeta);
		  setMetadataFor(None, 'None', objectMeta, SessionStatus);
		  setMetadataFor(Active, 'Active', classMeta, SessionStatus);
		  setMetadataFor(Inactive, 'Inactive', classMeta, SessionStatus, VOID, Inactive);
		  setMetadataFor(SessionError, 'SessionError', classMeta, Exception);
		  setMetadataFor(SessionConnectError, 'SessionConnectError', classMeta, SessionError);
		  setMetadataFor(SessionNoActiveSessionError, 'SessionNoActiveSessionError', classMeta, SessionConnectError, VOID, SessionNoActiveSessionError);
		  setMetadataFor(SocketConnect, 'SocketConnect', classMeta);
		  function encode_0() {
		    // Inline function 'kotlin.collections.mapOf' call
		    return emptyMap();
		  }
		  function eventName() {
		    return '';
		  }
		  setMetadataFor(SocketEmitAction, 'SocketEmitAction', interfaceMeta);
		  setMetadataFor(DeleteSession, 'DeleteSession', objectMeta, VOID, [SocketEmitAction]);
		  setMetadataFor(SocketDisconnect, 'SocketDisconnect', objectMeta);
		  setMetadataFor(SocketSetSession, 'SocketSetSession', classMeta);
		  setMetadataFor(SocketConnectionStatusWrapper, 'SocketConnectionStatusWrapper', classMeta);
		  setMetadataFor(MetricsSuccessfullySent, 'MetricsSuccessfullySent', classMeta);
		  setMetadataFor(SocketSetSessionId, 'SocketSetSessionId', classMeta);
		  setMetadataFor(Companion_126, 'Companion', objectMeta, VOID, [SerializerFactory]);
		  setMetadataFor(SocketStatus, 'SocketStatus', classMeta);
		  setMetadataFor(SocketConnectEmptyTokenError, 'SocketConnectEmptyTokenError', objectMeta);
		  setMetadataFor(SessionTimerEvent, 'SessionTimerEvent', classMeta);
		  setMetadataFor(Companion_127, 'Companion', objectMeta);
		  setMetadataFor($serializer_146, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionInvalidTokenEvent, 'SessionInvalidTokenEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_146});
		  setMetadataFor(Companion_128, 'Companion', objectMeta);
		  setMetadataFor($serializer_147, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionInvalidEvent, 'SessionInvalidEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_147});
		  setMetadataFor(Companion_129, 'Companion', objectMeta);
		  setMetadataFor($serializer_148, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionExpiredTokenEvent, 'SessionExpiredTokenEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_148});
		  setMetadataFor(Companion_130, 'Companion', objectMeta);
		  setMetadataFor($serializer_149, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionMaxOpenEvent, 'SessionMaxOpenEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_149});
		  setMetadataFor(Companion_131, 'Companion', objectMeta);
		  setMetadataFor($serializer_150, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AuthorizationErrorEvent, 'AuthorizationErrorEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_150});
		  setMetadataFor(SessionEmptyTokenError, 'SessionEmptyTokenError', classMeta, SessionError, VOID, SessionEmptyTokenError);
		  setMetadataFor(SessionSocketTransportError, 'SessionSocketTransportError', classMeta, SessionConnectError, VOID, SessionSocketTransportError);
		  setMetadataFor(SessionTimeoutError, 'SessionTimeoutError', classMeta, SessionConnectError, VOID, SessionTimeoutError);
		  setMetadataFor(SessionInvalidError, 'SessionInvalidError', classMeta, SessionConnectError, VOID, SessionInvalidError);
		  setMetadataFor(SessionInvalidTokenError, 'SessionInvalidTokenError', classMeta, SessionConnectError, VOID, SessionInvalidTokenError);
		  setMetadataFor(AuthorizationError, 'AuthorizationError', classMeta, SessionConnectError, VOID, AuthorizationError);
		  setMetadataFor(SessionExpiredTokenError, 'SessionExpiredTokenError', classMeta, SessionConnectError, VOID, SessionExpiredTokenError);
		  setMetadataFor(SessionMaxOpenSessions, 'SessionMaxOpenSessions', classMeta, SessionConnectError, VOID, SessionMaxOpenSessions);
		  setMetadataFor(SocketEventSerializer, 'SocketEventSerializer', objectMeta, JsonContentPolymorphicSerializer);
		  setMetadataFor(Companion_132, 'Companion', objectMeta);
		  setMetadataFor($serializer_151, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionUpdateTokenSuccessEvent, 'SessionUpdateTokenSuccessEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_151});
		  setMetadataFor(Companion_133, 'Companion', objectMeta);
		  setMetadataFor($serializer_152, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionLogoutSuccessEvent, 'SessionLogoutSuccessEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_152});
		  setMetadataFor(Companion_134, 'Companion', objectMeta);
		  setMetadataFor($serializer_153, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SessionTerminatedEvent, 'SessionTerminatedEvent', classMeta, VOID, [SocketEvent], VOID, VOID, {0: $serializer_getInstance_153});
		  function onRTCHangup(conversationId, legId, hangup) {
		  }
		  function onRTCTransfer(conversationId, legId) {
		  }
		  function onLegStatusUpdate(conversationId, legId, fromUserId, status) {
		  }
		  setMetadataFor(RTCEventListener, 'RTCEventListener', interfaceMeta);
		  function onAudioSay() {
		  }
		  function onAudioMuteUpdate(conversationId, legId, isMuted) {
		  }
		  function onAudioEarmuffUpdate(conversationId, legId, earmuffStatus) {
		  }
		  function onAudioDTMFUpdate(conversationId, legId, digits) {
		  }
		  setMetadataFor(AudioEventListener, 'AudioEventListener', interfaceMeta);
		  function onConversationEvent(event) {
		  }
		  setMetadataFor(ConversationEventListener, 'ConversationEventListener', interfaceMeta);
		  setMetadataFor(ChatAPIImpl$1, VOID, classMeta, VOID, [RTCEventListener, AudioEventListener, ConversationEventListener]);
		  setMetadataFor(ChatAPIImpl, 'ChatAPIImpl', classMeta, VOID, [ChatAPI]);
		  setMetadataFor(LoggingLevel, 'LoggingLevel', classMeta, Enum);
		  setMetadataFor(ClientConfigRegion, 'ClientConfigRegion', classMeta, Enum);
		  setMetadataFor(DefaultConfig, 'DefaultConfig', objectMeta);
		  setMetadataFor(Companion_135, 'Companion', objectMeta);
		  setMetadataFor(ConversationAPIImpl, 'ConversationAPIImpl', classMeta);
		  setMetadataFor(CSErrorCodes, 'CSErrorCodes', objectMeta);
		  setMetadataFor(InternalError, 'InternalError', classMeta, Exception);
		  setMetadataFor(CustomLoggersLimitReached, 'CustomLoggersLimitReached', classMeta, InternalError);
		  setMetadataFor(NoCallFound, 'NoCallFound', classMeta, InternalError, VOID, NoCallFound);
		  setMetadataFor(NoCallMediaFound, 'NoCallMediaFound', classMeta, InternalError, VOID, NoCallMediaFound);
		  setMetadataFor(MediaTimeout, 'MediaTimeout', classMeta, InternalError, VOID, MediaTimeout);
		  setMetadataFor(NoInviteFound, 'NoInviteFound', classMeta, InternalError, VOID, NoInviteFound);
		  setMetadataFor(InvalidCallAction, 'InvalidCallAction', classMeta, InternalError, VOID, InvalidCallAction);
		  setMetadataFor(NoOfferFound, 'NoOfferFound', classMeta, InternalError, VOID, NoOfferFound);
		  setMetadataFor(InboundCallFailed, 'InboundCallFailed', classMeta, InternalError, VOID, InboundCallFailed);
		  setMetadataFor(AuthorizationError_0, 'AuthorizationError', classMeta, InternalError, VOID, AuthorizationError_0);
		  setMetadataFor(MemberNotInConversation, 'MemberNotInConversation', classMeta, InternalError, VOID, MemberNotInConversation);
		  setMetadataFor(NoConversationFound, 'NoConversationFound', classMeta, InternalError, VOID, NoConversationFound);
		  setMetadataFor(NoLegFound, 'NoLegFound', classMeta, InternalError, VOID, NoLegFound);
		  setMetadataFor(ServiceTempNotAvailable, 'ServiceTempNotAvailable', classMeta, InternalError, VOID, ServiceTempNotAvailable);
		  setMetadataFor(UnexpectedNullValue, 'UnexpectedNullValue', classMeta, InternalError, VOID, UnexpectedNullValue);
		  setMetadataFor(IllegalArgumentException_0, 'IllegalArgumentException', classMeta, InternalError, VOID, IllegalArgumentException_0);
		  setMetadataFor(ServiceNotAvailable, 'ServiceNotAvailable', classMeta, InternalError, VOID, ServiceNotAvailable);
		  setMetadataFor(ParsingException, 'ParsingException', classMeta, InternalError);
		  setMetadataFor(UnsanitizedInputError, 'UnsanitizedInputError', classMeta, InternalError, VOID, UnsanitizedInputError);
		  setMetadataFor(NoAnswerFound, 'NoAnswerFound', classMeta, InternalError, VOID, NoAnswerFound);
		  setMetadataFor(Companion_136, 'Companion', objectMeta);
		  setMetadataFor(MediaClientError, 'MediaClientError', classMeta, Exception);
		  setMetadataFor(PeerConnectionNotFound, 'PeerConnectionNotFound', classMeta, MediaClientError);
		  setMetadataFor(TrackNotFound, 'TrackNotFound', classMeta, MediaClientError);
		  setMetadataFor(ProcessAnswerError, 'ProcessAnswerError', classMeta, MediaClientError);
		  setMetadataFor(CreateAnswerError, 'CreateAnswerError', classMeta, MediaClientError, VOID, CreateAnswerError);
		  setMetadataFor(CreateOfferError, 'CreateOfferError', classMeta, MediaClientError, VOID, CreateOfferError);
		  setMetadataFor(SessionErrorCodes, 'SessionErrorCodes', objectMeta);
		  setMetadataFor(SessionErrorMessages, 'SessionErrorMessages', objectMeta);
		  setMetadataFor(VonageError, 'VonageError', classMeta, Exception);
		  setMetadataFor(VonageErrorType, 'VonageErrorType', classMeta, Enum);
		  setMetadataFor(EventAPIImpl, 'EventAPIImpl', classMeta);
		  setMetadataFor(Companion_137, 'Companion', objectMeta);
		  setMetadataFor($serializer_154, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Channel, 'Channel', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_154});
		  setMetadataFor($serializer_155, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberChannel, 'MemberChannel', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_155});
		  setMetadataFor(Companion_138, 'Companion', objectMeta);
		  setMetadataFor($serializer_156, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(UserChannels, 'UserChannels', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_156});
		  setMetadataFor(Companion_139, 'Companion', objectMeta, VOID, [SerializerFactory]);
		  setMetadataFor($serializer_157, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ChannelType, 'ChannelType', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_141});
		  setMetadataFor($serializer_158, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ChannelFromTo, 'ChannelFromTo', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_158});
		  setMetadataFor(Properties_1, 'Properties', classMeta);
		  setMetadataFor(Companion_140, 'Companion', objectMeta);
		  setMetadataFor(Conversation, 'Conversation', classMeta);
		  setMetadataFor($serializer_159, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationTimestamp, 'ConversationTimestamp', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_159});
		  setMetadataFor(ConversationState, 'ConversationState', classMeta, Enum);
		  setMetadataFor(ConversationsPage, 'ConversationsPage', classMeta);
		  setMetadataFor(EventState, 'EventState', classMeta, VOID, VOID, EventState);
		  setMetadataFor(EventStateType, 'EventStateType', classMeta, Enum);
		  setMetadataFor(EventsPage, 'EventsPage', classMeta);
		  setMetadataFor(PersistentConversationEvent, 'PersistentConversationEvent', interfaceMeta);
		  setMetadataFor(EmbeddedInfo, 'EmbeddedInfo', classMeta);
		  setMetadataFor(Body_15, 'Body', classMeta);
		  setMetadataFor(MemberInvitedConversationEvent, 'MemberInvitedConversationEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(Companion_141, 'Companion', objectMeta);
		  setMetadataFor(MemberJoinedConversationEvent, 'MemberJoinedConversationEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(MemberLeftConversationEvent, 'MemberLeftConversationEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(CustomConversationEvent, 'CustomConversationEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(EphemeralConversationEvent, 'EphemeralConversationEvent', classMeta);
		  setMetadataFor(EventStateBody, 'EventStateBody', classMeta);
		  setMetadataFor(EventDeleteConversationEvent, 'EventDeleteConversationEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(MessageDeliveredEvent, 'MessageDeliveredEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(MessageRejectedEvent, 'MessageRejectedEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(MessageUndeliverableEvent, 'MessageUndeliverableEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(MessageSubmittedEvent, 'MessageSubmittedEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(MessageSeenEvent, 'MessageSeenEvent', classMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(System, 'System', objectMeta);
		  setMetadataFor(Companion_142, 'Companion', objectMeta);
		  setMetadataFor($serializer_160, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MediaState, 'MediaState', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_160});
		  setMetadataFor(Companion_143, 'Companion', objectMeta);
		  setMetadataFor(Leg, 'Leg', classMeta);
		  setMetadataFor(LegsPage, 'LegsPage', classMeta);
		  setMetadataFor(MemberState, 'MemberState', classMeta, Enum);
		  setMetadataFor(Companion_144, 'Companion', objectMeta);
		  setMetadataFor(Member, 'Member', classMeta);
		  setMetadataFor($serializer_161, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(MemberTimestamp, 'MemberTimestamp', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_161});
		  setMetadataFor(MembersPage, 'MembersPage', classMeta);
		  setMetadataFor(Body_16, 'Body', classMeta);
		  setMetadataFor(MessageEvent_0, 'MessageEvent', interfaceMeta, VOID, [PersistentConversationEvent]);
		  setMetadataFor(MessageTextEvent, 'MessageTextEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(Body_17, 'Body', classMeta);
		  setMetadataFor(MessageCustomEvent, 'MessageCustomEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(Body_18, 'Body', classMeta);
		  setMetadataFor(MessageImageEvent, 'MessageImageEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(Body_19, 'Body', classMeta);
		  setMetadataFor(MessageVideoEvent, 'MessageVideoEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(Body_20, 'Body', classMeta);
		  setMetadataFor(MessageAudioEvent, 'MessageAudioEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(Body_21, 'Body', classMeta);
		  setMetadataFor(MessageFileEvent, 'MessageFileEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(Body_22, 'Body', classMeta);
		  setMetadataFor(MessageVCardEvent, 'MessageVCardEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(Body_23, 'Body', classMeta);
		  setMetadataFor(TemplateObject_0, 'TemplateObject', classMeta);
		  setMetadataFor(WhatsappObject_0, 'WhatsappObject', classMeta);
		  setMetadataFor(MessageTemplateEvent, 'MessageTemplateEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(Body_24, 'Body', classMeta);
		  setMetadataFor(Location, 'Location', classMeta);
		  setMetadataFor(MessageLocationEvent, 'MessageLocationEvent', classMeta, VOID, [MessageEvent_0]);
		  setMetadataFor(PresentingOrder, 'PresentingOrder', classMeta, Enum);
		  setMetadataFor(OrderBy, 'OrderBy', classMeta, Enum);
		  setMetadataFor(OrderBy$CREATED, 'CREATED', classMeta, OrderBy);
		  setMetadataFor(OrderBy$CUSTOM_SORT_KEY, 'CUSTOM_SORT_KEY', classMeta, OrderBy);
		  setMetadataFor(CreateConversationParameters, 'CreateConversationParameters', classMeta, VOID, VOID, CreateConversationParameters);
		  setMetadataFor(GetConversationsParameters, 'GetConversationsParameters', classMeta, VOID, VOID, GetConversationsParameters);
		  setMetadataFor(GetConversationMembersParameters, 'GetConversationMembersParameters', classMeta, VOID, VOID, GetConversationMembersParameters);
		  setMetadataFor(GetConversationEventsParameters, 'GetConversationEventsParameters', classMeta, VOID, VOID, GetConversationEventsParameters);
		  setMetadataFor(UpdateConversationParameters, 'UpdateConversationParameters', classMeta, VOID, VOID, UpdateConversationParameters);
		  setMetadataFor(GetCallLegsParameters, 'GetCallLegsParameters', classMeta, VOID, VOID, GetCallLegsParameters);
		  setMetadataFor(User, 'User', classMeta);
		  setMetadataFor($serializer_162, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(UserTimestamp, 'UserTimestamp', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_162});
		  setMetadataFor(PushAPIImpl, 'PushAPIImpl', classMeta);
		  setMetadataFor(SessionErrorReason, 'SessionErrorReason', classMeta, Enum);
		  setMetadataFor(SessionAPIImpl, 'SessionAPIImpl', classMeta);
		  function onCallTransfer(callId, conversationId) {
		  }
		  function onMuteUpdate(callId, legId, isMuted) {
		  }
		  function onEarmuffUpdate(callId, legId, earmuffStatus) {
		  }
		  function onDTMFUpdate(callId, legId, digits) {
		  }
		  function onCallHangup(callId, callQuality, reason) {
		  }
		  function onLegStatusUpdate_0(callId, legId, status) {
		  }
		  function onCallMediaReconnecting(callId) {
		  }
		  function onCallMediaReconnection(callId) {
		  }
		  function onCallMediaDisconnect(callId, reason) {
		  }
		  function onRtcStatsUpdate(rtcStats, legId) {
		  }
		  function onCallMediaError(callId, error) {
		  }
		  setMetadataFor(VoiceClientListener, 'VoiceClientListener', interfaceMeta);
		  setMetadataFor(VoiceInviteCancelReason, 'VoiceInviteCancelReason', classMeta, Enum);
		  setMetadataFor(HangupReason, 'HangupReason', classMeta, Enum);
		  setMetadataFor(LegStatus, 'LegStatus', classMeta, Enum);
		  setMetadataFor(CallDisconnectReason, 'CallDisconnectReason', classMeta, Enum);
		  setMetadataFor(VoiceAPIImpl$1, VOID, classMeta, VOID, [RTCEventListener, AudioEventListener, ConversationEventListener]);
		  setMetadataFor(VoiceAPIImpl, 'VoiceAPIImpl', classMeta);
		  setMetadataFor(CallEvent, 'CallEvent', interfaceMeta);
		  setMetadataFor(SetupOutboundCall, 'SetupOutboundCall', classMeta, VOID, [CallEvent]);
		  setMetadataFor(CallKnockingRequestFailure, 'CallKnockingRequestFailure', classMeta, VOID, [CallEvent]);
		  setMetadataFor(CallCleanup, 'CallCleanup', classMeta, VOID, [CallEvent]);
		  setMetadataFor(CallReconnect, 'CallReconnect', classMeta, VOID, [CallEvent]);
		  setMetadataFor(SetupInboundCall, 'SetupInboundCall', classMeta, VOID, [CallEvent]);
		  setMetadataFor(CallReconnectSuccess, 'CallReconnectSuccess', classMeta, VOID, [CallEvent]);
		  setMetadataFor(CallReconnectFailure, 'CallReconnectFailure', classMeta, VOID, [CallEvent]);
		  setMetadataFor(InviteReconcile, 'InviteReconcile', classMeta, VOID, [CallEvent]);
		  setMetadataFor(CallCreate, 'CallCreate', classMeta, VOID, [CallEvent]);
		  setMetadataFor(CallMemberMediaTimeout, 'CallMemberMediaTimeout', classMeta, VOID, [CallEvent]);
		  setMetadataFor(MemberJoinInfo, 'MemberJoinInfo', classMeta);
		  setMetadataFor(CallConversationUpdate, 'CallConversationUpdate', classMeta, VOID, [CallEvent]);
		  setMetadataFor(InviteCleanup, 'InviteCleanup', classMeta, VOID, [CallEvent]);
		  setMetadataFor(VoiceChannelType, 'VoiceChannelType', classMeta, Enum);
		  setMetadataFor(Companion_145, 'Companion', objectMeta, VOID, [SerializerFactory]);
		  setMetadataFor(ChannelEndpoint, 'ChannelEndpoint', classMeta, VOID, VOID, VOID, VOID, {0: Companion_getInstance_147});
		  setMetadataFor(Companion_146, 'Companion', objectMeta);
		  setMetadataFor($serializer_163, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(PhoneChannelEndpoint, 'PhoneChannelEndpoint', classMeta, ChannelEndpoint, VOID, VOID, VOID, {0: $serializer_getInstance_163});
		  setMetadataFor(Companion_147, 'Companion', objectMeta);
		  setMetadataFor($serializer_164, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(AppChannelEndpoint, 'AppChannelEndpoint', classMeta, ChannelEndpoint, VOID, VOID, VOID, {0: $serializer_getInstance_164});
		  setMetadataFor(AppChannelEndpointNoUser, 'AppChannelEndpointNoUser', objectMeta, ChannelEndpoint, [ChannelEndpoint, SerializerFactory], VOID, VOID, {0: AppChannelEndpointNoUser_getInstance});
		  setMetadataFor(Companion_148, 'Companion', objectMeta);
		  setMetadataFor($serializer_165, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(SipChannelEndpoint, 'SipChannelEndpoint', classMeta, ChannelEndpoint, VOID, VOID, VOID, {0: $serializer_getInstance_165});
		  setMetadataFor(Companion_149, 'Companion', objectMeta);
		  setMetadataFor($serializer_166, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(WebSocketChannelEndpoint, 'WebSocketChannelEndpoint', classMeta, ChannelEndpoint, VOID, VOID, VOID, {0: $serializer_getInstance_166});
		  setMetadataFor(Companion_150, 'Companion', objectMeta);
		  setMetadataFor($serializer_167, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(DTMFChannel, 'DTMFChannel', classMeta, VOID, VOID, DTMFChannel, VOID, {0: $serializer_getInstance_167});
		  setMetadataFor(Companion_151, 'Companion', objectMeta);
		  setMetadataFor($serializer_168, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(Channel_0, 'Channel', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_168});
		  setMetadataFor(ChannelEndpointSerializer, 'ChannelEndpointSerializer', objectMeta, JsonContentPolymorphicSerializer);
		  setMetadataFor($serializer_169, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(ConversationInfo, 'ConversationInfo', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_169});
		  setMetadataFor(LegState, 'LegState', classMeta);
		  setMetadataFor(None_0, 'None', objectMeta, LegState);
		  setMetadataFor(Prewarm, 'Prewarm', classMeta, LegState);
		  setMetadataFor(Started, 'Started', classMeta, LegState);
		  setMetadataFor(Completed, 'Completed', classMeta, LegState);
		  setMetadataFor(MediaDescription, 'MediaDescription', classMeta);
		  setMetadataFor(Offer, 'Offer', classMeta, MediaDescription);
		  setMetadataFor(Answer, 'Answer', classMeta, MediaDescription);
		  setMetadataFor(MediaTransport, 'MediaTransport', classMeta, VOID, VOID, MediaTransport);
		  setMetadataFor($serializer_170, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(UserAudio, 'UserAudio', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_170});
		  setMetadataFor($serializer_171, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(InvitedUserMedia, 'InvitedUserMedia', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_171});
		  setMetadataFor($serializer_172, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCQuality, 'RTCQuality', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_172});
		  setMetadataFor(Companion_152, 'Companion', objectMeta, VOID, [SerializerFactory]);
		  setMetadataFor($serializer_173, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(CallCompleteReason, 'CallCompleteReason', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_154});
		  setMetadataFor($serializer_174, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCHangupReason, 'RTCHangupReason', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_174});
		  setMetadataFor(CallCompleteReasonSerialiser, 'CallCompleteReasonSerialiser', objectMeta, VOID, [KSerializer]);
		  setMetadataFor($serializer_175, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
		  setMetadataFor(RTCBandwidth, 'RTCBandwidth', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_175});
		  setMetadataFor(BaseVonageLogger, 'BaseVonageLogger', classMeta);
		  setMetadataFor(ConsoleLogger, 'ConsoleLogger', classMeta, BaseVonageLogger, VOID, ConsoleLogger);
		  setMetadataFor(WebRTCLogger, 'WebRTCLogger', classMeta, BaseVonageLogger, VOID, WebRTCLogger);
		  setMetadataFor(BaseVonageLogger$config$1, VOID, classMeta);
		  function e(topic, message, throwable) {
		    return this.x3g(LoggingLevel_Error_getInstance(), topic, message, throwable);
		  }
		  function v(topic, throwable, message) {
		    return this.w3g(LoggingLevel_Verbose_getInstance(), topic, throwable, message);
		  }
		  function d(topic, throwable, message) {
		    return this.w3g(LoggingLevel_Debug_getInstance(), topic, throwable, message);
		  }
		  function i(topic, throwable, message) {
		    return this.w3g(LoggingLevel_Info_getInstance(), topic, throwable, message);
		  }
		  function w(topic, throwable, message) {
		    return this.w3g(LoggingLevel_Warn_getInstance(), topic, throwable, message);
		  }
		  function e_0(topic, throwable, message) {
		    return this.w3g(LoggingLevel_Error_getInstance(), topic, throwable, message);
		  }
		  setMetadataFor(ILoggerAdapter, 'ILoggerAdapter', interfaceMeta);
		  setMetadataFor(LoggerAdapter, 'LoggerAdapter', classMeta, VOID, [ILoggerAdapter]);
		  setMetadataFor(TopicLoggerAdapter, 'TopicLoggerAdapter', classMeta, VOID, [ILoggerAdapter]);
		  setMetadataFor(Topic, 'Topic', classMeta);
		  setMetadataFor(Http, 'Http', classMeta, Topic);
		  setMetadataFor(Client, 'Client', objectMeta, Http);
		  setMetadataFor(Middleware, 'Middleware', objectMeta, Http);
		  setMetadataFor(Ws, 'Ws', classMeta, Topic);
		  setMetadataFor(Client_0, 'Client', objectMeta, Ws);
		  setMetadataFor(Middleware_0, 'Middleware', objectMeta, Ws);
		  setMetadataFor(EventParser, 'EventParser', objectMeta, Ws);
		  setMetadataFor(EventEmit, 'EventEmit', objectMeta, Ws);
		  setMetadataFor(Connection, 'Connection', objectMeta, Ws);
		  setMetadataFor(Media, 'Media', classMeta, Topic);
		  setMetadataFor(Client_1, 'Client', objectMeta, Media);
		  setMetadataFor(Middleware_1, 'Middleware', objectMeta, Media);
		  setMetadataFor(WebRtc, 'WebRtc', objectMeta, Media);
		  setMetadataFor(Api, 'Api', classMeta, Topic);
		  setMetadataFor(Session, 'Session', objectMeta, Api);
		  setMetadataFor(Voice, 'Voice', objectMeta, Api);
		  setMetadataFor(Chat, 'Chat', objectMeta, Api);
		  setMetadataFor(Push, 'Push', objectMeta, Api);
		  setMetadataFor(Conversation_0, 'Conversation', objectMeta, Api);
		  setMetadataFor(Store, 'Store', classMeta, Topic);
		  setMetadataFor(Action, 'Action', objectMeta, Store);
		  setMetadataFor(Callback, 'Callback', objectMeta, Store);
		  setMetadataFor(Reducer, 'Reducer', classMeta, Topic);
		  setMetadataFor(Call, 'Call', objectMeta, Reducer);
		  setMetadataFor(Invite, 'Invite', objectMeta, Reducer);
		  setMetadataFor(Session_0, 'Session', objectMeta, Reducer);
		  setMetadataFor(Config, 'Config', objectMeta, Reducer);
		  setMetadataFor(RemoteEvent, 'RemoteEvent', objectMeta, Reducer);
		  setMetadataFor(MediaEvent_0, 'MediaEvent', objectMeta, Reducer);
		  setMetadataFor(Companion_153, 'Companion', objectMeta);
		  setMetadataFor(createVonageLogger$1, VOID, classMeta);
		  function clear() {
		  }
		  setMetadataFor(HTTPClient, 'HTTPClient', interfaceMeta);
		  setMetadataFor(HTTPClientLogger, 'HTTPClientLogger', classMeta, VOID, [HTTPClient]);
		  setMetadataFor(SocketClientLogger, 'SocketClientLogger', classMeta);
		  setMetadataFor(MediaClientLogger, 'MediaClientLogger', classMeta);
		  setMetadataFor(SessionAPILogger, 'SessionAPILogger', classMeta);
		  setMetadataFor(VoiceAPILogger, 'VoiceAPILogger', classMeta);
		  setMetadataFor(PushAPILogger, 'PushAPILogger', classMeta);
		  setMetadataFor(ConversationAPILogger, 'ConversationAPILogger', classMeta);
		  setMetadataFor(ChatAPILogger, 'ChatAPILogger', classMeta, VOID, [ChatAPI]);
		  setMetadataFor(SocketClientDelegateLogger, 'SocketClientDelegateLogger', classMeta);
		  setMetadataFor(MediaClientDelegateLogger, 'MediaClientDelegateLogger', classMeta);
		  setMetadataFor(SessionAPIListenerLogger, 'SessionAPIListenerLogger', classMeta);
		  setMetadataFor(VoiceAPIListenerLogger, 'VoiceAPIListenerLogger', classMeta, VOID, [VoiceClientListener]);
		  setMetadataFor(ChatAPIListenerLogger, 'ChatAPIListenerLogger', classMeta);
		  setMetadataFor(CallbackAction, 'CallbackAction', classMeta);
		  setMetadataFor(BufferedSocketEvent, 'BufferedSocketEvent', classMeta);
		  setMetadataFor(CSEndPoints, 'CSEndPoints', classMeta);
		  setMetadataFor(UserConversations, 'UserConversations', classMeta, CSEndPoints);
		  setMetadataFor(User_0, 'User', classMeta, CSEndPoints);
		  setMetadataFor(ConversationMembers, 'ConversationMembers', classMeta, CSEndPoints);
		  setMetadataFor(ConversationMember, 'ConversationMember', classMeta, CSEndPoints);
		  setMetadataFor(Conversations, 'Conversations', classMeta, CSEndPoints, VOID, Conversations);
		  setMetadataFor(Conversation_1, 'Conversation', classMeta, CSEndPoints);
		  setMetadataFor(ConversationEvents, 'ConversationEvents', classMeta, CSEndPoints);
		  setMetadataFor(ConversationEvent, 'ConversationEvent', classMeta, CSEndPoints);
		  setMetadataFor(RtcReconnect, 'RtcReconnect', classMeta, CSEndPoints);
		  setMetadataFor(ConversationMemberMe, 'ConversationMemberMe', classMeta, CSEndPoints);
		  setMetadataFor(Leg_0, 'Leg', classMeta, CSEndPoints);
		  setMetadataFor(Knockers, 'Knockers', classMeta, CSEndPoints, VOID, Knockers);
		  setMetadataFor(Knocker, 'Knocker', classMeta, CSEndPoints);
		  setMetadataFor(Legs, 'Legs', classMeta, CSEndPoints, VOID, Legs);
		  setMetadataFor(Sessions, 'Sessions', classMeta, CSEndPoints);
		  setMetadataFor(RTCAnswer_0, 'RTCAnswer', classMeta, CSEndPoints);
		  setMetadataFor(ConversationLegs, 'ConversationLegs', classMeta, CSEndPoints);
		  setMetadataFor(CapiEndpoints, 'CapiEndpoints', classMeta);
		  setMetadataFor(Metrics, 'Metrics', classMeta, CapiEndpoints, VOID, Metrics);
		  setMetadataFor(HTTPMethod, 'HTTPMethod', classMeta, Enum);
		  setMetadataFor(HTTPClientError, 'HTTPClientError', classMeta, Exception, VOID, HTTPClientError);
		  setMetadataFor(HTTPClientResponse, 'HTTPClientResponse', classMeta);
		  setMetadataFor(RtcStatsEndpoints, 'RtcStatsEndpoints', classMeta);
		  setMetadataFor(RTCStats, 'RTCStats', objectMeta, RtcStatsEndpoints);
		  setMetadataFor(mediaActionMiddleware$2$1, VOID, classMeta);
		  setMetadataFor(MediaConnectionState, 'MediaConnectionState', classMeta, Enum);
		  setMetadataFor(SocketConfig, 'SocketConfig', classMeta);
		  setMetadataFor(SocketConnectionMiddleware$2$1, VOID, classMeta);
		  setMetadataFor(IgnoredSerializerException, 'IgnoredSerializerException', classMeta, Exception);
		  setMetadataFor(WSEndPoints, 'WSEndPoints', classMeta);
		  setMetadataFor(Logout, 'Logout', classMeta, WSEndPoints, VOID, Logout);
		  setMetadataFor(SetConfig, 'SetConfig', classMeta);
		  setMetadataFor(Reducer_0, 'Reducer', classMeta);
		  setMetadataFor(ConfigReducer, 'ConfigReducer', classMeta, Reducer_0);
		  setMetadataFor(ConfigState, 'ConfigState', classMeta, VOID, VOID, ConfigState);
		  setMetadataFor(RemoteEventReducer, 'RemoteEventReducer', classMeta, Reducer_0);
		  setMetadataFor(RemoteEventState, 'RemoteEventState', classMeta, VOID, VOID, RemoteEventState);
		  setMetadataFor(SessionReducer, 'SessionReducer', classMeta, Reducer_0);
		  setMetadataFor(SessionState, 'SessionState', classMeta, VOID, VOID, SessionState);
		  setMetadataFor(SessionUser, 'SessionUser', classMeta);
		  setMetadataFor(Call_0, 'Call', classMeta);
		  setMetadataFor(CallDirection, 'CallDirection', classMeta, Enum);
		  setMetadataFor(New, 'New', objectMeta);
		  setMetadataFor(Connected, 'Connected', objectMeta);
		  setMetadataFor(Disconnected, 'Disconnected', objectMeta);
		  setMetadataFor(Reconnecting, 'Reconnecting', classMeta, VOID, VOID, Reconnecting);
		  setMetadataFor(CallReducer, 'CallReducer', classMeta, Reducer_0);
		  setMetadataFor(CallState, 'CallState', classMeta, VOID, VOID, CallState);
		  setMetadataFor(None_1, 'None', objectMeta);
		  setMetadataFor(Knocking, 'Knocking', classMeta);
		  setMetadataFor(CoreMemberStateWithCid, 'CoreMemberStateWithCid', interfaceMeta);
		  setMetadataFor(Invited, 'Invited', classMeta, VOID, [CoreMemberStateWithCid]);
		  setMetadataFor(Joined, 'Joined', classMeta, VOID, [CoreMemberStateWithCid]);
		  setMetadataFor(Left, 'Left', classMeta, VOID, [CoreMemberStateWithCid]);
		  setMetadataFor(Invite_0, 'Invite', classMeta);
		  setMetadataFor(InviteReducer, 'InviteReducer', classMeta, Reducer_0);
		  setMetadataFor(InviteState, 'InviteState', classMeta, VOID, VOID, InviteState);
		  setMetadataFor(MediaEventReducer, 'MediaEventReducer', classMeta, Reducer_0);
		  setMetadataFor(MediaEventState, 'MediaEventState', classMeta, VOID, VOID, MediaEventState);
		  setMetadataFor(RTCStats_0, 'RTCStats', classMeta);
		  setMetadataFor(Companion_154, 'Companion', objectMeta);
		  setMetadataFor(EventBuffer, 'EventBuffer', classMeta, VOID, VOID, EventBuffer);
		  setMetadataFor(Companion_155, 'Companion', objectMeta);
		  setMetadataFor(Action_0, 'Action', classMeta);
		  setMetadataFor(UnitActionable, 'UnitActionable', objectMeta);
		  setMetadataFor(ActionMeta, 'ActionMeta', classMeta, VOID, VOID, ActionMeta);
		  setMetadataFor(Store_0, 'Store', classMeta, VOID, VOID, Store_0);
		  setMetadataFor(StoredSubscription, 'StoredSubscription', classMeta);
		  setMetadataFor(Companion_156, 'Companion', objectMeta);
		  setMetadataFor(Option, 'Option', classMeta, VOID, VOID, VOID, VOID, {0: Companion_getInstance_159});
		  setMetadataFor(None_2, 'None', classMeta, Option, VOID, None_2);
		  setMetadataFor(Some, 'Some', classMeta, Option);
		  setMetadataFor(Companion_157, 'Companion', objectMeta, VOID, [SerializerFactory]);
		  setMetadataFor(StateTransition, 'StateTransition', classMeta);
		  setMetadataFor(Pending, 'Pending', classMeta, StateTransition);
		  setMetadataFor(Resolved, 'Resolved', classMeta, StateTransition);
		  setMetadataFor(Failed, 'Failed', classMeta, StateTransition);
		  //endregion
		  function BuildKonfig() {
		    this.p1d_1 = '1.7.2';
		  }
		  var BuildKonfig_instance;
		  function BuildKonfig_getInstance() {
		    return BuildKonfig_instance;
		  }
		  function CoreClientWithMedia() {
		  }
		  function _get_logger__rkp4sl($this) {
		    var tmp = $this.i1e_1;
		    if (!(tmp == null))
		      return tmp;
		    else {
		      throwUninitializedPropertyAccessException('logger');
		    }
		  }
		  function _get_http__d7tner($this) {
		    var tmp = $this.j1e_1;
		    if (!(tmp == null))
		      return tmp;
		    else {
		      throwUninitializedPropertyAccessException('http');
		    }
		  }
		  function _get_socket__42u6ew($this) {
		    var tmp = $this.k1e_1;
		    if (!(tmp == null))
		      return tmp;
		    else {
		      throwUninitializedPropertyAccessException('socket');
		    }
		  }
		  function media($this, a) {
		    $this.l1e_1 = new MediaClientLogger(a, _get_logger__rkp4sl($this));
		    return $this;
		  }
		  function Builder() {
		    this.l1e_1 = null;
		    this.m1e_1 = null;
		  }
		  protoOf(Builder).n1e = function (adapter) {
		    this.i1e_1 = adapter;
		    return this;
		  };
		  protoOf(Builder).o1e = function (a) {
		    this.j1e_1 = new HTTPClientLogger(a, _get_logger__rkp4sl(this));
		    return this;
		  };
		  protoOf(Builder).p1e = function (a) {
		    this.k1e_1 = new SocketClientLogger(a, _get_logger__rkp4sl(this));
		    return this;
		  };
		  protoOf(Builder).q1e = function (media_0) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.Builder.build.<anonymous>' call
		    // Inline function 'kotlin.let' call
		    // Inline function 'kotlin.contracts.contract' call
		    media(this, media_0);
		    var tmp = this.to();
		    return isInterface(tmp, CoreClientWithMedia) ? tmp : THROW_CCE();
		  };
		  protoOf(Builder).to = function () {
		    var tmp0_elvis_lhs = this.m1e_1;
		    var store = tmp0_elvis_lhs == null ? getStoreWithReducersAndMiddleware(_get_socket__42u6ew(this), _get_http__d7tner(this), this.l1e_1, _get_logger__rkp4sl(this)) : tmp0_elvis_lhs;
		    var eventAPI = new EventAPIImpl(store);
		    var sessionAPI = new SessionAPIImpl(store, _get_logger__rkp4sl(this));
		    var voiceAPI = new VoiceAPIImpl(store, eventAPI, _get_logger__rkp4sl(this));
		    var pushAPI = new PushAPIImpl(store, sessionAPI);
		    var conversationAPI = new ConversationAPIImpl(store);
		    var chatAPI = new ChatAPIImpl(store, eventAPI);
		    return new CoreClientImpl(store, eventAPI, new SessionAPILogger(sessionAPI, _get_logger__rkp4sl(this)), new VoiceAPILogger(voiceAPI, _get_logger__rkp4sl(this)), new PushAPILogger(pushAPI, _get_logger__rkp4sl(this)), new ConversationAPILogger(conversationAPI, _get_logger__rkp4sl(this)), new ChatAPILogger(chatAPI, _get_logger__rkp4sl(this)));
		  };
		  function getStoreWithReducersAndMiddleware(socket, http, media, logger) {
		    var store = new Store_0();
		    store.t1e(getStoreWithReducersAndMiddleware$lambda(logger, socket, http, media));
		    store.w1e(listOfNotNull([new CallReducer(logger.v1e(Call_getInstance())), new InviteReducer(logger.v1e(Invite_getInstance())), new SessionReducer(logger.v1e(Session_getInstance_0())), new ConfigReducer(logger.v1e(Config_getInstance())), new RemoteEventReducer(logger.v1e(RemoteEvent_getInstance())), new MediaEventReducer(logger.v1e(MediaEvent_getInstance()))]));
		    return store;
		  }
		  function CoreClientImpl(store, eventAPI, sessionAPI, voiceAPI, pushAPI, conversationAPI, chatAPI) {
		    this.x1e_1 = store;
		    this.y1e_1 = eventAPI;
		    this.z1e_1 = sessionAPI;
		    this.a1f_1 = voiceAPI;
		    this.b1f_1 = pushAPI;
		    this.c1f_1 = conversationAPI;
		    this.d1f_1 = chatAPI;
		  }
		  protoOf(CoreClientImpl).a1e = function (callId, callback) {
		    this.a1f_1.a1e(callId, callback);
		  };
		  protoOf(CoreClientImpl).f1e = function (callId, callback) {
		    this.a1f_1.f1e(callId, callback);
		  };
		  protoOf(CoreClientImpl).e1e = function (callId, callback) {
		    this.a1f_1.e1e(callId, callback);
		  };
		  protoOf(CoreClientImpl).y1d = function (callId, parameters, callback) {
		    this.a1f_1.y1d(callId, parameters, callback);
		  };
		  protoOf(CoreClientImpl).x1d = function (legId, callback) {
		    this.a1f_1.x1d(legId, callback);
		  };
		  protoOf(CoreClientImpl).b1e = function (callId, reasonText, reasonCode, callback) {
		    this.a1f_1.b1e(callId, reasonText, reasonCode, callback);
		  };
		  protoOf(CoreClientImpl).c1e = function (callId, callback) {
		    this.a1f_1.c1e(callId, callback);
		  };
		  protoOf(CoreClientImpl).w1d = function (callId, callback) {
		    this.a1f_1.w1d(callId, callback);
		  };
		  protoOf(CoreClientImpl).z1d = function (callId, callback) {
		    this.a1f_1.z1d(callId, callback);
		  };
		  protoOf(CoreClientImpl).h1e = function (callId, text, level, loop, queue, voiceName, ssml, callback) {
		    this.a1f_1.h1e(callId, text, level, loop, queue, voiceName, ssml, callback);
		  };
		  protoOf(CoreClientImpl).g1e = function (callId, digits, callback) {
		    this.a1f_1.g1e(callId, digits, callback);
		  };
		  protoOf(CoreClientImpl).v1d = function (context, callback) {
		    this.a1f_1.v1d(context, callback);
		  };
		  protoOf(CoreClientImpl).u1d = function (listener) {
		    this.a1f_1.u1d(listener);
		  };
		  protoOf(CoreClientImpl).d1e = function (callId, callback) {
		    this.a1f_1.d1e(callId, callback);
		  };
		  protoOf(CoreClientImpl).r1d = function (_set____db54di) {
		    this.d1f_1.r1d(_set____db54di);
		  };
		  protoOf(CoreClientImpl).e1f = function (parameters, callback) {
		    this.d1f_1.e1f(parameters, callback);
		  };
		  protoOf(CoreClientImpl).f1f = function (cid, callback) {
		    this.d1f_1.f1f(cid, callback);
		  };
		  protoOf(CoreClientImpl).g1f = function (id, cid, callback) {
		    this.d1f_1.g1f(id, cid, callback);
		  };
		  protoOf(CoreClientImpl).h1f = function (cid, parameters, filterGroup, filterGroupVersion, callback) {
		    this.d1f_1.h1f(cid, parameters, filterGroup, filterGroupVersion, callback);
		  };
		  protoOf(CoreClientImpl).i1f = function (cid, mid, callback) {
		    this.d1f_1.i1f(cid, mid, callback);
		  };
		  protoOf(CoreClientImpl).j1f = function (cid, parameters, callback) {
		    this.d1f_1.j1f(cid, parameters, callback);
		  };
		  protoOf(CoreClientImpl).k1f = function (parameters, callback) {
		    this.d1f_1.k1f(parameters, callback);
		  };
		  protoOf(CoreClientImpl).l1f = function (cid, username, callback) {
		    this.d1f_1.l1f(cid, username, callback);
		  };
		  protoOf(CoreClientImpl).m1f = function (cid, callback) {
		    this.d1f_1.m1f(cid, callback);
		  };
		  protoOf(CoreClientImpl).n1f = function (cid, callback) {
		    this.d1f_1.n1f(cid, callback);
		  };
		  protoOf(CoreClientImpl).o1f = function (cid, eventType, customData, callback) {
		    this.d1f_1.o1f(cid, eventType, customData, callback);
		  };
		  protoOf(CoreClientImpl).p1f = function (cid, customData, callback) {
		    this.d1f_1.p1f(cid, customData, callback);
		  };
		  protoOf(CoreClientImpl).q1f = function (cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callback) {
		    this.d1f_1.q1f(cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callback);
		  };
		  protoOf(CoreClientImpl).r1f = function (id, cid, callback) {
		    this.d1f_1.r1f(id, cid, callback);
		  };
		  protoOf(CoreClientImpl).s1f = function (conversationId, parameters, callback) {
		    this.d1f_1.s1f(conversationId, parameters, callback);
		  };
		  protoOf(CoreClientImpl).t1f = function (token, sessionId, callback) {
		    this.z1e_1.t1f(token, sessionId, callback);
		  };
		  protoOf(CoreClientImpl).u1f = function (callback) {
		    this.z1e_1.u1f(callback);
		  };
		  protoOf(CoreClientImpl).v1f = function (token, callback) {
		    this.z1e_1.v1f(token, callback);
		  };
		  protoOf(CoreClientImpl).q1d = function (listener) {
		    this.z1e_1.q1d(listener);
		  };
		  protoOf(CoreClientImpl).w1f = function (listener) {
		    this.y1e_1.w1f(listener);
		  };
		  protoOf(CoreClientImpl).x1f = function (conversationIdOrName, callback) {
		    this.c1f_1.x1f(conversationIdOrName, callback);
		  };
		  protoOf(CoreClientImpl).y1f = function (userIdOrName, callback) {
		    this.c1f_1.y1f(userIdOrName, callback);
		  };
		  protoOf(CoreClientImpl).z1f = function (actionable) {
		    this.x1e_1.a1g(Action_init_$Create$(actionable));
		  };
		  function getStoreWithReducersAndMiddleware$lambda($logger, $socket, $http, $media) {
		    return function (s) {
		      var storeActionLoggerAdapter = $logger.v1e(Action_getInstance());
		      return compose([loggingMiddleware(s, storeActionLoggerAdapter), exceptionHandlerMiddleware(s, storeActionLoggerAdapter), socketEventParseMiddleware(s, $logger.v1e(EventParser_getInstance())), SocketConnectionMiddleware(s, $socket, $logger.v1e(Connection_getInstance())), httpActionMiddleware(s, $http, $logger.v1e(Middleware_getInstance())), SocketEmitMiddleware(s, $socket, $logger.v1e(EventEmit_getInstance())), CallbackMiddleware(s, $logger.v1e(Callback_getInstance())), SessionMiddleware(s, storeActionLoggerAdapter), !($media == null) ? mediaActionMiddleware(s, $media, $logger.v1e(Middleware_getInstance_1())) : null]);
		    };
		  }
		  function SdkInfo() {
		    SdkInfo_instance = this;
		    this.b1g_1 = BuildKonfig_instance.p1d_1;
		  }
		  var SdkInfo_instance;
		  function SdkInfo_getInstance() {
		    if (SdkInfo_instance == null)
		      new SdkInfo();
		    return SdkInfo_instance;
		  }
		  function StaticConfig() {
		    this.c1g_1 = 5000;
		    this.d1g_1 = 10000;
		    this.e1g_1 = 500;
		    this.f1g_1 = 1000;
		    this.g1g_1 = 3000;
		    this.h1g_1 = 5;
		    this.i1g_1 = 'local_cancel';
		    this.j1g_1 = 'cancelled';
		    this.k1g_1 = 'ring_timer';
		    this.l1g_1 = 'timeout';
		    this.m1g_1 = 'remote_no_answer';
		    this.n1g_1 = 'unanswered';
		    this.o1g_1 = 'remote_rejected';
		    this.p1g_1 = 'rejected';
		    this.q1g_1 = 'REMOTE_REJECT';
		    this.r1g_1 = 'call-rejected-by-callee';
		    this.s1g_1 = 'LOCAL_HANGUP';
		    this.t1g_1 = 'Call answered, terminated by FS, [Hangup-Cause=NORMAL_CLEARING]';
		    this.u1g_1 = 200;
		    this.v1g_1 = 'LOCAL_CANCEL';
		    this.w1g_1 = 'Call cancelled, terminated by FS, [Hangup-Cause=NO_ANSWER]';
		    this.x1g_1 = 487;
		    this.y1g_1 = 'RING_TIMER';
		    this.z1g_1 = 'Call cancelled before answer, after ring timeout, [Hangup-Cause=NORMAL_CLEARING]';
		    this.a1h_1 = 487;
		    this.b1h_1 = 'REMOTE_REJECTED';
		    this.c1h_1 = 'Call cancelled, terminated by FS, [Hangup-Cause=CALL_REJECTED]';
		    this.d1h_1 = 403;
		    this.e1h_1 = 'LOCAL_HANGUP';
		    this.f1h_1 = 'Call answered, terminated by FS, [Hangup-Cause=MEDIA_TIMEOUT]';
		    this.g1h_1 = 200;
		    this.h1h_1 = 'REMOTE_NO_ANSWER';
		    this.i1h_1 = 'Call refused, callee currently unavailable, [Hangup-Cause=NO_USER_RESPONSE]';
		    this.j1h_1 = 480;
		    this.k1h_1 = 10;
		    this.l1h_1 = false;
		    this.m1h_1 = 'ChatEvents';
		    this.n1h_1 = 3;
		  }
		  var StaticConfig_instance;
		  function StaticConfig_getInstance() {
		    return StaticConfig_instance;
		  }
		  function ErrorReport(error, src) {
		    this.o1h_1 = error;
		    this.p1h_1 = src;
		  }
		  protoOf(ErrorReport).toString = function () {
		    return 'ErrorReport(error=' + this.o1h_1 + ', src=' + this.p1h_1 + ')';
		  };
		  protoOf(ErrorReport).hashCode = function () {
		    var result = hashCode(this.o1h_1);
		    result = imul(result, 31) + hashCode(this.p1h_1) | 0;
		    return result;
		  };
		  protoOf(ErrorReport).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ErrorReport))
		      return false;
		    var tmp0_other_with_cast = other instanceof ErrorReport ? other : THROW_CCE();
		    if (!equals(this.o1h_1, tmp0_other_with_cast.o1h_1))
		      return false;
		    if (!equals(this.p1h_1, tmp0_other_with_cast.p1h_1))
		      return false;
		    return true;
		  };
		  function UpdateSessionRequest(sessionId, token) {
		    this.q1h_1 = sessionId;
		    this.r1h_1 = token;
		    this.s1h_1 = new Sessions(this.q1h_1);
		    this.t1h_1 = HTTPMethod_PUT_getInstance();
		  }
		  protoOf(UpdateSessionRequest).u1h = function () {
		    return this.s1h_1;
		  };
		  protoOf(UpdateSessionRequest).v1h = function () {
		    return this.t1h_1;
		  };
		  protoOf(UpdateSessionRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(PrimitiveClasses_getInstance().s6(), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, '');
		  };
		  protoOf(UpdateSessionRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(UpdateSession), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(UpdateSessionRequest).toString = function () {
		    return 'UpdateSessionRequest(sessionId=' + this.q1h_1 + ', token=' + this.r1h_1 + ')';
		  };
		  protoOf(UpdateSessionRequest).hashCode = function () {
		    var result = getStringHashCode(this.q1h_1);
		    result = imul(result, 31) + getStringHashCode(this.r1h_1) | 0;
		    return result;
		  };
		  protoOf(UpdateSessionRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UpdateSessionRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof UpdateSessionRequest ? other : THROW_CCE();
		    if (!(this.q1h_1 === tmp0_other_with_cast.q1h_1))
		      return false;
		    if (!(this.r1h_1 === tmp0_other_with_cast.r1h_1))
		      return false;
		    return true;
		  };
		  function Companion() {
		    Companion_instance_0 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.a1i_1 = [null, new ReferenceArraySerializer(getKClass(MetricsBody), $serializer_getInstance_0())];
		  }
		  var Companion_instance_0;
		  function Companion_getInstance_1() {
		    if (Companion_instance_0 == null)
		      new Companion();
		    return Companion_instance_0;
		  }
		  function $serializer() {
		    $serializer_instance = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MetricsWsReconnectionTimeReq.MetricsWsReconnectionTimeBody', this, 2);
		    tmp0_serialDesc.pq('sessionId', false);
		    tmp0_serialDesc.pq('metrics', false);
		    this.b1i_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer).uf = function () {
		    return this.b1i_1;
		  };
		  protoOf($serializer).er = function () {
		    var tmp0_cached = Companion_getInstance_1().a1i_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), tmp0_cached[1]];
		  };
		  protoOf($serializer).wf = function (decoder) {
		    var tmp0_desc = this.b1i_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    var tmp7_cached = Companion_getInstance_1().a1i_1;
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return MetricsWsReconnectionTimeBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer).c1i = function (encoder, value) {
		    var tmp0_desc = this.b1i_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_1().a1i_1;
		    tmp1_output.tk(tmp0_desc, 0, value.d1i_1);
		    tmp1_output.vk(tmp0_desc, 1, tmp2_cached[1], value.e1i_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer).vf = function (encoder, value) {
		    return this.c1i(encoder, value instanceof MetricsWsReconnectionTimeBody ? value : THROW_CCE());
		  };
		  var $serializer_instance;
		  function $serializer_getInstance() {
		    if ($serializer_instance == null)
		      new $serializer();
		    return $serializer_instance;
		  }
		  function MetricsWsReconnectionTimeBody_init_$Init$(seen1, sessionId, metrics, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance().b1i_1);
		    }
		    $this.d1i_1 = sessionId;
		    $this.e1i_1 = metrics;
		    return $this;
		  }
		  function MetricsWsReconnectionTimeBody_init_$Create$(seen1, sessionId, metrics, serializationConstructorMarker) {
		    return MetricsWsReconnectionTimeBody_init_$Init$(seen1, sessionId, metrics, serializationConstructorMarker, objectCreate(protoOf(MetricsWsReconnectionTimeBody)));
		  }
		  function Companion_0() {
		  }
		  var Companion_instance_1;
		  function Companion_getInstance_2() {
		    return Companion_instance_1;
		  }
		  function $serializer_0() {
		    $serializer_instance_0 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MetricsWsReconnectionTimeReq.MetricsBody', this, 3);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('time', false);
		    tmp0_serialDesc.pq('attempt', false);
		    this.f1i_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_0).uf = function () {
		    return this.f1i_1;
		  };
		  protoOf($serializer_0).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
		  };
		  protoOf($serializer_0).wf = function (decoder) {
		    var tmp0_desc = this.f1i_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return MetricsBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_0).g1i = function (encoder, value) {
		    var tmp0_desc = this.f1i_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.h1i_1);
		    tmp1_output.xk(tmp0_desc, 1, LongSerializer_getInstance(), value.i1i_1);
		    tmp1_output.xk(tmp0_desc, 2, IntSerializer_getInstance(), value.j1i_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_0).vf = function (encoder, value) {
		    return this.g1i(encoder, value instanceof MetricsBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_0;
		  function $serializer_getInstance_0() {
		    if ($serializer_instance_0 == null)
		      new $serializer_0();
		    return $serializer_instance_0;
		  }
		  function MetricsBody_init_$Init$(seen1, name, time, attempt, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_0().f1i_1);
		    }
		    $this.h1i_1 = name;
		    $this.i1i_1 = time;
		    $this.j1i_1 = attempt;
		    return $this;
		  }
		  function MetricsBody_init_$Create$(seen1, name, time, attempt, serializationConstructorMarker) {
		    return MetricsBody_init_$Init$(seen1, name, time, attempt, serializationConstructorMarker, objectCreate(protoOf(MetricsBody)));
		  }
		  function Companion_1() {
		  }
		  var Companion_instance_2;
		  function Companion_getInstance_3() {
		    return Companion_instance_2;
		  }
		  function $serializer_1() {
		    $serializer_instance_1 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MetricsWsReconnectionTimeReq.Body', this, 1);
		    tmp0_serialDesc.pq('body', false);
		    this.k1i_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_1).uf = function () {
		    return this.k1i_1;
		  };
		  protoOf($serializer_1).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance()];
		  };
		  protoOf($serializer_1).wf = function (decoder) {
		    var tmp0_desc = this.k1i_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return Body_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_1).l1i = function (encoder, value) {
		    var tmp0_desc = this.k1i_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance(), value.m1i_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_1).vf = function (encoder, value) {
		    return this.l1i(encoder, value instanceof Body ? value : THROW_CCE());
		  };
		  var $serializer_instance_1;
		  function $serializer_getInstance_1() {
		    if ($serializer_instance_1 == null)
		      new $serializer_1();
		    return $serializer_instance_1;
		  }
		  function Body_init_$Init$(seen1, body, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_1().k1i_1);
		    }
		    $this.m1i_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$(seen1, body, serializationConstructorMarker) {
		    return Body_init_$Init$(seen1, body, serializationConstructorMarker, objectCreate(protoOf(Body)));
		  }
		  function MetricsWsReconnectionTimeBody(sessionId, metrics) {
		    Companion_getInstance_1();
		    this.d1i_1 = sessionId;
		    this.e1i_1 = metrics;
		  }
		  protoOf(MetricsWsReconnectionTimeBody).toString = function () {
		    return 'MetricsWsReconnectionTimeBody(sessionId=' + this.d1i_1 + ', metrics=' + toString(this.e1i_1) + ')';
		  };
		  protoOf(MetricsWsReconnectionTimeBody).hashCode = function () {
		    var result = getStringHashCode(this.d1i_1);
		    result = imul(result, 31) + hashCode(this.e1i_1) | 0;
		    return result;
		  };
		  protoOf(MetricsWsReconnectionTimeBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MetricsWsReconnectionTimeBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof MetricsWsReconnectionTimeBody ? other : THROW_CCE();
		    if (!(this.d1i_1 === tmp0_other_with_cast.d1i_1))
		      return false;
		    if (!equals(this.e1i_1, tmp0_other_with_cast.e1i_1))
		      return false;
		    return true;
		  };
		  function MetricsBody(name, time, attempt) {
		    this.h1i_1 = name;
		    this.i1i_1 = time;
		    this.j1i_1 = attempt;
		  }
		  protoOf(MetricsBody).toString = function () {
		    return 'MetricsBody(name=' + this.h1i_1 + ', time=' + toString_0(this.i1i_1) + ', attempt=' + this.j1i_1 + ')';
		  };
		  protoOf(MetricsBody).hashCode = function () {
		    var result = getStringHashCode(this.h1i_1);
		    result = imul(result, 31) + (this.i1i_1 == null ? 0 : this.i1i_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.j1i_1 == null ? 0 : this.j1i_1) | 0;
		    return result;
		  };
		  protoOf(MetricsBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MetricsBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof MetricsBody ? other : THROW_CCE();
		    if (!(this.h1i_1 === tmp0_other_with_cast.h1i_1))
		      return false;
		    if (!equals(this.i1i_1, tmp0_other_with_cast.i1i_1))
		      return false;
		    if (!(this.j1i_1 == tmp0_other_with_cast.j1i_1))
		      return false;
		    return true;
		  };
		  function Body(body) {
		    this.m1i_1 = body;
		  }
		  function MetricsWsReconnectionTimeReq(sessionId, time, retryNumber, name) {
		    this.n1i_1 = sessionId;
		    this.o1i_1 = time;
		    this.p1i_1 = retryNumber;
		    this.q1i_1 = name;
		    this.r1i_1 = new Metrics('v2');
		    this.s1i_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(MetricsWsReconnectionTimeReq).u1h = function () {
		    return this.r1i_1;
		  };
		  protoOf(MetricsWsReconnectionTimeReq).v1h = function () {
		    return this.s1i_1;
		  };
		  protoOf(MetricsWsReconnectionTimeReq).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp$ret$2 = [new MetricsBody(this.q1i_1, this.o1i_1, this.p1i_1)];
		    var value = new Body(new MetricsWsReconnectionTimeBody(this.n1i_1, tmp$ret$2));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body), arrayOf([]), false));
		    var tmp$ret$4 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$4, value);
		  };
		  protoOf(MetricsWsReconnectionTimeReq).x1h = function (data, decoder) {
		    return new MetricsWsReconnectionTime();
		  };
		  function Companion_2() {
		  }
		  var Companion_instance_3;
		  function Companion_getInstance_4() {
		    return Companion_instance_3;
		  }
		  function $serializer_2() {
		    $serializer_instance_2 = this;
		    this.t1i_1 = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MetricsWsReconnectionTime', this, 0);
		  }
		  protoOf($serializer_2).uf = function () {
		    return this.t1i_1;
		  };
		  protoOf($serializer_2).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [];
		  };
		  protoOf($serializer_2).wf = function (decoder) {
		    var tmp0_desc = this.t1i_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp4_input = decoder.ej(tmp0_desc);
		    if (!tmp4_input.uj())
		      while (tmp1_flag) {
		        tmp2_index = tmp4_input.vj(tmp0_desc);
		        if (tmp2_index === -1)
		          tmp1_flag = false;
		        else
		          throw UnknownFieldException_init_$Create$(tmp2_index);
		      }
		    tmp4_input.fj(tmp0_desc);
		    return MetricsWsReconnectionTime_init_$Create$(0, null);
		  };
		  protoOf($serializer_2).u1i = function (encoder, value) {
		    var tmp0_desc = this.t1i_1;
		    encoder.ej(tmp0_desc).fj(tmp0_desc);
		  };
		  protoOf($serializer_2).vf = function (encoder, value) {
		    return this.u1i(encoder, value instanceof MetricsWsReconnectionTime ? value : THROW_CCE());
		  };
		  var $serializer_instance_2;
		  function $serializer_getInstance_2() {
		    if ($serializer_instance_2 == null)
		      new $serializer_2();
		    return $serializer_instance_2;
		  }
		  function MetricsWsReconnectionTime_init_$Init$(seen1, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_2().t1i_1);
		    }
		    return $this;
		  }
		  function MetricsWsReconnectionTime_init_$Create$(seen1, serializationConstructorMarker) {
		    return MetricsWsReconnectionTime_init_$Init$(seen1, serializationConstructorMarker, objectCreate(protoOf(MetricsWsReconnectionTime)));
		  }
		  function MetricsWsReconnectionTime() {
		  }
		  function GetLegRequest(legId) {
		    this.v1i_1 = legId;
		    this.w1i_1 = new Leg_0(this.v1i_1);
		    this.x1i_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetLegRequest).u1h = function () {
		    return this.w1i_1;
		  };
		  protoOf(GetLegRequest).v1h = function () {
		    return this.x1i_1;
		  };
		  protoOf(GetLegRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetLeg), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetLegRequest).toString = function () {
		    return 'GetLegRequest(legId=' + this.v1i_1 + ')';
		  };
		  protoOf(GetLegRequest).hashCode = function () {
		    return getStringHashCode(this.v1i_1);
		  };
		  protoOf(GetLegRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetLegRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetLegRequest ? other : THROW_CCE();
		    if (!(this.v1i_1 === tmp0_other_with_cast.v1i_1))
		      return false;
		    return true;
		  };
		  function Companion_3() {
		  }
		  var Companion_instance_4;
		  function Companion_getInstance_5() {
		    return Companion_instance_4;
		  }
		  function $serializer_3() {
		    $serializer_instance_3 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetLeg', this, 10);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('conversation_id', false);
		    tmp0_serialDesc.pq('status', false);
		    tmp0_serialDesc.pq('start_time', false);
		    tmp0_serialDesc.pq('end_time', false);
		    tmp0_serialDesc.pq('direction', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('to', false);
		    tmp0_serialDesc.pq('media_state', true);
		    this.y1i_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_3).uf = function () {
		    return this.y1i_1;
		  };
		  protoOf($serializer_3).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_158(), $serializer_getInstance_158(), get_nullable($serializer_getInstance_160())];
		  };
		  protoOf($serializer_3).wf = function (decoder) {
		    var tmp0_desc = this.y1i_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_local7 = null;
		    var tmp12_local8 = null;
		    var tmp13_local9 = null;
		    var tmp14_input = decoder.ej(tmp0_desc);
		    if (tmp14_input.uj()) {
		      tmp4_local0 = tmp14_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp14_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp14_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp14_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp14_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp14_input.oj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp14_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp14_input.qj(tmp0_desc, 7, $serializer_getInstance_158(), tmp11_local7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		      tmp12_local8 = tmp14_input.qj(tmp0_desc, 8, $serializer_getInstance_158(), tmp12_local8);
		      tmp3_bitMask0 = tmp3_bitMask0 | 256;
		      tmp13_local9 = tmp14_input.sj(tmp0_desc, 9, $serializer_getInstance_160(), tmp13_local9);
		      tmp3_bitMask0 = tmp3_bitMask0 | 512;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp14_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp14_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp14_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp14_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp14_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp14_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp14_input.oj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp14_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp14_input.qj(tmp0_desc, 7, $serializer_getInstance_158(), tmp11_local7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          case 8:
		            tmp12_local8 = tmp14_input.qj(tmp0_desc, 8, $serializer_getInstance_158(), tmp12_local8);
		            tmp3_bitMask0 = tmp3_bitMask0 | 256;
		            break;
		          case 9:
		            tmp13_local9 = tmp14_input.sj(tmp0_desc, 9, $serializer_getInstance_160(), tmp13_local9);
		            tmp3_bitMask0 = tmp3_bitMask0 | 512;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp14_input.fj(tmp0_desc);
		    return GetLeg_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
		  };
		  protoOf($serializer_3).z1i = function (encoder, value) {
		    var tmp0_desc = this.y1i_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.a1j_1);
		    tmp1_output.tk(tmp0_desc, 1, value.b1j_1);
		    tmp1_output.tk(tmp0_desc, 2, value.c1j_1);
		    tmp1_output.tk(tmp0_desc, 3, value.d1j_1);
		    tmp1_output.tk(tmp0_desc, 4, value.e1j_1);
		    tmp1_output.tk(tmp0_desc, 5, value.f1j_1);
		    tmp1_output.tk(tmp0_desc, 6, value.g1j_1);
		    tmp1_output.vk(tmp0_desc, 7, $serializer_getInstance_158(), value.h1j_1);
		    tmp1_output.vk(tmp0_desc, 8, $serializer_getInstance_158(), value.i1j_1);
		    if (tmp1_output.bl(tmp0_desc, 9) ? true : !(value.j1j_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 9, $serializer_getInstance_160(), value.j1j_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_3).vf = function (encoder, value) {
		    return this.z1i(encoder, value instanceof GetLeg ? value : THROW_CCE());
		  };
		  var $serializer_instance_3;
		  function $serializer_getInstance_3() {
		    if ($serializer_instance_3 == null)
		      new $serializer_3();
		    return $serializer_instance_3;
		  }
		  function GetLeg_init_$Init$(seen1, id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state, serializationConstructorMarker, $this) {
		    if (!(511 === (511 & seen1))) {
		      throwMissingFieldException(seen1, 511, $serializer_getInstance_3().y1i_1);
		    }
		    $this.a1j_1 = id;
		    $this.b1j_1 = conversation_id;
		    $this.c1j_1 = status;
		    $this.d1j_1 = start_time;
		    $this.e1j_1 = end_time;
		    $this.f1j_1 = direction;
		    $this.g1j_1 = type;
		    $this.h1j_1 = from;
		    $this.i1j_1 = to;
		    if (0 === (seen1 & 512))
		      $this.j1j_1 = null;
		    else
		      $this.j1j_1 = media_state;
		    return $this;
		  }
		  function GetLeg_init_$Create$(seen1, id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state, serializationConstructorMarker) {
		    return GetLeg_init_$Init$(seen1, id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state, serializationConstructorMarker, objectCreate(protoOf(GetLeg)));
		  }
		  function GetLeg(id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state) {
		    media_state = media_state === VOID ? null : media_state;
		    this.a1j_1 = id;
		    this.b1j_1 = conversation_id;
		    this.c1j_1 = status;
		    this.d1j_1 = start_time;
		    this.e1j_1 = end_time;
		    this.f1j_1 = direction;
		    this.g1j_1 = type;
		    this.h1j_1 = from;
		    this.i1j_1 = to;
		    this.j1j_1 = media_state;
		  }
		  protoOf(GetLeg).k1j = function (id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state) {
		    return new GetLeg(id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state);
		  };
		  protoOf(GetLeg).l1j = function (id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state, $super) {
		    id = id === VOID ? this.a1j_1 : id;
		    conversation_id = conversation_id === VOID ? this.b1j_1 : conversation_id;
		    status = status === VOID ? this.c1j_1 : status;
		    start_time = start_time === VOID ? this.d1j_1 : start_time;
		    end_time = end_time === VOID ? this.e1j_1 : end_time;
		    direction = direction === VOID ? this.f1j_1 : direction;
		    type = type === VOID ? this.g1j_1 : type;
		    from = from === VOID ? this.h1j_1 : from;
		    to = to === VOID ? this.i1j_1 : to;
		    media_state = media_state === VOID ? this.j1j_1 : media_state;
		    return $super === VOID ? this.k1j(id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state) : $super.k1j.call(this, id, conversation_id, status, start_time, end_time, direction, type, from, to, media_state);
		  };
		  protoOf(GetLeg).toString = function () {
		    return 'GetLeg(id=' + this.a1j_1 + ', conversation_id=' + this.b1j_1 + ', status=' + this.c1j_1 + ', start_time=' + this.d1j_1 + ', end_time=' + this.e1j_1 + ', direction=' + this.f1j_1 + ', type=' + this.g1j_1 + ', from=' + this.h1j_1 + ', to=' + this.i1j_1 + ', media_state=' + this.j1j_1 + ')';
		  };
		  protoOf(GetLeg).hashCode = function () {
		    var result = getStringHashCode(this.a1j_1);
		    result = imul(result, 31) + getStringHashCode(this.b1j_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.c1j_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.d1j_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.e1j_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f1j_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.g1j_1) | 0;
		    result = imul(result, 31) + this.h1j_1.hashCode() | 0;
		    result = imul(result, 31) + this.i1j_1.hashCode() | 0;
		    result = imul(result, 31) + (this.j1j_1 == null ? 0 : this.j1j_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(GetLeg).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetLeg))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetLeg ? other : THROW_CCE();
		    if (!(this.a1j_1 === tmp0_other_with_cast.a1j_1))
		      return false;
		    if (!(this.b1j_1 === tmp0_other_with_cast.b1j_1))
		      return false;
		    if (!(this.c1j_1 === tmp0_other_with_cast.c1j_1))
		      return false;
		    if (!(this.d1j_1 === tmp0_other_with_cast.d1j_1))
		      return false;
		    if (!(this.e1j_1 === tmp0_other_with_cast.e1j_1))
		      return false;
		    if (!(this.f1j_1 === tmp0_other_with_cast.f1j_1))
		      return false;
		    if (!(this.g1j_1 === tmp0_other_with_cast.g1j_1))
		      return false;
		    if (!this.h1j_1.equals(tmp0_other_with_cast.h1j_1))
		      return false;
		    if (!this.i1j_1.equals(tmp0_other_with_cast.i1j_1))
		      return false;
		    if (!equals(this.j1j_1, tmp0_other_with_cast.j1j_1))
		      return false;
		    return true;
		  };
		  function GetConversationRequest(cid) {
		    this.m1j_1 = cid;
		    this.n1j_1 = new Conversation_1(this.m1j_1);
		    this.o1j_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetConversationRequest).u1h = function () {
		    return this.n1j_1;
		  };
		  protoOf(GetConversationRequest).v1h = function () {
		    return this.o1j_1;
		  };
		  protoOf(GetConversationRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetConversation), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetConversationRequest).toString = function () {
		    return 'GetConversationRequest(cid=' + this.m1j_1 + ')';
		  };
		  protoOf(GetConversationRequest).hashCode = function () {
		    return getStringHashCode(this.m1j_1);
		  };
		  protoOf(GetConversationRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetConversationRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetConversationRequest ? other : THROW_CCE();
		    if (!(this.m1j_1 === tmp0_other_with_cast.m1j_1))
		      return false;
		    return true;
		  };
		  function $serializer_4() {
		    $serializer_instance_4 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetConversation.EmbeddedMember', this, 1);
		    tmp0_serialDesc.pq('member', false);
		    this.p1j_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_4).uf = function () {
		    return this.p1j_1;
		  };
		  protoOf($serializer_4).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_27()];
		  };
		  protoOf($serializer_4).wf = function (decoder) {
		    var tmp0_desc = this.p1j_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_27(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_27(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return EmbeddedMember_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_4).q1j = function (encoder, value) {
		    var tmp0_desc = this.p1j_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_27(), value.r1j_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_4).vf = function (encoder, value) {
		    return this.q1j(encoder, value instanceof EmbeddedMember ? value : THROW_CCE());
		  };
		  var $serializer_instance_4;
		  function $serializer_getInstance_4() {
		    if ($serializer_instance_4 == null)
		      new $serializer_4();
		    return $serializer_instance_4;
		  }
		  function EmbeddedMember_init_$Init$(seen1, member, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_4().p1j_1);
		    }
		    $this.r1j_1 = member;
		    return $this;
		  }
		  function EmbeddedMember_init_$Create$(seen1, member, serializationConstructorMarker) {
		    return EmbeddedMember_init_$Init$(seen1, member, serializationConstructorMarker, objectCreate(protoOf(EmbeddedMember)));
		  }
		  function EmbeddedMember() {
		  }
		  protoOf(EmbeddedMember).toString = function () {
		    return 'EmbeddedMember(member=' + this.r1j_1 + ')';
		  };
		  protoOf(EmbeddedMember).hashCode = function () {
		    return hashCode(this.r1j_1);
		  };
		  protoOf(EmbeddedMember).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EmbeddedMember))
		      return false;
		    var tmp0_other_with_cast = other instanceof EmbeddedMember ? other : THROW_CCE();
		    if (!equals(this.r1j_1, tmp0_other_with_cast.r1j_1))
		      return false;
		    return true;
		  };
		  function Companion_4() {
		    Companion_instance_5 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.s1j_1 = [null, null, null, null, new EnumSerializer('com.vonage.clientcore.core.api.models.ConversationState', values_1()), null, null, null, null];
		  }
		  var Companion_instance_5;
		  function Companion_getInstance_6() {
		    if (Companion_instance_5 == null)
		      new Companion_4();
		    return Companion_instance_5;
		  }
		  function $serializer_5() {
		    $serializer_instance_5 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetConversation', this, 9);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('display_name', true);
		    tmp0_serialDesc.pq('state', true);
		    tmp0_serialDesc.pq('image_url', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('properties', true);
		    tmp0_serialDesc.pq('media_state', true);
		    this.t1j_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_5).uf = function () {
		    return this.t1j_1;
		  };
		  protoOf($serializer_5).er = function () {
		    var tmp0_cached = Companion_getInstance_6().s1j_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_159(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[4]), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_28()), get_nullable($serializer_getInstance_160())];
		  };
		  protoOf($serializer_5).wf = function (decoder) {
		    var tmp0_desc = this.t1j_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_local7 = null;
		    var tmp12_local8 = null;
		    var tmp13_input = decoder.ej(tmp0_desc);
		    var tmp14_cached = Companion_getInstance_6().s1j_1;
		    if (tmp13_input.uj()) {
		      tmp4_local0 = tmp13_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp13_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp13_input.qj(tmp0_desc, 2, $serializer_getInstance_159(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp13_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp13_input.sj(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp13_input.sj(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp13_input.sj(tmp0_desc, 6, $serializer_getInstance_4(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp13_input.sj(tmp0_desc, 7, $serializer_getInstance_28(), tmp11_local7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		      tmp12_local8 = tmp13_input.sj(tmp0_desc, 8, $serializer_getInstance_160(), tmp12_local8);
		      tmp3_bitMask0 = tmp3_bitMask0 | 256;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp13_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp13_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp13_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp13_input.qj(tmp0_desc, 2, $serializer_getInstance_159(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp13_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp13_input.sj(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp13_input.sj(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp13_input.sj(tmp0_desc, 6, $serializer_getInstance_4(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp13_input.sj(tmp0_desc, 7, $serializer_getInstance_28(), tmp11_local7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          case 8:
		            tmp12_local8 = tmp13_input.sj(tmp0_desc, 8, $serializer_getInstance_160(), tmp12_local8);
		            tmp3_bitMask0 = tmp3_bitMask0 | 256;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp13_input.fj(tmp0_desc);
		    return GetConversation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
		  };
		  protoOf($serializer_5).u1j = function (encoder, value) {
		    var tmp0_desc = this.t1j_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_6().s1j_1;
		    tmp1_output.tk(tmp0_desc, 0, value.v1j_1);
		    tmp1_output.tk(tmp0_desc, 1, value.w1j_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_159(), value.x1j_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.y1j_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.y1j_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.z1j_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, tmp2_cached[4], value.z1j_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.a1k_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, StringSerializer_getInstance(), value.a1k_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.b1k_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, $serializer_getInstance_4(), value.b1k_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 7) ? true : !(value.c1k_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 7, $serializer_getInstance_28(), value.c1k_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 8) ? true : !(value.d1k_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 8, $serializer_getInstance_160(), value.d1k_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_5).vf = function (encoder, value) {
		    return this.u1j(encoder, value instanceof GetConversation ? value : THROW_CCE());
		  };
		  var $serializer_instance_5;
		  function $serializer_getInstance_5() {
		    if ($serializer_instance_5 == null)
		      new $serializer_5();
		    return $serializer_instance_5;
		  }
		  function GetConversation_init_$Init$(seen1, id, name, timestamp, display_name, state, image_url, _embedded, properties, media_state, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_5().t1j_1);
		    }
		    $this.v1j_1 = id;
		    $this.w1j_1 = name;
		    $this.x1j_1 = timestamp;
		    if (0 === (seen1 & 8))
		      $this.y1j_1 = null;
		    else
		      $this.y1j_1 = display_name;
		    if (0 === (seen1 & 16))
		      $this.z1j_1 = null;
		    else
		      $this.z1j_1 = state;
		    if (0 === (seen1 & 32))
		      $this.a1k_1 = null;
		    else
		      $this.a1k_1 = image_url;
		    if (0 === (seen1 & 64))
		      $this.b1k_1 = null;
		    else
		      $this.b1k_1 = _embedded;
		    if (0 === (seen1 & 128))
		      $this.c1k_1 = null;
		    else
		      $this.c1k_1 = properties;
		    if (0 === (seen1 & 256))
		      $this.d1k_1 = null;
		    else
		      $this.d1k_1 = media_state;
		    return $this;
		  }
		  function GetConversation_init_$Create$(seen1, id, name, timestamp, display_name, state, image_url, _embedded, properties, media_state, serializationConstructorMarker) {
		    return GetConversation_init_$Init$(seen1, id, name, timestamp, display_name, state, image_url, _embedded, properties, media_state, serializationConstructorMarker, objectCreate(protoOf(GetConversation)));
		  }
		  function GetConversation(id, name, timestamp, display_name, state, image_url, _embedded, properties, media_state) {
		    Companion_getInstance_6();
		    display_name = display_name === VOID ? null : display_name;
		    state = state === VOID ? null : state;
		    image_url = image_url === VOID ? null : image_url;
		    _embedded = _embedded === VOID ? null : _embedded;
		    properties = properties === VOID ? null : properties;
		    media_state = media_state === VOID ? null : media_state;
		    this.v1j_1 = id;
		    this.w1j_1 = name;
		    this.x1j_1 = timestamp;
		    this.y1j_1 = display_name;
		    this.z1j_1 = state;
		    this.a1k_1 = image_url;
		    this.b1k_1 = _embedded;
		    this.c1k_1 = properties;
		    this.d1k_1 = media_state;
		  }
		  function GetConversationLegsRequest(cid, order, pageSize, cursor) {
		    order = order === VOID ? null : order;
		    pageSize = pageSize === VOID ? null : pageSize;
		    cursor = cursor === VOID ? null : cursor;
		    this.e1k_1 = cid;
		    this.f1k_1 = order;
		    this.g1k_1 = pageSize;
		    this.h1k_1 = cursor;
		    this.i1k_1 = new ConversationLegs(this.e1k_1);
		    this.j1k_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetConversationLegsRequest).u1h = function () {
		    return this.i1k_1;
		  };
		  protoOf(GetConversationLegsRequest).v1h = function () {
		    return this.j1k_1;
		  };
		  protoOf(GetConversationLegsRequest).y1h = function () {
		    var tmp0_safe_receiver = this.f1k_1;
		    var tmp = to('order', tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8_1);
		    var tmp1_safe_receiver = this.g1k_1;
		    return mapOf([tmp, to('page_size', tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString()), to('cursor', this.h1k_1)]);
		  };
		  protoOf(GetConversationLegsRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetConversationLegs), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetConversationLegsRequest).toString = function () {
		    return 'GetConversationLegsRequest(cid=' + this.e1k_1 + ', order=' + this.f1k_1 + ', pageSize=' + this.g1k_1 + ', cursor=' + this.h1k_1 + ')';
		  };
		  protoOf(GetConversationLegsRequest).hashCode = function () {
		    var result = getStringHashCode(this.e1k_1);
		    result = imul(result, 31) + (this.f1k_1 == null ? 0 : this.f1k_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.g1k_1 == null ? 0 : this.g1k_1) | 0;
		    result = imul(result, 31) + (this.h1k_1 == null ? 0 : getStringHashCode(this.h1k_1)) | 0;
		    return result;
		  };
		  protoOf(GetConversationLegsRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetConversationLegsRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetConversationLegsRequest ? other : THROW_CCE();
		    if (!(this.e1k_1 === tmp0_other_with_cast.e1k_1))
		      return false;
		    if (!equals(this.f1k_1, tmp0_other_with_cast.f1k_1))
		      return false;
		    if (!(this.g1k_1 == tmp0_other_with_cast.g1k_1))
		      return false;
		    if (!(this.h1k_1 == tmp0_other_with_cast.h1k_1))
		      return false;
		    return true;
		  };
		  function Companion_5() {
		    Companion_instance_6 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.k1k_1 = [new ArrayListSerializer($serializer_getInstance_3())];
		  }
		  var Companion_instance_6;
		  function Companion_getInstance_7() {
		    if (Companion_instance_6 == null)
		      new Companion_5();
		    return Companion_instance_6;
		  }
		  function $serializer_6() {
		    $serializer_instance_6 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetConversationLegs.ConversationLegsEmbedded', this, 1);
		    tmp0_serialDesc.pq('legs', false);
		    this.l1k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_6).uf = function () {
		    return this.l1k_1;
		  };
		  protoOf($serializer_6).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [Companion_getInstance_7().k1k_1[0]];
		  };
		  protoOf($serializer_6).wf = function (decoder) {
		    var tmp0_desc = this.l1k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    var tmp6_cached = Companion_getInstance_7().k1k_1;
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return ConversationLegsEmbedded_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_6).m1k = function (encoder, value) {
		    var tmp0_desc = this.l1k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_7().k1k_1;
		    tmp1_output.vk(tmp0_desc, 0, tmp2_cached[0], value.n1k_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_6).vf = function (encoder, value) {
		    return this.m1k(encoder, value instanceof ConversationLegsEmbedded ? value : THROW_CCE());
		  };
		  var $serializer_instance_6;
		  function $serializer_getInstance_6() {
		    if ($serializer_instance_6 == null)
		      new $serializer_6();
		    return $serializer_instance_6;
		  }
		  function ConversationLegsEmbedded_init_$Init$(seen1, legs, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_6().l1k_1);
		    }
		    $this.n1k_1 = legs;
		    return $this;
		  }
		  function ConversationLegsEmbedded_init_$Create$(seen1, legs, serializationConstructorMarker) {
		    return ConversationLegsEmbedded_init_$Init$(seen1, legs, serializationConstructorMarker, objectCreate(protoOf(ConversationLegsEmbedded)));
		  }
		  function ConversationLegsEmbedded() {
		  }
		  protoOf(ConversationLegsEmbedded).toString = function () {
		    return 'ConversationLegsEmbedded(legs=' + this.n1k_1 + ')';
		  };
		  protoOf(ConversationLegsEmbedded).hashCode = function () {
		    return hashCode(this.n1k_1);
		  };
		  protoOf(ConversationLegsEmbedded).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationLegsEmbedded))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationLegsEmbedded ? other : THROW_CCE();
		    if (!equals(this.n1k_1, tmp0_other_with_cast.n1k_1))
		      return false;
		    return true;
		  };
		  function Companion_6() {
		  }
		  var Companion_instance_7;
		  function Companion_getInstance_8() {
		    return Companion_instance_7;
		  }
		  function $serializer_7() {
		    $serializer_instance_7 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetConversationLegs', this, 2);
		    tmp0_serialDesc.pq('_embedded', false);
		    tmp0_serialDesc.pq('_links', false);
		    this.o1k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_7).uf = function () {
		    return this.o1k_1;
		  };
		  protoOf($serializer_7).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_6(), $serializer_getInstance_9()];
		  };
		  protoOf($serializer_7).wf = function (decoder) {
		    var tmp0_desc = this.o1k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.qj(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.qj(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return GetConversationLegs_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_7).p1k = function (encoder, value) {
		    var tmp0_desc = this.o1k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_6(), value.q1k_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_9(), value.r1k_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_7).vf = function (encoder, value) {
		    return this.p1k(encoder, value instanceof GetConversationLegs ? value : THROW_CCE());
		  };
		  var $serializer_instance_7;
		  function $serializer_getInstance_7() {
		    if ($serializer_instance_7 == null)
		      new $serializer_7();
		    return $serializer_instance_7;
		  }
		  function GetConversationLegs_init_$Init$(seen1, _embedded, _links, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_7().o1k_1);
		    }
		    $this.q1k_1 = _embedded;
		    $this.r1k_1 = _links;
		    return $this;
		  }
		  function GetConversationLegs_init_$Create$(seen1, _embedded, _links, serializationConstructorMarker) {
		    return GetConversationLegs_init_$Init$(seen1, _embedded, _links, serializationConstructorMarker, objectCreate(protoOf(GetConversationLegs)));
		  }
		  function GetConversationLegs(_embedded, _links) {
		    this.q1k_1 = _embedded;
		    this.r1k_1 = _links;
		  }
		  function $serializer_8() {
		    $serializer_instance_8 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PageNavigationLinks.PageNavigationLink', this, 1);
		    tmp0_serialDesc.pq('href', false);
		    this.s1k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_8).uf = function () {
		    return this.s1k_1;
		  };
		  protoOf($serializer_8).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_8).wf = function (decoder) {
		    var tmp0_desc = this.s1k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return PageNavigationLink_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_8).t1k = function (encoder, value) {
		    var tmp0_desc = this.s1k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.u1k_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_8).vf = function (encoder, value) {
		    return this.t1k(encoder, value instanceof PageNavigationLink ? value : THROW_CCE());
		  };
		  var $serializer_instance_8;
		  function $serializer_getInstance_8() {
		    if ($serializer_instance_8 == null)
		      new $serializer_8();
		    return $serializer_instance_8;
		  }
		  function PageNavigationLink_init_$Init$(seen1, href, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_8().s1k_1);
		    }
		    $this.u1k_1 = href;
		    return $this;
		  }
		  function PageNavigationLink_init_$Create$(seen1, href, serializationConstructorMarker) {
		    return PageNavigationLink_init_$Init$(seen1, href, serializationConstructorMarker, objectCreate(protoOf(PageNavigationLink)));
		  }
		  function PageNavigationLink() {
		  }
		  protoOf(PageNavigationLink).toString = function () {
		    return 'PageNavigationLink(href=' + this.u1k_1 + ')';
		  };
		  protoOf(PageNavigationLink).hashCode = function () {
		    return getStringHashCode(this.u1k_1);
		  };
		  protoOf(PageNavigationLink).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PageNavigationLink))
		      return false;
		    var tmp0_other_with_cast = other instanceof PageNavigationLink ? other : THROW_CCE();
		    if (!(this.u1k_1 === tmp0_other_with_cast.u1k_1))
		      return false;
		    return true;
		  };
		  function Companion_7() {
		  }
		  var Companion_instance_8;
		  function Companion_getInstance_9() {
		    return Companion_instance_8;
		  }
		  function $serializer_9() {
		    $serializer_instance_9 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PageNavigationLinks', this, 2);
		    tmp0_serialDesc.pq('next', true);
		    tmp0_serialDesc.pq('prev', true);
		    this.v1k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_9).uf = function () {
		    return this.v1k_1;
		  };
		  protoOf($serializer_9).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_8())];
		  };
		  protoOf($serializer_9).wf = function (decoder) {
		    var tmp0_desc = this.v1k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, $serializer_getInstance_8(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, $serializer_getInstance_8(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return PageNavigationLinks_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_9).w1k = function (encoder, value) {
		    var tmp0_desc = this.v1k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.x1k_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, $serializer_getInstance_8(), value.x1k_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.y1k_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, $serializer_getInstance_8(), value.y1k_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_9).vf = function (encoder, value) {
		    return this.w1k(encoder, value instanceof PageNavigationLinks ? value : THROW_CCE());
		  };
		  var $serializer_instance_9;
		  function $serializer_getInstance_9() {
		    if ($serializer_instance_9 == null)
		      new $serializer_9();
		    return $serializer_instance_9;
		  }
		  function PageNavigationLinks_init_$Init$(seen1, next, prev, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_9().v1k_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.x1k_1 = null;
		    else
		      $this.x1k_1 = next;
		    if (0 === (seen1 & 2))
		      $this.y1k_1 = null;
		    else
		      $this.y1k_1 = prev;
		    return $this;
		  }
		  function PageNavigationLinks_init_$Create$(seen1, next, prev, serializationConstructorMarker) {
		    return PageNavigationLinks_init_$Init$(seen1, next, prev, serializationConstructorMarker, objectCreate(protoOf(PageNavigationLinks)));
		  }
		  function PageNavigationLinks(next, prev) {
		    next = next === VOID ? null : next;
		    prev = prev === VOID ? null : prev;
		    this.x1k_1 = next;
		    this.y1k_1 = prev;
		  }
		  protoOf(PageNavigationLinks).toString = function () {
		    return 'PageNavigationLinks(next=' + this.x1k_1 + ', prev=' + this.y1k_1 + ')';
		  };
		  protoOf(PageNavigationLinks).hashCode = function () {
		    var result = this.x1k_1 == null ? 0 : this.x1k_1.hashCode();
		    result = imul(result, 31) + (this.y1k_1 == null ? 0 : this.y1k_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(PageNavigationLinks).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PageNavigationLinks))
		      return false;
		    var tmp0_other_with_cast = other instanceof PageNavigationLinks ? other : THROW_CCE();
		    if (!equals(this.x1k_1, tmp0_other_with_cast.x1k_1))
		      return false;
		    if (!equals(this.y1k_1, tmp0_other_with_cast.y1k_1))
		      return false;
		    return true;
		  };
		  function AppKnockingRequest$encode$lambda(channel, it) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.actions.AppKnockingRequest.encode.<anonymous>.<anonymous>' call
		    if (channel instanceof AppChannelEndpoint) {
		      // Inline function 'kotlin.text.lowercase' call
		      // Inline function 'kotlin.js.asDynamic' call
		      var tmp$ret$1 = 'app'.toLowerCase();
		      put(it, 'type', tmp$ret$1);
		      put(it, 'user', channel.h1l_1);
		    } else {
		      if (channel instanceof AppChannelEndpointNoUser) {
		        // Inline function 'kotlin.text.lowercase' call
		        // Inline function 'kotlin.js.asDynamic' call
		        var tmp$ret$3 = 'app'.toLowerCase();
		        put(it, 'type', tmp$ret$3);
		      } else {
		        if (channel instanceof PhoneChannelEndpoint) {
		          // Inline function 'kotlin.text.lowercase' call
		          // Inline function 'kotlin.js.asDynamic' call
		          var tmp$ret$5 = 'phone'.toLowerCase();
		          put(it, 'type', tmp$ret$5);
		          put(it, 'number', channel.f1l_1);
		        } else {
		          if (channel instanceof WebSocketChannelEndpoint) {
		            // Inline function 'kotlin.text.lowercase' call
		            // Inline function 'kotlin.js.asDynamic' call
		            var tmp$ret$7 = 'phone'.toLowerCase();
		            put(it, 'type', tmp$ret$7);
		            put(it, 'uri', channel.d1l_1);
		          } else {
		            if (channel instanceof SipChannelEndpoint) {
		              // Inline function 'kotlin.text.lowercase' call
		              // Inline function 'kotlin.js.asDynamic' call
		              var tmp$ret$9 = 'phone'.toLowerCase();
		              put(it, 'type', tmp$ret$9);
		              put(it, 'uri', channel.z1k_1);
		            }
		          }
		        }
		      }
		    }
		    return Unit_instance;
		  }
		  function AppKnockingRequest$encode$lambda$lambda($translateChannel, this$0) {
		    return function ($this$putJsonObject) {
		      $translateChannel(this$0.k1l_1, $this$putJsonObject);
		      return Unit_instance;
		    };
		  }
		  function AppKnockingRequest$encode$lambda$lambda_0($translateChannel, this$0) {
		    return function ($this$putJsonObject) {
		      $translateChannel(this$0.j1l_1, $this$putJsonObject);
		      return Unit_instance;
		    };
		  }
		  function AppKnockingRequest$encode$lambda_0(this$0, $translateChannel) {
		    return function ($this$putJsonObject) {
		      put($this$putJsonObject, 'type', 'app');
		      putJsonObject($this$putJsonObject, 'to', AppKnockingRequest$encode$lambda$lambda($translateChannel, this$0));
		      putJsonObject($this$putJsonObject, 'from', AppKnockingRequest$encode$lambda$lambda_0($translateChannel, this$0));
		      put($this$putJsonObject, 'id', this$0.l1l_1);
		      return Unit_instance;
		    };
		  }
		  function AppKnockingRequest$encode$lambda_1(this$0) {
		    return function ($this$putJsonObject) {
		      var tmp0_safe_receiver = this$0.m1l_1;
		      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toJsonElement(tmp0_safe_receiver);
		      var tmp;
		      if (tmp1_elvis_lhs == null) {
		        // Inline function 'kotlin.collections.mapOf' call
		        var tmp$ret$0 = emptyMap();
		        tmp = new JsonObject(tmp$ret$0);
		      } else {
		        tmp = tmp1_elvis_lhs;
		      }
		      $this$putJsonObject.l13('custom_data', tmp);
		      return Unit_instance;
		    };
		  }
		  function AppKnockingRequest(from, to, legId, context) {
		    this.j1l_1 = from;
		    this.k1l_1 = to;
		    this.l1l_1 = legId;
		    this.m1l_1 = context;
		    this.n1l_1 = new Knockers();
		    this.o1l_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(AppKnockingRequest).u1h = function () {
		    return this.n1l_1;
		  };
		  protoOf(AppKnockingRequest).v1h = function () {
		    return this.o1l_1;
		  };
		  protoOf(AppKnockingRequest).w1h = function (encoder, originatingSessionId) {
		    var translateChannel = AppKnockingRequest$encode$lambda;
		    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
		    // Inline function 'kotlin.contracts.contract' call
		    var builder = new JsonObjectBuilder();
		    // Inline function 'com.vonage.clientcore.core.actions.AppKnockingRequest.encode.<anonymous>' call
		    put(builder, 'originating_session', originatingSessionId);
		    putJsonObject(builder, 'channel', AppKnockingRequest$encode$lambda_0(this, translateChannel));
		    putJsonObject(builder, 'properties', AppKnockingRequest$encode$lambda_1(this));
		    return builder.to().toString();
		  };
		  protoOf(AppKnockingRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(AppKnocking), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(AppKnockingRequest).toString = function () {
		    return 'AppKnockingRequest(from=' + this.j1l_1 + ', to=' + this.k1l_1 + ', legId=' + this.l1l_1 + ', context=' + this.m1l_1 + ')';
		  };
		  protoOf(AppKnockingRequest).hashCode = function () {
		    var result = hashCode(this.j1l_1);
		    result = imul(result, 31) + hashCode(this.k1l_1) | 0;
		    result = imul(result, 31) + (this.l1l_1 == null ? 0 : getStringHashCode(this.l1l_1)) | 0;
		    result = imul(result, 31) + (this.m1l_1 == null ? 0 : hashCode(this.m1l_1)) | 0;
		    return result;
		  };
		  protoOf(AppKnockingRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AppKnockingRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof AppKnockingRequest ? other : THROW_CCE();
		    if (!equals(this.j1l_1, tmp0_other_with_cast.j1l_1))
		      return false;
		    if (!equals(this.k1l_1, tmp0_other_with_cast.k1l_1))
		      return false;
		    if (!(this.l1l_1 == tmp0_other_with_cast.l1l_1))
		      return false;
		    if (!equals(this.m1l_1, tmp0_other_with_cast.m1l_1))
		      return false;
		    return true;
		  };
		  function MemberKickRequest(cid, mid, reasonText, reasonCode) {
		    reasonText = reasonText === VOID ? null : reasonText;
		    reasonCode = reasonCode === VOID ? null : reasonCode;
		    this.p1l_1 = cid;
		    this.q1l_1 = mid;
		    this.r1l_1 = reasonText;
		    this.s1l_1 = reasonCode;
		    this.t1l_1 = HTTPMethod_DELETE_getInstance();
		    this.u1l_1 = new ConversationMember(this.p1l_1, this.q1l_1, 'v0.2');
		  }
		  protoOf(MemberKickRequest).v1h = function () {
		    return this.t1l_1;
		  };
		  protoOf(MemberKickRequest).u1h = function () {
		    return this.u1l_1;
		  };
		  protoOf(MemberKickRequest).y1h = function () {
		    var tmp;
		    if (!(this.r1l_1 == null) ? true : !(this.s1l_1 == null)) {
		      var tmp0_elvis_lhs = this.s1l_1;
		      var tmp_0 = to('reason_code', tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
		      var tmp1_elvis_lhs = this.r1l_1;
		      tmp = mapOf([tmp_0, to('reason_text', tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs)]);
		    } else {
		      tmp = null;
		    }
		    return tmp;
		  };
		  protoOf(MemberKickRequest).w1h = function (encoder, originatingSessionId) {
		    return '';
		  };
		  protoOf(MemberKickRequest).x1h = function (data, decoder) {
		    return new MemberLeft(this.p1l_1, this.q1l_1);
		  };
		  protoOf(MemberKickRequest).toString = function () {
		    return 'MemberKickRequest(cid=' + this.p1l_1 + ', mid=' + this.q1l_1 + ', reasonText=' + this.r1l_1 + ', reasonCode=' + this.s1l_1 + ')';
		  };
		  protoOf(MemberKickRequest).hashCode = function () {
		    var result = getStringHashCode(this.p1l_1);
		    result = imul(result, 31) + getStringHashCode(this.q1l_1) | 0;
		    result = imul(result, 31) + (this.r1l_1 == null ? 0 : getStringHashCode(this.r1l_1)) | 0;
		    result = imul(result, 31) + (this.s1l_1 == null ? 0 : getStringHashCode(this.s1l_1)) | 0;
		    return result;
		  };
		  protoOf(MemberKickRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberKickRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberKickRequest ? other : THROW_CCE();
		    if (!(this.p1l_1 === tmp0_other_with_cast.p1l_1))
		      return false;
		    if (!(this.q1l_1 === tmp0_other_with_cast.q1l_1))
		      return false;
		    if (!(this.r1l_1 == tmp0_other_with_cast.r1l_1))
		      return false;
		    if (!(this.s1l_1 == tmp0_other_with_cast.s1l_1))
		      return false;
		    return true;
		  };
		  function Companion_8() {
		  }
		  var Companion_instance_9;
		  function Companion_getInstance_10() {
		    return Companion_instance_9;
		  }
		  function $serializer_10() {
		    $serializer_instance_10 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberJoinRequest.MemberJoinChannel', this, 1);
		    tmp0_serialDesc.pq('type', true);
		    this.v1l_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_10).uf = function () {
		    return this.v1l_1;
		  };
		  protoOf($serializer_10).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_10).wf = function (decoder) {
		    var tmp0_desc = this.v1l_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return MemberJoinChannel_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_10).w1l = function (encoder, value) {
		    var tmp0_desc = this.v1l_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.x1l_1 === 'app')) {
		      tmp1_output.tk(tmp0_desc, 0, value.x1l_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_10).vf = function (encoder, value) {
		    return this.w1l(encoder, value instanceof MemberJoinChannel ? value : THROW_CCE());
		  };
		  var $serializer_instance_10;
		  function $serializer_getInstance_10() {
		    if ($serializer_instance_10 == null)
		      new $serializer_10();
		    return $serializer_instance_10;
		  }
		  function MemberJoinChannel_init_$Init$(seen1, type, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_10().v1l_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.x1l_1 = 'app';
		    else
		      $this.x1l_1 = type;
		    return $this;
		  }
		  function MemberJoinChannel_init_$Create$(seen1, type, serializationConstructorMarker) {
		    return MemberJoinChannel_init_$Init$(seen1, type, serializationConstructorMarker, objectCreate(protoOf(MemberJoinChannel)));
		  }
		  function Companion_9() {
		  }
		  var Companion_instance_10;
		  function Companion_getInstance_11() {
		    return Companion_instance_10;
		  }
		  function $serializer_11() {
		    $serializer_instance_11 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberJoinRequest.Body', this, 3);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('channel', false);
		    tmp0_serialDesc.pq('state', true);
		    this.y1l_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_11).uf = function () {
		    return this.y1l_1;
		  };
		  protoOf($serializer_11).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_10(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_11).wf = function (decoder) {
		    var tmp0_desc = this.y1l_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_10(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_10(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return Body_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_11).z1l = function (encoder, value) {
		    var tmp0_desc = this.y1l_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.a1m_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_10(), value.b1m_1);
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.c1m_1 === 'joined')) {
		      tmp1_output.tk(tmp0_desc, 2, value.c1m_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_11).vf = function (encoder, value) {
		    return this.z1l(encoder, value instanceof Body_0 ? value : THROW_CCE());
		  };
		  var $serializer_instance_11;
		  function $serializer_getInstance_11() {
		    if ($serializer_instance_11 == null)
		      new $serializer_11();
		    return $serializer_instance_11;
		  }
		  function Body_init_$Init$_0(seen1, originating_session, channel, state, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_11().y1l_1);
		    }
		    $this.a1m_1 = originating_session;
		    $this.b1m_1 = channel;
		    if (0 === (seen1 & 4))
		      $this.c1m_1 = 'joined';
		    else
		      $this.c1m_1 = state;
		    return $this;
		  }
		  function Body_init_$Create$_0(seen1, originating_session, channel, state, serializationConstructorMarker) {
		    return Body_init_$Init$_0(seen1, originating_session, channel, state, serializationConstructorMarker, objectCreate(protoOf(Body_0)));
		  }
		  function MemberJoinChannel(type) {
		    type = type === VOID ? 'app' : type;
		    this.x1l_1 = type;
		  }
		  protoOf(MemberJoinChannel).toString = function () {
		    return 'MemberJoinChannel(type=' + this.x1l_1 + ')';
		  };
		  protoOf(MemberJoinChannel).hashCode = function () {
		    return getStringHashCode(this.x1l_1);
		  };
		  protoOf(MemberJoinChannel).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberJoinChannel))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberJoinChannel ? other : THROW_CCE();
		    if (!(this.x1l_1 === tmp0_other_with_cast.x1l_1))
		      return false;
		    return true;
		  };
		  function Body_0(originating_session, channel, state) {
		    state = state === VOID ? 'joined' : state;
		    this.a1m_1 = originating_session;
		    this.b1m_1 = channel;
		    this.c1m_1 = state;
		  }
		  function MemberJoinRequest(cid, mid) {
		    this.d1m_1 = cid;
		    this.e1m_1 = mid;
		    this.f1m_1 = new ConversationMember(this.d1m_1, this.e1m_1);
		    this.g1m_1 = HTTPMethod_PUT_getInstance();
		  }
		  protoOf(MemberJoinRequest).u1h = function () {
		    return this.f1m_1;
		  };
		  protoOf(MemberJoinRequest).v1h = function () {
		    return this.g1m_1;
		  };
		  protoOf(MemberJoinRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_0(originatingSessionId, new MemberJoinChannel());
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_0), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(MemberJoinRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(MemberJoin), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(MemberJoinRequest).toString = function () {
		    return 'MemberJoinRequest(cid=' + this.d1m_1 + ', mid=' + this.e1m_1 + ')';
		  };
		  protoOf(MemberJoinRequest).hashCode = function () {
		    var result = getStringHashCode(this.d1m_1);
		    result = imul(result, 31) + getStringHashCode(this.e1m_1) | 0;
		    return result;
		  };
		  protoOf(MemberJoinRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberJoinRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberJoinRequest ? other : THROW_CCE();
		    if (!(this.d1m_1 === tmp0_other_with_cast.d1m_1))
		      return false;
		    if (!(this.e1m_1 === tmp0_other_with_cast.e1m_1))
		      return false;
		    return true;
		  };
		  function DeleteKnockerRequest(knockingId) {
		    this.h1m_1 = knockingId;
		    this.i1m_1 = removePrefix(this.h1m_1, 'knocker:');
		    this.j1m_1 = new Knocker(this.i1m_1);
		    this.k1m_1 = HTTPMethod_DELETE_getInstance();
		  }
		  protoOf(DeleteKnockerRequest).u1h = function () {
		    return this.j1m_1;
		  };
		  protoOf(DeleteKnockerRequest).v1h = function () {
		    return this.k1m_1;
		  };
		  protoOf(DeleteKnockerRequest).w1h = function (encoder, originatingSessionId) {
		    return '';
		  };
		  protoOf(DeleteKnockerRequest).x1h = function (data, decoder) {
		    return new DeletedKnocker(this.h1m_1);
		  };
		  protoOf(DeleteKnockerRequest).toString = function () {
		    return 'DeleteKnockerRequest(knockingId=' + this.h1m_1 + ')';
		  };
		  protoOf(DeleteKnockerRequest).hashCode = function () {
		    return getStringHashCode(this.h1m_1);
		  };
		  protoOf(DeleteKnockerRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof DeleteKnockerRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof DeleteKnockerRequest ? other : THROW_CCE();
		    if (!(this.h1m_1 === tmp0_other_with_cast.h1m_1))
		      return false;
		    return true;
		  };
		  function Companion_10() {
		  }
		  var Companion_instance_11;
		  function Companion_getInstance_12() {
		    return Companion_instance_11;
		  }
		  function $serializer_12() {
		    $serializer_instance_12 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegMuteRequest.LegMuteBody', this, 1);
		    tmp0_serialDesc.pq('rtc_id', false);
		    this.l1m_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_12).uf = function () {
		    return this.l1m_1;
		  };
		  protoOf($serializer_12).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_12).wf = function (decoder) {
		    var tmp0_desc = this.l1m_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegMuteBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_12).m1m = function (encoder, value) {
		    var tmp0_desc = this.l1m_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.n1m_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_12).vf = function (encoder, value) {
		    return this.m1m(encoder, value instanceof LegMuteBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_12;
		  function $serializer_getInstance_12() {
		    if ($serializer_instance_12 == null)
		      new $serializer_12();
		    return $serializer_instance_12;
		  }
		  function LegMuteBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_12().l1m_1);
		    }
		    $this.n1m_1 = rtc_id;
		    return $this;
		  }
		  function LegMuteBody_init_$Create$(seen1, rtc_id, serializationConstructorMarker) {
		    return LegMuteBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, objectCreate(protoOf(LegMuteBody)));
		  }
		  function Companion_11() {
		  }
		  var Companion_instance_12;
		  function Companion_getInstance_13() {
		    return Companion_instance_12;
		  }
		  function $serializer_13() {
		    $serializer_instance_13 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegMuteRequest.Body', this, 5);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('to', false);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('body', false);
		    this.o1m_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_13).uf = function () {
		    return this.o1m_1;
		  };
		  protoOf($serializer_13).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_12()];
		  };
		  protoOf($serializer_13).wf = function (decoder) {
		    var tmp0_desc = this.o1m_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, $serializer_getInstance_12(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, $serializer_getInstance_12(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return Body_init_$Create$_1(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_13).p1m = function (encoder, value) {
		    var tmp0_desc = this.o1m_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.q1m_1);
		    tmp1_output.tk(tmp0_desc, 1, value.r1m_1);
		    tmp1_output.tk(tmp0_desc, 2, value.s1m_1);
		    tmp1_output.tk(tmp0_desc, 3, value.t1m_1);
		    tmp1_output.vk(tmp0_desc, 4, $serializer_getInstance_12(), value.u1m_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_13).vf = function (encoder, value) {
		    return this.p1m(encoder, value instanceof Body_1 ? value : THROW_CCE());
		  };
		  var $serializer_instance_13;
		  function $serializer_getInstance_13() {
		    if ($serializer_instance_13 == null)
		      new $serializer_13();
		    return $serializer_instance_13;
		  }
		  function Body_init_$Init$_1(seen1, type, from, to, originating_session, body, serializationConstructorMarker, $this) {
		    if (!(31 === (31 & seen1))) {
		      throwMissingFieldException(seen1, 31, $serializer_getInstance_13().o1m_1);
		    }
		    $this.q1m_1 = type;
		    $this.r1m_1 = from;
		    $this.s1m_1 = to;
		    $this.t1m_1 = originating_session;
		    $this.u1m_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_1(seen1, type, from, to, originating_session, body, serializationConstructorMarker) {
		    return Body_init_$Init$_1(seen1, type, from, to, originating_session, body, serializationConstructorMarker, objectCreate(protoOf(Body_1)));
		  }
		  function LegMuteBody(rtc_id) {
		    this.n1m_1 = rtc_id;
		  }
		  protoOf(LegMuteBody).toString = function () {
		    return 'LegMuteBody(rtc_id=' + this.n1m_1 + ')';
		  };
		  protoOf(LegMuteBody).hashCode = function () {
		    return getStringHashCode(this.n1m_1);
		  };
		  protoOf(LegMuteBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegMuteBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegMuteBody ? other : THROW_CCE();
		    if (!(this.n1m_1 === tmp0_other_with_cast.n1m_1))
		      return false;
		    return true;
		  };
		  function Body_1(type, from, to, originating_session, body) {
		    this.q1m_1 = type;
		    this.r1m_1 = from;
		    this.s1m_1 = to;
		    this.t1m_1 = originating_session;
		    this.u1m_1 = body;
		  }
		  function LegMuteRequest(conversationId, legId, memberId) {
		    this.v1m_1 = conversationId;
		    this.w1m_1 = legId;
		    this.x1m_1 = memberId;
		    this.y1m_1 = new ConversationEvents(this.v1m_1);
		    this.z1m_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(LegMuteRequest).u1h = function () {
		    return this.y1m_1;
		  };
		  protoOf(LegMuteRequest).v1h = function () {
		    return this.z1m_1;
		  };
		  protoOf(LegMuteRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_1('audio:mute:on', this.x1m_1, this.x1m_1, originatingSessionId, new LegMuteBody(this.w1m_1));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_1), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(LegMuteRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(LegMute), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(LegMuteRequest).toString = function () {
		    return 'LegMuteRequest(conversationId=' + this.v1m_1 + ', legId=' + this.w1m_1 + ', memberId=' + this.x1m_1 + ')';
		  };
		  protoOf(LegMuteRequest).hashCode = function () {
		    var result = getStringHashCode(this.v1m_1);
		    result = imul(result, 31) + getStringHashCode(this.w1m_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.x1m_1) | 0;
		    return result;
		  };
		  protoOf(LegMuteRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegMuteRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegMuteRequest ? other : THROW_CCE();
		    if (!(this.v1m_1 === tmp0_other_with_cast.v1m_1))
		      return false;
		    if (!(this.w1m_1 === tmp0_other_with_cast.w1m_1))
		      return false;
		    if (!(this.x1m_1 === tmp0_other_with_cast.x1m_1))
		      return false;
		    return true;
		  };
		  function Companion_12() {
		  }
		  var Companion_instance_13;
		  function Companion_getInstance_14() {
		    return Companion_instance_13;
		  }
		  function $serializer_14() {
		    $serializer_instance_14 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegUnmuteRequest.LegUnmuteBody', this, 1);
		    tmp0_serialDesc.pq('rtc_id', false);
		    this.a1n_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_14).uf = function () {
		    return this.a1n_1;
		  };
		  protoOf($serializer_14).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_14).wf = function (decoder) {
		    var tmp0_desc = this.a1n_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegUnmuteBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_14).b1n = function (encoder, value) {
		    var tmp0_desc = this.a1n_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.c1n_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_14).vf = function (encoder, value) {
		    return this.b1n(encoder, value instanceof LegUnmuteBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_14;
		  function $serializer_getInstance_14() {
		    if ($serializer_instance_14 == null)
		      new $serializer_14();
		    return $serializer_instance_14;
		  }
		  function LegUnmuteBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_14().a1n_1);
		    }
		    $this.c1n_1 = rtc_id;
		    return $this;
		  }
		  function LegUnmuteBody_init_$Create$(seen1, rtc_id, serializationConstructorMarker) {
		    return LegUnmuteBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, objectCreate(protoOf(LegUnmuteBody)));
		  }
		  function Companion_13() {
		  }
		  var Companion_instance_14;
		  function Companion_getInstance_15() {
		    return Companion_instance_14;
		  }
		  function $serializer_15() {
		    $serializer_instance_15 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegUnmuteRequest.Body', this, 5);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('to', false);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('body', false);
		    this.d1n_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_15).uf = function () {
		    return this.d1n_1;
		  };
		  protoOf($serializer_15).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_14()];
		  };
		  protoOf($serializer_15).wf = function (decoder) {
		    var tmp0_desc = this.d1n_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, $serializer_getInstance_14(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, $serializer_getInstance_14(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return Body_init_$Create$_2(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_15).e1n = function (encoder, value) {
		    var tmp0_desc = this.d1n_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.f1n_1);
		    tmp1_output.tk(tmp0_desc, 1, value.g1n_1);
		    tmp1_output.tk(tmp0_desc, 2, value.h1n_1);
		    tmp1_output.tk(tmp0_desc, 3, value.i1n_1);
		    tmp1_output.vk(tmp0_desc, 4, $serializer_getInstance_14(), value.j1n_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_15).vf = function (encoder, value) {
		    return this.e1n(encoder, value instanceof Body_2 ? value : THROW_CCE());
		  };
		  var $serializer_instance_15;
		  function $serializer_getInstance_15() {
		    if ($serializer_instance_15 == null)
		      new $serializer_15();
		    return $serializer_instance_15;
		  }
		  function Body_init_$Init$_2(seen1, type, from, to, originating_session, body, serializationConstructorMarker, $this) {
		    if (!(31 === (31 & seen1))) {
		      throwMissingFieldException(seen1, 31, $serializer_getInstance_15().d1n_1);
		    }
		    $this.f1n_1 = type;
		    $this.g1n_1 = from;
		    $this.h1n_1 = to;
		    $this.i1n_1 = originating_session;
		    $this.j1n_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_2(seen1, type, from, to, originating_session, body, serializationConstructorMarker) {
		    return Body_init_$Init$_2(seen1, type, from, to, originating_session, body, serializationConstructorMarker, objectCreate(protoOf(Body_2)));
		  }
		  function LegUnmuteBody(rtc_id) {
		    this.c1n_1 = rtc_id;
		  }
		  protoOf(LegUnmuteBody).toString = function () {
		    return 'LegUnmuteBody(rtc_id=' + this.c1n_1 + ')';
		  };
		  protoOf(LegUnmuteBody).hashCode = function () {
		    return getStringHashCode(this.c1n_1);
		  };
		  protoOf(LegUnmuteBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegUnmuteBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegUnmuteBody ? other : THROW_CCE();
		    if (!(this.c1n_1 === tmp0_other_with_cast.c1n_1))
		      return false;
		    return true;
		  };
		  function Body_2(type, from, to, originating_session, body) {
		    this.f1n_1 = type;
		    this.g1n_1 = from;
		    this.h1n_1 = to;
		    this.i1n_1 = originating_session;
		    this.j1n_1 = body;
		  }
		  function LegUnmuteRequest(conversationId, legId, memberId) {
		    this.k1n_1 = conversationId;
		    this.l1n_1 = legId;
		    this.m1n_1 = memberId;
		    this.n1n_1 = new ConversationEvents(this.k1n_1);
		    this.o1n_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(LegUnmuteRequest).u1h = function () {
		    return this.n1n_1;
		  };
		  protoOf(LegUnmuteRequest).v1h = function () {
		    return this.o1n_1;
		  };
		  protoOf(LegUnmuteRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_2('audio:mute:off', this.m1n_1, this.m1n_1, originatingSessionId, new LegUnmuteBody(this.l1n_1));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_2), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(LegUnmuteRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(LegUnmute), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(LegUnmuteRequest).toString = function () {
		    return 'LegUnmuteRequest(conversationId=' + this.k1n_1 + ', legId=' + this.l1n_1 + ', memberId=' + this.m1n_1 + ')';
		  };
		  protoOf(LegUnmuteRequest).hashCode = function () {
		    var result = getStringHashCode(this.k1n_1);
		    result = imul(result, 31) + getStringHashCode(this.l1n_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.m1n_1) | 0;
		    return result;
		  };
		  protoOf(LegUnmuteRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegUnmuteRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegUnmuteRequest ? other : THROW_CCE();
		    if (!(this.k1n_1 === tmp0_other_with_cast.k1n_1))
		      return false;
		    if (!(this.l1n_1 === tmp0_other_with_cast.l1n_1))
		      return false;
		    if (!(this.m1n_1 === tmp0_other_with_cast.m1n_1))
		      return false;
		    return true;
		  };
		  function Companion_14() {
		  }
		  var Companion_instance_15;
		  function Companion_getInstance_16() {
		    return Companion_instance_15;
		  }
		  function $serializer_16() {
		    $serializer_instance_16 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegEarmuffEnableRequest.LegEarmuffEnableBody', this, 1);
		    tmp0_serialDesc.pq('rtc_id', false);
		    this.p1n_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_16).uf = function () {
		    return this.p1n_1;
		  };
		  protoOf($serializer_16).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_16).wf = function (decoder) {
		    var tmp0_desc = this.p1n_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegEarmuffEnableBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_16).q1n = function (encoder, value) {
		    var tmp0_desc = this.p1n_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.r1n_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_16).vf = function (encoder, value) {
		    return this.q1n(encoder, value instanceof LegEarmuffEnableBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_16;
		  function $serializer_getInstance_16() {
		    if ($serializer_instance_16 == null)
		      new $serializer_16();
		    return $serializer_instance_16;
		  }
		  function LegEarmuffEnableBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_16().p1n_1);
		    }
		    $this.r1n_1 = rtc_id;
		    return $this;
		  }
		  function LegEarmuffEnableBody_init_$Create$(seen1, rtc_id, serializationConstructorMarker) {
		    return LegEarmuffEnableBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, objectCreate(protoOf(LegEarmuffEnableBody)));
		  }
		  function Companion_15() {
		  }
		  var Companion_instance_16;
		  function Companion_getInstance_17() {
		    return Companion_instance_16;
		  }
		  function $serializer_17() {
		    $serializer_instance_17 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegEarmuffEnableRequest.Body', this, 5);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('to', false);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('body', false);
		    this.s1n_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_17).uf = function () {
		    return this.s1n_1;
		  };
		  protoOf($serializer_17).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_16()];
		  };
		  protoOf($serializer_17).wf = function (decoder) {
		    var tmp0_desc = this.s1n_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, $serializer_getInstance_16(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, $serializer_getInstance_16(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return Body_init_$Create$_3(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_17).t1n = function (encoder, value) {
		    var tmp0_desc = this.s1n_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.u1n_1);
		    tmp1_output.tk(tmp0_desc, 1, value.v1n_1);
		    tmp1_output.tk(tmp0_desc, 2, value.w1n_1);
		    tmp1_output.tk(tmp0_desc, 3, value.x1n_1);
		    tmp1_output.vk(tmp0_desc, 4, $serializer_getInstance_16(), value.y1n_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_17).vf = function (encoder, value) {
		    return this.t1n(encoder, value instanceof Body_3 ? value : THROW_CCE());
		  };
		  var $serializer_instance_17;
		  function $serializer_getInstance_17() {
		    if ($serializer_instance_17 == null)
		      new $serializer_17();
		    return $serializer_instance_17;
		  }
		  function Body_init_$Init$_3(seen1, type, from, to, originating_session, body, serializationConstructorMarker, $this) {
		    if (!(31 === (31 & seen1))) {
		      throwMissingFieldException(seen1, 31, $serializer_getInstance_17().s1n_1);
		    }
		    $this.u1n_1 = type;
		    $this.v1n_1 = from;
		    $this.w1n_1 = to;
		    $this.x1n_1 = originating_session;
		    $this.y1n_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_3(seen1, type, from, to, originating_session, body, serializationConstructorMarker) {
		    return Body_init_$Init$_3(seen1, type, from, to, originating_session, body, serializationConstructorMarker, objectCreate(protoOf(Body_3)));
		  }
		  function LegEarmuffEnableBody(rtc_id) {
		    this.r1n_1 = rtc_id;
		  }
		  protoOf(LegEarmuffEnableBody).toString = function () {
		    return 'LegEarmuffEnableBody(rtc_id=' + this.r1n_1 + ')';
		  };
		  protoOf(LegEarmuffEnableBody).hashCode = function () {
		    return getStringHashCode(this.r1n_1);
		  };
		  protoOf(LegEarmuffEnableBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegEarmuffEnableBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegEarmuffEnableBody ? other : THROW_CCE();
		    if (!(this.r1n_1 === tmp0_other_with_cast.r1n_1))
		      return false;
		    return true;
		  };
		  function Body_3(type, from, to, originating_session, body) {
		    this.u1n_1 = type;
		    this.v1n_1 = from;
		    this.w1n_1 = to;
		    this.x1n_1 = originating_session;
		    this.y1n_1 = body;
		  }
		  function LegEarmuffEnableRequest(conversationId, legId, memberId) {
		    this.z1n_1 = conversationId;
		    this.a1o_1 = legId;
		    this.b1o_1 = memberId;
		    this.c1o_1 = new ConversationEvents(this.z1n_1);
		    this.d1o_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(LegEarmuffEnableRequest).u1h = function () {
		    return this.c1o_1;
		  };
		  protoOf(LegEarmuffEnableRequest).v1h = function () {
		    return this.d1o_1;
		  };
		  protoOf(LegEarmuffEnableRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_3('audio:earmuff:on', this.b1o_1, this.b1o_1, originatingSessionId, new LegEarmuffEnableBody(this.a1o_1));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_3), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(LegEarmuffEnableRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(LegEarmuffEnable), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(LegEarmuffEnableRequest).toString = function () {
		    return 'LegEarmuffEnableRequest(conversationId=' + this.z1n_1 + ', legId=' + this.a1o_1 + ', memberId=' + this.b1o_1 + ')';
		  };
		  protoOf(LegEarmuffEnableRequest).hashCode = function () {
		    var result = getStringHashCode(this.z1n_1);
		    result = imul(result, 31) + getStringHashCode(this.a1o_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.b1o_1) | 0;
		    return result;
		  };
		  protoOf(LegEarmuffEnableRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegEarmuffEnableRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegEarmuffEnableRequest ? other : THROW_CCE();
		    if (!(this.z1n_1 === tmp0_other_with_cast.z1n_1))
		      return false;
		    if (!(this.a1o_1 === tmp0_other_with_cast.a1o_1))
		      return false;
		    if (!(this.b1o_1 === tmp0_other_with_cast.b1o_1))
		      return false;
		    return true;
		  };
		  function Companion_16() {
		  }
		  var Companion_instance_17;
		  function Companion_getInstance_18() {
		    return Companion_instance_17;
		  }
		  function $serializer_18() {
		    $serializer_instance_18 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegEarmuffDisableRequest.LegEarmuffDisableBody', this, 1);
		    tmp0_serialDesc.pq('rtc_id', false);
		    this.e1o_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_18).uf = function () {
		    return this.e1o_1;
		  };
		  protoOf($serializer_18).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_18).wf = function (decoder) {
		    var tmp0_desc = this.e1o_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegEarmuffDisableBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_18).f1o = function (encoder, value) {
		    var tmp0_desc = this.e1o_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.g1o_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_18).vf = function (encoder, value) {
		    return this.f1o(encoder, value instanceof LegEarmuffDisableBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_18;
		  function $serializer_getInstance_18() {
		    if ($serializer_instance_18 == null)
		      new $serializer_18();
		    return $serializer_instance_18;
		  }
		  function LegEarmuffDisableBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_18().e1o_1);
		    }
		    $this.g1o_1 = rtc_id;
		    return $this;
		  }
		  function LegEarmuffDisableBody_init_$Create$(seen1, rtc_id, serializationConstructorMarker) {
		    return LegEarmuffDisableBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, objectCreate(protoOf(LegEarmuffDisableBody)));
		  }
		  function Companion_17() {
		  }
		  var Companion_instance_18;
		  function Companion_getInstance_19() {
		    return Companion_instance_18;
		  }
		  function $serializer_19() {
		    $serializer_instance_19 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegEarmuffDisableRequest.Body', this, 5);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('to', false);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('body', false);
		    this.h1o_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_19).uf = function () {
		    return this.h1o_1;
		  };
		  protoOf($serializer_19).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_18()];
		  };
		  protoOf($serializer_19).wf = function (decoder) {
		    var tmp0_desc = this.h1o_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, $serializer_getInstance_18(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, $serializer_getInstance_18(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return Body_init_$Create$_4(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_19).i1o = function (encoder, value) {
		    var tmp0_desc = this.h1o_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.j1o_1);
		    tmp1_output.tk(tmp0_desc, 1, value.k1o_1);
		    tmp1_output.tk(tmp0_desc, 2, value.l1o_1);
		    tmp1_output.tk(tmp0_desc, 3, value.m1o_1);
		    tmp1_output.vk(tmp0_desc, 4, $serializer_getInstance_18(), value.n1o_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_19).vf = function (encoder, value) {
		    return this.i1o(encoder, value instanceof Body_4 ? value : THROW_CCE());
		  };
		  var $serializer_instance_19;
		  function $serializer_getInstance_19() {
		    if ($serializer_instance_19 == null)
		      new $serializer_19();
		    return $serializer_instance_19;
		  }
		  function Body_init_$Init$_4(seen1, type, from, to, originating_session, body, serializationConstructorMarker, $this) {
		    if (!(31 === (31 & seen1))) {
		      throwMissingFieldException(seen1, 31, $serializer_getInstance_19().h1o_1);
		    }
		    $this.j1o_1 = type;
		    $this.k1o_1 = from;
		    $this.l1o_1 = to;
		    $this.m1o_1 = originating_session;
		    $this.n1o_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_4(seen1, type, from, to, originating_session, body, serializationConstructorMarker) {
		    return Body_init_$Init$_4(seen1, type, from, to, originating_session, body, serializationConstructorMarker, objectCreate(protoOf(Body_4)));
		  }
		  function LegEarmuffDisableBody(rtc_id) {
		    this.g1o_1 = rtc_id;
		  }
		  protoOf(LegEarmuffDisableBody).toString = function () {
		    return 'LegEarmuffDisableBody(rtc_id=' + this.g1o_1 + ')';
		  };
		  protoOf(LegEarmuffDisableBody).hashCode = function () {
		    return getStringHashCode(this.g1o_1);
		  };
		  protoOf(LegEarmuffDisableBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegEarmuffDisableBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegEarmuffDisableBody ? other : THROW_CCE();
		    if (!(this.g1o_1 === tmp0_other_with_cast.g1o_1))
		      return false;
		    return true;
		  };
		  function Body_4(type, from, to, originating_session, body) {
		    this.j1o_1 = type;
		    this.k1o_1 = from;
		    this.l1o_1 = to;
		    this.m1o_1 = originating_session;
		    this.n1o_1 = body;
		  }
		  function LegEarmuffDisableRequest(conversationId, legId, memberId) {
		    this.o1o_1 = conversationId;
		    this.p1o_1 = legId;
		    this.q1o_1 = memberId;
		    this.r1o_1 = new ConversationEvents(this.o1o_1);
		    this.s1o_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(LegEarmuffDisableRequest).u1h = function () {
		    return this.r1o_1;
		  };
		  protoOf(LegEarmuffDisableRequest).v1h = function () {
		    return this.s1o_1;
		  };
		  protoOf(LegEarmuffDisableRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_4('audio:earmuff:off', this.q1o_1, this.q1o_1, originatingSessionId, new LegEarmuffDisableBody(this.p1o_1));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_4), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(LegEarmuffDisableRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(LegEarmuffDisable), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(LegEarmuffDisableRequest).toString = function () {
		    return 'LegEarmuffDisableRequest(conversationId=' + this.o1o_1 + ', legId=' + this.p1o_1 + ', memberId=' + this.q1o_1 + ')';
		  };
		  protoOf(LegEarmuffDisableRequest).hashCode = function () {
		    var result = getStringHashCode(this.o1o_1);
		    result = imul(result, 31) + getStringHashCode(this.p1o_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.q1o_1) | 0;
		    return result;
		  };
		  protoOf(LegEarmuffDisableRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegEarmuffDisableRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegEarmuffDisableRequest ? other : THROW_CCE();
		    if (!(this.o1o_1 === tmp0_other_with_cast.o1o_1))
		      return false;
		    if (!(this.p1o_1 === tmp0_other_with_cast.p1o_1))
		      return false;
		    if (!(this.q1o_1 === tmp0_other_with_cast.q1o_1))
		      return false;
		    return true;
		  };
		  function Companion_18() {
		  }
		  var Companion_instance_19;
		  function Companion_getInstance_20() {
		    return Companion_instance_19;
		  }
		  function $serializer_20() {
		    $serializer_instance_20 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegDTMFRequest.LegDTMFBody', this, 2);
		    tmp0_serialDesc.pq('digit', false);
		    tmp0_serialDesc.pq('channel', false);
		    this.t1o_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_20).uf = function () {
		    return this.t1o_1;
		  };
		  protoOf($serializer_20).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_167()];
		  };
		  protoOf($serializer_20).wf = function (decoder) {
		    var tmp0_desc = this.t1o_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_167(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_167(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return LegDTMFBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_20).u1o = function (encoder, value) {
		    var tmp0_desc = this.t1o_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.v1o_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_167(), value.w1o_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_20).vf = function (encoder, value) {
		    return this.u1o(encoder, value instanceof LegDTMFBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_20;
		  function $serializer_getInstance_20() {
		    if ($serializer_instance_20 == null)
		      new $serializer_20();
		    return $serializer_instance_20;
		  }
		  function LegDTMFBody_init_$Init$(seen1, digit, channel, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_20().t1o_1);
		    }
		    $this.v1o_1 = digit;
		    $this.w1o_1 = channel;
		    return $this;
		  }
		  function LegDTMFBody_init_$Create$(seen1, digit, channel, serializationConstructorMarker) {
		    return LegDTMFBody_init_$Init$(seen1, digit, channel, serializationConstructorMarker, objectCreate(protoOf(LegDTMFBody)));
		  }
		  function Companion_19() {
		  }
		  var Companion_instance_20;
		  function Companion_getInstance_21() {
		    return Companion_instance_20;
		  }
		  function $serializer_21() {
		    $serializer_instance_21 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegDTMFRequest.Body', this, 4);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('body', false);
		    this.x1o_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_21).uf = function () {
		    return this.x1o_1;
		  };
		  protoOf($serializer_21).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_20()];
		  };
		  protoOf($serializer_21).wf = function (decoder) {
		    var tmp0_desc = this.x1o_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_20(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_20(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return Body_init_$Create$_5(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_21).y1o = function (encoder, value) {
		    var tmp0_desc = this.x1o_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.z1o_1);
		    tmp1_output.tk(tmp0_desc, 1, value.a1p_1);
		    tmp1_output.tk(tmp0_desc, 2, value.b1p_1);
		    tmp1_output.vk(tmp0_desc, 3, $serializer_getInstance_20(), value.c1p_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_21).vf = function (encoder, value) {
		    return this.y1o(encoder, value instanceof Body_5 ? value : THROW_CCE());
		  };
		  var $serializer_instance_21;
		  function $serializer_getInstance_21() {
		    if ($serializer_instance_21 == null)
		      new $serializer_21();
		    return $serializer_instance_21;
		  }
		  function Body_init_$Init$_5(seen1, type, from, originating_session, body, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_21().x1o_1);
		    }
		    $this.z1o_1 = type;
		    $this.a1p_1 = from;
		    $this.b1p_1 = originating_session;
		    $this.c1p_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_5(seen1, type, from, originating_session, body, serializationConstructorMarker) {
		    return Body_init_$Init$_5(seen1, type, from, originating_session, body, serializationConstructorMarker, objectCreate(protoOf(Body_5)));
		  }
		  function LegDTMFBody(digit, channel) {
		    this.v1o_1 = digit;
		    this.w1o_1 = channel;
		  }
		  protoOf(LegDTMFBody).toString = function () {
		    return 'LegDTMFBody(digit=' + this.v1o_1 + ', channel=' + this.w1o_1 + ')';
		  };
		  protoOf(LegDTMFBody).hashCode = function () {
		    var result = getStringHashCode(this.v1o_1);
		    result = imul(result, 31) + this.w1o_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(LegDTMFBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegDTMFBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegDTMFBody ? other : THROW_CCE();
		    if (!(this.v1o_1 === tmp0_other_with_cast.v1o_1))
		      return false;
		    if (!this.w1o_1.equals(tmp0_other_with_cast.w1o_1))
		      return false;
		    return true;
		  };
		  function Body_5(type, from, originating_session, body) {
		    this.z1o_1 = type;
		    this.a1p_1 = from;
		    this.b1p_1 = originating_session;
		    this.c1p_1 = body;
		  }
		  function LegDTMFRequest(conversationId, legId, memberId, digits) {
		    this.d1p_1 = conversationId;
		    this.e1p_1 = legId;
		    this.f1p_1 = memberId;
		    this.g1p_1 = digits;
		    this.h1p_1 = new ConversationEvents(this.d1p_1);
		    this.i1p_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(LegDTMFRequest).u1h = function () {
		    return this.h1p_1;
		  };
		  protoOf(LegDTMFRequest).v1h = function () {
		    return this.i1p_1;
		  };
		  protoOf(LegDTMFRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_5('audio:dtmf', this.f1p_1, originatingSessionId, new LegDTMFBody(this.g1p_1, new DTMFChannel(this.e1p_1, 'app')));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_5), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(LegDTMFRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(LegDTMF), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(LegDTMFRequest).toString = function () {
		    return 'LegDTMFRequest(conversationId=' + this.d1p_1 + ', legId=' + this.e1p_1 + ', memberId=' + this.f1p_1 + ', digits=' + this.g1p_1 + ')';
		  };
		  protoOf(LegDTMFRequest).hashCode = function () {
		    var result = getStringHashCode(this.d1p_1);
		    result = imul(result, 31) + getStringHashCode(this.e1p_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f1p_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.g1p_1) | 0;
		    return result;
		  };
		  protoOf(LegDTMFRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegDTMFRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegDTMFRequest ? other : THROW_CCE();
		    if (!(this.d1p_1 === tmp0_other_with_cast.d1p_1))
		      return false;
		    if (!(this.e1p_1 === tmp0_other_with_cast.e1p_1))
		      return false;
		    if (!(this.f1p_1 === tmp0_other_with_cast.f1p_1))
		      return false;
		    if (!(this.g1p_1 === tmp0_other_with_cast.g1p_1))
		      return false;
		    return true;
		  };
		  function Companion_20() {
		  }
		  var Companion_instance_21;
		  function Companion_getInstance_22() {
		    return Companion_instance_21;
		  }
		  function $serializer_22() {
		    $serializer_instance_22 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioSayRequest.AudioSayBody', this, 6);
		    tmp0_serialDesc.pq('text', false);
		    tmp0_serialDesc.pq('level', false);
		    tmp0_serialDesc.pq('loop', false);
		    tmp0_serialDesc.pq('queue', false);
		    tmp0_serialDesc.pq('voice_name', false);
		    tmp0_serialDesc.pq('ssml', false);
		    this.j1p_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_22).uf = function () {
		    return this.j1p_1;
		  };
		  protoOf($serializer_22).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
		  };
		  protoOf($serializer_22).wf = function (decoder) {
		    var tmp0_desc = this.j1p_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = 0;
		    var tmp7_local3 = false;
		    var tmp8_local4 = null;
		    var tmp9_local5 = false;
		    var tmp10_input = decoder.ej(tmp0_desc);
		    if (tmp10_input.uj()) {
		      tmp4_local0 = tmp10_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp10_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp10_input.jj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp10_input.gj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp10_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp10_input.gj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp10_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp10_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp10_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp10_input.jj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp10_input.gj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp10_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp10_input.gj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp10_input.fj(tmp0_desc);
		    return AudioSayBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
		  };
		  protoOf($serializer_22).k1p = function (encoder, value) {
		    var tmp0_desc = this.j1p_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.l1p_1);
		    tmp1_output.ok(tmp0_desc, 1, value.m1p_1);
		    tmp1_output.ok(tmp0_desc, 2, value.n1p_1);
		    tmp1_output.lk(tmp0_desc, 3, value.o1p_1);
		    tmp1_output.tk(tmp0_desc, 4, value.p1p_1);
		    tmp1_output.lk(tmp0_desc, 5, value.q1p_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_22).vf = function (encoder, value) {
		    return this.k1p(encoder, value instanceof AudioSayBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_22;
		  function $serializer_getInstance_22() {
		    if ($serializer_instance_22 == null)
		      new $serializer_22();
		    return $serializer_instance_22;
		  }
		  function AudioSayBody_init_$Init$(seen1, text, level, loop, queue, voice_name, ssml, serializationConstructorMarker, $this) {
		    if (!(63 === (63 & seen1))) {
		      throwMissingFieldException(seen1, 63, $serializer_getInstance_22().j1p_1);
		    }
		    $this.l1p_1 = text;
		    $this.m1p_1 = level;
		    $this.n1p_1 = loop;
		    $this.o1p_1 = queue;
		    $this.p1p_1 = voice_name;
		    $this.q1p_1 = ssml;
		    return $this;
		  }
		  function AudioSayBody_init_$Create$(seen1, text, level, loop, queue, voice_name, ssml, serializationConstructorMarker) {
		    return AudioSayBody_init_$Init$(seen1, text, level, loop, queue, voice_name, ssml, serializationConstructorMarker, objectCreate(protoOf(AudioSayBody)));
		  }
		  function Companion_21() {
		  }
		  var Companion_instance_22;
		  function Companion_getInstance_23() {
		    return Companion_instance_22;
		  }
		  function $serializer_23() {
		    $serializer_instance_23 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioSayRequest.Body', this, 4);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('body', false);
		    this.r1p_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_23).uf = function () {
		    return this.r1p_1;
		  };
		  protoOf($serializer_23).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_22()];
		  };
		  protoOf($serializer_23).wf = function (decoder) {
		    var tmp0_desc = this.r1p_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_22(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_22(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return Body_init_$Create$_6(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_23).s1p = function (encoder, value) {
		    var tmp0_desc = this.r1p_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.t1p_1);
		    tmp1_output.tk(tmp0_desc, 1, value.u1p_1);
		    tmp1_output.tk(tmp0_desc, 2, value.v1p_1);
		    tmp1_output.vk(tmp0_desc, 3, $serializer_getInstance_22(), value.w1p_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_23).vf = function (encoder, value) {
		    return this.s1p(encoder, value instanceof Body_6 ? value : THROW_CCE());
		  };
		  var $serializer_instance_23;
		  function $serializer_getInstance_23() {
		    if ($serializer_instance_23 == null)
		      new $serializer_23();
		    return $serializer_instance_23;
		  }
		  function Body_init_$Init$_6(seen1, type, from, originating_session, body, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_23().r1p_1);
		    }
		    $this.t1p_1 = type;
		    $this.u1p_1 = from;
		    $this.v1p_1 = originating_session;
		    $this.w1p_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_6(seen1, type, from, originating_session, body, serializationConstructorMarker) {
		    return Body_init_$Init$_6(seen1, type, from, originating_session, body, serializationConstructorMarker, objectCreate(protoOf(Body_6)));
		  }
		  function AudioSayBody(text, level, loop, queue, voice_name, ssml) {
		    this.l1p_1 = text;
		    this.m1p_1 = level;
		    this.n1p_1 = loop;
		    this.o1p_1 = queue;
		    this.p1p_1 = voice_name;
		    this.q1p_1 = ssml;
		  }
		  protoOf(AudioSayBody).toString = function () {
		    return 'AudioSayBody(text=' + this.l1p_1 + ', level=' + this.m1p_1 + ', loop=' + this.n1p_1 + ', queue=' + this.o1p_1 + ', voice_name=' + this.p1p_1 + ', ssml=' + this.q1p_1 + ')';
		  };
		  protoOf(AudioSayBody).hashCode = function () {
		    var result = getStringHashCode(this.l1p_1);
		    result = imul(result, 31) + this.m1p_1 | 0;
		    result = imul(result, 31) + this.n1p_1 | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.o1p_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.p1p_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.q1p_1) | 0;
		    return result;
		  };
		  protoOf(AudioSayBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioSayBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioSayBody ? other : THROW_CCE();
		    if (!(this.l1p_1 === tmp0_other_with_cast.l1p_1))
		      return false;
		    if (!(this.m1p_1 === tmp0_other_with_cast.m1p_1))
		      return false;
		    if (!(this.n1p_1 === tmp0_other_with_cast.n1p_1))
		      return false;
		    if (!(this.o1p_1 === tmp0_other_with_cast.o1p_1))
		      return false;
		    if (!(this.p1p_1 === tmp0_other_with_cast.p1p_1))
		      return false;
		    if (!(this.q1p_1 === tmp0_other_with_cast.q1p_1))
		      return false;
		    return true;
		  };
		  function Body_6(type, from, originating_session, body) {
		    this.t1p_1 = type;
		    this.u1p_1 = from;
		    this.v1p_1 = originating_session;
		    this.w1p_1 = body;
		  }
		  function AudioSayRequest(cid, mid, text, level, loop, queue, voiceName, ssml) {
		    this.x1p_1 = cid;
		    this.y1p_1 = mid;
		    this.z1p_1 = text;
		    this.a1q_1 = level;
		    this.b1q_1 = loop;
		    this.c1q_1 = queue;
		    this.d1q_1 = voiceName;
		    this.e1q_1 = ssml;
		    this.f1q_1 = new ConversationEvents(this.x1p_1);
		    this.g1q_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(AudioSayRequest).u1h = function () {
		    return this.f1q_1;
		  };
		  protoOf(AudioSayRequest).v1h = function () {
		    return this.g1q_1;
		  };
		  protoOf(AudioSayRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_6('audio:say', this.y1p_1, originatingSessionId, new AudioSayBody(this.z1p_1, this.a1q_1, this.b1q_1, this.c1q_1, this.d1q_1, this.e1q_1));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_6), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(AudioSayRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(AudioSay), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(AudioSayRequest).toString = function () {
		    return 'AudioSayRequest(cid=' + this.x1p_1 + ', mid=' + this.y1p_1 + ', text=' + this.z1p_1 + ', level=' + this.a1q_1 + ', loop=' + this.b1q_1 + ', queue=' + this.c1q_1 + ', voiceName=' + this.d1q_1 + ', ssml=' + this.e1q_1 + ')';
		  };
		  protoOf(AudioSayRequest).hashCode = function () {
		    var result = getStringHashCode(this.x1p_1);
		    result = imul(result, 31) + getStringHashCode(this.y1p_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.z1p_1) | 0;
		    result = imul(result, 31) + this.a1q_1 | 0;
		    result = imul(result, 31) + this.b1q_1 | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.c1q_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.d1q_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.e1q_1) | 0;
		    return result;
		  };
		  protoOf(AudioSayRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioSayRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioSayRequest ? other : THROW_CCE();
		    if (!(this.x1p_1 === tmp0_other_with_cast.x1p_1))
		      return false;
		    if (!(this.y1p_1 === tmp0_other_with_cast.y1p_1))
		      return false;
		    if (!(this.z1p_1 === tmp0_other_with_cast.z1p_1))
		      return false;
		    if (!(this.a1q_1 === tmp0_other_with_cast.a1q_1))
		      return false;
		    if (!(this.b1q_1 === tmp0_other_with_cast.b1q_1))
		      return false;
		    if (!(this.c1q_1 === tmp0_other_with_cast.c1q_1))
		      return false;
		    if (!(this.d1q_1 === tmp0_other_with_cast.d1q_1))
		      return false;
		    if (!(this.e1q_1 === tmp0_other_with_cast.e1q_1))
		      return false;
		    return true;
		  };
		  function $serializer_24() {
		    $serializer_instance_24 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSError.InvalidParameter', this, 2);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('reason', false);
		    this.h1q_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_24).uf = function () {
		    return this.h1q_1;
		  };
		  protoOf($serializer_24).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_24).wf = function (decoder) {
		    var tmp0_desc = this.h1q_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return InvalidParameter_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_24).i1q = function (encoder, value) {
		    var tmp0_desc = this.h1q_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.j1q_1);
		    tmp1_output.tk(tmp0_desc, 1, value.k1q_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_24).vf = function (encoder, value) {
		    return this.i1q(encoder, value instanceof InvalidParameter ? value : THROW_CCE());
		  };
		  var $serializer_instance_24;
		  function $serializer_getInstance_24() {
		    if ($serializer_instance_24 == null)
		      new $serializer_24();
		    return $serializer_instance_24;
		  }
		  function InvalidParameter_init_$Init$(seen1, name, reason, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_24().h1q_1);
		    }
		    $this.j1q_1 = name;
		    $this.k1q_1 = reason;
		    return $this;
		  }
		  function InvalidParameter_init_$Create$(seen1, name, reason, serializationConstructorMarker) {
		    return InvalidParameter_init_$Init$(seen1, name, reason, serializationConstructorMarker, objectCreate(protoOf(InvalidParameter)));
		  }
		  function InvalidParameter() {
		  }
		  protoOf(InvalidParameter).toString = function () {
		    return 'InvalidParameter(name=' + this.j1q_1 + ', reason=' + this.k1q_1 + ')';
		  };
		  protoOf(InvalidParameter).hashCode = function () {
		    var result = getStringHashCode(this.j1q_1);
		    result = imul(result, 31) + getStringHashCode(this.k1q_1) | 0;
		    return result;
		  };
		  protoOf(InvalidParameter).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof InvalidParameter))
		      return false;
		    var tmp0_other_with_cast = other instanceof InvalidParameter ? other : THROW_CCE();
		    if (!(this.j1q_1 === tmp0_other_with_cast.j1q_1))
		      return false;
		    if (!(this.k1q_1 === tmp0_other_with_cast.k1q_1))
		      return false;
		    return true;
		  };
		  function Companion_22() {
		    Companion_instance_23 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.l1q_1 = [null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_24()), null];
		  }
		  protoOf(Companion_22).y12 = function () {
		    return $serializer_getInstance_25();
		  };
		  var Companion_instance_23;
		  function Companion_getInstance_24() {
		    if (Companion_instance_23 == null)
		      new Companion_22();
		    return Companion_instance_23;
		  }
		  function $serializer_25() {
		    $serializer_instance_25 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSError', this, 7);
		    tmp0_serialDesc.pq('title', true);
		    tmp0_serialDesc.pq('type', true);
		    tmp0_serialDesc.pq('code', true);
		    tmp0_serialDesc.pq('detail', true);
		    tmp0_serialDesc.pq('instance', true);
		    tmp0_serialDesc.pq('invalid_parameters', true);
		    tmp0_serialDesc.pq('message', true);
		    this.m1q_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_25).uf = function () {
		    return this.m1q_1;
		  };
		  protoOf($serializer_25).er = function () {
		    var tmp0_cached = Companion_getInstance_24().l1q_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[5]), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_25).wf = function (decoder) {
		    var tmp0_desc = this.m1q_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    var tmp12_cached = Companion_getInstance_24().l1q_1;
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return CSError_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_25).n1q = function (encoder, value) {
		    var tmp0_desc = this.m1q_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_24().l1q_1;
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.o1q_1 === '')) {
		      tmp1_output.tk(tmp0_desc, 0, value.o1q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.p1q_1 === '')) {
		      tmp1_output.tk(tmp0_desc, 1, value.p1q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.q1q_1 === '')) {
		      tmp1_output.tk(tmp0_desc, 2, value.q1q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.r1q_1 === '')) {
		      tmp1_output.tk(tmp0_desc, 3, value.r1q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.s1q_1 === '')) {
		      tmp1_output.tk(tmp0_desc, 4, value.s1q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.t1q_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, tmp2_cached[5], value.t1q_1);
		    }
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 6)) {
		      tmp = true;
		    } else {
		      var tmp0_safe_receiver = value.t1q_1;
		      var tmp_0;
		      if (tmp0_safe_receiver == null) {
		        tmp_0 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.actions.$serializer.serialize.<anonymous>' call
		        tmp_0 = ' - invalid_parameters: ' + tmp0_safe_receiver;
		      }
		      var tmp1_elvis_lhs = tmp_0;
		      tmp = !(value.u1q_1 === value.r1q_1 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs));
		    }
		    if (tmp) {
		      tmp1_output.tk(tmp0_desc, 6, value.u1q_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_25).vf = function (encoder, value) {
		    return this.n1q(encoder, value instanceof CSError ? value : THROW_CCE());
		  };
		  var $serializer_instance_25;
		  function $serializer_getInstance_25() {
		    if ($serializer_instance_25 == null)
		      new $serializer_25();
		    return $serializer_instance_25;
		  }
		  function CSError_init_$Init$(seen1, title, type, code, detail, instance, invalid_parameters, message, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_25().m1q_1);
		    }
		    Exception_init_$Init$($this);
		    if (0 === (seen1 & 1))
		      $this.o1q_1 = '';
		    else
		      $this.o1q_1 = title;
		    if (0 === (seen1 & 2))
		      $this.p1q_1 = '';
		    else
		      $this.p1q_1 = type;
		    if (0 === (seen1 & 4))
		      $this.q1q_1 = '';
		    else
		      $this.q1q_1 = code;
		    if (0 === (seen1 & 8))
		      $this.r1q_1 = '';
		    else
		      $this.r1q_1 = detail;
		    if (0 === (seen1 & 16))
		      $this.s1q_1 = '';
		    else
		      $this.s1q_1 = instance;
		    if (0 === (seen1 & 32))
		      $this.t1q_1 = null;
		    else
		      $this.t1q_1 = invalid_parameters;
		    if (0 === (seen1 & 64)) {
		      var tmp = $this;
		      var tmp0_safe_receiver = $this.t1q_1;
		      var tmp_0;
		      if (tmp0_safe_receiver == null) {
		        tmp_0 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.actions.CSError.<init>.<anonymous>' call
		        tmp_0 = ' - invalid_parameters: ' + tmp0_safe_receiver;
		      }
		      var tmp1_elvis_lhs = tmp_0;
		      tmp.u1q_1 = $this.r1q_1 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
		    } else
		      $this.u1q_1 = message;
		    return $this;
		  }
		  function CSError_init_$Create$(seen1, title, type, code, detail, instance, invalid_parameters, message, serializationConstructorMarker) {
		    var tmp = CSError_init_$Init$(seen1, title, type, code, detail, instance, invalid_parameters, message, serializationConstructorMarker, objectCreate(protoOf(CSError)));
		    captureStack(tmp, CSError_init_$Create$);
		    return tmp;
		  }
		  function CSError(title, type, code, detail, instance, invalid_parameters) {
		    Companion_getInstance_24();
		    title = title === VOID ? '' : title;
		    type = type === VOID ? '' : type;
		    code = code === VOID ? '' : code;
		    detail = detail === VOID ? '' : detail;
		    instance = instance === VOID ? '' : instance;
		    invalid_parameters = invalid_parameters === VOID ? null : invalid_parameters;
		    Exception_init_$Init$(this);
		    captureStack(this, CSError);
		    this.o1q_1 = title;
		    this.p1q_1 = type;
		    this.q1q_1 = code;
		    this.r1q_1 = detail;
		    this.s1q_1 = instance;
		    this.t1q_1 = invalid_parameters;
		    var tmp = this;
		    var tmp0_safe_receiver = this.t1q_1;
		    var tmp_0;
		    if (tmp0_safe_receiver == null) {
		      tmp_0 = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.actions.CSError.message.<anonymous>' call
		      tmp_0 = ' - invalid_parameters: ' + tmp0_safe_receiver;
		    }
		    var tmp1_elvis_lhs = tmp_0;
		    tmp.u1q_1 = this.r1q_1 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
		  }
		  protoOf(CSError).ab = function () {
		    return this.u1q_1;
		  };
		  protoOf(CSError).toString = function () {
		    return 'CSError(title=' + this.o1q_1 + ', type=' + this.p1q_1 + ', code=' + this.q1q_1 + ', detail=' + this.r1q_1 + ', instance=' + this.s1q_1 + ', invalid_parameters=' + this.t1q_1 + ')';
		  };
		  protoOf(CSError).hashCode = function () {
		    var result = getStringHashCode(this.o1q_1);
		    result = imul(result, 31) + getStringHashCode(this.p1q_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.q1q_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.r1q_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.s1q_1) | 0;
		    result = imul(result, 31) + (this.t1q_1 == null ? 0 : hashCode(this.t1q_1)) | 0;
		    return result;
		  };
		  protoOf(CSError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSError))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSError ? other : THROW_CCE();
		    if (!(this.o1q_1 === tmp0_other_with_cast.o1q_1))
		      return false;
		    if (!(this.p1q_1 === tmp0_other_with_cast.p1q_1))
		      return false;
		    if (!(this.q1q_1 === tmp0_other_with_cast.q1q_1))
		      return false;
		    if (!(this.r1q_1 === tmp0_other_with_cast.r1q_1))
		      return false;
		    if (!(this.s1q_1 === tmp0_other_with_cast.s1q_1))
		      return false;
		    if (!equals(this.t1q_1, tmp0_other_with_cast.t1q_1))
		      return false;
		    return true;
		  };
		  function GetMyMemberRequest(cid) {
		    this.v1q_1 = cid;
		    this.w1q_1 = new ConversationMemberMe(this.v1q_1);
		    this.x1q_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetMyMemberRequest).u1h = function () {
		    return this.w1q_1;
		  };
		  protoOf(GetMyMemberRequest).v1h = function () {
		    return this.x1q_1;
		  };
		  protoOf(GetMyMemberRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetMember), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetMyMemberRequest).toString = function () {
		    return 'GetMyMemberRequest(cid=' + this.v1q_1 + ')';
		  };
		  protoOf(GetMyMemberRequest).hashCode = function () {
		    return getStringHashCode(this.v1q_1);
		  };
		  protoOf(GetMyMemberRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetMyMemberRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetMyMemberRequest ? other : THROW_CCE();
		    if (!(this.v1q_1 === tmp0_other_with_cast.v1q_1))
		      return false;
		    return true;
		  };
		  function $serializer_26() {
		    $serializer_instance_26 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetMember.EmbeddedUser', this, 1);
		    tmp0_serialDesc.pq('user', false);
		    this.y1q_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_26).uf = function () {
		    return this.y1q_1;
		  };
		  protoOf($serializer_26).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_51()];
		  };
		  protoOf($serializer_26).wf = function (decoder) {
		    var tmp0_desc = this.y1q_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_51(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_51(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return EmbeddedUser_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_26).z1q = function (encoder, value) {
		    var tmp0_desc = this.y1q_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_51(), value.a1r_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_26).vf = function (encoder, value) {
		    return this.z1q(encoder, value instanceof EmbeddedUser ? value : THROW_CCE());
		  };
		  var $serializer_instance_26;
		  function $serializer_getInstance_26() {
		    if ($serializer_instance_26 == null)
		      new $serializer_26();
		    return $serializer_instance_26;
		  }
		  function EmbeddedUser_init_$Init$(seen1, user, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_26().y1q_1);
		    }
		    $this.a1r_1 = user;
		    return $this;
		  }
		  function EmbeddedUser_init_$Create$(seen1, user, serializationConstructorMarker) {
		    return EmbeddedUser_init_$Init$(seen1, user, serializationConstructorMarker, objectCreate(protoOf(EmbeddedUser)));
		  }
		  function EmbeddedUser() {
		  }
		  protoOf(EmbeddedUser).toString = function () {
		    return 'EmbeddedUser(user=' + this.a1r_1 + ')';
		  };
		  protoOf(EmbeddedUser).hashCode = function () {
		    return hashCode(this.a1r_1);
		  };
		  protoOf(EmbeddedUser).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EmbeddedUser))
		      return false;
		    var tmp0_other_with_cast = other instanceof EmbeddedUser ? other : THROW_CCE();
		    if (!equals(this.a1r_1, tmp0_other_with_cast.a1r_1))
		      return false;
		    return true;
		  };
		  function Companion_23() {
		    Companion_instance_24 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.b1r_1 = [null, new EnumSerializer('com.vonage.clientcore.core.api.models.MemberState', values_2()), null, null, null];
		  }
		  var Companion_instance_24;
		  function Companion_getInstance_25() {
		    if (Companion_instance_24 == null)
		      new Companion_23();
		    return Companion_instance_24;
		  }
		  function $serializer_27() {
		    $serializer_instance_27 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetMember', this, 5);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('state', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('channel', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.c1r_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_27).uf = function () {
		    return this.c1r_1;
		  };
		  protoOf($serializer_27).er = function () {
		    var tmp0_cached = Companion_getInstance_25().b1r_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), tmp0_cached[1], get_nullable($serializer_getInstance_26()), get_nullable($serializer_getInstance_155()), get_nullable($serializer_getInstance_161())];
		  };
		  protoOf($serializer_27).wf = function (decoder) {
		    var tmp0_desc = this.c1r_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    var tmp10_cached = Companion_getInstance_25().b1r_1;
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.qj(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, $serializer_getInstance_26(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, $serializer_getInstance_155(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.sj(tmp0_desc, 4, $serializer_getInstance_161(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.qj(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, $serializer_getInstance_26(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, $serializer_getInstance_155(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.sj(tmp0_desc, 4, $serializer_getInstance_161(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return GetMember_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_27).d1r = function (encoder, value) {
		    var tmp0_desc = this.c1r_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_25().b1r_1;
		    tmp1_output.tk(tmp0_desc, 0, value.e1r_1);
		    tmp1_output.vk(tmp0_desc, 1, tmp2_cached[1], value.f1r_1);
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.g1r_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_26(), value.g1r_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.h1r_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, $serializer_getInstance_155(), value.h1r_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.i1r_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, $serializer_getInstance_161(), value.i1r_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_27).vf = function (encoder, value) {
		    return this.d1r(encoder, value instanceof GetMember ? value : THROW_CCE());
		  };
		  var $serializer_instance_27;
		  function $serializer_getInstance_27() {
		    if ($serializer_instance_27 == null)
		      new $serializer_27();
		    return $serializer_instance_27;
		  }
		  function GetMember_init_$Init$(seen1, id, state, _embedded, channel, timestamp, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_27().c1r_1);
		    }
		    $this.e1r_1 = id;
		    $this.f1r_1 = state;
		    if (0 === (seen1 & 4))
		      $this.g1r_1 = null;
		    else
		      $this.g1r_1 = _embedded;
		    if (0 === (seen1 & 8))
		      $this.h1r_1 = null;
		    else
		      $this.h1r_1 = channel;
		    if (0 === (seen1 & 16))
		      $this.i1r_1 = null;
		    else
		      $this.i1r_1 = timestamp;
		    return $this;
		  }
		  function GetMember_init_$Create$(seen1, id, state, _embedded, channel, timestamp, serializationConstructorMarker) {
		    return GetMember_init_$Init$(seen1, id, state, _embedded, channel, timestamp, serializationConstructorMarker, objectCreate(protoOf(GetMember)));
		  }
		  function GetMember(id, state, _embedded, channel, timestamp) {
		    Companion_getInstance_25();
		    _embedded = _embedded === VOID ? null : _embedded;
		    channel = channel === VOID ? null : channel;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.e1r_1 = id;
		    this.f1r_1 = state;
		    this.g1r_1 = _embedded;
		    this.h1r_1 = channel;
		    this.i1r_1 = timestamp;
		  }
		  function Companion_24() {
		  }
		  var Companion_instance_25;
		  function Companion_getInstance_26() {
		    return Companion_instance_25;
		  }
		  function $serializer_28() {
		    $serializer_instance_28 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.Properties', this, 3);
		    tmp0_serialDesc.pq('custom_sort_key', true);
		    tmp0_serialDesc.pq('custom_data', true);
		    tmp0_serialDesc.pq('ttl', true);
		    this.j1r_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_28).uf = function () {
		    return this.j1r_1;
		  };
		  protoOf($serializer_28).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(JsonObjectSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
		  };
		  protoOf($serializer_28).wf = function (decoder) {
		    var tmp0_desc = this.j1r_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return Properties_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_28).k1r = function (encoder, value) {
		    var tmp0_desc = this.j1r_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.l1r_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.l1r_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.m1r_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, JsonObjectSerializer_getInstance(), value.m1r_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.n1r_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, IntSerializer_getInstance(), value.n1r_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_28).vf = function (encoder, value) {
		    return this.k1r(encoder, value instanceof Properties ? value : THROW_CCE());
		  };
		  var $serializer_instance_28;
		  function $serializer_getInstance_28() {
		    if ($serializer_instance_28 == null)
		      new $serializer_28();
		    return $serializer_instance_28;
		  }
		  function Properties_init_$Init$(seen1, custom_sort_key, custom_data, ttl, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_28().j1r_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.l1r_1 = null;
		    else
		      $this.l1r_1 = custom_sort_key;
		    if (0 === (seen1 & 2))
		      $this.m1r_1 = null;
		    else
		      $this.m1r_1 = custom_data;
		    if (0 === (seen1 & 4))
		      $this.n1r_1 = null;
		    else
		      $this.n1r_1 = ttl;
		    return $this;
		  }
		  function Properties_init_$Create$(seen1, custom_sort_key, custom_data, ttl, serializationConstructorMarker) {
		    return Properties_init_$Init$(seen1, custom_sort_key, custom_data, ttl, serializationConstructorMarker, objectCreate(protoOf(Properties)));
		  }
		  function Properties(custom_sort_key, custom_data, ttl) {
		    custom_sort_key = custom_sort_key === VOID ? null : custom_sort_key;
		    custom_data = custom_data === VOID ? null : custom_data;
		    ttl = ttl === VOID ? null : ttl;
		    this.l1r_1 = custom_sort_key;
		    this.m1r_1 = custom_data;
		    this.n1r_1 = ttl;
		  }
		  protoOf(Properties).o1r = function () {
		    var tmp0_safe_receiver = this.m1r_1;
		    return new Properties_1(this.n1r_1, this.l1r_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString());
		  };
		  protoOf(Properties).toString = function () {
		    return 'Properties(custom_sort_key=' + this.l1r_1 + ', custom_data=' + this.m1r_1 + ', ttl=' + this.n1r_1 + ')';
		  };
		  protoOf(Properties).hashCode = function () {
		    var result = this.l1r_1 == null ? 0 : getStringHashCode(this.l1r_1);
		    result = imul(result, 31) + (this.m1r_1 == null ? 0 : this.m1r_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.n1r_1 == null ? 0 : this.n1r_1) | 0;
		    return result;
		  };
		  protoOf(Properties).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Properties))
		      return false;
		    var tmp0_other_with_cast = other instanceof Properties ? other : THROW_CCE();
		    if (!(this.l1r_1 == tmp0_other_with_cast.l1r_1))
		      return false;
		    if (!equals(this.m1r_1, tmp0_other_with_cast.m1r_1))
		      return false;
		    if (!(this.n1r_1 == tmp0_other_with_cast.n1r_1))
		      return false;
		    return true;
		  };
		  function Companion_25() {
		  }
		  var Companion_instance_26;
		  function Companion_getInstance_27() {
		    return Companion_instance_26;
		  }
		  function $serializer_29() {
		    $serializer_instance_29 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PostConversationEventRequest.PostedEvent', this, 4);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('body', false);
		    this.p1r_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_29).uf = function () {
		    return this.p1r_1;
		  };
		  protoOf($serializer_29).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), EmptySerializer_getInstance()];
		  };
		  protoOf($serializer_29).wf = function (decoder) {
		    var tmp0_desc = this.p1r_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, EmptySerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, EmptySerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return PostedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_29).q1r = function (encoder, value) {
		    var tmp0_desc = this.p1r_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.r1r_1);
		    tmp1_output.tk(tmp0_desc, 1, value.s1r_1);
		    tmp1_output.tk(tmp0_desc, 2, value.t1r_1);
		    tmp1_output.vk(tmp0_desc, 3, EmptySerializer_getInstance(), value.u1r_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_29).vf = function (encoder, value) {
		    return this.q1r(encoder, value instanceof PostedEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_29;
		  function $serializer_getInstance_29() {
		    if ($serializer_instance_29 == null)
		      new $serializer_29();
		    return $serializer_instance_29;
		  }
		  function PostedEvent_init_$Init$(seen1, cid, from, type, body, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_29().p1r_1);
		    }
		    $this.r1r_1 = cid;
		    $this.s1r_1 = from;
		    $this.t1r_1 = type;
		    $this.u1r_1 = body;
		    return $this;
		  }
		  function PostedEvent_init_$Create$(seen1, cid, from, type, body, serializationConstructorMarker) {
		    return PostedEvent_init_$Init$(seen1, cid, from, type, body, serializationConstructorMarker, objectCreate(protoOf(PostedEvent)));
		  }
		  function PostedEvent(cid, from, type, body) {
		    this.r1r_1 = cid;
		    this.s1r_1 = from;
		    this.t1r_1 = type;
		    this.u1r_1 = body;
		  }
		  protoOf(PostedEvent).toString = function () {
		    return 'PostedEvent(cid=' + this.r1r_1 + ', from=' + this.s1r_1 + ', type=' + this.t1r_1 + ', body=' + this.u1r_1 + ')';
		  };
		  protoOf(PostedEvent).hashCode = function () {
		    var result = getStringHashCode(this.r1r_1);
		    result = imul(result, 31) + getStringHashCode(this.s1r_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.t1r_1) | 0;
		    result = imul(result, 31) + hashCode(this.u1r_1) | 0;
		    return result;
		  };
		  protoOf(PostedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PostedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof PostedEvent ? other : THROW_CCE();
		    if (!(this.r1r_1 === tmp0_other_with_cast.r1r_1))
		      return false;
		    if (!(this.s1r_1 === tmp0_other_with_cast.s1r_1))
		      return false;
		    if (!(this.t1r_1 === tmp0_other_with_cast.t1r_1))
		      return false;
		    if (!equals(this.u1r_1, tmp0_other_with_cast.u1r_1))
		      return false;
		    return true;
		  };
		  function PostConversationEventRequest(cid, from, type, body) {
		    this.v1r_1 = cid;
		    this.w1r_1 = from;
		    this.x1r_1 = type;
		    this.y1r_1 = body;
		    this.z1r_1 = new ConversationEvents(this.v1r_1);
		    this.a1s_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(PostConversationEventRequest).u1h = function () {
		    return this.z1r_1;
		  };
		  protoOf(PostConversationEventRequest).v1h = function () {
		    return this.a1s_1;
		  };
		  protoOf(PostConversationEventRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new PostedEvent(this.v1r_1, this.w1r_1, this.x1r_1.d1s_1, this.y1r_1);
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(PostedEvent), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(PostConversationEventRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(PostConversationEvent), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(PostConversationEventRequest).z1h = function () {
		    return this.y1r_1.z1h();
		  };
		  protoOf(PostConversationEventRequest).toString = function () {
		    return 'PostConversationEventRequest(cid=' + this.v1r_1 + ', from=' + this.w1r_1 + ', type=' + this.x1r_1 + ', body=' + this.y1r_1 + ')';
		  };
		  protoOf(PostConversationEventRequest).hashCode = function () {
		    var result = getStringHashCode(this.v1r_1);
		    result = imul(result, 31) + getStringHashCode(this.w1r_1) | 0;
		    result = imul(result, 31) + this.x1r_1.hashCode() | 0;
		    result = imul(result, 31) + hashCode(this.y1r_1) | 0;
		    return result;
		  };
		  protoOf(PostConversationEventRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PostConversationEventRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof PostConversationEventRequest ? other : THROW_CCE();
		    if (!(this.v1r_1 === tmp0_other_with_cast.v1r_1))
		      return false;
		    if (!(this.w1r_1 === tmp0_other_with_cast.w1r_1))
		      return false;
		    if (!this.x1r_1.equals(tmp0_other_with_cast.x1r_1))
		      return false;
		    if (!equals(this.y1r_1, tmp0_other_with_cast.y1r_1))
		      return false;
		    return true;
		  };
		  function Companion_26() {
		  }
		  var Companion_instance_27;
		  function Companion_getInstance_28() {
		    return Companion_instance_27;
		  }
		  function $serializer_30() {
		    $serializer_instance_30 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.UpdateEventStateRequestBody', this, 1);
		    tmp0_serialDesc.pq('event_id', false);
		    this.e1s_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_30).uf = function () {
		    return this.e1s_1;
		  };
		  protoOf($serializer_30).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance()];
		  };
		  protoOf($serializer_30).wf = function (decoder) {
		    var tmp0_desc = this.e1s_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return UpdateEventStateRequestBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_30).f1s = function (encoder, value) {
		    var tmp0_desc = this.e1s_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.g1s_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_30).vf = function (encoder, value) {
		    return this.f1s(encoder, value instanceof UpdateEventStateRequestBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_30;
		  function $serializer_getInstance_30() {
		    if ($serializer_instance_30 == null)
		      new $serializer_30();
		    return $serializer_instance_30;
		  }
		  function UpdateEventStateRequestBody_init_$Init$(seen1, eventId, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_30().e1s_1);
		    }
		    $this.g1s_1 = eventId;
		    return $this;
		  }
		  function UpdateEventStateRequestBody_init_$Create$(seen1, eventId, serializationConstructorMarker) {
		    return UpdateEventStateRequestBody_init_$Init$(seen1, eventId, serializationConstructorMarker, objectCreate(protoOf(UpdateEventStateRequestBody)));
		  }
		  function UpdateEventStateRequestBody(eventId) {
		    this.g1s_1 = eventId;
		  }
		  function Companion_27() {
		  }
		  var Companion_instance_28;
		  function Companion_getInstance_29() {
		    return Companion_instance_28;
		  }
		  function $serializer_31() {
		    $serializer_instance_31 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CreateConversationRequest.Body', this, 4);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('display_name', false);
		    tmp0_serialDesc.pq('properties', false);
		    tmp0_serialDesc.pq('image_url', false);
		    this.h1s_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_31).uf = function () {
		    return this.h1s_1;
		  };
		  protoOf($serializer_31).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_28()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_31).wf = function (decoder) {
		    var tmp0_desc = this.h1s_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.sj(tmp0_desc, 2, $serializer_getInstance_28(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.sj(tmp0_desc, 2, $serializer_getInstance_28(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return Body_init_$Create$_7(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_31).i1s = function (encoder, value) {
		    var tmp0_desc = this.h1s_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.j1s_1);
		    tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.k1s_1);
		    tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_28(), value.l1s_1);
		    tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.m1s_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_31).vf = function (encoder, value) {
		    return this.i1s(encoder, value instanceof Body_7 ? value : THROW_CCE());
		  };
		  var $serializer_instance_31;
		  function $serializer_getInstance_31() {
		    if ($serializer_instance_31 == null)
		      new $serializer_31();
		    return $serializer_instance_31;
		  }
		  function Body_init_$Init$_7(seen1, name, display_name, properties, image_url, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_31().h1s_1);
		    }
		    $this.j1s_1 = name;
		    $this.k1s_1 = display_name;
		    $this.l1s_1 = properties;
		    $this.m1s_1 = image_url;
		    return $this;
		  }
		  function Body_init_$Create$_7(seen1, name, display_name, properties, image_url, serializationConstructorMarker) {
		    return Body_init_$Init$_7(seen1, name, display_name, properties, image_url, serializationConstructorMarker, objectCreate(protoOf(Body_7)));
		  }
		  function Body_7(name, display_name, properties, image_url) {
		    this.j1s_1 = name;
		    this.k1s_1 = display_name;
		    this.l1s_1 = properties;
		    this.m1s_1 = image_url;
		  }
		  function CreateConversationRequest(name, displayName, imageUrl, properties) {
		    name = name === VOID ? null : name;
		    displayName = displayName === VOID ? null : displayName;
		    imageUrl = imageUrl === VOID ? null : imageUrl;
		    properties = properties === VOID ? null : properties;
		    this.n1s_1 = name;
		    this.o1s_1 = displayName;
		    this.p1s_1 = imageUrl;
		    this.q1s_1 = properties;
		    this.r1s_1 = new Conversations();
		    this.s1s_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(CreateConversationRequest).u1h = function () {
		    return this.r1s_1;
		  };
		  protoOf(CreateConversationRequest).v1h = function () {
		    return this.s1s_1;
		  };
		  protoOf(CreateConversationRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_7(this.n1s_1, this.o1s_1, this.q1s_1, this.p1s_1);
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_7), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(CreateConversationRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(ConversationCreate), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(CreateConversationRequest).z1h = function () {
		    var tmp0_safe_receiver = this.n1s_1;
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.text.contains' call
		      tmp = Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(tmp0_safe_receiver);
		    }
		    var tmp1_elvis_lhs = tmp;
		    var nameSanitized = !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
		    var tmp2_safe_receiver = this.o1s_1;
		    var tmp_0;
		    if (tmp2_safe_receiver == null) {
		      tmp_0 = null;
		    } else {
		      // Inline function 'kotlin.text.contains' call
		      tmp_0 = Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(tmp2_safe_receiver);
		    }
		    var tmp3_elvis_lhs = tmp_0;
		    var displayNameSanitized = !(tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs);
		    var tmp4_safe_receiver = this.p1s_1;
		    var tmp_1;
		    if (tmp4_safe_receiver == null) {
		      tmp_1 = null;
		    } else {
		      // Inline function 'kotlin.text.contains' call
		      tmp_1 = Regex_init_$Create$('"|\'|<|>|\\|javascript:').v7(tmp4_safe_receiver);
		    }
		    var tmp5_elvis_lhs = tmp_1;
		    var imageUrlSanitized = !(tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs);
		    return (nameSanitized ? displayNameSanitized : false) ? imageUrlSanitized : false;
		  };
		  protoOf(CreateConversationRequest).toString = function () {
		    return 'CreateConversationRequest(name=' + this.n1s_1 + ', displayName=' + this.o1s_1 + ', imageUrl=' + this.p1s_1 + ', properties=' + this.q1s_1 + ')';
		  };
		  protoOf(CreateConversationRequest).hashCode = function () {
		    var result = this.n1s_1 == null ? 0 : getStringHashCode(this.n1s_1);
		    result = imul(result, 31) + (this.o1s_1 == null ? 0 : getStringHashCode(this.o1s_1)) | 0;
		    result = imul(result, 31) + (this.p1s_1 == null ? 0 : getStringHashCode(this.p1s_1)) | 0;
		    result = imul(result, 31) + (this.q1s_1 == null ? 0 : this.q1s_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(CreateConversationRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CreateConversationRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof CreateConversationRequest ? other : THROW_CCE();
		    if (!(this.n1s_1 == tmp0_other_with_cast.n1s_1))
		      return false;
		    if (!(this.o1s_1 == tmp0_other_with_cast.o1s_1))
		      return false;
		    if (!(this.p1s_1 == tmp0_other_with_cast.p1s_1))
		      return false;
		    if (!equals(this.q1s_1, tmp0_other_with_cast.q1s_1))
		      return false;
		    return true;
		  };
		  function Companion_28() {
		  }
		  var Companion_instance_29;
		  function Companion_getInstance_30() {
		    return Companion_instance_29;
		  }
		  function $serializer_32() {
		    $serializer_instance_32 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationCreate', this, 4);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('state', false);
		    tmp0_serialDesc.pq('display_name', true);
		    this.t1s_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_32).uf = function () {
		    return this.t1s_1;
		  };
		  protoOf($serializer_32).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_32).wf = function (decoder) {
		    var tmp0_desc = this.t1s_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return ConversationCreate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_32).u1s = function (encoder, value) {
		    var tmp0_desc = this.t1s_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.v1s_1);
		    tmp1_output.tk(tmp0_desc, 1, value.w1s_1);
		    tmp1_output.tk(tmp0_desc, 2, value.x1s_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.y1s_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.y1s_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_32).vf = function (encoder, value) {
		    return this.u1s(encoder, value instanceof ConversationCreate ? value : THROW_CCE());
		  };
		  var $serializer_instance_32;
		  function $serializer_getInstance_32() {
		    if ($serializer_instance_32 == null)
		      new $serializer_32();
		    return $serializer_instance_32;
		  }
		  function ConversationCreate_init_$Init$(seen1, id, name, state, display_name, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_32().t1s_1);
		    }
		    $this.v1s_1 = id;
		    $this.w1s_1 = name;
		    $this.x1s_1 = state;
		    if (0 === (seen1 & 8))
		      $this.y1s_1 = null;
		    else
		      $this.y1s_1 = display_name;
		    return $this;
		  }
		  function ConversationCreate_init_$Create$(seen1, id, name, state, display_name, serializationConstructorMarker) {
		    return ConversationCreate_init_$Init$(seen1, id, name, state, display_name, serializationConstructorMarker, objectCreate(protoOf(ConversationCreate)));
		  }
		  function ConversationCreate(id, name, state, display_name) {
		    display_name = display_name === VOID ? null : display_name;
		    this.v1s_1 = id;
		    this.w1s_1 = name;
		    this.x1s_1 = state;
		    this.y1s_1 = display_name;
		  }
		  protoOf(ConversationCreate).toString = function () {
		    return 'ConversationCreate(id=' + this.v1s_1 + ', name=' + this.w1s_1 + ', state=' + this.x1s_1 + ', display_name=' + this.y1s_1 + ')';
		  };
		  protoOf(ConversationCreate).hashCode = function () {
		    var result = getStringHashCode(this.v1s_1);
		    result = imul(result, 31) + getStringHashCode(this.w1s_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.x1s_1) | 0;
		    result = imul(result, 31) + (this.y1s_1 == null ? 0 : getStringHashCode(this.y1s_1)) | 0;
		    return result;
		  };
		  protoOf(ConversationCreate).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationCreate))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationCreate ? other : THROW_CCE();
		    if (!(this.v1s_1 === tmp0_other_with_cast.v1s_1))
		      return false;
		    if (!(this.w1s_1 === tmp0_other_with_cast.w1s_1))
		      return false;
		    if (!(this.x1s_1 === tmp0_other_with_cast.x1s_1))
		      return false;
		    if (!(this.y1s_1 == tmp0_other_with_cast.y1s_1))
		      return false;
		    return true;
		  };
		  function Companion_29() {
		    Companion_instance_30 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.z1s_1 = [new OptionSerializer(StringSerializer_getInstance()), new OptionSerializer(get_nullable(StringSerializer_getInstance())), new OptionSerializer(get_nullable(StringSerializer_getInstance())), new OptionSerializer(get_nullable($serializer_getInstance_34()))];
		  }
		  var Companion_instance_30;
		  function Companion_getInstance_31() {
		    if (Companion_instance_30 == null)
		      new Companion_29();
		    return Companion_instance_30;
		  }
		  function $serializer_33() {
		    $serializer_instance_33 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.UpdateConversationRequest.Body', this, 4);
		    tmp0_serialDesc.pq('name', true);
		    tmp0_serialDesc.pq('display_name', true);
		    tmp0_serialDesc.pq('image_url', true);
		    tmp0_serialDesc.pq('properties', true);
		    this.a1t_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_33).uf = function () {
		    return this.a1t_1;
		  };
		  protoOf($serializer_33).er = function () {
		    var tmp0_cached = Companion_getInstance_31().z1s_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], tmp0_cached[3]];
		  };
		  protoOf($serializer_33).wf = function (decoder) {
		    var tmp0_desc = this.a1t_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    var tmp9_cached = Companion_getInstance_31().z1s_1;
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.qj(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.qj(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.qj(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.qj(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.qj(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.qj(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return Body_init_$Create$_8(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_33).b1t = function (encoder, value) {
		    var tmp0_desc = this.a1t_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_31().z1s_1;
		    if (!value.c1t_1.equals(none())) {
		      tmp1_output.vk(tmp0_desc, 0, tmp2_cached[0], value.c1t_1);
		    }
		    if (!value.d1t_1.equals(none())) {
		      tmp1_output.vk(tmp0_desc, 1, tmp2_cached[1], value.d1t_1);
		    }
		    if (!value.e1t_1.equals(none())) {
		      tmp1_output.vk(tmp0_desc, 2, tmp2_cached[2], value.e1t_1);
		    }
		    if (!value.f1t_1.equals(none())) {
		      tmp1_output.vk(tmp0_desc, 3, tmp2_cached[3], value.f1t_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_33).vf = function (encoder, value) {
		    return this.b1t(encoder, value instanceof Body_8 ? value : THROW_CCE());
		  };
		  var $serializer_instance_33;
		  function $serializer_getInstance_33() {
		    if ($serializer_instance_33 == null)
		      new $serializer_33();
		    return $serializer_instance_33;
		  }
		  function Body_init_$Init$_8(seen1, name, display_name, image_url, properties, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_33().a1t_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.c1t_1 = none();
		    else
		      $this.c1t_1 = name;
		    if (0 === (seen1 & 2))
		      $this.d1t_1 = none();
		    else
		      $this.d1t_1 = display_name;
		    if (0 === (seen1 & 4))
		      $this.e1t_1 = none();
		    else
		      $this.e1t_1 = image_url;
		    if (0 === (seen1 & 8))
		      $this.f1t_1 = none();
		    else
		      $this.f1t_1 = properties;
		    return $this;
		  }
		  function Body_init_$Create$_8(seen1, name, display_name, image_url, properties, serializationConstructorMarker) {
		    return Body_init_$Init$_8(seen1, name, display_name, image_url, properties, serializationConstructorMarker, objectCreate(protoOf(Body_8)));
		  }
		  function Companion_30() {
		    Companion_instance_31 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.g1t_1 = [new OptionSerializer(get_nullable(StringSerializer_getInstance())), new OptionSerializer(get_nullable(JsonObjectSerializer_getInstance())), new OptionSerializer(IntSerializer_getInstance())];
		  }
		  var Companion_instance_31;
		  function Companion_getInstance_32() {
		    if (Companion_instance_31 == null)
		      new Companion_30();
		    return Companion_instance_31;
		  }
		  function $serializer_34() {
		    $serializer_instance_34 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.UpdateConversationRequest.Properties', this, 3);
		    tmp0_serialDesc.pq('custom_sort_key', true);
		    tmp0_serialDesc.pq('custom_data', true);
		    tmp0_serialDesc.pq('ttl', true);
		    this.h1t_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_34).uf = function () {
		    return this.h1t_1;
		  };
		  protoOf($serializer_34).er = function () {
		    var tmp0_cached = Companion_getInstance_32().g1t_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2]];
		  };
		  protoOf($serializer_34).wf = function (decoder) {
		    var tmp0_desc = this.h1t_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    var tmp8_cached = Companion_getInstance_32().g1t_1;
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return Properties_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_34).i1t = function (encoder, value) {
		    var tmp0_desc = this.h1t_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_32().g1t_1;
		    if (!value.j1t_1.equals(none())) {
		      tmp1_output.vk(tmp0_desc, 0, tmp2_cached[0], value.j1t_1);
		    }
		    if (!value.k1t_1.equals(none())) {
		      tmp1_output.vk(tmp0_desc, 1, tmp2_cached[1], value.k1t_1);
		    }
		    if (!value.l1t_1.equals(none())) {
		      tmp1_output.vk(tmp0_desc, 2, tmp2_cached[2], value.l1t_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_34).vf = function (encoder, value) {
		    return this.i1t(encoder, value instanceof Properties_0 ? value : THROW_CCE());
		  };
		  var $serializer_instance_34;
		  function $serializer_getInstance_34() {
		    if ($serializer_instance_34 == null)
		      new $serializer_34();
		    return $serializer_instance_34;
		  }
		  function Properties_init_$Init$_0(seen1, custom_sort_key, custom_data, ttl, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_34().h1t_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.j1t_1 = none();
		    else
		      $this.j1t_1 = custom_sort_key;
		    if (0 === (seen1 & 2))
		      $this.k1t_1 = none();
		    else
		      $this.k1t_1 = custom_data;
		    if (0 === (seen1 & 4))
		      $this.l1t_1 = none();
		    else
		      $this.l1t_1 = ttl;
		    return $this;
		  }
		  function Properties_init_$Create$_0(seen1, custom_sort_key, custom_data, ttl, serializationConstructorMarker) {
		    return Properties_init_$Init$_0(seen1, custom_sort_key, custom_data, ttl, serializationConstructorMarker, objectCreate(protoOf(Properties_0)));
		  }
		  function Body_8(name, display_name, image_url, properties) {
		    Companion_getInstance_31();
		    name = name === VOID ? none() : name;
		    display_name = display_name === VOID ? none() : display_name;
		    image_url = image_url === VOID ? none() : image_url;
		    properties = properties === VOID ? none() : properties;
		    this.c1t_1 = name;
		    this.d1t_1 = display_name;
		    this.e1t_1 = image_url;
		    this.f1t_1 = properties;
		  }
		  protoOf(Body_8).toString = function () {
		    return 'Body(name=' + this.c1t_1 + ', display_name=' + this.d1t_1 + ', image_url=' + this.e1t_1 + ', properties=' + this.f1t_1 + ')';
		  };
		  protoOf(Body_8).hashCode = function () {
		    var result = this.c1t_1.hashCode();
		    result = imul(result, 31) + this.d1t_1.hashCode() | 0;
		    result = imul(result, 31) + this.e1t_1.hashCode() | 0;
		    result = imul(result, 31) + this.f1t_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(Body_8).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_8))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_8 ? other : THROW_CCE();
		    if (!this.c1t_1.equals(tmp0_other_with_cast.c1t_1))
		      return false;
		    if (!this.d1t_1.equals(tmp0_other_with_cast.d1t_1))
		      return false;
		    if (!this.e1t_1.equals(tmp0_other_with_cast.e1t_1))
		      return false;
		    if (!this.f1t_1.equals(tmp0_other_with_cast.f1t_1))
		      return false;
		    return true;
		  };
		  function Properties_0(custom_sort_key, custom_data, ttl) {
		    Companion_getInstance_32();
		    custom_sort_key = custom_sort_key === VOID ? none() : custom_sort_key;
		    custom_data = custom_data === VOID ? none() : custom_data;
		    ttl = ttl === VOID ? none() : ttl;
		    this.j1t_1 = custom_sort_key;
		    this.k1t_1 = custom_data;
		    this.l1t_1 = ttl;
		  }
		  protoOf(Properties_0).toString = function () {
		    return 'Properties(custom_sort_key=' + this.j1t_1 + ', custom_data=' + this.k1t_1 + ', ttl=' + this.l1t_1 + ')';
		  };
		  protoOf(Properties_0).hashCode = function () {
		    var result = this.j1t_1.hashCode();
		    result = imul(result, 31) + this.k1t_1.hashCode() | 0;
		    result = imul(result, 31) + this.l1t_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(Properties_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Properties_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof Properties_0 ? other : THROW_CCE();
		    if (!this.j1t_1.equals(tmp0_other_with_cast.j1t_1))
		      return false;
		    if (!this.k1t_1.equals(tmp0_other_with_cast.k1t_1))
		      return false;
		    if (!this.l1t_1.equals(tmp0_other_with_cast.l1t_1))
		      return false;
		    return true;
		  };
		  function UpdateConversationRequest(cid, name, displayName, imageUrl, properties) {
		    this.m1t_1 = cid;
		    this.n1t_1 = name;
		    this.o1t_1 = displayName;
		    this.p1t_1 = imageUrl;
		    this.q1t_1 = properties;
		    this.r1t_1 = new Conversation_1(this.m1t_1);
		    this.s1t_1 = HTTPMethod_PATCH_getInstance();
		  }
		  protoOf(UpdateConversationRequest).u1h = function () {
		    return this.r1t_1;
		  };
		  protoOf(UpdateConversationRequest).v1h = function () {
		    return this.s1t_1;
		  };
		  protoOf(UpdateConversationRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_8(this.n1t_1, this.o1t_1, this.p1t_1, this.q1t_1);
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_8), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(UpdateConversationRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetConversation), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(UpdateConversationRequest).z1h = function () {
		    var tmp0_safe_receiver = this.n1t_1.t1t();
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.text.contains' call
		      tmp = Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(tmp0_safe_receiver);
		    }
		    var tmp1_elvis_lhs = tmp;
		    var nameSanitized = !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
		    var tmp2_safe_receiver = this.o1t_1.t1t();
		    var tmp_0;
		    if (tmp2_safe_receiver == null) {
		      tmp_0 = null;
		    } else {
		      // Inline function 'kotlin.text.contains' call
		      tmp_0 = Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(tmp2_safe_receiver);
		    }
		    var tmp3_elvis_lhs = tmp_0;
		    var displayNameSanitized = !(tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs);
		    var tmp4_safe_receiver = this.p1t_1.t1t();
		    var tmp_1;
		    if (tmp4_safe_receiver == null) {
		      tmp_1 = null;
		    } else {
		      // Inline function 'kotlin.text.contains' call
		      tmp_1 = Regex_init_$Create$('"|\'|<|>|\\|javascript:').v7(tmp4_safe_receiver);
		    }
		    var tmp5_elvis_lhs = tmp_1;
		    var imageUrlSanitized = !(tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs);
		    return (nameSanitized ? displayNameSanitized : false) ? imageUrlSanitized : false;
		  };
		  protoOf(UpdateConversationRequest).toString = function () {
		    return 'UpdateConversationRequest(cid=' + this.m1t_1 + ', name=' + this.n1t_1 + ', displayName=' + this.o1t_1 + ', imageUrl=' + this.p1t_1 + ', properties=' + this.q1t_1 + ')';
		  };
		  protoOf(UpdateConversationRequest).hashCode = function () {
		    var result = getStringHashCode(this.m1t_1);
		    result = imul(result, 31) + this.n1t_1.hashCode() | 0;
		    result = imul(result, 31) + this.o1t_1.hashCode() | 0;
		    result = imul(result, 31) + this.p1t_1.hashCode() | 0;
		    result = imul(result, 31) + this.q1t_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(UpdateConversationRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UpdateConversationRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof UpdateConversationRequest ? other : THROW_CCE();
		    if (!(this.m1t_1 === tmp0_other_with_cast.m1t_1))
		      return false;
		    if (!this.n1t_1.equals(tmp0_other_with_cast.n1t_1))
		      return false;
		    if (!this.o1t_1.equals(tmp0_other_with_cast.o1t_1))
		      return false;
		    if (!this.p1t_1.equals(tmp0_other_with_cast.p1t_1))
		      return false;
		    if (!this.q1t_1.equals(tmp0_other_with_cast.q1t_1))
		      return false;
		    return true;
		  };
		  function Companion_31() {
		  }
		  var Companion_instance_32;
		  function Companion_getInstance_33() {
		    return Companion_instance_32;
		  }
		  function $serializer_35() {
		    $serializer_instance_35 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationJoinRequest.MemberJoinChannel', this, 1);
		    tmp0_serialDesc.pq('type', true);
		    this.u1t_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_35).uf = function () {
		    return this.u1t_1;
		  };
		  protoOf($serializer_35).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_35).wf = function (decoder) {
		    var tmp0_desc = this.u1t_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return MemberJoinChannel_init_$Create$_0(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_35).v1t = function (encoder, value) {
		    var tmp0_desc = this.u1t_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.w1t_1 === 'app')) {
		      tmp1_output.tk(tmp0_desc, 0, value.w1t_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_35).vf = function (encoder, value) {
		    return this.v1t(encoder, value instanceof MemberJoinChannel_0 ? value : THROW_CCE());
		  };
		  var $serializer_instance_35;
		  function $serializer_getInstance_35() {
		    if ($serializer_instance_35 == null)
		      new $serializer_35();
		    return $serializer_instance_35;
		  }
		  function MemberJoinChannel_init_$Init$_0(seen1, type, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_35().u1t_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.w1t_1 = 'app';
		    else
		      $this.w1t_1 = type;
		    return $this;
		  }
		  function MemberJoinChannel_init_$Create$_0(seen1, type, serializationConstructorMarker) {
		    return MemberJoinChannel_init_$Init$_0(seen1, type, serializationConstructorMarker, objectCreate(protoOf(MemberJoinChannel_0)));
		  }
		  function Companion_32() {
		  }
		  var Companion_instance_33;
		  function Companion_getInstance_34() {
		    return Companion_instance_33;
		  }
		  function $serializer_36() {
		    $serializer_instance_36 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationJoinRequest.JoinUser', this, 2);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('name', false);
		    this.x1t_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_36).uf = function () {
		    return this.x1t_1;
		  };
		  protoOf($serializer_36).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_36).wf = function (decoder) {
		    var tmp0_desc = this.x1t_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return JoinUser_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_36).y1t = function (encoder, value) {
		    var tmp0_desc = this.x1t_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.z1t_1);
		    tmp1_output.tk(tmp0_desc, 1, value.a1u_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_36).vf = function (encoder, value) {
		    return this.y1t(encoder, value instanceof JoinUser ? value : THROW_CCE());
		  };
		  var $serializer_instance_36;
		  function $serializer_getInstance_36() {
		    if ($serializer_instance_36 == null)
		      new $serializer_36();
		    return $serializer_instance_36;
		  }
		  function JoinUser_init_$Init$(seen1, id, name, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_36().x1t_1);
		    }
		    $this.z1t_1 = id;
		    $this.a1u_1 = name;
		    return $this;
		  }
		  function JoinUser_init_$Create$(seen1, id, name, serializationConstructorMarker) {
		    return JoinUser_init_$Init$(seen1, id, name, serializationConstructorMarker, objectCreate(protoOf(JoinUser)));
		  }
		  function Companion_33() {
		  }
		  var Companion_instance_34;
		  function Companion_getInstance_35() {
		    return Companion_instance_34;
		  }
		  function $serializer_37() {
		    $serializer_instance_37 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationJoinRequest.Body', this, 4);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('channel', false);
		    tmp0_serialDesc.pq('user', false);
		    tmp0_serialDesc.pq('state', true);
		    this.b1u_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_37).uf = function () {
		    return this.b1u_1;
		  };
		  protoOf($serializer_37).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_35(), $serializer_getInstance_36(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_37).wf = function (decoder) {
		    var tmp0_desc = this.b1u_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.qj(tmp0_desc, 1, $serializer_getInstance_35(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.qj(tmp0_desc, 2, $serializer_getInstance_36(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.qj(tmp0_desc, 1, $serializer_getInstance_35(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.qj(tmp0_desc, 2, $serializer_getInstance_36(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return Body_init_$Create$_9(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_37).c1u = function (encoder, value) {
		    var tmp0_desc = this.b1u_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.d1u_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_35(), value.e1u_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_36(), value.f1u_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.g1u_1 === 'joined')) {
		      tmp1_output.tk(tmp0_desc, 3, value.g1u_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_37).vf = function (encoder, value) {
		    return this.c1u(encoder, value instanceof Body_9 ? value : THROW_CCE());
		  };
		  var $serializer_instance_37;
		  function $serializer_getInstance_37() {
		    if ($serializer_instance_37 == null)
		      new $serializer_37();
		    return $serializer_instance_37;
		  }
		  function Body_init_$Init$_9(seen1, originating_session, channel, user, state, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_37().b1u_1);
		    }
		    $this.d1u_1 = originating_session;
		    $this.e1u_1 = channel;
		    $this.f1u_1 = user;
		    if (0 === (seen1 & 8))
		      $this.g1u_1 = 'joined';
		    else
		      $this.g1u_1 = state;
		    return $this;
		  }
		  function Body_init_$Create$_9(seen1, originating_session, channel, user, state, serializationConstructorMarker) {
		    return Body_init_$Init$_9(seen1, originating_session, channel, user, state, serializationConstructorMarker, objectCreate(protoOf(Body_9)));
		  }
		  function MemberJoinChannel_0(type) {
		    type = type === VOID ? 'app' : type;
		    this.w1t_1 = type;
		  }
		  protoOf(MemberJoinChannel_0).toString = function () {
		    return 'MemberJoinChannel(type=' + this.w1t_1 + ')';
		  };
		  protoOf(MemberJoinChannel_0).hashCode = function () {
		    return getStringHashCode(this.w1t_1);
		  };
		  protoOf(MemberJoinChannel_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberJoinChannel_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberJoinChannel_0 ? other : THROW_CCE();
		    if (!(this.w1t_1 === tmp0_other_with_cast.w1t_1))
		      return false;
		    return true;
		  };
		  function JoinUser(id, name) {
		    this.z1t_1 = id;
		    this.a1u_1 = name;
		  }
		  protoOf(JoinUser).toString = function () {
		    return 'JoinUser(id=' + this.z1t_1 + ', name=' + this.a1u_1 + ')';
		  };
		  protoOf(JoinUser).hashCode = function () {
		    var result = getStringHashCode(this.z1t_1);
		    result = imul(result, 31) + getStringHashCode(this.a1u_1) | 0;
		    return result;
		  };
		  protoOf(JoinUser).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof JoinUser))
		      return false;
		    var tmp0_other_with_cast = other instanceof JoinUser ? other : THROW_CCE();
		    if (!(this.z1t_1 === tmp0_other_with_cast.z1t_1))
		      return false;
		    if (!(this.a1u_1 === tmp0_other_with_cast.a1u_1))
		      return false;
		    return true;
		  };
		  function Body_9(originating_session, channel, user, state) {
		    state = state === VOID ? 'joined' : state;
		    this.d1u_1 = originating_session;
		    this.e1u_1 = channel;
		    this.f1u_1 = user;
		    this.g1u_1 = state;
		  }
		  function ConversationJoinRequest(cid, userId, username) {
		    this.h1u_1 = cid;
		    this.i1u_1 = userId;
		    this.j1u_1 = username;
		    this.k1u_1 = new ConversationMembers(this.h1u_1);
		    this.l1u_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(ConversationJoinRequest).u1h = function () {
		    return this.k1u_1;
		  };
		  protoOf(ConversationJoinRequest).v1h = function () {
		    return this.l1u_1;
		  };
		  protoOf(ConversationJoinRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_9(originatingSessionId, new MemberJoinChannel_0(), new JoinUser(this.i1u_1, this.j1u_1));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_9), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(ConversationJoinRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(ConversationJoin), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(ConversationJoinRequest).toString = function () {
		    return 'ConversationJoinRequest(cid=' + this.h1u_1 + ', userId=' + this.i1u_1 + ', username=' + this.j1u_1 + ')';
		  };
		  protoOf(ConversationJoinRequest).hashCode = function () {
		    var result = getStringHashCode(this.h1u_1);
		    result = imul(result, 31) + getStringHashCode(this.i1u_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.j1u_1) | 0;
		    return result;
		  };
		  protoOf(ConversationJoinRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationJoinRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationJoinRequest ? other : THROW_CCE();
		    if (!(this.h1u_1 === tmp0_other_with_cast.h1u_1))
		      return false;
		    if (!(this.i1u_1 === tmp0_other_with_cast.i1u_1))
		      return false;
		    if (!(this.j1u_1 === tmp0_other_with_cast.j1u_1))
		      return false;
		    return true;
		  };
		  function Companion_34() {
		  }
		  var Companion_instance_35;
		  function Companion_getInstance_36() {
		    return Companion_instance_35;
		  }
		  function $serializer_38() {
		    $serializer_instance_38 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationJoin', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.m1u_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_38).uf = function () {
		    return this.m1u_1;
		  };
		  protoOf($serializer_38).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_38).wf = function (decoder) {
		    var tmp0_desc = this.m1u_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return ConversationJoin_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_38).n1u = function (encoder, value) {
		    var tmp0_desc = this.m1u_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.o1u_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_38).vf = function (encoder, value) {
		    return this.n1u(encoder, value instanceof ConversationJoin ? value : THROW_CCE());
		  };
		  var $serializer_instance_38;
		  function $serializer_getInstance_38() {
		    if ($serializer_instance_38 == null)
		      new $serializer_38();
		    return $serializer_instance_38;
		  }
		  function ConversationJoin_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_38().m1u_1);
		    }
		    $this.o1u_1 = id;
		    return $this;
		  }
		  function ConversationJoin_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return ConversationJoin_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(ConversationJoin)));
		  }
		  function ConversationJoin(id) {
		    this.o1u_1 = id;
		  }
		  protoOf(ConversationJoin).toString = function () {
		    return 'ConversationJoin(id=' + this.o1u_1 + ')';
		  };
		  protoOf(ConversationJoin).hashCode = function () {
		    return getStringHashCode(this.o1u_1);
		  };
		  protoOf(ConversationJoin).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationJoin))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationJoin ? other : THROW_CCE();
		    if (!(this.o1u_1 === tmp0_other_with_cast.o1u_1))
		      return false;
		    return true;
		  };
		  function Companion_35() {
		  }
		  var Companion_instance_36;
		  function Companion_getInstance_37() {
		    return Companion_instance_36;
		  }
		  function $serializer_39() {
		    $serializer_instance_39 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationInviteRequest.ConversationInviteTo', this, 1);
		    tmp0_serialDesc.pq('type', true);
		    this.p1u_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_39).uf = function () {
		    return this.p1u_1;
		  };
		  protoOf($serializer_39).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_39).wf = function (decoder) {
		    var tmp0_desc = this.p1u_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return ConversationInviteTo_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_39).q1u = function (encoder, value) {
		    var tmp0_desc = this.p1u_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.r1u_1 === 'app')) {
		      tmp1_output.tk(tmp0_desc, 0, value.r1u_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_39).vf = function (encoder, value) {
		    return this.q1u(encoder, value instanceof ConversationInviteTo ? value : THROW_CCE());
		  };
		  var $serializer_instance_39;
		  function $serializer_getInstance_39() {
		    if ($serializer_instance_39 == null)
		      new $serializer_39();
		    return $serializer_instance_39;
		  }
		  function ConversationInviteTo_init_$Init$(seen1, type, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_39().p1u_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.r1u_1 = 'app';
		    else
		      $this.r1u_1 = type;
		    return $this;
		  }
		  function ConversationInviteTo_init_$Create$(seen1, type, serializationConstructorMarker) {
		    return ConversationInviteTo_init_$Init$(seen1, type, serializationConstructorMarker, objectCreate(protoOf(ConversationInviteTo)));
		  }
		  function Companion_36() {
		  }
		  var Companion_instance_37;
		  function Companion_getInstance_38() {
		    return Companion_instance_37;
		  }
		  function $serializer_40() {
		    $serializer_instance_40 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationInviteRequest.ConversationInviteFrom', this, 1);
		    tmp0_serialDesc.pq('type', true);
		    this.s1u_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_40).uf = function () {
		    return this.s1u_1;
		  };
		  protoOf($serializer_40).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_40).wf = function (decoder) {
		    var tmp0_desc = this.s1u_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return ConversationInviteFrom_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_40).t1u = function (encoder, value) {
		    var tmp0_desc = this.s1u_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.u1u_1 === 'app')) {
		      tmp1_output.tk(tmp0_desc, 0, value.u1u_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_40).vf = function (encoder, value) {
		    return this.t1u(encoder, value instanceof ConversationInviteFrom ? value : THROW_CCE());
		  };
		  var $serializer_instance_40;
		  function $serializer_getInstance_40() {
		    if ($serializer_instance_40 == null)
		      new $serializer_40();
		    return $serializer_instance_40;
		  }
		  function ConversationInviteFrom_init_$Init$(seen1, type, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_40().s1u_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.u1u_1 = 'app';
		    else
		      $this.u1u_1 = type;
		    return $this;
		  }
		  function ConversationInviteFrom_init_$Create$(seen1, type, serializationConstructorMarker) {
		    return ConversationInviteFrom_init_$Init$(seen1, type, serializationConstructorMarker, objectCreate(protoOf(ConversationInviteFrom)));
		  }
		  function Companion_37() {
		  }
		  var Companion_instance_38;
		  function Companion_getInstance_39() {
		    return Companion_instance_38;
		  }
		  function $serializer_41() {
		    $serializer_instance_41 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationInviteRequest.ConversationInviteChannel', this, 3);
		    tmp0_serialDesc.pq('type', true);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('to', false);
		    this.v1u_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_41).uf = function () {
		    return this.v1u_1;
		  };
		  protoOf($serializer_41).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_40(), $serializer_getInstance_39()];
		  };
		  protoOf($serializer_41).wf = function (decoder) {
		    var tmp0_desc = this.v1u_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_40(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_39(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_40(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_39(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return ConversationInviteChannel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_41).w1u = function (encoder, value) {
		    var tmp0_desc = this.v1u_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.x1u_1 === 'app')) {
		      tmp1_output.tk(tmp0_desc, 0, value.x1u_1);
		    }
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_40(), value.y1u_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_39(), value.z1u_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_41).vf = function (encoder, value) {
		    return this.w1u(encoder, value instanceof ConversationInviteChannel ? value : THROW_CCE());
		  };
		  var $serializer_instance_41;
		  function $serializer_getInstance_41() {
		    if ($serializer_instance_41 == null)
		      new $serializer_41();
		    return $serializer_instance_41;
		  }
		  function ConversationInviteChannel_init_$Init$(seen1, type, from, to, serializationConstructorMarker, $this) {
		    if (!(6 === (6 & seen1))) {
		      throwMissingFieldException(seen1, 6, $serializer_getInstance_41().v1u_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.x1u_1 = 'app';
		    else
		      $this.x1u_1 = type;
		    $this.y1u_1 = from;
		    $this.z1u_1 = to;
		    return $this;
		  }
		  function ConversationInviteChannel_init_$Create$(seen1, type, from, to, serializationConstructorMarker) {
		    return ConversationInviteChannel_init_$Init$(seen1, type, from, to, serializationConstructorMarker, objectCreate(protoOf(ConversationInviteChannel)));
		  }
		  function Companion_38() {
		  }
		  var Companion_instance_39;
		  function Companion_getInstance_40() {
		    return Companion_instance_39;
		  }
		  function $serializer_42() {
		    $serializer_instance_42 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationInviteRequest.ConversationInviteUser', this, 1);
		    tmp0_serialDesc.pq('name', false);
		    this.a1v_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_42).uf = function () {
		    return this.a1v_1;
		  };
		  protoOf($serializer_42).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_42).wf = function (decoder) {
		    var tmp0_desc = this.a1v_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return ConversationInviteUser_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_42).b1v = function (encoder, value) {
		    var tmp0_desc = this.a1v_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.c1v_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_42).vf = function (encoder, value) {
		    return this.b1v(encoder, value instanceof ConversationInviteUser ? value : THROW_CCE());
		  };
		  var $serializer_instance_42;
		  function $serializer_getInstance_42() {
		    if ($serializer_instance_42 == null)
		      new $serializer_42();
		    return $serializer_instance_42;
		  }
		  function ConversationInviteUser_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_42().a1v_1);
		    }
		    $this.c1v_1 = name;
		    return $this;
		  }
		  function ConversationInviteUser_init_$Create$(seen1, name, serializationConstructorMarker) {
		    return ConversationInviteUser_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(ConversationInviteUser)));
		  }
		  function Companion_39() {
		  }
		  var Companion_instance_40;
		  function Companion_getInstance_41() {
		    return Companion_instance_40;
		  }
		  function $serializer_43() {
		    $serializer_instance_43 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationInviteRequest.Body', this, 4);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('state', false);
		    tmp0_serialDesc.pq('user', false);
		    tmp0_serialDesc.pq('channel', false);
		    this.d1v_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_43).uf = function () {
		    return this.d1v_1;
		  };
		  protoOf($serializer_43).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_42(), $serializer_getInstance_41()];
		  };
		  protoOf($serializer_43).wf = function (decoder) {
		    var tmp0_desc = this.d1v_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.qj(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_41(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.qj(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_41(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return Body_init_$Create$_10(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_43).e1v = function (encoder, value) {
		    var tmp0_desc = this.d1v_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.f1v_1);
		    tmp1_output.tk(tmp0_desc, 1, value.g1v_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_42(), value.h1v_1);
		    tmp1_output.vk(tmp0_desc, 3, $serializer_getInstance_41(), value.i1v_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_43).vf = function (encoder, value) {
		    return this.e1v(encoder, value instanceof Body_10 ? value : THROW_CCE());
		  };
		  var $serializer_instance_43;
		  function $serializer_getInstance_43() {
		    if ($serializer_instance_43 == null)
		      new $serializer_43();
		    return $serializer_instance_43;
		  }
		  function Body_init_$Init$_10(seen1, originating_session, state, user, channel, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_43().d1v_1);
		    }
		    $this.f1v_1 = originating_session;
		    $this.g1v_1 = state;
		    $this.h1v_1 = user;
		    $this.i1v_1 = channel;
		    return $this;
		  }
		  function Body_init_$Create$_10(seen1, originating_session, state, user, channel, serializationConstructorMarker) {
		    return Body_init_$Init$_10(seen1, originating_session, state, user, channel, serializationConstructorMarker, objectCreate(protoOf(Body_10)));
		  }
		  function ConversationInviteTo(type) {
		    type = type === VOID ? 'app' : type;
		    this.r1u_1 = type;
		  }
		  protoOf(ConversationInviteTo).toString = function () {
		    return 'ConversationInviteTo(type=' + this.r1u_1 + ')';
		  };
		  protoOf(ConversationInviteTo).hashCode = function () {
		    return getStringHashCode(this.r1u_1);
		  };
		  protoOf(ConversationInviteTo).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationInviteTo))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationInviteTo ? other : THROW_CCE();
		    if (!(this.r1u_1 === tmp0_other_with_cast.r1u_1))
		      return false;
		    return true;
		  };
		  function ConversationInviteFrom(type) {
		    type = type === VOID ? 'app' : type;
		    this.u1u_1 = type;
		  }
		  protoOf(ConversationInviteFrom).toString = function () {
		    return 'ConversationInviteFrom(type=' + this.u1u_1 + ')';
		  };
		  protoOf(ConversationInviteFrom).hashCode = function () {
		    return getStringHashCode(this.u1u_1);
		  };
		  protoOf(ConversationInviteFrom).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationInviteFrom))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationInviteFrom ? other : THROW_CCE();
		    if (!(this.u1u_1 === tmp0_other_with_cast.u1u_1))
		      return false;
		    return true;
		  };
		  function ConversationInviteChannel(type, from, to) {
		    type = type === VOID ? 'app' : type;
		    this.x1u_1 = type;
		    this.y1u_1 = from;
		    this.z1u_1 = to;
		  }
		  protoOf(ConversationInviteChannel).toString = function () {
		    return 'ConversationInviteChannel(type=' + this.x1u_1 + ', from=' + this.y1u_1 + ', to=' + this.z1u_1 + ')';
		  };
		  protoOf(ConversationInviteChannel).hashCode = function () {
		    var result = getStringHashCode(this.x1u_1);
		    result = imul(result, 31) + this.y1u_1.hashCode() | 0;
		    result = imul(result, 31) + this.z1u_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(ConversationInviteChannel).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationInviteChannel))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationInviteChannel ? other : THROW_CCE();
		    if (!(this.x1u_1 === tmp0_other_with_cast.x1u_1))
		      return false;
		    if (!this.y1u_1.equals(tmp0_other_with_cast.y1u_1))
		      return false;
		    if (!this.z1u_1.equals(tmp0_other_with_cast.z1u_1))
		      return false;
		    return true;
		  };
		  function ConversationInviteUser(name) {
		    this.c1v_1 = name;
		  }
		  protoOf(ConversationInviteUser).toString = function () {
		    return 'ConversationInviteUser(name=' + this.c1v_1 + ')';
		  };
		  protoOf(ConversationInviteUser).hashCode = function () {
		    return getStringHashCode(this.c1v_1);
		  };
		  protoOf(ConversationInviteUser).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationInviteUser))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationInviteUser ? other : THROW_CCE();
		    if (!(this.c1v_1 === tmp0_other_with_cast.c1v_1))
		      return false;
		    return true;
		  };
		  function Body_10(originating_session, state, user, channel) {
		    this.f1v_1 = originating_session;
		    this.g1v_1 = state;
		    this.h1v_1 = user;
		    this.i1v_1 = channel;
		  }
		  function ConversationInviteRequest(cid, username) {
		    this.j1v_1 = cid;
		    this.k1v_1 = username;
		    this.l1v_1 = new ConversationMembers(this.j1v_1);
		    this.m1v_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(ConversationInviteRequest).u1h = function () {
		    return this.l1v_1;
		  };
		  protoOf(ConversationInviteRequest).v1h = function () {
		    return this.m1v_1;
		  };
		  protoOf(ConversationInviteRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_10(originatingSessionId, 'invited', new ConversationInviteUser(this.k1v_1), new ConversationInviteChannel('app', new ConversationInviteFrom(), new ConversationInviteTo()));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_10), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(ConversationInviteRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(ConversationInvite), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(ConversationInviteRequest).toString = function () {
		    return 'ConversationInviteRequest(cid=' + this.j1v_1 + ', username=' + this.k1v_1 + ')';
		  };
		  protoOf(ConversationInviteRequest).hashCode = function () {
		    var result = getStringHashCode(this.j1v_1);
		    result = imul(result, 31) + getStringHashCode(this.k1v_1) | 0;
		    return result;
		  };
		  protoOf(ConversationInviteRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationInviteRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationInviteRequest ? other : THROW_CCE();
		    if (!(this.j1v_1 === tmp0_other_with_cast.j1v_1))
		      return false;
		    if (!(this.k1v_1 === tmp0_other_with_cast.k1v_1))
		      return false;
		    return true;
		  };
		  function Companion_40() {
		  }
		  var Companion_instance_41;
		  function Companion_getInstance_42() {
		    return Companion_instance_41;
		  }
		  function $serializer_44() {
		    $serializer_instance_44 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.ConversationInvite', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.n1v_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_44).uf = function () {
		    return this.n1v_1;
		  };
		  protoOf($serializer_44).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_44).wf = function (decoder) {
		    var tmp0_desc = this.n1v_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return ConversationInvite_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_44).o1v = function (encoder, value) {
		    var tmp0_desc = this.n1v_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.p1v_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_44).vf = function (encoder, value) {
		    return this.o1v(encoder, value instanceof ConversationInvite ? value : THROW_CCE());
		  };
		  var $serializer_instance_44;
		  function $serializer_getInstance_44() {
		    if ($serializer_instance_44 == null)
		      new $serializer_44();
		    return $serializer_instance_44;
		  }
		  function ConversationInvite_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_44().n1v_1);
		    }
		    $this.p1v_1 = id;
		    return $this;
		  }
		  function ConversationInvite_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return ConversationInvite_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(ConversationInvite)));
		  }
		  function ConversationInvite(id) {
		    this.p1v_1 = id;
		  }
		  protoOf(ConversationInvite).toString = function () {
		    return 'ConversationInvite(id=' + this.p1v_1 + ')';
		  };
		  protoOf(ConversationInvite).hashCode = function () {
		    return getStringHashCode(this.p1v_1);
		  };
		  protoOf(ConversationInvite).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationInvite))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationInvite ? other : THROW_CCE();
		    if (!(this.p1v_1 === tmp0_other_with_cast.p1v_1))
		      return false;
		    return true;
		  };
		  function MemberLeft(cid, mid) {
		    this.q1v_1 = cid;
		    this.r1v_1 = mid;
		  }
		  function ConversationDeleteRequest(cid) {
		    this.s1v_1 = cid;
		    this.t1v_1 = new Conversation_1(this.s1v_1);
		    this.u1v_1 = HTTPMethod_DELETE_getInstance();
		  }
		  protoOf(ConversationDeleteRequest).u1h = function () {
		    return this.t1v_1;
		  };
		  protoOf(ConversationDeleteRequest).v1h = function () {
		    return this.u1v_1;
		  };
		  protoOf(ConversationDeleteRequest).w1h = function (encoder, originatingSessionId) {
		    return '';
		  };
		  protoOf(ConversationDeleteRequest).x1h = function (data, decoder) {
		    return new ConversationDelete(this.s1v_1);
		  };
		  protoOf(ConversationDeleteRequest).toString = function () {
		    return 'ConversationDeleteRequest(cid=' + this.s1v_1 + ')';
		  };
		  protoOf(ConversationDeleteRequest).hashCode = function () {
		    return getStringHashCode(this.s1v_1);
		  };
		  protoOf(ConversationDeleteRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationDeleteRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationDeleteRequest ? other : THROW_CCE();
		    if (!(this.s1v_1 === tmp0_other_with_cast.s1v_1))
		      return false;
		    return true;
		  };
		  function ConversationDelete(cid) {
		    this.v1v_1 = cid;
		  }
		  protoOf(ConversationDelete).toString = function () {
		    return 'ConversationDelete(cid=' + this.v1v_1 + ')';
		  };
		  protoOf(ConversationDelete).hashCode = function () {
		    return getStringHashCode(this.v1v_1);
		  };
		  protoOf(ConversationDelete).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationDelete))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationDelete ? other : THROW_CCE();
		    if (!(this.v1v_1 === tmp0_other_with_cast.v1v_1))
		      return false;
		    return true;
		  };
		  function GetUserConversationsRequest(uid, order, pageSize, cursor, includeCustomData, orderBy) {
		    order = order === VOID ? null : order;
		    pageSize = pageSize === VOID ? null : pageSize;
		    cursor = cursor === VOID ? null : cursor;
		    includeCustomData = includeCustomData === VOID ? null : includeCustomData;
		    orderBy = orderBy === VOID ? null : orderBy;
		    this.w1v_1 = uid;
		    this.x1v_1 = order;
		    this.y1v_1 = pageSize;
		    this.z1v_1 = cursor;
		    this.a1w_1 = includeCustomData;
		    this.b1w_1 = orderBy;
		    this.c1w_1 = new UserConversations(this.w1v_1);
		    this.d1w_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetUserConversationsRequest).u1h = function () {
		    return this.c1w_1;
		  };
		  protoOf(GetUserConversationsRequest).v1h = function () {
		    return this.d1w_1;
		  };
		  protoOf(GetUserConversationsRequest).y1h = function () {
		    var tmp0_safe_receiver = this.x1v_1;
		    var tmp = to('order', tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8_1);
		    var tmp1_safe_receiver = this.y1v_1;
		    var tmp_0 = to('page_size', tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString());
		    var tmp_1 = to('cursor', this.z1v_1);
		    var tmp2_safe_receiver = this.a1w_1;
		    var tmp_2;
		    if (tmp2_safe_receiver == null) {
		      tmp_2 = null;
		    } else {
		      // Inline function 'kotlin.takeIf' call
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp_3;
		      // Inline function 'com.vonage.clientcore.core.actions.GetUserConversationsRequest.queryParams.<anonymous>' call
		      if (tmp2_safe_receiver) {
		        tmp_3 = tmp2_safe_receiver;
		      } else {
		        tmp_3 = null;
		      }
		      tmp_2 = tmp_3;
		    }
		    var tmp3_safe_receiver = tmp_2;
		    var tmp_4 = to('include_custom_data', tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString());
		    var tmp4_safe_receiver = this.b1w_1;
		    return mapOf([tmp, tmp_0, tmp_1, tmp_4, to('order_by', tmp4_safe_receiver == null ? null : tmp4_safe_receiver.toString())]);
		  };
		  protoOf(GetUserConversationsRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetUserConversations), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetUserConversationsRequest).toString = function () {
		    return 'GetUserConversationsRequest(uid=' + this.w1v_1 + ', order=' + this.x1v_1 + ', pageSize=' + this.y1v_1 + ', cursor=' + this.z1v_1 + ', includeCustomData=' + this.a1w_1 + ', orderBy=' + this.b1w_1 + ')';
		  };
		  protoOf(GetUserConversationsRequest).hashCode = function () {
		    var result = getStringHashCode(this.w1v_1);
		    result = imul(result, 31) + (this.x1v_1 == null ? 0 : this.x1v_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.y1v_1 == null ? 0 : this.y1v_1) | 0;
		    result = imul(result, 31) + (this.z1v_1 == null ? 0 : getStringHashCode(this.z1v_1)) | 0;
		    result = imul(result, 31) + (this.a1w_1 == null ? 0 : getBooleanHashCode(this.a1w_1)) | 0;
		    result = imul(result, 31) + (this.b1w_1 == null ? 0 : this.b1w_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(GetUserConversationsRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetUserConversationsRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetUserConversationsRequest ? other : THROW_CCE();
		    if (!(this.w1v_1 === tmp0_other_with_cast.w1v_1))
		      return false;
		    if (!equals(this.x1v_1, tmp0_other_with_cast.x1v_1))
		      return false;
		    if (!(this.y1v_1 == tmp0_other_with_cast.y1v_1))
		      return false;
		    if (!(this.z1v_1 == tmp0_other_with_cast.z1v_1))
		      return false;
		    if (!(this.a1w_1 == tmp0_other_with_cast.a1w_1))
		      return false;
		    if (!equals(this.b1w_1, tmp0_other_with_cast.b1w_1))
		      return false;
		    return true;
		  };
		  function Companion_41() {
		    Companion_instance_42 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.e1w_1 = [new ArrayListSerializer($serializer_getInstance_5())];
		  }
		  var Companion_instance_42;
		  function Companion_getInstance_43() {
		    if (Companion_instance_42 == null)
		      new Companion_41();
		    return Companion_instance_42;
		  }
		  function $serializer_45() {
		    $serializer_instance_45 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetUserConversations.UserConversationsEmbedded', this, 1);
		    tmp0_serialDesc.pq('conversations', false);
		    this.f1w_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_45).uf = function () {
		    return this.f1w_1;
		  };
		  protoOf($serializer_45).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [Companion_getInstance_43().e1w_1[0]];
		  };
		  protoOf($serializer_45).wf = function (decoder) {
		    var tmp0_desc = this.f1w_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    var tmp6_cached = Companion_getInstance_43().e1w_1;
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return UserConversationsEmbedded_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_45).g1w = function (encoder, value) {
		    var tmp0_desc = this.f1w_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_43().e1w_1;
		    tmp1_output.vk(tmp0_desc, 0, tmp2_cached[0], value.h1w_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_45).vf = function (encoder, value) {
		    return this.g1w(encoder, value instanceof UserConversationsEmbedded ? value : THROW_CCE());
		  };
		  var $serializer_instance_45;
		  function $serializer_getInstance_45() {
		    if ($serializer_instance_45 == null)
		      new $serializer_45();
		    return $serializer_instance_45;
		  }
		  function UserConversationsEmbedded_init_$Init$(seen1, conversations, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_45().f1w_1);
		    }
		    $this.h1w_1 = conversations;
		    return $this;
		  }
		  function UserConversationsEmbedded_init_$Create$(seen1, conversations, serializationConstructorMarker) {
		    return UserConversationsEmbedded_init_$Init$(seen1, conversations, serializationConstructorMarker, objectCreate(protoOf(UserConversationsEmbedded)));
		  }
		  function UserConversationsEmbedded() {
		  }
		  protoOf(UserConversationsEmbedded).toString = function () {
		    return 'UserConversationsEmbedded(conversations=' + this.h1w_1 + ')';
		  };
		  protoOf(UserConversationsEmbedded).hashCode = function () {
		    return hashCode(this.h1w_1);
		  };
		  protoOf(UserConversationsEmbedded).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UserConversationsEmbedded))
		      return false;
		    var tmp0_other_with_cast = other instanceof UserConversationsEmbedded ? other : THROW_CCE();
		    if (!equals(this.h1w_1, tmp0_other_with_cast.h1w_1))
		      return false;
		    return true;
		  };
		  function Companion_42() {
		  }
		  var Companion_instance_43;
		  function Companion_getInstance_44() {
		    return Companion_instance_43;
		  }
		  function $serializer_46() {
		    $serializer_instance_46 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetUserConversations', this, 2);
		    tmp0_serialDesc.pq('_embedded', false);
		    tmp0_serialDesc.pq('_links', false);
		    this.i1w_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_46).uf = function () {
		    return this.i1w_1;
		  };
		  protoOf($serializer_46).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_45(), $serializer_getInstance_9()];
		  };
		  protoOf($serializer_46).wf = function (decoder) {
		    var tmp0_desc = this.i1w_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.qj(tmp0_desc, 0, $serializer_getInstance_45(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.qj(tmp0_desc, 0, $serializer_getInstance_45(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return GetUserConversations_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_46).j1w = function (encoder, value) {
		    var tmp0_desc = this.i1w_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_45(), value.k1w_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_9(), value.l1w_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_46).vf = function (encoder, value) {
		    return this.j1w(encoder, value instanceof GetUserConversations ? value : THROW_CCE());
		  };
		  var $serializer_instance_46;
		  function $serializer_getInstance_46() {
		    if ($serializer_instance_46 == null)
		      new $serializer_46();
		    return $serializer_instance_46;
		  }
		  function GetUserConversations_init_$Init$(seen1, _embedded, _links, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_46().i1w_1);
		    }
		    $this.k1w_1 = _embedded;
		    $this.l1w_1 = _links;
		    return $this;
		  }
		  function GetUserConversations_init_$Create$(seen1, _embedded, _links, serializationConstructorMarker) {
		    return GetUserConversations_init_$Init$(seen1, _embedded, _links, serializationConstructorMarker, objectCreate(protoOf(GetUserConversations)));
		  }
		  function GetUserConversations(_embedded, _links) {
		    this.k1w_1 = _embedded;
		    this.l1w_1 = _links;
		  }
		  function GetConversationEventsRequest(cid, order, pageSize, cursor, filterGroup, filterGroupVersion, eventType, excludeDeletedEvents, startId) {
		    order = order === VOID ? null : order;
		    pageSize = pageSize === VOID ? null : pageSize;
		    cursor = cursor === VOID ? null : cursor;
		    eventType = eventType === VOID ? null : eventType;
		    excludeDeletedEvents = excludeDeletedEvents === VOID ? true : excludeDeletedEvents;
		    startId = startId === VOID ? null : startId;
		    this.m1w_1 = cid;
		    this.n1w_1 = order;
		    this.o1w_1 = pageSize;
		    this.p1w_1 = cursor;
		    this.q1w_1 = filterGroup;
		    this.r1w_1 = filterGroupVersion;
		    this.s1w_1 = eventType;
		    this.t1w_1 = excludeDeletedEvents;
		    this.u1w_1 = startId;
		    this.v1w_1 = new ConversationEvents(this.m1w_1);
		    this.w1w_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetConversationEventsRequest).u1h = function () {
		    return this.v1w_1;
		  };
		  protoOf(GetConversationEventsRequest).v1h = function () {
		    return this.w1w_1;
		  };
		  protoOf(GetConversationEventsRequest).y1h = function () {
		    var tmp0_safe_receiver = this.n1w_1;
		    var tmp = to('order', tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8_1);
		    var tmp1_safe_receiver = this.o1w_1;
		    var tmp_0 = to('page_size', tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString());
		    var tmp_1 = to('cursor', this.p1w_1);
		    var tmp_2 = to('filter_group_type', this.q1w_1);
		    var tmp_3 = to('filter_group_version', this.r1w_1.toString());
		    var tmp_4 = to('event_type', this.s1w_1);
		    var tmp_5 = to('exclude_deleted_events', this.t1w_1.toString());
		    var tmp2_safe_receiver = this.u1w_1;
		    return mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('start_id', tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toString())]);
		  };
		  protoOf(GetConversationEventsRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetConversationEvents), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetConversationEventsRequest).toString = function () {
		    return 'GetConversationEventsRequest(cid=' + this.m1w_1 + ', order=' + this.n1w_1 + ', pageSize=' + this.o1w_1 + ', cursor=' + this.p1w_1 + ', filterGroup=' + this.q1w_1 + ', filterGroupVersion=' + this.r1w_1 + ', eventType=' + this.s1w_1 + ', excludeDeletedEvents=' + this.t1w_1 + ', startId=' + this.u1w_1 + ')';
		  };
		  protoOf(GetConversationEventsRequest).hashCode = function () {
		    var result = getStringHashCode(this.m1w_1);
		    result = imul(result, 31) + (this.n1w_1 == null ? 0 : this.n1w_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.o1w_1 == null ? 0 : this.o1w_1) | 0;
		    result = imul(result, 31) + (this.p1w_1 == null ? 0 : getStringHashCode(this.p1w_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.q1w_1) | 0;
		    result = imul(result, 31) + this.r1w_1 | 0;
		    result = imul(result, 31) + (this.s1w_1 == null ? 0 : getStringHashCode(this.s1w_1)) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.t1w_1) | 0;
		    result = imul(result, 31) + (this.u1w_1 == null ? 0 : this.u1w_1) | 0;
		    return result;
		  };
		  protoOf(GetConversationEventsRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetConversationEventsRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetConversationEventsRequest ? other : THROW_CCE();
		    if (!(this.m1w_1 === tmp0_other_with_cast.m1w_1))
		      return false;
		    if (!equals(this.n1w_1, tmp0_other_with_cast.n1w_1))
		      return false;
		    if (!(this.o1w_1 == tmp0_other_with_cast.o1w_1))
		      return false;
		    if (!(this.p1w_1 == tmp0_other_with_cast.p1w_1))
		      return false;
		    if (!(this.q1w_1 === tmp0_other_with_cast.q1w_1))
		      return false;
		    if (!(this.r1w_1 === tmp0_other_with_cast.r1w_1))
		      return false;
		    if (!(this.s1w_1 == tmp0_other_with_cast.s1w_1))
		      return false;
		    if (!(this.t1w_1 === tmp0_other_with_cast.t1w_1))
		      return false;
		    if (!(this.u1w_1 == tmp0_other_with_cast.u1w_1))
		      return false;
		    return true;
		  };
		  function Companion_43() {
		    Companion_instance_44 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.x1w_1 = [new ArrayListSerializer(CSConversationEventsSerializer_getInstance())];
		  }
		  var Companion_instance_44;
		  function Companion_getInstance_45() {
		    if (Companion_instance_44 == null)
		      new Companion_43();
		    return Companion_instance_44;
		  }
		  function $serializer_47() {
		    $serializer_instance_47 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetConversationEvents.ConversationEventsEmbedded', this, 1);
		    tmp0_serialDesc.pq('events', false);
		    this.y1w_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_47).uf = function () {
		    return this.y1w_1;
		  };
		  protoOf($serializer_47).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [Companion_getInstance_45().x1w_1[0]];
		  };
		  protoOf($serializer_47).wf = function (decoder) {
		    var tmp0_desc = this.y1w_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    var tmp6_cached = Companion_getInstance_45().x1w_1;
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return ConversationEventsEmbedded_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_47).z1w = function (encoder, value) {
		    var tmp0_desc = this.y1w_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_45().x1w_1;
		    tmp1_output.vk(tmp0_desc, 0, tmp2_cached[0], value.a1x_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_47).vf = function (encoder, value) {
		    return this.z1w(encoder, value instanceof ConversationEventsEmbedded ? value : THROW_CCE());
		  };
		  var $serializer_instance_47;
		  function $serializer_getInstance_47() {
		    if ($serializer_instance_47 == null)
		      new $serializer_47();
		    return $serializer_instance_47;
		  }
		  function ConversationEventsEmbedded_init_$Init$(seen1, events, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_47().y1w_1);
		    }
		    $this.a1x_1 = events;
		    return $this;
		  }
		  function ConversationEventsEmbedded_init_$Create$(seen1, events, serializationConstructorMarker) {
		    return ConversationEventsEmbedded_init_$Init$(seen1, events, serializationConstructorMarker, objectCreate(protoOf(ConversationEventsEmbedded)));
		  }
		  function ConversationEventsEmbedded() {
		  }
		  protoOf(ConversationEventsEmbedded).toString = function () {
		    return 'ConversationEventsEmbedded(events=' + this.a1x_1 + ')';
		  };
		  protoOf(ConversationEventsEmbedded).hashCode = function () {
		    return hashCode(this.a1x_1);
		  };
		  protoOf(ConversationEventsEmbedded).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationEventsEmbedded))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationEventsEmbedded ? other : THROW_CCE();
		    if (!equals(this.a1x_1, tmp0_other_with_cast.a1x_1))
		      return false;
		    return true;
		  };
		  function Companion_44() {
		  }
		  var Companion_instance_45;
		  function Companion_getInstance_46() {
		    return Companion_instance_45;
		  }
		  function $serializer_48() {
		    $serializer_instance_48 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetConversationEvents', this, 2);
		    tmp0_serialDesc.pq('_embedded', false);
		    tmp0_serialDesc.pq('_links', false);
		    this.b1x_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_48).uf = function () {
		    return this.b1x_1;
		  };
		  protoOf($serializer_48).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_47(), $serializer_getInstance_9()];
		  };
		  protoOf($serializer_48).wf = function (decoder) {
		    var tmp0_desc = this.b1x_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.qj(tmp0_desc, 0, $serializer_getInstance_47(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.qj(tmp0_desc, 0, $serializer_getInstance_47(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return GetConversationEvents_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_48).c1x = function (encoder, value) {
		    var tmp0_desc = this.b1x_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_47(), value.d1x_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_9(), value.e1x_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_48).vf = function (encoder, value) {
		    return this.c1x(encoder, value instanceof GetConversationEvents ? value : THROW_CCE());
		  };
		  var $serializer_instance_48;
		  function $serializer_getInstance_48() {
		    if ($serializer_instance_48 == null)
		      new $serializer_48();
		    return $serializer_instance_48;
		  }
		  function GetConversationEvents_init_$Init$(seen1, _embedded, _links, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_48().b1x_1);
		    }
		    $this.d1x_1 = _embedded;
		    $this.e1x_1 = _links;
		    return $this;
		  }
		  function GetConversationEvents_init_$Create$(seen1, _embedded, _links, serializationConstructorMarker) {
		    return GetConversationEvents_init_$Init$(seen1, _embedded, _links, serializationConstructorMarker, objectCreate(protoOf(GetConversationEvents)));
		  }
		  function GetConversationEvents(_embedded, _links) {
		    this.d1x_1 = _embedded;
		    this.e1x_1 = _links;
		  }
		  function GetConversationMembersRequest(cid, order, pageSize, cursor) {
		    order = order === VOID ? null : order;
		    pageSize = pageSize === VOID ? null : pageSize;
		    cursor = cursor === VOID ? null : cursor;
		    this.f1x_1 = cid;
		    this.g1x_1 = order;
		    this.h1x_1 = pageSize;
		    this.i1x_1 = cursor;
		    this.j1x_1 = new ConversationMembers(this.f1x_1);
		    this.k1x_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetConversationMembersRequest).u1h = function () {
		    return this.j1x_1;
		  };
		  protoOf(GetConversationMembersRequest).v1h = function () {
		    return this.k1x_1;
		  };
		  protoOf(GetConversationMembersRequest).y1h = function () {
		    var tmp0_safe_receiver = this.g1x_1;
		    var tmp = to('order', tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8_1);
		    var tmp1_safe_receiver = this.h1x_1;
		    return mapOf([tmp, to('page_size', tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString()), to('cursor', this.i1x_1)]);
		  };
		  protoOf(GetConversationMembersRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetConversationMembers), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetConversationMembersRequest).toString = function () {
		    return 'GetConversationMembersRequest(cid=' + this.f1x_1 + ', order=' + this.g1x_1 + ', pageSize=' + this.h1x_1 + ', cursor=' + this.i1x_1 + ')';
		  };
		  protoOf(GetConversationMembersRequest).hashCode = function () {
		    var result = getStringHashCode(this.f1x_1);
		    result = imul(result, 31) + (this.g1x_1 == null ? 0 : this.g1x_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.h1x_1 == null ? 0 : this.h1x_1) | 0;
		    result = imul(result, 31) + (this.i1x_1 == null ? 0 : getStringHashCode(this.i1x_1)) | 0;
		    return result;
		  };
		  protoOf(GetConversationMembersRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetConversationMembersRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetConversationMembersRequest ? other : THROW_CCE();
		    if (!(this.f1x_1 === tmp0_other_with_cast.f1x_1))
		      return false;
		    if (!equals(this.g1x_1, tmp0_other_with_cast.g1x_1))
		      return false;
		    if (!(this.h1x_1 == tmp0_other_with_cast.h1x_1))
		      return false;
		    if (!(this.i1x_1 == tmp0_other_with_cast.i1x_1))
		      return false;
		    return true;
		  };
		  function Companion_45() {
		    Companion_instance_46 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.l1x_1 = [new ArrayListSerializer($serializer_getInstance_27())];
		  }
		  var Companion_instance_46;
		  function Companion_getInstance_47() {
		    if (Companion_instance_46 == null)
		      new Companion_45();
		    return Companion_instance_46;
		  }
		  function $serializer_49() {
		    $serializer_instance_49 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetConversationMembers.ConversationMembersEmbedded', this, 1);
		    tmp0_serialDesc.pq('members', false);
		    this.m1x_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_49).uf = function () {
		    return this.m1x_1;
		  };
		  protoOf($serializer_49).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [Companion_getInstance_47().l1x_1[0]];
		  };
		  protoOf($serializer_49).wf = function (decoder) {
		    var tmp0_desc = this.m1x_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    var tmp6_cached = Companion_getInstance_47().l1x_1;
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return ConversationMembersEmbedded_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_49).n1x = function (encoder, value) {
		    var tmp0_desc = this.m1x_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_47().l1x_1;
		    tmp1_output.vk(tmp0_desc, 0, tmp2_cached[0], value.o1x_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_49).vf = function (encoder, value) {
		    return this.n1x(encoder, value instanceof ConversationMembersEmbedded ? value : THROW_CCE());
		  };
		  var $serializer_instance_49;
		  function $serializer_getInstance_49() {
		    if ($serializer_instance_49 == null)
		      new $serializer_49();
		    return $serializer_instance_49;
		  }
		  function ConversationMembersEmbedded_init_$Init$(seen1, members, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_49().m1x_1);
		    }
		    $this.o1x_1 = members;
		    return $this;
		  }
		  function ConversationMembersEmbedded_init_$Create$(seen1, members, serializationConstructorMarker) {
		    return ConversationMembersEmbedded_init_$Init$(seen1, members, serializationConstructorMarker, objectCreate(protoOf(ConversationMembersEmbedded)));
		  }
		  function ConversationMembersEmbedded() {
		  }
		  protoOf(ConversationMembersEmbedded).toString = function () {
		    return 'ConversationMembersEmbedded(members=' + this.o1x_1 + ')';
		  };
		  protoOf(ConversationMembersEmbedded).hashCode = function () {
		    return hashCode(this.o1x_1);
		  };
		  protoOf(ConversationMembersEmbedded).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationMembersEmbedded))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationMembersEmbedded ? other : THROW_CCE();
		    if (!equals(this.o1x_1, tmp0_other_with_cast.o1x_1))
		      return false;
		    return true;
		  };
		  function Companion_46() {
		  }
		  var Companion_instance_47;
		  function Companion_getInstance_48() {
		    return Companion_instance_47;
		  }
		  function $serializer_50() {
		    $serializer_instance_50 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetConversationMembers', this, 2);
		    tmp0_serialDesc.pq('_embedded', false);
		    tmp0_serialDesc.pq('_links', false);
		    this.p1x_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_50).uf = function () {
		    return this.p1x_1;
		  };
		  protoOf($serializer_50).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_49(), $serializer_getInstance_9()];
		  };
		  protoOf($serializer_50).wf = function (decoder) {
		    var tmp0_desc = this.p1x_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.qj(tmp0_desc, 0, $serializer_getInstance_49(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.qj(tmp0_desc, 0, $serializer_getInstance_49(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return GetConversationMembers_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_50).q1x = function (encoder, value) {
		    var tmp0_desc = this.p1x_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_49(), value.r1x_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_9(), value.s1x_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_50).vf = function (encoder, value) {
		    return this.q1x(encoder, value instanceof GetConversationMembers ? value : THROW_CCE());
		  };
		  var $serializer_instance_50;
		  function $serializer_getInstance_50() {
		    if ($serializer_instance_50 == null)
		      new $serializer_50();
		    return $serializer_instance_50;
		  }
		  function GetConversationMembers_init_$Init$(seen1, _embedded, _links, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_50().p1x_1);
		    }
		    $this.r1x_1 = _embedded;
		    $this.s1x_1 = _links;
		    return $this;
		  }
		  function GetConversationMembers_init_$Create$(seen1, _embedded, _links, serializationConstructorMarker) {
		    return GetConversationMembers_init_$Init$(seen1, _embedded, _links, serializationConstructorMarker, objectCreate(protoOf(GetConversationMembers)));
		  }
		  function GetConversationMembers(_embedded, _links) {
		    this.r1x_1 = _embedded;
		    this.s1x_1 = _links;
		  }
		  function GetConversationMemberRequest(cid, mid) {
		    this.t1x_1 = cid;
		    this.u1x_1 = mid;
		    this.v1x_1 = new ConversationMember(this.t1x_1, this.u1x_1);
		    this.w1x_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetConversationMemberRequest).u1h = function () {
		    return this.v1x_1;
		  };
		  protoOf(GetConversationMemberRequest).v1h = function () {
		    return this.w1x_1;
		  };
		  protoOf(GetConversationMemberRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetMember), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetConversationMemberRequest).toString = function () {
		    return 'GetConversationMemberRequest(cid=' + this.t1x_1 + ', mid=' + this.u1x_1 + ')';
		  };
		  protoOf(GetConversationMemberRequest).hashCode = function () {
		    var result = getStringHashCode(this.t1x_1);
		    result = imul(result, 31) + getStringHashCode(this.u1x_1) | 0;
		    return result;
		  };
		  protoOf(GetConversationMemberRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetConversationMemberRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetConversationMemberRequest ? other : THROW_CCE();
		    if (!(this.t1x_1 === tmp0_other_with_cast.t1x_1))
		      return false;
		    if (!(this.u1x_1 === tmp0_other_with_cast.u1x_1))
		      return false;
		    return true;
		  };
		  function Companion_47() {
		  }
		  var Companion_instance_48;
		  function Companion_getInstance_49() {
		    return Companion_instance_48;
		  }
		  function $serializer_51() {
		    $serializer_instance_51 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.GetUser', this, 7);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('display_name', true);
		    tmp0_serialDesc.pq('channels', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    tmp0_serialDesc.pq('image_url', true);
		    tmp0_serialDesc.pq('properties', true);
		    this.x1x_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_51).uf = function () {
		    return this.x1x_1;
		  };
		  protoOf($serializer_51).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_156()), get_nullable($serializer_getInstance_162()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_28())];
		  };
		  protoOf($serializer_51).wf = function (decoder) {
		    var tmp0_desc = this.x1x_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, $serializer_getInstance_156(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, $serializer_getInstance_162(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.sj(tmp0_desc, 6, $serializer_getInstance_28(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, $serializer_getInstance_156(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, $serializer_getInstance_162(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.sj(tmp0_desc, 6, $serializer_getInstance_28(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return GetUser_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_51).y1x = function (encoder, value) {
		    var tmp0_desc = this.x1x_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.z1x_1);
		    tmp1_output.tk(tmp0_desc, 1, value.a1y_1);
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.b1y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.b1y_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.c1y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, $serializer_getInstance_156(), value.c1y_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.d1y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, $serializer_getInstance_162(), value.d1y_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.e1y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, StringSerializer_getInstance(), value.e1y_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.f1y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, $serializer_getInstance_28(), value.f1y_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_51).vf = function (encoder, value) {
		    return this.y1x(encoder, value instanceof GetUser ? value : THROW_CCE());
		  };
		  var $serializer_instance_51;
		  function $serializer_getInstance_51() {
		    if ($serializer_instance_51 == null)
		      new $serializer_51();
		    return $serializer_instance_51;
		  }
		  function GetUser_init_$Init$(seen1, id, name, display_name, channels, timestamp, image_url, properties, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_51().x1x_1);
		    }
		    $this.z1x_1 = id;
		    $this.a1y_1 = name;
		    if (0 === (seen1 & 4))
		      $this.b1y_1 = null;
		    else
		      $this.b1y_1 = display_name;
		    if (0 === (seen1 & 8))
		      $this.c1y_1 = null;
		    else
		      $this.c1y_1 = channels;
		    if (0 === (seen1 & 16))
		      $this.d1y_1 = null;
		    else
		      $this.d1y_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.e1y_1 = null;
		    else
		      $this.e1y_1 = image_url;
		    if (0 === (seen1 & 64))
		      $this.f1y_1 = null;
		    else
		      $this.f1y_1 = properties;
		    return $this;
		  }
		  function GetUser_init_$Create$(seen1, id, name, display_name, channels, timestamp, image_url, properties, serializationConstructorMarker) {
		    return GetUser_init_$Init$(seen1, id, name, display_name, channels, timestamp, image_url, properties, serializationConstructorMarker, objectCreate(protoOf(GetUser)));
		  }
		  function GetUser(id, name, display_name, channels, timestamp, image_url, properties) {
		    display_name = display_name === VOID ? null : display_name;
		    channels = channels === VOID ? null : channels;
		    timestamp = timestamp === VOID ? null : timestamp;
		    image_url = image_url === VOID ? null : image_url;
		    properties = properties === VOID ? null : properties;
		    this.z1x_1 = id;
		    this.a1y_1 = name;
		    this.b1y_1 = display_name;
		    this.c1y_1 = channels;
		    this.d1y_1 = timestamp;
		    this.e1y_1 = image_url;
		    this.f1y_1 = properties;
		  }
		  protoOf(GetUser).g1y = function () {
		    var tmp0_safe_receiver = this.f1y_1;
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m1r_1;
		    var tmp;
		    if (tmp1_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.takeUnless' call
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp_0;
		      // Inline function 'com.vonage.clientcore.core.actions.GetUser.toUser.<anonymous>' call
		      if (!tmp1_safe_receiver.x()) {
		        tmp_0 = tmp1_safe_receiver;
		      } else {
		        tmp_0 = null;
		      }
		      tmp = tmp_0;
		    }
		    var tmp2_safe_receiver = tmp;
		    return new User(this.z1x_1, this.a1y_1, this.b1y_1, this.c1y_1, this.d1y_1, this.e1y_1, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toString());
		  };
		  function PostConversationEventRequestBody() {
		  }
		  function Companion_48() {
		  }
		  var Companion_instance_49;
		  function Companion_getInstance_50() {
		    return Companion_instance_49;
		  }
		  function $serializer_52() {
		    $serializer_instance_52 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PostConversationEvent', this, 1);
		    tmp0_serialDesc.pq('timestamp', false);
		    this.h1y_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_52).uf = function () {
		    return this.h1y_1;
		  };
		  protoOf($serializer_52).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_52).wf = function (decoder) {
		    var tmp0_desc = this.h1y_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return PostConversationEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_52).i1y = function (encoder, value) {
		    var tmp0_desc = this.h1y_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.j1y_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_52).vf = function (encoder, value) {
		    return this.i1y(encoder, value instanceof PostConversationEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_52;
		  function $serializer_getInstance_52() {
		    if ($serializer_instance_52 == null)
		      new $serializer_52();
		    return $serializer_instance_52;
		  }
		  function PostConversationEvent_init_$Init$(seen1, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_52().h1y_1);
		    }
		    $this.j1y_1 = timestamp;
		    return $this;
		  }
		  function PostConversationEvent_init_$Create$(seen1, timestamp, serializationConstructorMarker) {
		    return PostConversationEvent_init_$Init$(seen1, timestamp, serializationConstructorMarker, objectCreate(protoOf(PostConversationEvent)));
		  }
		  function PostConversationEvent(timestamp) {
		    this.j1y_1 = timestamp;
		  }
		  protoOf(PostConversationEvent).toString = function () {
		    return 'PostConversationEvent(timestamp=' + this.j1y_1 + ')';
		  };
		  protoOf(PostConversationEvent).hashCode = function () {
		    return getStringHashCode(this.j1y_1);
		  };
		  protoOf(PostConversationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PostConversationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof PostConversationEvent ? other : THROW_CCE();
		    if (!(this.j1y_1 === tmp0_other_with_cast.j1y_1))
		      return false;
		    return true;
		  };
		  function DeleteConversationEventRequest(eventId, cid, mid) {
		    this.k1y_1 = eventId;
		    this.l1y_1 = cid;
		    this.m1y_1 = mid;
		    this.n1y_1 = new ConversationEvent(this.l1y_1, this.k1y_1.toString());
		    this.o1y_1 = HTTPMethod_DELETE_getInstance();
		  }
		  protoOf(DeleteConversationEventRequest).u1h = function () {
		    return this.n1y_1;
		  };
		  protoOf(DeleteConversationEventRequest).v1h = function () {
		    return this.o1y_1;
		  };
		  protoOf(DeleteConversationEventRequest).y1h = function () {
		    return mapOf_0(to('from', this.m1y_1));
		  };
		  protoOf(DeleteConversationEventRequest).x1h = function (data, decoder) {
		    return new DeleteConversationEvent();
		  };
		  protoOf(DeleteConversationEventRequest).toString = function () {
		    return 'DeleteConversationEventRequest(eventId=' + this.k1y_1 + ', cid=' + this.l1y_1 + ', mid=' + this.m1y_1 + ')';
		  };
		  protoOf(DeleteConversationEventRequest).hashCode = function () {
		    var result = this.k1y_1;
		    result = imul(result, 31) + getStringHashCode(this.l1y_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.m1y_1) | 0;
		    return result;
		  };
		  protoOf(DeleteConversationEventRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof DeleteConversationEventRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof DeleteConversationEventRequest ? other : THROW_CCE();
		    if (!(this.k1y_1 === tmp0_other_with_cast.k1y_1))
		      return false;
		    if (!(this.l1y_1 === tmp0_other_with_cast.l1y_1))
		      return false;
		    if (!(this.m1y_1 === tmp0_other_with_cast.m1y_1))
		      return false;
		    return true;
		  };
		  function Companion_49() {
		  }
		  var Companion_instance_50;
		  function Companion_getInstance_51() {
		    return Companion_instance_50;
		  }
		  function $serializer_53() {
		    $serializer_instance_53 = this;
		    this.p1y_1 = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.DeleteConversationEvent', this, 0);
		  }
		  protoOf($serializer_53).uf = function () {
		    return this.p1y_1;
		  };
		  protoOf($serializer_53).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [];
		  };
		  protoOf($serializer_53).wf = function (decoder) {
		    var tmp0_desc = this.p1y_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp4_input = decoder.ej(tmp0_desc);
		    if (!tmp4_input.uj())
		      while (tmp1_flag) {
		        tmp2_index = tmp4_input.vj(tmp0_desc);
		        if (tmp2_index === -1)
		          tmp1_flag = false;
		        else
		          throw UnknownFieldException_init_$Create$(tmp2_index);
		      }
		    tmp4_input.fj(tmp0_desc);
		    return DeleteConversationEvent_init_$Create$(0, null);
		  };
		  protoOf($serializer_53).q1y = function (encoder, value) {
		    var tmp0_desc = this.p1y_1;
		    encoder.ej(tmp0_desc).fj(tmp0_desc);
		  };
		  protoOf($serializer_53).vf = function (encoder, value) {
		    return this.q1y(encoder, value instanceof DeleteConversationEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_53;
		  function $serializer_getInstance_53() {
		    if ($serializer_instance_53 == null)
		      new $serializer_53();
		    return $serializer_instance_53;
		  }
		  function DeleteConversationEvent_init_$Init$(seen1, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_53().p1y_1);
		    }
		    return $this;
		  }
		  function DeleteConversationEvent_init_$Create$(seen1, serializationConstructorMarker) {
		    return DeleteConversationEvent_init_$Init$(seen1, serializationConstructorMarker, objectCreate(protoOf(DeleteConversationEvent)));
		  }
		  function DeleteConversationEvent() {
		  }
		  function Companion_50() {
		  }
		  var Companion_instance_51;
		  function Companion_getInstance_52() {
		    return Companion_instance_51;
		  }
		  function $serializer_54() {
		    $serializer_instance_54 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.Embedded', this, 2);
		    tmp0_serialDesc.pq('from_member', true);
		    tmp0_serialDesc.pq('from_user', true);
		    this.r1y_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_54).uf = function () {
		    return this.r1y_1;
		  };
		  protoOf($serializer_54).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable($serializer_getInstance_56()), get_nullable($serializer_getInstance_55())];
		  };
		  protoOf($serializer_54).wf = function (decoder) {
		    var tmp0_desc = this.r1y_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, $serializer_getInstance_56(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, $serializer_getInstance_55(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, $serializer_getInstance_56(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, $serializer_getInstance_55(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return Embedded_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_54).s1y = function (encoder, value) {
		    var tmp0_desc = this.r1y_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.t1y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, $serializer_getInstance_56(), value.t1y_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.u1y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, $serializer_getInstance_55(), value.u1y_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_54).vf = function (encoder, value) {
		    return this.s1y(encoder, value instanceof Embedded ? value : THROW_CCE());
		  };
		  var $serializer_instance_54;
		  function $serializer_getInstance_54() {
		    if ($serializer_instance_54 == null)
		      new $serializer_54();
		    return $serializer_instance_54;
		  }
		  function Embedded_init_$Init$(seen1, from_member, from_user, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_54().r1y_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.t1y_1 = null;
		    else
		      $this.t1y_1 = from_member;
		    if (0 === (seen1 & 2))
		      $this.u1y_1 = null;
		    else
		      $this.u1y_1 = from_user;
		    return $this;
		  }
		  function Embedded_init_$Create$(seen1, from_member, from_user, serializationConstructorMarker) {
		    return Embedded_init_$Init$(seen1, from_member, from_user, serializationConstructorMarker, objectCreate(protoOf(Embedded)));
		  }
		  function Embedded(from_member, from_user) {
		    from_member = from_member === VOID ? null : from_member;
		    from_user = from_user === VOID ? null : from_user;
		    this.t1y_1 = from_member;
		    this.u1y_1 = from_user;
		  }
		  protoOf(Embedded).toString = function () {
		    return 'Embedded(from_member=' + this.t1y_1 + ', from_user=' + this.u1y_1 + ')';
		  };
		  protoOf(Embedded).hashCode = function () {
		    var result = this.t1y_1 == null ? 0 : hashCode(this.t1y_1);
		    result = imul(result, 31) + (this.u1y_1 == null ? 0 : hashCode(this.u1y_1)) | 0;
		    return result;
		  };
		  protoOf(Embedded).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Embedded))
		      return false;
		    var tmp0_other_with_cast = other instanceof Embedded ? other : THROW_CCE();
		    if (!equals(this.t1y_1, tmp0_other_with_cast.t1y_1))
		      return false;
		    if (!equals(this.u1y_1, tmp0_other_with_cast.u1y_1))
		      return false;
		    return true;
		  };
		  function $serializer_55() {
		    $serializer_instance_55 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.FromUser', this, 5);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('display_name', true);
		    tmp0_serialDesc.pq('image_url', true);
		    tmp0_serialDesc.pq('custom_data', true);
		    this.v1y_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_55).uf = function () {
		    return this.v1y_1;
		  };
		  protoOf($serializer_55).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(JsonObjectSerializer_getInstance())];
		  };
		  protoOf($serializer_55).wf = function (decoder) {
		    var tmp0_desc = this.v1y_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.sj(tmp0_desc, 4, JsonObjectSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.sj(tmp0_desc, 4, JsonObjectSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return FromUser_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_55).w1y = function (encoder, value) {
		    var tmp0_desc = this.v1y_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.x1y_1);
		    tmp1_output.tk(tmp0_desc, 1, value.y1y_1);
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.z1y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.z1y_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.a1z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.a1z_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.b1z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, JsonObjectSerializer_getInstance(), value.b1z_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_55).vf = function (encoder, value) {
		    return this.w1y(encoder, value instanceof FromUser ? value : THROW_CCE());
		  };
		  var $serializer_instance_55;
		  function $serializer_getInstance_55() {
		    if ($serializer_instance_55 == null)
		      new $serializer_55();
		    return $serializer_instance_55;
		  }
		  function FromUser_init_$Init$(seen1, id, name, display_name, image_url, custom_data, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_55().v1y_1);
		    }
		    $this.x1y_1 = id;
		    $this.y1y_1 = name;
		    if (0 === (seen1 & 4))
		      $this.z1y_1 = null;
		    else
		      $this.z1y_1 = display_name;
		    if (0 === (seen1 & 8))
		      $this.a1z_1 = null;
		    else
		      $this.a1z_1 = image_url;
		    if (0 === (seen1 & 16))
		      $this.b1z_1 = null;
		    else
		      $this.b1z_1 = custom_data;
		    return $this;
		  }
		  function FromUser_init_$Create$(seen1, id, name, display_name, image_url, custom_data, serializationConstructorMarker) {
		    return FromUser_init_$Init$(seen1, id, name, display_name, image_url, custom_data, serializationConstructorMarker, objectCreate(protoOf(FromUser)));
		  }
		  function FromUser() {
		  }
		  protoOf(FromUser).g1y = function () {
		    var tmp0_safe_receiver = this.b1z_1;
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.takeUnless' call
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp_0;
		      // Inline function 'com.vonage.clientcore.core.actions.FromUser.toUser.<anonymous>' call
		      if (!tmp0_safe_receiver.x()) {
		        tmp_0 = tmp0_safe_receiver;
		      } else {
		        tmp_0 = null;
		      }
		      tmp = tmp_0;
		    }
		    var tmp1_safe_receiver = tmp;
		    return new User(this.x1y_1, this.y1y_1, this.z1y_1, VOID, VOID, this.a1z_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString());
		  };
		  function $serializer_56() {
		    $serializer_instance_56 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.FromMember', this, 3);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('name', true);
		    tmp0_serialDesc.pq('display_name', true);
		    this.c1z_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_56).uf = function () {
		    return this.c1z_1;
		  };
		  protoOf($serializer_56).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_56).wf = function (decoder) {
		    var tmp0_desc = this.c1z_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return FromMember_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_56).d1z = function (encoder, value) {
		    var tmp0_desc = this.c1z_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.e1z_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.f1z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.f1z_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.g1z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.g1z_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_56).vf = function (encoder, value) {
		    return this.d1z(encoder, value instanceof FromMember ? value : THROW_CCE());
		  };
		  var $serializer_instance_56;
		  function $serializer_getInstance_56() {
		    if ($serializer_instance_56 == null)
		      new $serializer_56();
		    return $serializer_instance_56;
		  }
		  function FromMember_init_$Init$(seen1, id, name, display_name, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_56().c1z_1);
		    }
		    $this.e1z_1 = id;
		    if (0 === (seen1 & 2))
		      $this.f1z_1 = null;
		    else
		      $this.f1z_1 = name;
		    if (0 === (seen1 & 4))
		      $this.g1z_1 = null;
		    else
		      $this.g1z_1 = display_name;
		    return $this;
		  }
		  function FromMember_init_$Create$(seen1, id, name, display_name, serializationConstructorMarker) {
		    return FromMember_init_$Init$(seen1, id, name, display_name, serializationConstructorMarker, objectCreate(protoOf(FromMember)));
		  }
		  function FromMember() {
		  }
		  function OptionSerializer(valueSerializer) {
		    this.h1z_1 = valueSerializer;
		    this.i1z_1 = this.h1z_1.uf();
		  }
		  protoOf(OptionSerializer).uf = function () {
		    return this.i1z_1;
		  };
		  protoOf(OptionSerializer).j1z = function (encoder, value) {
		    if (value instanceof Some) {
		      encoder.wk(this.h1z_1, value.k1z_1);
		    }
		  };
		  protoOf(OptionSerializer).vf = function (encoder, value) {
		    return this.j1z(encoder, value instanceof Option ? value : THROW_CCE());
		  };
		  protoOf(OptionSerializer).wf = function (decoder) {
		    return new Some(decoder.dj(this.h1z_1));
		  };
		  function GetUserRequest(userIdOrName) {
		    this.l1z_1 = userIdOrName;
		    this.m1z_1 = new User_0(this.l1z_1);
		    this.n1z_1 = HTTPMethod_GET_getInstance();
		  }
		  protoOf(GetUserRequest).u1h = function () {
		    return this.m1z_1;
		  };
		  protoOf(GetUserRequest).v1h = function () {
		    return this.n1z_1;
		  };
		  protoOf(GetUserRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(GetUser), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(GetUserRequest).toString = function () {
		    return 'GetUserRequest(userIdOrName=' + this.l1z_1 + ')';
		  };
		  protoOf(GetUserRequest).hashCode = function () {
		    return getStringHashCode(this.l1z_1);
		  };
		  protoOf(GetUserRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetUserRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetUserRequest ? other : THROW_CCE();
		    if (!(this.l1z_1 === tmp0_other_with_cast.l1z_1))
		      return false;
		    return true;
		  };
		  function Companion_51() {
		    this.o1z_1 = '"|\'|<|>|&|\\|/';
		    this.p1z_1 = '"|\'|<|>|\\|javascript:';
		  }
		  var Companion_instance_52;
		  function Companion_getInstance_53() {
		    return Companion_instance_52;
		  }
		  function ApiRequest() {
		  }
		  function Companion_52() {
		  }
		  var Companion_instance_53;
		  function Companion_getInstance_54() {
		    return Companion_instance_53;
		  }
		  function $serializer_57() {
		    $serializer_instance_57 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCStatsReportRequest.RTCUpdateStatsReport', this, 15);
		    tmp0_serialDesc.pq('audioRecvPackets', false);
		    tmp0_serialDesc.pq('audioRecvPacketsLost', false);
		    tmp0_serialDesc.pq('audioRecvBytes', false);
		    tmp0_serialDesc.pq('audioRecvJitter', false);
		    tmp0_serialDesc.pq('audioSentPackets', false);
		    tmp0_serialDesc.pq('audioSentBytes', false);
		    tmp0_serialDesc.pq('audioSentPacketsLost', false);
		    tmp0_serialDesc.pq('audioRtt', false);
		    tmp0_serialDesc.pq('audioSentJitter', false);
		    tmp0_serialDesc.pq('networkMos', false);
		    tmp0_serialDesc.pq('legId', false);
		    tmp0_serialDesc.pq('apiKey', false);
		    tmp0_serialDesc.pq('applicationId', false);
		    tmp0_serialDesc.pq('conversationId', false);
		    tmp0_serialDesc.pq('conversationName', false);
		    this.q1z_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_57).uf = function () {
		    return this.q1z_1;
		  };
		  protoOf($serializer_57).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [LongSerializer_getInstance(), IntSerializer_getInstance(), LongSerializer_getInstance(), DoubleSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), IntSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_57).wf = function (decoder) {
		    var tmp0_desc = this.q1z_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = new Long(0, 0);
		    var tmp5_local1 = 0;
		    var tmp6_local2 = new Long(0, 0);
		    var tmp7_local3 = 0.0;
		    var tmp8_local4 = new Long(0, 0);
		    var tmp9_local5 = new Long(0, 0);
		    var tmp10_local6 = 0;
		    var tmp11_local7 = 0.0;
		    var tmp12_local8 = 0.0;
		    var tmp13_local9 = 0.0;
		    var tmp14_local10 = null;
		    var tmp15_local11 = null;
		    var tmp16_local12 = null;
		    var tmp17_local13 = null;
		    var tmp18_local14 = null;
		    var tmp19_input = decoder.ej(tmp0_desc);
		    if (tmp19_input.uj()) {
		      tmp4_local0 = tmp19_input.kj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp19_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp19_input.kj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp19_input.mj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp19_input.kj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp19_input.kj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp19_input.jj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp19_input.mj(tmp0_desc, 7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		      tmp12_local8 = tmp19_input.mj(tmp0_desc, 8);
		      tmp3_bitMask0 = tmp3_bitMask0 | 256;
		      tmp13_local9 = tmp19_input.mj(tmp0_desc, 9);
		      tmp3_bitMask0 = tmp3_bitMask0 | 512;
		      tmp14_local10 = tmp19_input.oj(tmp0_desc, 10);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
		      tmp15_local11 = tmp19_input.oj(tmp0_desc, 11);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
		      tmp16_local12 = tmp19_input.oj(tmp0_desc, 12);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
		      tmp17_local13 = tmp19_input.oj(tmp0_desc, 13);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
		      tmp18_local14 = tmp19_input.oj(tmp0_desc, 14);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp19_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp19_input.kj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp19_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp19_input.kj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp19_input.mj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp19_input.kj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp19_input.kj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp19_input.jj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp19_input.mj(tmp0_desc, 7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          case 8:
		            tmp12_local8 = tmp19_input.mj(tmp0_desc, 8);
		            tmp3_bitMask0 = tmp3_bitMask0 | 256;
		            break;
		          case 9:
		            tmp13_local9 = tmp19_input.mj(tmp0_desc, 9);
		            tmp3_bitMask0 = tmp3_bitMask0 | 512;
		            break;
		          case 10:
		            tmp14_local10 = tmp19_input.oj(tmp0_desc, 10);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
		            break;
		          case 11:
		            tmp15_local11 = tmp19_input.oj(tmp0_desc, 11);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
		            break;
		          case 12:
		            tmp16_local12 = tmp19_input.oj(tmp0_desc, 12);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
		            break;
		          case 13:
		            tmp17_local13 = tmp19_input.oj(tmp0_desc, 13);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
		            break;
		          case 14:
		            tmp18_local14 = tmp19_input.oj(tmp0_desc, 14);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp19_input.fj(tmp0_desc);
		    return RTCUpdateStatsReport_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
		  };
		  protoOf($serializer_57).r1z = function (encoder, value) {
		    var tmp0_desc = this.q1z_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.pk(tmp0_desc, 0, value.s1z_1);
		    tmp1_output.ok(tmp0_desc, 1, value.t1z_1);
		    tmp1_output.pk(tmp0_desc, 2, value.u1z_1);
		    tmp1_output.rk(tmp0_desc, 3, value.v1z_1);
		    tmp1_output.pk(tmp0_desc, 4, value.w1z_1);
		    tmp1_output.pk(tmp0_desc, 5, value.x1z_1);
		    tmp1_output.ok(tmp0_desc, 6, value.y1z_1);
		    tmp1_output.rk(tmp0_desc, 7, value.z1z_1);
		    tmp1_output.rk(tmp0_desc, 8, value.a20_1);
		    tmp1_output.rk(tmp0_desc, 9, value.b20_1);
		    tmp1_output.tk(tmp0_desc, 10, value.c20_1);
		    tmp1_output.tk(tmp0_desc, 11, value.d20_1);
		    tmp1_output.tk(tmp0_desc, 12, value.e20_1);
		    tmp1_output.tk(tmp0_desc, 13, value.f20_1);
		    tmp1_output.tk(tmp0_desc, 14, value.g20_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_57).vf = function (encoder, value) {
		    return this.r1z(encoder, value instanceof RTCUpdateStatsReport ? value : THROW_CCE());
		  };
		  var $serializer_instance_57;
		  function $serializer_getInstance_57() {
		    if ($serializer_instance_57 == null)
		      new $serializer_57();
		    return $serializer_instance_57;
		  }
		  function RTCUpdateStatsReport_init_$Init$(seen1, audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter, networkMos, legId, apiKey, applicationId, conversationId, conversationName, serializationConstructorMarker, $this) {
		    if (!(32767 === (32767 & seen1))) {
		      throwMissingFieldException(seen1, 32767, $serializer_getInstance_57().q1z_1);
		    }
		    $this.s1z_1 = audioRecvPackets;
		    $this.t1z_1 = audioRecvPacketsLost;
		    $this.u1z_1 = audioRecvBytes;
		    $this.v1z_1 = audioRecvJitter;
		    $this.w1z_1 = audioSentPackets;
		    $this.x1z_1 = audioSentBytes;
		    $this.y1z_1 = audioSentPacketsLost;
		    $this.z1z_1 = audioRtt;
		    $this.a20_1 = audioSentJitter;
		    $this.b20_1 = networkMos;
		    $this.c20_1 = legId;
		    $this.d20_1 = apiKey;
		    $this.e20_1 = applicationId;
		    $this.f20_1 = conversationId;
		    $this.g20_1 = conversationName;
		    return $this;
		  }
		  function RTCUpdateStatsReport_init_$Create$(seen1, audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter, networkMos, legId, apiKey, applicationId, conversationId, conversationName, serializationConstructorMarker) {
		    return RTCUpdateStatsReport_init_$Init$(seen1, audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter, networkMos, legId, apiKey, applicationId, conversationId, conversationName, serializationConstructorMarker, objectCreate(protoOf(RTCUpdateStatsReport)));
		  }
		  function RTCUpdateStatsReport(audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter, networkMos, legId, apiKey, applicationId, conversationId, conversationName) {
		    this.s1z_1 = audioRecvPackets;
		    this.t1z_1 = audioRecvPacketsLost;
		    this.u1z_1 = audioRecvBytes;
		    this.v1z_1 = audioRecvJitter;
		    this.w1z_1 = audioSentPackets;
		    this.x1z_1 = audioSentBytes;
		    this.y1z_1 = audioSentPacketsLost;
		    this.z1z_1 = audioRtt;
		    this.a20_1 = audioSentJitter;
		    this.b20_1 = networkMos;
		    this.c20_1 = legId;
		    this.d20_1 = apiKey;
		    this.e20_1 = applicationId;
		    this.f20_1 = conversationId;
		    this.g20_1 = conversationName;
		  }
		  protoOf(RTCUpdateStatsReport).toString = function () {
		    return 'RTCUpdateStatsReport(audioRecvPackets=' + this.s1z_1.toString() + ', audioRecvPacketsLost=' + this.t1z_1 + ', audioRecvBytes=' + this.u1z_1.toString() + ', audioRecvJitter=' + this.v1z_1 + ', audioSentPackets=' + this.w1z_1.toString() + ', audioSentBytes=' + this.x1z_1.toString() + ', audioSentPacketsLost=' + this.y1z_1 + ', audioRtt=' + this.z1z_1 + ', audioSentJitter=' + this.a20_1 + ', networkMos=' + this.b20_1 + ', legId=' + this.c20_1 + ', apiKey=' + this.d20_1 + ', applicationId=' + this.e20_1 + ', conversationId=' + this.f20_1 + ', conversationName=' + this.g20_1 + ')';
		  };
		  protoOf(RTCUpdateStatsReport).hashCode = function () {
		    var result = this.s1z_1.hashCode();
		    result = imul(result, 31) + this.t1z_1 | 0;
		    result = imul(result, 31) + this.u1z_1.hashCode() | 0;
		    result = imul(result, 31) + getNumberHashCode(this.v1z_1) | 0;
		    result = imul(result, 31) + this.w1z_1.hashCode() | 0;
		    result = imul(result, 31) + this.x1z_1.hashCode() | 0;
		    result = imul(result, 31) + this.y1z_1 | 0;
		    result = imul(result, 31) + getNumberHashCode(this.z1z_1) | 0;
		    result = imul(result, 31) + getNumberHashCode(this.a20_1) | 0;
		    result = imul(result, 31) + getNumberHashCode(this.b20_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.c20_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.d20_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.e20_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f20_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.g20_1) | 0;
		    return result;
		  };
		  protoOf(RTCUpdateStatsReport).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCUpdateStatsReport))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCUpdateStatsReport ? other : THROW_CCE();
		    if (!this.s1z_1.equals(tmp0_other_with_cast.s1z_1))
		      return false;
		    if (!(this.t1z_1 === tmp0_other_with_cast.t1z_1))
		      return false;
		    if (!this.u1z_1.equals(tmp0_other_with_cast.u1z_1))
		      return false;
		    if (!equals(this.v1z_1, tmp0_other_with_cast.v1z_1))
		      return false;
		    if (!this.w1z_1.equals(tmp0_other_with_cast.w1z_1))
		      return false;
		    if (!this.x1z_1.equals(tmp0_other_with_cast.x1z_1))
		      return false;
		    if (!(this.y1z_1 === tmp0_other_with_cast.y1z_1))
		      return false;
		    if (!equals(this.z1z_1, tmp0_other_with_cast.z1z_1))
		      return false;
		    if (!equals(this.a20_1, tmp0_other_with_cast.a20_1))
		      return false;
		    if (!equals(this.b20_1, tmp0_other_with_cast.b20_1))
		      return false;
		    if (!(this.c20_1 === tmp0_other_with_cast.c20_1))
		      return false;
		    if (!(this.d20_1 === tmp0_other_with_cast.d20_1))
		      return false;
		    if (!(this.e20_1 === tmp0_other_with_cast.e20_1))
		      return false;
		    if (!(this.f20_1 === tmp0_other_with_cast.f20_1))
		      return false;
		    if (!(this.g20_1 === tmp0_other_with_cast.g20_1))
		      return false;
		    return true;
		  };
		  function RTCStatsReportRequest(statsReport) {
		    this.h20_1 = statsReport;
		    this.i20_1 = RTCStats_getInstance();
		    this.j20_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(RTCStatsReportRequest).u1h = function () {
		    return this.i20_1;
		  };
		  protoOf(RTCStatsReportRequest).v1h = function () {
		    return this.j20_1;
		  };
		  protoOf(RTCStatsReportRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = this.h20_1;
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(RTCUpdateStatsReport), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(RTCStatsReportRequest).x1h = function (data, decoder) {
		    return new RTCStatsReportResponse();
		  };
		  function ApiResponse() {
		  }
		  function Companion_53() {
		  }
		  var Companion_instance_54;
		  function Companion_getInstance_55() {
		    return Companion_instance_54;
		  }
		  function $serializer_58() {
		    $serializer_instance_58 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PostLegRequest.PostLegBody', this, 1);
		    tmp0_serialDesc.pq('offer', false);
		    this.k20_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_58).uf = function () {
		    return this.k20_1;
		  };
		  protoOf($serializer_58).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_59()];
		  };
		  protoOf($serializer_58).wf = function (decoder) {
		    var tmp0_desc = this.k20_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_59(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_59(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return PostLegBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_58).l20 = function (encoder, value) {
		    var tmp0_desc = this.k20_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_59(), value.m20_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_58).vf = function (encoder, value) {
		    return this.l20(encoder, value instanceof PostLegBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_58;
		  function $serializer_getInstance_58() {
		    if ($serializer_instance_58 == null)
		      new $serializer_58();
		    return $serializer_instance_58;
		  }
		  function PostLegBody_init_$Init$(seen1, offer, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_58().k20_1);
		    }
		    $this.m20_1 = offer;
		    return $this;
		  }
		  function PostLegBody_init_$Create$(seen1, offer, serializationConstructorMarker) {
		    return PostLegBody_init_$Init$(seen1, offer, serializationConstructorMarker, objectCreate(protoOf(PostLegBody)));
		  }
		  function Companion_54() {
		  }
		  var Companion_instance_55;
		  function Companion_getInstance_56() {
		    return Companion_instance_55;
		  }
		  function $serializer_59() {
		    $serializer_instance_59 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PostLegRequest.PostLegOffer', this, 2);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('sdp', false);
		    this.n20_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_59).uf = function () {
		    return this.n20_1;
		  };
		  protoOf($serializer_59).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_59).wf = function (decoder) {
		    var tmp0_desc = this.n20_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return PostLegOffer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_59).o20 = function (encoder, value) {
		    var tmp0_desc = this.n20_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.p20_1);
		    tmp1_output.tk(tmp0_desc, 1, value.q20_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_59).vf = function (encoder, value) {
		    return this.o20(encoder, value instanceof PostLegOffer ? value : THROW_CCE());
		  };
		  var $serializer_instance_59;
		  function $serializer_getInstance_59() {
		    if ($serializer_instance_59 == null)
		      new $serializer_59();
		    return $serializer_instance_59;
		  }
		  function PostLegOffer_init_$Init$(seen1, type, sdp, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_59().n20_1);
		    }
		    $this.p20_1 = type;
		    $this.q20_1 = sdp;
		    return $this;
		  }
		  function PostLegOffer_init_$Create$(seen1, type, sdp, serializationConstructorMarker) {
		    return PostLegOffer_init_$Init$(seen1, type, sdp, serializationConstructorMarker, objectCreate(protoOf(PostLegOffer)));
		  }
		  function Companion_55() {
		  }
		  var Companion_instance_56;
		  function Companion_getInstance_57() {
		    return Companion_instance_56;
		  }
		  function $serializer_60() {
		    $serializer_instance_60 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PostLegRequest.Body', this, 2);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('body', false);
		    this.r20_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_60).uf = function () {
		    return this.r20_1;
		  };
		  protoOf($serializer_60).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_58()];
		  };
		  protoOf($serializer_60).wf = function (decoder) {
		    var tmp0_desc = this.r20_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_58(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_58(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return Body_init_$Create$_11(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_60).s20 = function (encoder, value) {
		    var tmp0_desc = this.r20_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.t20_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_58(), value.u20_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_60).vf = function (encoder, value) {
		    return this.s20(encoder, value instanceof Body_11 ? value : THROW_CCE());
		  };
		  var $serializer_instance_60;
		  function $serializer_getInstance_60() {
		    if ($serializer_instance_60 == null)
		      new $serializer_60();
		    return $serializer_instance_60;
		  }
		  function Body_init_$Init$_11(seen1, originating_session, body, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_60().r20_1);
		    }
		    $this.t20_1 = originating_session;
		    $this.u20_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_11(seen1, originating_session, body, serializationConstructorMarker) {
		    return Body_init_$Init$_11(seen1, originating_session, body, serializationConstructorMarker, objectCreate(protoOf(Body_11)));
		  }
		  function PostLegBody(offer) {
		    this.m20_1 = offer;
		  }
		  protoOf(PostLegBody).toString = function () {
		    return 'PostLegBody(offer=' + this.m20_1 + ')';
		  };
		  protoOf(PostLegBody).hashCode = function () {
		    return this.m20_1.hashCode();
		  };
		  protoOf(PostLegBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PostLegBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof PostLegBody ? other : THROW_CCE();
		    if (!this.m20_1.equals(tmp0_other_with_cast.m20_1))
		      return false;
		    return true;
		  };
		  function PostLegOffer(type, sdp) {
		    this.p20_1 = type;
		    this.q20_1 = sdp;
		  }
		  protoOf(PostLegOffer).toString = function () {
		    return 'PostLegOffer(type=' + this.p20_1 + ', sdp=' + this.q20_1 + ')';
		  };
		  protoOf(PostLegOffer).hashCode = function () {
		    var result = getStringHashCode(this.p20_1);
		    result = imul(result, 31) + getStringHashCode(this.q20_1) | 0;
		    return result;
		  };
		  protoOf(PostLegOffer).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PostLegOffer))
		      return false;
		    var tmp0_other_with_cast = other instanceof PostLegOffer ? other : THROW_CCE();
		    if (!(this.p20_1 === tmp0_other_with_cast.p20_1))
		      return false;
		    if (!(this.q20_1 === tmp0_other_with_cast.q20_1))
		      return false;
		    return true;
		  };
		  function Body_11(originating_session, body) {
		    this.t20_1 = originating_session;
		    this.u20_1 = body;
		  }
		  function PostLegRequest(sdp) {
		    this.v20_1 = sdp;
		    this.w20_1 = new Legs();
		    this.x20_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(PostLegRequest).u1h = function () {
		    return this.w20_1;
		  };
		  protoOf(PostLegRequest).v1h = function () {
		    return this.x20_1;
		  };
		  protoOf(PostLegRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_11(originatingSessionId, new PostLegBody(new PostLegOffer('offer', this.v20_1)));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_11), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(PostLegRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(PostLeg), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(PostLegRequest).toString = function () {
		    return 'PostLegRequest(sdp=' + this.v20_1 + ')';
		  };
		  protoOf(PostLegRequest).hashCode = function () {
		    return getStringHashCode(this.v20_1);
		  };
		  protoOf(PostLegRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PostLegRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof PostLegRequest ? other : THROW_CCE();
		    if (!(this.v20_1 === tmp0_other_with_cast.v20_1))
		      return false;
		    return true;
		  };
		  function Companion_56() {
		  }
		  var Companion_instance_57;
		  function Companion_getInstance_58() {
		    return Companion_instance_57;
		  }
		  function $serializer_61() {
		    $serializer_instance_61 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PostLeg', this, 2);
		    tmp0_serialDesc.pq('rtc_id', false);
		    tmp0_serialDesc.pq('sdp', false);
		    this.y20_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_61).uf = function () {
		    return this.y20_1;
		  };
		  protoOf($serializer_61).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_61).wf = function (decoder) {
		    var tmp0_desc = this.y20_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return PostLeg_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_61).z20 = function (encoder, value) {
		    var tmp0_desc = this.y20_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.a21_1);
		    tmp1_output.tk(tmp0_desc, 1, value.b21_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_61).vf = function (encoder, value) {
		    return this.z20(encoder, value instanceof PostLeg ? value : THROW_CCE());
		  };
		  var $serializer_instance_61;
		  function $serializer_getInstance_61() {
		    if ($serializer_instance_61 == null)
		      new $serializer_61();
		    return $serializer_instance_61;
		  }
		  function PostLeg_init_$Init$(seen1, rtc_id, sdp, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_61().y20_1);
		    }
		    $this.a21_1 = rtc_id;
		    $this.b21_1 = sdp;
		    return $this;
		  }
		  function PostLeg_init_$Create$(seen1, rtc_id, sdp, serializationConstructorMarker) {
		    return PostLeg_init_$Init$(seen1, rtc_id, sdp, serializationConstructorMarker, objectCreate(protoOf(PostLeg)));
		  }
		  function PostLeg(rtc_id, sdp) {
		    this.a21_1 = rtc_id;
		    this.b21_1 = sdp;
		  }
		  protoOf(PostLeg).toString = function () {
		    return 'PostLeg(rtc_id=' + this.a21_1 + ', sdp=' + this.b21_1 + ')';
		  };
		  protoOf(PostLeg).hashCode = function () {
		    var result = getStringHashCode(this.a21_1);
		    result = imul(result, 31) + getStringHashCode(this.b21_1) | 0;
		    return result;
		  };
		  protoOf(PostLeg).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PostLeg))
		      return false;
		    var tmp0_other_with_cast = other instanceof PostLeg ? other : THROW_CCE();
		    if (!(this.a21_1 === tmp0_other_with_cast.a21_1))
		      return false;
		    if (!(this.b21_1 === tmp0_other_with_cast.b21_1))
		      return false;
		    return true;
		  };
		  function Companion_57() {
		  }
		  var Companion_instance_58;
		  function Companion_getInstance_59() {
		    return Companion_instance_58;
		  }
		  function $serializer_62() {
		    $serializer_instance_62 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCAnswerRequest.RtcAnswerBody', this, 1);
		    tmp0_serialDesc.pq('answer', false);
		    this.c21_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_62).uf = function () {
		    return this.c21_1;
		  };
		  protoOf($serializer_62).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_62).wf = function (decoder) {
		    var tmp0_desc = this.c21_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return RtcAnswerBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_62).d21 = function (encoder, value) {
		    var tmp0_desc = this.c21_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.e21_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_62).vf = function (encoder, value) {
		    return this.d21(encoder, value instanceof RtcAnswerBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_62;
		  function $serializer_getInstance_62() {
		    if ($serializer_instance_62 == null)
		      new $serializer_62();
		    return $serializer_instance_62;
		  }
		  function RtcAnswerBody_init_$Init$(seen1, answer, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_62().c21_1);
		    }
		    $this.e21_1 = answer;
		    return $this;
		  }
		  function RtcAnswerBody_init_$Create$(seen1, answer, serializationConstructorMarker) {
		    return RtcAnswerBody_init_$Init$(seen1, answer, serializationConstructorMarker, objectCreate(protoOf(RtcAnswerBody)));
		  }
		  function Companion_58() {
		  }
		  var Companion_instance_59;
		  function Companion_getInstance_60() {
		    return Companion_instance_59;
		  }
		  function $serializer_63() {
		    $serializer_instance_63 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCAnswerRequest.Body', this, 3);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('body', false);
		    this.f21_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_63).uf = function () {
		    return this.f21_1;
		  };
		  protoOf($serializer_63).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_62()];
		  };
		  protoOf($serializer_63).wf = function (decoder) {
		    var tmp0_desc = this.f21_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_62(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_62(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return Body_init_$Create$_12(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_63).g21 = function (encoder, value) {
		    var tmp0_desc = this.f21_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.h21_1);
		    tmp1_output.tk(tmp0_desc, 1, value.i21_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_62(), value.j21_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_63).vf = function (encoder, value) {
		    return this.g21(encoder, value instanceof Body_12 ? value : THROW_CCE());
		  };
		  var $serializer_instance_63;
		  function $serializer_getInstance_63() {
		    if ($serializer_instance_63 == null)
		      new $serializer_63();
		    return $serializer_instance_63;
		  }
		  function Body_init_$Init$_12(seen1, originating_session, from, body, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_63().f21_1);
		    }
		    $this.h21_1 = originating_session;
		    $this.i21_1 = from;
		    $this.j21_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_12(seen1, originating_session, from, body, serializationConstructorMarker) {
		    return Body_init_$Init$_12(seen1, originating_session, from, body, serializationConstructorMarker, objectCreate(protoOf(Body_12)));
		  }
		  function RtcAnswerBody(answer) {
		    this.e21_1 = answer;
		  }
		  protoOf(RtcAnswerBody).toString = function () {
		    return 'RtcAnswerBody(answer=' + this.e21_1 + ')';
		  };
		  protoOf(RtcAnswerBody).hashCode = function () {
		    return getStringHashCode(this.e21_1);
		  };
		  protoOf(RtcAnswerBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RtcAnswerBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof RtcAnswerBody ? other : THROW_CCE();
		    if (!(this.e21_1 === tmp0_other_with_cast.e21_1))
		      return false;
		    return true;
		  };
		  function Body_12(originating_session, from, body) {
		    this.h21_1 = originating_session;
		    this.i21_1 = from;
		    this.j21_1 = body;
		  }
		  function RTCAnswerRequest(cid, mid, rtc_id, sdp) {
		    this.k21_1 = cid;
		    this.l21_1 = mid;
		    this.m21_1 = rtc_id;
		    this.n21_1 = sdp;
		    this.o21_1 = new RTCAnswer_0(this.k21_1, this.m21_1);
		    this.p21_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(RTCAnswerRequest).u1h = function () {
		    return this.o21_1;
		  };
		  protoOf(RTCAnswerRequest).v1h = function () {
		    return this.p21_1;
		  };
		  protoOf(RTCAnswerRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_12(originatingSessionId, this.l21_1, new RtcAnswerBody(this.n21_1));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_12), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(RTCAnswerRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(RTCAnswerResponse), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(RTCAnswerRequest).toString = function () {
		    return 'RTCAnswerRequest(cid=' + this.k21_1 + ', mid=' + this.l21_1 + ', rtc_id=' + this.m21_1 + ', sdp=' + this.n21_1 + ')';
		  };
		  protoOf(RTCAnswerRequest).hashCode = function () {
		    var result = getStringHashCode(this.k21_1);
		    result = imul(result, 31) + getStringHashCode(this.l21_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.m21_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.n21_1) | 0;
		    return result;
		  };
		  protoOf(RTCAnswerRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCAnswerRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCAnswerRequest ? other : THROW_CCE();
		    if (!(this.k21_1 === tmp0_other_with_cast.k21_1))
		      return false;
		    if (!(this.l21_1 === tmp0_other_with_cast.l21_1))
		      return false;
		    if (!(this.m21_1 === tmp0_other_with_cast.m21_1))
		      return false;
		    if (!(this.n21_1 === tmp0_other_with_cast.n21_1))
		      return false;
		    return true;
		  };
		  function Companion_59() {
		  }
		  var Companion_instance_60;
		  function Companion_getInstance_61() {
		    return Companion_instance_60;
		  }
		  function $serializer_64() {
		    $serializer_instance_64 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCReconnectRequest.RtcReconnectBody', this, 1);
		    tmp0_serialDesc.pq('offer', false);
		    this.q21_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_64).uf = function () {
		    return this.q21_1;
		  };
		  protoOf($serializer_64).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_65()];
		  };
		  protoOf($serializer_64).wf = function (decoder) {
		    var tmp0_desc = this.q21_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_65(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_65(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return RtcReconnectBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_64).r21 = function (encoder, value) {
		    var tmp0_desc = this.q21_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_65(), value.s21_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_64).vf = function (encoder, value) {
		    return this.r21(encoder, value instanceof RtcReconnectBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_64;
		  function $serializer_getInstance_64() {
		    if ($serializer_instance_64 == null)
		      new $serializer_64();
		    return $serializer_instance_64;
		  }
		  function RtcReconnectBody_init_$Init$(seen1, offer, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_64().q21_1);
		    }
		    $this.s21_1 = offer;
		    return $this;
		  }
		  function RtcReconnectBody_init_$Create$(seen1, offer, serializationConstructorMarker) {
		    return RtcReconnectBody_init_$Init$(seen1, offer, serializationConstructorMarker, objectCreate(protoOf(RtcReconnectBody)));
		  }
		  function Companion_60() {
		  }
		  var Companion_instance_61;
		  function Companion_getInstance_62() {
		    return Companion_instance_61;
		  }
		  function $serializer_65() {
		    $serializer_instance_65 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCReconnectRequest.RtcReconnectOffer', this, 1);
		    tmp0_serialDesc.pq('sdp', false);
		    this.t21_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_65).uf = function () {
		    return this.t21_1;
		  };
		  protoOf($serializer_65).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_65).wf = function (decoder) {
		    var tmp0_desc = this.t21_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return RtcReconnectOffer_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_65).u21 = function (encoder, value) {
		    var tmp0_desc = this.t21_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.v21_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_65).vf = function (encoder, value) {
		    return this.u21(encoder, value instanceof RtcReconnectOffer ? value : THROW_CCE());
		  };
		  var $serializer_instance_65;
		  function $serializer_getInstance_65() {
		    if ($serializer_instance_65 == null)
		      new $serializer_65();
		    return $serializer_instance_65;
		  }
		  function RtcReconnectOffer_init_$Init$(seen1, sdp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_65().t21_1);
		    }
		    $this.v21_1 = sdp;
		    return $this;
		  }
		  function RtcReconnectOffer_init_$Create$(seen1, sdp, serializationConstructorMarker) {
		    return RtcReconnectOffer_init_$Init$(seen1, sdp, serializationConstructorMarker, objectCreate(protoOf(RtcReconnectOffer)));
		  }
		  function Companion_61() {
		  }
		  var Companion_instance_62;
		  function Companion_getInstance_63() {
		    return Companion_instance_62;
		  }
		  function $serializer_66() {
		    $serializer_instance_66 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCReconnectRequest.Body', this, 3);
		    tmp0_serialDesc.pq('originating_session', false);
		    tmp0_serialDesc.pq('from', false);
		    tmp0_serialDesc.pq('body', false);
		    this.w21_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_66).uf = function () {
		    return this.w21_1;
		  };
		  protoOf($serializer_66).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_64()];
		  };
		  protoOf($serializer_66).wf = function (decoder) {
		    var tmp0_desc = this.w21_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_64(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_64(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return Body_init_$Create$_13(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_66).x21 = function (encoder, value) {
		    var tmp0_desc = this.w21_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.y21_1);
		    tmp1_output.tk(tmp0_desc, 1, value.z21_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_64(), value.a22_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_66).vf = function (encoder, value) {
		    return this.x21(encoder, value instanceof Body_13 ? value : THROW_CCE());
		  };
		  var $serializer_instance_66;
		  function $serializer_getInstance_66() {
		    if ($serializer_instance_66 == null)
		      new $serializer_66();
		    return $serializer_instance_66;
		  }
		  function Body_init_$Init$_13(seen1, originating_session, from, body, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_66().w21_1);
		    }
		    $this.y21_1 = originating_session;
		    $this.z21_1 = from;
		    $this.a22_1 = body;
		    return $this;
		  }
		  function Body_init_$Create$_13(seen1, originating_session, from, body, serializationConstructorMarker) {
		    return Body_init_$Init$_13(seen1, originating_session, from, body, serializationConstructorMarker, objectCreate(protoOf(Body_13)));
		  }
		  function RtcReconnectBody(offer) {
		    this.s21_1 = offer;
		  }
		  protoOf(RtcReconnectBody).toString = function () {
		    return 'RtcReconnectBody(offer=' + this.s21_1 + ')';
		  };
		  protoOf(RtcReconnectBody).hashCode = function () {
		    return this.s21_1.hashCode();
		  };
		  protoOf(RtcReconnectBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RtcReconnectBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof RtcReconnectBody ? other : THROW_CCE();
		    if (!this.s21_1.equals(tmp0_other_with_cast.s21_1))
		      return false;
		    return true;
		  };
		  function RtcReconnectOffer(sdp) {
		    this.v21_1 = sdp;
		  }
		  protoOf(RtcReconnectOffer).toString = function () {
		    return 'RtcReconnectOffer(sdp=' + this.v21_1 + ')';
		  };
		  protoOf(RtcReconnectOffer).hashCode = function () {
		    return getStringHashCode(this.v21_1);
		  };
		  protoOf(RtcReconnectOffer).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RtcReconnectOffer))
		      return false;
		    var tmp0_other_with_cast = other instanceof RtcReconnectOffer ? other : THROW_CCE();
		    if (!(this.v21_1 === tmp0_other_with_cast.v21_1))
		      return false;
		    return true;
		  };
		  function Body_13(originating_session, from, body) {
		    this.y21_1 = originating_session;
		    this.z21_1 = from;
		    this.a22_1 = body;
		  }
		  function RTCReconnectRequest(cid, mid, sdp, reconnectRtcId) {
		    this.b22_1 = cid;
		    this.c22_1 = mid;
		    this.d22_1 = sdp;
		    this.e22_1 = reconnectRtcId;
		    this.f22_1 = new RtcReconnect(this.b22_1, this.e22_1);
		    this.g22_1 = HTTPMethod_POST_getInstance();
		  }
		  protoOf(RTCReconnectRequest).u1h = function () {
		    return this.f22_1;
		  };
		  protoOf(RTCReconnectRequest).v1h = function () {
		    return this.g22_1;
		  };
		  protoOf(RTCReconnectRequest).w1h = function (encoder, originatingSessionId) {
		    // Inline function 'kotlinx.serialization.encodeToString' call
		    var value = new Body_13(originatingSessionId, this.c22_1, new RtcReconnectBody(new RtcReconnectOffer(this.d22_1)));
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = encoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(Body_13), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return encoder.a11(tmp$ret$1, value);
		  };
		  protoOf(RTCReconnectRequest).x1h = function (data, decoder) {
		    // Inline function 'kotlinx.serialization.decodeFromString' call
		    // Inline function 'kotlinx.serialization.serializer' call
		    var this_0 = decoder.tj();
		    // Inline function 'kotlinx.serialization.internal.cast' call
		    var this_1 = serializer(this_0, createKType(getKClass(RTCReconnect), arrayOf([]), false));
		    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
		    return decoder.b11(tmp$ret$1, data);
		  };
		  protoOf(RTCReconnectRequest).toString = function () {
		    return 'RTCReconnectRequest(cid=' + this.b22_1 + ', mid=' + this.c22_1 + ', sdp=' + this.d22_1 + ', reconnectRtcId=' + this.e22_1 + ')';
		  };
		  protoOf(RTCReconnectRequest).hashCode = function () {
		    var result = getStringHashCode(this.b22_1);
		    result = imul(result, 31) + getStringHashCode(this.c22_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.d22_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.e22_1) | 0;
		    return result;
		  };
		  protoOf(RTCReconnectRequest).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCReconnectRequest))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCReconnectRequest ? other : THROW_CCE();
		    if (!(this.b22_1 === tmp0_other_with_cast.b22_1))
		      return false;
		    if (!(this.c22_1 === tmp0_other_with_cast.c22_1))
		      return false;
		    if (!(this.d22_1 === tmp0_other_with_cast.d22_1))
		      return false;
		    if (!(this.e22_1 === tmp0_other_with_cast.e22_1))
		      return false;
		    return true;
		  };
		  function Companion_62() {
		  }
		  var Companion_instance_63;
		  function Companion_getInstance_64() {
		    return Companion_instance_63;
		  }
		  function $serializer_67() {
		    $serializer_instance_67 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AppKnocking', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.h22_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_67).uf = function () {
		    return this.h22_1;
		  };
		  protoOf($serializer_67).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_67).wf = function (decoder) {
		    var tmp0_desc = this.h22_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return AppKnocking_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_67).i22 = function (encoder, value) {
		    var tmp0_desc = this.h22_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.j22_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_67).vf = function (encoder, value) {
		    return this.i22(encoder, value instanceof AppKnocking ? value : THROW_CCE());
		  };
		  var $serializer_instance_67;
		  function $serializer_getInstance_67() {
		    if ($serializer_instance_67 == null)
		      new $serializer_67();
		    return $serializer_instance_67;
		  }
		  function AppKnocking_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_67().h22_1);
		    }
		    $this.j22_1 = id;
		    return $this;
		  }
		  function AppKnocking_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return AppKnocking_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(AppKnocking)));
		  }
		  function AppKnocking(id) {
		    this.j22_1 = id;
		  }
		  function Companion_63() {
		  }
		  var Companion_instance_64;
		  function Companion_getInstance_65() {
		    return Companion_instance_64;
		  }
		  function $serializer_68() {
		    $serializer_instance_68 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCReconnect', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.k22_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_68).uf = function () {
		    return this.k22_1;
		  };
		  protoOf($serializer_68).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_68).wf = function (decoder) {
		    var tmp0_desc = this.k22_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return RTCReconnect_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_68).l22 = function (encoder, value) {
		    var tmp0_desc = this.k22_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.m22_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_68).vf = function (encoder, value) {
		    return this.l22(encoder, value instanceof RTCReconnect ? value : THROW_CCE());
		  };
		  var $serializer_instance_68;
		  function $serializer_getInstance_68() {
		    if ($serializer_instance_68 == null)
		      new $serializer_68();
		    return $serializer_instance_68;
		  }
		  function RTCReconnect_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_68().k22_1);
		    }
		    $this.m22_1 = id;
		    return $this;
		  }
		  function RTCReconnect_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return RTCReconnect_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(RTCReconnect)));
		  }
		  function RTCReconnect(id) {
		    this.m22_1 = id;
		  }
		  protoOf(RTCReconnect).toString = function () {
		    return 'RTCReconnect(id=' + this.m22_1 + ')';
		  };
		  protoOf(RTCReconnect).hashCode = function () {
		    return getStringHashCode(this.m22_1);
		  };
		  protoOf(RTCReconnect).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCReconnect))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCReconnect ? other : THROW_CCE();
		    if (!(this.m22_1 === tmp0_other_with_cast.m22_1))
		      return false;
		    return true;
		  };
		  function DeletedKnocker(id) {
		    this.n22_1 = id;
		  }
		  function Companion_64() {
		  }
		  var Companion_instance_65;
		  function Companion_getInstance_66() {
		    return Companion_instance_65;
		  }
		  function $serializer_69() {
		    $serializer_instance_69 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.UpdateSession', this, 1);
		    tmp0_serialDesc.pq('session_id', false);
		    this.o22_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_69).uf = function () {
		    return this.o22_1;
		  };
		  protoOf($serializer_69).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_69).wf = function (decoder) {
		    var tmp0_desc = this.o22_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return UpdateSession_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_69).p22 = function (encoder, value) {
		    var tmp0_desc = this.o22_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.q22_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_69).vf = function (encoder, value) {
		    return this.p22(encoder, value instanceof UpdateSession ? value : THROW_CCE());
		  };
		  var $serializer_instance_69;
		  function $serializer_getInstance_69() {
		    if ($serializer_instance_69 == null)
		      new $serializer_69();
		    return $serializer_instance_69;
		  }
		  function UpdateSession_init_$Init$(seen1, session_id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_69().o22_1);
		    }
		    $this.q22_1 = session_id;
		    return $this;
		  }
		  function UpdateSession_init_$Create$(seen1, session_id, serializationConstructorMarker) {
		    return UpdateSession_init_$Init$(seen1, session_id, serializationConstructorMarker, objectCreate(protoOf(UpdateSession)));
		  }
		  function UpdateSession(session_id) {
		    this.q22_1 = session_id;
		  }
		  protoOf(UpdateSession).toString = function () {
		    return 'UpdateSession(session_id=' + this.q22_1 + ')';
		  };
		  protoOf(UpdateSession).hashCode = function () {
		    return getStringHashCode(this.q22_1);
		  };
		  protoOf(UpdateSession).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UpdateSession))
		      return false;
		    var tmp0_other_with_cast = other instanceof UpdateSession ? other : THROW_CCE();
		    if (!(this.q22_1 === tmp0_other_with_cast.q22_1))
		      return false;
		    return true;
		  };
		  function Companion_65() {
		  }
		  var Companion_instance_66;
		  function Companion_getInstance_67() {
		    return Companion_instance_66;
		  }
		  function $serializer_70() {
		    $serializer_instance_70 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberJoin', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.r22_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_70).uf = function () {
		    return this.r22_1;
		  };
		  protoOf($serializer_70).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_70).wf = function (decoder) {
		    var tmp0_desc = this.r22_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return MemberJoin_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_70).s22 = function (encoder, value) {
		    var tmp0_desc = this.r22_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.t22_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_70).vf = function (encoder, value) {
		    return this.s22(encoder, value instanceof MemberJoin ? value : THROW_CCE());
		  };
		  var $serializer_instance_70;
		  function $serializer_getInstance_70() {
		    if ($serializer_instance_70 == null)
		      new $serializer_70();
		    return $serializer_instance_70;
		  }
		  function MemberJoin_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_70().r22_1);
		    }
		    $this.t22_1 = id;
		    return $this;
		  }
		  function MemberJoin_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return MemberJoin_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(MemberJoin)));
		  }
		  function MemberJoin(id) {
		    this.t22_1 = id;
		  }
		  protoOf(MemberJoin).toString = function () {
		    return 'MemberJoin(id=' + this.t22_1 + ')';
		  };
		  protoOf(MemberJoin).hashCode = function () {
		    return getStringHashCode(this.t22_1);
		  };
		  protoOf(MemberJoin).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberJoin))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberJoin ? other : THROW_CCE();
		    if (!(this.t22_1 === tmp0_other_with_cast.t22_1))
		      return false;
		    return true;
		  };
		  function Companion_66() {
		  }
		  var Companion_instance_67;
		  function Companion_getInstance_68() {
		    return Companion_instance_67;
		  }
		  function $serializer_71() {
		    $serializer_instance_71 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegMute', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.u22_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_71).uf = function () {
		    return this.u22_1;
		  };
		  protoOf($serializer_71).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance()];
		  };
		  protoOf($serializer_71).wf = function (decoder) {
		    var tmp0_desc = this.u22_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegMute_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_71).v22 = function (encoder, value) {
		    var tmp0_desc = this.u22_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.w22_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_71).vf = function (encoder, value) {
		    return this.v22(encoder, value instanceof LegMute ? value : THROW_CCE());
		  };
		  var $serializer_instance_71;
		  function $serializer_getInstance_71() {
		    if ($serializer_instance_71 == null)
		      new $serializer_71();
		    return $serializer_instance_71;
		  }
		  function LegMute_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_71().u22_1);
		    }
		    $this.w22_1 = id;
		    return $this;
		  }
		  function LegMute_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return LegMute_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(LegMute)));
		  }
		  function LegMute(id) {
		    this.w22_1 = id;
		  }
		  protoOf(LegMute).toString = function () {
		    return 'LegMute(id=' + this.w22_1 + ')';
		  };
		  protoOf(LegMute).hashCode = function () {
		    return this.w22_1;
		  };
		  protoOf(LegMute).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegMute))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegMute ? other : THROW_CCE();
		    if (!(this.w22_1 === tmp0_other_with_cast.w22_1))
		      return false;
		    return true;
		  };
		  function Companion_67() {
		  }
		  var Companion_instance_68;
		  function Companion_getInstance_69() {
		    return Companion_instance_68;
		  }
		  function $serializer_72() {
		    $serializer_instance_72 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegUnmute', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.x22_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_72).uf = function () {
		    return this.x22_1;
		  };
		  protoOf($serializer_72).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance()];
		  };
		  protoOf($serializer_72).wf = function (decoder) {
		    var tmp0_desc = this.x22_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegUnmute_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_72).y22 = function (encoder, value) {
		    var tmp0_desc = this.x22_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.z22_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_72).vf = function (encoder, value) {
		    return this.y22(encoder, value instanceof LegUnmute ? value : THROW_CCE());
		  };
		  var $serializer_instance_72;
		  function $serializer_getInstance_72() {
		    if ($serializer_instance_72 == null)
		      new $serializer_72();
		    return $serializer_instance_72;
		  }
		  function LegUnmute_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_72().x22_1);
		    }
		    $this.z22_1 = id;
		    return $this;
		  }
		  function LegUnmute_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return LegUnmute_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(LegUnmute)));
		  }
		  function LegUnmute(id) {
		    this.z22_1 = id;
		  }
		  protoOf(LegUnmute).toString = function () {
		    return 'LegUnmute(id=' + this.z22_1 + ')';
		  };
		  protoOf(LegUnmute).hashCode = function () {
		    return this.z22_1;
		  };
		  protoOf(LegUnmute).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegUnmute))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegUnmute ? other : THROW_CCE();
		    if (!(this.z22_1 === tmp0_other_with_cast.z22_1))
		      return false;
		    return true;
		  };
		  function Companion_68() {
		  }
		  var Companion_instance_69;
		  function Companion_getInstance_70() {
		    return Companion_instance_69;
		  }
		  function $serializer_73() {
		    $serializer_instance_73 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegEarmuffEnable', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.a23_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_73).uf = function () {
		    return this.a23_1;
		  };
		  protoOf($serializer_73).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance()];
		  };
		  protoOf($serializer_73).wf = function (decoder) {
		    var tmp0_desc = this.a23_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegEarmuffEnable_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_73).b23 = function (encoder, value) {
		    var tmp0_desc = this.a23_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.c23_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_73).vf = function (encoder, value) {
		    return this.b23(encoder, value instanceof LegEarmuffEnable ? value : THROW_CCE());
		  };
		  var $serializer_instance_73;
		  function $serializer_getInstance_73() {
		    if ($serializer_instance_73 == null)
		      new $serializer_73();
		    return $serializer_instance_73;
		  }
		  function LegEarmuffEnable_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_73().a23_1);
		    }
		    $this.c23_1 = id;
		    return $this;
		  }
		  function LegEarmuffEnable_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return LegEarmuffEnable_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(LegEarmuffEnable)));
		  }
		  function LegEarmuffEnable(id) {
		    this.c23_1 = id;
		  }
		  protoOf(LegEarmuffEnable).toString = function () {
		    return 'LegEarmuffEnable(id=' + this.c23_1 + ')';
		  };
		  protoOf(LegEarmuffEnable).hashCode = function () {
		    return this.c23_1;
		  };
		  protoOf(LegEarmuffEnable).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegEarmuffEnable))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegEarmuffEnable ? other : THROW_CCE();
		    if (!(this.c23_1 === tmp0_other_with_cast.c23_1))
		      return false;
		    return true;
		  };
		  function Companion_69() {
		  }
		  var Companion_instance_70;
		  function Companion_getInstance_71() {
		    return Companion_instance_70;
		  }
		  function $serializer_74() {
		    $serializer_instance_74 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegEarmuffDisable', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.d23_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_74).uf = function () {
		    return this.d23_1;
		  };
		  protoOf($serializer_74).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance()];
		  };
		  protoOf($serializer_74).wf = function (decoder) {
		    var tmp0_desc = this.d23_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegEarmuffDisable_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_74).e23 = function (encoder, value) {
		    var tmp0_desc = this.d23_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.f23_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_74).vf = function (encoder, value) {
		    return this.e23(encoder, value instanceof LegEarmuffDisable ? value : THROW_CCE());
		  };
		  var $serializer_instance_74;
		  function $serializer_getInstance_74() {
		    if ($serializer_instance_74 == null)
		      new $serializer_74();
		    return $serializer_instance_74;
		  }
		  function LegEarmuffDisable_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_74().d23_1);
		    }
		    $this.f23_1 = id;
		    return $this;
		  }
		  function LegEarmuffDisable_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return LegEarmuffDisable_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(LegEarmuffDisable)));
		  }
		  function LegEarmuffDisable(id) {
		    this.f23_1 = id;
		  }
		  protoOf(LegEarmuffDisable).toString = function () {
		    return 'LegEarmuffDisable(id=' + this.f23_1 + ')';
		  };
		  protoOf(LegEarmuffDisable).hashCode = function () {
		    return this.f23_1;
		  };
		  protoOf(LegEarmuffDisable).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegEarmuffDisable))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegEarmuffDisable ? other : THROW_CCE();
		    if (!(this.f23_1 === tmp0_other_with_cast.f23_1))
		      return false;
		    return true;
		  };
		  function Companion_70() {
		  }
		  var Companion_instance_71;
		  function Companion_getInstance_72() {
		    return Companion_instance_71;
		  }
		  function $serializer_75() {
		    $serializer_instance_75 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegDTMF', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.g23_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_75).uf = function () {
		    return this.g23_1;
		  };
		  protoOf($serializer_75).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance()];
		  };
		  protoOf($serializer_75).wf = function (decoder) {
		    var tmp0_desc = this.g23_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return LegDTMF_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_75).h23 = function (encoder, value) {
		    var tmp0_desc = this.g23_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.i23_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_75).vf = function (encoder, value) {
		    return this.h23(encoder, value instanceof LegDTMF ? value : THROW_CCE());
		  };
		  var $serializer_instance_75;
		  function $serializer_getInstance_75() {
		    if ($serializer_instance_75 == null)
		      new $serializer_75();
		    return $serializer_instance_75;
		  }
		  function LegDTMF_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_75().g23_1);
		    }
		    $this.i23_1 = id;
		    return $this;
		  }
		  function LegDTMF_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return LegDTMF_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(LegDTMF)));
		  }
		  function LegDTMF(id) {
		    this.i23_1 = id;
		  }
		  protoOf(LegDTMF).toString = function () {
		    return 'LegDTMF(id=' + this.i23_1 + ')';
		  };
		  protoOf(LegDTMF).hashCode = function () {
		    return this.i23_1;
		  };
		  protoOf(LegDTMF).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegDTMF))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegDTMF ? other : THROW_CCE();
		    if (!(this.i23_1 === tmp0_other_with_cast.i23_1))
		      return false;
		    return true;
		  };
		  function Companion_71() {
		  }
		  var Companion_instance_72;
		  function Companion_getInstance_73() {
		    return Companion_instance_72;
		  }
		  function $serializer_76() {
		    $serializer_instance_76 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioSay', this, 7);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('_links', true);
		    this.j23_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_76).uf = function () {
		    return this.j23_1;
		  };
		  protoOf($serializer_76).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_117(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), get_nullable($serializer_getInstance_79())];
		  };
		  protoOf($serializer_76).wf = function (decoder) {
		    var tmp0_desc = this.j23_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.qj(tmp0_desc, 3, $serializer_getInstance_117(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.sj(tmp0_desc, 6, $serializer_getInstance_79(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.qj(tmp0_desc, 3, $serializer_getInstance_117(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.sj(tmp0_desc, 6, $serializer_getInstance_79(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return AudioSay_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_76).k23 = function (encoder, value) {
		    var tmp0_desc = this.j23_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.l23_1);
		    tmp1_output.tk(tmp0_desc, 1, value.m23_1);
		    tmp1_output.tk(tmp0_desc, 2, value.n23_1);
		    tmp1_output.vk(tmp0_desc, 3, $serializer_getInstance_117(), value.o23_1);
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.p23_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.p23_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.q23_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.q23_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.r23_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, $serializer_getInstance_79(), value.r23_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_76).vf = function (encoder, value) {
		    return this.k23(encoder, value instanceof AudioSay ? value : THROW_CCE());
		  };
		  var $serializer_instance_76;
		  function $serializer_getInstance_76() {
		    if ($serializer_instance_76 == null)
		      new $serializer_76();
		    return $serializer_instance_76;
		  }
		  function AudioSay_init_$Init$(seen1, id, type, timestamp, body, from, _embedded, _links, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_76().j23_1);
		    }
		    $this.l23_1 = id;
		    $this.m23_1 = type;
		    $this.n23_1 = timestamp;
		    $this.o23_1 = body;
		    if (0 === (seen1 & 16))
		      $this.p23_1 = null;
		    else
		      $this.p23_1 = from;
		    if (0 === (seen1 & 32))
		      $this.q23_1 = null;
		    else
		      $this.q23_1 = _embedded;
		    if (0 === (seen1 & 64))
		      $this.r23_1 = null;
		    else
		      $this.r23_1 = _links;
		    return $this;
		  }
		  function AudioSay_init_$Create$(seen1, id, type, timestamp, body, from, _embedded, _links, serializationConstructorMarker) {
		    return AudioSay_init_$Init$(seen1, id, type, timestamp, body, from, _embedded, _links, serializationConstructorMarker, objectCreate(protoOf(AudioSay)));
		  }
		  function AudioSay(id, type, timestamp, body, from, _embedded, _links) {
		    from = from === VOID ? null : from;
		    _embedded = _embedded === VOID ? null : _embedded;
		    _links = _links === VOID ? null : _links;
		    this.l23_1 = id;
		    this.m23_1 = type;
		    this.n23_1 = timestamp;
		    this.o23_1 = body;
		    this.p23_1 = from;
		    this.q23_1 = _embedded;
		    this.r23_1 = _links;
		  }
		  protoOf(AudioSay).toString = function () {
		    return 'AudioSay(id=' + this.l23_1 + ', type=' + this.m23_1 + ', timestamp=' + this.n23_1 + ', body=' + this.o23_1 + ', from=' + this.p23_1 + ', _embedded=' + this.q23_1 + ', _links=' + this.r23_1 + ')';
		  };
		  protoOf(AudioSay).hashCode = function () {
		    var result = this.l23_1;
		    result = imul(result, 31) + getStringHashCode(this.m23_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.n23_1) | 0;
		    result = imul(result, 31) + this.o23_1.hashCode() | 0;
		    result = imul(result, 31) + (this.p23_1 == null ? 0 : getStringHashCode(this.p23_1)) | 0;
		    result = imul(result, 31) + (this.q23_1 == null ? 0 : this.q23_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.r23_1 == null ? 0 : this.r23_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(AudioSay).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioSay))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioSay ? other : THROW_CCE();
		    if (!(this.l23_1 === tmp0_other_with_cast.l23_1))
		      return false;
		    if (!(this.m23_1 === tmp0_other_with_cast.m23_1))
		      return false;
		    if (!(this.n23_1 === tmp0_other_with_cast.n23_1))
		      return false;
		    if (!this.o23_1.equals(tmp0_other_with_cast.o23_1))
		      return false;
		    if (!(this.p23_1 == tmp0_other_with_cast.p23_1))
		      return false;
		    if (!equals(this.q23_1, tmp0_other_with_cast.q23_1))
		      return false;
		    if (!equals(this.r23_1, tmp0_other_with_cast.r23_1))
		      return false;
		    return true;
		  };
		  function EmptySerializer() {
		    EmptySerializer_instance = this;
		    JsonContentPolymorphicSerializer.call(this, getKClass(PostConversationEventRequestBody));
		  }
		  protoOf(EmptySerializer).w12 = function (element) {
		    throw new NotImplementedError('This polymorphic interface is not serializable.');
		  };
		  var EmptySerializer_instance;
		  function EmptySerializer_getInstance() {
		    if (EmptySerializer_instance == null)
		      new EmptySerializer();
		    return EmptySerializer_instance;
		  }
		  function Companion_72() {
		  }
		  var Companion_instance_73;
		  function Companion_getInstance_74() {
		    return Companion_instance_73;
		  }
		  function $serializer_77() {
		    $serializer_instance_77 = this;
		    this.u23_1 = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCStatsReportResponse', this, 0);
		  }
		  protoOf($serializer_77).uf = function () {
		    return this.u23_1;
		  };
		  protoOf($serializer_77).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [];
		  };
		  protoOf($serializer_77).wf = function (decoder) {
		    var tmp0_desc = this.u23_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp4_input = decoder.ej(tmp0_desc);
		    if (!tmp4_input.uj())
		      while (tmp1_flag) {
		        tmp2_index = tmp4_input.vj(tmp0_desc);
		        if (tmp2_index === -1)
		          tmp1_flag = false;
		        else
		          throw UnknownFieldException_init_$Create$(tmp2_index);
		      }
		    tmp4_input.fj(tmp0_desc);
		    return RTCStatsReportResponse_init_$Create$(0, null);
		  };
		  protoOf($serializer_77).v23 = function (encoder, value) {
		    var tmp0_desc = this.u23_1;
		    encoder.ej(tmp0_desc).fj(tmp0_desc);
		  };
		  protoOf($serializer_77).vf = function (encoder, value) {
		    return this.v23(encoder, value instanceof RTCStatsReportResponse ? value : THROW_CCE());
		  };
		  var $serializer_instance_77;
		  function $serializer_getInstance_77() {
		    if ($serializer_instance_77 == null)
		      new $serializer_77();
		    return $serializer_instance_77;
		  }
		  function RTCStatsReportResponse_init_$Init$(seen1, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_77().u23_1);
		    }
		    return $this;
		  }
		  function RTCStatsReportResponse_init_$Create$(seen1, serializationConstructorMarker) {
		    return RTCStatsReportResponse_init_$Init$(seen1, serializationConstructorMarker, objectCreate(protoOf(RTCStatsReportResponse)));
		  }
		  function RTCStatsReportResponse() {
		  }
		  function Companion_73() {
		  }
		  var Companion_instance_74;
		  function Companion_getInstance_75() {
		    return Companion_instance_74;
		  }
		  function $serializer_78() {
		    $serializer_instance_78 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCAnswerResponse', this, 1);
		    tmp0_serialDesc.pq('id', false);
		    this.w23_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_78).uf = function () {
		    return this.w23_1;
		  };
		  protoOf($serializer_78).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_78).wf = function (decoder) {
		    var tmp0_desc = this.w23_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return RTCAnswerResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_78).x23 = function (encoder, value) {
		    var tmp0_desc = this.w23_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.y23_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_78).vf = function (encoder, value) {
		    return this.x23(encoder, value instanceof RTCAnswerResponse ? value : THROW_CCE());
		  };
		  var $serializer_instance_78;
		  function $serializer_getInstance_78() {
		    if ($serializer_instance_78 == null)
		      new $serializer_78();
		    return $serializer_instance_78;
		  }
		  function RTCAnswerResponse_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_78().w23_1);
		    }
		    $this.y23_1 = id;
		    return $this;
		  }
		  function RTCAnswerResponse_init_$Create$(seen1, id, serializationConstructorMarker) {
		    return RTCAnswerResponse_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(RTCAnswerResponse)));
		  }
		  function RTCAnswerResponse(id) {
		    this.y23_1 = id;
		  }
		  protoOf(RTCAnswerResponse).toString = function () {
		    return 'RTCAnswerResponse(id=' + this.y23_1 + ')';
		  };
		  protoOf(RTCAnswerResponse).hashCode = function () {
		    return getStringHashCode(this.y23_1);
		  };
		  protoOf(RTCAnswerResponse).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCAnswerResponse))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCAnswerResponse ? other : THROW_CCE();
		    if (!(this.y23_1 === tmp0_other_with_cast.y23_1))
		      return false;
		    return true;
		  };
		  function Companion_74() {
		    Companion_instance_75 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.z23_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
		  }
		  var Companion_instance_75;
		  function Companion_getInstance_76() {
		    if (Companion_instance_75 == null)
		      new Companion_74();
		    return Companion_instance_75;
		  }
		  function $serializer_79() {
		    $serializer_instance_79 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.Links', this, 1);
		    tmp0_serialDesc.pq('self', false);
		    this.a24_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_79).uf = function () {
		    return this.a24_1;
		  };
		  protoOf($serializer_79).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [Companion_getInstance_76().z23_1[0]];
		  };
		  protoOf($serializer_79).wf = function (decoder) {
		    var tmp0_desc = this.a24_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    var tmp6_cached = Companion_getInstance_76().z23_1;
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return Links_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_79).b24 = function (encoder, value) {
		    var tmp0_desc = this.a24_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_76().z23_1;
		    tmp1_output.vk(tmp0_desc, 0, tmp2_cached[0], value.c24_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_79).vf = function (encoder, value) {
		    return this.b24(encoder, value instanceof Links ? value : THROW_CCE());
		  };
		  var $serializer_instance_79;
		  function $serializer_getInstance_79() {
		    if ($serializer_instance_79 == null)
		      new $serializer_79();
		    return $serializer_instance_79;
		  }
		  function Links_init_$Init$(seen1, self_0, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_79().a24_1);
		    }
		    $this.c24_1 = self_0;
		    return $this;
		  }
		  function Links_init_$Create$(seen1, self_0, serializationConstructorMarker) {
		    return Links_init_$Init$(seen1, self_0, serializationConstructorMarker, objectCreate(protoOf(Links)));
		  }
		  function Links() {
		  }
		  protoOf(Links).toString = function () {
		    return 'Links(self=' + this.c24_1 + ')';
		  };
		  protoOf(Links).hashCode = function () {
		    return hashCode(this.c24_1);
		  };
		  protoOf(Links).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Links))
		      return false;
		    var tmp0_other_with_cast = other instanceof Links ? other : THROW_CCE();
		    if (!equals(this.c24_1, tmp0_other_with_cast.c24_1))
		      return false;
		    return true;
		  };
		  var CSConversationEventType_MEMBER_INVITED_instance;
		  var CSConversationEventType_MEMBER_JOINED_instance;
		  var CSConversationEventType_MEMBER_LEFT_instance;
		  var CSConversationEventType_MESSAGE_instance;
		  var CSConversationEventType_EPHEMERAL_instance;
		  var CSConversationEventType_CUSTOM_instance;
		  var CSConversationEventType_EVENT_DELETE_instance;
		  var CSConversationEventType_MESSAGE_DELIVERED_instance;
		  var CSConversationEventType_MESSAGE_REJECTED_instance;
		  var CSConversationEventType_MESSAGE_UNDELIVERABLE_instance;
		  var CSConversationEventType_MESSAGE_SUBMITTED_instance;
		  var CSConversationEventType_MESSAGE_SEEN_instance;
		  var CSConversationEventType_entriesInitialized;
		  function CSConversationEventType_initEntries() {
		    if (CSConversationEventType_entriesInitialized)
		      return Unit_instance;
		    CSConversationEventType_entriesInitialized = true;
		    CSConversationEventType_MEMBER_INVITED_instance = new CSConversationEventType('MEMBER_INVITED', 0, 'member:invited');
		    CSConversationEventType_MEMBER_JOINED_instance = new CSConversationEventType('MEMBER_JOINED', 1, 'member:joined');
		    CSConversationEventType_MEMBER_LEFT_instance = new CSConversationEventType('MEMBER_LEFT', 2, 'member:left');
		    CSConversationEventType_MESSAGE_instance = new CSConversationEventType('MESSAGE', 3, 'message');
		    CSConversationEventType_EPHEMERAL_instance = new CSConversationEventType('EPHEMERAL', 4, 'ephemeral');
		    CSConversationEventType_CUSTOM_instance = new CSConversationEventType('CUSTOM', 5, 'custom:');
		    CSConversationEventType_EVENT_DELETE_instance = new CSConversationEventType('EVENT_DELETE', 6, 'event:delete');
		    CSConversationEventType_MESSAGE_DELIVERED_instance = new CSConversationEventType('MESSAGE_DELIVERED', 7, 'message:delivered');
		    CSConversationEventType_MESSAGE_REJECTED_instance = new CSConversationEventType('MESSAGE_REJECTED', 8, 'message:rejected');
		    CSConversationEventType_MESSAGE_UNDELIVERABLE_instance = new CSConversationEventType('MESSAGE_UNDELIVERABLE', 9, 'message:undeliverable');
		    CSConversationEventType_MESSAGE_SUBMITTED_instance = new CSConversationEventType('MESSAGE_SUBMITTED', 10, 'message:submitted');
		    CSConversationEventType_MESSAGE_SEEN_instance = new CSConversationEventType('MESSAGE_SEEN', 11, 'message:seen');
		  }
		  function CSConversationEventType(name, ordinal, jsonType) {
		    Enum.call(this, name, ordinal);
		    this.d1s_1 = jsonType;
		  }
		  function Companion_75() {
		  }
		  protoOf(Companion_75).y12 = function () {
		    return CSConversationEventsSerializer_getInstance();
		  };
		  protoOf(Companion_75).nr = function (typeParamsSerializers) {
		    return this.y12();
		  };
		  var Companion_instance_76;
		  function Companion_getInstance_77() {
		    return Companion_instance_76;
		  }
		  function CSConversationEvent() {
		  }
		  function Companion_76() {
		  }
		  var Companion_instance_77;
		  function Companion_getInstance_78() {
		    return Companion_instance_77;
		  }
		  function CSConversationEventJsonBody(jsonObject) {
		    this.e24_1 = jsonObject;
		  }
		  protoOf(CSConversationEventJsonBody).toString = function () {
		    return 'CSConversationEventJsonBody(jsonObject=' + this.e24_1 + ')';
		  };
		  protoOf(CSConversationEventJsonBody).hashCode = function () {
		    return this.e24_1.hashCode();
		  };
		  protoOf(CSConversationEventJsonBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSConversationEventJsonBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSConversationEventJsonBody ? other : THROW_CCE();
		    if (!this.e24_1.equals(tmp0_other_with_cast.e24_1))
		      return false;
		    return true;
		  };
		  function CSConversationEventsSerializer() {
		    CSConversationEventsSerializer_instance = this;
		    JsonContentPolymorphicSerializer.call(this, getKClass(CSConversationEvent));
		  }
		  protoOf(CSConversationEventsSerializer).w12 = function (element) {
		    var tmp0_safe_receiver = get_jsonObject(element).b13('type');
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
		    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e13();
		    var type = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
		    return startsWith(type, CSConversationEventType_CUSTOM_getInstance().d1s_1) ? Companion_instance_78.y12() : type === CSConversationEventType_MEMBER_INVITED_getInstance().d1s_1 ? Companion_instance_79.y12() : type === CSConversationEventType_MEMBER_JOINED_getInstance().d1s_1 ? Companion_instance_80.y12() : type === CSConversationEventType_MEMBER_LEFT_getInstance().d1s_1 ? Companion_instance_81.y12() : type === CSConversationEventType_MESSAGE_getInstance().d1s_1 ? Companion_instance_121.y12() : type === CSConversationEventType_EVENT_DELETE_getInstance().d1s_1 ? Companion_instance_82.y12() : Companion_instance_76.y12();
		  };
		  var CSConversationEventsSerializer_instance;
		  function CSConversationEventsSerializer_getInstance() {
		    if (CSConversationEventsSerializer_instance == null)
		      new CSConversationEventsSerializer();
		    return CSConversationEventsSerializer_instance;
		  }
		  function CSConversationEventJsonBodySerializer() {
		    CSConversationEventJsonBodySerializer_instance = this;
		    this.h24_1 = Companion_instance.y12().uf();
		  }
		  protoOf(CSConversationEventJsonBodySerializer).uf = function () {
		    return this.h24_1;
		  };
		  protoOf(CSConversationEventJsonBodySerializer).i24 = function (encoder, value) {
		    encoder.wk(Companion_instance.y12(), value.e24_1);
		  };
		  protoOf(CSConversationEventJsonBodySerializer).vf = function (encoder, value) {
		    return this.i24(encoder, value instanceof CSConversationEventJsonBody ? value : THROW_CCE());
		  };
		  protoOf(CSConversationEventJsonBodySerializer).wf = function (decoder) {
		    var jsonObject = decoder.dj(Companion_instance.y12());
		    return new CSConversationEventJsonBody(jsonObject);
		  };
		  var CSConversationEventJsonBodySerializer_instance;
		  function CSConversationEventJsonBodySerializer_getInstance() {
		    if (CSConversationEventJsonBodySerializer_instance == null)
		      new CSConversationEventJsonBodySerializer();
		    return CSConversationEventJsonBodySerializer_instance;
		  }
		  function Companion_77() {
		  }
		  protoOf(Companion_77).y12 = function () {
		    return $serializer_getInstance_80();
		  };
		  var Companion_instance_78;
		  function Companion_getInstance_79() {
		    return Companion_instance_78;
		  }
		  function $serializer_80() {
		    $serializer_instance_80 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSCustomEvent', this, 7);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('conversation_id', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('body', false);
		    this.j24_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_80).uf = function () {
		    return this.j24_1;
		  };
		  protoOf($serializer_80).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), JsonObjectSerializer_getInstance()];
		  };
		  protoOf($serializer_80).wf = function (decoder) {
		    var tmp0_desc = this.j24_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, JsonObjectSerializer_getInstance(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, JsonObjectSerializer_getInstance(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return CSCustomEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_80).k24 = function (encoder, value) {
		    var tmp0_desc = this.j24_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.l24_1);
		    tmp1_output.tk(tmp0_desc, 1, value.m24_1);
		    tmp1_output.tk(tmp0_desc, 2, value.n24_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.o24_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.o24_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.p24_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.p24_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.q24_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.q24_1);
		    }
		    tmp1_output.vk(tmp0_desc, 6, JsonObjectSerializer_getInstance(), value.r24_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_80).vf = function (encoder, value) {
		    return this.k24(encoder, value instanceof CSCustomEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_80;
		  function $serializer_getInstance_80() {
		    if ($serializer_instance_80 == null)
		      new $serializer_80();
		    return $serializer_instance_80;
		  }
		  function CSCustomEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, $this) {
		    if (!(71 === (71 & seen1))) {
		      throwMissingFieldException(seen1, 71, $serializer_getInstance_80().j24_1);
		    }
		    $this.l24_1 = id;
		    $this.m24_1 = type;
		    $this.n24_1 = timestamp;
		    if (0 === (seen1 & 8))
		      $this.o24_1 = null;
		    else
		      $this.o24_1 = from;
		    if (0 === (seen1 & 16))
		      $this.p24_1 = null;
		    else
		      $this.p24_1 = conversation_id;
		    if (0 === (seen1 & 32))
		      $this.q24_1 = null;
		    else
		      $this.q24_1 = _embedded;
		    $this.r24_1 = body;
		    return $this;
		  }
		  function CSCustomEvent_init_$Create$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker) {
		    return CSCustomEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, objectCreate(protoOf(CSCustomEvent)));
		  }
		  function CSCustomEvent() {
		  }
		  protoOf(CSCustomEvent).d24 = function (conversationId) {
		    var tmp0_id = this.l24_1;
		    var tmp1_timestamp = this.n24_1;
		    var tmp2_from = Companion_instance_142.s24(this.q24_1);
		    var tmp3_eventType = this.m24_1;
		    var tmp4_body = this.r24_1.toString();
		    return new CustomConversationEvent(tmp0_id, tmp1_timestamp, conversationId, tmp2_from, tmp4_body, tmp3_eventType);
		  };
		  protoOf(CSCustomEvent).toString = function () {
		    return 'CSCustomEvent(id=' + this.l24_1 + ', type=' + this.m24_1 + ', timestamp=' + this.n24_1 + ', from=' + this.o24_1 + ', conversation_id=' + this.p24_1 + ', _embedded=' + this.q24_1 + ', body=' + this.r24_1 + ')';
		  };
		  protoOf(CSCustomEvent).hashCode = function () {
		    var result = this.l24_1;
		    result = imul(result, 31) + getStringHashCode(this.m24_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.n24_1) | 0;
		    result = imul(result, 31) + (this.o24_1 == null ? 0 : getStringHashCode(this.o24_1)) | 0;
		    result = imul(result, 31) + (this.p24_1 == null ? 0 : getStringHashCode(this.p24_1)) | 0;
		    result = imul(result, 31) + (this.q24_1 == null ? 0 : this.q24_1.hashCode()) | 0;
		    result = imul(result, 31) + this.r24_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(CSCustomEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSCustomEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSCustomEvent ? other : THROW_CCE();
		    if (!(this.l24_1 === tmp0_other_with_cast.l24_1))
		      return false;
		    if (!(this.m24_1 === tmp0_other_with_cast.m24_1))
		      return false;
		    if (!(this.n24_1 === tmp0_other_with_cast.n24_1))
		      return false;
		    if (!(this.o24_1 == tmp0_other_with_cast.o24_1))
		      return false;
		    if (!(this.p24_1 == tmp0_other_with_cast.p24_1))
		      return false;
		    if (!equals(this.q24_1, tmp0_other_with_cast.q24_1))
		      return false;
		    if (!this.r24_1.equals(tmp0_other_with_cast.r24_1))
		      return false;
		    return true;
		  };
		  function Companion_78() {
		  }
		  protoOf(Companion_78).y12 = function () {
		    return $serializer_getInstance_81();
		  };
		  var Companion_instance_79;
		  function Companion_getInstance_80() {
		    return Companion_instance_79;
		  }
		  function $serializer_81() {
		    $serializer_instance_81 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMemberInvitedEvent', this, 7);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('conversation_id', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('body', false);
		    this.t24_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_81).uf = function () {
		    return this.t24_1;
		  };
		  protoOf($serializer_81).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), $serializer_getInstance_85()];
		  };
		  protoOf($serializer_81).wf = function (decoder) {
		    var tmp0_desc = this.t24_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, $serializer_getInstance_85(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, $serializer_getInstance_85(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return CSMemberInvitedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_81).u24 = function (encoder, value) {
		    var tmp0_desc = this.t24_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.v24_1);
		    tmp1_output.tk(tmp0_desc, 1, value.w24_1);
		    tmp1_output.tk(tmp0_desc, 2, value.x24_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.y24_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.y24_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.z24_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.z24_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.a25_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.a25_1);
		    }
		    tmp1_output.vk(tmp0_desc, 6, $serializer_getInstance_85(), value.b25_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_81).vf = function (encoder, value) {
		    return this.u24(encoder, value instanceof CSMemberInvitedEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_81;
		  function $serializer_getInstance_81() {
		    if ($serializer_instance_81 == null)
		      new $serializer_81();
		    return $serializer_instance_81;
		  }
		  function CSMemberInvitedEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, $this) {
		    if (!(71 === (71 & seen1))) {
		      throwMissingFieldException(seen1, 71, $serializer_getInstance_81().t24_1);
		    }
		    $this.v24_1 = id;
		    $this.w24_1 = type;
		    $this.x24_1 = timestamp;
		    if (0 === (seen1 & 8))
		      $this.y24_1 = null;
		    else
		      $this.y24_1 = from;
		    if (0 === (seen1 & 16))
		      $this.z24_1 = null;
		    else
		      $this.z24_1 = conversation_id;
		    if (0 === (seen1 & 32))
		      $this.a25_1 = null;
		    else
		      $this.a25_1 = _embedded;
		    $this.b25_1 = body;
		    return $this;
		  }
		  function CSMemberInvitedEvent_init_$Create$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker) {
		    return CSMemberInvitedEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, objectCreate(protoOf(CSMemberInvitedEvent)));
		  }
		  function CSMemberInvitedEvent() {
		  }
		  protoOf(CSMemberInvitedEvent).d24 = function (conversationId) {
		    return new MemberInvitedConversationEvent(this.v24_1, this.x24_1, conversationId, Companion_instance_142.s24(this.a25_1), this.b25_1.f25());
		  };
		  protoOf(CSMemberInvitedEvent).toString = function () {
		    return 'CSMemberInvitedEvent(id=' + this.v24_1 + ', type=' + this.w24_1 + ', timestamp=' + this.x24_1 + ', from=' + this.y24_1 + ', conversation_id=' + this.z24_1 + ', _embedded=' + this.a25_1 + ', body=' + this.b25_1 + ')';
		  };
		  protoOf(CSMemberInvitedEvent).hashCode = function () {
		    var result = this.v24_1;
		    result = imul(result, 31) + getStringHashCode(this.w24_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.x24_1) | 0;
		    result = imul(result, 31) + (this.y24_1 == null ? 0 : getStringHashCode(this.y24_1)) | 0;
		    result = imul(result, 31) + (this.z24_1 == null ? 0 : getStringHashCode(this.z24_1)) | 0;
		    result = imul(result, 31) + (this.a25_1 == null ? 0 : this.a25_1.hashCode()) | 0;
		    result = imul(result, 31) + this.b25_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(CSMemberInvitedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSMemberInvitedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSMemberInvitedEvent ? other : THROW_CCE();
		    if (!(this.v24_1 === tmp0_other_with_cast.v24_1))
		      return false;
		    if (!(this.w24_1 === tmp0_other_with_cast.w24_1))
		      return false;
		    if (!(this.x24_1 === tmp0_other_with_cast.x24_1))
		      return false;
		    if (!(this.y24_1 == tmp0_other_with_cast.y24_1))
		      return false;
		    if (!(this.z24_1 == tmp0_other_with_cast.z24_1))
		      return false;
		    if (!equals(this.a25_1, tmp0_other_with_cast.a25_1))
		      return false;
		    if (!this.b25_1.equals(tmp0_other_with_cast.b25_1))
		      return false;
		    return true;
		  };
		  function Companion_79() {
		  }
		  protoOf(Companion_79).y12 = function () {
		    return $serializer_getInstance_82();
		  };
		  var Companion_instance_80;
		  function Companion_getInstance_81() {
		    return Companion_instance_80;
		  }
		  function $serializer_82() {
		    $serializer_instance_82 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMemberJoinedEvent', this, 7);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('conversation_id', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('body', false);
		    this.g25_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_82).uf = function () {
		    return this.g25_1;
		  };
		  protoOf($serializer_82).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), $serializer_getInstance_85()];
		  };
		  protoOf($serializer_82).wf = function (decoder) {
		    var tmp0_desc = this.g25_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, $serializer_getInstance_85(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, $serializer_getInstance_85(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return CSMemberJoinedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_82).h25 = function (encoder, value) {
		    var tmp0_desc = this.g25_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.i25_1);
		    tmp1_output.tk(tmp0_desc, 1, value.j25_1);
		    tmp1_output.tk(tmp0_desc, 2, value.k25_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.l25_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.l25_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.m25_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.m25_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.n25_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.n25_1);
		    }
		    tmp1_output.vk(tmp0_desc, 6, $serializer_getInstance_85(), value.o25_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_82).vf = function (encoder, value) {
		    return this.h25(encoder, value instanceof CSMemberJoinedEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_82;
		  function $serializer_getInstance_82() {
		    if ($serializer_instance_82 == null)
		      new $serializer_82();
		    return $serializer_instance_82;
		  }
		  function CSMemberJoinedEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, $this) {
		    if (!(71 === (71 & seen1))) {
		      throwMissingFieldException(seen1, 71, $serializer_getInstance_82().g25_1);
		    }
		    $this.i25_1 = id;
		    $this.j25_1 = type;
		    $this.k25_1 = timestamp;
		    if (0 === (seen1 & 8))
		      $this.l25_1 = null;
		    else
		      $this.l25_1 = from;
		    if (0 === (seen1 & 16))
		      $this.m25_1 = null;
		    else
		      $this.m25_1 = conversation_id;
		    if (0 === (seen1 & 32))
		      $this.n25_1 = null;
		    else
		      $this.n25_1 = _embedded;
		    $this.o25_1 = body;
		    return $this;
		  }
		  function CSMemberJoinedEvent_init_$Create$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker) {
		    return CSMemberJoinedEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, objectCreate(protoOf(CSMemberJoinedEvent)));
		  }
		  function CSMemberJoinedEvent() {
		  }
		  protoOf(CSMemberJoinedEvent).d24 = function (conversationId) {
		    return new MemberJoinedConversationEvent(this.i25_1, this.k25_1, conversationId, Companion_instance_142.s24(this.n25_1), this.o25_1.f25());
		  };
		  protoOf(CSMemberJoinedEvent).toString = function () {
		    return 'CSMemberJoinedEvent(id=' + this.i25_1 + ', type=' + this.j25_1 + ', timestamp=' + this.k25_1 + ', from=' + this.l25_1 + ', conversation_id=' + this.m25_1 + ', _embedded=' + this.n25_1 + ', body=' + this.o25_1 + ')';
		  };
		  protoOf(CSMemberJoinedEvent).hashCode = function () {
		    var result = this.i25_1;
		    result = imul(result, 31) + getStringHashCode(this.j25_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.k25_1) | 0;
		    result = imul(result, 31) + (this.l25_1 == null ? 0 : getStringHashCode(this.l25_1)) | 0;
		    result = imul(result, 31) + (this.m25_1 == null ? 0 : getStringHashCode(this.m25_1)) | 0;
		    result = imul(result, 31) + (this.n25_1 == null ? 0 : this.n25_1.hashCode()) | 0;
		    result = imul(result, 31) + this.o25_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(CSMemberJoinedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSMemberJoinedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSMemberJoinedEvent ? other : THROW_CCE();
		    if (!(this.i25_1 === tmp0_other_with_cast.i25_1))
		      return false;
		    if (!(this.j25_1 === tmp0_other_with_cast.j25_1))
		      return false;
		    if (!(this.k25_1 === tmp0_other_with_cast.k25_1))
		      return false;
		    if (!(this.l25_1 == tmp0_other_with_cast.l25_1))
		      return false;
		    if (!(this.m25_1 == tmp0_other_with_cast.m25_1))
		      return false;
		    if (!equals(this.n25_1, tmp0_other_with_cast.n25_1))
		      return false;
		    if (!this.o25_1.equals(tmp0_other_with_cast.o25_1))
		      return false;
		    return true;
		  };
		  function Companion_80() {
		  }
		  protoOf(Companion_80).y12 = function () {
		    return $serializer_getInstance_83();
		  };
		  var Companion_instance_81;
		  function Companion_getInstance_82() {
		    return Companion_instance_81;
		  }
		  function $serializer_83() {
		    $serializer_instance_83 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMemberLeftEvent', this, 7);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('conversation_id', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('body', false);
		    this.p25_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_83).uf = function () {
		    return this.p25_1;
		  };
		  protoOf($serializer_83).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), $serializer_getInstance_85()];
		  };
		  protoOf($serializer_83).wf = function (decoder) {
		    var tmp0_desc = this.p25_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, $serializer_getInstance_85(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, $serializer_getInstance_85(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return CSMemberLeftEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_83).q25 = function (encoder, value) {
		    var tmp0_desc = this.p25_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.r25_1);
		    tmp1_output.tk(tmp0_desc, 1, value.s25_1);
		    tmp1_output.tk(tmp0_desc, 2, value.t25_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.u25_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.u25_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.v25_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.v25_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.w25_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.w25_1);
		    }
		    tmp1_output.vk(tmp0_desc, 6, $serializer_getInstance_85(), value.x25_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_83).vf = function (encoder, value) {
		    return this.q25(encoder, value instanceof CSMemberLeftEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_83;
		  function $serializer_getInstance_83() {
		    if ($serializer_instance_83 == null)
		      new $serializer_83();
		    return $serializer_instance_83;
		  }
		  function CSMemberLeftEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, $this) {
		    if (!(71 === (71 & seen1))) {
		      throwMissingFieldException(seen1, 71, $serializer_getInstance_83().p25_1);
		    }
		    $this.r25_1 = id;
		    $this.s25_1 = type;
		    $this.t25_1 = timestamp;
		    if (0 === (seen1 & 8))
		      $this.u25_1 = null;
		    else
		      $this.u25_1 = from;
		    if (0 === (seen1 & 16))
		      $this.v25_1 = null;
		    else
		      $this.v25_1 = conversation_id;
		    if (0 === (seen1 & 32))
		      $this.w25_1 = null;
		    else
		      $this.w25_1 = _embedded;
		    $this.x25_1 = body;
		    return $this;
		  }
		  function CSMemberLeftEvent_init_$Create$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker) {
		    return CSMemberLeftEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, objectCreate(protoOf(CSMemberLeftEvent)));
		  }
		  function CSMemberLeftEvent() {
		  }
		  protoOf(CSMemberLeftEvent).d24 = function (conversationId) {
		    return new MemberLeftConversationEvent(this.r25_1, this.t25_1, conversationId, Companion_instance_142.s24(this.w25_1), this.x25_1.f25());
		  };
		  protoOf(CSMemberLeftEvent).toString = function () {
		    return 'CSMemberLeftEvent(id=' + this.r25_1 + ', type=' + this.s25_1 + ', timestamp=' + this.t25_1 + ', from=' + this.u25_1 + ', conversation_id=' + this.v25_1 + ', _embedded=' + this.w25_1 + ', body=' + this.x25_1 + ')';
		  };
		  protoOf(CSMemberLeftEvent).hashCode = function () {
		    var result = this.r25_1;
		    result = imul(result, 31) + getStringHashCode(this.s25_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.t25_1) | 0;
		    result = imul(result, 31) + (this.u25_1 == null ? 0 : getStringHashCode(this.u25_1)) | 0;
		    result = imul(result, 31) + (this.v25_1 == null ? 0 : getStringHashCode(this.v25_1)) | 0;
		    result = imul(result, 31) + (this.w25_1 == null ? 0 : this.w25_1.hashCode()) | 0;
		    result = imul(result, 31) + this.x25_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(CSMemberLeftEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSMemberLeftEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSMemberLeftEvent ? other : THROW_CCE();
		    if (!(this.r25_1 === tmp0_other_with_cast.r25_1))
		      return false;
		    if (!(this.s25_1 === tmp0_other_with_cast.s25_1))
		      return false;
		    if (!(this.t25_1 === tmp0_other_with_cast.t25_1))
		      return false;
		    if (!(this.u25_1 == tmp0_other_with_cast.u25_1))
		      return false;
		    if (!(this.v25_1 == tmp0_other_with_cast.v25_1))
		      return false;
		    if (!equals(this.w25_1, tmp0_other_with_cast.w25_1))
		      return false;
		    if (!this.x25_1.equals(tmp0_other_with_cast.x25_1))
		      return false;
		    return true;
		  };
		  function Companion_81() {
		  }
		  protoOf(Companion_81).y12 = function () {
		    return $serializer_getInstance_84();
		  };
		  var Companion_instance_82;
		  function Companion_getInstance_83() {
		    return Companion_instance_82;
		  }
		  function $serializer_84() {
		    $serializer_instance_84 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSEventDelete', this, 7);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('conversation_id', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('body', false);
		    this.y25_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_84).uf = function () {
		    return this.y25_1;
		  };
		  protoOf($serializer_84).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), $serializer_getInstance_119()];
		  };
		  protoOf($serializer_84).wf = function (decoder) {
		    var tmp0_desc = this.y25_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, $serializer_getInstance_119(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.qj(tmp0_desc, 6, $serializer_getInstance_119(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return CSEventDelete_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_84).z25 = function (encoder, value) {
		    var tmp0_desc = this.y25_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.a26_1);
		    tmp1_output.tk(tmp0_desc, 1, value.b26_1);
		    tmp1_output.tk(tmp0_desc, 2, value.c26_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.d26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.d26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.e26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.e26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.f26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.f26_1);
		    }
		    tmp1_output.vk(tmp0_desc, 6, $serializer_getInstance_119(), value.g26_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_84).vf = function (encoder, value) {
		    return this.z25(encoder, value instanceof CSEventDelete ? value : THROW_CCE());
		  };
		  var $serializer_instance_84;
		  function $serializer_getInstance_84() {
		    if ($serializer_instance_84 == null)
		      new $serializer_84();
		    return $serializer_instance_84;
		  }
		  function CSEventDelete_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, $this) {
		    if (!(71 === (71 & seen1))) {
		      throwMissingFieldException(seen1, 71, $serializer_getInstance_84().y25_1);
		    }
		    $this.a26_1 = id;
		    $this.b26_1 = type;
		    $this.c26_1 = timestamp;
		    if (0 === (seen1 & 8))
		      $this.d26_1 = null;
		    else
		      $this.d26_1 = from;
		    if (0 === (seen1 & 16))
		      $this.e26_1 = null;
		    else
		      $this.e26_1 = conversation_id;
		    if (0 === (seen1 & 32))
		      $this.f26_1 = null;
		    else
		      $this.f26_1 = _embedded;
		    $this.g26_1 = body;
		    return $this;
		  }
		  function CSEventDelete_init_$Create$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker) {
		    return CSEventDelete_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, serializationConstructorMarker, objectCreate(protoOf(CSEventDelete)));
		  }
		  function CSEventDelete() {
		  }
		  protoOf(CSEventDelete).d24 = function (conversationId) {
		    return new EventDeleteConversationEvent(this.a26_1, this.c26_1, conversationId, Companion_instance_142.s24(this.f26_1), new EventStateBody(this.g26_1.h26_1));
		  };
		  protoOf(CSEventDelete).toString = function () {
		    return 'CSEventDelete(id=' + this.a26_1 + ', type=' + this.b26_1 + ', timestamp=' + this.c26_1 + ', from=' + this.d26_1 + ', conversation_id=' + this.e26_1 + ', _embedded=' + this.f26_1 + ', body=' + this.g26_1 + ')';
		  };
		  protoOf(CSEventDelete).hashCode = function () {
		    var result = this.a26_1;
		    result = imul(result, 31) + getStringHashCode(this.b26_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.c26_1) | 0;
		    result = imul(result, 31) + (this.d26_1 == null ? 0 : getStringHashCode(this.d26_1)) | 0;
		    result = imul(result, 31) + (this.e26_1 == null ? 0 : getStringHashCode(this.e26_1)) | 0;
		    result = imul(result, 31) + (this.f26_1 == null ? 0 : this.f26_1.hashCode()) | 0;
		    result = imul(result, 31) + this.g26_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(CSEventDelete).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSEventDelete))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSEventDelete ? other : THROW_CCE();
		    if (!(this.a26_1 === tmp0_other_with_cast.a26_1))
		      return false;
		    if (!(this.b26_1 === tmp0_other_with_cast.b26_1))
		      return false;
		    if (!(this.c26_1 === tmp0_other_with_cast.c26_1))
		      return false;
		    if (!(this.d26_1 == tmp0_other_with_cast.d26_1))
		      return false;
		    if (!(this.e26_1 == tmp0_other_with_cast.e26_1))
		      return false;
		    if (!equals(this.f26_1, tmp0_other_with_cast.f26_1))
		      return false;
		    if (!this.g26_1.equals(tmp0_other_with_cast.g26_1))
		      return false;
		    return true;
		  };
		  function $serializer_85() {
		    $serializer_instance_85 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMemberEventBody', this, 3);
		    tmp0_serialDesc.pq('user', false);
		    tmp0_serialDesc.pq('member_id', false);
		    tmp0_serialDesc.pq('channel', false);
		    this.i26_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_85).uf = function () {
		    return this.i26_1;
		  };
		  protoOf($serializer_85).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_51(), StringSerializer_getInstance(), $serializer_getInstance_168()];
		  };
		  protoOf($serializer_85).wf = function (decoder) {
		    var tmp0_desc = this.i26_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_51(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_168(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_51(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_168(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return CSMemberEventBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_85).j26 = function (encoder, value) {
		    var tmp0_desc = this.i26_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_51(), value.c25_1);
		    tmp1_output.tk(tmp0_desc, 1, value.d25_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_168(), value.e25_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_85).vf = function (encoder, value) {
		    return this.j26(encoder, value instanceof CSMemberEventBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_85;
		  function $serializer_getInstance_85() {
		    if ($serializer_instance_85 == null)
		      new $serializer_85();
		    return $serializer_instance_85;
		  }
		  function CSMemberEventBody_init_$Init$(seen1, user, member_id, channel, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_85().i26_1);
		    }
		    $this.c25_1 = user;
		    $this.d25_1 = member_id;
		    $this.e25_1 = channel;
		    return $this;
		  }
		  function CSMemberEventBody_init_$Create$(seen1, user, member_id, channel, serializationConstructorMarker) {
		    return CSMemberEventBody_init_$Init$(seen1, user, member_id, channel, serializationConstructorMarker, objectCreate(protoOf(CSMemberEventBody)));
		  }
		  function CSMemberEventBody() {
		  }
		  protoOf(CSMemberEventBody).f25 = function () {
		    return new Body_15(this.c25_1.g1y(), this.d25_1, this.e25_1.q26());
		  };
		  protoOf(CSMemberEventBody).toString = function () {
		    return 'CSMemberEventBody(user=' + this.c25_1 + ', member_id=' + this.d25_1 + ', channel=' + this.e25_1 + ')';
		  };
		  protoOf(CSMemberEventBody).hashCode = function () {
		    var result = hashCode(this.c25_1);
		    result = imul(result, 31) + getStringHashCode(this.d25_1) | 0;
		    result = imul(result, 31) + this.e25_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(CSMemberEventBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSMemberEventBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSMemberEventBody ? other : THROW_CCE();
		    if (!equals(this.c25_1, tmp0_other_with_cast.c25_1))
		      return false;
		    if (!(this.d25_1 === tmp0_other_with_cast.d25_1))
		      return false;
		    if (!this.e25_1.equals(tmp0_other_with_cast.e25_1))
		      return false;
		    return true;
		  };
		  function Companion_82() {
		    Companion_instance_83 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.r26_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
		  }
		  var Companion_instance_83;
		  function Companion_getInstance_84() {
		    if (Companion_instance_83 == null)
		      new Companion_82();
		    return Companion_instance_83;
		  }
		  function $serializer_86() {
		    $serializer_instance_86 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSEventState', this, 5);
		    tmp0_serialDesc.pq('seen_by', true);
		    tmp0_serialDesc.pq('delivered_to', true);
		    tmp0_serialDesc.pq('submitted_to', true);
		    tmp0_serialDesc.pq('rejected_by', true);
		    tmp0_serialDesc.pq('undeliverable_to', true);
		    this.s26_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_86).uf = function () {
		    return this.s26_1;
		  };
		  protoOf($serializer_86).er = function () {
		    var tmp0_cached = Companion_getInstance_84().r26_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2]), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4])];
		  };
		  protoOf($serializer_86).wf = function (decoder) {
		    var tmp0_desc = this.s26_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    var tmp10_cached = Companion_getInstance_84().r26_1;
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.sj(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.sj(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.sj(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.sj(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return CSEventState_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_86).t26 = function (encoder, value) {
		    var tmp0_desc = this.s26_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_84().r26_1;
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.u26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, tmp2_cached[0], value.u26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.v26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, tmp2_cached[1], value.v26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.w26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, tmp2_cached[2], value.w26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.x26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, tmp2_cached[3], value.x26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.y26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, tmp2_cached[4], value.y26_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_86).vf = function (encoder, value) {
		    return this.t26(encoder, value instanceof CSEventState ? value : THROW_CCE());
		  };
		  var $serializer_instance_86;
		  function $serializer_getInstance_86() {
		    if ($serializer_instance_86 == null)
		      new $serializer_86();
		    return $serializer_instance_86;
		  }
		  function CSEventState_init_$Init$(seen1, seenBy, deliveredTo, submittedTo, rejectedBy, undeliverableTo, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_86().s26_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.u26_1 = null;
		    else
		      $this.u26_1 = seenBy;
		    if (0 === (seen1 & 2))
		      $this.v26_1 = null;
		    else
		      $this.v26_1 = deliveredTo;
		    if (0 === (seen1 & 4))
		      $this.w26_1 = null;
		    else
		      $this.w26_1 = submittedTo;
		    if (0 === (seen1 & 8))
		      $this.x26_1 = null;
		    else
		      $this.x26_1 = rejectedBy;
		    if (0 === (seen1 & 16))
		      $this.y26_1 = null;
		    else
		      $this.y26_1 = undeliverableTo;
		    return $this;
		  }
		  function CSEventState_init_$Create$(seen1, seenBy, deliveredTo, submittedTo, rejectedBy, undeliverableTo, serializationConstructorMarker) {
		    return CSEventState_init_$Init$(seen1, seenBy, deliveredTo, submittedTo, rejectedBy, undeliverableTo, serializationConstructorMarker, objectCreate(protoOf(CSEventState)));
		  }
		  function CSEventState() {
		    Companion_getInstance_84();
		    this.u26_1 = null;
		    this.v26_1 = null;
		    this.w26_1 = null;
		    this.x26_1 = null;
		    this.y26_1 = null;
		  }
		  protoOf(CSEventState).z26 = function () {
		    var tmp8_safe_receiver = this.u26_1;
		    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.q1();
		    var tmp;
		    if (tmp9_elvis_lhs == null) {
		      // Inline function 'kotlin.collections.setOf' call
		      tmp = emptySet();
		    } else {
		      tmp = tmp9_elvis_lhs;
		    }
		    var tmp_0 = tmp;
		    var tmp6_safe_receiver = this.v26_1;
		    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.q1();
		    var tmp_1;
		    if (tmp7_elvis_lhs == null) {
		      // Inline function 'kotlin.collections.setOf' call
		      tmp_1 = emptySet();
		    } else {
		      tmp_1 = tmp7_elvis_lhs;
		    }
		    var tmp_2 = plus(tmp_0, tmp_1);
		    var tmp4_safe_receiver = this.w26_1;
		    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.q1();
		    var tmp_3;
		    if (tmp5_elvis_lhs == null) {
		      // Inline function 'kotlin.collections.setOf' call
		      tmp_3 = emptySet();
		    } else {
		      tmp_3 = tmp5_elvis_lhs;
		    }
		    var tmp_4 = plus(tmp_2, tmp_3);
		    var tmp2_safe_receiver = this.x26_1;
		    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.q1();
		    var tmp_5;
		    if (tmp3_elvis_lhs == null) {
		      // Inline function 'kotlin.collections.setOf' call
		      tmp_5 = emptySet();
		    } else {
		      tmp_5 = tmp3_elvis_lhs;
		    }
		    var tmp_6 = plus(tmp_4, tmp_5);
		    var tmp0_safe_receiver = this.y26_1;
		    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q1();
		    var tmp_7;
		    if (tmp1_elvis_lhs == null) {
		      // Inline function 'kotlin.collections.setOf' call
		      tmp_7 = emptySet();
		    } else {
		      tmp_7 = tmp1_elvis_lhs;
		    }
		    var memberIds = plus(tmp_6, tmp_7);
		    // Inline function 'kotlin.collections.mutableMapOf' call
		    var map = LinkedHashMap_init_$Create$();
		    // Inline function 'kotlin.collections.forEach' call
		    var tmp0_iterator = memberIds.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.core.actions.CSEventState.getMemberStatus.<anonymous>' call
		      // Inline function 'kotlin.collections.set' call
		      var tmp0_safe_receiver_0 = this.u26_1;
		      var tmp_8 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.c2(element);
		      var tmp1_safe_receiver = this.v26_1;
		      var tmp_9 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c2(element);
		      var tmp2_safe_receiver_0 = this.w26_1;
		      var tmp_10 = tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.c2(element);
		      var tmp3_safe_receiver = this.x26_1;
		      var tmp_11 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.c2(element);
		      var tmp4_safe_receiver_0 = this.y26_1;
		      var value = new EventState(tmp_8, tmp_9, tmp_10, tmp_11, tmp4_safe_receiver_0 == null ? null : tmp4_safe_receiver_0.c2(element));
		      map.s1(element, value);
		    }
		    return map;
		  };
		  function $serializer_87() {
		    $serializer_instance_87 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSEventTimestamp', this, 3);
		    tmp0_serialDesc.pq('created', true);
		    tmp0_serialDesc.pq('updated', true);
		    tmp0_serialDesc.pq('deleted', true);
		    this.a27_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_87).uf = function () {
		    return this.a27_1;
		  };
		  protoOf($serializer_87).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_87).wf = function (decoder) {
		    var tmp0_desc = this.a27_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return CSEventTimestamp_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_87).b27 = function (encoder, value) {
		    var tmp0_desc = this.a27_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.c27_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.c27_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.d27_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.d27_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.e27_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.e27_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_87).vf = function (encoder, value) {
		    return this.b27(encoder, value instanceof CSEventTimestamp ? value : THROW_CCE());
		  };
		  var $serializer_instance_87;
		  function $serializer_getInstance_87() {
		    if ($serializer_instance_87 == null)
		      new $serializer_87();
		    return $serializer_instance_87;
		  }
		  function CSEventTimestamp_init_$Init$(seen1, created, updated, deleted, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_87().a27_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.c27_1 = null;
		    else
		      $this.c27_1 = created;
		    if (0 === (seen1 & 2))
		      $this.d27_1 = null;
		    else
		      $this.d27_1 = updated;
		    if (0 === (seen1 & 4))
		      $this.e27_1 = null;
		    else
		      $this.e27_1 = deleted;
		    return $this;
		  }
		  function CSEventTimestamp_init_$Create$(seen1, created, updated, deleted, serializationConstructorMarker) {
		    return CSEventTimestamp_init_$Init$(seen1, created, updated, deleted, serializationConstructorMarker, objectCreate(protoOf(CSEventTimestamp)));
		  }
		  function CSEventTimestamp() {
		  }
		  protoOf(CSEventTimestamp).toString = function () {
		    return 'CSEventTimestamp(created=' + this.c27_1 + ', updated=' + this.d27_1 + ', deleted=' + this.e27_1 + ')';
		  };
		  protoOf(CSEventTimestamp).hashCode = function () {
		    var result = this.c27_1 == null ? 0 : getStringHashCode(this.c27_1);
		    result = imul(result, 31) + (this.d27_1 == null ? 0 : getStringHashCode(this.d27_1)) | 0;
		    result = imul(result, 31) + (this.e27_1 == null ? 0 : getStringHashCode(this.e27_1)) | 0;
		    return result;
		  };
		  protoOf(CSEventTimestamp).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSEventTimestamp))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSEventTimestamp ? other : THROW_CCE();
		    if (!(this.c27_1 == tmp0_other_with_cast.c27_1))
		      return false;
		    if (!(this.d27_1 == tmp0_other_with_cast.d27_1))
		      return false;
		    if (!(this.e27_1 == tmp0_other_with_cast.e27_1))
		      return false;
		    return true;
		  };
		  function CSConversationEventType_MEMBER_INVITED_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MEMBER_INVITED_instance;
		  }
		  function CSConversationEventType_MEMBER_JOINED_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MEMBER_JOINED_instance;
		  }
		  function CSConversationEventType_MEMBER_LEFT_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MEMBER_LEFT_instance;
		  }
		  function CSConversationEventType_MESSAGE_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MESSAGE_instance;
		  }
		  function CSConversationEventType_EPHEMERAL_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_EPHEMERAL_instance;
		  }
		  function CSConversationEventType_CUSTOM_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_CUSTOM_instance;
		  }
		  function CSConversationEventType_EVENT_DELETE_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_EVENT_DELETE_instance;
		  }
		  function CSConversationEventType_MESSAGE_DELIVERED_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MESSAGE_DELIVERED_instance;
		  }
		  function CSConversationEventType_MESSAGE_REJECTED_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MESSAGE_REJECTED_instance;
		  }
		  function CSConversationEventType_MESSAGE_UNDELIVERABLE_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MESSAGE_UNDELIVERABLE_instance;
		  }
		  function CSConversationEventType_MESSAGE_SUBMITTED_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MESSAGE_SUBMITTED_instance;
		  }
		  function CSConversationEventType_MESSAGE_SEEN_getInstance() {
		    CSConversationEventType_initEntries();
		    return CSConversationEventType_MESSAGE_SEEN_instance;
		  }
		  function $serializer_88() {
		    $serializer_instance_88 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCHangup', this, 5);
		    tmp0_serialDesc.pq('channel', false);
		    tmp0_serialDesc.pq('bandwidth', false);
		    tmp0_serialDesc.pq('reason', false);
		    tmp0_serialDesc.pq('quality', false);
		    tmp0_serialDesc.pq('direction', false);
		    this.f27_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_88).uf = function () {
		    return this.f27_1;
		  };
		  protoOf($serializer_88).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_168(), $serializer_getInstance_175(), $serializer_getInstance_174(), $serializer_getInstance_172(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_88).wf = function (decoder) {
		    var tmp0_desc = this.f27_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_168(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.qj(tmp0_desc, 1, $serializer_getInstance_175(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.qj(tmp0_desc, 2, $serializer_getInstance_174(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.qj(tmp0_desc, 3, $serializer_getInstance_172(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_168(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.qj(tmp0_desc, 1, $serializer_getInstance_175(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.qj(tmp0_desc, 2, $serializer_getInstance_174(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.qj(tmp0_desc, 3, $serializer_getInstance_172(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return RTCHangup_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_88).g27 = function (encoder, value) {
		    var tmp0_desc = this.f27_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_168(), value.h27_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_175(), value.i27_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_174(), value.j27_1);
		    tmp1_output.vk(tmp0_desc, 3, $serializer_getInstance_172(), value.k27_1);
		    tmp1_output.tk(tmp0_desc, 4, value.l27_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_88).vf = function (encoder, value) {
		    return this.g27(encoder, value instanceof RTCHangup ? value : THROW_CCE());
		  };
		  var $serializer_instance_88;
		  function $serializer_getInstance_88() {
		    if ($serializer_instance_88 == null)
		      new $serializer_88();
		    return $serializer_instance_88;
		  }
		  function RTCHangup_init_$Init$(seen1, channel, bandwidth, reason, quality, direction, serializationConstructorMarker, $this) {
		    if (!(31 === (31 & seen1))) {
		      throwMissingFieldException(seen1, 31, $serializer_getInstance_88().f27_1);
		    }
		    $this.h27_1 = channel;
		    $this.i27_1 = bandwidth;
		    $this.j27_1 = reason;
		    $this.k27_1 = quality;
		    $this.l27_1 = direction;
		    return $this;
		  }
		  function RTCHangup_init_$Create$(seen1, channel, bandwidth, reason, quality, direction, serializationConstructorMarker) {
		    return RTCHangup_init_$Init$(seen1, channel, bandwidth, reason, quality, direction, serializationConstructorMarker, objectCreate(protoOf(RTCHangup)));
		  }
		  function RTCHangup() {
		  }
		  protoOf(RTCHangup).toString = function () {
		    return 'RTCHangup(channel=' + this.h27_1 + ', bandwidth=' + this.i27_1 + ', reason=' + this.j27_1 + ', quality=' + this.k27_1 + ', direction=' + this.l27_1 + ')';
		  };
		  protoOf(RTCHangup).hashCode = function () {
		    var result = this.h27_1.hashCode();
		    result = imul(result, 31) + this.i27_1.hashCode() | 0;
		    result = imul(result, 31) + this.j27_1.hashCode() | 0;
		    result = imul(result, 31) + this.k27_1.hashCode() | 0;
		    result = imul(result, 31) + getStringHashCode(this.l27_1) | 0;
		    return result;
		  };
		  protoOf(RTCHangup).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCHangup))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCHangup ? other : THROW_CCE();
		    if (!this.h27_1.equals(tmp0_other_with_cast.h27_1))
		      return false;
		    if (!this.i27_1.equals(tmp0_other_with_cast.i27_1))
		      return false;
		    if (!this.j27_1.equals(tmp0_other_with_cast.j27_1))
		      return false;
		    if (!this.k27_1.equals(tmp0_other_with_cast.k27_1))
		      return false;
		    if (!(this.l27_1 === tmp0_other_with_cast.l27_1))
		      return false;
		    return true;
		  };
		  function Companion_83() {
		  }
		  protoOf(Companion_83).y12 = function () {
		    return $serializer_getInstance_89();
		  };
		  var Companion_instance_84;
		  function Companion_getInstance_85() {
		    return Companion_instance_84;
		  }
		  function $serializer_89() {
		    $serializer_instance_89 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioSayEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.m27_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_89).uf = function () {
		    return this.m27_1;
		  };
		  protoOf($serializer_89).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_117(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_89).wf = function (decoder) {
		    var tmp0_desc = this.m27_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_117(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_117(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return AudioSayEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_89).n27 = function (encoder, value) {
		    var tmp0_desc = this.m27_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_117(), value.o27_1);
		    tmp1_output.ok(tmp0_desc, 1, value.p27_1);
		    tmp1_output.tk(tmp0_desc, 2, value.q27_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.r27_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.r27_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.s27_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_89).vf = function (encoder, value) {
		    return this.n27(encoder, value instanceof AudioSayEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_89;
		  function $serializer_getInstance_89() {
		    if ($serializer_instance_89 == null)
		      new $serializer_89();
		    return $serializer_instance_89;
		  }
		  function AudioSayEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_89().m27_1);
		    }
		    $this.o27_1 = body;
		    $this.p27_1 = id;
		    $this.q27_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.r27_1 = null;
		    else
		      $this.r27_1 = from;
		    $this.s27_1 = type;
		    return $this;
		  }
		  function AudioSayEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return AudioSayEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(AudioSayEvent)));
		  }
		  function AudioSayEvent() {
		  }
		  protoOf(AudioSayEvent).t27 = function () {
		    return this.p27_1;
		  };
		  protoOf(AudioSayEvent).u27 = function () {
		    return this.q27_1;
		  };
		  protoOf(AudioSayEvent).toString = function () {
		    return 'AudioSayEvent(body=' + this.o27_1 + ', id=' + this.p27_1 + ', cid=' + this.q27_1 + ', from=' + this.r27_1 + ', type=' + this.s27_1 + ')';
		  };
		  protoOf(AudioSayEvent).hashCode = function () {
		    var result = this.o27_1.hashCode();
		    result = imul(result, 31) + this.p27_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.q27_1) | 0;
		    result = imul(result, 31) + (this.r27_1 == null ? 0 : getStringHashCode(this.r27_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.s27_1) | 0;
		    return result;
		  };
		  protoOf(AudioSayEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioSayEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioSayEvent ? other : THROW_CCE();
		    if (!this.o27_1.equals(tmp0_other_with_cast.o27_1))
		      return false;
		    if (!(this.p27_1 === tmp0_other_with_cast.p27_1))
		      return false;
		    if (!(this.q27_1 === tmp0_other_with_cast.q27_1))
		      return false;
		    if (!(this.r27_1 == tmp0_other_with_cast.r27_1))
		      return false;
		    if (!(this.s27_1 === tmp0_other_with_cast.s27_1))
		      return false;
		    return true;
		  };
		  function Companion_84() {
		  }
		  protoOf(Companion_84).y12 = function () {
		    return $serializer_getInstance_90();
		  };
		  var Companion_instance_85;
		  function Companion_getInstance_86() {
		    return Companion_instance_85;
		  }
		  function $serializer_90() {
		    $serializer_instance_90 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegStatusUpdateEvent', this, 6);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.v27_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_90).uf = function () {
		    return this.v27_1;
		  };
		  protoOf($serializer_90).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_91(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_90).wf = function (decoder) {
		    var tmp0_desc = this.v27_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_input = decoder.ej(tmp0_desc);
		    if (tmp10_input.uj()) {
		      tmp4_local0 = tmp10_input.qj(tmp0_desc, 0, $serializer_getInstance_91(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp10_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp10_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp10_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp10_input.sj(tmp0_desc, 4, $serializer_getInstance_54(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp10_input.oj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp10_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp10_input.qj(tmp0_desc, 0, $serializer_getInstance_91(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp10_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp10_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp10_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp10_input.sj(tmp0_desc, 4, $serializer_getInstance_54(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp10_input.oj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp10_input.fj(tmp0_desc);
		    return LegStatusUpdateEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
		  };
		  protoOf($serializer_90).w27 = function (encoder, value) {
		    var tmp0_desc = this.v27_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_91(), value.x27_1);
		    tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.y27_1);
		    tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.z27_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.a28_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.a28_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.b28_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, $serializer_getInstance_54(), value.b28_1);
		    }
		    tmp1_output.tk(tmp0_desc, 5, value.c28_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_90).vf = function (encoder, value) {
		    return this.w27(encoder, value instanceof LegStatusUpdateEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_90;
		  function $serializer_getInstance_90() {
		    if ($serializer_instance_90 == null)
		      new $serializer_90();
		    return $serializer_instance_90;
		  }
		  function LegStatusUpdateEvent_init_$Init$(seen1, body, id, cid, from, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(39 === (39 & seen1))) {
		      throwMissingFieldException(seen1, 39, $serializer_getInstance_90().v27_1);
		    }
		    $this.x27_1 = body;
		    $this.y27_1 = id;
		    $this.z27_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.a28_1 = null;
		    else
		      $this.a28_1 = from;
		    if (0 === (seen1 & 16))
		      $this.b28_1 = null;
		    else
		      $this.b28_1 = _embedded;
		    $this.c28_1 = type;
		    return $this;
		  }
		  function LegStatusUpdateEvent_init_$Create$(seen1, body, id, cid, from, _embedded, type, serializationConstructorMarker) {
		    return LegStatusUpdateEvent_init_$Init$(seen1, body, id, cid, from, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(LegStatusUpdateEvent)));
		  }
		  function LegStatusUpdateEvent() {
		  }
		  protoOf(LegStatusUpdateEvent).t27 = function () {
		    return this.y27_1;
		  };
		  protoOf(LegStatusUpdateEvent).u27 = function () {
		    return this.z27_1;
		  };
		  function Companion_85() {
		    Companion_instance_86 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.d28_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_118())];
		  }
		  var Companion_instance_86;
		  function Companion_getInstance_87() {
		    if (Companion_instance_86 == null)
		      new Companion_85();
		    return Companion_instance_86;
		  }
		  function $serializer_91() {
		    $serializer_instance_91 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegStatusUpdate', this, 5);
		    tmp0_serialDesc.pq('direction', false);
		    tmp0_serialDesc.pq('leg_id', false);
		    tmp0_serialDesc.pq('status', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('statusHistory', false);
		    this.e28_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_91).uf = function () {
		    return this.e28_1;
		  };
		  protoOf($serializer_91).er = function () {
		    var tmp0_cached = Companion_getInstance_87().d28_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4]];
		  };
		  protoOf($serializer_91).wf = function (decoder) {
		    var tmp0_desc = this.e28_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    var tmp10_cached = Companion_getInstance_87().d28_1;
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.qj(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return LegStatusUpdate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_91).f28 = function (encoder, value) {
		    var tmp0_desc = this.e28_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_87().d28_1;
		    tmp1_output.tk(tmp0_desc, 0, value.g28_1);
		    tmp1_output.tk(tmp0_desc, 1, value.h28_1);
		    tmp1_output.tk(tmp0_desc, 2, value.i28_1);
		    tmp1_output.tk(tmp0_desc, 3, value.j28_1);
		    tmp1_output.vk(tmp0_desc, 4, tmp2_cached[4], value.k28_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_91).vf = function (encoder, value) {
		    return this.f28(encoder, value instanceof LegStatusUpdate ? value : THROW_CCE());
		  };
		  var $serializer_instance_91;
		  function $serializer_getInstance_91() {
		    if ($serializer_instance_91 == null)
		      new $serializer_91();
		    return $serializer_instance_91;
		  }
		  function LegStatusUpdate_init_$Init$(seen1, direction, leg_id, status, type, statusHistory, serializationConstructorMarker, $this) {
		    if (!(31 === (31 & seen1))) {
		      throwMissingFieldException(seen1, 31, $serializer_getInstance_91().e28_1);
		    }
		    $this.g28_1 = direction;
		    $this.h28_1 = leg_id;
		    $this.i28_1 = status;
		    $this.j28_1 = type;
		    $this.k28_1 = statusHistory;
		    return $this;
		  }
		  function LegStatusUpdate_init_$Create$(seen1, direction, leg_id, status, type, statusHistory, serializationConstructorMarker) {
		    return LegStatusUpdate_init_$Init$(seen1, direction, leg_id, status, type, statusHistory, serializationConstructorMarker, objectCreate(protoOf(LegStatusUpdate)));
		  }
		  function LegStatusUpdate() {
		  }
		  protoOf(LegStatusUpdate).toString = function () {
		    return 'LegStatusUpdate(direction=' + this.g28_1 + ', leg_id=' + this.h28_1 + ', status=' + this.i28_1 + ', type=' + this.j28_1 + ', statusHistory=' + this.k28_1 + ')';
		  };
		  protoOf(LegStatusUpdate).hashCode = function () {
		    var result = getStringHashCode(this.g28_1);
		    result = imul(result, 31) + getStringHashCode(this.h28_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.i28_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.j28_1) | 0;
		    result = imul(result, 31) + hashCode(this.k28_1) | 0;
		    return result;
		  };
		  protoOf(LegStatusUpdate).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegStatusUpdate))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegStatusUpdate ? other : THROW_CCE();
		    if (!(this.g28_1 === tmp0_other_with_cast.g28_1))
		      return false;
		    if (!(this.h28_1 === tmp0_other_with_cast.h28_1))
		      return false;
		    if (!(this.i28_1 === tmp0_other_with_cast.i28_1))
		      return false;
		    if (!(this.j28_1 === tmp0_other_with_cast.j28_1))
		      return false;
		    if (!equals(this.k28_1, tmp0_other_with_cast.k28_1))
		      return false;
		    return true;
		  };
		  function Companion_86() {
		  }
		  protoOf(Companion_86).y12 = function () {
		    return $serializer_getInstance_92();
		  };
		  var Companion_instance_87;
		  function Companion_getInstance_88() {
		    return Companion_instance_87;
		  }
		  function $serializer_92() {
		    $serializer_instance_92 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioMuteOnEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.l28_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_92).uf = function () {
		    return this.l28_1;
		  };
		  protoOf($serializer_92).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_93(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_92).wf = function (decoder) {
		    var tmp0_desc = this.l28_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_93(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_93(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return AudioMuteOnEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_92).m28 = function (encoder, value) {
		    var tmp0_desc = this.l28_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_93(), value.n28_1);
		    tmp1_output.ok(tmp0_desc, 1, value.o28_1);
		    tmp1_output.tk(tmp0_desc, 2, value.p28_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.q28_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.q28_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.r28_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_92).vf = function (encoder, value) {
		    return this.m28(encoder, value instanceof AudioMuteOnEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_92;
		  function $serializer_getInstance_92() {
		    if ($serializer_instance_92 == null)
		      new $serializer_92();
		    return $serializer_instance_92;
		  }
		  function AudioMuteOnEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_92().l28_1);
		    }
		    $this.n28_1 = body;
		    $this.o28_1 = id;
		    $this.p28_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.q28_1 = null;
		    else
		      $this.q28_1 = from;
		    $this.r28_1 = type;
		    return $this;
		  }
		  function AudioMuteOnEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return AudioMuteOnEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(AudioMuteOnEvent)));
		  }
		  function AudioMuteOnEvent() {
		  }
		  protoOf(AudioMuteOnEvent).t27 = function () {
		    return this.o28_1;
		  };
		  protoOf(AudioMuteOnEvent).u27 = function () {
		    return this.p28_1;
		  };
		  protoOf(AudioMuteOnEvent).toString = function () {
		    return 'AudioMuteOnEvent(body=' + this.n28_1 + ', id=' + this.o28_1 + ', cid=' + this.p28_1 + ', from=' + this.q28_1 + ', type=' + this.r28_1 + ')';
		  };
		  protoOf(AudioMuteOnEvent).hashCode = function () {
		    var result = this.n28_1.hashCode();
		    result = imul(result, 31) + this.o28_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.p28_1) | 0;
		    result = imul(result, 31) + (this.q28_1 == null ? 0 : getStringHashCode(this.q28_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.r28_1) | 0;
		    return result;
		  };
		  protoOf(AudioMuteOnEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioMuteOnEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioMuteOnEvent ? other : THROW_CCE();
		    if (!this.n28_1.equals(tmp0_other_with_cast.n28_1))
		      return false;
		    if (!(this.o28_1 === tmp0_other_with_cast.o28_1))
		      return false;
		    if (!(this.p28_1 === tmp0_other_with_cast.p28_1))
		      return false;
		    if (!(this.q28_1 == tmp0_other_with_cast.q28_1))
		      return false;
		    if (!(this.r28_1 === tmp0_other_with_cast.r28_1))
		      return false;
		    return true;
		  };
		  function $serializer_93() {
		    $serializer_instance_93 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioMuteBody', this, 1);
		    tmp0_serialDesc.pq('rtc_id', false);
		    this.s28_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_93).uf = function () {
		    return this.s28_1;
		  };
		  protoOf($serializer_93).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_93).wf = function (decoder) {
		    var tmp0_desc = this.s28_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return AudioMuteBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_93).t28 = function (encoder, value) {
		    var tmp0_desc = this.s28_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.u28_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_93).vf = function (encoder, value) {
		    return this.t28(encoder, value instanceof AudioMuteBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_93;
		  function $serializer_getInstance_93() {
		    if ($serializer_instance_93 == null)
		      new $serializer_93();
		    return $serializer_instance_93;
		  }
		  function AudioMuteBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_93().s28_1);
		    }
		    $this.u28_1 = rtc_id;
		    return $this;
		  }
		  function AudioMuteBody_init_$Create$(seen1, rtc_id, serializationConstructorMarker) {
		    return AudioMuteBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, objectCreate(protoOf(AudioMuteBody)));
		  }
		  function AudioMuteBody() {
		  }
		  protoOf(AudioMuteBody).toString = function () {
		    return 'AudioMuteBody(rtc_id=' + this.u28_1 + ')';
		  };
		  protoOf(AudioMuteBody).hashCode = function () {
		    return getStringHashCode(this.u28_1);
		  };
		  protoOf(AudioMuteBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioMuteBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioMuteBody ? other : THROW_CCE();
		    if (!(this.u28_1 === tmp0_other_with_cast.u28_1))
		      return false;
		    return true;
		  };
		  function Companion_87() {
		  }
		  protoOf(Companion_87).y12 = function () {
		    return $serializer_getInstance_94();
		  };
		  var Companion_instance_88;
		  function Companion_getInstance_89() {
		    return Companion_instance_88;
		  }
		  function $serializer_94() {
		    $serializer_instance_94 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioMuteOffEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.v28_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_94).uf = function () {
		    return this.v28_1;
		  };
		  protoOf($serializer_94).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_93(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_94).wf = function (decoder) {
		    var tmp0_desc = this.v28_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_93(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_93(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return AudioMuteOffEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_94).w28 = function (encoder, value) {
		    var tmp0_desc = this.v28_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_93(), value.x28_1);
		    tmp1_output.ok(tmp0_desc, 1, value.y28_1);
		    tmp1_output.tk(tmp0_desc, 2, value.z28_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.a29_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.a29_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.b29_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_94).vf = function (encoder, value) {
		    return this.w28(encoder, value instanceof AudioMuteOffEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_94;
		  function $serializer_getInstance_94() {
		    if ($serializer_instance_94 == null)
		      new $serializer_94();
		    return $serializer_instance_94;
		  }
		  function AudioMuteOffEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_94().v28_1);
		    }
		    $this.x28_1 = body;
		    $this.y28_1 = id;
		    $this.z28_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.a29_1 = null;
		    else
		      $this.a29_1 = from;
		    $this.b29_1 = type;
		    return $this;
		  }
		  function AudioMuteOffEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return AudioMuteOffEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(AudioMuteOffEvent)));
		  }
		  function AudioMuteOffEvent() {
		  }
		  protoOf(AudioMuteOffEvent).t27 = function () {
		    return this.y28_1;
		  };
		  protoOf(AudioMuteOffEvent).u27 = function () {
		    return this.z28_1;
		  };
		  protoOf(AudioMuteOffEvent).toString = function () {
		    return 'AudioMuteOffEvent(body=' + this.x28_1 + ', id=' + this.y28_1 + ', cid=' + this.z28_1 + ', from=' + this.a29_1 + ', type=' + this.b29_1 + ')';
		  };
		  protoOf(AudioMuteOffEvent).hashCode = function () {
		    var result = this.x28_1.hashCode();
		    result = imul(result, 31) + this.y28_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.z28_1) | 0;
		    result = imul(result, 31) + (this.a29_1 == null ? 0 : getStringHashCode(this.a29_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.b29_1) | 0;
		    return result;
		  };
		  protoOf(AudioMuteOffEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioMuteOffEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioMuteOffEvent ? other : THROW_CCE();
		    if (!this.x28_1.equals(tmp0_other_with_cast.x28_1))
		      return false;
		    if (!(this.y28_1 === tmp0_other_with_cast.y28_1))
		      return false;
		    if (!(this.z28_1 === tmp0_other_with_cast.z28_1))
		      return false;
		    if (!(this.a29_1 == tmp0_other_with_cast.a29_1))
		      return false;
		    if (!(this.b29_1 === tmp0_other_with_cast.b29_1))
		      return false;
		    return true;
		  };
		  function Companion_88() {
		  }
		  protoOf(Companion_88).y12 = function () {
		    return $serializer_getInstance_95();
		  };
		  var Companion_instance_89;
		  function Companion_getInstance_90() {
		    return Companion_instance_89;
		  }
		  function $serializer_95() {
		    $serializer_instance_95 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioEarmuffOnEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.c29_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_95).uf = function () {
		    return this.c29_1;
		  };
		  protoOf($serializer_95).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_96(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_95).wf = function (decoder) {
		    var tmp0_desc = this.c29_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_96(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_96(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return AudioEarmuffOnEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_95).d29 = function (encoder, value) {
		    var tmp0_desc = this.c29_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_96(), value.e29_1);
		    tmp1_output.ok(tmp0_desc, 1, value.f29_1);
		    tmp1_output.tk(tmp0_desc, 2, value.g29_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.h29_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.h29_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.i29_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_95).vf = function (encoder, value) {
		    return this.d29(encoder, value instanceof AudioEarmuffOnEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_95;
		  function $serializer_getInstance_95() {
		    if ($serializer_instance_95 == null)
		      new $serializer_95();
		    return $serializer_instance_95;
		  }
		  function AudioEarmuffOnEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_95().c29_1);
		    }
		    $this.e29_1 = body;
		    $this.f29_1 = id;
		    $this.g29_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.h29_1 = null;
		    else
		      $this.h29_1 = from;
		    $this.i29_1 = type;
		    return $this;
		  }
		  function AudioEarmuffOnEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return AudioEarmuffOnEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(AudioEarmuffOnEvent)));
		  }
		  function AudioEarmuffOnEvent() {
		  }
		  protoOf(AudioEarmuffOnEvent).t27 = function () {
		    return this.f29_1;
		  };
		  protoOf(AudioEarmuffOnEvent).u27 = function () {
		    return this.g29_1;
		  };
		  protoOf(AudioEarmuffOnEvent).toString = function () {
		    return 'AudioEarmuffOnEvent(body=' + this.e29_1 + ', id=' + this.f29_1 + ', cid=' + this.g29_1 + ', from=' + this.h29_1 + ', type=' + this.i29_1 + ')';
		  };
		  protoOf(AudioEarmuffOnEvent).hashCode = function () {
		    var result = this.e29_1.hashCode();
		    result = imul(result, 31) + this.f29_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.g29_1) | 0;
		    result = imul(result, 31) + (this.h29_1 == null ? 0 : getStringHashCode(this.h29_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.i29_1) | 0;
		    return result;
		  };
		  protoOf(AudioEarmuffOnEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioEarmuffOnEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioEarmuffOnEvent ? other : THROW_CCE();
		    if (!this.e29_1.equals(tmp0_other_with_cast.e29_1))
		      return false;
		    if (!(this.f29_1 === tmp0_other_with_cast.f29_1))
		      return false;
		    if (!(this.g29_1 === tmp0_other_with_cast.g29_1))
		      return false;
		    if (!(this.h29_1 == tmp0_other_with_cast.h29_1))
		      return false;
		    if (!(this.i29_1 === tmp0_other_with_cast.i29_1))
		      return false;
		    return true;
		  };
		  function $serializer_96() {
		    $serializer_instance_96 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioEarmuffBody', this, 1);
		    tmp0_serialDesc.pq('rtc_id', false);
		    this.j29_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_96).uf = function () {
		    return this.j29_1;
		  };
		  protoOf($serializer_96).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_96).wf = function (decoder) {
		    var tmp0_desc = this.j29_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return AudioEarmuffBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_96).k29 = function (encoder, value) {
		    var tmp0_desc = this.j29_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.l29_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_96).vf = function (encoder, value) {
		    return this.k29(encoder, value instanceof AudioEarmuffBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_96;
		  function $serializer_getInstance_96() {
		    if ($serializer_instance_96 == null)
		      new $serializer_96();
		    return $serializer_instance_96;
		  }
		  function AudioEarmuffBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_96().j29_1);
		    }
		    $this.l29_1 = rtc_id;
		    return $this;
		  }
		  function AudioEarmuffBody_init_$Create$(seen1, rtc_id, serializationConstructorMarker) {
		    return AudioEarmuffBody_init_$Init$(seen1, rtc_id, serializationConstructorMarker, objectCreate(protoOf(AudioEarmuffBody)));
		  }
		  function AudioEarmuffBody() {
		  }
		  protoOf(AudioEarmuffBody).toString = function () {
		    return 'AudioEarmuffBody(rtc_id=' + this.l29_1 + ')';
		  };
		  protoOf(AudioEarmuffBody).hashCode = function () {
		    return getStringHashCode(this.l29_1);
		  };
		  protoOf(AudioEarmuffBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioEarmuffBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioEarmuffBody ? other : THROW_CCE();
		    if (!(this.l29_1 === tmp0_other_with_cast.l29_1))
		      return false;
		    return true;
		  };
		  function Companion_89() {
		  }
		  protoOf(Companion_89).y12 = function () {
		    return $serializer_getInstance_97();
		  };
		  var Companion_instance_90;
		  function Companion_getInstance_91() {
		    return Companion_instance_90;
		  }
		  function $serializer_97() {
		    $serializer_instance_97 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioEarmuffOffEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.m29_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_97).uf = function () {
		    return this.m29_1;
		  };
		  protoOf($serializer_97).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_96(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_97).wf = function (decoder) {
		    var tmp0_desc = this.m29_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_96(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_96(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return AudioEarmuffOffEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_97).n29 = function (encoder, value) {
		    var tmp0_desc = this.m29_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_96(), value.o29_1);
		    tmp1_output.ok(tmp0_desc, 1, value.p29_1);
		    tmp1_output.tk(tmp0_desc, 2, value.q29_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.r29_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.r29_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.s29_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_97).vf = function (encoder, value) {
		    return this.n29(encoder, value instanceof AudioEarmuffOffEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_97;
		  function $serializer_getInstance_97() {
		    if ($serializer_instance_97 == null)
		      new $serializer_97();
		    return $serializer_instance_97;
		  }
		  function AudioEarmuffOffEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_97().m29_1);
		    }
		    $this.o29_1 = body;
		    $this.p29_1 = id;
		    $this.q29_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.r29_1 = null;
		    else
		      $this.r29_1 = from;
		    $this.s29_1 = type;
		    return $this;
		  }
		  function AudioEarmuffOffEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return AudioEarmuffOffEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(AudioEarmuffOffEvent)));
		  }
		  function AudioEarmuffOffEvent() {
		  }
		  protoOf(AudioEarmuffOffEvent).t27 = function () {
		    return this.p29_1;
		  };
		  protoOf(AudioEarmuffOffEvent).u27 = function () {
		    return this.q29_1;
		  };
		  protoOf(AudioEarmuffOffEvent).toString = function () {
		    return 'AudioEarmuffOffEvent(body=' + this.o29_1 + ', id=' + this.p29_1 + ', cid=' + this.q29_1 + ', from=' + this.r29_1 + ', type=' + this.s29_1 + ')';
		  };
		  protoOf(AudioEarmuffOffEvent).hashCode = function () {
		    var result = this.o29_1.hashCode();
		    result = imul(result, 31) + this.p29_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.q29_1) | 0;
		    result = imul(result, 31) + (this.r29_1 == null ? 0 : getStringHashCode(this.r29_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.s29_1) | 0;
		    return result;
		  };
		  protoOf(AudioEarmuffOffEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioEarmuffOffEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioEarmuffOffEvent ? other : THROW_CCE();
		    if (!this.o29_1.equals(tmp0_other_with_cast.o29_1))
		      return false;
		    if (!(this.p29_1 === tmp0_other_with_cast.p29_1))
		      return false;
		    if (!(this.q29_1 === tmp0_other_with_cast.q29_1))
		      return false;
		    if (!(this.r29_1 == tmp0_other_with_cast.r29_1))
		      return false;
		    if (!(this.s29_1 === tmp0_other_with_cast.s29_1))
		      return false;
		    return true;
		  };
		  function Companion_90() {
		  }
		  protoOf(Companion_90).y12 = function () {
		    return $serializer_getInstance_98();
		  };
		  var Companion_instance_91;
		  function Companion_getInstance_92() {
		    return Companion_instance_91;
		  }
		  function $serializer_98() {
		    $serializer_instance_98 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioDTMFEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.t29_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_98).uf = function () {
		    return this.t29_1;
		  };
		  protoOf($serializer_98).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_99(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_98).wf = function (decoder) {
		    var tmp0_desc = this.t29_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_99(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_99(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return AudioDTMFEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_98).u29 = function (encoder, value) {
		    var tmp0_desc = this.t29_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_99(), value.v29_1);
		    tmp1_output.ok(tmp0_desc, 1, value.w29_1);
		    tmp1_output.tk(tmp0_desc, 2, value.x29_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.y29_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.y29_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.z29_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_98).vf = function (encoder, value) {
		    return this.u29(encoder, value instanceof AudioDTMFEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_98;
		  function $serializer_getInstance_98() {
		    if ($serializer_instance_98 == null)
		      new $serializer_98();
		    return $serializer_instance_98;
		  }
		  function AudioDTMFEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_98().t29_1);
		    }
		    $this.v29_1 = body;
		    $this.w29_1 = id;
		    $this.x29_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.y29_1 = null;
		    else
		      $this.y29_1 = from;
		    $this.z29_1 = type;
		    return $this;
		  }
		  function AudioDTMFEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return AudioDTMFEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(AudioDTMFEvent)));
		  }
		  function AudioDTMFEvent() {
		  }
		  protoOf(AudioDTMFEvent).t27 = function () {
		    return this.w29_1;
		  };
		  protoOf(AudioDTMFEvent).u27 = function () {
		    return this.x29_1;
		  };
		  protoOf(AudioDTMFEvent).toString = function () {
		    return 'AudioDTMFEvent(body=' + this.v29_1 + ', id=' + this.w29_1 + ', cid=' + this.x29_1 + ', from=' + this.y29_1 + ', type=' + this.z29_1 + ')';
		  };
		  protoOf(AudioDTMFEvent).hashCode = function () {
		    var result = this.v29_1.hashCode();
		    result = imul(result, 31) + this.w29_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.x29_1) | 0;
		    result = imul(result, 31) + (this.y29_1 == null ? 0 : getStringHashCode(this.y29_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.z29_1) | 0;
		    return result;
		  };
		  protoOf(AudioDTMFEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioDTMFEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioDTMFEvent ? other : THROW_CCE();
		    if (!this.v29_1.equals(tmp0_other_with_cast.v29_1))
		      return false;
		    if (!(this.w29_1 === tmp0_other_with_cast.w29_1))
		      return false;
		    if (!(this.x29_1 === tmp0_other_with_cast.x29_1))
		      return false;
		    if (!(this.y29_1 == tmp0_other_with_cast.y29_1))
		      return false;
		    if (!(this.z29_1 === tmp0_other_with_cast.z29_1))
		      return false;
		    return true;
		  };
		  function $serializer_99() {
		    $serializer_instance_99 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioDTMFBody', this, 2);
		    tmp0_serialDesc.pq('digit', false);
		    tmp0_serialDesc.pq('channel', false);
		    this.a2a_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_99).uf = function () {
		    return this.a2a_1;
		  };
		  protoOf($serializer_99).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_167()];
		  };
		  protoOf($serializer_99).wf = function (decoder) {
		    var tmp0_desc = this.a2a_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_167(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, $serializer_getInstance_167(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return AudioDTMFBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_99).b2a = function (encoder, value) {
		    var tmp0_desc = this.a2a_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.c2a_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_167(), value.d2a_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_99).vf = function (encoder, value) {
		    return this.b2a(encoder, value instanceof AudioDTMFBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_99;
		  function $serializer_getInstance_99() {
		    if ($serializer_instance_99 == null)
		      new $serializer_99();
		    return $serializer_instance_99;
		  }
		  function AudioDTMFBody_init_$Init$(seen1, digit, channel, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_99().a2a_1);
		    }
		    $this.c2a_1 = digit;
		    $this.d2a_1 = channel;
		    return $this;
		  }
		  function AudioDTMFBody_init_$Create$(seen1, digit, channel, serializationConstructorMarker) {
		    return AudioDTMFBody_init_$Init$(seen1, digit, channel, serializationConstructorMarker, objectCreate(protoOf(AudioDTMFBody)));
		  }
		  function AudioDTMFBody() {
		  }
		  protoOf(AudioDTMFBody).toString = function () {
		    return 'AudioDTMFBody(digit=' + this.c2a_1 + ', channel=' + this.d2a_1 + ')';
		  };
		  protoOf(AudioDTMFBody).hashCode = function () {
		    var result = getStringHashCode(this.c2a_1);
		    result = imul(result, 31) + this.d2a_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(AudioDTMFBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioDTMFBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioDTMFBody ? other : THROW_CCE();
		    if (!(this.c2a_1 === tmp0_other_with_cast.c2a_1))
		      return false;
		    if (!this.d2a_1.equals(tmp0_other_with_cast.d2a_1))
		      return false;
		    return true;
		  };
		  function Companion_91() {
		  }
		  protoOf(Companion_91).y12 = function () {
		    return $serializer_getInstance_100();
		  };
		  var Companion_instance_92;
		  function Companion_getInstance_93() {
		    return Companion_instance_92;
		  }
		  function $serializer_100() {
		    $serializer_instance_100 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCHangupEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.e2a_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_100).uf = function () {
		    return this.e2a_1;
		  };
		  protoOf($serializer_100).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_88(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_100).wf = function (decoder) {
		    var tmp0_desc = this.e2a_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_88(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_88(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return RTCHangupEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_100).f2a = function (encoder, value) {
		    var tmp0_desc = this.e2a_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_88(), value.g2a_1);
		    tmp1_output.ok(tmp0_desc, 1, value.h2a_1);
		    tmp1_output.tk(tmp0_desc, 2, value.i2a_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.j2a_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.j2a_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.k2a_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_100).vf = function (encoder, value) {
		    return this.f2a(encoder, value instanceof RTCHangupEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_100;
		  function $serializer_getInstance_100() {
		    if ($serializer_instance_100 == null)
		      new $serializer_100();
		    return $serializer_instance_100;
		  }
		  function RTCHangupEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_100().e2a_1);
		    }
		    $this.g2a_1 = body;
		    $this.h2a_1 = id;
		    $this.i2a_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.j2a_1 = null;
		    else
		      $this.j2a_1 = from;
		    $this.k2a_1 = type;
		    return $this;
		  }
		  function RTCHangupEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return RTCHangupEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(RTCHangupEvent)));
		  }
		  function RTCHangupEvent() {
		  }
		  protoOf(RTCHangupEvent).t27 = function () {
		    return this.h2a_1;
		  };
		  protoOf(RTCHangupEvent).u27 = function () {
		    return this.i2a_1;
		  };
		  protoOf(RTCHangupEvent).toString = function () {
		    return 'RTCHangupEvent(body=' + this.g2a_1 + ', id=' + this.h2a_1 + ', cid=' + this.i2a_1 + ', from=' + this.j2a_1 + ', type=' + this.k2a_1 + ')';
		  };
		  protoOf(RTCHangupEvent).hashCode = function () {
		    var result = this.g2a_1.hashCode();
		    result = imul(result, 31) + this.h2a_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.i2a_1) | 0;
		    result = imul(result, 31) + (this.j2a_1 == null ? 0 : getStringHashCode(this.j2a_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.k2a_1) | 0;
		    return result;
		  };
		  protoOf(RTCHangupEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCHangupEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCHangupEvent ? other : THROW_CCE();
		    if (!this.g2a_1.equals(tmp0_other_with_cast.g2a_1))
		      return false;
		    if (!(this.h2a_1 === tmp0_other_with_cast.h2a_1))
		      return false;
		    if (!(this.i2a_1 === tmp0_other_with_cast.i2a_1))
		      return false;
		    if (!(this.j2a_1 == tmp0_other_with_cast.j2a_1))
		      return false;
		    if (!(this.k2a_1 === tmp0_other_with_cast.k2a_1))
		      return false;
		    return true;
		  };
		  function Companion_92() {
		  }
		  protoOf(Companion_92).y12 = function () {
		    return $serializer_getInstance_101();
		  };
		  var Companion_instance_93;
		  function Companion_getInstance_94() {
		    return Companion_instance_93;
		  }
		  function $serializer_101() {
		    $serializer_instance_101 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCTransferEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.l2a_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_101).uf = function () {
		    return this.l2a_1;
		  };
		  protoOf($serializer_101).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_102(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_101).wf = function (decoder) {
		    var tmp0_desc = this.l2a_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_102(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_102(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return RTCTransferEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_101).m2a = function (encoder, value) {
		    var tmp0_desc = this.l2a_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_102(), value.n2a_1);
		    tmp1_output.ok(tmp0_desc, 1, value.o2a_1);
		    tmp1_output.tk(tmp0_desc, 2, value.p2a_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.q2a_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.q2a_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.r2a_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_101).vf = function (encoder, value) {
		    return this.m2a(encoder, value instanceof RTCTransferEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_101;
		  function $serializer_getInstance_101() {
		    if ($serializer_instance_101 == null)
		      new $serializer_101();
		    return $serializer_instance_101;
		  }
		  function RTCTransferEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_101().l2a_1);
		    }
		    $this.n2a_1 = body;
		    $this.o2a_1 = id;
		    $this.p2a_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.q2a_1 = null;
		    else
		      $this.q2a_1 = from;
		    $this.r2a_1 = type;
		    return $this;
		  }
		  function RTCTransferEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return RTCTransferEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(RTCTransferEvent)));
		  }
		  function RTCTransferEvent() {
		  }
		  protoOf(RTCTransferEvent).t27 = function () {
		    return this.o2a_1;
		  };
		  protoOf(RTCTransferEvent).u27 = function () {
		    return this.p2a_1;
		  };
		  protoOf(RTCTransferEvent).toString = function () {
		    return 'RTCTransferEvent(body=' + this.n2a_1 + ', id=' + this.o2a_1 + ', cid=' + this.p2a_1 + ', from=' + this.q2a_1 + ', type=' + this.r2a_1 + ')';
		  };
		  protoOf(RTCTransferEvent).hashCode = function () {
		    var result = this.n2a_1.hashCode();
		    result = imul(result, 31) + this.o2a_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.p2a_1) | 0;
		    result = imul(result, 31) + (this.q2a_1 == null ? 0 : getStringHashCode(this.q2a_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.r2a_1) | 0;
		    return result;
		  };
		  protoOf(RTCTransferEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCTransferEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCTransferEvent ? other : THROW_CCE();
		    if (!this.n2a_1.equals(tmp0_other_with_cast.n2a_1))
		      return false;
		    if (!(this.o2a_1 === tmp0_other_with_cast.o2a_1))
		      return false;
		    if (!(this.p2a_1 === tmp0_other_with_cast.p2a_1))
		      return false;
		    if (!(this.q2a_1 == tmp0_other_with_cast.q2a_1))
		      return false;
		    if (!(this.r2a_1 === tmp0_other_with_cast.r2a_1))
		      return false;
		    return true;
		  };
		  function $serializer_102() {
		    $serializer_instance_102 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCTransfer', this, 4);
		    tmp0_serialDesc.pq('was_member', false);
		    tmp0_serialDesc.pq('user_id', false);
		    tmp0_serialDesc.pq('transferred_from', false);
		    tmp0_serialDesc.pq('channel', false);
		    this.s2a_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_102).uf = function () {
		    return this.s2a_1;
		  };
		  protoOf($serializer_102).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_168()];
		  };
		  protoOf($serializer_102).wf = function (decoder) {
		    var tmp0_desc = this.s2a_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_168(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_168(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return RTCTransfer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_102).t2a = function (encoder, value) {
		    var tmp0_desc = this.s2a_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.u2a_1);
		    tmp1_output.tk(tmp0_desc, 1, value.v2a_1);
		    tmp1_output.tk(tmp0_desc, 2, value.w2a_1);
		    tmp1_output.vk(tmp0_desc, 3, $serializer_getInstance_168(), value.x2a_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_102).vf = function (encoder, value) {
		    return this.t2a(encoder, value instanceof RTCTransfer ? value : THROW_CCE());
		  };
		  var $serializer_instance_102;
		  function $serializer_getInstance_102() {
		    if ($serializer_instance_102 == null)
		      new $serializer_102();
		    return $serializer_instance_102;
		  }
		  function RTCTransfer_init_$Init$(seen1, was_member, user_id, transferred_from, channel, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_102().s2a_1);
		    }
		    $this.u2a_1 = was_member;
		    $this.v2a_1 = user_id;
		    $this.w2a_1 = transferred_from;
		    $this.x2a_1 = channel;
		    return $this;
		  }
		  function RTCTransfer_init_$Create$(seen1, was_member, user_id, transferred_from, channel, serializationConstructorMarker) {
		    return RTCTransfer_init_$Init$(seen1, was_member, user_id, transferred_from, channel, serializationConstructorMarker, objectCreate(protoOf(RTCTransfer)));
		  }
		  function RTCTransfer() {
		  }
		  protoOf(RTCTransfer).toString = function () {
		    return 'RTCTransfer(was_member=' + this.u2a_1 + ', user_id=' + this.v2a_1 + ', transferred_from=' + this.w2a_1 + ', channel=' + this.x2a_1 + ')';
		  };
		  protoOf(RTCTransfer).hashCode = function () {
		    var result = getStringHashCode(this.u2a_1);
		    result = imul(result, 31) + getStringHashCode(this.v2a_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.w2a_1) | 0;
		    result = imul(result, 31) + this.x2a_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(RTCTransfer).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCTransfer))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCTransfer ? other : THROW_CCE();
		    if (!(this.u2a_1 === tmp0_other_with_cast.u2a_1))
		      return false;
		    if (!(this.v2a_1 === tmp0_other_with_cast.v2a_1))
		      return false;
		    if (!(this.w2a_1 === tmp0_other_with_cast.w2a_1))
		      return false;
		    if (!this.x2a_1.equals(tmp0_other_with_cast.x2a_1))
		      return false;
		    return true;
		  };
		  function $serializer_103() {
		    $serializer_instance_103 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberInvited', this, 7);
		    tmp0_serialDesc.pq('conversation', false);
		    tmp0_serialDesc.pq('member_id', false);
		    tmp0_serialDesc.pq('user', false);
		    tmp0_serialDesc.pq('media', false);
		    tmp0_serialDesc.pq('channel', false);
		    tmp0_serialDesc.pq('invited_by', true);
		    tmp0_serialDesc.pq('sdp', true);
		    this.y2a_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_103).uf = function () {
		    return this.y2a_1;
		  };
		  protoOf($serializer_103).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_169(), StringSerializer_getInstance(), $serializer_getInstance_51(), $serializer_getInstance_171(), $serializer_getInstance_168(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_103).wf = function (decoder) {
		    var tmp0_desc = this.y2a_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_169(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.qj(tmp0_desc, 2, $serializer_getInstance_51(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.qj(tmp0_desc, 3, $serializer_getInstance_171(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.qj(tmp0_desc, 4, $serializer_getInstance_168(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.sj(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_169(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.qj(tmp0_desc, 2, $serializer_getInstance_51(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.qj(tmp0_desc, 3, $serializer_getInstance_171(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.qj(tmp0_desc, 4, $serializer_getInstance_168(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.sj(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return MemberInvited_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_103).z2a = function (encoder, value) {
		    var tmp0_desc = this.y2a_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_169(), value.a2b_1);
		    tmp1_output.tk(tmp0_desc, 1, value.b2b_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_51(), value.c2b_1);
		    tmp1_output.vk(tmp0_desc, 3, $serializer_getInstance_171(), value.d2b_1);
		    tmp1_output.vk(tmp0_desc, 4, $serializer_getInstance_168(), value.e2b_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.f2b_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, StringSerializer_getInstance(), value.f2b_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.g2b_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, StringSerializer_getInstance(), value.g2b_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_103).vf = function (encoder, value) {
		    return this.z2a(encoder, value instanceof MemberInvited ? value : THROW_CCE());
		  };
		  var $serializer_instance_103;
		  function $serializer_getInstance_103() {
		    if ($serializer_instance_103 == null)
		      new $serializer_103();
		    return $serializer_instance_103;
		  }
		  function MemberInvited_init_$Init$(seen1, conversation, member_id, user, media, channel, invited_by, sdp, serializationConstructorMarker, $this) {
		    if (!(31 === (31 & seen1))) {
		      throwMissingFieldException(seen1, 31, $serializer_getInstance_103().y2a_1);
		    }
		    $this.a2b_1 = conversation;
		    $this.b2b_1 = member_id;
		    $this.c2b_1 = user;
		    $this.d2b_1 = media;
		    $this.e2b_1 = channel;
		    if (0 === (seen1 & 32))
		      $this.f2b_1 = null;
		    else
		      $this.f2b_1 = invited_by;
		    if (0 === (seen1 & 64))
		      $this.g2b_1 = null;
		    else
		      $this.g2b_1 = sdp;
		    return $this;
		  }
		  function MemberInvited_init_$Create$(seen1, conversation, member_id, user, media, channel, invited_by, sdp, serializationConstructorMarker) {
		    return MemberInvited_init_$Init$(seen1, conversation, member_id, user, media, channel, invited_by, sdp, serializationConstructorMarker, objectCreate(protoOf(MemberInvited)));
		  }
		  function MemberInvited() {
		  }
		  protoOf(MemberInvited).toString = function () {
		    return 'MemberInvited(conversation=' + this.a2b_1 + ', member_id=' + this.b2b_1 + ', user=' + this.c2b_1 + ', media=' + this.d2b_1 + ', channel=' + this.e2b_1 + ', invited_by=' + this.f2b_1 + ', sdp=' + this.g2b_1 + ')';
		  };
		  protoOf(MemberInvited).hashCode = function () {
		    var result = this.a2b_1.hashCode();
		    result = imul(result, 31) + getStringHashCode(this.b2b_1) | 0;
		    result = imul(result, 31) + hashCode(this.c2b_1) | 0;
		    result = imul(result, 31) + this.d2b_1.hashCode() | 0;
		    result = imul(result, 31) + this.e2b_1.hashCode() | 0;
		    result = imul(result, 31) + (this.f2b_1 == null ? 0 : getStringHashCode(this.f2b_1)) | 0;
		    result = imul(result, 31) + (this.g2b_1 == null ? 0 : getStringHashCode(this.g2b_1)) | 0;
		    return result;
		  };
		  protoOf(MemberInvited).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberInvited))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberInvited ? other : THROW_CCE();
		    if (!this.a2b_1.equals(tmp0_other_with_cast.a2b_1))
		      return false;
		    if (!(this.b2b_1 === tmp0_other_with_cast.b2b_1))
		      return false;
		    if (!equals(this.c2b_1, tmp0_other_with_cast.c2b_1))
		      return false;
		    if (!this.d2b_1.equals(tmp0_other_with_cast.d2b_1))
		      return false;
		    if (!this.e2b_1.equals(tmp0_other_with_cast.e2b_1))
		      return false;
		    if (!(this.f2b_1 == tmp0_other_with_cast.f2b_1))
		      return false;
		    if (!(this.g2b_1 == tmp0_other_with_cast.g2b_1))
		      return false;
		    return true;
		  };
		  function $serializer_104() {
		    $serializer_instance_104 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.PushMemberInvitedEvent', this, 6);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('conversation_id', false);
		    tmp0_serialDesc.pq('type', false);
		    this.h2b_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_104).uf = function () {
		    return this.h2b_1;
		  };
		  protoOf($serializer_104).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_103(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_104).wf = function (decoder) {
		    var tmp0_desc = this.h2b_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_input = decoder.ej(tmp0_desc);
		    if (tmp10_input.uj()) {
		      tmp4_local0 = tmp10_input.qj(tmp0_desc, 0, $serializer_getInstance_103(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp10_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp10_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp10_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp10_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp10_input.oj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp10_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp10_input.qj(tmp0_desc, 0, $serializer_getInstance_103(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp10_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp10_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp10_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp10_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp10_input.oj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp10_input.fj(tmp0_desc);
		    return PushMemberInvitedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
		  };
		  protoOf($serializer_104).i2b = function (encoder, value) {
		    var tmp0_desc = this.h2b_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_103(), value.j2b_1);
		    tmp1_output.ok(tmp0_desc, 1, value.k2b_1);
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.l2b_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.l2b_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.m2b_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.m2b_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.n2b_1);
		    tmp1_output.tk(tmp0_desc, 5, value.o2b_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_104).vf = function (encoder, value) {
		    return this.i2b(encoder, value instanceof PushMemberInvitedEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_104;
		  function $serializer_getInstance_104() {
		    if ($serializer_instance_104 == null)
		      new $serializer_104();
		    return $serializer_instance_104;
		  }
		  function PushMemberInvitedEvent_init_$Init$(seen1, body, id, cid, from, conversation_id, type, serializationConstructorMarker, $this) {
		    if (!(51 === (51 & seen1))) {
		      throwMissingFieldException(seen1, 51, $serializer_getInstance_104().h2b_1);
		    }
		    $this.j2b_1 = body;
		    $this.k2b_1 = id;
		    if (0 === (seen1 & 4))
		      $this.l2b_1 = null;
		    else
		      $this.l2b_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.m2b_1 = null;
		    else
		      $this.m2b_1 = from;
		    $this.n2b_1 = conversation_id;
		    $this.o2b_1 = type;
		    return $this;
		  }
		  function PushMemberInvitedEvent_init_$Create$(seen1, body, id, cid, from, conversation_id, type, serializationConstructorMarker) {
		    return PushMemberInvitedEvent_init_$Init$(seen1, body, id, cid, from, conversation_id, type, serializationConstructorMarker, objectCreate(protoOf(PushMemberInvitedEvent)));
		  }
		  function PushMemberInvitedEvent() {
		  }
		  protoOf(PushMemberInvitedEvent).t27 = function () {
		    return this.k2b_1;
		  };
		  protoOf(PushMemberInvitedEvent).u27 = function () {
		    return this.l2b_1;
		  };
		  protoOf(PushMemberInvitedEvent).toString = function () {
		    return 'PushMemberInvitedEvent(body=' + this.j2b_1 + ', id=' + this.k2b_1 + ', cid=' + this.l2b_1 + ', from=' + this.m2b_1 + ', conversation_id=' + this.n2b_1 + ', type=' + this.o2b_1 + ')';
		  };
		  protoOf(PushMemberInvitedEvent).hashCode = function () {
		    var result = this.j2b_1.hashCode();
		    result = imul(result, 31) + this.k2b_1 | 0;
		    result = imul(result, 31) + (this.l2b_1 == null ? 0 : getStringHashCode(this.l2b_1)) | 0;
		    result = imul(result, 31) + (this.m2b_1 == null ? 0 : getStringHashCode(this.m2b_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.n2b_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.o2b_1) | 0;
		    return result;
		  };
		  protoOf(PushMemberInvitedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PushMemberInvitedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof PushMemberInvitedEvent ? other : THROW_CCE();
		    if (!this.j2b_1.equals(tmp0_other_with_cast.j2b_1))
		      return false;
		    if (!(this.k2b_1 === tmp0_other_with_cast.k2b_1))
		      return false;
		    if (!(this.l2b_1 == tmp0_other_with_cast.l2b_1))
		      return false;
		    if (!(this.m2b_1 == tmp0_other_with_cast.m2b_1))
		      return false;
		    if (!(this.n2b_1 === tmp0_other_with_cast.n2b_1))
		      return false;
		    if (!(this.o2b_1 === tmp0_other_with_cast.o2b_1))
		      return false;
		    return true;
		  };
		  function Companion_93() {
		  }
		  protoOf(Companion_93).y12 = function () {
		    return $serializer_getInstance_105();
		  };
		  var Companion_instance_94;
		  function Companion_getInstance_95() {
		    return Companion_instance_94;
		  }
		  function $serializer_105() {
		    $serializer_instance_105 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionSuccessEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.p2b_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_105).uf = function () {
		    return this.p2b_1;
		  };
		  protoOf($serializer_105).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_106(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_105).wf = function (decoder) {
		    var tmp0_desc = this.p2b_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_106(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_106(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionSuccessEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_105).q2b = function (encoder, value) {
		    var tmp0_desc = this.p2b_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_106(), value.r2b_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.s2b_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.s2b_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.t2b_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.t2b_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.u2b_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.u2b_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.v2b_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_105).vf = function (encoder, value) {
		    return this.q2b(encoder, value instanceof SessionSuccessEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_105;
		  function $serializer_getInstance_105() {
		    if ($serializer_instance_105 == null)
		      new $serializer_105();
		    return $serializer_instance_105;
		  }
		  function SessionSuccessEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(17 === (17 & seen1))) {
		      throwMissingFieldException(seen1, 17, $serializer_getInstance_105().p2b_1);
		    }
		    $this.r2b_1 = body;
		    if (0 === (seen1 & 2))
		      $this.s2b_1 = null;
		    else
		      $this.s2b_1 = id;
		    if (0 === (seen1 & 4))
		      $this.t2b_1 = null;
		    else
		      $this.t2b_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.u2b_1 = null;
		    else
		      $this.u2b_1 = from;
		    $this.v2b_1 = type;
		    return $this;
		  }
		  function SessionSuccessEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return SessionSuccessEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(SessionSuccessEvent)));
		  }
		  function SessionSuccessEvent() {
		  }
		  protoOf(SessionSuccessEvent).t27 = function () {
		    return this.s2b_1;
		  };
		  protoOf(SessionSuccessEvent).u27 = function () {
		    return this.t2b_1;
		  };
		  protoOf(SessionSuccessEvent).toString = function () {
		    return 'SessionSuccessEvent(body=' + this.r2b_1 + ', id=' + this.s2b_1 + ', cid=' + this.t2b_1 + ', from=' + this.u2b_1 + ', type=' + this.v2b_1 + ')';
		  };
		  protoOf(SessionSuccessEvent).hashCode = function () {
		    var result = this.r2b_1.hashCode();
		    result = imul(result, 31) + (this.s2b_1 == null ? 0 : this.s2b_1) | 0;
		    result = imul(result, 31) + (this.t2b_1 == null ? 0 : getStringHashCode(this.t2b_1)) | 0;
		    result = imul(result, 31) + (this.u2b_1 == null ? 0 : getStringHashCode(this.u2b_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.v2b_1) | 0;
		    return result;
		  };
		  protoOf(SessionSuccessEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionSuccessEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionSuccessEvent ? other : THROW_CCE();
		    if (!this.r2b_1.equals(tmp0_other_with_cast.r2b_1))
		      return false;
		    if (!(this.s2b_1 == tmp0_other_with_cast.s2b_1))
		      return false;
		    if (!(this.t2b_1 == tmp0_other_with_cast.t2b_1))
		      return false;
		    if (!(this.u2b_1 == tmp0_other_with_cast.u2b_1))
		      return false;
		    if (!(this.v2b_1 === tmp0_other_with_cast.v2b_1))
		      return false;
		    return true;
		  };
		  function Companion_94() {
		    Companion_instance_95 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.w2b_1 = [null, null, null, null, new ArrayListSerializer(SocketEventSerializer_getInstance())];
		  }
		  var Companion_instance_95;
		  function Companion_getInstance_96() {
		    if (Companion_instance_95 == null)
		      new Companion_94();
		    return Companion_instance_95;
		  }
		  function $serializer_106() {
		    $serializer_instance_106 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionSuccess', this, 5);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('user_id', false);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('api_key', false);
		    tmp0_serialDesc.pq('pending_events', true);
		    this.x2b_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_106).uf = function () {
		    return this.x2b_1;
		  };
		  protoOf($serializer_106).er = function () {
		    var tmp0_cached = Companion_getInstance_96().w2b_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[4])];
		  };
		  protoOf($serializer_106).wf = function (decoder) {
		    var tmp0_desc = this.x2b_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    var tmp10_cached = Companion_getInstance_96().w2b_1;
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.sj(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.sj(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionSuccess_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_106).y2b = function (encoder, value) {
		    var tmp0_desc = this.x2b_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_96().w2b_1;
		    tmp1_output.tk(tmp0_desc, 0, value.z2b_1);
		    tmp1_output.tk(tmp0_desc, 1, value.a2c_1);
		    tmp1_output.tk(tmp0_desc, 2, value.b2c_1);
		    tmp1_output.tk(tmp0_desc, 3, value.c2c_1);
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.d2c_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, tmp2_cached[4], value.d2c_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_106).vf = function (encoder, value) {
		    return this.y2b(encoder, value instanceof SessionSuccess ? value : THROW_CCE());
		  };
		  var $serializer_instance_106;
		  function $serializer_getInstance_106() {
		    if ($serializer_instance_106 == null)
		      new $serializer_106();
		    return $serializer_instance_106;
		  }
		  function SessionSuccess_init_$Init$(seen1, id, user_id, name, api_key, pending_events, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_106().x2b_1);
		    }
		    $this.z2b_1 = id;
		    $this.a2c_1 = user_id;
		    $this.b2c_1 = name;
		    $this.c2c_1 = api_key;
		    if (0 === (seen1 & 16))
		      $this.d2c_1 = null;
		    else
		      $this.d2c_1 = pending_events;
		    return $this;
		  }
		  function SessionSuccess_init_$Create$(seen1, id, user_id, name, api_key, pending_events, serializationConstructorMarker) {
		    return SessionSuccess_init_$Init$(seen1, id, user_id, name, api_key, pending_events, serializationConstructorMarker, objectCreate(protoOf(SessionSuccess)));
		  }
		  function SessionSuccess() {
		  }
		  protoOf(SessionSuccess).toString = function () {
		    return 'SessionSuccess(id=' + this.z2b_1 + ', user_id=' + this.a2c_1 + ', name=' + this.b2c_1 + ', api_key=' + this.c2c_1 + ', pending_events=' + this.d2c_1 + ')';
		  };
		  protoOf(SessionSuccess).hashCode = function () {
		    var result = getStringHashCode(this.z2b_1);
		    result = imul(result, 31) + getStringHashCode(this.a2c_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.b2c_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.c2c_1) | 0;
		    result = imul(result, 31) + (this.d2c_1 == null ? 0 : hashCode(this.d2c_1)) | 0;
		    return result;
		  };
		  protoOf(SessionSuccess).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionSuccess))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionSuccess ? other : THROW_CCE();
		    if (!(this.z2b_1 === tmp0_other_with_cast.z2b_1))
		      return false;
		    if (!(this.a2c_1 === tmp0_other_with_cast.a2c_1))
		      return false;
		    if (!(this.b2c_1 === tmp0_other_with_cast.b2c_1))
		      return false;
		    if (!(this.c2c_1 === tmp0_other_with_cast.c2c_1))
		      return false;
		    if (!equals(this.d2c_1, tmp0_other_with_cast.d2c_1))
		      return false;
		    return true;
		  };
		  function Companion_95() {
		  }
		  protoOf(Companion_95).y12 = function () {
		    return $serializer_getInstance_107();
		  };
		  var Companion_instance_96;
		  function Companion_getInstance_97() {
		    return Companion_instance_96;
		  }
		  function $serializer_107() {
		    $serializer_instance_107 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberJoinedEvent', this, 8);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('application_id', true);
		    tmp0_serialDesc.pq('type', false);
		    this.e2c_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_107).uf = function () {
		    return this.e2c_1;
		  };
		  protoOf($serializer_107).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_108(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_107).wf = function (decoder) {
		    var tmp0_desc = this.e2c_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_local7 = null;
		    var tmp12_input = decoder.ej(tmp0_desc);
		    if (tmp12_input.uj()) {
		      tmp4_local0 = tmp12_input.qj(tmp0_desc, 0, $serializer_getInstance_108(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp12_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp12_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp12_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp12_input.sj(tmp0_desc, 4, $serializer_getInstance_54(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp12_input.oj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp12_input.sj(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp12_input.oj(tmp0_desc, 7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp12_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp12_input.qj(tmp0_desc, 0, $serializer_getInstance_108(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp12_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp12_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp12_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp12_input.sj(tmp0_desc, 4, $serializer_getInstance_54(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp12_input.oj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp12_input.sj(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp12_input.oj(tmp0_desc, 7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp12_input.fj(tmp0_desc);
		    return MemberJoinedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
		  };
		  protoOf($serializer_107).f2c = function (encoder, value) {
		    var tmp0_desc = this.e2c_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_108(), value.g2c_1);
		    tmp1_output.ok(tmp0_desc, 1, value.h2c_1);
		    tmp1_output.tk(tmp0_desc, 2, value.i2c_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.j2c_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.j2c_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.k2c_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, $serializer_getInstance_54(), value.k2c_1);
		    }
		    tmp1_output.tk(tmp0_desc, 5, value.l2c_1);
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.m2c_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, StringSerializer_getInstance(), value.m2c_1);
		    }
		    tmp1_output.tk(tmp0_desc, 7, value.n2c_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_107).vf = function (encoder, value) {
		    return this.f2c(encoder, value instanceof MemberJoinedEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_107;
		  function $serializer_getInstance_107() {
		    if ($serializer_instance_107 == null)
		      new $serializer_107();
		    return $serializer_instance_107;
		  }
		  function MemberJoinedEvent_init_$Init$(seen1, body, id, cid, from, _embedded, timestamp, application_id, type, serializationConstructorMarker, $this) {
		    if (!(167 === (167 & seen1))) {
		      throwMissingFieldException(seen1, 167, $serializer_getInstance_107().e2c_1);
		    }
		    $this.g2c_1 = body;
		    $this.h2c_1 = id;
		    $this.i2c_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.j2c_1 = null;
		    else
		      $this.j2c_1 = from;
		    if (0 === (seen1 & 16))
		      $this.k2c_1 = null;
		    else
		      $this.k2c_1 = _embedded;
		    $this.l2c_1 = timestamp;
		    if (0 === (seen1 & 64))
		      $this.m2c_1 = null;
		    else
		      $this.m2c_1 = application_id;
		    $this.n2c_1 = type;
		    return $this;
		  }
		  function MemberJoinedEvent_init_$Create$(seen1, body, id, cid, from, _embedded, timestamp, application_id, type, serializationConstructorMarker) {
		    return MemberJoinedEvent_init_$Init$(seen1, body, id, cid, from, _embedded, timestamp, application_id, type, serializationConstructorMarker, objectCreate(protoOf(MemberJoinedEvent)));
		  }
		  function MemberJoinedEvent() {
		  }
		  protoOf(MemberJoinedEvent).t27 = function () {
		    return this.h2c_1;
		  };
		  protoOf(MemberJoinedEvent).u27 = function () {
		    return this.i2c_1;
		  };
		  protoOf(MemberJoinedEvent).o2c = function () {
		    return new MemberJoinedConversationEvent(this.h2c_1, this.l2c_1, this.i2c_1, Companion_instance_142.s24(this.k2c_1), new Body_15(this.g2c_1.q2c_1.g1y(), this.g2c_1.p2c_1, this.g2c_1.r2c_1.q26()));
		  };
		  protoOf(MemberJoinedEvent).toString = function () {
		    return 'MemberJoinedEvent(body=' + this.g2c_1 + ', id=' + this.h2c_1 + ', cid=' + this.i2c_1 + ', from=' + this.j2c_1 + ', _embedded=' + this.k2c_1 + ', timestamp=' + this.l2c_1 + ', application_id=' + this.m2c_1 + ', type=' + this.n2c_1 + ')';
		  };
		  protoOf(MemberJoinedEvent).hashCode = function () {
		    var result = this.g2c_1.hashCode();
		    result = imul(result, 31) + this.h2c_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.i2c_1) | 0;
		    result = imul(result, 31) + (this.j2c_1 == null ? 0 : getStringHashCode(this.j2c_1)) | 0;
		    result = imul(result, 31) + (this.k2c_1 == null ? 0 : this.k2c_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.l2c_1) | 0;
		    result = imul(result, 31) + (this.m2c_1 == null ? 0 : getStringHashCode(this.m2c_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.n2c_1) | 0;
		    return result;
		  };
		  protoOf(MemberJoinedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberJoinedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberJoinedEvent ? other : THROW_CCE();
		    if (!this.g2c_1.equals(tmp0_other_with_cast.g2c_1))
		      return false;
		    if (!(this.h2c_1 === tmp0_other_with_cast.h2c_1))
		      return false;
		    if (!(this.i2c_1 === tmp0_other_with_cast.i2c_1))
		      return false;
		    if (!(this.j2c_1 == tmp0_other_with_cast.j2c_1))
		      return false;
		    if (!equals(this.k2c_1, tmp0_other_with_cast.k2c_1))
		      return false;
		    if (!(this.l2c_1 === tmp0_other_with_cast.l2c_1))
		      return false;
		    if (!(this.m2c_1 == tmp0_other_with_cast.m2c_1))
		      return false;
		    if (!(this.n2c_1 === tmp0_other_with_cast.n2c_1))
		      return false;
		    return true;
		  };
		  function $serializer_108() {
		    $serializer_instance_108 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberJoined', this, 3);
		    tmp0_serialDesc.pq('member_id', false);
		    tmp0_serialDesc.pq('user', false);
		    tmp0_serialDesc.pq('channel', false);
		    this.s2c_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_108).uf = function () {
		    return this.s2c_1;
		  };
		  protoOf($serializer_108).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_51(), $serializer_getInstance_168()];
		  };
		  protoOf($serializer_108).wf = function (decoder) {
		    var tmp0_desc = this.s2c_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_51(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_168(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_51(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.qj(tmp0_desc, 2, $serializer_getInstance_168(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return MemberJoined_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_108).t2c = function (encoder, value) {
		    var tmp0_desc = this.s2c_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.p2c_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_51(), value.q2c_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_168(), value.r2c_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_108).vf = function (encoder, value) {
		    return this.t2c(encoder, value instanceof MemberJoined ? value : THROW_CCE());
		  };
		  var $serializer_instance_108;
		  function $serializer_getInstance_108() {
		    if ($serializer_instance_108 == null)
		      new $serializer_108();
		    return $serializer_instance_108;
		  }
		  function MemberJoined_init_$Init$(seen1, member_id, user, channel, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_108().s2c_1);
		    }
		    $this.p2c_1 = member_id;
		    $this.q2c_1 = user;
		    $this.r2c_1 = channel;
		    return $this;
		  }
		  function MemberJoined_init_$Create$(seen1, member_id, user, channel, serializationConstructorMarker) {
		    return MemberJoined_init_$Init$(seen1, member_id, user, channel, serializationConstructorMarker, objectCreate(protoOf(MemberJoined)));
		  }
		  function MemberJoined() {
		  }
		  protoOf(MemberJoined).toString = function () {
		    return 'MemberJoined(member_id=' + this.p2c_1 + ', user=' + this.q2c_1 + ', channel=' + this.r2c_1 + ')';
		  };
		  protoOf(MemberJoined).hashCode = function () {
		    var result = getStringHashCode(this.p2c_1);
		    result = imul(result, 31) + hashCode(this.q2c_1) | 0;
		    result = imul(result, 31) + this.r2c_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MemberJoined).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberJoined))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberJoined ? other : THROW_CCE();
		    if (!(this.p2c_1 === tmp0_other_with_cast.p2c_1))
		      return false;
		    if (!equals(this.q2c_1, tmp0_other_with_cast.q2c_1))
		      return false;
		    if (!this.r2c_1.equals(tmp0_other_with_cast.r2c_1))
		      return false;
		    return true;
		  };
		  function Companion_96() {
		  }
		  protoOf(Companion_96).y12 = function () {
		    return $serializer_getInstance_109();
		  };
		  var Companion_instance_97;
		  function Companion_getInstance_98() {
		    return Companion_instance_97;
		  }
		  function $serializer_109() {
		    $serializer_instance_109 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCAnswerEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.u2c_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_109).uf = function () {
		    return this.u2c_1;
		  };
		  protoOf($serializer_109).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_110(), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_109).wf = function (decoder) {
		    var tmp0_desc = this.u2c_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_110(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_110(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return RTCAnswerEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_109).v2c = function (encoder, value) {
		    var tmp0_desc = this.u2c_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_110(), value.w2c_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.x2c_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.x2c_1);
		    }
		    tmp1_output.tk(tmp0_desc, 2, value.y2c_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.z2c_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.z2c_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.a2d_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_109).vf = function (encoder, value) {
		    return this.v2c(encoder, value instanceof RTCAnswerEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_109;
		  function $serializer_getInstance_109() {
		    if ($serializer_instance_109 == null)
		      new $serializer_109();
		    return $serializer_instance_109;
		  }
		  function RTCAnswerEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(21 === (21 & seen1))) {
		      throwMissingFieldException(seen1, 21, $serializer_getInstance_109().u2c_1);
		    }
		    $this.w2c_1 = body;
		    if (0 === (seen1 & 2))
		      $this.x2c_1 = null;
		    else
		      $this.x2c_1 = id;
		    $this.y2c_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.z2c_1 = null;
		    else
		      $this.z2c_1 = from;
		    $this.a2d_1 = type;
		    return $this;
		  }
		  function RTCAnswerEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return RTCAnswerEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(RTCAnswerEvent)));
		  }
		  function RTCAnswerEvent() {
		  }
		  protoOf(RTCAnswerEvent).t27 = function () {
		    return this.x2c_1;
		  };
		  protoOf(RTCAnswerEvent).u27 = function () {
		    return this.y2c_1;
		  };
		  protoOf(RTCAnswerEvent).toString = function () {
		    return 'RTCAnswerEvent(body=' + this.w2c_1 + ', id=' + this.x2c_1 + ', cid=' + this.y2c_1 + ', from=' + this.z2c_1 + ', type=' + this.a2d_1 + ')';
		  };
		  protoOf(RTCAnswerEvent).hashCode = function () {
		    var result = this.w2c_1.hashCode();
		    result = imul(result, 31) + (this.x2c_1 == null ? 0 : this.x2c_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.y2c_1) | 0;
		    result = imul(result, 31) + (this.z2c_1 == null ? 0 : getStringHashCode(this.z2c_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.a2d_1) | 0;
		    return result;
		  };
		  protoOf(RTCAnswerEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCAnswerEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCAnswerEvent ? other : THROW_CCE();
		    if (!this.w2c_1.equals(tmp0_other_with_cast.w2c_1))
		      return false;
		    if (!(this.x2c_1 == tmp0_other_with_cast.x2c_1))
		      return false;
		    if (!(this.y2c_1 === tmp0_other_with_cast.y2c_1))
		      return false;
		    if (!(this.z2c_1 == tmp0_other_with_cast.z2c_1))
		      return false;
		    if (!(this.a2d_1 === tmp0_other_with_cast.a2d_1))
		      return false;
		    return true;
		  };
		  function $serializer_110() {
		    $serializer_instance_110 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.RTCAnswer', this, 2);
		    tmp0_serialDesc.pq('rtc_id', false);
		    tmp0_serialDesc.pq('answer', false);
		    this.b2d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_110).uf = function () {
		    return this.b2d_1;
		  };
		  protoOf($serializer_110).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_110).wf = function (decoder) {
		    var tmp0_desc = this.b2d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return RTCAnswer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_110).c2d = function (encoder, value) {
		    var tmp0_desc = this.b2d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.d2d_1);
		    tmp1_output.tk(tmp0_desc, 1, value.e2d_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_110).vf = function (encoder, value) {
		    return this.c2d(encoder, value instanceof RTCAnswer ? value : THROW_CCE());
		  };
		  var $serializer_instance_110;
		  function $serializer_getInstance_110() {
		    if ($serializer_instance_110 == null)
		      new $serializer_110();
		    return $serializer_instance_110;
		  }
		  function RTCAnswer_init_$Init$(seen1, rtc_id, answer, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_110().b2d_1);
		    }
		    $this.d2d_1 = rtc_id;
		    $this.e2d_1 = answer;
		    return $this;
		  }
		  function RTCAnswer_init_$Create$(seen1, rtc_id, answer, serializationConstructorMarker) {
		    return RTCAnswer_init_$Init$(seen1, rtc_id, answer, serializationConstructorMarker, objectCreate(protoOf(RTCAnswer)));
		  }
		  function RTCAnswer() {
		  }
		  protoOf(RTCAnswer).toString = function () {
		    return 'RTCAnswer(rtc_id=' + this.d2d_1 + ', answer=' + this.e2d_1 + ')';
		  };
		  protoOf(RTCAnswer).hashCode = function () {
		    var result = getStringHashCode(this.d2d_1);
		    result = imul(result, 31) + getStringHashCode(this.e2d_1) | 0;
		    return result;
		  };
		  protoOf(RTCAnswer).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCAnswer))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCAnswer ? other : THROW_CCE();
		    if (!(this.d2d_1 === tmp0_other_with_cast.d2d_1))
		      return false;
		    if (!(this.e2d_1 === tmp0_other_with_cast.e2d_1))
		      return false;
		    return true;
		  };
		  function Companion_97() {
		  }
		  protoOf(Companion_97).y12 = function () {
		    return $serializer_getInstance_111();
		  };
		  var Companion_instance_98;
		  function Companion_getInstance_99() {
		    return Companion_instance_98;
		  }
		  function $serializer_111() {
		    $serializer_instance_111 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberInvitedEvent', this, 8);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('application_id', true);
		    tmp0_serialDesc.pq('type', false);
		    this.f2d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_111).uf = function () {
		    return this.f2d_1;
		  };
		  protoOf($serializer_111).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_103(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_111).wf = function (decoder) {
		    var tmp0_desc = this.f2d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_local7 = null;
		    var tmp12_input = decoder.ej(tmp0_desc);
		    if (tmp12_input.uj()) {
		      tmp4_local0 = tmp12_input.qj(tmp0_desc, 0, $serializer_getInstance_103(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp12_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp12_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp12_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp12_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp12_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp12_input.sj(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp12_input.oj(tmp0_desc, 7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp12_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp12_input.qj(tmp0_desc, 0, $serializer_getInstance_103(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp12_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp12_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp12_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp12_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp12_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp12_input.sj(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp12_input.oj(tmp0_desc, 7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp12_input.fj(tmp0_desc);
		    return MemberInvitedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
		  };
		  protoOf($serializer_111).g2d = function (encoder, value) {
		    var tmp0_desc = this.f2d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_103(), value.h2d_1);
		    tmp1_output.ok(tmp0_desc, 1, value.i2d_1);
		    tmp1_output.tk(tmp0_desc, 2, value.j2d_1);
		    tmp1_output.tk(tmp0_desc, 3, value.k2d_1);
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.l2d_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.l2d_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.m2d_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.m2d_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.n2d_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, StringSerializer_getInstance(), value.n2d_1);
		    }
		    tmp1_output.tk(tmp0_desc, 7, value.o2d_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_111).vf = function (encoder, value) {
		    return this.g2d(encoder, value instanceof MemberInvitedEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_111;
		  function $serializer_getInstance_111() {
		    if ($serializer_instance_111 == null)
		      new $serializer_111();
		    return $serializer_instance_111;
		  }
		  function MemberInvitedEvent_init_$Init$(seen1, body, id, cid, timestamp, from, _embedded, application_id, type, serializationConstructorMarker, $this) {
		    if (!(143 === (143 & seen1))) {
		      throwMissingFieldException(seen1, 143, $serializer_getInstance_111().f2d_1);
		    }
		    $this.h2d_1 = body;
		    $this.i2d_1 = id;
		    $this.j2d_1 = cid;
		    $this.k2d_1 = timestamp;
		    if (0 === (seen1 & 16))
		      $this.l2d_1 = null;
		    else
		      $this.l2d_1 = from;
		    if (0 === (seen1 & 32))
		      $this.m2d_1 = null;
		    else
		      $this.m2d_1 = _embedded;
		    if (0 === (seen1 & 64))
		      $this.n2d_1 = null;
		    else
		      $this.n2d_1 = application_id;
		    $this.o2d_1 = type;
		    return $this;
		  }
		  function MemberInvitedEvent_init_$Create$(seen1, body, id, cid, timestamp, from, _embedded, application_id, type, serializationConstructorMarker) {
		    return MemberInvitedEvent_init_$Init$(seen1, body, id, cid, timestamp, from, _embedded, application_id, type, serializationConstructorMarker, objectCreate(protoOf(MemberInvitedEvent)));
		  }
		  function MemberInvitedEvent() {
		  }
		  protoOf(MemberInvitedEvent).t27 = function () {
		    return this.i2d_1;
		  };
		  protoOf(MemberInvitedEvent).u27 = function () {
		    return this.j2d_1;
		  };
		  protoOf(MemberInvitedEvent).o2c = function () {
		    return new MemberInvitedConversationEvent(this.i2d_1, this.k2d_1, this.j2d_1, Companion_instance_142.s24(this.m2d_1), new Body_15(this.h2d_1.c2b_1.g1y(), this.h2d_1.b2b_1, this.h2d_1.e2b_1.q26()));
		  };
		  protoOf(MemberInvitedEvent).toString = function () {
		    return 'MemberInvitedEvent(body=' + this.h2d_1 + ', id=' + this.i2d_1 + ', cid=' + this.j2d_1 + ', timestamp=' + this.k2d_1 + ', from=' + this.l2d_1 + ', _embedded=' + this.m2d_1 + ', application_id=' + this.n2d_1 + ', type=' + this.o2d_1 + ')';
		  };
		  protoOf(MemberInvitedEvent).hashCode = function () {
		    var result = this.h2d_1.hashCode();
		    result = imul(result, 31) + this.i2d_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.j2d_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.k2d_1) | 0;
		    result = imul(result, 31) + (this.l2d_1 == null ? 0 : getStringHashCode(this.l2d_1)) | 0;
		    result = imul(result, 31) + (this.m2d_1 == null ? 0 : this.m2d_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.n2d_1 == null ? 0 : getStringHashCode(this.n2d_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.o2d_1) | 0;
		    return result;
		  };
		  protoOf(MemberInvitedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberInvitedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberInvitedEvent ? other : THROW_CCE();
		    if (!this.h2d_1.equals(tmp0_other_with_cast.h2d_1))
		      return false;
		    if (!(this.i2d_1 === tmp0_other_with_cast.i2d_1))
		      return false;
		    if (!(this.j2d_1 === tmp0_other_with_cast.j2d_1))
		      return false;
		    if (!(this.k2d_1 === tmp0_other_with_cast.k2d_1))
		      return false;
		    if (!(this.l2d_1 == tmp0_other_with_cast.l2d_1))
		      return false;
		    if (!equals(this.m2d_1, tmp0_other_with_cast.m2d_1))
		      return false;
		    if (!(this.n2d_1 == tmp0_other_with_cast.n2d_1))
		      return false;
		    if (!(this.o2d_1 === tmp0_other_with_cast.o2d_1))
		      return false;
		    return true;
		  };
		  function Companion_98() {
		  }
		  protoOf(Companion_98).y12 = function () {
		    return $serializer_getInstance_112();
		  };
		  var Companion_instance_99;
		  function Companion_getInstance_100() {
		    return Companion_instance_99;
		  }
		  function $serializer_112() {
		    $serializer_instance_112 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberMediaEvent', this, 6);
		    tmp0_serialDesc.pq('_embedded', false);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.p2d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_112).uf = function () {
		    return this.p2d_1;
		  };
		  protoOf($serializer_112).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable($serializer_getInstance_54()), $serializer_getInstance_113(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_112).wf = function (decoder) {
		    var tmp0_desc = this.p2d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = 0;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_input = decoder.ej(tmp0_desc);
		    if (tmp10_input.uj()) {
		      tmp4_local0 = tmp10_input.sj(tmp0_desc, 0, $serializer_getInstance_54(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp10_input.qj(tmp0_desc, 1, $serializer_getInstance_113(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp10_input.jj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp10_input.oj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp10_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp10_input.oj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp10_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp10_input.sj(tmp0_desc, 0, $serializer_getInstance_54(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp10_input.qj(tmp0_desc, 1, $serializer_getInstance_113(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp10_input.jj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp10_input.oj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp10_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp10_input.oj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp10_input.fj(tmp0_desc);
		    return MemberMediaEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
		  };
		  protoOf($serializer_112).q2d = function (encoder, value) {
		    var tmp0_desc = this.p2d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.xk(tmp0_desc, 0, $serializer_getInstance_54(), value.r2d_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_113(), value.s2d_1);
		    tmp1_output.ok(tmp0_desc, 2, value.t2d_1);
		    tmp1_output.tk(tmp0_desc, 3, value.u2d_1);
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.v2d_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.v2d_1);
		    }
		    tmp1_output.tk(tmp0_desc, 5, value.w2d_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_112).vf = function (encoder, value) {
		    return this.q2d(encoder, value instanceof MemberMediaEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_112;
		  function $serializer_getInstance_112() {
		    if ($serializer_instance_112 == null)
		      new $serializer_112();
		    return $serializer_instance_112;
		  }
		  function MemberMediaEvent_init_$Init$(seen1, _embedded, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(47 === (47 & seen1))) {
		      throwMissingFieldException(seen1, 47, $serializer_getInstance_112().p2d_1);
		    }
		    $this.r2d_1 = _embedded;
		    $this.s2d_1 = body;
		    $this.t2d_1 = id;
		    $this.u2d_1 = cid;
		    if (0 === (seen1 & 16))
		      $this.v2d_1 = null;
		    else
		      $this.v2d_1 = from;
		    $this.w2d_1 = type;
		    return $this;
		  }
		  function MemberMediaEvent_init_$Create$(seen1, _embedded, body, id, cid, from, type, serializationConstructorMarker) {
		    return MemberMediaEvent_init_$Init$(seen1, _embedded, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(MemberMediaEvent)));
		  }
		  function MemberMediaEvent() {
		  }
		  protoOf(MemberMediaEvent).t27 = function () {
		    return this.t2d_1;
		  };
		  protoOf(MemberMediaEvent).u27 = function () {
		    return this.u2d_1;
		  };
		  protoOf(MemberMediaEvent).toString = function () {
		    return 'MemberMediaEvent(_embedded=' + this.r2d_1 + ', body=' + this.s2d_1 + ', id=' + this.t2d_1 + ', cid=' + this.u2d_1 + ', from=' + this.v2d_1 + ', type=' + this.w2d_1 + ')';
		  };
		  protoOf(MemberMediaEvent).hashCode = function () {
		    var result = this.r2d_1 == null ? 0 : this.r2d_1.hashCode();
		    result = imul(result, 31) + this.s2d_1.hashCode() | 0;
		    result = imul(result, 31) + this.t2d_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.u2d_1) | 0;
		    result = imul(result, 31) + (this.v2d_1 == null ? 0 : getStringHashCode(this.v2d_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.w2d_1) | 0;
		    return result;
		  };
		  protoOf(MemberMediaEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberMediaEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberMediaEvent ? other : THROW_CCE();
		    if (!equals(this.r2d_1, tmp0_other_with_cast.r2d_1))
		      return false;
		    if (!this.s2d_1.equals(tmp0_other_with_cast.s2d_1))
		      return false;
		    if (!(this.t2d_1 === tmp0_other_with_cast.t2d_1))
		      return false;
		    if (!(this.u2d_1 === tmp0_other_with_cast.u2d_1))
		      return false;
		    if (!(this.v2d_1 == tmp0_other_with_cast.v2d_1))
		      return false;
		    if (!(this.w2d_1 === tmp0_other_with_cast.w2d_1))
		      return false;
		    return true;
		  };
		  function $serializer_113() {
		    $serializer_instance_113 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberMedia', this, 1);
		    tmp0_serialDesc.pq('channel', false);
		    this.x2d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_113).uf = function () {
		    return this.x2d_1;
		  };
		  protoOf($serializer_113).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_168()];
		  };
		  protoOf($serializer_113).wf = function (decoder) {
		    var tmp0_desc = this.x2d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_168(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.qj(tmp0_desc, 0, $serializer_getInstance_168(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return MemberMedia_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_113).y2d = function (encoder, value) {
		    var tmp0_desc = this.x2d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_168(), value.z2d_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_113).vf = function (encoder, value) {
		    return this.y2d(encoder, value instanceof MemberMedia ? value : THROW_CCE());
		  };
		  var $serializer_instance_113;
		  function $serializer_getInstance_113() {
		    if ($serializer_instance_113 == null)
		      new $serializer_113();
		    return $serializer_instance_113;
		  }
		  function MemberMedia_init_$Init$(seen1, channel, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_113().x2d_1);
		    }
		    $this.z2d_1 = channel;
		    return $this;
		  }
		  function MemberMedia_init_$Create$(seen1, channel, serializationConstructorMarker) {
		    return MemberMedia_init_$Init$(seen1, channel, serializationConstructorMarker, objectCreate(protoOf(MemberMedia)));
		  }
		  function MemberMedia() {
		  }
		  protoOf(MemberMedia).toString = function () {
		    return 'MemberMedia(channel=' + this.z2d_1 + ')';
		  };
		  protoOf(MemberMedia).hashCode = function () {
		    return this.z2d_1.hashCode();
		  };
		  protoOf(MemberMedia).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberMedia))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberMedia ? other : THROW_CCE();
		    if (!this.z2d_1.equals(tmp0_other_with_cast.z2d_1))
		      return false;
		    return true;
		  };
		  function Companion_99() {
		  }
		  protoOf(Companion_99).y12 = function () {
		    return $serializer_getInstance_114();
		  };
		  var Companion_instance_100;
		  function Companion_getInstance_101() {
		    return Companion_instance_100;
		  }
		  function $serializer_114() {
		    $serializer_instance_114 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberLeftEvent', this, 8);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('application_id', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.a2e_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_114).uf = function () {
		    return this.a2e_1;
		  };
		  protoOf($serializer_114).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_115(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_114).wf = function (decoder) {
		    var tmp0_desc = this.a2e_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_local7 = null;
		    var tmp12_input = decoder.ej(tmp0_desc);
		    if (tmp12_input.uj()) {
		      tmp4_local0 = tmp12_input.qj(tmp0_desc, 0, $serializer_getInstance_115(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp12_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp12_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp12_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp12_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp12_input.sj(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp12_input.sj(tmp0_desc, 6, $serializer_getInstance_54(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp12_input.oj(tmp0_desc, 7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp12_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp12_input.qj(tmp0_desc, 0, $serializer_getInstance_115(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp12_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp12_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp12_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp12_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp12_input.sj(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp12_input.sj(tmp0_desc, 6, $serializer_getInstance_54(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp12_input.oj(tmp0_desc, 7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp12_input.fj(tmp0_desc);
		    return MemberLeftEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
		  };
		  protoOf($serializer_114).b2e = function (encoder, value) {
		    var tmp0_desc = this.a2e_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_115(), value.c2e_1);
		    tmp1_output.ok(tmp0_desc, 1, value.d2e_1);
		    tmp1_output.tk(tmp0_desc, 2, value.e2e_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.f2e_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.f2e_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.g2e_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.h2e_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, StringSerializer_getInstance(), value.h2e_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.i2e_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, $serializer_getInstance_54(), value.i2e_1);
		    }
		    tmp1_output.tk(tmp0_desc, 7, value.j2e_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_114).vf = function (encoder, value) {
		    return this.b2e(encoder, value instanceof MemberLeftEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_114;
		  function $serializer_getInstance_114() {
		    if ($serializer_instance_114 == null)
		      new $serializer_114();
		    return $serializer_instance_114;
		  }
		  function MemberLeftEvent_init_$Init$(seen1, body, id, cid, from, timestamp, application_id, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(151 === (151 & seen1))) {
		      throwMissingFieldException(seen1, 151, $serializer_getInstance_114().a2e_1);
		    }
		    $this.c2e_1 = body;
		    $this.d2e_1 = id;
		    $this.e2e_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.f2e_1 = null;
		    else
		      $this.f2e_1 = from;
		    $this.g2e_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.h2e_1 = null;
		    else
		      $this.h2e_1 = application_id;
		    if (0 === (seen1 & 64))
		      $this.i2e_1 = null;
		    else
		      $this.i2e_1 = _embedded;
		    $this.j2e_1 = type;
		    return $this;
		  }
		  function MemberLeftEvent_init_$Create$(seen1, body, id, cid, from, timestamp, application_id, _embedded, type, serializationConstructorMarker) {
		    return MemberLeftEvent_init_$Init$(seen1, body, id, cid, from, timestamp, application_id, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(MemberLeftEvent)));
		  }
		  function MemberLeftEvent() {
		  }
		  protoOf(MemberLeftEvent).t27 = function () {
		    return this.d2e_1;
		  };
		  protoOf(MemberLeftEvent).u27 = function () {
		    return this.e2e_1;
		  };
		  protoOf(MemberLeftEvent).o2c = function () {
		    return new MemberLeftConversationEvent(this.d2e_1, this.g2e_1, this.e2e_1, Companion_instance_142.s24(this.i2e_1), new Body_15(this.c2e_1.l2e_1.g1y(), this.c2e_1.k2e_1, this.c2e_1.m2e_1.q26()));
		  };
		  protoOf(MemberLeftEvent).toString = function () {
		    return 'MemberLeftEvent(body=' + this.c2e_1 + ', id=' + this.d2e_1 + ', cid=' + this.e2e_1 + ', from=' + this.f2e_1 + ', timestamp=' + this.g2e_1 + ', application_id=' + this.h2e_1 + ', _embedded=' + this.i2e_1 + ', type=' + this.j2e_1 + ')';
		  };
		  protoOf(MemberLeftEvent).hashCode = function () {
		    var result = this.c2e_1.hashCode();
		    result = imul(result, 31) + this.d2e_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.e2e_1) | 0;
		    result = imul(result, 31) + (this.f2e_1 == null ? 0 : getStringHashCode(this.f2e_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.g2e_1) | 0;
		    result = imul(result, 31) + (this.h2e_1 == null ? 0 : getStringHashCode(this.h2e_1)) | 0;
		    result = imul(result, 31) + (this.i2e_1 == null ? 0 : this.i2e_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.j2e_1) | 0;
		    return result;
		  };
		  protoOf(MemberLeftEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberLeftEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberLeftEvent ? other : THROW_CCE();
		    if (!this.c2e_1.equals(tmp0_other_with_cast.c2e_1))
		      return false;
		    if (!(this.d2e_1 === tmp0_other_with_cast.d2e_1))
		      return false;
		    if (!(this.e2e_1 === tmp0_other_with_cast.e2e_1))
		      return false;
		    if (!(this.f2e_1 == tmp0_other_with_cast.f2e_1))
		      return false;
		    if (!(this.g2e_1 === tmp0_other_with_cast.g2e_1))
		      return false;
		    if (!(this.h2e_1 == tmp0_other_with_cast.h2e_1))
		      return false;
		    if (!equals(this.i2e_1, tmp0_other_with_cast.i2e_1))
		      return false;
		    if (!(this.j2e_1 === tmp0_other_with_cast.j2e_1))
		      return false;
		    return true;
		  };
		  function $serializer_115() {
		    $serializer_instance_115 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberLeftBody', this, 4);
		    tmp0_serialDesc.pq('member_id', false);
		    tmp0_serialDesc.pq('user', false);
		    tmp0_serialDesc.pq('channel', false);
		    tmp0_serialDesc.pq('reason', true);
		    this.o2e_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_115).uf = function () {
		    return this.o2e_1;
		  };
		  protoOf($serializer_115).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_51(), $serializer_getInstance_168(), get_nullable($serializer_getInstance_116())];
		  };
		  protoOf($serializer_115).wf = function (decoder) {
		    var tmp0_desc = this.o2e_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.qj(tmp0_desc, 1, $serializer_getInstance_51(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.qj(tmp0_desc, 2, $serializer_getInstance_168(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.sj(tmp0_desc, 3, $serializer_getInstance_116(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.qj(tmp0_desc, 1, $serializer_getInstance_51(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.qj(tmp0_desc, 2, $serializer_getInstance_168(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.sj(tmp0_desc, 3, $serializer_getInstance_116(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return MemberLeftBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_115).p2e = function (encoder, value) {
		    var tmp0_desc = this.o2e_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.k2e_1);
		    tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_51(), value.l2e_1);
		    tmp1_output.vk(tmp0_desc, 2, $serializer_getInstance_168(), value.m2e_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.n2e_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, $serializer_getInstance_116(), value.n2e_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_115).vf = function (encoder, value) {
		    return this.p2e(encoder, value instanceof MemberLeftBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_115;
		  function $serializer_getInstance_115() {
		    if ($serializer_instance_115 == null)
		      new $serializer_115();
		    return $serializer_instance_115;
		  }
		  function MemberLeftBody_init_$Init$(seen1, member_id, user, channel, reason, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_115().o2e_1);
		    }
		    $this.k2e_1 = member_id;
		    $this.l2e_1 = user;
		    $this.m2e_1 = channel;
		    if (0 === (seen1 & 8))
		      $this.n2e_1 = null;
		    else
		      $this.n2e_1 = reason;
		    return $this;
		  }
		  function MemberLeftBody_init_$Create$(seen1, member_id, user, channel, reason, serializationConstructorMarker) {
		    return MemberLeftBody_init_$Init$(seen1, member_id, user, channel, reason, serializationConstructorMarker, objectCreate(protoOf(MemberLeftBody)));
		  }
		  function MemberLeftBody() {
		  }
		  protoOf(MemberLeftBody).toString = function () {
		    return 'MemberLeftBody(member_id=' + this.k2e_1 + ', user=' + this.l2e_1 + ', channel=' + this.m2e_1 + ', reason=' + this.n2e_1 + ')';
		  };
		  protoOf(MemberLeftBody).hashCode = function () {
		    var result = getStringHashCode(this.k2e_1);
		    result = imul(result, 31) + hashCode(this.l2e_1) | 0;
		    result = imul(result, 31) + this.m2e_1.hashCode() | 0;
		    result = imul(result, 31) + (this.n2e_1 == null ? 0 : this.n2e_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(MemberLeftBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberLeftBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberLeftBody ? other : THROW_CCE();
		    if (!(this.k2e_1 === tmp0_other_with_cast.k2e_1))
		      return false;
		    if (!equals(this.l2e_1, tmp0_other_with_cast.l2e_1))
		      return false;
		    if (!this.m2e_1.equals(tmp0_other_with_cast.m2e_1))
		      return false;
		    if (!equals(this.n2e_1, tmp0_other_with_cast.n2e_1))
		      return false;
		    return true;
		  };
		  function Companion_100() {
		  }
		  var Companion_instance_101;
		  function Companion_getInstance_102() {
		    return Companion_instance_101;
		  }
		  function $serializer_116() {
		    $serializer_instance_116 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MemberLeftReason', this, 2);
		    tmp0_serialDesc.pq('code', true);
		    tmp0_serialDesc.pq('text', true);
		    this.q2e_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_116).uf = function () {
		    return this.q2e_1;
		  };
		  protoOf($serializer_116).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_116).wf = function (decoder) {
		    var tmp0_desc = this.q2e_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return MemberLeftReason_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_116).r2e = function (encoder, value) {
		    var tmp0_desc = this.q2e_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.s2e_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.s2e_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.t2e_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.t2e_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_116).vf = function (encoder, value) {
		    return this.r2e(encoder, value instanceof MemberLeftReason ? value : THROW_CCE());
		  };
		  var $serializer_instance_116;
		  function $serializer_getInstance_116() {
		    if ($serializer_instance_116 == null)
		      new $serializer_116();
		    return $serializer_instance_116;
		  }
		  function MemberLeftReason_init_$Init$(seen1, code, text, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_116().q2e_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.s2e_1 = null;
		    else
		      $this.s2e_1 = code;
		    if (0 === (seen1 & 2))
		      $this.t2e_1 = null;
		    else
		      $this.t2e_1 = text;
		    return $this;
		  }
		  function MemberLeftReason_init_$Create$(seen1, code, text, serializationConstructorMarker) {
		    return MemberLeftReason_init_$Init$(seen1, code, text, serializationConstructorMarker, objectCreate(protoOf(MemberLeftReason)));
		  }
		  function MemberLeftReason(code, text) {
		    code = code === VOID ? null : code;
		    text = text === VOID ? null : text;
		    this.s2e_1 = code;
		    this.t2e_1 = text;
		  }
		  protoOf(MemberLeftReason).toString = function () {
		    return 'MemberLeftReason(code=' + this.s2e_1 + ', text=' + this.t2e_1 + ')';
		  };
		  protoOf(MemberLeftReason).hashCode = function () {
		    var result = this.s2e_1 == null ? 0 : getStringHashCode(this.s2e_1);
		    result = imul(result, 31) + (this.t2e_1 == null ? 0 : getStringHashCode(this.t2e_1)) | 0;
		    return result;
		  };
		  protoOf(MemberLeftReason).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberLeftReason))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberLeftReason ? other : THROW_CCE();
		    if (!(this.s2e_1 == tmp0_other_with_cast.s2e_1))
		      return false;
		    if (!(this.t2e_1 == tmp0_other_with_cast.t2e_1))
		      return false;
		    return true;
		  };
		  function $serializer_117() {
		    $serializer_instance_117 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioSayBody', this, 11);
		    tmp0_serialDesc.pq('say_id', false);
		    tmp0_serialDesc.pq('text', false);
		    tmp0_serialDesc.pq('level', false);
		    tmp0_serialDesc.pq('loop', false);
		    tmp0_serialDesc.pq('language', true);
		    tmp0_serialDesc.pq('premium', true);
		    tmp0_serialDesc.pq('queue', true);
		    tmp0_serialDesc.pq('ssml', true);
		    tmp0_serialDesc.pq('voice_name', true);
		    tmp0_serialDesc.pq('style', true);
		    tmp0_serialDesc.pq('type', true);
		    this.u2e_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_117).uf = function () {
		    return this.u2e_1;
		  };
		  protoOf($serializer_117).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_117).wf = function (decoder) {
		    var tmp0_desc = this.u2e_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = 0;
		    var tmp7_local3 = 0;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_local7 = null;
		    var tmp12_local8 = null;
		    var tmp13_local9 = null;
		    var tmp14_local10 = null;
		    var tmp15_input = decoder.ej(tmp0_desc);
		    if (tmp15_input.uj()) {
		      tmp4_local0 = tmp15_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp15_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp15_input.jj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp15_input.jj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp15_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp15_input.sj(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp15_input.sj(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp15_input.sj(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		      tmp12_local8 = tmp15_input.sj(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
		      tmp3_bitMask0 = tmp3_bitMask0 | 256;
		      tmp13_local9 = tmp15_input.sj(tmp0_desc, 9, IntSerializer_getInstance(), tmp13_local9);
		      tmp3_bitMask0 = tmp3_bitMask0 | 512;
		      tmp14_local10 = tmp15_input.sj(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp15_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp15_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp15_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp15_input.jj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp15_input.jj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp15_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp15_input.sj(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp15_input.sj(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp15_input.sj(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          case 8:
		            tmp12_local8 = tmp15_input.sj(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
		            tmp3_bitMask0 = tmp3_bitMask0 | 256;
		            break;
		          case 9:
		            tmp13_local9 = tmp15_input.sj(tmp0_desc, 9, IntSerializer_getInstance(), tmp13_local9);
		            tmp3_bitMask0 = tmp3_bitMask0 | 512;
		            break;
		          case 10:
		            tmp14_local10 = tmp15_input.sj(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp15_input.fj(tmp0_desc);
		    return AudioSayBody_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
		  };
		  protoOf($serializer_117).v2e = function (encoder, value) {
		    var tmp0_desc = this.u2e_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.w2e_1);
		    tmp1_output.tk(tmp0_desc, 1, value.x2e_1);
		    tmp1_output.ok(tmp0_desc, 2, value.y2e_1);
		    tmp1_output.ok(tmp0_desc, 3, value.z2e_1);
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.a2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.a2f_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.b2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, BooleanSerializer_getInstance(), value.b2f_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.c2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, BooleanSerializer_getInstance(), value.c2f_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 7) ? true : !(value.d2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 7, BooleanSerializer_getInstance(), value.d2f_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 8) ? true : !(value.e2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 8, StringSerializer_getInstance(), value.e2f_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 9) ? true : !(value.f2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 9, IntSerializer_getInstance(), value.f2f_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 10) ? true : !(value.g2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 10, StringSerializer_getInstance(), value.g2f_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_117).vf = function (encoder, value) {
		    return this.v2e(encoder, value instanceof AudioSayBody_0 ? value : THROW_CCE());
		  };
		  var $serializer_instance_117;
		  function $serializer_getInstance_117() {
		    if ($serializer_instance_117 == null)
		      new $serializer_117();
		    return $serializer_instance_117;
		  }
		  function AudioSayBody_init_$Init$_0(seen1, say_id, text, level, loop, language, premium, queue, ssml, voice_name, style, type, serializationConstructorMarker, $this) {
		    if (!(15 === (15 & seen1))) {
		      throwMissingFieldException(seen1, 15, $serializer_getInstance_117().u2e_1);
		    }
		    $this.w2e_1 = say_id;
		    $this.x2e_1 = text;
		    $this.y2e_1 = level;
		    $this.z2e_1 = loop;
		    if (0 === (seen1 & 16))
		      $this.a2f_1 = null;
		    else
		      $this.a2f_1 = language;
		    if (0 === (seen1 & 32))
		      $this.b2f_1 = null;
		    else
		      $this.b2f_1 = premium;
		    if (0 === (seen1 & 64))
		      $this.c2f_1 = null;
		    else
		      $this.c2f_1 = queue;
		    if (0 === (seen1 & 128))
		      $this.d2f_1 = null;
		    else
		      $this.d2f_1 = ssml;
		    if (0 === (seen1 & 256))
		      $this.e2f_1 = null;
		    else
		      $this.e2f_1 = voice_name;
		    if (0 === (seen1 & 512))
		      $this.f2f_1 = null;
		    else
		      $this.f2f_1 = style;
		    if (0 === (seen1 & 1024))
		      $this.g2f_1 = null;
		    else
		      $this.g2f_1 = type;
		    return $this;
		  }
		  function AudioSayBody_init_$Create$_0(seen1, say_id, text, level, loop, language, premium, queue, ssml, voice_name, style, type, serializationConstructorMarker) {
		    return AudioSayBody_init_$Init$_0(seen1, say_id, text, level, loop, language, premium, queue, ssml, voice_name, style, type, serializationConstructorMarker, objectCreate(protoOf(AudioSayBody_0)));
		  }
		  function AudioSayBody_0() {
		  }
		  protoOf(AudioSayBody_0).toString = function () {
		    return 'AudioSayBody(say_id=' + this.w2e_1 + ', text=' + this.x2e_1 + ', level=' + this.y2e_1 + ', loop=' + this.z2e_1 + ', language=' + this.a2f_1 + ', premium=' + this.b2f_1 + ', queue=' + this.c2f_1 + ', ssml=' + this.d2f_1 + ', voice_name=' + this.e2f_1 + ', style=' + this.f2f_1 + ', type=' + this.g2f_1 + ')';
		  };
		  protoOf(AudioSayBody_0).hashCode = function () {
		    var result = getStringHashCode(this.w2e_1);
		    result = imul(result, 31) + getStringHashCode(this.x2e_1) | 0;
		    result = imul(result, 31) + this.y2e_1 | 0;
		    result = imul(result, 31) + this.z2e_1 | 0;
		    result = imul(result, 31) + (this.a2f_1 == null ? 0 : getStringHashCode(this.a2f_1)) | 0;
		    result = imul(result, 31) + (this.b2f_1 == null ? 0 : getBooleanHashCode(this.b2f_1)) | 0;
		    result = imul(result, 31) + (this.c2f_1 == null ? 0 : getBooleanHashCode(this.c2f_1)) | 0;
		    result = imul(result, 31) + (this.d2f_1 == null ? 0 : getBooleanHashCode(this.d2f_1)) | 0;
		    result = imul(result, 31) + (this.e2f_1 == null ? 0 : getStringHashCode(this.e2f_1)) | 0;
		    result = imul(result, 31) + (this.f2f_1 == null ? 0 : this.f2f_1) | 0;
		    result = imul(result, 31) + (this.g2f_1 == null ? 0 : getStringHashCode(this.g2f_1)) | 0;
		    return result;
		  };
		  protoOf(AudioSayBody_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioSayBody_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioSayBody_0 ? other : THROW_CCE();
		    if (!(this.w2e_1 === tmp0_other_with_cast.w2e_1))
		      return false;
		    if (!(this.x2e_1 === tmp0_other_with_cast.x2e_1))
		      return false;
		    if (!(this.y2e_1 === tmp0_other_with_cast.y2e_1))
		      return false;
		    if (!(this.z2e_1 === tmp0_other_with_cast.z2e_1))
		      return false;
		    if (!(this.a2f_1 == tmp0_other_with_cast.a2f_1))
		      return false;
		    if (!(this.b2f_1 == tmp0_other_with_cast.b2f_1))
		      return false;
		    if (!(this.c2f_1 == tmp0_other_with_cast.c2f_1))
		      return false;
		    if (!(this.d2f_1 == tmp0_other_with_cast.d2f_1))
		      return false;
		    if (!(this.e2f_1 == tmp0_other_with_cast.e2f_1))
		      return false;
		    if (!(this.f2f_1 == tmp0_other_with_cast.f2f_1))
		      return false;
		    if (!(this.g2f_1 == tmp0_other_with_cast.g2f_1))
		      return false;
		    return true;
		  };
		  function $serializer_118() {
		    $serializer_instance_118 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LegStatusHistory', this, 2);
		    tmp0_serialDesc.pq('status', false);
		    tmp0_serialDesc.pq('date', false);
		    this.h2f_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_118).uf = function () {
		    return this.h2f_1;
		  };
		  protoOf($serializer_118).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_118).wf = function (decoder) {
		    var tmp0_desc = this.h2f_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return LegStatusHistory_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_118).i2f = function (encoder, value) {
		    var tmp0_desc = this.h2f_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.j2f_1);
		    tmp1_output.tk(tmp0_desc, 1, value.k2f_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_118).vf = function (encoder, value) {
		    return this.i2f(encoder, value instanceof LegStatusHistory ? value : THROW_CCE());
		  };
		  var $serializer_instance_118;
		  function $serializer_getInstance_118() {
		    if ($serializer_instance_118 == null)
		      new $serializer_118();
		    return $serializer_instance_118;
		  }
		  function LegStatusHistory_init_$Init$(seen1, status, date, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_118().h2f_1);
		    }
		    $this.j2f_1 = status;
		    $this.k2f_1 = date;
		    return $this;
		  }
		  function LegStatusHistory_init_$Create$(seen1, status, date, serializationConstructorMarker) {
		    return LegStatusHistory_init_$Init$(seen1, status, date, serializationConstructorMarker, objectCreate(protoOf(LegStatusHistory)));
		  }
		  function LegStatusHistory() {
		  }
		  protoOf(LegStatusHistory).toString = function () {
		    return 'LegStatusHistory(status=' + this.j2f_1 + ', date=' + this.k2f_1 + ')';
		  };
		  protoOf(LegStatusHistory).hashCode = function () {
		    var result = getStringHashCode(this.j2f_1);
		    result = imul(result, 31) + getStringHashCode(this.k2f_1) | 0;
		    return result;
		  };
		  protoOf(LegStatusHistory).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegStatusHistory))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegStatusHistory ? other : THROW_CCE();
		    if (!(this.j2f_1 === tmp0_other_with_cast.j2f_1))
		      return false;
		    if (!(this.k2f_1 === tmp0_other_with_cast.k2f_1))
		      return false;
		    return true;
		  };
		  function $serializer_119() {
		    $serializer_instance_119 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSEventStateBody', this, 1);
		    tmp0_serialDesc.pq('event_id', false);
		    this.l2f_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_119).uf = function () {
		    return this.l2f_1;
		  };
		  protoOf($serializer_119).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance()];
		  };
		  protoOf($serializer_119).wf = function (decoder) {
		    var tmp0_desc = this.l2f_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return CSEventStateBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_119).m2f = function (encoder, value) {
		    var tmp0_desc = this.l2f_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.h26_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_119).vf = function (encoder, value) {
		    return this.m2f(encoder, value instanceof CSEventStateBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_119;
		  function $serializer_getInstance_119() {
		    if ($serializer_instance_119 == null)
		      new $serializer_119();
		    return $serializer_instance_119;
		  }
		  function CSEventStateBody_init_$Init$(seen1, eventId, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_119().l2f_1);
		    }
		    $this.h26_1 = eventId;
		    return $this;
		  }
		  function CSEventStateBody_init_$Create$(seen1, eventId, serializationConstructorMarker) {
		    return CSEventStateBody_init_$Init$(seen1, eventId, serializationConstructorMarker, objectCreate(protoOf(CSEventStateBody)));
		  }
		  function CSEventStateBody() {
		  }
		  protoOf(CSEventStateBody).toString = function () {
		    return 'CSEventStateBody(eventId=' + this.h26_1 + ')';
		  };
		  protoOf(CSEventStateBody).hashCode = function () {
		    return this.h26_1;
		  };
		  protoOf(CSEventStateBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSEventStateBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSEventStateBody ? other : THROW_CCE();
		    if (!(this.h26_1 === tmp0_other_with_cast.h26_1))
		      return false;
		    return true;
		  };
		  function Companion_101() {
		  }
		  protoOf(Companion_101).y12 = function () {
		    return $serializer_getInstance_120();
		  };
		  var Companion_instance_102;
		  function Companion_getInstance_103() {
		    return Companion_instance_102;
		  }
		  function $serializer_120() {
		    $serializer_instance_120 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MessageEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.n2f_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_120).uf = function () {
		    return this.n2f_1;
		  };
		  protoOf($serializer_120).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [CSMessageEventBodySerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_120).wf = function (decoder) {
		    var tmp0_desc = this.n2f_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, CSMessageEventBodySerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, CSMessageEventBodySerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return MessageEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_120).o2f = function (encoder, value) {
		    var tmp0_desc = this.n2f_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, CSMessageEventBodySerializer_getInstance(), value.p2f_1);
		    tmp1_output.ok(tmp0_desc, 1, value.q2f_1);
		    tmp1_output.tk(tmp0_desc, 2, value.r2f_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.s2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.s2f_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.t2f_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.u2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.u2f_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.v2f_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_120).vf = function (encoder, value) {
		    return this.o2f(encoder, value instanceof MessageEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_120;
		  function $serializer_getInstance_120() {
		    if ($serializer_instance_120 == null)
		      new $serializer_120();
		    return $serializer_instance_120;
		  }
		  function MessageEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(87 === (87 & seen1))) {
		      throwMissingFieldException(seen1, 87, $serializer_getInstance_120().n2f_1);
		    }
		    $this.p2f_1 = body;
		    $this.q2f_1 = id;
		    $this.r2f_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.s2f_1 = null;
		    else
		      $this.s2f_1 = from;
		    $this.t2f_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.u2f_1 = null;
		    else
		      $this.u2f_1 = _embedded;
		    $this.v2f_1 = type;
		    return $this;
		  }
		  function MessageEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return MessageEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(MessageEvent)));
		  }
		  function MessageEvent() {
		  }
		  protoOf(MessageEvent).t27 = function () {
		    return this.q2f_1;
		  };
		  protoOf(MessageEvent).u27 = function () {
		    return this.r2f_1;
		  };
		  protoOf(MessageEvent).o2c = function () {
		    var from = Companion_instance_142.s24(this.u2f_1);
		    var tmp0_subject = this.p2f_1;
		    var tmp;
		    if (tmp0_subject instanceof TextBody) {
		      tmp = new MessageTextEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_16(this.p2f_1.e2h_1));
		    } else {
		      if (tmp0_subject instanceof CustomBody) {
		        tmp = new MessageCustomEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_17(this.p2f_1.b2h_1.toString()));
		      } else {
		        if (tmp0_subject instanceof AudioBody) {
		          tmp = new MessageAudioEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_20(this.p2f_1.y2g_1.w2f_1));
		        } else {
		          if (tmp0_subject instanceof FileBody) {
		            tmp = new MessageFileEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_21(this.p2f_1.v2g_1.w2f_1));
		          } else {
		            if (tmp0_subject instanceof ImageBody) {
		              tmp = new MessageImageEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_18(this.p2f_1.s2g_1.w2f_1));
		            } else {
		              if (tmp0_subject instanceof LocationBody) {
		                tmp = new MessageLocationEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_24(new Location(this.p2f_1.p2g_1.l2g_1, this.p2f_1.p2g_1.m2g_1, this.p2f_1.p2g_1.n2g_1, this.p2f_1.p2g_1.o2g_1)));
		              } else {
		                if (tmp0_subject instanceof TemplateBody) {
		                  tmp = new MessageTemplateEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_23(new TemplateObject_0(this.p2f_1.f2g_1.d2g_1, this.p2f_1.f2g_1.e2g_1), new WhatsappObject_0(this.p2f_1.i2g_1.j2g_1, this.p2f_1.i2g_1.k2g_1)));
		                } else {
		                  if (tmp0_subject instanceof VCardBody) {
		                    tmp = new MessageVCardEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_22(this.p2f_1.a2g_1.w2f_1));
		                  } else {
		                    if (tmp0_subject instanceof VideoBody) {
		                      tmp = new MessageVideoEvent(this.t2f_1, this.r2f_1, this.q2f_1, from, new Body_19(this.p2f_1.x2f_1.w2f_1));
		                    } else {
		                      noWhenBranchMatchedException();
		                    }
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  };
		  protoOf(MessageEvent).toString = function () {
		    return 'MessageEvent(body=' + this.p2f_1 + ', id=' + this.q2f_1 + ', cid=' + this.r2f_1 + ', from=' + this.s2f_1 + ', timestamp=' + this.t2f_1 + ', _embedded=' + this.u2f_1 + ', type=' + this.v2f_1 + ')';
		  };
		  protoOf(MessageEvent).hashCode = function () {
		    var result = hashCode(this.p2f_1);
		    result = imul(result, 31) + this.q2f_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.r2f_1) | 0;
		    result = imul(result, 31) + (this.s2f_1 == null ? 0 : getStringHashCode(this.s2f_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.t2f_1) | 0;
		    result = imul(result, 31) + (this.u2f_1 == null ? 0 : this.u2f_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.v2f_1) | 0;
		    return result;
		  };
		  protoOf(MessageEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageEvent ? other : THROW_CCE();
		    if (!equals(this.p2f_1, tmp0_other_with_cast.p2f_1))
		      return false;
		    if (!(this.q2f_1 === tmp0_other_with_cast.q2f_1))
		      return false;
		    if (!(this.r2f_1 === tmp0_other_with_cast.r2f_1))
		      return false;
		    if (!(this.s2f_1 == tmp0_other_with_cast.s2f_1))
		      return false;
		    if (!(this.t2f_1 === tmp0_other_with_cast.t2f_1))
		      return false;
		    if (!equals(this.u2f_1, tmp0_other_with_cast.u2f_1))
		      return false;
		    if (!(this.v2f_1 === tmp0_other_with_cast.v2f_1))
		      return false;
		    return true;
		  };
		  function Companion_102() {
		  }
		  protoOf(Companion_102).y12 = function () {
		    return $serializer_getInstance_121();
		  };
		  var Companion_instance_103;
		  function Companion_getInstance_104() {
		    return Companion_instance_103;
		  }
		  function $serializer_121() {
		    $serializer_instance_121 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.EphemeralEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.h2h_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_121).uf = function () {
		    return this.h2h_1;
		  };
		  protoOf($serializer_121).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [JsonObjectSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_121).wf = function (decoder) {
		    var tmp0_desc = this.h2h_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, JsonObjectSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, JsonObjectSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return EphemeralEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_121).i2h = function (encoder, value) {
		    var tmp0_desc = this.h2h_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, JsonObjectSerializer_getInstance(), value.j2h_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.k2h_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.k2h_1);
		    }
		    tmp1_output.tk(tmp0_desc, 2, value.l2h_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.m2h_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.m2h_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.n2h_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.o2h_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.o2h_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.p2h_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_121).vf = function (encoder, value) {
		    return this.i2h(encoder, value instanceof EphemeralEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_121;
		  function $serializer_getInstance_121() {
		    if ($serializer_instance_121 == null)
		      new $serializer_121();
		    return $serializer_instance_121;
		  }
		  function EphemeralEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(85 === (85 & seen1))) {
		      throwMissingFieldException(seen1, 85, $serializer_getInstance_121().h2h_1);
		    }
		    $this.j2h_1 = body;
		    if (0 === (seen1 & 2))
		      $this.k2h_1 = null;
		    else
		      $this.k2h_1 = id;
		    $this.l2h_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.m2h_1 = null;
		    else
		      $this.m2h_1 = from;
		    $this.n2h_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.o2h_1 = null;
		    else
		      $this.o2h_1 = _embedded;
		    $this.p2h_1 = type;
		    return $this;
		  }
		  function EphemeralEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return EphemeralEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(EphemeralEvent)));
		  }
		  function EphemeralEvent() {
		  }
		  protoOf(EphemeralEvent).t27 = function () {
		    return this.k2h_1;
		  };
		  protoOf(EphemeralEvent).u27 = function () {
		    return this.l2h_1;
		  };
		  protoOf(EphemeralEvent).o2c = function () {
		    return new EphemeralConversationEvent(this.n2h_1, this.l2h_1, Companion_instance_142.s24(this.o2h_1), this.j2h_1.toString());
		  };
		  protoOf(EphemeralEvent).toString = function () {
		    return 'EphemeralEvent(body=' + this.j2h_1 + ', id=' + this.k2h_1 + ', cid=' + this.l2h_1 + ', from=' + this.m2h_1 + ', timestamp=' + this.n2h_1 + ', _embedded=' + this.o2h_1 + ', type=' + this.p2h_1 + ')';
		  };
		  protoOf(EphemeralEvent).hashCode = function () {
		    var result = this.j2h_1.hashCode();
		    result = imul(result, 31) + (this.k2h_1 == null ? 0 : this.k2h_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.l2h_1) | 0;
		    result = imul(result, 31) + (this.m2h_1 == null ? 0 : getStringHashCode(this.m2h_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.n2h_1) | 0;
		    result = imul(result, 31) + (this.o2h_1 == null ? 0 : this.o2h_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.p2h_1) | 0;
		    return result;
		  };
		  protoOf(EphemeralEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EphemeralEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof EphemeralEvent ? other : THROW_CCE();
		    if (!this.j2h_1.equals(tmp0_other_with_cast.j2h_1))
		      return false;
		    if (!(this.k2h_1 == tmp0_other_with_cast.k2h_1))
		      return false;
		    if (!(this.l2h_1 === tmp0_other_with_cast.l2h_1))
		      return false;
		    if (!(this.m2h_1 == tmp0_other_with_cast.m2h_1))
		      return false;
		    if (!(this.n2h_1 === tmp0_other_with_cast.n2h_1))
		      return false;
		    if (!equals(this.o2h_1, tmp0_other_with_cast.o2h_1))
		      return false;
		    if (!(this.p2h_1 === tmp0_other_with_cast.p2h_1))
		      return false;
		    return true;
		  };
		  function Companion_103() {
		  }
		  protoOf(Companion_103).y12 = function () {
		    return $serializer_getInstance_122();
		  };
		  var Companion_instance_104;
		  function Companion_getInstance_105() {
		    return Companion_instance_104;
		  }
		  function $serializer_122() {
		    $serializer_instance_122 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.DeleteEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.q2h_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_122).uf = function () {
		    return this.q2h_1;
		  };
		  protoOf($serializer_122).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_119(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_122).wf = function (decoder) {
		    var tmp0_desc = this.q2h_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return DeleteEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_122).r2h = function (encoder, value) {
		    var tmp0_desc = this.q2h_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_119(), value.s2h_1);
		    tmp1_output.ok(tmp0_desc, 1, value.t2h_1);
		    tmp1_output.tk(tmp0_desc, 2, value.u2h_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.v2h_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.v2h_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.w2h_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.x2h_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.x2h_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.y2h_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_122).vf = function (encoder, value) {
		    return this.r2h(encoder, value instanceof DeleteEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_122;
		  function $serializer_getInstance_122() {
		    if ($serializer_instance_122 == null)
		      new $serializer_122();
		    return $serializer_instance_122;
		  }
		  function DeleteEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(87 === (87 & seen1))) {
		      throwMissingFieldException(seen1, 87, $serializer_getInstance_122().q2h_1);
		    }
		    $this.s2h_1 = body;
		    $this.t2h_1 = id;
		    $this.u2h_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.v2h_1 = null;
		    else
		      $this.v2h_1 = from;
		    $this.w2h_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.x2h_1 = null;
		    else
		      $this.x2h_1 = _embedded;
		    $this.y2h_1 = type;
		    return $this;
		  }
		  function DeleteEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return DeleteEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(DeleteEvent)));
		  }
		  function DeleteEvent() {
		  }
		  protoOf(DeleteEvent).t27 = function () {
		    return this.t2h_1;
		  };
		  protoOf(DeleteEvent).u27 = function () {
		    return this.u2h_1;
		  };
		  protoOf(DeleteEvent).o2c = function () {
		    return new EventDeleteConversationEvent(this.t2h_1, this.w2h_1, this.u2h_1, Companion_instance_142.s24(this.x2h_1), new EventStateBody(this.s2h_1.h26_1));
		  };
		  protoOf(DeleteEvent).toString = function () {
		    return 'DeleteEvent(body=' + this.s2h_1 + ', id=' + this.t2h_1 + ', cid=' + this.u2h_1 + ', from=' + this.v2h_1 + ', timestamp=' + this.w2h_1 + ', _embedded=' + this.x2h_1 + ', type=' + this.y2h_1 + ')';
		  };
		  protoOf(DeleteEvent).hashCode = function () {
		    var result = this.s2h_1.hashCode();
		    result = imul(result, 31) + this.t2h_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.u2h_1) | 0;
		    result = imul(result, 31) + (this.v2h_1 == null ? 0 : getStringHashCode(this.v2h_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.w2h_1) | 0;
		    result = imul(result, 31) + (this.x2h_1 == null ? 0 : this.x2h_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.y2h_1) | 0;
		    return result;
		  };
		  protoOf(DeleteEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof DeleteEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof DeleteEvent ? other : THROW_CCE();
		    if (!this.s2h_1.equals(tmp0_other_with_cast.s2h_1))
		      return false;
		    if (!(this.t2h_1 === tmp0_other_with_cast.t2h_1))
		      return false;
		    if (!(this.u2h_1 === tmp0_other_with_cast.u2h_1))
		      return false;
		    if (!(this.v2h_1 == tmp0_other_with_cast.v2h_1))
		      return false;
		    if (!(this.w2h_1 === tmp0_other_with_cast.w2h_1))
		      return false;
		    if (!equals(this.x2h_1, tmp0_other_with_cast.x2h_1))
		      return false;
		    if (!(this.y2h_1 === tmp0_other_with_cast.y2h_1))
		      return false;
		    return true;
		  };
		  function Companion_104() {
		  }
		  protoOf(Companion_104).y12 = function () {
		    return $serializer_getInstance_123();
		  };
		  var Companion_instance_105;
		  function Companion_getInstance_106() {
		    return Companion_instance_105;
		  }
		  function $serializer_123() {
		    $serializer_instance_123 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MessageDeliveredSocketEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.z2h_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_123).uf = function () {
		    return this.z2h_1;
		  };
		  protoOf($serializer_123).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_119(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_123).wf = function (decoder) {
		    var tmp0_desc = this.z2h_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return MessageDeliveredSocketEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_123).a2i = function (encoder, value) {
		    var tmp0_desc = this.z2h_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_119(), value.b2i_1);
		    tmp1_output.ok(tmp0_desc, 1, value.c2i_1);
		    tmp1_output.tk(tmp0_desc, 2, value.d2i_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.e2i_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.e2i_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.f2i_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.g2i_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.g2i_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.h2i_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_123).vf = function (encoder, value) {
		    return this.a2i(encoder, value instanceof MessageDeliveredSocketEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_123;
		  function $serializer_getInstance_123() {
		    if ($serializer_instance_123 == null)
		      new $serializer_123();
		    return $serializer_instance_123;
		  }
		  function MessageDeliveredSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(87 === (87 & seen1))) {
		      throwMissingFieldException(seen1, 87, $serializer_getInstance_123().z2h_1);
		    }
		    $this.b2i_1 = body;
		    $this.c2i_1 = id;
		    $this.d2i_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.e2i_1 = null;
		    else
		      $this.e2i_1 = from;
		    $this.f2i_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.g2i_1 = null;
		    else
		      $this.g2i_1 = _embedded;
		    $this.h2i_1 = type;
		    return $this;
		  }
		  function MessageDeliveredSocketEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return MessageDeliveredSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(MessageDeliveredSocketEvent)));
		  }
		  function MessageDeliveredSocketEvent() {
		  }
		  protoOf(MessageDeliveredSocketEvent).t27 = function () {
		    return this.c2i_1;
		  };
		  protoOf(MessageDeliveredSocketEvent).u27 = function () {
		    return this.d2i_1;
		  };
		  protoOf(MessageDeliveredSocketEvent).o2c = function () {
		    return new MessageDeliveredEvent(this.c2i_1, this.f2i_1, this.d2i_1, Companion_instance_142.s24(this.g2i_1), new EventStateBody(this.b2i_1.h26_1));
		  };
		  protoOf(MessageDeliveredSocketEvent).toString = function () {
		    return 'MessageDeliveredSocketEvent(body=' + this.b2i_1 + ', id=' + this.c2i_1 + ', cid=' + this.d2i_1 + ', from=' + this.e2i_1 + ', timestamp=' + this.f2i_1 + ', _embedded=' + this.g2i_1 + ', type=' + this.h2i_1 + ')';
		  };
		  protoOf(MessageDeliveredSocketEvent).hashCode = function () {
		    var result = this.b2i_1.hashCode();
		    result = imul(result, 31) + this.c2i_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.d2i_1) | 0;
		    result = imul(result, 31) + (this.e2i_1 == null ? 0 : getStringHashCode(this.e2i_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f2i_1) | 0;
		    result = imul(result, 31) + (this.g2i_1 == null ? 0 : this.g2i_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.h2i_1) | 0;
		    return result;
		  };
		  protoOf(MessageDeliveredSocketEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageDeliveredSocketEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageDeliveredSocketEvent ? other : THROW_CCE();
		    if (!this.b2i_1.equals(tmp0_other_with_cast.b2i_1))
		      return false;
		    if (!(this.c2i_1 === tmp0_other_with_cast.c2i_1))
		      return false;
		    if (!(this.d2i_1 === tmp0_other_with_cast.d2i_1))
		      return false;
		    if (!(this.e2i_1 == tmp0_other_with_cast.e2i_1))
		      return false;
		    if (!(this.f2i_1 === tmp0_other_with_cast.f2i_1))
		      return false;
		    if (!equals(this.g2i_1, tmp0_other_with_cast.g2i_1))
		      return false;
		    if (!(this.h2i_1 === tmp0_other_with_cast.h2i_1))
		      return false;
		    return true;
		  };
		  function Companion_105() {
		  }
		  protoOf(Companion_105).y12 = function () {
		    return $serializer_getInstance_124();
		  };
		  var Companion_instance_106;
		  function Companion_getInstance_107() {
		    return Companion_instance_106;
		  }
		  function $serializer_124() {
		    $serializer_instance_124 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MessageRejectedSocketEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.i2i_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_124).uf = function () {
		    return this.i2i_1;
		  };
		  protoOf($serializer_124).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_119(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_124).wf = function (decoder) {
		    var tmp0_desc = this.i2i_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return MessageRejectedSocketEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_124).j2i = function (encoder, value) {
		    var tmp0_desc = this.i2i_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_119(), value.k2i_1);
		    tmp1_output.ok(tmp0_desc, 1, value.l2i_1);
		    tmp1_output.tk(tmp0_desc, 2, value.m2i_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.n2i_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.n2i_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.o2i_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.p2i_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.p2i_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.q2i_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_124).vf = function (encoder, value) {
		    return this.j2i(encoder, value instanceof MessageRejectedSocketEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_124;
		  function $serializer_getInstance_124() {
		    if ($serializer_instance_124 == null)
		      new $serializer_124();
		    return $serializer_instance_124;
		  }
		  function MessageRejectedSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(87 === (87 & seen1))) {
		      throwMissingFieldException(seen1, 87, $serializer_getInstance_124().i2i_1);
		    }
		    $this.k2i_1 = body;
		    $this.l2i_1 = id;
		    $this.m2i_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.n2i_1 = null;
		    else
		      $this.n2i_1 = from;
		    $this.o2i_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.p2i_1 = null;
		    else
		      $this.p2i_1 = _embedded;
		    $this.q2i_1 = type;
		    return $this;
		  }
		  function MessageRejectedSocketEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return MessageRejectedSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(MessageRejectedSocketEvent)));
		  }
		  function MessageRejectedSocketEvent() {
		  }
		  protoOf(MessageRejectedSocketEvent).t27 = function () {
		    return this.l2i_1;
		  };
		  protoOf(MessageRejectedSocketEvent).u27 = function () {
		    return this.m2i_1;
		  };
		  protoOf(MessageRejectedSocketEvent).o2c = function () {
		    return new MessageRejectedEvent(this.l2i_1, this.o2i_1, this.m2i_1, Companion_instance_142.s24(this.p2i_1), new EventStateBody(this.k2i_1.h26_1));
		  };
		  protoOf(MessageRejectedSocketEvent).toString = function () {
		    return 'MessageRejectedSocketEvent(body=' + this.k2i_1 + ', id=' + this.l2i_1 + ', cid=' + this.m2i_1 + ', from=' + this.n2i_1 + ', timestamp=' + this.o2i_1 + ', _embedded=' + this.p2i_1 + ', type=' + this.q2i_1 + ')';
		  };
		  protoOf(MessageRejectedSocketEvent).hashCode = function () {
		    var result = this.k2i_1.hashCode();
		    result = imul(result, 31) + this.l2i_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.m2i_1) | 0;
		    result = imul(result, 31) + (this.n2i_1 == null ? 0 : getStringHashCode(this.n2i_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.o2i_1) | 0;
		    result = imul(result, 31) + (this.p2i_1 == null ? 0 : this.p2i_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.q2i_1) | 0;
		    return result;
		  };
		  protoOf(MessageRejectedSocketEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageRejectedSocketEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageRejectedSocketEvent ? other : THROW_CCE();
		    if (!this.k2i_1.equals(tmp0_other_with_cast.k2i_1))
		      return false;
		    if (!(this.l2i_1 === tmp0_other_with_cast.l2i_1))
		      return false;
		    if (!(this.m2i_1 === tmp0_other_with_cast.m2i_1))
		      return false;
		    if (!(this.n2i_1 == tmp0_other_with_cast.n2i_1))
		      return false;
		    if (!(this.o2i_1 === tmp0_other_with_cast.o2i_1))
		      return false;
		    if (!equals(this.p2i_1, tmp0_other_with_cast.p2i_1))
		      return false;
		    if (!(this.q2i_1 === tmp0_other_with_cast.q2i_1))
		      return false;
		    return true;
		  };
		  function Companion_106() {
		  }
		  protoOf(Companion_106).y12 = function () {
		    return $serializer_getInstance_125();
		  };
		  var Companion_instance_107;
		  function Companion_getInstance_108() {
		    return Companion_instance_107;
		  }
		  function $serializer_125() {
		    $serializer_instance_125 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MessageSubmittedSocketEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.r2i_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_125).uf = function () {
		    return this.r2i_1;
		  };
		  protoOf($serializer_125).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_119(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_125).wf = function (decoder) {
		    var tmp0_desc = this.r2i_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return MessageSubmittedSocketEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_125).s2i = function (encoder, value) {
		    var tmp0_desc = this.r2i_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_119(), value.t2i_1);
		    tmp1_output.ok(tmp0_desc, 1, value.u2i_1);
		    tmp1_output.tk(tmp0_desc, 2, value.v2i_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.w2i_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.w2i_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.x2i_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.y2i_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.y2i_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.z2i_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_125).vf = function (encoder, value) {
		    return this.s2i(encoder, value instanceof MessageSubmittedSocketEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_125;
		  function $serializer_getInstance_125() {
		    if ($serializer_instance_125 == null)
		      new $serializer_125();
		    return $serializer_instance_125;
		  }
		  function MessageSubmittedSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(87 === (87 & seen1))) {
		      throwMissingFieldException(seen1, 87, $serializer_getInstance_125().r2i_1);
		    }
		    $this.t2i_1 = body;
		    $this.u2i_1 = id;
		    $this.v2i_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.w2i_1 = null;
		    else
		      $this.w2i_1 = from;
		    $this.x2i_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.y2i_1 = null;
		    else
		      $this.y2i_1 = _embedded;
		    $this.z2i_1 = type;
		    return $this;
		  }
		  function MessageSubmittedSocketEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return MessageSubmittedSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(MessageSubmittedSocketEvent)));
		  }
		  function MessageSubmittedSocketEvent() {
		  }
		  protoOf(MessageSubmittedSocketEvent).t27 = function () {
		    return this.u2i_1;
		  };
		  protoOf(MessageSubmittedSocketEvent).u27 = function () {
		    return this.v2i_1;
		  };
		  protoOf(MessageSubmittedSocketEvent).o2c = function () {
		    return new MessageSubmittedEvent(this.u2i_1, this.x2i_1, this.v2i_1, Companion_instance_142.s24(this.y2i_1), new EventStateBody(this.t2i_1.h26_1));
		  };
		  protoOf(MessageSubmittedSocketEvent).toString = function () {
		    return 'MessageSubmittedSocketEvent(body=' + this.t2i_1 + ', id=' + this.u2i_1 + ', cid=' + this.v2i_1 + ', from=' + this.w2i_1 + ', timestamp=' + this.x2i_1 + ', _embedded=' + this.y2i_1 + ', type=' + this.z2i_1 + ')';
		  };
		  protoOf(MessageSubmittedSocketEvent).hashCode = function () {
		    var result = this.t2i_1.hashCode();
		    result = imul(result, 31) + this.u2i_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.v2i_1) | 0;
		    result = imul(result, 31) + (this.w2i_1 == null ? 0 : getStringHashCode(this.w2i_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.x2i_1) | 0;
		    result = imul(result, 31) + (this.y2i_1 == null ? 0 : this.y2i_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.z2i_1) | 0;
		    return result;
		  };
		  protoOf(MessageSubmittedSocketEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageSubmittedSocketEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageSubmittedSocketEvent ? other : THROW_CCE();
		    if (!this.t2i_1.equals(tmp0_other_with_cast.t2i_1))
		      return false;
		    if (!(this.u2i_1 === tmp0_other_with_cast.u2i_1))
		      return false;
		    if (!(this.v2i_1 === tmp0_other_with_cast.v2i_1))
		      return false;
		    if (!(this.w2i_1 == tmp0_other_with_cast.w2i_1))
		      return false;
		    if (!(this.x2i_1 === tmp0_other_with_cast.x2i_1))
		      return false;
		    if (!equals(this.y2i_1, tmp0_other_with_cast.y2i_1))
		      return false;
		    if (!(this.z2i_1 === tmp0_other_with_cast.z2i_1))
		      return false;
		    return true;
		  };
		  function Companion_107() {
		  }
		  protoOf(Companion_107).y12 = function () {
		    return $serializer_getInstance_126();
		  };
		  var Companion_instance_108;
		  function Companion_getInstance_109() {
		    return Companion_instance_108;
		  }
		  function $serializer_126() {
		    $serializer_instance_126 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MessageUndeliverableSocketEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.a2j_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_126).uf = function () {
		    return this.a2j_1;
		  };
		  protoOf($serializer_126).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_119(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_126).wf = function (decoder) {
		    var tmp0_desc = this.a2j_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return MessageUndeliverableSocketEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_126).b2j = function (encoder, value) {
		    var tmp0_desc = this.a2j_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_119(), value.c2j_1);
		    tmp1_output.ok(tmp0_desc, 1, value.d2j_1);
		    tmp1_output.tk(tmp0_desc, 2, value.e2j_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.f2j_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.f2j_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.g2j_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.h2j_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.h2j_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.i2j_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_126).vf = function (encoder, value) {
		    return this.b2j(encoder, value instanceof MessageUndeliverableSocketEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_126;
		  function $serializer_getInstance_126() {
		    if ($serializer_instance_126 == null)
		      new $serializer_126();
		    return $serializer_instance_126;
		  }
		  function MessageUndeliverableSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(87 === (87 & seen1))) {
		      throwMissingFieldException(seen1, 87, $serializer_getInstance_126().a2j_1);
		    }
		    $this.c2j_1 = body;
		    $this.d2j_1 = id;
		    $this.e2j_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.f2j_1 = null;
		    else
		      $this.f2j_1 = from;
		    $this.g2j_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.h2j_1 = null;
		    else
		      $this.h2j_1 = _embedded;
		    $this.i2j_1 = type;
		    return $this;
		  }
		  function MessageUndeliverableSocketEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return MessageUndeliverableSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(MessageUndeliverableSocketEvent)));
		  }
		  function MessageUndeliverableSocketEvent() {
		  }
		  protoOf(MessageUndeliverableSocketEvent).t27 = function () {
		    return this.d2j_1;
		  };
		  protoOf(MessageUndeliverableSocketEvent).u27 = function () {
		    return this.e2j_1;
		  };
		  protoOf(MessageUndeliverableSocketEvent).o2c = function () {
		    return new MessageUndeliverableEvent(this.d2j_1, this.g2j_1, this.e2j_1, Companion_instance_142.s24(this.h2j_1), new EventStateBody(this.c2j_1.h26_1));
		  };
		  protoOf(MessageUndeliverableSocketEvent).toString = function () {
		    return 'MessageUndeliverableSocketEvent(body=' + this.c2j_1 + ', id=' + this.d2j_1 + ', cid=' + this.e2j_1 + ', from=' + this.f2j_1 + ', timestamp=' + this.g2j_1 + ', _embedded=' + this.h2j_1 + ', type=' + this.i2j_1 + ')';
		  };
		  protoOf(MessageUndeliverableSocketEvent).hashCode = function () {
		    var result = this.c2j_1.hashCode();
		    result = imul(result, 31) + this.d2j_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.e2j_1) | 0;
		    result = imul(result, 31) + (this.f2j_1 == null ? 0 : getStringHashCode(this.f2j_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.g2j_1) | 0;
		    result = imul(result, 31) + (this.h2j_1 == null ? 0 : this.h2j_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.i2j_1) | 0;
		    return result;
		  };
		  protoOf(MessageUndeliverableSocketEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageUndeliverableSocketEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageUndeliverableSocketEvent ? other : THROW_CCE();
		    if (!this.c2j_1.equals(tmp0_other_with_cast.c2j_1))
		      return false;
		    if (!(this.d2j_1 === tmp0_other_with_cast.d2j_1))
		      return false;
		    if (!(this.e2j_1 === tmp0_other_with_cast.e2j_1))
		      return false;
		    if (!(this.f2j_1 == tmp0_other_with_cast.f2j_1))
		      return false;
		    if (!(this.g2j_1 === tmp0_other_with_cast.g2j_1))
		      return false;
		    if (!equals(this.h2j_1, tmp0_other_with_cast.h2j_1))
		      return false;
		    if (!(this.i2j_1 === tmp0_other_with_cast.i2j_1))
		      return false;
		    return true;
		  };
		  function Companion_108() {
		  }
		  protoOf(Companion_108).y12 = function () {
		    return $serializer_getInstance_127();
		  };
		  var Companion_instance_109;
		  function Companion_getInstance_110() {
		    return Companion_instance_109;
		  }
		  function $serializer_127() {
		    $serializer_instance_127 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.MessageSeenSocketEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.j2j_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_127).uf = function () {
		    return this.j2j_1;
		  };
		  protoOf($serializer_127).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_119(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_127).wf = function (decoder) {
		    var tmp0_desc = this.j2j_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, $serializer_getInstance_119(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return MessageSeenSocketEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_127).k2j = function (encoder, value) {
		    var tmp0_desc = this.j2j_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_119(), value.l2j_1);
		    tmp1_output.ok(tmp0_desc, 1, value.m2j_1);
		    tmp1_output.tk(tmp0_desc, 2, value.n2j_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.o2j_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.o2j_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.p2j_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.q2j_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.q2j_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.r2j_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_127).vf = function (encoder, value) {
		    return this.k2j(encoder, value instanceof MessageSeenSocketEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_127;
		  function $serializer_getInstance_127() {
		    if ($serializer_instance_127 == null)
		      new $serializer_127();
		    return $serializer_instance_127;
		  }
		  function MessageSeenSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(87 === (87 & seen1))) {
		      throwMissingFieldException(seen1, 87, $serializer_getInstance_127().j2j_1);
		    }
		    $this.l2j_1 = body;
		    $this.m2j_1 = id;
		    $this.n2j_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.o2j_1 = null;
		    else
		      $this.o2j_1 = from;
		    $this.p2j_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.q2j_1 = null;
		    else
		      $this.q2j_1 = _embedded;
		    $this.r2j_1 = type;
		    return $this;
		  }
		  function MessageSeenSocketEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return MessageSeenSocketEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(MessageSeenSocketEvent)));
		  }
		  function MessageSeenSocketEvent() {
		  }
		  protoOf(MessageSeenSocketEvent).t27 = function () {
		    return this.m2j_1;
		  };
		  protoOf(MessageSeenSocketEvent).u27 = function () {
		    return this.n2j_1;
		  };
		  protoOf(MessageSeenSocketEvent).o2c = function () {
		    return new MessageSeenEvent(this.m2j_1, this.p2j_1, this.n2j_1, Companion_instance_142.s24(this.q2j_1), new EventStateBody(this.l2j_1.h26_1));
		  };
		  protoOf(MessageSeenSocketEvent).toString = function () {
		    return 'MessageSeenSocketEvent(body=' + this.l2j_1 + ', id=' + this.m2j_1 + ', cid=' + this.n2j_1 + ', from=' + this.o2j_1 + ', timestamp=' + this.p2j_1 + ', _embedded=' + this.q2j_1 + ', type=' + this.r2j_1 + ')';
		  };
		  protoOf(MessageSeenSocketEvent).hashCode = function () {
		    var result = this.l2j_1.hashCode();
		    result = imul(result, 31) + this.m2j_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.n2j_1) | 0;
		    result = imul(result, 31) + (this.o2j_1 == null ? 0 : getStringHashCode(this.o2j_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.p2j_1) | 0;
		    result = imul(result, 31) + (this.q2j_1 == null ? 0 : this.q2j_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.r2j_1) | 0;
		    return result;
		  };
		  protoOf(MessageSeenSocketEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageSeenSocketEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageSeenSocketEvent ? other : THROW_CCE();
		    if (!this.l2j_1.equals(tmp0_other_with_cast.l2j_1))
		      return false;
		    if (!(this.m2j_1 === tmp0_other_with_cast.m2j_1))
		      return false;
		    if (!(this.n2j_1 === tmp0_other_with_cast.n2j_1))
		      return false;
		    if (!(this.o2j_1 == tmp0_other_with_cast.o2j_1))
		      return false;
		    if (!(this.p2j_1 === tmp0_other_with_cast.p2j_1))
		      return false;
		    if (!equals(this.q2j_1, tmp0_other_with_cast.q2j_1))
		      return false;
		    if (!(this.r2j_1 === tmp0_other_with_cast.r2j_1))
		      return false;
		    return true;
		  };
		  function Companion_109() {
		  }
		  protoOf(Companion_109).y12 = function () {
		    return $serializer_getInstance_128();
		  };
		  var Companion_instance_110;
		  function Companion_getInstance_111() {
		    return Companion_instance_110;
		  }
		  function $serializer_128() {
		    $serializer_instance_128 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioSayDoneEvent', this, 5);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.s2j_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_128).uf = function () {
		    return this.s2j_1;
		  };
		  protoOf($serializer_128).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_130(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_128).wf = function (decoder) {
		    var tmp0_desc = this.s2j_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_130(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, $serializer_getInstance_130(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return AudioSayDoneEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_128).t2j = function (encoder, value) {
		    var tmp0_desc = this.s2j_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_130(), value.u2j_1);
		    tmp1_output.ok(tmp0_desc, 1, value.v2j_1);
		    tmp1_output.tk(tmp0_desc, 2, value.w2j_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.x2j_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.x2j_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.y2j_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_128).vf = function (encoder, value) {
		    return this.t2j(encoder, value instanceof AudioSayDoneEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_128;
		  function $serializer_getInstance_128() {
		    if ($serializer_instance_128 == null)
		      new $serializer_128();
		    return $serializer_instance_128;
		  }
		  function AudioSayDoneEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(23 === (23 & seen1))) {
		      throwMissingFieldException(seen1, 23, $serializer_getInstance_128().s2j_1);
		    }
		    $this.u2j_1 = body;
		    $this.v2j_1 = id;
		    $this.w2j_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.x2j_1 = null;
		    else
		      $this.x2j_1 = from;
		    $this.y2j_1 = type;
		    return $this;
		  }
		  function AudioSayDoneEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return AudioSayDoneEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(AudioSayDoneEvent)));
		  }
		  function AudioSayDoneEvent() {
		  }
		  protoOf(AudioSayDoneEvent).t27 = function () {
		    return this.v2j_1;
		  };
		  protoOf(AudioSayDoneEvent).u27 = function () {
		    return this.w2j_1;
		  };
		  protoOf(AudioSayDoneEvent).toString = function () {
		    return 'AudioSayDoneEvent(body=' + this.u2j_1 + ', id=' + this.v2j_1 + ', cid=' + this.w2j_1 + ', from=' + this.x2j_1 + ', type=' + this.y2j_1 + ')';
		  };
		  protoOf(AudioSayDoneEvent).hashCode = function () {
		    var result = this.u2j_1.hashCode();
		    result = imul(result, 31) + this.v2j_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.w2j_1) | 0;
		    result = imul(result, 31) + (this.x2j_1 == null ? 0 : getStringHashCode(this.x2j_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.y2j_1) | 0;
		    return result;
		  };
		  protoOf(AudioSayDoneEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioSayDoneEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioSayDoneEvent ? other : THROW_CCE();
		    if (!this.u2j_1.equals(tmp0_other_with_cast.u2j_1))
		      return false;
		    if (!(this.v2j_1 === tmp0_other_with_cast.v2j_1))
		      return false;
		    if (!(this.w2j_1 === tmp0_other_with_cast.w2j_1))
		      return false;
		    if (!(this.x2j_1 == tmp0_other_with_cast.x2j_1))
		      return false;
		    if (!(this.y2j_1 === tmp0_other_with_cast.y2j_1))
		      return false;
		    return true;
		  };
		  function Companion_110() {
		  }
		  protoOf(Companion_110).y12 = function () {
		    return $serializer_getInstance_129();
		  };
		  var Companion_instance_111;
		  function Companion_getInstance_112() {
		    return Companion_instance_111;
		  }
		  function $serializer_129() {
		    $serializer_instance_129 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CustomEvent', this, 7);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('cid', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('type', false);
		    this.z2j_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_129).uf = function () {
		    return this.z2j_1;
		  };
		  protoOf($serializer_129).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [JsonObjectSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_54()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_129).wf = function (decoder) {
		    var tmp0_desc = this.z2j_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = 0;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_input = decoder.ej(tmp0_desc);
		    if (tmp11_input.uj()) {
		      tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, JsonObjectSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp11_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp11_input.qj(tmp0_desc, 0, JsonObjectSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp11_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp11_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp11_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp11_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp11_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp11_input.oj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp11_input.fj(tmp0_desc);
		    return CustomEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
		  };
		  protoOf($serializer_129).a2k = function (encoder, value) {
		    var tmp0_desc = this.z2j_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, JsonObjectSerializer_getInstance(), value.b2k_1);
		    tmp1_output.ok(tmp0_desc, 1, value.c2k_1);
		    tmp1_output.tk(tmp0_desc, 2, value.d2k_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.e2k_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.e2k_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.f2k_1);
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.g2k_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.g2k_1);
		    }
		    tmp1_output.tk(tmp0_desc, 6, value.h2k_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_129).vf = function (encoder, value) {
		    return this.a2k(encoder, value instanceof CustomEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_129;
		  function $serializer_getInstance_129() {
		    if ($serializer_instance_129 == null)
		      new $serializer_129();
		    return $serializer_instance_129;
		  }
		  function CustomEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, $this) {
		    if (!(87 === (87 & seen1))) {
		      throwMissingFieldException(seen1, 87, $serializer_getInstance_129().z2j_1);
		    }
		    $this.b2k_1 = body;
		    $this.c2k_1 = id;
		    $this.d2k_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.e2k_1 = null;
		    else
		      $this.e2k_1 = from;
		    $this.f2k_1 = timestamp;
		    if (0 === (seen1 & 32))
		      $this.g2k_1 = null;
		    else
		      $this.g2k_1 = _embedded;
		    $this.h2k_1 = type;
		    return $this;
		  }
		  function CustomEvent_init_$Create$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker) {
		    return CustomEvent_init_$Init$(seen1, body, id, cid, from, timestamp, _embedded, type, serializationConstructorMarker, objectCreate(protoOf(CustomEvent)));
		  }
		  function CustomEvent() {
		  }
		  protoOf(CustomEvent).t27 = function () {
		    return this.c2k_1;
		  };
		  protoOf(CustomEvent).u27 = function () {
		    return this.d2k_1;
		  };
		  protoOf(CustomEvent).o2c = function () {
		    return new CustomConversationEvent(this.c2k_1, this.f2k_1, this.d2k_1, Companion_instance_142.s24(this.g2k_1), this.b2k_1.toString(), this.h2k_1);
		  };
		  protoOf(CustomEvent).toString = function () {
		    return 'CustomEvent(body=' + this.b2k_1 + ', id=' + this.c2k_1 + ', cid=' + this.d2k_1 + ', from=' + this.e2k_1 + ', timestamp=' + this.f2k_1 + ', _embedded=' + this.g2k_1 + ', type=' + this.h2k_1 + ')';
		  };
		  protoOf(CustomEvent).hashCode = function () {
		    var result = this.b2k_1.hashCode();
		    result = imul(result, 31) + this.c2k_1 | 0;
		    result = imul(result, 31) + getStringHashCode(this.d2k_1) | 0;
		    result = imul(result, 31) + (this.e2k_1 == null ? 0 : getStringHashCode(this.e2k_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f2k_1) | 0;
		    result = imul(result, 31) + (this.g2k_1 == null ? 0 : this.g2k_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.h2k_1) | 0;
		    return result;
		  };
		  protoOf(CustomEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CustomEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof CustomEvent ? other : THROW_CCE();
		    if (!this.b2k_1.equals(tmp0_other_with_cast.b2k_1))
		      return false;
		    if (!(this.c2k_1 === tmp0_other_with_cast.c2k_1))
		      return false;
		    if (!(this.d2k_1 === tmp0_other_with_cast.d2k_1))
		      return false;
		    if (!(this.e2k_1 == tmp0_other_with_cast.e2k_1))
		      return false;
		    if (!(this.f2k_1 === tmp0_other_with_cast.f2k_1))
		      return false;
		    if (!equals(this.g2k_1, tmp0_other_with_cast.g2k_1))
		      return false;
		    if (!(this.h2k_1 === tmp0_other_with_cast.h2k_1))
		      return false;
		    return true;
		  };
		  function $serializer_130() {
		    $serializer_instance_130 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AudioSayDone', this, 1);
		    tmp0_serialDesc.pq('say_id', false);
		    this.i2k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_130).uf = function () {
		    return this.i2k_1;
		  };
		  protoOf($serializer_130).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_130).wf = function (decoder) {
		    var tmp0_desc = this.i2k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return AudioSayDone_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_130).j2k = function (encoder, value) {
		    var tmp0_desc = this.i2k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.k2k_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_130).vf = function (encoder, value) {
		    return this.j2k(encoder, value instanceof AudioSayDone ? value : THROW_CCE());
		  };
		  var $serializer_instance_130;
		  function $serializer_getInstance_130() {
		    if ($serializer_instance_130 == null)
		      new $serializer_130();
		    return $serializer_instance_130;
		  }
		  function AudioSayDone_init_$Init$(seen1, say_id, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_130().i2k_1);
		    }
		    $this.k2k_1 = say_id;
		    return $this;
		  }
		  function AudioSayDone_init_$Create$(seen1, say_id, serializationConstructorMarker) {
		    return AudioSayDone_init_$Init$(seen1, say_id, serializationConstructorMarker, objectCreate(protoOf(AudioSayDone)));
		  }
		  function AudioSayDone() {
		  }
		  protoOf(AudioSayDone).toString = function () {
		    return 'AudioSayDone(say_id=' + this.k2k_1 + ')';
		  };
		  protoOf(AudioSayDone).hashCode = function () {
		    return getStringHashCode(this.k2k_1);
		  };
		  protoOf(AudioSayDone).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioSayDone))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioSayDone ? other : THROW_CCE();
		    if (!(this.k2k_1 === tmp0_other_with_cast.k2k_1))
		      return false;
		    return true;
		  };
		  function Companion_111() {
		  }
		  protoOf(Companion_111).y12 = function () {
		    return $serializer_getInstance_131();
		  };
		  var Companion_instance_112;
		  function Companion_getInstance_113() {
		    return Companion_instance_112;
		  }
		  function $serializer_131() {
		    $serializer_instance_131 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.TextBody', this, 3);
		    tmp0_serialDesc.pq('text', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.l2k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_131).uf = function () {
		    return this.l2k_1;
		  };
		  protoOf($serializer_131).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87())];
		  };
		  protoOf($serializer_131).wf = function (decoder) {
		    var tmp0_desc = this.l2k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return TextBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_131).m2k = function (encoder, value) {
		    var tmp0_desc = this.l2k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.e2h_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.f2h_1.equals(CSMessageType_TEXT_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.f2h_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.g2h_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.g2h_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_131).vf = function (encoder, value) {
		    return this.m2k(encoder, value instanceof TextBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_131;
		  function $serializer_getInstance_131() {
		    if ($serializer_instance_131 == null)
		      new $serializer_131();
		    return $serializer_instance_131;
		  }
		  function TextBody_init_$Init$(seen1, text, message_type, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_131().l2k_1);
		    }
		    $this.e2h_1 = text;
		    if (0 === (seen1 & 2))
		      $this.f2h_1 = CSMessageType_TEXT_getInstance();
		    else
		      $this.f2h_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.g2h_1 = null;
		    else
		      $this.g2h_1 = timestamp;
		    return $this;
		  }
		  function TextBody_init_$Create$(seen1, text, message_type, timestamp, serializationConstructorMarker) {
		    return TextBody_init_$Init$(seen1, text, message_type, timestamp, serializationConstructorMarker, objectCreate(protoOf(TextBody)));
		  }
		  function Companion_112() {
		  }
		  protoOf(Companion_112).y12 = function () {
		    return $serializer_getInstance_132();
		  };
		  var Companion_instance_113;
		  function Companion_getInstance_114() {
		    return Companion_instance_113;
		  }
		  function $serializer_132() {
		    $serializer_instance_132 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.ImageBody', this, 3);
		    tmp0_serialDesc.pq('image', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.n2k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_132).uf = function () {
		    return this.n2k_1;
		  };
		  protoOf($serializer_132).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_141(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87())];
		  };
		  protoOf($serializer_132).wf = function (decoder) {
		    var tmp0_desc = this.n2k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return ImageBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_132).o2k = function (encoder, value) {
		    var tmp0_desc = this.n2k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_141(), value.s2g_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.t2g_1.equals(CSMessageType_IMAGE_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.t2g_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.u2g_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.u2g_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_132).vf = function (encoder, value) {
		    return this.o2k(encoder, value instanceof ImageBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_132;
		  function $serializer_getInstance_132() {
		    if ($serializer_instance_132 == null)
		      new $serializer_132();
		    return $serializer_instance_132;
		  }
		  function ImageBody_init_$Init$(seen1, image, message_type, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_132().n2k_1);
		    }
		    $this.s2g_1 = image;
		    if (0 === (seen1 & 2))
		      $this.t2g_1 = CSMessageType_IMAGE_getInstance();
		    else
		      $this.t2g_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.u2g_1 = null;
		    else
		      $this.u2g_1 = timestamp;
		    return $this;
		  }
		  function ImageBody_init_$Create$(seen1, image, message_type, timestamp, serializationConstructorMarker) {
		    return ImageBody_init_$Init$(seen1, image, message_type, timestamp, serializationConstructorMarker, objectCreate(protoOf(ImageBody)));
		  }
		  function Companion_113() {
		  }
		  protoOf(Companion_113).y12 = function () {
		    return $serializer_getInstance_133();
		  };
		  var Companion_instance_114;
		  function Companion_getInstance_115() {
		    return Companion_instance_114;
		  }
		  function $serializer_133() {
		    $serializer_instance_133 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.VideoBody', this, 3);
		    tmp0_serialDesc.pq('video', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.p2k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_133).uf = function () {
		    return this.p2k_1;
		  };
		  protoOf($serializer_133).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_141(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87())];
		  };
		  protoOf($serializer_133).wf = function (decoder) {
		    var tmp0_desc = this.p2k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return VideoBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_133).q2k = function (encoder, value) {
		    var tmp0_desc = this.p2k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_141(), value.x2f_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.y2f_1.equals(CSMessageType_VIDEO_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.y2f_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.z2f_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.z2f_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_133).vf = function (encoder, value) {
		    return this.q2k(encoder, value instanceof VideoBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_133;
		  function $serializer_getInstance_133() {
		    if ($serializer_instance_133 == null)
		      new $serializer_133();
		    return $serializer_instance_133;
		  }
		  function VideoBody_init_$Init$(seen1, video, message_type, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_133().p2k_1);
		    }
		    $this.x2f_1 = video;
		    if (0 === (seen1 & 2))
		      $this.y2f_1 = CSMessageType_VIDEO_getInstance();
		    else
		      $this.y2f_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.z2f_1 = null;
		    else
		      $this.z2f_1 = timestamp;
		    return $this;
		  }
		  function VideoBody_init_$Create$(seen1, video, message_type, timestamp, serializationConstructorMarker) {
		    return VideoBody_init_$Init$(seen1, video, message_type, timestamp, serializationConstructorMarker, objectCreate(protoOf(VideoBody)));
		  }
		  function Companion_114() {
		  }
		  protoOf(Companion_114).y12 = function () {
		    return $serializer_getInstance_134();
		  };
		  var Companion_instance_115;
		  function Companion_getInstance_116() {
		    return Companion_instance_115;
		  }
		  function $serializer_134() {
		    $serializer_instance_134 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.AudioBody', this, 3);
		    tmp0_serialDesc.pq('audio', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.r2k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_134).uf = function () {
		    return this.r2k_1;
		  };
		  protoOf($serializer_134).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_141(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87())];
		  };
		  protoOf($serializer_134).wf = function (decoder) {
		    var tmp0_desc = this.r2k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return AudioBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_134).s2k = function (encoder, value) {
		    var tmp0_desc = this.r2k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_141(), value.y2g_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.z2g_1.equals(CSMessageType_AUDIO_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.z2g_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.a2h_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.a2h_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_134).vf = function (encoder, value) {
		    return this.s2k(encoder, value instanceof AudioBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_134;
		  function $serializer_getInstance_134() {
		    if ($serializer_instance_134 == null)
		      new $serializer_134();
		    return $serializer_instance_134;
		  }
		  function AudioBody_init_$Init$(seen1, audio, message_type, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_134().r2k_1);
		    }
		    $this.y2g_1 = audio;
		    if (0 === (seen1 & 2))
		      $this.z2g_1 = CSMessageType_AUDIO_getInstance();
		    else
		      $this.z2g_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.a2h_1 = null;
		    else
		      $this.a2h_1 = timestamp;
		    return $this;
		  }
		  function AudioBody_init_$Create$(seen1, audio, message_type, timestamp, serializationConstructorMarker) {
		    return AudioBody_init_$Init$(seen1, audio, message_type, timestamp, serializationConstructorMarker, objectCreate(protoOf(AudioBody)));
		  }
		  function Companion_115() {
		  }
		  protoOf(Companion_115).y12 = function () {
		    return $serializer_getInstance_135();
		  };
		  var Companion_instance_116;
		  function Companion_getInstance_117() {
		    return Companion_instance_116;
		  }
		  function $serializer_135() {
		    $serializer_instance_135 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.FileBody', this, 3);
		    tmp0_serialDesc.pq('file', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.t2k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_135).uf = function () {
		    return this.t2k_1;
		  };
		  protoOf($serializer_135).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_141(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87())];
		  };
		  protoOf($serializer_135).wf = function (decoder) {
		    var tmp0_desc = this.t2k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return FileBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_135).u2k = function (encoder, value) {
		    var tmp0_desc = this.t2k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_141(), value.v2g_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.w2g_1.equals(CSMessageType_FILE_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.w2g_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.x2g_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.x2g_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_135).vf = function (encoder, value) {
		    return this.u2k(encoder, value instanceof FileBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_135;
		  function $serializer_getInstance_135() {
		    if ($serializer_instance_135 == null)
		      new $serializer_135();
		    return $serializer_instance_135;
		  }
		  function FileBody_init_$Init$(seen1, file, message_type, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_135().t2k_1);
		    }
		    $this.v2g_1 = file;
		    if (0 === (seen1 & 2))
		      $this.w2g_1 = CSMessageType_FILE_getInstance();
		    else
		      $this.w2g_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.x2g_1 = null;
		    else
		      $this.x2g_1 = timestamp;
		    return $this;
		  }
		  function FileBody_init_$Create$(seen1, file, message_type, timestamp, serializationConstructorMarker) {
		    return FileBody_init_$Init$(seen1, file, message_type, timestamp, serializationConstructorMarker, objectCreate(protoOf(FileBody)));
		  }
		  function Companion_116() {
		  }
		  protoOf(Companion_116).y12 = function () {
		    return $serializer_getInstance_136();
		  };
		  var Companion_instance_117;
		  function Companion_getInstance_118() {
		    return Companion_instance_117;
		  }
		  function $serializer_136() {
		    $serializer_instance_136 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.VCardBody', this, 3);
		    tmp0_serialDesc.pq('vcard', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.v2k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_136).uf = function () {
		    return this.v2k_1;
		  };
		  protoOf($serializer_136).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_141(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87())];
		  };
		  protoOf($serializer_136).wf = function (decoder) {
		    var tmp0_desc = this.v2k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_141(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return VCardBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_136).w2k = function (encoder, value) {
		    var tmp0_desc = this.v2k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_141(), value.a2g_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.b2g_1.equals(CSMessageType_VCARD_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.b2g_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.c2g_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.c2g_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_136).vf = function (encoder, value) {
		    return this.w2k(encoder, value instanceof VCardBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_136;
		  function $serializer_getInstance_136() {
		    if ($serializer_instance_136 == null)
		      new $serializer_136();
		    return $serializer_instance_136;
		  }
		  function VCardBody_init_$Init$(seen1, vcard, message_type, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_136().v2k_1);
		    }
		    $this.a2g_1 = vcard;
		    if (0 === (seen1 & 2))
		      $this.b2g_1 = CSMessageType_VCARD_getInstance();
		    else
		      $this.b2g_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.c2g_1 = null;
		    else
		      $this.c2g_1 = timestamp;
		    return $this;
		  }
		  function VCardBody_init_$Create$(seen1, vcard, message_type, timestamp, serializationConstructorMarker) {
		    return VCardBody_init_$Init$(seen1, vcard, message_type, timestamp, serializationConstructorMarker, objectCreate(protoOf(VCardBody)));
		  }
		  function Companion_117() {
		  }
		  protoOf(Companion_117).y12 = function () {
		    return $serializer_getInstance_137();
		  };
		  var Companion_instance_118;
		  function Companion_getInstance_119() {
		    return Companion_instance_118;
		  }
		  function $serializer_137() {
		    $serializer_instance_137 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.CustomBody', this, 3);
		    tmp0_serialDesc.pq('custom', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.x2k_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_137).uf = function () {
		    return this.x2k_1;
		  };
		  protoOf($serializer_137).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [JsonObjectSerializer_getInstance(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87())];
		  };
		  protoOf($serializer_137).wf = function (decoder) {
		    var tmp0_desc = this.x2k_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, JsonObjectSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, JsonObjectSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return CustomBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_137).y2k = function (encoder, value) {
		    var tmp0_desc = this.x2k_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, JsonObjectSerializer_getInstance(), value.b2h_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.c2h_1.equals(CSMessageType_CUSTOM_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.c2h_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.d2h_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.d2h_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_137).vf = function (encoder, value) {
		    return this.y2k(encoder, value instanceof CustomBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_137;
		  function $serializer_getInstance_137() {
		    if ($serializer_instance_137 == null)
		      new $serializer_137();
		    return $serializer_instance_137;
		  }
		  function CustomBody_init_$Init$(seen1, custom, message_type, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_137().x2k_1);
		    }
		    $this.b2h_1 = custom;
		    if (0 === (seen1 & 2))
		      $this.c2h_1 = CSMessageType_CUSTOM_getInstance();
		    else
		      $this.c2h_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.d2h_1 = null;
		    else
		      $this.d2h_1 = timestamp;
		    return $this;
		  }
		  function CustomBody_init_$Create$(seen1, custom, message_type, timestamp, serializationConstructorMarker) {
		    return CustomBody_init_$Init$(seen1, custom, message_type, timestamp, serializationConstructorMarker, objectCreate(protoOf(CustomBody)));
		  }
		  function Companion_118() {
		  }
		  protoOf(Companion_118).z2k = function (pair) {
		    return new TemplateBody(Companion_getInstance_125().b2l(pair.m5_1), VOID, VOID, Companion_instance_125.c2l(pair.n5_1));
		  };
		  protoOf(Companion_118).y12 = function () {
		    return $serializer_getInstance_138();
		  };
		  var Companion_instance_119;
		  function Companion_getInstance_120() {
		    return Companion_instance_119;
		  }
		  function $serializer_138() {
		    $serializer_instance_138 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.TemplateBody', this, 4);
		    tmp0_serialDesc.pq('template', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    tmp0_serialDesc.pq('whatsapp', false);
		    this.d2l_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_138).uf = function () {
		    return this.d2l_1;
		  };
		  protoOf($serializer_138).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_143(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87()), $serializer_getInstance_144()];
		  };
		  protoOf($serializer_138).wf = function (decoder) {
		    var tmp0_desc = this.d2l_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.qj(tmp0_desc, 0, $serializer_getInstance_143(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_144(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.qj(tmp0_desc, 0, $serializer_getInstance_143(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, $serializer_getInstance_144(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return TemplateBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_138).e2l = function (encoder, value) {
		    var tmp0_desc = this.d2l_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_143(), value.f2g_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.g2g_1.equals(CSMessageType_TEMPLATE_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.g2g_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.h2g_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.h2g_1);
		    }
		    tmp1_output.vk(tmp0_desc, 3, $serializer_getInstance_144(), value.i2g_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_138).vf = function (encoder, value) {
		    return this.e2l(encoder, value instanceof TemplateBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_138;
		  function $serializer_getInstance_138() {
		    if ($serializer_instance_138 == null)
		      new $serializer_138();
		    return $serializer_instance_138;
		  }
		  function TemplateBody_init_$Init$(seen1, template, message_type, timestamp, whatsapp, serializationConstructorMarker, $this) {
		    if (!(9 === (9 & seen1))) {
		      throwMissingFieldException(seen1, 9, $serializer_getInstance_138().d2l_1);
		    }
		    $this.f2g_1 = template;
		    if (0 === (seen1 & 2))
		      $this.g2g_1 = CSMessageType_TEMPLATE_getInstance();
		    else
		      $this.g2g_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.h2g_1 = null;
		    else
		      $this.h2g_1 = timestamp;
		    $this.i2g_1 = whatsapp;
		    return $this;
		  }
		  function TemplateBody_init_$Create$(seen1, template, message_type, timestamp, whatsapp, serializationConstructorMarker) {
		    return TemplateBody_init_$Init$(seen1, template, message_type, timestamp, whatsapp, serializationConstructorMarker, objectCreate(protoOf(TemplateBody)));
		  }
		  function Companion_119() {
		  }
		  protoOf(Companion_119).f2l = function (location) {
		    return new LocationBody(Companion_instance_126.f2l(location));
		  };
		  protoOf(Companion_119).y12 = function () {
		    return $serializer_getInstance_139();
		  };
		  var Companion_instance_120;
		  function Companion_getInstance_121() {
		    return Companion_instance_120;
		  }
		  function $serializer_139() {
		    $serializer_instance_139 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent.LocationBody', this, 3);
		    tmp0_serialDesc.pq('location', false);
		    tmp0_serialDesc.pq('message_type', true);
		    tmp0_serialDesc.pq('timestamp', true);
		    this.g2l_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_139).uf = function () {
		    return this.g2l_1;
		  };
		  protoOf($serializer_139).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_145(), $serializer_getInstance_142(), get_nullable($serializer_getInstance_87())];
		  };
		  protoOf($serializer_139).wf = function (decoder) {
		    var tmp0_desc = this.g2l_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_145(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_145(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, $serializer_getInstance_142(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_87(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return LocationBody_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_139).h2l = function (encoder, value) {
		    var tmp0_desc = this.g2l_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_145(), value.p2g_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.q2g_1.equals(CSMessageType_LOCATION_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, $serializer_getInstance_142(), value.q2g_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.r2g_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_87(), value.r2g_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_139).vf = function (encoder, value) {
		    return this.h2l(encoder, value instanceof LocationBody ? value : THROW_CCE());
		  };
		  var $serializer_instance_139;
		  function $serializer_getInstance_139() {
		    if ($serializer_instance_139 == null)
		      new $serializer_139();
		    return $serializer_instance_139;
		  }
		  function LocationBody_init_$Init$(seen1, location, message_type, timestamp, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_139().g2l_1);
		    }
		    $this.p2g_1 = location;
		    if (0 === (seen1 & 2))
		      $this.q2g_1 = CSMessageType_LOCATION_getInstance();
		    else
		      $this.q2g_1 = message_type;
		    if (0 === (seen1 & 4))
		      $this.r2g_1 = null;
		    else
		      $this.r2g_1 = timestamp;
		    return $this;
		  }
		  function LocationBody_init_$Create$(seen1, location, message_type, timestamp, serializationConstructorMarker) {
		    return LocationBody_init_$Init$(seen1, location, message_type, timestamp, serializationConstructorMarker, objectCreate(protoOf(LocationBody)));
		  }
		  function Body_14() {
		  }
		  function TextBody(text, message_type, timestamp) {
		    message_type = message_type === VOID ? CSMessageType_TEXT_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.e2h_1 = text;
		    this.f2h_1 = message_type;
		    this.g2h_1 = timestamp;
		  }
		  protoOf(TextBody).i2l = function () {
		    return this.g2h_1;
		  };
		  protoOf(TextBody).z1h = function () {
		    // Inline function 'kotlin.text.contains' call
		    var this_0 = this.e2h_1;
		    return !Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(this_0);
		  };
		  protoOf(TextBody).toString = function () {
		    return 'TextBody(text=' + this.e2h_1 + ', message_type=' + this.f2h_1 + ', timestamp=' + this.g2h_1 + ')';
		  };
		  protoOf(TextBody).hashCode = function () {
		    var result = getStringHashCode(this.e2h_1);
		    result = imul(result, 31) + this.f2h_1.hashCode() | 0;
		    result = imul(result, 31) + (this.g2h_1 == null ? 0 : this.g2h_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(TextBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof TextBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof TextBody ? other : THROW_CCE();
		    if (!(this.e2h_1 === tmp0_other_with_cast.e2h_1))
		      return false;
		    if (!this.f2h_1.equals(tmp0_other_with_cast.f2h_1))
		      return false;
		    if (!equals(this.g2h_1, tmp0_other_with_cast.g2h_1))
		      return false;
		    return true;
		  };
		  function ImageBody(image, message_type, timestamp) {
		    message_type = message_type === VOID ? CSMessageType_IMAGE_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.s2g_1 = image;
		    this.t2g_1 = message_type;
		    this.u2g_1 = timestamp;
		  }
		  protoOf(ImageBody).i2l = function () {
		    return this.u2g_1;
		  };
		  protoOf(ImageBody).z1h = function () {
		    // Inline function 'kotlin.text.contains' call
		    var this_0 = this.s2g_1.w2f_1;
		    return !Regex_init_$Create$('"|\'|<|>|\\|javascript:').v7(this_0);
		  };
		  protoOf(ImageBody).toString = function () {
		    return 'ImageBody(image=' + this.s2g_1 + ', message_type=' + this.t2g_1 + ', timestamp=' + this.u2g_1 + ')';
		  };
		  protoOf(ImageBody).hashCode = function () {
		    var result = this.s2g_1.hashCode();
		    result = imul(result, 31) + this.t2g_1.hashCode() | 0;
		    result = imul(result, 31) + (this.u2g_1 == null ? 0 : this.u2g_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(ImageBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ImageBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof ImageBody ? other : THROW_CCE();
		    if (!this.s2g_1.equals(tmp0_other_with_cast.s2g_1))
		      return false;
		    if (!this.t2g_1.equals(tmp0_other_with_cast.t2g_1))
		      return false;
		    if (!equals(this.u2g_1, tmp0_other_with_cast.u2g_1))
		      return false;
		    return true;
		  };
		  function VideoBody(video, message_type, timestamp) {
		    message_type = message_type === VOID ? CSMessageType_VIDEO_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.x2f_1 = video;
		    this.y2f_1 = message_type;
		    this.z2f_1 = timestamp;
		  }
		  protoOf(VideoBody).i2l = function () {
		    return this.z2f_1;
		  };
		  protoOf(VideoBody).z1h = function () {
		    // Inline function 'kotlin.text.contains' call
		    var this_0 = this.x2f_1.w2f_1;
		    return !Regex_init_$Create$('"|\'|<|>|\\|javascript:').v7(this_0);
		  };
		  protoOf(VideoBody).toString = function () {
		    return 'VideoBody(video=' + this.x2f_1 + ', message_type=' + this.y2f_1 + ', timestamp=' + this.z2f_1 + ')';
		  };
		  protoOf(VideoBody).hashCode = function () {
		    var result = this.x2f_1.hashCode();
		    result = imul(result, 31) + this.y2f_1.hashCode() | 0;
		    result = imul(result, 31) + (this.z2f_1 == null ? 0 : this.z2f_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(VideoBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof VideoBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof VideoBody ? other : THROW_CCE();
		    if (!this.x2f_1.equals(tmp0_other_with_cast.x2f_1))
		      return false;
		    if (!this.y2f_1.equals(tmp0_other_with_cast.y2f_1))
		      return false;
		    if (!equals(this.z2f_1, tmp0_other_with_cast.z2f_1))
		      return false;
		    return true;
		  };
		  function AudioBody(audio, message_type, timestamp) {
		    message_type = message_type === VOID ? CSMessageType_AUDIO_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.y2g_1 = audio;
		    this.z2g_1 = message_type;
		    this.a2h_1 = timestamp;
		  }
		  protoOf(AudioBody).i2l = function () {
		    return this.a2h_1;
		  };
		  protoOf(AudioBody).z1h = function () {
		    // Inline function 'kotlin.text.contains' call
		    var this_0 = this.y2g_1.w2f_1;
		    return !Regex_init_$Create$('"|\'|<|>|\\|javascript:').v7(this_0);
		  };
		  protoOf(AudioBody).toString = function () {
		    return 'AudioBody(audio=' + this.y2g_1 + ', message_type=' + this.z2g_1 + ', timestamp=' + this.a2h_1 + ')';
		  };
		  protoOf(AudioBody).hashCode = function () {
		    var result = this.y2g_1.hashCode();
		    result = imul(result, 31) + this.z2g_1.hashCode() | 0;
		    result = imul(result, 31) + (this.a2h_1 == null ? 0 : this.a2h_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(AudioBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AudioBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof AudioBody ? other : THROW_CCE();
		    if (!this.y2g_1.equals(tmp0_other_with_cast.y2g_1))
		      return false;
		    if (!this.z2g_1.equals(tmp0_other_with_cast.z2g_1))
		      return false;
		    if (!equals(this.a2h_1, tmp0_other_with_cast.a2h_1))
		      return false;
		    return true;
		  };
		  function FileBody(file, message_type, timestamp) {
		    message_type = message_type === VOID ? CSMessageType_FILE_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.v2g_1 = file;
		    this.w2g_1 = message_type;
		    this.x2g_1 = timestamp;
		  }
		  protoOf(FileBody).i2l = function () {
		    return this.x2g_1;
		  };
		  protoOf(FileBody).z1h = function () {
		    // Inline function 'kotlin.text.contains' call
		    var this_0 = this.v2g_1.w2f_1;
		    return !Regex_init_$Create$('"|\'|<|>|\\|javascript:').v7(this_0);
		  };
		  protoOf(FileBody).toString = function () {
		    return 'FileBody(file=' + this.v2g_1 + ', message_type=' + this.w2g_1 + ', timestamp=' + this.x2g_1 + ')';
		  };
		  protoOf(FileBody).hashCode = function () {
		    var result = this.v2g_1.hashCode();
		    result = imul(result, 31) + this.w2g_1.hashCode() | 0;
		    result = imul(result, 31) + (this.x2g_1 == null ? 0 : this.x2g_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(FileBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof FileBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof FileBody ? other : THROW_CCE();
		    if (!this.v2g_1.equals(tmp0_other_with_cast.v2g_1))
		      return false;
		    if (!this.w2g_1.equals(tmp0_other_with_cast.w2g_1))
		      return false;
		    if (!equals(this.x2g_1, tmp0_other_with_cast.x2g_1))
		      return false;
		    return true;
		  };
		  function VCardBody(vcard, message_type, timestamp) {
		    message_type = message_type === VOID ? CSMessageType_VCARD_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.a2g_1 = vcard;
		    this.b2g_1 = message_type;
		    this.c2g_1 = timestamp;
		  }
		  protoOf(VCardBody).i2l = function () {
		    return this.c2g_1;
		  };
		  protoOf(VCardBody).z1h = function () {
		    // Inline function 'kotlin.text.contains' call
		    var this_0 = this.a2g_1.w2f_1;
		    return !Regex_init_$Create$('"|\'|<|>|\\|javascript:').v7(this_0);
		  };
		  protoOf(VCardBody).toString = function () {
		    return 'VCardBody(vcard=' + this.a2g_1 + ', message_type=' + this.b2g_1 + ', timestamp=' + this.c2g_1 + ')';
		  };
		  protoOf(VCardBody).hashCode = function () {
		    var result = this.a2g_1.hashCode();
		    result = imul(result, 31) + this.b2g_1.hashCode() | 0;
		    result = imul(result, 31) + (this.c2g_1 == null ? 0 : this.c2g_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(VCardBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof VCardBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof VCardBody ? other : THROW_CCE();
		    if (!this.a2g_1.equals(tmp0_other_with_cast.a2g_1))
		      return false;
		    if (!this.b2g_1.equals(tmp0_other_with_cast.b2g_1))
		      return false;
		    if (!equals(this.c2g_1, tmp0_other_with_cast.c2g_1))
		      return false;
		    return true;
		  };
		  function CustomBody(custom, message_type, timestamp) {
		    message_type = message_type === VOID ? CSMessageType_CUSTOM_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.b2h_1 = custom;
		    this.c2h_1 = message_type;
		    this.d2h_1 = timestamp;
		  }
		  protoOf(CustomBody).i2l = function () {
		    return this.d2h_1;
		  };
		  protoOf(CustomBody).toString = function () {
		    return 'CustomBody(custom=' + this.b2h_1 + ', message_type=' + this.c2h_1 + ', timestamp=' + this.d2h_1 + ')';
		  };
		  protoOf(CustomBody).hashCode = function () {
		    var result = this.b2h_1.hashCode();
		    result = imul(result, 31) + this.c2h_1.hashCode() | 0;
		    result = imul(result, 31) + (this.d2h_1 == null ? 0 : this.d2h_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(CustomBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CustomBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof CustomBody ? other : THROW_CCE();
		    if (!this.b2h_1.equals(tmp0_other_with_cast.b2h_1))
		      return false;
		    if (!this.c2h_1.equals(tmp0_other_with_cast.c2h_1))
		      return false;
		    if (!equals(this.d2h_1, tmp0_other_with_cast.d2h_1))
		      return false;
		    return true;
		  };
		  function TemplateBody(template, message_type, timestamp, whatsapp) {
		    message_type = message_type === VOID ? CSMessageType_TEMPLATE_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.f2g_1 = template;
		    this.g2g_1 = message_type;
		    this.h2g_1 = timestamp;
		    this.i2g_1 = whatsapp;
		  }
		  protoOf(TemplateBody).i2l = function () {
		    return this.h2g_1;
		  };
		  protoOf(TemplateBody).toString = function () {
		    return 'TemplateBody(template=' + this.f2g_1 + ', message_type=' + this.g2g_1 + ', timestamp=' + this.h2g_1 + ', whatsapp=' + this.i2g_1 + ')';
		  };
		  protoOf(TemplateBody).hashCode = function () {
		    var result = this.f2g_1.hashCode();
		    result = imul(result, 31) + this.g2g_1.hashCode() | 0;
		    result = imul(result, 31) + (this.h2g_1 == null ? 0 : this.h2g_1.hashCode()) | 0;
		    result = imul(result, 31) + this.i2g_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(TemplateBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof TemplateBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof TemplateBody ? other : THROW_CCE();
		    if (!this.f2g_1.equals(tmp0_other_with_cast.f2g_1))
		      return false;
		    if (!this.g2g_1.equals(tmp0_other_with_cast.g2g_1))
		      return false;
		    if (!equals(this.h2g_1, tmp0_other_with_cast.h2g_1))
		      return false;
		    if (!this.i2g_1.equals(tmp0_other_with_cast.i2g_1))
		      return false;
		    return true;
		  };
		  function LocationBody(location, message_type, timestamp) {
		    message_type = message_type === VOID ? CSMessageType_LOCATION_getInstance() : message_type;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.p2g_1 = location;
		    this.q2g_1 = message_type;
		    this.r2g_1 = timestamp;
		  }
		  protoOf(LocationBody).i2l = function () {
		    return this.r2g_1;
		  };
		  protoOf(LocationBody).z1h = function () {
		    var tmp;
		    var tmp_0;
		    var tmp_1;
		    // Inline function 'kotlin.text.contains' call
		    var this_0 = this.p2g_1.l2g_1;
		    if (!Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(this_0)) {
		      // Inline function 'kotlin.text.contains' call
		      var this_1 = this.p2g_1.m2g_1;
		      tmp_1 = !Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(this_1);
		    } else {
		      tmp_1 = false;
		    }
		    if (tmp_1) {
		      var tmp0_safe_receiver = this.p2g_1.n2g_1;
		      var tmp_2;
		      if (tmp0_safe_receiver == null) {
		        tmp_2 = null;
		      } else {
		        // Inline function 'kotlin.text.contains' call
		        tmp_2 = Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(tmp0_safe_receiver);
		      }
		      tmp_0 = tmp_2 === false;
		    } else {
		      tmp_0 = false;
		    }
		    if (tmp_0) {
		      var tmp1_safe_receiver = this.p2g_1.o2g_1;
		      var tmp_3;
		      if (tmp1_safe_receiver == null) {
		        tmp_3 = null;
		      } else {
		        // Inline function 'kotlin.text.contains' call
		        tmp_3 = Regex_init_$Create$('"|\'|<|>|&|\\|/').v7(tmp1_safe_receiver);
		      }
		      tmp = tmp_3 === false;
		    } else {
		      tmp = false;
		    }
		    return tmp;
		  };
		  protoOf(LocationBody).toString = function () {
		    return 'LocationBody(location=' + this.p2g_1 + ', message_type=' + this.q2g_1 + ', timestamp=' + this.r2g_1 + ')';
		  };
		  protoOf(LocationBody).hashCode = function () {
		    var result = this.p2g_1.hashCode();
		    result = imul(result, 31) + this.q2g_1.hashCode() | 0;
		    result = imul(result, 31) + (this.r2g_1 == null ? 0 : this.r2g_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(LocationBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LocationBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof LocationBody ? other : THROW_CCE();
		    if (!this.p2g_1.equals(tmp0_other_with_cast.p2g_1))
		      return false;
		    if (!this.q2g_1.equals(tmp0_other_with_cast.q2g_1))
		      return false;
		    if (!equals(this.r2g_1, tmp0_other_with_cast.r2g_1))
		      return false;
		    return true;
		  };
		  function Companion_120() {
		  }
		  protoOf(Companion_120).y12 = function () {
		    return $serializer_getInstance_140();
		  };
		  var Companion_instance_121;
		  function Companion_getInstance_122() {
		    return Companion_instance_121;
		  }
		  function $serializer_140() {
		    $serializer_instance_140 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.CSMessageEvent', this, 8);
		    tmp0_serialDesc.pq('id', false);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('timestamp', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('conversation_id', true);
		    tmp0_serialDesc.pq('_embedded', true);
		    tmp0_serialDesc.pq('body', false);
		    tmp0_serialDesc.pq('state', true);
		    this.j2l_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_140).uf = function () {
		    return this.j2l_1;
		  };
		  protoOf($serializer_140).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_54()), CSMessageEventBodySerializer_getInstance(), get_nullable($serializer_getInstance_86())];
		  };
		  protoOf($serializer_140).wf = function (decoder) {
		    var tmp0_desc = this.j2l_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_local7 = null;
		    var tmp12_input = decoder.ej(tmp0_desc);
		    if (tmp12_input.uj()) {
		      tmp4_local0 = tmp12_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp12_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp12_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp12_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp12_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp12_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp12_input.qj(tmp0_desc, 6, CSMessageEventBodySerializer_getInstance(), tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp12_input.sj(tmp0_desc, 7, $serializer_getInstance_86(), tmp11_local7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp12_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp12_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp12_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp12_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp12_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp12_input.sj(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp12_input.sj(tmp0_desc, 5, $serializer_getInstance_54(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp12_input.qj(tmp0_desc, 6, CSMessageEventBodySerializer_getInstance(), tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp12_input.sj(tmp0_desc, 7, $serializer_getInstance_86(), tmp11_local7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp12_input.fj(tmp0_desc);
		    return CSMessageEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
		  };
		  protoOf($serializer_140).k2l = function (encoder, value) {
		    var tmp0_desc = this.j2l_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.l2l_1);
		    tmp1_output.tk(tmp0_desc, 1, value.m2l_1);
		    tmp1_output.tk(tmp0_desc, 2, value.n2l_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.o2l_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.o2l_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.p2l_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, StringSerializer_getInstance(), value.p2l_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.q2l_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, $serializer_getInstance_54(), value.q2l_1);
		    }
		    tmp1_output.vk(tmp0_desc, 6, CSMessageEventBodySerializer_getInstance(), value.r2l_1);
		    if (tmp1_output.bl(tmp0_desc, 7) ? true : !(value.s2l_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 7, $serializer_getInstance_86(), value.s2l_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_140).vf = function (encoder, value) {
		    return this.k2l(encoder, value instanceof CSMessageEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_140;
		  function $serializer_getInstance_140() {
		    if ($serializer_instance_140 == null)
		      new $serializer_140();
		    return $serializer_instance_140;
		  }
		  function CSMessageEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, state, serializationConstructorMarker, $this) {
		    if (!(71 === (71 & seen1))) {
		      throwMissingFieldException(seen1, 71, $serializer_getInstance_140().j2l_1);
		    }
		    $this.l2l_1 = id;
		    $this.m2l_1 = type;
		    $this.n2l_1 = timestamp;
		    if (0 === (seen1 & 8))
		      $this.o2l_1 = null;
		    else
		      $this.o2l_1 = from;
		    if (0 === (seen1 & 16))
		      $this.p2l_1 = null;
		    else
		      $this.p2l_1 = conversation_id;
		    if (0 === (seen1 & 32))
		      $this.q2l_1 = null;
		    else
		      $this.q2l_1 = _embedded;
		    $this.r2l_1 = body;
		    if (0 === (seen1 & 128))
		      $this.s2l_1 = null;
		    else
		      $this.s2l_1 = state;
		    return $this;
		  }
		  function CSMessageEvent_init_$Create$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, state, serializationConstructorMarker) {
		    return CSMessageEvent_init_$Init$(seen1, id, type, timestamp, from, conversation_id, _embedded, body, state, serializationConstructorMarker, objectCreate(protoOf(CSMessageEvent)));
		  }
		  function CSMessageEvent() {
		  }
		  protoOf(CSMessageEvent).d24 = function (conversationId) {
		    var from = Companion_instance_142.s24(this.q2l_1);
		    var tmp0_subject = this.r2l_1;
		    var tmp;
		    if (tmp0_subject instanceof TextBody) {
		      var tmp1_safe_receiver = this.r2l_1.i2l();
		      var tmp_0 = new Body_16(this.r2l_1.e2h_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e27_1);
		      var tmp2_safe_receiver = this.s2l_1;
		      tmp = new MessageTextEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_0, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.z26());
		    } else {
		      if (tmp0_subject instanceof AudioBody) {
		        var tmp3_safe_receiver = this.r2l_1.i2l();
		        var tmp_1 = new Body_20(this.r2l_1.y2g_1.w2f_1, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.e27_1);
		        var tmp4_safe_receiver = this.s2l_1;
		        tmp = new MessageAudioEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_1, tmp4_safe_receiver == null ? null : tmp4_safe_receiver.z26());
		      } else {
		        if (tmp0_subject instanceof FileBody) {
		          var tmp5_safe_receiver = this.r2l_1.i2l();
		          var tmp_2 = new Body_21(this.r2l_1.v2g_1.w2f_1, tmp5_safe_receiver == null ? null : tmp5_safe_receiver.e27_1);
		          var tmp6_safe_receiver = this.s2l_1;
		          tmp = new MessageFileEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_2, tmp6_safe_receiver == null ? null : tmp6_safe_receiver.z26());
		        } else {
		          if (tmp0_subject instanceof ImageBody) {
		            var tmp7_safe_receiver = this.r2l_1.i2l();
		            var tmp_3 = new Body_18(this.r2l_1.s2g_1.w2f_1, tmp7_safe_receiver == null ? null : tmp7_safe_receiver.e27_1);
		            var tmp8_safe_receiver = this.s2l_1;
		            tmp = new MessageImageEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_3, tmp8_safe_receiver == null ? null : tmp8_safe_receiver.z26());
		          } else {
		            if (tmp0_subject instanceof LocationBody) {
		              var tmp_4 = new Location(this.r2l_1.p2g_1.l2g_1, this.r2l_1.p2g_1.m2g_1, this.r2l_1.p2g_1.n2g_1, this.r2l_1.p2g_1.o2g_1);
		              var tmp9_safe_receiver = this.r2l_1.i2l();
		              var tmp_5 = new Body_24(tmp_4, tmp9_safe_receiver == null ? null : tmp9_safe_receiver.e27_1);
		              var tmp10_safe_receiver = this.s2l_1;
		              tmp = new MessageLocationEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_5, tmp10_safe_receiver == null ? null : tmp10_safe_receiver.z26());
		            } else {
		              if (tmp0_subject instanceof TemplateBody) {
		                var tmp_6 = new TemplateObject_0(this.r2l_1.f2g_1.d2g_1, this.r2l_1.f2g_1.e2g_1);
		                var tmp_7 = new WhatsappObject_0(this.r2l_1.i2g_1.j2g_1, this.r2l_1.i2g_1.k2g_1);
		                var tmp11_safe_receiver = this.r2l_1.i2l();
		                var tmp_8 = new Body_23(tmp_6, tmp_7, tmp11_safe_receiver == null ? null : tmp11_safe_receiver.e27_1);
		                var tmp12_safe_receiver = this.s2l_1;
		                tmp = new MessageTemplateEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_8, tmp12_safe_receiver == null ? null : tmp12_safe_receiver.z26());
		              } else {
		                if (tmp0_subject instanceof VCardBody) {
		                  var tmp13_safe_receiver = this.r2l_1.i2l();
		                  var tmp_9 = new Body_22(this.r2l_1.a2g_1.w2f_1, tmp13_safe_receiver == null ? null : tmp13_safe_receiver.e27_1);
		                  var tmp14_safe_receiver = this.s2l_1;
		                  tmp = new MessageVCardEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_9, tmp14_safe_receiver == null ? null : tmp14_safe_receiver.z26());
		                } else {
		                  if (tmp0_subject instanceof VideoBody) {
		                    var tmp15_safe_receiver = this.r2l_1.i2l();
		                    var tmp_10 = new Body_19(this.r2l_1.x2f_1.w2f_1, tmp15_safe_receiver == null ? null : tmp15_safe_receiver.e27_1);
		                    var tmp16_safe_receiver = this.s2l_1;
		                    tmp = new MessageVideoEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_10, tmp16_safe_receiver == null ? null : tmp16_safe_receiver.z26());
		                  } else {
		                    if (tmp0_subject instanceof CustomBody) {
		                      var tmp_11 = this.r2l_1.b2h_1.toString();
		                      var tmp17_safe_receiver = this.r2l_1.i2l();
		                      var tmp_12 = new Body_17(tmp_11, tmp17_safe_receiver == null ? null : tmp17_safe_receiver.e27_1);
		                      var tmp18_safe_receiver = this.s2l_1;
		                      tmp = new MessageCustomEvent(this.n2l_1, conversationId, this.l2l_1, from, tmp_12, tmp18_safe_receiver == null ? null : tmp18_safe_receiver.z26());
		                    } else {
		                      noWhenBranchMatchedException();
		                    }
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  };
		  protoOf(CSMessageEvent).toString = function () {
		    return 'CSMessageEvent(id=' + this.l2l_1 + ', type=' + this.m2l_1 + ', timestamp=' + this.n2l_1 + ', from=' + this.o2l_1 + ', conversation_id=' + this.p2l_1 + ', _embedded=' + this.q2l_1 + ', body=' + this.r2l_1 + ', state=' + this.s2l_1 + ')';
		  };
		  protoOf(CSMessageEvent).hashCode = function () {
		    var result = this.l2l_1;
		    result = imul(result, 31) + getStringHashCode(this.m2l_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.n2l_1) | 0;
		    result = imul(result, 31) + (this.o2l_1 == null ? 0 : getStringHashCode(this.o2l_1)) | 0;
		    result = imul(result, 31) + (this.p2l_1 == null ? 0 : getStringHashCode(this.p2l_1)) | 0;
		    result = imul(result, 31) + (this.q2l_1 == null ? 0 : this.q2l_1.hashCode()) | 0;
		    result = imul(result, 31) + hashCode(this.r2l_1) | 0;
		    result = imul(result, 31) + (this.s2l_1 == null ? 0 : hashCode(this.s2l_1)) | 0;
		    return result;
		  };
		  protoOf(CSMessageEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CSMessageEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof CSMessageEvent ? other : THROW_CCE();
		    if (!(this.l2l_1 === tmp0_other_with_cast.l2l_1))
		      return false;
		    if (!(this.m2l_1 === tmp0_other_with_cast.m2l_1))
		      return false;
		    if (!(this.n2l_1 === tmp0_other_with_cast.n2l_1))
		      return false;
		    if (!(this.o2l_1 == tmp0_other_with_cast.o2l_1))
		      return false;
		    if (!(this.p2l_1 == tmp0_other_with_cast.p2l_1))
		      return false;
		    if (!equals(this.q2l_1, tmp0_other_with_cast.q2l_1))
		      return false;
		    if (!equals(this.r2l_1, tmp0_other_with_cast.r2l_1))
		      return false;
		    if (!equals(this.s2l_1, tmp0_other_with_cast.s2l_1))
		      return false;
		    return true;
		  };
		  function Companion_121() {
		  }
		  var Companion_instance_122;
		  function Companion_getInstance_123() {
		    return Companion_instance_122;
		  }
		  function $serializer_141() {
		    $serializer_instance_141 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.UrlObject', this, 1);
		    tmp0_serialDesc.pq('url', false);
		    this.t2l_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_141).uf = function () {
		    return this.t2l_1;
		  };
		  protoOf($serializer_141).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance()];
		  };
		  protoOf($serializer_141).wf = function (decoder) {
		    var tmp0_desc = this.t2l_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return UrlObject_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_141).u2l = function (encoder, value) {
		    var tmp0_desc = this.t2l_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.w2f_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_141).vf = function (encoder, value) {
		    return this.u2l(encoder, value instanceof UrlObject ? value : THROW_CCE());
		  };
		  var $serializer_instance_141;
		  function $serializer_getInstance_141() {
		    if ($serializer_instance_141 == null)
		      new $serializer_141();
		    return $serializer_instance_141;
		  }
		  function UrlObject_init_$Init$(seen1, url, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_141().t2l_1);
		    }
		    $this.w2f_1 = url;
		    return $this;
		  }
		  function UrlObject_init_$Create$(seen1, url, serializationConstructorMarker) {
		    return UrlObject_init_$Init$(seen1, url, serializationConstructorMarker, objectCreate(protoOf(UrlObject)));
		  }
		  function UrlObject(url) {
		    this.w2f_1 = url;
		  }
		  protoOf(UrlObject).toString = function () {
		    return 'UrlObject(url=' + this.w2f_1 + ')';
		  };
		  protoOf(UrlObject).hashCode = function () {
		    return getStringHashCode(this.w2f_1);
		  };
		  protoOf(UrlObject).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UrlObject))
		      return false;
		    var tmp0_other_with_cast = other instanceof UrlObject ? other : THROW_CCE();
		    if (!(this.w2f_1 === tmp0_other_with_cast.w2f_1))
		      return false;
		    return true;
		  };
		  function _get_$cachedSerializer__te6jhj($this) {
		    return $this.v2l_1.w1();
		  }
		  function CSMessageType$Companion$_anonymous__rj5gke() {
		    return $serializer_getInstance_142();
		  }
		  var CSMessageType_TEXT_instance;
		  var CSMessageType_IMAGE_instance;
		  var CSMessageType_VIDEO_instance;
		  var CSMessageType_AUDIO_instance;
		  var CSMessageType_FILE_instance;
		  var CSMessageType_VCARD_instance;
		  var CSMessageType_CUSTOM_instance;
		  var CSMessageType_TEMPLATE_instance;
		  var CSMessageType_LOCATION_instance;
		  function Companion_122() {
		    Companion_instance_123 = this;
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.v2l_1 = lazy(tmp_0, CSMessageType$Companion$_anonymous__rj5gke);
		  }
		  protoOf(Companion_122).y12 = function () {
		    return _get_$cachedSerializer__te6jhj(this);
		  };
		  protoOf(Companion_122).nr = function (typeParamsSerializers) {
		    return this.y12();
		  };
		  var Companion_instance_123;
		  function Companion_getInstance_124() {
		    CSMessageType_initEntries();
		    if (Companion_instance_123 == null)
		      new Companion_122();
		    return Companion_instance_123;
		  }
		  function $serializer_142() {
		    $serializer_instance_142 = this;
		    var tmp0_serialDesc = new EnumDescriptor('com.vonage.clientcore.core.actions.CSMessageType', 9);
		    tmp0_serialDesc.pq('text', false);
		    tmp0_serialDesc.pq('image', false);
		    tmp0_serialDesc.pq('video', false);
		    tmp0_serialDesc.pq('audio', false);
		    tmp0_serialDesc.pq('file', false);
		    tmp0_serialDesc.pq('vcard', false);
		    tmp0_serialDesc.pq('custom', false);
		    tmp0_serialDesc.pq('template', false);
		    tmp0_serialDesc.pq('location', false);
		    this.w2l_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_142).uf = function () {
		    return this.w2l_1;
		  };
		  protoOf($serializer_142).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [];
		  };
		  protoOf($serializer_142).wf = function (decoder) {
		    return values()[decoder.aj(this.w2l_1)];
		  };
		  protoOf($serializer_142).x2l = function (encoder, value) {
		    encoder.jk(this.w2l_1, value.i8_1);
		  };
		  protoOf($serializer_142).vf = function (encoder, value) {
		    return this.x2l(encoder, value instanceof CSMessageType ? value : THROW_CCE());
		  };
		  var $serializer_instance_142;
		  function $serializer_getInstance_142() {
		    CSMessageType_initEntries();
		    if ($serializer_instance_142 == null)
		      new $serializer_142();
		    return $serializer_instance_142;
		  }
		  function values() {
		    return [CSMessageType_TEXT_getInstance(), CSMessageType_IMAGE_getInstance(), CSMessageType_VIDEO_getInstance(), CSMessageType_AUDIO_getInstance(), CSMessageType_FILE_getInstance(), CSMessageType_VCARD_getInstance(), CSMessageType_CUSTOM_getInstance(), CSMessageType_TEMPLATE_getInstance(), CSMessageType_LOCATION_getInstance()];
		  }
		  function valueOf_0(value) {
		    switch (value) {
		      case 'TEXT':
		        return CSMessageType_TEXT_getInstance();
		      case 'IMAGE':
		        return CSMessageType_IMAGE_getInstance();
		      case 'VIDEO':
		        return CSMessageType_VIDEO_getInstance();
		      case 'AUDIO':
		        return CSMessageType_AUDIO_getInstance();
		      case 'FILE':
		        return CSMessageType_FILE_getInstance();
		      case 'VCARD':
		        return CSMessageType_VCARD_getInstance();
		      case 'CUSTOM':
		        return CSMessageType_CUSTOM_getInstance();
		      case 'TEMPLATE':
		        return CSMessageType_TEMPLATE_getInstance();
		      case 'LOCATION':
		        return CSMessageType_LOCATION_getInstance();
		      default:
		        CSMessageType_initEntries();
		        THROW_IAE('No enum constant value.');
		        break;
		    }
		  }
		  var CSMessageType_entriesInitialized;
		  function CSMessageType_initEntries() {
		    if (CSMessageType_entriesInitialized)
		      return Unit_instance;
		    CSMessageType_entriesInitialized = true;
		    CSMessageType_TEXT_instance = new CSMessageType('TEXT', 0);
		    CSMessageType_IMAGE_instance = new CSMessageType('IMAGE', 1);
		    CSMessageType_VIDEO_instance = new CSMessageType('VIDEO', 2);
		    CSMessageType_AUDIO_instance = new CSMessageType('AUDIO', 3);
		    CSMessageType_FILE_instance = new CSMessageType('FILE', 4);
		    CSMessageType_VCARD_instance = new CSMessageType('VCARD', 5);
		    CSMessageType_CUSTOM_instance = new CSMessageType('CUSTOM', 6);
		    CSMessageType_TEMPLATE_instance = new CSMessageType('TEMPLATE', 7);
		    CSMessageType_LOCATION_instance = new CSMessageType('LOCATION', 8);
		    Companion_getInstance_124();
		  }
		  function CSMessageType(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function CSMessageEventBodySerializer() {
		    CSMessageEventBodySerializer_instance = this;
		    JsonContentPolymorphicSerializer.call(this, getKClass(Body_14));
		  }
		  protoOf(CSMessageEventBodySerializer).w12 = function (element) {
		    var tmp0_safe_receiver = get_jsonObject(element).b13('message_type');
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
		    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e13();
		    var tmp;
		    if (tmp2_elvis_lhs == null) {
		      throw toVonageError(new UnexpectedNullValue());
		    } else {
		      tmp = tmp2_elvis_lhs;
		    }
		    var messageType = tmp;
		    // Inline function 'kotlin.text.uppercase' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp$ret$1 = messageType.toUpperCase();
		    var tmp_0;
		    switch (valueOf_0(tmp$ret$1).i8_1) {
		      case 0:
		        tmp_0 = Companion_instance_112.y12();
		        break;
		      case 1:
		        tmp_0 = Companion_instance_113.y12();
		        break;
		      case 2:
		        tmp_0 = Companion_instance_114.y12();
		        break;
		      case 3:
		        tmp_0 = Companion_instance_115.y12();
		        break;
		      case 4:
		        tmp_0 = Companion_instance_116.y12();
		        break;
		      case 5:
		        tmp_0 = Companion_instance_117.y12();
		        break;
		      case 6:
		        tmp_0 = Companion_instance_118.y12();
		        break;
		      case 7:
		        tmp_0 = Companion_instance_119.y12();
		        break;
		      case 8:
		        tmp_0 = Companion_instance_120.y12();
		        break;
		      default:
		        noWhenBranchMatchedException();
		        break;
		    }
		    return tmp_0;
		  };
		  var CSMessageEventBodySerializer_instance;
		  function CSMessageEventBodySerializer_getInstance() {
		    if (CSMessageEventBodySerializer_instance == null)
		      new CSMessageEventBodySerializer();
		    return CSMessageEventBodySerializer_instance;
		  }
		  function Companion_123() {
		    Companion_instance_124 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.a2l_1 = [null, new ArrayListSerializer(StringSerializer_getInstance())];
		  }
		  protoOf(Companion_123).b2l = function (template) {
		    return new TemplateObject(template.a2m_1, template.b2m_1);
		  };
		  var Companion_instance_124;
		  function Companion_getInstance_125() {
		    if (Companion_instance_124 == null)
		      new Companion_123();
		    return Companion_instance_124;
		  }
		  function $serializer_143() {
		    $serializer_instance_143 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.TemplateObject', this, 2);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('parameters', true);
		    this.c2m_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_143).uf = function () {
		    return this.c2m_1;
		  };
		  protoOf($serializer_143).er = function () {
		    var tmp0_cached = Companion_getInstance_125().a2l_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), get_nullable(tmp0_cached[1])];
		  };
		  protoOf($serializer_143).wf = function (decoder) {
		    var tmp0_desc = this.c2m_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    var tmp7_cached = Companion_getInstance_125().a2l_1;
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return TemplateObject_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_143).d2m = function (encoder, value) {
		    var tmp0_desc = this.c2m_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_125().a2l_1;
		    tmp1_output.tk(tmp0_desc, 0, value.d2g_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.e2g_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, tmp2_cached[1], value.e2g_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_143).vf = function (encoder, value) {
		    return this.d2m(encoder, value instanceof TemplateObject ? value : THROW_CCE());
		  };
		  var $serializer_instance_143;
		  function $serializer_getInstance_143() {
		    if ($serializer_instance_143 == null)
		      new $serializer_143();
		    return $serializer_instance_143;
		  }
		  function TemplateObject_init_$Init$(seen1, name, parameters, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_143().c2m_1);
		    }
		    $this.d2g_1 = name;
		    if (0 === (seen1 & 2))
		      $this.e2g_1 = null;
		    else
		      $this.e2g_1 = parameters;
		    return $this;
		  }
		  function TemplateObject_init_$Create$(seen1, name, parameters, serializationConstructorMarker) {
		    return TemplateObject_init_$Init$(seen1, name, parameters, serializationConstructorMarker, objectCreate(protoOf(TemplateObject)));
		  }
		  function TemplateObject(name, parameters) {
		    Companion_getInstance_125();
		    parameters = parameters === VOID ? null : parameters;
		    this.d2g_1 = name;
		    this.e2g_1 = parameters;
		  }
		  protoOf(TemplateObject).toString = function () {
		    return 'TemplateObject(name=' + this.d2g_1 + ', parameters=' + this.e2g_1 + ')';
		  };
		  protoOf(TemplateObject).hashCode = function () {
		    var result = getStringHashCode(this.d2g_1);
		    result = imul(result, 31) + (this.e2g_1 == null ? 0 : hashCode(this.e2g_1)) | 0;
		    return result;
		  };
		  protoOf(TemplateObject).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof TemplateObject))
		      return false;
		    var tmp0_other_with_cast = other instanceof TemplateObject ? other : THROW_CCE();
		    if (!(this.d2g_1 === tmp0_other_with_cast.d2g_1))
		      return false;
		    if (!equals(this.e2g_1, tmp0_other_with_cast.e2g_1))
		      return false;
		    return true;
		  };
		  function Companion_124() {
		  }
		  protoOf(Companion_124).c2l = function (whatsapp) {
		    return new WhatsappObject(whatsapp.e2m_1, whatsapp.f2m_1);
		  };
		  var Companion_instance_125;
		  function Companion_getInstance_126() {
		    return Companion_instance_125;
		  }
		  function $serializer_144() {
		    $serializer_instance_144 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.WhatsappObject', this, 2);
		    tmp0_serialDesc.pq('policy', false);
		    tmp0_serialDesc.pq('locale', false);
		    this.g2m_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_144).uf = function () {
		    return this.g2m_1;
		  };
		  protoOf($serializer_144).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_144).wf = function (decoder) {
		    var tmp0_desc = this.g2m_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return WhatsappObject_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_144).h2m = function (encoder, value) {
		    var tmp0_desc = this.g2m_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.j2g_1);
		    tmp1_output.tk(tmp0_desc, 1, value.k2g_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_144).vf = function (encoder, value) {
		    return this.h2m(encoder, value instanceof WhatsappObject ? value : THROW_CCE());
		  };
		  var $serializer_instance_144;
		  function $serializer_getInstance_144() {
		    if ($serializer_instance_144 == null)
		      new $serializer_144();
		    return $serializer_instance_144;
		  }
		  function WhatsappObject_init_$Init$(seen1, policy, locale, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_144().g2m_1);
		    }
		    $this.j2g_1 = policy;
		    $this.k2g_1 = locale;
		    return $this;
		  }
		  function WhatsappObject_init_$Create$(seen1, policy, locale, serializationConstructorMarker) {
		    return WhatsappObject_init_$Init$(seen1, policy, locale, serializationConstructorMarker, objectCreate(protoOf(WhatsappObject)));
		  }
		  function WhatsappObject(policy, locale) {
		    this.j2g_1 = policy;
		    this.k2g_1 = locale;
		  }
		  protoOf(WhatsappObject).toString = function () {
		    return 'WhatsappObject(policy=' + this.j2g_1 + ', locale=' + this.k2g_1 + ')';
		  };
		  protoOf(WhatsappObject).hashCode = function () {
		    var result = getStringHashCode(this.j2g_1);
		    result = imul(result, 31) + getStringHashCode(this.k2g_1) | 0;
		    return result;
		  };
		  protoOf(WhatsappObject).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof WhatsappObject))
		      return false;
		    var tmp0_other_with_cast = other instanceof WhatsappObject ? other : THROW_CCE();
		    if (!(this.j2g_1 === tmp0_other_with_cast.j2g_1))
		      return false;
		    if (!(this.k2g_1 === tmp0_other_with_cast.k2g_1))
		      return false;
		    return true;
		  };
		  function Companion_125() {
		  }
		  protoOf(Companion_125).f2l = function (location) {
		    return new LocationObject(location.i2m_1, location.j2m_1, location.k2m_1, location.l2m_1);
		  };
		  var Companion_instance_126;
		  function Companion_getInstance_127() {
		    return Companion_instance_126;
		  }
		  function $serializer_145() {
		    $serializer_instance_145 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.LocationObject', this, 4);
		    tmp0_serialDesc.pq('longitude', false);
		    tmp0_serialDesc.pq('latitude', false);
		    tmp0_serialDesc.pq('name', true);
		    tmp0_serialDesc.pq('address', true);
		    this.m2m_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_145).uf = function () {
		    return this.m2m_1;
		  };
		  protoOf($serializer_145).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_145).wf = function (decoder) {
		    var tmp0_desc = this.m2m_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return LocationObject_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_145).n2m = function (encoder, value) {
		    var tmp0_desc = this.m2m_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.l2g_1);
		    tmp1_output.tk(tmp0_desc, 1, value.m2g_1);
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.n2g_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.n2g_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.o2g_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.o2g_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_145).vf = function (encoder, value) {
		    return this.n2m(encoder, value instanceof LocationObject ? value : THROW_CCE());
		  };
		  var $serializer_instance_145;
		  function $serializer_getInstance_145() {
		    if ($serializer_instance_145 == null)
		      new $serializer_145();
		    return $serializer_instance_145;
		  }
		  function LocationObject_init_$Init$(seen1, longitude, latitude, name, address, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_145().m2m_1);
		    }
		    $this.l2g_1 = longitude;
		    $this.m2g_1 = latitude;
		    if (0 === (seen1 & 4))
		      $this.n2g_1 = null;
		    else
		      $this.n2g_1 = name;
		    if (0 === (seen1 & 8))
		      $this.o2g_1 = null;
		    else
		      $this.o2g_1 = address;
		    return $this;
		  }
		  function LocationObject_init_$Create$(seen1, longitude, latitude, name, address, serializationConstructorMarker) {
		    return LocationObject_init_$Init$(seen1, longitude, latitude, name, address, serializationConstructorMarker, objectCreate(protoOf(LocationObject)));
		  }
		  function LocationObject(longitude, latitude, name, address) {
		    name = name === VOID ? null : name;
		    address = address === VOID ? null : address;
		    this.l2g_1 = longitude;
		    this.m2g_1 = latitude;
		    this.n2g_1 = name;
		    this.o2g_1 = address;
		  }
		  protoOf(LocationObject).toString = function () {
		    return 'LocationObject(longitude=' + this.l2g_1 + ', latitude=' + this.m2g_1 + ', name=' + this.n2g_1 + ', address=' + this.o2g_1 + ')';
		  };
		  protoOf(LocationObject).hashCode = function () {
		    var result = getStringHashCode(this.l2g_1);
		    result = imul(result, 31) + getStringHashCode(this.m2g_1) | 0;
		    result = imul(result, 31) + (this.n2g_1 == null ? 0 : getStringHashCode(this.n2g_1)) | 0;
		    result = imul(result, 31) + (this.o2g_1 == null ? 0 : getStringHashCode(this.o2g_1)) | 0;
		    return result;
		  };
		  protoOf(LocationObject).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LocationObject))
		      return false;
		    var tmp0_other_with_cast = other instanceof LocationObject ? other : THROW_CCE();
		    if (!(this.l2g_1 === tmp0_other_with_cast.l2g_1))
		      return false;
		    if (!(this.m2g_1 === tmp0_other_with_cast.m2g_1))
		      return false;
		    if (!(this.n2g_1 == tmp0_other_with_cast.n2g_1))
		      return false;
		    if (!(this.o2g_1 == tmp0_other_with_cast.o2g_1))
		      return false;
		    return true;
		  };
		  function CSMessageType_TEXT_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_TEXT_instance;
		  }
		  function CSMessageType_IMAGE_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_IMAGE_instance;
		  }
		  function CSMessageType_VIDEO_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_VIDEO_instance;
		  }
		  function CSMessageType_AUDIO_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_AUDIO_instance;
		  }
		  function CSMessageType_FILE_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_FILE_instance;
		  }
		  function CSMessageType_VCARD_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_VCARD_instance;
		  }
		  function CSMessageType_CUSTOM_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_CUSTOM_instance;
		  }
		  function CSMessageType_TEMPLATE_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_TEMPLATE_instance;
		  }
		  function CSMessageType_LOCATION_getInstance() {
		    CSMessageType_initEntries();
		    return CSMessageType_LOCATION_instance;
		  }
		  function TimeoutAction(callbackAction, delay) {
		    this.o2m_1 = callbackAction;
		    this.p2m_1 = delay;
		  }
		  protoOf(TimeoutAction).toString = function () {
		    return 'TimeoutAction(callbackAction=' + this.o2m_1 + ', delay=' + this.p2m_1 + ')';
		  };
		  protoOf(TimeoutAction).hashCode = function () {
		    var result = hashCode(this.o2m_1);
		    result = imul(result, 31) + this.p2m_1 | 0;
		    return result;
		  };
		  protoOf(TimeoutAction).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof TimeoutAction))
		      return false;
		    var tmp0_other_with_cast = other instanceof TimeoutAction ? other : THROW_CCE();
		    if (!equals(this.o2m_1, tmp0_other_with_cast.o2m_1))
		      return false;
		    if (!(this.p2m_1 === tmp0_other_with_cast.p2m_1))
		      return false;
		    return true;
		  };
		  function MediaDisable(id) {
		    this.q2m_1 = id;
		  }
		  protoOf(MediaDisable).t27 = function () {
		    return this.q2m_1;
		  };
		  protoOf(MediaDisable).toString = function () {
		    return 'MediaDisable(id=' + this.q2m_1 + ')';
		  };
		  protoOf(MediaDisable).hashCode = function () {
		    return getStringHashCode(this.q2m_1);
		  };
		  protoOf(MediaDisable).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MediaDisable))
		      return false;
		    var tmp0_other_with_cast = other instanceof MediaDisable ? other : THROW_CCE();
		    if (!(this.q2m_1 === tmp0_other_with_cast.q2m_1))
		      return false;
		    return true;
		  };
		  function Mute(id) {
		    this.r2m_1 = id;
		  }
		  protoOf(Mute).t27 = function () {
		    return this.r2m_1;
		  };
		  protoOf(Mute).toString = function () {
		    return 'Mute(id=' + this.r2m_1 + ')';
		  };
		  protoOf(Mute).hashCode = function () {
		    return getStringHashCode(this.r2m_1);
		  };
		  protoOf(Mute).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Mute))
		      return false;
		    var tmp0_other_with_cast = other instanceof Mute ? other : THROW_CCE();
		    if (!(this.r2m_1 === tmp0_other_with_cast.r2m_1))
		      return false;
		    return true;
		  };
		  function Unmute(id) {
		    this.s2m_1 = id;
		  }
		  protoOf(Unmute).t27 = function () {
		    return this.s2m_1;
		  };
		  protoOf(Unmute).toString = function () {
		    return 'Unmute(id=' + this.s2m_1 + ')';
		  };
		  protoOf(Unmute).hashCode = function () {
		    return getStringHashCode(this.s2m_1);
		  };
		  protoOf(Unmute).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Unmute))
		      return false;
		    var tmp0_other_with_cast = other instanceof Unmute ? other : THROW_CCE();
		    if (!(this.s2m_1 === tmp0_other_with_cast.s2m_1))
		      return false;
		    return true;
		  };
		  function EnableEarmuff(id) {
		    this.t2m_1 = id;
		  }
		  protoOf(EnableEarmuff).t27 = function () {
		    return this.t2m_1;
		  };
		  protoOf(EnableEarmuff).toString = function () {
		    return 'EnableEarmuff(id=' + this.t2m_1 + ')';
		  };
		  protoOf(EnableEarmuff).hashCode = function () {
		    return getStringHashCode(this.t2m_1);
		  };
		  protoOf(EnableEarmuff).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EnableEarmuff))
		      return false;
		    var tmp0_other_with_cast = other instanceof EnableEarmuff ? other : THROW_CCE();
		    if (!(this.t2m_1 === tmp0_other_with_cast.t2m_1))
		      return false;
		    return true;
		  };
		  function DisableEarmuff(id) {
		    this.u2m_1 = id;
		  }
		  protoOf(DisableEarmuff).t27 = function () {
		    return this.u2m_1;
		  };
		  protoOf(DisableEarmuff).toString = function () {
		    return 'DisableEarmuff(id=' + this.u2m_1 + ')';
		  };
		  protoOf(DisableEarmuff).hashCode = function () {
		    return getStringHashCode(this.u2m_1);
		  };
		  protoOf(DisableEarmuff).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof DisableEarmuff))
		      return false;
		    var tmp0_other_with_cast = other instanceof DisableEarmuff ? other : THROW_CCE();
		    if (!(this.u2m_1 === tmp0_other_with_cast.u2m_1))
		      return false;
		    return true;
		  };
		  function EnableNoiseSuppression() {
		  }
		  function DisableNoiseSuppression() {
		  }
		  function CallReconnectionRetry(id) {
		    this.v2m_1 = id;
		  }
		  protoOf(CallReconnectionRetry).t27 = function () {
		    return this.v2m_1;
		  };
		  protoOf(CallReconnectionRetry).toString = function () {
		    return 'CallReconnectionRetry(id=' + this.v2m_1 + ')';
		  };
		  protoOf(CallReconnectionRetry).hashCode = function () {
		    return getStringHashCode(this.v2m_1);
		  };
		  protoOf(CallReconnectionRetry).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallReconnectionRetry))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallReconnectionRetry ? other : THROW_CCE();
		    if (!(this.v2m_1 === tmp0_other_with_cast.v2m_1))
		      return false;
		    return true;
		  };
		  function MediaEvent() {
		  }
		  function MediaErrorEvent(id, error) {
		    this.w2m_1 = id;
		    this.x2m_1 = error;
		  }
		  protoOf(MediaErrorEvent).t27 = function () {
		    return this.w2m_1;
		  };
		  protoOf(MediaErrorEvent).toString = function () {
		    return 'MediaErrorEvent(id=' + this.w2m_1 + ', error=' + this.x2m_1 + ')';
		  };
		  protoOf(MediaErrorEvent).hashCode = function () {
		    var result = getStringHashCode(this.w2m_1);
		    result = imul(result, 31) + hashCode(this.x2m_1) | 0;
		    return result;
		  };
		  protoOf(MediaErrorEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MediaErrorEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MediaErrorEvent ? other : THROW_CCE();
		    if (!(this.w2m_1 === tmp0_other_with_cast.w2m_1))
		      return false;
		    if (!equals(this.x2m_1, tmp0_other_with_cast.x2m_1))
		      return false;
		    return true;
		  };
		  function RTCStatsUpdate(id, rtcStats) {
		    this.y2m_1 = id;
		    this.z2m_1 = rtcStats;
		  }
		  protoOf(RTCStatsUpdate).t27 = function () {
		    return this.y2m_1;
		  };
		  protoOf(RTCStatsUpdate).toString = function () {
		    return 'RTCStatsUpdate(id=' + this.y2m_1 + ', rtcStats=' + this.z2m_1 + ')';
		  };
		  protoOf(RTCStatsUpdate).hashCode = function () {
		    var result = getStringHashCode(this.y2m_1);
		    result = imul(result, 31) + this.z2m_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(RTCStatsUpdate).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCStatsUpdate))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCStatsUpdate ? other : THROW_CCE();
		    if (!(this.y2m_1 === tmp0_other_with_cast.y2m_1))
		      return false;
		    if (!this.z2m_1.equals(tmp0_other_with_cast.z2m_1))
		      return false;
		    return true;
		  };
		  function MediaConnectionStateUpdate(id, state) {
		    this.a2n_1 = id;
		    this.b2n_1 = state;
		  }
		  protoOf(MediaConnectionStateUpdate).t27 = function () {
		    return this.a2n_1;
		  };
		  protoOf(MediaConnectionStateUpdate).toString = function () {
		    return 'MediaConnectionStateUpdate(id=' + this.a2n_1 + ', state=' + this.b2n_1 + ')';
		  };
		  protoOf(MediaConnectionStateUpdate).hashCode = function () {
		    var result = getStringHashCode(this.a2n_1);
		    result = imul(result, 31) + this.b2n_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MediaConnectionStateUpdate).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MediaConnectionStateUpdate))
		      return false;
		    var tmp0_other_with_cast = other instanceof MediaConnectionStateUpdate ? other : THROW_CCE();
		    if (!(this.a2n_1 === tmp0_other_with_cast.a2n_1))
		      return false;
		    if (!this.b2n_1.equals(tmp0_other_with_cast.b2n_1))
		      return false;
		    return true;
		  };
		  function MediaOffer(id, sdp) {
		    this.c2n_1 = id;
		    this.d2n_1 = sdp;
		  }
		  protoOf(MediaOffer).t27 = function () {
		    return this.c2n_1;
		  };
		  protoOf(MediaOffer).toString = function () {
		    return 'MediaOffer(id=' + this.c2n_1 + ', sdp=' + this.d2n_1 + ')';
		  };
		  protoOf(MediaOffer).hashCode = function () {
		    var result = getStringHashCode(this.c2n_1);
		    result = imul(result, 31) + getStringHashCode(this.d2n_1) | 0;
		    return result;
		  };
		  protoOf(MediaOffer).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MediaOffer))
		      return false;
		    var tmp0_other_with_cast = other instanceof MediaOffer ? other : THROW_CCE();
		    if (!(this.c2n_1 === tmp0_other_with_cast.c2n_1))
		      return false;
		    if (!(this.d2n_1 === tmp0_other_with_cast.d2n_1))
		      return false;
		    return true;
		  };
		  function MediaAnswer(id, sdp) {
		    this.e2n_1 = id;
		    this.f2n_1 = sdp;
		  }
		  protoOf(MediaAnswer).t27 = function () {
		    return this.e2n_1;
		  };
		  protoOf(MediaAnswer).toString = function () {
		    return 'MediaAnswer(id=' + this.e2n_1 + ', sdp=' + this.f2n_1 + ')';
		  };
		  protoOf(MediaAnswer).hashCode = function () {
		    var result = getStringHashCode(this.e2n_1);
		    result = imul(result, 31) + getStringHashCode(this.f2n_1) | 0;
		    return result;
		  };
		  protoOf(MediaAnswer).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MediaAnswer))
		      return false;
		    var tmp0_other_with_cast = other instanceof MediaAnswer ? other : THROW_CCE();
		    if (!(this.e2n_1 === tmp0_other_with_cast.e2n_1))
		      return false;
		    if (!(this.f2n_1 === tmp0_other_with_cast.f2n_1))
		      return false;
		    return true;
		  };
		  function UnknownSocketEvent(event) {
		    this.g2n_1 = event;
		  }
		  protoOf(UnknownSocketEvent).toString = function () {
		    return 'UnknownSocketEvent(event=' + this.g2n_1 + ')';
		  };
		  protoOf(UnknownSocketEvent).hashCode = function () {
		    return getStringHashCode(this.g2n_1);
		  };
		  protoOf(UnknownSocketEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UnknownSocketEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof UnknownSocketEvent ? other : THROW_CCE();
		    if (!(this.g2n_1 === tmp0_other_with_cast.g2n_1))
		      return false;
		    return true;
		  };
		  var SocketConnectionStatus_Disconnected_instance;
		  var SocketConnectionStatus_Reconnecting_instance;
		  var SocketConnectionStatus_Connected_instance;
		  var SocketConnectionStatus_entriesInitialized;
		  function SocketConnectionStatus_initEntries() {
		    if (SocketConnectionStatus_entriesInitialized)
		      return Unit_instance;
		    SocketConnectionStatus_entriesInitialized = true;
		    SocketConnectionStatus_Disconnected_instance = new SocketConnectionStatus('Disconnected', 0);
		    SocketConnectionStatus_Reconnecting_instance = new SocketConnectionStatus('Reconnecting', 1);
		    SocketConnectionStatus_Connected_instance = new SocketConnectionStatus('Connected', 2);
		  }
		  function SocketConnectionStatus(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  var SocketConnectionFailedReason_ServerDisconnected_instance;
		  var SocketConnectionFailedReason_ClientDisconnected_instance;
		  var SocketConnectionFailedReason_ClientNetworkError_instance;
		  var SocketConnectionFailedReason_PingTimeout_instance;
		  var SocketConnectionFailedReason_entriesInitialized;
		  function SocketConnectionFailedReason_initEntries() {
		    if (SocketConnectionFailedReason_entriesInitialized)
		      return Unit_instance;
		    SocketConnectionFailedReason_entriesInitialized = true;
		    SocketConnectionFailedReason_ServerDisconnected_instance = new SocketConnectionFailedReason('ServerDisconnected', 0);
		    SocketConnectionFailedReason_ClientDisconnected_instance = new SocketConnectionFailedReason('ClientDisconnected', 1);
		    SocketConnectionFailedReason_ClientNetworkError_instance = new SocketConnectionFailedReason('ClientNetworkError', 2);
		    SocketConnectionFailedReason_PingTimeout_instance = new SocketConnectionFailedReason('PingTimeout', 3);
		  }
		  function SocketConnectionFailedReason(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function None() {
		    None_instance = this;
		    SessionStatus.call(this);
		    this.h2n_1 = null;
		    this.i2n_1 = null;
		    this.j2n_1 = null;
		    this.k2n_1 = null;
		  }
		  protoOf(None).t27 = function () {
		    return this.h2n_1;
		  };
		  protoOf(None).l2n = function () {
		    return this.i2n_1;
		  };
		  protoOf(None).m2n = function () {
		    return this.j2n_1;
		  };
		  protoOf(None).n2n = function () {
		    return this.k2n_1;
		  };
		  var None_instance;
		  function None_getInstance() {
		    if (None_instance == null)
		      new None();
		    return None_instance;
		  }
		  function Active(id, user, reason, apiKey) {
		    reason = reason === VOID ? null : reason;
		    SessionStatus.call(this);
		    this.o2n_1 = id;
		    this.p2n_1 = user;
		    this.q2n_1 = reason;
		    this.r2n_1 = apiKey;
		  }
		  protoOf(Active).t27 = function () {
		    return this.o2n_1;
		  };
		  protoOf(Active).l2n = function () {
		    return this.p2n_1;
		  };
		  protoOf(Active).m2n = function () {
		    return this.q2n_1;
		  };
		  protoOf(Active).n2n = function () {
		    return this.r2n_1;
		  };
		  protoOf(Active).toString = function () {
		    return 'Active(id=' + this.o2n_1 + ', user=' + this.p2n_1 + ', reason=' + this.q2n_1 + ', apiKey=' + this.r2n_1 + ')';
		  };
		  protoOf(Active).hashCode = function () {
		    var result = getStringHashCode(this.o2n_1);
		    result = imul(result, 31) + this.p2n_1.hashCode() | 0;
		    result = imul(result, 31) + (this.q2n_1 == null ? 0 : this.q2n_1.hashCode()) | 0;
		    result = imul(result, 31) + getStringHashCode(this.r2n_1) | 0;
		    return result;
		  };
		  protoOf(Active).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Active))
		      return false;
		    var tmp0_other_with_cast = other instanceof Active ? other : THROW_CCE();
		    if (!(this.o2n_1 === tmp0_other_with_cast.o2n_1))
		      return false;
		    if (!this.p2n_1.equals(tmp0_other_with_cast.p2n_1))
		      return false;
		    if (!equals(this.q2n_1, tmp0_other_with_cast.q2n_1))
		      return false;
		    if (!(this.r2n_1 === tmp0_other_with_cast.r2n_1))
		      return false;
		    return true;
		  };
		  function Inactive(id, user, reason, apiKey) {
		    id = id === VOID ? null : id;
		    user = user === VOID ? null : user;
		    reason = reason === VOID ? null : reason;
		    apiKey = apiKey === VOID ? null : apiKey;
		    SessionStatus.call(this);
		    this.s2n_1 = id;
		    this.t2n_1 = user;
		    this.u2n_1 = reason;
		    this.v2n_1 = apiKey;
		  }
		  protoOf(Inactive).t27 = function () {
		    return this.s2n_1;
		  };
		  protoOf(Inactive).l2n = function () {
		    return this.t2n_1;
		  };
		  protoOf(Inactive).m2n = function () {
		    return this.u2n_1;
		  };
		  protoOf(Inactive).n2n = function () {
		    return this.v2n_1;
		  };
		  protoOf(Inactive).toString = function () {
		    return 'Inactive(id=' + this.s2n_1 + ', user=' + this.t2n_1 + ', reason=' + this.u2n_1 + ', apiKey=' + this.v2n_1 + ')';
		  };
		  protoOf(Inactive).hashCode = function () {
		    var result = this.s2n_1 == null ? 0 : getStringHashCode(this.s2n_1);
		    result = imul(result, 31) + (this.t2n_1 == null ? 0 : this.t2n_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.u2n_1 == null ? 0 : this.u2n_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.v2n_1 == null ? 0 : getStringHashCode(this.v2n_1)) | 0;
		    return result;
		  };
		  protoOf(Inactive).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Inactive))
		      return false;
		    var tmp0_other_with_cast = other instanceof Inactive ? other : THROW_CCE();
		    if (!(this.s2n_1 == tmp0_other_with_cast.s2n_1))
		      return false;
		    if (!equals(this.t2n_1, tmp0_other_with_cast.t2n_1))
		      return false;
		    if (!equals(this.u2n_1, tmp0_other_with_cast.u2n_1))
		      return false;
		    if (!(this.v2n_1 == tmp0_other_with_cast.v2n_1))
		      return false;
		    return true;
		  };
		  function SessionStatus() {
		  }
		  function SessionNoActiveSessionError(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'session:error:no-active-session';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'You do not have an active session. Please establish a valid session and try again.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionConnectError.call(this, code, message);
		    captureStack(this, SessionNoActiveSessionError);
		    this.b2o_1 = code;
		    this.c2o_1 = message;
		  }
		  protoOf(SessionNoActiveSessionError).d2o = function () {
		    return this.b2o_1;
		  };
		  protoOf(SessionNoActiveSessionError).ab = function () {
		    return this.c2o_1;
		  };
		  protoOf(SessionNoActiveSessionError).toString = function () {
		    return 'SessionNoActiveSessionError(code=' + this.b2o_1 + ', message=' + this.c2o_1 + ')';
		  };
		  protoOf(SessionNoActiveSessionError).hashCode = function () {
		    var result = getStringHashCode(this.b2o_1);
		    result = imul(result, 31) + getStringHashCode(this.c2o_1) | 0;
		    return result;
		  };
		  protoOf(SessionNoActiveSessionError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionNoActiveSessionError))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionNoActiveSessionError ? other : THROW_CCE();
		    if (!(this.b2o_1 === tmp0_other_with_cast.b2o_1))
		      return false;
		    if (!(this.c2o_1 === tmp0_other_with_cast.c2o_1))
		      return false;
		    return true;
		  };
		  function SocketConnect(token, sessionId) {
		    this.h2o_1 = token;
		    this.i2o_1 = sessionId;
		  }
		  protoOf(SocketConnect).toString = function () {
		    return toMaskedString(this, mapOf([to('token', this.h2o_1), to('sessionId', toString_0(this.i2o_1))]));
		  };
		  protoOf(SocketConnect).hashCode = function () {
		    var result = getStringHashCode(this.h2o_1);
		    result = imul(result, 31) + (this.i2o_1 == null ? 0 : getStringHashCode(this.i2o_1)) | 0;
		    return result;
		  };
		  protoOf(SocketConnect).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SocketConnect))
		      return false;
		    var tmp0_other_with_cast = other instanceof SocketConnect ? other : THROW_CCE();
		    if (!(this.h2o_1 === tmp0_other_with_cast.h2o_1))
		      return false;
		    if (!(this.i2o_1 == tmp0_other_with_cast.i2o_1))
		      return false;
		    return true;
		  };
		  function DeleteSession() {
		  }
		  protoOf(DeleteSession).j2o = function () {
		    return (new Logout()).l2o();
		  };
		  var DeleteSession_instance;
		  function DeleteSession_getInstance() {
		    return DeleteSession_instance;
		  }
		  function SocketDisconnect() {
		  }
		  var SocketDisconnect_instance;
		  function SocketDisconnect_getInstance() {
		    return SocketDisconnect_instance;
		  }
		  function SocketSetSession(sessionId, token) {
		    this.n2o_1 = sessionId;
		    this.o2o_1 = token;
		  }
		  protoOf(SocketSetSession).toString = function () {
		    return toMaskedString(this, mapOf([to('token', this.o2o_1), to('sessionId', this.n2o_1)]));
		  };
		  protoOf(SocketSetSession).hashCode = function () {
		    var result = getStringHashCode(this.n2o_1);
		    result = imul(result, 31) + getStringHashCode(this.o2o_1) | 0;
		    return result;
		  };
		  protoOf(SocketSetSession).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SocketSetSession))
		      return false;
		    var tmp0_other_with_cast = other instanceof SocketSetSession ? other : THROW_CCE();
		    if (!(this.n2o_1 === tmp0_other_with_cast.n2o_1))
		      return false;
		    if (!(this.o2o_1 === tmp0_other_with_cast.o2o_1))
		      return false;
		    return true;
		  };
		  function SocketConnectionStatusWrapper(state, timestamp) {
		    this.p2o_1 = state;
		    this.q2o_1 = timestamp;
		  }
		  protoOf(SocketConnectionStatusWrapper).toString = function () {
		    return 'SocketConnectionStatusWrapper(state=' + this.p2o_1 + ', timestamp=' + toString_0(this.q2o_1) + ')';
		  };
		  protoOf(SocketConnectionStatusWrapper).hashCode = function () {
		    var result = this.p2o_1.hashCode();
		    result = imul(result, 31) + (this.q2o_1 == null ? 0 : hashCode(this.q2o_1)) | 0;
		    return result;
		  };
		  protoOf(SocketConnectionStatusWrapper).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SocketConnectionStatusWrapper))
		      return false;
		    var tmp0_other_with_cast = other instanceof SocketConnectionStatusWrapper ? other : THROW_CCE();
		    if (!this.p2o_1.equals(tmp0_other_with_cast.p2o_1))
		      return false;
		    if (!equals(this.q2o_1, tmp0_other_with_cast.q2o_1))
		      return false;
		    return true;
		  };
		  function MetricsSuccessfullySent(retryNumber, timeOfFirstRetry) {
		    this.r2o_1 = retryNumber;
		    this.s2o_1 = timeOfFirstRetry;
		  }
		  protoOf(MetricsSuccessfullySent).toString = function () {
		    return 'MetricsSuccessfullySent(retryNumber=' + this.r2o_1 + ', timeOfFirstRetry=' + this.s2o_1 + ')';
		  };
		  protoOf(MetricsSuccessfullySent).hashCode = function () {
		    var result = this.r2o_1 == null ? 0 : this.r2o_1;
		    result = imul(result, 31) + (this.s2o_1 == null ? 0 : this.s2o_1) | 0;
		    return result;
		  };
		  protoOf(MetricsSuccessfullySent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MetricsSuccessfullySent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MetricsSuccessfullySent ? other : THROW_CCE();
		    if (!(this.r2o_1 == tmp0_other_with_cast.r2o_1))
		      return false;
		    if (!(this.s2o_1 == tmp0_other_with_cast.s2o_1))
		      return false;
		    return true;
		  };
		  function SocketSetSessionId(sessionId) {
		    this.t2o_1 = sessionId;
		  }
		  protoOf(SocketSetSessionId).toString = function () {
		    return toMaskedString(this, mapOf_0(to('sessionId', this.t2o_1)));
		  };
		  protoOf(SocketSetSessionId).hashCode = function () {
		    return getStringHashCode(this.t2o_1);
		  };
		  protoOf(SocketSetSessionId).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SocketSetSessionId))
		      return false;
		    var tmp0_other_with_cast = other instanceof SocketSetSessionId ? other : THROW_CCE();
		    if (!(this.t2o_1 === tmp0_other_with_cast.t2o_1))
		      return false;
		    return true;
		  };
		  function SessionError(code, message, cause) {
		    cause = cause === VOID ? null : cause;
		    Exception_init_$Init$_0(message, cause, this);
		    captureStack(this, SessionError);
		    this.e2o_1 = code;
		    this.f2o_1 = message;
		    this.g2o_1 = cause;
		  }
		  protoOf(SessionError).d2o = function () {
		    return this.e2o_1;
		  };
		  protoOf(SessionError).ab = function () {
		    return this.f2o_1;
		  };
		  protoOf(SessionError).bb = function () {
		    return this.g2o_1;
		  };
		  function SessionConnectError(code, message) {
		    SessionError.call(this, code, message);
		    captureStack(this, SessionConnectError);
		    this.x2o_1 = code;
		    this.y2o_1 = message;
		  }
		  protoOf(SessionConnectError).d2o = function () {
		    return this.x2o_1;
		  };
		  protoOf(SessionConnectError).ab = function () {
		    return this.y2o_1;
		  };
		  function SocketEmitAction() {
		  }
		  function Companion_126() {
		  }
		  protoOf(Companion_126).y12 = function () {
		    return SocketEventSerializer_getInstance();
		  };
		  protoOf(Companion_126).nr = function (typeParamsSerializers) {
		    return this.y12();
		  };
		  var Companion_instance_127;
		  function Companion_getInstance_128() {
		    return Companion_instance_127;
		  }
		  function SocketEvent() {
		  }
		  function SocketConversationEvent() {
		  }
		  function SocketStatus(status, reason, timestamp, retryNumber) {
		    this.z2o_1 = status;
		    this.a2p_1 = reason;
		    this.b2p_1 = timestamp;
		    this.c2p_1 = retryNumber;
		  }
		  protoOf(SocketStatus).toString = function () {
		    return 'SocketStatus(status=' + this.z2o_1 + ', reason=' + this.a2p_1 + ', timestamp=' + toString_0(this.b2p_1) + ', retryNumber=' + this.c2p_1 + ')';
		  };
		  protoOf(SocketStatus).hashCode = function () {
		    var result = this.z2o_1.hashCode();
		    result = imul(result, 31) + (this.a2p_1 == null ? 0 : this.a2p_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.b2p_1 == null ? 0 : hashCode(this.b2p_1)) | 0;
		    result = imul(result, 31) + (this.c2p_1 == null ? 0 : this.c2p_1) | 0;
		    return result;
		  };
		  protoOf(SocketStatus).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SocketStatus))
		      return false;
		    var tmp0_other_with_cast = other instanceof SocketStatus ? other : THROW_CCE();
		    if (!this.z2o_1.equals(tmp0_other_with_cast.z2o_1))
		      return false;
		    if (!equals(this.a2p_1, tmp0_other_with_cast.a2p_1))
		      return false;
		    if (!equals(this.b2p_1, tmp0_other_with_cast.b2p_1))
		      return false;
		    if (!(this.c2p_1 == tmp0_other_with_cast.c2p_1))
		      return false;
		    return true;
		  };
		  function SocketConnectEmptyTokenError() {
		  }
		  var SocketConnectEmptyTokenError_instance;
		  function SocketConnectEmptyTokenError_getInstance() {
		    return SocketConnectEmptyTokenError_instance;
		  }
		  function SessionTimerEvent(originalAction) {
		    this.d2p_1 = originalAction;
		  }
		  protoOf(SessionTimerEvent).toString = function () {
		    return 'SessionTimerEvent(originalAction=' + this.d2p_1 + ')';
		  };
		  protoOf(SessionTimerEvent).hashCode = function () {
		    return hashCode(this.d2p_1);
		  };
		  protoOf(SessionTimerEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionTimerEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionTimerEvent ? other : THROW_CCE();
		    if (!equals(this.d2p_1, tmp0_other_with_cast.d2p_1))
		      return false;
		    return true;
		  };
		  function Companion_127() {
		  }
		  protoOf(Companion_127).y12 = function () {
		    return $serializer_getInstance_146();
		  };
		  var Companion_instance_128;
		  function Companion_getInstance_129() {
		    return Companion_instance_128;
		  }
		  function $serializer_146() {
		    $serializer_instance_146 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionInvalidTokenEvent', this, 5);
		    tmp0_serialDesc.pq('body', true);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.e2p_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_146).uf = function () {
		    return this.e2p_1;
		  };
		  protoOf($serializer_146).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [UnitSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_146).wf = function (decoder) {
		    var tmp0_desc = this.e2p_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionInvalidTokenEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_146).f2p = function (encoder, value) {
		    var tmp0_desc = this.e2p_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 0)) {
		      tmp = true;
		    } else {
		      tmp = !equals(Unit_instance, Unit_instance);
		    }
		    if (tmp) {
		      var tmp_0 = UnitSerializer_getInstance();
		      tmp1_output.vk(tmp0_desc, 0, tmp_0, Unit_instance);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.h2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.h2p_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.i2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.i2p_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.j2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.j2p_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.k2p_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_146).vf = function (encoder, value) {
		    return this.f2p(encoder, value instanceof SessionInvalidTokenEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_146;
		  function $serializer_getInstance_146() {
		    if ($serializer_instance_146 == null)
		      new $serializer_146();
		    return $serializer_instance_146;
		  }
		  function SessionInvalidTokenEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(16 === (16 & seen1))) {
		      throwMissingFieldException(seen1, 16, $serializer_getInstance_146().e2p_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.g2p_1 = Unit_instance;
		    else
		      $this.g2p_1 = body;
		    if (0 === (seen1 & 2))
		      $this.h2p_1 = null;
		    else
		      $this.h2p_1 = id;
		    if (0 === (seen1 & 4))
		      $this.i2p_1 = null;
		    else
		      $this.i2p_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.j2p_1 = null;
		    else
		      $this.j2p_1 = from;
		    $this.k2p_1 = type;
		    return $this;
		  }
		  function SessionInvalidTokenEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return SessionInvalidTokenEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(SessionInvalidTokenEvent)));
		  }
		  function SessionInvalidTokenEvent() {
		  }
		  protoOf(SessionInvalidTokenEvent).t27 = function () {
		    return this.h2p_1;
		  };
		  protoOf(SessionInvalidTokenEvent).u27 = function () {
		    return this.i2p_1;
		  };
		  protoOf(SessionInvalidTokenEvent).toString = function () {
		    return 'SessionInvalidTokenEvent(body=' + Unit_instance + ', id=' + this.h2p_1 + ', cid=' + this.i2p_1 + ', from=' + this.j2p_1 + ', type=' + this.k2p_1 + ')';
		  };
		  protoOf(SessionInvalidTokenEvent).hashCode = function () {
		    var result = hashCode(Unit_instance);
		    result = imul(result, 31) + (this.h2p_1 == null ? 0 : this.h2p_1) | 0;
		    result = imul(result, 31) + (this.i2p_1 == null ? 0 : getStringHashCode(this.i2p_1)) | 0;
		    result = imul(result, 31) + (this.j2p_1 == null ? 0 : getStringHashCode(this.j2p_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.k2p_1) | 0;
		    return result;
		  };
		  protoOf(SessionInvalidTokenEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionInvalidTokenEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionInvalidTokenEvent ? other : THROW_CCE();
		    if (!equals(Unit_instance, Unit_instance))
		      return false;
		    if (!(this.h2p_1 == tmp0_other_with_cast.h2p_1))
		      return false;
		    if (!(this.i2p_1 == tmp0_other_with_cast.i2p_1))
		      return false;
		    if (!(this.j2p_1 == tmp0_other_with_cast.j2p_1))
		      return false;
		    if (!(this.k2p_1 === tmp0_other_with_cast.k2p_1))
		      return false;
		    return true;
		  };
		  function Companion_128() {
		  }
		  protoOf(Companion_128).y12 = function () {
		    return $serializer_getInstance_147();
		  };
		  var Companion_instance_129;
		  function Companion_getInstance_130() {
		    return Companion_instance_129;
		  }
		  function $serializer_147() {
		    $serializer_instance_147 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionInvalidEvent', this, 5);
		    tmp0_serialDesc.pq('body', true);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.l2p_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_147).uf = function () {
		    return this.l2p_1;
		  };
		  protoOf($serializer_147).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [UnitSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_147).wf = function (decoder) {
		    var tmp0_desc = this.l2p_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionInvalidEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_147).m2p = function (encoder, value) {
		    var tmp0_desc = this.l2p_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 0)) {
		      tmp = true;
		    } else {
		      tmp = !equals(Unit_instance, Unit_instance);
		    }
		    if (tmp) {
		      var tmp_0 = UnitSerializer_getInstance();
		      tmp1_output.vk(tmp0_desc, 0, tmp_0, Unit_instance);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.o2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.o2p_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.p2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.p2p_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.q2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.q2p_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.r2p_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_147).vf = function (encoder, value) {
		    return this.m2p(encoder, value instanceof SessionInvalidEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_147;
		  function $serializer_getInstance_147() {
		    if ($serializer_instance_147 == null)
		      new $serializer_147();
		    return $serializer_instance_147;
		  }
		  function SessionInvalidEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(16 === (16 & seen1))) {
		      throwMissingFieldException(seen1, 16, $serializer_getInstance_147().l2p_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.n2p_1 = Unit_instance;
		    else
		      $this.n2p_1 = body;
		    if (0 === (seen1 & 2))
		      $this.o2p_1 = null;
		    else
		      $this.o2p_1 = id;
		    if (0 === (seen1 & 4))
		      $this.p2p_1 = null;
		    else
		      $this.p2p_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.q2p_1 = null;
		    else
		      $this.q2p_1 = from;
		    $this.r2p_1 = type;
		    return $this;
		  }
		  function SessionInvalidEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return SessionInvalidEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(SessionInvalidEvent)));
		  }
		  function SessionInvalidEvent() {
		  }
		  protoOf(SessionInvalidEvent).t27 = function () {
		    return this.o2p_1;
		  };
		  protoOf(SessionInvalidEvent).u27 = function () {
		    return this.p2p_1;
		  };
		  protoOf(SessionInvalidEvent).toString = function () {
		    return 'SessionInvalidEvent(body=' + Unit_instance + ', id=' + this.o2p_1 + ', cid=' + this.p2p_1 + ', from=' + this.q2p_1 + ', type=' + this.r2p_1 + ')';
		  };
		  protoOf(SessionInvalidEvent).hashCode = function () {
		    var result = hashCode(Unit_instance);
		    result = imul(result, 31) + (this.o2p_1 == null ? 0 : this.o2p_1) | 0;
		    result = imul(result, 31) + (this.p2p_1 == null ? 0 : getStringHashCode(this.p2p_1)) | 0;
		    result = imul(result, 31) + (this.q2p_1 == null ? 0 : getStringHashCode(this.q2p_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.r2p_1) | 0;
		    return result;
		  };
		  protoOf(SessionInvalidEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionInvalidEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionInvalidEvent ? other : THROW_CCE();
		    if (!equals(Unit_instance, Unit_instance))
		      return false;
		    if (!(this.o2p_1 == tmp0_other_with_cast.o2p_1))
		      return false;
		    if (!(this.p2p_1 == tmp0_other_with_cast.p2p_1))
		      return false;
		    if (!(this.q2p_1 == tmp0_other_with_cast.q2p_1))
		      return false;
		    if (!(this.r2p_1 === tmp0_other_with_cast.r2p_1))
		      return false;
		    return true;
		  };
		  function Companion_129() {
		  }
		  protoOf(Companion_129).y12 = function () {
		    return $serializer_getInstance_148();
		  };
		  var Companion_instance_130;
		  function Companion_getInstance_131() {
		    return Companion_instance_130;
		  }
		  function $serializer_148() {
		    $serializer_instance_148 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionExpiredTokenEvent', this, 5);
		    tmp0_serialDesc.pq('body', true);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.s2p_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_148).uf = function () {
		    return this.s2p_1;
		  };
		  protoOf($serializer_148).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [UnitSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_148).wf = function (decoder) {
		    var tmp0_desc = this.s2p_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionExpiredTokenEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_148).t2p = function (encoder, value) {
		    var tmp0_desc = this.s2p_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 0)) {
		      tmp = true;
		    } else {
		      tmp = !equals(Unit_instance, Unit_instance);
		    }
		    if (tmp) {
		      var tmp_0 = UnitSerializer_getInstance();
		      tmp1_output.vk(tmp0_desc, 0, tmp_0, Unit_instance);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.v2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.v2p_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.w2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.w2p_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.x2p_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.x2p_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.y2p_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_148).vf = function (encoder, value) {
		    return this.t2p(encoder, value instanceof SessionExpiredTokenEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_148;
		  function $serializer_getInstance_148() {
		    if ($serializer_instance_148 == null)
		      new $serializer_148();
		    return $serializer_instance_148;
		  }
		  function SessionExpiredTokenEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(16 === (16 & seen1))) {
		      throwMissingFieldException(seen1, 16, $serializer_getInstance_148().s2p_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.u2p_1 = Unit_instance;
		    else
		      $this.u2p_1 = body;
		    if (0 === (seen1 & 2))
		      $this.v2p_1 = null;
		    else
		      $this.v2p_1 = id;
		    if (0 === (seen1 & 4))
		      $this.w2p_1 = null;
		    else
		      $this.w2p_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.x2p_1 = null;
		    else
		      $this.x2p_1 = from;
		    $this.y2p_1 = type;
		    return $this;
		  }
		  function SessionExpiredTokenEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return SessionExpiredTokenEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(SessionExpiredTokenEvent)));
		  }
		  function SessionExpiredTokenEvent() {
		  }
		  protoOf(SessionExpiredTokenEvent).t27 = function () {
		    return this.v2p_1;
		  };
		  protoOf(SessionExpiredTokenEvent).u27 = function () {
		    return this.w2p_1;
		  };
		  protoOf(SessionExpiredTokenEvent).toString = function () {
		    return 'SessionExpiredTokenEvent(body=' + Unit_instance + ', id=' + this.v2p_1 + ', cid=' + this.w2p_1 + ', from=' + this.x2p_1 + ', type=' + this.y2p_1 + ')';
		  };
		  protoOf(SessionExpiredTokenEvent).hashCode = function () {
		    var result = hashCode(Unit_instance);
		    result = imul(result, 31) + (this.v2p_1 == null ? 0 : this.v2p_1) | 0;
		    result = imul(result, 31) + (this.w2p_1 == null ? 0 : getStringHashCode(this.w2p_1)) | 0;
		    result = imul(result, 31) + (this.x2p_1 == null ? 0 : getStringHashCode(this.x2p_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.y2p_1) | 0;
		    return result;
		  };
		  protoOf(SessionExpiredTokenEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionExpiredTokenEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionExpiredTokenEvent ? other : THROW_CCE();
		    if (!equals(Unit_instance, Unit_instance))
		      return false;
		    if (!(this.v2p_1 == tmp0_other_with_cast.v2p_1))
		      return false;
		    if (!(this.w2p_1 == tmp0_other_with_cast.w2p_1))
		      return false;
		    if (!(this.x2p_1 == tmp0_other_with_cast.x2p_1))
		      return false;
		    if (!(this.y2p_1 === tmp0_other_with_cast.y2p_1))
		      return false;
		    return true;
		  };
		  function Companion_130() {
		  }
		  protoOf(Companion_130).y12 = function () {
		    return $serializer_getInstance_149();
		  };
		  var Companion_instance_131;
		  function Companion_getInstance_132() {
		    return Companion_instance_131;
		  }
		  function $serializer_149() {
		    $serializer_instance_149 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionMaxOpenEvent', this, 5);
		    tmp0_serialDesc.pq('body', true);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.z2p_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_149).uf = function () {
		    return this.z2p_1;
		  };
		  protoOf($serializer_149).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [UnitSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_149).wf = function (decoder) {
		    var tmp0_desc = this.z2p_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionMaxOpenEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_149).a2q = function (encoder, value) {
		    var tmp0_desc = this.z2p_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 0)) {
		      tmp = true;
		    } else {
		      tmp = !equals(Unit_instance, Unit_instance);
		    }
		    if (tmp) {
		      var tmp_0 = UnitSerializer_getInstance();
		      tmp1_output.vk(tmp0_desc, 0, tmp_0, Unit_instance);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.c2q_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.c2q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.d2q_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.d2q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.e2q_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.e2q_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.f2q_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_149).vf = function (encoder, value) {
		    return this.a2q(encoder, value instanceof SessionMaxOpenEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_149;
		  function $serializer_getInstance_149() {
		    if ($serializer_instance_149 == null)
		      new $serializer_149();
		    return $serializer_instance_149;
		  }
		  function SessionMaxOpenEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(16 === (16 & seen1))) {
		      throwMissingFieldException(seen1, 16, $serializer_getInstance_149().z2p_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.b2q_1 = Unit_instance;
		    else
		      $this.b2q_1 = body;
		    if (0 === (seen1 & 2))
		      $this.c2q_1 = null;
		    else
		      $this.c2q_1 = id;
		    if (0 === (seen1 & 4))
		      $this.d2q_1 = null;
		    else
		      $this.d2q_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.e2q_1 = null;
		    else
		      $this.e2q_1 = from;
		    $this.f2q_1 = type;
		    return $this;
		  }
		  function SessionMaxOpenEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return SessionMaxOpenEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(SessionMaxOpenEvent)));
		  }
		  function SessionMaxOpenEvent() {
		  }
		  protoOf(SessionMaxOpenEvent).t27 = function () {
		    return this.c2q_1;
		  };
		  protoOf(SessionMaxOpenEvent).u27 = function () {
		    return this.d2q_1;
		  };
		  protoOf(SessionMaxOpenEvent).toString = function () {
		    return 'SessionMaxOpenEvent(body=' + Unit_instance + ', id=' + this.c2q_1 + ', cid=' + this.d2q_1 + ', from=' + this.e2q_1 + ', type=' + this.f2q_1 + ')';
		  };
		  protoOf(SessionMaxOpenEvent).hashCode = function () {
		    var result = hashCode(Unit_instance);
		    result = imul(result, 31) + (this.c2q_1 == null ? 0 : this.c2q_1) | 0;
		    result = imul(result, 31) + (this.d2q_1 == null ? 0 : getStringHashCode(this.d2q_1)) | 0;
		    result = imul(result, 31) + (this.e2q_1 == null ? 0 : getStringHashCode(this.e2q_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f2q_1) | 0;
		    return result;
		  };
		  protoOf(SessionMaxOpenEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionMaxOpenEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionMaxOpenEvent ? other : THROW_CCE();
		    if (!equals(Unit_instance, Unit_instance))
		      return false;
		    if (!(this.c2q_1 == tmp0_other_with_cast.c2q_1))
		      return false;
		    if (!(this.d2q_1 == tmp0_other_with_cast.d2q_1))
		      return false;
		    if (!(this.e2q_1 == tmp0_other_with_cast.e2q_1))
		      return false;
		    if (!(this.f2q_1 === tmp0_other_with_cast.f2q_1))
		      return false;
		    return true;
		  };
		  function Companion_131() {
		  }
		  protoOf(Companion_131).y12 = function () {
		    return $serializer_getInstance_150();
		  };
		  var Companion_instance_132;
		  function Companion_getInstance_133() {
		    return Companion_instance_132;
		  }
		  function $serializer_150() {
		    $serializer_instance_150 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.AuthorizationErrorEvent', this, 5);
		    tmp0_serialDesc.pq('body', true);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.g2q_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_150).uf = function () {
		    return this.g2q_1;
		  };
		  protoOf($serializer_150).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [UnitSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_150).wf = function (decoder) {
		    var tmp0_desc = this.g2q_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return AuthorizationErrorEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_150).h2q = function (encoder, value) {
		    var tmp0_desc = this.g2q_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 0)) {
		      tmp = true;
		    } else {
		      tmp = !equals(Unit_instance, Unit_instance);
		    }
		    if (tmp) {
		      var tmp_0 = UnitSerializer_getInstance();
		      tmp1_output.vk(tmp0_desc, 0, tmp_0, Unit_instance);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.j2q_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.j2q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.k2q_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.k2q_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.l2q_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.l2q_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.m2q_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_150).vf = function (encoder, value) {
		    return this.h2q(encoder, value instanceof AuthorizationErrorEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_150;
		  function $serializer_getInstance_150() {
		    if ($serializer_instance_150 == null)
		      new $serializer_150();
		    return $serializer_instance_150;
		  }
		  function AuthorizationErrorEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(16 === (16 & seen1))) {
		      throwMissingFieldException(seen1, 16, $serializer_getInstance_150().g2q_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.i2q_1 = Unit_instance;
		    else
		      $this.i2q_1 = body;
		    if (0 === (seen1 & 2))
		      $this.j2q_1 = null;
		    else
		      $this.j2q_1 = id;
		    if (0 === (seen1 & 4))
		      $this.k2q_1 = null;
		    else
		      $this.k2q_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.l2q_1 = null;
		    else
		      $this.l2q_1 = from;
		    $this.m2q_1 = type;
		    return $this;
		  }
		  function AuthorizationErrorEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return AuthorizationErrorEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(AuthorizationErrorEvent)));
		  }
		  function AuthorizationErrorEvent() {
		  }
		  protoOf(AuthorizationErrorEvent).t27 = function () {
		    return this.j2q_1;
		  };
		  protoOf(AuthorizationErrorEvent).u27 = function () {
		    return this.k2q_1;
		  };
		  protoOf(AuthorizationErrorEvent).toString = function () {
		    return 'AuthorizationErrorEvent(body=' + Unit_instance + ', id=' + this.j2q_1 + ', cid=' + this.k2q_1 + ', from=' + this.l2q_1 + ', type=' + this.m2q_1 + ')';
		  };
		  protoOf(AuthorizationErrorEvent).hashCode = function () {
		    var result = hashCode(Unit_instance);
		    result = imul(result, 31) + (this.j2q_1 == null ? 0 : this.j2q_1) | 0;
		    result = imul(result, 31) + (this.k2q_1 == null ? 0 : getStringHashCode(this.k2q_1)) | 0;
		    result = imul(result, 31) + (this.l2q_1 == null ? 0 : getStringHashCode(this.l2q_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.m2q_1) | 0;
		    return result;
		  };
		  protoOf(AuthorizationErrorEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AuthorizationErrorEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof AuthorizationErrorEvent ? other : THROW_CCE();
		    if (!equals(Unit_instance, Unit_instance))
		      return false;
		    if (!(this.j2q_1 == tmp0_other_with_cast.j2q_1))
		      return false;
		    if (!(this.k2q_1 == tmp0_other_with_cast.k2q_1))
		      return false;
		    if (!(this.l2q_1 == tmp0_other_with_cast.l2q_1))
		      return false;
		    if (!(this.m2q_1 === tmp0_other_with_cast.m2q_1))
		      return false;
		    return true;
		  };
		  function SessionEmptyTokenError(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'session:error:empty-token';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'You provided an empty token. Please provide a valid token.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionError.call(this, code, message);
		    captureStack(this, SessionEmptyTokenError);
		    this.q2q_1 = code;
		    this.r2q_1 = message;
		  }
		  protoOf(SessionEmptyTokenError).d2o = function () {
		    return this.q2q_1;
		  };
		  protoOf(SessionEmptyTokenError).ab = function () {
		    return this.r2q_1;
		  };
		  protoOf(SessionEmptyTokenError).toString = function () {
		    return 'SessionEmptyTokenError(code=' + this.q2q_1 + ', message=' + this.r2q_1 + ')';
		  };
		  protoOf(SessionEmptyTokenError).hashCode = function () {
		    var result = getStringHashCode(this.q2q_1);
		    result = imul(result, 31) + getStringHashCode(this.r2q_1) | 0;
		    return result;
		  };
		  protoOf(SessionEmptyTokenError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionEmptyTokenError))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionEmptyTokenError ? other : THROW_CCE();
		    if (!(this.q2q_1 === tmp0_other_with_cast.q2q_1))
		      return false;
		    if (!(this.r2q_1 === tmp0_other_with_cast.r2q_1))
		      return false;
		    return true;
		  };
		  function SessionSocketTransportError(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'session:error:websocket-transport-invalid';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'Session failed due to an invalid websocket transport.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionConnectError.call(this, code, message);
		    captureStack(this, SessionSocketTransportError);
		    this.x2q_1 = code;
		    this.y2q_1 = message;
		  }
		  protoOf(SessionSocketTransportError).d2o = function () {
		    return this.x2q_1;
		  };
		  protoOf(SessionSocketTransportError).ab = function () {
		    return this.y2q_1;
		  };
		  protoOf(SessionSocketTransportError).toString = function () {
		    return 'SessionSocketTransportError(code=' + this.x2q_1 + ', message=' + this.y2q_1 + ')';
		  };
		  protoOf(SessionSocketTransportError).hashCode = function () {
		    var result = getStringHashCode(this.x2q_1);
		    result = imul(result, 31) + getStringHashCode(this.y2q_1) | 0;
		    return result;
		  };
		  protoOf(SessionSocketTransportError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionSocketTransportError))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionSocketTransportError ? other : THROW_CCE();
		    if (!(this.x2q_1 === tmp0_other_with_cast.x2q_1))
		      return false;
		    if (!(this.y2q_1 === tmp0_other_with_cast.y2q_1))
		      return false;
		    return true;
		  };
		  function SessionTimeoutError(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'session:error:timeout';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'Session failed due to a timeout expiration.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionConnectError.call(this, code, message);
		    captureStack(this, SessionTimeoutError);
		    this.e2r_1 = code;
		    this.f2r_1 = message;
		  }
		  protoOf(SessionTimeoutError).d2o = function () {
		    return this.e2r_1;
		  };
		  protoOf(SessionTimeoutError).ab = function () {
		    return this.f2r_1;
		  };
		  protoOf(SessionTimeoutError).toString = function () {
		    return 'SessionTimeoutError(code=' + this.e2r_1 + ', message=' + this.f2r_1 + ')';
		  };
		  protoOf(SessionTimeoutError).hashCode = function () {
		    var result = getStringHashCode(this.e2r_1);
		    result = imul(result, 31) + getStringHashCode(this.f2r_1) | 0;
		    return result;
		  };
		  protoOf(SessionTimeoutError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionTimeoutError))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionTimeoutError ? other : THROW_CCE();
		    if (!(this.e2r_1 === tmp0_other_with_cast.e2r_1))
		      return false;
		    if (!(this.f2r_1 === tmp0_other_with_cast.f2r_1))
		      return false;
		    return true;
		  };
		  function SessionInvalidError(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'session:error:invalid-session';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'The request failed due to an invalid session. Please establish a valid session and try again.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionConnectError.call(this, code, message);
		    captureStack(this, SessionInvalidError);
		    this.l2r_1 = code;
		    this.m2r_1 = message;
		  }
		  protoOf(SessionInvalidError).d2o = function () {
		    return this.l2r_1;
		  };
		  protoOf(SessionInvalidError).ab = function () {
		    return this.m2r_1;
		  };
		  protoOf(SessionInvalidError).toString = function () {
		    return 'SessionInvalidError(code=' + this.l2r_1 + ', message=' + this.m2r_1 + ')';
		  };
		  protoOf(SessionInvalidError).hashCode = function () {
		    var result = getStringHashCode(this.l2r_1);
		    result = imul(result, 31) + getStringHashCode(this.m2r_1) | 0;
		    return result;
		  };
		  protoOf(SessionInvalidError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionInvalidError))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionInvalidError ? other : THROW_CCE();
		    if (!(this.l2r_1 === tmp0_other_with_cast.l2r_1))
		      return false;
		    if (!(this.m2r_1 === tmp0_other_with_cast.m2r_1))
		      return false;
		    return true;
		  };
		  function SessionInvalidTokenError(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'session:error:invalid-token';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'You provided an invalid token. Please provide a valid token.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionConnectError.call(this, code, message);
		    captureStack(this, SessionInvalidTokenError);
		    this.s2r_1 = code;
		    this.t2r_1 = message;
		  }
		  protoOf(SessionInvalidTokenError).d2o = function () {
		    return this.s2r_1;
		  };
		  protoOf(SessionInvalidTokenError).ab = function () {
		    return this.t2r_1;
		  };
		  protoOf(SessionInvalidTokenError).toString = function () {
		    return 'SessionInvalidTokenError(code=' + this.s2r_1 + ', message=' + this.t2r_1 + ')';
		  };
		  protoOf(SessionInvalidTokenError).hashCode = function () {
		    var result = getStringHashCode(this.s2r_1);
		    result = imul(result, 31) + getStringHashCode(this.t2r_1) | 0;
		    return result;
		  };
		  protoOf(SessionInvalidTokenError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionInvalidTokenError))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionInvalidTokenError ? other : THROW_CCE();
		    if (!(this.s2r_1 === tmp0_other_with_cast.s2r_1))
		      return false;
		    if (!(this.t2r_1 === tmp0_other_with_cast.t2r_1))
		      return false;
		    return true;
		  };
		  function AuthorizationError(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'system:error:permission';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'Permission denied. Please provide a valid token.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionConnectError.call(this, code, message);
		    captureStack(this, AuthorizationError);
		    this.z2r_1 = code;
		    this.a2s_1 = message;
		  }
		  protoOf(AuthorizationError).d2o = function () {
		    return this.z2r_1;
		  };
		  protoOf(AuthorizationError).ab = function () {
		    return this.a2s_1;
		  };
		  protoOf(AuthorizationError).toString = function () {
		    return 'AuthorizationError(code=' + this.z2r_1 + ', message=' + this.a2s_1 + ')';
		  };
		  protoOf(AuthorizationError).hashCode = function () {
		    var result = getStringHashCode(this.z2r_1);
		    result = imul(result, 31) + getStringHashCode(this.a2s_1) | 0;
		    return result;
		  };
		  protoOf(AuthorizationError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AuthorizationError))
		      return false;
		    var tmp0_other_with_cast = other instanceof AuthorizationError ? other : THROW_CCE();
		    if (!(this.z2r_1 === tmp0_other_with_cast.z2r_1))
		      return false;
		    if (!(this.a2s_1 === tmp0_other_with_cast.a2s_1))
		      return false;
		    return true;
		  };
		  function SessionExpiredTokenError(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'session:error:expired-token';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'You provided an expired token. Please provide a valid token.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionConnectError.call(this, code, message);
		    captureStack(this, SessionExpiredTokenError);
		    this.g2s_1 = code;
		    this.h2s_1 = message;
		  }
		  protoOf(SessionExpiredTokenError).d2o = function () {
		    return this.g2s_1;
		  };
		  protoOf(SessionExpiredTokenError).ab = function () {
		    return this.h2s_1;
		  };
		  protoOf(SessionExpiredTokenError).toString = function () {
		    return 'SessionExpiredTokenError(code=' + this.g2s_1 + ', message=' + this.h2s_1 + ')';
		  };
		  protoOf(SessionExpiredTokenError).hashCode = function () {
		    var result = getStringHashCode(this.g2s_1);
		    result = imul(result, 31) + getStringHashCode(this.h2s_1) | 0;
		    return result;
		  };
		  protoOf(SessionExpiredTokenError).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionExpiredTokenError))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionExpiredTokenError ? other : THROW_CCE();
		    if (!(this.g2s_1 === tmp0_other_with_cast.g2s_1))
		      return false;
		    if (!(this.h2s_1 === tmp0_other_with_cast.h2s_1))
		      return false;
		    return true;
		  };
		  function SessionMaxOpenSessions(code, message) {
		    var tmp;
		    if (code === VOID) {
		      tmp = 'session:error:max-open-sessions-permitted';
		    } else {
		      tmp = code;
		    }
		    code = tmp;
		    var tmp_0;
		    if (message === VOID) {
		      tmp_0 = 'The maximum amount of open sessions has been established. Please delete them by logging out and try again.';
		    } else {
		      tmp_0 = message;
		    }
		    message = tmp_0;
		    SessionConnectError.call(this, code, message);
		    captureStack(this, SessionMaxOpenSessions);
		    this.n2s_1 = code;
		    this.o2s_1 = message;
		  }
		  protoOf(SessionMaxOpenSessions).d2o = function () {
		    return this.n2s_1;
		  };
		  protoOf(SessionMaxOpenSessions).ab = function () {
		    return this.o2s_1;
		  };
		  protoOf(SessionMaxOpenSessions).toString = function () {
		    return 'SessionMaxOpenSessions(code=' + this.n2s_1 + ', message=' + this.o2s_1 + ')';
		  };
		  protoOf(SessionMaxOpenSessions).hashCode = function () {
		    var result = getStringHashCode(this.n2s_1);
		    result = imul(result, 31) + getStringHashCode(this.o2s_1) | 0;
		    return result;
		  };
		  protoOf(SessionMaxOpenSessions).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionMaxOpenSessions))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionMaxOpenSessions ? other : THROW_CCE();
		    if (!(this.n2s_1 === tmp0_other_with_cast.n2s_1))
		      return false;
		    if (!(this.o2s_1 === tmp0_other_with_cast.o2s_1))
		      return false;
		    return true;
		  };
		  function SocketEventSerializer() {
		    SocketEventSerializer_instance = this;
		    JsonContentPolymorphicSerializer.call(this, getKClass(SocketEvent));
		  }
		  protoOf(SocketEventSerializer).w12 = function (element) {
		    var tmp0_safe_receiver = get_jsonObject(element).b13('type');
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
		    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e13();
		    var type = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
		    var tmp;
		    if (type === 'session:success') {
		      tmp = Companion_instance_94.y12();
		    } else {
		      if (type === 'member:media') {
		        tmp = Companion_instance_99.y12();
		      } else {
		        if (type === CSConversationEventType_MEMBER_INVITED_getInstance().d1s_1) {
		          tmp = Companion_instance_98.y12();
		        } else {
		          if (type === CSConversationEventType_MEMBER_JOINED_getInstance().d1s_1) {
		            tmp = Companion_instance_96.y12();
		          } else {
		            if (type === CSConversationEventType_MEMBER_LEFT_getInstance().d1s_1) {
		              tmp = Companion_instance_100.y12();
		            } else {
		              if (type === CSConversationEventType_MESSAGE_getInstance().d1s_1) {
		                tmp = Companion_instance_102.y12();
		              } else {
		                if (type === CSConversationEventType_EPHEMERAL_getInstance().d1s_1) {
		                  tmp = Companion_instance_103.y12();
		                } else {
		                  if (type === CSConversationEventType_EVENT_DELETE_getInstance().d1s_1) {
		                    tmp = Companion_instance_104.y12();
		                  } else {
		                    if (type === CSConversationEventType_MESSAGE_DELIVERED_getInstance().d1s_1) {
		                      tmp = Companion_instance_105.y12();
		                    } else {
		                      if (type === CSConversationEventType_MESSAGE_REJECTED_getInstance().d1s_1) {
		                        tmp = Companion_instance_106.y12();
		                      } else {
		                        if (type === CSConversationEventType_MESSAGE_SUBMITTED_getInstance().d1s_1) {
		                          tmp = Companion_instance_107.y12();
		                        } else {
		                          if (type === CSConversationEventType_MESSAGE_UNDELIVERABLE_getInstance().d1s_1) {
		                            tmp = Companion_instance_108.y12();
		                          } else {
		                            if (type === CSConversationEventType_MESSAGE_SEEN_getInstance().d1s_1) {
		                              tmp = Companion_instance_109.y12();
		                            } else {
		                              if (type === 'rtc:answer') {
		                                tmp = Companion_instance_97.y12();
		                              } else {
		                                if (type === 'rtc:hangup') {
		                                  tmp = Companion_instance_92.y12();
		                                } else {
		                                  if (type === 'rtc:transfer') {
		                                    tmp = Companion_instance_93.y12();
		                                  } else {
		                                    if (type === 'audio:say') {
		                                      tmp = Companion_instance_84.y12();
		                                    } else {
		                                      if (type === 'audio:say:done') {
		                                        tmp = Companion_instance_110.y12();
		                                      } else {
		                                        if (type === 'audio:mute:on') {
		                                          tmp = Companion_instance_87.y12();
		                                        } else {
		                                          if (type === 'audio:mute:off') {
		                                            tmp = Companion_instance_88.y12();
		                                          } else {
		                                            if (type === 'audio:earmuff:on') {
		                                              tmp = Companion_instance_89.y12();
		                                            } else {
		                                              if (type === 'audio:earmuff:off') {
		                                                tmp = Companion_instance_90.y12();
		                                              } else {
		                                                if (type === 'audio:dtmf') {
		                                                  tmp = Companion_instance_91.y12();
		                                                } else {
		                                                  if (type === 'leg:status:update') {
		                                                    tmp = Companion_instance_85.y12();
		                                                  } else {
		                                                    if (type === 'session:update-token:success') {
		                                                      tmp = Companion_instance_133.y12();
		                                                    } else {
		                                                      if (type === 'session:logged-out') {
		                                                        tmp = Companion_instance_134.y12();
		                                                      } else {
		                                                        if (type === 'session:terminated') {
		                                                          tmp = Companion_instance_135.y12();
		                                                        } else {
		                                                          if (type === 'session:invalid') {
		                                                            tmp = Companion_instance_129.y12();
		                                                          } else {
		                                                            if (type === 'session:error:invalid') {
		                                                              tmp = Companion_instance_129.y12();
		                                                            } else {
		                                                              if (type === 'system:error:expired-token') {
		                                                                tmp = Companion_instance_130.y12();
		                                                              } else {
		                                                                switch (type) {
		                                                                  case 'system:error:invalid-token':
		                                                                  case 'user:error:invalid-user':
		                                                                    tmp = Companion_instance_128.y12();
		                                                                    break;
		                                                                  default:
		                                                                    if (type === 'session:error:max-open-sessions') {
		                                                                      tmp = Companion_instance_131.y12();
		                                                                    } else {
		                                                                      if (type === 'system:error:permission') {
		                                                                        tmp = Companion_instance_132.y12();
		                                                                      } else {
		                                                                        // Inline function 'kotlin.takeIf' call
		                                                                        // Inline function 'kotlin.contracts.contract' call
		                                                                        var tmp_0;
		                                                                        // Inline function 'com.vonage.clientcore.core.actions.SocketEventSerializer.selectDeserializer.<anonymous>' call
		                                                                        if (startsWith(type, CSConversationEventType_CUSTOM_getInstance().d1s_1)) {
		                                                                          tmp_0 = type;
		                                                                        } else {
		                                                                          tmp_0 = null;
		                                                                        }
		                                                                        if (type === tmp_0) {
		                                                                          tmp = Companion_instance_111.y12();
		                                                                        } else {
		                                                                          throw new IgnoredSerializerException(type);
		                                                                        }
		                                                                      }
		                                                                    }

		                                                                    break;
		                                                                }
		                                                              }
		                                                            }
		                                                          }
		                                                        }
		                                                      }
		                                                    }
		                                                  }
		                                                }
		                                              }
		                                            }
		                                          }
		                                        }
		                                      }
		                                    }
		                                  }
		                                }
		                              }
		                            }
		                          }
		                        }
		                      }
		                    }
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  };
		  var SocketEventSerializer_instance;
		  function SocketEventSerializer_getInstance() {
		    if (SocketEventSerializer_instance == null)
		      new SocketEventSerializer();
		    return SocketEventSerializer_instance;
		  }
		  function Companion_132() {
		  }
		  protoOf(Companion_132).y12 = function () {
		    return $serializer_getInstance_151();
		  };
		  var Companion_instance_133;
		  function Companion_getInstance_134() {
		    return Companion_instance_133;
		  }
		  function $serializer_151() {
		    $serializer_instance_151 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionUpdateTokenSuccessEvent', this, 5);
		    tmp0_serialDesc.pq('body', true);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.r2s_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_151).uf = function () {
		    return this.r2s_1;
		  };
		  protoOf($serializer_151).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [UnitSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_151).wf = function (decoder) {
		    var tmp0_desc = this.r2s_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionUpdateTokenSuccessEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_151).s2s = function (encoder, value) {
		    var tmp0_desc = this.r2s_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 0)) {
		      tmp = true;
		    } else {
		      tmp = !equals(Unit_instance, Unit_instance);
		    }
		    if (tmp) {
		      var tmp_0 = UnitSerializer_getInstance();
		      tmp1_output.vk(tmp0_desc, 0, tmp_0, Unit_instance);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.u2s_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.u2s_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.v2s_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.v2s_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.w2s_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.w2s_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.x2s_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_151).vf = function (encoder, value) {
		    return this.s2s(encoder, value instanceof SessionUpdateTokenSuccessEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_151;
		  function $serializer_getInstance_151() {
		    if ($serializer_instance_151 == null)
		      new $serializer_151();
		    return $serializer_instance_151;
		  }
		  function SessionUpdateTokenSuccessEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(16 === (16 & seen1))) {
		      throwMissingFieldException(seen1, 16, $serializer_getInstance_151().r2s_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.t2s_1 = Unit_instance;
		    else
		      $this.t2s_1 = body;
		    if (0 === (seen1 & 2))
		      $this.u2s_1 = null;
		    else
		      $this.u2s_1 = id;
		    if (0 === (seen1 & 4))
		      $this.v2s_1 = null;
		    else
		      $this.v2s_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.w2s_1 = null;
		    else
		      $this.w2s_1 = from;
		    $this.x2s_1 = type;
		    return $this;
		  }
		  function SessionUpdateTokenSuccessEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return SessionUpdateTokenSuccessEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(SessionUpdateTokenSuccessEvent)));
		  }
		  function SessionUpdateTokenSuccessEvent() {
		  }
		  protoOf(SessionUpdateTokenSuccessEvent).t27 = function () {
		    return this.u2s_1;
		  };
		  protoOf(SessionUpdateTokenSuccessEvent).u27 = function () {
		    return this.v2s_1;
		  };
		  protoOf(SessionUpdateTokenSuccessEvent).toString = function () {
		    return 'SessionUpdateTokenSuccessEvent(body=' + Unit_instance + ', id=' + this.u2s_1 + ', cid=' + this.v2s_1 + ', from=' + this.w2s_1 + ', type=' + this.x2s_1 + ')';
		  };
		  protoOf(SessionUpdateTokenSuccessEvent).hashCode = function () {
		    var result = hashCode(Unit_instance);
		    result = imul(result, 31) + (this.u2s_1 == null ? 0 : this.u2s_1) | 0;
		    result = imul(result, 31) + (this.v2s_1 == null ? 0 : getStringHashCode(this.v2s_1)) | 0;
		    result = imul(result, 31) + (this.w2s_1 == null ? 0 : getStringHashCode(this.w2s_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.x2s_1) | 0;
		    return result;
		  };
		  protoOf(SessionUpdateTokenSuccessEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionUpdateTokenSuccessEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionUpdateTokenSuccessEvent ? other : THROW_CCE();
		    if (!equals(Unit_instance, Unit_instance))
		      return false;
		    if (!(this.u2s_1 == tmp0_other_with_cast.u2s_1))
		      return false;
		    if (!(this.v2s_1 == tmp0_other_with_cast.v2s_1))
		      return false;
		    if (!(this.w2s_1 == tmp0_other_with_cast.w2s_1))
		      return false;
		    if (!(this.x2s_1 === tmp0_other_with_cast.x2s_1))
		      return false;
		    return true;
		  };
		  function Companion_133() {
		  }
		  protoOf(Companion_133).y12 = function () {
		    return $serializer_getInstance_152();
		  };
		  var Companion_instance_134;
		  function Companion_getInstance_135() {
		    return Companion_instance_134;
		  }
		  function $serializer_152() {
		    $serializer_instance_152 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionLogoutSuccessEvent', this, 5);
		    tmp0_serialDesc.pq('body', true);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.y2s_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_152).uf = function () {
		    return this.y2s_1;
		  };
		  protoOf($serializer_152).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [UnitSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_152).wf = function (decoder) {
		    var tmp0_desc = this.y2s_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionLogoutSuccessEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_152).z2s = function (encoder, value) {
		    var tmp0_desc = this.y2s_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 0)) {
		      tmp = true;
		    } else {
		      tmp = !equals(Unit_instance, Unit_instance);
		    }
		    if (tmp) {
		      var tmp_0 = UnitSerializer_getInstance();
		      tmp1_output.vk(tmp0_desc, 0, tmp_0, Unit_instance);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.b2t_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.b2t_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.c2t_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.c2t_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.d2t_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.d2t_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.e2t_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_152).vf = function (encoder, value) {
		    return this.z2s(encoder, value instanceof SessionLogoutSuccessEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_152;
		  function $serializer_getInstance_152() {
		    if ($serializer_instance_152 == null)
		      new $serializer_152();
		    return $serializer_instance_152;
		  }
		  function SessionLogoutSuccessEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(16 === (16 & seen1))) {
		      throwMissingFieldException(seen1, 16, $serializer_getInstance_152().y2s_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.a2t_1 = Unit_instance;
		    else
		      $this.a2t_1 = body;
		    if (0 === (seen1 & 2))
		      $this.b2t_1 = null;
		    else
		      $this.b2t_1 = id;
		    if (0 === (seen1 & 4))
		      $this.c2t_1 = null;
		    else
		      $this.c2t_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.d2t_1 = null;
		    else
		      $this.d2t_1 = from;
		    $this.e2t_1 = type;
		    return $this;
		  }
		  function SessionLogoutSuccessEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return SessionLogoutSuccessEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(SessionLogoutSuccessEvent)));
		  }
		  function SessionLogoutSuccessEvent() {
		  }
		  protoOf(SessionLogoutSuccessEvent).t27 = function () {
		    return this.b2t_1;
		  };
		  protoOf(SessionLogoutSuccessEvent).u27 = function () {
		    return this.c2t_1;
		  };
		  protoOf(SessionLogoutSuccessEvent).toString = function () {
		    return 'SessionLogoutSuccessEvent(body=' + Unit_instance + ', id=' + this.b2t_1 + ', cid=' + this.c2t_1 + ', from=' + this.d2t_1 + ', type=' + this.e2t_1 + ')';
		  };
		  protoOf(SessionLogoutSuccessEvent).hashCode = function () {
		    var result = hashCode(Unit_instance);
		    result = imul(result, 31) + (this.b2t_1 == null ? 0 : this.b2t_1) | 0;
		    result = imul(result, 31) + (this.c2t_1 == null ? 0 : getStringHashCode(this.c2t_1)) | 0;
		    result = imul(result, 31) + (this.d2t_1 == null ? 0 : getStringHashCode(this.d2t_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.e2t_1) | 0;
		    return result;
		  };
		  protoOf(SessionLogoutSuccessEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionLogoutSuccessEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionLogoutSuccessEvent ? other : THROW_CCE();
		    if (!equals(Unit_instance, Unit_instance))
		      return false;
		    if (!(this.b2t_1 == tmp0_other_with_cast.b2t_1))
		      return false;
		    if (!(this.c2t_1 == tmp0_other_with_cast.c2t_1))
		      return false;
		    if (!(this.d2t_1 == tmp0_other_with_cast.d2t_1))
		      return false;
		    if (!(this.e2t_1 === tmp0_other_with_cast.e2t_1))
		      return false;
		    return true;
		  };
		  function Companion_134() {
		  }
		  protoOf(Companion_134).y12 = function () {
		    return $serializer_getInstance_153();
		  };
		  var Companion_instance_135;
		  function Companion_getInstance_136() {
		    return Companion_instance_135;
		  }
		  function $serializer_153() {
		    $serializer_instance_153 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.actions.SessionTerminatedEvent', this, 5);
		    tmp0_serialDesc.pq('body', true);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('cid', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('type', false);
		    this.f2t_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_153).uf = function () {
		    return this.f2t_1;
		  };
		  protoOf($serializer_153).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [UnitSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_153).wf = function (decoder) {
		    var tmp0_desc = this.f2t_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_input = decoder.ej(tmp0_desc);
		    if (tmp9_input.uj()) {
		      tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp9_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp9_input.qj(tmp0_desc, 0, UnitSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp9_input.sj(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp9_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp9_input.sj(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp9_input.oj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp9_input.fj(tmp0_desc);
		    return SessionTerminatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
		  };
		  protoOf($serializer_153).g2t = function (encoder, value) {
		    var tmp0_desc = this.f2t_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp;
		    if (tmp1_output.bl(tmp0_desc, 0)) {
		      tmp = true;
		    } else {
		      tmp = !equals(Unit_instance, Unit_instance);
		    }
		    if (tmp) {
		      var tmp_0 = UnitSerializer_getInstance();
		      tmp1_output.vk(tmp0_desc, 0, tmp_0, Unit_instance);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.i2t_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, IntSerializer_getInstance(), value.i2t_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.j2t_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.j2t_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.k2t_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, StringSerializer_getInstance(), value.k2t_1);
		    }
		    tmp1_output.tk(tmp0_desc, 4, value.l2t_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_153).vf = function (encoder, value) {
		    return this.g2t(encoder, value instanceof SessionTerminatedEvent ? value : THROW_CCE());
		  };
		  var $serializer_instance_153;
		  function $serializer_getInstance_153() {
		    if ($serializer_instance_153 == null)
		      new $serializer_153();
		    return $serializer_instance_153;
		  }
		  function SessionTerminatedEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, $this) {
		    if (!(16 === (16 & seen1))) {
		      throwMissingFieldException(seen1, 16, $serializer_getInstance_153().f2t_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.h2t_1 = Unit_instance;
		    else
		      $this.h2t_1 = body;
		    if (0 === (seen1 & 2))
		      $this.i2t_1 = null;
		    else
		      $this.i2t_1 = id;
		    if (0 === (seen1 & 4))
		      $this.j2t_1 = null;
		    else
		      $this.j2t_1 = cid;
		    if (0 === (seen1 & 8))
		      $this.k2t_1 = null;
		    else
		      $this.k2t_1 = from;
		    $this.l2t_1 = type;
		    return $this;
		  }
		  function SessionTerminatedEvent_init_$Create$(seen1, body, id, cid, from, type, serializationConstructorMarker) {
		    return SessionTerminatedEvent_init_$Init$(seen1, body, id, cid, from, type, serializationConstructorMarker, objectCreate(protoOf(SessionTerminatedEvent)));
		  }
		  function SessionTerminatedEvent() {
		  }
		  protoOf(SessionTerminatedEvent).t27 = function () {
		    return this.i2t_1;
		  };
		  protoOf(SessionTerminatedEvent).u27 = function () {
		    return this.j2t_1;
		  };
		  protoOf(SessionTerminatedEvent).toString = function () {
		    return 'SessionTerminatedEvent(body=' + Unit_instance + ', id=' + this.i2t_1 + ', cid=' + this.j2t_1 + ', from=' + this.k2t_1 + ', type=' + this.l2t_1 + ')';
		  };
		  protoOf(SessionTerminatedEvent).hashCode = function () {
		    var result = hashCode(Unit_instance);
		    result = imul(result, 31) + (this.i2t_1 == null ? 0 : this.i2t_1) | 0;
		    result = imul(result, 31) + (this.j2t_1 == null ? 0 : getStringHashCode(this.j2t_1)) | 0;
		    result = imul(result, 31) + (this.k2t_1 == null ? 0 : getStringHashCode(this.k2t_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.l2t_1) | 0;
		    return result;
		  };
		  protoOf(SessionTerminatedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionTerminatedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionTerminatedEvent ? other : THROW_CCE();
		    if (!equals(Unit_instance, Unit_instance))
		      return false;
		    if (!(this.i2t_1 == tmp0_other_with_cast.i2t_1))
		      return false;
		    if (!(this.j2t_1 == tmp0_other_with_cast.j2t_1))
		      return false;
		    if (!(this.k2t_1 == tmp0_other_with_cast.k2t_1))
		      return false;
		    if (!(this.l2t_1 === tmp0_other_with_cast.l2t_1))
		      return false;
		    return true;
		  };
		  function SocketConnectionStatus_Disconnected_getInstance() {
		    SocketConnectionStatus_initEntries();
		    return SocketConnectionStatus_Disconnected_instance;
		  }
		  function SocketConnectionStatus_Reconnecting_getInstance() {
		    SocketConnectionStatus_initEntries();
		    return SocketConnectionStatus_Reconnecting_instance;
		  }
		  function SocketConnectionStatus_Connected_getInstance() {
		    SocketConnectionStatus_initEntries();
		    return SocketConnectionStatus_Connected_instance;
		  }
		  function SocketConnectionFailedReason_ServerDisconnected_getInstance() {
		    SocketConnectionFailedReason_initEntries();
		    return SocketConnectionFailedReason_ServerDisconnected_instance;
		  }
		  function SocketConnectionFailedReason_ClientDisconnected_getInstance() {
		    SocketConnectionFailedReason_initEntries();
		    return SocketConnectionFailedReason_ClientDisconnected_instance;
		  }
		  function SocketConnectionFailedReason_ClientNetworkError_getInstance() {
		    SocketConnectionFailedReason_initEntries();
		    return SocketConnectionFailedReason_ClientNetworkError_instance;
		  }
		  function SocketConnectionFailedReason_PingTimeout_getInstance() {
		    SocketConnectionFailedReason_initEntries();
		    return SocketConnectionFailedReason_PingTimeout_instance;
		  }
		  function ChatAPI() {
		  }
		  function ChatAPIImpl$o$onConversationEvent$lambda(this$0, $event) {
		    return function (memberResponse) {
		      var tmp;
		      if (memberResponse instanceof GetMember) {
		        this$0.m2t_1.a1g(Action_init_$Create$(new PostConversationEventRequest($event.o2t(), memberResponse.e1r_1, CSConversationEventType_MESSAGE_DELIVERED_getInstance(), new UpdateEventStateRequestBody($event.t27()))));
		        tmp = Unit_instance;
		      } else {
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function buildMessageEventBody($this, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template) {
		    var tmp;
		    if (text == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		      tmp = new TextBody(text);
		    }
		    var tmp2_elvis_lhs = tmp;
		    var tmp_0;
		    if (tmp2_elvis_lhs == null) {
		      var tmp_1;
		      if (imageUrl == null) {
		        tmp_1 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		        tmp_1 = new ImageBody(new UrlObject(imageUrl));
		      }
		      tmp_0 = tmp_1;
		    } else {
		      tmp_0 = tmp2_elvis_lhs;
		    }
		    var tmp4_elvis_lhs = tmp_0;
		    var tmp_2;
		    if (tmp4_elvis_lhs == null) {
		      var tmp_3;
		      if (videoUrl == null) {
		        tmp_3 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		        tmp_3 = new VideoBody(new UrlObject(videoUrl));
		      }
		      tmp_2 = tmp_3;
		    } else {
		      tmp_2 = tmp4_elvis_lhs;
		    }
		    var tmp6_elvis_lhs = tmp_2;
		    var tmp_4;
		    if (tmp6_elvis_lhs == null) {
		      var tmp_5;
		      if (audioUrl == null) {
		        tmp_5 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		        tmp_5 = new AudioBody(new UrlObject(audioUrl));
		      }
		      tmp_4 = tmp_5;
		    } else {
		      tmp_4 = tmp6_elvis_lhs;
		    }
		    var tmp8_elvis_lhs = tmp_4;
		    var tmp_6;
		    if (tmp8_elvis_lhs == null) {
		      var tmp_7;
		      if (fileUrl == null) {
		        tmp_7 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		        tmp_7 = new FileBody(new UrlObject(fileUrl));
		      }
		      tmp_6 = tmp_7;
		    } else {
		      tmp_6 = tmp8_elvis_lhs;
		    }
		    var tmp10_elvis_lhs = tmp_6;
		    var tmp_8;
		    if (tmp10_elvis_lhs == null) {
		      var tmp_9;
		      if (vCardUrl == null) {
		        tmp_9 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		        tmp_9 = new VCardBody(new UrlObject(vCardUrl));
		      }
		      tmp_8 = tmp_9;
		    } else {
		      tmp_8 = tmp10_elvis_lhs;
		    }
		    var tmp12_elvis_lhs = tmp_8;
		    var tmp_10;
		    if (tmp12_elvis_lhs == null) {
		      var tmp_11;
		      if (customBody == null) {
		        tmp_11 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		        tmp_11 = new CustomBody(get_jsonObject(Default_getInstance().e11(customBody)));
		      }
		      tmp_10 = tmp_11;
		    } else {
		      tmp_10 = tmp12_elvis_lhs;
		    }
		    var tmp14_elvis_lhs = tmp_10;
		    var tmp_12;
		    if (tmp14_elvis_lhs == null) {
		      var tmp_13;
		      if (location == null) {
		        tmp_13 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		        tmp_13 = Companion_instance_120.f2l(location);
		      }
		      tmp_12 = tmp_13;
		    } else {
		      tmp_12 = tmp14_elvis_lhs;
		    }
		    var tmp16_elvis_lhs = tmp_12;
		    var tmp_14;
		    if (tmp16_elvis_lhs == null) {
		      var tmp_15;
		      if (template == null) {
		        tmp_15 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.buildMessageEventBody.<anonymous>' call
		        tmp_15 = Companion_instance_119.z2k(template);
		      }
		      tmp_14 = tmp_15;
		    } else {
		      tmp_14 = tmp16_elvis_lhs;
		    }
		    return tmp_14;
		  }
		  function ChatAPIImpl$1(this$0) {
		    this.p2t_1 = this$0;
		  }
		  protoOf(ChatAPIImpl$1).q2t = function (event) {
		    var tmp0_safe_receiver = this.p2t_1.n2t_1;
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      tmp0_safe_receiver.q2t(event);
		    }
		    if (isInterface(event, MessageEvent_0)) {
		      var tmp = new GetMyMemberRequest(event.o2t());
		      this.p2t_1.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$o$onConversationEvent$lambda(this.p2t_1, event))));
		    }
		  };
		  function ChatAPIImpl$createConversation$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof ConversationCreate) {
		        tmp = $callback(null, it.v1s_1);
		      } else {
		        invokeCallbackWithError(it, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$updateConversation$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof GetConversation) {
		        tmp = $callback(null, Companion_instance_141.y2t(response));
		      } else {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$joinConversation$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof ConversationJoin) {
		        tmp = $callback(null, it.o1u_1);
		      } else {
		        invokeCallbackWithError(it, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$inviteToConversation$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof ConversationInvite) {
		        tmp = $callback(null, it.p1v_1);
		      } else {
		        invokeCallbackWithError(it, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$leaveConversation$lambda$lambda($callback) {
		    return function (memberKickResponse) {
		      var tmp;
		      if (memberKickResponse instanceof MemberLeft) {
		        tmp = $callback(null);
		      } else {
		        invokeCallbackWithError_0(memberKickResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$leaveConversation$lambda(this$0, $cid, $callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof GetMember) {
		        var tmp_0 = new MemberKickRequest($cid, it.e1r_1);
		        this$0.m2t_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, VOID, ChatAPIImpl$leaveConversation$lambda$lambda($callback))));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$deleteConversation$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof ConversationDelete) {
		        tmp = $callback(null);
		      } else {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$getConversations$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof GetUserConversations) {
		        // Inline function 'kotlin.collections.map' call
		        var this_0 = response.k1w_1.h1w_1;
		        // Inline function 'kotlin.collections.mapTo' call
		        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
		        var tmp0_iterator = this_0.p();
		        while (tmp0_iterator.q()) {
		          var item = tmp0_iterator.s();
		          // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.getConversations.<anonymous>.<anonymous>' call
		          var tmp$ret$0 = Companion_instance_141.y2t(item);
		          destination.m(tmp$ret$0);
		        }
		        var conversations = destination;
		        var tmp1_safe_receiver = response.l1w_1.y1k_1;
		        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u1k_1;
		        var previous = tmp2_safe_receiver == null ? null : getCursor(tmp2_safe_receiver);
		        var tmp3_safe_receiver = response.l1w_1.x1k_1;
		        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.u1k_1;
		        var next = tmp4_safe_receiver == null ? null : getCursor(tmp4_safe_receiver);
		        var page = new ConversationsPage(conversations, previous, next);
		        tmp = $callback(null, page);
		      } else {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$getConversationEvents$lambda($cid, $callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof GetConversationEvents) {
		        // Inline function 'kotlin.collections.map' call
		        var this_0 = response.d1x_1.a1x_1;
		        // Inline function 'kotlin.collections.mapTo' call
		        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
		        var tmp0_iterator = this_0.p();
		        while (tmp0_iterator.q()) {
		          var item = tmp0_iterator.s();
		          // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.getConversationEvents.<anonymous>.<anonymous>' call
		          var tmp$ret$0 = item.d24($cid);
		          destination.m(tmp$ret$0);
		        }
		        var events = destination;
		        var tmp1_safe_receiver = response.e1x_1.y1k_1;
		        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u1k_1;
		        var previous = tmp2_safe_receiver == null ? null : getCursor(tmp2_safe_receiver);
		        var tmp3_safe_receiver = response.e1x_1.x1k_1;
		        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.u1k_1;
		        var next = tmp4_safe_receiver == null ? null : getCursor(tmp4_safe_receiver);
		        var page = new EventsPage(events, previous, next);
		        tmp = $callback(null, page);
		      } else {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$getConversationMembers$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof GetConversationMembers) {
		        // Inline function 'kotlin.collections.map' call
		        var this_0 = response.r1x_1.o1x_1;
		        // Inline function 'kotlin.collections.mapTo' call
		        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
		        var tmp0_iterator = this_0.p();
		        while (tmp0_iterator.q()) {
		          var item = tmp0_iterator.s();
		          // Inline function 'com.vonage.clientcore.core.api.ChatAPIImpl.getConversationMembers.<anonymous>.<anonymous>' call
		          var tmp$ret$0 = Companion_instance_145.z2t(item);
		          destination.m(tmp$ret$0);
		        }
		        var members = destination;
		        var tmp1_safe_receiver = response.s1x_1.y1k_1;
		        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u1k_1;
		        var previous = tmp2_safe_receiver == null ? null : getCursor(tmp2_safe_receiver);
		        var tmp3_safe_receiver = response.s1x_1.x1k_1;
		        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.u1k_1;
		        var next = tmp4_safe_receiver == null ? null : getCursor(tmp4_safe_receiver);
		        var page = new MembersPage(members, previous, next);
		        tmp = $callback(null, page);
		      } else {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$getConversationMember$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof GetMember) {
		        var tmp1_safe_receiver = response.g1r_1;
		        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a1r_1;
		        var user = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.g1y();
		        tmp = $callback(null, new Member(response.e1r_1, response.f1r_1, user, response.h1r_1, response.i1r_1));
		      } else {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$sendMessageEvent$lambda$lambda($callback) {
		    return function (postEventResponse) {
		      var tmp;
		      if (postEventResponse instanceof PostConversationEvent) {
		        tmp = $callback(null, postEventResponse.j1y_1);
		      } else {
		        invokeCallbackWithError(postEventResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$sendMessageEvent$lambda(this$0, $text, $imageUrl, $videoUrl, $audioUrl, $fileUrl, $vCardUrl, $customBody, $location, $template, $callback, $cid) {
		    return function (memberResponse) {
		      var tmp;
		      if (memberResponse instanceof GetMember) {
		        var tmp_0;
		        try {
		          var tmp1_elvis_lhs = buildMessageEventBody(this$0, $text, $imageUrl, $videoUrl, $audioUrl, $fileUrl, $vCardUrl, $customBody, $location, $template);
		          var tmp_1;
		          if (tmp1_elvis_lhs == null) {
		            // Inline function 'kotlin.run' call
		            // Inline function 'kotlin.contracts.contract' call
		            var message = 'At least one between text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl or customBody must be provided.';
		            invokeCallbackWithError(new IllegalArgumentException_0(message), $callback);
		            return Unit_instance;
		          } else {
		            tmp_1 = tmp1_elvis_lhs;
		          }
		          tmp_0 = tmp_1;
		        } catch ($p) {
		          var tmp_2;
		          if ($p instanceof IllegalArgumentException) {
		            var error = $p;
		            invokeCallbackWithError(new IllegalArgumentException_0(VOID, error), $callback);
		            return Unit_instance;
		          } else {
		            throw $p;
		          }
		        }
		        var body = tmp_0;
		        var tmp_3 = new PostConversationEventRequest($cid, memberResponse.e1r_1, CSConversationEventType_MESSAGE_getInstance(), body);
		        this$0.m2t_1.a1g(new Action_0(tmp_3, new ActionMeta(VOID, VOID, ChatAPIImpl$sendMessageEvent$lambda$lambda($callback))));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError(memberResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$sendEphemeralEvent$lambda$lambda($callback) {
		    return function (postEventResponse) {
		      var tmp;
		      if (postEventResponse instanceof PostConversationEvent) {
		        tmp = $callback(null, postEventResponse.j1y_1);
		      } else {
		        invokeCallbackWithError(postEventResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$sendEphemeralEvent$lambda($customData, $callback, this$0, $cid) {
		    return function (memberResponse) {
		      var tmp;
		      if (memberResponse instanceof GetMember) {
		        var tmp_0;
		        try {
		          var jsonObject = get_jsonObject(Default_getInstance().e11($customData));
		          tmp_0 = new CSConversationEventJsonBody(jsonObject);
		        } catch ($p) {
		          var tmp_1;
		          if ($p instanceof IllegalArgumentException) {
		            var error = $p;
		            invokeCallbackWithError(new IllegalArgumentException_0(VOID, error), $callback);
		            return Unit_instance;
		          } else {
		            throw $p;
		          }
		        }
		        var body = tmp_0;
		        var tmp_2 = new PostConversationEventRequest($cid, memberResponse.e1r_1, CSConversationEventType_EPHEMERAL_getInstance(), body);
		        this$0.m2t_1.a1g(new Action_0(tmp_2, new ActionMeta(VOID, VOID, ChatAPIImpl$sendEphemeralEvent$lambda$lambda($callback))));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError(memberResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$sendCustomEvent$lambda$lambda($callback) {
		    return function (postEventResponse) {
		      var tmp;
		      if (postEventResponse instanceof PostConversationEvent) {
		        tmp = $callback(null, postEventResponse.j1y_1);
		      } else {
		        invokeCallbackWithError(postEventResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$sendCustomEvent$lambda($customData, $callback, $eventType, this$0, $cid) {
		    return function (memberResponse) {
		      var tmp;
		      if (memberResponse instanceof GetMember) {
		        var tmp_0;
		        try {
		          var jsonObject = get_jsonObject(Default_getInstance().e11($customData));
		          tmp_0 = new CSConversationEventJsonBody(jsonObject);
		        } catch ($p) {
		          var tmp_1;
		          if ($p instanceof IllegalArgumentException) {
		            var error = $p;
		            invokeCallbackWithError(new IllegalArgumentException_0(VOID, error), $callback);
		            return Unit_instance;
		          } else {
		            throw $p;
		          }
		        }
		        var body = tmp_0;
		        var typeCustom = CSConversationEventType_CUSTOM_getInstance();
		        typeCustom.d1s_1 = $eventType;
		        var tmp_2 = new PostConversationEventRequest($cid, memberResponse.e1r_1, typeCustom, body);
		        this$0.m2t_1.a1g(new Action_0(tmp_2, new ActionMeta(VOID, VOID, ChatAPIImpl$sendCustomEvent$lambda$lambda($callback))));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError(memberResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$deleteEvent$lambda$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof DeleteConversationEvent) {
		        tmp = $callback(null);
		      } else {
		        invokeCallbackWithError_0(response, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$deleteEvent$lambda(this$0, $id, $cid, $callback) {
		    return function (memberResponse) {
		      var tmp;
		      if (memberResponse instanceof GetMember) {
		        var tmp_0 = new DeleteConversationEventRequest($id, $cid, memberResponse.e1r_1);
		        this$0.m2t_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, VOID, ChatAPIImpl$deleteEvent$lambda$lambda($callback))));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError_0(memberResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$sendMessageSeenEvent$lambda$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof PostConversationEvent) {
		        tmp = $callback(null, response.j1y_1);
		      } else {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl$sendMessageSeenEvent$lambda(this$0, $cid, $id, $callback) {
		    return function (memberResponse) {
		      var tmp;
		      if (memberResponse instanceof GetMember) {
		        var tmp_0 = new PostConversationEventRequest($cid, memberResponse.e1r_1, CSConversationEventType_MESSAGE_SEEN_getInstance(), new UpdateEventStateRequestBody($id));
		        this$0.m2t_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, VOID, ChatAPIImpl$sendMessageSeenEvent$lambda$lambda($callback))));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError(memberResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function ChatAPIImpl(store, events) {
		    this.m2t_1 = store;
		    this.n2t_1 = null;
		    events.w1f(new ChatAPIImpl$1(this));
		  }
		  protoOf(ChatAPIImpl).r1d = function (_set____db54di) {
		    this.n2t_1 = _set____db54di;
		  };
		  protoOf(ChatAPIImpl).e1f = function (parameters, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp;
		    try {
		      var tmp_0 = parameters == null ? null : parameters.a2u_1;
		      var tmp_1 = parameters == null ? null : parameters.b2u_1;
		      var tmp_2 = parameters == null ? null : parameters.c2u_1;
		      tmp = new CreateConversationRequest(tmp_0, tmp_1, tmp_2, parameters == null ? null : parameters.g2u());
		    } catch ($p) {
		      var tmp_3;
		      if ($p instanceof IllegalArgumentException) {
		        var error = $p;
		        invokeCallbackWithError(new IllegalArgumentException_0(VOID, error), callback);
		        return Unit_instance;
		      } else {
		        throw $p;
		      }
		    }
		    var createConversationRequest = tmp;
		    this.m2t_1.a1g(new Action_0(createConversationRequest, new ActionMeta(VOID, VOID, ChatAPIImpl$createConversation$lambda(callback))));
		  };
		  protoOf(ChatAPIImpl).s1f = function (conversationId, parameters, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp;
		    try {
		      tmp = new UpdateConversationRequest(conversationId, parameters.h2u_1, parameters.i2u_1, parameters.j2u_1, parameters.g2u());
		    } catch ($p) {
		      var tmp_0;
		      if ($p instanceof IllegalArgumentException) {
		        var error = $p;
		        invokeCallbackWithError(new IllegalArgumentException_0(VOID, error), callback);
		        return Unit_instance;
		      } else {
		        throw $p;
		      }
		    }
		    var updateConversationRequest = tmp;
		    this.m2t_1.a1g(new Action_0(updateConversationRequest, new ActionMeta(VOID, VOID, ChatAPIImpl$updateConversation$lambda(callback))));
		  };
		  protoOf(ChatAPIImpl).m1f = function (cid, callback) {
		    var tmp0_elvis_lhs = getSessionUserOrError(this.m2t_1, callback);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return Unit_instance;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var user = tmp;
		    var tmp_0 = new ConversationJoinRequest(cid, user.n2u_1, user.o2u_1);
		    this.m2t_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, VOID, ChatAPIImpl$joinConversation$lambda(callback))));
		  };
		  protoOf(ChatAPIImpl).l1f = function (cid, username, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new ConversationInviteRequest(cid, username);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$inviteToConversation$lambda(callback))));
		  };
		  protoOf(ChatAPIImpl).n1f = function (cid, callback) {
		    if (getSessionUserOrError_0(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new GetMyMemberRequest(cid);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$leaveConversation$lambda(this, cid, callback))));
		  };
		  protoOf(ChatAPIImpl).f1f = function (cid, callback) {
		    if (getSessionUserOrError_0(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new ConversationDeleteRequest(cid);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$deleteConversation$lambda(callback))));
		  };
		  protoOf(ChatAPIImpl).k1f = function (parameters, callback) {
		    var tmp0_elvis_lhs = getSessionUserOrError(this.m2t_1, callback);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return Unit_instance;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var user = tmp;
		    var tmp_0 = user.n2u_1;
		    var tmp_1 = parameters == null ? null : parameters.p2u_1;
		    var tmp_2 = parameters == null ? null : parameters.q2u_1;
		    var tmp_3 = parameters == null ? null : parameters.r2u_1;
		    var tmp_4 = parameters == null ? null : parameters.s2u_1;
		    var tmp_5 = new GetUserConversationsRequest(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, parameters == null ? null : parameters.t2u_1);
		    this.m2t_1.a1g(new Action_0(tmp_5, new ActionMeta(VOID, VOID, ChatAPIImpl$getConversations$lambda(callback))));
		  };
		  protoOf(ChatAPIImpl).h1f = function (cid, parameters, filterGroup, filterGroupVersion, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = parameters == null ? null : parameters.u2u_1;
		    var tmp_0 = parameters == null ? null : parameters.v2u_1;
		    var tmp_1 = parameters == null ? null : parameters.w2u_1;
		    var tmp5_safe_receiver = parameters == null ? null : parameters.x2u_1;
		    var tmp_2 = tmp5_safe_receiver == null ? null : joinToString(tmp5_safe_receiver, ',');
		    var tmp7_elvis_lhs = parameters == null ? null : parameters.y2u_1;
		    var tmp_3;
		    if (tmp7_elvis_lhs == null) {
		      tmp_3 = false;
		    } else {
		      tmp_3 = tmp7_elvis_lhs;
		    }
		    var tmp_4 = !tmp_3;
		    var tmp_5 = new GetConversationEventsRequest(cid, tmp, tmp_0, tmp_1, filterGroup, filterGroupVersion, tmp_2, tmp_4, parameters == null ? null : parameters.z2u_1);
		    this.m2t_1.a1g(new Action_0(tmp_5, new ActionMeta(VOID, VOID, ChatAPIImpl$getConversationEvents$lambda(cid, callback))));
		  };
		  protoOf(ChatAPIImpl).j1f = function (cid, parameters, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = parameters == null ? null : parameters.a2v_1;
		    var tmp_0 = parameters == null ? null : parameters.b2v_1;
		    var tmp_1 = new GetConversationMembersRequest(cid, tmp, tmp_0, parameters == null ? null : parameters.c2v_1);
		    this.m2t_1.a1g(new Action_0(tmp_1, new ActionMeta(VOID, VOID, ChatAPIImpl$getConversationMembers$lambda(callback))));
		  };
		  protoOf(ChatAPIImpl).i1f = function (cid, mid, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new GetConversationMemberRequest(cid, mid);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$getConversationMember$lambda(callback))));
		  };
		  protoOf(ChatAPIImpl).q1f = function (cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new GetMyMemberRequest(cid);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$sendMessageEvent$lambda(this, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callback, cid))));
		  };
		  protoOf(ChatAPIImpl).p1f = function (cid, customData, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new GetMyMemberRequest(cid);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$sendEphemeralEvent$lambda(customData, callback, this, cid))));
		  };
		  protoOf(ChatAPIImpl).o1f = function (cid, eventType, customData, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new GetMyMemberRequest(cid);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$sendCustomEvent$lambda(customData, callback, eventType, this, cid))));
		  };
		  protoOf(ChatAPIImpl).g1f = function (id, cid, callback) {
		    if (getSessionUserOrError_0(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new GetMyMemberRequest(cid);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$deleteEvent$lambda(this, id, cid, callback))));
		  };
		  protoOf(ChatAPIImpl).r1f = function (id, cid, callback) {
		    if (getSessionUserOrError(this.m2t_1, callback) == null)
		      return Unit_instance;
		    var tmp = new GetMyMemberRequest(cid);
		    this.m2t_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ChatAPIImpl$sendMessageSeenEvent$lambda(this, cid, id, callback))));
		  };
		  var LoggingLevel_Verbose_instance;
		  var LoggingLevel_Debug_instance;
		  var LoggingLevel_Info_instance;
		  var LoggingLevel_Warn_instance;
		  var LoggingLevel_Error_instance;
		  var LoggingLevel_Assert_instance;
		  function valueOf_1(value) {
		    switch (value) {
		      case 'Verbose':
		        return LoggingLevel_Verbose_getInstance();
		      case 'Debug':
		        return LoggingLevel_Debug_getInstance();
		      case 'Info':
		        return LoggingLevel_Info_getInstance();
		      case 'Warn':
		        return LoggingLevel_Warn_getInstance();
		      case 'Error':
		        return LoggingLevel_Error_getInstance();
		      case 'Assert':
		        return LoggingLevel_Assert_getInstance();
		      default:
		        LoggingLevel_initEntries();
		        THROW_IAE('No enum constant value.');
		        break;
		    }
		  }
		  var LoggingLevel_entriesInitialized;
		  function LoggingLevel_initEntries() {
		    if (LoggingLevel_entriesInitialized)
		      return Unit_instance;
		    LoggingLevel_entriesInitialized = true;
		    LoggingLevel_Verbose_instance = new LoggingLevel('Verbose', 0, 'Verbose');
		    LoggingLevel_Debug_instance = new LoggingLevel('Debug', 1, 'Debug');
		    LoggingLevel_Info_instance = new LoggingLevel('Info', 2, 'Info');
		    LoggingLevel_Warn_instance = new LoggingLevel('Warn', 3, 'Warn');
		    LoggingLevel_Error_instance = new LoggingLevel('Error', 4, 'Error');
		    LoggingLevel_Assert_instance = new LoggingLevel('Assert', 5, 'Assert');
		  }
		  function LoggingLevel(name, ordinal, sev) {
		    Enum.call(this, name, ordinal);
		    this.f2v_1 = sev;
		  }
		  var ClientConfigRegion_AP_instance;
		  var ClientConfigRegion_EU_instance;
		  var ClientConfigRegion_US_instance;
		  var ClientConfigRegion_entriesInitialized;
		  function ClientConfigRegion_initEntries() {
		    if (ClientConfigRegion_entriesInitialized)
		      return Unit_instance;
		    ClientConfigRegion_entriesInitialized = true;
		    ClientConfigRegion_AP_instance = new ClientConfigRegion('AP', 0, 'https://api-ap.vonage.com', 'https://ws-ap.vonage.com');
		    ClientConfigRegion_EU_instance = new ClientConfigRegion('EU', 1, 'https://api-eu.vonage.com', 'https://ws-eu.vonage.com');
		    ClientConfigRegion_US_instance = new ClientConfigRegion('US', 2, 'https://api-us.vonage.com', 'https://ws-us.vonage.com');
		  }
		  function ClientConfigRegion(name, ordinal, apiUrl, websocketUrl) {
		    Enum.call(this, name, ordinal);
		    this.i2v_1 = apiUrl;
		    this.j2v_1 = websocketUrl;
		  }
		  function DefaultConfig() {
		    DefaultConfig_instance = this;
		    this.k2v_1 = '/v2/rtc';
		    this.l2v_1 = false;
		    this.m2v_1 = true;
		    this.n2v_1 = true;
		    this.o2v_1 = false;
		    this.p2v_1 = ClientConfigRegion_US_getInstance();
		    this.q2v_1 = LoggingLevel_Error_getInstance();
		  }
		  var DefaultConfig_instance;
		  function DefaultConfig_getInstance() {
		    if (DefaultConfig_instance == null)
		      new DefaultConfig();
		    return DefaultConfig_instance;
		  }
		  function Companion_135() {
		    Companion_instance_136 = this;
		    this.r2v_1 = DefaultConfig_getInstance().q2v_1;
		  }
		  var Companion_instance_136;
		  function Companion_getInstance_137() {
		    if (Companion_instance_136 == null)
		      new Companion_135();
		    return Companion_instance_136;
		  }
		  function LoggingLevel_Verbose_getInstance() {
		    LoggingLevel_initEntries();
		    return LoggingLevel_Verbose_instance;
		  }
		  function LoggingLevel_Debug_getInstance() {
		    LoggingLevel_initEntries();
		    return LoggingLevel_Debug_instance;
		  }
		  function LoggingLevel_Info_getInstance() {
		    LoggingLevel_initEntries();
		    return LoggingLevel_Info_instance;
		  }
		  function LoggingLevel_Warn_getInstance() {
		    LoggingLevel_initEntries();
		    return LoggingLevel_Warn_instance;
		  }
		  function LoggingLevel_Error_getInstance() {
		    LoggingLevel_initEntries();
		    return LoggingLevel_Error_instance;
		  }
		  function LoggingLevel_Assert_getInstance() {
		    LoggingLevel_initEntries();
		    return LoggingLevel_Assert_instance;
		  }
		  function ClientConfigRegion_AP_getInstance() {
		    ClientConfigRegion_initEntries();
		    return ClientConfigRegion_AP_instance;
		  }
		  function ClientConfigRegion_EU_getInstance() {
		    ClientConfigRegion_initEntries();
		    return ClientConfigRegion_EU_instance;
		  }
		  function ClientConfigRegion_US_getInstance() {
		    ClientConfigRegion_initEntries();
		    return ClientConfigRegion_US_instance;
		  }
		  function ConversationAPIImpl$getConversation$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof Exception) {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      } else {
		        if (response instanceof GetConversation) {
		          var tmp1_safe_receiver = response.b1k_1;
		          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r1j_1;
		          var tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.e1r_1;
		          var tmp3_safe_receiver = response.b1k_1;
		          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.r1j_1;
		          var tmp_1 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.f1r_1;
		          var tmp5_safe_receiver = response.c1k_1;
		          var conversation = new Conversation(response.v1j_1, response.w1j_1, response.x1j_1, tmp_0, tmp_1, response.y1j_1, response.a1k_1, response.z1j_1, tmp5_safe_receiver == null ? null : tmp5_safe_receiver.o1r());
		          tmp = $callback(null, conversation);
		        }
		      }
		      return Unit_instance;
		    };
		  }
		  function ConversationAPIImpl$getUser$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof Exception) {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      } else {
		        if (response instanceof GetUser) {
		          var tmp1_safe_receiver = response.c1y_1;
		          var tmp_0;
		          if (tmp1_safe_receiver == null) {
		            tmp_0 = null;
		          } else {
		            // Inline function 'kotlin.takeUnless' call
		            // Inline function 'kotlin.contracts.contract' call
		            var tmp_1;
		            // Inline function 'com.vonage.clientcore.core.api.ConversationAPIImpl.getUser.<anonymous>.<anonymous>' call
		            if (!tmp1_safe_receiver.x()) {
		              tmp_1 = tmp1_safe_receiver;
		            } else {
		              tmp_1 = null;
		            }
		            tmp_0 = tmp_1;
		          }
		          var tmp_2 = tmp_0;
		          var tmp2_safe_receiver = response.f1y_1;
		          var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.m1r_1;
		          var tmp_3;
		          if (tmp3_safe_receiver == null) {
		            tmp_3 = null;
		          } else {
		            // Inline function 'kotlin.takeUnless' call
		            // Inline function 'kotlin.contracts.contract' call
		            var tmp_4;
		            // Inline function 'com.vonage.clientcore.core.api.ConversationAPIImpl.getUser.<anonymous>.<anonymous>' call
		            if (!tmp3_safe_receiver.x()) {
		              tmp_4 = tmp3_safe_receiver;
		            } else {
		              tmp_4 = null;
		            }
		            tmp_3 = tmp_4;
		          }
		          var tmp4_safe_receiver = tmp_3;
		          var user = new User(response.z1x_1, response.a1y_1, response.b1y_1, tmp_2, response.d1y_1, response.e1y_1, tmp4_safe_receiver == null ? null : tmp4_safe_receiver.toString());
		          tmp = $callback(null, user);
		        }
		      }
		      return Unit_instance;
		    };
		  }
		  function ConversationAPIImpl(store) {
		    this.d2w_1 = store;
		  }
		  protoOf(ConversationAPIImpl).x1f = function (conversationIdOrName, callback) {
		    var tmp = new GetConversationRequest(conversationIdOrName);
		    this.d2w_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ConversationAPIImpl$getConversation$lambda(callback))));
		  };
		  protoOf(ConversationAPIImpl).y1f = function (userIdOrName, callback) {
		    var tmp = new GetUserRequest(userIdOrName);
		    this.d2w_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, ConversationAPIImpl$getUser$lambda(callback))));
		  };
		  function CSErrorCodes() {
		    this.e2w_1 = 'conversation:error:duplicate-name';
		    this.f2w_1 = 'conversation:error:member-already-joined';
		    this.g2w_1 = 'conversation:error:member-already-invited';
		    this.h2w_1 = 'conversation:error:not-found';
		    this.i2w_1 = 'leg:error:not-found';
		    this.j2w_1 = 'conversation:error:not-allowed';
		    this.k2w_1 = 'conversation:error:member-not-found';
		    this.l2w_1 = 'user:error:not-found';
		    this.m2w_1 = 'paginator-builder:error:invalid-cursor';
		    this.n2w_1 = 'http:error:validation-fail';
		    this.o2w_1 = 'conversation:error:maximum-number-of-members';
		    this.p2w_1 = 'system:error:permission';
		    this.q2w_1 = 'system:error:missing-token';
		    this.r2w_1 = 'system:error:expired-token';
		    this.s2w_1 = 'system:error:invalid-token';
		    this.t2w_1 = 'system:error:internal';
		    this.u2w_1 = 'event:error:invalid-filter-group';
		    this.v2w_1 = 'event:error:bad-request';
		    this.w2w_1 = 'event:error:delete-not-allowed';
		    this.x2w_1 = 'event:error:not-found';
		    this.y2w_1 = 'event:error:permission-denied';
		    this.z2w_1 = 'event:error:not-joined';
		    this.a2x_1 = 'custom-data:error:max-data-sum-limit-exceeded';
		  }
		  var CSErrorCodes_instance;
		  function CSErrorCodes_getInstance() {
		    return CSErrorCodes_instance;
		  }
		  function CustomLoggersLimitReached(provided, limit) {
		    var tmp;
		    if (limit === VOID) {
		      tmp = 10;
		    } else {
		      tmp = limit;
		    }
		    limit = tmp;
		    InternalError.call(this, 'internal:error:custom_loggers_limit_exceeded', 'Exceeded Max number of Custom Client Loggers. Provided: ' + provided + ', Limit: ' + limit);
		    captureStack(this, CustomLoggersLimitReached);
		  }
		  function NoCallFound() {
		    InternalError.call(this, 'voice:error:no_call_found', 'No call found');
		    captureStack(this, NoCallFound);
		  }
		  function NoCallMediaFound() {
		    InternalError.call(this, 'voice:error:no_call_media_found', 'No call media found');
		    captureStack(this, NoCallMediaFound);
		  }
		  function MediaTimeout() {
		    InternalError.call(this, 'voice:error:media_timeout', 'Media Timeout');
		    captureStack(this, MediaTimeout);
		  }
		  function NoInviteFound() {
		    InternalError.call(this, 'voice:error:no_invite_found', 'No invite found');
		    captureStack(this, NoInviteFound);
		  }
		  function InvalidCallAction() {
		    InternalError.call(this, 'voice:error:invalid_call_action', 'Invalid call action');
		    captureStack(this, InvalidCallAction);
		  }
		  function NoOfferFound() {
		    InternalError.call(this, 'voice:error:no_offer_found', 'No offer found');
		    captureStack(this, NoOfferFound);
		  }
		  function InboundCallFailed(cause) {
		    cause = cause === VOID ? null : cause;
		    InternalError.call(this, 'voice:error:inbound_call_failed', 'Inbound call failed', cause);
		    captureStack(this, InboundCallFailed);
		  }
		  function AuthorizationError_0(message) {
		    message = message === VOID ? null : message;
		    var tmp;
		    if (message == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.errors.AuthorizationError.<init>.<anonymous>' call
		      tmp = ': ' + message;
		    }
		    var tmp1_elvis_lhs = tmp;
		    InternalError.call(this, 'internal:auth:authorization_error', 'Authorization Error' + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs));
		    captureStack(this, AuthorizationError_0);
		  }
		  function MemberNotInConversation() {
		    InternalError.call(this, 'voice:error:member_not_in_conversation', 'Member has not joined the conversation');
		    captureStack(this, MemberNotInConversation);
		  }
		  function NoConversationFound() {
		    InternalError.call(this, 'voice:error:no_conversation_found', 'No conversation found');
		    captureStack(this, NoConversationFound);
		  }
		  function NoLegFound() {
		    InternalError.call(this, 'voice:error:no_leg_found', 'No leg found');
		    captureStack(this, NoLegFound);
		  }
		  function InternalError(code, message, cause) {
		    cause = cause === VOID ? null : cause;
		    Exception_init_$Init$_0(message, cause, this);
		    captureStack(this, InternalError);
		    this.b2x_1 = code;
		    this.c2x_1 = message;
		    this.d2x_1 = cause;
		  }
		  protoOf(InternalError).ab = function () {
		    return this.c2x_1;
		  };
		  protoOf(InternalError).bb = function () {
		    return this.d2x_1;
		  };
		  function ServiceTempNotAvailable() {
		    InternalError.call(this, 'internal:error:serviceNotAvailable', 'ServiceTempNotAvailable');
		    captureStack(this, ServiceTempNotAvailable);
		  }
		  function UnexpectedNullValue() {
		    InternalError.call(this, 'internal:error:unexpected_null_value', 'Unexpected Null Value');
		    captureStack(this, UnexpectedNullValue);
		  }
		  function IllegalArgumentException_0(message, cause) {
		    message = message === VOID ? null : message;
		    cause = cause === VOID ? null : cause;
		    InternalError.call(this, 'internal:error:illegal_argument_exception', message == null ? 'Incorrect arguments provided to method' : message, cause);
		    captureStack(this, IllegalArgumentException_0);
		  }
		  function ServiceNotAvailable(statusCode) {
		    statusCode = statusCode === VOID ? 500 : statusCode;
		    InternalError.call(this, 'internal:error:service_no_available', 'ServiceNotAvailable:' + statusCode);
		    captureStack(this, ServiceNotAvailable);
		  }
		  function ParsingException(cause) {
		    InternalError.call(this, 'internal:error:parsing_exception', 'Error throw whilst parsing data', cause);
		    captureStack(this, ParsingException);
		  }
		  function UnsanitizedInputError() {
		    InternalError.call(this, 'internal:error:unsanitized_input_error', 'Unsanitized Input Error');
		    captureStack(this, UnsanitizedInputError);
		  }
		  function NoAnswerFound() {
		    InternalError.call(this, 'voice:error:no_answer_found', 'No answer found');
		    captureStack(this, NoAnswerFound);
		  }
		  function Companion_136() {
		    this.e2x_1 = 'Unknown failure';
		  }
		  var Companion_instance_137;
		  function Companion_getInstance_138() {
		    return Companion_instance_137;
		  }
		  function MediaClientError(code, message, cause) {
		    cause = cause === VOID ? null : cause;
		    Exception_init_$Init$_0(message, cause, this);
		    captureStack(this, MediaClientError);
		    this.f2x_1 = code;
		    this.g2x_1 = message;
		    this.h2x_1 = cause;
		  }
		  protoOf(MediaClientError).ab = function () {
		    return this.g2x_1;
		  };
		  protoOf(MediaClientError).bb = function () {
		    return this.h2x_1;
		  };
		  function PeerConnectionNotFound(legId) {
		    MediaClientError.call(this, 'media:error:peer_connection_not_found', 'Peer Connection Not Found for Leg Id: ' + legId);
		    captureStack(this, PeerConnectionNotFound);
		  }
		  function TrackNotFound(legId) {
		    MediaClientError.call(this, 'media:error:track_not_found', 'Audio Track Not Found for Leg Id: ' + legId);
		    captureStack(this, TrackNotFound);
		  }
		  function ProcessAnswerError(legId, message) {
		    message = message === VOID ? null : message;
		    MediaClientError.call(this, 'media:error:process_answer_error', 'Error Processing Answer for Leg Id ' + legId + ': ' + (message == null ? 'Unknown failure' : message));
		    captureStack(this, ProcessAnswerError);
		  }
		  function CreateAnswerError(message) {
		    message = message === VOID ? null : message;
		    MediaClientError.call(this, 'media:error:create_answer_error', 'Error Creating Answer: ' + (message == null ? 'Unknown failure' : message));
		    captureStack(this, CreateAnswerError);
		  }
		  function CreateOfferError(message) {
		    message = message === VOID ? null : message;
		    MediaClientError.call(this, 'media:error:create_offer_error', 'Error Creating Offer: ' + (message == null ? 'Unknown failure' : message));
		    captureStack(this, CreateOfferError);
		  }
		  function SessionErrorCodes() {
		    this.i2x_1 = 'session:error:empty-token';
		    this.j2x_1 = 'session:error:server-forced-disconnect';
		    this.k2x_1 = 'session:error:timeout';
		    this.l2x_1 = 'session:error:internal-failure';
		    this.m2x_1 = 'session:error:no-active-session';
		    this.n2x_1 = 'session:error:already-active-session';
		    this.o2x_1 = 'session:error:invalid-token';
		    this.p2x_1 = 'session:error:expired-token';
		    this.q2x_1 = 'user:error:invalid-user';
		    this.r2x_1 = 'system:error:permission';
		    this.s2x_1 = 'session:error:invalid-session';
		    this.t2x_1 = 'session:error:max-open-sessions-permitted';
		    this.u2x_1 = 'session:error:websocket-transport-invalid';
		    this.v2x_1 = 'session:disconnect:client-disconnect';
		    this.w2x_1 = 'session:disconnect:ping-timeout';
		    this.x2x_1 = 'session:disconnect:websocket-transport-closed';
		  }
		  var SessionErrorCodes_instance;
		  function SessionErrorCodes_getInstance() {
		    return SessionErrorCodes_instance;
		  }
		  function SessionErrorMessages() {
		    this.y2x_1 = 'You provided an empty token. Please provide a valid token.';
		    this.z2x_1 = 'Session was forcefully disconnected.';
		    this.a2y_1 = 'Session failed due to a timeout expiration.';
		    this.b2y_1 = 'An internal error occurred with the session. Please try again shortly.';
		    this.c2y_1 = 'You do not have an active session. Please establish a valid session and try again.';
		    this.d2y_1 = 'You already have an active session.';
		    this.e2y_1 = 'You provided an invalid token. Please provide a valid token.';
		    this.f2y_1 = 'You provided an expired token. Please provide a valid token.';
		    this.g2y_1 = 'You provided an invalid user. Please provide a valid user.';
		    this.h2y_1 = 'Permission denied. Please provide a valid token.';
		    this.i2y_1 = 'The request failed due to an invalid session. Please establish a valid session and try again.';
		    this.j2y_1 = 'The maximum amount of open sessions has been established. Please delete them by logging out and try again.';
		    this.k2y_1 = 'Session failed due to an invalid websocket transport.';
		    this.l2y_1 = 'Session failed because client disconnected.';
		    this.m2y_1 = 'Session failed due to a ping timeout expiration.';
		    this.n2y_1 = 'Session failed because websocket transport has been closed.';
		  }
		  var SessionErrorMessages_instance;
		  function SessionErrorMessages_getInstance() {
		    return SessionErrorMessages_instance;
		  }
		  function VonageError(type, code, message, cause) {
		    type = type === VOID ? VonageErrorType_UNKNOWN_ERROR_getInstance() : type;
		    code = code === VOID ? null : code;
		    message = message === VOID ? null : message;
		    cause = cause === VOID ? null : cause;
		    Exception_init_$Init$_0(message, cause, this);
		    captureStack(this, VonageError);
		    this.o2y_1 = type;
		    this.p2y_1 = code;
		  }
		  var VonageErrorType_CS_ERROR_instance;
		  var VonageErrorType_SESSION_ERROR_instance;
		  var VonageErrorType_INTERNAL_ERROR_instance;
		  var VonageErrorType_NETWORK_ERROR_instance;
		  var VonageErrorType_UNKNOWN_ERROR_instance;
		  var VonageErrorType_entriesInitialized;
		  function VonageErrorType_initEntries() {
		    if (VonageErrorType_entriesInitialized)
		      return Unit_instance;
		    VonageErrorType_entriesInitialized = true;
		    VonageErrorType_CS_ERROR_instance = new VonageErrorType('CS_ERROR', 0);
		    VonageErrorType_SESSION_ERROR_instance = new VonageErrorType('SESSION_ERROR', 1);
		    VonageErrorType_INTERNAL_ERROR_instance = new VonageErrorType('INTERNAL_ERROR', 2);
		    VonageErrorType_NETWORK_ERROR_instance = new VonageErrorType('NETWORK_ERROR', 3);
		    VonageErrorType_UNKNOWN_ERROR_instance = new VonageErrorType('UNKNOWN_ERROR', 4);
		  }
		  function VonageErrorType(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function toVonageError(_this__u8e3s4) {
		    var tmp;
		    if (_this__u8e3s4 instanceof VonageError) {
		      tmp = _this__u8e3s4;
		    } else {
		      if (_this__u8e3s4 instanceof SessionError) {
		        var tmp_0 = VonageErrorType_SESSION_ERROR_getInstance();
		        var tmp_1 = _this__u8e3s4.d2o();
		        var tmp_2 = _this__u8e3s4.ab();
		        var tmp1_elvis_lhs = _this__u8e3s4.cause;
		        tmp = new VonageError(tmp_0, tmp_1, tmp_2, tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs);
		      } else {
		        if (_this__u8e3s4 instanceof CSError) {
		          var tmp_3 = VonageErrorType_CS_ERROR_getInstance();
		          var tmp2_elvis_lhs = _this__u8e3s4.cause;
		          tmp = new VonageError(tmp_3, _this__u8e3s4.q1q_1, _this__u8e3s4.u1q_1, tmp2_elvis_lhs == null ? _this__u8e3s4 : tmp2_elvis_lhs);
		        } else {
		          if (_this__u8e3s4 instanceof HTTPClientError) {
		            var tmp_4 = VonageErrorType_NETWORK_ERROR_getInstance();
		            var tmp_5 = _this__u8e3s4.message;
		            var tmp3_elvis_lhs = _this__u8e3s4.cause;
		            tmp = new VonageError(tmp_4, VOID, tmp_5, tmp3_elvis_lhs == null ? _this__u8e3s4 : tmp3_elvis_lhs);
		          } else {
		            if (_this__u8e3s4 instanceof MediaClientError) {
		              var tmp_6 = VonageErrorType_INTERNAL_ERROR_getInstance();
		              var tmp_7 = _this__u8e3s4.ab();
		              var tmp4_elvis_lhs = _this__u8e3s4.cause;
		              tmp = new VonageError(tmp_6, _this__u8e3s4.f2x_1, tmp_7, tmp4_elvis_lhs == null ? _this__u8e3s4 : tmp4_elvis_lhs);
		            } else {
		              if (_this__u8e3s4 instanceof InternalError) {
		                var tmp_8;
		                if (_this__u8e3s4 instanceof ServiceTempNotAvailable) {
		                  var tmp_9 = VonageErrorType_NETWORK_ERROR_getInstance();
		                  var tmp_10 = _this__u8e3s4.ab();
		                  var tmp6_elvis_lhs = _this__u8e3s4.bb();
		                  tmp_8 = new VonageError(tmp_9, _this__u8e3s4.b2x_1, tmp_10, tmp6_elvis_lhs == null ? _this__u8e3s4 : tmp6_elvis_lhs);
		                } else {
		                  var tmp_11 = VonageErrorType_INTERNAL_ERROR_getInstance();
		                  var tmp_12 = _this__u8e3s4.ab();
		                  var tmp7_elvis_lhs = _this__u8e3s4.bb();
		                  tmp_8 = new VonageError(tmp_11, _this__u8e3s4.b2x_1, tmp_12, tmp7_elvis_lhs == null ? _this__u8e3s4 : tmp7_elvis_lhs);
		                }
		                tmp = tmp_8;
		              } else {
		                var tmp_13 = VonageErrorType_UNKNOWN_ERROR_getInstance();
		                var tmp_14 = _this__u8e3s4.message;
		                var tmp8_elvis_lhs = _this__u8e3s4.cause;
		                tmp = new VonageError(tmp_13, null, tmp_14, tmp8_elvis_lhs == null ? _this__u8e3s4 : tmp8_elvis_lhs);
		              }
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  }
		  function invokeCallbackWithError(e, callback) {
		    if (e instanceof Exception)
		      callback(toVonageError(e), null);
		    else {
		      callback(toVonageError(new UnexpectedNullValue()), null);
		    }
		  }
		  function invokeCallbackWithError_0(e, callback) {
		    return invokeCallbackWithError(e, invokeCallbackWithError$lambda(callback));
		  }
		  function invokeCallbackWithError$lambda($callback) {
		    return function (exception, _anonymous_parameter_1__qggqgd) {
		      $callback(exception);
		      return Unit_instance;
		    };
		  }
		  function VonageErrorType_CS_ERROR_getInstance() {
		    VonageErrorType_initEntries();
		    return VonageErrorType_CS_ERROR_instance;
		  }
		  function VonageErrorType_SESSION_ERROR_getInstance() {
		    VonageErrorType_initEntries();
		    return VonageErrorType_SESSION_ERROR_instance;
		  }
		  function VonageErrorType_INTERNAL_ERROR_getInstance() {
		    VonageErrorType_initEntries();
		    return VonageErrorType_INTERNAL_ERROR_instance;
		  }
		  function VonageErrorType_NETWORK_ERROR_getInstance() {
		    VonageErrorType_initEntries();
		    return VonageErrorType_NETWORK_ERROR_instance;
		  }
		  function VonageErrorType_UNKNOWN_ERROR_getInstance() {
		    VonageErrorType_initEntries();
		    return VonageErrorType_UNKNOWN_ERROR_instance;
		  }
		  function invokeEventListener($this, event, listener) {
		    if (event == null)
		      return Unit_instance;
		    if (isInterface(event, SocketConversationEvent)) {
		      listener.q2t(event.o2c());
		    } else {
		      if (event instanceof AudioSayEvent) {
		        listener.u2t();
		      } else {
		        if (event instanceof LegStatusUpdateEvent) {
		          var tmp1_safe_receiver = event.b28_1;
		          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u1y_1;
		          var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.x1y_1;
		          if (tmp3_safe_receiver == null)
		            null;
		          else {
		            // Inline function 'kotlin.let' call
		            // Inline function 'kotlin.contracts.contract' call
		            listener.t2t(event.u27(), event.x27_1.h28_1, tmp3_safe_receiver, event.x27_1.i28_1);
		          }
		        } else {
		          if (event instanceof AudioMuteOnEvent) {
		            listener.v2t(event.p28_1, event.n28_1.u28_1, true);
		          } else {
		            if (event instanceof AudioMuteOffEvent) {
		              listener.v2t(event.z28_1, event.x28_1.u28_1, false);
		            } else {
		              if (event instanceof AudioEarmuffOnEvent) {
		                listener.w2t(event.g29_1, event.e29_1.l29_1, true);
		              } else {
		                if (event instanceof AudioEarmuffOffEvent) {
		                  listener.w2t(event.q29_1, event.o29_1.l29_1, false);
		                } else {
		                  if (event instanceof AudioDTMFEvent) {
		                    listener.x2t(event.x29_1, event.v29_1.d2a_1.q2y_1, event.v29_1.c2a_1);
		                  } else {
		                    if (event instanceof RTCHangupEvent) {
		                      listener.r2t(event.i2a_1, event.g2a_1.h27_1.k26_1, event.g2a_1);
		                    } else {
		                      if (event instanceof RTCTransferEvent) {
		                        var tmp4_safe_receiver = event.n2a_1.x2a_1.k26_1;
		                        if (tmp4_safe_receiver == null)
		                          null;
		                        else {
		                          // Inline function 'kotlin.let' call
		                          // Inline function 'kotlin.contracts.contract' call
		                          listener.s2t(event.p2a_1, tmp4_safe_receiver);
		                        }
		                      }
		                    }
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		  }
		  function EventAPIImpl$onEvent$lambda$lambda(this$0, $listener, $eventCounters) {
		    return function () {
		      var state = this$0.s2y_1.t2y(getKClass(RemoteEventReducer));
		      var tmp0_safe_receiver = state.v2y_1;
		      if (tmp0_safe_receiver == null)
		        null;
		      else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        var tmp0_elvis_lhs = state.u2y_1.c2(tmp0_safe_receiver);
		        var tmp;
		        if (tmp0_elvis_lhs == null) {
		          return Unit_instance;
		        } else {
		          tmp = tmp0_elvis_lhs;
		        }
		        var buffer = tmp;
		        invokeEventListener(this$0, buffer.y2y_1, $listener);
		        var this_0 = $eventCounters;
		        var value = buffer.w2y_1;
		        this_0.s1(tmp0_safe_receiver, value);
		      }
		      return Unit_instance;
		    };
		  }
		  function EventAPIImpl$onEvent$lambda(this$0, $listener) {
		    return function () {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      var eventCounters = LinkedHashMap_init_$Create$();
		      return new StoredSubscription(EventAPIImpl$onEvent$lambda$lambda(this$0, $listener, eventCounters));
		    };
		  }
		  function EventAPIImpl(store) {
		    this.s2y_1 = store;
		  }
		  protoOf(EventAPIImpl).w1f = function (listener) {
		    var tmp = getKClass(RemoteEventReducer);
		    this.s2y_1.a2z(tmp, EventAPIImpl$onEvent$lambda(this, listener));
		  };
		  function RTCEventListener() {
		  }
		  function AudioEventListener() {
		  }
		  function ConversationEventListener() {
		  }
		  function Companion_137() {
		  }
		  var Companion_instance_138;
		  function Companion_getInstance_139() {
		    return Companion_instance_138;
		  }
		  function $serializer_154() {
		    $serializer_instance_154 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.api.models.Channel', this, 2);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('number', true);
		    this.b2z_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_154).uf = function () {
		    return this.b2z_1;
		  };
		  protoOf($serializer_154).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_154).wf = function (decoder) {
		    var tmp0_desc = this.b2z_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return Channel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_154).c2z = function (encoder, value) {
		    var tmp0_desc = this.b2z_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.d2z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.d2z_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.e2z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.e2z_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_154).vf = function (encoder, value) {
		    return this.c2z(encoder, value instanceof Channel ? value : THROW_CCE());
		  };
		  var $serializer_instance_154;
		  function $serializer_getInstance_154() {
		    if ($serializer_instance_154 == null)
		      new $serializer_154();
		    return $serializer_instance_154;
		  }
		  function Channel_init_$Init$(seen1, id, number, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_154().b2z_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.d2z_1 = null;
		    else
		      $this.d2z_1 = id;
		    if (0 === (seen1 & 2))
		      $this.e2z_1 = null;
		    else
		      $this.e2z_1 = number;
		    return $this;
		  }
		  function Channel_init_$Create$(seen1, id, number, serializationConstructorMarker) {
		    return Channel_init_$Init$(seen1, id, number, serializationConstructorMarker, objectCreate(protoOf(Channel)));
		  }
		  function Channel(id, number) {
		    id = id === VOID ? null : id;
		    number = number === VOID ? null : number;
		    this.d2z_1 = id;
		    this.e2z_1 = number;
		  }
		  protoOf(Channel).toString = function () {
		    return 'Channel(id=' + this.d2z_1 + ', number=' + this.e2z_1 + ')';
		  };
		  protoOf(Channel).hashCode = function () {
		    var result = this.d2z_1 == null ? 0 : getStringHashCode(this.d2z_1);
		    result = imul(result, 31) + (this.e2z_1 == null ? 0 : getStringHashCode(this.e2z_1)) | 0;
		    return result;
		  };
		  protoOf(Channel).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Channel))
		      return false;
		    var tmp0_other_with_cast = other instanceof Channel ? other : THROW_CCE();
		    if (!(this.d2z_1 == tmp0_other_with_cast.d2z_1))
		      return false;
		    if (!(this.e2z_1 == tmp0_other_with_cast.e2z_1))
		      return false;
		    return true;
		  };
		  function $serializer_155() {
		    $serializer_instance_155 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.api.models.MemberChannel', this, 3);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('to', true);
		    this.f2z_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_155).uf = function () {
		    return this.f2z_1;
		  };
		  protoOf($serializer_155).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [$serializer_getInstance_157(), get_nullable($serializer_getInstance_154()), get_nullable($serializer_getInstance_154())];
		  };
		  protoOf($serializer_155).wf = function (decoder) {
		    var tmp0_desc = this.f2z_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_157(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, $serializer_getInstance_154(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_154(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.qj(tmp0_desc, 0, $serializer_getInstance_157(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, $serializer_getInstance_154(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, $serializer_getInstance_154(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return MemberChannel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_155).g2z = function (encoder, value) {
		    var tmp0_desc = this.f2z_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.vk(tmp0_desc, 0, $serializer_getInstance_157(), value.h2z_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.i2z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, $serializer_getInstance_154(), value.i2z_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.j2z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, $serializer_getInstance_154(), value.j2z_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_155).vf = function (encoder, value) {
		    return this.g2z(encoder, value instanceof MemberChannel ? value : THROW_CCE());
		  };
		  var $serializer_instance_155;
		  function $serializer_getInstance_155() {
		    if ($serializer_instance_155 == null)
		      new $serializer_155();
		    return $serializer_instance_155;
		  }
		  function MemberChannel_init_$Init$(seen1, type, from, to, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_155().f2z_1);
		    }
		    $this.h2z_1 = type;
		    if (0 === (seen1 & 2))
		      $this.i2z_1 = null;
		    else
		      $this.i2z_1 = from;
		    if (0 === (seen1 & 4))
		      $this.j2z_1 = null;
		    else
		      $this.j2z_1 = to;
		    return $this;
		  }
		  function MemberChannel_init_$Create$(seen1, type, from, to, serializationConstructorMarker) {
		    return MemberChannel_init_$Init$(seen1, type, from, to, serializationConstructorMarker, objectCreate(protoOf(MemberChannel)));
		  }
		  function MemberChannel() {
		  }
		  protoOf(MemberChannel).toString = function () {
		    return 'MemberChannel(type=' + this.h2z_1 + ', from=' + this.i2z_1 + ', to=' + this.j2z_1 + ')';
		  };
		  protoOf(MemberChannel).hashCode = function () {
		    var result = this.h2z_1.hashCode();
		    result = imul(result, 31) + (this.i2z_1 == null ? 0 : this.i2z_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.j2z_1 == null ? 0 : this.j2z_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(MemberChannel).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberChannel))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberChannel ? other : THROW_CCE();
		    if (!this.h2z_1.equals(tmp0_other_with_cast.h2z_1))
		      return false;
		    if (!equals(this.i2z_1, tmp0_other_with_cast.i2z_1))
		      return false;
		    if (!equals(this.j2z_1, tmp0_other_with_cast.j2z_1))
		      return false;
		    return true;
		  };
		  function Companion_138() {
		    Companion_instance_139 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.k2z_1 = [new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154()), new ArrayListSerializer($serializer_getInstance_154())];
		  }
		  var Companion_instance_139;
		  function Companion_getInstance_140() {
		    if (Companion_instance_139 == null)
		      new Companion_138();
		    return Companion_instance_139;
		  }
		  function $serializer_156() {
		    $serializer_instance_156 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.api.models.UserChannels', this, 11);
		    tmp0_serialDesc.pq('app', true);
		    tmp0_serialDesc.pq('phone', true);
		    tmp0_serialDesc.pq('pstn', true);
		    tmp0_serialDesc.pq('sip', true);
		    tmp0_serialDesc.pq('vbc', true);
		    tmp0_serialDesc.pq('websocket', true);
		    tmp0_serialDesc.pq('sms', true);
		    tmp0_serialDesc.pq('mms', true);
		    tmp0_serialDesc.pq('whatsapp', true);
		    tmp0_serialDesc.pq('viber', true);
		    tmp0_serialDesc.pq('messenger', true);
		    this.l2z_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_156).uf = function () {
		    return this.l2z_1;
		  };
		  protoOf($serializer_156).er = function () {
		    var tmp0_cached = Companion_getInstance_140().k2z_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2]), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4]), get_nullable(tmp0_cached[5]), get_nullable(tmp0_cached[6]), get_nullable(tmp0_cached[7]), get_nullable(tmp0_cached[8]), get_nullable(tmp0_cached[9]), get_nullable(tmp0_cached[10])];
		  };
		  protoOf($serializer_156).wf = function (decoder) {
		    var tmp0_desc = this.l2z_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_local6 = null;
		    var tmp11_local7 = null;
		    var tmp12_local8 = null;
		    var tmp13_local9 = null;
		    var tmp14_local10 = null;
		    var tmp15_input = decoder.ej(tmp0_desc);
		    var tmp16_cached = Companion_getInstance_140().k2z_1;
		    if (tmp15_input.uj()) {
		      tmp4_local0 = tmp15_input.sj(tmp0_desc, 0, tmp16_cached[0], tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp15_input.sj(tmp0_desc, 1, tmp16_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp15_input.sj(tmp0_desc, 2, tmp16_cached[2], tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp15_input.sj(tmp0_desc, 3, tmp16_cached[3], tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp15_input.sj(tmp0_desc, 4, tmp16_cached[4], tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp15_input.sj(tmp0_desc, 5, tmp16_cached[5], tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp15_input.sj(tmp0_desc, 6, tmp16_cached[6], tmp10_local6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp15_input.sj(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		      tmp12_local8 = tmp15_input.sj(tmp0_desc, 8, tmp16_cached[8], tmp12_local8);
		      tmp3_bitMask0 = tmp3_bitMask0 | 256;
		      tmp13_local9 = tmp15_input.sj(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
		      tmp3_bitMask0 = tmp3_bitMask0 | 512;
		      tmp14_local10 = tmp15_input.sj(tmp0_desc, 10, tmp16_cached[10], tmp14_local10);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp15_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp15_input.sj(tmp0_desc, 0, tmp16_cached[0], tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp15_input.sj(tmp0_desc, 1, tmp16_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp15_input.sj(tmp0_desc, 2, tmp16_cached[2], tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp15_input.sj(tmp0_desc, 3, tmp16_cached[3], tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp15_input.sj(tmp0_desc, 4, tmp16_cached[4], tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp15_input.sj(tmp0_desc, 5, tmp16_cached[5], tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp15_input.sj(tmp0_desc, 6, tmp16_cached[6], tmp10_local6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp15_input.sj(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          case 8:
		            tmp12_local8 = tmp15_input.sj(tmp0_desc, 8, tmp16_cached[8], tmp12_local8);
		            tmp3_bitMask0 = tmp3_bitMask0 | 256;
		            break;
		          case 9:
		            tmp13_local9 = tmp15_input.sj(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
		            tmp3_bitMask0 = tmp3_bitMask0 | 512;
		            break;
		          case 10:
		            tmp14_local10 = tmp15_input.sj(tmp0_desc, 10, tmp16_cached[10], tmp14_local10);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp15_input.fj(tmp0_desc);
		    return UserChannels_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
		  };
		  protoOf($serializer_156).m2z = function (encoder, value) {
		    var tmp0_desc = this.l2z_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_140().k2z_1;
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.s2v_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, tmp2_cached[0], value.s2v_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.t2v_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, tmp2_cached[1], value.t2v_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.u2v_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, tmp2_cached[2], value.u2v_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.v2v_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, tmp2_cached[3], value.v2v_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.w2v_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, tmp2_cached[4], value.w2v_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.x2v_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, tmp2_cached[5], value.x2v_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 6) ? true : !(value.y2v_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 6, tmp2_cached[6], value.y2v_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 7) ? true : !(value.z2v_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 7, tmp2_cached[7], value.z2v_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 8) ? true : !(value.a2w_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 8, tmp2_cached[8], value.a2w_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 9) ? true : !(value.b2w_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 9, tmp2_cached[9], value.b2w_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 10) ? true : !(value.c2w_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 10, tmp2_cached[10], value.c2w_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_156).vf = function (encoder, value) {
		    return this.m2z(encoder, value instanceof UserChannels ? value : THROW_CCE());
		  };
		  var $serializer_instance_156;
		  function $serializer_getInstance_156() {
		    if ($serializer_instance_156 == null)
		      new $serializer_156();
		    return $serializer_instance_156;
		  }
		  function UserChannels_init_$Init$(seen1, app, phone, pstn, sip, vbc, websocket, sms, mms, whatsapp, viber, messenger, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_156().l2z_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.s2v_1 = null;
		    else
		      $this.s2v_1 = app;
		    if (0 === (seen1 & 2))
		      $this.t2v_1 = null;
		    else
		      $this.t2v_1 = phone;
		    if (0 === (seen1 & 4))
		      $this.u2v_1 = null;
		    else
		      $this.u2v_1 = pstn;
		    if (0 === (seen1 & 8))
		      $this.v2v_1 = null;
		    else
		      $this.v2v_1 = sip;
		    if (0 === (seen1 & 16))
		      $this.w2v_1 = null;
		    else
		      $this.w2v_1 = vbc;
		    if (0 === (seen1 & 32))
		      $this.x2v_1 = null;
		    else
		      $this.x2v_1 = websocket;
		    if (0 === (seen1 & 64))
		      $this.y2v_1 = null;
		    else
		      $this.y2v_1 = sms;
		    if (0 === (seen1 & 128))
		      $this.z2v_1 = null;
		    else
		      $this.z2v_1 = mms;
		    if (0 === (seen1 & 256))
		      $this.a2w_1 = null;
		    else
		      $this.a2w_1 = whatsapp;
		    if (0 === (seen1 & 512))
		      $this.b2w_1 = null;
		    else
		      $this.b2w_1 = viber;
		    if (0 === (seen1 & 1024))
		      $this.c2w_1 = null;
		    else
		      $this.c2w_1 = messenger;
		    return $this;
		  }
		  function UserChannels_init_$Create$(seen1, app, phone, pstn, sip, vbc, websocket, sms, mms, whatsapp, viber, messenger, serializationConstructorMarker) {
		    return UserChannels_init_$Init$(seen1, app, phone, pstn, sip, vbc, websocket, sms, mms, whatsapp, viber, messenger, serializationConstructorMarker, objectCreate(protoOf(UserChannels)));
		  }
		  function UserChannels(app, phone, pstn, sip, vbc, websocket, sms, mms, whatsapp, viber, messenger) {
		    Companion_getInstance_140();
		    app = app === VOID ? null : app;
		    phone = phone === VOID ? null : phone;
		    pstn = pstn === VOID ? null : pstn;
		    sip = sip === VOID ? null : sip;
		    vbc = vbc === VOID ? null : vbc;
		    websocket = websocket === VOID ? null : websocket;
		    sms = sms === VOID ? null : sms;
		    mms = mms === VOID ? null : mms;
		    whatsapp = whatsapp === VOID ? null : whatsapp;
		    viber = viber === VOID ? null : viber;
		    messenger = messenger === VOID ? null : messenger;
		    this.s2v_1 = app;
		    this.t2v_1 = phone;
		    this.u2v_1 = pstn;
		    this.v2v_1 = sip;
		    this.w2v_1 = vbc;
		    this.x2v_1 = websocket;
		    this.y2v_1 = sms;
		    this.z2v_1 = mms;
		    this.a2w_1 = whatsapp;
		    this.b2w_1 = viber;
		    this.c2w_1 = messenger;
		  }
		  protoOf(UserChannels).x = function () {
		    return this.equals(new UserChannels());
		  };
		  protoOf(UserChannels).toString = function () {
		    return 'UserChannels(app=' + this.s2v_1 + ', phone=' + this.t2v_1 + ', pstn=' + this.u2v_1 + ', sip=' + this.v2v_1 + ', vbc=' + this.w2v_1 + ', websocket=' + this.x2v_1 + ', sms=' + this.y2v_1 + ', mms=' + this.z2v_1 + ', whatsapp=' + this.a2w_1 + ', viber=' + this.b2w_1 + ', messenger=' + this.c2w_1 + ')';
		  };
		  protoOf(UserChannels).hashCode = function () {
		    var result = this.s2v_1 == null ? 0 : hashCode(this.s2v_1);
		    result = imul(result, 31) + (this.t2v_1 == null ? 0 : hashCode(this.t2v_1)) | 0;
		    result = imul(result, 31) + (this.u2v_1 == null ? 0 : hashCode(this.u2v_1)) | 0;
		    result = imul(result, 31) + (this.v2v_1 == null ? 0 : hashCode(this.v2v_1)) | 0;
		    result = imul(result, 31) + (this.w2v_1 == null ? 0 : hashCode(this.w2v_1)) | 0;
		    result = imul(result, 31) + (this.x2v_1 == null ? 0 : hashCode(this.x2v_1)) | 0;
		    result = imul(result, 31) + (this.y2v_1 == null ? 0 : hashCode(this.y2v_1)) | 0;
		    result = imul(result, 31) + (this.z2v_1 == null ? 0 : hashCode(this.z2v_1)) | 0;
		    result = imul(result, 31) + (this.a2w_1 == null ? 0 : hashCode(this.a2w_1)) | 0;
		    result = imul(result, 31) + (this.b2w_1 == null ? 0 : hashCode(this.b2w_1)) | 0;
		    result = imul(result, 31) + (this.c2w_1 == null ? 0 : hashCode(this.c2w_1)) | 0;
		    return result;
		  };
		  protoOf(UserChannels).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UserChannels))
		      return false;
		    var tmp0_other_with_cast = other instanceof UserChannels ? other : THROW_CCE();
		    if (!equals(this.s2v_1, tmp0_other_with_cast.s2v_1))
		      return false;
		    if (!equals(this.t2v_1, tmp0_other_with_cast.t2v_1))
		      return false;
		    if (!equals(this.u2v_1, tmp0_other_with_cast.u2v_1))
		      return false;
		    if (!equals(this.v2v_1, tmp0_other_with_cast.v2v_1))
		      return false;
		    if (!equals(this.w2v_1, tmp0_other_with_cast.w2v_1))
		      return false;
		    if (!equals(this.x2v_1, tmp0_other_with_cast.x2v_1))
		      return false;
		    if (!equals(this.y2v_1, tmp0_other_with_cast.y2v_1))
		      return false;
		    if (!equals(this.z2v_1, tmp0_other_with_cast.z2v_1))
		      return false;
		    if (!equals(this.a2w_1, tmp0_other_with_cast.a2w_1))
		      return false;
		    if (!equals(this.b2w_1, tmp0_other_with_cast.b2w_1))
		      return false;
		    if (!equals(this.c2w_1, tmp0_other_with_cast.c2w_1))
		      return false;
		    return true;
		  };
		  function _get_$cachedSerializer__te6jhj_0($this) {
		    return $this.n2z_1.w1();
		  }
		  function ChannelType$Companion$_anonymous__a1qjea() {
		    return $serializer_getInstance_157();
		  }
		  var ChannelType_APP_instance;
		  var ChannelType_PHONE_instance;
		  var ChannelType_PSTN_instance;
		  var ChannelType_SIP_instance;
		  var ChannelType_VBC_instance;
		  var ChannelType_WEBSOCKET_instance;
		  var ChannelType_SMS_instance;
		  var ChannelType_MMS_instance;
		  var ChannelType_WHATSAPP_instance;
		  var ChannelType_VIBER_instance;
		  var ChannelType_MESSENGER_instance;
		  function Companion_139() {
		    Companion_instance_140 = this;
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.n2z_1 = lazy(tmp_0, ChannelType$Companion$_anonymous__a1qjea);
		  }
		  protoOf(Companion_139).y12 = function () {
		    return _get_$cachedSerializer__te6jhj_0(this);
		  };
		  protoOf(Companion_139).nr = function (typeParamsSerializers) {
		    return this.y12();
		  };
		  var Companion_instance_140;
		  function Companion_getInstance_141() {
		    ChannelType_initEntries();
		    if (Companion_instance_140 == null)
		      new Companion_139();
		    return Companion_instance_140;
		  }
		  function $serializer_157() {
		    $serializer_instance_157 = this;
		    var tmp0_serialDesc = new EnumDescriptor('com.vonage.clientcore.core.api.models.ChannelType', 11);
		    tmp0_serialDesc.pq('app', false);
		    tmp0_serialDesc.pq('phone', false);
		    tmp0_serialDesc.pq('pstn', false);
		    tmp0_serialDesc.pq('sip', false);
		    tmp0_serialDesc.pq('vbc', false);
		    tmp0_serialDesc.pq('websocket', false);
		    tmp0_serialDesc.pq('sms', false);
		    tmp0_serialDesc.pq('mms', false);
		    tmp0_serialDesc.pq('whatsapp', false);
		    tmp0_serialDesc.pq('viber', false);
		    tmp0_serialDesc.pq('messenger', false);
		    this.o2z_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_157).uf = function () {
		    return this.o2z_1;
		  };
		  protoOf($serializer_157).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [];
		  };
		  protoOf($serializer_157).wf = function (decoder) {
		    return values_0()[decoder.aj(this.o2z_1)];
		  };
		  protoOf($serializer_157).p2z = function (encoder, value) {
		    encoder.jk(this.o2z_1, value.i8_1);
		  };
		  protoOf($serializer_157).vf = function (encoder, value) {
		    return this.p2z(encoder, value instanceof ChannelType ? value : THROW_CCE());
		  };
		  var $serializer_instance_157;
		  function $serializer_getInstance_157() {
		    ChannelType_initEntries();
		    if ($serializer_instance_157 == null)
		      new $serializer_157();
		    return $serializer_instance_157;
		  }
		  function values_0() {
		    return [ChannelType_APP_getInstance(), ChannelType_PHONE_getInstance(), ChannelType_PSTN_getInstance(), ChannelType_SIP_getInstance(), ChannelType_VBC_getInstance(), ChannelType_WEBSOCKET_getInstance(), ChannelType_SMS_getInstance(), ChannelType_MMS_getInstance(), ChannelType_WHATSAPP_getInstance(), ChannelType_VIBER_getInstance(), ChannelType_MESSENGER_getInstance()];
		  }
		  var ChannelType_entriesInitialized;
		  function ChannelType_initEntries() {
		    if (ChannelType_entriesInitialized)
		      return Unit_instance;
		    ChannelType_entriesInitialized = true;
		    ChannelType_APP_instance = new ChannelType('APP', 0);
		    ChannelType_PHONE_instance = new ChannelType('PHONE', 1);
		    ChannelType_PSTN_instance = new ChannelType('PSTN', 2);
		    ChannelType_SIP_instance = new ChannelType('SIP', 3);
		    ChannelType_VBC_instance = new ChannelType('VBC', 4);
		    ChannelType_WEBSOCKET_instance = new ChannelType('WEBSOCKET', 5);
		    ChannelType_SMS_instance = new ChannelType('SMS', 6);
		    ChannelType_MMS_instance = new ChannelType('MMS', 7);
		    ChannelType_WHATSAPP_instance = new ChannelType('WHATSAPP', 8);
		    ChannelType_VIBER_instance = new ChannelType('VIBER', 9);
		    ChannelType_MESSENGER_instance = new ChannelType('MESSENGER', 10);
		    Companion_getInstance_141();
		  }
		  function ChannelType(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function $serializer_158() {
		    $serializer_instance_158 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.api.models.ChannelFromTo', this, 3);
		    tmp0_serialDesc.pq('type', true);
		    tmp0_serialDesc.pq('number', true);
		    tmp0_serialDesc.pq('user', true);
		    this.q2z_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_158).uf = function () {
		    return this.q2z_1;
		  };
		  protoOf($serializer_158).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_158).wf = function (decoder) {
		    var tmp0_desc = this.q2z_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return ChannelFromTo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_158).r2z = function (encoder, value) {
		    var tmp0_desc = this.q2z_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.s2z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.s2z_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.t2z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.t2z_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.u2z_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.u2z_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_158).vf = function (encoder, value) {
		    return this.r2z(encoder, value instanceof ChannelFromTo ? value : THROW_CCE());
		  };
		  var $serializer_instance_158;
		  function $serializer_getInstance_158() {
		    if ($serializer_instance_158 == null)
		      new $serializer_158();
		    return $serializer_instance_158;
		  }
		  function ChannelFromTo_init_$Init$(seen1, type, number, user, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_158().q2z_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.s2z_1 = null;
		    else
		      $this.s2z_1 = type;
		    if (0 === (seen1 & 2))
		      $this.t2z_1 = null;
		    else
		      $this.t2z_1 = number;
		    if (0 === (seen1 & 4))
		      $this.u2z_1 = null;
		    else
		      $this.u2z_1 = user;
		    return $this;
		  }
		  function ChannelFromTo_init_$Create$(seen1, type, number, user, serializationConstructorMarker) {
		    return ChannelFromTo_init_$Init$(seen1, type, number, user, serializationConstructorMarker, objectCreate(protoOf(ChannelFromTo)));
		  }
		  function ChannelFromTo() {
		  }
		  protoOf(ChannelFromTo).toString = function () {
		    return 'ChannelFromTo(type=' + this.s2z_1 + ', number=' + this.t2z_1 + ', user=' + this.u2z_1 + ')';
		  };
		  protoOf(ChannelFromTo).hashCode = function () {
		    var result = this.s2z_1 == null ? 0 : getStringHashCode(this.s2z_1);
		    result = imul(result, 31) + (this.t2z_1 == null ? 0 : getStringHashCode(this.t2z_1)) | 0;
		    result = imul(result, 31) + (this.u2z_1 == null ? 0 : getStringHashCode(this.u2z_1)) | 0;
		    return result;
		  };
		  protoOf(ChannelFromTo).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ChannelFromTo))
		      return false;
		    var tmp0_other_with_cast = other instanceof ChannelFromTo ? other : THROW_CCE();
		    if (!(this.s2z_1 == tmp0_other_with_cast.s2z_1))
		      return false;
		    if (!(this.t2z_1 == tmp0_other_with_cast.t2z_1))
		      return false;
		    if (!(this.u2z_1 == tmp0_other_with_cast.u2z_1))
		      return false;
		    return true;
		  };
		  function ChannelType_APP_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_APP_instance;
		  }
		  function ChannelType_PHONE_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_PHONE_instance;
		  }
		  function ChannelType_PSTN_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_PSTN_instance;
		  }
		  function ChannelType_SIP_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_SIP_instance;
		  }
		  function ChannelType_VBC_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_VBC_instance;
		  }
		  function ChannelType_WEBSOCKET_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_WEBSOCKET_instance;
		  }
		  function ChannelType_SMS_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_SMS_instance;
		  }
		  function ChannelType_MMS_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_MMS_instance;
		  }
		  function ChannelType_WHATSAPP_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_WHATSAPP_instance;
		  }
		  function ChannelType_VIBER_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_VIBER_instance;
		  }
		  function ChannelType_MESSENGER_getInstance() {
		    ChannelType_initEntries();
		    return ChannelType_MESSENGER_instance;
		  }
		  function Properties_1(ttl, customSortKey, customData) {
		    ttl = ttl === VOID ? null : ttl;
		    customSortKey = customSortKey === VOID ? null : customSortKey;
		    customData = customData === VOID ? null : customData;
		    this.v2z_1 = ttl;
		    this.w2z_1 = customSortKey;
		    this.x2z_1 = customData;
		  }
		  protoOf(Properties_1).toString = function () {
		    return 'Properties(ttl=' + this.v2z_1 + ', customSortKey=' + this.w2z_1 + ', customData=' + this.x2z_1 + ')';
		  };
		  protoOf(Properties_1).hashCode = function () {
		    var result = this.v2z_1 == null ? 0 : this.v2z_1;
		    result = imul(result, 31) + (this.w2z_1 == null ? 0 : getStringHashCode(this.w2z_1)) | 0;
		    result = imul(result, 31) + (this.x2z_1 == null ? 0 : getStringHashCode(this.x2z_1)) | 0;
		    return result;
		  };
		  protoOf(Properties_1).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Properties_1))
		      return false;
		    var tmp0_other_with_cast = other instanceof Properties_1 ? other : THROW_CCE();
		    if (!(this.v2z_1 == tmp0_other_with_cast.v2z_1))
		      return false;
		    if (!(this.w2z_1 == tmp0_other_with_cast.w2z_1))
		      return false;
		    if (!(this.x2z_1 == tmp0_other_with_cast.x2z_1))
		      return false;
		    return true;
		  };
		  function Companion_140() {
		  }
		  protoOf(Companion_140).y2t = function (response) {
		    var tmp0_safe_receiver = response.b1k_1;
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r1j_1;
		    var tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1r_1;
		    var tmp2_safe_receiver = response.b1k_1;
		    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.r1j_1;
		    var tmp_0 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.f1r_1;
		    var tmp4_safe_receiver = response.c1k_1;
		    return new Conversation(response.v1j_1, response.w1j_1, response.x1j_1, tmp, tmp_0, response.y1j_1, response.a1k_1, response.z1j_1, tmp4_safe_receiver == null ? null : tmp4_safe_receiver.o1r());
		  };
		  var Companion_instance_141;
		  function Companion_getInstance_142() {
		    return Companion_instance_141;
		  }
		  function Conversation(id, name, timestamp, memberId, memberState, displayName, imageUrl, state, properties) {
		    memberId = memberId === VOID ? null : memberId;
		    memberState = memberState === VOID ? null : memberState;
		    displayName = displayName === VOID ? null : displayName;
		    imageUrl = imageUrl === VOID ? null : imageUrl;
		    state = state === VOID ? null : state;
		    properties = properties === VOID ? null : properties;
		    this.y2z_1 = id;
		    this.z2z_1 = name;
		    this.a30_1 = timestamp;
		    this.b30_1 = memberId;
		    this.c30_1 = memberState;
		    this.d30_1 = displayName;
		    this.e30_1 = imageUrl;
		    this.f30_1 = state;
		    this.g30_1 = properties;
		  }
		  protoOf(Conversation).toString = function () {
		    return 'Conversation(id=' + this.y2z_1 + ', name=' + this.z2z_1 + ', timestamp=' + this.a30_1 + ', memberId=' + this.b30_1 + ', memberState=' + this.c30_1 + ', displayName=' + this.d30_1 + ', imageUrl=' + this.e30_1 + ', state=' + this.f30_1 + ', properties=' + this.g30_1 + ')';
		  };
		  protoOf(Conversation).hashCode = function () {
		    var result = getStringHashCode(this.y2z_1);
		    result = imul(result, 31) + getStringHashCode(this.z2z_1) | 0;
		    result = imul(result, 31) + this.a30_1.hashCode() | 0;
		    result = imul(result, 31) + (this.b30_1 == null ? 0 : getStringHashCode(this.b30_1)) | 0;
		    result = imul(result, 31) + (this.c30_1 == null ? 0 : this.c30_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.d30_1 == null ? 0 : getStringHashCode(this.d30_1)) | 0;
		    result = imul(result, 31) + (this.e30_1 == null ? 0 : getStringHashCode(this.e30_1)) | 0;
		    result = imul(result, 31) + (this.f30_1 == null ? 0 : this.f30_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.g30_1 == null ? 0 : this.g30_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(Conversation).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Conversation))
		      return false;
		    var tmp0_other_with_cast = other instanceof Conversation ? other : THROW_CCE();
		    if (!(this.y2z_1 === tmp0_other_with_cast.y2z_1))
		      return false;
		    if (!(this.z2z_1 === tmp0_other_with_cast.z2z_1))
		      return false;
		    if (!this.a30_1.equals(tmp0_other_with_cast.a30_1))
		      return false;
		    if (!(this.b30_1 == tmp0_other_with_cast.b30_1))
		      return false;
		    if (!equals(this.c30_1, tmp0_other_with_cast.c30_1))
		      return false;
		    if (!(this.d30_1 == tmp0_other_with_cast.d30_1))
		      return false;
		    if (!(this.e30_1 == tmp0_other_with_cast.e30_1))
		      return false;
		    if (!equals(this.f30_1, tmp0_other_with_cast.f30_1))
		      return false;
		    if (!equals(this.g30_1, tmp0_other_with_cast.g30_1))
		      return false;
		    return true;
		  };
		  function $serializer_159() {
		    $serializer_instance_159 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.api.models.ConversationTimestamp', this, 3);
		    tmp0_serialDesc.pq('created', true);
		    tmp0_serialDesc.pq('updated', true);
		    tmp0_serialDesc.pq('destroyed', true);
		    this.h30_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_159).uf = function () {
		    return this.h30_1;
		  };
		  protoOf($serializer_159).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_159).wf = function (decoder) {
		    var tmp0_desc = this.h30_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return ConversationTimestamp_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_159).i30 = function (encoder, value) {
		    var tmp0_desc = this.h30_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.j30_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.j30_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.k30_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.k30_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.l30_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.l30_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_159).vf = function (encoder, value) {
		    return this.i30(encoder, value instanceof ConversationTimestamp ? value : THROW_CCE());
		  };
		  var $serializer_instance_159;
		  function $serializer_getInstance_159() {
		    if ($serializer_instance_159 == null)
		      new $serializer_159();
		    return $serializer_instance_159;
		  }
		  function ConversationTimestamp_init_$Init$(seen1, created, updated, destroyed, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_159().h30_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.j30_1 = null;
		    else
		      $this.j30_1 = created;
		    if (0 === (seen1 & 2))
		      $this.k30_1 = null;
		    else
		      $this.k30_1 = updated;
		    if (0 === (seen1 & 4))
		      $this.l30_1 = null;
		    else
		      $this.l30_1 = destroyed;
		    return $this;
		  }
		  function ConversationTimestamp_init_$Create$(seen1, created, updated, destroyed, serializationConstructorMarker) {
		    return ConversationTimestamp_init_$Init$(seen1, created, updated, destroyed, serializationConstructorMarker, objectCreate(protoOf(ConversationTimestamp)));
		  }
		  function ConversationTimestamp() {
		  }
		  protoOf(ConversationTimestamp).toString = function () {
		    return 'ConversationTimestamp(created=' + this.j30_1 + ', updated=' + this.k30_1 + ', destroyed=' + this.l30_1 + ')';
		  };
		  protoOf(ConversationTimestamp).hashCode = function () {
		    var result = this.j30_1 == null ? 0 : getStringHashCode(this.j30_1);
		    result = imul(result, 31) + (this.k30_1 == null ? 0 : getStringHashCode(this.k30_1)) | 0;
		    result = imul(result, 31) + (this.l30_1 == null ? 0 : getStringHashCode(this.l30_1)) | 0;
		    return result;
		  };
		  protoOf(ConversationTimestamp).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationTimestamp))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationTimestamp ? other : THROW_CCE();
		    if (!(this.j30_1 == tmp0_other_with_cast.j30_1))
		      return false;
		    if (!(this.k30_1 == tmp0_other_with_cast.k30_1))
		      return false;
		    if (!(this.l30_1 == tmp0_other_with_cast.l30_1))
		      return false;
		    return true;
		  };
		  var ConversationState_ACTIVE_instance;
		  var ConversationState_INACTIVE_instance;
		  var ConversationState_DELETED_instance;
		  function values_1() {
		    return [ConversationState_ACTIVE_getInstance(), ConversationState_INACTIVE_getInstance(), ConversationState_DELETED_getInstance()];
		  }
		  var ConversationState_entriesInitialized;
		  function ConversationState_initEntries() {
		    if (ConversationState_entriesInitialized)
		      return Unit_instance;
		    ConversationState_entriesInitialized = true;
		    ConversationState_ACTIVE_instance = new ConversationState('ACTIVE', 0);
		    ConversationState_INACTIVE_instance = new ConversationState('INACTIVE', 1);
		    ConversationState_DELETED_instance = new ConversationState('DELETED', 2);
		  }
		  function ConversationState(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function ConversationsPage(conversations, previousCursor, nextCursor) {
		    previousCursor = previousCursor === VOID ? null : previousCursor;
		    nextCursor = nextCursor === VOID ? null : nextCursor;
		    this.m30_1 = conversations;
		    this.n30_1 = previousCursor;
		    this.o30_1 = nextCursor;
		  }
		  protoOf(ConversationsPage).toString = function () {
		    return 'ConversationsPage(conversations=' + this.m30_1 + ', previousCursor=' + this.n30_1 + ', nextCursor=' + this.o30_1 + ')';
		  };
		  protoOf(ConversationsPage).hashCode = function () {
		    var result = hashCode(this.m30_1);
		    result = imul(result, 31) + (this.n30_1 == null ? 0 : getStringHashCode(this.n30_1)) | 0;
		    result = imul(result, 31) + (this.o30_1 == null ? 0 : getStringHashCode(this.o30_1)) | 0;
		    return result;
		  };
		  protoOf(ConversationsPage).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationsPage))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationsPage ? other : THROW_CCE();
		    if (!equals(this.m30_1, tmp0_other_with_cast.m30_1))
		      return false;
		    if (!(this.n30_1 == tmp0_other_with_cast.n30_1))
		      return false;
		    if (!(this.o30_1 == tmp0_other_with_cast.o30_1))
		      return false;
		    return true;
		  };
		  function ConversationState_ACTIVE_getInstance() {
		    ConversationState_initEntries();
		    return ConversationState_ACTIVE_instance;
		  }
		  function ConversationState_INACTIVE_getInstance() {
		    ConversationState_initEntries();
		    return ConversationState_INACTIVE_instance;
		  }
		  function ConversationState_DELETED_getInstance() {
		    ConversationState_initEntries();
		    return ConversationState_DELETED_instance;
		  }
		  function EventState(seen, delivered, submitted, rejected, undeliverable) {
		    seen = seen === VOID ? null : seen;
		    delivered = delivered === VOID ? null : delivered;
		    submitted = submitted === VOID ? null : submitted;
		    rejected = rejected === VOID ? null : rejected;
		    undeliverable = undeliverable === VOID ? null : undeliverable;
		    this.p30_1 = seen;
		    this.q30_1 = delivered;
		    this.r30_1 = submitted;
		    this.s30_1 = rejected;
		    this.t30_1 = undeliverable;
		    var tmp = this;
		    // Inline function 'kotlin.collections.reduce' call
		    var tmp0_safe_receiver = this.p30_1;
		    var tmp_0;
		    if (tmp0_safe_receiver == null) {
		      tmp_0 = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.models.EventState.current.<anonymous>' call
		      tmp_0 = new Pair(EventStateType_SEEN_getInstance(), Companion_getInstance().t10(tmp0_safe_receiver));
		    }
		    var tmp_1 = tmp_0;
		    var tmp1_safe_receiver = this.q30_1;
		    var tmp_2;
		    if (tmp1_safe_receiver == null) {
		      tmp_2 = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.models.EventState.current.<anonymous>' call
		      tmp_2 = new Pair(EventStateType_DELIVERED_getInstance(), Companion_getInstance().t10(tmp1_safe_receiver));
		    }
		    var tmp_3 = tmp_2;
		    var tmp2_safe_receiver = this.r30_1;
		    var tmp_4;
		    if (tmp2_safe_receiver == null) {
		      tmp_4 = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.models.EventState.current.<anonymous>' call
		      tmp_4 = new Pair(EventStateType_SUBMITTED_getInstance(), Companion_getInstance().t10(tmp2_safe_receiver));
		    }
		    var tmp_5 = tmp_4;
		    var tmp3_safe_receiver = this.s30_1;
		    var tmp_6;
		    if (tmp3_safe_receiver == null) {
		      tmp_6 = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.models.EventState.current.<anonymous>' call
		      tmp_6 = new Pair(EventStateType_REJECTED_getInstance(), Companion_getInstance().t10(tmp3_safe_receiver));
		    }
		    var tmp_7 = tmp_6;
		    var tmp4_safe_receiver = this.t30_1;
		    var tmp_8;
		    if (tmp4_safe_receiver == null) {
		      tmp_8 = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.models.EventState.current.<anonymous>' call
		      tmp_8 = new Pair(EventStateType_UNDELIVERABLE_getInstance(), Companion_getInstance().t10(tmp4_safe_receiver));
		    }
		    var iterator = listOfNotNull([tmp_1, tmp_3, tmp_5, tmp_7, tmp_8, new Pair(EventStateType_NONE_getInstance(), Companion_getInstance().p10_1)]).p();
		    if (!iterator.q())
		      throw UnsupportedOperationException_init_$Create$("Empty collection can't be reduced.");
		    var accumulator = iterator.s();
		    while (iterator.q()) {
		      // Inline function 'com.vonage.clientcore.core.api.models.EventState.current.<anonymous>' call
		      var acc = accumulator;
		      var pair = iterator.s();
		      // Inline function 'kotlin.takeIf' call
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp_9;
		      // Inline function 'com.vonage.clientcore.core.api.models.EventState.current.<anonymous>.<anonymous>' call
		      if (acc.n5_1.w10(pair.n5_1) > 0) {
		        tmp_9 = acc;
		      } else {
		        tmp_9 = null;
		      }
		      var tmp0_elvis_lhs = tmp_9;
		      accumulator = tmp0_elvis_lhs == null ? pair : tmp0_elvis_lhs;
		    }
		    tmp.u30_1 = accumulator.m5_1;
		  }
		  protoOf(EventState).toString = function () {
		    return 'EventState(seen=' + this.p30_1 + ', delivered=' + this.q30_1 + ', submitted=' + this.r30_1 + ', rejected=' + this.s30_1 + ', undeliverable=' + this.t30_1 + ')';
		  };
		  protoOf(EventState).hashCode = function () {
		    var result = this.p30_1 == null ? 0 : getStringHashCode(this.p30_1);
		    result = imul(result, 31) + (this.q30_1 == null ? 0 : getStringHashCode(this.q30_1)) | 0;
		    result = imul(result, 31) + (this.r30_1 == null ? 0 : getStringHashCode(this.r30_1)) | 0;
		    result = imul(result, 31) + (this.s30_1 == null ? 0 : getStringHashCode(this.s30_1)) | 0;
		    result = imul(result, 31) + (this.t30_1 == null ? 0 : getStringHashCode(this.t30_1)) | 0;
		    return result;
		  };
		  protoOf(EventState).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EventState))
		      return false;
		    var tmp0_other_with_cast = other instanceof EventState ? other : THROW_CCE();
		    if (!(this.p30_1 == tmp0_other_with_cast.p30_1))
		      return false;
		    if (!(this.q30_1 == tmp0_other_with_cast.q30_1))
		      return false;
		    if (!(this.r30_1 == tmp0_other_with_cast.r30_1))
		      return false;
		    if (!(this.s30_1 == tmp0_other_with_cast.s30_1))
		      return false;
		    if (!(this.t30_1 == tmp0_other_with_cast.t30_1))
		      return false;
		    return true;
		  };
		  var EventStateType_SEEN_instance;
		  var EventStateType_DELIVERED_instance;
		  var EventStateType_SUBMITTED_instance;
		  var EventStateType_REJECTED_instance;
		  var EventStateType_UNDELIVERABLE_instance;
		  var EventStateType_NONE_instance;
		  var EventStateType_entriesInitialized;
		  function EventStateType_initEntries() {
		    if (EventStateType_entriesInitialized)
		      return Unit_instance;
		    EventStateType_entriesInitialized = true;
		    EventStateType_SEEN_instance = new EventStateType('SEEN', 0);
		    EventStateType_DELIVERED_instance = new EventStateType('DELIVERED', 1);
		    EventStateType_SUBMITTED_instance = new EventStateType('SUBMITTED', 2);
		    EventStateType_REJECTED_instance = new EventStateType('REJECTED', 3);
		    EventStateType_UNDELIVERABLE_instance = new EventStateType('UNDELIVERABLE', 4);
		    EventStateType_NONE_instance = new EventStateType('NONE', 5);
		  }
		  function EventStateType(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function EventsPage(events, previousCursor, nextCursor) {
		    previousCursor = previousCursor === VOID ? null : previousCursor;
		    nextCursor = nextCursor === VOID ? null : nextCursor;
		    this.v30_1 = events;
		    this.w30_1 = previousCursor;
		    this.x30_1 = nextCursor;
		  }
		  protoOf(EventsPage).toString = function () {
		    return 'EventsPage(events=' + this.v30_1 + ', previousCursor=' + this.w30_1 + ', nextCursor=' + this.x30_1 + ')';
		  };
		  protoOf(EventsPage).hashCode = function () {
		    var result = hashCode(this.v30_1);
		    result = imul(result, 31) + (this.w30_1 == null ? 0 : getStringHashCode(this.w30_1)) | 0;
		    result = imul(result, 31) + (this.x30_1 == null ? 0 : getStringHashCode(this.x30_1)) | 0;
		    return result;
		  };
		  protoOf(EventsPage).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EventsPage))
		      return false;
		    var tmp0_other_with_cast = other instanceof EventsPage ? other : THROW_CCE();
		    if (!equals(this.v30_1, tmp0_other_with_cast.v30_1))
		      return false;
		    if (!(this.w30_1 == tmp0_other_with_cast.w30_1))
		      return false;
		    if (!(this.x30_1 == tmp0_other_with_cast.x30_1))
		      return false;
		    return true;
		  };
		  function PersistentConversationEvent() {
		  }
		  function EmbeddedInfo(memberId, user) {
		    this.y30_1 = memberId;
		    this.z30_1 = user;
		  }
		  protoOf(EmbeddedInfo).toString = function () {
		    return 'EmbeddedInfo(memberId=' + this.y30_1 + ', user=' + this.z30_1 + ')';
		  };
		  protoOf(EmbeddedInfo).hashCode = function () {
		    var result = this.y30_1 == null ? 0 : getStringHashCode(this.y30_1);
		    result = imul(result, 31) + this.z30_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(EmbeddedInfo).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EmbeddedInfo))
		      return false;
		    var tmp0_other_with_cast = other instanceof EmbeddedInfo ? other : THROW_CCE();
		    if (!(this.y30_1 == tmp0_other_with_cast.y30_1))
		      return false;
		    if (!this.z30_1.equals(tmp0_other_with_cast.z30_1))
		      return false;
		    return true;
		  };
		  function Body_15(user, memberId, channel) {
		    this.a31_1 = user;
		    this.b31_1 = memberId;
		    this.c31_1 = channel;
		  }
		  protoOf(Body_15).toString = function () {
		    return 'Body(user=' + this.a31_1 + ', memberId=' + this.b31_1 + ', channel=' + this.c31_1 + ')';
		  };
		  protoOf(Body_15).hashCode = function () {
		    var result = this.a31_1.hashCode();
		    result = imul(result, 31) + getStringHashCode(this.b31_1) | 0;
		    result = imul(result, 31) + this.c31_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(Body_15).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_15))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_15 ? other : THROW_CCE();
		    if (!this.a31_1.equals(tmp0_other_with_cast.a31_1))
		      return false;
		    if (!(this.b31_1 === tmp0_other_with_cast.b31_1))
		      return false;
		    if (!this.c31_1.equals(tmp0_other_with_cast.c31_1))
		      return false;
		    return true;
		  };
		  function MemberInvitedConversationEvent(id, timestamp, conversationId, from, body) {
		    this.d31_1 = id;
		    this.e31_1 = timestamp;
		    this.f31_1 = conversationId;
		    this.g31_1 = from;
		    this.h31_1 = body;
		  }
		  protoOf(MemberInvitedConversationEvent).o2t = function () {
		    return this.f31_1;
		  };
		  protoOf(MemberInvitedConversationEvent).toString = function () {
		    return 'MemberInvitedConversationEvent(id=' + this.d31_1 + ', timestamp=' + this.e31_1 + ', conversationId=' + this.f31_1 + ', from=' + this.g31_1 + ', body=' + this.h31_1 + ')';
		  };
		  protoOf(MemberInvitedConversationEvent).hashCode = function () {
		    var result = this.d31_1;
		    result = imul(result, 31) + getStringHashCode(this.e31_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f31_1) | 0;
		    result = imul(result, 31) + hashCode(this.g31_1) | 0;
		    result = imul(result, 31) + this.h31_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MemberInvitedConversationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberInvitedConversationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberInvitedConversationEvent ? other : THROW_CCE();
		    if (!(this.d31_1 === tmp0_other_with_cast.d31_1))
		      return false;
		    if (!(this.e31_1 === tmp0_other_with_cast.e31_1))
		      return false;
		    if (!(this.f31_1 === tmp0_other_with_cast.f31_1))
		      return false;
		    if (!equals(this.g31_1, tmp0_other_with_cast.g31_1))
		      return false;
		    if (!this.h31_1.equals(tmp0_other_with_cast.h31_1))
		      return false;
		    return true;
		  };
		  function Companion_141() {
		  }
		  protoOf(Companion_141).s24 = function (embedded) {
		    var tmp;
		    if (embedded == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.run' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.models.Companion.invoke.<anonymous>' call
		      var tmp0_safe_receiver = embedded.u1y_1;
		      var tmp_0;
		      if (tmp0_safe_receiver == null) {
		        tmp_0 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.models.Companion.invoke.<anonymous>.<anonymous>' call
		        var tmp0_safe_receiver_0 = embedded.t1y_1;
		        tmp_0 = new EmbeddedInfo(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.e1z_1, tmp0_safe_receiver.g1y());
		      }
		      var tmp1_elvis_lhs = tmp_0;
		      tmp = tmp1_elvis_lhs == null ? System_instance : tmp1_elvis_lhs;
		    }
		    var tmp1_elvis_lhs_0 = tmp;
		    return tmp1_elvis_lhs_0 == null ? System_instance : tmp1_elvis_lhs_0;
		  };
		  var Companion_instance_142;
		  function Companion_getInstance_143() {
		    return Companion_instance_142;
		  }
		  function MemberJoinedConversationEvent(id, timestamp, conversationId, from, body) {
		    this.i31_1 = id;
		    this.j31_1 = timestamp;
		    this.k31_1 = conversationId;
		    this.l31_1 = from;
		    this.m31_1 = body;
		  }
		  protoOf(MemberJoinedConversationEvent).o2t = function () {
		    return this.k31_1;
		  };
		  protoOf(MemberJoinedConversationEvent).toString = function () {
		    return 'MemberJoinedConversationEvent(id=' + this.i31_1 + ', timestamp=' + this.j31_1 + ', conversationId=' + this.k31_1 + ', from=' + this.l31_1 + ', body=' + this.m31_1 + ')';
		  };
		  protoOf(MemberJoinedConversationEvent).hashCode = function () {
		    var result = this.i31_1;
		    result = imul(result, 31) + getStringHashCode(this.j31_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.k31_1) | 0;
		    result = imul(result, 31) + hashCode(this.l31_1) | 0;
		    result = imul(result, 31) + this.m31_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MemberJoinedConversationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberJoinedConversationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberJoinedConversationEvent ? other : THROW_CCE();
		    if (!(this.i31_1 === tmp0_other_with_cast.i31_1))
		      return false;
		    if (!(this.j31_1 === tmp0_other_with_cast.j31_1))
		      return false;
		    if (!(this.k31_1 === tmp0_other_with_cast.k31_1))
		      return false;
		    if (!equals(this.l31_1, tmp0_other_with_cast.l31_1))
		      return false;
		    if (!this.m31_1.equals(tmp0_other_with_cast.m31_1))
		      return false;
		    return true;
		  };
		  function MemberLeftConversationEvent(id, timestamp, conversationId, from, body) {
		    this.n31_1 = id;
		    this.o31_1 = timestamp;
		    this.p31_1 = conversationId;
		    this.q31_1 = from;
		    this.r31_1 = body;
		  }
		  protoOf(MemberLeftConversationEvent).o2t = function () {
		    return this.p31_1;
		  };
		  protoOf(MemberLeftConversationEvent).toString = function () {
		    return 'MemberLeftConversationEvent(id=' + this.n31_1 + ', timestamp=' + this.o31_1 + ', conversationId=' + this.p31_1 + ', from=' + this.q31_1 + ', body=' + this.r31_1 + ')';
		  };
		  protoOf(MemberLeftConversationEvent).hashCode = function () {
		    var result = this.n31_1;
		    result = imul(result, 31) + getStringHashCode(this.o31_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.p31_1) | 0;
		    result = imul(result, 31) + hashCode(this.q31_1) | 0;
		    result = imul(result, 31) + this.r31_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MemberLeftConversationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberLeftConversationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberLeftConversationEvent ? other : THROW_CCE();
		    if (!(this.n31_1 === tmp0_other_with_cast.n31_1))
		      return false;
		    if (!(this.o31_1 === tmp0_other_with_cast.o31_1))
		      return false;
		    if (!(this.p31_1 === tmp0_other_with_cast.p31_1))
		      return false;
		    if (!equals(this.q31_1, tmp0_other_with_cast.q31_1))
		      return false;
		    if (!this.r31_1.equals(tmp0_other_with_cast.r31_1))
		      return false;
		    return true;
		  };
		  function CustomConversationEvent(id, timestamp, conversationId, from, body, eventType) {
		    this.s31_1 = id;
		    this.t31_1 = timestamp;
		    this.u31_1 = conversationId;
		    this.v31_1 = from;
		    this.w31_1 = body;
		    this.x31_1 = eventType;
		  }
		  protoOf(CustomConversationEvent).o2t = function () {
		    return this.u31_1;
		  };
		  protoOf(CustomConversationEvent).toString = function () {
		    return 'CustomConversationEvent(id=' + this.s31_1 + ', timestamp=' + this.t31_1 + ', conversationId=' + this.u31_1 + ', from=' + this.v31_1 + ', body=' + this.w31_1 + ', eventType=' + this.x31_1 + ')';
		  };
		  protoOf(CustomConversationEvent).hashCode = function () {
		    var result = this.s31_1;
		    result = imul(result, 31) + getStringHashCode(this.t31_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.u31_1) | 0;
		    result = imul(result, 31) + hashCode(this.v31_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.w31_1) | 0;
		    result = imul(result, 31) + (this.x31_1 == null ? 0 : getStringHashCode(this.x31_1)) | 0;
		    return result;
		  };
		  protoOf(CustomConversationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CustomConversationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof CustomConversationEvent ? other : THROW_CCE();
		    if (!(this.s31_1 === tmp0_other_with_cast.s31_1))
		      return false;
		    if (!(this.t31_1 === tmp0_other_with_cast.t31_1))
		      return false;
		    if (!(this.u31_1 === tmp0_other_with_cast.u31_1))
		      return false;
		    if (!equals(this.v31_1, tmp0_other_with_cast.v31_1))
		      return false;
		    if (!(this.w31_1 === tmp0_other_with_cast.w31_1))
		      return false;
		    if (!(this.x31_1 == tmp0_other_with_cast.x31_1))
		      return false;
		    return true;
		  };
		  function EphemeralConversationEvent(timestamp, conversationId, from, body) {
		    this.y31_1 = timestamp;
		    this.z31_1 = conversationId;
		    this.a32_1 = from;
		    this.b32_1 = body;
		  }
		  protoOf(EphemeralConversationEvent).o2t = function () {
		    return this.z31_1;
		  };
		  protoOf(EphemeralConversationEvent).toString = function () {
		    return 'EphemeralConversationEvent(timestamp=' + this.y31_1 + ', conversationId=' + this.z31_1 + ', from=' + this.a32_1 + ', body=' + this.b32_1 + ')';
		  };
		  protoOf(EphemeralConversationEvent).hashCode = function () {
		    var result = getStringHashCode(this.y31_1);
		    result = imul(result, 31) + getStringHashCode(this.z31_1) | 0;
		    result = imul(result, 31) + hashCode(this.a32_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.b32_1) | 0;
		    return result;
		  };
		  protoOf(EphemeralConversationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EphemeralConversationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof EphemeralConversationEvent ? other : THROW_CCE();
		    if (!(this.y31_1 === tmp0_other_with_cast.y31_1))
		      return false;
		    if (!(this.z31_1 === tmp0_other_with_cast.z31_1))
		      return false;
		    if (!equals(this.a32_1, tmp0_other_with_cast.a32_1))
		      return false;
		    if (!(this.b32_1 === tmp0_other_with_cast.b32_1))
		      return false;
		    return true;
		  };
		  function EventStateBody(eventId) {
		    this.c32_1 = eventId;
		  }
		  protoOf(EventStateBody).toString = function () {
		    return 'EventStateBody(eventId=' + this.c32_1 + ')';
		  };
		  protoOf(EventStateBody).hashCode = function () {
		    return this.c32_1;
		  };
		  protoOf(EventStateBody).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EventStateBody))
		      return false;
		    var tmp0_other_with_cast = other instanceof EventStateBody ? other : THROW_CCE();
		    if (!(this.c32_1 === tmp0_other_with_cast.c32_1))
		      return false;
		    return true;
		  };
		  function EventDeleteConversationEvent(id, timestamp, conversationId, from, body) {
		    this.d32_1 = id;
		    this.e32_1 = timestamp;
		    this.f32_1 = conversationId;
		    this.g32_1 = from;
		    this.h32_1 = body;
		  }
		  protoOf(EventDeleteConversationEvent).o2t = function () {
		    return this.f32_1;
		  };
		  protoOf(EventDeleteConversationEvent).toString = function () {
		    return 'EventDeleteConversationEvent(id=' + this.d32_1 + ', timestamp=' + this.e32_1 + ', conversationId=' + this.f32_1 + ', from=' + this.g32_1 + ', body=' + this.h32_1 + ')';
		  };
		  protoOf(EventDeleteConversationEvent).hashCode = function () {
		    var result = this.d32_1;
		    result = imul(result, 31) + getStringHashCode(this.e32_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f32_1) | 0;
		    result = imul(result, 31) + hashCode(this.g32_1) | 0;
		    result = imul(result, 31) + this.h32_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(EventDeleteConversationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EventDeleteConversationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof EventDeleteConversationEvent ? other : THROW_CCE();
		    if (!(this.d32_1 === tmp0_other_with_cast.d32_1))
		      return false;
		    if (!(this.e32_1 === tmp0_other_with_cast.e32_1))
		      return false;
		    if (!(this.f32_1 === tmp0_other_with_cast.f32_1))
		      return false;
		    if (!equals(this.g32_1, tmp0_other_with_cast.g32_1))
		      return false;
		    if (!this.h32_1.equals(tmp0_other_with_cast.h32_1))
		      return false;
		    return true;
		  };
		  function MessageDeliveredEvent(id, timestamp, conversationId, from, body) {
		    this.i32_1 = id;
		    this.j32_1 = timestamp;
		    this.k32_1 = conversationId;
		    this.l32_1 = from;
		    this.m32_1 = body;
		  }
		  protoOf(MessageDeliveredEvent).o2t = function () {
		    return this.k32_1;
		  };
		  protoOf(MessageDeliveredEvent).toString = function () {
		    return 'MessageDeliveredEvent(id=' + this.i32_1 + ', timestamp=' + this.j32_1 + ', conversationId=' + this.k32_1 + ', from=' + this.l32_1 + ', body=' + this.m32_1 + ')';
		  };
		  protoOf(MessageDeliveredEvent).hashCode = function () {
		    var result = this.i32_1;
		    result = imul(result, 31) + getStringHashCode(this.j32_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.k32_1) | 0;
		    result = imul(result, 31) + hashCode(this.l32_1) | 0;
		    result = imul(result, 31) + this.m32_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MessageDeliveredEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageDeliveredEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageDeliveredEvent ? other : THROW_CCE();
		    if (!(this.i32_1 === tmp0_other_with_cast.i32_1))
		      return false;
		    if (!(this.j32_1 === tmp0_other_with_cast.j32_1))
		      return false;
		    if (!(this.k32_1 === tmp0_other_with_cast.k32_1))
		      return false;
		    if (!equals(this.l32_1, tmp0_other_with_cast.l32_1))
		      return false;
		    if (!this.m32_1.equals(tmp0_other_with_cast.m32_1))
		      return false;
		    return true;
		  };
		  function MessageRejectedEvent(id, timestamp, conversationId, from, body) {
		    this.n32_1 = id;
		    this.o32_1 = timestamp;
		    this.p32_1 = conversationId;
		    this.q32_1 = from;
		    this.r32_1 = body;
		  }
		  protoOf(MessageRejectedEvent).o2t = function () {
		    return this.p32_1;
		  };
		  protoOf(MessageRejectedEvent).toString = function () {
		    return 'MessageRejectedEvent(id=' + this.n32_1 + ', timestamp=' + this.o32_1 + ', conversationId=' + this.p32_1 + ', from=' + this.q32_1 + ', body=' + this.r32_1 + ')';
		  };
		  protoOf(MessageRejectedEvent).hashCode = function () {
		    var result = this.n32_1;
		    result = imul(result, 31) + getStringHashCode(this.o32_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.p32_1) | 0;
		    result = imul(result, 31) + hashCode(this.q32_1) | 0;
		    result = imul(result, 31) + this.r32_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MessageRejectedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageRejectedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageRejectedEvent ? other : THROW_CCE();
		    if (!(this.n32_1 === tmp0_other_with_cast.n32_1))
		      return false;
		    if (!(this.o32_1 === tmp0_other_with_cast.o32_1))
		      return false;
		    if (!(this.p32_1 === tmp0_other_with_cast.p32_1))
		      return false;
		    if (!equals(this.q32_1, tmp0_other_with_cast.q32_1))
		      return false;
		    if (!this.r32_1.equals(tmp0_other_with_cast.r32_1))
		      return false;
		    return true;
		  };
		  function MessageUndeliverableEvent(id, timestamp, conversationId, from, body) {
		    this.s32_1 = id;
		    this.t32_1 = timestamp;
		    this.u32_1 = conversationId;
		    this.v32_1 = from;
		    this.w32_1 = body;
		  }
		  protoOf(MessageUndeliverableEvent).o2t = function () {
		    return this.u32_1;
		  };
		  protoOf(MessageUndeliverableEvent).toString = function () {
		    return 'MessageUndeliverableEvent(id=' + this.s32_1 + ', timestamp=' + this.t32_1 + ', conversationId=' + this.u32_1 + ', from=' + this.v32_1 + ', body=' + this.w32_1 + ')';
		  };
		  protoOf(MessageUndeliverableEvent).hashCode = function () {
		    var result = this.s32_1;
		    result = imul(result, 31) + getStringHashCode(this.t32_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.u32_1) | 0;
		    result = imul(result, 31) + hashCode(this.v32_1) | 0;
		    result = imul(result, 31) + this.w32_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MessageUndeliverableEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageUndeliverableEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageUndeliverableEvent ? other : THROW_CCE();
		    if (!(this.s32_1 === tmp0_other_with_cast.s32_1))
		      return false;
		    if (!(this.t32_1 === tmp0_other_with_cast.t32_1))
		      return false;
		    if (!(this.u32_1 === tmp0_other_with_cast.u32_1))
		      return false;
		    if (!equals(this.v32_1, tmp0_other_with_cast.v32_1))
		      return false;
		    if (!this.w32_1.equals(tmp0_other_with_cast.w32_1))
		      return false;
		    return true;
		  };
		  function MessageSubmittedEvent(id, timestamp, conversationId, from, body) {
		    this.x32_1 = id;
		    this.y32_1 = timestamp;
		    this.z32_1 = conversationId;
		    this.a33_1 = from;
		    this.b33_1 = body;
		  }
		  protoOf(MessageSubmittedEvent).o2t = function () {
		    return this.z32_1;
		  };
		  protoOf(MessageSubmittedEvent).toString = function () {
		    return 'MessageSubmittedEvent(id=' + this.x32_1 + ', timestamp=' + this.y32_1 + ', conversationId=' + this.z32_1 + ', from=' + this.a33_1 + ', body=' + this.b33_1 + ')';
		  };
		  protoOf(MessageSubmittedEvent).hashCode = function () {
		    var result = this.x32_1;
		    result = imul(result, 31) + getStringHashCode(this.y32_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.z32_1) | 0;
		    result = imul(result, 31) + hashCode(this.a33_1) | 0;
		    result = imul(result, 31) + this.b33_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MessageSubmittedEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageSubmittedEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageSubmittedEvent ? other : THROW_CCE();
		    if (!(this.x32_1 === tmp0_other_with_cast.x32_1))
		      return false;
		    if (!(this.y32_1 === tmp0_other_with_cast.y32_1))
		      return false;
		    if (!(this.z32_1 === tmp0_other_with_cast.z32_1))
		      return false;
		    if (!equals(this.a33_1, tmp0_other_with_cast.a33_1))
		      return false;
		    if (!this.b33_1.equals(tmp0_other_with_cast.b33_1))
		      return false;
		    return true;
		  };
		  function MessageSeenEvent(id, timestamp, conversationId, from, body) {
		    this.c33_1 = id;
		    this.d33_1 = timestamp;
		    this.e33_1 = conversationId;
		    this.f33_1 = from;
		    this.g33_1 = body;
		  }
		  protoOf(MessageSeenEvent).o2t = function () {
		    return this.e33_1;
		  };
		  protoOf(MessageSeenEvent).toString = function () {
		    return 'MessageSeenEvent(id=' + this.c33_1 + ', timestamp=' + this.d33_1 + ', conversationId=' + this.e33_1 + ', from=' + this.f33_1 + ', body=' + this.g33_1 + ')';
		  };
		  protoOf(MessageSeenEvent).hashCode = function () {
		    var result = this.c33_1;
		    result = imul(result, 31) + getStringHashCode(this.d33_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.e33_1) | 0;
		    result = imul(result, 31) + hashCode(this.f33_1) | 0;
		    result = imul(result, 31) + this.g33_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(MessageSeenEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageSeenEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageSeenEvent ? other : THROW_CCE();
		    if (!(this.c33_1 === tmp0_other_with_cast.c33_1))
		      return false;
		    if (!(this.d33_1 === tmp0_other_with_cast.d33_1))
		      return false;
		    if (!(this.e33_1 === tmp0_other_with_cast.e33_1))
		      return false;
		    if (!equals(this.f33_1, tmp0_other_with_cast.f33_1))
		      return false;
		    if (!this.g33_1.equals(tmp0_other_with_cast.g33_1))
		      return false;
		    return true;
		  };
		  function System() {
		  }
		  var System_instance;
		  function System_getInstance() {
		    return System_instance;
		  }
		  function EventStateType_SEEN_getInstance() {
		    EventStateType_initEntries();
		    return EventStateType_SEEN_instance;
		  }
		  function EventStateType_DELIVERED_getInstance() {
		    EventStateType_initEntries();
		    return EventStateType_DELIVERED_instance;
		  }
		  function EventStateType_SUBMITTED_getInstance() {
		    EventStateType_initEntries();
		    return EventStateType_SUBMITTED_instance;
		  }
		  function EventStateType_REJECTED_getInstance() {
		    EventStateType_initEntries();
		    return EventStateType_REJECTED_instance;
		  }
		  function EventStateType_UNDELIVERABLE_getInstance() {
		    EventStateType_initEntries();
		    return EventStateType_UNDELIVERABLE_instance;
		  }
		  function EventStateType_NONE_getInstance() {
		    EventStateType_initEntries();
		    return EventStateType_NONE_instance;
		  }
		  function Companion_142() {
		  }
		  var Companion_instance_143;
		  function Companion_getInstance_144() {
		    return Companion_instance_143;
		  }
		  function $serializer_160() {
		    $serializer_instance_160 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.api.models.MediaState', this, 6);
		    tmp0_serialDesc.pq('mute', false);
		    tmp0_serialDesc.pq('earmuff', false);
		    tmp0_serialDesc.pq('play_stream', false);
		    tmp0_serialDesc.pq('tts', false);
		    tmp0_serialDesc.pq('recording', false);
		    tmp0_serialDesc.pq('transcribing', false);
		    this.h33_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_160).uf = function () {
		    return this.h33_1;
		  };
		  protoOf($serializer_160).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
		  };
		  protoOf($serializer_160).wf = function (decoder) {
		    var tmp0_desc = this.h33_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = false;
		    var tmp5_local1 = false;
		    var tmp6_local2 = false;
		    var tmp7_local3 = false;
		    var tmp8_local4 = false;
		    var tmp9_local5 = false;
		    var tmp10_input = decoder.ej(tmp0_desc);
		    if (tmp10_input.uj()) {
		      tmp4_local0 = tmp10_input.gj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp10_input.gj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp10_input.gj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp10_input.gj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp10_input.gj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp10_input.gj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp10_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp10_input.gj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp10_input.gj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp10_input.gj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp10_input.gj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp10_input.gj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp10_input.gj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp10_input.fj(tmp0_desc);
		    return MediaState_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
		  };
		  protoOf($serializer_160).i33 = function (encoder, value) {
		    var tmp0_desc = this.h33_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.lk(tmp0_desc, 0, value.j33_1);
		    tmp1_output.lk(tmp0_desc, 1, value.k33_1);
		    tmp1_output.lk(tmp0_desc, 2, value.l33_1);
		    tmp1_output.lk(tmp0_desc, 3, value.m33_1);
		    tmp1_output.lk(tmp0_desc, 4, value.n33_1);
		    tmp1_output.lk(tmp0_desc, 5, value.o33_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_160).vf = function (encoder, value) {
		    return this.i33(encoder, value instanceof MediaState ? value : THROW_CCE());
		  };
		  var $serializer_instance_160;
		  function $serializer_getInstance_160() {
		    if ($serializer_instance_160 == null)
		      new $serializer_160();
		    return $serializer_instance_160;
		  }
		  function MediaState_init_$Init$(seen1, mute, earmuff, playStream, tts, recording, transcribing, serializationConstructorMarker, $this) {
		    if (!(63 === (63 & seen1))) {
		      throwMissingFieldException(seen1, 63, $serializer_getInstance_160().h33_1);
		    }
		    $this.j33_1 = mute;
		    $this.k33_1 = earmuff;
		    $this.l33_1 = playStream;
		    $this.m33_1 = tts;
		    $this.n33_1 = recording;
		    $this.o33_1 = transcribing;
		    return $this;
		  }
		  function MediaState_init_$Create$(seen1, mute, earmuff, playStream, tts, recording, transcribing, serializationConstructorMarker) {
		    return MediaState_init_$Init$(seen1, mute, earmuff, playStream, tts, recording, transcribing, serializationConstructorMarker, objectCreate(protoOf(MediaState)));
		  }
		  function MediaState(mute, earmuff, playStream, tts, recording, transcribing) {
		    this.j33_1 = mute;
		    this.k33_1 = earmuff;
		    this.l33_1 = playStream;
		    this.m33_1 = tts;
		    this.n33_1 = recording;
		    this.o33_1 = transcribing;
		  }
		  protoOf(MediaState).toString = function () {
		    return 'MediaState(mute=' + this.j33_1 + ', earmuff=' + this.k33_1 + ', playStream=' + this.l33_1 + ', tts=' + this.m33_1 + ', recording=' + this.n33_1 + ', transcribing=' + this.o33_1 + ')';
		  };
		  protoOf(MediaState).hashCode = function () {
		    var result = getBooleanHashCode(this.j33_1);
		    result = imul(result, 31) + getBooleanHashCode(this.k33_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.l33_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.m33_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.n33_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.o33_1) | 0;
		    return result;
		  };
		  protoOf(MediaState).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MediaState))
		      return false;
		    var tmp0_other_with_cast = other instanceof MediaState ? other : THROW_CCE();
		    if (!(this.j33_1 === tmp0_other_with_cast.j33_1))
		      return false;
		    if (!(this.k33_1 === tmp0_other_with_cast.k33_1))
		      return false;
		    if (!(this.l33_1 === tmp0_other_with_cast.l33_1))
		      return false;
		    if (!(this.m33_1 === tmp0_other_with_cast.m33_1))
		      return false;
		    if (!(this.n33_1 === tmp0_other_with_cast.n33_1))
		      return false;
		    if (!(this.o33_1 === tmp0_other_with_cast.o33_1))
		      return false;
		    return true;
		  };
		  function Companion_143() {
		  }
		  protoOf(Companion_143).p33 = function (response) {
		    return new Leg(response.a1j_1, response.g1j_1, response.f1j_1, response.b1j_1, response.c1j_1, response.d1j_1, response.e1j_1, response.h1j_1, response.i1j_1, response.j1j_1);
		  };
		  var Companion_instance_144;
		  function Companion_getInstance_145() {
		    return Companion_instance_144;
		  }
		  function Leg(id, type, direction, conversationId, status, startTime, endTime, from, to, mediaState) {
		    this.q33_1 = id;
		    this.r33_1 = type;
		    this.s33_1 = direction;
		    this.t33_1 = conversationId;
		    this.u33_1 = status;
		    this.v33_1 = startTime;
		    this.w33_1 = endTime;
		    this.x33_1 = from;
		    this.y33_1 = to;
		    this.z33_1 = mediaState;
		  }
		  protoOf(Leg).toString = function () {
		    return 'Leg(id=' + this.q33_1 + ', type=' + this.r33_1 + ', direction=' + this.s33_1 + ', conversationId=' + this.t33_1 + ', status=' + this.u33_1 + ', startTime=' + this.v33_1 + ', endTime=' + this.w33_1 + ', from=' + this.x33_1 + ', to=' + this.y33_1 + ', mediaState=' + this.z33_1 + ')';
		  };
		  protoOf(Leg).hashCode = function () {
		    var result = getStringHashCode(this.q33_1);
		    result = imul(result, 31) + getStringHashCode(this.r33_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.s33_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.t33_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.u33_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.v33_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.w33_1) | 0;
		    result = imul(result, 31) + this.x33_1.hashCode() | 0;
		    result = imul(result, 31) + this.y33_1.hashCode() | 0;
		    result = imul(result, 31) + (this.z33_1 == null ? 0 : this.z33_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(Leg).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Leg))
		      return false;
		    var tmp0_other_with_cast = other instanceof Leg ? other : THROW_CCE();
		    if (!(this.q33_1 === tmp0_other_with_cast.q33_1))
		      return false;
		    if (!(this.r33_1 === tmp0_other_with_cast.r33_1))
		      return false;
		    if (!(this.s33_1 === tmp0_other_with_cast.s33_1))
		      return false;
		    if (!(this.t33_1 === tmp0_other_with_cast.t33_1))
		      return false;
		    if (!(this.u33_1 === tmp0_other_with_cast.u33_1))
		      return false;
		    if (!(this.v33_1 === tmp0_other_with_cast.v33_1))
		      return false;
		    if (!(this.w33_1 === tmp0_other_with_cast.w33_1))
		      return false;
		    if (!this.x33_1.equals(tmp0_other_with_cast.x33_1))
		      return false;
		    if (!this.y33_1.equals(tmp0_other_with_cast.y33_1))
		      return false;
		    if (!equals(this.z33_1, tmp0_other_with_cast.z33_1))
		      return false;
		    return true;
		  };
		  function LegsPage(legs, previousCursor, nextCursor) {
		    previousCursor = previousCursor === VOID ? null : previousCursor;
		    nextCursor = nextCursor === VOID ? null : nextCursor;
		    this.a34_1 = legs;
		    this.b34_1 = previousCursor;
		    this.c34_1 = nextCursor;
		  }
		  protoOf(LegsPage).toString = function () {
		    return 'LegsPage(legs=' + this.a34_1 + ', previousCursor=' + this.b34_1 + ', nextCursor=' + this.c34_1 + ')';
		  };
		  protoOf(LegsPage).hashCode = function () {
		    var result = hashCode(this.a34_1);
		    result = imul(result, 31) + (this.b34_1 == null ? 0 : getStringHashCode(this.b34_1)) | 0;
		    result = imul(result, 31) + (this.c34_1 == null ? 0 : getStringHashCode(this.c34_1)) | 0;
		    return result;
		  };
		  protoOf(LegsPage).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof LegsPage))
		      return false;
		    var tmp0_other_with_cast = other instanceof LegsPage ? other : THROW_CCE();
		    if (!equals(this.a34_1, tmp0_other_with_cast.a34_1))
		      return false;
		    if (!(this.b34_1 == tmp0_other_with_cast.b34_1))
		      return false;
		    if (!(this.c34_1 == tmp0_other_with_cast.c34_1))
		      return false;
		    return true;
		  };
		  var MemberState_INVITED_instance;
		  var MemberState_JOINED_instance;
		  var MemberState_LEFT_instance;
		  var MemberState_UNKNOWN_instance;
		  function values_2() {
		    return [MemberState_INVITED_getInstance(), MemberState_JOINED_getInstance(), MemberState_LEFT_getInstance(), MemberState_UNKNOWN_getInstance()];
		  }
		  var MemberState_entriesInitialized;
		  function MemberState_initEntries() {
		    if (MemberState_entriesInitialized)
		      return Unit_instance;
		    MemberState_entriesInitialized = true;
		    MemberState_INVITED_instance = new MemberState('INVITED', 0);
		    MemberState_JOINED_instance = new MemberState('JOINED', 1);
		    MemberState_LEFT_instance = new MemberState('LEFT', 2);
		    MemberState_UNKNOWN_instance = new MemberState('UNKNOWN', 3);
		  }
		  function MemberState(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function Companion_144() {
		  }
		  protoOf(Companion_144).z2t = function (response) {
		    var tmp0_safe_receiver = response.g1r_1;
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1r_1;
		    return new Member(response.e1r_1, response.f1r_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g1y());
		  };
		  var Companion_instance_145;
		  function Companion_getInstance_146() {
		    return Companion_instance_145;
		  }
		  function Member(id, state, user, channel, timestamp) {
		    user = user === VOID ? null : user;
		    channel = channel === VOID ? null : channel;
		    timestamp = timestamp === VOID ? null : timestamp;
		    this.d34_1 = id;
		    this.e34_1 = state;
		    this.f34_1 = user;
		    this.g34_1 = channel;
		    this.h34_1 = timestamp;
		  }
		  protoOf(Member).toString = function () {
		    return 'Member(id=' + this.d34_1 + ', state=' + this.e34_1 + ', user=' + this.f34_1 + ', channel=' + this.g34_1 + ', timestamp=' + this.h34_1 + ')';
		  };
		  protoOf(Member).hashCode = function () {
		    var result = getStringHashCode(this.d34_1);
		    result = imul(result, 31) + this.e34_1.hashCode() | 0;
		    result = imul(result, 31) + (this.f34_1 == null ? 0 : this.f34_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.g34_1 == null ? 0 : this.g34_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.h34_1 == null ? 0 : this.h34_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(Member).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Member))
		      return false;
		    var tmp0_other_with_cast = other instanceof Member ? other : THROW_CCE();
		    if (!(this.d34_1 === tmp0_other_with_cast.d34_1))
		      return false;
		    if (!this.e34_1.equals(tmp0_other_with_cast.e34_1))
		      return false;
		    if (!equals(this.f34_1, tmp0_other_with_cast.f34_1))
		      return false;
		    if (!equals(this.g34_1, tmp0_other_with_cast.g34_1))
		      return false;
		    if (!equals(this.h34_1, tmp0_other_with_cast.h34_1))
		      return false;
		    return true;
		  };
		  function $serializer_161() {
		    $serializer_instance_161 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.api.models.MemberTimestamp', this, 3);
		    tmp0_serialDesc.pq('invited', true);
		    tmp0_serialDesc.pq('joined', true);
		    tmp0_serialDesc.pq('left', true);
		    this.i34_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_161).uf = function () {
		    return this.i34_1;
		  };
		  protoOf($serializer_161).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_161).wf = function (decoder) {
		    var tmp0_desc = this.i34_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return MemberTimestamp_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_161).j34 = function (encoder, value) {
		    var tmp0_desc = this.i34_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.k34_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.k34_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.l34_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.l34_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.m34_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.m34_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_161).vf = function (encoder, value) {
		    return this.j34(encoder, value instanceof MemberTimestamp ? value : THROW_CCE());
		  };
		  var $serializer_instance_161;
		  function $serializer_getInstance_161() {
		    if ($serializer_instance_161 == null)
		      new $serializer_161();
		    return $serializer_instance_161;
		  }
		  function MemberTimestamp_init_$Init$(seen1, invited, joined, left, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_161().i34_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.k34_1 = null;
		    else
		      $this.k34_1 = invited;
		    if (0 === (seen1 & 2))
		      $this.l34_1 = null;
		    else
		      $this.l34_1 = joined;
		    if (0 === (seen1 & 4))
		      $this.m34_1 = null;
		    else
		      $this.m34_1 = left;
		    return $this;
		  }
		  function MemberTimestamp_init_$Create$(seen1, invited, joined, left, serializationConstructorMarker) {
		    return MemberTimestamp_init_$Init$(seen1, invited, joined, left, serializationConstructorMarker, objectCreate(protoOf(MemberTimestamp)));
		  }
		  function MemberTimestamp() {
		  }
		  protoOf(MemberTimestamp).toString = function () {
		    return 'MemberTimestamp(invited=' + this.k34_1 + ', joined=' + this.l34_1 + ', left=' + this.m34_1 + ')';
		  };
		  protoOf(MemberTimestamp).hashCode = function () {
		    var result = this.k34_1 == null ? 0 : getStringHashCode(this.k34_1);
		    result = imul(result, 31) + (this.l34_1 == null ? 0 : getStringHashCode(this.l34_1)) | 0;
		    result = imul(result, 31) + (this.m34_1 == null ? 0 : getStringHashCode(this.m34_1)) | 0;
		    return result;
		  };
		  protoOf(MemberTimestamp).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberTimestamp))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberTimestamp ? other : THROW_CCE();
		    if (!(this.k34_1 == tmp0_other_with_cast.k34_1))
		      return false;
		    if (!(this.l34_1 == tmp0_other_with_cast.l34_1))
		      return false;
		    if (!(this.m34_1 == tmp0_other_with_cast.m34_1))
		      return false;
		    return true;
		  };
		  function MembersPage(members, previousCursor, nextCursor) {
		    previousCursor = previousCursor === VOID ? null : previousCursor;
		    nextCursor = nextCursor === VOID ? null : nextCursor;
		    this.n34_1 = members;
		    this.o34_1 = previousCursor;
		    this.p34_1 = nextCursor;
		  }
		  protoOf(MembersPage).toString = function () {
		    return 'MembersPage(members=' + this.n34_1 + ', previousCursor=' + this.o34_1 + ', nextCursor=' + this.p34_1 + ')';
		  };
		  protoOf(MembersPage).hashCode = function () {
		    var result = hashCode(this.n34_1);
		    result = imul(result, 31) + (this.o34_1 == null ? 0 : getStringHashCode(this.o34_1)) | 0;
		    result = imul(result, 31) + (this.p34_1 == null ? 0 : getStringHashCode(this.p34_1)) | 0;
		    return result;
		  };
		  protoOf(MembersPage).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MembersPage))
		      return false;
		    var tmp0_other_with_cast = other instanceof MembersPage ? other : THROW_CCE();
		    if (!equals(this.n34_1, tmp0_other_with_cast.n34_1))
		      return false;
		    if (!(this.o34_1 == tmp0_other_with_cast.o34_1))
		      return false;
		    if (!(this.p34_1 == tmp0_other_with_cast.p34_1))
		      return false;
		    return true;
		  };
		  function MemberState_INVITED_getInstance() {
		    MemberState_initEntries();
		    return MemberState_INVITED_instance;
		  }
		  function MemberState_JOINED_getInstance() {
		    MemberState_initEntries();
		    return MemberState_JOINED_instance;
		  }
		  function MemberState_LEFT_getInstance() {
		    MemberState_initEntries();
		    return MemberState_LEFT_instance;
		  }
		  function MemberState_UNKNOWN_getInstance() {
		    MemberState_initEntries();
		    return MemberState_UNKNOWN_instance;
		  }
		  function Body_16(text, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.q34_1 = text;
		    this.r34_1 = deleted;
		  }
		  protoOf(Body_16).toString = function () {
		    return 'Body(text=' + this.q34_1 + ', deleted=' + this.r34_1 + ')';
		  };
		  protoOf(Body_16).hashCode = function () {
		    var result = getStringHashCode(this.q34_1);
		    result = imul(result, 31) + (this.r34_1 == null ? 0 : getStringHashCode(this.r34_1)) | 0;
		    return result;
		  };
		  protoOf(Body_16).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_16))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_16 ? other : THROW_CCE();
		    if (!(this.q34_1 === tmp0_other_with_cast.q34_1))
		      return false;
		    if (!(this.r34_1 == tmp0_other_with_cast.r34_1))
		      return false;
		    return true;
		  };
		  function MessageTextEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.s34_1 = timestamp;
		    this.t34_1 = conversationId;
		    this.u34_1 = id;
		    this.v34_1 = from;
		    this.w34_1 = body;
		    this.x34_1 = memberStatuses;
		  }
		  protoOf(MessageTextEvent).o2t = function () {
		    return this.t34_1;
		  };
		  protoOf(MessageTextEvent).t27 = function () {
		    return this.u34_1;
		  };
		  protoOf(MessageTextEvent).toString = function () {
		    return 'MessageTextEvent(timestamp=' + this.s34_1 + ', conversationId=' + this.t34_1 + ', id=' + this.u34_1 + ', from=' + this.v34_1 + ', body=' + this.w34_1 + ', memberStatuses=' + this.x34_1 + ')';
		  };
		  protoOf(MessageTextEvent).hashCode = function () {
		    var result = getStringHashCode(this.s34_1);
		    result = imul(result, 31) + getStringHashCode(this.t34_1) | 0;
		    result = imul(result, 31) + this.u34_1 | 0;
		    result = imul(result, 31) + hashCode(this.v34_1) | 0;
		    result = imul(result, 31) + this.w34_1.hashCode() | 0;
		    result = imul(result, 31) + (this.x34_1 == null ? 0 : hashCode(this.x34_1)) | 0;
		    return result;
		  };
		  protoOf(MessageTextEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageTextEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageTextEvent ? other : THROW_CCE();
		    if (!(this.s34_1 === tmp0_other_with_cast.s34_1))
		      return false;
		    if (!(this.t34_1 === tmp0_other_with_cast.t34_1))
		      return false;
		    if (!(this.u34_1 === tmp0_other_with_cast.u34_1))
		      return false;
		    if (!equals(this.v34_1, tmp0_other_with_cast.v34_1))
		      return false;
		    if (!this.w34_1.equals(tmp0_other_with_cast.w34_1))
		      return false;
		    if (!equals(this.x34_1, tmp0_other_with_cast.x34_1))
		      return false;
		    return true;
		  };
		  function Body_17(customData, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.y34_1 = customData;
		    this.z34_1 = deleted;
		  }
		  protoOf(Body_17).toString = function () {
		    return 'Body(customData=' + this.y34_1 + ', deleted=' + this.z34_1 + ')';
		  };
		  protoOf(Body_17).hashCode = function () {
		    var result = getStringHashCode(this.y34_1);
		    result = imul(result, 31) + (this.z34_1 == null ? 0 : getStringHashCode(this.z34_1)) | 0;
		    return result;
		  };
		  protoOf(Body_17).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_17))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_17 ? other : THROW_CCE();
		    if (!(this.y34_1 === tmp0_other_with_cast.y34_1))
		      return false;
		    if (!(this.z34_1 == tmp0_other_with_cast.z34_1))
		      return false;
		    return true;
		  };
		  function MessageCustomEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.a35_1 = timestamp;
		    this.b35_1 = conversationId;
		    this.c35_1 = id;
		    this.d35_1 = from;
		    this.e35_1 = body;
		    this.f35_1 = memberStatuses;
		  }
		  protoOf(MessageCustomEvent).o2t = function () {
		    return this.b35_1;
		  };
		  protoOf(MessageCustomEvent).t27 = function () {
		    return this.c35_1;
		  };
		  protoOf(MessageCustomEvent).toString = function () {
		    return 'MessageCustomEvent(timestamp=' + this.a35_1 + ', conversationId=' + this.b35_1 + ', id=' + this.c35_1 + ', from=' + this.d35_1 + ', body=' + this.e35_1 + ', memberStatuses=' + this.f35_1 + ')';
		  };
		  protoOf(MessageCustomEvent).hashCode = function () {
		    var result = getStringHashCode(this.a35_1);
		    result = imul(result, 31) + getStringHashCode(this.b35_1) | 0;
		    result = imul(result, 31) + this.c35_1 | 0;
		    result = imul(result, 31) + hashCode(this.d35_1) | 0;
		    result = imul(result, 31) + this.e35_1.hashCode() | 0;
		    result = imul(result, 31) + (this.f35_1 == null ? 0 : hashCode(this.f35_1)) | 0;
		    return result;
		  };
		  protoOf(MessageCustomEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageCustomEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageCustomEvent ? other : THROW_CCE();
		    if (!(this.a35_1 === tmp0_other_with_cast.a35_1))
		      return false;
		    if (!(this.b35_1 === tmp0_other_with_cast.b35_1))
		      return false;
		    if (!(this.c35_1 === tmp0_other_with_cast.c35_1))
		      return false;
		    if (!equals(this.d35_1, tmp0_other_with_cast.d35_1))
		      return false;
		    if (!this.e35_1.equals(tmp0_other_with_cast.e35_1))
		      return false;
		    if (!equals(this.f35_1, tmp0_other_with_cast.f35_1))
		      return false;
		    return true;
		  };
		  function Body_18(imageUrl, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.g35_1 = imageUrl;
		    this.h35_1 = deleted;
		  }
		  protoOf(Body_18).toString = function () {
		    return 'Body(imageUrl=' + this.g35_1 + ', deleted=' + this.h35_1 + ')';
		  };
		  protoOf(Body_18).hashCode = function () {
		    var result = getStringHashCode(this.g35_1);
		    result = imul(result, 31) + (this.h35_1 == null ? 0 : getStringHashCode(this.h35_1)) | 0;
		    return result;
		  };
		  protoOf(Body_18).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_18))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_18 ? other : THROW_CCE();
		    if (!(this.g35_1 === tmp0_other_with_cast.g35_1))
		      return false;
		    if (!(this.h35_1 == tmp0_other_with_cast.h35_1))
		      return false;
		    return true;
		  };
		  function MessageImageEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.i35_1 = timestamp;
		    this.j35_1 = conversationId;
		    this.k35_1 = id;
		    this.l35_1 = from;
		    this.m35_1 = body;
		    this.n35_1 = memberStatuses;
		  }
		  protoOf(MessageImageEvent).o2t = function () {
		    return this.j35_1;
		  };
		  protoOf(MessageImageEvent).t27 = function () {
		    return this.k35_1;
		  };
		  protoOf(MessageImageEvent).toString = function () {
		    return 'MessageImageEvent(timestamp=' + this.i35_1 + ', conversationId=' + this.j35_1 + ', id=' + this.k35_1 + ', from=' + this.l35_1 + ', body=' + this.m35_1 + ', memberStatuses=' + this.n35_1 + ')';
		  };
		  protoOf(MessageImageEvent).hashCode = function () {
		    var result = getStringHashCode(this.i35_1);
		    result = imul(result, 31) + getStringHashCode(this.j35_1) | 0;
		    result = imul(result, 31) + this.k35_1 | 0;
		    result = imul(result, 31) + hashCode(this.l35_1) | 0;
		    result = imul(result, 31) + this.m35_1.hashCode() | 0;
		    result = imul(result, 31) + (this.n35_1 == null ? 0 : hashCode(this.n35_1)) | 0;
		    return result;
		  };
		  protoOf(MessageImageEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageImageEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageImageEvent ? other : THROW_CCE();
		    if (!(this.i35_1 === tmp0_other_with_cast.i35_1))
		      return false;
		    if (!(this.j35_1 === tmp0_other_with_cast.j35_1))
		      return false;
		    if (!(this.k35_1 === tmp0_other_with_cast.k35_1))
		      return false;
		    if (!equals(this.l35_1, tmp0_other_with_cast.l35_1))
		      return false;
		    if (!this.m35_1.equals(tmp0_other_with_cast.m35_1))
		      return false;
		    if (!equals(this.n35_1, tmp0_other_with_cast.n35_1))
		      return false;
		    return true;
		  };
		  function Body_19(videoUrl, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.o35_1 = videoUrl;
		    this.p35_1 = deleted;
		  }
		  protoOf(Body_19).toString = function () {
		    return 'Body(videoUrl=' + this.o35_1 + ', deleted=' + this.p35_1 + ')';
		  };
		  protoOf(Body_19).hashCode = function () {
		    var result = getStringHashCode(this.o35_1);
		    result = imul(result, 31) + (this.p35_1 == null ? 0 : getStringHashCode(this.p35_1)) | 0;
		    return result;
		  };
		  protoOf(Body_19).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_19))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_19 ? other : THROW_CCE();
		    if (!(this.o35_1 === tmp0_other_with_cast.o35_1))
		      return false;
		    if (!(this.p35_1 == tmp0_other_with_cast.p35_1))
		      return false;
		    return true;
		  };
		  function MessageVideoEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.q35_1 = timestamp;
		    this.r35_1 = conversationId;
		    this.s35_1 = id;
		    this.t35_1 = from;
		    this.u35_1 = body;
		    this.v35_1 = memberStatuses;
		  }
		  protoOf(MessageVideoEvent).o2t = function () {
		    return this.r35_1;
		  };
		  protoOf(MessageVideoEvent).t27 = function () {
		    return this.s35_1;
		  };
		  protoOf(MessageVideoEvent).toString = function () {
		    return 'MessageVideoEvent(timestamp=' + this.q35_1 + ', conversationId=' + this.r35_1 + ', id=' + this.s35_1 + ', from=' + this.t35_1 + ', body=' + this.u35_1 + ', memberStatuses=' + this.v35_1 + ')';
		  };
		  protoOf(MessageVideoEvent).hashCode = function () {
		    var result = getStringHashCode(this.q35_1);
		    result = imul(result, 31) + getStringHashCode(this.r35_1) | 0;
		    result = imul(result, 31) + this.s35_1 | 0;
		    result = imul(result, 31) + hashCode(this.t35_1) | 0;
		    result = imul(result, 31) + this.u35_1.hashCode() | 0;
		    result = imul(result, 31) + (this.v35_1 == null ? 0 : hashCode(this.v35_1)) | 0;
		    return result;
		  };
		  protoOf(MessageVideoEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageVideoEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageVideoEvent ? other : THROW_CCE();
		    if (!(this.q35_1 === tmp0_other_with_cast.q35_1))
		      return false;
		    if (!(this.r35_1 === tmp0_other_with_cast.r35_1))
		      return false;
		    if (!(this.s35_1 === tmp0_other_with_cast.s35_1))
		      return false;
		    if (!equals(this.t35_1, tmp0_other_with_cast.t35_1))
		      return false;
		    if (!this.u35_1.equals(tmp0_other_with_cast.u35_1))
		      return false;
		    if (!equals(this.v35_1, tmp0_other_with_cast.v35_1))
		      return false;
		    return true;
		  };
		  function Body_20(audioUrl, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.w35_1 = audioUrl;
		    this.x35_1 = deleted;
		  }
		  protoOf(Body_20).toString = function () {
		    return 'Body(audioUrl=' + this.w35_1 + ', deleted=' + this.x35_1 + ')';
		  };
		  protoOf(Body_20).hashCode = function () {
		    var result = getStringHashCode(this.w35_1);
		    result = imul(result, 31) + (this.x35_1 == null ? 0 : getStringHashCode(this.x35_1)) | 0;
		    return result;
		  };
		  protoOf(Body_20).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_20))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_20 ? other : THROW_CCE();
		    if (!(this.w35_1 === tmp0_other_with_cast.w35_1))
		      return false;
		    if (!(this.x35_1 == tmp0_other_with_cast.x35_1))
		      return false;
		    return true;
		  };
		  function MessageAudioEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.y35_1 = timestamp;
		    this.z35_1 = conversationId;
		    this.a36_1 = id;
		    this.b36_1 = from;
		    this.c36_1 = body;
		    this.d36_1 = memberStatuses;
		  }
		  protoOf(MessageAudioEvent).o2t = function () {
		    return this.z35_1;
		  };
		  protoOf(MessageAudioEvent).t27 = function () {
		    return this.a36_1;
		  };
		  protoOf(MessageAudioEvent).toString = function () {
		    return 'MessageAudioEvent(timestamp=' + this.y35_1 + ', conversationId=' + this.z35_1 + ', id=' + this.a36_1 + ', from=' + this.b36_1 + ', body=' + this.c36_1 + ', memberStatuses=' + this.d36_1 + ')';
		  };
		  protoOf(MessageAudioEvent).hashCode = function () {
		    var result = getStringHashCode(this.y35_1);
		    result = imul(result, 31) + getStringHashCode(this.z35_1) | 0;
		    result = imul(result, 31) + this.a36_1 | 0;
		    result = imul(result, 31) + hashCode(this.b36_1) | 0;
		    result = imul(result, 31) + this.c36_1.hashCode() | 0;
		    result = imul(result, 31) + (this.d36_1 == null ? 0 : hashCode(this.d36_1)) | 0;
		    return result;
		  };
		  protoOf(MessageAudioEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageAudioEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageAudioEvent ? other : THROW_CCE();
		    if (!(this.y35_1 === tmp0_other_with_cast.y35_1))
		      return false;
		    if (!(this.z35_1 === tmp0_other_with_cast.z35_1))
		      return false;
		    if (!(this.a36_1 === tmp0_other_with_cast.a36_1))
		      return false;
		    if (!equals(this.b36_1, tmp0_other_with_cast.b36_1))
		      return false;
		    if (!this.c36_1.equals(tmp0_other_with_cast.c36_1))
		      return false;
		    if (!equals(this.d36_1, tmp0_other_with_cast.d36_1))
		      return false;
		    return true;
		  };
		  function Body_21(fileUrl, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.e36_1 = fileUrl;
		    this.f36_1 = deleted;
		  }
		  protoOf(Body_21).toString = function () {
		    return 'Body(fileUrl=' + this.e36_1 + ', deleted=' + this.f36_1 + ')';
		  };
		  protoOf(Body_21).hashCode = function () {
		    var result = getStringHashCode(this.e36_1);
		    result = imul(result, 31) + (this.f36_1 == null ? 0 : getStringHashCode(this.f36_1)) | 0;
		    return result;
		  };
		  protoOf(Body_21).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_21))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_21 ? other : THROW_CCE();
		    if (!(this.e36_1 === tmp0_other_with_cast.e36_1))
		      return false;
		    if (!(this.f36_1 == tmp0_other_with_cast.f36_1))
		      return false;
		    return true;
		  };
		  function MessageFileEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.g36_1 = timestamp;
		    this.h36_1 = conversationId;
		    this.i36_1 = id;
		    this.j36_1 = from;
		    this.k36_1 = body;
		    this.l36_1 = memberStatuses;
		  }
		  protoOf(MessageFileEvent).o2t = function () {
		    return this.h36_1;
		  };
		  protoOf(MessageFileEvent).t27 = function () {
		    return this.i36_1;
		  };
		  protoOf(MessageFileEvent).toString = function () {
		    return 'MessageFileEvent(timestamp=' + this.g36_1 + ', conversationId=' + this.h36_1 + ', id=' + this.i36_1 + ', from=' + this.j36_1 + ', body=' + this.k36_1 + ', memberStatuses=' + this.l36_1 + ')';
		  };
		  protoOf(MessageFileEvent).hashCode = function () {
		    var result = getStringHashCode(this.g36_1);
		    result = imul(result, 31) + getStringHashCode(this.h36_1) | 0;
		    result = imul(result, 31) + this.i36_1 | 0;
		    result = imul(result, 31) + hashCode(this.j36_1) | 0;
		    result = imul(result, 31) + this.k36_1.hashCode() | 0;
		    result = imul(result, 31) + (this.l36_1 == null ? 0 : hashCode(this.l36_1)) | 0;
		    return result;
		  };
		  protoOf(MessageFileEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageFileEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageFileEvent ? other : THROW_CCE();
		    if (!(this.g36_1 === tmp0_other_with_cast.g36_1))
		      return false;
		    if (!(this.h36_1 === tmp0_other_with_cast.h36_1))
		      return false;
		    if (!(this.i36_1 === tmp0_other_with_cast.i36_1))
		      return false;
		    if (!equals(this.j36_1, tmp0_other_with_cast.j36_1))
		      return false;
		    if (!this.k36_1.equals(tmp0_other_with_cast.k36_1))
		      return false;
		    if (!equals(this.l36_1, tmp0_other_with_cast.l36_1))
		      return false;
		    return true;
		  };
		  function Body_22(vcardUrl, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.m36_1 = vcardUrl;
		    this.n36_1 = deleted;
		  }
		  protoOf(Body_22).toString = function () {
		    return 'Body(vcardUrl=' + this.m36_1 + ', deleted=' + this.n36_1 + ')';
		  };
		  protoOf(Body_22).hashCode = function () {
		    var result = getStringHashCode(this.m36_1);
		    result = imul(result, 31) + (this.n36_1 == null ? 0 : getStringHashCode(this.n36_1)) | 0;
		    return result;
		  };
		  protoOf(Body_22).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_22))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_22 ? other : THROW_CCE();
		    if (!(this.m36_1 === tmp0_other_with_cast.m36_1))
		      return false;
		    if (!(this.n36_1 == tmp0_other_with_cast.n36_1))
		      return false;
		    return true;
		  };
		  function MessageVCardEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.o36_1 = timestamp;
		    this.p36_1 = conversationId;
		    this.q36_1 = id;
		    this.r36_1 = from;
		    this.s36_1 = body;
		    this.t36_1 = memberStatuses;
		  }
		  protoOf(MessageVCardEvent).o2t = function () {
		    return this.p36_1;
		  };
		  protoOf(MessageVCardEvent).t27 = function () {
		    return this.q36_1;
		  };
		  protoOf(MessageVCardEvent).toString = function () {
		    return 'MessageVCardEvent(timestamp=' + this.o36_1 + ', conversationId=' + this.p36_1 + ', id=' + this.q36_1 + ', from=' + this.r36_1 + ', body=' + this.s36_1 + ', memberStatuses=' + this.t36_1 + ')';
		  };
		  protoOf(MessageVCardEvent).hashCode = function () {
		    var result = getStringHashCode(this.o36_1);
		    result = imul(result, 31) + getStringHashCode(this.p36_1) | 0;
		    result = imul(result, 31) + this.q36_1 | 0;
		    result = imul(result, 31) + hashCode(this.r36_1) | 0;
		    result = imul(result, 31) + this.s36_1.hashCode() | 0;
		    result = imul(result, 31) + (this.t36_1 == null ? 0 : hashCode(this.t36_1)) | 0;
		    return result;
		  };
		  protoOf(MessageVCardEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageVCardEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageVCardEvent ? other : THROW_CCE();
		    if (!(this.o36_1 === tmp0_other_with_cast.o36_1))
		      return false;
		    if (!(this.p36_1 === tmp0_other_with_cast.p36_1))
		      return false;
		    if (!(this.q36_1 === tmp0_other_with_cast.q36_1))
		      return false;
		    if (!equals(this.r36_1, tmp0_other_with_cast.r36_1))
		      return false;
		    if (!this.s36_1.equals(tmp0_other_with_cast.s36_1))
		      return false;
		    if (!equals(this.t36_1, tmp0_other_with_cast.t36_1))
		      return false;
		    return true;
		  };
		  function Body_23(template, whatsapp, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.u36_1 = template;
		    this.v36_1 = whatsapp;
		    this.w36_1 = deleted;
		  }
		  protoOf(Body_23).toString = function () {
		    return 'Body(template=' + this.u36_1 + ', whatsapp=' + this.v36_1 + ', deleted=' + this.w36_1 + ')';
		  };
		  protoOf(Body_23).hashCode = function () {
		    var result = this.u36_1.hashCode();
		    result = imul(result, 31) + this.v36_1.hashCode() | 0;
		    result = imul(result, 31) + (this.w36_1 == null ? 0 : getStringHashCode(this.w36_1)) | 0;
		    return result;
		  };
		  protoOf(Body_23).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_23))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_23 ? other : THROW_CCE();
		    if (!this.u36_1.equals(tmp0_other_with_cast.u36_1))
		      return false;
		    if (!this.v36_1.equals(tmp0_other_with_cast.v36_1))
		      return false;
		    if (!(this.w36_1 == tmp0_other_with_cast.w36_1))
		      return false;
		    return true;
		  };
		  function TemplateObject_0(name, parameters) {
		    parameters = parameters === VOID ? null : parameters;
		    this.a2m_1 = name;
		    this.b2m_1 = parameters;
		  }
		  protoOf(TemplateObject_0).toString = function () {
		    return 'TemplateObject(name=' + this.a2m_1 + ', parameters=' + this.b2m_1 + ')';
		  };
		  protoOf(TemplateObject_0).hashCode = function () {
		    var result = getStringHashCode(this.a2m_1);
		    result = imul(result, 31) + (this.b2m_1 == null ? 0 : hashCode(this.b2m_1)) | 0;
		    return result;
		  };
		  protoOf(TemplateObject_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof TemplateObject_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof TemplateObject_0 ? other : THROW_CCE();
		    if (!(this.a2m_1 === tmp0_other_with_cast.a2m_1))
		      return false;
		    if (!equals(this.b2m_1, tmp0_other_with_cast.b2m_1))
		      return false;
		    return true;
		  };
		  function WhatsappObject_0(policy, locale) {
		    this.e2m_1 = policy;
		    this.f2m_1 = locale;
		  }
		  protoOf(WhatsappObject_0).toString = function () {
		    return 'WhatsappObject(policy=' + this.e2m_1 + ', locale=' + this.f2m_1 + ')';
		  };
		  protoOf(WhatsappObject_0).hashCode = function () {
		    var result = getStringHashCode(this.e2m_1);
		    result = imul(result, 31) + getStringHashCode(this.f2m_1) | 0;
		    return result;
		  };
		  protoOf(WhatsappObject_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof WhatsappObject_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof WhatsappObject_0 ? other : THROW_CCE();
		    if (!(this.e2m_1 === tmp0_other_with_cast.e2m_1))
		      return false;
		    if (!(this.f2m_1 === tmp0_other_with_cast.f2m_1))
		      return false;
		    return true;
		  };
		  function MessageTemplateEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.x36_1 = timestamp;
		    this.y36_1 = conversationId;
		    this.z36_1 = id;
		    this.a37_1 = from;
		    this.b37_1 = body;
		    this.c37_1 = memberStatuses;
		  }
		  protoOf(MessageTemplateEvent).o2t = function () {
		    return this.y36_1;
		  };
		  protoOf(MessageTemplateEvent).t27 = function () {
		    return this.z36_1;
		  };
		  protoOf(MessageTemplateEvent).toString = function () {
		    return 'MessageTemplateEvent(timestamp=' + this.x36_1 + ', conversationId=' + this.y36_1 + ', id=' + this.z36_1 + ', from=' + this.a37_1 + ', body=' + this.b37_1 + ', memberStatuses=' + this.c37_1 + ')';
		  };
		  protoOf(MessageTemplateEvent).hashCode = function () {
		    var result = getStringHashCode(this.x36_1);
		    result = imul(result, 31) + getStringHashCode(this.y36_1) | 0;
		    result = imul(result, 31) + this.z36_1 | 0;
		    result = imul(result, 31) + hashCode(this.a37_1) | 0;
		    result = imul(result, 31) + this.b37_1.hashCode() | 0;
		    result = imul(result, 31) + (this.c37_1 == null ? 0 : hashCode(this.c37_1)) | 0;
		    return result;
		  };
		  protoOf(MessageTemplateEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageTemplateEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageTemplateEvent ? other : THROW_CCE();
		    if (!(this.x36_1 === tmp0_other_with_cast.x36_1))
		      return false;
		    if (!(this.y36_1 === tmp0_other_with_cast.y36_1))
		      return false;
		    if (!(this.z36_1 === tmp0_other_with_cast.z36_1))
		      return false;
		    if (!equals(this.a37_1, tmp0_other_with_cast.a37_1))
		      return false;
		    if (!this.b37_1.equals(tmp0_other_with_cast.b37_1))
		      return false;
		    if (!equals(this.c37_1, tmp0_other_with_cast.c37_1))
		      return false;
		    return true;
		  };
		  function Body_24(location, deleted) {
		    deleted = deleted === VOID ? null : deleted;
		    this.d37_1 = location;
		    this.e37_1 = deleted;
		  }
		  protoOf(Body_24).toString = function () {
		    return 'Body(location=' + this.d37_1 + ', deleted=' + this.e37_1 + ')';
		  };
		  protoOf(Body_24).hashCode = function () {
		    var result = this.d37_1.hashCode();
		    result = imul(result, 31) + (this.e37_1 == null ? 0 : getStringHashCode(this.e37_1)) | 0;
		    return result;
		  };
		  protoOf(Body_24).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Body_24))
		      return false;
		    var tmp0_other_with_cast = other instanceof Body_24 ? other : THROW_CCE();
		    if (!this.d37_1.equals(tmp0_other_with_cast.d37_1))
		      return false;
		    if (!(this.e37_1 == tmp0_other_with_cast.e37_1))
		      return false;
		    return true;
		  };
		  function Location(longitude, latitude, name, address) {
		    name = name === VOID ? null : name;
		    address = address === VOID ? null : address;
		    this.i2m_1 = longitude;
		    this.j2m_1 = latitude;
		    this.k2m_1 = name;
		    this.l2m_1 = address;
		  }
		  protoOf(Location).toString = function () {
		    return 'Location(longitude=' + this.i2m_1 + ', latitude=' + this.j2m_1 + ', name=' + this.k2m_1 + ', address=' + this.l2m_1 + ')';
		  };
		  protoOf(Location).hashCode = function () {
		    var result = getStringHashCode(this.i2m_1);
		    result = imul(result, 31) + getStringHashCode(this.j2m_1) | 0;
		    result = imul(result, 31) + (this.k2m_1 == null ? 0 : getStringHashCode(this.k2m_1)) | 0;
		    result = imul(result, 31) + (this.l2m_1 == null ? 0 : getStringHashCode(this.l2m_1)) | 0;
		    return result;
		  };
		  protoOf(Location).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Location))
		      return false;
		    var tmp0_other_with_cast = other instanceof Location ? other : THROW_CCE();
		    if (!(this.i2m_1 === tmp0_other_with_cast.i2m_1))
		      return false;
		    if (!(this.j2m_1 === tmp0_other_with_cast.j2m_1))
		      return false;
		    if (!(this.k2m_1 == tmp0_other_with_cast.k2m_1))
		      return false;
		    if (!(this.l2m_1 == tmp0_other_with_cast.l2m_1))
		      return false;
		    return true;
		  };
		  function MessageLocationEvent(timestamp, conversationId, id, from, body, memberStatuses) {
		    memberStatuses = memberStatuses === VOID ? null : memberStatuses;
		    this.f37_1 = timestamp;
		    this.g37_1 = conversationId;
		    this.h37_1 = id;
		    this.i37_1 = from;
		    this.j37_1 = body;
		    this.k37_1 = memberStatuses;
		  }
		  protoOf(MessageLocationEvent).o2t = function () {
		    return this.g37_1;
		  };
		  protoOf(MessageLocationEvent).t27 = function () {
		    return this.h37_1;
		  };
		  protoOf(MessageLocationEvent).toString = function () {
		    return 'MessageLocationEvent(timestamp=' + this.f37_1 + ', conversationId=' + this.g37_1 + ', id=' + this.h37_1 + ', from=' + this.i37_1 + ', body=' + this.j37_1 + ', memberStatuses=' + this.k37_1 + ')';
		  };
		  protoOf(MessageLocationEvent).hashCode = function () {
		    var result = getStringHashCode(this.f37_1);
		    result = imul(result, 31) + getStringHashCode(this.g37_1) | 0;
		    result = imul(result, 31) + this.h37_1 | 0;
		    result = imul(result, 31) + hashCode(this.i37_1) | 0;
		    result = imul(result, 31) + this.j37_1.hashCode() | 0;
		    result = imul(result, 31) + (this.k37_1 == null ? 0 : hashCode(this.k37_1)) | 0;
		    return result;
		  };
		  protoOf(MessageLocationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MessageLocationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof MessageLocationEvent ? other : THROW_CCE();
		    if (!(this.f37_1 === tmp0_other_with_cast.f37_1))
		      return false;
		    if (!(this.g37_1 === tmp0_other_with_cast.g37_1))
		      return false;
		    if (!(this.h37_1 === tmp0_other_with_cast.h37_1))
		      return false;
		    if (!equals(this.i37_1, tmp0_other_with_cast.i37_1))
		      return false;
		    if (!this.j37_1.equals(tmp0_other_with_cast.j37_1))
		      return false;
		    if (!equals(this.k37_1, tmp0_other_with_cast.k37_1))
		      return false;
		    return true;
		  };
		  function MessageEvent_0() {
		  }
		  var PresentingOrder_ASC_instance;
		  var PresentingOrder_DESC_instance;
		  var PresentingOrder_entriesInitialized;
		  function PresentingOrder_initEntries() {
		    if (PresentingOrder_entriesInitialized)
		      return Unit_instance;
		    PresentingOrder_entriesInitialized = true;
		    PresentingOrder_ASC_instance = new PresentingOrder('ASC', 0);
		    PresentingOrder_DESC_instance = new PresentingOrder('DESC', 1);
		  }
		  function PresentingOrder(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function OrderBy$CREATED() {
		    OrderBy.call(this, 'CREATED', 0);
		    OrderBy_CREATED_instance = this;
		  }
		  protoOf(OrderBy$CREATED).toString = function () {
		    return 'created';
		  };
		  var OrderBy_CREATED_instance;
		  function OrderBy$CUSTOM_SORT_KEY() {
		    OrderBy.call(this, 'CUSTOM_SORT_KEY', 1);
		    OrderBy_CUSTOM_SORT_KEY_instance = this;
		  }
		  protoOf(OrderBy$CUSTOM_SORT_KEY).toString = function () {
		    return 'custom_sort_key';
		  };
		  var OrderBy_CUSTOM_SORT_KEY_instance;
		  var OrderBy_entriesInitialized;
		  function OrderBy_initEntries() {
		    if (OrderBy_entriesInitialized)
		      return Unit_instance;
		    OrderBy_entriesInitialized = true;
		    OrderBy_CREATED_instance = new OrderBy$CREATED();
		    OrderBy_CUSTOM_SORT_KEY_instance = new OrderBy$CUSTOM_SORT_KEY();
		  }
		  function OrderBy(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function getCursor(_this__u8e3s4) {
		    return getQueryParameter(_this__u8e3s4, 'cursor');
		  }
		  function PresentingOrder_ASC_getInstance() {
		    PresentingOrder_initEntries();
		    return PresentingOrder_ASC_instance;
		  }
		  function PresentingOrder_DESC_getInstance() {
		    PresentingOrder_initEntries();
		    return PresentingOrder_DESC_instance;
		  }
		  function OrderBy_CREATED_getInstance() {
		    OrderBy_initEntries();
		    return OrderBy_CREATED_instance;
		  }
		  function OrderBy_CUSTOM_SORT_KEY_getInstance() {
		    OrderBy_initEntries();
		    return OrderBy_CUSTOM_SORT_KEY_instance;
		  }
		  function CreateConversationParameters(name, displayName, imageUrl, ttl, customSortKey, customData) {
		    name = name === VOID ? null : name;
		    displayName = displayName === VOID ? null : displayName;
		    imageUrl = imageUrl === VOID ? null : imageUrl;
		    ttl = ttl === VOID ? null : ttl;
		    customSortKey = customSortKey === VOID ? null : customSortKey;
		    customData = customData === VOID ? null : customData;
		    this.a2u_1 = name;
		    this.b2u_1 = displayName;
		    this.c2u_1 = imageUrl;
		    this.d2u_1 = ttl;
		    this.e2u_1 = customSortKey;
		    this.f2u_1 = customData;
		  }
		  protoOf(CreateConversationParameters).g2u = function () {
		    var tmp;
		    if ((this.d2u_1 == null ? this.f2u_1 == null : false) ? this.e2u_1 == null : false) {
		      tmp = null;
		    } else {
		      var tmp1_ttl = this.d2u_1;
		      var tmp2_custom_sort_key = this.e2u_1;
		      var tmp0_safe_receiver = this.f2u_1;
		      var tmp_0;
		      if (tmp0_safe_receiver == null) {
		        tmp_0 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.models.CreateConversationParameters.<get-properties>.<anonymous>' call
		        tmp_0 = get_jsonObject(Default_getInstance().e11(tmp0_safe_receiver));
		      }
		      var tmp3_custom_data = tmp_0;
		      tmp = new Properties(tmp2_custom_sort_key, tmp3_custom_data, tmp1_ttl);
		    }
		    return tmp;
		  };
		  protoOf(CreateConversationParameters).toString = function () {
		    return 'CreateConversationParameters(name=' + this.a2u_1 + ', displayName=' + this.b2u_1 + ', imageUrl=' + this.c2u_1 + ', ttl=' + this.d2u_1 + ', customSortKey=' + this.e2u_1 + ', customData=' + this.f2u_1 + ')';
		  };
		  protoOf(CreateConversationParameters).hashCode = function () {
		    var result = this.a2u_1 == null ? 0 : getStringHashCode(this.a2u_1);
		    result = imul(result, 31) + (this.b2u_1 == null ? 0 : getStringHashCode(this.b2u_1)) | 0;
		    result = imul(result, 31) + (this.c2u_1 == null ? 0 : getStringHashCode(this.c2u_1)) | 0;
		    result = imul(result, 31) + (this.d2u_1 == null ? 0 : this.d2u_1) | 0;
		    result = imul(result, 31) + (this.e2u_1 == null ? 0 : getStringHashCode(this.e2u_1)) | 0;
		    result = imul(result, 31) + (this.f2u_1 == null ? 0 : getStringHashCode(this.f2u_1)) | 0;
		    return result;
		  };
		  protoOf(CreateConversationParameters).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CreateConversationParameters))
		      return false;
		    var tmp0_other_with_cast = other instanceof CreateConversationParameters ? other : THROW_CCE();
		    if (!(this.a2u_1 == tmp0_other_with_cast.a2u_1))
		      return false;
		    if (!(this.b2u_1 == tmp0_other_with_cast.b2u_1))
		      return false;
		    if (!(this.c2u_1 == tmp0_other_with_cast.c2u_1))
		      return false;
		    if (!(this.d2u_1 == tmp0_other_with_cast.d2u_1))
		      return false;
		    if (!(this.e2u_1 == tmp0_other_with_cast.e2u_1))
		      return false;
		    if (!(this.f2u_1 == tmp0_other_with_cast.f2u_1))
		      return false;
		    return true;
		  };
		  function GetConversationsParameters(order, pageSize, cursor, includeCustomData, orderBy) {
		    order = order === VOID ? null : order;
		    pageSize = pageSize === VOID ? null : pageSize;
		    cursor = cursor === VOID ? null : cursor;
		    includeCustomData = includeCustomData === VOID ? null : includeCustomData;
		    orderBy = orderBy === VOID ? null : orderBy;
		    this.p2u_1 = order;
		    this.q2u_1 = pageSize;
		    this.r2u_1 = cursor;
		    this.s2u_1 = includeCustomData;
		    this.t2u_1 = orderBy;
		  }
		  protoOf(GetConversationsParameters).toString = function () {
		    return 'GetConversationsParameters(order=' + this.p2u_1 + ', pageSize=' + this.q2u_1 + ', cursor=' + this.r2u_1 + ', includeCustomData=' + this.s2u_1 + ', orderBy=' + this.t2u_1 + ')';
		  };
		  protoOf(GetConversationsParameters).hashCode = function () {
		    var result = this.p2u_1 == null ? 0 : this.p2u_1.hashCode();
		    result = imul(result, 31) + (this.q2u_1 == null ? 0 : this.q2u_1) | 0;
		    result = imul(result, 31) + (this.r2u_1 == null ? 0 : getStringHashCode(this.r2u_1)) | 0;
		    result = imul(result, 31) + (this.s2u_1 == null ? 0 : getBooleanHashCode(this.s2u_1)) | 0;
		    result = imul(result, 31) + (this.t2u_1 == null ? 0 : this.t2u_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(GetConversationsParameters).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetConversationsParameters))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetConversationsParameters ? other : THROW_CCE();
		    if (!equals(this.p2u_1, tmp0_other_with_cast.p2u_1))
		      return false;
		    if (!(this.q2u_1 == tmp0_other_with_cast.q2u_1))
		      return false;
		    if (!(this.r2u_1 == tmp0_other_with_cast.r2u_1))
		      return false;
		    if (!(this.s2u_1 == tmp0_other_with_cast.s2u_1))
		      return false;
		    if (!equals(this.t2u_1, tmp0_other_with_cast.t2u_1))
		      return false;
		    return true;
		  };
		  function GetConversationMembersParameters(order, pageSize, cursor) {
		    order = order === VOID ? null : order;
		    pageSize = pageSize === VOID ? null : pageSize;
		    cursor = cursor === VOID ? null : cursor;
		    this.a2v_1 = order;
		    this.b2v_1 = pageSize;
		    this.c2v_1 = cursor;
		  }
		  protoOf(GetConversationMembersParameters).toString = function () {
		    return 'GetConversationMembersParameters(order=' + this.a2v_1 + ', pageSize=' + this.b2v_1 + ', cursor=' + this.c2v_1 + ')';
		  };
		  protoOf(GetConversationMembersParameters).hashCode = function () {
		    var result = this.a2v_1 == null ? 0 : this.a2v_1.hashCode();
		    result = imul(result, 31) + (this.b2v_1 == null ? 0 : this.b2v_1) | 0;
		    result = imul(result, 31) + (this.c2v_1 == null ? 0 : getStringHashCode(this.c2v_1)) | 0;
		    return result;
		  };
		  protoOf(GetConversationMembersParameters).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetConversationMembersParameters))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetConversationMembersParameters ? other : THROW_CCE();
		    if (!equals(this.a2v_1, tmp0_other_with_cast.a2v_1))
		      return false;
		    if (!(this.b2v_1 == tmp0_other_with_cast.b2v_1))
		      return false;
		    if (!(this.c2v_1 == tmp0_other_with_cast.c2v_1))
		      return false;
		    return true;
		  };
		  function GetConversationEventsParameters(order, pageSize, cursor, eventFilter, includeDeletedEvents, startId) {
		    order = order === VOID ? null : order;
		    pageSize = pageSize === VOID ? null : pageSize;
		    cursor = cursor === VOID ? null : cursor;
		    eventFilter = eventFilter === VOID ? null : eventFilter;
		    includeDeletedEvents = includeDeletedEvents === VOID ? null : includeDeletedEvents;
		    startId = startId === VOID ? null : startId;
		    this.u2u_1 = order;
		    this.v2u_1 = pageSize;
		    this.w2u_1 = cursor;
		    this.x2u_1 = eventFilter;
		    this.y2u_1 = includeDeletedEvents;
		    this.z2u_1 = startId;
		  }
		  protoOf(GetConversationEventsParameters).toString = function () {
		    return 'GetConversationEventsParameters(order=' + this.u2u_1 + ', pageSize=' + this.v2u_1 + ', cursor=' + this.w2u_1 + ', eventFilter=' + this.x2u_1 + ', includeDeletedEvents=' + this.y2u_1 + ', startId=' + this.z2u_1 + ')';
		  };
		  protoOf(GetConversationEventsParameters).hashCode = function () {
		    var result = this.u2u_1 == null ? 0 : this.u2u_1.hashCode();
		    result = imul(result, 31) + (this.v2u_1 == null ? 0 : this.v2u_1) | 0;
		    result = imul(result, 31) + (this.w2u_1 == null ? 0 : getStringHashCode(this.w2u_1)) | 0;
		    result = imul(result, 31) + (this.x2u_1 == null ? 0 : hashCode(this.x2u_1)) | 0;
		    result = imul(result, 31) + (this.y2u_1 == null ? 0 : getBooleanHashCode(this.y2u_1)) | 0;
		    result = imul(result, 31) + (this.z2u_1 == null ? 0 : this.z2u_1) | 0;
		    return result;
		  };
		  protoOf(GetConversationEventsParameters).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetConversationEventsParameters))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetConversationEventsParameters ? other : THROW_CCE();
		    if (!equals(this.u2u_1, tmp0_other_with_cast.u2u_1))
		      return false;
		    if (!(this.v2u_1 == tmp0_other_with_cast.v2u_1))
		      return false;
		    if (!(this.w2u_1 == tmp0_other_with_cast.w2u_1))
		      return false;
		    if (!equals(this.x2u_1, tmp0_other_with_cast.x2u_1))
		      return false;
		    if (!(this.y2u_1 == tmp0_other_with_cast.y2u_1))
		      return false;
		    if (!(this.z2u_1 == tmp0_other_with_cast.z2u_1))
		      return false;
		    return true;
		  };
		  function UpdateConversationParameters$_get_properties_$lambda_kj27c5(it) {
		    return get_jsonObject(Default_getInstance().e11(it));
		  }
		  function UpdateConversationParameters(name, displayName, imageUrl, ttl, customSortKey, customData) {
		    name = name === VOID ? none() : name;
		    displayName = displayName === VOID ? none() : displayName;
		    imageUrl = imageUrl === VOID ? none() : imageUrl;
		    ttl = ttl === VOID ? none() : ttl;
		    customSortKey = customSortKey === VOID ? none() : customSortKey;
		    customData = customData === VOID ? none() : customData;
		    this.h2u_1 = name;
		    this.i2u_1 = displayName;
		    this.j2u_1 = imageUrl;
		    this.k2u_1 = ttl;
		    this.l2u_1 = customSortKey;
		    this.m2u_1 = customData;
		  }
		  protoOf(UpdateConversationParameters).g2u = function () {
		    var tmp;
		    var tmp_0;
		    var tmp_1;
		    var tmp_2 = this.k2u_1;
		    if (tmp_2 instanceof None_2) {
		      var tmp_3 = this.m2u_1;
		      tmp_1 = tmp_3 instanceof None_2;
		    } else {
		      tmp_1 = false;
		    }
		    if (tmp_1) {
		      var tmp_4 = this.l2u_1;
		      tmp_0 = tmp_4 instanceof None_2;
		    } else {
		      tmp_0 = false;
		    }
		    if (tmp_0) {
		      tmp = none();
		    } else {
		      var tmp_5;
		      var tmp_6;
		      var tmp_7 = this.k2u_1;
		      if (tmp_7 instanceof None_2) {
		        tmp_6 = this.m2u_1.l37(null);
		      } else {
		        tmp_6 = false;
		      }
		      if (tmp_6) {
		        tmp_5 = this.l2u_1.l37(null);
		      } else {
		        tmp_5 = false;
		      }
		      if (tmp_5) {
		        tmp = some(null);
		      } else {
		        var tmp0_ttl = this.k2u_1;
		        var tmp1_custom_sort_key = this.l2u_1;
		        var tmp2_custom_data = this.m2u_1.m37(UpdateConversationParameters$_get_properties_$lambda_kj27c5);
		        tmp = some(new Properties_0(tmp1_custom_sort_key, tmp2_custom_data, tmp0_ttl));
		      }
		    }
		    return tmp;
		  };
		  protoOf(UpdateConversationParameters).toString = function () {
		    return 'UpdateConversationParameters(name=' + this.h2u_1 + ', displayName=' + this.i2u_1 + ', imageUrl=' + this.j2u_1 + ', ttl=' + this.k2u_1 + ', customSortKey=' + this.l2u_1 + ', customData=' + this.m2u_1 + ')';
		  };
		  protoOf(UpdateConversationParameters).hashCode = function () {
		    var result = this.h2u_1.hashCode();
		    result = imul(result, 31) + this.i2u_1.hashCode() | 0;
		    result = imul(result, 31) + this.j2u_1.hashCode() | 0;
		    result = imul(result, 31) + this.k2u_1.hashCode() | 0;
		    result = imul(result, 31) + this.l2u_1.hashCode() | 0;
		    result = imul(result, 31) + this.m2u_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(UpdateConversationParameters).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UpdateConversationParameters))
		      return false;
		    var tmp0_other_with_cast = other instanceof UpdateConversationParameters ? other : THROW_CCE();
		    if (!this.h2u_1.equals(tmp0_other_with_cast.h2u_1))
		      return false;
		    if (!this.i2u_1.equals(tmp0_other_with_cast.i2u_1))
		      return false;
		    if (!this.j2u_1.equals(tmp0_other_with_cast.j2u_1))
		      return false;
		    if (!this.k2u_1.equals(tmp0_other_with_cast.k2u_1))
		      return false;
		    if (!this.l2u_1.equals(tmp0_other_with_cast.l2u_1))
		      return false;
		    if (!this.m2u_1.equals(tmp0_other_with_cast.m2u_1))
		      return false;
		    return true;
		  };
		  function GetCallLegsParameters(order, pageSize, cursor) {
		    order = order === VOID ? null : order;
		    pageSize = pageSize === VOID ? null : pageSize;
		    cursor = cursor === VOID ? null : cursor;
		    this.n37_1 = order;
		    this.o37_1 = pageSize;
		    this.p37_1 = cursor;
		  }
		  protoOf(GetCallLegsParameters).toString = function () {
		    return 'GetCallLegsParameters(order=' + this.n37_1 + ', pageSize=' + this.o37_1 + ', cursor=' + this.p37_1 + ')';
		  };
		  protoOf(GetCallLegsParameters).hashCode = function () {
		    var result = this.n37_1 == null ? 0 : this.n37_1.hashCode();
		    result = imul(result, 31) + (this.o37_1 == null ? 0 : this.o37_1) | 0;
		    result = imul(result, 31) + (this.p37_1 == null ? 0 : getStringHashCode(this.p37_1)) | 0;
		    return result;
		  };
		  protoOf(GetCallLegsParameters).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof GetCallLegsParameters))
		      return false;
		    var tmp0_other_with_cast = other instanceof GetCallLegsParameters ? other : THROW_CCE();
		    if (!equals(this.n37_1, tmp0_other_with_cast.n37_1))
		      return false;
		    if (!(this.o37_1 == tmp0_other_with_cast.o37_1))
		      return false;
		    if (!(this.p37_1 == tmp0_other_with_cast.p37_1))
		      return false;
		    return true;
		  };
		  function User(id, name, displayName, channels, timestamp, imageUrl, customData) {
		    displayName = displayName === VOID ? null : displayName;
		    channels = channels === VOID ? null : channels;
		    timestamp = timestamp === VOID ? null : timestamp;
		    imageUrl = imageUrl === VOID ? null : imageUrl;
		    customData = customData === VOID ? null : customData;
		    this.q37_1 = id;
		    this.r37_1 = name;
		    this.s37_1 = displayName;
		    this.t37_1 = channels;
		    this.u37_1 = timestamp;
		    this.v37_1 = imageUrl;
		    this.w37_1 = customData;
		  }
		  protoOf(User).toString = function () {
		    return 'User(id=' + this.q37_1 + ', name=' + this.r37_1 + ', displayName=' + this.s37_1 + ', channels=' + this.t37_1 + ', timestamp=' + this.u37_1 + ', imageUrl=' + this.v37_1 + ', customData=' + this.w37_1 + ')';
		  };
		  protoOf(User).hashCode = function () {
		    var result = getStringHashCode(this.q37_1);
		    result = imul(result, 31) + getStringHashCode(this.r37_1) | 0;
		    result = imul(result, 31) + (this.s37_1 == null ? 0 : getStringHashCode(this.s37_1)) | 0;
		    result = imul(result, 31) + (this.t37_1 == null ? 0 : this.t37_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.u37_1 == null ? 0 : this.u37_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.v37_1 == null ? 0 : getStringHashCode(this.v37_1)) | 0;
		    result = imul(result, 31) + (this.w37_1 == null ? 0 : getStringHashCode(this.w37_1)) | 0;
		    return result;
		  };
		  protoOf(User).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof User))
		      return false;
		    var tmp0_other_with_cast = other instanceof User ? other : THROW_CCE();
		    if (!(this.q37_1 === tmp0_other_with_cast.q37_1))
		      return false;
		    if (!(this.r37_1 === tmp0_other_with_cast.r37_1))
		      return false;
		    if (!(this.s37_1 == tmp0_other_with_cast.s37_1))
		      return false;
		    if (!equals(this.t37_1, tmp0_other_with_cast.t37_1))
		      return false;
		    if (!equals(this.u37_1, tmp0_other_with_cast.u37_1))
		      return false;
		    if (!(this.v37_1 == tmp0_other_with_cast.v37_1))
		      return false;
		    if (!(this.w37_1 == tmp0_other_with_cast.w37_1))
		      return false;
		    return true;
		  };
		  function $serializer_162() {
		    $serializer_instance_162 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.api.models.UserTimestamp', this, 3);
		    tmp0_serialDesc.pq('created', true);
		    tmp0_serialDesc.pq('updated', true);
		    tmp0_serialDesc.pq('destroyed', true);
		    this.x37_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_162).uf = function () {
		    return this.x37_1;
		  };
		  protoOf($serializer_162).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_162).wf = function (decoder) {
		    var tmp0_desc = this.x37_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return UserTimestamp_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_162).y37 = function (encoder, value) {
		    var tmp0_desc = this.x37_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.z37_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.z37_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.a38_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.a38_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.b38_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.b38_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_162).vf = function (encoder, value) {
		    return this.y37(encoder, value instanceof UserTimestamp ? value : THROW_CCE());
		  };
		  var $serializer_instance_162;
		  function $serializer_getInstance_162() {
		    if ($serializer_instance_162 == null)
		      new $serializer_162();
		    return $serializer_instance_162;
		  }
		  function UserTimestamp_init_$Init$(seen1, created, updated, destroyed, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_162().x37_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.z37_1 = null;
		    else
		      $this.z37_1 = created;
		    if (0 === (seen1 & 2))
		      $this.a38_1 = null;
		    else
		      $this.a38_1 = updated;
		    if (0 === (seen1 & 4))
		      $this.b38_1 = null;
		    else
		      $this.b38_1 = destroyed;
		    return $this;
		  }
		  function UserTimestamp_init_$Create$(seen1, created, updated, destroyed, serializationConstructorMarker) {
		    return UserTimestamp_init_$Init$(seen1, created, updated, destroyed, serializationConstructorMarker, objectCreate(protoOf(UserTimestamp)));
		  }
		  function UserTimestamp() {
		  }
		  protoOf(UserTimestamp).toString = function () {
		    return 'UserTimestamp(created=' + this.z37_1 + ', updated=' + this.a38_1 + ', destroyed=' + this.b38_1 + ')';
		  };
		  protoOf(UserTimestamp).hashCode = function () {
		    var result = this.z37_1 == null ? 0 : getStringHashCode(this.z37_1);
		    result = imul(result, 31) + (this.a38_1 == null ? 0 : getStringHashCode(this.a38_1)) | 0;
		    result = imul(result, 31) + (this.b38_1 == null ? 0 : getStringHashCode(this.b38_1)) | 0;
		    return result;
		  };
		  protoOf(UserTimestamp).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UserTimestamp))
		      return false;
		    var tmp0_other_with_cast = other instanceof UserTimestamp ? other : THROW_CCE();
		    if (!(this.z37_1 == tmp0_other_with_cast.z37_1))
		      return false;
		    if (!(this.a38_1 == tmp0_other_with_cast.a38_1))
		      return false;
		    if (!(this.b38_1 == tmp0_other_with_cast.b38_1))
		      return false;
		    return true;
		  };
		  function PushAPIImpl$decoder$lambda($this$Json) {
		    $this$Json.w11_1 = true;
		    $this$Json.u11_1 = true;
		    $this$Json.d12_1 = 'type';
		    return Unit_instance;
		  }
		  function PushAPIImpl(store, sessionAPI) {
		    this.c38_1 = store;
		    this.d38_1 = sessionAPI;
		    var tmp = this;
		    tmp.e38_1 = Json(VOID, PushAPIImpl$decoder$lambda);
		  }
		  var SessionErrorReason_TokenExpired_instance;
		  var SessionErrorReason_TransportClosed_instance;
		  var SessionErrorReason_PingTimeout_instance;
		  var SessionErrorReason_entriesInitialized;
		  function SessionErrorReason_initEntries() {
		    if (SessionErrorReason_entriesInitialized)
		      return Unit_instance;
		    SessionErrorReason_entriesInitialized = true;
		    SessionErrorReason_TokenExpired_instance = new SessionErrorReason('TokenExpired', 0);
		    SessionErrorReason_TransportClosed_instance = new SessionErrorReason('TransportClosed', 1);
		    SessionErrorReason_PingTimeout_instance = new SessionErrorReason('PingTimeout', 2);
		  }
		  function SessionErrorReason(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function onCreateSession($this, callback) {
		    var cleanup = {_v: null};
		    var tmp = getKClass(SessionReducer);
		    cleanup._v = $this.f38_1.a2z(tmp, SessionAPIImpl$onCreateSession$lambda($this, cleanup, callback));
		  }
		  function onDeleteSession($this, callback) {
		    var cleanup = {_v: null};
		    var tmp = getKClass(SessionReducer);
		    cleanup._v = $this.f38_1.a2z(tmp, SessionAPIImpl$onDeleteSession$lambda($this, cleanup, callback));
		  }
		  function onDeleteSessionClientDisconnect($this, callback) {
		    var cleanup = {_v: null};
		    var tmp = getKClass(SessionReducer);
		    cleanup._v = $this.f38_1.a2z(tmp, SessionAPIImpl$onDeleteSessionClientDisconnect$lambda($this, cleanup, callback));
		  }
		  function SessionAPIImpl$createSession$lambda($callback, this$0, $token, $sessionId) {
		    return function (e) {
		      var tmp;
		      if (!(e == null)) {
		        invokeCallbackWithError(new SessionNoActiveSessionError(), $callback);
		        tmp = Unit_instance;
		      } else {
		        onCreateSession(this$0, $callback);
		        this$0.f38_1.a1g(Action_init_$Create$(new SocketConnect($token, $sessionId)));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function SessionAPIImpl$refreshSession$lambda($callback, this$0, $sessionId, $token) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        this$0.f38_1.a1g(Action_init_$Create$(new SocketSetSession($sessionId, $token)));
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function SessionAPIImpl$lambda$lambda$lambda(this$0) {
		    return function (it) {
		      var tmp;
		      if (it instanceof MetricsWsReconnectionTime) {
		        this$0.f38_1.a1g(Action_init_$Create$(new MetricsSuccessfullySent(null, null)));
		        tmp = Unit_instance;
		      } else {
		        if (it instanceof Exception) {
		          this$0.g38_1.k38('Failed to publish socket reconnection metrics ' + toString_0(it));
		          tmp = Unit_instance;
		        }
		      }
		      return Unit_instance;
		    };
		  }
		  function SessionAPIImpl$lambda$lambda(this$0, $connectionStatus) {
		    return function () {
		      var state = this$0.f38_1.t2y(getKClass(SessionReducer));
		      var tmp;
		      var tmp0_safe_receiver = $connectionStatus._v;
		      if (!equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p2o_1, state.m38_1.p2o_1)) {
		        var tmp_0;
		        switch (state.m38_1.p2o_1.i8_1) {
		          case 1:
		            var tmp_1 = state.l38_1;
		            if (tmp_1 instanceof Resolved) {
		              var tmp2_safe_receiver = this$0.h38_1;
		              if (tmp2_safe_receiver == null)
		                null;
		              else {
		                tmp2_safe_receiver.s38();
		              }
		            }

		            $connectionStatus._v = state.m38_1;
		            tmp_0 = Unit_instance;
		            break;
		          case 2:
		            var tmp_2 = state.l38_1;
		            if (tmp_2 instanceof Resolved) {
		              var tmp3_safe_receiver = this$0.h38_1;
		              if (tmp3_safe_receiver == null)
		                null;
		              else {
		                tmp3_safe_receiver.t38();
		              }
		              var tmp4_elvis_lhs = state.l38_1.w1().t27();
		              var tmp_3;
		              if (tmp4_elvis_lhs == null) {
		                return Unit_instance;
		              } else {
		                tmp_3 = tmp4_elvis_lhs;
		              }
		              var sessionId = tmp_3;
		              var tmp5_elvis_lhs = state.n38_1;
		              var tmp_4;
		              if (tmp5_elvis_lhs == null) {
		                return Unit_instance;
		              } else {
		                tmp_4 = tmp5_elvis_lhs;
		              }
		              var timeOfFirstRetry = tmp_4;
		              var tmp6_elvis_lhs = state.o38_1;
		              var tmp_5;
		              if (tmp6_elvis_lhs == null) {
		                return Unit_instance;
		              } else {
		                tmp_5 = tmp6_elvis_lhs;
		              }
		              var retryNumber = tmp_5;
		              var reconnectingOffset = numberToLong(generateTimeStamp()).s9(numberToLong(timeOfFirstRetry));
		              var tmp_6 = new MetricsWsReconnectionTimeReq(sessionId, reconnectingOffset, retryNumber, 'TIME_TO_RECONNECT_SUCCESS');
		              this$0.f38_1.a1g(new Action_0(tmp_6, new ActionMeta(VOID, VOID, SessionAPIImpl$lambda$lambda$lambda(this$0))));
		            }

		            $connectionStatus._v = state.m38_1;
		            tmp_0 = Unit_instance;
		            break;
		          case 0:
		            var tmp7_safe_receiver = state.l38_1.w1().m2n();
		            if (tmp7_safe_receiver == null)
		              null;
		            else {
		              // Inline function 'kotlin.let' call
		              // Inline function 'kotlin.contracts.contract' call
		              // Inline function 'com.vonage.clientcore.core.api.SessionAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		              this$0.f38_1.a1g(Action_init_$Create$(DeleteSession_instance));
		              this$0.f38_1.a1g(Action_init_$Create$(SocketDisconnect_instance));
		              var tmp0_safe_receiver_0 = this$0.h38_1;
		              var tmp_7;
		              if (tmp0_safe_receiver_0 == null) {
		                tmp_7 = null;
		              } else {
		                tmp0_safe_receiver_0.u38(tmp7_safe_receiver);
		                tmp_7 = Unit_instance;
		              }
		            }

		            $connectionStatus._v = state.m38_1;
		            tmp_0 = Unit_instance;
		            break;
		        }
		        tmp = tmp_0;
		      }
		      return Unit_instance;
		    };
		  }
		  function SessionAPIImpl$lambda(this$0) {
		    return function () {
		      var connectionStatus = {_v: null};
		      return new StoredSubscription(SessionAPIImpl$lambda$lambda(this$0, connectionStatus));
		    };
		  }
		  function SessionAPIImpl$onCreateSession$lambda$lambda(this$0, $cleanup, $callback) {
		    return function () {
		      var state = this$0.f38_1.t2y(getKClass(SessionReducer));
		      var s = state.l38_1;
		      var tmp;
		      if (s instanceof Failed) {
		        var tmp0_safe_receiver = $cleanup._v;
		        if (tmp0_safe_receiver == null)
		          null;
		        else {
		          // Inline function 'kotlin.let' call
		          // Inline function 'kotlin.contracts.contract' call
		          tmp0_safe_receiver();
		        }
		        if (state.m38_1.p2o_1.equals(SocketConnectionStatus_Connected_getInstance())) {
		          this$0.f38_1.a1g(Action_init_$Create$(SocketDisconnect_instance));
		        }
		        invokeCallbackWithError(s.v38_1.n5_1, $callback);
		        tmp = Unit_instance;
		      } else {
		        if (s instanceof Resolved) {
		          var tmp1_safe_receiver = $cleanup._v;
		          if (tmp1_safe_receiver == null)
		            null;
		          else {
		            // Inline function 'kotlin.let' call
		            // Inline function 'kotlin.contracts.contract' call
		            tmp1_safe_receiver();
		          }
		          $callback(null, s.w1().t27());
		          var tmp2_safe_receiver = s.w1().t27();
		          if (tmp2_safe_receiver == null)
		            null;
		          else {
		            // Inline function 'kotlin.let' call
		            // Inline function 'kotlin.contracts.contract' call
		            this$0.f38_1.a1g(Action_init_$Create$(new SocketSetSessionId(tmp2_safe_receiver)));
		          }
		          tmp = Unit_instance;
		        } else {
		          tmp = Unit_instance;
		        }
		      }
		      return Unit_instance;
		    };
		  }
		  function SessionAPIImpl$onCreateSession$lambda(this$0, $cleanup, $callback) {
		    return function () {
		      return new StoredSubscription(SessionAPIImpl$onCreateSession$lambda$lambda(this$0, $cleanup, $callback));
		    };
		  }
		  function SessionAPIImpl$onDeleteSession$lambda$lambda(this$0, $connectionStatus, $cleanup, $callback) {
		    return function () {
		      var state = this$0.f38_1.t2y(getKClass(SessionReducer));
		      var tmp;
		      if ((state.l38_1.w1().t27() == null ? state.m38_1.p2o_1.equals(SocketConnectionStatus_Disconnected_getInstance()) : false) ? !state.m38_1.p2o_1.equals($connectionStatus) : false) {
		        var tmp0_safe_receiver = $cleanup._v;
		        if (tmp0_safe_receiver == null)
		          null;
		        else
		          tmp0_safe_receiver();
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function SessionAPIImpl$onDeleteSession$lambda(this$0, $cleanup, $callback) {
		    return function () {
		      var connectionStatus = this$0.f38_1.t2y(getKClass(SessionReducer)).m38_1.p2o_1;
		      return new StoredSubscription(SessionAPIImpl$onDeleteSession$lambda$lambda(this$0, connectionStatus, $cleanup, $callback));
		    };
		  }
		  function SessionAPIImpl$onDeleteSessionClientDisconnect$lambda$lambda(this$0, $cleanup, $callback) {
		    return function () {
		      var state = this$0.f38_1.t2y(getKClass(SessionReducer));
		      var tmp;
		      if (equals(state.p38_1, SocketConnectionFailedReason_ClientDisconnected_getInstance())) {
		        var tmp0_safe_receiver = $cleanup._v;
		        if (tmp0_safe_receiver == null)
		          null;
		        else
		          tmp0_safe_receiver();
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function SessionAPIImpl$onDeleteSessionClientDisconnect$lambda(this$0, $cleanup, $callback) {
		    return function () {
		      return new StoredSubscription(SessionAPIImpl$onDeleteSessionClientDisconnect$lambda$lambda(this$0, $cleanup, $callback));
		    };
		  }
		  function SessionAPIImpl(store, loggerAdapter) {
		    this.f38_1 = store;
		    this.g38_1 = loggerAdapter.v1e(Session_getInstance());
		    this.h38_1 = null;
		    var tmp = getKClass(SessionReducer);
		    this.f38_1.a2z(tmp, SessionAPIImpl$lambda(this));
		  }
		  protoOf(SessionAPIImpl).t1f = function (token, sessionId, callback) {
		    var state = this.f38_1.t2y(getKClass(SessionReducer));
		    if (!(state.l38_1.w1().t27() == null)) {
		      onDeleteSessionClientDisconnect(this, SessionAPIImpl$createSession$lambda(callback, this, token, sessionId));
		      this.f38_1.a1g(Action_init_$Create$(DeleteSession_instance));
		      this.f38_1.a1g(Action_init_$Create$(SocketDisconnect_instance));
		    } else {
		      onCreateSession(this, callback);
		      this.f38_1.a1g(Action_init_$Create$(new SocketConnect(token, sessionId)));
		    }
		  };
		  protoOf(SessionAPIImpl).u1f = function (callback) {
		    var state = this.f38_1.t2y(getKClass(SessionReducer));
		    if (state.l38_1.w1().t27() == null)
		      return invokeCallbackWithError_0(new SessionNoActiveSessionError(), callback);
		    onDeleteSession(this, callback);
		    this.f38_1.a1g(Action_init_$Create$(DeleteSession_instance));
		    this.f38_1.a1g(Action_init_$Create$(SocketDisconnect_instance));
		  };
		  protoOf(SessionAPIImpl).v1f = function (token, callback) {
		    var state = this.f38_1.t2y(getKClass(SessionReducer));
		    var tmp0_elvis_lhs = state.l38_1.w1().t27();
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return invokeCallbackWithError_0(new SessionNoActiveSessionError(), callback);
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var sessionId = tmp;
		    var tmp_0 = new UpdateSessionRequest(sessionId, token);
		    this.f38_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, VOID, SessionAPIImpl$refreshSession$lambda(callback, this, sessionId, token))));
		  };
		  protoOf(SessionAPIImpl).q1d = function (listener) {
		    this.h38_1 = listener;
		  };
		  function SessionErrorReason_TokenExpired_getInstance() {
		    SessionErrorReason_initEntries();
		    return SessionErrorReason_TokenExpired_instance;
		  }
		  function SessionErrorReason_TransportClosed_getInstance() {
		    SessionErrorReason_initEntries();
		    return SessionErrorReason_TransportClosed_instance;
		  }
		  function SessionErrorReason_PingTimeout_getInstance() {
		    SessionErrorReason_initEntries();
		    return SessionErrorReason_PingTimeout_instance;
		  }
		  function VoiceClientListener() {
		  }
		  var VoiceInviteCancelReason_AnsweredElsewhere_instance;
		  var VoiceInviteCancelReason_RejectedElsewhere_instance;
		  var VoiceInviteCancelReason_RemoteCancel_instance;
		  var VoiceInviteCancelReason_RemoteTimeout_instance;
		  var VoiceInviteCancelReason_entriesInitialized;
		  function VoiceInviteCancelReason_initEntries() {
		    if (VoiceInviteCancelReason_entriesInitialized)
		      return Unit_instance;
		    VoiceInviteCancelReason_entriesInitialized = true;
		    VoiceInviteCancelReason_AnsweredElsewhere_instance = new VoiceInviteCancelReason('AnsweredElsewhere', 0);
		    VoiceInviteCancelReason_RejectedElsewhere_instance = new VoiceInviteCancelReason('RejectedElsewhere', 1);
		    VoiceInviteCancelReason_RemoteCancel_instance = new VoiceInviteCancelReason('RemoteCancel', 2);
		    VoiceInviteCancelReason_RemoteTimeout_instance = new VoiceInviteCancelReason('RemoteTimeout', 3);
		  }
		  function VoiceInviteCancelReason(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  var HangupReason_remoteReject_instance;
		  var HangupReason_remoteHangup_instance;
		  var HangupReason_remoteNoAnswerTimeout_instance;
		  var HangupReason_localHangup_instance;
		  var HangupReason_mediaTimeout_instance;
		  var HangupReason_entriesInitialized;
		  function HangupReason_initEntries() {
		    if (HangupReason_entriesInitialized)
		      return Unit_instance;
		    HangupReason_entriesInitialized = true;
		    HangupReason_remoteReject_instance = new HangupReason('remoteReject', 0);
		    HangupReason_remoteHangup_instance = new HangupReason('remoteHangup', 1);
		    HangupReason_remoteNoAnswerTimeout_instance = new HangupReason('remoteNoAnswerTimeout', 2);
		    HangupReason_localHangup_instance = new HangupReason('localHangup', 3);
		    HangupReason_mediaTimeout_instance = new HangupReason('mediaTimeout', 4);
		  }
		  function HangupReason(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  var LegStatus_ringing_instance;
		  var LegStatus_answered_instance;
		  var LegStatus_completed_instance;
		  function valueOf_2(value) {
		    switch (value) {
		      case 'ringing':
		        return LegStatus_ringing_getInstance();
		      case 'answered':
		        return LegStatus_answered_getInstance();
		      case 'completed':
		        return LegStatus_completed_getInstance();
		      default:
		        LegStatus_initEntries();
		        THROW_IAE('No enum constant value.');
		        break;
		    }
		  }
		  var LegStatus_entriesInitialized;
		  function LegStatus_initEntries() {
		    if (LegStatus_entriesInitialized)
		      return Unit_instance;
		    LegStatus_entriesInitialized = true;
		    LegStatus_ringing_instance = new LegStatus('ringing', 0);
		    LegStatus_answered_instance = new LegStatus('answered', 1);
		    LegStatus_completed_instance = new LegStatus('completed', 2);
		  }
		  function LegStatus(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  var CallDisconnectReason_networkChange_instance;
		  var CallDisconnectReason_entriesInitialized;
		  function CallDisconnectReason_initEntries() {
		    if (CallDisconnectReason_entriesInitialized)
		      return Unit_instance;
		    CallDisconnectReason_entriesInitialized = true;
		    CallDisconnectReason_networkChange_instance = new CallDisconnectReason('networkChange', 0);
		  }
		  function CallDisconnectReason(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function VoiceAPIImpl$o$onAudioMuteUpdate$lambda($legId, $isMuted) {
		    return function (l, callId) {
		      l.b39(callId, $legId, $isMuted);
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$o$onAudioEarmuffUpdate$lambda($legId, $earmuffStatus) {
		    return function (l, callId) {
		      l.c39(callId, $legId, $earmuffStatus);
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$o$onAudioDTMFUpdate$lambda($leg_id, $digits) {
		    return function (l, callId) {
		      l.d39(callId, $leg_id, $digits);
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$o$onRTCHangup$lambda($hangup, $reason) {
		    return function (l, callId) {
		      l.e39(callId, $hangup.k27_1, $reason._v);
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$o$onLegStatusUpdate$lambda($legId, $status) {
		    return function (l, callId) {
		      l.f39(callId, $legId, valueOf_2($status));
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$o$onRTCTransfer$lambda($legId, $conversationId) {
		    return function (l, callId) {
		      var tmp;
		      if (callId === $legId) {
		        l.a39(callId, $conversationId);
		        tmp = Unit_instance;
		      } else {
		        l.f39(callId, $legId, LegStatus_answered_getInstance());
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function dispatchCallAction($this, callId, action) {
		    var tmp0_elvis_lhs = getCallStateByLeg($this, callId);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return new NoCallFound();
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var call = tmp;
		    var callMemberShipState = call.p39_1.w1();
		    var tmp_0;
		    if (callMemberShipState instanceof Joined) {
		      action(callMemberShipState.u39_1, callMemberShipState.v39_1);
		      tmp_0 = null;
		    } else {
		      tmp_0 = new InvalidCallAction();
		    }
		    return tmp_0;
		  }
		  function getCallStateByLeg($this, legId) {
		    var state = $this.x39_1.t2y(getKClass(CallReducer));
		    return state.a3a_1.c2(legId);
		  }
		  function getCallStateByConversation($this, cid) {
		    var state = $this.x39_1.t2y(getKClass(CallReducer));
		    var tmp0_safe_receiver = state.b3a_1.c2(cid);
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.getCallStateByConversation.<anonymous>' call
		      tmp = getCallStateByLeg($this, tmp0_safe_receiver);
		    }
		    return tmp;
		  }
		  function getLegIdByConversation($this, cid) {
		    var state = $this.x39_1.t2y(getKClass(CallReducer));
		    return state.b3a_1.c2(cid);
		  }
		  function isFromMe($this, userId) {
		    var state = $this.x39_1.t2y(getKClass(SessionReducer));
		    var tmp0_safe_receiver = state.l38_1.w1().l2n();
		    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n2u_1) === userId;
		  }
		  function invokeListener($this, conversationId, givenLegId, fn) {
		    var tmp0_safe_receiver = $this.z39_1;
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp1_elvis_lhs = getLegIdByConversation($this, conversationId);
		      var tmp;
		      if (tmp1_elvis_lhs == null) {
		        var tmp_0;
		        if (givenLegId == null) {
		          tmp_0 = null;
		        } else {
		          // Inline function 'kotlin.let' call
		          // Inline function 'kotlin.contracts.contract' call
		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.invokeListener.<anonymous>.<anonymous>' call
		          var tmp_1;
		          if (getCallStateByLeg($this, givenLegId) == null) {
		            tmp_1 = null;
		          } else {
		            // Inline function 'kotlin.let' call
		            // Inline function 'kotlin.contracts.contract' call
		            // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.invokeListener.<anonymous>.<anonymous>.<anonymous>' call
		            tmp_1 = givenLegId;
		          }
		          tmp_0 = tmp_1;
		        }
		        tmp = tmp_0;
		      } else {
		        tmp = tmp1_elvis_lhs;
		      }
		      var tmp3_elvis_lhs = tmp;
		      var tmp_2;
		      if (tmp3_elvis_lhs == null) {
		        var tmp2_safe_receiver = getCallStateByConversation($this, conversationId);
		        tmp_2 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.o39_1;
		      } else {
		        tmp_2 = tmp3_elvis_lhs;
		      }
		      var legId = tmp_2;
		      var tmp_3;
		      if (legId == null) {
		        $this.y39_1.k38('Call Id for Conversation Id: ' + conversationId + ' was not found');
		        tmp_3 = Unit_instance;
		      } else {
		        tmp_3 = fn(tmp0_safe_receiver, legId);
		      }
		    }
		  }
		  function invokeListener$default($this, conversationId, givenLegId, fn, $super) {
		    givenLegId = givenLegId === VOID ? null : givenLegId;
		    return invokeListener($this, conversationId, givenLegId, fn);
		  }
		  function handleCallReconnection($this, store, callId) {
		    var cancel = {_v: null};
		    var cachedRetryCount = {_v: 0};
		    var tmp = getKClass(CallReducer);
		    cancel._v = store.a2z(tmp, VoiceAPIImpl$handleCallReconnection$lambda(store, callId, cancel, cachedRetryCount, $this));
		  }
		  function reconnectCall($this, store, callId) {
		    var tmp0_safe_receiver = store.t2y(getKClass(CallReducer)).a3a_1.c2(callId);
		    var tmp;
		    if (tmp0_safe_receiver == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.takeIf' call
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp_0;
		      // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.reconnectCall.<anonymous>' call
		      var tmp_1 = tmp0_safe_receiver.s39_1;
		      if (tmp_1 instanceof Reconnecting) {
		        tmp_0 = tmp0_safe_receiver;
		      } else {
		        tmp_0 = null;
		      }
		      tmp = tmp_0;
		    }
		    var tmp1_elvis_lhs = tmp;
		    var tmp_2;
		    if (tmp1_elvis_lhs == null) {
		      return Unit_instance;
		    } else {
		      tmp_2 = tmp1_elvis_lhs;
		    }
		    var updatedCall = tmp_2;
		    var tmp_3 = updatedCall.p39_1.w1();
		    var tmp2_elvis_lhs = tmp_3 instanceof Joined ? tmp_3 : null;
		    var tmp_4;
		    if (tmp2_elvis_lhs == null) {
		      return Unit_instance;
		    } else {
		      tmp_4 = tmp2_elvis_lhs;
		    }
		    var member = tmp_4;
		    var tmp_5 = new CallReconnect(updatedCall.o39_1, member.v39_1, member.u39_1);
		    var reconnectAction = new Action_0(tmp_5, new ActionMeta(VOID, VOID, VoiceAPIImpl$reconnectCall$lambda_0(store, updatedCall)));
		    store.a1g(reconnectAction);
		  }
		  function onCallMediaChange($this, callState) {
		    var tmp = callState.q39_1;
		    if (tmp instanceof Failed) {
		      $this.x39_1.a1g(Action_init_$Create$(new MediaDisable(callState.o39_1)));
		    } else {
		      var tmp_0 = callState.q39_1.w1();
		      if (tmp_0 instanceof Completed) {
		        $this.x39_1.a1g(Action_init_$Create$(new MediaDisable(callState.o39_1)));
		      }
		    }
		  }
		  function onCallMemberChange($this, callState) {
		    if (callState.p39_1 instanceof Failed) {
		      var tmp1_subject = callState.p39_1.w1();
		      if (tmp1_subject instanceof Knocking) {
		        $this.x39_1.a1g(Action_init_$Create$(new MediaDisable(callState.o39_1)));
		      } else {
		        if (tmp1_subject instanceof Left) {
		          $this.x39_1.a1g(Action_init_$Create$(new MediaDisable(callState.o39_1)));
		        }
		      }
		    }
		  }
		  function getCallDetailsAndDispatchCallReconnect($this, legId, callback) {
		    var tmp = new GetLegRequest(legId);
		    $this.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, legId, VoiceAPIImpl$getCallDetailsAndDispatchCallReconnect$lambda($this, callback, legId))));
		  }
		  function VoiceAPIImpl$getLeg$lambda($callback) {
		    return function (response) {
		      var tmp;
		      if (response instanceof GetLeg) {
		        var leg = Companion_instance_144.p33(response);
		        tmp = $callback(null, leg);
		      } else {
		        invokeCallbackWithError(response, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$getCallLegs$lambda$lambda($conversationMedia, $callback) {
		    return function (conversationLegsResponse) {
		      var tmp;
		      if (conversationLegsResponse instanceof GetConversationLegs) {
		        // Inline function 'kotlin.collections.map' call
		        var this_0 = conversationLegsResponse.q1k_1.n1k_1;
		        // Inline function 'kotlin.collections.mapTo' call
		        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
		        var tmp0_iterator = this_0.p();
		        while (tmp0_iterator.q()) {
		          var item = tmp0_iterator.s();
		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.getCallLegs.<anonymous>.<anonymous>.<anonymous>' call
		          var tmp0_safe_receiver = item.j1j_1;
		          var tmp_0;
		          if (tmp0_safe_receiver == null) {
		            tmp_0 = null;
		          } else {
		            // Inline function 'kotlin.let' call
		            // Inline function 'kotlin.contracts.contract' call
		            // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.getCallLegs.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
		            tmp_0 = new MediaState($conversationMedia.j33_1 ? true : tmp0_safe_receiver.j33_1, $conversationMedia.k33_1 ? true : tmp0_safe_receiver.k33_1, $conversationMedia.l33_1 ? true : tmp0_safe_receiver.l33_1, $conversationMedia.m33_1 ? true : tmp0_safe_receiver.m33_1, $conversationMedia.n33_1 ? true : tmp0_safe_receiver.n33_1, $conversationMedia.o33_1 ? true : tmp0_safe_receiver.o33_1);
		          }
		          var tmp1_elvis_lhs = tmp_0;
		          var mediaState = tmp1_elvis_lhs == null ? $conversationMedia : tmp1_elvis_lhs;
		          var tmp$ret$2 = Companion_instance_144.p33(item.l1j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mediaState));
		          destination.m(tmp$ret$2);
		        }
		        var legs = destination;
		        var tmp1_safe_receiver = conversationLegsResponse.r1k_1.y1k_1;
		        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u1k_1;
		        var previous = tmp2_safe_receiver == null ? null : getCursor(tmp2_safe_receiver);
		        var tmp3_safe_receiver = conversationLegsResponse.r1k_1.x1k_1;
		        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.u1k_1;
		        var next = tmp4_safe_receiver == null ? null : getCursor(tmp4_safe_receiver);
		        var page = new LegsPage(legs, previous, next);
		        tmp = $callback(null, page);
		      } else {
		        invokeCallbackWithError(conversationLegsResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$getCallLegs$lambda(this$0, $callback, $memberState, $parameters) {
		    return function (getConversationResponse) {
		      var tmp;
		      if (getConversationResponse instanceof GetConversation) {
		        var tmp1_elvis_lhs = getConversationResponse.d1k_1;
		        var tmp_0;
		        if (tmp1_elvis_lhs == null) {
		          // Inline function 'kotlin.run' call
		          // Inline function 'kotlin.contracts.contract' call
		          invokeCallbackWithError(new NoCallMediaFound(), $callback);
		          return Unit_instance;
		        } else {
		          tmp_0 = tmp1_elvis_lhs;
		        }
		        var conversationMedia = tmp_0;
		        var tmp2_safe_receiver = $parameters;
		        var tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.n37_1;
		        var tmp3_safe_receiver = $parameters;
		        var tmp_2 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.o37_1;
		        var tmp4_safe_receiver = $parameters;
		        var tmp_3 = new GetConversationLegsRequest($memberState.u39_1, tmp_1, tmp_2, tmp4_safe_receiver == null ? null : tmp4_safe_receiver.p37_1);
		        this$0.x39_1.a1g(new Action_0(tmp_3, new ActionMeta(VOID, VOID, VoiceAPIImpl$getCallLegs$lambda$lambda(conversationMedia, $callback))));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError(getConversationResponse, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$serverCall$lambda$lambda$lambda$lambda$lambda$lambda($call, $cancel, $callback, this$0, $legId) {
		    return function () {
		      var tmp;
		      if ($call.t39_1.i8_1 === 5) {
		        var tmp1_safe_receiver = $cancel._v;
		        if (tmp1_safe_receiver == null)
		          null;
		        else
		          tmp1_safe_receiver();
		        invokeCallbackWithError(new MediaTimeout(), $callback);
		        this$0.x39_1.a1g(Action_init_$Create$(new CallCleanup($legId)));
		        tmp = Unit_instance;
		      } else {
		        var tmp_0;
		        if ($call.p39_1.w1() instanceof Joined) {
		          var tmp3_safe_receiver = $cancel._v;
		          if (tmp3_safe_receiver == null)
		            null;
		          else
		            tmp3_safe_receiver();
		          tmp_0 = $callback(null, $legId);
		        } else {
		          tmp_0 = Unit_instance;
		        }
		        tmp = tmp_0;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$serverCall$lambda$lambda$lambda$lambda$lambda($call, $cancel, $callback, this$0, $legId) {
		    return function () {
		      return new StoredSubscription(VoiceAPIImpl$serverCall$lambda$lambda$lambda$lambda$lambda$lambda($call, $cancel, $callback, this$0, $legId));
		    };
		  }
		  function VoiceAPIImpl$serverCall$lambda$lambda$lambda$lambda(this$0, $call, $callback, $cancel, $legId) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        this$0.x39_1.a1g(Action_init_$Create$(new CallKnockingRequestFailure($call.o39_1, it)));
		        invokeCallbackWithError(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        var tmp_0 = getKClass(CallReducer);
		        $cancel._v = this$0.x39_1.a2z(tmp_0, VoiceAPIImpl$serverCall$lambda$lambda$lambda$lambda$lambda($call, $cancel, $callback, this$0, $legId));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$serverCall$lambda$lambda$lambda$lambda_0() {
		    return 'Unexpected Media Connection Transition during setup';
		  }
		  function VoiceAPIImpl$serverCall$lambda$lambda$lambda(this$0, $legId, $cancel, $callback) {
		    return function () {
		      var state = this$0.x39_1.t2y(getKClass(CallReducer));
		      var tmp0_safe_receiver = state.a3a_1.c2($legId);
		      if (tmp0_safe_receiver == null)
		        null;
		      else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        var tmp;
		        switch (tmp0_safe_receiver.t39_1.i8_1) {
		          case 3:
		            var tmp1_safe_receiver = $cancel._v;
		            if (tmp1_safe_receiver == null)
		              null;
		            else
		              tmp1_safe_receiver();
		            var tmp2_safe_receiver = tmp0_safe_receiver.n39_1;
		            var tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.c2('to');
		            var tmp3_elvis_lhs = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null;
		            var tmp_1 = new AppKnockingRequest(tmp0_safe_receiver.m39_1, new PhoneChannelEndpoint(tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs), $legId, tmp0_safe_receiver.n39_1);
		            this$0.x39_1.a1g(new Action_0(tmp_1, new ActionMeta(VOID, tmp0_safe_receiver.o39_1, VoiceAPIImpl$serverCall$lambda$lambda$lambda$lambda(this$0, tmp0_safe_receiver, $callback, $cancel, $legId))));
		            tmp = Unit_instance;
		            break;
		          case 2:
		          case 1:
		          case 0:
		            tmp = Unit_instance;
		            break;
		          case 5:
		            var tmp4_safe_receiver = $cancel._v;
		            if (tmp4_safe_receiver == null)
		              null;
		            else
		              tmp4_safe_receiver();
		            invokeCallbackWithError(new MediaTimeout(), $callback);
		            this$0.x39_1.a1g(Action_init_$Create$(new CallCleanup($legId)));
		            tmp = Unit_instance;
		            break;
		          case 6:
		          case 4:
		            this$0.y39_1.e3a(VOID, VoiceAPIImpl$serverCall$lambda$lambda$lambda$lambda_0);
		            var tmp5_safe_receiver = $cancel._v;
		            if (tmp5_safe_receiver == null)
		              null;
		            else
		              tmp5_safe_receiver();
		            this$0.x39_1.a1g(Action_init_$Create$(new CallCleanup($legId)));
		            tmp = Unit_instance;
		            break;
		        }
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$serverCall$lambda$lambda(this$0, $legId, $cancel, $callback) {
		    return function () {
		      return new StoredSubscription(VoiceAPIImpl$serverCall$lambda$lambda$lambda(this$0, $legId, $cancel, $callback));
		    };
		  }
		  function VoiceAPIImpl$serverCall$lambda(this$0, $callback) {
		    return function (it) {
		      var tmp;
		      if (!(it == null) ? typeof it === 'string' : false) {
		        var legId = it;
		        var cancel = {_v: null};
		        var tmp_0 = getKClass(CallReducer);
		        cancel._v = this$0.x39_1.a2z(tmp_0, VoiceAPIImpl$serverCall$lambda$lambda(this$0, legId, cancel, $callback));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError(it, $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$reconnectCall$lambda$lambda(this$0, $callId, $once, $callback) {
		    return function () {
		      var state = this$0.x39_1.t2y(getKClass(CallReducer));
		      var tmp0_elvis_lhs = state.a3a_1.c2($callId);
		      var tmp;
		      if (tmp0_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp = tmp0_elvis_lhs;
		      }
		      var call = tmp;
		      var legState = call.q39_1;
		      var tmp_0;
		      if (legState.w1() instanceof Started) {
		        var tmp2_safe_receiver = $once._v;
		        if (tmp2_safe_receiver == null)
		          null;
		        else
		          tmp2_safe_receiver();
		        var tmp_1;
		        if (call.l39_1) {
		          tmp_1 = $callback(null);
		        }
		        tmp_0 = tmp_1;
		      } else {
		        tmp_0 = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$reconnectCall$lambda(this$0, $callId, $once, $callback) {
		    return function () {
		      return new StoredSubscription(VoiceAPIImpl$reconnectCall$lambda$lambda(this$0, $callId, $once, $callback));
		    };
		  }
		  function VoiceAPIImpl$rejectCall$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$answerCall$lambda$lambda$lambda$lambda(this$0, $legIdOrErr, $callback, $cancel) {
		    return function () {
		      var call = this$0.x39_1.t2y(getKClass(CallReducer)).a3a_1.c2($legIdOrErr);
		      var tmp1_subject = call == null ? null : call.t39_1;
		      var tmp;
		      switch (tmp1_subject == null ? -1 : tmp1_subject.i8_1) {
		        case -1:
		          // Inline function 'kotlin.let' call

		          invokeCallbackWithError_0(new NoInviteFound(), $callback);
		          // Inline function 'kotlin.contracts.contract' call

		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.answerCall.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call

		          var tmp0_safe_receiver = $cancel._v;
		          tmp0_safe_receiver == null || tmp0_safe_receiver();
		          tmp = Unit_instance;
		          break;
		        case 3:
		          // Inline function 'kotlin.also' call

		          var tmp2_safe_receiver = $cancel._v;
		          tmp2_safe_receiver == null || tmp2_safe_receiver();
		          // Inline function 'kotlin.contracts.contract' call

		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.answerCall.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call

		          $callback(null);
		          tmp = Unit_instance;
		          break;
		        case 5:
		        case 6:
		          // Inline function 'kotlin.also' call

		          var tmp3_safe_receiver = $cancel._v;
		          tmp3_safe_receiver == null || tmp3_safe_receiver();
		          // Inline function 'kotlin.contracts.contract' call

		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.answerCall.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call

		          invokeCallbackWithError_0(new InboundCallFailed(), $callback);
		          tmp = Unit_instance;
		          break;
		        default:
		          tmp = Unit_instance;
		          break;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$answerCall$lambda$lambda$lambda(this$0, $legIdOrErr, $callback, $cancel) {
		    return function () {
		      return new StoredSubscription(VoiceAPIImpl$answerCall$lambda$lambda$lambda$lambda(this$0, $legIdOrErr, $callback, $cancel));
		    };
		  }
		  function VoiceAPIImpl$answerCall$lambda$lambda(this$0, $callback) {
		    return function (legIdOrErr) {
		      var tmp;
		      if (!(legIdOrErr == null) ? typeof legIdOrErr === 'string' : false) {
		        var cancel = {_v: null};
		        var tmp_0 = getKClass(CallReducer);
		        cancel._v = this$0.x39_1.a2z(tmp_0, VoiceAPIImpl$answerCall$lambda$lambda$lambda(this$0, legIdOrErr, $callback, cancel));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError_0(new InboundCallFailed(legIdOrErr instanceof Exception ? legIdOrErr : null), $callback);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$answerCall$lambda($callback, $invite, this$0, $callId) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        if ($invite.j3a_1 == null) {
		          // Inline function 'kotlin.run' call
		          // Inline function 'kotlin.contracts.contract' call
		          invokeCallbackWithError_0(new NoOfferFound(), $callback);
		          return Unit_instance;
		        }
		        var tmp_0 = new SetupInboundCall($callId, $invite.i3a_1, $invite.h3a_1, $invite.f3a_1, $invite.j3a_1, null);
		        this$0.x39_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, VOID, VoiceAPIImpl$answerCall$lambda$lambda(this$0, $callback))));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$hangupCall$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$hangupCall$lambda_0($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$mute$lambda$lambda$lambda($callback) {
		    return function (legMuteResponse) {
		      var tmp;
		      if (legMuteResponse instanceof Exception) {
		        invokeCallbackWithError_0(legMuteResponse, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$mute$lambda$lambda($callback, this$0, $cid, $callId, $mid) {
		    return function (muteOutcome) {
		      var tmp;
		      if (muteOutcome instanceof Exception) {
		        invokeCallbackWithError_0(muteOutcome, $callback);
		        tmp = Unit_instance;
		      } else {
		        var tmp_0 = new LegMuteRequest($cid, $callId, $mid);
		        this$0.x39_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, $callId, VoiceAPIImpl$mute$lambda$lambda$lambda($callback))));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$mute$lambda(this$0, $callId, $callback) {
		    return function (cid, mid) {
		      var tmp = new Mute($callId);
		      this$0.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, $callId, VoiceAPIImpl$mute$lambda$lambda($callback, this$0, cid, $callId, mid))));
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$unmute$lambda$lambda$lambda($callback) {
		    return function (legUnmuteResponse) {
		      var tmp;
		      if (legUnmuteResponse instanceof Exception) {
		        invokeCallbackWithError_0(legUnmuteResponse, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$unmute$lambda$lambda($callback, this$0, $cid, $callId, $mid) {
		    return function (unmuteOutcome) {
		      var tmp;
		      if (unmuteOutcome instanceof Exception) {
		        invokeCallbackWithError_0(unmuteOutcome, $callback);
		        tmp = Unit_instance;
		      } else {
		        var tmp_0 = new LegUnmuteRequest($cid, $callId, $mid);
		        this$0.x39_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, $callId, VoiceAPIImpl$unmute$lambda$lambda$lambda($callback))));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$unmute$lambda(this$0, $callId, $callback) {
		    return function (cid, mid) {
		      var tmp = new Unmute($callId);
		      this$0.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, $callId, VoiceAPIImpl$unmute$lambda$lambda($callback, this$0, cid, $callId, mid))));
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$enableEarmuff$lambda$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$enableEarmuff$lambda(this$0, $callId, $callback) {
		    return function (cid, mid) {
		      this$0.x39_1.a1g(Action_init_$Create$(new EnableEarmuff($callId)));
		      var tmp = new LegEarmuffEnableRequest(cid, $callId, mid);
		      this$0.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, $callId, VoiceAPIImpl$enableEarmuff$lambda$lambda($callback))));
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$disableEarmuff$lambda$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$disableEarmuff$lambda(this$0, $callId, $callback) {
		    return function (cid, mid) {
		      this$0.x39_1.a1g(Action_init_$Create$(new DisableEarmuff($callId)));
		      var tmp = new LegEarmuffDisableRequest(cid, $callId, mid);
		      this$0.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, $callId, VoiceAPIImpl$disableEarmuff$lambda$lambda($callback))));
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$sendDTMF$lambda$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$sendDTMF$lambda(this$0, $callId, $digits, $callback) {
		    return function (cid, mid) {
		      this$0.x39_1.a1g(Action_init_$Create$(new DisableEarmuff($callId)));
		      var tmp = new LegDTMFRequest(cid, $callId, mid, $digits);
		      this$0.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, $callId, VoiceAPIImpl$sendDTMF$lambda$lambda($callback))));
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$say$lambda$lambda($callback) {
		    return function (it) {
		      var tmp;
		      if (it instanceof Exception) {
		        invokeCallbackWithError_0(it, $callback);
		        tmp = Unit_instance;
		      } else {
		        tmp = $callback(null);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$say$lambda(this$0, $text, $level, $loop, $queue, $voiceName, $ssml, $callId, $callback) {
		    return function (cid, mid) {
		      var tmp = new AudioSayRequest(cid, mid, $text, $level, $loop, $queue, $voiceName, $ssml);
		      this$0.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, $callId, VoiceAPIImpl$say$lambda$lambda($callback))));
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$handleCallReconnection$lambda$lambda($store, $callId, $cancel, $cachedRetryCount, this$0) {
		    return function () {
		      var callState = $store.t2y(getKClass(CallReducer));
		      var tmp0_elvis_lhs = callState.a3a_1.c2($callId);
		      var tmp;
		      if (tmp0_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp = tmp0_elvis_lhs;
		      }
		      var call = tmp;
		      var tmp_0;
		      var tmp_1 = call.s39_1;
		      if (tmp_1 instanceof Connected) {
		        var tmp1_safe_receiver = $cancel._v;
		        if (tmp1_safe_receiver == null)
		          null;
		        else
		          tmp1_safe_receiver();
		        tmp_0 = Unit_instance;
		      }
		      var tmp_2 = call.s39_1;
		      var tmp2_safe_receiver = tmp_2 instanceof Reconnecting ? tmp_2 : null;
		      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.o3a_1;
		      var tmp_3;
		      if (tmp3_safe_receiver == null) {
		        tmp_3 = null;
		      } else {
		        // Inline function 'kotlin.takeIf' call
		        // Inline function 'kotlin.contracts.contract' call
		        var tmp_4;
		        // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.handleCallReconnection.<anonymous>.<anonymous>.<anonymous>' call
		        if (tmp3_safe_receiver > $cachedRetryCount._v) {
		          tmp_4 = tmp3_safe_receiver;
		        } else {
		          tmp_4 = null;
		        }
		        tmp_3 = tmp_4;
		      }
		      var tmp4_elvis_lhs = tmp_3;
		      var tmp_5;
		      if (tmp4_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp_5 = tmp4_elvis_lhs;
		      }
		      $cachedRetryCount._v = tmp_5;
		      reconnectCall(this$0, $store, $callId);
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$handleCallReconnection$lambda($store, $callId, $cancel, $cachedRetryCount, this$0) {
		    return function () {
		      return new StoredSubscription(VoiceAPIImpl$handleCallReconnection$lambda$lambda($store, $callId, $cancel, $cachedRetryCount, this$0));
		    };
		  }
		  function VoiceAPIImpl$reconnectCall$lambda_0($store, $updatedCall) {
		    return function (response) {
		      var tmp;
		      if (!(response == null) ? typeof response === 'string' : false) {
		        $store.a1g(Action_init_$Create$(new CallReconnectSuccess($updatedCall.o39_1)));
		        tmp = Unit_instance;
		      } else {
		        var tmp_0 = $updatedCall.s39_1;
		        var tmp1_safe_receiver = tmp_0 instanceof Reconnecting ? tmp_0 : null;
		        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.o3a_1;
		        var tmp_1;
		        if (tmp2_elvis_lhs == null) {
		          return Unit_instance;
		        } else {
		          tmp_1 = tmp2_elvis_lhs;
		        }
		        var retryCount = tmp_1;
		        var csError = response instanceof CSError ? response : null;
		        var tmp_2;
		        var tmp_3;
		        if (retryCount === 5) {
		          tmp_3 = true;
		        } else {
		          tmp_3 = !(csError == null);
		        }
		        if (tmp_3) {
		          $store.a1g(Action_init_$Create$(new CallReconnectFailure($updatedCall.o39_1)));
		          tmp_2 = Unit_instance;
		        } else {
		          var tmp_4 = new CallReconnectionRetry($updatedCall.o39_1);
		          $store.a1g(Action_init_$Create$(new TimeoutAction(tmp_4, 3000)));
		          tmp_2 = Unit_instance;
		        }
		        tmp = tmp_2;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$1(this$0) {
		    this.p3a_1 = this$0;
		  }
		  protoOf(VoiceAPIImpl$1).v2t = function (conversationId, legId, isMuted) {
		    invokeListener$default(this.p3a_1, conversationId, VOID, VoiceAPIImpl$o$onAudioMuteUpdate$lambda(legId, isMuted));
		  };
		  protoOf(VoiceAPIImpl$1).w2t = function (conversationId, legId, earmuffStatus) {
		    invokeListener$default(this.p3a_1, conversationId, VOID, VoiceAPIImpl$o$onAudioEarmuffUpdate$lambda(legId, earmuffStatus));
		  };
		  protoOf(VoiceAPIImpl$1).x2t = function (conversationId, legId, digits) {
		    var leg_id = legId == null ? '' : legId;
		    invokeListener$default(this.p3a_1, conversationId, VOID, VoiceAPIImpl$o$onAudioDTMFUpdate$lambda(leg_id, digits));
		  };
		  protoOf(VoiceAPIImpl$1).r2t = function (conversationId, legId, hangup) {
		    var tmp;
		    if (legId == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.api.<no name provided>.onRTCHangup.<anonymous>' call
		      tmp = getCallStateByLeg(this.p3a_1, legId);
		    }
		    var call = tmp;
		    var tmp0 = hangup.j27_1.r3a_1.i8_1;
		    var reason = {_v: tmp0 === 0 ? HangupReason_localHangup_getInstance() : tmp0 === 2 ? HangupReason_remoteHangup_getInstance() : tmp0 === 1 ? HangupReason_mediaTimeout_getInstance() : tmp0 === 4 ? HangupReason_mediaTimeout_getInstance() : HangupReason_localHangup_getInstance()};
		    if (!(call == null)) {
		      if (call.p39_1.x3a() === null) {
		        var tmp_0;
		        var tmp_1;
		        var tmp_2 = call.p39_1;
		        if (tmp_2 instanceof Resolved) {
		          var tmp_3 = call.p39_1.w1();
		          tmp_1 = tmp_3 instanceof Left;
		        } else {
		          tmp_1 = false;
		        }
		        if (tmp_1) {
		          var tmp_4 = call.p39_1.w1();
		          var tmp2_subject = (tmp_4 instanceof Left ? tmp_4 : THROW_CCE()).w3a_1;
		          var tmp_5;
		          if (tmp2_subject === 'remote_rejected') {
		            tmp_5 = HangupReason_remoteReject_getInstance();
		          } else {
		            if (tmp2_subject === 'remote_no_answer') {
		              tmp_5 = HangupReason_remoteReject_getInstance();
		            } else {
		              if (tmp2_subject === 'local_cancel') {
		                tmp_5 = HangupReason_remoteNoAnswerTimeout_getInstance();
		              } else {
		                if (tmp2_subject === 'ring_timer') {
		                  tmp_5 = HangupReason_remoteNoAnswerTimeout_getInstance();
		                } else {
		                  tmp_5 = HangupReason_remoteHangup_getInstance();
		                }
		              }
		            }
		          }
		          tmp_0 = tmp_5;
		        } else {
		          tmp_0 = HangupReason_remoteHangup_getInstance();
		        }
		        reason._v = tmp_0;
		      }
		      invokeListener$default(this.p3a_1, conversationId, VOID, VoiceAPIImpl$o$onRTCHangup$lambda(hangup, reason));
		    }
		    cleanupReducers(this.p3a_1.x39_1, legId, conversationId);
		  };
		  protoOf(VoiceAPIImpl$1).t2t = function (conversationId, legId, fromUserId, status) {
		    if (!(conversationId == null) ? !isFromMe(this.p3a_1, fromUserId) : false) {
		      invokeListener(this.p3a_1, conversationId, legId, VoiceAPIImpl$o$onLegStatusUpdate$lambda(legId, status));
		    }
		  };
		  protoOf(VoiceAPIImpl$1).s2t = function (conversationId, legId) {
		    invokeListener$default(this.p3a_1, conversationId, VOID, VoiceAPIImpl$o$onRTCTransfer$lambda(legId, conversationId));
		  };
		  function VoiceAPIImpl$lambda$lambda(this$0, $cachedSessionId) {
		    return function () {
		      var state = this$0.x39_1.t2y(getKClass(SessionReducer));
		      var currentSessionId = state.l38_1.w1().t27();
		      var tmp;
		      if (!state.m38_1.p2o_1.equals(SocketConnectionStatus_Connected_getInstance())) {
		        $cachedSessionId._v = null;
		        tmp = Unit_instance;
		      } else if (!(currentSessionId == null) ? !(currentSessionId == $cachedSessionId._v) : false) {
		        cleanupReducers(this$0.x39_1);
		        var invites = this$0.x39_1.t2y(getKClass(InviteReducer)).y3a_1;
		        // Inline function 'kotlin.collections.filterValues' call
		        var result = LinkedHashMap_init_$Create$();
		        // Inline function 'kotlin.collections.iterator' call
		        var tmp0_iterator = invites.u1().p();
		        while (tmp0_iterator.q()) {
		          var entry = tmp0_iterator.s();
		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		          var invite = entry.w1();
		          if (equals(invite.k3a_1.w1(), None_instance_1)) {
		            result.s1(entry.v1(), entry.w1());
		          }
		        }
		        // Inline function 'kotlin.collections.iterator' call
		        var tmp0_iterator_0 = result.u1().p();
		        while (tmp0_iterator_0.q()) {
		          var element = tmp0_iterator_0.s();
		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		          this$0.x39_1.a1g(new Action_0(new GetConversationRequest(element.w1().i3a_1), new ActionMeta(VOID, element.w1().g3a_1)));
		        }
		        tmp = Unit_instance;
		      } else {
		        tmp = Unit_instance;
		      }
		      $cachedSessionId._v = state.l38_1.w1().t27();
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$lambda(this$0) {
		    return function () {
		      var cachedSessionId = {_v: null};
		      return new StoredSubscription(VoiceAPIImpl$lambda$lambda(this$0, cachedSessionId));
		    };
		  }
		  function VoiceAPIImpl$lambda$lambda$lambda($state, $it, this$0) {
		    return function (getConversationResponse) {
		      var tmp;
		      var tmp_0;
		      var tmp_1;
		      if (getConversationResponse instanceof HTTPClientError) {
		        tmp_1 = true;
		      } else {
		        tmp_1 = getConversationResponse instanceof CSError;
		      }
		      if (tmp_1) {
		        tmp_0 = true;
		      } else {
		        tmp_0 = getConversationResponse instanceof AuthorizationError_0;
		      }
		      if (tmp_0) {
		        var tmp0_safe_receiver = $state.y3a_1.c2($it.g3a_1);
		        var currentInviteState = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k3a_1;
		        var tmp_2;
		        if (!(currentInviteState == null) ? equals(currentInviteState.w1(), None_instance_1) : false) {
		          this$0.x39_1.a1g(Action_init_$Create$(new InviteReconcile($it.g3a_1)));
		          tmp_2 = Unit_instance;
		        }
		        tmp = tmp_2;
		      } else {
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$lambda$lambda_0(this$0, $cache) {
		    return function () {
		      var state = this$0.x39_1.t2y(getKClass(InviteReducer));
		      var tmp;
		      if (state.a3b_1 == null) {
		        tmp = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		        // Inline function 'kotlin.collections.get' call
		        var this_0 = state.y3a_1;
		        var key = state.a3b_1;
		        tmp = (isInterface(this_0, Map) ? this_0 : THROW_CCE()).c2(key);
		      }
		      var updatedInvite = tmp;
		      var tmp_0;
		      if (state.a3b_1 == null) {
		        tmp_0 = Unit_instance;
		      } else {
		        var tmp_1;
		        if (!(updatedInvite == null)) {
		          // Inline function 'kotlin.collections.get' call
		          var this_1 = $cache;
		          var key_0 = state.a3b_1;
		          tmp_1 = (isInterface(this_1, Map) ? this_1 : THROW_CCE()).c2(key_0) == null;
		        } else {
		          tmp_1 = false;
		        }
		        if (tmp_1) {
		          // Inline function 'kotlin.collections.set' call
		          var this_2 = $cache;
		          var key_1 = updatedInvite.g3a_1;
		          var value = updatedInvite.b3b();
		          this_2.s1(key_1, value);
		          // Inline function 'kotlin.also' call
		          // Inline function 'kotlin.contracts.contract' call
		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		          var config = this$0.x39_1.t2y(getKClass(ConfigReducer));
		          if (config.h3b_1 ? updatedInvite.l3a_1 : false) {
		            var tmp0_safe_receiver = this$0.z39_1;
		            if (tmp0_safe_receiver == null)
		              null;
		            else {
		              tmp0_safe_receiver.y38(updatedInvite.g3a_1, from(updatedInvite.f3a_1), updatedInvite.f3a_1.c3b());
		            }
		          }
		          this$0.x39_1.a1g(new Action_0(new GetConversationRequest(updatedInvite.i3a_1), new ActionMeta(VOID, updatedInvite.g3a_1)));
		          var tmp_2 = new TimeoutAction(new GetConversationRequest(updatedInvite.i3a_1), 60000);
		          this$0.x39_1.a1g(new Action_0(tmp_2, new ActionMeta(VOID, updatedInvite.g3a_1, VoiceAPIImpl$lambda$lambda$lambda(state, updatedInvite, this$0))));
		          tmp_0 = Unit_instance;
		        } else {
		          var tmp_3;
		          var tmp_4;
		          var tmp_5;
		          if (!(updatedInvite == null)) {
		            var tmp_6 = updatedInvite.k3a_1.w1();
		            tmp_5 = tmp_6 instanceof Joined;
		          } else {
		            tmp_5 = false;
		          }
		          if (tmp_5) {
		            tmp_4 = updatedInvite.k3a_1.x3a() == null;
		          } else {
		            tmp_4 = false;
		          }
		          if (tmp_4) {
		            // Inline function 'kotlin.collections.get' call
		            var this_3 = $cache;
		            var key_2 = state.a3b_1;
		            var tmp1_safe_receiver = (isInterface(this_3, Map) ? this_3 : THROW_CCE()).c2(key_2);
		            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k3a_1;
		            tmp_3 = equals(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w1(), None_instance_1);
		          } else {
		            tmp_3 = false;
		          }
		          if (tmp_3) {
		            var tmp3_safe_receiver = this$0.z39_1;
		            if (tmp3_safe_receiver == null)
		              null;
		            else {
		              tmp3_safe_receiver.z38(updatedInvite.g3a_1, VoiceInviteCancelReason_AnsweredElsewhere_getInstance());
		            }
		            tmp_0 = Unit_instance;
		          } else {
		            var tmp_7;
		            var tmp_8;
		            if (!(updatedInvite == null)) {
		              // Inline function 'kotlin.collections.get' call
		              var this_4 = $cache;
		              var key_3 = state.a3b_1;
		              var tmp6_safe_receiver = (isInterface(this_4, Map) ? this_4 : THROW_CCE()).c2(key_3);
		              var tmp_9 = (tmp6_safe_receiver == null ? null : tmp6_safe_receiver.m3a_1) === false;
		              // Inline function 'kotlin.collections.get' call
		              var this_5 = $cache;
		              var key_4 = state.a3b_1;
		              var tmp4_safe_receiver = (isInterface(this_5, Map) ? this_5 : THROW_CCE()).c2(key_4);
		              var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.k3a_1;
		              tmp_8 = !!(tmp_9 | equals(tmp5_safe_receiver == null ? null : tmp5_safe_receiver.w1(), None_instance_1));
		            } else {
		              tmp_8 = false;
		            }
		            if (tmp_8) {
		              var tmp_10 = updatedInvite.m3a_1;
		              var tmp_11 = updatedInvite.k3a_1.w1();
		              tmp_7 = !!(tmp_10 & tmp_11 instanceof Left);
		            } else {
		              tmp_7 = false;
		            }
		            if (tmp_7) {
		              var tmp_12;
		              // Inline function 'kotlin.collections.get' call
		              var this_6 = $cache;
		              var key_5 = state.a3b_1;
		              var tmp7_safe_receiver = (isInterface(this_6, Map) ? this_6 : THROW_CCE()).c2(key_5);
		              var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.k3a_1;
		              var tmp_13 = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.w1();
		              if (tmp_13 instanceof Joined) {
		                tmp_12 = null;
		              } else {
		                if (!(updatedInvite.k3a_1.x3a() == null)) {
		                  tmp_12 = null;
		                } else {
		                  var tmp_14 = updatedInvite.k3a_1.w1();
		                  var tmp_15 = (tmp_14 instanceof Left ? tmp_14 : THROW_CCE()).w3a_1;
		                  if (tmp_15 === 'REMOTE_REJECT') {
		                    tmp_12 = VoiceInviteCancelReason_RejectedElsewhere_getInstance();
		                  } else {
		                    if (updatedInvite.n3a_1 === 487) {
		                      tmp_12 = VoiceInviteCancelReason_RemoteTimeout_getInstance();
		                    } else {
		                      tmp_12 = VoiceInviteCancelReason_RemoteCancel_getInstance();
		                    }
		                  }
		                }
		              }
		              var reason = tmp_12;
		              if (reason == null)
		                null;
		              else {
		                // Inline function 'kotlin.let' call
		                // Inline function 'kotlin.contracts.contract' call
		                // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		                var tmp0_safe_receiver_0 = this$0.z39_1;
		                var tmp_16;
		                if (tmp0_safe_receiver_0 == null) {
		                  tmp_16 = null;
		                } else {
		                  tmp0_safe_receiver_0.z38(updatedInvite.g3a_1, reason);
		                  tmp_16 = Unit_instance;
		                }
		              }
		              tmp_0 = Unit_instance;
		            } else {
		              var tmp_17;
		              if (updatedInvite == null) {
		                // Inline function 'kotlin.collections.get' call
		                var this_7 = $cache;
		                var key_6 = state.a3b_1;
		                tmp_17 = !((isInterface(this_7, Map) ? this_7 : THROW_CCE()).c2(key_6) == null);
		              } else {
		                tmp_17 = false;
		              }
		              if (tmp_17) {
		                // Inline function 'kotlin.collections.remove' call
		                var this_8 = $cache;
		                var key_7 = state.a3b_1;
		                (isInterface(this_8, MutableMap) ? this_8 : THROW_CCE()).t1(key_7);
		                tmp_0 = Unit_instance;
		              } else {
		                tmp_0 = Unit_instance;
		              }
		            }
		          }
		        }
		      }
		      if (updatedInvite == null)
		        null;
		      else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        var this_9 = $cache;
		        var key_8 = updatedInvite.g3a_1;
		        var value_0 = updatedInvite.b3b();
		        this_9.s1(key_8, value_0);
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$lambda_0(this$0) {
		    return function () {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      var cache = LinkedHashMap_init_$Create$();
		      return new StoredSubscription(VoiceAPIImpl$lambda$lambda_0(this$0, cache));
		    };
		  }
		  function VoiceAPIImpl$lambda$lambda_1(this$0, $cache) {
		    return function () {
		      var state = this$0.x39_1.t2y(getKClass(CallReducer));
		      var tmp0_elvis_lhs = state.d3a_1;
		      var tmp;
		      if (tmp0_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp = tmp0_elvis_lhs;
		      }
		      var lastModifiedCallId = tmp;
		      var tmp1_elvis_lhs = state.a3a_1.c2(lastModifiedCallId);
		      var tmp_0;
		      if (tmp1_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp_0 = tmp1_elvis_lhs;
		      }
		      var updatedCall = tmp_0;
		      var cachedCall = $cache.c2(lastModifiedCallId);
		      var this_0 = $cache;
		      var key = updatedCall.o39_1;
		      var value = updatedCall.o3b();
		      this_0.s1(key, value);
		      if (cachedCall == null)
		        return Unit_instance;
		      var tmp_1;
		      if (!equals(updatedCall.p39_1, cachedCall.p39_1)) {
		        onCallMemberChange(this$0, updatedCall);
		        tmp_1 = Unit_instance;
		      }
		      var tmp_2;
		      if ((!(updatedCall.r39_1.p3b_1 == null) ? true : updatedCall.l39_1) ? !updatedCall.r39_1.equals(cachedCall.r39_1) ? true : !equals(updatedCall.q39_1, cachedCall.q39_1) : false) {
		        onCallMediaChange(this$0, updatedCall);
		        tmp_2 = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$lambda_1(this$0) {
		    return function () {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      var cache = LinkedHashMap_init_$Create$();
		      return new StoredSubscription(VoiceAPIImpl$lambda$lambda_1(this$0, cache));
		    };
		  }
		  function VoiceAPIImpl$lambda$lambda_2(this$0, $cache) {
		    return function () {
		      var callState = this$0.x39_1.t2y(getKClass(CallReducer));
		      var tmp0_elvis_lhs = callState.d3a_1;
		      var tmp;
		      if (tmp0_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp = tmp0_elvis_lhs;
		      }
		      var lastModifiedCallId = tmp;
		      var tmp1_safe_receiver = callState.a3a_1.c2(lastModifiedCallId);
		      var tmp_0;
		      if (tmp1_safe_receiver == null) {
		        tmp_0 = null;
		      } else {
		        // Inline function 'kotlin.takeUnless' call
		        // Inline function 'kotlin.contracts.contract' call
		        var tmp_1;
		        // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		        var tmp_2 = tmp1_safe_receiver.q39_1.w1();
		        if (!(tmp_2 instanceof Completed)) {
		          tmp_1 = tmp1_safe_receiver;
		        } else {
		          tmp_1 = null;
		        }
		        tmp_0 = tmp_1;
		      }
		      var tmp2_elvis_lhs = tmp_0;
		      var tmp_3;
		      if (tmp2_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp_3 = tmp2_elvis_lhs;
		      }
		      var updatedCall = tmp_3;
		      var tmp3_safe_receiver = $cache.c2(lastModifiedCallId);
		      var tmp_4;
		      if (tmp3_safe_receiver == null) {
		        tmp_4 = null;
		      } else {
		        // Inline function 'kotlin.takeUnless' call
		        // Inline function 'kotlin.contracts.contract' call
		        var tmp_5;
		        // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		        if (!getKClassFromExpression(tmp3_safe_receiver.s39_1).equals(getKClassFromExpression(updatedCall.s39_1))) {
		          tmp_5 = tmp3_safe_receiver;
		        } else {
		          tmp_5 = null;
		        }
		        tmp_4 = tmp_5;
		      }
		      var tmp4_safe_receiver = tmp_4;
		      if (tmp4_safe_receiver == null)
		        null;
		      else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        $l$block: {
		          // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>' call
		          var tmp0_subject = updatedCall.s39_1;
		          if (tmp0_subject instanceof Reconnecting) {
		            // Inline function 'kotlin.takeIf' call
		            var this_0 = this$0.x39_1.t2y(getKClass(ConfigReducer));
		            // Inline function 'kotlin.contracts.contract' call
		            var tmp_6;
		            // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
		            if (this_0.m3b_1) {
		              tmp_6 = this_0;
		            } else {
		              tmp_6 = null;
		            }
		            if (tmp_6 == null) {
		              break $l$block;
		            }
		            var tmp2_safe_receiver = this$0.z39_1;
		            if (tmp2_safe_receiver == null)
		              null;
		            else {
		              tmp2_safe_receiver.g39(updatedCall.o39_1);
		            }
		            handleCallReconnection(this$0, this$0.x39_1, updatedCall.o39_1);
		          } else {
		            if (equals(tmp0_subject, Connected_instance)) {
		              var tmp3_safe_receiver_0 = this$0.z39_1;
		              var tmp_7;
		              if (tmp3_safe_receiver_0 == null) {
		                tmp_7 = null;
		              } else {
		                // Inline function 'kotlin.takeIf' call
		                // Inline function 'kotlin.contracts.contract' call
		                var tmp_8;
		                // Inline function 'com.vonage.clientcore.core.api.VoiceAPIImpl.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
		                var tmp_9 = tmp4_safe_receiver.s39_1;
		                if (tmp_9 instanceof Reconnecting) {
		                  tmp_8 = tmp3_safe_receiver_0;
		                } else {
		                  tmp_8 = null;
		                }
		                tmp_7 = tmp_8;
		              }
		              var tmp4_safe_receiver_0 = tmp_7;
		              if (tmp4_safe_receiver_0 == null)
		                null;
		              else {
		                tmp4_safe_receiver_0.h39(updatedCall.o39_1);
		              }
		            } else {
		              if (equals(tmp0_subject, Disconnected_instance)) {
		                var tmp5_safe_receiver = this$0.z39_1;
		                if (tmp5_safe_receiver == null)
		                  null;
		                else {
		                  tmp5_safe_receiver.i39(updatedCall.o39_1, CallDisconnectReason_networkChange_getInstance());
		                }
		              } else {
		                equals(tmp0_subject, New_instance);
		              }
		            }
		          }
		        }
		      }
		      var this_1 = $cache;
		      var value = updatedCall.o3b();
		      this_1.s1(lastModifiedCallId, value);
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$lambda_2(this$0) {
		    return function () {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      var cache = LinkedHashMap_init_$Create$();
		      return new StoredSubscription(VoiceAPIImpl$lambda$lambda_2(this$0, cache));
		    };
		  }
		  function VoiceAPIImpl$lambda$lambda_3(this$0) {
		    return function () {
		      var state = this$0.x39_1.t2y(getKClass(MediaEventReducer));
		      var tmp0_elvis_lhs = state.t3b_1;
		      var tmp;
		      if (tmp0_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp = tmp0_elvis_lhs;
		      }
		      var callId = tmp;
		      var tmp1_elvis_lhs = state.s3b_1.c2(callId);
		      var tmp_0;
		      if (tmp1_elvis_lhs == null) {
		        return Unit_instance;
		      } else {
		        tmp_0 = tmp1_elvis_lhs;
		      }
		      var mediaEvent = tmp_0;
		      var tmp_1;
		      if (mediaEvent instanceof MediaErrorEvent) {
		        var tmp3_safe_receiver = this$0.z39_1;
		        if (tmp3_safe_receiver == null)
		          null;
		        else {
		          tmp3_safe_receiver.k39(callId, toVonageError(mediaEvent.x2m_1));
		        }
		        tmp_1 = Unit_instance;
		      } else {
		        if (mediaEvent instanceof RTCStatsUpdate) {
		          var tmp4_safe_receiver = this$0.z39_1;
		          if (tmp4_safe_receiver == null)
		            null;
		          else {
		            tmp4_safe_receiver.j39(mediaEvent.z2m_1, callId);
		          }
		          tmp_1 = Unit_instance;
		        } else {
		          tmp_1 = Unit_instance;
		        }
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$lambda_3(this$0) {
		    return function () {
		      return new StoredSubscription(VoiceAPIImpl$lambda$lambda_3(this$0));
		    };
		  }
		  function VoiceAPIImpl$getCallDetailsAndDispatchCallReconnect$lambda$lambda(this$0, $legId, $legResponse, $callback) {
		    return function (memberResponse) {
		      var tmp;
		      if (memberResponse instanceof GetMember) {
		        var tmp_0;
		        if (memberResponse.f1r_1.i8_1 === 1) {
		          this$0.x39_1.a1g(Action_init_$Create$(new CallReconnect($legId, memberResponse.e1r_1, $legResponse.b1j_1)));
		          tmp_0 = Unit_instance;
		        } else {
		          invokeCallbackWithError_0(new MemberNotInConversation(), $callback);
		          tmp_0 = Unit_instance;
		        }
		        tmp = tmp_0;
		      } else {
		        invokeCallbackWithError_0(new NoConversationFound(), $callback);
		        this$0.x39_1.a1g(Action_init_$Create$(new CallCleanup($legId)));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl$getCallDetailsAndDispatchCallReconnect$lambda(this$0, $callback, $legId) {
		    return function (legResponse) {
		      var tmp;
		      if (legResponse instanceof GetLeg) {
		        var tmp_0 = new GetMyMemberRequest(legResponse.b1j_1);
		        this$0.x39_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, legResponse.a1j_1, VoiceAPIImpl$getCallDetailsAndDispatchCallReconnect$lambda$lambda(this$0, $legId, legResponse, $callback))));
		        tmp = Unit_instance;
		      } else {
		        invokeCallbackWithError_0(new NoLegFound(), $callback);
		        this$0.x39_1.a1g(Action_init_$Create$(new CallCleanup($legId)));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function VoiceAPIImpl(store, events, loggerAdapter) {
		    this.x39_1 = store;
		    this.y39_1 = loggerAdapter.v1e(Voice_getInstance());
		    this.z39_1 = null;
		    events.w1f(new VoiceAPIImpl$1(this));
		    var tmp = getKClass(SessionReducer);
		    this.x39_1.a2z(tmp, VoiceAPIImpl$lambda(this));
		    var tmp_0 = getKClass(InviteReducer);
		    this.x39_1.a2z(tmp_0, VoiceAPIImpl$lambda_0(this));
		    var tmp_1 = getKClass(CallReducer);
		    this.x39_1.a2z(tmp_1, VoiceAPIImpl$lambda_1(this));
		    var tmp_2 = getKClass(CallReducer);
		    this.x39_1.a2z(tmp_2, VoiceAPIImpl$lambda_2(this));
		    var tmp_3 = getKClass(MediaEventReducer);
		    this.x39_1.a2z(tmp_3, VoiceAPIImpl$lambda_3(this));
		  }
		  protoOf(VoiceAPIImpl).u1d = function (listener) {
		    this.z39_1 = listener;
		  };
		  protoOf(VoiceAPIImpl).x1d = function (legId, callback) {
		    if (getSessionUserOrError(this.x39_1, callback) == null)
		      return Unit_instance;
		    var tmp = new GetLegRequest(legId);
		    this.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, VoiceAPIImpl$getLeg$lambda(callback))));
		  };
		  protoOf(VoiceAPIImpl).y1d = function (callId, parameters, callback) {
		    if (getSessionUserOrError(this.x39_1, callback) == null)
		      return Unit_instance;
		    var callState = this.x39_1.t2y(getKClass(CallReducer));
		    var call = callState.a3a_1.c2(callId);
		    var tmp2_safe_receiver = call == null ? null : call.p39_1;
		    var tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w1();
		    var memberState = tmp instanceof Joined ? tmp : null;
		    if (call == null ? true : memberState == null) {
		      return invokeCallbackWithError(new NoCallFound(), callback);
		    }
		    var tmp_0 = new GetConversationRequest(memberState.u39_1);
		    this.x39_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, VOID, VoiceAPIImpl$getCallLegs$lambda(this, callback, memberState, parameters))));
		  };
		  protoOf(VoiceAPIImpl).v1d = function (context, callback) {
		    var tmp0_elvis_lhs = getSessionUserOrError(this.x39_1, callback);
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      return Unit_instance;
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var user = tmp;
		    var tmp_0 = new SetupOutboundCall(user.o2u_1, context);
		    this.x39_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, VOID, VoiceAPIImpl$serverCall$lambda(this, callback))));
		  };
		  protoOf(VoiceAPIImpl).w1d = function (callId, callback) {
		    var once = {_v: null};
		    var tmp = getKClass(CallReducer);
		    once._v = this.x39_1.a2z(tmp, VoiceAPIImpl$reconnectCall$lambda(this, callId, once, callback));
		    if (getSessionUserOrError_0(this.x39_1, callback) == null)
		      return Unit_instance;
		    var callState = this.x39_1.t2y(getKClass(CallReducer));
		    var call = callState.a3a_1.c2(callId);
		    var tmp2_safe_receiver = call == null ? null : call.p39_1;
		    var tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w1();
		    var memberState = tmp_0 instanceof Joined ? tmp_0 : null;
		    if (call == null ? true : memberState == null) {
		      getCallDetailsAndDispatchCallReconnect(this, callId, callback);
		    } else {
		      this.x39_1.a1g(Action_init_$Create$(new CallReconnect(callId, memberState.v39_1, memberState.u39_1)));
		    }
		  };
		  protoOf(VoiceAPIImpl).z1d = function (callId, callback) {
		    var invite = this.x39_1.t2y(getKClass(InviteReducer)).y3a_1.c2(callId);
		    if (invite == null) {
		      invokeCallbackWithError_0(new NoInviteFound(), callback);
		      return Unit_instance;
		    }
		    var tmp;
		    var tmp_0;
		    var tmp_1 = invite.k3a_1;
		    if (tmp_1 instanceof Pending) {
		      tmp_0 = true;
		    } else {
		      var tmp_2 = invite.k3a_1.w1();
		      tmp_0 = tmp_2 instanceof Joined;
		    }
		    if (tmp_0) {
		      tmp = true;
		    } else {
		      var tmp_3 = invite.k3a_1.w1();
		      tmp = tmp_3 instanceof Left;
		    }
		    if (tmp) {
		      invokeCallbackWithError_0(new InvalidCallAction(), callback);
		      return Unit_instance;
		    }
		    var tmp_4 = new MemberKickRequest(invite.i3a_1, invite.h3a_1, 'call-rejected-by-callee', 'REMOTE_REJECT');
		    this.x39_1.a1g(new Action_0(tmp_4, new ActionMeta(VOID, callId, VoiceAPIImpl$rejectCall$lambda(callback))));
		  };
		  protoOf(VoiceAPIImpl).a1e = function (callId, callback) {
		    var invite = this.x39_1.t2y(getKClass(InviteReducer)).y3a_1.c2(callId);
		    if (invite == null) {
		      invokeCallbackWithError_0(new NoInviteFound(), callback);
		      return Unit_instance;
		    }
		    var tmp;
		    var tmp_0;
		    var tmp_1 = invite.k3a_1;
		    if (tmp_1 instanceof Pending) {
		      tmp_0 = true;
		    } else {
		      var tmp_2 = invite.k3a_1.w1();
		      tmp_0 = tmp_2 instanceof Joined;
		    }
		    if (tmp_0) {
		      tmp = true;
		    } else {
		      var tmp_3 = invite.k3a_1.w1();
		      tmp = tmp_3 instanceof Left;
		    }
		    if (tmp) {
		      invokeCallbackWithError_0(new InvalidCallAction(), callback);
		      return Unit_instance;
		    }
		    var tmp_4 = new MemberJoinRequest(invite.i3a_1, invite.h3a_1);
		    this.x39_1.a1g(new Action_0(tmp_4, new ActionMeta(VOID, callId, VoiceAPIImpl$answerCall$lambda(callback, invite, this, callId))));
		  };
		  protoOf(VoiceAPIImpl).b1e = function (callId, reasonText, reasonCode, callback) {
		    var call = this.x39_1.t2y(getKClass(CallReducer)).a3a_1.c2(callId);
		    if (call == null) {
		      invokeCallbackWithError_0(new NoCallFound(), callback);
		      return Unit_instance;
		    }
		    this.x39_1.a1g(Action_init_$Create$(new MediaDisable(callId)));
		    var callMemberShipState = call.p39_1.w1();
		    if (callMemberShipState instanceof Joined) {
		      var tmp = new MemberKickRequest(callMemberShipState.u39_1, callMemberShipState.v39_1, reasonText, reasonCode);
		      this.x39_1.a1g(new Action_0(tmp, new ActionMeta(VOID, callId, VoiceAPIImpl$hangupCall$lambda(callback))));
		    } else {
		      if (callMemberShipState instanceof Knocking) {
		        var tmp_0 = new DeleteKnockerRequest(callMemberShipState.u3b_1);
		        this.x39_1.a1g(new Action_0(tmp_0, new ActionMeta(VOID, callId, VoiceAPIImpl$hangupCall$lambda_0(callback))));
		      } else {
		        invokeCallbackWithError_0(new InvalidCallAction(), callback);
		      }
		    }
		  };
		  protoOf(VoiceAPIImpl).c1e = function (callId, callback) {
		    var tmp0_safe_receiver = dispatchCallAction(this, callId, VoiceAPIImpl$mute$lambda(this, callId, callback));
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      invokeCallbackWithError_0(tmp0_safe_receiver, callback);
		    }
		  };
		  protoOf(VoiceAPIImpl).d1e = function (callId, callback) {
		    var tmp0_safe_receiver = dispatchCallAction(this, callId, VoiceAPIImpl$unmute$lambda(this, callId, callback));
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      invokeCallbackWithError_0(tmp0_safe_receiver, callback);
		    }
		  };
		  protoOf(VoiceAPIImpl).e1e = function (callId, callback) {
		    var tmp0_safe_receiver = dispatchCallAction(this, callId, VoiceAPIImpl$enableEarmuff$lambda(this, callId, callback));
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      invokeCallbackWithError_0(tmp0_safe_receiver, callback);
		    }
		  };
		  protoOf(VoiceAPIImpl).f1e = function (callId, callback) {
		    var tmp0_safe_receiver = dispatchCallAction(this, callId, VoiceAPIImpl$disableEarmuff$lambda(this, callId, callback));
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      invokeCallbackWithError_0(tmp0_safe_receiver, callback);
		    }
		  };
		  protoOf(VoiceAPIImpl).g1e = function (callId, digits, callback) {
		    var tmp0_safe_receiver = dispatchCallAction(this, callId, VoiceAPIImpl$sendDTMF$lambda(this, callId, digits, callback));
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      invokeCallbackWithError_0(tmp0_safe_receiver, callback);
		    }
		  };
		  protoOf(VoiceAPIImpl).h1e = function (callId, text, level, loop, queue, voiceName, ssml, callback) {
		    var tmp0_safe_receiver = dispatchCallAction(this, callId, VoiceAPIImpl$say$lambda(this, text, level, loop, queue, voiceName, ssml, callId, callback));
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      invokeCallbackWithError_0(tmp0_safe_receiver, callback);
		    }
		  };
		  function SetupOutboundCall(user, context) {
		    this.v3b_1 = user;
		    this.w3b_1 = context;
		  }
		  protoOf(SetupOutboundCall).toString = function () {
		    return 'SetupOutboundCall(user=' + this.v3b_1 + ', context=' + this.w3b_1 + ')';
		  };
		  protoOf(SetupOutboundCall).hashCode = function () {
		    var result = getStringHashCode(this.v3b_1);
		    result = imul(result, 31) + (this.w3b_1 == null ? 0 : hashCode(this.w3b_1)) | 0;
		    return result;
		  };
		  protoOf(SetupOutboundCall).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SetupOutboundCall))
		      return false;
		    var tmp0_other_with_cast = other instanceof SetupOutboundCall ? other : THROW_CCE();
		    if (!(this.v3b_1 === tmp0_other_with_cast.v3b_1))
		      return false;
		    if (!equals(this.w3b_1, tmp0_other_with_cast.w3b_1))
		      return false;
		    return true;
		  };
		  function CallKnockingRequestFailure(callId, exception) {
		    this.x3b_1 = callId;
		    this.y3b_1 = exception;
		  }
		  protoOf(CallKnockingRequestFailure).toString = function () {
		    return 'CallKnockingRequestFailure(callId=' + this.x3b_1 + ', exception=' + this.y3b_1 + ')';
		  };
		  protoOf(CallKnockingRequestFailure).hashCode = function () {
		    var result = getStringHashCode(this.x3b_1);
		    result = imul(result, 31) + hashCode(this.y3b_1) | 0;
		    return result;
		  };
		  protoOf(CallKnockingRequestFailure).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallKnockingRequestFailure))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallKnockingRequestFailure ? other : THROW_CCE();
		    if (!(this.x3b_1 === tmp0_other_with_cast.x3b_1))
		      return false;
		    if (!equals(this.y3b_1, tmp0_other_with_cast.y3b_1))
		      return false;
		    return true;
		  };
		  function CallCleanup(callId) {
		    this.z3b_1 = callId;
		  }
		  protoOf(CallCleanup).toString = function () {
		    return 'CallCleanup(callId=' + this.z3b_1 + ')';
		  };
		  protoOf(CallCleanup).hashCode = function () {
		    return getStringHashCode(this.z3b_1);
		  };
		  protoOf(CallCleanup).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallCleanup))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallCleanup ? other : THROW_CCE();
		    if (!(this.z3b_1 === tmp0_other_with_cast.z3b_1))
		      return false;
		    return true;
		  };
		  function CallReconnect(callId, from, conversationId) {
		    this.a3c_1 = callId;
		    this.b3c_1 = from;
		    this.c3c_1 = conversationId;
		  }
		  protoOf(CallReconnect).toString = function () {
		    return 'CallReconnect(callId=' + this.a3c_1 + ', from=' + this.b3c_1 + ', conversationId=' + this.c3c_1 + ')';
		  };
		  protoOf(CallReconnect).hashCode = function () {
		    var result = getStringHashCode(this.a3c_1);
		    result = imul(result, 31) + getStringHashCode(this.b3c_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.c3c_1) | 0;
		    return result;
		  };
		  protoOf(CallReconnect).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallReconnect))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallReconnect ? other : THROW_CCE();
		    if (!(this.a3c_1 === tmp0_other_with_cast.a3c_1))
		      return false;
		    if (!(this.b3c_1 === tmp0_other_with_cast.b3c_1))
		      return false;
		    if (!(this.c3c_1 === tmp0_other_with_cast.c3c_1))
		      return false;
		    return true;
		  };
		  function SetupInboundCall(rtcId, conversationId, memberId, from, sdp, context) {
		    this.d3c_1 = rtcId;
		    this.e3c_1 = conversationId;
		    this.f3c_1 = memberId;
		    this.g3c_1 = from;
		    this.h3c_1 = sdp;
		    this.i3c_1 = context;
		  }
		  protoOf(SetupInboundCall).toString = function () {
		    return 'SetupInboundCall(rtcId=' + this.d3c_1 + ', conversationId=' + this.e3c_1 + ', memberId=' + this.f3c_1 + ', from=' + this.g3c_1 + ', sdp=' + this.h3c_1 + ', context=' + this.i3c_1 + ')';
		  };
		  protoOf(SetupInboundCall).hashCode = function () {
		    var result = getStringHashCode(this.d3c_1);
		    result = imul(result, 31) + getStringHashCode(this.e3c_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.f3c_1) | 0;
		    result = imul(result, 31) + hashCode(this.g3c_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.h3c_1) | 0;
		    result = imul(result, 31) + (this.i3c_1 == null ? 0 : hashCode(this.i3c_1)) | 0;
		    return result;
		  };
		  protoOf(SetupInboundCall).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SetupInboundCall))
		      return false;
		    var tmp0_other_with_cast = other instanceof SetupInboundCall ? other : THROW_CCE();
		    if (!(this.d3c_1 === tmp0_other_with_cast.d3c_1))
		      return false;
		    if (!(this.e3c_1 === tmp0_other_with_cast.e3c_1))
		      return false;
		    if (!(this.f3c_1 === tmp0_other_with_cast.f3c_1))
		      return false;
		    if (!equals(this.g3c_1, tmp0_other_with_cast.g3c_1))
		      return false;
		    if (!(this.h3c_1 === tmp0_other_with_cast.h3c_1))
		      return false;
		    if (!equals(this.i3c_1, tmp0_other_with_cast.i3c_1))
		      return false;
		    return true;
		  };
		  function CallReconnectSuccess(callId) {
		    this.j3c_1 = callId;
		  }
		  protoOf(CallReconnectSuccess).toString = function () {
		    return 'CallReconnectSuccess(callId=' + this.j3c_1 + ')';
		  };
		  protoOf(CallReconnectSuccess).hashCode = function () {
		    return getStringHashCode(this.j3c_1);
		  };
		  protoOf(CallReconnectSuccess).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallReconnectSuccess))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallReconnectSuccess ? other : THROW_CCE();
		    if (!(this.j3c_1 === tmp0_other_with_cast.j3c_1))
		      return false;
		    return true;
		  };
		  function CallReconnectFailure(callId) {
		    this.k3c_1 = callId;
		  }
		  protoOf(CallReconnectFailure).toString = function () {
		    return 'CallReconnectFailure(callId=' + this.k3c_1 + ')';
		  };
		  protoOf(CallReconnectFailure).hashCode = function () {
		    return getStringHashCode(this.k3c_1);
		  };
		  protoOf(CallReconnectFailure).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallReconnectFailure))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallReconnectFailure ? other : THROW_CCE();
		    if (!(this.k3c_1 === tmp0_other_with_cast.k3c_1))
		      return false;
		    return true;
		  };
		  function InviteReconcile(callId) {
		    this.l3c_1 = callId;
		  }
		  protoOf(InviteReconcile).toString = function () {
		    return 'InviteReconcile(callId=' + this.l3c_1 + ')';
		  };
		  protoOf(InviteReconcile).hashCode = function () {
		    return getStringHashCode(this.l3c_1);
		  };
		  protoOf(InviteReconcile).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof InviteReconcile))
		      return false;
		    var tmp0_other_with_cast = other instanceof InviteReconcile ? other : THROW_CCE();
		    if (!(this.l3c_1 === tmp0_other_with_cast.l3c_1))
		      return false;
		    return true;
		  };
		  function CallEvent() {
		  }
		  function CallCreate(legId, from, direction, context, memberJoinInfo) {
		    memberJoinInfo = memberJoinInfo === VOID ? null : memberJoinInfo;
		    this.m3c_1 = legId;
		    this.n3c_1 = from;
		    this.o3c_1 = direction;
		    this.p3c_1 = context;
		    this.q3c_1 = memberJoinInfo;
		  }
		  protoOf(CallCreate).toString = function () {
		    return 'CallCreate(legId=' + this.m3c_1 + ', from=' + this.n3c_1 + ', direction=' + this.o3c_1 + ', context=' + this.p3c_1 + ', memberJoinInfo=' + this.q3c_1 + ')';
		  };
		  protoOf(CallCreate).hashCode = function () {
		    var result = getStringHashCode(this.m3c_1);
		    result = imul(result, 31) + hashCode(this.n3c_1) | 0;
		    result = imul(result, 31) + this.o3c_1.hashCode() | 0;
		    result = imul(result, 31) + (this.p3c_1 == null ? 0 : hashCode(this.p3c_1)) | 0;
		    result = imul(result, 31) + (this.q3c_1 == null ? 0 : this.q3c_1.hashCode()) | 0;
		    return result;
		  };
		  protoOf(CallCreate).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallCreate))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallCreate ? other : THROW_CCE();
		    if (!(this.m3c_1 === tmp0_other_with_cast.m3c_1))
		      return false;
		    if (!equals(this.n3c_1, tmp0_other_with_cast.n3c_1))
		      return false;
		    if (!this.o3c_1.equals(tmp0_other_with_cast.o3c_1))
		      return false;
		    if (!equals(this.p3c_1, tmp0_other_with_cast.p3c_1))
		      return false;
		    if (!equals(this.q3c_1, tmp0_other_with_cast.q3c_1))
		      return false;
		    return true;
		  };
		  function CallMemberMediaTimeout(callId) {
		    this.r3c_1 = callId;
		  }
		  protoOf(CallMemberMediaTimeout).toString = function () {
		    return 'CallMemberMediaTimeout(callId=' + this.r3c_1 + ')';
		  };
		  protoOf(CallMemberMediaTimeout).hashCode = function () {
		    return getStringHashCode(this.r3c_1);
		  };
		  protoOf(CallMemberMediaTimeout).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallMemberMediaTimeout))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallMemberMediaTimeout ? other : THROW_CCE();
		    if (!(this.r3c_1 === tmp0_other_with_cast.r3c_1))
		      return false;
		    return true;
		  };
		  function MemberJoinInfo(conversationId, memberId) {
		    this.s3c_1 = conversationId;
		    this.t3c_1 = memberId;
		  }
		  protoOf(MemberJoinInfo).toString = function () {
		    return 'MemberJoinInfo(conversationId=' + this.s3c_1 + ', memberId=' + this.t3c_1 + ')';
		  };
		  protoOf(MemberJoinInfo).hashCode = function () {
		    var result = getStringHashCode(this.s3c_1);
		    result = imul(result, 31) + getStringHashCode(this.t3c_1) | 0;
		    return result;
		  };
		  protoOf(MemberJoinInfo).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MemberJoinInfo))
		      return false;
		    var tmp0_other_with_cast = other instanceof MemberJoinInfo ? other : THROW_CCE();
		    if (!(this.s3c_1 === tmp0_other_with_cast.s3c_1))
		      return false;
		    if (!(this.t3c_1 === tmp0_other_with_cast.t3c_1))
		      return false;
		    return true;
		  };
		  function CallConversationUpdate(rtcId, name) {
		    this.u3c_1 = rtcId;
		    this.v3c_1 = name;
		  }
		  protoOf(CallConversationUpdate).toString = function () {
		    return 'CallConversationUpdate(rtcId=' + this.u3c_1 + ', name=' + this.v3c_1 + ')';
		  };
		  protoOf(CallConversationUpdate).hashCode = function () {
		    var result = getStringHashCode(this.u3c_1);
		    result = imul(result, 31) + getStringHashCode(this.v3c_1) | 0;
		    return result;
		  };
		  protoOf(CallConversationUpdate).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallConversationUpdate))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallConversationUpdate ? other : THROW_CCE();
		    if (!(this.u3c_1 === tmp0_other_with_cast.u3c_1))
		      return false;
		    if (!(this.v3c_1 === tmp0_other_with_cast.v3c_1))
		      return false;
		    return true;
		  };
		  function InviteCleanup(callId) {
		    this.w3c_1 = callId;
		  }
		  protoOf(InviteCleanup).toString = function () {
		    return 'InviteCleanup(callId=' + this.w3c_1 + ')';
		  };
		  protoOf(InviteCleanup).hashCode = function () {
		    return getStringHashCode(this.w3c_1);
		  };
		  protoOf(InviteCleanup).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof InviteCleanup))
		      return false;
		    var tmp0_other_with_cast = other instanceof InviteCleanup ? other : THROW_CCE();
		    if (!(this.w3c_1 === tmp0_other_with_cast.w3c_1))
		      return false;
		    return true;
		  };
		  function VoiceInviteCancelReason_AnsweredElsewhere_getInstance() {
		    VoiceInviteCancelReason_initEntries();
		    return VoiceInviteCancelReason_AnsweredElsewhere_instance;
		  }
		  function VoiceInviteCancelReason_RejectedElsewhere_getInstance() {
		    VoiceInviteCancelReason_initEntries();
		    return VoiceInviteCancelReason_RejectedElsewhere_instance;
		  }
		  function VoiceInviteCancelReason_RemoteCancel_getInstance() {
		    VoiceInviteCancelReason_initEntries();
		    return VoiceInviteCancelReason_RemoteCancel_instance;
		  }
		  function VoiceInviteCancelReason_RemoteTimeout_getInstance() {
		    VoiceInviteCancelReason_initEntries();
		    return VoiceInviteCancelReason_RemoteTimeout_instance;
		  }
		  function HangupReason_remoteReject_getInstance() {
		    HangupReason_initEntries();
		    return HangupReason_remoteReject_instance;
		  }
		  function HangupReason_remoteHangup_getInstance() {
		    HangupReason_initEntries();
		    return HangupReason_remoteHangup_instance;
		  }
		  function HangupReason_remoteNoAnswerTimeout_getInstance() {
		    HangupReason_initEntries();
		    return HangupReason_remoteNoAnswerTimeout_instance;
		  }
		  function HangupReason_localHangup_getInstance() {
		    HangupReason_initEntries();
		    return HangupReason_localHangup_instance;
		  }
		  function HangupReason_mediaTimeout_getInstance() {
		    HangupReason_initEntries();
		    return HangupReason_mediaTimeout_instance;
		  }
		  function LegStatus_ringing_getInstance() {
		    LegStatus_initEntries();
		    return LegStatus_ringing_instance;
		  }
		  function LegStatus_answered_getInstance() {
		    LegStatus_initEntries();
		    return LegStatus_answered_instance;
		  }
		  function LegStatus_completed_getInstance() {
		    LegStatus_initEntries();
		    return LegStatus_completed_instance;
		  }
		  function CallDisconnectReason_networkChange_getInstance() {
		    CallDisconnectReason_initEntries();
		    return CallDisconnectReason_networkChange_instance;
		  }
		  var VoiceChannelType_app_instance;
		  var VoiceChannelType_phone_instance;
		  var VoiceChannelType_sip_instance;
		  var VoiceChannelType_websocket_instance;
		  function values_3() {
		    return [VoiceChannelType_app_getInstance(), VoiceChannelType_phone_getInstance(), VoiceChannelType_sip_getInstance(), VoiceChannelType_websocket_getInstance()];
		  }
		  var VoiceChannelType_entriesInitialized;
		  function VoiceChannelType_initEntries() {
		    if (VoiceChannelType_entriesInitialized)
		      return Unit_instance;
		    VoiceChannelType_entriesInitialized = true;
		    VoiceChannelType_app_instance = new VoiceChannelType('app', 0);
		    VoiceChannelType_phone_instance = new VoiceChannelType('phone', 1);
		    VoiceChannelType_sip_instance = new VoiceChannelType('sip', 2);
		    VoiceChannelType_websocket_instance = new VoiceChannelType('websocket', 3);
		  }
		  function VoiceChannelType(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function _get_$cachedSerializer__te6jhj_1($this) {
		    return $this.x3c_1.w1();
		  }
		  function ChannelEndpoint$Companion$_anonymous__4a66ll() {
		    var tmp = getKClass(ChannelEndpoint);
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp_0 = [getKClass(AppChannelEndpoint), getKClass(AppChannelEndpointNoUser), getKClass(PhoneChannelEndpoint), getKClass(SipChannelEndpoint), getKClass(WebSocketChannelEndpoint)];
		    // Inline function 'kotlin.arrayOf' call
		    var tmp_1 = $serializer_getInstance_164();
		    var tmp_2 = AppChannelEndpointNoUser_getInstance();
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp$ret$5 = [];
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp_3 = [tmp_1, ObjectSerializer_init_$Create$('com.vonage.clientcore.core.conversation.AppChannelEndpointNoUser', tmp_2, tmp$ret$5), $serializer_getInstance_163(), $serializer_getInstance_165(), $serializer_getInstance_166()];
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp$ret$11 = [];
		    return SealedClassSerializer_init_$Create$('com.vonage.clientcore.core.conversation.ChannelEndpoint', tmp, tmp_0, tmp_3, tmp$ret$11);
		  }
		  function Companion_145() {
		    Companion_instance_146 = this;
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.x3c_1 = lazy(tmp_0, ChannelEndpoint$Companion$_anonymous__4a66ll);
		  }
		  protoOf(Companion_145).y12 = function () {
		    return _get_$cachedSerializer__te6jhj_1(this);
		  };
		  protoOf(Companion_145).nr = function (typeParamsSerializers) {
		    return this.y12();
		  };
		  var Companion_instance_146;
		  function Companion_getInstance_147() {
		    if (Companion_instance_146 == null)
		      new Companion_145();
		    return Companion_instance_146;
		  }
		  function ChannelEndpoint_init_$Init$(seen1, serializationConstructorMarker, $this) {
		    return $this;
		  }
		  function ChannelEndpoint() {
		    Companion_getInstance_147();
		  }
		  function Companion_146() {
		    Companion_instance_147 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.y3c_1 = [null, new EnumSerializer('com.vonage.clientcore.core.conversation.VoiceChannelType', values_3())];
		  }
		  protoOf(Companion_146).y12 = function () {
		    return $serializer_getInstance_163();
		  };
		  var Companion_instance_147;
		  function Companion_getInstance_148() {
		    if (Companion_instance_147 == null)
		      new Companion_146();
		    return Companion_instance_147;
		  }
		  function $serializer_163() {
		    $serializer_instance_163 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.PhoneChannelEndpoint', this, 2);
		    tmp0_serialDesc.pq('number', false);
		    tmp0_serialDesc.pq('type', true);
		    this.z3c_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_163).uf = function () {
		    return this.z3c_1;
		  };
		  protoOf($serializer_163).er = function () {
		    var tmp0_cached = Companion_getInstance_148().y3c_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), tmp0_cached[1]];
		  };
		  protoOf($serializer_163).wf = function (decoder) {
		    var tmp0_desc = this.z3c_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    var tmp7_cached = Companion_getInstance_148().y3c_1;
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return PhoneChannelEndpoint_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_163).a3d = function (encoder, value) {
		    var tmp0_desc = this.z3c_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_148().y3c_1;
		    tmp1_output.tk(tmp0_desc, 0, value.f1l_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.g1l_1.equals(VoiceChannelType_phone_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, tmp2_cached[1], value.g1l_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_163).vf = function (encoder, value) {
		    return this.a3d(encoder, value instanceof PhoneChannelEndpoint ? value : THROW_CCE());
		  };
		  var $serializer_instance_163;
		  function $serializer_getInstance_163() {
		    if ($serializer_instance_163 == null)
		      new $serializer_163();
		    return $serializer_instance_163;
		  }
		  function PhoneChannelEndpoint_init_$Init$(seen1, number, type, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_163().z3c_1);
		    }
		    ChannelEndpoint_init_$Init$(seen1, serializationConstructorMarker, $this);
		    $this.f1l_1 = number;
		    if (0 === (seen1 & 2))
		      $this.g1l_1 = VoiceChannelType_phone_getInstance();
		    else
		      $this.g1l_1 = type;
		    return $this;
		  }
		  function PhoneChannelEndpoint_init_$Create$(seen1, number, type, serializationConstructorMarker) {
		    return PhoneChannelEndpoint_init_$Init$(seen1, number, type, serializationConstructorMarker, objectCreate(protoOf(PhoneChannelEndpoint)));
		  }
		  function PhoneChannelEndpoint(number) {
		    Companion_getInstance_148();
		    ChannelEndpoint.call(this);
		    this.f1l_1 = number;
		    this.g1l_1 = VoiceChannelType_phone_getInstance();
		  }
		  protoOf(PhoneChannelEndpoint).c3b = function () {
		    return this.g1l_1;
		  };
		  protoOf(PhoneChannelEndpoint).toString = function () {
		    return 'PhoneChannelEndpoint(number=' + this.f1l_1 + ')';
		  };
		  protoOf(PhoneChannelEndpoint).hashCode = function () {
		    return getStringHashCode(this.f1l_1);
		  };
		  protoOf(PhoneChannelEndpoint).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof PhoneChannelEndpoint))
		      return false;
		    var tmp0_other_with_cast = other instanceof PhoneChannelEndpoint ? other : THROW_CCE();
		    if (!(this.f1l_1 === tmp0_other_with_cast.f1l_1))
		      return false;
		    return true;
		  };
		  function from(_this__u8e3s4) {
		    // Inline function 'kotlin.run' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.conversation.from.<anonymous>' call
		    var tmp;
		    if (_this__u8e3s4 instanceof PhoneChannelEndpoint) {
		      tmp = _this__u8e3s4.f1l_1;
		    } else {
		      if (_this__u8e3s4 instanceof AppChannelEndpoint) {
		        tmp = _this__u8e3s4.h1l_1;
		      } else {
		        if (_this__u8e3s4 instanceof AppChannelEndpointNoUser) {
		          tmp = '';
		        } else {
		          if (_this__u8e3s4 instanceof SipChannelEndpoint) {
		            var tmp1_elvis_lhs = _this__u8e3s4.a1l_1;
		            tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
		          } else {
		            if (_this__u8e3s4 instanceof WebSocketChannelEndpoint) {
		              tmp = _this__u8e3s4.d1l_1;
		            } else {
		              noWhenBranchMatchedException();
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  }
		  function Companion_147() {
		    Companion_instance_148 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.b3d_1 = [null, new EnumSerializer('com.vonage.clientcore.core.conversation.VoiceChannelType', values_3())];
		  }
		  protoOf(Companion_147).y12 = function () {
		    return $serializer_getInstance_164();
		  };
		  var Companion_instance_148;
		  function Companion_getInstance_149() {
		    if (Companion_instance_148 == null)
		      new Companion_147();
		    return Companion_instance_148;
		  }
		  function $serializer_164() {
		    $serializer_instance_164 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.AppChannelEndpoint', this, 2);
		    tmp0_serialDesc.pq('user', false);
		    tmp0_serialDesc.pq('type', true);
		    this.c3d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_164).uf = function () {
		    return this.c3d_1;
		  };
		  protoOf($serializer_164).er = function () {
		    var tmp0_cached = Companion_getInstance_149().b3d_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), tmp0_cached[1]];
		  };
		  protoOf($serializer_164).wf = function (decoder) {
		    var tmp0_desc = this.c3d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    var tmp7_cached = Companion_getInstance_149().b3d_1;
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return AppChannelEndpoint_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_164).d3d = function (encoder, value) {
		    var tmp0_desc = this.c3d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_149().b3d_1;
		    tmp1_output.tk(tmp0_desc, 0, value.h1l_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.i1l_1.equals(VoiceChannelType_app_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, tmp2_cached[1], value.i1l_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_164).vf = function (encoder, value) {
		    return this.d3d(encoder, value instanceof AppChannelEndpoint ? value : THROW_CCE());
		  };
		  var $serializer_instance_164;
		  function $serializer_getInstance_164() {
		    if ($serializer_instance_164 == null)
		      new $serializer_164();
		    return $serializer_instance_164;
		  }
		  function AppChannelEndpoint_init_$Init$(seen1, user, type, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_164().c3d_1);
		    }
		    ChannelEndpoint_init_$Init$(seen1, serializationConstructorMarker, $this);
		    $this.h1l_1 = user;
		    if (0 === (seen1 & 2))
		      $this.i1l_1 = VoiceChannelType_app_getInstance();
		    else
		      $this.i1l_1 = type;
		    return $this;
		  }
		  function AppChannelEndpoint_init_$Create$(seen1, user, type, serializationConstructorMarker) {
		    return AppChannelEndpoint_init_$Init$(seen1, user, type, serializationConstructorMarker, objectCreate(protoOf(AppChannelEndpoint)));
		  }
		  function AppChannelEndpoint(user) {
		    Companion_getInstance_149();
		    ChannelEndpoint.call(this);
		    this.h1l_1 = user;
		    this.i1l_1 = VoiceChannelType_app_getInstance();
		  }
		  protoOf(AppChannelEndpoint).c3b = function () {
		    return this.i1l_1;
		  };
		  protoOf(AppChannelEndpoint).toString = function () {
		    return 'AppChannelEndpoint(user=' + this.h1l_1 + ')';
		  };
		  protoOf(AppChannelEndpoint).hashCode = function () {
		    return getStringHashCode(this.h1l_1);
		  };
		  protoOf(AppChannelEndpoint).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof AppChannelEndpoint))
		      return false;
		    var tmp0_other_with_cast = other instanceof AppChannelEndpoint ? other : THROW_CCE();
		    if (!(this.h1l_1 === tmp0_other_with_cast.h1l_1))
		      return false;
		    return true;
		  };
		  function _get_$cachedSerializer__te6jhj_2($this) {
		    return $this.f3d_1.w1();
		  }
		  function AppChannelEndpointNoUser$_anonymous__rkc74c() {
		    var tmp = AppChannelEndpointNoUser_getInstance();
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    var tmp$ret$2 = [];
		    return ObjectSerializer_init_$Create$('com.vonage.clientcore.core.conversation.AppChannelEndpointNoUser', tmp, tmp$ret$2);
		  }
		  function AppChannelEndpointNoUser() {
		    AppChannelEndpointNoUser_instance = this;
		    ChannelEndpoint.call(this);
		    this.e3d_1 = VoiceChannelType_app_getInstance();
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.f3d_1 = lazy(tmp_0, AppChannelEndpointNoUser$_anonymous__rkc74c);
		  }
		  protoOf(AppChannelEndpointNoUser).c3b = function () {
		    return this.e3d_1;
		  };
		  protoOf(AppChannelEndpointNoUser).y12 = function () {
		    return _get_$cachedSerializer__te6jhj_2(this);
		  };
		  protoOf(AppChannelEndpointNoUser).nr = function (typeParamsSerializers) {
		    return this.y12();
		  };
		  var AppChannelEndpointNoUser_instance;
		  function AppChannelEndpointNoUser_getInstance() {
		    if (AppChannelEndpointNoUser_instance == null)
		      new AppChannelEndpointNoUser();
		    return AppChannelEndpointNoUser_instance;
		  }
		  function Companion_148() {
		    Companion_instance_149 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.g3d_1 = [null, null, null, new EnumSerializer('com.vonage.clientcore.core.conversation.VoiceChannelType', values_3())];
		  }
		  protoOf(Companion_148).y12 = function () {
		    return $serializer_getInstance_165();
		  };
		  var Companion_instance_149;
		  function Companion_getInstance_150() {
		    if (Companion_instance_149 == null)
		      new Companion_148();
		    return Companion_instance_149;
		  }
		  function $serializer_165() {
		    $serializer_instance_165 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.SipChannelEndpoint', this, 4);
		    tmp0_serialDesc.pq('uri', false);
		    tmp0_serialDesc.pq('username', true);
		    tmp0_serialDesc.pq('password', true);
		    tmp0_serialDesc.pq('type', true);
		    this.h3d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_165).uf = function () {
		    return this.h3d_1;
		  };
		  protoOf($serializer_165).er = function () {
		    var tmp0_cached = Companion_getInstance_150().g3d_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[3]];
		  };
		  protoOf($serializer_165).wf = function (decoder) {
		    var tmp0_desc = this.h3d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_input = decoder.ej(tmp0_desc);
		    var tmp9_cached = Companion_getInstance_150().g3d_1;
		    if (tmp8_input.uj()) {
		      tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp8_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp8_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp8_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp8_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp8_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp8_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp8_input.qj(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp8_input.fj(tmp0_desc);
		    return SipChannelEndpoint_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
		  };
		  protoOf($serializer_165).i3d = function (encoder, value) {
		    var tmp0_desc = this.h3d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_150().g3d_1;
		    tmp1_output.tk(tmp0_desc, 0, value.z1k_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.a1l_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.a1l_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.b1l_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.b1l_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !value.c1l_1.equals(VoiceChannelType_sip_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 3, tmp2_cached[3], value.c1l_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_165).vf = function (encoder, value) {
		    return this.i3d(encoder, value instanceof SipChannelEndpoint ? value : THROW_CCE());
		  };
		  var $serializer_instance_165;
		  function $serializer_getInstance_165() {
		    if ($serializer_instance_165 == null)
		      new $serializer_165();
		    return $serializer_instance_165;
		  }
		  function SipChannelEndpoint_init_$Init$(seen1, uri, username, password, type, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_165().h3d_1);
		    }
		    ChannelEndpoint_init_$Init$(seen1, serializationConstructorMarker, $this);
		    $this.z1k_1 = uri;
		    if (0 === (seen1 & 2))
		      $this.a1l_1 = null;
		    else
		      $this.a1l_1 = username;
		    if (0 === (seen1 & 4))
		      $this.b1l_1 = null;
		    else
		      $this.b1l_1 = password;
		    if (0 === (seen1 & 8))
		      $this.c1l_1 = VoiceChannelType_sip_getInstance();
		    else
		      $this.c1l_1 = type;
		    return $this;
		  }
		  function SipChannelEndpoint_init_$Create$(seen1, uri, username, password, type, serializationConstructorMarker) {
		    return SipChannelEndpoint_init_$Init$(seen1, uri, username, password, type, serializationConstructorMarker, objectCreate(protoOf(SipChannelEndpoint)));
		  }
		  function SipChannelEndpoint(uri, username, password) {
		    Companion_getInstance_150();
		    username = username === VOID ? null : username;
		    password = password === VOID ? null : password;
		    ChannelEndpoint.call(this);
		    this.z1k_1 = uri;
		    this.a1l_1 = username;
		    this.b1l_1 = password;
		    this.c1l_1 = VoiceChannelType_sip_getInstance();
		  }
		  protoOf(SipChannelEndpoint).c3b = function () {
		    return this.c1l_1;
		  };
		  protoOf(SipChannelEndpoint).toString = function () {
		    return 'SipChannelEndpoint(uri=' + this.z1k_1 + ', username=' + this.a1l_1 + ', password=' + this.b1l_1 + ')';
		  };
		  protoOf(SipChannelEndpoint).hashCode = function () {
		    var result = getStringHashCode(this.z1k_1);
		    result = imul(result, 31) + (this.a1l_1 == null ? 0 : getStringHashCode(this.a1l_1)) | 0;
		    result = imul(result, 31) + (this.b1l_1 == null ? 0 : getStringHashCode(this.b1l_1)) | 0;
		    return result;
		  };
		  protoOf(SipChannelEndpoint).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SipChannelEndpoint))
		      return false;
		    var tmp0_other_with_cast = other instanceof SipChannelEndpoint ? other : THROW_CCE();
		    if (!(this.z1k_1 === tmp0_other_with_cast.z1k_1))
		      return false;
		    if (!(this.a1l_1 == tmp0_other_with_cast.a1l_1))
		      return false;
		    if (!(this.b1l_1 == tmp0_other_with_cast.b1l_1))
		      return false;
		    return true;
		  };
		  function Companion_149() {
		    Companion_instance_150 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.j3d_1 = [null, new EnumSerializer('com.vonage.clientcore.core.conversation.VoiceChannelType', values_3())];
		  }
		  protoOf(Companion_149).y12 = function () {
		    return $serializer_getInstance_166();
		  };
		  var Companion_instance_150;
		  function Companion_getInstance_151() {
		    if (Companion_instance_150 == null)
		      new Companion_149();
		    return Companion_instance_150;
		  }
		  function $serializer_166() {
		    $serializer_instance_166 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.WebSocketChannelEndpoint', this, 2);
		    tmp0_serialDesc.pq('uri', false);
		    tmp0_serialDesc.pq('type', true);
		    this.k3d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_166).uf = function () {
		    return this.k3d_1;
		  };
		  protoOf($serializer_166).er = function () {
		    var tmp0_cached = Companion_getInstance_151().j3d_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), tmp0_cached[1]];
		  };
		  protoOf($serializer_166).wf = function (decoder) {
		    var tmp0_desc = this.k3d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    var tmp7_cached = Companion_getInstance_151().j3d_1;
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.qj(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return WebSocketChannelEndpoint_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_166).l3d = function (encoder, value) {
		    var tmp0_desc = this.k3d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_151().j3d_1;
		    tmp1_output.tk(tmp0_desc, 0, value.d1l_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !value.e1l_1.equals(VoiceChannelType_websocket_getInstance())) {
		      tmp1_output.vk(tmp0_desc, 1, tmp2_cached[1], value.e1l_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_166).vf = function (encoder, value) {
		    return this.l3d(encoder, value instanceof WebSocketChannelEndpoint ? value : THROW_CCE());
		  };
		  var $serializer_instance_166;
		  function $serializer_getInstance_166() {
		    if ($serializer_instance_166 == null)
		      new $serializer_166();
		    return $serializer_instance_166;
		  }
		  function WebSocketChannelEndpoint_init_$Init$(seen1, uri, type, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_166().k3d_1);
		    }
		    ChannelEndpoint_init_$Init$(seen1, serializationConstructorMarker, $this);
		    $this.d1l_1 = uri;
		    if (0 === (seen1 & 2))
		      $this.e1l_1 = VoiceChannelType_websocket_getInstance();
		    else
		      $this.e1l_1 = type;
		    return $this;
		  }
		  function WebSocketChannelEndpoint_init_$Create$(seen1, uri, type, serializationConstructorMarker) {
		    return WebSocketChannelEndpoint_init_$Init$(seen1, uri, type, serializationConstructorMarker, objectCreate(protoOf(WebSocketChannelEndpoint)));
		  }
		  function WebSocketChannelEndpoint(uri) {
		    Companion_getInstance_151();
		    ChannelEndpoint.call(this);
		    this.d1l_1 = uri;
		    this.e1l_1 = VoiceChannelType_websocket_getInstance();
		  }
		  protoOf(WebSocketChannelEndpoint).c3b = function () {
		    return this.e1l_1;
		  };
		  protoOf(WebSocketChannelEndpoint).toString = function () {
		    return 'WebSocketChannelEndpoint(uri=' + this.d1l_1 + ')';
		  };
		  protoOf(WebSocketChannelEndpoint).hashCode = function () {
		    return getStringHashCode(this.d1l_1);
		  };
		  protoOf(WebSocketChannelEndpoint).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof WebSocketChannelEndpoint))
		      return false;
		    var tmp0_other_with_cast = other instanceof WebSocketChannelEndpoint ? other : THROW_CCE();
		    if (!(this.d1l_1 === tmp0_other_with_cast.d1l_1))
		      return false;
		    return true;
		  };
		  function Companion_150() {
		  }
		  var Companion_instance_151;
		  function Companion_getInstance_152() {
		    return Companion_instance_151;
		  }
		  function $serializer_167() {
		    $serializer_instance_167 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.DTMFChannel', this, 2);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('type', true);
		    this.m3d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_167).uf = function () {
		    return this.m3d_1;
		  };
		  protoOf($serializer_167).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
		  };
		  protoOf($serializer_167).wf = function (decoder) {
		    var tmp0_desc = this.m3d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return DTMFChannel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_167).n3d = function (encoder, value) {
		    var tmp0_desc = this.m3d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.q2y_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.q2y_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.r2y_1 === 'app')) {
		      tmp1_output.tk(tmp0_desc, 1, value.r2y_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_167).vf = function (encoder, value) {
		    return this.n3d(encoder, value instanceof DTMFChannel ? value : THROW_CCE());
		  };
		  var $serializer_instance_167;
		  function $serializer_getInstance_167() {
		    if ($serializer_instance_167 == null)
		      new $serializer_167();
		    return $serializer_instance_167;
		  }
		  function DTMFChannel_init_$Init$(seen1, id, type, serializationConstructorMarker, $this) {
		    if (!(0 === (0 & seen1))) {
		      throwMissingFieldException(seen1, 0, $serializer_getInstance_167().m3d_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.q2y_1 = null;
		    else
		      $this.q2y_1 = id;
		    if (0 === (seen1 & 2))
		      $this.r2y_1 = 'app';
		    else
		      $this.r2y_1 = type;
		    return $this;
		  }
		  function DTMFChannel_init_$Create$(seen1, id, type, serializationConstructorMarker) {
		    return DTMFChannel_init_$Init$(seen1, id, type, serializationConstructorMarker, objectCreate(protoOf(DTMFChannel)));
		  }
		  function DTMFChannel(id, type) {
		    id = id === VOID ? null : id;
		    type = type === VOID ? 'app' : type;
		    this.q2y_1 = id;
		    this.r2y_1 = type;
		  }
		  protoOf(DTMFChannel).toString = function () {
		    return 'DTMFChannel(id=' + this.q2y_1 + ', type=' + this.r2y_1 + ')';
		  };
		  protoOf(DTMFChannel).hashCode = function () {
		    var result = this.q2y_1 == null ? 0 : getStringHashCode(this.q2y_1);
		    result = imul(result, 31) + getStringHashCode(this.r2y_1) | 0;
		    return result;
		  };
		  protoOf(DTMFChannel).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof DTMFChannel))
		      return false;
		    var tmp0_other_with_cast = other instanceof DTMFChannel ? other : THROW_CCE();
		    if (!(this.q2y_1 == tmp0_other_with_cast.q2y_1))
		      return false;
		    if (!(this.r2y_1 === tmp0_other_with_cast.r2y_1))
		      return false;
		    return true;
		  };
		  function Companion_151() {
		    Companion_instance_152 = this;
		    var tmp = this;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    tmp.o3d_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null];
		  }
		  var Companion_instance_152;
		  function Companion_getInstance_153() {
		    if (Companion_instance_152 == null)
		      new Companion_151();
		    return Companion_instance_152;
		  }
		  function $serializer_168() {
		    $serializer_instance_168 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.Channel', this, 6);
		    tmp0_serialDesc.pq('id', true);
		    tmp0_serialDesc.pq('knocking_id', true);
		    tmp0_serialDesc.pq('type', false);
		    tmp0_serialDesc.pq('leg_ids', true);
		    tmp0_serialDesc.pq('from', true);
		    tmp0_serialDesc.pq('to', true);
		    this.p3d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_168).uf = function () {
		    return this.p3d_1;
		  };
		  protoOf($serializer_168).er = function () {
		    var tmp0_cached = Companion_getInstance_153().o3d_1;
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(tmp0_cached[3]), get_nullable(ChannelEndpointSerializer_getInstance()), get_nullable(ChannelEndpointSerializer_getInstance())];
		  };
		  protoOf($serializer_168).wf = function (decoder) {
		    var tmp0_desc = this.p3d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_local3 = null;
		    var tmp8_local4 = null;
		    var tmp9_local5 = null;
		    var tmp10_input = decoder.ej(tmp0_desc);
		    var tmp11_cached = Companion_getInstance_153().o3d_1;
		    if (tmp10_input.uj()) {
		      tmp4_local0 = tmp10_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp10_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp10_input.oj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp10_input.sj(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp10_input.sj(tmp0_desc, 4, ChannelEndpointSerializer_getInstance(), tmp8_local4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp10_input.sj(tmp0_desc, 5, ChannelEndpointSerializer_getInstance(), tmp9_local5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp10_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp10_input.sj(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp10_input.sj(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp10_input.oj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp10_input.sj(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp10_input.sj(tmp0_desc, 4, ChannelEndpointSerializer_getInstance(), tmp8_local4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp10_input.sj(tmp0_desc, 5, ChannelEndpointSerializer_getInstance(), tmp9_local5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp10_input.fj(tmp0_desc);
		    return Channel_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
		  };
		  protoOf($serializer_168).q3d = function (encoder, value) {
		    var tmp0_desc = this.p3d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    var tmp2_cached = Companion_getInstance_153().o3d_1;
		    if (tmp1_output.bl(tmp0_desc, 0) ? true : !(value.k26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 0, StringSerializer_getInstance(), value.k26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.l26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 1, StringSerializer_getInstance(), value.l26_1);
		    }
		    tmp1_output.tk(tmp0_desc, 2, value.m26_1);
		    if (tmp1_output.bl(tmp0_desc, 3) ? true : !(value.n26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 3, tmp2_cached[3], value.n26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 4) ? true : !(value.o26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 4, ChannelEndpointSerializer_getInstance(), value.o26_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 5) ? true : !(value.p26_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 5, ChannelEndpointSerializer_getInstance(), value.p26_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_168).vf = function (encoder, value) {
		    return this.q3d(encoder, value instanceof Channel_0 ? value : THROW_CCE());
		  };
		  var $serializer_instance_168;
		  function $serializer_getInstance_168() {
		    if ($serializer_instance_168 == null)
		      new $serializer_168();
		    return $serializer_instance_168;
		  }
		  function Channel_init_$Init$_0(seen1, id, knocking_id, type, leg_ids, from, to, serializationConstructorMarker, $this) {
		    if (!(4 === (4 & seen1))) {
		      throwMissingFieldException(seen1, 4, $serializer_getInstance_168().p3d_1);
		    }
		    if (0 === (seen1 & 1))
		      $this.k26_1 = null;
		    else
		      $this.k26_1 = id;
		    if (0 === (seen1 & 2))
		      $this.l26_1 = null;
		    else
		      $this.l26_1 = knocking_id;
		    $this.m26_1 = type;
		    if (0 === (seen1 & 8))
		      $this.n26_1 = null;
		    else
		      $this.n26_1 = leg_ids;
		    if (0 === (seen1 & 16))
		      $this.o26_1 = null;
		    else
		      $this.o26_1 = from;
		    if (0 === (seen1 & 32))
		      $this.p26_1 = null;
		    else
		      $this.p26_1 = to;
		    return $this;
		  }
		  function Channel_init_$Create$_0(seen1, id, knocking_id, type, leg_ids, from, to, serializationConstructorMarker) {
		    return Channel_init_$Init$_0(seen1, id, knocking_id, type, leg_ids, from, to, serializationConstructorMarker, objectCreate(protoOf(Channel_0)));
		  }
		  function Channel_0() {
		  }
		  protoOf(Channel_0).q26 = function () {
		    return new Channel(this.k26_1, this.k26_1);
		  };
		  protoOf(Channel_0).toString = function () {
		    return 'Channel(id=' + this.k26_1 + ', knocking_id=' + this.l26_1 + ', type=' + this.m26_1 + ', leg_ids=' + this.n26_1 + ', from=' + this.o26_1 + ', to=' + this.p26_1 + ')';
		  };
		  protoOf(Channel_0).hashCode = function () {
		    var result = this.k26_1 == null ? 0 : getStringHashCode(this.k26_1);
		    result = imul(result, 31) + (this.l26_1 == null ? 0 : getStringHashCode(this.l26_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.m26_1) | 0;
		    result = imul(result, 31) + (this.n26_1 == null ? 0 : hashCode(this.n26_1)) | 0;
		    result = imul(result, 31) + (this.o26_1 == null ? 0 : hashCode(this.o26_1)) | 0;
		    result = imul(result, 31) + (this.p26_1 == null ? 0 : hashCode(this.p26_1)) | 0;
		    return result;
		  };
		  protoOf(Channel_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Channel_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof Channel_0 ? other : THROW_CCE();
		    if (!(this.k26_1 == tmp0_other_with_cast.k26_1))
		      return false;
		    if (!(this.l26_1 == tmp0_other_with_cast.l26_1))
		      return false;
		    if (!(this.m26_1 === tmp0_other_with_cast.m26_1))
		      return false;
		    if (!equals(this.n26_1, tmp0_other_with_cast.n26_1))
		      return false;
		    if (!equals(this.o26_1, tmp0_other_with_cast.o26_1))
		      return false;
		    if (!equals(this.p26_1, tmp0_other_with_cast.p26_1))
		      return false;
		    return true;
		  };
		  function ChannelEndpointSerializer() {
		    ChannelEndpointSerializer_instance = this;
		    JsonContentPolymorphicSerializer.call(this, getKClass(ChannelEndpoint));
		  }
		  protoOf(ChannelEndpointSerializer).w12 = function (element) {
		    var tmp0_safe_receiver = get_jsonObject(element).b13('type');
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
		    var tmp;
		    switch (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e13()) {
		      case 'app':
		        var tmp_0;
		        if (!(get_jsonObject(element).b13('user') == null)) {
		          tmp_0 = Companion_getInstance_149().y12();
		        } else {
		          Companion_getInstance_149().y12();
		          tmp_0 = AppChannelEndpointNoUser_getInstance().y12();
		        }

		        tmp = tmp_0;
		        break;
		      case 'phone':
		        tmp = Companion_getInstance_148().y12();
		        break;
		      case 'sip':
		        tmp = Companion_getInstance_150().y12();
		        break;
		      case 'websocket':
		        tmp = Companion_getInstance_151().y12();
		        break;
		      default:
		        tmp = Companion_getInstance_147().y12();
		        break;
		    }
		    return tmp;
		  };
		  var ChannelEndpointSerializer_instance;
		  function ChannelEndpointSerializer_getInstance() {
		    if (ChannelEndpointSerializer_instance == null)
		      new ChannelEndpointSerializer();
		    return ChannelEndpointSerializer_instance;
		  }
		  function VoiceChannelType_app_getInstance() {
		    VoiceChannelType_initEntries();
		    return VoiceChannelType_app_instance;
		  }
		  function VoiceChannelType_phone_getInstance() {
		    VoiceChannelType_initEntries();
		    return VoiceChannelType_phone_instance;
		  }
		  function VoiceChannelType_sip_getInstance() {
		    VoiceChannelType_initEntries();
		    return VoiceChannelType_sip_instance;
		  }
		  function VoiceChannelType_websocket_getInstance() {
		    VoiceChannelType_initEntries();
		    return VoiceChannelType_websocket_instance;
		  }
		  function $serializer_169() {
		    $serializer_instance_169 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.ConversationInfo', this, 3);
		    tmp0_serialDesc.pq('conversation_id', false);
		    tmp0_serialDesc.pq('name', false);
		    tmp0_serialDesc.pq('display_name', true);
		    this.t3d_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_169).uf = function () {
		    return this.t3d_1;
		  };
		  protoOf($serializer_169).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
		  };
		  protoOf($serializer_169).wf = function (decoder) {
		    var tmp0_desc = this.t3d_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.oj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.oj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return ConversationInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_169).u3d = function (encoder, value) {
		    var tmp0_desc = this.t3d_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.v3d_1);
		    tmp1_output.tk(tmp0_desc, 1, value.w3d_1);
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.x3d_1 == null)) {
		      tmp1_output.xk(tmp0_desc, 2, StringSerializer_getInstance(), value.x3d_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_169).vf = function (encoder, value) {
		    return this.u3d(encoder, value instanceof ConversationInfo ? value : THROW_CCE());
		  };
		  var $serializer_instance_169;
		  function $serializer_getInstance_169() {
		    if ($serializer_instance_169 == null)
		      new $serializer_169();
		    return $serializer_instance_169;
		  }
		  function ConversationInfo_init_$Init$(seen1, conversation_id, name, display_name, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_169().t3d_1);
		    }
		    $this.v3d_1 = conversation_id;
		    $this.w3d_1 = name;
		    if (0 === (seen1 & 4))
		      $this.x3d_1 = null;
		    else
		      $this.x3d_1 = display_name;
		    return $this;
		  }
		  function ConversationInfo_init_$Create$(seen1, conversation_id, name, display_name, serializationConstructorMarker) {
		    return ConversationInfo_init_$Init$(seen1, conversation_id, name, display_name, serializationConstructorMarker, objectCreate(protoOf(ConversationInfo)));
		  }
		  function ConversationInfo() {
		  }
		  protoOf(ConversationInfo).toString = function () {
		    return 'ConversationInfo(conversation_id=' + this.v3d_1 + ', name=' + this.w3d_1 + ', display_name=' + this.x3d_1 + ')';
		  };
		  protoOf(ConversationInfo).hashCode = function () {
		    var result = getStringHashCode(this.v3d_1);
		    result = imul(result, 31) + getStringHashCode(this.w3d_1) | 0;
		    result = imul(result, 31) + (this.x3d_1 == null ? 0 : getStringHashCode(this.x3d_1)) | 0;
		    return result;
		  };
		  protoOf(ConversationInfo).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationInfo))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationInfo ? other : THROW_CCE();
		    if (!(this.v3d_1 === tmp0_other_with_cast.v3d_1))
		      return false;
		    if (!(this.w3d_1 === tmp0_other_with_cast.w3d_1))
		      return false;
		    if (!(this.x3d_1 == tmp0_other_with_cast.x3d_1))
		      return false;
		    return true;
		  };
		  function None_0() {
		    None_instance_0 = this;
		    LegState.call(this);
		    this.y3d_1 = null;
		  }
		  var None_instance_0;
		  function None_getInstance_0() {
		    if (None_instance_0 == null)
		      new None_0();
		    return None_instance_0;
		  }
		  function Prewarm(id) {
		    LegState.call(this);
		    this.z3d_1 = id;
		  }
		  protoOf(Prewarm).toString = function () {
		    return 'Prewarm(id=' + this.z3d_1 + ')';
		  };
		  protoOf(Prewarm).hashCode = function () {
		    return getStringHashCode(this.z3d_1);
		  };
		  protoOf(Prewarm).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Prewarm))
		      return false;
		    var tmp0_other_with_cast = other instanceof Prewarm ? other : THROW_CCE();
		    if (!(this.z3d_1 === tmp0_other_with_cast.z3d_1))
		      return false;
		    return true;
		  };
		  function Started(id) {
		    LegState.call(this);
		    this.a3e_1 = id;
		  }
		  protoOf(Started).toString = function () {
		    return 'Started(id=' + this.a3e_1 + ')';
		  };
		  protoOf(Started).hashCode = function () {
		    return getStringHashCode(this.a3e_1);
		  };
		  protoOf(Started).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Started))
		      return false;
		    var tmp0_other_with_cast = other instanceof Started ? other : THROW_CCE();
		    if (!(this.a3e_1 === tmp0_other_with_cast.a3e_1))
		      return false;
		    return true;
		  };
		  function Completed(id, hangupReason) {
		    LegState.call(this);
		    this.b3e_1 = id;
		    this.c3e_1 = hangupReason;
		  }
		  protoOf(Completed).toString = function () {
		    return 'Completed(id=' + this.b3e_1 + ', hangupReason=' + this.c3e_1 + ')';
		  };
		  protoOf(Completed).hashCode = function () {
		    var result = getStringHashCode(this.b3e_1);
		    result = imul(result, 31) + this.c3e_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(Completed).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Completed))
		      return false;
		    var tmp0_other_with_cast = other instanceof Completed ? other : THROW_CCE();
		    if (!(this.b3e_1 === tmp0_other_with_cast.b3e_1))
		      return false;
		    if (!this.c3e_1.equals(tmp0_other_with_cast.c3e_1))
		      return false;
		    return true;
		  };
		  function LegState() {
		  }
		  function Offer(sdp) {
		    MediaDescription.call(this);
		    this.d3e_1 = sdp;
		  }
		  function Answer(sdp) {
		    MediaDescription.call(this);
		    this.e3e_1 = sdp;
		  }
		  function MediaDescription() {
		  }
		  function MediaTransport(localDescription, remoteDescription, connected) {
		    localDescription = localDescription === VOID ? null : localDescription;
		    remoteDescription = remoteDescription === VOID ? null : remoteDescription;
		    connected = connected === VOID ? false : connected;
		    this.p3b_1 = localDescription;
		    this.q3b_1 = remoteDescription;
		    this.r3b_1 = connected;
		  }
		  protoOf(MediaTransport).f3e = function (localDescription, remoteDescription, connected) {
		    return new MediaTransport(localDescription, remoteDescription, connected);
		  };
		  protoOf(MediaTransport).g3e = function (localDescription, remoteDescription, connected, $super) {
		    localDescription = localDescription === VOID ? this.p3b_1 : localDescription;
		    remoteDescription = remoteDescription === VOID ? this.q3b_1 : remoteDescription;
		    connected = connected === VOID ? this.r3b_1 : connected;
		    return $super === VOID ? this.f3e(localDescription, remoteDescription, connected) : $super.f3e.call(this, localDescription, remoteDescription, connected);
		  };
		  protoOf(MediaTransport).toString = function () {
		    return 'MediaTransport(localDescription=' + this.p3b_1 + ', remoteDescription=' + this.q3b_1 + ', connected=' + this.r3b_1 + ')';
		  };
		  protoOf(MediaTransport).hashCode = function () {
		    var result = this.p3b_1 == null ? 0 : hashCode(this.p3b_1);
		    result = imul(result, 31) + (this.q3b_1 == null ? 0 : hashCode(this.q3b_1)) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.r3b_1) | 0;
		    return result;
		  };
		  protoOf(MediaTransport).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MediaTransport))
		      return false;
		    var tmp0_other_with_cast = other instanceof MediaTransport ? other : THROW_CCE();
		    if (!equals(this.p3b_1, tmp0_other_with_cast.p3b_1))
		      return false;
		    if (!equals(this.q3b_1, tmp0_other_with_cast.q3b_1))
		      return false;
		    if (!(this.r3b_1 === tmp0_other_with_cast.r3b_1))
		      return false;
		    return true;
		  };
		  function $serializer_170() {
		    $serializer_instance_170 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.UserAudio', this, 3);
		    tmp0_serialDesc.pq('enabled', false);
		    tmp0_serialDesc.pq('earmuffed', true);
		    tmp0_serialDesc.pq('muted', true);
		    this.h3e_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_170).uf = function () {
		    return this.h3e_1;
		  };
		  protoOf($serializer_170).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [BooleanSerializer_getInstance(), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
		  };
		  protoOf($serializer_170).wf = function (decoder) {
		    var tmp0_desc = this.h3e_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = false;
		    var tmp5_local1 = null;
		    var tmp6_local2 = null;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.gj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.gj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.sj(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.sj(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return UserAudio_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_170).i3e = function (encoder, value) {
		    var tmp0_desc = this.h3e_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.lk(tmp0_desc, 0, value.j3e_1);
		    if (tmp1_output.bl(tmp0_desc, 1) ? true : !(value.k3e_1 === false)) {
		      tmp1_output.xk(tmp0_desc, 1, BooleanSerializer_getInstance(), value.k3e_1);
		    }
		    if (tmp1_output.bl(tmp0_desc, 2) ? true : !(value.l3e_1 === false)) {
		      tmp1_output.xk(tmp0_desc, 2, BooleanSerializer_getInstance(), value.l3e_1);
		    }
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_170).vf = function (encoder, value) {
		    return this.i3e(encoder, value instanceof UserAudio ? value : THROW_CCE());
		  };
		  var $serializer_instance_170;
		  function $serializer_getInstance_170() {
		    if ($serializer_instance_170 == null)
		      new $serializer_170();
		    return $serializer_instance_170;
		  }
		  function UserAudio_init_$Init$(seen1, enabled, earmuffed, muted, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_170().h3e_1);
		    }
		    $this.j3e_1 = enabled;
		    if (0 === (seen1 & 2))
		      $this.k3e_1 = false;
		    else
		      $this.k3e_1 = earmuffed;
		    if (0 === (seen1 & 4))
		      $this.l3e_1 = false;
		    else
		      $this.l3e_1 = muted;
		    return $this;
		  }
		  function UserAudio_init_$Create$(seen1, enabled, earmuffed, muted, serializationConstructorMarker) {
		    return UserAudio_init_$Init$(seen1, enabled, earmuffed, muted, serializationConstructorMarker, objectCreate(protoOf(UserAudio)));
		  }
		  function UserAudio() {
		  }
		  protoOf(UserAudio).toString = function () {
		    return 'UserAudio(enabled=' + this.j3e_1 + ', earmuffed=' + this.k3e_1 + ', muted=' + this.l3e_1 + ')';
		  };
		  protoOf(UserAudio).hashCode = function () {
		    var result = getBooleanHashCode(this.j3e_1);
		    result = imul(result, 31) + (this.k3e_1 == null ? 0 : getBooleanHashCode(this.k3e_1)) | 0;
		    result = imul(result, 31) + (this.l3e_1 == null ? 0 : getBooleanHashCode(this.l3e_1)) | 0;
		    return result;
		  };
		  protoOf(UserAudio).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UserAudio))
		      return false;
		    var tmp0_other_with_cast = other instanceof UserAudio ? other : THROW_CCE();
		    if (!(this.j3e_1 === tmp0_other_with_cast.j3e_1))
		      return false;
		    if (!(this.k3e_1 == tmp0_other_with_cast.k3e_1))
		      return false;
		    if (!(this.l3e_1 == tmp0_other_with_cast.l3e_1))
		      return false;
		    return true;
		  };
		  function $serializer_171() {
		    $serializer_instance_171 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.InvitedUserMedia', this, 1);
		    tmp0_serialDesc.pq('audio_settings', false);
		    this.m3e_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_171).uf = function () {
		    return this.m3e_1;
		  };
		  protoOf($serializer_171).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [get_nullable($serializer_getInstance_170())];
		  };
		  protoOf($serializer_171).wf = function (decoder) {
		    var tmp0_desc = this.m3e_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_input = decoder.ej(tmp0_desc);
		    if (tmp5_input.uj()) {
		      tmp4_local0 = tmp5_input.sj(tmp0_desc, 0, $serializer_getInstance_170(), tmp4_local0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp5_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp5_input.sj(tmp0_desc, 0, $serializer_getInstance_170(), tmp4_local0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp5_input.fj(tmp0_desc);
		    return InvitedUserMedia_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
		  };
		  protoOf($serializer_171).n3e = function (encoder, value) {
		    var tmp0_desc = this.m3e_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.xk(tmp0_desc, 0, $serializer_getInstance_170(), value.o3e_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_171).vf = function (encoder, value) {
		    return this.n3e(encoder, value instanceof InvitedUserMedia ? value : THROW_CCE());
		  };
		  var $serializer_instance_171;
		  function $serializer_getInstance_171() {
		    if ($serializer_instance_171 == null)
		      new $serializer_171();
		    return $serializer_instance_171;
		  }
		  function InvitedUserMedia_init_$Init$(seen1, audio_settings, serializationConstructorMarker, $this) {
		    if (!(1 === (1 & seen1))) {
		      throwMissingFieldException(seen1, 1, $serializer_getInstance_171().m3e_1);
		    }
		    $this.o3e_1 = audio_settings;
		    return $this;
		  }
		  function InvitedUserMedia_init_$Create$(seen1, audio_settings, serializationConstructorMarker) {
		    return InvitedUserMedia_init_$Init$(seen1, audio_settings, serializationConstructorMarker, objectCreate(protoOf(InvitedUserMedia)));
		  }
		  function InvitedUserMedia() {
		  }
		  protoOf(InvitedUserMedia).toString = function () {
		    return 'InvitedUserMedia(audio_settings=' + this.o3e_1 + ')';
		  };
		  protoOf(InvitedUserMedia).hashCode = function () {
		    return this.o3e_1 == null ? 0 : this.o3e_1.hashCode();
		  };
		  protoOf(InvitedUserMedia).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof InvitedUserMedia))
		      return false;
		    var tmp0_other_with_cast = other instanceof InvitedUserMedia ? other : THROW_CCE();
		    if (!equals(this.o3e_1, tmp0_other_with_cast.o3e_1))
		      return false;
		    return true;
		  };
		  function $serializer_172() {
		    $serializer_instance_172 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.RTCQuality', this, 9);
		    tmp0_serialDesc.pq('mos_score', false);
		    tmp0_serialDesc.pq('quality_percentage', false);
		    tmp0_serialDesc.pq('jitter_min_var', false);
		    tmp0_serialDesc.pq('jitter_max_var', false);
		    tmp0_serialDesc.pq('jitter_loss_rate', false);
		    tmp0_serialDesc.pq('jitter_burst_rate', false);
		    tmp0_serialDesc.pq('flaw_total', false);
		    tmp0_serialDesc.pq('packet_cnt', false);
		    tmp0_serialDesc.pq('packet_loss_perc', false);
		    this.p3e_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_172).uf = function () {
		    return this.p3e_1;
		  };
		  protoOf($serializer_172).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance()];
		  };
		  protoOf($serializer_172).wf = function (decoder) {
		    var tmp0_desc = this.p3e_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0.0;
		    var tmp5_local1 = 0.0;
		    var tmp6_local2 = 0.0;
		    var tmp7_local3 = 0.0;
		    var tmp8_local4 = 0.0;
		    var tmp9_local5 = 0.0;
		    var tmp10_local6 = 0;
		    var tmp11_local7 = 0;
		    var tmp12_local8 = 0.0;
		    var tmp13_input = decoder.ej(tmp0_desc);
		    if (tmp13_input.uj()) {
		      tmp4_local0 = tmp13_input.lj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp13_input.lj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp13_input.lj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		      tmp7_local3 = tmp13_input.lj(tmp0_desc, 3);
		      tmp3_bitMask0 = tmp3_bitMask0 | 8;
		      tmp8_local4 = tmp13_input.lj(tmp0_desc, 4);
		      tmp3_bitMask0 = tmp3_bitMask0 | 16;
		      tmp9_local5 = tmp13_input.lj(tmp0_desc, 5);
		      tmp3_bitMask0 = tmp3_bitMask0 | 32;
		      tmp10_local6 = tmp13_input.jj(tmp0_desc, 6);
		      tmp3_bitMask0 = tmp3_bitMask0 | 64;
		      tmp11_local7 = tmp13_input.jj(tmp0_desc, 7);
		      tmp3_bitMask0 = tmp3_bitMask0 | 128;
		      tmp12_local8 = tmp13_input.lj(tmp0_desc, 8);
		      tmp3_bitMask0 = tmp3_bitMask0 | 256;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp13_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp13_input.lj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp13_input.lj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp13_input.lj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          case 3:
		            tmp7_local3 = tmp13_input.lj(tmp0_desc, 3);
		            tmp3_bitMask0 = tmp3_bitMask0 | 8;
		            break;
		          case 4:
		            tmp8_local4 = tmp13_input.lj(tmp0_desc, 4);
		            tmp3_bitMask0 = tmp3_bitMask0 | 16;
		            break;
		          case 5:
		            tmp9_local5 = tmp13_input.lj(tmp0_desc, 5);
		            tmp3_bitMask0 = tmp3_bitMask0 | 32;
		            break;
		          case 6:
		            tmp10_local6 = tmp13_input.jj(tmp0_desc, 6);
		            tmp3_bitMask0 = tmp3_bitMask0 | 64;
		            break;
		          case 7:
		            tmp11_local7 = tmp13_input.jj(tmp0_desc, 7);
		            tmp3_bitMask0 = tmp3_bitMask0 | 128;
		            break;
		          case 8:
		            tmp12_local8 = tmp13_input.lj(tmp0_desc, 8);
		            tmp3_bitMask0 = tmp3_bitMask0 | 256;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp13_input.fj(tmp0_desc);
		    return RTCQuality_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
		  };
		  protoOf($serializer_172).q3e = function (encoder, value) {
		    var tmp0_desc = this.p3e_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.qk(tmp0_desc, 0, value.r3e_1);
		    tmp1_output.qk(tmp0_desc, 1, value.s3e_1);
		    tmp1_output.qk(tmp0_desc, 2, value.t3e_1);
		    tmp1_output.qk(tmp0_desc, 3, value.u3e_1);
		    tmp1_output.qk(tmp0_desc, 4, value.v3e_1);
		    tmp1_output.qk(tmp0_desc, 5, value.w3e_1);
		    tmp1_output.ok(tmp0_desc, 6, value.x3e_1);
		    tmp1_output.ok(tmp0_desc, 7, value.y3e_1);
		    tmp1_output.qk(tmp0_desc, 8, value.z3e_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_172).vf = function (encoder, value) {
		    return this.q3e(encoder, value instanceof RTCQuality ? value : THROW_CCE());
		  };
		  var $serializer_instance_172;
		  function $serializer_getInstance_172() {
		    if ($serializer_instance_172 == null)
		      new $serializer_172();
		    return $serializer_instance_172;
		  }
		  function RTCQuality_init_$Init$(seen1, mos_score, quality_percentage, jitter_min_var, jitter_max_var, jitter_loss_rate, jitter_burst_rate, flaw_total, packet_cnt, packet_loss_perc, serializationConstructorMarker, $this) {
		    if (!(511 === (511 & seen1))) {
		      throwMissingFieldException(seen1, 511, $serializer_getInstance_172().p3e_1);
		    }
		    $this.r3e_1 = mos_score;
		    $this.s3e_1 = quality_percentage;
		    $this.t3e_1 = jitter_min_var;
		    $this.u3e_1 = jitter_max_var;
		    $this.v3e_1 = jitter_loss_rate;
		    $this.w3e_1 = jitter_burst_rate;
		    $this.x3e_1 = flaw_total;
		    $this.y3e_1 = packet_cnt;
		    $this.z3e_1 = packet_loss_perc;
		    return $this;
		  }
		  function RTCQuality_init_$Create$(seen1, mos_score, quality_percentage, jitter_min_var, jitter_max_var, jitter_loss_rate, jitter_burst_rate, flaw_total, packet_cnt, packet_loss_perc, serializationConstructorMarker) {
		    return RTCQuality_init_$Init$(seen1, mos_score, quality_percentage, jitter_min_var, jitter_max_var, jitter_loss_rate, jitter_burst_rate, flaw_total, packet_cnt, packet_loss_perc, serializationConstructorMarker, objectCreate(protoOf(RTCQuality)));
		  }
		  function RTCQuality() {
		  }
		  protoOf(RTCQuality).toString = function () {
		    return 'RTCQuality(mos_score=' + this.r3e_1 + ', quality_percentage=' + this.s3e_1 + ', jitter_min_var=' + this.t3e_1 + ', jitter_max_var=' + this.u3e_1 + ', jitter_loss_rate=' + this.v3e_1 + ', jitter_burst_rate=' + this.w3e_1 + ', flaw_total=' + this.x3e_1 + ', packet_cnt=' + this.y3e_1 + ', packet_loss_perc=' + this.z3e_1 + ')';
		  };
		  protoOf(RTCQuality).hashCode = function () {
		    var result = getNumberHashCode(this.r3e_1);
		    result = imul(result, 31) + getNumberHashCode(this.s3e_1) | 0;
		    result = imul(result, 31) + getNumberHashCode(this.t3e_1) | 0;
		    result = imul(result, 31) + getNumberHashCode(this.u3e_1) | 0;
		    result = imul(result, 31) + getNumberHashCode(this.v3e_1) | 0;
		    result = imul(result, 31) + getNumberHashCode(this.w3e_1) | 0;
		    result = imul(result, 31) + this.x3e_1 | 0;
		    result = imul(result, 31) + this.y3e_1 | 0;
		    result = imul(result, 31) + getNumberHashCode(this.z3e_1) | 0;
		    return result;
		  };
		  protoOf(RTCQuality).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCQuality))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCQuality ? other : THROW_CCE();
		    if (!equals(this.r3e_1, tmp0_other_with_cast.r3e_1))
		      return false;
		    if (!equals(this.s3e_1, tmp0_other_with_cast.s3e_1))
		      return false;
		    if (!equals(this.t3e_1, tmp0_other_with_cast.t3e_1))
		      return false;
		    if (!equals(this.u3e_1, tmp0_other_with_cast.u3e_1))
		      return false;
		    if (!equals(this.v3e_1, tmp0_other_with_cast.v3e_1))
		      return false;
		    if (!equals(this.w3e_1, tmp0_other_with_cast.w3e_1))
		      return false;
		    if (!(this.x3e_1 === tmp0_other_with_cast.x3e_1))
		      return false;
		    if (!(this.y3e_1 === tmp0_other_with_cast.y3e_1))
		      return false;
		    if (!equals(this.z3e_1, tmp0_other_with_cast.z3e_1))
		      return false;
		    return true;
		  };
		  function _get_$cachedSerializer__te6jhj_3($this) {
		    return $this.a3f_1.w1();
		  }
		  function CallCompleteReason$Companion$_anonymous__x937xw() {
		    return $serializer_getInstance_173();
		  }
		  var CallCompleteReason_LocalHangup_instance;
		  var CallCompleteReason_LocalCancel_instance;
		  var CallCompleteReason_RemoteHangup_instance;
		  var CallCompleteReason_MaxLength_instance;
		  var CallCompleteReason_RingTimeout_instance;
		  var CallCompleteReason_Failed_instance;
		  var CallCompleteReason_Unknown_instance;
		  function Companion_152() {
		    Companion_instance_153 = this;
		    var tmp = this;
		    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
		    tmp.a3f_1 = lazy(tmp_0, CallCompleteReason$Companion$_anonymous__x937xw);
		  }
		  protoOf(Companion_152).y12 = function () {
		    return _get_$cachedSerializer__te6jhj_3(this);
		  };
		  protoOf(Companion_152).nr = function (typeParamsSerializers) {
		    return this.y12();
		  };
		  var Companion_instance_153;
		  function Companion_getInstance_154() {
		    CallCompleteReason_initEntries();
		    if (Companion_instance_153 == null)
		      new Companion_152();
		    return Companion_instance_153;
		  }
		  function $serializer_173() {
		    $serializer_instance_173 = this;
		    var tmp0_serialDesc = new EnumDescriptor('com.vonage.clientcore.core.conversation.CallCompleteReason', 7);
		    tmp0_serialDesc.pq('LocalHangup', false);
		    tmp0_serialDesc.pq('LocalCancel', false);
		    tmp0_serialDesc.pq('RemoteHangup', false);
		    tmp0_serialDesc.pq('MaxLength', false);
		    tmp0_serialDesc.pq('RingTimeout', false);
		    tmp0_serialDesc.pq('Failed', false);
		    tmp0_serialDesc.pq('Unknown', false);
		    this.b3f_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_173).uf = function () {
		    return this.b3f_1;
		  };
		  protoOf($serializer_173).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [];
		  };
		  protoOf($serializer_173).wf = function (decoder) {
		    return values_4()[decoder.aj(this.b3f_1)];
		  };
		  protoOf($serializer_173).c3f = function (encoder, value) {
		    encoder.jk(this.b3f_1, value.i8_1);
		  };
		  protoOf($serializer_173).vf = function (encoder, value) {
		    return this.c3f(encoder, value instanceof CallCompleteReason ? value : THROW_CCE());
		  };
		  var $serializer_instance_173;
		  function $serializer_getInstance_173() {
		    CallCompleteReason_initEntries();
		    if ($serializer_instance_173 == null)
		      new $serializer_173();
		    return $serializer_instance_173;
		  }
		  function values_4() {
		    return [CallCompleteReason_LocalHangup_getInstance(), CallCompleteReason_LocalCancel_getInstance(), CallCompleteReason_RemoteHangup_getInstance(), CallCompleteReason_MaxLength_getInstance(), CallCompleteReason_RingTimeout_getInstance(), CallCompleteReason_Failed_getInstance(), CallCompleteReason_Unknown_getInstance()];
		  }
		  var CallCompleteReason_entriesInitialized;
		  function CallCompleteReason_initEntries() {
		    if (CallCompleteReason_entriesInitialized)
		      return Unit_instance;
		    CallCompleteReason_entriesInitialized = true;
		    CallCompleteReason_LocalHangup_instance = new CallCompleteReason('LocalHangup', 0);
		    CallCompleteReason_LocalCancel_instance = new CallCompleteReason('LocalCancel', 1);
		    CallCompleteReason_RemoteHangup_instance = new CallCompleteReason('RemoteHangup', 2);
		    CallCompleteReason_MaxLength_instance = new CallCompleteReason('MaxLength', 3);
		    CallCompleteReason_RingTimeout_instance = new CallCompleteReason('RingTimeout', 4);
		    CallCompleteReason_Failed_instance = new CallCompleteReason('Failed', 5);
		    CallCompleteReason_Unknown_instance = new CallCompleteReason('Unknown', 6);
		    Companion_getInstance_154();
		  }
		  function CallCompleteReason(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function $serializer_174() {
		    $serializer_instance_174 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.RTCHangupReason', this, 3);
		    tmp0_serialDesc.pq('text', false);
		    tmp0_serialDesc.pq('code', false);
		    tmp0_serialDesc.pq('sip_code', false);
		    this.d3f_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_174).uf = function () {
		    return this.d3f_1;
		  };
		  protoOf($serializer_174).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [StringSerializer_getInstance(), CallCompleteReasonSerialiser_getInstance(), IntSerializer_getInstance()];
		  };
		  protoOf($serializer_174).wf = function (decoder) {
		    var tmp0_desc = this.d3f_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = null;
		    var tmp5_local1 = null;
		    var tmp6_local2 = 0;
		    var tmp7_input = decoder.ej(tmp0_desc);
		    if (tmp7_input.uj()) {
		      tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, CallCompleteReasonSerialiser_getInstance(), tmp5_local1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		      tmp6_local2 = tmp7_input.jj(tmp0_desc, 2);
		      tmp3_bitMask0 = tmp3_bitMask0 | 4;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp7_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp7_input.oj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp7_input.qj(tmp0_desc, 1, CallCompleteReasonSerialiser_getInstance(), tmp5_local1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          case 2:
		            tmp6_local2 = tmp7_input.jj(tmp0_desc, 2);
		            tmp3_bitMask0 = tmp3_bitMask0 | 4;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp7_input.fj(tmp0_desc);
		    return RTCHangupReason_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
		  };
		  protoOf($serializer_174).e3f = function (encoder, value) {
		    var tmp0_desc = this.d3f_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.tk(tmp0_desc, 0, value.q3a_1);
		    tmp1_output.vk(tmp0_desc, 1, CallCompleteReasonSerialiser_getInstance(), value.r3a_1);
		    tmp1_output.ok(tmp0_desc, 2, value.s3a_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_174).vf = function (encoder, value) {
		    return this.e3f(encoder, value instanceof RTCHangupReason ? value : THROW_CCE());
		  };
		  var $serializer_instance_174;
		  function $serializer_getInstance_174() {
		    if ($serializer_instance_174 == null)
		      new $serializer_174();
		    return $serializer_instance_174;
		  }
		  function RTCHangupReason_init_$Init$(seen1, text, code, sip_code, serializationConstructorMarker, $this) {
		    if (!(7 === (7 & seen1))) {
		      throwMissingFieldException(seen1, 7, $serializer_getInstance_174().d3f_1);
		    }
		    $this.q3a_1 = text;
		    $this.r3a_1 = code;
		    $this.s3a_1 = sip_code;
		    return $this;
		  }
		  function RTCHangupReason_init_$Create$(seen1, text, code, sip_code, serializationConstructorMarker) {
		    return RTCHangupReason_init_$Init$(seen1, text, code, sip_code, serializationConstructorMarker, objectCreate(protoOf(RTCHangupReason)));
		  }
		  function RTCHangupReason() {
		  }
		  protoOf(RTCHangupReason).toString = function () {
		    return 'RTCHangupReason(text=' + this.q3a_1 + ', code=' + this.r3a_1 + ', sip_code=' + this.s3a_1 + ')';
		  };
		  protoOf(RTCHangupReason).hashCode = function () {
		    var result = getStringHashCode(this.q3a_1);
		    result = imul(result, 31) + this.r3a_1.hashCode() | 0;
		    result = imul(result, 31) + this.s3a_1 | 0;
		    return result;
		  };
		  protoOf(RTCHangupReason).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCHangupReason))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCHangupReason ? other : THROW_CCE();
		    if (!(this.q3a_1 === tmp0_other_with_cast.q3a_1))
		      return false;
		    if (!this.r3a_1.equals(tmp0_other_with_cast.r3a_1))
		      return false;
		    if (!(this.s3a_1 === tmp0_other_with_cast.s3a_1))
		      return false;
		    return true;
		  };
		  function CallCompleteReasonSerialiser() {
		    CallCompleteReasonSerialiser_instance = this;
		    this.f3f_1 = PrimitiveSerialDescriptor('RTCHangupReason.code', STRING_getInstance());
		  }
		  protoOf(CallCompleteReasonSerialiser).uf = function () {
		    return this.f3f_1;
		  };
		  protoOf(CallCompleteReasonSerialiser).wf = function (decoder) {
		    switch (decoder.zi()) {
		      case 'LOCAL_HANGUP':
		        return CallCompleteReason_LocalHangup_getInstance();
		      case 'REMOTE_HANGUP':
		        return CallCompleteReason_RemoteHangup_getInstance();
		      case 'LOCAL_CANCEL':
		        return CallCompleteReason_LocalCancel_getInstance();
		      case 'LENGTH_TIMER':
		        return CallCompleteReason_MaxLength_getInstance();
		      case 'RING_TIMER':
		        return CallCompleteReason_RingTimeout_getInstance();
		      case 'REMOTE_NO_ANSWER':
		      case 'REMOTE_REJECTED':
		      case 'REMOTE_BUSY':
		      case 'REMOTE_CANCEL':
		      case 'REMOTE_NOT_FOUND':
		      case 'REMOTE_FAILURE':
		        return CallCompleteReason_RemoteHangup_getInstance();
		      default:
		        return CallCompleteReason_Unknown_getInstance();
		    }
		  };
		  protoOf(CallCompleteReasonSerialiser).c3f = function (encoder, value) {
		    encoder.ik(value.h8_1);
		  };
		  protoOf(CallCompleteReasonSerialiser).vf = function (encoder, value) {
		    return this.c3f(encoder, value instanceof CallCompleteReason ? value : THROW_CCE());
		  };
		  var CallCompleteReasonSerialiser_instance;
		  function CallCompleteReasonSerialiser_getInstance() {
		    if (CallCompleteReasonSerialiser_instance == null)
		      new CallCompleteReasonSerialiser();
		    return CallCompleteReasonSerialiser_instance;
		  }
		  function $serializer_175() {
		    $serializer_instance_175 = this;
		    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.vonage.clientcore.core.conversation.RTCBandwidth', this, 2);
		    tmp0_serialDesc.pq('bytes_in', false);
		    tmp0_serialDesc.pq('bytes_out', false);
		    this.g3f_1 = tmp0_serialDesc;
		  }
		  protoOf($serializer_175).uf = function () {
		    return this.g3f_1;
		  };
		  protoOf($serializer_175).er = function () {
		    // Inline function 'kotlin.arrayOf' call
		    // Inline function 'kotlin.js.unsafeCast' call
		    // Inline function 'kotlin.js.asDynamic' call
		    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
		  };
		  protoOf($serializer_175).wf = function (decoder) {
		    var tmp0_desc = this.g3f_1;
		    var tmp1_flag = true;
		    var tmp2_index = 0;
		    var tmp3_bitMask0 = 0;
		    var tmp4_local0 = 0;
		    var tmp5_local1 = 0;
		    var tmp6_input = decoder.ej(tmp0_desc);
		    if (tmp6_input.uj()) {
		      tmp4_local0 = tmp6_input.jj(tmp0_desc, 0);
		      tmp3_bitMask0 = tmp3_bitMask0 | 1;
		      tmp5_local1 = tmp6_input.jj(tmp0_desc, 1);
		      tmp3_bitMask0 = tmp3_bitMask0 | 2;
		    } else
		      while (tmp1_flag) {
		        tmp2_index = tmp6_input.vj(tmp0_desc);
		        switch (tmp2_index) {
		          case -1:
		            tmp1_flag = false;
		            break;
		          case 0:
		            tmp4_local0 = tmp6_input.jj(tmp0_desc, 0);
		            tmp3_bitMask0 = tmp3_bitMask0 | 1;
		            break;
		          case 1:
		            tmp5_local1 = tmp6_input.jj(tmp0_desc, 1);
		            tmp3_bitMask0 = tmp3_bitMask0 | 2;
		            break;
		          default:
		            throw UnknownFieldException_init_$Create$(tmp2_index);
		        }
		      }
		    tmp6_input.fj(tmp0_desc);
		    return RTCBandwidth_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
		  };
		  protoOf($serializer_175).h3f = function (encoder, value) {
		    var tmp0_desc = this.g3f_1;
		    var tmp1_output = encoder.ej(tmp0_desc);
		    tmp1_output.ok(tmp0_desc, 0, value.i3f_1);
		    tmp1_output.ok(tmp0_desc, 1, value.j3f_1);
		    tmp1_output.fj(tmp0_desc);
		  };
		  protoOf($serializer_175).vf = function (encoder, value) {
		    return this.h3f(encoder, value instanceof RTCBandwidth ? value : THROW_CCE());
		  };
		  var $serializer_instance_175;
		  function $serializer_getInstance_175() {
		    if ($serializer_instance_175 == null)
		      new $serializer_175();
		    return $serializer_instance_175;
		  }
		  function RTCBandwidth_init_$Init$(seen1, bytes_in, bytes_out, serializationConstructorMarker, $this) {
		    if (!(3 === (3 & seen1))) {
		      throwMissingFieldException(seen1, 3, $serializer_getInstance_175().g3f_1);
		    }
		    $this.i3f_1 = bytes_in;
		    $this.j3f_1 = bytes_out;
		    return $this;
		  }
		  function RTCBandwidth_init_$Create$(seen1, bytes_in, bytes_out, serializationConstructorMarker) {
		    return RTCBandwidth_init_$Init$(seen1, bytes_in, bytes_out, serializationConstructorMarker, objectCreate(protoOf(RTCBandwidth)));
		  }
		  function RTCBandwidth() {
		  }
		  protoOf(RTCBandwidth).toString = function () {
		    return 'RTCBandwidth(bytes_in=' + this.i3f_1 + ', bytes_out=' + this.j3f_1 + ')';
		  };
		  protoOf(RTCBandwidth).hashCode = function () {
		    var result = this.i3f_1;
		    result = imul(result, 31) + this.j3f_1 | 0;
		    return result;
		  };
		  protoOf(RTCBandwidth).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCBandwidth))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCBandwidth ? other : THROW_CCE();
		    if (!(this.i3f_1 === tmp0_other_with_cast.i3f_1))
		      return false;
		    if (!(this.j3f_1 === tmp0_other_with_cast.j3f_1))
		      return false;
		    return true;
		  };
		  function CallCompleteReason_LocalHangup_getInstance() {
		    CallCompleteReason_initEntries();
		    return CallCompleteReason_LocalHangup_instance;
		  }
		  function CallCompleteReason_LocalCancel_getInstance() {
		    CallCompleteReason_initEntries();
		    return CallCompleteReason_LocalCancel_instance;
		  }
		  function CallCompleteReason_RemoteHangup_getInstance() {
		    CallCompleteReason_initEntries();
		    return CallCompleteReason_RemoteHangup_instance;
		  }
		  function CallCompleteReason_MaxLength_getInstance() {
		    CallCompleteReason_initEntries();
		    return CallCompleteReason_MaxLength_instance;
		  }
		  function CallCompleteReason_RingTimeout_getInstance() {
		    CallCompleteReason_initEntries();
		    return CallCompleteReason_RingTimeout_instance;
		  }
		  function CallCompleteReason_Failed_getInstance() {
		    CallCompleteReason_initEntries();
		    return CallCompleteReason_Failed_instance;
		  }
		  function CallCompleteReason_Unknown_getInstance() {
		    CallCompleteReason_initEntries();
		    return CallCompleteReason_Unknown_instance;
		  }
		  function ConsoleLogger(minLogLevel) {
		    minLogLevel = minLogLevel === VOID ? Companion_getInstance_137().r2v_1 : minLogLevel;
		    BaseVonageLogger.call(this, 'VonageConsoleLogger', minLogLevel);
		    this.r3f_1 = flatten(Companion_getInstance_155().y3f_1);
		  }
		  protoOf(ConsoleLogger).a3g = function () {
		    return this.r3f_1;
		  };
		  function WebRTCLogger(minLogLevel) {
		    minLogLevel = minLogLevel === VOID ? LoggingLevel_Verbose_getInstance() : minLogLevel;
		    BaseVonageLogger.call(this, 'VonageWebRTCLogger', minLogLevel);
		    this.r3g_1 = Companion_getInstance_155().z3f_1;
		  }
		  protoOf(WebRTCLogger).a3g = function () {
		    return this.r3g_1;
		  };
		  function BaseVonageLogger$config$1(this$0) {
		    this.s3g_1 = Companion_getInstance_0().j1d_1.m1d();
		    this.t3g_1 = toSev(this$0.c3g_1);
		  }
		  protoOf(BaseVonageLogger$config$1).m1d = function () {
		    return this.s3g_1;
		  };
		  function BaseVonageLogger(name, minLogLevel) {
		    this.b3g_1 = name;
		    this.c3g_1 = minLogLevel;
		    var tmp = this;
		    tmp.d3g_1 = new BaseVonageLogger$config$1(this);
		    this.e3g_1 = SdkInfo_getInstance().b1g_1;
		    this.f3g_1 = slice(generateUUID(), numberRangeToNumber(1, 5));
		    this.g3g_1 = this.b3g_1 + '::vonage.core.' + this.f3g_1 + '.' + this.e3g_1;
		    this.h3g_1 = new Logger(this.d3g_1);
		  }
		  protoOf(BaseVonageLogger).i3g = function () {
		    return this.c3g_1;
		  };
		  protoOf(BaseVonageLogger).j3g = function (logLevel, topic, message, throwable) {
		    return this.h3g_1.l1d(toSev(logLevel), this.g3g_1 + '.' + topic.u3g_1 + '.' + topic.v3g_1, throwable, message);
		  };
		  function toSev(_this__u8e3s4) {
		    return valueOf(_this__u8e3s4.f2v_1);
		  }
		  function checkSize(_this__u8e3s4, $this) {
		    var tmp = _this__u8e3s4.length;
		    if (tmp > 10) {
		      throw toVonageError(new CustomLoggersLimitReached(_this__u8e3s4.length));
		    }
		  }
		  function LoggerAdapter(consoleLogLevel, customLoggers, disableInternalLogger) {
		    consoleLogLevel = consoleLogLevel === VOID ? Companion_getInstance_137().r2v_1 : consoleLogLevel;
		    disableInternalLogger = disableInternalLogger === VOID ? false : disableInternalLogger;
		    var tmp = this;
		    // Inline function 'kotlin.takeUnless' call
		    // Inline function 'kotlin.contracts.contract' call
		    var tmp_0;
		    // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.loggers.<anonymous>' call
		    if (!disableInternalLogger) {
		      tmp_0 = consoleLogLevel;
		    } else {
		      tmp_0 = null;
		    }
		    var tmp0_safe_receiver = tmp_0;
		    var tmp_1;
		    if (tmp0_safe_receiver == null) {
		      tmp_1 = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.loggers.<anonymous>' call
		      tmp_1 = new ConsoleLogger(tmp0_safe_receiver);
		    }
		    var tmp_2 = tmp_1;
		    // Inline function 'kotlin.takeIf' call
		    // Inline function 'kotlin.contracts.contract' call
		    var tmp_3;
		    // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.loggers.<anonymous>' call
		    if (consoleLogLevel.equals(LoggingLevel_Verbose_getInstance()) ? !disableInternalLogger : false) {
		      tmp_3 = consoleLogLevel;
		    } else {
		      tmp_3 = null;
		    }
		    var tmp_4;
		    if (tmp_3 == null) {
		      tmp_4 = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.loggers.<anonymous>' call
		      tmp_4 = new WebRTCLogger();
		    }
		    var tmp_5 = [tmp_2, tmp_4];
		    // Inline function 'kotlin.also' call
		    // Inline function 'kotlin.collections.toTypedArray' call
		    var this_0 = copyToArray(customLoggers);
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.loggers.<anonymous>' call
		    checkSize(this_0, this);
		    tmp.u1e_1 = listOfNotNull(arrayConcat([tmp_5, this_0]));
		  }
		  protoOf(LoggerAdapter).w3g = function (logLevel, topic, throwable, message) {
		    // Inline function 'kotlin.let' call
		    // Inline function 'kotlin.collections.filter' call
		    // Inline function 'kotlin.collections.filter' call
		    // Inline function 'kotlin.collections.filterTo' call
		    var this_0 = this.u1e_1;
		    var destination = ArrayList_init_$Create$_0();
		    var tmp0_iterator = this_0.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.log.<anonymous>' call
		      if (element.i3g().j8(logLevel) <= 0) {
		        destination.m(element);
		      }
		    }
		    // Inline function 'kotlin.collections.filterTo' call
		    var destination_0 = ArrayList_init_$Create$_0();
		    var tmp0_iterator_0 = destination.p();
		    while (tmp0_iterator_0.q()) {
		      var element_0 = tmp0_iterator_0.s();
		      // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.log.<anonymous>' call
		      if (element_0.a3g().v(topic)) {
		        destination_0.m(element_0);
		      }
		    }
		    // Inline function 'kotlin.contracts.contract' call
		    var log = message();
		    var tmp0_iterator_1 = destination_0.p();
		    while (tmp0_iterator_1.q()) {
		      var element_1 = tmp0_iterator_1.s();
		      // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.log.<anonymous>.<anonymous>' call
		      element_1.j3g(logLevel, topic, log, throwable);
		    }
		    return Unit_instance;
		  };
		  protoOf(LoggerAdapter).x3g = function (logLevel, topic, message, throwable) {
		    // Inline function 'kotlin.collections.filter' call
		    // Inline function 'kotlin.collections.filter' call
		    // Inline function 'kotlin.collections.filterTo' call
		    var this_0 = this.u1e_1;
		    var destination = ArrayList_init_$Create$_0();
		    var tmp0_iterator = this_0.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.log.<anonymous>' call
		      if (element.i3g().j8(logLevel) <= 0) {
		        destination.m(element);
		      }
		    }
		    // Inline function 'kotlin.collections.filterTo' call
		    var destination_0 = ArrayList_init_$Create$_0();
		    var tmp0_iterator_0 = destination.p();
		    while (tmp0_iterator_0.q()) {
		      var element_0 = tmp0_iterator_0.s();
		      // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.log.<anonymous>' call
		      if (element_0.a3g().v(topic)) {
		        destination_0.m(element_0);
		      }
		    }
		    var tmp0_iterator_1 = destination_0.p();
		    while (tmp0_iterator_1.q()) {
		      var element_1 = tmp0_iterator_1.s();
		      // Inline function 'com.vonage.clientcore.core.logging.LoggerAdapter.log.<anonymous>' call
		      element_1.j3g(logLevel, topic, message, throwable);
		    }
		    return Unit_instance;
		  };
		  protoOf(LoggerAdapter).v1e = function (topic) {
		    return new TopicLoggerAdapter(topic, this);
		  };
		  function TopicLoggerAdapter(topic, loggerAdapter) {
		    this.i38_1 = topic;
		    this.j38_1 = loggerAdapter;
		  }
		  protoOf(TopicLoggerAdapter).z3g = function (topic, throwable, message) {
		    this.j38_1.z3g(topic, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).c3h = function (topic, message, throwable) {
		    this.j38_1.c3h(topic, message, throwable);
		  };
		  protoOf(TopicLoggerAdapter).d3h = function (topic, throwable, message) {
		    this.j38_1.d3h(topic, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).a3h = function (topic, throwable, message) {
		    this.j38_1.a3h(topic, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).x3g = function (logLevel, topic, message, throwable) {
		    this.j38_1.x3g(logLevel, topic, message, throwable);
		  };
		  protoOf(TopicLoggerAdapter).w3g = function (logLevel, topic, throwable, message) {
		    this.j38_1.w3g(logLevel, topic, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).y3g = function (topic, throwable, message) {
		    this.j38_1.y3g(topic, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).b3h = function (topic, throwable, message) {
		    this.j38_1.b3h(topic, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).e3h = function (message, throwable) {
		    return this.c3h(this.i38_1, message, throwable);
		  };
		  protoOf(TopicLoggerAdapter).k38 = function (message, throwable, $super) {
		    throwable = throwable === VOID ? null : throwable;
		    var tmp;
		    if ($super === VOID) {
		      this.e3h(message, throwable);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.e3h.call(this, message, throwable);
		    }
		    return tmp;
		  };
		  protoOf(TopicLoggerAdapter).f3h = function (throwable, message) {
		    return this.y3g(this.i38_1, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).g3h = function (throwable, message, $super) {
		    throwable = throwable === VOID ? null : throwable;
		    var tmp;
		    if ($super === VOID) {
		      this.f3h(throwable, message);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.f3h.call(this, throwable, message);
		    }
		    return tmp;
		  };
		  protoOf(TopicLoggerAdapter).h3h = function (throwable, message) {
		    return this.z3g(this.i38_1, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).i3h = function (throwable, message, $super) {
		    throwable = throwable === VOID ? null : throwable;
		    var tmp;
		    if ($super === VOID) {
		      this.h3h(throwable, message);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.h3h.call(this, throwable, message);
		    }
		    return tmp;
		  };
		  protoOf(TopicLoggerAdapter).j3h = function (throwable, message) {
		    return this.a3h(this.i38_1, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).k3h = function (throwable, message, $super) {
		    throwable = throwable === VOID ? null : throwable;
		    var tmp;
		    if ($super === VOID) {
		      this.j3h(throwable, message);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.j3h.call(this, throwable, message);
		    }
		    return tmp;
		  };
		  protoOf(TopicLoggerAdapter).l3h = function (throwable, message) {
		    return this.b3h(this.i38_1, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).e3a = function (throwable, message, $super) {
		    throwable = throwable === VOID ? null : throwable;
		    var tmp;
		    if ($super === VOID) {
		      this.l3h(throwable, message);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.l3h.call(this, throwable, message);
		    }
		    return tmp;
		  };
		  protoOf(TopicLoggerAdapter).m3h = function (throwable, message) {
		    return this.d3h(this.i38_1, throwable, message);
		  };
		  protoOf(TopicLoggerAdapter).n3h = function (throwable, message, $super) {
		    throwable = throwable === VOID ? null : throwable;
		    var tmp;
		    if ($super === VOID) {
		      this.m3h(throwable, message);
		      tmp = Unit_instance;
		    } else {
		      tmp = $super.m3h.call(this, throwable, message);
		    }
		    return tmp;
		  };
		  function ILoggerAdapter() {
		  }
		  function callbackLogger2(fn, logger, tag) {
		    return callbackLogger2$lambda(logger, fn, tag);
		  }
		  function callbackLogger1(fn, logger, tag) {
		    return callbackLogger1$lambda(logger, fn, tag);
		  }
		  function v_0(_this__u8e3s4, a, fn) {
		    return _this__u8e3s4.g3h(VOID, v$lambda(a, fn));
		  }
		  function e_1(_this__u8e3s4, a, fn) {
		    return _this__u8e3s4.n3h(VOID, e$lambda(a, fn));
		  }
		  function d_0(_this__u8e3s4, a, fn) {
		    return _this__u8e3s4.i3h(VOID, d$lambda(a, fn));
		  }
		  function callbackLogger2$lambda$lambda($tag, $a) {
		    return function () {
		      var tmp = $a.message;
		      var tmp0_elvis_lhs = $a.cause;
		      return $tag + ' Callback - Error: ' + tmp + ' ' + toString(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
		    };
		  }
		  function callbackLogger2$lambda$lambda_0($tag, $a, $b) {
		    return function () {
		      return $tag + ' Callback - params: ' + $a + ', ' + $b;
		    };
		  }
		  function callbackLogger2$lambda($logger, $fn, $tag) {
		    return function (a, b) {
		      var tmp;
		      if (a instanceof Exception) {
		        $logger.n3h(VOID, callbackLogger2$lambda$lambda($tag, a));
		        tmp = Unit_instance;
		      } else {
		        $logger.k3h(VOID, callbackLogger2$lambda$lambda_0($tag, a, b));
		        tmp = Unit_instance;
		      }
		      return $fn(a, b);
		    };
		  }
		  function callbackLogger1$lambda$lambda($tag, $a) {
		    return function () {
		      var tmp = $a.message;
		      var tmp0_elvis_lhs = $a.cause;
		      return $tag + ' Callback - Error: ' + tmp + ' ' + toString(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
		    };
		  }
		  function callbackLogger1$lambda$lambda_0($tag, $a) {
		    return function () {
		      return $tag + ' Callback - params: ' + $a;
		    };
		  }
		  function callbackLogger1$lambda($logger, $fn, $tag) {
		    return function (a) {
		      var tmp;
		      if (a instanceof Exception) {
		        $logger.n3h(VOID, callbackLogger1$lambda$lambda($tag, a));
		        tmp = Unit_instance;
		      } else {
		        $logger.k3h(VOID, callbackLogger1$lambda$lambda_0($tag, a));
		        tmp = Unit_instance;
		      }
		      return $fn(a);
		    };
		  }
		  function v$lambda($a, $fn) {
		    return function () {
		      var tmp0_elvis_lhs = getKClassFromExpression($a.o3h_1).t5();
		      return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' ' + $a.p3h_1.q3h_1 + ' ' + $fn();
		    };
		  }
		  function e$lambda($a, $fn) {
		    return function () {
		      var tmp0_elvis_lhs = getKClassFromExpression($a.o3h_1).t5();
		      return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' ' + $a.p3h_1.q3h_1 + ' ' + $fn();
		    };
		  }
		  function d$lambda($a, $fn) {
		    return function () {
		      var tmp0_elvis_lhs = getKClassFromExpression($a.o3h_1).t5();
		      return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' ' + $a.p3h_1.q3h_1 + ' ' + $fn();
		    };
		  }
		  function Client() {
		    Client_instance = this;
		    Http.call(this, 'client');
		  }
		  var Client_instance;
		  function Client_getInstance() {
		    if (Client_instance == null)
		      new Client();
		    return Client_instance;
		  }
		  function Middleware() {
		    Middleware_instance = this;
		    Http.call(this, 'middleware');
		  }
		  var Middleware_instance;
		  function Middleware_getInstance() {
		    if (Middleware_instance == null)
		      new Middleware();
		    return Middleware_instance;
		  }
		  function Client_0() {
		    Client_instance_0 = this;
		    Ws.call(this, 'client');
		  }
		  var Client_instance_0;
		  function Client_getInstance_0() {
		    if (Client_instance_0 == null)
		      new Client_0();
		    return Client_instance_0;
		  }
		  function Middleware_0() {
		    Middleware_instance_0 = this;
		    Ws.call(this, 'middleware');
		  }
		  var Middleware_instance_0;
		  function Middleware_getInstance_0() {
		    if (Middleware_instance_0 == null)
		      new Middleware_0();
		    return Middleware_instance_0;
		  }
		  function EventParser() {
		    EventParser_instance = this;
		    Ws.call(this, 'event-parser');
		  }
		  var EventParser_instance;
		  function EventParser_getInstance() {
		    if (EventParser_instance == null)
		      new EventParser();
		    return EventParser_instance;
		  }
		  function EventEmit() {
		    EventEmit_instance = this;
		    Ws.call(this, 'event-emitter');
		  }
		  var EventEmit_instance;
		  function EventEmit_getInstance() {
		    if (EventEmit_instance == null)
		      new EventEmit();
		    return EventEmit_instance;
		  }
		  function Connection() {
		    Connection_instance = this;
		    Ws.call(this, 'connection');
		  }
		  var Connection_instance;
		  function Connection_getInstance() {
		    if (Connection_instance == null)
		      new Connection();
		    return Connection_instance;
		  }
		  function Client_1() {
		    Client_instance_1 = this;
		    Media.call(this, 'client');
		  }
		  var Client_instance_1;
		  function Client_getInstance_1() {
		    if (Client_instance_1 == null)
		      new Client_1();
		    return Client_instance_1;
		  }
		  function Middleware_1() {
		    Middleware_instance_1 = this;
		    Media.call(this, 'middleware');
		  }
		  var Middleware_instance_1;
		  function Middleware_getInstance_1() {
		    if (Middleware_instance_1 == null)
		      new Middleware_1();
		    return Middleware_instance_1;
		  }
		  function WebRtc() {
		    WebRtc_instance = this;
		    Media.call(this, 'webrtc');
		  }
		  var WebRtc_instance;
		  function WebRtc_getInstance() {
		    if (WebRtc_instance == null)
		      new WebRtc();
		    return WebRtc_instance;
		  }
		  function Session() {
		    Session_instance = this;
		    Api.call(this, 'session');
		  }
		  var Session_instance;
		  function Session_getInstance() {
		    if (Session_instance == null)
		      new Session();
		    return Session_instance;
		  }
		  function Voice() {
		    Voice_instance = this;
		    Api.call(this, 'voice');
		  }
		  var Voice_instance;
		  function Voice_getInstance() {
		    if (Voice_instance == null)
		      new Voice();
		    return Voice_instance;
		  }
		  function Chat() {
		    Chat_instance = this;
		    Api.call(this, 'chat');
		  }
		  var Chat_instance;
		  function Chat_getInstance() {
		    if (Chat_instance == null)
		      new Chat();
		    return Chat_instance;
		  }
		  function Push() {
		    Push_instance = this;
		    Api.call(this, 'push');
		  }
		  var Push_instance;
		  function Push_getInstance() {
		    if (Push_instance == null)
		      new Push();
		    return Push_instance;
		  }
		  function Conversation_0() {
		    Conversation_instance = this;
		    Api.call(this, 'conversation');
		  }
		  var Conversation_instance;
		  function Conversation_getInstance() {
		    if (Conversation_instance == null)
		      new Conversation_0();
		    return Conversation_instance;
		  }
		  function Action() {
		    Action_instance = this;
		    Store.call(this, 'action');
		  }
		  var Action_instance;
		  function Action_getInstance() {
		    if (Action_instance == null)
		      new Action();
		    return Action_instance;
		  }
		  function Callback() {
		    Callback_instance = this;
		    Store.call(this, 'callback');
		  }
		  var Callback_instance;
		  function Callback_getInstance() {
		    if (Callback_instance == null)
		      new Callback();
		    return Callback_instance;
		  }
		  function Call() {
		    Call_instance = this;
		    Reducer.call(this, 'call');
		  }
		  var Call_instance;
		  function Call_getInstance() {
		    if (Call_instance == null)
		      new Call();
		    return Call_instance;
		  }
		  function Invite() {
		    Invite_instance = this;
		    Reducer.call(this, 'invite');
		  }
		  var Invite_instance;
		  function Invite_getInstance() {
		    if (Invite_instance == null)
		      new Invite();
		    return Invite_instance;
		  }
		  function Session_0() {
		    Session_instance_0 = this;
		    Reducer.call(this, 'session');
		  }
		  var Session_instance_0;
		  function Session_getInstance_0() {
		    if (Session_instance_0 == null)
		      new Session_0();
		    return Session_instance_0;
		  }
		  function Config() {
		    Config_instance = this;
		    Reducer.call(this, 'config');
		  }
		  var Config_instance;
		  function Config_getInstance() {
		    if (Config_instance == null)
		      new Config();
		    return Config_instance;
		  }
		  function RemoteEvent() {
		    RemoteEvent_instance = this;
		    Reducer.call(this, 'remote-event');
		  }
		  var RemoteEvent_instance;
		  function RemoteEvent_getInstance() {
		    if (RemoteEvent_instance == null)
		      new RemoteEvent();
		    return RemoteEvent_instance;
		  }
		  function MediaEvent_0() {
		    MediaEvent_instance = this;
		    Reducer.call(this, 'media-event');
		  }
		  var MediaEvent_instance;
		  function MediaEvent_getInstance() {
		    if (MediaEvent_instance == null)
		      new MediaEvent_0();
		    return MediaEvent_instance;
		  }
		  function Http(tag) {
		    Topic.call(this, 'http', tag);
		  }
		  function Ws(tag) {
		    Topic.call(this, 'websocket', tag);
		  }
		  function Media(tag) {
		    Topic.call(this, 'media', tag);
		  }
		  function Api(tag) {
		    Topic.call(this, 'api', tag);
		  }
		  function Store(tag) {
		    Topic.call(this, 'store', tag);
		  }
		  function Reducer(tag) {
		    Topic.call(this, 'reducer', tag);
		  }
		  function Companion_153() {
		    Companion_instance_154 = this;
		    this.s3f_1 = listOf([Client_getInstance(), Middleware_getInstance()]);
		    this.t3f_1 = listOf([Client_getInstance_0(), Middleware_getInstance_0(), EventParser_getInstance(), EventEmit_getInstance(), Connection_getInstance()]);
		    this.u3f_1 = listOf([Client_getInstance_1(), Middleware_getInstance_1()]);
		    this.v3f_1 = listOf([Session_getInstance(), Voice_getInstance(), Chat_getInstance(), Conversation_getInstance(), Push_getInstance()]);
		    this.w3f_1 = listOf([Action_getInstance(), Callback_getInstance()]);
		    this.x3f_1 = listOf([Call_getInstance(), Invite_getInstance(), Session_getInstance_0(), Config_getInstance(), RemoteEvent_getInstance(), MediaEvent_getInstance()]);
		    this.y3f_1 = listOf([this.s3f_1, this.t3f_1, this.u3f_1, this.v3f_1, this.w3f_1, this.x3f_1]);
		    this.z3f_1 = listOf_0(WebRtc_getInstance());
		  }
		  var Companion_instance_154;
		  function Companion_getInstance_155() {
		    if (Companion_instance_154 == null)
		      new Companion_153();
		    return Companion_instance_154;
		  }
		  function Topic(name, tag) {
		    Companion_getInstance_155();
		    this.u3g_1 = name;
		    this.v3g_1 = tag;
		  }
		  function createVonageLogger(name, minLogLevel, topics, onLog) {
		    minLogLevel = minLogLevel === VOID ? null : minLogLevel;
		    topics = topics === VOID ? null : topics;
		    return new createVonageLogger$1(name, minLogLevel, topics, onLog);
		  }
		  function createVonageLogger$1($name, $minLogLevel, $topics, $onLog) {
		    this.w3h_1 = $onLog;
		    this.t3h_1 = $name;
		    var tmp = this;
		    tmp.u3h_1 = $minLogLevel == null ? Companion_getInstance_137().r2v_1 : $minLogLevel;
		    var tmp_0 = this;
		    tmp_0.v3h_1 = $topics == null ? flatten(Companion_getInstance_155().y3f_1) : $topics;
		  }
		  protoOf(createVonageLogger$1).i3g = function () {
		    return this.u3h_1;
		  };
		  protoOf(createVonageLogger$1).a3g = function () {
		    return this.v3h_1;
		  };
		  protoOf(createVonageLogger$1).j3g = function (logLevel, topic, message, throwable) {
		    return this.w3h_1(logLevel, topic, message, throwable);
		  };
		  function HTTPClientLogger$request$lambda($verb, $url, $headers, $body) {
		    return function () {
		      return 'request() ' + $verb + ' ' + $url + '\nheaders:' + maskAuthHeader($headers) + '\nbody:' + $body;
		    };
		  }
		  function HTTPClientLogger(client, logger) {
		    this.x3h_1 = client;
		    this.y3h_1 = logger.v1e(Client_getInstance());
		  }
		  protoOf(HTTPClientLogger).z3h = function (verb, url, headers, body, callback) {
		    this.y3h_1.k3h(VOID, HTTPClientLogger$request$lambda(verb, url, headers, body));
		    this.x3h_1.z3h(verb, url, headers, body, callback);
		  };
		  function SocketClientLogger$_set_delegate_$lambda_2humt9($value) {
		    return function () {
		      return 'setSocketClientDelegate() params: ' + $value;
		    };
		  }
		  function SocketClientLogger$emit$lambda($type, $msg) {
		    return function () {
		      return 'emit() ' + $type + ' ' + $msg;
		    };
		  }
		  function SocketClientLogger$connect$lambda($sessionId, $host, $path, $reconnectionAttempts, $reconnectionDelay, $randomizationFactor) {
		    return function () {
		      return 'connect() session_id:' + $sessionId + ' host: ' + $host + ' path: ' + $path + ' reconnectionAttempts: ' + toString($reconnectionAttempts) + ' reconnectionDelay: ' + toString($reconnectionDelay) + ' randomizationFactor: ' + toString($randomizationFactor) + ' ';
		    };
		  }
		  function SocketClientLogger$disconnect$lambda() {
		    return 'disconnect()';
		  }
		  function SocketClientLogger$setConnectParamsSocketConfig$lambda() {
		    return 'setConnectParamsSocketConfig() sessionId: <sessionId>, token: <token>';
		  }
		  function SocketClientLogger$setSocketSessionId$lambda() {
		    return 'setSocketSessionId() sessionId: <sessionId>';
		  }
		  function SocketClientLogger$startVerifyResponseTimer$lambda($milliseconds) {
		    return function () {
		      return 'startVerifyResponseTimer() ' + toString($milliseconds);
		    };
		  }
		  function SocketClientLogger(client, logger) {
		    this.b3i_1 = client;
		    this.c3i_1 = logger.v1e(Client_getInstance_0());
		  }
		  protoOf(SocketClientLogger).d3i = function (value) {
		    this.c3i_1.k3h(VOID, SocketClientLogger$_set_delegate_$lambda_2humt9(value));
		    this.b3i_1.d3i(value == null ? value : new SocketClientDelegateLogger(value, this.c3i_1));
		  };
		  protoOf(SocketClientLogger).e3i = function (type, msg, callback) {
		    this.c3i_1.k3h(VOID, SocketClientLogger$emit$lambda(type, msg));
		    this.b3i_1.e3i(type, msg, callback);
		  };
		  protoOf(SocketClientLogger).f3i = function (host, path, reconnectionAttempts, reconnectionDelay, randomizationFactor, token, sessionId, query) {
		    this.c3i_1.k3h(VOID, SocketClientLogger$connect$lambda(sessionId, host, path, reconnectionAttempts, reconnectionDelay, randomizationFactor));
		    this.b3i_1.f3i(host, path, reconnectionAttempts, reconnectionDelay, randomizationFactor, token, sessionId, query);
		  };
		  protoOf(SocketClientLogger).g3i = function () {
		    this.c3i_1.k3h(VOID, SocketClientLogger$disconnect$lambda);
		    this.b3i_1.g3i();
		  };
		  protoOf(SocketClientLogger).h3i = function (sessionId, token) {
		    this.c3i_1.k3h(VOID, SocketClientLogger$setConnectParamsSocketConfig$lambda);
		    this.b3i_1.h3i(sessionId, token);
		  };
		  protoOf(SocketClientLogger).i3i = function (sessionId) {
		    this.c3i_1.k3h(VOID, SocketClientLogger$setSocketSessionId$lambda);
		    this.b3i_1.i3i(sessionId);
		  };
		  protoOf(SocketClientLogger).j3i = function (milliseconds, callback) {
		    this.c3i_1.k3h(VOID, SocketClientLogger$startVerifyResponseTimer$lambda(milliseconds));
		    this.b3i_1.j3i(milliseconds, callback);
		  };
		  function MediaClientLogger$_set_delegate_$lambda_uk0t84($value) {
		    return function () {
		      return 'setMediaClientDelegate() params: ' + $value;
		    };
		  }
		  function MediaClientLogger$enableMediaOutbound$lambda() {
		    return 'enableMediaOutbound()';
		  }
		  function MediaClientLogger$enableMediaInbound$lambda($offerSDP) {
		    return function () {
		      return 'enableMediaInbound() ' + $offerSDP;
		    };
		  }
		  function MediaClientLogger$processAnswer$lambda($id) {
		    return function () {
		      return 'processAnswer() ' + $id;
		    };
		  }
		  function MediaClientLogger$disableMedia$lambda($id) {
		    return function () {
		      return 'disableMedia() ' + $id;
		    };
		  }
		  function MediaClientLogger$mute$lambda($id) {
		    return function () {
		      return 'mute() ' + $id;
		    };
		  }
		  function MediaClientLogger$unmute$lambda($id) {
		    return function () {
		      return 'unmute() ' + $id;
		    };
		  }
		  function MediaClientLogger$enableRtcStatsCollection$lambda($id) {
		    return function () {
		      return 'enableRtcStatsCollection() ' + $id;
		    };
		  }
		  function MediaClientLogger$enableNoiseSuppression$lambda($id) {
		    return function () {
		      return 'enableNoiseSuppression() ' + $id;
		    };
		  }
		  function MediaClientLogger$disableNoiseSuppression$lambda($id) {
		    return function () {
		      return 'disableNoiseSuppression() ' + $id;
		    };
		  }
		  function MediaClientLogger$getMediaConnectionState$lambda($id, $state) {
		    return function () {
		      return 'getMediaConnectionState() ' + $id + ': ' + $state;
		    };
		  }
		  function MediaClientLogger(client, logger) {
		    this.k3i_1 = client;
		    this.l3i_1 = logger.v1e(Client_getInstance_1());
		  }
		  protoOf(MediaClientLogger).m3i = function (value) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$_set_delegate_$lambda_uk0t84(value));
		    this.k3i_1.m3i(value == null ? value : new MediaClientDelegateLogger(value, this.l3i_1));
		  };
		  protoOf(MediaClientLogger).n3i = function () {
		    return this.k3i_1.n3i();
		  };
		  protoOf(MediaClientLogger).o3i = function (closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$enableMediaOutbound$lambda);
		    this.k3i_1.o3i(closure);
		  };
		  protoOf(MediaClientLogger).p3i = function (rtcId, offerSDP, closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$enableMediaInbound$lambda(offerSDP));
		    this.k3i_1.p3i(rtcId, offerSDP, closure);
		  };
		  protoOf(MediaClientLogger).q3i = function (id, sdp, closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$processAnswer$lambda(id));
		    this.k3i_1.q3i(id, sdp, closure);
		  };
		  protoOf(MediaClientLogger).r3i = function (id, closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$disableMedia$lambda(id));
		    this.k3i_1.r3i(id, closure);
		  };
		  protoOf(MediaClientLogger).s3i = function (id, closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$mute$lambda(id));
		    this.k3i_1.s3i(id, closure);
		  };
		  protoOf(MediaClientLogger).t3i = function (id, closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$unmute$lambda(id));
		    this.k3i_1.t3i(id, closure);
		  };
		  protoOf(MediaClientLogger).u3i = function (id, interval, closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$enableRtcStatsCollection$lambda(id));
		    this.k3i_1.u3i(id, interval, closure);
		  };
		  protoOf(MediaClientLogger).v3i = function (id, closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$enableNoiseSuppression$lambda(id));
		    this.k3i_1.v3i(id, closure);
		  };
		  protoOf(MediaClientLogger).w3i = function (id, closure) {
		    this.l3i_1.k3h(VOID, MediaClientLogger$disableNoiseSuppression$lambda(id));
		    this.k3i_1.w3i(id, closure);
		  };
		  protoOf(MediaClientLogger).x3i = function (id) {
		    var state = this.k3i_1.x3i(id);
		    this.l3i_1.k3h(VOID, MediaClientLogger$getMediaConnectionState$lambda(id, state));
		    return state;
		  };
		  function SessionAPILogger$createSession$lambda($sessionId) {
		    return function () {
		      return 'createSession() params: <token>, ' + $sessionId;
		    };
		  }
		  function SessionAPILogger$deleteSession$lambda() {
		    return 'deleteSession()';
		  }
		  function SessionAPILogger$refreshSession$lambda() {
		    return 'refreshSession() params: <token>';
		  }
		  function SessionAPILogger$setSessionListener$lambda($listener) {
		    return function () {
		      return 'setSessionListener() params: ' + $listener;
		    };
		  }
		  function SessionAPILogger(api, logger) {
		    this.y3i_1 = api;
		    this.z3i_1 = logger.v1e(Session_getInstance());
		  }
		  protoOf(SessionAPILogger).t1f = function (token, sessionId, callback) {
		    this.z3i_1.k3h(VOID, SessionAPILogger$createSession$lambda(sessionId));
		    this.y3i_1.t1f(token, sessionId, callbackLogger2(callback, this.z3i_1, 'createSession'));
		  };
		  protoOf(SessionAPILogger).u1f = function (callback) {
		    this.z3i_1.k3h(VOID, SessionAPILogger$deleteSession$lambda);
		    this.y3i_1.u1f(callbackLogger1(callback, this.z3i_1, 'deleteSession'));
		  };
		  protoOf(SessionAPILogger).v1f = function (token, callback) {
		    this.z3i_1.k3h(VOID, SessionAPILogger$refreshSession$lambda);
		    this.y3i_1.v1f(token, callbackLogger1(callback, this.z3i_1, 'refreshSession'));
		  };
		  protoOf(SessionAPILogger).q1d = function (listener) {
		    this.z3i_1.k3h(VOID, SessionAPILogger$setSessionListener$lambda(listener));
		    this.y3i_1.q1d(new SessionAPIListenerLogger(listener, this.z3i_1));
		  };
		  function VoiceAPILogger$serverCall$lambda($tag, $context) {
		    return function () {
		      return $tag + ' params: ' + $context;
		    };
		  }
		  function VoiceAPILogger$reconnectCall$lambda($callId) {
		    return function () {
		      return 'reconnectCall() params: ' + $callId;
		    };
		  }
		  function VoiceAPILogger$getLeg$lambda($legId) {
		    return function () {
		      return 'getLeg() params: ' + $legId;
		    };
		  }
		  function VoiceAPILogger$getCallLegs$lambda($callId, $parameters) {
		    return function () {
		      return 'getCallLegs() params: ' + $callId + ', ' + $parameters;
		    };
		  }
		  function VoiceAPILogger$rejectCall$lambda($callId) {
		    return function () {
		      return 'rejectCall() params: ' + $callId;
		    };
		  }
		  function VoiceAPILogger$answerCall$lambda($callId) {
		    return function () {
		      return 'answerCall() params: ' + $callId;
		    };
		  }
		  function VoiceAPILogger$hangupCall$lambda($callId, $reasonText, $reasonCode) {
		    return function () {
		      return 'hangupCall() params: ' + $callId + ', ' + $reasonText + ', ' + $reasonCode;
		    };
		  }
		  function VoiceAPILogger$mute$lambda($callId) {
		    return function () {
		      return 'mute() params: ' + $callId;
		    };
		  }
		  function VoiceAPILogger$unmute$lambda($callId) {
		    return function () {
		      return 'unmute() params: ' + $callId;
		    };
		  }
		  function VoiceAPILogger$enableEarmuff$lambda($callId) {
		    return function () {
		      return 'enableEarmuff() params: ' + $callId;
		    };
		  }
		  function VoiceAPILogger$disableEarmuff$lambda($callId) {
		    return function () {
		      return 'disableEarmuff() params: ' + $callId;
		    };
		  }
		  function VoiceAPILogger$sendDTMF$lambda($callId, $digits) {
		    return function () {
		      return 'sendDTMF() params: ' + $callId + ', ' + $digits;
		    };
		  }
		  function VoiceAPILogger$say$lambda($callId, $text, $level, $loop, $queue, $voiceName, $ssml) {
		    return function () {
		      return 'say() params: ' + $callId + ', ' + $text + ', ' + $level + ', ' + $loop + ', ' + $queue + ', ' + $voiceName + ', ' + $ssml;
		    };
		  }
		  function VoiceAPILogger$setVoiceListener$lambda($listener) {
		    return function () {
		      return 'setVoiceListener() params: ' + $listener;
		    };
		  }
		  function VoiceAPILogger(api, logger) {
		    this.a3j_1 = api;
		    this.b3j_1 = logger.v1e(Voice_getInstance());
		  }
		  protoOf(VoiceAPILogger).v1d = function (context, callback) {
		    var tag = 'serverCall()';
		    this.b3j_1.k3h(VOID, VoiceAPILogger$serverCall$lambda(tag, context));
		    this.a3j_1.v1d(context, callbackLogger2(callback, this.b3j_1, tag));
		  };
		  protoOf(VoiceAPILogger).w1d = function (callId, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$reconnectCall$lambda(callId));
		    this.a3j_1.w1d(callId, callbackLogger1(callback, this.b3j_1, 'reconnectCall'));
		  };
		  protoOf(VoiceAPILogger).x1d = function (legId, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$getLeg$lambda(legId));
		    this.a3j_1.x1d(legId, callbackLogger2(callback, this.b3j_1, 'getLeg'));
		  };
		  protoOf(VoiceAPILogger).y1d = function (callId, parameters, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$getCallLegs$lambda(callId, parameters));
		    this.a3j_1.y1d(callId, parameters, callbackLogger2(callback, this.b3j_1, 'getCallLegs'));
		  };
		  protoOf(VoiceAPILogger).z1d = function (callId, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$rejectCall$lambda(callId));
		    this.a3j_1.z1d(callId, callbackLogger1(callback, this.b3j_1, 'rejectCall'));
		  };
		  protoOf(VoiceAPILogger).a1e = function (callId, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$answerCall$lambda(callId));
		    this.a3j_1.a1e(callId, callbackLogger1(callback, this.b3j_1, 'answerCall'));
		  };
		  protoOf(VoiceAPILogger).b1e = function (callId, reasonText, reasonCode, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$hangupCall$lambda(callId, reasonText, reasonCode));
		    this.a3j_1.b1e(callId, reasonText, reasonCode, callbackLogger1(callback, this.b3j_1, 'hangupCall'));
		  };
		  protoOf(VoiceAPILogger).c1e = function (callId, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$mute$lambda(callId));
		    this.a3j_1.c1e(callId, callbackLogger1(callback, this.b3j_1, 'mute'));
		  };
		  protoOf(VoiceAPILogger).d1e = function (callId, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$unmute$lambda(callId));
		    this.a3j_1.d1e(callId, callbackLogger1(callback, this.b3j_1, 'unmute'));
		  };
		  protoOf(VoiceAPILogger).e1e = function (callId, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$enableEarmuff$lambda(callId));
		    this.a3j_1.e1e(callId, callbackLogger1(callback, this.b3j_1, 'enableEarmuff'));
		  };
		  protoOf(VoiceAPILogger).f1e = function (callId, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$disableEarmuff$lambda(callId));
		    this.a3j_1.f1e(callId, callbackLogger1(callback, this.b3j_1, 'disableEarmuff'));
		  };
		  protoOf(VoiceAPILogger).g1e = function (callId, digits, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$sendDTMF$lambda(callId, digits));
		    this.a3j_1.g1e(callId, digits, callbackLogger1(callback, this.b3j_1, 'sendDTMF'));
		  };
		  protoOf(VoiceAPILogger).h1e = function (callId, text, level, loop, queue, voiceName, ssml, callback) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$say$lambda(callId, text, level, loop, queue, voiceName, ssml));
		    this.a3j_1.h1e(callId, text, level, loop, queue, voiceName, ssml, callbackLogger1(callback, this.b3j_1, 'say'));
		  };
		  protoOf(VoiceAPILogger).u1d = function (listener) {
		    this.b3j_1.k3h(VOID, VoiceAPILogger$setVoiceListener$lambda(listener));
		    var tmp;
		    if (listener == null) {
		      tmp = null;
		    } else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      this.a3j_1.u1d(new VoiceAPIListenerLogger(listener, this.b3j_1));
		      tmp = Unit_instance;
		    }
		    if (tmp == null) {
		      this.a3j_1.u1d(listener);
		    }
		  };
		  function PushAPILogger(api, logger) {
		    this.c3j_1 = api;
		    this.d3j_1 = logger.v1e(Push_getInstance());
		  }
		  function ConversationAPILogger$getConversation$lambda($conversationIdOrName) {
		    return function () {
		      return 'getConversation() params: ' + $conversationIdOrName;
		    };
		  }
		  function ConversationAPILogger$getUser$lambda($userIdOrName) {
		    return function () {
		      return 'getUser() params: ' + $userIdOrName;
		    };
		  }
		  function ConversationAPILogger(api, logger) {
		    this.e3j_1 = api;
		    this.f3j_1 = logger.v1e(Conversation_getInstance());
		  }
		  protoOf(ConversationAPILogger).x1f = function (conversationIdOrName, callback) {
		    this.f3j_1.k3h(VOID, ConversationAPILogger$getConversation$lambda(conversationIdOrName));
		    this.e3j_1.x1f(conversationIdOrName, callbackLogger2(callback, this.f3j_1, 'getConversation'));
		  };
		  protoOf(ConversationAPILogger).y1f = function (userIdOrName, callback) {
		    this.f3j_1.k3h(VOID, ConversationAPILogger$getUser$lambda(userIdOrName));
		    this.e3j_1.y1f(userIdOrName, callbackLogger2(callback, this.f3j_1, 'getUser'));
		  };
		  function ChatAPILogger$_set_chatListener_$lambda_wbqlbi($value) {
		    return function () {
		      return 'setChatListener() params: ' + $value;
		    };
		  }
		  function ChatAPILogger$createConversation$ref($boundThis) {
		    var l = function (p0, p1) {
		      $boundThis.e1f(p0, p1);
		      return Unit_instance;
		    };
		    l.callableName = 'createConversation';
		    return l;
		  }
		  function ChatAPILogger$createConversation$lambda(this$0, $parameters) {
		    return function () {
		      return '' + ChatAPILogger$createConversation$ref(this$0) + '() params: ' + $parameters;
		    };
		  }
		  function ChatAPILogger$joinConversation$lambda($cid) {
		    return function () {
		      return 'joinConversation() params: ' + $cid;
		    };
		  }
		  function ChatAPILogger$inviteToConversation$lambda($cid, $username) {
		    return function () {
		      return 'inviteToConversation() params: ' + $cid + ', ' + $username;
		    };
		  }
		  function ChatAPILogger$leaveConversation$lambda($cid) {
		    return function () {
		      return 'leaveConversation() params: ' + $cid;
		    };
		  }
		  function ChatAPILogger$deleteConversation$lambda($cid) {
		    return function () {
		      return 'deleteConversation() params: ' + $cid;
		    };
		  }
		  function ChatAPILogger$getConversations$lambda($parameters) {
		    return function () {
		      return 'getConversations() params: ' + $parameters;
		    };
		  }
		  function ChatAPILogger$getConversationMembers$lambda($cid, $parameters) {
		    return function () {
		      return 'getConversationMembers() params: ' + $cid + ', ' + $parameters;
		    };
		  }
		  function ChatAPILogger$getConversationEvents$lambda($cid, $parameters, $filterGroup, $filterGroupVersion) {
		    return function () {
		      return 'getConversationEvents() params: ' + $cid + ', ' + $parameters + ', ' + $filterGroup + ', ' + $filterGroupVersion;
		    };
		  }
		  function ChatAPILogger$getConversationMember$lambda($cid, $mid) {
		    return function () {
		      return 'getConversationMember() params: ' + $cid + ', ' + $mid;
		    };
		  }
		  function ChatAPILogger$sendMessageEvent$lambda($cid, $text, $imageUrl, $videoUrl, $audioUrl, $fileUrl, $vCardUrl, $customBody, $location, $template) {
		    return function () {
		      return 'sendMessageEvent() params: ' + $cid + ', ' + $text + ', ' + $imageUrl + ', ' + $videoUrl + ', ' + $audioUrl + ', ' + $fileUrl + ', ' + $vCardUrl + ', ' + $customBody + ', ' + $location + ', ' + $template;
		    };
		  }
		  function ChatAPILogger$sendEphemeralEvent$lambda($cid, $customData) {
		    return function () {
		      return 'sendEphemeralEvent() params: ' + $cid + ', ' + $customData;
		    };
		  }
		  function ChatAPILogger$sendCustomEvent$lambda($cid, $customData, $eventType) {
		    return function () {
		      return 'sendCustomEvent() params: ' + $cid + ', ' + $customData + ' ' + $eventType;
		    };
		  }
		  function ChatAPILogger$deleteEvent$lambda($id, $cid) {
		    return function () {
		      return 'deleteEvent() params: ' + $id + ', ' + $cid;
		    };
		  }
		  function ChatAPILogger$sendMessageSeenEvent$lambda($id, $cid) {
		    return function () {
		      return 'sendMessageSeenEvent() params: ' + $id + ', ' + $cid;
		    };
		  }
		  function ChatAPILogger$updateConversation$lambda($conversationId, $parameters) {
		    return function () {
		      return 'updateConversation() params: ' + $conversationId + ', ' + $parameters;
		    };
		  }
		  function ChatAPILogger(api, logger) {
		    this.g3j_1 = api;
		    this.h3j_1 = logger.v1e(Chat_getInstance());
		  }
		  protoOf(ChatAPILogger).r1d = function (value) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$_set_chatListener_$lambda_wbqlbi(value));
		    this.g3j_1.r1d(value == null ? value : new ChatAPIListenerLogger(value, this.h3j_1));
		  };
		  protoOf(ChatAPILogger).e1f = function (parameters, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$createConversation$lambda(this, parameters));
		    this.g3j_1.e1f(parameters, callbackLogger2(callback, this.h3j_1, 'createConversation'));
		  };
		  protoOf(ChatAPILogger).m1f = function (cid, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$joinConversation$lambda(cid));
		    this.g3j_1.m1f(cid, callbackLogger2(callback, this.h3j_1, 'joinConversation'));
		  };
		  protoOf(ChatAPILogger).l1f = function (cid, username, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$inviteToConversation$lambda(cid, username));
		    this.g3j_1.l1f(cid, username, callbackLogger2(callback, this.h3j_1, 'inviteToConversation'));
		  };
		  protoOf(ChatAPILogger).n1f = function (cid, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$leaveConversation$lambda(cid));
		    this.g3j_1.n1f(cid, callbackLogger1(callback, this.h3j_1, 'leaveConversation'));
		  };
		  protoOf(ChatAPILogger).f1f = function (cid, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$deleteConversation$lambda(cid));
		    this.g3j_1.f1f(cid, callbackLogger1(callback, this.h3j_1, 'deleteConversation'));
		  };
		  protoOf(ChatAPILogger).k1f = function (parameters, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$getConversations$lambda(parameters));
		    this.g3j_1.k1f(parameters, callbackLogger2(callback, this.h3j_1, 'getConversations'));
		  };
		  protoOf(ChatAPILogger).j1f = function (cid, parameters, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$getConversationMembers$lambda(cid, parameters));
		    this.g3j_1.j1f(cid, parameters, callbackLogger2(callback, this.h3j_1, 'getConversationMembers'));
		  };
		  protoOf(ChatAPILogger).h1f = function (cid, parameters, filterGroup, filterGroupVersion, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$getConversationEvents$lambda(cid, parameters, filterGroup, filterGroupVersion));
		    this.g3j_1.h1f(cid, parameters, filterGroup, filterGroupVersion, callbackLogger2(callback, this.h3j_1, 'getConversationEvents'));
		  };
		  protoOf(ChatAPILogger).i1f = function (cid, mid, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$getConversationMember$lambda(cid, mid));
		    this.g3j_1.i1f(cid, mid, callbackLogger2(callback, this.h3j_1, 'getConversationMember'));
		  };
		  protoOf(ChatAPILogger).q1f = function (cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$sendMessageEvent$lambda(cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template));
		    this.g3j_1.q1f(cid, text, imageUrl, videoUrl, audioUrl, fileUrl, vCardUrl, customBody, location, template, callbackLogger2(callback, this.h3j_1, 'sendMessageEvent'));
		  };
		  protoOf(ChatAPILogger).p1f = function (cid, customData, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$sendEphemeralEvent$lambda(cid, customData));
		    this.g3j_1.p1f(cid, customData, callbackLogger2(callback, this.h3j_1, 'sendEphemeralEvent'));
		  };
		  protoOf(ChatAPILogger).o1f = function (cid, eventType, customData, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$sendCustomEvent$lambda(cid, customData, eventType));
		    this.g3j_1.o1f(cid, eventType, customData, callbackLogger2(callback, this.h3j_1, 'sendCustomEvent'));
		  };
		  protoOf(ChatAPILogger).g1f = function (id, cid, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$deleteEvent$lambda(id, cid));
		    this.g3j_1.g1f(id, cid, callbackLogger1(callback, this.h3j_1, 'deleteEvent'));
		  };
		  protoOf(ChatAPILogger).r1f = function (id, cid, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$sendMessageSeenEvent$lambda(id, cid));
		    this.g3j_1.r1f(id, cid, callbackLogger2(callback, this.h3j_1, 'sendMessageSeenEvent'));
		  };
		  protoOf(ChatAPILogger).s1f = function (conversationId, parameters, callback) {
		    this.h3j_1.k3h(VOID, ChatAPILogger$updateConversation$lambda(conversationId, parameters));
		    this.g3j_1.s1f(conversationId, parameters, callbackLogger2(callback, this.h3j_1, 'updateConversation'));
		  };
		  function SocketClientDelegateLogger$didReceiveNewSocketEvent$lambda($event) {
		    return function () {
		      return 'didReceiveNewSocketEvent() params: ' + $event.g2n_1;
		    };
		  }
		  function SocketClientDelegateLogger$didReceiveNewSocketConnectionStatusEvent$lambda($type, $reason, $timestamp, $retryNumber) {
		    return function () {
		      var tmp0_safe_receiver = $reason;
		      return 'didReceiveNewSocketConnectionStatusEvent() params: ' + $type.h8_1 + ' ' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8_1) + ' ' + toString($timestamp) + ' ' + $retryNumber;
		    };
		  }
		  function SocketClientDelegateLogger(delegate, logger) {
		    this.i3j_1 = delegate;
		    this.j3j_1 = logger;
		  }
		  protoOf(SocketClientDelegateLogger).k3j = function (event) {
		    this.j3j_1.g3h(VOID, SocketClientDelegateLogger$didReceiveNewSocketEvent$lambda(event));
		    this.i3j_1.k3j(event);
		  };
		  protoOf(SocketClientDelegateLogger).l3j = function (type, reason, timestamp, retryNumber) {
		    this.j3j_1.i3h(VOID, SocketClientDelegateLogger$didReceiveNewSocketConnectionStatusEvent$lambda(type, reason, timestamp, retryNumber));
		    this.i3j_1.l3j(type, reason, timestamp, retryNumber);
		  };
		  function MediaClientDelegateLogger$onRtcStats$lambda($id, $rtcStats) {
		    return function () {
		      return 'onRtcStats() params: ' + $id + ' ' + $rtcStats;
		    };
		  }
		  function MediaClientDelegateLogger$onConnectionChange$lambda($id, $state) {
		    return function () {
		      return 'onConnectionChange() params: ' + $id + ' ' + $state.h8_1;
		    };
		  }
		  function MediaClientDelegateLogger$onMediaError$lambda($id, $error) {
		    return function () {
		      return 'onMediaError() params: ' + $id + ' ' + $error.f2x_1;
		    };
		  }
		  function MediaClientDelegateLogger(delegate, logger) {
		    this.m3j_1 = delegate;
		    this.n3j_1 = logger;
		  }
		  protoOf(MediaClientDelegateLogger).o3j = function (id, rtcStats) {
		    this.n3j_1.g3h(VOID, MediaClientDelegateLogger$onRtcStats$lambda(id, rtcStats));
		    this.m3j_1.o3j(id, rtcStats);
		  };
		  protoOf(MediaClientDelegateLogger).p3j = function (id, state) {
		    this.n3j_1.i3h(VOID, MediaClientDelegateLogger$onConnectionChange$lambda(id, state));
		    this.m3j_1.p3j(id, state);
		  };
		  protoOf(MediaClientDelegateLogger).q3j = function (id, error) {
		    this.n3j_1.i3h(VOID, MediaClientDelegateLogger$onMediaError$lambda(id, error));
		    this.m3j_1.q3j(id, error);
		  };
		  function SessionAPIListenerLogger$onReconnecting$lambda() {
		    return 'onReconnecting()';
		  }
		  function SessionAPIListenerLogger$onReconnection$lambda() {
		    return 'onReconnection()';
		  }
		  function SessionAPIListenerLogger$onSessionError$lambda($reason) {
		    return function () {
		      return 'onSessionError() params: ' + $reason.h8_1;
		    };
		  }
		  function SessionAPIListenerLogger(listener, logger) {
		    this.r3j_1 = listener;
		    this.s3j_1 = logger;
		  }
		  protoOf(SessionAPIListenerLogger).s38 = function () {
		    this.s3j_1.k3h(VOID, SessionAPIListenerLogger$onReconnecting$lambda);
		    this.r3j_1.s38();
		  };
		  protoOf(SessionAPIListenerLogger).t38 = function () {
		    this.s3j_1.k3h(VOID, SessionAPIListenerLogger$onReconnection$lambda);
		    this.r3j_1.t38();
		  };
		  protoOf(SessionAPIListenerLogger).u38 = function (reason) {
		    this.s3j_1.n3h(VOID, SessionAPIListenerLogger$onSessionError$lambda(reason));
		    this.r3j_1.u38(reason);
		  };
		  function VoiceAPIListenerLogger$onCallInvite$lambda($callId, $from, $channelType) {
		    return function () {
		      return 'onCallInvite() params: ' + $callId + ', ' + $from + ', ' + $channelType;
		    };
		  }
		  function VoiceAPIListenerLogger$onCallInviteCancel$lambda($callId, $reason) {
		    return function () {
		      return 'onCallInviteCancel() params: ' + $callId + ', ' + $reason;
		    };
		  }
		  function VoiceAPIListenerLogger$onCallTransfer$lambda($callId, $conversationId) {
		    return function () {
		      return 'onCallTransfer() params: ' + $callId + ', ' + $conversationId;
		    };
		  }
		  function VoiceAPIListenerLogger$onMuteUpdate$lambda($callId, $legId, $isMuted) {
		    return function () {
		      return 'onMuteUpdate() params: ' + $callId + ', ' + $legId + ', ' + $isMuted;
		    };
		  }
		  function VoiceAPIListenerLogger$onEarmuffUpdate$lambda($callId, $legId, $earmuffStatus) {
		    return function () {
		      return 'onEarmuffUpdate() params: ' + $callId + ', ' + $legId + ', ' + $earmuffStatus;
		    };
		  }
		  function VoiceAPIListenerLogger$onDTMFUpdate$lambda($callId, $legId, $digits) {
		    return function () {
		      return 'onDTMFUpdate() params: ' + $callId + ', ' + $legId + ', ' + $digits;
		    };
		  }
		  function VoiceAPIListenerLogger$onCallHangup$lambda($callId, $callQuality, $reason) {
		    return function () {
		      return 'onCallHangup() params: ' + $callId + ', ' + $callQuality + ', ' + $reason;
		    };
		  }
		  function VoiceAPIListenerLogger$onLegStatusUpdate$lambda($callId, $legId, $status) {
		    return function () {
		      return 'onLegStatusUpdate() params: ' + $callId + ', ' + $legId + ', ' + $status;
		    };
		  }
		  function VoiceAPIListenerLogger$onCallMediaReconnecting$lambda($callId) {
		    return function () {
		      return 'onCallMediaReconnecting() params: ' + $callId;
		    };
		  }
		  function VoiceAPIListenerLogger$onCallMediaReconnection$lambda($callId) {
		    return function () {
		      return 'onCallMediaReconnection() params: ' + $callId;
		    };
		  }
		  function VoiceAPIListenerLogger$onCallMediaDisconnect$lambda($callId, $reason) {
		    return function () {
		      return 'onCallMediaDisconnect() params: ' + $callId + ', ' + $reason;
		    };
		  }
		  function VoiceAPIListenerLogger$onRtcStatsUpdate$lambda($legId) {
		    return function () {
		      return 'onRtcStatsUpdate() params: ' + $legId + ' <rtcStats>';
		    };
		  }
		  function VoiceAPIListenerLogger$onRtcStatsUpdate$lambda_0($legId, $rtcStats) {
		    return function () {
		      return 'onRtcStatsUpdate() params: ' + $legId + ' ' + $rtcStats;
		    };
		  }
		  function VoiceAPIListenerLogger$onCallMediaError$lambda($callId, $error) {
		    return function () {
		      return 'onCallMediaError() params: ' + $callId + ', ' + $error;
		    };
		  }
		  function VoiceAPIListenerLogger(listener, logger) {
		    this.t3j_1 = listener;
		    this.u3j_1 = logger;
		  }
		  protoOf(VoiceAPIListenerLogger).y38 = function (callId, from, channelType) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onCallInvite$lambda(callId, from, channelType));
		    this.t3j_1.y38(callId, from, channelType);
		  };
		  protoOf(VoiceAPIListenerLogger).z38 = function (callId, reason) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onCallInviteCancel$lambda(callId, reason));
		    this.t3j_1.z38(callId, reason);
		  };
		  protoOf(VoiceAPIListenerLogger).a39 = function (callId, conversationId) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onCallTransfer$lambda(callId, conversationId));
		    this.t3j_1.a39(callId, conversationId);
		  };
		  protoOf(VoiceAPIListenerLogger).b39 = function (callId, legId, isMuted) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onMuteUpdate$lambda(callId, legId, isMuted));
		    this.t3j_1.b39(callId, legId, isMuted);
		  };
		  protoOf(VoiceAPIListenerLogger).c39 = function (callId, legId, earmuffStatus) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onEarmuffUpdate$lambda(callId, legId, earmuffStatus));
		    this.t3j_1.c39(callId, legId, earmuffStatus);
		  };
		  protoOf(VoiceAPIListenerLogger).d39 = function (callId, legId, digits) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onDTMFUpdate$lambda(callId, legId, digits));
		    this.t3j_1.d39(callId, legId, digits);
		  };
		  protoOf(VoiceAPIListenerLogger).e39 = function (callId, callQuality, reason) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onCallHangup$lambda(callId, callQuality, reason));
		    this.t3j_1.e39(callId, callQuality, reason);
		  };
		  protoOf(VoiceAPIListenerLogger).f39 = function (callId, legId, status) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onLegStatusUpdate$lambda(callId, legId, status));
		    this.t3j_1.f39(callId, legId, status);
		  };
		  protoOf(VoiceAPIListenerLogger).g39 = function (callId) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onCallMediaReconnecting$lambda(callId));
		    this.t3j_1.g39(callId);
		  };
		  protoOf(VoiceAPIListenerLogger).h39 = function (callId) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onCallMediaReconnection$lambda(callId));
		    this.t3j_1.h39(callId);
		  };
		  protoOf(VoiceAPIListenerLogger).i39 = function (callId, reason) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onCallMediaDisconnect$lambda(callId, reason));
		    this.t3j_1.i39(callId, reason);
		  };
		  protoOf(VoiceAPIListenerLogger).j39 = function (rtcStats, legId) {
		    this.u3j_1.k3h(VOID, VoiceAPIListenerLogger$onRtcStatsUpdate$lambda(legId));
		    this.u3j_1.g3h(VOID, VoiceAPIListenerLogger$onRtcStatsUpdate$lambda_0(legId, rtcStats));
		    this.t3j_1.j39(rtcStats, legId);
		  };
		  protoOf(VoiceAPIListenerLogger).k39 = function (callId, error) {
		    this.u3j_1.n3h(VOID, VoiceAPIListenerLogger$onCallMediaError$lambda(callId, error));
		    this.t3j_1.k39(callId, error);
		  };
		  function ChatAPIListenerLogger$onConversationEvent$lambda($event) {
		    return function () {
		      return 'onConversationEvent() params: ' + $event;
		    };
		  }
		  function ChatAPIListenerLogger(listener, logger) {
		    this.v3j_1 = listener;
		    this.w3j_1 = logger;
		  }
		  protoOf(ChatAPIListenerLogger).q2t = function (event) {
		    this.w3j_1.k3h(VOID, ChatAPIListenerLogger$onConversationEvent$lambda(event));
		    this.v3j_1.q2t(event);
		  };
		  function CallbackMiddleware(store, logger) {
		    return CallbackMiddleware$lambda(logger);
		  }
		  function CallbackAction(fn, value) {
		    this.x3j_1 = fn;
		    this.y3j_1 = value;
		  }
		  protoOf(CallbackAction).toString = function () {
		    return 'CallbackAction(fn=' + this.x3j_1 + ', value=' + toString_0(this.y3j_1) + ')';
		  };
		  protoOf(CallbackAction).hashCode = function () {
		    var result = hashCode(this.x3j_1);
		    result = imul(result, 31) + (this.y3j_1 == null ? 0 : hashCode(this.y3j_1)) | 0;
		    return result;
		  };
		  protoOf(CallbackAction).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallbackAction))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallbackAction ? other : THROW_CCE();
		    if (!equals(this.x3j_1, tmp0_other_with_cast.x3j_1))
		      return false;
		    if (!equals(this.y3j_1, tmp0_other_with_cast.y3j_1))
		      return false;
		    return true;
		  };
		  function CallbackMiddleware$lambda$lambda$lambda() {
		    return '';
		  }
		  function CallbackMiddleware$lambda$lambda$lambda_0($action) {
		    return function () {
		      return 'Invoking Callback with value:' + toString_0($action.o3h_1.y3j_1);
		    };
		  }
		  function CallbackMiddleware$lambda$lambda($logger, $next) {
		    return function (action) {
		      v_0($logger, action, CallbackMiddleware$lambda$lambda$lambda);
		      var tmp;
		      if (action.o3h_1 instanceof CallbackAction) {
		        d_0($logger, action, CallbackMiddleware$lambda$lambda$lambda_0(action));
		        tmp = action.o3h_1.x3j_1(action.o3h_1.y3j_1);
		      } else {
		        tmp = Unit_instance;
		      }
		      return $next(action);
		    };
		  }
		  function CallbackMiddleware$lambda($logger) {
		    return function (next) {
		      return CallbackMiddleware$lambda$lambda($logger, next);
		    };
		  }
		  function BufferedSocketEvent() {
		  }
		  function exceptionHandlerMiddleware(store, logger) {
		    return exceptionHandlerMiddleware$lambda(logger);
		  }
		  function exceptionHandlerMiddleware$lambda$lambda$lambda($error) {
		    return function () {
		      return 'Unhandled Exception:\n ' + $error;
		    };
		  }
		  function exceptionHandlerMiddleware$lambda$lambda($next, $logger) {
		    return function (action) {
		      var tmp;
		      try {
		        tmp = $next(action);
		      } catch ($p) {
		        var tmp_0;
		        if ($p instanceof Exception) {
		          var error = $p;
		          e_1($logger, action, exceptionHandlerMiddleware$lambda$lambda$lambda(error));
		          tmp_0 = $next(Action_init_$Create$(new ErrorReport(error, action)));
		        } else {
		          throw $p;
		        }
		        tmp = tmp_0;
		      }
		      return tmp;
		    };
		  }
		  function exceptionHandlerMiddleware$lambda($logger) {
		    return function (next) {
		      return exceptionHandlerMiddleware$lambda$lambda(next, $logger);
		    };
		  }
		  function loggingMiddleware(store, logger) {
		    return loggingMiddleware$lambda(logger);
		  }
		  function loggingMiddleware$lambda$lambda$lambda($action) {
		    return function () {
		      return 'NEW ACTION - ' + $action.o3h_1 + ' - ' + $action.p3h_1;
		    };
		  }
		  function loggingMiddleware$lambda$lambda($logger, $next) {
		    return function (action) {
		      v_0($logger, action, loggingMiddleware$lambda$lambda$lambda(action));
		      return $next(action);
		    };
		  }
		  function loggingMiddleware$lambda($logger) {
		    return function (next) {
		      return loggingMiddleware$lambda$lambda($logger, next);
		    };
		  }
		  function SessionMiddleware(store, logger) {
		    return SessionMiddleware$lambda(logger, store);
		  }
		  function SessionMiddleware$lambda$lambda$lambda() {
		    return '';
		  }
		  function SessionMiddleware$lambda$lambda($logger, $next, $store) {
		    return function (action) {
		      v_0($logger, action, SessionMiddleware$lambda$lambda$lambda);
		      // Inline function 'kotlin.also' call
		      var this_0 = $next(action);
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.middlewares.SessionMiddleware.<anonymous>.<anonymous>.<anonymous>' call
		      if (action.o3h_1 instanceof SessionSuccessEvent) {
		        if (!(action.o3h_1.r2b_1.d2c_1 == null)) {
		          // Inline function 'kotlin.collections.forEach' call
		          var tmp0_iterator = action.o3h_1.r2b_1.d2c_1.p();
		          while (tmp0_iterator.q()) {
		            var element = tmp0_iterator.s();
		            // Inline function 'com.vonage.clientcore.core.middlewares.SessionMiddleware.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
		            $store.a1g(Action_init_$Create$(element));
		          }
		        }
		      }
		      return this_0;
		    };
		  }
		  function SessionMiddleware$lambda($logger, $store) {
		    return function (next) {
		      return SessionMiddleware$lambda$lambda($logger, next, $store);
		    };
		  }
		  function UserConversations(uid, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.z3j_1 = uid;
		    this.a3k_1 = version;
		  }
		  protoOf(UserConversations).b3k = function () {
		    return '/' + this.a3k_1 + '/users/' + this.z3j_1 + '/conversations';
		  };
		  protoOf(UserConversations).toString = function () {
		    return 'UserConversations(uid=' + this.z3j_1 + ', version=' + this.a3k_1 + ')';
		  };
		  protoOf(UserConversations).hashCode = function () {
		    var result = getStringHashCode(this.z3j_1);
		    result = imul(result, 31) + getStringHashCode(this.a3k_1) | 0;
		    return result;
		  };
		  protoOf(UserConversations).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof UserConversations))
		      return false;
		    var tmp0_other_with_cast = other instanceof UserConversations ? other : THROW_CCE();
		    if (!(this.z3j_1 === tmp0_other_with_cast.z3j_1))
		      return false;
		    if (!(this.a3k_1 === tmp0_other_with_cast.a3k_1))
		      return false;
		    return true;
		  };
		  function User_0(userIdOrName, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.c3k_1 = userIdOrName;
		    this.d3k_1 = version;
		  }
		  protoOf(User_0).b3k = function () {
		    return '/' + this.d3k_1 + '/users/' + this.c3k_1;
		  };
		  protoOf(User_0).toString = function () {
		    return 'User(userIdOrName=' + this.c3k_1 + ', version=' + this.d3k_1 + ')';
		  };
		  protoOf(User_0).hashCode = function () {
		    var result = getStringHashCode(this.c3k_1);
		    result = imul(result, 31) + getStringHashCode(this.d3k_1) | 0;
		    return result;
		  };
		  protoOf(User_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof User_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof User_0 ? other : THROW_CCE();
		    if (!(this.c3k_1 === tmp0_other_with_cast.c3k_1))
		      return false;
		    if (!(this.d3k_1 === tmp0_other_with_cast.d3k_1))
		      return false;
		    return true;
		  };
		  function ConversationMembers(cid, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.e3k_1 = cid;
		    this.f3k_1 = version;
		  }
		  protoOf(ConversationMembers).b3k = function () {
		    return '/' + this.f3k_1 + '/conversations/' + this.e3k_1 + '/members';
		  };
		  protoOf(ConversationMembers).toString = function () {
		    return 'ConversationMembers(cid=' + this.e3k_1 + ', version=' + this.f3k_1 + ')';
		  };
		  protoOf(ConversationMembers).hashCode = function () {
		    var result = getStringHashCode(this.e3k_1);
		    result = imul(result, 31) + getStringHashCode(this.f3k_1) | 0;
		    return result;
		  };
		  protoOf(ConversationMembers).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationMembers))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationMembers ? other : THROW_CCE();
		    if (!(this.e3k_1 === tmp0_other_with_cast.e3k_1))
		      return false;
		    if (!(this.f3k_1 === tmp0_other_with_cast.f3k_1))
		      return false;
		    return true;
		  };
		  function ConversationMember(cid, mid, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.g3k_1 = cid;
		    this.h3k_1 = mid;
		    this.i3k_1 = version;
		  }
		  protoOf(ConversationMember).b3k = function () {
		    return '/' + this.i3k_1 + '/conversations/' + this.g3k_1 + '/members/' + this.h3k_1;
		  };
		  protoOf(ConversationMember).toString = function () {
		    return 'ConversationMember(cid=' + this.g3k_1 + ', mid=' + this.h3k_1 + ', version=' + this.i3k_1 + ')';
		  };
		  protoOf(ConversationMember).hashCode = function () {
		    var result = getStringHashCode(this.g3k_1);
		    result = imul(result, 31) + getStringHashCode(this.h3k_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.i3k_1) | 0;
		    return result;
		  };
		  protoOf(ConversationMember).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationMember))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationMember ? other : THROW_CCE();
		    if (!(this.g3k_1 === tmp0_other_with_cast.g3k_1))
		      return false;
		    if (!(this.h3k_1 === tmp0_other_with_cast.h3k_1))
		      return false;
		    if (!(this.i3k_1 === tmp0_other_with_cast.i3k_1))
		      return false;
		    return true;
		  };
		  function Conversations(version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.j3k_1 = version;
		  }
		  protoOf(Conversations).b3k = function () {
		    return '/' + this.j3k_1 + '/conversations';
		  };
		  protoOf(Conversations).toString = function () {
		    return 'Conversations(version=' + this.j3k_1 + ')';
		  };
		  protoOf(Conversations).hashCode = function () {
		    return getStringHashCode(this.j3k_1);
		  };
		  protoOf(Conversations).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Conversations))
		      return false;
		    var tmp0_other_with_cast = other instanceof Conversations ? other : THROW_CCE();
		    if (!(this.j3k_1 === tmp0_other_with_cast.j3k_1))
		      return false;
		    return true;
		  };
		  function Conversation_1(cid, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.k3k_1 = cid;
		    this.l3k_1 = version;
		  }
		  protoOf(Conversation_1).b3k = function () {
		    return '/' + this.l3k_1 + '/conversations/' + this.k3k_1;
		  };
		  protoOf(Conversation_1).toString = function () {
		    return 'Conversation(cid=' + this.k3k_1 + ', version=' + this.l3k_1 + ')';
		  };
		  protoOf(Conversation_1).hashCode = function () {
		    var result = getStringHashCode(this.k3k_1);
		    result = imul(result, 31) + getStringHashCode(this.l3k_1) | 0;
		    return result;
		  };
		  protoOf(Conversation_1).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Conversation_1))
		      return false;
		    var tmp0_other_with_cast = other instanceof Conversation_1 ? other : THROW_CCE();
		    if (!(this.k3k_1 === tmp0_other_with_cast.k3k_1))
		      return false;
		    if (!(this.l3k_1 === tmp0_other_with_cast.l3k_1))
		      return false;
		    return true;
		  };
		  function ConversationEvents(cid, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.m3k_1 = cid;
		    this.n3k_1 = version;
		  }
		  protoOf(ConversationEvents).b3k = function () {
		    return '/' + this.n3k_1 + '/conversations/' + this.m3k_1 + '/events';
		  };
		  protoOf(ConversationEvents).toString = function () {
		    return 'ConversationEvents(cid=' + this.m3k_1 + ', version=' + this.n3k_1 + ')';
		  };
		  protoOf(ConversationEvents).hashCode = function () {
		    var result = getStringHashCode(this.m3k_1);
		    result = imul(result, 31) + getStringHashCode(this.n3k_1) | 0;
		    return result;
		  };
		  protoOf(ConversationEvents).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationEvents))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationEvents ? other : THROW_CCE();
		    if (!(this.m3k_1 === tmp0_other_with_cast.m3k_1))
		      return false;
		    if (!(this.n3k_1 === tmp0_other_with_cast.n3k_1))
		      return false;
		    return true;
		  };
		  function ConversationEvent(cid, eventId, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.o3k_1 = cid;
		    this.p3k_1 = eventId;
		    this.q3k_1 = version;
		  }
		  protoOf(ConversationEvent).b3k = function () {
		    return '/' + this.q3k_1 + '/conversations/' + this.o3k_1 + '/events/' + this.p3k_1;
		  };
		  protoOf(ConversationEvent).toString = function () {
		    return 'ConversationEvent(cid=' + this.o3k_1 + ', eventId=' + this.p3k_1 + ', version=' + this.q3k_1 + ')';
		  };
		  protoOf(ConversationEvent).hashCode = function () {
		    var result = getStringHashCode(this.o3k_1);
		    result = imul(result, 31) + getStringHashCode(this.p3k_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.q3k_1) | 0;
		    return result;
		  };
		  protoOf(ConversationEvent).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationEvent))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationEvent ? other : THROW_CCE();
		    if (!(this.o3k_1 === tmp0_other_with_cast.o3k_1))
		      return false;
		    if (!(this.p3k_1 === tmp0_other_with_cast.p3k_1))
		      return false;
		    if (!(this.q3k_1 === tmp0_other_with_cast.q3k_1))
		      return false;
		    return true;
		  };
		  function RtcReconnect(cid, reconnectRtcId, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.r3k_1 = cid;
		    this.s3k_1 = reconnectRtcId;
		    this.t3k_1 = version;
		  }
		  protoOf(RtcReconnect).b3k = function () {
		    return '/' + this.t3k_1 + '/conversations/' + this.r3k_1 + '/rtc/' + this.s3k_1 + '/offer';
		  };
		  protoOf(RtcReconnect).toString = function () {
		    return 'RtcReconnect(cid=' + this.r3k_1 + ', reconnectRtcId=' + this.s3k_1 + ', version=' + this.t3k_1 + ')';
		  };
		  protoOf(RtcReconnect).hashCode = function () {
		    var result = getStringHashCode(this.r3k_1);
		    result = imul(result, 31) + getStringHashCode(this.s3k_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.t3k_1) | 0;
		    return result;
		  };
		  protoOf(RtcReconnect).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RtcReconnect))
		      return false;
		    var tmp0_other_with_cast = other instanceof RtcReconnect ? other : THROW_CCE();
		    if (!(this.r3k_1 === tmp0_other_with_cast.r3k_1))
		      return false;
		    if (!(this.s3k_1 === tmp0_other_with_cast.s3k_1))
		      return false;
		    if (!(this.t3k_1 === tmp0_other_with_cast.t3k_1))
		      return false;
		    return true;
		  };
		  function ConversationMemberMe(cid, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.u3k_1 = cid;
		    this.v3k_1 = version;
		  }
		  protoOf(ConversationMemberMe).b3k = function () {
		    return '/' + this.v3k_1 + '/conversations/' + this.u3k_1 + '/members/me';
		  };
		  protoOf(ConversationMemberMe).toString = function () {
		    return 'ConversationMemberMe(cid=' + this.u3k_1 + ', version=' + this.v3k_1 + ')';
		  };
		  protoOf(ConversationMemberMe).hashCode = function () {
		    var result = getStringHashCode(this.u3k_1);
		    result = imul(result, 31) + getStringHashCode(this.v3k_1) | 0;
		    return result;
		  };
		  protoOf(ConversationMemberMe).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConversationMemberMe))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConversationMemberMe ? other : THROW_CCE();
		    if (!(this.u3k_1 === tmp0_other_with_cast.u3k_1))
		      return false;
		    if (!(this.v3k_1 === tmp0_other_with_cast.v3k_1))
		      return false;
		    return true;
		  };
		  function Leg_0(legId, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.w3k_1 = legId;
		    this.x3k_1 = version;
		  }
		  protoOf(Leg_0).b3k = function () {
		    return '/' + this.x3k_1 + '/legs/' + this.w3k_1;
		  };
		  protoOf(Leg_0).toString = function () {
		    return 'Leg(legId=' + this.w3k_1 + ', version=' + this.x3k_1 + ')';
		  };
		  protoOf(Leg_0).hashCode = function () {
		    var result = getStringHashCode(this.w3k_1);
		    result = imul(result, 31) + getStringHashCode(this.x3k_1) | 0;
		    return result;
		  };
		  protoOf(Leg_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Leg_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof Leg_0 ? other : THROW_CCE();
		    if (!(this.w3k_1 === tmp0_other_with_cast.w3k_1))
		      return false;
		    if (!(this.x3k_1 === tmp0_other_with_cast.x3k_1))
		      return false;
		    return true;
		  };
		  function Knockers(version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.y3k_1 = version;
		  }
		  protoOf(Knockers).b3k = function () {
		    return '/' + this.y3k_1 + '/knocking';
		  };
		  protoOf(Knockers).toString = function () {
		    return 'Knockers(version=' + this.y3k_1 + ')';
		  };
		  protoOf(Knockers).hashCode = function () {
		    return getStringHashCode(this.y3k_1);
		  };
		  protoOf(Knockers).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Knockers))
		      return false;
		    var tmp0_other_with_cast = other instanceof Knockers ? other : THROW_CCE();
		    if (!(this.y3k_1 === tmp0_other_with_cast.y3k_1))
		      return false;
		    return true;
		  };
		  function Knocker(knockingId, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.z3k_1 = knockingId;
		    this.a3l_1 = version;
		  }
		  protoOf(Knocker).b3k = function () {
		    return '/' + this.a3l_1 + '/knocking/' + this.z3k_1;
		  };
		  protoOf(Knocker).toString = function () {
		    return 'Knocker(knockingId=' + this.z3k_1 + ', version=' + this.a3l_1 + ')';
		  };
		  protoOf(Knocker).hashCode = function () {
		    var result = getStringHashCode(this.z3k_1);
		    result = imul(result, 31) + getStringHashCode(this.a3l_1) | 0;
		    return result;
		  };
		  protoOf(Knocker).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Knocker))
		      return false;
		    var tmp0_other_with_cast = other instanceof Knocker ? other : THROW_CCE();
		    if (!(this.z3k_1 === tmp0_other_with_cast.z3k_1))
		      return false;
		    if (!(this.a3l_1 === tmp0_other_with_cast.a3l_1))
		      return false;
		    return true;
		  };
		  function Legs(version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.b3l_1 = version;
		  }
		  protoOf(Legs).b3k = function () {
		    return '/' + this.b3l_1 + '/legs';
		  };
		  protoOf(Legs).toString = function () {
		    return 'Legs(version=' + this.b3l_1 + ')';
		  };
		  protoOf(Legs).hashCode = function () {
		    return getStringHashCode(this.b3l_1);
		  };
		  protoOf(Legs).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Legs))
		      return false;
		    var tmp0_other_with_cast = other instanceof Legs ? other : THROW_CCE();
		    if (!(this.b3l_1 === tmp0_other_with_cast.b3l_1))
		      return false;
		    return true;
		  };
		  function Sessions(sessionId, version) {
		    version = version === VOID ? 'v0.2' : version;
		    CSEndPoints.call(this);
		    this.c3l_1 = sessionId;
		    this.d3l_1 = version;
		  }
		  protoOf(Sessions).b3k = function () {
		    return '/' + this.d3l_1 + '/sessions/' + this.c3l_1;
		  };
		  protoOf(Sessions).toString = function () {
		    return 'Sessions(sessionId=' + this.c3l_1 + ', version=' + this.d3l_1 + ')';
		  };
		  protoOf(Sessions).hashCode = function () {
		    var result = getStringHashCode(this.c3l_1);
		    result = imul(result, 31) + getStringHashCode(this.d3l_1) | 0;
		    return result;
		  };
		  protoOf(Sessions).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Sessions))
		      return false;
		    var tmp0_other_with_cast = other instanceof Sessions ? other : THROW_CCE();
		    if (!(this.c3l_1 === tmp0_other_with_cast.c3l_1))
		      return false;
		    if (!(this.d3l_1 === tmp0_other_with_cast.d3l_1))
		      return false;
		    return true;
		  };
		  function RTCAnswer_0(cid, rtc_id, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.e3l_1 = cid;
		    this.f3l_1 = rtc_id;
		    this.g3l_1 = version;
		  }
		  protoOf(RTCAnswer_0).b3k = function () {
		    return '/' + this.g3l_1 + '/conversations/' + this.e3l_1 + '/rtc/' + this.f3l_1 + '/answer';
		  };
		  protoOf(RTCAnswer_0).toString = function () {
		    return 'RTCAnswer(cid=' + this.e3l_1 + ', rtc_id=' + this.f3l_1 + ', version=' + this.g3l_1 + ')';
		  };
		  protoOf(RTCAnswer_0).hashCode = function () {
		    var result = getStringHashCode(this.e3l_1);
		    result = imul(result, 31) + getStringHashCode(this.f3l_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.g3l_1) | 0;
		    return result;
		  };
		  protoOf(RTCAnswer_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCAnswer_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCAnswer_0 ? other : THROW_CCE();
		    if (!(this.e3l_1 === tmp0_other_with_cast.e3l_1))
		      return false;
		    if (!(this.f3l_1 === tmp0_other_with_cast.f3l_1))
		      return false;
		    if (!(this.g3l_1 === tmp0_other_with_cast.g3l_1))
		      return false;
		    return true;
		  };
		  function ConversationLegs(cid, version) {
		    version = version === VOID ? 'v0.3' : version;
		    CSEndPoints.call(this);
		    this.h3l_1 = cid;
		    this.i3l_1 = version;
		  }
		  protoOf(ConversationLegs).b3k = function () {
		    return '/' + this.i3l_1 + '/conversations/' + this.h3l_1 + '/legs';
		  };
		  function CSEndPoints() {
		  }
		  function Metrics(version) {
		    version = version === VOID ? 'v2' : version;
		    CapiEndpoints.call(this);
		    this.j3l_1 = version;
		  }
		  protoOf(Metrics).b3k = function () {
		    return '/' + this.j3l_1 + '/rtc/metrics';
		  };
		  protoOf(Metrics).toString = function () {
		    return 'Metrics(version=' + this.j3l_1 + ')';
		  };
		  protoOf(Metrics).hashCode = function () {
		    return getStringHashCode(this.j3l_1);
		  };
		  protoOf(Metrics).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Metrics))
		      return false;
		    var tmp0_other_with_cast = other instanceof Metrics ? other : THROW_CCE();
		    if (!(this.j3l_1 === tmp0_other_with_cast.j3l_1))
		      return false;
		    return true;
		  };
		  function CapiEndpoints() {
		  }
		  function get_httpMiddlewareSerializer() {
		    _init_properties_HTTPActionMiddleware_kt__sbjcs0();
		    return httpMiddlewareSerializer;
		  }
		  var httpMiddlewareSerializer;
		  function httpActionMiddleware(store, http, logger) {
		    _init_properties_HTTPActionMiddleware_kt__sbjcs0();
		    return httpActionMiddleware$lambda(logger, store, http);
		  }
		  function httpMiddlewareSerializer$lambda($this$Json) {
		    _init_properties_HTTPActionMiddleware_kt__sbjcs0();
		    $this$Json.w11_1 = true;
		    $this$Json.u11_1 = true;
		    $this$Json.v11_1 = false;
		    return Unit_instance;
		  }
		  function httpActionMiddleware$lambda$lambda$lambda() {
		    _init_properties_HTTPActionMiddleware_kt__sbjcs0();
		    return '';
		  }
		  function httpActionMiddleware$lambda$lambda$lambda$lambda($response) {
		    return function () {
		      return 'Callback RESPONSE --> ' + $response;
		    };
		  }
		  function httpActionMiddleware$lambda$lambda$lambda$lambda_0($err) {
		    return function () {
		      return 'Callback ERROR --> ' + $err;
		    };
		  }
		  function httpActionMiddleware$lambda$lambda$lambda_0($logger, $action, $store) {
		    return function (httpClientError, response) {
		      $logger.i3h(VOID, httpActionMiddleware$lambda$lambda$lambda$lambda(response));
		      var tmp;
		      if (httpClientError == null) {
		        var tmp_0;
		        if (response == null) {
		          tmp_0 = new UnexpectedNullValue();
		        } else if (response.k3l_1 === 503) {
		          tmp_0 = new ServiceTempNotAvailable();
		        } else if (response.k3l_1 >= 500) {
		          tmp_0 = new ServiceNotAvailable(response.k3l_1);
		        } else if (response.k3l_1 === 401) {
		          tmp_0 = new AuthorizationError_0(response.l3l_1);
		        } else if (response.k3l_1 >= 400) {
		          var tmp0_elvis_lhs = CSError_0(response);
		          tmp_0 = tmp0_elvis_lhs == null ? new ParsingException(Exception_init_$Create$('CSErrorParsing')) : tmp0_elvis_lhs;
		        } else {
		          var tmp_1;
		          if (response.l3l_1 == null) {
		            tmp_1 = null;
		          } else {
		            // Inline function 'kotlin.let' call
		            // Inline function 'kotlin.contracts.contract' call
		            // Inline function 'com.vonage.clientcore.core.middlewares.http.httpActionMiddleware.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
		            var tmp_2;
		            try {
		              var decodedResponse = $action.o3h_1.x1h(response.l3l_1, get_httpMiddlewareSerializer());
		              $store.a1g(new Action_0(decodedResponse, new ActionMeta(VOID, $action.p3h_1.r3h_1)));
		              var tmp0_safe_receiver = $action.p3h_1.s3h_1;
		              if (tmp0_safe_receiver == null)
		                null;
		              else {
		                // Inline function 'kotlin.let' call
		                // Inline function 'kotlin.contracts.contract' call
		                $store.a1g(Action_init_$Create$(new CallbackAction(tmp0_safe_receiver, decodedResponse)));
		              }
		              tmp_2 = null;
		            } catch ($p) {
		              var tmp_3;
		              if ($p instanceof Exception) {
		                var e = $p;
		                tmp_3 = new ParsingException(e);
		              } else {
		                throw $p;
		              }
		              tmp_2 = tmp_3;
		            }
		            tmp_1 = tmp_2;
		          }
		          tmp_0 = tmp_1;
		        }
		        tmp = tmp_0;
		      } else {
		        tmp = httpClientError;
		      }
		      var err = tmp;
		      var tmp_4;
		      if (!(err == null)) {
		        $logger.n3h(VOID, httpActionMiddleware$lambda$lambda$lambda$lambda_0(err));
		        $store.a1g(Companion_instance_156.m3l(err, $action));
		        var tmp3_safe_receiver = $action.p3h_1.s3h_1;
		        if (tmp3_safe_receiver == null)
		          null;
		        else {
		          // Inline function 'kotlin.let' call
		          // Inline function 'kotlin.contracts.contract' call
		          $store.a1g(Action_init_$Create$(new CallbackAction(tmp3_safe_receiver, err)));
		        }
		        tmp_4 = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function httpActionMiddleware$lambda$lambda$lambda_1() {
		    _init_properties_HTTPActionMiddleware_kt__sbjcs0();
		    return 'Request is not sanitized';
		  }
		  function httpActionMiddleware$lambda$lambda$lambda_2($method, $url, $headers, $body) {
		    return function () {
		      return 'REQUEST --> ' + $method + ' ' + $url + '\n headers:' + maskAuthHeader($headers) + '\n body:' + $body;
		    };
		  }
		  function httpActionMiddleware$lambda$lambda$lambda_3($e) {
		    return function () {
		      return 'ERROR --> ' + $e;
		    };
		  }
		  function httpActionMiddleware$lambda$lambda($logger, $store, $next, $http) {
		    return function (action) {
		      v_0($logger, action, httpActionMiddleware$lambda$lambda$lambda);
		      var tmp0_elvis_lhs = $store.t2y(getKClass(SessionReducer)).l38_1.w1().t27();
		      var sessionId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
		      var tmp1_subject = action.o3h_1;
		      var tmp;
		      if (tmp1_subject instanceof SessionSuccessEvent) {
		        // Inline function 'kotlin.also' call
		        var this_0 = $next(action);
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.middlewares.http.httpActionMiddleware.<anonymous>.<anonymous>.<anonymous>' call
		        $http.a3i();
		        tmp = this_0;
		      } else {
		        if (!isInterface(tmp1_subject, ApiRequest)) {
		          tmp = $next(action);
		        } else {
		          var tmp2_subject = action.o3h_1.u1h();
		          var tmp_0;
		          if (tmp2_subject instanceof CapiEndpoints) {
		            var tmp3_safe_receiver = $store.t2y(getKClass(ConfigReducer)).d3b_1;
		            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : replaceFirst(tmp3_safe_receiver, 'wss', 'https');
		            tmp_0 = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
		          } else {
		            if (tmp2_subject instanceof CSEndPoints) {
		              var tmp5_elvis_lhs = $store.t2y(getKClass(ConfigReducer)).f3b_1;
		              tmp_0 = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
		            } else {
		              if (tmp2_subject instanceof RtcStatsEndpoints) {
		                var tmp6_elvis_lhs = $store.t2y(getKClass(ConfigReducer)).g3b_1;
		                tmp_0 = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
		              } else {
		                tmp_0 = '';
		              }
		            }
		          }
		          var host = tmp_0;
		          var auth = $store.t2y(getKClass(SessionReducer)).q38_1;
		          var tmp_1 = action.o3h_1;
		          if (tmp_1 instanceof UpdateSessionRequest)
		            auth = action.o3h_1.r1h_1;
		          var tmp_2;
		          var tmp_3 = action.o3h_1;
		          if (!(tmp_3 instanceof RTCStatsReportRequest)) {
		            tmp_2 = mapOf([to('Authorization', 'bearer ' + auth), to('Content-Type', 'application/json')]);
		          } else {
		            tmp_2 = mapOf_0(to('Content-Type', 'application/json'));
		          }
		          var headers = tmp_2;
		          var callback = httpActionMiddleware$lambda$lambda$lambda_0($logger, action, $store);
		          // Inline function 'kotlin.also' call
		          var this_1 = $next(action);
		          // Inline function 'kotlin.contracts.contract' call
		          $l$block: {
		            // Inline function 'com.vonage.clientcore.core.middlewares.http.httpActionMiddleware.<anonymous>.<anonymous>.<anonymous>' call
		            try {
		              if (!action.o3h_1.z1h()) {
		                $logger.n3h(VOID, httpActionMiddleware$lambda$lambda$lambda_1);
		                var e = new UnsanitizedInputError();
		                $store.a1g(Companion_instance_156.m3l(e, action));
		                var tmp0_safe_receiver = action.p3h_1.s3h_1;
		                if (tmp0_safe_receiver == null)
		                  null;
		                else {
		                  // Inline function 'kotlin.let' call
		                  // Inline function 'kotlin.contracts.contract' call
		                  $store.a1g(Action_init_$Create$(new CallbackAction(tmp0_safe_receiver, e)));
		                }
		                break $l$block;
		              }
		              var method = action.o3h_1.v1h();
		              var tmp1_safe_receiver = action.o3h_1.y1h();
		              var tmp_4;
		              if (tmp1_safe_receiver == null) {
		                tmp_4 = null;
		              } else {
		                // Inline function 'kotlin.collections.filterNot' call
		                // Inline function 'kotlin.collections.filterNotTo' call
		                var destination = LinkedHashMap_init_$Create$();
		                // Inline function 'kotlin.collections.iterator' call
		                var tmp0_iterator = tmp1_safe_receiver.u1().p();
		                while (tmp0_iterator.q()) {
		                  var element = tmp0_iterator.s();
		                  // Inline function 'com.vonage.clientcore.core.middlewares.http.httpActionMiddleware.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
		                  // Inline function 'kotlin.collections.component2' call
		                  var value = element.w1();
		                  // Inline function 'kotlin.text.isNullOrEmpty' call
		                  // Inline function 'kotlin.contracts.contract' call
		                  if (!(value == null ? true : charSequenceLength(value) === 0)) {
		                    destination.s1(element.v1(), element.w1());
		                  }
		                }
		                tmp_4 = destination;
		              }
		              var tmp2_safe_receiver = tmp_4;
		              var tmp_5;
		              if (tmp2_safe_receiver == null) {
		                tmp_5 = null;
		              } else {
		                // Inline function 'kotlin.collections.map' call
		                // Inline function 'kotlin.collections.mapTo' call
		                var destination_0 = ArrayList_init_$Create$(tmp2_safe_receiver.u());
		                // Inline function 'kotlin.collections.iterator' call
		                var tmp0_iterator_0 = tmp2_safe_receiver.u1().p();
		                while (tmp0_iterator_0.q()) {
		                  var item = tmp0_iterator_0.s();
		                  // Inline function 'com.vonage.clientcore.core.middlewares.http.httpActionMiddleware.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
		                  // Inline function 'kotlin.collections.component1' call
		                  var key = item.v1();
		                  // Inline function 'kotlin.collections.component2' call
		                  var value_0 = item.w1();
		                  var tmp$ret$12 = key + '=' + value_0;
		                  destination_0.m(tmp$ret$12);
		                }
		                tmp_5 = destination_0;
		              }
		              var tmp3_safe_receiver_0 = tmp_5;
		              var queryString = tmp3_safe_receiver_0 == null ? null : joinToString(tmp3_safe_receiver_0, '&');
		              var tmp_6 = host + action.o3h_1.u1h().b3k();
		              var tmp_7;
		              // Inline function 'kotlin.text.isNullOrEmpty' call
		              // Inline function 'kotlin.contracts.contract' call
		              if (queryString == null ? true : charSequenceLength(queryString) === 0) {
		                tmp_7 = '';
		              } else {
		                tmp_7 = '?' + queryString;
		              }
		              var url = tmp_6 + tmp_7;
		              var body = action.o3h_1.w1h(get_httpMiddlewareSerializer(), sessionId);
		              $logger.i3h(VOID, httpActionMiddleware$lambda$lambda$lambda_2(method, url, headers, body));
		              $http.z3h(method, url, headers, body, callback);
		            } catch ($p) {
		              if ($p instanceof Exception) {
		                var e_0 = $p;
		                $logger.n3h(VOID, httpActionMiddleware$lambda$lambda$lambda_3(e_0));
		                $store.a1g(Companion_instance_156.m3l(e_0, action));
		              } else {
		                throw $p;
		              }
		            }
		          }
		          tmp = this_1;
		        }
		      }
		      return tmp;
		    };
		  }
		  function httpActionMiddleware$lambda($logger, $store, $http) {
		    return function (next) {
		      return httpActionMiddleware$lambda$lambda($logger, $store, next, $http);
		    };
		  }
		  var properties_initialized_HTTPActionMiddleware_kt_a2sle6;
		  function _init_properties_HTTPActionMiddleware_kt__sbjcs0() {
		    if (!properties_initialized_HTTPActionMiddleware_kt_a2sle6) {
		      properties_initialized_HTTPActionMiddleware_kt_a2sle6 = true;
		      httpMiddlewareSerializer = Json(VOID, httpMiddlewareSerializer$lambda);
		    }
		  }
		  var HTTPMethod_GET_instance;
		  var HTTPMethod_POST_instance;
		  var HTTPMethod_DELETE_instance;
		  var HTTPMethod_PUT_instance;
		  var HTTPMethod_PATCH_instance;
		  var HTTPMethod_entriesInitialized;
		  function HTTPMethod_initEntries() {
		    if (HTTPMethod_entriesInitialized)
		      return Unit_instance;
		    HTTPMethod_entriesInitialized = true;
		    HTTPMethod_GET_instance = new HTTPMethod('GET', 0);
		    HTTPMethod_POST_instance = new HTTPMethod('POST', 1);
		    HTTPMethod_DELETE_instance = new HTTPMethod('DELETE', 2);
		    HTTPMethod_PUT_instance = new HTTPMethod('PUT', 3);
		    HTTPMethod_PATCH_instance = new HTTPMethod('PATCH', 4);
		  }
		  function HTTPMethod(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function HTTPMethod_GET_getInstance() {
		    HTTPMethod_initEntries();
		    return HTTPMethod_GET_instance;
		  }
		  function HTTPMethod_POST_getInstance() {
		    HTTPMethod_initEntries();
		    return HTTPMethod_POST_instance;
		  }
		  function HTTPMethod_DELETE_getInstance() {
		    HTTPMethod_initEntries();
		    return HTTPMethod_DELETE_instance;
		  }
		  function HTTPMethod_PUT_getInstance() {
		    HTTPMethod_initEntries();
		    return HTTPMethod_PUT_instance;
		  }
		  function HTTPMethod_PATCH_getInstance() {
		    HTTPMethod_initEntries();
		    return HTTPMethod_PATCH_instance;
		  }
		  function HTTPClient() {
		  }
		  function HTTPClientError(message, cause) {
		    message = message === VOID ? '' : message;
		    cause = cause === VOID ? null : cause;
		    Exception_init_$Init$_0(message, cause, this);
		    captureStack(this, HTTPClientError);
		  }
		  function HTTPClientResponse(statusCode, body) {
		    body = body === VOID ? null : body;
		    this.k3l_1 = statusCode;
		    this.l3l_1 = body;
		  }
		  protoOf(HTTPClientResponse).toString = function () {
		    return 'HTTPClientResponse(statusCode=' + this.k3l_1 + ', body=' + this.l3l_1 + ')';
		  };
		  protoOf(HTTPClientResponse).hashCode = function () {
		    var result = this.k3l_1;
		    result = imul(result, 31) + (this.l3l_1 == null ? 0 : getStringHashCode(this.l3l_1)) | 0;
		    return result;
		  };
		  protoOf(HTTPClientResponse).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof HTTPClientResponse))
		      return false;
		    var tmp0_other_with_cast = other instanceof HTTPClientResponse ? other : THROW_CCE();
		    if (!(this.k3l_1 === tmp0_other_with_cast.k3l_1))
		      return false;
		    if (!(this.l3l_1 == tmp0_other_with_cast.l3l_1))
		      return false;
		    return true;
		  };
		  function CSError_0(from) {
		    var tmp;
		    try {
		      var tmp0_safe_receiver = from.l3l_1;
		      var tmp_0;
		      if (tmp0_safe_receiver == null) {
		        tmp_0 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        return get_httpMiddlewareSerializer().b11(Companion_getInstance_24().y12(), tmp0_safe_receiver);
		      }
		      tmp = tmp_0;
		    } catch ($p) {
		      var tmp_1;
		      if ($p instanceof Exception) {
		        var e = $p;
		        return null;
		      } else {
		        throw $p;
		      }
		    }
		    return tmp;
		  }
		  function RTCStats() {
		    RTCStats_instance = this;
		    RtcStatsEndpoints.call(this);
		  }
		  protoOf(RTCStats).b3k = function () {
		    return '/prod/logging/nexmo_client_js_stats';
		  };
		  var RTCStats_instance;
		  function RTCStats_getInstance() {
		    if (RTCStats_instance == null)
		      new RTCStats();
		    return RTCStats_instance;
		  }
		  function RtcStatsEndpoints() {
		  }
		  function mediaActionMiddleware(store, media, logger) {
		    // Inline function 'kotlin.also' call
		    var this_0 = mediaActionMiddleware$lambda(logger, store, media);
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.middlewares.media.mediaActionMiddleware.<anonymous>' call
		    media.m3i(new mediaActionMiddleware$2$1(store));
		    return this_0;
		  }
		  function callConversationUpdate(store, cid, rtcId) {
		    var tmp = new GetConversationRequest(cid);
		    store.a1g(new Action_0(tmp, new ActionMeta(VOID, VOID, callConversationUpdate$lambda(rtcId, store))));
		  }
		  function dispatchStats($this, rtcStats, conversationId, conversationName, legId) {
		    var sessionState = $this.n3l_1.t2y(getKClass(SessionReducer));
		    var apiKey = sessionState.l38_1.w1().n2n();
		    var applicationId = sessionState.r38_1;
		    if (apiKey == null ? true : applicationId == null) {
		      return Unit_instance;
		    }
		    var tmp = Companion_instance_157.o3l(rtcStats);
		    var tmp_0 = conversationId == null ? '' : conversationId;
		    $this.n3l_1.a1g(Action_init_$Create$(new RTCStatsReportRequest(new RTCUpdateStatsReport(rtcStats.p3l_1, rtcStats.q3l_1, rtcStats.r3l_1, rtcStats.s3l_1, rtcStats.t3l_1, rtcStats.u3l_1, rtcStats.v3l_1, rtcStats.w3l_1, rtcStats.x3l_1, tmp, legId, apiKey, applicationId, tmp_0, conversationName == null ? '' : conversationName))));
		  }
		  function mediaActionMiddleware$2$1($store) {
		    this.n3l_1 = $store;
		  }
		  protoOf(mediaActionMiddleware$2$1).o3j = function (id, rtcStats) {
		    this.n3l_1.a1g(Action_init_$Create$(new RTCStatsUpdate(id, rtcStats)));
		    var callState = this.n3l_1.t2y(getKClass(CallReducer));
		    var tmp0_safe_receiver = callState.a3a_1.c2(id);
		    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p39_1;
		    var member = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w1();
		    var tmp;
		    if (member instanceof Joined) {
		      tmp = true;
		    } else {
		      tmp = member instanceof Invited;
		    }
		    if (tmp) {
		      dispatchStats(this, rtcStats, ((!(member == null) ? isInterface(member, CoreMemberStateWithCid) : false) ? member : THROW_CCE()).u27(), member.y3l(), id);
		    } else {
		      dispatchStats(this, rtcStats, null, null, id);
		    }
		  };
		  protoOf(mediaActionMiddleware$2$1).q3j = function (id, error) {
		    this.n3l_1.a1g(Action_init_$Create$(new MediaErrorEvent(id, error)));
		  };
		  protoOf(mediaActionMiddleware$2$1).p3j = function (id, state) {
		    this.n3l_1.a1g(Action_init_$Create$(new MediaConnectionStateUpdate(id, state)));
		  };
		  function mediaActionMiddleware$lambda$lambda$lambda() {
		    return '';
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_0($action, $store) {
		    return function (result) {
		      var tmp0_safe_receiver = $action.p3h_1.s3h_1;
		      if (tmp0_safe_receiver == null)
		        null;
		      else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        $store.a1g(Action_init_$Create$(new CallbackAction(tmp0_safe_receiver, result)));
		      }
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_1($media) {
		    return function (legId, error) {
		      var tmp0_safe_receiver = $media.n3i();
		      if (tmp0_safe_receiver == null)
		        null;
		      else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        if (error == null)
		          null;
		        else {
		          // Inline function 'kotlin.let' call
		          // Inline function 'kotlin.contracts.contract' call
		          tmp0_safe_receiver.q3j(legId, error);
		        }
		      }
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda($invokeMediaErrorDelegate, $legId) {
		    return function (it) {
		      $invokeMediaErrorDelegate($legId, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_0($invokeMediaErrorDelegate, $legId) {
		    return function (it) {
		      $invokeMediaErrorDelegate($legId, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_1($invokeMediaErrorDelegate, $legId) {
		    return function (it) {
		      $invokeMediaErrorDelegate($legId, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda($dispatchActionMetaCallback, $callback, $store, $action, $offer, $media, $configState, $invokeMediaErrorDelegate) {
		    return function (response) {
		      var tmp;
		      if (response instanceof Exception) {
		        tmp = $dispatchActionMetaCallback(response);
		      } else {
		        var leg = response instanceof PostLeg ? response : THROW_CCE();
		        var legId = leg.a21_1;
		        var remoteSdp = leg.b21_1;
		        $callback(legId);
		        $store.a1g(Action_init_$Create$(new CallCreate(legId, new AppChannelEndpoint($action.o3h_1.v3b_1), CallDirection_outbound_getInstance(), $action.o3h_1.w3b_1)));
		        $store.a1g(Action_init_$Create$(new MediaOffer(legId, $offer)));
		        $media.q3i(legId, remoteSdp, mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda($invokeMediaErrorDelegate, legId));
		        if ($configState.n3b_1) {
		          $media.v3i(legId, mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_0($invokeMediaErrorDelegate, legId));
		        }
		        if ($configState.l3b_1) {
		          $media.u3i(legId, 1000, mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_1($invokeMediaErrorDelegate, legId));
		        }
		        var tmp_0 = new CallMemberMediaTimeout(legId);
		        $store.a1g(Action_init_$Create$(new TimeoutAction(tmp_0, 10000)));
		        tmp = $dispatchActionMetaCallback(legId);
		      }
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_2($dispatchActionMetaCallback, $store, $action, $media, $configState, $invokeMediaErrorDelegate) {
		    return function (error, offer, callback) {
		      var tmp;
		      var tmp_0;
		      if (error instanceof Exception) {
		        tmp_0 = true;
		      } else {
		        tmp_0 = offer == null;
		      }
		      if (tmp_0) {
		        tmp = $dispatchActionMetaCallback(error == null ? new NoOfferFound() : error);
		      } else {
		        var tmp_1 = new PostLegRequest(offer);
		        $store.a1g(new Action_0(tmp_1, new ActionMeta(VOID, VOID, mediaActionMiddleware$lambda$lambda$lambda$lambda($dispatchActionMetaCallback, callback, $store, $action, offer, $media, $configState, $invokeMediaErrorDelegate))));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_2($invokeMediaErrorDelegate, $legId) {
		    return function (it) {
		      $invokeMediaErrorDelegate($legId, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_3($invokeMediaErrorDelegate, $legId) {
		    return function (it) {
		      $invokeMediaErrorDelegate($legId, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda_0($dispatchActionMetaCallback, $store, $legId, $action, $offer, $configState, $media, $invokeMediaErrorDelegate) {
		    return function (response) {
		      var tmp;
		      if (response instanceof Exception) {
		        tmp = $dispatchActionMetaCallback(response);
		      } else {
		        $store.a1g(Action_init_$Create$(new CallCreate($legId, $action.o3h_1.g3c_1, CallDirection_inbound_getInstance(), null, new MemberJoinInfo($action.o3h_1.e3c_1, $action.o3h_1.f3c_1))));
		        $store.a1g(Action_init_$Create$(new MediaAnswer($legId, $offer)));
		        if ($configState.n3b_1) {
		          $media.v3i($legId, mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_2($invokeMediaErrorDelegate, $legId));
		        }
		        if ($configState.l3b_1) {
		          $media.u3i($legId, 1000, mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_3($invokeMediaErrorDelegate, $legId));
		        }
		        $dispatchActionMetaCallback($legId);
		        var mediaState = $media.x3i($legId);
		        var tmp_0;
		        if (!mediaState.equals(MediaConnectionState_New_getInstance())) {
		          var tmp0_safe_receiver = $media.n3i();
		          if (tmp0_safe_receiver == null)
		            null;
		          else {
		            tmp0_safe_receiver.p3j($legId, mediaState);
		          }
		          tmp_0 = Unit_instance;
		        }
		        tmp = tmp_0;
		      }
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_3($dispatchActionMetaCallback, $store, $action, $legId, $offer, $configState, $media, $invokeMediaErrorDelegate) {
		    return function (error, answer) {
		      var tmp;
		      var tmp_0;
		      if (error instanceof Exception) {
		        tmp_0 = true;
		      } else {
		        tmp_0 = answer == null;
		      }
		      if (tmp_0) {
		        tmp = $dispatchActionMetaCallback(error == null ? new NoAnswerFound() : error);
		      } else {
		        var tmp_1 = new RTCAnswerRequest($action.o3h_1.e3c_1, $action.o3h_1.f3c_1, $legId, answer);
		        $store.a1g(new Action_0(tmp_1, new ActionMeta(VOID, VOID, mediaActionMiddleware$lambda$lambda$lambda$lambda_0($dispatchActionMetaCallback, $store, $legId, $action, $offer, $configState, $media, $invokeMediaErrorDelegate))));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_4($invokeMediaErrorDelegate, $action) {
		    return function (it) {
		      $invokeMediaErrorDelegate($action.o3h_1.a3c_1, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_4($invokeMediaErrorDelegate, $action) {
		    return function (it) {
		      $invokeMediaErrorDelegate($action.o3h_1.a3c_1, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_5($invokeMediaErrorDelegate, $action) {
		    return function (it) {
		      $invokeMediaErrorDelegate($action.o3h_1.a3c_1, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda$lambda_1($dispatchActionMetaCallback, $configState, $media, $action, $invokeMediaErrorDelegate) {
		    return function (response) {
		      var tmp;
		      if (response instanceof Exception) {
		        tmp = $dispatchActionMetaCallback(response);
		      } else {
		        if ($configState.l3b_1) {
		          $media.u3i($action.o3h_1.a3c_1, 1000, mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_4($invokeMediaErrorDelegate, $action));
		        }
		        if ($configState.n3b_1) {
		          $media.v3i($action.o3h_1.a3c_1, mediaActionMiddleware$lambda$lambda$lambda$lambda$lambda_5($invokeMediaErrorDelegate, $action));
		        }
		        tmp = $dispatchActionMetaCallback($action.o3h_1.a3c_1);
		      }
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_5($dispatchActionMetaCallback, $action, $store, $configState, $media, $invokeMediaErrorDelegate) {
		    return function (error, offer, callback) {
		      var tmp;
		      var tmp_0;
		      if (error instanceof Exception) {
		        tmp_0 = true;
		      } else {
		        tmp_0 = offer == null;
		      }
		      if (tmp_0) {
		        tmp = $dispatchActionMetaCallback(error == null ? new NoOfferFound() : error);
		      } else {
		        callback($action.o3h_1.a3c_1);
		        var tmp_1 = new RTCReconnectRequest($action.o3h_1.c3c_1, $action.o3h_1.b3c_1, offer, $action.o3h_1.a3c_1);
		        $store.a1g(new Action_0(tmp_1, new ActionMeta(VOID, $action.o3h_1.a3c_1, mediaActionMiddleware$lambda$lambda$lambda$lambda_1($dispatchActionMetaCallback, $configState, $media, $action, $invokeMediaErrorDelegate))));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_6($invokeMediaErrorDelegate, $action) {
		    return function (it) {
		      $invokeMediaErrorDelegate($action.o3h_1.w2c_1.d2d_1, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_7($invokeMediaErrorDelegate, $action) {
		    return function (it) {
		      $invokeMediaErrorDelegate($action.o3h_1.z3b_1, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda$lambda_8($invokeMediaErrorDelegate, $action) {
		    return function (it) {
		      $invokeMediaErrorDelegate($action.o3h_1.q2m_1, it);
		      return Unit_instance;
		    };
		  }
		  function mediaActionMiddleware$lambda$lambda($logger, $next, $store, $media) {
		    return function (action) {
		      v_0($logger, action, mediaActionMiddleware$lambda$lambda$lambda);
		      // Inline function 'kotlin.also' call
		      var this_0 = $next(action);
		      // Inline function 'kotlin.contracts.contract' call
		      $l$block_0: {
		        // Inline function 'com.vonage.clientcore.core.middlewares.media.mediaActionMiddleware.<anonymous>.<anonymous>.<anonymous>' call
		        var dispatchActionMetaCallback = mediaActionMiddleware$lambda$lambda$lambda_0(action, $store);
		        var invokeMediaErrorDelegate = mediaActionMiddleware$lambda$lambda$lambda_1($media);
		        var tmp0_subject = action.o3h_1;
		        if (tmp0_subject instanceof SetupOutboundCall) {
		          var configState = $store.t2y(getKClass(ConfigReducer));
		          $media.o3i(mediaActionMiddleware$lambda$lambda$lambda_2(dispatchActionMetaCallback, $store, action, $media, configState, invokeMediaErrorDelegate));
		        } else {
		          if (tmp0_subject instanceof SetupInboundCall) {
		            var configState_0 = $store.t2y(getKClass(ConfigReducer));
		            var offer = action.o3h_1.h3c_1;
		            var legId = action.o3h_1.d3c_1;
		            $media.p3i(legId, offer, mediaActionMiddleware$lambda$lambda$lambda_3(dispatchActionMetaCallback, $store, action, legId, offer, configState_0, $media, invokeMediaErrorDelegate));
		          } else {
		            if (tmp0_subject instanceof CallReconnect) {
		              var configState_1 = $store.t2y(getKClass(ConfigReducer));
		              $media.r3i(action.o3h_1.a3c_1, mediaActionMiddleware$lambda$lambda$lambda_4(invokeMediaErrorDelegate, action));
		              $media.o3i(mediaActionMiddleware$lambda$lambda$lambda_5(dispatchActionMetaCallback, action, $store, configState_1, $media, invokeMediaErrorDelegate));
		            } else {
		              if (tmp0_subject instanceof MemberJoinedEvent) {
		                callConversationUpdate($store, action.o3h_1.i2c_1, action.o3h_1.g2c_1.r2c_1.k26_1);
		              } else {
		                if (tmp0_subject instanceof RTCTransferEvent) {
		                  callConversationUpdate($store, action.o3h_1.p2a_1, action.o3h_1.n2a_1.x2a_1.k26_1);
		                } else {
		                  if (tmp0_subject instanceof RTCAnswerEvent) {
		                    $media.q3i(action.o3h_1.w2c_1.d2d_1, action.o3h_1.w2c_1.e2d_1, mediaActionMiddleware$lambda$lambda$lambda_6(invokeMediaErrorDelegate, action));
		                  } else {
		                    if (tmp0_subject instanceof CallCleanup) {
		                      $media.r3i(action.o3h_1.z3b_1, mediaActionMiddleware$lambda$lambda$lambda_7(invokeMediaErrorDelegate, action));
		                    } else {
		                      if (tmp0_subject instanceof MediaDisable) {
		                        $media.r3i(action.o3h_1.q2m_1, mediaActionMiddleware$lambda$lambda$lambda_8(invokeMediaErrorDelegate, action));
		                      } else {
		                        if (tmp0_subject instanceof Mute) {
		                          $media.s3i(action.o3h_1.r2m_1, dispatchActionMetaCallback);
		                        } else {
		                          if (tmp0_subject instanceof Unmute) {
		                            $media.t3i(action.o3h_1.s2m_1, dispatchActionMetaCallback);
		                          } else {
		                            if (tmp0_subject instanceof EnableNoiseSuppression) {
		                              $media.v3i(action.o3h_1.a3m_1, dispatchActionMetaCallback);
		                            } else {
		                              if (tmp0_subject instanceof DisableNoiseSuppression) {
		                                $media.w3i(action.o3h_1.z3l_1, dispatchActionMetaCallback);
		                              } else {
		                                if (tmp0_subject instanceof MediaConnectionStateUpdate) {
		                                  var state = $store.t2y(getKClass(CallReducer));
		                                  var tmp1_elvis_lhs = state.a3a_1.c2(action.o3h_1.a2n_1);
		                                  var tmp;
		                                  if (tmp1_elvis_lhs == null) {
		                                    break $l$block_0;
		                                  } else {
		                                    tmp = tmp1_elvis_lhs;
		                                  }
		                                  var call = tmp;
		                                  var autoReconnectMedia = $store.t2y(getKClass(ConfigReducer)).m3b_1;
		                                  if (!action.o3h_1.b2n_1.equals(MediaConnectionState_Disconnected_getInstance())) {
		                                    break $l$block_0;
		                                  }
		                                  if (autoReconnectMedia) {
		                                    var tmp_0 = new CallReconnectionRetry(call.o39_1);
		                                    $store.a1g(Action_init_$Create$(new TimeoutAction(tmp_0, 3000)));
		                                  } else {
		                                    $store.a1g(Action_init_$Create$(new CallReconnectFailure(call.o39_1)));
		                                  }
		                                } else {
		                                  if (tmp0_subject instanceof CallReconnectFailure) {
		                                    $store.a1g(Action_init_$Create$(new CallCleanup(action.o3h_1.k3c_1)));
		                                  }
		                                }
		                              }
		                            }
		                          }
		                        }
		                      }
		                    }
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
		      return this_0;
		    };
		  }
		  function mediaActionMiddleware$lambda($logger, $store, $media) {
		    return function (next) {
		      return mediaActionMiddleware$lambda$lambda($logger, next, $store, $media);
		    };
		  }
		  function callConversationUpdate$lambda($rtcId, $store) {
		    return function (res) {
		      var tmp;
		      if (res instanceof GetConversation) {
		        var tmp0_safe_receiver = $rtcId;
		        if (tmp0_safe_receiver == null)
		          null;
		        else {
		          // Inline function 'kotlin.let' call
		          // Inline function 'kotlin.contracts.contract' call
		          $store.a1g(Action_init_$Create$(new CallConversationUpdate(tmp0_safe_receiver, res.w1j_1)));
		        }
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  var MediaConnectionState_Unknown_instance;
		  var MediaConnectionState_New_instance;
		  var MediaConnectionState_Connecting_instance;
		  var MediaConnectionState_Connected_instance;
		  var MediaConnectionState_Disconnected_instance;
		  var MediaConnectionState_Failed_instance;
		  var MediaConnectionState_Closed_instance;
		  var MediaConnectionState_entriesInitialized;
		  function MediaConnectionState_initEntries() {
		    if (MediaConnectionState_entriesInitialized)
		      return Unit_instance;
		    MediaConnectionState_entriesInitialized = true;
		    MediaConnectionState_Unknown_instance = new MediaConnectionState('Unknown', 0);
		    MediaConnectionState_New_instance = new MediaConnectionState('New', 1);
		    MediaConnectionState_Connecting_instance = new MediaConnectionState('Connecting', 2);
		    MediaConnectionState_Connected_instance = new MediaConnectionState('Connected', 3);
		    MediaConnectionState_Disconnected_instance = new MediaConnectionState('Disconnected', 4);
		    MediaConnectionState_Failed_instance = new MediaConnectionState('Failed', 5);
		    MediaConnectionState_Closed_instance = new MediaConnectionState('Closed', 6);
		  }
		  function MediaConnectionState(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function MediaConnectionState_Unknown_getInstance() {
		    MediaConnectionState_initEntries();
		    return MediaConnectionState_Unknown_instance;
		  }
		  function MediaConnectionState_New_getInstance() {
		    MediaConnectionState_initEntries();
		    return MediaConnectionState_New_instance;
		  }
		  function MediaConnectionState_Connecting_getInstance() {
		    MediaConnectionState_initEntries();
		    return MediaConnectionState_Connecting_instance;
		  }
		  function MediaConnectionState_Connected_getInstance() {
		    MediaConnectionState_initEntries();
		    return MediaConnectionState_Connected_instance;
		  }
		  function MediaConnectionState_Disconnected_getInstance() {
		    MediaConnectionState_initEntries();
		    return MediaConnectionState_Disconnected_instance;
		  }
		  function MediaConnectionState_Failed_getInstance() {
		    MediaConnectionState_initEntries();
		    return MediaConnectionState_Failed_instance;
		  }
		  function MediaConnectionState_Closed_getInstance() {
		    MediaConnectionState_initEntries();
		    return MediaConnectionState_Closed_instance;
		  }
		  function SocketConfig(query, path, forceNew, transports, reconnection, reconnectionAttempts, reconnectionDelay, randomizationFactor) {
		    forceNew = forceNew === VOID ? true : forceNew;
		    var tmp;
		    if (transports === VOID) {
		      // Inline function 'kotlin.arrayOf' call
		      // Inline function 'kotlin.js.unsafeCast' call
		      // Inline function 'kotlin.js.asDynamic' call
		      tmp = ['websocket'];
		    } else {
		      tmp = transports;
		    }
		    transports = tmp;
		    reconnection = reconnection === VOID ? true : reconnection;
		    reconnectionAttempts = reconnectionAttempts === VOID ? 5 : reconnectionAttempts;
		    reconnectionDelay = reconnectionDelay === VOID ? 5 : reconnectionDelay;
		    randomizationFactor = randomizationFactor === VOID ? 0.75 : randomizationFactor;
		    this.b3m_1 = query;
		    this.c3m_1 = path;
		    this.d3m_1 = forceNew;
		    this.e3m_1 = transports;
		    this.f3m_1 = reconnection;
		    this.g3m_1 = reconnectionAttempts;
		    this.h3m_1 = reconnectionDelay;
		    this.i3m_1 = randomizationFactor;
		  }
		  protoOf(SocketConfig).toString = function () {
		    return 'SocketConfig(query=' + this.b3m_1 + ', path=' + this.c3m_1 + ', forceNew=' + this.d3m_1 + ', transports=' + toString(this.e3m_1) + ', reconnection=' + this.f3m_1 + ', reconnectionAttempts=' + toString(this.g3m_1) + ', reconnectionDelay=' + toString(this.h3m_1) + ', randomizationFactor=' + toString(this.i3m_1) + ')';
		  };
		  protoOf(SocketConfig).hashCode = function () {
		    var result = getStringHashCode(this.b3m_1);
		    result = imul(result, 31) + getStringHashCode(this.c3m_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.d3m_1) | 0;
		    result = imul(result, 31) + hashCode(this.e3m_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.f3m_1) | 0;
		    result = imul(result, 31) + hashCode(this.g3m_1) | 0;
		    result = imul(result, 31) + hashCode(this.h3m_1) | 0;
		    result = imul(result, 31) + hashCode(this.i3m_1) | 0;
		    return result;
		  };
		  protoOf(SocketConfig).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SocketConfig))
		      return false;
		    var tmp0_other_with_cast = other instanceof SocketConfig ? other : THROW_CCE();
		    if (!(this.b3m_1 === tmp0_other_with_cast.b3m_1))
		      return false;
		    if (!(this.c3m_1 === tmp0_other_with_cast.c3m_1))
		      return false;
		    if (!(this.d3m_1 === tmp0_other_with_cast.d3m_1))
		      return false;
		    if (!equals(this.e3m_1, tmp0_other_with_cast.e3m_1))
		      return false;
		    if (!(this.f3m_1 === tmp0_other_with_cast.f3m_1))
		      return false;
		    if (!equals(this.g3m_1, tmp0_other_with_cast.g3m_1))
		      return false;
		    if (!equals(this.h3m_1, tmp0_other_with_cast.h3m_1))
		      return false;
		    if (!equals(this.i3m_1, tmp0_other_with_cast.i3m_1))
		      return false;
		    return true;
		  };
		  function SocketConnectionMiddleware(store, ws, logger) {
		    // Inline function 'kotlin.also' call
		    var this_0 = SocketConnectionMiddleware$lambda(logger, store, ws);
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.middlewares.ws.SocketConnectionMiddleware.<anonymous>' call
		    ws.d3i(new SocketConnectionMiddleware$2$1(store));
		    return this_0;
		  }
		  function SocketConnectionMiddleware$2$1($store) {
		    this.j3m_1 = $store;
		  }
		  protoOf(SocketConnectionMiddleware$2$1).k3j = function (event) {
		    this.j3m_1.a1g(Action_init_$Create$(event));
		  };
		  protoOf(SocketConnectionMiddleware$2$1).l3j = function (type, reason, timestamp, retryNumber) {
		    this.j3m_1.a1g(Action_init_$Create$(new SocketStatus(type, reason, timestamp, retryNumber)));
		  };
		  function SocketConnectionMiddleware$lambda$lambda$lambda() {
		    return '';
		  }
		  function SocketConnectionMiddleware$lambda$lambda$lambda_0(_name_for_destructuring_parameter_0__wldtmu) {
		    // Inline function 'kotlin.collections.component1' call
		    var key = _name_for_destructuring_parameter_0__wldtmu.v1();
		    // Inline function 'kotlin.collections.component2' call
		    var value = _name_for_destructuring_parameter_0__wldtmu.w1();
		    return key + '=' + value;
		  }
		  function SocketConnectionMiddleware$lambda$lambda$lambda_1($host, $path) {
		    return function () {
		      return 'SocketConnect host null, login ignored ' + $host + ', ' + $path;
		    };
		  }
		  function SocketConnectionMiddleware$lambda$lambda$lambda_2($host, $path) {
		    return function () {
		      return 'SocketConnect path null, login ignored ' + $host + ', ' + $path;
		    };
		  }
		  function SocketConnectionMiddleware$lambda$lambda$lambda_3($store, $action) {
		    return function () {
		      $store.a1g(Action_init_$Create$(new SessionTimerEvent($action)));
		      return Unit_instance;
		    };
		  }
		  function SocketConnectionMiddleware$lambda$lambda$lambda_4($store, $a, $action) {
		    return function () {
		      $store.a1g(new Action_0($a.o2m_1, $action.p3h_1));
		      return Unit_instance;
		    };
		  }
		  function SocketConnectionMiddleware$lambda$lambda$lambda_5($e) {
		    return function () {
		      return 'ERROR --> ' + $e;
		    };
		  }
		  function SocketConnectionMiddleware$lambda$lambda($logger, $store, $ws, $next) {
		    return function (action) {
		      v_0($logger, action, SocketConnectionMiddleware$lambda$lambda$lambda);
		      var state = $store.t2y(getKClass(ConfigReducer));
		      var tmp;
		      try {
		        var a = action.o3h_1;
		        var tmp_0;
		        if (a instanceof SocketConnect) {
		          var host = state.d3b_1;
		          var path = state.e3b_1;
		          var token = a.h2o_1;
		          var sessionId = a.i2o_1;
		          var queryParams = mapOf([to('session_version', '0.0.3'), to('token', token), to('SDK_version', BuildKonfig_instance.p1d_1), to('SDK_name', state.k3b_1), to('acknowledge_events', 'true'), to('session_id', sessionId), to('OS_family', state.i3b_1), to('OS_revision', state.j3b_1)]);
		          // Inline function 'kotlin.collections.filterValues' call
		          var result = LinkedHashMap_init_$Create$();
		          // Inline function 'kotlin.collections.iterator' call
		          var tmp0_iterator = queryParams.u1().p();
		          while (tmp0_iterator.q()) {
		            var entry = tmp0_iterator.s();
		            // Inline function 'com.vonage.clientcore.core.middlewares.ws.SocketConnectionMiddleware.<anonymous>.<anonymous>.<anonymous>' call
		            if (!(entry.w1() == null)) {
		              result.s1(entry.v1(), entry.w1());
		            }
		          }
		          var tmp_1 = result.u1();
		          var query = joinToString(tmp_1, '&', VOID, VOID, VOID, VOID, SocketConnectionMiddleware$lambda$lambda$lambda_0);
		          var tmp_2;
		          if (token === '') {
		            $store.a1g(Action_init_$Create$(SocketConnectEmptyTokenError_instance));
		            tmp_2 = Unit_instance;
		          } else if (host == null) {
		            $logger.e3a(VOID, SocketConnectionMiddleware$lambda$lambda$lambda_1(host, path));
		            tmp_2 = Unit_instance;
		          } else if (path == null) {
		            $logger.e3a(VOID, SocketConnectionMiddleware$lambda$lambda$lambda_2(host, path));
		            tmp_2 = Unit_instance;
		          } else {
		            var config = new SocketConfig(query, path);
		            $ws.f3i(host, path, config.g3m_1, config.h3m_1, config.i3m_1, token, sessionId, query);
		            $ws.j3i(5000, SocketConnectionMiddleware$lambda$lambda$lambda_3($store, action));
		            tmp_2 = Unit_instance;
		          }
		          tmp_0 = tmp_2;
		        } else {
		          if (a instanceof SocketSetSessionId) {
		            $ws.i3i(a.t2o_1);
		            tmp_0 = Unit_instance;
		          } else {
		            if (a instanceof SocketSetSession) {
		              $ws.h3i(a.n2o_1, a.o2o_1);
		              tmp_0 = Unit_instance;
		            } else {
		              if (a instanceof SocketDisconnect) {
		                $ws.g3i();
		                $store.a1g(Action_init_$Create$(new SocketStatus(SocketConnectionStatus_Disconnected_getInstance(), SocketConnectionFailedReason_ClientDisconnected_getInstance(), generateTimeStamp(), null)));
		                tmp_0 = Unit_instance;
		              } else {
		                if (a instanceof TimeoutAction) {
		                  $ws.j3i(a.p2m_1, SocketConnectionMiddleware$lambda$lambda$lambda_4($store, a, action));
		                  tmp_0 = Unit_instance;
		                } else {
		                  if (a instanceof SessionTimerEvent) {
		                    var tmp_3;
		                    var tmp_4 = $store.t2y(getKClass(SessionReducer)).l38_1;
		                    if (tmp_4 instanceof Pending) {
		                      $ws.g3i();
		                      tmp_3 = Unit_instance;
		                    }
		                    tmp_0 = tmp_3;
		                  } else {
		                    tmp_0 = Unit_instance;
		                  }
		                }
		              }
		            }
		          }
		        }
		        tmp = tmp_0;
		      } catch ($p) {
		        var tmp_5;
		        if ($p instanceof Exception) {
		          var e = $p;
		          $logger.n3h(VOID, SocketConnectionMiddleware$lambda$lambda$lambda_5(e));
		          $store.a1g(Action_init_$Create$(new ErrorReport(e, action)));
		          tmp_5 = Unit_instance;
		        } else {
		          throw $p;
		        }
		        tmp = tmp_5;
		      }
		      return $next(action);
		    };
		  }
		  function SocketConnectionMiddleware$lambda($logger, $store, $ws) {
		    return function (next) {
		      return SocketConnectionMiddleware$lambda$lambda($logger, $store, $ws, next);
		    };
		  }
		  function SocketEmitMiddleware(store, ws, logger) {
		    return SocketEmitMiddleware$lambda(logger, ws, store);
		  }
		  function SocketEmitMiddleware$lambda$lambda$lambda() {
		    return '';
		  }
		  function SocketEmitMiddleware$lambda$lambda$lambda$lambda($response) {
		    return function () {
		      return 'RESPONSE\n ' + $response;
		    };
		  }
		  function SocketEmitMiddleware$lambda$lambda$lambda$lambda_0() {
		    return 'Request Error';
		  }
		  function SocketEmitMiddleware$lambda$lambda$lambda$lambda_1() {
		    return 'Response Error';
		  }
		  function SocketEmitMiddleware$lambda$lambda$lambda_0($logger, $store, $action) {
		    return function (error, response) {
		      $logger.i3h(VOID, SocketEmitMiddleware$lambda$lambda$lambda$lambda(response));
		      var tmp;
		      if (!(error == null)) {
		        $logger.n3h(VOID, SocketEmitMiddleware$lambda$lambda$lambda$lambda_0);
		        $store.a1g(Action_init_$Create$(new ErrorReport(error, $action)));
		        tmp = Unit_instance;
		      } else if (response == null) {
		        $logger.n3h(VOID, SocketEmitMiddleware$lambda$lambda$lambda$lambda_1);
		        $store.a1g(Action_init_$Create$(new ErrorReport(Exception_init_$Create$('INVALID RESPONSE'), $action)));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function SocketEmitMiddleware$lambda$lambda$lambda_1() {
		    return 'Error in emitting over websocket';
		  }
		  function SocketEmitMiddleware$lambda$lambda($logger, $ws, $store, $next) {
		    return function (action) {
		      v_0($logger, action, SocketEmitMiddleware$lambda$lambda$lambda);
		      var tmp;
		      var tmp_0 = action.o3h_1;
		      if (!isInterface(tmp_0, SocketEmitAction)) {
		        tmp = Unit_instance;
		      } else {
		        var callback = SocketEmitMiddleware$lambda$lambda$lambda_0($logger, $store, action);
		        var tmp_1;
		        try {
		          var msg = mapOf([to('tid', action.p3h_1.q3h_1), to('body', action.o3h_1.m2o())]);
		          $ws.e3i(action.o3h_1.j2o(), msg, callback);
		          tmp_1 = Unit_instance;
		        } catch ($p) {
		          var tmp_2;
		          if ($p instanceof Exception) {
		            var e = $p;
		            $logger.n3h(VOID, SocketEmitMiddleware$lambda$lambda$lambda_1);
		            $store.a1g(Action_init_$Create$(new ErrorReport(e, action)));
		            tmp_2 = Unit_instance;
		          } else {
		            throw $p;
		          }
		          tmp_1 = tmp_2;
		        }
		        tmp = tmp_1;
		      }
		      return $next(action);
		    };
		  }
		  function SocketEmitMiddleware$lambda($logger, $ws, $store) {
		    return function (next) {
		      return SocketEmitMiddleware$lambda$lambda($logger, $ws, $store, next);
		    };
		  }
		  function get_decoder() {
		    _init_properties_SocketEventParseMiddleware_kt__3leo2q();
		    return decoder;
		  }
		  var decoder;
		  function socketEventParseMiddleware(store, logger) {
		    _init_properties_SocketEventParseMiddleware_kt__3leo2q();
		    return socketEventParseMiddleware$lambda(logger);
		  }
		  function IgnoredSerializerException(type, message) {
		    message = message === VOID ? "Serialization for event type '" + type + "' is not supported or intentionally skipped." : message;
		    Exception_init_$Init$_1(message, this);
		    captureStack(this, IgnoredSerializerException);
		    this.k3m_1 = type;
		    this.l3m_1 = message;
		  }
		  protoOf(IgnoredSerializerException).ab = function () {
		    return this.l3m_1;
		  };
		  protoOf(IgnoredSerializerException).toString = function () {
		    return 'IgnoredSerializerException(type=' + this.k3m_1 + ', message=' + this.l3m_1 + ')';
		  };
		  protoOf(IgnoredSerializerException).hashCode = function () {
		    var result = getStringHashCode(this.k3m_1);
		    result = imul(result, 31) + getStringHashCode(this.l3m_1) | 0;
		    return result;
		  };
		  protoOf(IgnoredSerializerException).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof IgnoredSerializerException))
		      return false;
		    var tmp0_other_with_cast = other instanceof IgnoredSerializerException ? other : THROW_CCE();
		    if (!(this.k3m_1 === tmp0_other_with_cast.k3m_1))
		      return false;
		    if (!(this.l3m_1 === tmp0_other_with_cast.l3m_1))
		      return false;
		    return true;
		  };
		  function decoder$lambda($this$Json) {
		    _init_properties_SocketEventParseMiddleware_kt__3leo2q();
		    $this$Json.w11_1 = true;
		    return Unit_instance;
		  }
		  function socketEventParseMiddleware$lambda$lambda$lambda() {
		    _init_properties_SocketEventParseMiddleware_kt__3leo2q();
		    return '';
		  }
		  function socketEventParseMiddleware$lambda$lambda$lambda_0($e) {
		    return function () {
		      return $e.l3m_1;
		    };
		  }
		  function socketEventParseMiddleware$lambda$lambda$lambda_1($e) {
		    return function () {
		      return 'Socket Parsing error: ' + $e;
		    };
		  }
		  function socketEventParseMiddleware$lambda$lambda$lambda_2($newAction) {
		    return function () {
		      return 'SOCKET DECODE - ' + $newAction.o3h_1;
		    };
		  }
		  function socketEventParseMiddleware$lambda$lambda($logger, $next) {
		    return function (action) {
		      v_0($logger, action, socketEventParseMiddleware$lambda$lambda$lambda);
		      var tmp;
		      if (action.o3h_1 instanceof UnknownSocketEvent) {
		        var tmp_0;
		        try {
		          tmp_0 = get_decoder().b11(Companion_instance_127.y12(), action.o3h_1.g2n_1);
		        } catch ($p) {
		          var tmp_1;
		          if ($p instanceof IgnoredSerializerException) {
		            var e = $p;
		            $logger.i3h(VOID, socketEventParseMiddleware$lambda$lambda$lambda_0(e));
		            tmp_1 = null;
		          } else {
		            if ($p instanceof Exception) {
		              var e_0 = $p;
		              $logger.n3h(VOID, socketEventParseMiddleware$lambda$lambda$lambda_1(e_0));
		              tmp_1 = null;
		            } else {
		              throw $p;
		            }
		          }
		          tmp_0 = tmp_1;
		        }
		        tmp = tmp_0;
		      } else {
		        tmp = null;
		      }
		      var result = tmp;
		      var tmp_2;
		      if (result == null) {
		        tmp_2 = $next(action);
		      } else {
		        var newAction = new Action_0(result, action.p3h_1.m3m());
		        d_0($logger, newAction, socketEventParseMiddleware$lambda$lambda$lambda_2(newAction));
		        tmp_2 = $next(newAction);
		      }
		      return tmp_2;
		    };
		  }
		  function socketEventParseMiddleware$lambda($logger) {
		    return function (next) {
		      return socketEventParseMiddleware$lambda$lambda($logger, next);
		    };
		  }
		  var properties_initialized_SocketEventParseMiddleware_kt_itdrwg;
		  function _init_properties_SocketEventParseMiddleware_kt__3leo2q() {
		    if (!properties_initialized_SocketEventParseMiddleware_kt_itdrwg) {
		      properties_initialized_SocketEventParseMiddleware_kt_itdrwg = true;
		      decoder = Json(VOID, decoder$lambda);
		    }
		  }
		  function Logout(version) {
		    version = version === VOID ? '' : version;
		    WSEndPoints.call(this);
		    this.k2o_1 = version;
		  }
		  protoOf(Logout).l2o = function () {
		    return 'session:logout';
		  };
		  protoOf(Logout).toString = function () {
		    return 'Logout(version=' + this.k2o_1 + ')';
		  };
		  protoOf(Logout).hashCode = function () {
		    return getStringHashCode(this.k2o_1);
		  };
		  protoOf(Logout).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Logout))
		      return false;
		    var tmp0_other_with_cast = other instanceof Logout ? other : THROW_CCE();
		    if (!(this.k2o_1 === tmp0_other_with_cast.k2o_1))
		      return false;
		    return true;
		  };
		  function WSEndPoints() {
		  }
		  function cleanupReducers(_this__u8e3s4, filteredLegId, filteredConversationId) {
		    filteredLegId = filteredLegId === VOID ? null : filteredLegId;
		    filteredConversationId = filteredConversationId === VOID ? null : filteredConversationId;
		    // Inline function 'kotlin.run' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'kotlin.collections.filter' call
		    // Inline function 'kotlin.collections.filterTo' call
		    var this_0 = _this__u8e3s4.t2y(getKClass(InviteReducer)).y3a_1;
		    var destination = LinkedHashMap_init_$Create$();
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator = this_0.u1().p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.core.reducers.cleanupReducers.<anonymous>.<anonymous>' call
		      var tmp;
		      if (filteredLegId == null) {
		        tmp = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.reducers.cleanupReducers.<anonymous>.<anonymous>.<anonymous>' call
		        tmp = !(element.w1().g3a_1 === filteredLegId);
		      }
		      var tmp1_elvis_lhs = tmp;
		      if (tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs) {
		        destination.s1(element.v1(), element.w1());
		      }
		    }
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator_0 = destination.u1().p();
		    while (tmp0_iterator_0.q()) {
		      var element_0 = tmp0_iterator_0.s();
		      // Inline function 'com.vonage.clientcore.core.reducers.cleanupReducers.<anonymous>.<anonymous>' call
		      if (element_0.w1().m3a_1) {
		        _this__u8e3s4.a1g(Action_init_$Create$(new InviteCleanup(element_0.v1())));
		      }
		    }
		    // Inline function 'kotlin.run' call
		    // Inline function 'kotlin.contracts.contract' call
		    var $this$run = _this__u8e3s4.t2y(getKClass(CallReducer));
		    // Inline function 'kotlin.collections.filter' call
		    // Inline function 'kotlin.collections.filterTo' call
		    var this_1 = $this$run.b3a_1;
		    var destination_0 = LinkedHashMap_init_$Create$();
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator_1 = this_1.u1().p();
		    while (tmp0_iterator_1.q()) {
		      var element_1 = tmp0_iterator_1.s();
		      // Inline function 'com.vonage.clientcore.core.reducers.cleanupReducers.<anonymous>.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var conversationId = element_1.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var callId = element_1.w1();
		      var tmp_0;
		      var tmp_1;
		      if (filteredLegId == null) {
		        tmp_1 = null;
		      } else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        // Inline function 'com.vonage.clientcore.core.reducers.cleanupReducers.<anonymous>.<anonymous>.<anonymous>' call
		        tmp_1 = !(callId === filteredLegId);
		      }
		      var tmp1_elvis_lhs_0 = tmp_1;
		      if (tmp1_elvis_lhs_0 == null ? true : tmp1_elvis_lhs_0) {
		        var tmp_2;
		        if (filteredConversationId == null) {
		          tmp_2 = null;
		        } else {
		          // Inline function 'kotlin.let' call
		          // Inline function 'kotlin.contracts.contract' call
		          // Inline function 'com.vonage.clientcore.core.reducers.cleanupReducers.<anonymous>.<anonymous>.<anonymous>' call
		          tmp_2 = !(filteredConversationId === conversationId);
		        }
		        var tmp3_elvis_lhs = tmp_2;
		        tmp_0 = tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs;
		      } else {
		        tmp_0 = false;
		      }
		      if (tmp_0) {
		        destination_0.s1(element_1.v1(), element_1.w1());
		      }
		    }
		    var tmp0_iterator_2 = destination_0.r1().p();
		    while (tmp0_iterator_2.q()) {
		      var element_2 = tmp0_iterator_2.s();
		      // Inline function 'com.vonage.clientcore.core.reducers.cleanupReducers.<anonymous>.<anonymous>' call
		      // Inline function 'kotlin.let' call
		      var tmp0_safe_receiver = $this$run.a3a_1.c2(element_2);
		      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q39_1;
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp_3;
		      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w1())instanceof Completed) {
		        _this__u8e3s4.a1g(Action_init_$Create$(new CallCleanup(element_2)));
		        tmp_3 = Unit_instance;
		      }
		    }
		  }
		  function SetConfig(wsHost, wsPath, httpHost, enableWsInvites, osFamily, osRevision, sdkName, rtcStatsTelemetry, autoReconnectMedia, enableNoiseSuppression) {
		    this.n3m_1 = wsHost;
		    this.o3m_1 = wsPath;
		    this.p3m_1 = httpHost;
		    this.q3m_1 = enableWsInvites;
		    this.r3m_1 = osFamily;
		    this.s3m_1 = osRevision;
		    this.t3m_1 = sdkName;
		    this.u3m_1 = rtcStatsTelemetry;
		    this.v3m_1 = autoReconnectMedia;
		    this.w3m_1 = enableNoiseSuppression;
		  }
		  protoOf(SetConfig).toString = function () {
		    return 'SetConfig(wsHost=' + this.n3m_1 + ', wsPath=' + this.o3m_1 + ', httpHost=' + this.p3m_1 + ', enableWsInvites=' + this.q3m_1 + ', osFamily=' + this.r3m_1 + ', osRevision=' + this.s3m_1 + ', sdkName=' + this.t3m_1 + ', rtcStatsTelemetry=' + this.u3m_1 + ', autoReconnectMedia=' + this.v3m_1 + ', enableNoiseSuppression=' + this.w3m_1 + ')';
		  };
		  protoOf(SetConfig).hashCode = function () {
		    var result = getStringHashCode(this.n3m_1);
		    result = imul(result, 31) + getStringHashCode(this.o3m_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.p3m_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.q3m_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.r3m_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.s3m_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.t3m_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.u3m_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.v3m_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.w3m_1) | 0;
		    return result;
		  };
		  protoOf(SetConfig).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SetConfig))
		      return false;
		    var tmp0_other_with_cast = other instanceof SetConfig ? other : THROW_CCE();
		    if (!(this.n3m_1 === tmp0_other_with_cast.n3m_1))
		      return false;
		    if (!(this.o3m_1 === tmp0_other_with_cast.o3m_1))
		      return false;
		    if (!(this.p3m_1 === tmp0_other_with_cast.p3m_1))
		      return false;
		    if (!(this.q3m_1 === tmp0_other_with_cast.q3m_1))
		      return false;
		    if (!(this.r3m_1 === tmp0_other_with_cast.r3m_1))
		      return false;
		    if (!(this.s3m_1 === tmp0_other_with_cast.s3m_1))
		      return false;
		    if (!(this.t3m_1 === tmp0_other_with_cast.t3m_1))
		      return false;
		    if (!(this.u3m_1 === tmp0_other_with_cast.u3m_1))
		      return false;
		    if (!(this.v3m_1 === tmp0_other_with_cast.v3m_1))
		      return false;
		    if (!(this.w3m_1 === tmp0_other_with_cast.w3m_1))
		      return false;
		    return true;
		  };
		  function ConfigReducer$lambda(this$0) {
		    return function () {
		      return 'STATE INIT: ' + this$0.z3m_1;
		    };
		  }
		  function ConfigReducer(logger, state) {
		    state = state === VOID ? new ConfigState() : state;
		    Reducer_0.call(this, logger);
		    this.z3m_1 = state;
		    if (logger == null)
		      null;
		    else {
		      logger.g3h(VOID, ConfigReducer$lambda(this));
		    }
		  }
		  protoOf(ConfigReducer).a3n = function (_set____db54di) {
		    this.z3m_1 = _set____db54di;
		  };
		  protoOf(ConfigReducer).b3n = function (_set____db54di) {
		    return this.a3n(_set____db54di instanceof ConfigState ? _set____db54di : THROW_CCE());
		  };
		  protoOf(ConfigReducer).c3n = function () {
		    return this.z3m_1;
		  };
		  protoOf(ConfigReducer).d3n = function () {
		    return this.z3m_1.e3n();
		  };
		  protoOf(ConfigReducer).f3n = function (action, state) {
		    var tmp;
		    if (action.o3h_1 instanceof SetConfig) {
		      tmp = state.g3n(action.o3h_1);
		    } else {
		      tmp = null;
		    }
		    return tmp;
		  };
		  protoOf(ConfigReducer).h3n = function (action, state) {
		    return this.f3n(action, state instanceof ConfigState ? state : THROW_CCE());
		  };
		  function ConfigState(wsHost, wsPath, httpHost, rtcStatsHost, enableWsInvites, osFamily, osRevision, sdkName, rtcStatsTelemetry, autoReconnectMedia, enableNoiseSuppression) {
		    wsHost = wsHost === VOID ? null : wsHost;
		    wsPath = wsPath === VOID ? null : wsPath;
		    httpHost = httpHost === VOID ? null : httpHost;
		    rtcStatsHost = rtcStatsHost === VOID ? 'https://hlg.tokbox.com' : rtcStatsHost;
		    enableWsInvites = enableWsInvites === VOID ? true : enableWsInvites;
		    osFamily = osFamily === VOID ? null : osFamily;
		    osRevision = osRevision === VOID ? null : osRevision;
		    sdkName = sdkName === VOID ? null : sdkName;
		    rtcStatsTelemetry = rtcStatsTelemetry === VOID ? true : rtcStatsTelemetry;
		    var tmp;
		    if (autoReconnectMedia === VOID) {
		      DefaultConfig_getInstance();
		      tmp = true;
		    } else {
		      tmp = autoReconnectMedia;
		    }
		    autoReconnectMedia = tmp;
		    var tmp_0;
		    if (enableNoiseSuppression === VOID) {
		      DefaultConfig_getInstance();
		      tmp_0 = false;
		    } else {
		      tmp_0 = enableNoiseSuppression;
		    }
		    enableNoiseSuppression = tmp_0;
		    this.d3b_1 = wsHost;
		    this.e3b_1 = wsPath;
		    this.f3b_1 = httpHost;
		    this.g3b_1 = rtcStatsHost;
		    this.h3b_1 = enableWsInvites;
		    this.i3b_1 = osFamily;
		    this.j3b_1 = osRevision;
		    this.k3b_1 = sdkName;
		    this.l3b_1 = rtcStatsTelemetry;
		    this.m3b_1 = autoReconnectMedia;
		    this.n3b_1 = enableNoiseSuppression;
		  }
		  protoOf(ConfigState).g3n = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.ConfigState.update.<anonymous>' call
		    this.f3b_1 = action.p3m_1;
		    this.d3b_1 = action.n3m_1;
		    this.e3b_1 = action.o3m_1;
		    this.h3b_1 = action.q3m_1;
		    this.i3b_1 = action.r3m_1;
		    this.j3b_1 = action.s3m_1;
		    this.k3b_1 = action.t3m_1;
		    this.l3b_1 = action.u3m_1;
		    this.m3b_1 = action.v3m_1;
		    this.n3b_1 = action.w3m_1;
		    return this;
		  };
		  protoOf(ConfigState).l3n = function (wsHost, wsPath, httpHost, rtcStatsHost, enableWsInvites, osFamily, osRevision, sdkName, rtcStatsTelemetry, autoReconnectMedia, enableNoiseSuppression) {
		    return new ConfigState(wsHost, wsPath, httpHost, rtcStatsHost, enableWsInvites, osFamily, osRevision, sdkName, rtcStatsTelemetry, autoReconnectMedia, enableNoiseSuppression);
		  };
		  protoOf(ConfigState).e3n = function (wsHost, wsPath, httpHost, rtcStatsHost, enableWsInvites, osFamily, osRevision, sdkName, rtcStatsTelemetry, autoReconnectMedia, enableNoiseSuppression, $super) {
		    wsHost = wsHost === VOID ? this.d3b_1 : wsHost;
		    wsPath = wsPath === VOID ? this.e3b_1 : wsPath;
		    httpHost = httpHost === VOID ? this.f3b_1 : httpHost;
		    rtcStatsHost = rtcStatsHost === VOID ? this.g3b_1 : rtcStatsHost;
		    enableWsInvites = enableWsInvites === VOID ? this.h3b_1 : enableWsInvites;
		    osFamily = osFamily === VOID ? this.i3b_1 : osFamily;
		    osRevision = osRevision === VOID ? this.j3b_1 : osRevision;
		    sdkName = sdkName === VOID ? this.k3b_1 : sdkName;
		    rtcStatsTelemetry = rtcStatsTelemetry === VOID ? this.l3b_1 : rtcStatsTelemetry;
		    autoReconnectMedia = autoReconnectMedia === VOID ? this.m3b_1 : autoReconnectMedia;
		    enableNoiseSuppression = enableNoiseSuppression === VOID ? this.n3b_1 : enableNoiseSuppression;
		    return $super === VOID ? this.l3n(wsHost, wsPath, httpHost, rtcStatsHost, enableWsInvites, osFamily, osRevision, sdkName, rtcStatsTelemetry, autoReconnectMedia, enableNoiseSuppression) : $super.l3n.call(this, wsHost, wsPath, httpHost, rtcStatsHost, enableWsInvites, osFamily, osRevision, sdkName, rtcStatsTelemetry, autoReconnectMedia, enableNoiseSuppression);
		  };
		  protoOf(ConfigState).toString = function () {
		    return 'ConfigState(wsHost=' + this.d3b_1 + ', wsPath=' + this.e3b_1 + ', httpHost=' + this.f3b_1 + ', rtcStatsHost=' + this.g3b_1 + ', enableWsInvites=' + this.h3b_1 + ', osFamily=' + this.i3b_1 + ', osRevision=' + this.j3b_1 + ', sdkName=' + this.k3b_1 + ', rtcStatsTelemetry=' + this.l3b_1 + ', autoReconnectMedia=' + this.m3b_1 + ', enableNoiseSuppression=' + this.n3b_1 + ')';
		  };
		  protoOf(ConfigState).hashCode = function () {
		    var result = this.d3b_1 == null ? 0 : getStringHashCode(this.d3b_1);
		    result = imul(result, 31) + (this.e3b_1 == null ? 0 : getStringHashCode(this.e3b_1)) | 0;
		    result = imul(result, 31) + (this.f3b_1 == null ? 0 : getStringHashCode(this.f3b_1)) | 0;
		    result = imul(result, 31) + (this.g3b_1 == null ? 0 : getStringHashCode(this.g3b_1)) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.h3b_1) | 0;
		    result = imul(result, 31) + (this.i3b_1 == null ? 0 : getStringHashCode(this.i3b_1)) | 0;
		    result = imul(result, 31) + (this.j3b_1 == null ? 0 : getStringHashCode(this.j3b_1)) | 0;
		    result = imul(result, 31) + (this.k3b_1 == null ? 0 : getStringHashCode(this.k3b_1)) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.l3b_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.m3b_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.n3b_1) | 0;
		    return result;
		  };
		  protoOf(ConfigState).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ConfigState))
		      return false;
		    var tmp0_other_with_cast = other instanceof ConfigState ? other : THROW_CCE();
		    if (!(this.d3b_1 == tmp0_other_with_cast.d3b_1))
		      return false;
		    if (!(this.e3b_1 == tmp0_other_with_cast.e3b_1))
		      return false;
		    if (!(this.f3b_1 == tmp0_other_with_cast.f3b_1))
		      return false;
		    if (!(this.g3b_1 == tmp0_other_with_cast.g3b_1))
		      return false;
		    if (!(this.h3b_1 === tmp0_other_with_cast.h3b_1))
		      return false;
		    if (!(this.i3b_1 == tmp0_other_with_cast.i3b_1))
		      return false;
		    if (!(this.j3b_1 == tmp0_other_with_cast.j3b_1))
		      return false;
		    if (!(this.k3b_1 == tmp0_other_with_cast.k3b_1))
		      return false;
		    if (!(this.l3b_1 === tmp0_other_with_cast.l3b_1))
		      return false;
		    if (!(this.m3b_1 === tmp0_other_with_cast.m3b_1))
		      return false;
		    if (!(this.n3b_1 === tmp0_other_with_cast.n3b_1))
		      return false;
		    return true;
		  };
		  function modify(_this__u8e3s4, id, fn) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.modify.<anonymous>' call
		    var tmp0_safe_receiver = _this__u8e3s4.m3n().c2(id);
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.apply' call
		      // Inline function 'kotlin.contracts.contract' call
		      fn(tmp0_safe_receiver);
		    }
		    _this__u8e3s4.n3n(id);
		    return _this__u8e3s4;
		  }
		  function new_0(_this__u8e3s4, id, fn) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.new.<anonymous>' call
		    // Inline function 'kotlin.let' call
		    // Inline function 'kotlin.contracts.contract' call
		    var tmp0_safe_receiver = fn(_this__u8e3s4);
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.also' call
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.reducers.new.<anonymous>.<anonymous>' call
		      // Inline function 'kotlin.collections.set' call
		      _this__u8e3s4.m3n().s1(id, tmp0_safe_receiver);
		      _this__u8e3s4.n3n(id);
		    }
		    return _this__u8e3s4;
		  }
		  function RemoteEventReducer$lambda(this$0) {
		    return function () {
		      return 'STATE INIT: ' + this$0.q3n_1;
		    };
		  }
		  function RemoteEventReducer(logger, state) {
		    state = state === VOID ? new RemoteEventState() : state;
		    Reducer_0.call(this, logger);
		    this.q3n_1 = state;
		    if (logger == null)
		      null;
		    else {
		      logger.g3h(VOID, RemoteEventReducer$lambda(this));
		    }
		  }
		  protoOf(RemoteEventReducer).r3n = function (_set____db54di) {
		    this.q3n_1 = _set____db54di;
		  };
		  protoOf(RemoteEventReducer).b3n = function (_set____db54di) {
		    return this.r3n(_set____db54di instanceof RemoteEventState ? _set____db54di : THROW_CCE());
		  };
		  protoOf(RemoteEventReducer).c3n = function () {
		    return this.q3n_1;
		  };
		  protoOf(RemoteEventReducer).d3n = function () {
		    return this.q3n_1;
		  };
		  protoOf(RemoteEventReducer).s3n = function (action, state) {
		    var tmp0_subject = action.o3h_1;
		    var tmp;
		    if (isInterface(tmp0_subject, SocketEvent)) {
		      tmp = state.u3n(action.o3h_1);
		    } else {
		      if (tmp0_subject instanceof BufferedSocketEvent) {
		        tmp = state.t3n(action.o3h_1);
		      } else {
		        tmp = null;
		      }
		    }
		    return tmp;
		  };
		  protoOf(RemoteEventReducer).h3n = function (action, state) {
		    return this.s3n(action, state instanceof RemoteEventState ? state : THROW_CCE());
		  };
		  function RemoteEventState(buffers, lastModified) {
		    var tmp;
		    if (buffers === VOID) {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      tmp = LinkedHashMap_init_$Create$();
		    } else {
		      tmp = buffers;
		    }
		    buffers = tmp;
		    lastModified = lastModified === VOID ? null : lastModified;
		    this.u2y_1 = buffers;
		    this.v2y_1 = lastModified;
		  }
		  protoOf(RemoteEventState).u3n = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.RemoteEventState.update.<anonymous>' call
		    // Inline function 'kotlin.collections.getOrPut' call
		    var this_0 = this.u2y_1;
		    var tmp0_elvis_lhs = action.u27();
		    var tmp;
		    if (tmp0_elvis_lhs == null) {
		      tmp = 'default';
		    } else {
		      tmp = tmp0_elvis_lhs;
		    }
		    var key = tmp;
		    var value = this_0.c2(key);
		    var tmp_0;
		    if (value == null) {
		      // Inline function 'com.vonage.clientcore.core.reducers.RemoteEventState.update.<anonymous>.<anonymous>' call
		      var answer = new EventBuffer();
		      this_0.s1(key, answer);
		      tmp_0 = answer;
		    } else {
		      tmp_0 = value;
		    }
		    var buffer = tmp_0;
		    buffer.y2y_1 = action;
		    var tmp_1 = this;
		    var tmp1_elvis_lhs = action.u27();
		    var tmp_2;
		    if (tmp1_elvis_lhs == null) {
		      tmp_2 = 'default';
		    } else {
		      tmp_2 = tmp1_elvis_lhs;
		    }
		    tmp_1.v2y_1 = tmp_2;
		    var tmp2_elvis_lhs = action.t27();
		    if ((tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs) > buffer.w2y_1) {
		      var tmp_3 = buffer;
		      var tmp3_elvis_lhs = action.t27();
		      tmp_3.w2y_1 = tmp3_elvis_lhs == null ? buffer.w2y_1 : tmp3_elvis_lhs;
		    }
		    if (buffer.w2y_1 > buffer.x2y_1) {
		      buffer.x2y_1 = buffer.w2y_1;
		    }
		    return this;
		  };
		  protoOf(RemoteEventState).t3n = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.RemoteEventState.update.<anonymous>' call
		    // Inline function 'kotlin.collections.getOrPut' call
		    var this_0 = this.u2y_1;
		    var key = action.w3n_1;
		    var value = this_0.c2(key);
		    var tmp;
		    if (value == null) {
		      // Inline function 'com.vonage.clientcore.core.reducers.RemoteEventState.update.<anonymous>.<anonymous>' call
		      var answer = new EventBuffer();
		      this_0.s1(key, answer);
		      tmp = answer;
		    } else {
		      tmp = value;
		    }
		    var buffer = tmp;
		    if (action.x3n_1 > buffer.x2y_1) {
		      buffer.x2y_1 = action.x3n_1;
		      buffer.z2y_1 = action.v3n_1;
		      this.v2y_1 = action.w3n_1;
		    }
		    return this;
		  };
		  protoOf(RemoteEventState).toString = function () {
		    return 'RemoteEventState(buffers=' + this.u2y_1 + ', lastModified=' + this.v2y_1 + ')';
		  };
		  protoOf(RemoteEventState).hashCode = function () {
		    var result = hashCode(this.u2y_1);
		    result = imul(result, 31) + (this.v2y_1 == null ? 0 : getStringHashCode(this.v2y_1)) | 0;
		    return result;
		  };
		  protoOf(RemoteEventState).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RemoteEventState))
		      return false;
		    var tmp0_other_with_cast = other instanceof RemoteEventState ? other : THROW_CCE();
		    if (!equals(this.u2y_1, tmp0_other_with_cast.u2y_1))
		      return false;
		    if (!(this.v2y_1 == tmp0_other_with_cast.v2y_1))
		      return false;
		    return true;
		  };
		  function SessionReducer$lambda(this$0) {
		    return function () {
		      return 'STATE INIT: ' + this$0.a3o_1;
		    };
		  }
		  function SessionReducer(logger, state) {
		    state = state === VOID ? new SessionState() : state;
		    Reducer_0.call(this, logger);
		    this.a3o_1 = state;
		    if (logger == null)
		      null;
		    else {
		      logger.g3h(VOID, SessionReducer$lambda(this));
		    }
		  }
		  protoOf(SessionReducer).b3o = function (_set____db54di) {
		    this.a3o_1 = _set____db54di;
		  };
		  protoOf(SessionReducer).b3n = function (_set____db54di) {
		    return this.b3o(_set____db54di instanceof SessionState ? _set____db54di : THROW_CCE());
		  };
		  protoOf(SessionReducer).c3n = function () {
		    return this.a3o_1;
		  };
		  protoOf(SessionReducer).d3n = function () {
		    return this.a3o_1.c3o();
		  };
		  protoOf(SessionReducer).d3o = function (action, state) {
		    var tmp0_subject = action.o3h_1;
		    var tmp;
		    if (tmp0_subject instanceof SocketStatus) {
		      tmp = state.s3o(action.o3h_1);
		    } else {
		      if (tmp0_subject instanceof SocketConnect) {
		        tmp = state.r3o(action.o3h_1, action.p3h_1.q3h_1);
		      } else {
		        if (tmp0_subject instanceof SocketConnectEmptyTokenError) {
		          tmp = state.q3o(action.o3h_1, action.p3h_1.q3h_1);
		        } else {
		          if (tmp0_subject instanceof SessionSuccessEvent) {
		            tmp = state.p3o(action.o3h_1);
		          } else {
		            if (tmp0_subject instanceof DeleteSession) {
		              tmp = state.o3o(action.o3h_1);
		            } else {
		              if (tmp0_subject instanceof SocketSetSession) {
		                tmp = state.n3o(action.o3h_1);
		              } else {
		                if (tmp0_subject instanceof SessionTimerEvent) {
		                  tmp = state.m3o(action.o3h_1);
		                } else {
		                  if (tmp0_subject instanceof SessionInvalidTokenEvent) {
		                    tmp = state.l3o(action.o3h_1);
		                  } else {
		                    if (tmp0_subject instanceof SessionInvalidEvent) {
		                      tmp = state.k3o(action.o3h_1);
		                    } else {
		                      if (tmp0_subject instanceof SessionExpiredTokenEvent) {
		                        tmp = state.j3o(action.o3h_1);
		                      } else {
		                        if (tmp0_subject instanceof SessionMaxOpenEvent) {
		                          tmp = state.i3o(action.o3h_1);
		                        } else {
		                          if (tmp0_subject instanceof AuthorizationErrorEvent) {
		                            tmp = state.h3o(action.o3h_1);
		                          } else {
		                            if (tmp0_subject instanceof MemberInvitedEvent) {
		                              tmp = state.g3o(action.o3h_1);
		                            } else {
		                              if (tmp0_subject instanceof MemberJoinedEvent) {
		                                tmp = state.f3o(action.o3h_1);
		                              } else {
		                                if (tmp0_subject instanceof MetricsSuccessfullySent) {
		                                  tmp = state.e3o(action.o3h_1);
		                                } else {
		                                  tmp = null;
		                                }
		                              }
		                            }
		                          }
		                        }
		                      }
		                    }
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  };
		  protoOf(SessionReducer).h3n = function (action, state) {
		    return this.d3o(action, state instanceof SessionState ? state : THROW_CCE());
		  };
		  function SessionState(sessionStatus, connectionStatus, timeOfFirstRetry, retryNumber, reason, token, applicationId) {
		    sessionStatus = sessionStatus === VOID ? new Resolved(None_getInstance()) : sessionStatus;
		    connectionStatus = connectionStatus === VOID ? new SocketConnectionStatusWrapper(SocketConnectionStatus_Disconnected_getInstance(), null) : connectionStatus;
		    timeOfFirstRetry = timeOfFirstRetry === VOID ? null : timeOfFirstRetry;
		    retryNumber = retryNumber === VOID ? null : retryNumber;
		    reason = reason === VOID ? null : reason;
		    token = token === VOID ? null : token;
		    applicationId = applicationId === VOID ? null : applicationId;
		    this.l38_1 = sessionStatus;
		    this.m38_1 = connectionStatus;
		    this.n38_1 = timeOfFirstRetry;
		    this.o38_1 = retryNumber;
		    this.p38_1 = reason;
		    this.q38_1 = token;
		    this.r38_1 = applicationId;
		  }
		  protoOf(SessionState).toString = function () {
		    return toMaskedString(this, mapOf([to('sessionStatus', toString(this.l38_1)), to('connectionStatus', this.m38_1.toString()), to('timeOfFirstRetry', toString_0(this.n38_1)), to('retryNumber', toString_0(this.o38_1)), to('reason', toString_0(this.p38_1)), to('token', toString_0(this.q38_1)), to('applicationId', toString_0(this.r38_1))]));
		  };
		  protoOf(SessionState).r3o = function (action, uuid) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.l38_1 = toPending(this.l38_1, new Active('', new SessionUser('', ''), null, ''), uuid);
		    this.q38_1 = action.h2o_1;
		    return this;
		  };
		  protoOf(SessionState).q3o = function (action, uuid) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.l38_1 = toPending(this.l38_1, None_getInstance(), uuid);
		    this.l38_1 = toFailed(this.l38_1, new SessionEmptyTokenError());
		    return this;
		  };
		  protoOf(SessionState).e3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.n38_1 = action.s2o_1;
		    this.o38_1 = action.r2o_1;
		    return this;
		  };
		  protoOf(SessionState).s3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    if (action.z2o_1.equals(SocketConnectionStatus_Disconnected_getInstance())) {
		      var tmp0_subject = this.l38_1;
		      if (tmp0_subject instanceof Pending) {
		        if (!equals(action.a2p_1, SocketConnectionFailedReason_ClientDisconnected_getInstance())) {
		          this.l38_1 = toFailed(this.l38_1, new SessionSocketTransportError());
		        }
		      } else {
		        if (tmp0_subject instanceof Resolved) {
		          var tmp;
		          var tmp1_safe_receiver = this.l38_1.w1().t27();
		          if ((tmp1_safe_receiver == null ? null : equals(tmp1_safe_receiver, '')) === true) {
		            tmp = true;
		          } else {
		            tmp = this.l38_1.w1().t27() == null;
		          }
		          if (!tmp) {
		            if (this.m38_1.p2o_1.equals(SocketConnectionStatus_Reconnecting_getInstance())) {
		              this.l38_1 = new Resolved(new Inactive(null, null, SessionErrorReason_TransportClosed_getInstance()));
		            }
		            if (this.m38_1.p2o_1.equals(SocketConnectionStatus_Connected_getInstance())) {
		              var tmp2_subject = action.a2p_1;
		              switch (tmp2_subject == null ? -1 : tmp2_subject.i8_1) {
		                case 0:
		                  this.l38_1 = new Resolved(new Inactive(null, null, SessionErrorReason_TokenExpired_getInstance()));
		                  break;
		                case 3:
		                  this.l38_1 = new Resolved(new Inactive(null, null, SessionErrorReason_PingTimeout_getInstance()));
		                  break;
		                case 2:
		                  this.l38_1 = new Resolved(new Inactive(null, null, SessionErrorReason_TransportClosed_getInstance()));
		                  break;
		                default:
		                  break;
		              }
		            }
		          } else {
		            if (action.z2o_1.equals(SocketConnectionStatus_Disconnected_getInstance())) {
		              if (equals(action.a2p_1, SocketConnectionFailedReason_ClientDisconnected_getInstance())) {
		                this.p38_1 = SocketConnectionFailedReason_ClientDisconnected_getInstance();
		              }
		            }
		          }
		        }
		      }
		    } else if (action.z2o_1.equals(SocketConnectionStatus_Reconnecting_getInstance())) {
		      this.m38_1 = new SocketConnectionStatusWrapper(SocketConnectionStatus_Reconnecting_getInstance(), generateTimeStamp());
		      this.o38_1 = action.c2p_1;
		      if (this.n38_1 == null) {
		        this.n38_1 = action.b2p_1;
		      }
		    }
		    this.m38_1 = new SocketConnectionStatusWrapper(action.z2o_1, generateTimeStamp());
		    return this;
		  };
		  protoOf(SessionState).p3o = function (event) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.p38_1 = null;
		    this.l38_1 = toResolved(this.l38_1, new Active(event.r2b_1.z2b_1, new SessionUser(event.r2b_1.a2c_1, event.r2b_1.b2c_1), VOID, event.r2b_1.c2c_1));
		    return this;
		  };
		  protoOf(SessionState).m3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    var tmp;
		    var tmp_0 = this.l38_1;
		    if (tmp_0 instanceof Pending) {
		      tmp = this.l38_1.x3a() === action.d2p_1.p3h_1.q3h_1;
		    } else {
		      tmp = false;
		    }
		    if (tmp) {
		      this.l38_1 = toFailed(this.l38_1, new SessionTimeoutError());
		    }
		    return this;
		  };
		  protoOf(SessionState).k3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.l38_1 = toFailed(this.l38_1, new SessionInvalidError());
		    return this;
		  };
		  protoOf(SessionState).l3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.l38_1 = toFailed(this.l38_1, new SessionInvalidTokenError());
		    return this;
		  };
		  protoOf(SessionState).h3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.l38_1 = toFailed(this.l38_1, new AuthorizationError());
		    return this;
		  };
		  protoOf(SessionState).j3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.l38_1 = toFailed(this.l38_1, new SessionExpiredTokenError());
		    return this;
		  };
		  protoOf(SessionState).i3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.l38_1 = toFailed(this.l38_1, new SessionMaxOpenSessions());
		    return this;
		  };
		  protoOf(SessionState).o3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.q38_1 = null;
		    this.l38_1 = new Resolved(None_getInstance());
		    return this;
		  };
		  protoOf(SessionState).n3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.q38_1 = action.o2o_1;
		    return this;
		  };
		  protoOf(SessionState).g3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.r38_1 = action.n2d_1;
		    return this;
		  };
		  protoOf(SessionState).f3o = function (action) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.SessionState.update.<anonymous>' call
		    this.r38_1 = action.m2c_1;
		    return this;
		  };
		  protoOf(SessionState).t3o = function (sessionStatus, connectionStatus, timeOfFirstRetry, retryNumber, reason, token, applicationId) {
		    return new SessionState(sessionStatus, connectionStatus, timeOfFirstRetry, retryNumber, reason, token, applicationId);
		  };
		  protoOf(SessionState).c3o = function (sessionStatus, connectionStatus, timeOfFirstRetry, retryNumber, reason, token, applicationId, $super) {
		    sessionStatus = sessionStatus === VOID ? this.l38_1 : sessionStatus;
		    connectionStatus = connectionStatus === VOID ? this.m38_1 : connectionStatus;
		    timeOfFirstRetry = timeOfFirstRetry === VOID ? this.n38_1 : timeOfFirstRetry;
		    retryNumber = retryNumber === VOID ? this.o38_1 : retryNumber;
		    reason = reason === VOID ? this.p38_1 : reason;
		    token = token === VOID ? this.q38_1 : token;
		    applicationId = applicationId === VOID ? this.r38_1 : applicationId;
		    return $super === VOID ? this.t3o(sessionStatus, connectionStatus, timeOfFirstRetry, retryNumber, reason, token, applicationId) : $super.t3o.call(this, sessionStatus, connectionStatus, timeOfFirstRetry, retryNumber, reason, token, applicationId);
		  };
		  protoOf(SessionState).hashCode = function () {
		    var result = hashCode(this.l38_1);
		    result = imul(result, 31) + this.m38_1.hashCode() | 0;
		    result = imul(result, 31) + (this.n38_1 == null ? 0 : hashCode(this.n38_1)) | 0;
		    result = imul(result, 31) + (this.o38_1 == null ? 0 : this.o38_1) | 0;
		    result = imul(result, 31) + (this.p38_1 == null ? 0 : this.p38_1.hashCode()) | 0;
		    result = imul(result, 31) + (this.q38_1 == null ? 0 : getStringHashCode(this.q38_1)) | 0;
		    result = imul(result, 31) + (this.r38_1 == null ? 0 : getStringHashCode(this.r38_1)) | 0;
		    return result;
		  };
		  protoOf(SessionState).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionState))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionState ? other : THROW_CCE();
		    if (!equals(this.l38_1, tmp0_other_with_cast.l38_1))
		      return false;
		    if (!this.m38_1.equals(tmp0_other_with_cast.m38_1))
		      return false;
		    if (!equals(this.n38_1, tmp0_other_with_cast.n38_1))
		      return false;
		    if (!(this.o38_1 == tmp0_other_with_cast.o38_1))
		      return false;
		    if (!equals(this.p38_1, tmp0_other_with_cast.p38_1))
		      return false;
		    if (!(this.q38_1 == tmp0_other_with_cast.q38_1))
		      return false;
		    if (!(this.r38_1 == tmp0_other_with_cast.r38_1))
		      return false;
		    return true;
		  };
		  function SessionUser(id, name) {
		    this.n2u_1 = id;
		    this.o2u_1 = name;
		  }
		  protoOf(SessionUser).toString = function () {
		    return 'SessionUser(id=' + this.n2u_1 + ', name=' + this.o2u_1 + ')';
		  };
		  protoOf(SessionUser).hashCode = function () {
		    var result = getStringHashCode(this.n2u_1);
		    result = imul(result, 31) + getStringHashCode(this.o2u_1) | 0;
		    return result;
		  };
		  protoOf(SessionUser).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof SessionUser))
		      return false;
		    var tmp0_other_with_cast = other instanceof SessionUser ? other : THROW_CCE();
		    if (!(this.n2u_1 === tmp0_other_with_cast.n2u_1))
		      return false;
		    if (!(this.o2u_1 === tmp0_other_with_cast.o2u_1))
		      return false;
		    return true;
		  };
		  function Call_0(isReconnect, from, customData, id, memberState, legState, localMedia, callConnectivityState, mediaState) {
		    isReconnect = isReconnect === VOID ? false : isReconnect;
		    customData = customData === VOID ? null : customData;
		    memberState = memberState === VOID ? new Resolved(None_instance_1) : memberState;
		    legState = legState === VOID ? new Resolved(None_getInstance_0()) : legState;
		    localMedia = localMedia === VOID ? new MediaTransport() : localMedia;
		    callConnectivityState = callConnectivityState === VOID ? New_instance : callConnectivityState;
		    mediaState = mediaState === VOID ? MediaConnectionState_New_getInstance() : mediaState;
		    this.l39_1 = isReconnect;
		    this.m39_1 = from;
		    this.n39_1 = customData;
		    this.o39_1 = id;
		    this.p39_1 = memberState;
		    this.q39_1 = legState;
		    this.r39_1 = localMedia;
		    this.s39_1 = callConnectivityState;
		    this.t39_1 = mediaState;
		  }
		  protoOf(Call_0).u3o = function (isReconnect, from, customData, id, memberState, legState, localMedia, callConnectivityState, mediaState) {
		    return new Call_0(isReconnect, from, customData, id, memberState, legState, localMedia, callConnectivityState, mediaState);
		  };
		  protoOf(Call_0).o3b = function (isReconnect, from, customData, id, memberState, legState, localMedia, callConnectivityState, mediaState, $super) {
		    isReconnect = isReconnect === VOID ? this.l39_1 : isReconnect;
		    from = from === VOID ? this.m39_1 : from;
		    customData = customData === VOID ? this.n39_1 : customData;
		    id = id === VOID ? this.o39_1 : id;
		    memberState = memberState === VOID ? this.p39_1 : memberState;
		    legState = legState === VOID ? this.q39_1 : legState;
		    localMedia = localMedia === VOID ? this.r39_1 : localMedia;
		    callConnectivityState = callConnectivityState === VOID ? this.s39_1 : callConnectivityState;
		    mediaState = mediaState === VOID ? this.t39_1 : mediaState;
		    return $super === VOID ? this.u3o(isReconnect, from, customData, id, memberState, legState, localMedia, callConnectivityState, mediaState) : $super.u3o.call(this, isReconnect, from, customData, id, memberState, legState, localMedia, callConnectivityState, mediaState);
		  };
		  protoOf(Call_0).toString = function () {
		    return 'Call(isReconnect=' + this.l39_1 + ', from=' + this.m39_1 + ', customData=' + this.n39_1 + ', id=' + this.o39_1 + ', memberState=' + this.p39_1 + ', legState=' + this.q39_1 + ', localMedia=' + this.r39_1 + ', callConnectivityState=' + this.s39_1 + ', mediaState=' + this.t39_1 + ')';
		  };
		  protoOf(Call_0).hashCode = function () {
		    var result = getBooleanHashCode(this.l39_1);
		    result = imul(result, 31) + hashCode(this.m39_1) | 0;
		    result = imul(result, 31) + (this.n39_1 == null ? 0 : hashCode(this.n39_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.o39_1) | 0;
		    result = imul(result, 31) + hashCode(this.p39_1) | 0;
		    result = imul(result, 31) + hashCode(this.q39_1) | 0;
		    result = imul(result, 31) + this.r39_1.hashCode() | 0;
		    result = imul(result, 31) + hashCode(this.s39_1) | 0;
		    result = imul(result, 31) + this.t39_1.hashCode() | 0;
		    return result;
		  };
		  protoOf(Call_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Call_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof Call_0 ? other : THROW_CCE();
		    if (!(this.l39_1 === tmp0_other_with_cast.l39_1))
		      return false;
		    if (!equals(this.m39_1, tmp0_other_with_cast.m39_1))
		      return false;
		    if (!equals(this.n39_1, tmp0_other_with_cast.n39_1))
		      return false;
		    if (!(this.o39_1 === tmp0_other_with_cast.o39_1))
		      return false;
		    if (!equals(this.p39_1, tmp0_other_with_cast.p39_1))
		      return false;
		    if (!equals(this.q39_1, tmp0_other_with_cast.q39_1))
		      return false;
		    if (!this.r39_1.equals(tmp0_other_with_cast.r39_1))
		      return false;
		    if (!equals(this.s39_1, tmp0_other_with_cast.s39_1))
		      return false;
		    if (!this.t39_1.equals(tmp0_other_with_cast.t39_1))
		      return false;
		    return true;
		  };
		  var CallDirection_outbound_instance;
		  var CallDirection_inbound_instance;
		  var CallDirection_entriesInitialized;
		  function CallDirection_initEntries() {
		    if (CallDirection_entriesInitialized)
		      return Unit_instance;
		    CallDirection_entriesInitialized = true;
		    CallDirection_outbound_instance = new CallDirection('outbound', 0);
		    CallDirection_inbound_instance = new CallDirection('inbound', 1);
		  }
		  function CallDirection(name, ordinal) {
		    Enum.call(this, name, ordinal);
		  }
		  function CallDirection_outbound_getInstance() {
		    CallDirection_initEntries();
		    return CallDirection_outbound_instance;
		  }
		  function CallDirection_inbound_getInstance() {
		    CallDirection_initEntries();
		    return CallDirection_inbound_instance;
		  }
		  function New() {
		  }
		  var New_instance;
		  function New_getInstance() {
		    return New_instance;
		  }
		  function Connected() {
		  }
		  var Connected_instance;
		  function Connected_getInstance() {
		    return Connected_instance;
		  }
		  function Disconnected() {
		  }
		  var Disconnected_instance;
		  function Disconnected_getInstance() {
		    return Disconnected_instance;
		  }
		  function Reconnecting(retryCount) {
		    retryCount = retryCount === VOID ? 0 : retryCount;
		    this.o3a_1 = retryCount;
		  }
		  protoOf(Reconnecting).toString = function () {
		    return 'Reconnecting(retryCount=' + this.o3a_1 + ')';
		  };
		  protoOf(Reconnecting).hashCode = function () {
		    return this.o3a_1;
		  };
		  protoOf(Reconnecting).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Reconnecting))
		      return false;
		    var tmp0_other_with_cast = other instanceof Reconnecting ? other : THROW_CCE();
		    if (!(this.o3a_1 === tmp0_other_with_cast.o3a_1))
		      return false;
		    return true;
		  };
		  function CallReducer$lambda(this$0) {
		    return function () {
		      return 'STATE INIT: ' + this$0.x3o_1;
		    };
		  }
		  function CallReducer(logger, state) {
		    state = state === VOID ? new CallState() : state;
		    Reducer_0.call(this, logger);
		    this.x3o_1 = state;
		    if (logger == null)
		      null;
		    else {
		      logger.g3h(VOID, CallReducer$lambda(this));
		    }
		  }
		  protoOf(CallReducer).y3o = function (_set____db54di) {
		    this.x3o_1 = _set____db54di;
		  };
		  protoOf(CallReducer).b3n = function (_set____db54di) {
		    return this.y3o(_set____db54di instanceof CallState ? _set____db54di : THROW_CCE());
		  };
		  protoOf(CallReducer).c3n = function () {
		    return this.x3o_1;
		  };
		  protoOf(CallReducer).d3n = function () {
		    return this.x3o_1;
		  };
		  protoOf(CallReducer).z3o = function (action, state) {
		    var tmp0_subject = action.o3h_1;
		    var tmp;
		    if (tmp0_subject instanceof ErrorReport) {
		      var tmp1_elvis_lhs = action.p3h_1.r3h_1;
		      tmp = state.b3q(action.o3h_1, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
		    } else {
		      if (tmp0_subject instanceof SessionSuccessEvent) {
		        tmp = state.p3o(action.o3h_1);
		      } else {
		        if (isInterface(tmp0_subject, MediaEvent)) {
		          var callId = action.o3h_1.t27();
		          var tmp2_subject = action.o3h_1;
		          var tmp_0;
		          if (tmp2_subject instanceof MediaOffer) {
		            tmp_0 = state.a3q(action.o3h_1, callId);
		          } else {
		            if (tmp2_subject instanceof MediaAnswer) {
		              tmp_0 = state.z3p(action.o3h_1, callId);
		            } else {
		              if (tmp2_subject instanceof MediaDisable) {
		                tmp_0 = state.y3p(action.o3h_1, callId);
		              } else {
		                if (tmp2_subject instanceof MediaConnectionStateUpdate) {
		                  tmp_0 = state.x3p(action.o3h_1, callId);
		                } else {
		                  if (tmp2_subject instanceof CallReconnectionRetry) {
		                    tmp_0 = state.w3p(action.o3h_1, callId);
		                  } else {
		                    tmp_0 = null;
		                  }
		                }
		              }
		            }
		          }
		          tmp = tmp_0;
		        } else {
		          if (isInterface(tmp0_subject, CallEvent)) {
		            var tmp3_subject = action.o3h_1;
		            var tmp_1;
		            if (tmp3_subject instanceof CallMemberMediaTimeout) {
		              tmp_1 = state.v3p(action.o3h_1, action.o3h_1.r3c_1);
		            } else {
		              if (tmp3_subject instanceof CallKnockingRequestFailure) {
		                tmp_1 = state.u3p(action.o3h_1, action.o3h_1.x3b_1);
		              } else {
		                if (tmp3_subject instanceof CallCreate) {
		                  tmp_1 = state.t3p(action.o3h_1, action.o3h_1.m3c_1);
		                } else {
		                  if (tmp3_subject instanceof CallReconnect) {
		                    tmp_1 = state.s3p(action.o3h_1, action.o3h_1.a3c_1);
		                  } else {
		                    if (tmp3_subject instanceof CallReconnectSuccess) {
		                      tmp_1 = state.r3p(action.o3h_1, action.o3h_1.j3c_1);
		                    } else {
		                      if (tmp3_subject instanceof CallReconnectFailure) {
		                        tmp_1 = state.q3p(action.o3h_1, action.o3h_1.k3c_1);
		                      } else {
		                        if (tmp3_subject instanceof CallCleanup) {
		                          tmp_1 = state.p3p(action.o3h_1, action.o3h_1.z3b_1);
		                        } else {
		                          if (tmp3_subject instanceof CallConversationUpdate) {
		                            tmp_1 = state.o3p(action.o3h_1, action.o3h_1.u3c_1);
		                          } else {
		                            tmp_1 = null;
		                          }
		                        }
		                      }
		                    }
		                  }
		                }
		              }
		            }
		            tmp = tmp_1;
		          } else {
		            if (isInterface(tmp0_subject, SocketEvent)) {
		              var tmp4_subject = action.o3h_1;
		              var tmp_2;
		              if (tmp4_subject instanceof MemberInvitedEvent) {
		                var tmp5_safe_receiver = action.o3h_1.h2d_1.e2b_1.k26_1;
		                var tmp_3;
		                if (tmp5_safe_receiver == null) {
		                  tmp_3 = null;
		                } else {
		                  // Inline function 'kotlin.let' call
		                  // Inline function 'kotlin.contracts.contract' call
		                  // Inline function 'com.vonage.clientcore.core.reducers.call.CallReducer.reduce.<anonymous>' call
		                  tmp_3 = state.n3p(action.o3h_1, tmp5_safe_receiver);
		                }
		                tmp_2 = tmp_3;
		              } else {
		                if (tmp4_subject instanceof MemberMediaEvent) {
		                  var tmp6_safe_receiver = action.o3h_1.s2d_1.z2d_1.k26_1;
		                  var tmp_4;
		                  if (tmp6_safe_receiver == null) {
		                    tmp_4 = null;
		                  } else {
		                    // Inline function 'kotlin.let' call
		                    // Inline function 'kotlin.contracts.contract' call
		                    // Inline function 'com.vonage.clientcore.core.reducers.call.CallReducer.reduce.<anonymous>' call
		                    tmp_4 = state.m3p(action.o3h_1, tmp6_safe_receiver);
		                  }
		                  tmp_2 = tmp_4;
		                } else {
		                  if (tmp4_subject instanceof MemberLeftEvent) {
		                    var tmp7_safe_receiver = action.o3h_1.c2e_1.m2e_1.k26_1;
		                    var tmp_5;
		                    if (tmp7_safe_receiver == null) {
		                      tmp_5 = null;
		                    } else {
		                      // Inline function 'kotlin.let' call
		                      // Inline function 'kotlin.contracts.contract' call
		                      // Inline function 'com.vonage.clientcore.core.reducers.call.CallReducer.reduce.<anonymous>' call
		                      tmp_5 = state.l3p(action.o3h_1, tmp7_safe_receiver);
		                    }
		                    tmp_2 = tmp_5;
		                  } else {
		                    if (tmp4_subject instanceof MemberJoinedEvent) {
		                      var tmp8_safe_receiver = action.o3h_1.g2c_1.r2c_1.k26_1;
		                      var tmp_6;
		                      if (tmp8_safe_receiver == null) {
		                        tmp_6 = null;
		                      } else {
		                        // Inline function 'kotlin.let' call
		                        // Inline function 'kotlin.contracts.contract' call
		                        // Inline function 'com.vonage.clientcore.core.reducers.call.CallReducer.reduce.<anonymous>' call
		                        tmp_6 = state.k3p(action.o3h_1, tmp8_safe_receiver);
		                      }
		                      tmp_2 = tmp_6;
		                    } else {
		                      if (tmp4_subject instanceof RTCAnswerEvent) {
		                        // Inline function 'kotlin.let' call
		                        // Inline function 'kotlin.contracts.contract' call
		                        // Inline function 'com.vonage.clientcore.core.reducers.call.CallReducer.reduce.<anonymous>' call
		                        var it = action.o3h_1.w2c_1.d2d_1;
		                        tmp_2 = state.j3p(action.o3h_1, it);
		                      } else {
		                        if (tmp4_subject instanceof RTCHangupEvent) {
		                          var tmp9_safe_receiver = action.o3h_1.g2a_1.h27_1.k26_1;
		                          var tmp_7;
		                          if (tmp9_safe_receiver == null) {
		                            tmp_7 = null;
		                          } else {
		                            // Inline function 'kotlin.let' call
		                            // Inline function 'kotlin.contracts.contract' call
		                            // Inline function 'com.vonage.clientcore.core.reducers.call.CallReducer.reduce.<anonymous>' call
		                            tmp_7 = state.i3p(action.o3h_1, tmp9_safe_receiver);
		                          }
		                          tmp_2 = tmp_7;
		                        } else {
		                          if (tmp4_subject instanceof RTCTransferEvent) {
		                            var tmp10_safe_receiver = action.o3h_1.n2a_1.x2a_1.k26_1;
		                            var tmp_8;
		                            if (tmp10_safe_receiver == null) {
		                              tmp_8 = null;
		                            } else {
		                              // Inline function 'kotlin.let' call
		                              // Inline function 'kotlin.contracts.contract' call
		                              // Inline function 'com.vonage.clientcore.core.reducers.call.CallReducer.reduce.<anonymous>' call
		                              tmp_8 = state.h3p(action.o3h_1, tmp10_safe_receiver);
		                            }
		                            tmp_2 = tmp_8;
		                          } else {
		                            tmp_2 = null;
		                          }
		                        }
		                      }
		                    }
		                  }
		                }
		              }
		              tmp = tmp_2;
		            } else {
		              if (isInterface(tmp0_subject, ApiRequest)) {
		                var tmp11_elvis_lhs = action.p3h_1.r3h_1;
		                var callId_0 = tmp11_elvis_lhs == null ? '' : tmp11_elvis_lhs;
		                var tmp12_subject = action.o3h_1;
		                var tmp_9;
		                if (tmp12_subject instanceof AppKnockingRequest) {
		                  tmp_9 = state.g3p(action.o3h_1, callId_0, action.p3h_1.q3h_1);
		                } else {
		                  if (tmp12_subject instanceof MemberKickRequest) {
		                    tmp_9 = state.f3p(action.o3h_1, callId_0, action.p3h_1.q3h_1);
		                  } else {
		                    if (tmp12_subject instanceof MemberJoinRequest) {
		                      tmp_9 = state.e3p(action.o3h_1, callId_0, action.p3h_1.q3h_1);
		                    } else {
		                      tmp_9 = null;
		                    }
		                  }
		                }
		                tmp = tmp_9;
		              } else {
		                if (isInterface(tmp0_subject, ApiResponse)) {
		                  var tmp13_elvis_lhs = action.p3h_1.r3h_1;
		                  var callId_1 = tmp13_elvis_lhs == null ? '' : tmp13_elvis_lhs;
		                  var tmp14_subject = action.o3h_1;
		                  var tmp_10;
		                  if (tmp14_subject instanceof AppKnocking) {
		                    tmp_10 = state.d3p(action.o3h_1, callId_1);
		                  } else {
		                    if (tmp14_subject instanceof RTCReconnect) {
		                      tmp_10 = state.c3p(action.o3h_1, callId_1);
		                    } else {
		                      if (tmp14_subject instanceof DeletedKnocker) {
		                        tmp_10 = state.b3p(action.o3h_1, callId_1);
		                      } else {
		                        if (tmp14_subject instanceof MemberLeft) {
		                          tmp_10 = state.a3p(action.o3h_1, callId_1);
		                        } else {
		                          tmp_10 = null;
		                        }
		                      }
		                    }
		                  }
		                  tmp = tmp_10;
		                } else {
		                  tmp = null;
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  };
		  protoOf(CallReducer).h3n = function (action, state) {
		    return this.z3o(action, state instanceof CallState ? state : THROW_CCE());
		  };
		  function CallState$update$lambda($action, this$0) {
		    return function ($this$modify) {
		      var tmp;
		      if ($action.c2e_1.l2e_1.z1x_1 === this$0.c3a_1) {
		        var tmp_0;
		        var tmp_1;
		        var tmp_2 = $this$modify.p39_1.w1();
		        if (isInterface(tmp_2, CoreMemberStateWithCid)) {
		          var tmp_3 = $this$modify.p39_1.w1();
		          tmp_1 = (isInterface(tmp_3, CoreMemberStateWithCid) ? tmp_3 : THROW_CCE()).u27() === $action.e2e_1;
		        } else {
		          tmp_1 = false;
		        }
		        if (tmp_1) {
		          var tmp_4 = $this$modify;
		          var tmp_5 = $this$modify.p39_1;
		          var tmp0_safe_receiver = $action.c2e_1.n2e_1;
		          tmp_4.p39_1 = toResolved(tmp_5, new Left($action.e2e_1, $action.c2e_1.k2e_1, '', tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s2e_1));
		          tmp_0 = Unit_instance;
		        }
		        tmp = tmp_0;
		      }
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_0($action, $id) {
		    return function ($this$new) {
		      // Inline function 'kotlin.also' call
		      var tmp0_customData = $action.p3c_1;
		      var tmp1_id = $action.m3c_1;
		      var tmp2_from = $action.n3c_1;
		      var this_0 = new Call_0(VOID, tmp2_from, tmp0_customData, tmp1_id);
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>.<anonymous>' call
		      var tmp = this_0;
		      var tmp_0;
		      switch ($action.o3c_1.i8_1) {
		        case 1:
		          tmp_0 = toResolved(this_0.q39_1, new Started($action.m3c_1));
		          break;
		        case 0:
		          tmp_0 = toResolved(this_0.q39_1, new Prewarm($action.m3c_1));
		          break;
		        default:
		          noWhenBranchMatchedException();
		          break;
		      }
		      tmp.q39_1 = tmp_0;
		      var tmp1_safe_receiver = $action.q3c_1;
		      if (tmp1_safe_receiver == null)
		        null;
		      else {
		        // Inline function 'kotlin.let' call
		        // Inline function 'kotlin.contracts.contract' call
		        this_0.p39_1 = toResolved(this_0.p39_1, new Joined(tmp1_safe_receiver.s3c_1, tmp1_safe_receiver.t3c_1));
		        var this_1 = $this$new.b3a_1;
		        var key = tmp1_safe_receiver.s3c_1;
		        var value = $id;
		        this_1.s1(key, value);
		      }
		      return this_0;
		    };
		  }
		  function CallState$update$lambda_1($action) {
		    return function ($this$modify) {
		      var tmp;
		      var tmp_0 = $this$modify.p39_1.w1();
		      if (isInterface(tmp_0, CoreMemberStateWithCid)) {
		        var tmp_1 = $this$modify.p39_1.w1();
		        (isInterface(tmp_1, CoreMemberStateWithCid) ? tmp_1 : THROW_CCE()).c3q($action.v3c_1);
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_2($action, $requestId, $$this$apply, $callId) {
		    return function ($this$modify) {
		      $this$modify.p39_1 = toPending($this$modify.p39_1, new Joined($action.d1m_1, $action.e1m_1), $requestId);
		      var this_0 = $$this$apply.b3a_1;
		      var key = $action.d1m_1;
		      var value = $callId;
		      this_0.s1(key, value);
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_3($event, $newMemberId, $$this$apply, $callId) {
		    return function ($this$modify) {
		      $this$modify.p39_1 = new Resolved(new Joined($event.p2a_1, $newMemberId));
		      $$this$apply.b3a_1.t1($event.n2a_1.w2a_1);
		      var this_0 = $$this$apply.b3a_1;
		      var key = $event.p2a_1;
		      var value = $callId;
		      this_0.s1(key, value);
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_4($this$modify) {
		    if ($this$modify.t39_1.equals(MediaConnectionState_Closed_getInstance()))
		      return Unit_instance;
		    var tmp = $this$modify;
		    var tmp_0;
		    if ($this$modify.t39_1.equals(MediaConnectionState_New_getInstance())) {
		      tmp_0 = MediaConnectionState_Failed_getInstance();
		    } else {
		      var tmp_1 = $this$modify.p39_1.w1();
		      if (!(tmp_1 instanceof Joined)) {
		        tmp_0 = MediaConnectionState_Failed_getInstance();
		      } else {
		        tmp_0 = $this$modify.t39_1;
		      }
		    }
		    tmp.t39_1 = tmp_0;
		    return Unit_instance;
		  }
		  function CallState$update$lambda_5($event) {
		    return function ($this$modify) {
		      $this$modify.p39_1 = toFailed($this$modify.p39_1, $event.y3b_1);
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_6($event) {
		    return function ($this$modify) {
		      $this$modify.p39_1 = new Resolved(new Joined($event.i2c_1, $event.g2c_1.p2c_1));
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_7($requestId) {
		    return function ($this$modify) {
		      $this$modify.p39_1 = toPending($this$modify.p39_1, new Knocking('placeholder'), $requestId);
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_8($response) {
		    return function ($this$modify) {
		      var tmp;
		      var tmp_0 = $this$modify.p39_1.w1();
		      if (tmp_0 instanceof Knocking) {
		        $this$modify.p39_1 = toResolved($this$modify.p39_1, new Knocking($response.j22_1));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_9($this$modify) {
		    // Inline function 'kotlin.TODO' call
		    throw new NotImplementedError();
		  }
		  function CallState$update$lambda_10($response) {
		    return function ($this$modify) {
		      $this$modify.q39_1 = toResolved($this$modify.q39_1, new Started($response.m22_1));
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_11($action, $requestId) {
		    return function ($this$modify) {
		      $this$modify.p39_1 = toPending($this$modify.p39_1, new Left($action.p1l_1, $action.q1l_1), $requestId);
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_12($action) {
		    return function ($this$modify) {
		      $this$modify.p39_1 = toResolved($this$modify.p39_1, new Left($action.q1v_1, $action.r1v_1));
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_13($callId, $action) {
		    return function ($this$modify) {
		      $this$modify.q39_1 = new Resolved(new Completed($callId, $action.g2a_1.j27_1));
		      $this$modify.s39_1 = Disconnected_instance;
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_14($action) {
		    return function ($this$modify) {
		      $this$modify.p39_1 = toFailed($this$modify.p39_1, $action.o1h_1);
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_15($offer) {
		    return function ($this$modify) {
		      $this$modify.r39_1 = $this$modify.r39_1.g3e(new Offer($offer.d2n_1));
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_16($offer) {
		    return function ($this$modify) {
		      $this$modify.r39_1 = $this$modify.r39_1.g3e(new Answer($offer.f2n_1));
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_17($this$modify) {
		    $this$modify.r39_1 = $this$modify.r39_1.g3e(VOID, VOID, false);
		    return Unit_instance;
		  }
		  function CallState$update$lambda_18($action) {
		    return function ($this$modify) {
		      $this$modify.r39_1 = $this$modify.r39_1.g3e(VOID, new Answer($action.w2c_1.e2d_1));
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_19($action) {
		    return function ($this$modify) {
		      $this$modify.t39_1 = $action.b2n_1;
		      var tmp;
		      var tmp_0 = $this$modify.s39_1;
		      if (tmp_0 instanceof Disconnected) {
		        return Unit_instance;
		      }
		      var tmp_1 = $this$modify;
		      switch ($this$modify.t39_1.i8_1) {
		        case 3:
		          tmp_1.s39_1 = Connected_instance;
		          break;
		        case 4:
		          tmp_1.s39_1 = new Reconnecting();
		          break;
		        default:
		          tmp_1.s39_1 = $this$modify.s39_1;
		          break;
		      }
		      return Unit_instance;
		    };
		  }
		  function CallState$update$lambda_20($action, $id) {
		    return function ($this$new) {
		      // Inline function 'kotlin.also' call
		      var tmp0_from = new AppChannelEndpoint($action.b3c_1);
		      var tmp1_memberState = new Resolved(new Joined($action.c3c_1, $action.b3c_1));
		      var this_0 = new Call_0(true, tmp0_from, null, $id, tmp1_memberState);
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>.<anonymous>' call
		      // Inline function 'kotlin.collections.set' call
		      var this_1 = $this$new.b3a_1;
		      var key = $action.c3c_1;
		      var value = $id;
		      this_1.s1(key, value);
		      return this_0;
		    };
		  }
		  function CallState$update$lambda_21($this$modify) {
		    $this$modify.l39_1 = true;
		    return Unit_instance;
		  }
		  function CallState$update$lambda_22($this$modify) {
		    var tmp = $this$modify.s39_1;
		    var tmp0_safe_receiver = tmp instanceof Reconnecting ? tmp : null;
		    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o3a_1;
		    var tmp_0;
		    if (tmp1_elvis_lhs == null) {
		      return Unit_instance;
		    } else {
		      tmp_0 = tmp1_elvis_lhs;
		    }
		    var currentRetryCount = tmp_0;
		    $this$modify.s39_1 = new Reconnecting(currentRetryCount + 1 | 0);
		    return Unit_instance;
		  }
		  function CallState$update$lambda_23($this$modify) {
		    $this$modify.l39_1 = false;
		    return Unit_instance;
		  }
		  function CallState$update$lambda_24($this$modify) {
		    $this$modify.l39_1 = false;
		    $this$modify.s39_1 = Disconnected_instance;
		    return Unit_instance;
		  }
		  function CallState(calls, conversationIdToCallId, currentUserId) {
		    var tmp;
		    if (calls === VOID) {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      tmp = LinkedHashMap_init_$Create$();
		    } else {
		      tmp = calls;
		    }
		    calls = tmp;
		    var tmp_0;
		    if (conversationIdToCallId === VOID) {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      tmp_0 = LinkedHashMap_init_$Create$();
		    } else {
		      tmp_0 = conversationIdToCallId;
		    }
		    conversationIdToCallId = tmp_0;
		    currentUserId = currentUserId === VOID ? null : currentUserId;
		    this.a3a_1 = calls;
		    this.b3a_1 = conversationIdToCallId;
		    this.c3a_1 = currentUserId;
		    this.d3a_1 = null;
		  }
		  protoOf(CallState).m3n = function () {
		    return this.a3a_1;
		  };
		  protoOf(CallState).n3n = function (_set____db54di) {
		    this.d3a_1 = _set____db54di;
		  };
		  protoOf(CallState).toString = function () {
		    var tmp = 'CallState(currentUserId=' + this.c3a_1 + ',lastModified=' + this.d3a_1 + ',conversationIdToCallId=' + this.b3a_1 + ',';
		    // Inline function 'kotlin.collections.map' call
		    var this_0 = this.a3a_1;
		    // Inline function 'kotlin.collections.mapTo' call
		    var destination = ArrayList_init_$Create$(this_0.u());
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator = this_0.u1().p();
		    while (tmp0_iterator.q()) {
		      var item = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.toString.<anonymous>' call
		      var tmp$ret$1 = item.v1() + ':' + item.w1() + '\n';
		      destination.m(tmp$ret$1);
		    }
		    return tmp + ('\ncallInfo:' + destination + ')');
		  };
		  protoOf(CallState).p3o = function (event) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>' call
		    this.c3a_1 = event.r2b_1.a2c_1;
		    this.d3a_1 = null;
		    return this;
		  };
		  protoOf(CallState).l3p = function (action, id) {
		    return modify(this, id, CallState$update$lambda(action, this));
		  };
		  protoOf(CallState).t3p = function (action, id) {
		    return new_0(this, id, CallState$update$lambda_0(action, id));
		  };
		  protoOf(CallState).p3p = function (action, callId) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>' call
		    // Inline function 'kotlin.collections.forEach' call
		    // Inline function 'kotlin.collections.filterValues' call
		    var this_0 = this.b3a_1;
		    var result = LinkedHashMap_init_$Create$();
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator = this_0.u1().p();
		    while (tmp0_iterator.q()) {
		      var entry = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>.<anonymous>' call
		      if (entry.w1() === callId) {
		        result.s1(entry.v1(), entry.w1());
		      }
		    }
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator_0 = result.u1().p();
		    while (tmp0_iterator_0.q()) {
		      var element = tmp0_iterator_0.s();
		      // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>.<anonymous>' call
		      this.b3a_1.t1(element.v1());
		    }
		    this.a3a_1.t1(callId);
		    return this;
		  };
		  protoOf(CallState).o3p = function (action, id) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>' call
		    modify(this, id, CallState$update$lambda_1(action));
		    return this;
		  };
		  protoOf(CallState).e3p = function (action, callId, requestId) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>' call
		    modify(this, callId, CallState$update$lambda_2(action, requestId, this, callId));
		    return this;
		  };
		  protoOf(CallState).h3p = function (event, callId) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>' call
		    var tmp0_safe_receiver = event.q2a_1;
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      // Inline function 'kotlin.let' call
		      // Inline function 'kotlin.contracts.contract' call
		      modify(this, callId, CallState$update$lambda_3(event, tmp0_safe_receiver, this, callId));
		    }
		    return this;
		  };
		  protoOf(CallState).v3p = function (event, id) {
		    return modify(this, id, CallState$update$lambda_4);
		  };
		  protoOf(CallState).u3p = function (event, id) {
		    return modify(this, id, CallState$update$lambda_5(event));
		  };
		  protoOf(CallState).m3p = function (event, id) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>' call
		    if (event.v2d_1 == this.c3a_1) {
		      // Inline function 'kotlin.collections.set' call
		      var this_0 = this.b3a_1;
		      var key = event.u2d_1;
		      this_0.s1(key, id);
		    }
		    return this;
		  };
		  protoOf(CallState).k3p = function (event, id) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>' call
		    if (event.g2c_1.q2c_1.z1x_1 === this.c3a_1) {
		      // Inline function 'kotlin.collections.set' call
		      var this_0 = this.b3a_1;
		      var key = event.i2c_1;
		      this_0.s1(key, id);
		    }
		    modify(this, id, CallState$update$lambda_6(event));
		    return this;
		  };
		  protoOf(CallState).n3p = function (event, id) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.CallState.update.<anonymous>' call
		    if (event.h2d_1.c2b_1.z1x_1 === this.c3a_1) {
		      // Inline function 'kotlin.collections.set' call
		      var this_0 = this.b3a_1;
		      var key = event.j2d_1;
		      this_0.s1(key, id);
		    }
		    return this;
		  };
		  protoOf(CallState).g3p = function (action, id, requestId) {
		    return modify(this, id, CallState$update$lambda_7(requestId));
		  };
		  protoOf(CallState).d3p = function (response, id) {
		    return modify(this, id, CallState$update$lambda_8(response));
		  };
		  protoOf(CallState).b3p = function (response, id) {
		    return modify(this, id, CallState$update$lambda_9);
		  };
		  protoOf(CallState).c3p = function (response, callId) {
		    return modify(this, callId, CallState$update$lambda_10(response));
		  };
		  protoOf(CallState).f3p = function (action, id, requestId) {
		    return modify(this, id, CallState$update$lambda_11(action, requestId));
		  };
		  protoOf(CallState).a3p = function (action, id) {
		    return modify(this, id, CallState$update$lambda_12(action));
		  };
		  protoOf(CallState).i3p = function (action, callId) {
		    return modify(this, callId, CallState$update$lambda_13(callId, action));
		  };
		  protoOf(CallState).b3q = function (action, callId) {
		    return modify(this, callId, CallState$update$lambda_14(action));
		  };
		  protoOf(CallState).a3q = function (offer, callId) {
		    return modify(this, callId, CallState$update$lambda_15(offer));
		  };
		  protoOf(CallState).z3p = function (offer, callId) {
		    return modify(this, callId, CallState$update$lambda_16(offer));
		  };
		  protoOf(CallState).y3p = function (action, id) {
		    return modify(this, id, CallState$update$lambda_17);
		  };
		  protoOf(CallState).j3p = function (action, id) {
		    return modify(this, id, CallState$update$lambda_18(action));
		  };
		  protoOf(CallState).x3p = function (action, id) {
		    return modify(this, id, CallState$update$lambda_19(action));
		  };
		  protoOf(CallState).s3p = function (action, id) {
		    var tmp;
		    if (this.a3a_1.c2(id) == null) {
		      tmp = new_0(this, id, CallState$update$lambda_20(action, id));
		    } else {
		      tmp = modify(this, id, CallState$update$lambda_21);
		    }
		    return tmp;
		  };
		  protoOf(CallState).w3p = function (action, id) {
		    return modify(this, id, CallState$update$lambda_22);
		  };
		  protoOf(CallState).r3p = function (action, id) {
		    return modify(this, id, CallState$update$lambda_23);
		  };
		  protoOf(CallState).q3p = function (action, id) {
		    return modify(this, id, CallState$update$lambda_24);
		  };
		  protoOf(CallState).hashCode = function () {
		    var result = hashCode(this.a3a_1);
		    result = imul(result, 31) + hashCode(this.b3a_1) | 0;
		    result = imul(result, 31) + (this.c3a_1 == null ? 0 : getStringHashCode(this.c3a_1)) | 0;
		    return result;
		  };
		  protoOf(CallState).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof CallState))
		      return false;
		    var tmp0_other_with_cast = other instanceof CallState ? other : THROW_CCE();
		    if (!equals(this.a3a_1, tmp0_other_with_cast.a3a_1))
		      return false;
		    if (!equals(this.b3a_1, tmp0_other_with_cast.b3a_1))
		      return false;
		    if (!(this.c3a_1 == tmp0_other_with_cast.c3a_1))
		      return false;
		    return true;
		  };
		  function None_1() {
		  }
		  var None_instance_1;
		  function None_getInstance_1() {
		    return None_instance_1;
		  }
		  function Knocking(id) {
		    this.u3b_1 = id;
		  }
		  protoOf(Knocking).toString = function () {
		    return 'Knocking(id=' + this.u3b_1 + ')';
		  };
		  protoOf(Knocking).hashCode = function () {
		    return getStringHashCode(this.u3b_1);
		  };
		  protoOf(Knocking).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Knocking))
		      return false;
		    var tmp0_other_with_cast = other instanceof Knocking ? other : THROW_CCE();
		    if (!(this.u3b_1 === tmp0_other_with_cast.u3b_1))
		      return false;
		    return true;
		  };
		  function Invited() {
		  }
		  function Joined(cid, mid, conversationName) {
		    conversationName = conversationName === VOID ? null : conversationName;
		    this.u39_1 = cid;
		    this.v39_1 = mid;
		    this.w39_1 = conversationName;
		  }
		  protoOf(Joined).u27 = function () {
		    return this.u39_1;
		  };
		  protoOf(Joined).c3q = function (_set____db54di) {
		    this.w39_1 = _set____db54di;
		  };
		  protoOf(Joined).y3l = function () {
		    return this.w39_1;
		  };
		  protoOf(Joined).toString = function () {
		    return 'Joined(cid=' + this.u39_1 + ', mid=' + this.v39_1 + ', conversationName=' + this.w39_1 + ')';
		  };
		  protoOf(Joined).hashCode = function () {
		    var result = getStringHashCode(this.u39_1);
		    result = imul(result, 31) + getStringHashCode(this.v39_1) | 0;
		    result = imul(result, 31) + (this.w39_1 == null ? 0 : getStringHashCode(this.w39_1)) | 0;
		    return result;
		  };
		  protoOf(Joined).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Joined))
		      return false;
		    var tmp0_other_with_cast = other instanceof Joined ? other : THROW_CCE();
		    if (!(this.u39_1 === tmp0_other_with_cast.u39_1))
		      return false;
		    if (!(this.v39_1 === tmp0_other_with_cast.v39_1))
		      return false;
		    if (!(this.w39_1 == tmp0_other_with_cast.w39_1))
		      return false;
		    return true;
		  };
		  function Left(cid, mid, conversationName, reasonCode) {
		    conversationName = conversationName === VOID ? null : conversationName;
		    reasonCode = reasonCode === VOID ? null : reasonCode;
		    this.t3a_1 = cid;
		    this.u3a_1 = mid;
		    this.v3a_1 = conversationName;
		    this.w3a_1 = reasonCode;
		  }
		  protoOf(Left).u27 = function () {
		    return this.t3a_1;
		  };
		  protoOf(Left).c3q = function (_set____db54di) {
		    this.v3a_1 = _set____db54di;
		  };
		  protoOf(Left).y3l = function () {
		    return this.v3a_1;
		  };
		  protoOf(Left).toString = function () {
		    return 'Left(cid=' + this.t3a_1 + ', mid=' + this.u3a_1 + ', conversationName=' + this.v3a_1 + ', reasonCode=' + this.w3a_1 + ')';
		  };
		  protoOf(Left).hashCode = function () {
		    var result = getStringHashCode(this.t3a_1);
		    result = imul(result, 31) + getStringHashCode(this.u3a_1) | 0;
		    result = imul(result, 31) + (this.v3a_1 == null ? 0 : getStringHashCode(this.v3a_1)) | 0;
		    result = imul(result, 31) + (this.w3a_1 == null ? 0 : getStringHashCode(this.w3a_1)) | 0;
		    return result;
		  };
		  protoOf(Left).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Left))
		      return false;
		    var tmp0_other_with_cast = other instanceof Left ? other : THROW_CCE();
		    if (!(this.t3a_1 === tmp0_other_with_cast.t3a_1))
		      return false;
		    if (!(this.u3a_1 === tmp0_other_with_cast.u3a_1))
		      return false;
		    if (!(this.v3a_1 == tmp0_other_with_cast.v3a_1))
		      return false;
		    if (!(this.w3a_1 == tmp0_other_with_cast.w3a_1))
		      return false;
		    return true;
		  };
		  function CoreMemberStateWithCid() {
		  }
		  function Invite_0(from, rtcId, memberId, conversationId, offer, memberState, isSocketInvite, hangupReceived, FS_SIP_Code) {
		    memberState = memberState === VOID ? new Resolved(None_instance_1) : memberState;
		    hangupReceived = hangupReceived === VOID ? false : hangupReceived;
		    FS_SIP_Code = FS_SIP_Code === VOID ? 0 : FS_SIP_Code;
		    this.f3a_1 = from;
		    this.g3a_1 = rtcId;
		    this.h3a_1 = memberId;
		    this.i3a_1 = conversationId;
		    this.j3a_1 = offer;
		    this.k3a_1 = memberState;
		    this.l3a_1 = isSocketInvite;
		    this.m3a_1 = hangupReceived;
		    this.n3a_1 = FS_SIP_Code;
		  }
		  protoOf(Invite_0).d3q = function (from, rtcId, memberId, conversationId, offer, memberState, isSocketInvite, hangupReceived, FS_SIP_Code) {
		    return new Invite_0(from, rtcId, memberId, conversationId, offer, memberState, isSocketInvite, hangupReceived, FS_SIP_Code);
		  };
		  protoOf(Invite_0).b3b = function (from, rtcId, memberId, conversationId, offer, memberState, isSocketInvite, hangupReceived, FS_SIP_Code, $super) {
		    from = from === VOID ? this.f3a_1 : from;
		    rtcId = rtcId === VOID ? this.g3a_1 : rtcId;
		    memberId = memberId === VOID ? this.h3a_1 : memberId;
		    conversationId = conversationId === VOID ? this.i3a_1 : conversationId;
		    offer = offer === VOID ? this.j3a_1 : offer;
		    memberState = memberState === VOID ? this.k3a_1 : memberState;
		    isSocketInvite = isSocketInvite === VOID ? this.l3a_1 : isSocketInvite;
		    hangupReceived = hangupReceived === VOID ? this.m3a_1 : hangupReceived;
		    FS_SIP_Code = FS_SIP_Code === VOID ? this.n3a_1 : FS_SIP_Code;
		    return $super === VOID ? this.d3q(from, rtcId, memberId, conversationId, offer, memberState, isSocketInvite, hangupReceived, FS_SIP_Code) : $super.d3q.call(this, from, rtcId, memberId, conversationId, offer, memberState, isSocketInvite, hangupReceived, FS_SIP_Code);
		  };
		  protoOf(Invite_0).toString = function () {
		    return 'Invite(from=' + this.f3a_1 + ', rtcId=' + this.g3a_1 + ', memberId=' + this.h3a_1 + ', conversationId=' + this.i3a_1 + ', offer=' + this.j3a_1 + ', memberState=' + this.k3a_1 + ', isSocketInvite=' + this.l3a_1 + ', hangupReceived=' + this.m3a_1 + ', FS_SIP_Code=' + this.n3a_1 + ')';
		  };
		  protoOf(Invite_0).hashCode = function () {
		    var result = hashCode(this.f3a_1);
		    result = imul(result, 31) + getStringHashCode(this.g3a_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.h3a_1) | 0;
		    result = imul(result, 31) + getStringHashCode(this.i3a_1) | 0;
		    result = imul(result, 31) + (this.j3a_1 == null ? 0 : getStringHashCode(this.j3a_1)) | 0;
		    result = imul(result, 31) + hashCode(this.k3a_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.l3a_1) | 0;
		    result = imul(result, 31) + getBooleanHashCode(this.m3a_1) | 0;
		    result = imul(result, 31) + this.n3a_1 | 0;
		    return result;
		  };
		  protoOf(Invite_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Invite_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof Invite_0 ? other : THROW_CCE();
		    if (!equals(this.f3a_1, tmp0_other_with_cast.f3a_1))
		      return false;
		    if (!(this.g3a_1 === tmp0_other_with_cast.g3a_1))
		      return false;
		    if (!(this.h3a_1 === tmp0_other_with_cast.h3a_1))
		      return false;
		    if (!(this.i3a_1 === tmp0_other_with_cast.i3a_1))
		      return false;
		    if (!(this.j3a_1 == tmp0_other_with_cast.j3a_1))
		      return false;
		    if (!equals(this.k3a_1, tmp0_other_with_cast.k3a_1))
		      return false;
		    if (!(this.l3a_1 === tmp0_other_with_cast.l3a_1))
		      return false;
		    if (!(this.m3a_1 === tmp0_other_with_cast.m3a_1))
		      return false;
		    if (!(this.n3a_1 === tmp0_other_with_cast.n3a_1))
		      return false;
		    return true;
		  };
		  function InviteReducer$lambda(this$0) {
		    return function () {
		      return 'STATE INIT: ' + this$0.g3q_1;
		    };
		  }
		  function InviteReducer(logger, state) {
		    state = state === VOID ? new InviteState() : state;
		    Reducer_0.call(this, logger);
		    this.g3q_1 = state;
		    if (logger == null)
		      null;
		    else {
		      logger.g3h(VOID, InviteReducer$lambda(this));
		    }
		  }
		  protoOf(InviteReducer).h3q = function (_set____db54di) {
		    this.g3q_1 = _set____db54di;
		  };
		  protoOf(InviteReducer).b3n = function (_set____db54di) {
		    return this.h3q(_set____db54di instanceof InviteState ? _set____db54di : THROW_CCE());
		  };
		  protoOf(InviteReducer).c3n = function () {
		    return this.g3q_1;
		  };
		  protoOf(InviteReducer).d3n = function () {
		    return this.g3q_1.i3q();
		  };
		  protoOf(InviteReducer).j3q = function (action, state) {
		    var tmp0_subject = action.o3h_1;
		    var tmp;
		    if (tmp0_subject instanceof ErrorReport) {
		      var tmp1_elvis_lhs = action.p3h_1.r3h_1;
		      tmp = state.b3q(action.o3h_1, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
		    } else {
		      if (tmp0_subject instanceof SessionSuccessEvent) {
		        tmp = state.p3o(action.o3h_1);
		      } else {
		        if (tmp0_subject instanceof MemberInvitedEvent) {
		          var tmp2_safe_receiver = action.o3h_1.h2d_1.e2b_1.k26_1;
		          var tmp_0;
		          if (tmp2_safe_receiver == null) {
		            tmp_0 = null;
		          } else {
		            // Inline function 'kotlin.let' call
		            // Inline function 'kotlin.contracts.contract' call
		            // Inline function 'com.vonage.clientcore.core.reducers.call.InviteReducer.reduce.<anonymous>' call
		            tmp_0 = state.n3p(action.o3h_1, tmp2_safe_receiver);
		          }
		          tmp = tmp_0;
		        } else {
		          if (tmp0_subject instanceof PushMemberInvitedEvent) {
		            var tmp3_safe_receiver = action.o3h_1.j2b_1.e2b_1.k26_1;
		            var tmp_1;
		            if (tmp3_safe_receiver == null) {
		              tmp_1 = null;
		            } else {
		              // Inline function 'kotlin.let' call
		              // Inline function 'kotlin.contracts.contract' call
		              // Inline function 'com.vonage.clientcore.core.reducers.call.InviteReducer.reduce.<anonymous>' call
		              tmp_1 = state.n3q(action.o3h_1, tmp3_safe_receiver);
		            }
		            tmp = tmp_1;
		          } else {
		            if (tmp0_subject instanceof MemberJoinedEvent) {
		              var tmp4_safe_receiver = action.o3h_1.g2c_1.r2c_1.k26_1;
		              var tmp_2;
		              if (tmp4_safe_receiver == null) {
		                tmp_2 = null;
		              } else {
		                // Inline function 'kotlin.let' call
		                // Inline function 'kotlin.contracts.contract' call
		                // Inline function 'com.vonage.clientcore.core.reducers.call.InviteReducer.reduce.<anonymous>' call
		                tmp_2 = state.k3p(action.o3h_1, tmp4_safe_receiver);
		              }
		              tmp = tmp_2;
		            } else {
		              if (tmp0_subject instanceof MemberLeftEvent) {
		                var tmp5_safe_receiver = action.o3h_1.c2e_1.m2e_1.k26_1;
		                var tmp_3;
		                if (tmp5_safe_receiver == null) {
		                  tmp_3 = null;
		                } else {
		                  // Inline function 'kotlin.let' call
		                  // Inline function 'kotlin.contracts.contract' call
		                  // Inline function 'com.vonage.clientcore.core.reducers.call.InviteReducer.reduce.<anonymous>' call
		                  tmp_3 = state.l3p(action.o3h_1, tmp5_safe_receiver);
		                }
		                tmp = tmp_3;
		              } else {
		                if (tmp0_subject instanceof RTCHangupEvent) {
		                  var tmp6_safe_receiver = action.o3h_1.g2a_1.h27_1.k26_1;
		                  var tmp_4;
		                  if (tmp6_safe_receiver == null) {
		                    tmp_4 = null;
		                  } else {
		                    // Inline function 'kotlin.let' call
		                    // Inline function 'kotlin.contracts.contract' call
		                    // Inline function 'com.vonage.clientcore.core.reducers.call.InviteReducer.reduce.<anonymous>' call
		                    tmp_4 = state.i3p(action.o3h_1, tmp6_safe_receiver);
		                  }
		                  tmp = tmp_4;
		                } else {
		                  if (tmp0_subject instanceof InviteCleanup) {
		                    // Inline function 'kotlin.let' call
		                    // Inline function 'kotlin.contracts.contract' call
		                    // Inline function 'com.vonage.clientcore.core.reducers.call.InviteReducer.reduce.<anonymous>' call
		                    state.m3q(action.o3h_1, action.o3h_1.w3c_1);
		                    tmp = null;
		                  } else {
		                    if (tmp0_subject instanceof InviteReconcile) {
		                      tmp = state.l3q(action.o3h_1, action.o3h_1.l3c_1);
		                    } else {
		                      if (isInterface(tmp0_subject, ApiRequest)) {
		                        var tmp7_elvis_lhs = action.p3h_1.r3h_1;
		                        var callId = tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs;
		                        var tmp8_subject = action.o3h_1;
		                        var tmp_5;
		                        if (tmp8_subject instanceof MemberKickRequest) {
		                          tmp_5 = state.f3p(action.o3h_1, callId, action.p3h_1.q3h_1);
		                        } else {
		                          if (tmp8_subject instanceof MemberJoinRequest) {
		                            tmp_5 = state.e3p(action.o3h_1, callId, action.p3h_1.q3h_1);
		                          } else {
		                            tmp_5 = null;
		                          }
		                        }
		                        tmp = tmp_5;
		                      } else {
		                        if (isInterface(tmp0_subject, ApiResponse)) {
		                          var tmp9_elvis_lhs = action.p3h_1.r3h_1;
		                          var callId_0 = tmp9_elvis_lhs == null ? '' : tmp9_elvis_lhs;
		                          var tmp_6;
		                          if (action.o3h_1 instanceof GetConversation) {
		                            tmp_6 = state.k3q(action.o3h_1, callId_0);
		                          } else {
		                            tmp_6 = null;
		                          }
		                          tmp = tmp_6;
		                        } else {
		                          tmp = null;
		                        }
		                      }
		                    }
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  };
		  protoOf(InviteReducer).h3n = function (action, state) {
		    return this.j3q(action, state instanceof InviteState ? state : THROW_CCE());
		  };
		  function InviteState$update$lambda($sdp, $from, $id, $event) {
		    return function ($this$new) {
		      var remoteDescription = new Offer($sdp);
		      return new Invite_0($from, $id, $event.h2d_1.b2b_1, $event.h2d_1.a2b_1.v3d_1, remoteDescription.d3e_1, VOID, true);
		    };
		  }
		  function InviteState$update$lambda_0($sdp, $from, $id, $event) {
		    return function ($this$new) {
		      var remoteDescription = new Offer($sdp);
		      var tmp0_safe_receiver = $this$new.y3a_1.c2($id);
		      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l3a_1;
		      return new Invite_0($from, $id, $event.j2b_1.b2b_1, $event.n2b_1, remoteDescription.d3e_1, VOID, tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
		    };
		  }
		  function InviteState$update$lambda_1($event) {
		    return function ($this$modify) {
		      $this$modify.k3a_1 = toResolved($this$modify.k3a_1, new Joined($event.i2c_1, $event.g2c_1.p2c_1));
		      return Unit_instance;
		    };
		  }
		  function InviteState$update$lambda_2($action, $requestId) {
		    return function ($this$modify) {
		      $this$modify.k3a_1 = toPending($this$modify.k3a_1, new Joined($action.d1m_1, $action.e1m_1), $requestId);
		      return Unit_instance;
		    };
		  }
		  function InviteState$update$lambda_3($event, this$0) {
		    return function ($this$modify) {
		      var tmp;
		      if ($event.c2e_1.l2e_1.z1x_1 === this$0.z3a_1 ? equals($this$modify.k3a_1.w1(), None_instance_1) : false) {
		        var tmp_0 = $this$modify;
		        var tmp_1 = $this$modify.k3a_1;
		        var tmp0_safe_receiver = $event.c2e_1.n2e_1;
		        tmp_0.k3a_1 = toResolved(tmp_1, new Left($event.e2e_1, $event.c2e_1.k2e_1, VOID, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s2e_1));
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function InviteState$update$lambda_4($event) {
		    return function ($this$modify) {
		      $this$modify.m3a_1 = true;
		      $this$modify.n3a_1 = $event.g2a_1.j27_1.s3a_1;
		      return Unit_instance;
		    };
		  }
		  function InviteState$update$lambda_5($action, $requestId) {
		    return function ($this$modify) {
		      $this$modify.k3a_1 = toPending($this$modify.k3a_1, new Left($action.p1l_1, $action.q1l_1), $requestId);
		      return Unit_instance;
		    };
		  }
		  function InviteState$update$lambda_6($this$modify) {
		    $this$modify.m3a_1 = true;
		    $this$modify.k3a_1 = new Resolved(new Left($this$modify.i3a_1, $this$modify.h3a_1, ''));
		    return Unit_instance;
		  }
		  function InviteState$update$lambda_7($action) {
		    return function ($this$modify) {
		      var tmp;
		      var tmp_0;
		      var tmp_1 = $this$modify.k3a_1;
		      if (tmp_1 instanceof Pending) {
		        tmp_0 = $this$modify.k3a_1.x3a() === $action.p1h_1.p3h_1.q3h_1;
		      } else {
		        tmp_0 = false;
		      }
		      if (tmp_0) {
		        $this$modify.k3a_1 = toFailed($this$modify.k3a_1, $action.o1h_1);
		        tmp = Unit_instance;
		      }
		      var tmp_2;
		      var tmp_3;
		      var tmp_4;
		      var tmp_5;
		      var tmp_6 = $action.p1h_1.o3h_1;
		      if (tmp_6 instanceof GetConversationRequest) {
		        var tmp_7 = $action.o1h_1;
		        tmp_5 = tmp_7 instanceof CSError;
		      } else {
		        tmp_5 = false;
		      }
		      if (tmp_5) {
		        tmp_4 = $action.o1h_1.q1q_1 === 'conversation:error:not-found';
		      } else {
		        tmp_4 = false;
		      }
		      if (tmp_4) {
		        tmp_3 = equals($this$modify.k3a_1.w1(), None_instance_1);
		      } else {
		        tmp_3 = false;
		      }
		      if (tmp_3) {
		        $this$modify.k3a_1 = new Resolved(new Left($this$modify.i3a_1, $this$modify.h3a_1, ''));
		        $this$modify.m3a_1 = true;
		        tmp_2 = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function InviteState$update$lambda_8($action) {
		    return function ($this$modify) {
		      var tmp;
		      if (equals($action.z1j_1, ConversationState_INACTIVE_getInstance()) ? equals($this$modify.k3a_1.w1(), None_instance_1) : false) {
		        $this$modify.k3a_1 = new Resolved(new Left($this$modify.i3a_1, $this$modify.h3a_1, ''));
		        $this$modify.m3a_1 = true;
		        tmp = Unit_instance;
		      }
		      return Unit_instance;
		    };
		  }
		  function InviteState(invites, currentUserId) {
		    var tmp;
		    if (invites === VOID) {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      tmp = LinkedHashMap_init_$Create$();
		    } else {
		      tmp = invites;
		    }
		    invites = tmp;
		    currentUserId = currentUserId === VOID ? null : currentUserId;
		    this.y3a_1 = invites;
		    this.z3a_1 = currentUserId;
		    this.a3b_1 = null;
		  }
		  protoOf(InviteState).m3n = function () {
		    return this.y3a_1;
		  };
		  protoOf(InviteState).n3n = function (_set____db54di) {
		    this.a3b_1 = _set____db54di;
		  };
		  protoOf(InviteState).p3o = function (event) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.InviteState.update.<anonymous>' call
		    this.z3a_1 = event.r2b_1.a2c_1;
		    this.a3b_1 = null;
		    return this;
		  };
		  protoOf(InviteState).n3p = function (event, id) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    $l$block_0: {
		      // Inline function 'com.vonage.clientcore.core.reducers.call.InviteState.update.<anonymous>' call
		      var tmp0_elvis_lhs = event.h2d_1.g2b_1;
		      var tmp;
		      if (tmp0_elvis_lhs == null) {
		        break $l$block_0;
		      } else {
		        tmp = tmp0_elvis_lhs;
		      }
		      var sdp = tmp;
		      var tmp1_elvis_lhs = event.h2d_1.e2b_1.o26_1;
		      var tmp_0;
		      if (tmp1_elvis_lhs == null) {
		        break $l$block_0;
		      } else {
		        tmp_0 = tmp1_elvis_lhs;
		      }
		      var from = tmp_0;
		      // Inline function 'kotlin.takeIf' call
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp_1;
		      // Inline function 'com.vonage.clientcore.core.reducers.call.InviteState.update.<anonymous>.<anonymous>' call
		      var tmp_2;
		      var tmp0_safe_receiver = event.h2d_1.d2b_1.o3e_1;
		      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j3e_1) === true) {
		        tmp_2 = event.h2d_1.c2b_1.z1x_1 === this.z3a_1;
		      } else {
		        tmp_2 = false;
		      }
		      if (tmp_2) {
		        tmp_1 = this;
		      } else {
		        tmp_1 = null;
		      }
		      var tmp2_safe_receiver = tmp_1;
		      if (tmp2_safe_receiver == null)
		        null;
		      else {
		        new_0(tmp2_safe_receiver, id, InviteState$update$lambda(sdp, from, id, event));
		      }
		    }
		    return this;
		  };
		  protoOf(InviteState).n3q = function (event, id) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    $l$block_0: {
		      // Inline function 'com.vonage.clientcore.core.reducers.call.InviteState.update.<anonymous>' call
		      var tmp0_elvis_lhs = event.j2b_1.g2b_1;
		      var tmp;
		      if (tmp0_elvis_lhs == null) {
		        break $l$block_0;
		      } else {
		        tmp = tmp0_elvis_lhs;
		      }
		      var sdp = tmp;
		      var tmp1_elvis_lhs = event.j2b_1.e2b_1.o26_1;
		      var tmp_0;
		      if (tmp1_elvis_lhs == null) {
		        break $l$block_0;
		      } else {
		        tmp_0 = tmp1_elvis_lhs;
		      }
		      var from = tmp_0;
		      // Inline function 'kotlin.takeIf' call
		      // Inline function 'kotlin.contracts.contract' call
		      var tmp_1;
		      // Inline function 'com.vonage.clientcore.core.reducers.call.InviteState.update.<anonymous>.<anonymous>' call
		      var tmp0_safe_receiver = event.j2b_1.d2b_1.o3e_1;
		      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j3e_1) === true) {
		        tmp_1 = this;
		      } else {
		        tmp_1 = null;
		      }
		      var tmp2_safe_receiver = tmp_1;
		      if (tmp2_safe_receiver == null)
		        null;
		      else {
		        new_0(tmp2_safe_receiver, id, InviteState$update$lambda_0(sdp, from, id, event));
		      }
		    }
		    return this;
		  };
		  protoOf(InviteState).k3p = function (event, id) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.InviteState.update.<anonymous>' call
		    // Inline function 'kotlin.takeIf' call
		    // Inline function 'kotlin.contracts.contract' call
		    var tmp;
		    // Inline function 'com.vonage.clientcore.core.reducers.call.InviteState.update.<anonymous>.<anonymous>' call
		    if (event.g2c_1.q2c_1.z1x_1 === this.z3a_1) {
		      tmp = this;
		    } else {
		      tmp = null;
		    }
		    var tmp0_safe_receiver = tmp;
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      modify(tmp0_safe_receiver, id, InviteState$update$lambda_1(event));
		    }
		    return this;
		  };
		  protoOf(InviteState).e3p = function (action, id, requestId) {
		    return modify(this, id, InviteState$update$lambda_2(action, requestId));
		  };
		  protoOf(InviteState).l3p = function (event, id) {
		    return modify(this, id, InviteState$update$lambda_3(event, this));
		  };
		  protoOf(InviteState).i3p = function (event, id) {
		    return modify(this, id, InviteState$update$lambda_4(event));
		  };
		  protoOf(InviteState).f3p = function (action, id, requestId) {
		    return modify(this, id, InviteState$update$lambda_5(action, requestId));
		  };
		  protoOf(InviteState).l3q = function (action, id) {
		    return modify(this, id, InviteState$update$lambda_6);
		  };
		  protoOf(InviteState).m3q = function (action, id) {
		    // Inline function 'kotlin.apply' call
		    // Inline function 'kotlin.contracts.contract' call
		    // Inline function 'com.vonage.clientcore.core.reducers.call.InviteState.update.<anonymous>' call
		    this.y3a_1.t1(id);
		    return this;
		  };
		  protoOf(InviteState).b3q = function (action, callId) {
		    return modify(this, callId, InviteState$update$lambda_7(action));
		  };
		  protoOf(InviteState).k3q = function (action, callId) {
		    return modify(this, callId, InviteState$update$lambda_8(action));
		  };
		  protoOf(InviteState).o3q = function (invites, currentUserId) {
		    return new InviteState(invites, currentUserId);
		  };
		  protoOf(InviteState).i3q = function (invites, currentUserId, $super) {
		    invites = invites === VOID ? this.y3a_1 : invites;
		    currentUserId = currentUserId === VOID ? this.z3a_1 : currentUserId;
		    return $super === VOID ? this.o3q(invites, currentUserId) : $super.o3q.call(this, invites, currentUserId);
		  };
		  protoOf(InviteState).toString = function () {
		    return 'InviteState(invites=' + this.y3a_1 + ', currentUserId=' + this.z3a_1 + ')';
		  };
		  protoOf(InviteState).hashCode = function () {
		    var result = hashCode(this.y3a_1);
		    result = imul(result, 31) + (this.z3a_1 == null ? 0 : getStringHashCode(this.z3a_1)) | 0;
		    return result;
		  };
		  protoOf(InviteState).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof InviteState))
		      return false;
		    var tmp0_other_with_cast = other instanceof InviteState ? other : THROW_CCE();
		    if (!equals(this.y3a_1, tmp0_other_with_cast.y3a_1))
		      return false;
		    if (!(this.z3a_1 == tmp0_other_with_cast.z3a_1))
		      return false;
		    return true;
		  };
		  function MediaEventReducer$lambda(this$0) {
		    return function () {
		      return 'STATE INIT: ' + this$0.r3q_1;
		    };
		  }
		  function MediaEventReducer(logger, state) {
		    state = state === VOID ? new MediaEventState() : state;
		    Reducer_0.call(this, logger);
		    this.r3q_1 = state;
		    if (logger == null)
		      null;
		    else {
		      logger.g3h(VOID, MediaEventReducer$lambda(this));
		    }
		  }
		  protoOf(MediaEventReducer).s3q = function (_set____db54di) {
		    this.r3q_1 = _set____db54di;
		  };
		  protoOf(MediaEventReducer).b3n = function (_set____db54di) {
		    return this.s3q(_set____db54di instanceof MediaEventState ? _set____db54di : THROW_CCE());
		  };
		  protoOf(MediaEventReducer).c3n = function () {
		    return this.r3q_1;
		  };
		  protoOf(MediaEventReducer).d3n = function () {
		    return this.r3q_1.t3q();
		  };
		  protoOf(MediaEventReducer).u3q = function (action, state) {
		    var tmp0_subject = action.o3h_1;
		    var tmp;
		    if (tmp0_subject instanceof RTCStatsUpdate) {
		      tmp = state.w3q(action.o3h_1, action.o3h_1.y2m_1);
		    } else {
		      if (tmp0_subject instanceof MediaErrorEvent) {
		        tmp = state.v3q(action.o3h_1, action.o3h_1.w2m_1);
		      } else {
		        tmp = null;
		      }
		    }
		    return tmp;
		  };
		  protoOf(MediaEventReducer).h3n = function (action, state) {
		    return this.u3q(action, state instanceof MediaEventState ? state : THROW_CCE());
		  };
		  function MediaEventState$update$lambda($action) {
		    return function ($this$new) {
		      return $action;
		    };
		  }
		  function MediaEventState$update$lambda_0($action) {
		    return function ($this$new) {
		      return $action;
		    };
		  }
		  function MediaEventState(mediaEvents) {
		    var tmp;
		    if (mediaEvents === VOID) {
		      // Inline function 'kotlin.collections.mutableMapOf' call
		      tmp = LinkedHashMap_init_$Create$();
		    } else {
		      tmp = mediaEvents;
		    }
		    mediaEvents = tmp;
		    this.s3b_1 = mediaEvents;
		    this.t3b_1 = null;
		  }
		  protoOf(MediaEventState).m3n = function () {
		    return this.s3b_1;
		  };
		  protoOf(MediaEventState).n3n = function (_set____db54di) {
		    this.t3b_1 = _set____db54di;
		  };
		  protoOf(MediaEventState).w3q = function (action, callId) {
		    return new_0(this, callId, MediaEventState$update$lambda(action));
		  };
		  protoOf(MediaEventState).v3q = function (action, callId) {
		    return new_0(this, callId, MediaEventState$update$lambda_0(action));
		  };
		  protoOf(MediaEventState).x3q = function (mediaEvents) {
		    return new MediaEventState(mediaEvents);
		  };
		  protoOf(MediaEventState).t3q = function (mediaEvents, $super) {
		    mediaEvents = mediaEvents === VOID ? this.s3b_1 : mediaEvents;
		    return $super === VOID ? this.x3q(mediaEvents) : $super.x3q.call(this, mediaEvents);
		  };
		  protoOf(MediaEventState).toString = function () {
		    return 'MediaEventState(mediaEvents=' + this.s3b_1 + ')';
		  };
		  protoOf(MediaEventState).hashCode = function () {
		    return hashCode(this.s3b_1);
		  };
		  protoOf(MediaEventState).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof MediaEventState))
		      return false;
		    var tmp0_other_with_cast = other instanceof MediaEventState ? other : THROW_CCE();
		    if (!equals(this.s3b_1, tmp0_other_with_cast.s3b_1))
		      return false;
		    return true;
		  };
		  function RTCStats_0(audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter) {
		    this.p3l_1 = audioRecvPackets;
		    this.q3l_1 = audioRecvPacketsLost;
		    this.r3l_1 = audioRecvBytes;
		    this.s3l_1 = audioRecvJitter;
		    this.t3l_1 = audioSentPackets;
		    this.u3l_1 = audioSentBytes;
		    this.v3l_1 = audioSentPacketsLost;
		    this.w3l_1 = audioRtt;
		    this.x3l_1 = audioSentJitter;
		  }
		  protoOf(RTCStats_0).toString = function () {
		    return 'RTCStats(audioRecvPackets=' + this.p3l_1.toString() + ', audioRecvPacketsLost=' + this.q3l_1 + ', audioRecvBytes=' + this.r3l_1.toString() + ', audioRecvJitter=' + this.s3l_1 + ', audioSentPackets=' + this.t3l_1.toString() + ', audioSentBytes=' + this.u3l_1.toString() + ', audioSentPacketsLost=' + this.v3l_1 + ', audioRtt=' + this.w3l_1 + ', audioSentJitter=' + this.x3l_1 + ')';
		  };
		  protoOf(RTCStats_0).hashCode = function () {
		    var result = this.p3l_1.hashCode();
		    result = imul(result, 31) + this.q3l_1 | 0;
		    result = imul(result, 31) + this.r3l_1.hashCode() | 0;
		    result = imul(result, 31) + getNumberHashCode(this.s3l_1) | 0;
		    result = imul(result, 31) + this.t3l_1.hashCode() | 0;
		    result = imul(result, 31) + this.u3l_1.hashCode() | 0;
		    result = imul(result, 31) + this.v3l_1 | 0;
		    result = imul(result, 31) + getNumberHashCode(this.w3l_1) | 0;
		    result = imul(result, 31) + getNumberHashCode(this.x3l_1) | 0;
		    return result;
		  };
		  protoOf(RTCStats_0).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof RTCStats_0))
		      return false;
		    var tmp0_other_with_cast = other instanceof RTCStats_0 ? other : THROW_CCE();
		    if (!this.p3l_1.equals(tmp0_other_with_cast.p3l_1))
		      return false;
		    if (!(this.q3l_1 === tmp0_other_with_cast.q3l_1))
		      return false;
		    if (!this.r3l_1.equals(tmp0_other_with_cast.r3l_1))
		      return false;
		    if (!equals(this.s3l_1, tmp0_other_with_cast.s3l_1))
		      return false;
		    if (!this.t3l_1.equals(tmp0_other_with_cast.t3l_1))
		      return false;
		    if (!this.u3l_1.equals(tmp0_other_with_cast.u3l_1))
		      return false;
		    if (!(this.v3l_1 === tmp0_other_with_cast.v3l_1))
		      return false;
		    if (!equals(this.w3l_1, tmp0_other_with_cast.w3l_1))
		      return false;
		    if (!equals(this.x3l_1, tmp0_other_with_cast.x3l_1))
		      return false;
		    return true;
		  };
		  function Companion_154() {
		    this.y3q_1 = 'default';
		  }
		  var Companion_instance_155;
		  function Companion_getInstance_156() {
		    return Companion_instance_155;
		  }
		  function EventBuffer(localCounter, remoteCounter, localHead, remoteHead) {
		    localCounter = localCounter === VOID ? 0 : localCounter;
		    remoteCounter = remoteCounter === VOID ? 0 : remoteCounter;
		    localHead = localHead === VOID ? null : localHead;
		    remoteHead = remoteHead === VOID ? null : remoteHead;
		    this.w2y_1 = localCounter;
		    this.x2y_1 = remoteCounter;
		    this.y2y_1 = localHead;
		    this.z2y_1 = remoteHead;
		  }
		  protoOf(EventBuffer).toString = function () {
		    return 'EventBuffer(localCounter=' + this.w2y_1 + ', remoteCounter=' + this.x2y_1 + ', localHead=' + this.y2y_1 + ', remoteHead=' + this.z2y_1 + ')';
		  };
		  protoOf(EventBuffer).hashCode = function () {
		    var result = this.w2y_1;
		    result = imul(result, 31) + this.x2y_1 | 0;
		    result = imul(result, 31) + (this.y2y_1 == null ? 0 : hashCode(this.y2y_1)) | 0;
		    result = imul(result, 31) + (this.z2y_1 == null ? 0 : hashCode(this.z2y_1)) | 0;
		    return result;
		  };
		  protoOf(EventBuffer).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof EventBuffer))
		      return false;
		    var tmp0_other_with_cast = other instanceof EventBuffer ? other : THROW_CCE();
		    if (!(this.w2y_1 === tmp0_other_with_cast.w2y_1))
		      return false;
		    if (!(this.x2y_1 === tmp0_other_with_cast.x2y_1))
		      return false;
		    if (!equals(this.y2y_1, tmp0_other_with_cast.y2y_1))
		      return false;
		    if (!equals(this.z2y_1, tmp0_other_with_cast.z2y_1))
		      return false;
		    return true;
		  };
		  function get_UnitAction() {
		    _init_properties_Action_kt__mgyt1y();
		    return UnitAction;
		  }
		  var UnitAction;
		  function Action_init_$Init$(body, $this) {
		    Action_0.call($this, body, new ActionMeta());
		    return $this;
		  }
		  function Action_init_$Create$(body) {
		    return Action_init_$Init$(body, objectCreate(protoOf(Action_0)));
		  }
		  function Companion_155() {
		  }
		  protoOf(Companion_155).m3l = function (e, src) {
		    return new Action_0(new ErrorReport(e, src), src.p3h_1.m3m());
		  };
		  var Companion_instance_156;
		  function Companion_getInstance_157() {
		    return Companion_instance_156;
		  }
		  function Action_0(body, meta) {
		    meta = meta === VOID ? new ActionMeta() : meta;
		    this.o3h_1 = body;
		    this.p3h_1 = meta;
		  }
		  function UnitActionable() {
		  }
		  var UnitActionable_instance;
		  function UnitActionable_getInstance() {
		    return UnitActionable_instance;
		  }
		  function ActionMeta(uuid, entityId, callback) {
		    uuid = uuid === VOID ? generateUUID() : uuid;
		    entityId = entityId === VOID ? null : entityId;
		    callback = callback === VOID ? null : callback;
		    this.q3h_1 = uuid;
		    this.r3h_1 = entityId;
		    this.s3h_1 = callback;
		  }
		  protoOf(ActionMeta).z3q = function (uuid, entityId, callback) {
		    return new ActionMeta(uuid, entityId, callback);
		  };
		  protoOf(ActionMeta).m3m = function (uuid, entityId, callback, $super) {
		    uuid = uuid === VOID ? this.q3h_1 : uuid;
		    entityId = entityId === VOID ? this.r3h_1 : entityId;
		    callback = callback === VOID ? this.s3h_1 : callback;
		    return $super === VOID ? this.z3q(uuid, entityId, callback) : $super.z3q.call(this, uuid, entityId, callback);
		  };
		  protoOf(ActionMeta).toString = function () {
		    return 'ActionMeta(uuid=' + this.q3h_1 + ', entityId=' + this.r3h_1 + ', callback=' + this.s3h_1 + ')';
		  };
		  protoOf(ActionMeta).hashCode = function () {
		    var result = getStringHashCode(this.q3h_1);
		    result = imul(result, 31) + (this.r3h_1 == null ? 0 : getStringHashCode(this.r3h_1)) | 0;
		    result = imul(result, 31) + (this.s3h_1 == null ? 0 : hashCode(this.s3h_1)) | 0;
		    return result;
		  };
		  protoOf(ActionMeta).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof ActionMeta))
		      return false;
		    var tmp0_other_with_cast = other instanceof ActionMeta ? other : THROW_CCE();
		    if (!(this.q3h_1 === tmp0_other_with_cast.q3h_1))
		      return false;
		    if (!(this.r3h_1 == tmp0_other_with_cast.r3h_1))
		      return false;
		    if (!equals(this.s3h_1, tmp0_other_with_cast.s3h_1))
		      return false;
		    return true;
		  };
		  var properties_initialized_Action_kt_vlp01k;
		  function _init_properties_Action_kt__mgyt1y() {
		    if (!properties_initialized_Action_kt_vlp01k) {
		      properties_initialized_Action_kt_vlp01k = true;
		      UnitAction = Action_init_$Create$(UnitActionable_instance);
		    }
		  }
		  function compose(d) {
		    return compose$lambda(d);
		  }
		  function compose$lambda($d) {
		    return function (it) {
		      // Inline function 'kotlin.collections.fold' call
		      var accumulator = it;
		      var tmp0_iterator = filterNotNull(reversed($d)).p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'com.vonage.clientcore.redux.compose.<anonymous>.<anonymous>' call
		        accumulator = element(accumulator);
		      }
		      return accumulator;
		    };
		  }
		  function Reducer$lambda() {
		    return 'Reducer created';
		  }
		  function Reducer$processAction$lambda(this$0) {
		    return function () {
		      var tmp0_elvis_lhs = getKClassFromExpression(this$0).t5();
		      return tmp0_elvis_lhs == null ? 'reducer' : tmp0_elvis_lhs;
		    };
		  }
		  function Reducer$processAction$lambda_0(this$0) {
		    return function () {
		      return 'NEW STATE ' + toString_0(this$0.c3n()) + ' - subscribers: ' + this$0.j3n_1.u();
		    };
		  }
		  function Reducer_0(logger, subscribers) {
		    var tmp;
		    if (subscribers === VOID) {
		      // Inline function 'kotlin.collections.mutableListOf' call
		      tmp = ArrayList_init_$Create$_0();
		    } else {
		      tmp = subscribers;
		    }
		    subscribers = tmp;
		    this.i3n_1 = logger;
		    this.j3n_1 = subscribers;
		    var tmp0_safe_receiver = this.i3n_1;
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      tmp0_safe_receiver.g3h(VOID, Reducer$lambda);
		    }
		  }
		  protoOf(Reducer_0).k3n = function (action) {
		    var tmp0_safe_receiver = this.i3n_1;
		    if (tmp0_safe_receiver == null)
		      null;
		    else {
		      v_0(tmp0_safe_receiver, action, Reducer$processAction$lambda(this));
		    }
		    if (equals(action, get_UnitAction()))
		      return false;
		    var current = this.d3n();
		    var new_0 = this.h3n(action, current);
		    var hasChanged = new_0 == null ? false : current === new_0 ? true : equals(current, new_0);
		    this.b3n(new_0 == null ? this.c3n() : new_0);
		    if (hasChanged) {
		      var tmp2_safe_receiver = this.i3n_1;
		      if (tmp2_safe_receiver == null)
		        null;
		      else {
		        d_0(tmp2_safe_receiver, action, Reducer$processAction$lambda_0(this));
		      }
		    }
		    return hasChanged;
		  };
		  function Store$middleware$lambda(_anonymous_parameter_0__qggqh8) {
		    return Store$middleware$lambda$lambda;
		  }
		  function Store$middleware$lambda$lambda(a) {
		    return a;
		  }
		  function Store$subscribe$lambda($reducer, $sub) {
		    return function () {
		      $reducer.j3n_1.n($sub);
		      return Unit_instance;
		    };
		  }
		  function Store$dispatch$lambda(this$0) {
		    return function (a) {
		      // Inline function 'kotlin.collections.fold' call
		      var this_0 = this$0.r1e_1.r1();
		      // Inline function 'kotlin.collections.mutableListOf' call
		      var accumulator = ArrayList_init_$Create$_0();
		      var tmp0_iterator = this_0.p();
		      while (tmp0_iterator.q()) {
		        var element = tmp0_iterator.s();
		        // Inline function 'com.vonage.clientcore.redux.Store.dispatch.<anonymous>.<anonymous>' call
		        var subs = accumulator;
		        if (element.k3n(a)) {
		          subs.t(element.j3n_1);
		        }
		        accumulator = subs;
		      }
		      var tmp0_iterator_0 = accumulator.p();
		      while (tmp0_iterator_0.q()) {
		        var element_0 = tmp0_iterator_0.s();
		        // Inline function 'com.vonage.clientcore.redux.Store.dispatch.<anonymous>.<anonymous>' call
		        element_0.a3r_1();
		      }
		      return a;
		    };
		  }
		  function Store_0() {
		    var tmp = this;
		    // Inline function 'kotlin.collections.mutableMapOf' call
		    tmp.r1e_1 = LinkedHashMap_init_$Create$();
		    var tmp_0 = this;
		    tmp_0.s1e_1 = Store$middleware$lambda;
		  }
		  protoOf(Store_0).t1e = function (fn) {
		    this.s1e_1 = fn(this);
		  };
		  protoOf(Store_0).w1e = function (reducers) {
		    var tmp = this;
		    // Inline function 'kotlin.collections.fold' call
		    // Inline function 'kotlin.collections.mutableMapOf' call
		    var accumulator = LinkedHashMap_init_$Create$();
		    var tmp0_iterator = reducers.p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.redux.Store.setReducers.<anonymous>' call
		      var map = accumulator;
		      // Inline function 'kotlin.collections.set' call
		      var key = getKClassFromExpression(element);
		      map.s1(key, element);
		      accumulator = map;
		    }
		    tmp.r1e_1 = accumulator;
		  };
		  protoOf(Store_0).a2z = function (key, listener) {
		    var reducer = cast(key, this.r1e_1.c2(key));
		    var sub = listener();
		    reducer.j3n_1.m(sub);
		    return Store$subscribe$lambda(reducer, sub);
		  };
		  protoOf(Store_0).a1g = function (action) {
		    var tmp = this.s1e_1;
		    tmp(Store$dispatch$lambda(this))(action);
		  };
		  protoOf(Store_0).t2y = function (key) {
		    return cast(key, this.r1e_1.c2(key)).c3n();
		  };
		  function StoredSubscription(callback) {
		    this.a3r_1 = callback;
		  }
		  function getQueryParameter(_this__u8e3s4, parameter) {
		    var query = substringAfter(_this__u8e3s4, '?');
		    var queryParams = split(query, ['&']);
		    var tmp0_iterator = queryParams.p();
		    while (tmp0_iterator.q()) {
		      var param = tmp0_iterator.s();
		      var pair = split(param, ['=']);
		      if (pair.u() === 2 ? pair.b1(0) === parameter : false) {
		        return pair.b1(1);
		      }
		    }
		    return null;
		  }
		  function toMaskedString(_this__u8e3s4, properties) {
		    var tmp = getKClassFromExpression(_this__u8e3s4).t5();
		    // Inline function 'kotlin.collections.map' call
		    var this_0 = maskTokenProperty(properties);
		    // Inline function 'kotlin.collections.mapTo' call
		    var destination = ArrayList_init_$Create$(this_0.u());
		    // Inline function 'kotlin.collections.iterator' call
		    var tmp0_iterator = this_0.u1().p();
		    while (tmp0_iterator.q()) {
		      var item = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.utils.toMaskedString.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var key = item.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var value = item.w1();
		      var tmp$ret$3 = key + '=' + value;
		      destination.m(tmp$ret$3);
		    }
		    return '' + tmp + '(' + joinToString(destination, ', ') + ')';
		  }
		  function maskAuthHeader(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.mapValues' call
		    // Inline function 'kotlin.collections.mapValuesTo' call
		    var destination = LinkedHashMap_init_$Create$_0(mapCapacity(_this__u8e3s4.u()));
		    // Inline function 'kotlin.collections.associateByTo' call
		    var tmp0_iterator = _this__u8e3s4.u1().p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
		      var tmp = element.v1();
		      // Inline function 'com.vonage.clientcore.utils.maskAuthHeader.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var key = element.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var value = element.w1();
		      var tmp_0;
		      if (key === 'Authorization' ? startsWith(value, 'bearer ', true) : false) {
		        tmp_0 = 'Bearer <token>';
		      } else {
		        tmp_0 = value;
		      }
		      var tmp$ret$3 = tmp_0;
		      destination.s1(tmp, tmp$ret$3);
		    }
		    return destination;
		  }
		  function maskTokenProperty(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.mapValues' call
		    // Inline function 'kotlin.collections.mapValuesTo' call
		    var destination = LinkedHashMap_init_$Create$_0(mapCapacity(_this__u8e3s4.u()));
		    // Inline function 'kotlin.collections.associateByTo' call
		    var tmp0_iterator = _this__u8e3s4.u1().p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
		      var tmp = element.v1();
		      // Inline function 'com.vonage.clientcore.utils.maskTokenProperty.<anonymous>' call
		      // Inline function 'kotlin.collections.component1' call
		      var key = element.v1();
		      // Inline function 'kotlin.collections.component2' call
		      var value = element.w1();
		      var tmp_0;
		      if (key === 'token' ? !(value === 'null') : false) {
		        tmp_0 = '<token>';
		      } else {
		        tmp_0 = value;
		      }
		      var tmp$ret$3 = tmp_0;
		      destination.s1(tmp, tmp$ret$3);
		    }
		    return destination;
		  }
		  function toJsonElement(_this__u8e3s4) {
		    var tmp;
		    if (isNumber(_this__u8e3s4)) {
		      tmp = JsonPrimitive_1(_this__u8e3s4);
		    } else {
		      if (!(_this__u8e3s4 == null) ? typeof _this__u8e3s4 === 'boolean' : false) {
		        tmp = JsonPrimitive_0(_this__u8e3s4);
		      } else {
		        if (!(_this__u8e3s4 == null) ? typeof _this__u8e3s4 === 'string' : false) {
		          tmp = JsonPrimitive(_this__u8e3s4);
		        } else {
		          if (!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) {
		            tmp = toJsonArray(_this__u8e3s4);
		          } else {
		            if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, List) : false) {
		              tmp = toJsonArray_0(_this__u8e3s4);
		            } else {
		              if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) {
		                tmp = toJsonObject(_this__u8e3s4);
		              } else {
		                if (_this__u8e3s4 instanceof JsonElement) {
		                  tmp = _this__u8e3s4;
		                } else {
		                  if (_this__u8e3s4 instanceof Serializable) {
		                    // Inline function 'kotlinx.serialization.json.encodeToJsonElement' call
		                    var this_0 = Default_getInstance();
		                    // Inline function 'kotlinx.serialization.serializer' call
		                    var this_1 = this_0.tj();
		                    // Inline function 'kotlinx.serialization.internal.cast' call
		                    var this_2 = serializer(this_1, createKType(getKClass(Serializable), arrayOf([]), false));
		                    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
		                    tmp = this_0.c11(tmp$ret$1, _this__u8e3s4);
		                  } else {
		                    tmp = JsonNull_getInstance();
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		    return tmp;
		  }
		  function toJsonArray(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.map' call
		    // Inline function 'kotlin.collections.mapTo' call
		    var destination = ArrayList_init_$Create$(_this__u8e3s4.length);
		    var inductionVariable = 0;
		    var last = _this__u8e3s4.length;
		    while (inductionVariable < last) {
		      var item = _this__u8e3s4[inductionVariable];
		      inductionVariable = inductionVariable + 1 | 0;
		      // Inline function 'com.vonage.clientcore.utils.toJsonArray.<anonymous>' call
		      var tmp$ret$0 = toJsonElement(item);
		      destination.m(tmp$ret$0);
		    }
		    return new JsonArray(destination);
		  }
		  function toJsonArray_0(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.map' call
		    // Inline function 'kotlin.collections.mapTo' call
		    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
		    var tmp0_iterator = _this__u8e3s4.p();
		    while (tmp0_iterator.q()) {
		      var item = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.utils.toJsonArray.<anonymous>' call
		      var tmp$ret$0 = toJsonElement(item);
		      destination.m(tmp$ret$0);
		    }
		    return new JsonArray(destination);
		  }
		  function toJsonObject(_this__u8e3s4) {
		    // Inline function 'kotlin.collections.mapValues' call
		    // Inline function 'kotlin.collections.mapKeys' call
		    // Inline function 'kotlin.collections.mapKeysTo' call
		    var destination = LinkedHashMap_init_$Create$_0(mapCapacity(_this__u8e3s4.u()));
		    // Inline function 'kotlin.collections.associateByTo' call
		    var tmp0_iterator = _this__u8e3s4.u1().p();
		    while (tmp0_iterator.q()) {
		      var element = tmp0_iterator.s();
		      // Inline function 'com.vonage.clientcore.utils.toJsonObject.<anonymous>' call
		      var tmp = toString_0(element.v1());
		      // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
		      var tmp$ret$1 = element.w1();
		      destination.s1(tmp, tmp$ret$1);
		    }
		    // Inline function 'kotlin.collections.mapValuesTo' call
		    var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.u()));
		    // Inline function 'kotlin.collections.associateByTo' call
		    var tmp0_iterator_0 = destination.u1().p();
		    while (tmp0_iterator_0.q()) {
		      var element_0 = tmp0_iterator_0.s();
		      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
		      var tmp_0 = element_0.v1();
		      // Inline function 'com.vonage.clientcore.utils.toJsonObject.<anonymous>' call
		      var tmp$ret$6 = toJsonElement(element_0.w1());
		      destination_0.s1(tmp_0, tmp$ret$6);
		    }
		    return new JsonObject(destination_0);
		  }
		  function Companion_156() {
		  }
		  protoOf(Companion_156).o3l = function (stats) {
		    var jitterTime = stats.s3l_1;
		    var recvPkts = stats.p3l_1;
		    var lostPkts = stats.q3l_1;
		    var average = 100.0;
		    var packetLoss = 0.0;
		    var rValue;
		    // Inline function 'kotlin.Long.plus' call
		    if (recvPkts.r9(toLong(lostPkts)).m8(new Long(0, 0)) > 0) {
		      // Inline function 'kotlin.Long.plus' call
		      packetLoss = 100.0 * (lostPkts / recvPkts.r9(toLong(lostPkts)).q5());
		    }
		    var effectiveLatency = average + jitterTime * 2 + 10;
		    var tmp;
		    if (effectiveLatency < 160.0) {
		      tmp = 93.2 - effectiveLatency / 40;
		    } else {
		      tmp = 93.2 - (effectiveLatency - 120) / 10;
		    }
		    rValue = tmp;
		    rValue = rValue - packetLoss * 2.5;
		    if (rValue < 1.0) {
		      rValue = 1.0;
		    }
		    return 1 + 0.035 * rValue + 7.0E-6 * rValue * (rValue - 60) * (100 - rValue);
		  };
		  var Companion_instance_157;
		  function Companion_getInstance_158() {
		    return Companion_instance_157;
		  }
		  function None_2() {
		    Option.call(this);
		  }
		  function Some(value) {
		    Option.call(this);
		    this.k1z_1 = value;
		  }
		  protoOf(Some).toString = function () {
		    return 'Some(value=' + this.k1z_1 + ')';
		  };
		  protoOf(Some).hashCode = function () {
		    return this.k1z_1 == null ? 0 : hashCode(this.k1z_1);
		  };
		  protoOf(Some).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Some))
		      return false;
		    var tmp0_other_with_cast = other instanceof Some ? other : THROW_CCE();
		    if (!equals(this.k1z_1, tmp0_other_with_cast.k1z_1))
		      return false;
		    return true;
		  };
		  function Companion_157() {
		  }
		  protoOf(Companion_157).b3r = function (typeSerial0) {
		    return new OptionSerializer(typeSerial0);
		  };
		  protoOf(Companion_157).nr = function (typeParamsSerializers) {
		    return this.b3r(typeParamsSerializers[0]);
		  };
		  var Companion_instance_158;
		  function Companion_getInstance_159() {
		    return Companion_instance_158;
		  }
		  function Option() {
		  }
		  protoOf(Option).t1t = function () {
		    var tmp;
		    if (this instanceof None_2) {
		      tmp = null;
		    } else {
		      if (this instanceof Some) {
		        tmp = this.k1z_1;
		      } else {
		        noWhenBranchMatchedException();
		      }
		    }
		    return tmp;
		  };
		  protoOf(Option).l37 = function (value) {
		    var tmp;
		    if (this instanceof None_2) {
		      tmp = false;
		    } else {
		      if (this instanceof Some) {
		        tmp = equals(this.k1z_1, value);
		      } else {
		        noWhenBranchMatchedException();
		      }
		    }
		    return tmp;
		  };
		  protoOf(Option).m37 = function (f) {
		    var tmp;
		    if (this instanceof None_2) {
		      tmp = new None_2();
		    } else {
		      if (this instanceof Some) {
		        var tmp1_safe_receiver = this.k1z_1;
		        var tmp_0;
		        if (tmp1_safe_receiver == null) {
		          tmp_0 = null;
		        } else {
		          // Inline function 'kotlin.let' call
		          // Inline function 'kotlin.contracts.contract' call
		          // Inline function 'com.vonage.clientcore.utils.Option.mapNotNull.<anonymous>' call
		          tmp_0 = new Some(f(tmp1_safe_receiver));
		        }
		        var tmp2_elvis_lhs = tmp_0;
		        tmp = tmp2_elvis_lhs == null ? some(null) : tmp2_elvis_lhs;
		      } else {
		        noWhenBranchMatchedException();
		      }
		    }
		    return tmp;
		  };
		  protoOf(Option).equals = function (other) {
		    var tmp;
		    if (other instanceof None_2) {
		      tmp = this instanceof None_2;
		    } else {
		      if (other instanceof Some) {
		        var tmp_0;
		        if (this instanceof Some) {
		          tmp_0 = equals(this.k1z_1, other.k1z_1);
		        } else {
		          tmp_0 = false;
		        }
		        tmp = tmp_0;
		      } else {
		        tmp = false;
		      }
		    }
		    return tmp;
		  };
		  protoOf(Option).hashCode = function () {
		    var tmp;
		    if (this instanceof None_2) {
		      tmp = 0;
		    } else {
		      if (this instanceof Some) {
		        // Inline function 'kotlin.hashCode' call
		        var tmp0_safe_receiver = this.k1z_1;
		        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
		        tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
		      } else {
		        noWhenBranchMatchedException();
		      }
		    }
		    return tmp;
		  };
		  function none() {
		    return new None_2();
		  }
		  function some(value) {
		    return new Some(value);
		  }
		  function getSessionUserOrError(_this__u8e3s4, callback) {
		    var sessionState = _this__u8e3s4.t2y(getKClass(SessionReducer));
		    var s = sessionState.l38_1.w1();
		    var tmp;
		    if (s instanceof Active) {
		      tmp = s.p2n_1;
		    } else {
		      // Inline function 'kotlin.let' call
		      invokeCallbackWithError(new SessionNoActiveSessionError(), callback);
		      // Inline function 'kotlin.contracts.contract' call
		      // Inline function 'com.vonage.clientcore.utils.getSessionUserOrError.<anonymous>' call
		      tmp = null;
		    }
		    return tmp;
		  }
		  function getSessionUserOrError_0(_this__u8e3s4, callback) {
		    return getSessionUserOrError(_this__u8e3s4, getSessionUserOrError$lambda(callback));
		  }
		  function getSessionUserOrError$lambda($callback) {
		    return function (exception, _anonymous_parameter_1__qggqgd) {
		      $callback(exception);
		      return Unit_instance;
		    };
		  }
		  function Pending(value, future, requestId) {
		    StateTransition.call(this);
		    this.c3r_1 = value;
		    this.d3r_1 = future;
		    this.e3r_1 = requestId;
		  }
		  protoOf(Pending).w1 = function () {
		    return this.c3r_1;
		  };
		  protoOf(Pending).x3a = function () {
		    return this.e3r_1;
		  };
		  protoOf(Pending).toString = function () {
		    return 'Pending(value=' + this.c3r_1 + ', future=' + this.d3r_1 + ', requestId=' + this.e3r_1 + ')';
		  };
		  protoOf(Pending).hashCode = function () {
		    var result = this.c3r_1 == null ? 0 : hashCode(this.c3r_1);
		    result = imul(result, 31) + (this.d3r_1 == null ? 0 : hashCode(this.d3r_1)) | 0;
		    result = imul(result, 31) + getStringHashCode(this.e3r_1) | 0;
		    return result;
		  };
		  protoOf(Pending).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Pending))
		      return false;
		    var tmp0_other_with_cast = other instanceof Pending ? other : THROW_CCE();
		    if (!equals(this.c3r_1, tmp0_other_with_cast.c3r_1))
		      return false;
		    if (!equals(this.d3r_1, tmp0_other_with_cast.d3r_1))
		      return false;
		    if (!(this.e3r_1 === tmp0_other_with_cast.e3r_1))
		      return false;
		    return true;
		  };
		  function Resolved(value, requestId) {
		    requestId = requestId === VOID ? null : requestId;
		    StateTransition.call(this);
		    this.f3r_1 = value;
		    this.g3r_1 = requestId;
		  }
		  protoOf(Resolved).w1 = function () {
		    return this.f3r_1;
		  };
		  protoOf(Resolved).x3a = function () {
		    return this.g3r_1;
		  };
		  protoOf(Resolved).toString = function () {
		    return 'Resolved(value=' + this.f3r_1 + ', requestId=' + this.g3r_1 + ')';
		  };
		  protoOf(Resolved).hashCode = function () {
		    var result = this.f3r_1 == null ? 0 : hashCode(this.f3r_1);
		    result = imul(result, 31) + (this.g3r_1 == null ? 0 : getStringHashCode(this.g3r_1)) | 0;
		    return result;
		  };
		  protoOf(Resolved).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Resolved))
		      return false;
		    var tmp0_other_with_cast = other instanceof Resolved ? other : THROW_CCE();
		    if (!equals(this.f3r_1, tmp0_other_with_cast.f3r_1))
		      return false;
		    if (!(this.g3r_1 == tmp0_other_with_cast.g3r_1))
		      return false;
		    return true;
		  };
		  function Failed(error, value, requestId) {
		    requestId = requestId === VOID ? null : requestId;
		    StateTransition.call(this);
		    this.v38_1 = error;
		    this.w38_1 = value;
		    this.x38_1 = requestId;
		  }
		  protoOf(Failed).w1 = function () {
		    return this.w38_1;
		  };
		  protoOf(Failed).x3a = function () {
		    return this.x38_1;
		  };
		  protoOf(Failed).toString = function () {
		    return 'Failed(error=' + this.v38_1 + ', value=' + this.w38_1 + ', requestId=' + this.x38_1 + ')';
		  };
		  protoOf(Failed).hashCode = function () {
		    var result = this.v38_1.hashCode();
		    result = imul(result, 31) + (this.w38_1 == null ? 0 : hashCode(this.w38_1)) | 0;
		    result = imul(result, 31) + (this.x38_1 == null ? 0 : getStringHashCode(this.x38_1)) | 0;
		    return result;
		  };
		  protoOf(Failed).equals = function (other) {
		    if (this === other)
		      return true;
		    if (!(other instanceof Failed))
		      return false;
		    var tmp0_other_with_cast = other instanceof Failed ? other : THROW_CCE();
		    if (!this.v38_1.equals(tmp0_other_with_cast.v38_1))
		      return false;
		    if (!equals(this.w38_1, tmp0_other_with_cast.w38_1))
		      return false;
		    if (!(this.x38_1 == tmp0_other_with_cast.x38_1))
		      return false;
		    return true;
		  };
		  function StateTransition() {
		  }
		  function toResolved(_this__u8e3s4, value) {
		    return new Resolved(value, _this__u8e3s4.x3a());
		  }
		  function toPending(_this__u8e3s4, future, requestId) {
		    return new Pending(_this__u8e3s4.w1(), future, requestId);
		  }
		  function toFailed(_this__u8e3s4, err) {
		    var tmp;
		    if (_this__u8e3s4 instanceof Pending) {
		      tmp = new Failed(new Pair(_this__u8e3s4.d3r_1, err), _this__u8e3s4.w1(), _this__u8e3s4.e3r_1);
		    } else {
		      if (_this__u8e3s4 instanceof Resolved) {
		        tmp = _this__u8e3s4;
		      } else {
		        if (_this__u8e3s4 instanceof Failed) {
		          tmp = _this__u8e3s4;
		        } else {
		          noWhenBranchMatchedException();
		        }
		      }
		    }
		    return tmp;
		  }
		  function generateUUID() {
		    return uuidToken(8) + '-' + uuidToken(4) + '-' + uuidToken(4) + '-' + uuidToken(4) + '-' + uuidToken(12);
		  }
		  function uuidToken(len) {
		    var chars = listOf([new Char(_Char___init__impl__6a9atx(97)), new Char(_Char___init__impl__6a9atx(98)), new Char(_Char___init__impl__6a9atx(99)), new Char(_Char___init__impl__6a9atx(100)), new Char(_Char___init__impl__6a9atx(101)), new Char(_Char___init__impl__6a9atx(102))]);
		    var res = '';
		    var inductionVariable = 1;
		    if (inductionVariable <= len)
		      do {
		        var i = inductionVariable;
		        inductionVariable = inductionVariable + 1 | 0;
		        // Inline function 'kotlin.ranges.random' call
		        var this_0 = numberRangeToNumber(0, 15);
		        var n = random(this_0, Default_getInstance_0());
		        var c = n < 10 ? n : chars.b1(n - 10 | 0);
		        res = res + toString(c);
		      }
		       while (!(i === len));
		    return res;
		  }
		  function generateTimeStamp() {
		    var tmp = Date.now();
		    return isNumber(tmp) ? tmp : THROW_CCE();
		  }
		  //region block: post-declaration
		  protoOf(CoreClientImpl).s1d = getConversationEvents$default;
		  protoOf(CoreClientImpl).t1d = sendMessageEvent$default;
		  protoOf(UpdateSessionRequest).y1h = queryParams;
		  protoOf(UpdateSessionRequest).z1h = isSanitized;
		  protoOf($serializer).fr = typeParametersSerializers;
		  protoOf($serializer_0).fr = typeParametersSerializers;
		  protoOf($serializer_1).fr = typeParametersSerializers;
		  protoOf(MetricsWsReconnectionTimeReq).y1h = queryParams;
		  protoOf(MetricsWsReconnectionTimeReq).z1h = isSanitized;
		  protoOf($serializer_2).fr = typeParametersSerializers;
		  protoOf(GetLegRequest).y1h = queryParams;
		  protoOf(GetLegRequest).w1h = encode;
		  protoOf(GetLegRequest).z1h = isSanitized;
		  protoOf($serializer_3).fr = typeParametersSerializers;
		  protoOf(GetConversationRequest).y1h = queryParams;
		  protoOf(GetConversationRequest).w1h = encode;
		  protoOf(GetConversationRequest).z1h = isSanitized;
		  protoOf($serializer_4).fr = typeParametersSerializers;
		  protoOf($serializer_5).fr = typeParametersSerializers;
		  protoOf(GetConversationLegsRequest).w1h = encode;
		  protoOf(GetConversationLegsRequest).z1h = isSanitized;
		  protoOf($serializer_6).fr = typeParametersSerializers;
		  protoOf($serializer_7).fr = typeParametersSerializers;
		  protoOf($serializer_8).fr = typeParametersSerializers;
		  protoOf($serializer_9).fr = typeParametersSerializers;
		  protoOf(AppKnockingRequest).y1h = queryParams;
		  protoOf(AppKnockingRequest).z1h = isSanitized;
		  protoOf(MemberKickRequest).z1h = isSanitized;
		  protoOf($serializer_10).fr = typeParametersSerializers;
		  protoOf($serializer_11).fr = typeParametersSerializers;
		  protoOf(MemberJoinRequest).y1h = queryParams;
		  protoOf(MemberJoinRequest).z1h = isSanitized;
		  protoOf(DeleteKnockerRequest).y1h = queryParams;
		  protoOf(DeleteKnockerRequest).z1h = isSanitized;
		  protoOf($serializer_12).fr = typeParametersSerializers;
		  protoOf($serializer_13).fr = typeParametersSerializers;
		  protoOf(LegMuteRequest).y1h = queryParams;
		  protoOf(LegMuteRequest).z1h = isSanitized;
		  protoOf($serializer_14).fr = typeParametersSerializers;
		  protoOf($serializer_15).fr = typeParametersSerializers;
		  protoOf(LegUnmuteRequest).y1h = queryParams;
		  protoOf(LegUnmuteRequest).z1h = isSanitized;
		  protoOf($serializer_16).fr = typeParametersSerializers;
		  protoOf($serializer_17).fr = typeParametersSerializers;
		  protoOf(LegEarmuffEnableRequest).y1h = queryParams;
		  protoOf(LegEarmuffEnableRequest).z1h = isSanitized;
		  protoOf($serializer_18).fr = typeParametersSerializers;
		  protoOf($serializer_19).fr = typeParametersSerializers;
		  protoOf(LegEarmuffDisableRequest).y1h = queryParams;
		  protoOf(LegEarmuffDisableRequest).z1h = isSanitized;
		  protoOf($serializer_20).fr = typeParametersSerializers;
		  protoOf($serializer_21).fr = typeParametersSerializers;
		  protoOf(LegDTMFRequest).y1h = queryParams;
		  protoOf(LegDTMFRequest).z1h = isSanitized;
		  protoOf($serializer_22).fr = typeParametersSerializers;
		  protoOf($serializer_23).fr = typeParametersSerializers;
		  protoOf(AudioSayRequest).y1h = queryParams;
		  protoOf(AudioSayRequest).z1h = isSanitized;
		  protoOf($serializer_24).fr = typeParametersSerializers;
		  protoOf($serializer_25).fr = typeParametersSerializers;
		  defineProp(protoOf(CSError), 'message', function () {
		    return this.ab();
		  });
		  protoOf(GetMyMemberRequest).y1h = queryParams;
		  protoOf(GetMyMemberRequest).w1h = encode;
		  protoOf(GetMyMemberRequest).z1h = isSanitized;
		  protoOf($serializer_26).fr = typeParametersSerializers;
		  protoOf($serializer_27).fr = typeParametersSerializers;
		  protoOf($serializer_28).fr = typeParametersSerializers;
		  protoOf($serializer_29).fr = typeParametersSerializers;
		  protoOf(PostConversationEventRequest).y1h = queryParams;
		  protoOf($serializer_30).fr = typeParametersSerializers;
		  protoOf(UpdateEventStateRequestBody).z1h = isSanitized_0;
		  protoOf($serializer_31).fr = typeParametersSerializers;
		  protoOf(CreateConversationRequest).y1h = queryParams;
		  protoOf($serializer_32).fr = typeParametersSerializers;
		  protoOf($serializer_33).fr = typeParametersSerializers;
		  protoOf($serializer_34).fr = typeParametersSerializers;
		  protoOf(UpdateConversationRequest).y1h = queryParams;
		  protoOf($serializer_35).fr = typeParametersSerializers;
		  protoOf($serializer_36).fr = typeParametersSerializers;
		  protoOf($serializer_37).fr = typeParametersSerializers;
		  protoOf(ConversationJoinRequest).y1h = queryParams;
		  protoOf(ConversationJoinRequest).z1h = isSanitized;
		  protoOf($serializer_38).fr = typeParametersSerializers;
		  protoOf($serializer_39).fr = typeParametersSerializers;
		  protoOf($serializer_40).fr = typeParametersSerializers;
		  protoOf($serializer_41).fr = typeParametersSerializers;
		  protoOf($serializer_42).fr = typeParametersSerializers;
		  protoOf($serializer_43).fr = typeParametersSerializers;
		  protoOf(ConversationInviteRequest).y1h = queryParams;
		  protoOf(ConversationInviteRequest).z1h = isSanitized;
		  protoOf($serializer_44).fr = typeParametersSerializers;
		  protoOf(ConversationDeleteRequest).y1h = queryParams;
		  protoOf(ConversationDeleteRequest).z1h = isSanitized;
		  protoOf(GetUserConversationsRequest).w1h = encode;
		  protoOf(GetUserConversationsRequest).z1h = isSanitized;
		  protoOf($serializer_45).fr = typeParametersSerializers;
		  protoOf($serializer_46).fr = typeParametersSerializers;
		  protoOf(GetConversationEventsRequest).w1h = encode;
		  protoOf(GetConversationEventsRequest).z1h = isSanitized;
		  protoOf($serializer_47).fr = typeParametersSerializers;
		  protoOf($serializer_48).fr = typeParametersSerializers;
		  protoOf(GetConversationMembersRequest).w1h = encode;
		  protoOf(GetConversationMembersRequest).z1h = isSanitized;
		  protoOf($serializer_49).fr = typeParametersSerializers;
		  protoOf($serializer_50).fr = typeParametersSerializers;
		  protoOf(GetConversationMemberRequest).y1h = queryParams;
		  protoOf(GetConversationMemberRequest).w1h = encode;
		  protoOf(GetConversationMemberRequest).z1h = isSanitized;
		  protoOf($serializer_51).fr = typeParametersSerializers;
		  protoOf($serializer_52).fr = typeParametersSerializers;
		  protoOf(DeleteConversationEventRequest).w1h = encode;
		  protoOf(DeleteConversationEventRequest).z1h = isSanitized;
		  protoOf($serializer_53).fr = typeParametersSerializers;
		  protoOf($serializer_54).fr = typeParametersSerializers;
		  protoOf($serializer_55).fr = typeParametersSerializers;
		  protoOf($serializer_56).fr = typeParametersSerializers;
		  protoOf(GetUserRequest).y1h = queryParams;
		  protoOf(GetUserRequest).w1h = encode;
		  protoOf(GetUserRequest).z1h = isSanitized;
		  protoOf($serializer_57).fr = typeParametersSerializers;
		  protoOf(RTCStatsReportRequest).y1h = queryParams;
		  protoOf(RTCStatsReportRequest).z1h = isSanitized;
		  protoOf($serializer_58).fr = typeParametersSerializers;
		  protoOf($serializer_59).fr = typeParametersSerializers;
		  protoOf($serializer_60).fr = typeParametersSerializers;
		  protoOf(PostLegRequest).y1h = queryParams;
		  protoOf(PostLegRequest).z1h = isSanitized;
		  protoOf($serializer_61).fr = typeParametersSerializers;
		  protoOf($serializer_62).fr = typeParametersSerializers;
		  protoOf($serializer_63).fr = typeParametersSerializers;
		  protoOf(RTCAnswerRequest).y1h = queryParams;
		  protoOf(RTCAnswerRequest).z1h = isSanitized;
		  protoOf($serializer_64).fr = typeParametersSerializers;
		  protoOf($serializer_65).fr = typeParametersSerializers;
		  protoOf($serializer_66).fr = typeParametersSerializers;
		  protoOf(RTCReconnectRequest).y1h = queryParams;
		  protoOf(RTCReconnectRequest).z1h = isSanitized;
		  protoOf($serializer_67).fr = typeParametersSerializers;
		  protoOf($serializer_68).fr = typeParametersSerializers;
		  protoOf($serializer_69).fr = typeParametersSerializers;
		  protoOf($serializer_70).fr = typeParametersSerializers;
		  protoOf($serializer_71).fr = typeParametersSerializers;
		  protoOf($serializer_72).fr = typeParametersSerializers;
		  protoOf($serializer_73).fr = typeParametersSerializers;
		  protoOf($serializer_74).fr = typeParametersSerializers;
		  protoOf($serializer_75).fr = typeParametersSerializers;
		  protoOf($serializer_76).fr = typeParametersSerializers;
		  protoOf($serializer_77).fr = typeParametersSerializers;
		  protoOf($serializer_78).fr = typeParametersSerializers;
		  protoOf($serializer_79).fr = typeParametersSerializers;
		  protoOf(CSConversationEventJsonBody).z1h = isSanitized_0;
		  protoOf($serializer_80).fr = typeParametersSerializers;
		  protoOf($serializer_81).fr = typeParametersSerializers;
		  protoOf($serializer_82).fr = typeParametersSerializers;
		  protoOf($serializer_83).fr = typeParametersSerializers;
		  protoOf($serializer_84).fr = typeParametersSerializers;
		  protoOf($serializer_85).fr = typeParametersSerializers;
		  protoOf($serializer_86).fr = typeParametersSerializers;
		  protoOf($serializer_87).fr = typeParametersSerializers;
		  protoOf($serializer_88).fr = typeParametersSerializers;
		  protoOf($serializer_89).fr = typeParametersSerializers;
		  protoOf($serializer_90).fr = typeParametersSerializers;
		  protoOf($serializer_91).fr = typeParametersSerializers;
		  protoOf($serializer_92).fr = typeParametersSerializers;
		  protoOf($serializer_93).fr = typeParametersSerializers;
		  protoOf($serializer_94).fr = typeParametersSerializers;
		  protoOf($serializer_95).fr = typeParametersSerializers;
		  protoOf($serializer_96).fr = typeParametersSerializers;
		  protoOf($serializer_97).fr = typeParametersSerializers;
		  protoOf($serializer_98).fr = typeParametersSerializers;
		  protoOf($serializer_99).fr = typeParametersSerializers;
		  protoOf($serializer_100).fr = typeParametersSerializers;
		  protoOf($serializer_101).fr = typeParametersSerializers;
		  protoOf($serializer_102).fr = typeParametersSerializers;
		  protoOf($serializer_103).fr = typeParametersSerializers;
		  protoOf($serializer_104).fr = typeParametersSerializers;
		  protoOf($serializer_105).fr = typeParametersSerializers;
		  protoOf($serializer_106).fr = typeParametersSerializers;
		  protoOf($serializer_107).fr = typeParametersSerializers;
		  protoOf($serializer_108).fr = typeParametersSerializers;
		  protoOf($serializer_109).fr = typeParametersSerializers;
		  protoOf($serializer_110).fr = typeParametersSerializers;
		  protoOf($serializer_111).fr = typeParametersSerializers;
		  protoOf($serializer_112).fr = typeParametersSerializers;
		  protoOf($serializer_113).fr = typeParametersSerializers;
		  protoOf($serializer_114).fr = typeParametersSerializers;
		  protoOf($serializer_115).fr = typeParametersSerializers;
		  protoOf($serializer_116).fr = typeParametersSerializers;
		  protoOf($serializer_117).fr = typeParametersSerializers;
		  protoOf($serializer_118).fr = typeParametersSerializers;
		  protoOf($serializer_119).fr = typeParametersSerializers;
		  protoOf($serializer_120).fr = typeParametersSerializers;
		  protoOf($serializer_121).fr = typeParametersSerializers;
		  protoOf($serializer_122).fr = typeParametersSerializers;
		  protoOf($serializer_123).fr = typeParametersSerializers;
		  protoOf($serializer_124).fr = typeParametersSerializers;
		  protoOf($serializer_125).fr = typeParametersSerializers;
		  protoOf($serializer_126).fr = typeParametersSerializers;
		  protoOf($serializer_127).fr = typeParametersSerializers;
		  protoOf($serializer_128).fr = typeParametersSerializers;
		  protoOf($serializer_129).fr = typeParametersSerializers;
		  protoOf($serializer_130).fr = typeParametersSerializers;
		  protoOf($serializer_131).fr = typeParametersSerializers;
		  protoOf($serializer_132).fr = typeParametersSerializers;
		  protoOf($serializer_133).fr = typeParametersSerializers;
		  protoOf($serializer_134).fr = typeParametersSerializers;
		  protoOf($serializer_135).fr = typeParametersSerializers;
		  protoOf($serializer_136).fr = typeParametersSerializers;
		  protoOf($serializer_137).fr = typeParametersSerializers;
		  protoOf($serializer_138).fr = typeParametersSerializers;
		  protoOf($serializer_139).fr = typeParametersSerializers;
		  protoOf(CustomBody).z1h = isSanitized_0;
		  protoOf(TemplateBody).z1h = isSanitized_0;
		  protoOf($serializer_140).fr = typeParametersSerializers;
		  protoOf($serializer_141).fr = typeParametersSerializers;
		  protoOf($serializer_142).fr = typeParametersSerializers;
		  protoOf($serializer_143).fr = typeParametersSerializers;
		  protoOf($serializer_144).fr = typeParametersSerializers;
		  protoOf($serializer_145).fr = typeParametersSerializers;
		  defineProp(protoOf(SessionError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(SessionError), 'cause', function () {
		    return this.bb();
		  });
		  defineProp(protoOf(SessionConnectError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(SessionNoActiveSessionError), 'message', function () {
		    return this.ab();
		  });
		  protoOf(DeleteSession).m2o = encode_0;
		  protoOf($serializer_146).fr = typeParametersSerializers;
		  protoOf($serializer_147).fr = typeParametersSerializers;
		  protoOf($serializer_148).fr = typeParametersSerializers;
		  protoOf($serializer_149).fr = typeParametersSerializers;
		  protoOf($serializer_150).fr = typeParametersSerializers;
		  defineProp(protoOf(SessionEmptyTokenError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(SessionSocketTransportError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(SessionTimeoutError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(SessionInvalidError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(SessionInvalidTokenError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(AuthorizationError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(SessionExpiredTokenError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(SessionMaxOpenSessions), 'message', function () {
		    return this.ab();
		  });
		  protoOf($serializer_151).fr = typeParametersSerializers;
		  protoOf($serializer_152).fr = typeParametersSerializers;
		  protoOf($serializer_153).fr = typeParametersSerializers;
		  protoOf(ChatAPIImpl$1).r2t = onRTCHangup;
		  protoOf(ChatAPIImpl$1).s2t = onRTCTransfer;
		  protoOf(ChatAPIImpl$1).t2t = onLegStatusUpdate;
		  protoOf(ChatAPIImpl$1).u2t = onAudioSay;
		  protoOf(ChatAPIImpl$1).v2t = onAudioMuteUpdate;
		  protoOf(ChatAPIImpl$1).w2t = onAudioEarmuffUpdate;
		  protoOf(ChatAPIImpl$1).x2t = onAudioDTMFUpdate;
		  protoOf(ChatAPIImpl).s1d = getConversationEvents$default;
		  protoOf(ChatAPIImpl).t1d = sendMessageEvent$default;
		  defineProp(protoOf(InternalError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(InternalError), 'cause', function () {
		    return this.bb();
		  });
		  defineProp(protoOf(MediaClientError), 'message', function () {
		    return this.ab();
		  });
		  defineProp(protoOf(MediaClientError), 'cause', function () {
		    return this.bb();
		  });
		  protoOf($serializer_154).fr = typeParametersSerializers;
		  protoOf($serializer_155).fr = typeParametersSerializers;
		  protoOf($serializer_156).fr = typeParametersSerializers;
		  protoOf($serializer_157).fr = typeParametersSerializers;
		  protoOf($serializer_158).fr = typeParametersSerializers;
		  protoOf($serializer_159).fr = typeParametersSerializers;
		  protoOf($serializer_160).fr = typeParametersSerializers;
		  protoOf($serializer_161).fr = typeParametersSerializers;
		  protoOf($serializer_162).fr = typeParametersSerializers;
		  protoOf(VoiceAPIImpl$1).u2t = onAudioSay;
		  protoOf(VoiceAPIImpl$1).q2t = onConversationEvent;
		  protoOf($serializer_163).fr = typeParametersSerializers;
		  protoOf($serializer_164).fr = typeParametersSerializers;
		  protoOf($serializer_165).fr = typeParametersSerializers;
		  protoOf($serializer_166).fr = typeParametersSerializers;
		  protoOf($serializer_167).fr = typeParametersSerializers;
		  protoOf($serializer_168).fr = typeParametersSerializers;
		  protoOf($serializer_169).fr = typeParametersSerializers;
		  protoOf($serializer_170).fr = typeParametersSerializers;
		  protoOf($serializer_171).fr = typeParametersSerializers;
		  protoOf($serializer_172).fr = typeParametersSerializers;
		  protoOf($serializer_173).fr = typeParametersSerializers;
		  protoOf($serializer_174).fr = typeParametersSerializers;
		  protoOf($serializer_175).fr = typeParametersSerializers;
		  protoOf(LoggerAdapter).y3g = v;
		  protoOf(LoggerAdapter).z3g = d;
		  protoOf(LoggerAdapter).a3h = i;
		  protoOf(LoggerAdapter).b3h = w;
		  protoOf(LoggerAdapter).c3h = e;
		  protoOf(LoggerAdapter).d3h = e_0;
		  protoOf(HTTPClientLogger).a3i = clear;
		  protoOf(ChatAPILogger).s1d = getConversationEvents$default;
		  protoOf(ChatAPILogger).t1d = sendMessageEvent$default;
		  defineProp(protoOf(IgnoredSerializerException), 'message', function () {
		    return this.ab();
		  });
		  //endregion
		  //region block: init
		  BuildKonfig_instance = new BuildKonfig();
		  StaticConfig_instance = new StaticConfig();
		  Companion_instance_1 = new Companion_0();
		  Companion_instance_2 = new Companion_1();
		  Companion_instance_3 = new Companion_2();
		  Companion_instance_4 = new Companion_3();
		  Companion_instance_7 = new Companion_6();
		  Companion_instance_8 = new Companion_7();
		  Companion_instance_9 = new Companion_8();
		  Companion_instance_10 = new Companion_9();
		  Companion_instance_11 = new Companion_10();
		  Companion_instance_12 = new Companion_11();
		  Companion_instance_13 = new Companion_12();
		  Companion_instance_14 = new Companion_13();
		  Companion_instance_15 = new Companion_14();
		  Companion_instance_16 = new Companion_15();
		  Companion_instance_17 = new Companion_16();
		  Companion_instance_18 = new Companion_17();
		  Companion_instance_19 = new Companion_18();
		  Companion_instance_20 = new Companion_19();
		  Companion_instance_21 = new Companion_20();
		  Companion_instance_22 = new Companion_21();
		  Companion_instance_25 = new Companion_24();
		  Companion_instance_26 = new Companion_25();
		  Companion_instance_27 = new Companion_26();
		  Companion_instance_28 = new Companion_27();
		  Companion_instance_29 = new Companion_28();
		  Companion_instance_32 = new Companion_31();
		  Companion_instance_33 = new Companion_32();
		  Companion_instance_34 = new Companion_33();
		  Companion_instance_35 = new Companion_34();
		  Companion_instance_36 = new Companion_35();
		  Companion_instance_37 = new Companion_36();
		  Companion_instance_38 = new Companion_37();
		  Companion_instance_39 = new Companion_38();
		  Companion_instance_40 = new Companion_39();
		  Companion_instance_41 = new Companion_40();
		  Companion_instance_43 = new Companion_42();
		  Companion_instance_45 = new Companion_44();
		  Companion_instance_47 = new Companion_46();
		  Companion_instance_48 = new Companion_47();
		  Companion_instance_49 = new Companion_48();
		  Companion_instance_50 = new Companion_49();
		  Companion_instance_51 = new Companion_50();
		  Companion_instance_52 = new Companion_51();
		  Companion_instance_53 = new Companion_52();
		  Companion_instance_54 = new Companion_53();
		  Companion_instance_55 = new Companion_54();
		  Companion_instance_56 = new Companion_55();
		  Companion_instance_57 = new Companion_56();
		  Companion_instance_58 = new Companion_57();
		  Companion_instance_59 = new Companion_58();
		  Companion_instance_60 = new Companion_59();
		  Companion_instance_61 = new Companion_60();
		  Companion_instance_62 = new Companion_61();
		  Companion_instance_63 = new Companion_62();
		  Companion_instance_64 = new Companion_63();
		  Companion_instance_65 = new Companion_64();
		  Companion_instance_66 = new Companion_65();
		  Companion_instance_67 = new Companion_66();
		  Companion_instance_68 = new Companion_67();
		  Companion_instance_69 = new Companion_68();
		  Companion_instance_70 = new Companion_69();
		  Companion_instance_71 = new Companion_70();
		  Companion_instance_72 = new Companion_71();
		  Companion_instance_73 = new Companion_72();
		  Companion_instance_74 = new Companion_73();
		  Companion_instance_76 = new Companion_75();
		  Companion_instance_77 = new Companion_76();
		  Companion_instance_78 = new Companion_77();
		  Companion_instance_79 = new Companion_78();
		  Companion_instance_80 = new Companion_79();
		  Companion_instance_81 = new Companion_80();
		  Companion_instance_82 = new Companion_81();
		  Companion_instance_84 = new Companion_83();
		  Companion_instance_85 = new Companion_84();
		  Companion_instance_87 = new Companion_86();
		  Companion_instance_88 = new Companion_87();
		  Companion_instance_89 = new Companion_88();
		  Companion_instance_90 = new Companion_89();
		  Companion_instance_91 = new Companion_90();
		  Companion_instance_92 = new Companion_91();
		  Companion_instance_93 = new Companion_92();
		  Companion_instance_94 = new Companion_93();
		  Companion_instance_96 = new Companion_95();
		  Companion_instance_97 = new Companion_96();
		  Companion_instance_98 = new Companion_97();
		  Companion_instance_99 = new Companion_98();
		  Companion_instance_100 = new Companion_99();
		  Companion_instance_101 = new Companion_100();
		  Companion_instance_102 = new Companion_101();
		  Companion_instance_103 = new Companion_102();
		  Companion_instance_104 = new Companion_103();
		  Companion_instance_105 = new Companion_104();
		  Companion_instance_106 = new Companion_105();
		  Companion_instance_107 = new Companion_106();
		  Companion_instance_108 = new Companion_107();
		  Companion_instance_109 = new Companion_108();
		  Companion_instance_110 = new Companion_109();
		  Companion_instance_111 = new Companion_110();
		  Companion_instance_112 = new Companion_111();
		  Companion_instance_113 = new Companion_112();
		  Companion_instance_114 = new Companion_113();
		  Companion_instance_115 = new Companion_114();
		  Companion_instance_116 = new Companion_115();
		  Companion_instance_117 = new Companion_116();
		  Companion_instance_118 = new Companion_117();
		  Companion_instance_119 = new Companion_118();
		  Companion_instance_120 = new Companion_119();
		  Companion_instance_121 = new Companion_120();
		  Companion_instance_122 = new Companion_121();
		  Companion_instance_125 = new Companion_124();
		  Companion_instance_126 = new Companion_125();
		  DeleteSession_instance = new DeleteSession();
		  SocketDisconnect_instance = new SocketDisconnect();
		  Companion_instance_127 = new Companion_126();
		  SocketConnectEmptyTokenError_instance = new SocketConnectEmptyTokenError();
		  Companion_instance_128 = new Companion_127();
		  Companion_instance_129 = new Companion_128();
		  Companion_instance_130 = new Companion_129();
		  Companion_instance_131 = new Companion_130();
		  Companion_instance_132 = new Companion_131();
		  Companion_instance_133 = new Companion_132();
		  Companion_instance_134 = new Companion_133();
		  Companion_instance_135 = new Companion_134();
		  CSErrorCodes_instance = new CSErrorCodes();
		  Companion_instance_137 = new Companion_136();
		  SessionErrorCodes_instance = new SessionErrorCodes();
		  SessionErrorMessages_instance = new SessionErrorMessages();
		  Companion_instance_138 = new Companion_137();
		  Companion_instance_141 = new Companion_140();
		  Companion_instance_142 = new Companion_141();
		  System_instance = new System();
		  Companion_instance_143 = new Companion_142();
		  Companion_instance_144 = new Companion_143();
		  Companion_instance_145 = new Companion_144();
		  Companion_instance_151 = new Companion_150();
		  New_instance = new New();
		  Connected_instance = new Connected();
		  Disconnected_instance = new Disconnected();
		  None_instance_1 = new None_1();
		  Companion_instance_155 = new Companion_154();
		  Companion_instance_156 = new Companion_155();
		  UnitActionable_instance = new UnitActionable();
		  Companion_instance_157 = new Companion_156();
		  Companion_instance_158 = new Companion_157();
		  //endregion
		  //region block: exports
		  _.$_$ = _.$_$ || {};
		  _.$_$.a = UnknownSocketEvent;
		  _.$_$.b = CreateAnswerError;
		  _.$_$.c = CreateOfferError;
		  _.$_$.d = PeerConnectionNotFound;
		  _.$_$.e = ProcessAnswerError;
		  _.$_$.f = TrackNotFound;
		  _.$_$.g = VonageError;
		  _.$_$.h = CreateConversationParameters;
		  _.$_$.i = CustomConversationEvent;
		  _.$_$.j = EmbeddedInfo;
		  _.$_$.k = EphemeralConversationEvent;
		  _.$_$.l = EventDeleteConversationEvent;
		  _.$_$.m = GetCallLegsParameters;
		  _.$_$.n = GetConversationEventsParameters;
		  _.$_$.o = GetConversationMembersParameters;
		  _.$_$.p = GetConversationsParameters;
		  _.$_$.q = MemberInvitedConversationEvent;
		  _.$_$.r = MemberJoinedConversationEvent;
		  _.$_$.s = MemberLeftConversationEvent;
		  _.$_$.t = MessageAudioEvent;
		  _.$_$.u = MessageCustomEvent;
		  _.$_$.v = MessageDeliveredEvent;
		  _.$_$.w = MessageFileEvent;
		  _.$_$.x = MessageImageEvent;
		  _.$_$.y = Location;
		  _.$_$.z = MessageLocationEvent;
		  _.$_$.a1 = MessageRejectedEvent;
		  _.$_$.b1 = MessageSeenEvent;
		  _.$_$.c1 = MessageSubmittedEvent;
		  _.$_$.d1 = TemplateObject_0;
		  _.$_$.e1 = WhatsappObject_0;
		  _.$_$.f1 = MessageTemplateEvent;
		  _.$_$.g1 = MessageTextEvent;
		  _.$_$.h1 = MessageUndeliverableEvent;
		  _.$_$.i1 = MessageVCardEvent;
		  _.$_$.j1 = MessageVideoEvent;
		  _.$_$.k1 = PersistentConversationEvent;
		  _.$_$.l1 = UpdateConversationParameters;
		  _.$_$.m1 = valueOf_1;
		  _.$_$.n1 = VoiceClientListener;
		  _.$_$.o1 = LoggerAdapter;
		  _.$_$.p1 = createVonageLogger;
		  _.$_$.q1 = clear;
		  _.$_$.r1 = HTTPClientError;
		  _.$_$.s1 = HTTPClientResponse;
		  _.$_$.t1 = HTTPClient;
		  _.$_$.u1 = RTCStats_0;
		  _.$_$.v1 = SetConfig;
		  _.$_$.w1 = Builder;
		  _.$_$.x1 = none;
		  _.$_$.y1 = some;
		  _.$_$.z1 = SocketConnectionFailedReason_ClientDisconnected_getInstance;
		  _.$_$.a2 = SocketConnectionFailedReason_ClientNetworkError_getInstance;
		  _.$_$.b2 = SocketConnectionFailedReason_PingTimeout_getInstance;
		  _.$_$.c2 = SocketConnectionFailedReason_ServerDisconnected_getInstance;
		  _.$_$.d2 = SocketConnectionStatus_Connected_getInstance;
		  _.$_$.e2 = SocketConnectionStatus_Disconnected_getInstance;
		  _.$_$.f2 = SocketConnectionStatus_Reconnecting_getInstance;
		  _.$_$.g2 = OrderBy_CREATED_getInstance;
		  _.$_$.h2 = OrderBy_CUSTOM_SORT_KEY_getInstance;
		  _.$_$.i2 = PresentingOrder_ASC_getInstance;
		  _.$_$.j2 = PresentingOrder_DESC_getInstance;
		  _.$_$.k2 = ClientConfigRegion_AP_getInstance;
		  _.$_$.l2 = ClientConfigRegion_EU_getInstance;
		  _.$_$.m2 = ClientConfigRegion_US_getInstance;
		  _.$_$.n2 = SessionErrorReason_PingTimeout_getInstance;
		  _.$_$.o2 = SessionErrorReason_TokenExpired_getInstance;
		  _.$_$.p2 = SessionErrorReason_TransportClosed_getInstance;
		  _.$_$.q2 = MediaConnectionState_Closed_getInstance;
		  _.$_$.r2 = MediaConnectionState_Connected_getInstance;
		  _.$_$.s2 = MediaConnectionState_Connecting_getInstance;
		  _.$_$.t2 = MediaConnectionState_Disconnected_getInstance;
		  _.$_$.u2 = MediaConnectionState_Failed_getInstance;
		  _.$_$.v2 = MediaConnectionState_New_getInstance;
		  _.$_$.w2 = MediaConnectionState_Unknown_getInstance;
		  _.$_$.x2 = System_instance;
		  _.$_$.y2 = Companion_getInstance_137;
		  _.$_$.z2 = DefaultConfig_getInstance;
		  _.$_$.a3 = Companion_getInstance_155;
		  _.$_$.b3 = Companion_instance_158;
		  //endregion
		  return _;
		}));

		
} (clientsdkClientcore, clientsdkClientcoreExports));
	return clientsdkClientcoreExports;
}

(function (module, exports) {
	(function (root, factory) {
	  if (typeof undefined === 'function' && undefined.amd)
	    undefined(['exports', './kotlin-kotlin-stdlib.js', './clientsdk-clientcore.js'], factory);
	  else if ('object' === 'object')
	    factory(module.exports, requireKotlinKotlinStdlib(), requireClientsdkClientcore());
	  else {
	    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
	      throw new Error("Error loading module 'clientsdk:clientcore_js'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'clientsdk:clientcore_js'.");
	    }
	    if (typeof this['clientsdk-clientcore'] === 'undefined') {
	      throw new Error("Error loading module 'clientsdk:clientcore_js'. Its dependency 'clientsdk-clientcore' was not found. Please, check whether 'clientsdk-clientcore' is loaded prior to 'clientsdk:clientcore_js'.");
	    }
	    root['clientsdk:clientcore_js'] = factory(typeof this['clientsdk:clientcore_js'] === 'undefined' ? {} : this['clientsdk:clientcore_js'], this['kotlin-kotlin-stdlib'], this['clientsdk-clientcore']);
	  }
	}(commonjsGlobal, function (_, kotlin_kotlin, kotlin_com_vonage_rtc_clientcore) {
	  'use strict';
	  //region block: imports
	  var imul = Math.imul;
	  var protoOf = kotlin_kotlin.$_$.x7;
	  var THROW_CCE = kotlin_kotlin.$_$.w9;
	  var objectMeta = kotlin_kotlin.$_$.w7;
	  var setMetadataFor = kotlin_kotlin.$_$.y7;
	  var Unit_instance = kotlin_kotlin.$_$.w3;
	  var classMeta = kotlin_kotlin.$_$.q6;
	  var VOID = kotlin_kotlin.$_$.f;
	  var VoiceClientListener = kotlin_com_vonage_rtc_clientcore.$_$.n1;
	  var Builder = kotlin_com_vonage_rtc_clientcore.$_$.w1;
	  var LoggerAdapter = kotlin_com_vonage_rtc_clientcore.$_$.o1;
	  var defineProp = kotlin_kotlin.$_$.r6;
	  var noWhenBranchMatchedException = kotlin_kotlin.$_$.ra;
	  var THROW_IAE = kotlin_kotlin.$_$.x9;
	  var Enum = kotlin_kotlin.$_$.p9;
	  var collectionSizeOrDefault = kotlin_kotlin.$_$.m4;
	  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
	  var copyToArray = kotlin_kotlin.$_$.z4;
	  var interfaceMeta = kotlin_kotlin.$_$.a7;
	  var System_instance = kotlin_com_vonage_rtc_clientcore.$_$.x2;
	  var equals = kotlin_kotlin.$_$.s6;
	  var EmbeddedInfo = kotlin_com_vonage_rtc_clientcore.$_$.j;
	  var EphemeralConversationEvent = kotlin_com_vonage_rtc_clientcore.$_$.k;
	  var PersistentConversationEvent = kotlin_com_vonage_rtc_clientcore.$_$.k1;
	  var isInterface = kotlin_kotlin.$_$.i7;
	  var MessageSeenEvent = kotlin_com_vonage_rtc_clientcore.$_$.b1;
	  var MessageUndeliverableEvent = kotlin_com_vonage_rtc_clientcore.$_$.h1;
	  var MessageSubmittedEvent = kotlin_com_vonage_rtc_clientcore.$_$.c1;
	  var MessageRejectedEvent = kotlin_com_vonage_rtc_clientcore.$_$.a1;
	  var MessageDeliveredEvent = kotlin_com_vonage_rtc_clientcore.$_$.v;
	  var EventDeleteConversationEvent = kotlin_com_vonage_rtc_clientcore.$_$.l;
	  var CustomConversationEvent = kotlin_com_vonage_rtc_clientcore.$_$.i;
	  var MessageLocationEvent = kotlin_com_vonage_rtc_clientcore.$_$.z;
	  var MessageTemplateEvent = kotlin_com_vonage_rtc_clientcore.$_$.f1;
	  var MessageVCardEvent = kotlin_com_vonage_rtc_clientcore.$_$.i1;
	  var MessageFileEvent = kotlin_com_vonage_rtc_clientcore.$_$.w;
	  var MessageAudioEvent = kotlin_com_vonage_rtc_clientcore.$_$.t;
	  var MessageVideoEvent = kotlin_com_vonage_rtc_clientcore.$_$.j1;
	  var MessageImageEvent = kotlin_com_vonage_rtc_clientcore.$_$.x;
	  var MessageCustomEvent = kotlin_com_vonage_rtc_clientcore.$_$.u;
	  var MessageTextEvent = kotlin_com_vonage_rtc_clientcore.$_$.g1;
	  var MemberLeftConversationEvent = kotlin_com_vonage_rtc_clientcore.$_$.s;
	  var MemberJoinedConversationEvent = kotlin_com_vonage_rtc_clientcore.$_$.r;
	  var MemberInvitedConversationEvent = kotlin_com_vonage_rtc_clientcore.$_$.q;
	  var mapCapacity = kotlin_kotlin.$_$.s5;
	  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.q;
	  var PresentingOrder_ASC_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.i2;
	  var PresentingOrder_DESC_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.j2;
	  var OrderBy_CREATED_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.g2;
	  var OrderBy_CUSTOM_SORT_KEY_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.h2;
	  var extendThrowable = kotlin_kotlin.$_$.t6;
	  var captureStack = kotlin_kotlin.$_$.l6;
	  var CreateOfferError = kotlin_com_vonage_rtc_clientcore.$_$.c;
	  var CreateAnswerError = kotlin_com_vonage_rtc_clientcore.$_$.b;
	  var ProcessAnswerError = kotlin_com_vonage_rtc_clientcore.$_$.e;
	  var TrackNotFound = kotlin_com_vonage_rtc_clientcore.$_$.f;
	  var PeerConnectionNotFound = kotlin_com_vonage_rtc_clientcore.$_$.d;
	  var getStringHashCode = kotlin_kotlin.$_$.y6;
	  var VonageError = kotlin_com_vonage_rtc_clientcore.$_$.g;
	  var newThrowable = kotlin_kotlin.$_$.p7;
	  var toString = kotlin_kotlin.$_$.c8;
	  var Location = kotlin_com_vonage_rtc_clientcore.$_$.y;
	  var toList = kotlin_kotlin.$_$.d6;
	  var TemplateObject = kotlin_com_vonage_rtc_clientcore.$_$.d1;
	  var WhatsappObject = kotlin_com_vonage_rtc_clientcore.$_$.e1;
	  var Pair = kotlin_kotlin.$_$.u9;
	  var ClientConfigRegion_AP_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.k2;
	  var ClientConfigRegion_EU_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.l2;
	  var ClientConfigRegion_US_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.m2;
	  var DefaultConfig_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.z2;
	  var Companion_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.y2;
	  var SessionErrorReason_TokenExpired_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.o2;
	  var SessionErrorReason_TransportClosed_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.p2;
	  var SessionErrorReason_PingTimeout_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.n2;
	  var SetConfig = kotlin_com_vonage_rtc_clientcore.$_$.v1;
	  var Companion_getInstance_0 = kotlin_com_vonage_rtc_clientcore.$_$.a3;
	  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.i;
	  var addAll = kotlin_kotlin.$_$.k4;
	  var createVonageLogger = kotlin_com_vonage_rtc_clientcore.$_$.p1;
	  var emptyList = kotlin_kotlin.$_$.b5;
	  var valueOf = kotlin_com_vonage_rtc_clientcore.$_$.m1;
	  var emptyMap = kotlin_kotlin.$_$.c5;
	  var Exception = kotlin_kotlin.$_$.q9;
	  var HTTPClientError = kotlin_com_vonage_rtc_clientcore.$_$.r1;
	  var hashCode = kotlin_kotlin.$_$.z6;
	  var getNumberHashCode = kotlin_kotlin.$_$.w6;
	  var numberToLong = kotlin_kotlin.$_$.u7;
	  var numberToInt = kotlin_kotlin.$_$.t7;
	  var numberToDouble = kotlin_kotlin.$_$.s7;
	  var RTCStats = kotlin_com_vonage_rtc_clientcore.$_$.u1;
	  var MediaConnectionState_New_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.v2;
	  var MediaConnectionState_Connecting_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.s2;
	  var MediaConnectionState_Connected_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.r2;
	  var MediaConnectionState_Disconnected_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.t2;
	  var MediaConnectionState_Closed_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.q2;
	  var MediaConnectionState_Failed_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.u2;
	  var MediaConnectionState_Unknown_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.w2;
	  var HTTPClientResponse = kotlin_com_vonage_rtc_clientcore.$_$.s1;
	  var clear = kotlin_com_vonage_rtc_clientcore.$_$.q1;
	  var HTTPClient = kotlin_com_vonage_rtc_clientcore.$_$.t1;
	  var Exception_init_$Create$ = kotlin_kotlin.$_$.y;
	  var UnknownSocketEvent = kotlin_com_vonage_rtc_clientcore.$_$.a;
	  var SocketConnectionStatus_Connected_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.d2;
	  var SocketConnectionStatus_Reconnecting_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.f2;
	  var SocketConnectionStatus_Disconnected_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.e2;
	  var SocketConnectionFailedReason_ServerDisconnected_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.c2;
	  var SocketConnectionFailedReason_ClientDisconnected_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.z1;
	  var SocketConnectionFailedReason_ClientNetworkError_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.a2;
	  var SocketConnectionFailedReason_PingTimeout_getInstance = kotlin_com_vonage_rtc_clientcore.$_$.b2;
	  var some = kotlin_com_vonage_rtc_clientcore.$_$.y1;
	  var none = kotlin_com_vonage_rtc_clientcore.$_$.x1;
	  var CreateConversationParameters = kotlin_com_vonage_rtc_clientcore.$_$.h;
	  var Companion_instance = kotlin_com_vonage_rtc_clientcore.$_$.b3;
	  var UpdateConversationParameters = kotlin_com_vonage_rtc_clientcore.$_$.l1;
	  var GetConversationsParameters = kotlin_com_vonage_rtc_clientcore.$_$.p;
	  var GetConversationEventsParameters = kotlin_com_vonage_rtc_clientcore.$_$.n;
	  var GetConversationMembersParameters = kotlin_com_vonage_rtc_clientcore.$_$.o;
	  var GetCallLegsParameters = kotlin_com_vonage_rtc_clientcore.$_$.m;
	  var to = kotlin_kotlin.$_$.wa;
	  var toMap = kotlin_kotlin.$_$.e6;
	  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.r;
	  var Map = kotlin_kotlin.$_$.f4;
	  var json = kotlin_kotlin.$_$.n7;
	  //endregion
	  //region block: pre-declaration
	  setMetadataFor(VoiceChannelTypeObject, 'VoiceChannelTypeObject', objectMeta);
	  setMetadataFor(CombinedClientJS$1, VOID, classMeta);
	  setMetadataFor(CombinedClientJS$2, VOID, classMeta, VOID, [VoiceClientListener]);
	  setMetadataFor(CombinedClientJS$3, VOID, classMeta);
	  function setConfig(config) {
	    this.core.z1f(new SetConfig(getWebsocketUrl(config), getWebsocketPath(config), getApiUrl(config), true, 'js', 'Generic JS Navigator', '@vonage/client-sdk', getRtcStatsTelemetry(config), getAutoReconnectMedia(config), getNoiseSuppression(config)));
	  }
	  function createSession(token, sessionId) {
	    return new Promise(ICoreClientJS$createSession$lambda(this, token, sessionId));
	  }
	  function deleteSession() {
	    return new Promise(ICoreClientJS$deleteSession$lambda(this));
	  }
	  function refreshSession(token) {
	    return new Promise(ICoreClientJS$refreshSession$lambda(this, token));
	  }
	  function getConversation(conversationIdOrName) {
	    return new Promise(ICoreClientJS$getConversation$lambda(this, conversationIdOrName));
	  }
	  function getUser(userIdOrName) {
	    return new Promise(ICoreClientJS$getUser$lambda(this, userIdOrName));
	  }
	  setMetadataFor(ICoreClientJS, 'ICoreClientJS', interfaceMeta);
	  function createConversation(parameters) {
	    return new Promise(IChatClientJS$createConversation$lambda(this, parameters));
	  }
	  function joinConversation(cid) {
	    return new Promise(IChatClientJS$joinConversation$lambda(this, cid));
	  }
	  function inviteToConversation(cid, username) {
	    return new Promise(IChatClientJS$inviteToConversation$lambda(this, cid, username));
	  }
	  function leaveConversation(cid) {
	    return new Promise(IChatClientJS$leaveConversation$lambda(this, cid));
	  }
	  function deleteConversation(cid) {
	    return new Promise(IChatClientJS$deleteConversation$lambda(this, cid));
	  }
	  function getConversations(parameters) {
	    return new Promise(IChatClientJS$getConversations$lambda(this, parameters));
	  }
	  function getConversationMembers(cid, parameters) {
	    return new Promise(IChatClientJS$getConversationMembers$lambda(this, cid, parameters));
	  }
	  function getConversationEvents(cid, parameters) {
	    return new Promise(IChatClientJS$getConversationEvents$lambda(this, cid, parameters));
	  }
	  function getConversationMember(cid, mid) {
	    return new Promise(IChatClientJS$getConversationMember$lambda(this, cid, mid));
	  }
	  function sendMessageTextEvent(cid, text) {
	    return new Promise(IChatClientJS$sendMessageTextEvent$lambda(this, cid, text));
	  }
	  function sendMessageCustomEvent(cid, customData) {
	    return new Promise(IChatClientJS$sendMessageCustomEvent$lambda(this, cid, customData));
	  }
	  function sendMessageImageEvent(cid, imageURL) {
	    return new Promise(IChatClientJS$sendMessageImageEvent$lambda(this, cid, imageURL));
	  }
	  function sendMessageVideoEvent(cid, videoURL) {
	    return new Promise(IChatClientJS$sendMessageVideoEvent$lambda(this, cid, videoURL));
	  }
	  function sendMessageFileEvent(cid, fileURL) {
	    return new Promise(IChatClientJS$sendMessageFileEvent$lambda(this, cid, fileURL));
	  }
	  function sendMessageAudioEvent(cid, audioURL) {
	    return new Promise(IChatClientJS$sendMessageAudioEvent$lambda(this, cid, audioURL));
	  }
	  function sendMessageVCardEvent(cid, vCardURL) {
	    return new Promise(IChatClientJS$sendMessageVCardEvent$lambda(this, cid, vCardURL));
	  }
	  function sendMessageLocationEvent(cid, location) {
	    return new Promise(IChatClientJS$sendMessageLocationEvent$lambda(this, cid, location));
	  }
	  function sendMessageTemplateEvent(cid, templateObject, whatsappObject) {
	    return new Promise(IChatClientJS$sendMessageTemplateEvent$lambda(this, cid, templateObject, whatsappObject));
	  }
	  function sendEphemeralEvent(cid, customData) {
	    return new Promise(IChatClientJS$sendEphemeralEvent$lambda(this, cid, customData));
	  }
	  function sendCustomEvent(cid, eventType, customData) {
	    return new Promise(IChatClientJS$sendCustomEvent$lambda(this, cid, eventType, customData));
	  }
	  function deleteEvent(id, conversationId) {
	    return new Promise(IChatClientJS$deleteEvent$lambda(this, id, conversationId));
	  }
	  function sendMessageSeenEvent(id, conversationId) {
	    return new Promise(IChatClientJS$sendMessageSeenEvent$lambda(this, id, conversationId));
	  }
	  function updateConversation(conversationId, parameters) {
	    return new Promise(IChatClientJS$updateConversation$lambda(this, conversationId, parameters));
	  }
	  setMetadataFor(IChatClientJS, 'IChatClientJS', interfaceMeta, VOID, [ICoreClientJS]);
	  function getPeerConnection(id) {
	    return this.media.getPeerConnection(id);
	  }
	  function getAudioOutputElement() {
	    return this.media.getAudioOutputElement();
	  }
	  function serverCall(context) {
	    var tmp0_safe_receiver = get_jsonNullable(context);
	    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toMap_0(tmp0_safe_receiver);
	    var tmp;
	    if (tmp1_elvis_lhs == null) {
	      // Inline function 'kotlin.collections.mapOf' call
	      tmp = emptyMap();
	    } else {
	      tmp = tmp1_elvis_lhs;
	    }
	    var typedContext = tmp;
	    return new Promise(IVoiceClientJS$serverCall$lambda(this, typedContext));
	  }
	  function reconnectCall(legId) {
	    return new Promise(IVoiceClientJS$reconnectCall$lambda(this, legId));
	  }
	  function getLeg(legId) {
	    return new Promise(IVoiceClientJS$getLeg$lambda(this, legId));
	  }
	  function getCallLegs(callId, parameters) {
	    return new Promise(IVoiceClientJS$getCallLegs$lambda(this, callId, parameters));
	  }
	  function answer(callId) {
	    return new Promise(IVoiceClientJS$answer$lambda(this, callId));
	  }
	  function reject(callId) {
	    return new Promise(IVoiceClientJS$reject$lambda(this, callId));
	  }
	  function hangup(callId, reasonText, reasonCode) {
	    return new Promise(IVoiceClientJS$hangup$lambda(this, callId, reasonText, reasonCode));
	  }
	  function say(callId, params) {
	    return new Promise(IVoiceClientJS$say$lambda(this, callId, params));
	  }
	  function mute(callId) {
	    return new Promise(IVoiceClientJS$mute$lambda(this, callId));
	  }
	  function unmute(callId) {
	    return new Promise(IVoiceClientJS$unmute$lambda(this, callId));
	  }
	  function enableEarmuff(callId) {
	    return new Promise(IVoiceClientJS$enableEarmuff$lambda(this, callId));
	  }
	  function disableEarmuff(callId) {
	    return new Promise(IVoiceClientJS$disableEarmuff$lambda(this, callId));
	  }
	  function sendDTMF(callId, digits) {
	    return new Promise(IVoiceClientJS$sendDTMF$lambda(this, callId, digits));
	  }
	  setMetadataFor(IVoiceClientJS, 'IVoiceClientJS', interfaceMeta, VOID, [ICoreClientJS]);
	  setMetadataFor(CombinedClientJS, 'CombinedClientJS', classMeta, VOID, [IChatClientJS, IVoiceClientJS]);
	  setMetadataFor(EventStateTypeJS, 'EventStateTypeJS', classMeta, Enum);
	  setMetadataFor(EventStateJS, 'EventStateJS', classMeta);
	  setMetadataFor(EventsPageJS, 'EventsPageJS', classMeta);
	  setMetadataFor(FromJS, 'FromJS', interfaceMeta);
	  setMetadataFor(EmbeddedInfoJS, 'EmbeddedInfoJS', classMeta, VOID, [FromJS]);
	  setMetadataFor(SystemJS, 'SystemJS', objectMeta, VOID, [FromJS]);
	  setMetadataFor(ConversationEventJS, 'ConversationEventJS', interfaceMeta);
	  setMetadataFor(NonPersistentConversationEventJS, 'NonPersistentConversationEventJS', interfaceMeta, VOID, [ConversationEventJS]);
	  setMetadataFor(PersistentConversationEventJS, 'PersistentConversationEventJS', interfaceMeta, VOID, [ConversationEventJS]);
	  setMetadataFor(MemberEventJS, 'MemberEventJS', interfaceMeta);
	  setMetadataFor(MemberEventBodyJS, 'MemberEventBodyJS', classMeta);
	  setMetadataFor(MemberInvitedEventJS, 'MemberInvitedEventJS', classMeta, VOID, [MemberEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MemberJoinedEventJS, 'MemberJoinedEventJS', classMeta, VOID, [MemberEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MemberLeftEventJS, 'MemberLeftEventJS', classMeta, VOID, [MemberEventJS, PersistentConversationEventJS]);
	  setMetadataFor(JSONBodyEventJS, 'JSONBodyEventJS', interfaceMeta);
	  setMetadataFor(CustomConversationEventJS, 'CustomConversationEventJS', classMeta, VOID, [PersistentConversationEventJS, JSONBodyEventJS]);
	  setMetadataFor(EphemeralConversationEventJS, 'EphemeralConversationEventJS', classMeta, VOID, [NonPersistentConversationEventJS, JSONBodyEventJS]);
	  setMetadataFor(EventStateBodyJS, 'EventStateBodyJS', classMeta);
	  setMetadataFor(EventDeleteConversationEventJS, 'EventDeleteConversationEventJS', classMeta, VOID, [PersistentConversationEventJS, JSONBodyEventJS]);
	  setMetadataFor(MessageDeliveredEventJS, 'MessageDeliveredEventJS', classMeta, VOID, [PersistentConversationEventJS, JSONBodyEventJS]);
	  setMetadataFor(MessageRejectedEventJS, 'MessageRejectedEventJS', classMeta, VOID, [PersistentConversationEventJS, JSONBodyEventJS]);
	  setMetadataFor(MessageUndeliverableEventJS, 'MessageUndeliverableEventJS', classMeta, VOID, [PersistentConversationEventJS, JSONBodyEventJS]);
	  setMetadataFor(MessageSubmittedEventJS, 'MessageSubmittedEventJS', classMeta, VOID, [PersistentConversationEventJS, JSONBodyEventJS]);
	  setMetadataFor(MessageSeenEventJS, 'MessageSeenEventJS', classMeta, VOID, [PersistentConversationEventJS, JSONBodyEventJS]);
	  setMetadataFor(MessageEventJS, 'MessageEventJS', interfaceMeta);
	  setMetadataFor(MessageEventBodyJS, 'MessageEventBodyJS', interfaceMeta);
	  setMetadataFor(MessageTextEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(MessageTextEventJS, 'MessageTextEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MessageCustomEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(MessageCustomEventJS, 'MessageCustomEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MessageAudioEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(MessageAudioEventJS, 'MessageAudioEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MessageVideoEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(MessageVideoEventJS, 'MessageVideoEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MessageImageEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(MessageImageEventJS, 'MessageImageEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MessageFileEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(MessageFileEventJS, 'MessageFileEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MessageVCardEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(MessageVCardEventJS, 'MessageVCardEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MessageLocationEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(Location_0, 'Location', classMeta);
	  setMetadataFor(MessageLocationEventJS, 'MessageLocationEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(MessageTemplateEventBody, 'Body', classMeta, VOID, [MessageEventBodyJS]);
	  setMetadataFor(TemplateObject_0, 'TemplateObject', classMeta);
	  setMetadataFor(WhatsappObject_0, 'WhatsappObject', classMeta);
	  setMetadataFor(MessageTemplateEventJS, 'MessageTemplateEventJS', classMeta, VOID, [MessageEventJS, PersistentConversationEventJS]);
	  setMetadataFor(PresentingOrderJS, 'PresentingOrderJS', classMeta, Enum);
	  setMetadataFor(OrderByJS, 'OrderByJS', classMeta, Enum);
	  setMetadataFor(Properties, 'Properties', classMeta);
	  setMetadataFor(ConversationJS, 'ConversationJS', classMeta);
	  setMetadataFor(ConversationStateJS, 'ConversationStateJS', objectMeta);
	  setMetadataFor(ConversationTimestampJS, 'ConversationTimestampJS', classMeta);
	  setMetadataFor(ConversationsPageJS, 'ConversationsPageJS', classMeta);
	  setMetadataFor(MemberJS, 'MemberJS', classMeta);
	  setMetadataFor(MemberStateJSObj, 'MemberStateJSObj', objectMeta);
	  setMetadataFor(MemberTimestampJS, 'MemberTimestampJS', classMeta);
	  setMetadataFor(MembersPageJS, 'MembersPageJS', classMeta);
	  setMetadataFor(UserJS, 'UserJS', classMeta);
	  setMetadataFor(UserTimestampJS, 'UserTimestampJS', classMeta);
	  setMetadataFor(UserChannelsJS, 'UserChannelsJS', classMeta);
	  setMetadataFor(MemberChannelJS, 'MemberChannelJS', classMeta);
	  setMetadataFor(ChannelJS, 'ChannelJS', classMeta);
	  setMetadataFor(LegChannelJS, 'LegChannelJS', classMeta);
	  setMetadataFor(MediaStateJS, 'MediaStateJS', classMeta);
	  setMetadataFor(LegJS, 'LegJS', classMeta);
	  setMetadataFor(LegsPageJS, 'LegsPageJS', classMeta);
	  setMetadataFor(ChannelTypeObj, 'ChannelTypeObj', objectMeta);
	  setMetadataFor(CSErrorCodesJS, 'CSErrorCodesJS', objectMeta);
	  setMetadataFor(SessionErrorCodesJS, 'SessionErrorCodesJS', objectMeta);
	  setMetadataFor(VonageErrorJS, 'VonageErrorJS', classMeta, Error);
	  setMetadataFor(VonageErrorTypeJS, 'VonageErrorTypeJS', classMeta, Enum);
	  setMetadataFor(MediaClientErrorJS, 'MediaClientErrorJS', classMeta);
	  setMetadataFor(PeerConnectionNotFoundJS, 'PeerConnectionNotFoundJS', classMeta, MediaClientErrorJS);
	  setMetadataFor(TrackNotFoundJS, 'TrackNotFoundJS', classMeta, MediaClientErrorJS);
	  setMetadataFor(ProcessAnswerErrorJS, 'ProcessAnswerErrorJS', classMeta, MediaClientErrorJS);
	  setMetadataFor(CreateAnswerErrorJS, 'CreateAnswerErrorJS', classMeta, MediaClientErrorJS, VOID, CreateAnswerErrorJS);
	  setMetadataFor(CreateOfferErrorJS, 'CreateOfferErrorJS', classMeta, MediaClientErrorJS, VOID, CreateOfferErrorJS);
	  setMetadataFor(CoreClientConfigRegionJS, 'CoreClientConfigRegionJS', classMeta, Enum);
	  setMetadataFor(CoreClientConfigJS, 'CoreClientConfigJS', classMeta, VOID, VOID, CoreClientConfigJS);
	  setMetadataFor(TopicJS, 'TopicJS', classMeta);
	  setMetadataFor(Topics, 'Topics', classMeta, Enum);
	  setMetadataFor(LoggingLevelJS, 'LoggingLevelJS', classMeta, Enum);
	  setMetadataFor(SessionErrorReasonJS, 'SessionErrorReasonJS', classMeta, Enum);
	  setMetadataFor(createVonageLoggerJS$1, VOID, classMeta);
	  setMetadataFor(LegStatusJSObject, 'LegStatusJSObject', objectMeta);
	  setMetadataFor(CallDisconnectReasonJSObject, 'CallDisconnectReasonJSObject', objectMeta);
	  setMetadataFor(HangupReasonJSObject, 'HangupReasonJSObject', objectMeta);
	  setMetadataFor(VoiceInviteFromInfoJS, 'VoiceInviteFromInfoJS', classMeta);
	  setMetadataFor(HttpClientErrorJS, 'HttpClientErrorJS', classMeta, Error, VOID, HttpClientErrorJS);
	  setMetadataFor(HttpClientResponseJS, 'HttpClientResponseJS', classMeta);
	  setMetadataFor(CancelReasonJSObject, 'CancelReasonJSObject', objectMeta);
	  setMetadataFor(RTCQualityJS, 'RTCQualityJS', classMeta);
	  setMetadataFor(Companion, 'Companion', objectMeta);
	  setMetadataFor(RTCStatsJS, 'RTCStatsJS', classMeta);
	  setMetadataFor(HttpClientJSAdapter$1, VOID, classMeta, VOID, [HTTPClient]);
	  setMetadataFor(SocketClientJSAdapter$adapter$1, VOID, classMeta);
	  setMetadataFor(SocketClientJSAdapter$1, VOID, classMeta);
	  setMetadataFor(MediaClientJSAdapter$adapter$1, VOID, classMeta);
	  setMetadataFor(MediaClientJSAdapter$1, VOID, classMeta);
	  setMetadataFor(OptionJS, 'OptionJS', classMeta);
	  setMetadataFor(None, 'None', classMeta, OptionJS, VOID, None);
	  setMetadataFor(Some, 'Some', classMeta, OptionJS);
	  setMetadataFor(Companion_0, 'Companion', objectMeta);
	  //endregion
	  function VoiceChannelTypeObject() {
	    this.app = 'app';
	    this.phone = 'phone';
	    this.sip = 'sip';
	    this.websocket = 'websocket';
	  }
	  protoOf(VoiceChannelTypeObject).h3r = function () {
	    return this.app;
	  };
	  protoOf(VoiceChannelTypeObject).i3r = function () {
	    return this.phone;
	  };
	  protoOf(VoiceChannelTypeObject).j3r = function () {
	    return this.sip;
	  };
	  protoOf(VoiceChannelTypeObject).k3r = function () {
	    return this.websocket;
	  };
	  protoOf(VoiceChannelTypeObject).toString = function () {
	    return 'VoiceChannelTypeObject';
	  };
	  protoOf(VoiceChannelTypeObject).hashCode = function () {
	    return -1025446930;
	  };
	  protoOf(VoiceChannelTypeObject).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof VoiceChannelTypeObject))
	      return false;
	    other instanceof VoiceChannelTypeObject || THROW_CCE();
	    return true;
	  };
	  var VoiceChannelTypeObject_instance;
	  function VoiceChannelTypeObject_getInstance() {
	    return VoiceChannelTypeObject_instance;
	  }
	  function CombinedClientJS$1(this$0) {
	    this.l3r_1 = this$0;
	  }
	  protoOf(CombinedClientJS$1).s38 = function () {
	    var tmp0_safe_receiver = this.l3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.reconnecting();
	    }
	  };
	  protoOf(CombinedClientJS$1).t38 = function () {
	    var tmp0_safe_receiver = this.l3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.reconnection();
	    }
	  };
	  protoOf(CombinedClientJS$1).u38 = function (reason) {
	    var tmp0_safe_receiver = this.l3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.sessionError(map_10(reason));
	    }
	  };
	  function CombinedClientJS$2(this$0) {
	    this.o3r_1 = this$0;
	  }
	  protoOf(CombinedClientJS$2).y38 = function (callId, from, channelType) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.callInvite(callId, from, map(channelType));
	    }
	  };
	  protoOf(CombinedClientJS$2).z38 = function (callId, reason) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.callInviteCancel(callId, map_14(reason));
	    }
	  };
	  protoOf(CombinedClientJS$2).a39 = function (callId, conversationId) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.callTransfer(callId, conversationId);
	    }
	  };
	  protoOf(CombinedClientJS$2).b39 = function (callId, legId, isMuted) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.mute(callId, legId, isMuted);
	    }
	  };
	  protoOf(CombinedClientJS$2).c39 = function (callId, legId, earmuffStatus) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.earmuff(callId, legId, earmuffStatus);
	    }
	  };
	  protoOf(CombinedClientJS$2).d39 = function (callId, legId, digits) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.dtmf(callId, legId, digits);
	    }
	  };
	  protoOf(CombinedClientJS$2).e39 = function (callId, callQuality, reason) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.callHangup(callId, map_15(callQuality), map_13(reason));
	    }
	  };
	  protoOf(CombinedClientJS$2).f39 = function (callId, legId, status) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.legStatusUpdate(callId, legId, map_11(status));
	    }
	  };
	  protoOf(CombinedClientJS$2).g39 = function (callId) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.callMediaReconnecting(callId);
	    }
	  };
	  protoOf(CombinedClientJS$2).h39 = function (callId) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.callMediaReconnection(callId);
	    }
	  };
	  protoOf(CombinedClientJS$2).i39 = function (callId, reason) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.callMediaDisconnect(callId, map_12(reason));
	    }
	  };
	  protoOf(CombinedClientJS$2).j39 = function (rtcStats, legId) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.rtcStatsUpdate(Companion_instance_0.p3r(rtcStats), legId);
	    }
	  };
	  protoOf(CombinedClientJS$2).k39 = function (callId, error) {
	    var tmp0_safe_receiver = this.o3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.callMediaError(callId, new VonageErrorJS(error));
	    }
	  };
	  function CombinedClientJS$3(this$0) {
	    this.q3r_1 = this$0;
	  }
	  protoOf(CombinedClientJS$3).q2t = function (event) {
	    var tmp0_safe_receiver = this.q3r_1.emitter;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.conversationEvent(map_1(event));
	    }
	  };
	  function CombinedClientJS(config, http, socket, media) {
	    this.m3r_1 = media;
	    var tmp = this;
	    var tmp_0 = new Builder();
	    var tmp0_safe_receiver = config.loggingLevel;
	    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getLoggingLevel(tmp0_safe_receiver);
	    var tmp_1 = tmp1_elvis_lhs == null ? getLoggingLevel(get_DEFAULT_LOGGING_LEVEL()) : tmp1_elvis_lhs;
	    var tmp_2 = map_9(config.customLoggers);
	    var tmp2_elvis_lhs = config.disableInternalLogger;
	    tmp.n3r_1 = tmp_0.n1e(new LoggerAdapter(tmp_1, tmp_2, tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs)).o1e(HttpClientJSAdapter(http)).p1e(SocketClientJSAdapter(socket)).q1e(MediaClientJSAdapter(this.m3r_1));
	    this.emitter = null;
	    this.n3r_1.q1d(new CombinedClientJS$1(this));
	    this.n3r_1.u1d(new CombinedClientJS$2(this));
	    this.n3r_1.r1d(new CombinedClientJS$3(this));
	  }
	  protoOf(CombinedClientJS).r3r = function () {
	    return this.m3r_1;
	  };
	  protoOf(CombinedClientJS).s3r = function () {
	    return this.n3r_1;
	  };
	  protoOf(CombinedClientJS).t3r = function (_set____db54di) {
	    this.emitter = _set____db54di;
	  };
	  protoOf(CombinedClientJS).u3r = function () {
	    return this.emitter;
	  };
	  function map(_this__u8e3s4) {
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 0:
	        tmp = VoiceChannelTypeObject_instance.app;
	        break;
	      case 1:
	        tmp = VoiceChannelTypeObject_instance.phone;
	        break;
	      case 2:
	        tmp = VoiceChannelTypeObject_instance.sip;
	        break;
	      case 3:
	        tmp = VoiceChannelTypeObject_instance.websocket;
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  var EventStateTypeJS_SEEN_instance;
	  var EventStateTypeJS_DELIVERED_instance;
	  var EventStateTypeJS_SUBMITTED_instance;
	  var EventStateTypeJS_REJECTED_instance;
	  var EventStateTypeJS_UNDELIVERABLE_instance;
	  var EventStateTypeJS_NONE_instance;
	  function values() {
	    return [EventStateTypeJS_SEEN_getInstance(), EventStateTypeJS_DELIVERED_getInstance(), EventStateTypeJS_SUBMITTED_getInstance(), EventStateTypeJS_REJECTED_getInstance(), EventStateTypeJS_UNDELIVERABLE_getInstance(), EventStateTypeJS_NONE_getInstance()];
	  }
	  function valueOf_0(value) {
	    switch (value) {
	      case 'SEEN':
	        return EventStateTypeJS_SEEN_getInstance();
	      case 'DELIVERED':
	        return EventStateTypeJS_DELIVERED_getInstance();
	      case 'SUBMITTED':
	        return EventStateTypeJS_SUBMITTED_getInstance();
	      case 'REJECTED':
	        return EventStateTypeJS_REJECTED_getInstance();
	      case 'UNDELIVERABLE':
	        return EventStateTypeJS_UNDELIVERABLE_getInstance();
	      case 'NONE':
	        return EventStateTypeJS_NONE_getInstance();
	      default:
	        EventStateTypeJS_initEntries();
	        THROW_IAE('No enum constant value.');
	        break;
	    }
	  }
	  var EventStateTypeJS_entriesInitialized;
	  function EventStateTypeJS_initEntries() {
	    if (EventStateTypeJS_entriesInitialized)
	      return Unit_instance;
	    EventStateTypeJS_entriesInitialized = true;
	    EventStateTypeJS_SEEN_instance = new EventStateTypeJS('SEEN', 0);
	    EventStateTypeJS_DELIVERED_instance = new EventStateTypeJS('DELIVERED', 1);
	    EventStateTypeJS_SUBMITTED_instance = new EventStateTypeJS('SUBMITTED', 2);
	    EventStateTypeJS_REJECTED_instance = new EventStateTypeJS('REJECTED', 3);
	    EventStateTypeJS_UNDELIVERABLE_instance = new EventStateTypeJS('UNDELIVERABLE', 4);
	    EventStateTypeJS_NONE_instance = new EventStateTypeJS('NONE', 5);
	  }
	  function EventStateTypeJS(name, ordinal) {
	    Enum.call(this, name, ordinal);
	  }
	  function EventStateJS(eventState) {
	    var tmp = this;
	    tmp.seen = eventState == null ? null : eventState.p30_1;
	    var tmp_0 = this;
	    tmp_0.delivered = eventState == null ? null : eventState.q30_1;
	    var tmp_1 = this;
	    tmp_1.submitted = eventState == null ? null : eventState.r30_1;
	    var tmp_2 = this;
	    tmp_2.rejected = eventState == null ? null : eventState.s30_1;
	    var tmp_3 = this;
	    tmp_3.undeliverable = eventState == null ? null : eventState.t30_1;
	    var tmp_4 = this;
	    var tmp1_safe_receiver = eventState == null ? null : eventState.u30_1;
	    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h8_1;
	    var tmp_5;
	    if (tmp2_safe_receiver == null) {
	      tmp_5 = null;
	    } else {
	      // Inline function 'kotlin.text.lowercase' call
	      // Inline function 'kotlin.js.asDynamic' call
	      tmp_5 = tmp2_safe_receiver.toLowerCase();
	    }
	    var tmp3_elvis_lhs = tmp_5;
	    tmp_4.current = tmp3_elvis_lhs == null ? 'none' : tmp3_elvis_lhs;
	  }
	  protoOf(EventStateJS).x3r = function () {
	    return this.seen;
	  };
	  protoOf(EventStateJS).y3r = function () {
	    return this.delivered;
	  };
	  protoOf(EventStateJS).z3r = function () {
	    return this.submitted;
	  };
	  protoOf(EventStateJS).a3s = function () {
	    return this.rejected;
	  };
	  protoOf(EventStateJS).b3s = function () {
	    return this.undeliverable;
	  };
	  protoOf(EventStateJS).c3s = function () {
	    return this.current;
	  };
	  function EventsPageJS(eventsPage) {
	    var tmp = this;
	    // Inline function 'kotlin.collections.toTypedArray' call
	    // Inline function 'kotlin.collections.map' call
	    var this_0 = eventsPage.v30_1;
	    // Inline function 'kotlin.collections.mapTo' call
	    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
	    var tmp0_iterator = this_0.p();
	    while (tmp0_iterator.q()) {
	      var item = tmp0_iterator.s();
	      // Inline function 'vonage.EventsPageJS.events.<anonymous>' call
	      var tmp$ret$0 = map_2(item);
	      destination.m(tmp$ret$0);
	    }
	    tmp.events = copyToArray(destination);
	    this.previousCursor = eventsPage.w30_1;
	    this.nextCursor = eventsPage.x30_1;
	  }
	  protoOf(EventsPageJS).d3s = function () {
	    return this.events;
	  };
	  protoOf(EventsPageJS).e3s = function () {
	    return this.previousCursor;
	  };
	  protoOf(EventsPageJS).f3s = function () {
	    return this.nextCursor;
	  };
	  function FromJS() {
	  }
	  function EmbeddedInfoJS(embeddedInfo) {
	    this.kind = 'embeddedInfo';
	    this.memberId = embeddedInfo.y30_1;
	    this.user = new UserJS(embeddedInfo.z30_1);
	  }
	  protoOf(EmbeddedInfoJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(EmbeddedInfoJS).g3s = function () {
	    return this.memberId;
	  };
	  protoOf(EmbeddedInfoJS).l2n = function () {
	    return this.user;
	  };
	  function SystemJS() {
	    this.kind = 'system';
	  }
	  protoOf(SystemJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(SystemJS).toString = function () {
	    return 'SystemJS';
	  };
	  protoOf(SystemJS).hashCode = function () {
	    return 668363068;
	  };
	  protoOf(SystemJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof SystemJS))
	      return false;
	    other instanceof SystemJS || THROW_CCE();
	    return true;
	  };
	  var SystemJS_instance;
	  function SystemJS_getInstance() {
	    return SystemJS_instance;
	  }
	  function ConversationEventJS() {
	  }
	  function NonPersistentConversationEventJS() {
	  }
	  function PersistentConversationEventJS() {
	  }
	  function MemberEventJS() {
	  }
	  function MemberEventBodyJS(body) {
	    this.memberId = body.b31_1;
	    this.user = new UserJS(body.a31_1);
	    this.channel = new ChannelJS(body.c31_1);
	  }
	  protoOf(MemberEventBodyJS).g3s = function () {
	    return this.memberId;
	  };
	  protoOf(MemberEventBodyJS).l2n = function () {
	    return this.user;
	  };
	  protoOf(MemberEventBodyJS).h3s = function () {
	    return this.channel;
	  };
	  function MemberInvitedEventJS(event) {
	    this.kind = 'member:invited';
	    this.id = event.d31_1;
	    this.timestamp = event.e31_1;
	    this.conversationId = event.f31_1;
	    this.from = map_0(event.g31_1);
	    this.body = new MemberEventBodyJS(event.h31_1);
	  }
	  protoOf(MemberInvitedEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MemberInvitedEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MemberInvitedEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MemberInvitedEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MemberInvitedEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MemberInvitedEventJS).j3s = function () {
	    return this.body;
	  };
	  function MemberJoinedEventJS(event) {
	    this.kind = 'member:joined';
	    this.id = event.i31_1;
	    this.timestamp = event.j31_1;
	    this.conversationId = event.k31_1;
	    this.from = map_0(event.l31_1);
	    this.body = new MemberEventBodyJS(event.m31_1);
	  }
	  protoOf(MemberJoinedEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MemberJoinedEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MemberJoinedEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MemberJoinedEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MemberJoinedEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MemberJoinedEventJS).j3s = function () {
	    return this.body;
	  };
	  function MemberLeftEventJS(event) {
	    this.kind = 'member:left';
	    this.id = event.n31_1;
	    this.timestamp = event.o31_1;
	    this.conversationId = event.p31_1;
	    this.from = map_0(event.q31_1);
	    this.body = new MemberEventBodyJS(event.r31_1);
	  }
	  protoOf(MemberLeftEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MemberLeftEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MemberLeftEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MemberLeftEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MemberLeftEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MemberLeftEventJS).j3s = function () {
	    return this.body;
	  };
	  function JSONBodyEventJS() {
	  }
	  function CustomConversationEventJS(event) {
	    this.kind = 'custom';
	    this.id = event.s31_1;
	    this.timestamp = event.t31_1;
	    this.conversationId = event.u31_1;
	    this.from = map_0(event.v31_1);
	    this.eventType = event.x31_1;
	    this.body = parseCustomJson(event.w31_1);
	  }
	  protoOf(CustomConversationEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(CustomConversationEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(CustomConversationEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(CustomConversationEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(CustomConversationEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(CustomConversationEventJS).k3s = function () {
	    return this.eventType;
	  };
	  protoOf(CustomConversationEventJS).j3s = function () {
	    return this.body;
	  };
	  function EphemeralConversationEventJS(event) {
	    this.kind = 'ephemeral';
	    this.timestamp = event.y31_1;
	    this.conversationId = event.z31_1;
	    this.from = map_0(event.a32_1);
	    this.body = parseCustomJson(event.b32_1);
	  }
	  protoOf(EphemeralConversationEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(EphemeralConversationEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(EphemeralConversationEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(EphemeralConversationEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(EphemeralConversationEventJS).j3s = function () {
	    return this.body;
	  };
	  function EventStateBodyJS(stateBody) {
	    this.eventId = stateBody.c32_1;
	  }
	  protoOf(EventStateBodyJS).l3s = function () {
	    return this.eventId;
	  };
	  function EventDeleteConversationEventJS(event) {
	    this.kind = 'event:delete';
	    this.id = event.d32_1;
	    this.timestamp = event.e32_1;
	    this.conversationId = event.f32_1;
	    this.from = map_0(event.g32_1);
	    this.body = new EventStateBodyJS(event.h32_1);
	  }
	  protoOf(EventDeleteConversationEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(EventDeleteConversationEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(EventDeleteConversationEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(EventDeleteConversationEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(EventDeleteConversationEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(EventDeleteConversationEventJS).j3s = function () {
	    return this.body;
	  };
	  function MessageDeliveredEventJS(event) {
	    this.kind = 'message:delivered';
	    this.id = event.i32_1;
	    this.timestamp = event.j32_1;
	    this.conversationId = event.k32_1;
	    this.from = map_0(event.l32_1);
	    this.body = new EventStateBodyJS(event.m32_1);
	  }
	  protoOf(MessageDeliveredEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageDeliveredEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageDeliveredEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageDeliveredEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageDeliveredEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageDeliveredEventJS).j3s = function () {
	    return this.body;
	  };
	  function MessageRejectedEventJS(event) {
	    this.kind = 'message:rejected';
	    this.id = event.n32_1;
	    this.timestamp = event.o32_1;
	    this.conversationId = event.p32_1;
	    this.from = map_0(event.q32_1);
	    this.body = new EventStateBodyJS(event.r32_1);
	  }
	  protoOf(MessageRejectedEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageRejectedEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageRejectedEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageRejectedEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageRejectedEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageRejectedEventJS).j3s = function () {
	    return this.body;
	  };
	  function MessageUndeliverableEventJS(event) {
	    this.kind = 'message:undeliverable';
	    this.id = event.s32_1;
	    this.timestamp = event.t32_1;
	    this.conversationId = event.u32_1;
	    this.from = map_0(event.v32_1);
	    this.body = new EventStateBodyJS(event.w32_1);
	  }
	  protoOf(MessageUndeliverableEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageUndeliverableEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageUndeliverableEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageUndeliverableEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageUndeliverableEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageUndeliverableEventJS).j3s = function () {
	    return this.body;
	  };
	  function MessageSubmittedEventJS(event) {
	    this.kind = 'message:submitted';
	    this.id = event.x32_1;
	    this.timestamp = event.y32_1;
	    this.conversationId = event.z32_1;
	    this.from = map_0(event.a33_1);
	    this.body = new EventStateBodyJS(event.b33_1);
	  }
	  protoOf(MessageSubmittedEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageSubmittedEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageSubmittedEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageSubmittedEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageSubmittedEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageSubmittedEventJS).j3s = function () {
	    return this.body;
	  };
	  function MessageSeenEventJS(event) {
	    this.kind = 'message:seen';
	    this.id = event.c33_1;
	    this.timestamp = event.d33_1;
	    this.conversationId = event.e33_1;
	    this.from = map_0(event.f33_1);
	    this.body = new EventStateBodyJS(event.g33_1);
	  }
	  protoOf(MessageSeenEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageSeenEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageSeenEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageSeenEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageSeenEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageSeenEventJS).j3s = function () {
	    return this.body;
	  };
	  function map_0(_this__u8e3s4) {
	    var tmp;
	    if (_this__u8e3s4 instanceof EmbeddedInfo) {
	      tmp = new EmbeddedInfoJS(_this__u8e3s4);
	    } else {
	      if (equals(_this__u8e3s4, System_instance)) {
	        tmp = SystemJS_instance;
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  }
	  function map_1(_this__u8e3s4) {
	    var tmp;
	    if (isInterface(_this__u8e3s4, PersistentConversationEvent)) {
	      tmp = map_2(_this__u8e3s4);
	    } else {
	      if (_this__u8e3s4 instanceof EphemeralConversationEvent) {
	        tmp = new EphemeralConversationEventJS(_this__u8e3s4);
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  }
	  function map_2(_this__u8e3s4) {
	    var tmp;
	    if (_this__u8e3s4 instanceof MemberInvitedConversationEvent) {
	      tmp = new MemberInvitedEventJS(_this__u8e3s4);
	    } else {
	      if (_this__u8e3s4 instanceof MemberJoinedConversationEvent) {
	        tmp = new MemberJoinedEventJS(_this__u8e3s4);
	      } else {
	        if (_this__u8e3s4 instanceof MemberLeftConversationEvent) {
	          tmp = new MemberLeftEventJS(_this__u8e3s4);
	        } else {
	          if (_this__u8e3s4 instanceof MessageTextEvent) {
	            tmp = new MessageTextEventJS(_this__u8e3s4);
	          } else {
	            if (_this__u8e3s4 instanceof MessageCustomEvent) {
	              tmp = new MessageCustomEventJS(_this__u8e3s4);
	            } else {
	              if (_this__u8e3s4 instanceof MessageImageEvent) {
	                tmp = new MessageImageEventJS(_this__u8e3s4);
	              } else {
	                if (_this__u8e3s4 instanceof MessageVideoEvent) {
	                  tmp = new MessageVideoEventJS(_this__u8e3s4);
	                } else {
	                  if (_this__u8e3s4 instanceof MessageAudioEvent) {
	                    tmp = new MessageAudioEventJS(_this__u8e3s4);
	                  } else {
	                    if (_this__u8e3s4 instanceof MessageFileEvent) {
	                      tmp = new MessageFileEventJS(_this__u8e3s4);
	                    } else {
	                      if (_this__u8e3s4 instanceof MessageVCardEvent) {
	                        tmp = new MessageVCardEventJS(_this__u8e3s4);
	                      } else {
	                        if (_this__u8e3s4 instanceof MessageTemplateEvent) {
	                          tmp = new MessageTemplateEventJS(_this__u8e3s4);
	                        } else {
	                          if (_this__u8e3s4 instanceof MessageLocationEvent) {
	                            tmp = new MessageLocationEventJS(_this__u8e3s4);
	                          } else {
	                            if (_this__u8e3s4 instanceof CustomConversationEvent) {
	                              tmp = new CustomConversationEventJS(_this__u8e3s4);
	                            } else {
	                              if (_this__u8e3s4 instanceof EventDeleteConversationEvent) {
	                                tmp = new EventDeleteConversationEventJS(_this__u8e3s4);
	                              } else {
	                                if (_this__u8e3s4 instanceof MessageDeliveredEvent) {
	                                  tmp = new MessageDeliveredEventJS(_this__u8e3s4);
	                                } else {
	                                  if (_this__u8e3s4 instanceof MessageRejectedEvent) {
	                                    tmp = new MessageRejectedEventJS(_this__u8e3s4);
	                                  } else {
	                                    if (_this__u8e3s4 instanceof MessageSubmittedEvent) {
	                                      tmp = new MessageSubmittedEventJS(_this__u8e3s4);
	                                    } else {
	                                      if (_this__u8e3s4 instanceof MessageUndeliverableEvent) {
	                                        tmp = new MessageUndeliverableEventJS(_this__u8e3s4);
	                                      } else {
	                                        if (_this__u8e3s4 instanceof MessageSeenEvent) {
	                                          tmp = new MessageSeenEventJS(_this__u8e3s4);
	                                        } else {
	                                          noWhenBranchMatchedException();
	                                        }
	                                      }
	                                    }
	                                  }
	                                }
	                              }
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	    return tmp;
	  }
	  function EventStateTypeJS_SEEN_getInstance() {
	    EventStateTypeJS_initEntries();
	    return EventStateTypeJS_SEEN_instance;
	  }
	  function EventStateTypeJS_DELIVERED_getInstance() {
	    EventStateTypeJS_initEntries();
	    return EventStateTypeJS_DELIVERED_instance;
	  }
	  function EventStateTypeJS_SUBMITTED_getInstance() {
	    EventStateTypeJS_initEntries();
	    return EventStateTypeJS_SUBMITTED_instance;
	  }
	  function EventStateTypeJS_REJECTED_getInstance() {
	    EventStateTypeJS_initEntries();
	    return EventStateTypeJS_REJECTED_instance;
	  }
	  function EventStateTypeJS_UNDELIVERABLE_getInstance() {
	    EventStateTypeJS_initEntries();
	    return EventStateTypeJS_UNDELIVERABLE_instance;
	  }
	  function EventStateTypeJS_NONE_getInstance() {
	    EventStateTypeJS_initEntries();
	    return EventStateTypeJS_NONE_instance;
	  }
	  function MessageEventJS() {
	  }
	  function MessageEventBodyJS() {
	  }
	  function MessageTextEventBody(body) {
	    this.text = body.q34_1;
	    this.deleted = body.r34_1;
	  }
	  protoOf(MessageTextEventBody).m3s = function () {
	    return this.text;
	  };
	  protoOf(MessageTextEventBody).n3s = function () {
	    return this.deleted;
	  };
	  function MessageTextEventJS(event) {
	    this.kind = 'message:text';
	    this.id = event.u34_1;
	    this.timestamp = event.s34_1;
	    this.conversationId = event.t34_1;
	    this.from = map_0(event.v34_1);
	    this.body = new MessageTextEventBody(event.w34_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.x34_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageTextEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatuses = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	  }
	  protoOf(MessageTextEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageTextEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageTextEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageTextEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageTextEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageTextEventJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageTextEventJS).o3s = function () {
	    return this.memberStatuses;
	  };
	  function MessageCustomEventBody(body) {
	    this.customData = parseCustomJson(body.y34_1);
	    this.deleted = body.z34_1;
	  }
	  protoOf(MessageCustomEventBody).p3s = function () {
	    return this.customData;
	  };
	  protoOf(MessageCustomEventBody).n3s = function () {
	    return this.deleted;
	  };
	  function MessageCustomEventJS(event) {
	    this.kind = 'message:custom';
	    this.id = event.c35_1;
	    this.timestamp = event.a35_1;
	    this.conversationId = event.b35_1;
	    this.from = map_0(event.d35_1);
	    this.body = new MessageCustomEventBody(event.e35_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.f35_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageCustomEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatuses = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	  }
	  protoOf(MessageCustomEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageCustomEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageCustomEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageCustomEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageCustomEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageCustomEventJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageCustomEventJS).o3s = function () {
	    return this.memberStatuses;
	  };
	  function MessageAudioEventBody(body) {
	    this.audioUrl = body.w35_1;
	    this.deleted = body.x35_1;
	  }
	  protoOf(MessageAudioEventBody).q3s = function () {
	    return this.audioUrl;
	  };
	  protoOf(MessageAudioEventBody).n3s = function () {
	    return this.deleted;
	  };
	  function MessageAudioEventJS(event) {
	    this.kind = 'message:audio';
	    this.id = event.a36_1;
	    this.timestamp = event.y35_1;
	    this.conversationId = event.z35_1;
	    this.from = map_0(event.b36_1);
	    this.body = new MessageAudioEventBody(event.c36_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.d36_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageAudioEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatuses = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	  }
	  protoOf(MessageAudioEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageAudioEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageAudioEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageAudioEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageAudioEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageAudioEventJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageAudioEventJS).o3s = function () {
	    return this.memberStatuses;
	  };
	  function MessageVideoEventBody(body) {
	    this.videoUrl = body.o35_1;
	    this.deleted = body.p35_1;
	  }
	  protoOf(MessageVideoEventBody).r3s = function () {
	    return this.videoUrl;
	  };
	  protoOf(MessageVideoEventBody).n3s = function () {
	    return this.deleted;
	  };
	  function MessageVideoEventJS(event) {
	    this.kind = 'message:video';
	    this.id = event.s35_1;
	    this.timestamp = event.q35_1;
	    this.conversationId = event.r35_1;
	    this.from = map_0(event.t35_1);
	    this.body = new MessageVideoEventBody(event.u35_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.v35_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageVideoEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatuses = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	  }
	  protoOf(MessageVideoEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageVideoEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageVideoEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageVideoEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageVideoEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageVideoEventJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageVideoEventJS).o3s = function () {
	    return this.memberStatuses;
	  };
	  function MessageImageEventBody(body) {
	    this.imageUrl = body.g35_1;
	    this.deleted = body.h35_1;
	  }
	  protoOf(MessageImageEventBody).s3s = function () {
	    return this.imageUrl;
	  };
	  protoOf(MessageImageEventBody).n3s = function () {
	    return this.deleted;
	  };
	  function MessageImageEventJS(event) {
	    this.kind = 'message:image';
	    this.id = event.k35_1;
	    this.timestamp = event.i35_1;
	    this.conversationId = event.j35_1;
	    this.from = map_0(event.l35_1);
	    this.body = new MessageImageEventBody(event.m35_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.n35_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageImageEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatuses = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	  }
	  protoOf(MessageImageEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageImageEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageImageEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageImageEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageImageEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageImageEventJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageImageEventJS).o3s = function () {
	    return this.memberStatuses;
	  };
	  function MessageFileEventBody(body) {
	    this.fileUrl = body.e36_1;
	    this.deleted = body.f36_1;
	  }
	  protoOf(MessageFileEventBody).t3s = function () {
	    return this.fileUrl;
	  };
	  protoOf(MessageFileEventBody).n3s = function () {
	    return this.deleted;
	  };
	  function MessageFileEventJS(event) {
	    this.kind = 'message:file';
	    this.id = event.i36_1;
	    this.timestamp = event.g36_1;
	    this.conversationId = event.h36_1;
	    this.from = map_0(event.j36_1);
	    this.body = new MessageFileEventBody(event.k36_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.l36_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageFileEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatuses = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	  }
	  protoOf(MessageFileEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageFileEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageFileEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageFileEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageFileEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageFileEventJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageFileEventJS).o3s = function () {
	    return this.memberStatuses;
	  };
	  function MessageVCardEventBody(body) {
	    this.vcardUrl = body.m36_1;
	    this.deleted = body.n36_1;
	  }
	  protoOf(MessageVCardEventBody).u3s = function () {
	    return this.vcardUrl;
	  };
	  protoOf(MessageVCardEventBody).n3s = function () {
	    return this.deleted;
	  };
	  function MessageVCardEventJS(event) {
	    this.kind = 'message:vcard';
	    this.id = event.q36_1;
	    this.timestamp = event.o36_1;
	    this.conversationId = event.p36_1;
	    this.from = map_0(event.r36_1);
	    this.body = new MessageVCardEventBody(event.s36_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.t36_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageVCardEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatuses = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	  }
	  protoOf(MessageVCardEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageVCardEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageVCardEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageVCardEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageVCardEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageVCardEventJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageVCardEventJS).o3s = function () {
	    return this.memberStatuses;
	  };
	  function MessageLocationEventBody(body) {
	    this.location = new Location_0(body.d37_1);
	    this.deleted = body.e37_1;
	  }
	  protoOf(MessageLocationEventBody).v3s = function () {
	    return this.location;
	  };
	  protoOf(MessageLocationEventBody).n3s = function () {
	    return this.deleted;
	  };
	  function Location_0(location) {
	    this.longitude = location.i2m_1;
	    this.latitude = location.j2m_1;
	    this.name = location.k2m_1;
	    this.address = location.l2m_1;
	  }
	  protoOf(Location_0).w3s = function () {
	    return this.longitude;
	  };
	  protoOf(Location_0).x3s = function () {
	    return this.latitude;
	  };
	  protoOf(Location_0).j9 = function () {
	    return this.name;
	  };
	  protoOf(Location_0).y3s = function () {
	    return this.address;
	  };
	  function MessageLocationEventJS(event) {
	    this.kind = 'message:location';
	    this.id = event.h37_1;
	    this.timestamp = event.f37_1;
	    this.conversationId = event.g37_1;
	    this.from = map_0(event.i37_1);
	    this.body = new MessageLocationEventBody(event.j37_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.k37_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageLocationEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatuses = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	  }
	  protoOf(MessageLocationEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageLocationEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageLocationEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageLocationEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageLocationEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageLocationEventJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageLocationEventJS).o3s = function () {
	    return this.memberStatuses;
	  };
	  function MessageTemplateEventBody(body) {
	    this.body = body;
	    this.template = new TemplateObject_0(this.body.u36_1);
	    this.whatsapp = new WhatsappObject_0(this.body.v36_1);
	    this.deleted = this.body.w36_1;
	  }
	  protoOf(MessageTemplateEventBody).j3s = function () {
	    return this.body;
	  };
	  protoOf(MessageTemplateEventBody).z3s = function () {
	    return this.template;
	  };
	  protoOf(MessageTemplateEventBody).a3t = function () {
	    return this.whatsapp;
	  };
	  protoOf(MessageTemplateEventBody).n3s = function () {
	    return this.deleted;
	  };
	  protoOf(MessageTemplateEventBody).o5 = function () {
	    return this.body;
	  };
	  protoOf(MessageTemplateEventBody).b3t = function (body) {
	    return new MessageTemplateEventBody(body);
	  };
	  protoOf(MessageTemplateEventBody).copy = function (body, $super) {
	    body = body === VOID ? this.body : body;
	    return this.b3t(body);
	  };
	  protoOf(MessageTemplateEventBody).toString = function () {
	    return 'Body(body=' + this.body + ')';
	  };
	  protoOf(MessageTemplateEventBody).hashCode = function () {
	    return this.body.hashCode();
	  };
	  protoOf(MessageTemplateEventBody).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof MessageTemplateEventBody))
	      return false;
	    var tmp0_other_with_cast = other instanceof MessageTemplateEventBody ? other : THROW_CCE();
	    if (!this.body.equals(tmp0_other_with_cast.body))
	      return false;
	    return true;
	  };
	  function TemplateObject_0(template) {
	    this.name = template.a2m_1;
	    var tmp = this;
	    var tmp0_safe_receiver = template.b2m_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_0 = copyToArray(tmp0_safe_receiver);
	    }
	    tmp.parameters = tmp_0;
	  }
	  protoOf(TemplateObject_0).j9 = function () {
	    return this.name;
	  };
	  protoOf(TemplateObject_0).c3t = function () {
	    return this.parameters;
	  };
	  function WhatsappObject_0(whatsapp) {
	    this.policy = whatsapp.e2m_1;
	    this.locale = whatsapp.f2m_1;
	  }
	  protoOf(WhatsappObject_0).d3t = function () {
	    return this.policy;
	  };
	  protoOf(WhatsappObject_0).e3t = function () {
	    return this.locale;
	  };
	  function MessageTemplateEventJS(event) {
	    this.kind = 'message:template';
	    this.id = event.z36_1;
	    this.timestamp = event.x36_1;
	    this.conversationId = event.y36_1;
	    this.from = map_0(event.a37_1);
	    var tmp = this;
	    var tmp0_safe_receiver = event.c37_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.mapValues' call
	      // Inline function 'kotlin.collections.mapValuesTo' call
	      var destination = LinkedHashMap_init_$Create$(mapCapacity(tmp0_safe_receiver.u()));
	      // Inline function 'kotlin.collections.associateByTo' call
	      var tmp0_iterator = tmp0_safe_receiver.u1().p();
	      while (tmp0_iterator.q()) {
	        var element = tmp0_iterator.s();
	        // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
	        var tmp_1 = element.v1();
	        // Inline function 'vonage.MessageTemplateEventJS.memberStatuses.<anonymous>' call
	        var tmp$ret$1 = new EventStateJS(element.w1());
	        destination.s1(tmp_1, tmp$ret$1);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    tmp.memberStatus = tmp1_safe_receiver == null ? null : toJsObject(tmp1_safe_receiver);
	    this.body = new MessageTemplateEventBody(event.b37_1);
	  }
	  protoOf(MessageTemplateEventJS).lh = function () {
	    return this.kind;
	  };
	  protoOf(MessageTemplateEventJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MessageTemplateEventJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(MessageTemplateEventJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(MessageTemplateEventJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MessageTemplateEventJS).f3t = function () {
	    return this.memberStatus;
	  };
	  protoOf(MessageTemplateEventJS).j3s = function () {
	    return this.body;
	  };
	  var PresentingOrderJS_ASC_instance;
	  var PresentingOrderJS_DESC_instance;
	  function values_0() {
	    return [PresentingOrderJS_ASC_getInstance(), PresentingOrderJS_DESC_getInstance()];
	  }
	  function valueOf_1(value) {
	    switch (value) {
	      case 'ASC':
	        return PresentingOrderJS_ASC_getInstance();
	      case 'DESC':
	        return PresentingOrderJS_DESC_getInstance();
	      default:
	        PresentingOrderJS_initEntries();
	        THROW_IAE('No enum constant value.');
	        break;
	    }
	  }
	  var PresentingOrderJS_entriesInitialized;
	  function PresentingOrderJS_initEntries() {
	    if (PresentingOrderJS_entriesInitialized)
	      return Unit_instance;
	    PresentingOrderJS_entriesInitialized = true;
	    PresentingOrderJS_ASC_instance = new PresentingOrderJS('ASC', 0, PresentingOrder_ASC_getInstance());
	    PresentingOrderJS_DESC_instance = new PresentingOrderJS('DESC', 1, PresentingOrder_DESC_getInstance());
	  }
	  function PresentingOrderJS(name, ordinal, corePresentingOrder) {
	    Enum.call(this, name, ordinal);
	    this.corePresentingOrder = corePresentingOrder;
	  }
	  protoOf(PresentingOrderJS).i3t = function () {
	    return this.corePresentingOrder;
	  };
	  var OrderByJS_CREATED_instance;
	  var OrderByJS_CUSTOM_SORT_KEY_instance;
	  function values_1() {
	    return [OrderByJS_CREATED_getInstance(), OrderByJS_CUSTOM_SORT_KEY_getInstance()];
	  }
	  function valueOf_2(value) {
	    switch (value) {
	      case 'CREATED':
	        return OrderByJS_CREATED_getInstance();
	      case 'CUSTOM_SORT_KEY':
	        return OrderByJS_CUSTOM_SORT_KEY_getInstance();
	      default:
	        OrderByJS_initEntries();
	        THROW_IAE('No enum constant value.');
	        break;
	    }
	  }
	  var OrderByJS_entriesInitialized;
	  function OrderByJS_initEntries() {
	    if (OrderByJS_entriesInitialized)
	      return Unit_instance;
	    OrderByJS_entriesInitialized = true;
	    OrderByJS_CREATED_instance = new OrderByJS('CREATED', 0, OrderBy_CREATED_getInstance());
	    OrderByJS_CUSTOM_SORT_KEY_instance = new OrderByJS('CUSTOM_SORT_KEY', 1, OrderBy_CUSTOM_SORT_KEY_getInstance());
	  }
	  function OrderByJS(name, ordinal, coreOrderBy) {
	    Enum.call(this, name, ordinal);
	    this.coreOrderBy = coreOrderBy;
	  }
	  protoOf(OrderByJS).l3t = function () {
	    return this.coreOrderBy;
	  };
	  function Properties(properties) {
	    var tmp = this;
	    tmp.ttl = properties == null ? null : properties.v2z_1;
	    var tmp_0 = this;
	    tmp_0.customSortKey = properties == null ? null : properties.w2z_1;
	    var tmp_1 = this;
	    var tmp1_safe_receiver = properties == null ? null : properties.x2z_1;
	    var tmp_2;
	    if (tmp1_safe_receiver == null) {
	      tmp_2 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.Properties.customData.<anonymous>' call
	      tmp_2 = parseCustomJson(tmp1_safe_receiver);
	    }
	    tmp_1.customData = tmp_2;
	  }
	  protoOf(Properties).m3t = function () {
	    return this.ttl;
	  };
	  protoOf(Properties).n3t = function () {
	    return this.customSortKey;
	  };
	  protoOf(Properties).p3s = function () {
	    return this.customData;
	  };
	  function ConversationJS(conversation) {
	    this.id = conversation.y2z_1;
	    this.name = conversation.z2z_1;
	    this.timestamp = new ConversationTimestampJS(conversation.a30_1);
	    this.memberId = conversation.b30_1;
	    var tmp = this;
	    var tmp0_safe_receiver = conversation.c30_1;
	    tmp.memberState = tmp0_safe_receiver == null ? null : map_4(tmp0_safe_receiver);
	    this.displayName = conversation.d30_1;
	    this.imageUrl = conversation.e30_1;
	    var tmp_0 = this;
	    var tmp0_safe_receiver_0 = conversation.f30_1;
	    tmp_0.state = tmp0_safe_receiver_0 == null ? null : map_3(tmp0_safe_receiver_0);
	    this.properties = new Properties(conversation.g30_1);
	  }
	  protoOf(ConversationJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(ConversationJS).j9 = function () {
	    return this.name;
	  };
	  protoOf(ConversationJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(ConversationJS).g3s = function () {
	    return this.memberId;
	  };
	  protoOf(ConversationJS).o3t = function () {
	    return this.memberState;
	  };
	  protoOf(ConversationJS).p3t = function () {
	    return this.displayName;
	  };
	  protoOf(ConversationJS).s3s = function () {
	    return this.imageUrl;
	  };
	  protoOf(ConversationJS).c3n = function () {
	    return this.state;
	  };
	  protoOf(ConversationJS).g2u = function () {
	    return this.properties;
	  };
	  function ConversationStateJS() {
	    this.ACTIVE = 'ACTIVE';
	    this.INACTIVE = 'INACTIVE';
	    this.DELETED = 'DELETED';
	  }
	  protoOf(ConversationStateJS).q3t = function () {
	    return this.ACTIVE;
	  };
	  protoOf(ConversationStateJS).r3t = function () {
	    return this.INACTIVE;
	  };
	  protoOf(ConversationStateJS).s3t = function () {
	    return this.DELETED;
	  };
	  protoOf(ConversationStateJS).toString = function () {
	    return 'ConversationStateJS';
	  };
	  protoOf(ConversationStateJS).hashCode = function () {
	    return -1732999277;
	  };
	  protoOf(ConversationStateJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof ConversationStateJS))
	      return false;
	    other instanceof ConversationStateJS || THROW_CCE();
	    return true;
	  };
	  var ConversationStateJS_instance;
	  function ConversationStateJS_getInstance() {
	    return ConversationStateJS_instance;
	  }
	  function ConversationTimestampJS(conversationTimestamp) {
	    this.created = conversationTimestamp.j30_1;
	    this.updated = conversationTimestamp.k30_1;
	    this.destroyed = conversationTimestamp.l30_1;
	  }
	  protoOf(ConversationTimestampJS).t3t = function () {
	    return this.created;
	  };
	  protoOf(ConversationTimestampJS).u3t = function () {
	    return this.updated;
	  };
	  protoOf(ConversationTimestampJS).v3t = function () {
	    return this.destroyed;
	  };
	  function ConversationsPageJS(conversationsPage) {
	    var tmp = this;
	    // Inline function 'kotlin.collections.toTypedArray' call
	    // Inline function 'kotlin.collections.map' call
	    var this_0 = conversationsPage.m30_1;
	    // Inline function 'kotlin.collections.mapTo' call
	    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
	    var tmp0_iterator = this_0.p();
	    while (tmp0_iterator.q()) {
	      var item = tmp0_iterator.s();
	      // Inline function 'vonage.ConversationsPageJS.conversations.<anonymous>' call
	      var tmp$ret$0 = new ConversationJS(item);
	      destination.m(tmp$ret$0);
	    }
	    tmp.conversations = copyToArray(destination);
	    this.previousCursor = conversationsPage.n30_1;
	    this.nextCursor = conversationsPage.o30_1;
	  }
	  protoOf(ConversationsPageJS).w3t = function () {
	    return this.conversations;
	  };
	  protoOf(ConversationsPageJS).e3s = function () {
	    return this.previousCursor;
	  };
	  protoOf(ConversationsPageJS).f3s = function () {
	    return this.nextCursor;
	  };
	  function MemberJS(member) {
	    this.id = member.d34_1;
	    this.state = map_4(member.e34_1);
	    var tmp = this;
	    var tmp0_safe_receiver = member.f34_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.MemberJS.user.<anonymous>' call
	      tmp_0 = new UserJS(tmp0_safe_receiver);
	    }
	    tmp.user = tmp_0;
	    var tmp_1 = this;
	    var tmp0_safe_receiver_0 = member.g34_1;
	    var tmp_2;
	    if (tmp0_safe_receiver_0 == null) {
	      tmp_2 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.MemberJS.channel.<anonymous>' call
	      tmp_2 = new MemberChannelJS(tmp0_safe_receiver_0);
	    }
	    tmp_1.channel = tmp_2;
	    var tmp_3 = this;
	    var tmp0_safe_receiver_1 = member.h34_1;
	    var tmp_4;
	    if (tmp0_safe_receiver_1 == null) {
	      tmp_4 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.MemberJS.timestamp.<anonymous>' call
	      tmp_4 = new MemberTimestampJS(tmp0_safe_receiver_1);
	    }
	    tmp_3.timestamp = tmp_4;
	  }
	  protoOf(MemberJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(MemberJS).c3n = function () {
	    return this.state;
	  };
	  protoOf(MemberJS).l2n = function () {
	    return this.user;
	  };
	  protoOf(MemberJS).h3s = function () {
	    return this.channel;
	  };
	  protoOf(MemberJS).i2l = function () {
	    return this.timestamp;
	  };
	  function MemberStateJSObj() {
	    this.INVITED = 'INVITED';
	    this.JOINED = 'JOINED';
	    this.LEFT = 'LEFT';
	    this.UNKNOWN = 'UNKNOWN';
	  }
	  protoOf(MemberStateJSObj).x3t = function () {
	    return this.INVITED;
	  };
	  protoOf(MemberStateJSObj).y3t = function () {
	    return this.JOINED;
	  };
	  protoOf(MemberStateJSObj).z3t = function () {
	    return this.LEFT;
	  };
	  protoOf(MemberStateJSObj).a3u = function () {
	    return this.UNKNOWN;
	  };
	  protoOf(MemberStateJSObj).toString = function () {
	    return 'MemberStateJSObj';
	  };
	  protoOf(MemberStateJSObj).hashCode = function () {
	    return 92639419;
	  };
	  protoOf(MemberStateJSObj).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof MemberStateJSObj))
	      return false;
	    other instanceof MemberStateJSObj || THROW_CCE();
	    return true;
	  };
	  var MemberStateJSObj_instance;
	  function MemberStateJSObj_getInstance() {
	    return MemberStateJSObj_instance;
	  }
	  function MemberTimestampJS(memberTimestamp) {
	    this.invited = memberTimestamp.k34_1;
	    this.joined = memberTimestamp.l34_1;
	    this.left = memberTimestamp.m34_1;
	  }
	  protoOf(MemberTimestampJS).b3u = function () {
	    return this.invited;
	  };
	  protoOf(MemberTimestampJS).c3u = function () {
	    return this.joined;
	  };
	  protoOf(MemberTimestampJS).d3u = function () {
	    return this.left;
	  };
	  function MembersPageJS(membersPage) {
	    var tmp = this;
	    // Inline function 'kotlin.collections.toTypedArray' call
	    // Inline function 'kotlin.collections.map' call
	    var this_0 = membersPage.n34_1;
	    // Inline function 'kotlin.collections.mapTo' call
	    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
	    var tmp0_iterator = this_0.p();
	    while (tmp0_iterator.q()) {
	      var item = tmp0_iterator.s();
	      // Inline function 'vonage.MembersPageJS.members.<anonymous>' call
	      var tmp$ret$0 = new MemberJS(item);
	      destination.m(tmp$ret$0);
	    }
	    tmp.members = copyToArray(destination);
	    this.previousCursor = membersPage.o34_1;
	    this.nextCursor = membersPage.p34_1;
	  }
	  protoOf(MembersPageJS).e3u = function () {
	    return this.members;
	  };
	  protoOf(MembersPageJS).e3s = function () {
	    return this.previousCursor;
	  };
	  protoOf(MembersPageJS).f3s = function () {
	    return this.nextCursor;
	  };
	  function UserJS(user) {
	    this.id = user.q37_1;
	    this.name = user.r37_1;
	    this.displayName = user.s37_1;
	    var tmp = this;
	    var tmp0_safe_receiver = user.t37_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.UserJS.channels.<anonymous>' call
	      tmp_0 = new UserChannelsJS(tmp0_safe_receiver);
	    }
	    tmp.channels = tmp_0;
	    var tmp_1 = this;
	    var tmp0_safe_receiver_0 = user.u37_1;
	    var tmp_2;
	    if (tmp0_safe_receiver_0 == null) {
	      tmp_2 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.UserJS.timestamp.<anonymous>' call
	      tmp_2 = new UserTimestampJS(tmp0_safe_receiver_0);
	    }
	    tmp_1.timestamp = tmp_2;
	    this.imageUrl = user.v37_1;
	    var tmp_3 = this;
	    var tmp0_safe_receiver_1 = user.w37_1;
	    var tmp_4;
	    if (tmp0_safe_receiver_1 == null) {
	      tmp_4 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.UserJS.customData.<anonymous>' call
	      tmp_4 = parseCustomJson(tmp0_safe_receiver_1);
	    }
	    tmp_3.customData = tmp_4;
	  }
	  protoOf(UserJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(UserJS).j9 = function () {
	    return this.name;
	  };
	  protoOf(UserJS).p3t = function () {
	    return this.displayName;
	  };
	  protoOf(UserJS).f3u = function () {
	    return this.channels;
	  };
	  protoOf(UserJS).i2l = function () {
	    return this.timestamp;
	  };
	  protoOf(UserJS).s3s = function () {
	    return this.imageUrl;
	  };
	  protoOf(UserJS).p3s = function () {
	    return this.customData;
	  };
	  function UserTimestampJS(userTimestamp) {
	    this.created = userTimestamp.z37_1;
	    this.updated = userTimestamp.a38_1;
	    this.destroyed = userTimestamp.b38_1;
	  }
	  protoOf(UserTimestampJS).t3t = function () {
	    return this.created;
	  };
	  protoOf(UserTimestampJS).u3t = function () {
	    return this.updated;
	  };
	  protoOf(UserTimestampJS).v3t = function () {
	    return this.destroyed;
	  };
	  function UserChannelsJS(userChannels) {
	    var tmp = this;
	    var tmp0_safe_receiver = userChannels.s2v_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver, 10));
	      var tmp0_iterator = tmp0_safe_receiver.p();
	      while (tmp0_iterator.q()) {
	        var item = tmp0_iterator.s();
	        // Inline function 'vonage.UserChannelsJS.app.<anonymous>' call
	        var tmp$ret$0 = new ChannelJS(item);
	        destination.m(tmp$ret$0);
	      }
	      tmp_0 = destination;
	    }
	    var tmp1_safe_receiver = tmp_0;
	    var tmp_1;
	    if (tmp1_safe_receiver == null) {
	      tmp_1 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_1 = copyToArray(tmp1_safe_receiver);
	    }
	    tmp.app = tmp_1;
	    var tmp_2 = this;
	    var tmp0_safe_receiver_0 = userChannels.t2v_1;
	    var tmp_3;
	    if (tmp0_safe_receiver_0 == null) {
	      tmp_3 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_0, 10));
	      var tmp0_iterator_0 = tmp0_safe_receiver_0.p();
	      while (tmp0_iterator_0.q()) {
	        var item_0 = tmp0_iterator_0.s();
	        // Inline function 'vonage.UserChannelsJS.phone.<anonymous>' call
	        var tmp$ret$4 = new ChannelJS(item_0);
	        destination_0.m(tmp$ret$4);
	      }
	      tmp_3 = destination_0;
	    }
	    var tmp1_safe_receiver_0 = tmp_3;
	    var tmp_4;
	    if (tmp1_safe_receiver_0 == null) {
	      tmp_4 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_4 = copyToArray(tmp1_safe_receiver_0);
	    }
	    tmp_2.phone = tmp_4;
	    var tmp_5 = this;
	    var tmp0_safe_receiver_1 = userChannels.u2v_1;
	    var tmp_6;
	    if (tmp0_safe_receiver_1 == null) {
	      tmp_6 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_1, 10));
	      var tmp0_iterator_1 = tmp0_safe_receiver_1.p();
	      while (tmp0_iterator_1.q()) {
	        var item_1 = tmp0_iterator_1.s();
	        // Inline function 'vonage.UserChannelsJS.pstn.<anonymous>' call
	        var tmp$ret$8 = new ChannelJS(item_1);
	        destination_1.m(tmp$ret$8);
	      }
	      tmp_6 = destination_1;
	    }
	    var tmp1_safe_receiver_1 = tmp_6;
	    var tmp_7;
	    if (tmp1_safe_receiver_1 == null) {
	      tmp_7 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_7 = copyToArray(tmp1_safe_receiver_1);
	    }
	    tmp_5.pstn = tmp_7;
	    var tmp_8 = this;
	    var tmp0_safe_receiver_2 = userChannels.v2v_1;
	    var tmp_9;
	    if (tmp0_safe_receiver_2 == null) {
	      tmp_9 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_2, 10));
	      var tmp0_iterator_2 = tmp0_safe_receiver_2.p();
	      while (tmp0_iterator_2.q()) {
	        var item_2 = tmp0_iterator_2.s();
	        // Inline function 'vonage.UserChannelsJS.sip.<anonymous>' call
	        var tmp$ret$12 = new ChannelJS(item_2);
	        destination_2.m(tmp$ret$12);
	      }
	      tmp_9 = destination_2;
	    }
	    var tmp1_safe_receiver_2 = tmp_9;
	    var tmp_10;
	    if (tmp1_safe_receiver_2 == null) {
	      tmp_10 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_10 = copyToArray(tmp1_safe_receiver_2);
	    }
	    tmp_8.sip = tmp_10;
	    var tmp_11 = this;
	    var tmp0_safe_receiver_3 = userChannels.w2v_1;
	    var tmp_12;
	    if (tmp0_safe_receiver_3 == null) {
	      tmp_12 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_3, 10));
	      var tmp0_iterator_3 = tmp0_safe_receiver_3.p();
	      while (tmp0_iterator_3.q()) {
	        var item_3 = tmp0_iterator_3.s();
	        // Inline function 'vonage.UserChannelsJS.vbc.<anonymous>' call
	        var tmp$ret$16 = new ChannelJS(item_3);
	        destination_3.m(tmp$ret$16);
	      }
	      tmp_12 = destination_3;
	    }
	    var tmp1_safe_receiver_3 = tmp_12;
	    var tmp_13;
	    if (tmp1_safe_receiver_3 == null) {
	      tmp_13 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_13 = copyToArray(tmp1_safe_receiver_3);
	    }
	    tmp_11.vbc = tmp_13;
	    var tmp_14 = this;
	    var tmp0_safe_receiver_4 = userChannels.x2v_1;
	    var tmp_15;
	    if (tmp0_safe_receiver_4 == null) {
	      tmp_15 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_4, 10));
	      var tmp0_iterator_4 = tmp0_safe_receiver_4.p();
	      while (tmp0_iterator_4.q()) {
	        var item_4 = tmp0_iterator_4.s();
	        // Inline function 'vonage.UserChannelsJS.websocket.<anonymous>' call
	        var tmp$ret$20 = new ChannelJS(item_4);
	        destination_4.m(tmp$ret$20);
	      }
	      tmp_15 = destination_4;
	    }
	    var tmp1_safe_receiver_4 = tmp_15;
	    var tmp_16;
	    if (tmp1_safe_receiver_4 == null) {
	      tmp_16 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_16 = copyToArray(tmp1_safe_receiver_4);
	    }
	    tmp_14.websocket = tmp_16;
	    var tmp_17 = this;
	    var tmp0_safe_receiver_5 = userChannels.y2v_1;
	    var tmp_18;
	    if (tmp0_safe_receiver_5 == null) {
	      tmp_18 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_5, 10));
	      var tmp0_iterator_5 = tmp0_safe_receiver_5.p();
	      while (tmp0_iterator_5.q()) {
	        var item_5 = tmp0_iterator_5.s();
	        // Inline function 'vonage.UserChannelsJS.sms.<anonymous>' call
	        var tmp$ret$24 = new ChannelJS(item_5);
	        destination_5.m(tmp$ret$24);
	      }
	      tmp_18 = destination_5;
	    }
	    var tmp1_safe_receiver_5 = tmp_18;
	    var tmp_19;
	    if (tmp1_safe_receiver_5 == null) {
	      tmp_19 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_19 = copyToArray(tmp1_safe_receiver_5);
	    }
	    tmp_17.sms = tmp_19;
	    var tmp_20 = this;
	    var tmp0_safe_receiver_6 = userChannels.z2v_1;
	    var tmp_21;
	    if (tmp0_safe_receiver_6 == null) {
	      tmp_21 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_6 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_6, 10));
	      var tmp0_iterator_6 = tmp0_safe_receiver_6.p();
	      while (tmp0_iterator_6.q()) {
	        var item_6 = tmp0_iterator_6.s();
	        // Inline function 'vonage.UserChannelsJS.mms.<anonymous>' call
	        var tmp$ret$28 = new ChannelJS(item_6);
	        destination_6.m(tmp$ret$28);
	      }
	      tmp_21 = destination_6;
	    }
	    var tmp1_safe_receiver_6 = tmp_21;
	    var tmp_22;
	    if (tmp1_safe_receiver_6 == null) {
	      tmp_22 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_22 = copyToArray(tmp1_safe_receiver_6);
	    }
	    tmp_20.mms = tmp_22;
	    var tmp_23 = this;
	    var tmp0_safe_receiver_7 = userChannels.a2w_1;
	    var tmp_24;
	    if (tmp0_safe_receiver_7 == null) {
	      tmp_24 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_7 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_7, 10));
	      var tmp0_iterator_7 = tmp0_safe_receiver_7.p();
	      while (tmp0_iterator_7.q()) {
	        var item_7 = tmp0_iterator_7.s();
	        // Inline function 'vonage.UserChannelsJS.whatsapp.<anonymous>' call
	        var tmp$ret$32 = new ChannelJS(item_7);
	        destination_7.m(tmp$ret$32);
	      }
	      tmp_24 = destination_7;
	    }
	    var tmp1_safe_receiver_7 = tmp_24;
	    var tmp_25;
	    if (tmp1_safe_receiver_7 == null) {
	      tmp_25 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_25 = copyToArray(tmp1_safe_receiver_7);
	    }
	    tmp_23.whatsapp = tmp_25;
	    var tmp_26 = this;
	    var tmp0_safe_receiver_8 = userChannels.b2w_1;
	    var tmp_27;
	    if (tmp0_safe_receiver_8 == null) {
	      tmp_27 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_8 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_8, 10));
	      var tmp0_iterator_8 = tmp0_safe_receiver_8.p();
	      while (tmp0_iterator_8.q()) {
	        var item_8 = tmp0_iterator_8.s();
	        // Inline function 'vonage.UserChannelsJS.viber.<anonymous>' call
	        var tmp$ret$36 = new ChannelJS(item_8);
	        destination_8.m(tmp$ret$36);
	      }
	      tmp_27 = destination_8;
	    }
	    var tmp1_safe_receiver_8 = tmp_27;
	    var tmp_28;
	    if (tmp1_safe_receiver_8 == null) {
	      tmp_28 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_28 = copyToArray(tmp1_safe_receiver_8);
	    }
	    tmp_26.viber = tmp_28;
	    var tmp_29 = this;
	    var tmp0_safe_receiver_9 = userChannels.c2w_1;
	    var tmp_30;
	    if (tmp0_safe_receiver_9 == null) {
	      tmp_30 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination_9 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver_9, 10));
	      var tmp0_iterator_9 = tmp0_safe_receiver_9.p();
	      while (tmp0_iterator_9.q()) {
	        var item_9 = tmp0_iterator_9.s();
	        // Inline function 'vonage.UserChannelsJS.messenger.<anonymous>' call
	        var tmp$ret$40 = new ChannelJS(item_9);
	        destination_9.m(tmp$ret$40);
	      }
	      tmp_30 = destination_9;
	    }
	    var tmp1_safe_receiver_9 = tmp_30;
	    var tmp_31;
	    if (tmp1_safe_receiver_9 == null) {
	      tmp_31 = null;
	    } else {
	      // Inline function 'kotlin.collections.toTypedArray' call
	      tmp_31 = copyToArray(tmp1_safe_receiver_9);
	    }
	    tmp_29.messenger = tmp_31;
	  }
	  protoOf(UserChannelsJS).h3r = function () {
	    return this.app;
	  };
	  protoOf(UserChannelsJS).i3r = function () {
	    return this.phone;
	  };
	  protoOf(UserChannelsJS).g3u = function () {
	    return this.pstn;
	  };
	  protoOf(UserChannelsJS).j3r = function () {
	    return this.sip;
	  };
	  protoOf(UserChannelsJS).h3u = function () {
	    return this.vbc;
	  };
	  protoOf(UserChannelsJS).k3r = function () {
	    return this.websocket;
	  };
	  protoOf(UserChannelsJS).i3u = function () {
	    return this.sms;
	  };
	  protoOf(UserChannelsJS).j3u = function () {
	    return this.mms;
	  };
	  protoOf(UserChannelsJS).a3t = function () {
	    return this.whatsapp;
	  };
	  protoOf(UserChannelsJS).k3u = function () {
	    return this.viber;
	  };
	  protoOf(UserChannelsJS).l3u = function () {
	    return this.messenger;
	  };
	  function MemberChannelJS(memberChannel) {
	    this.type = map_5(memberChannel.h2z_1);
	    var tmp = this;
	    var tmp0_safe_receiver = memberChannel.i2z_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.MemberChannelJS.from.<anonymous>' call
	      tmp_0 = new ChannelJS(tmp0_safe_receiver);
	    }
	    tmp.from = tmp_0;
	    var tmp_1 = this;
	    var tmp0_safe_receiver_0 = memberChannel.j2z_1;
	    var tmp_2;
	    if (tmp0_safe_receiver_0 == null) {
	      tmp_2 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.MemberChannelJS.to.<anonymous>' call
	      tmp_2 = new ChannelJS(tmp0_safe_receiver_0);
	    }
	    tmp_1.to = tmp_2;
	  }
	  protoOf(MemberChannelJS).c3b = function () {
	    return this.type;
	  };
	  protoOf(MemberChannelJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(MemberChannelJS).m3u = function () {
	    return this.to;
	  };
	  function ChannelJS(channel) {
	    this.id = channel.d2z_1;
	    this.number = channel.e2z_1;
	  }
	  protoOf(ChannelJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(ChannelJS).n3u = function () {
	    return this.number;
	  };
	  function LegChannelJS(channel) {
	    this.type = channel.s2z_1;
	    this.user = channel.u2z_1;
	    this.number = channel.t2z_1;
	  }
	  protoOf(LegChannelJS).c3b = function () {
	    return this.type;
	  };
	  protoOf(LegChannelJS).l2n = function () {
	    return this.user;
	  };
	  protoOf(LegChannelJS).n3u = function () {
	    return this.number;
	  };
	  function MediaStateJS(mediaState) {
	    var tmp = this;
	    tmp.mute = mediaState == null ? null : mediaState.j33_1;
	    var tmp_0 = this;
	    tmp_0.earmuff = mediaState == null ? null : mediaState.k33_1;
	    var tmp_1 = this;
	    tmp_1.play_stream = mediaState == null ? null : mediaState.l33_1;
	    var tmp_2 = this;
	    tmp_2.recording = mediaState == null ? null : mediaState.n33_1;
	    var tmp_3 = this;
	    tmp_3.transcribing = mediaState == null ? null : mediaState.o33_1;
	    var tmp_4 = this;
	    tmp_4.tts = mediaState == null ? null : mediaState.m33_1;
	  }
	  protoOf(MediaStateJS).o3u = function () {
	    return this.mute;
	  };
	  protoOf(MediaStateJS).p3u = function () {
	    return this.earmuff;
	  };
	  protoOf(MediaStateJS).q3u = function () {
	    return this.play_stream;
	  };
	  protoOf(MediaStateJS).r3u = function () {
	    return this.recording;
	  };
	  protoOf(MediaStateJS).s3u = function () {
	    return this.transcribing;
	  };
	  protoOf(MediaStateJS).t3u = function () {
	    return this.tts;
	  };
	  function LegJS(leg) {
	    this.id = leg.q33_1;
	    this.type = leg.r33_1;
	    this.direction = leg.s33_1;
	    this.conversationId = leg.t33_1;
	    this.status = leg.u33_1;
	    this.startTime = leg.v33_1;
	    this.endTime = leg.w33_1;
	    this.from = new LegChannelJS(leg.x33_1);
	    this.to = new LegChannelJS(leg.y33_1);
	    var tmp = this;
	    var tmp0_safe_receiver = leg.z33_1;
	    var tmp_0;
	    if (tmp0_safe_receiver == null) {
	      tmp_0 = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.LegJS.mediaState.<anonymous>' call
	      tmp_0 = new MediaStateJS(tmp0_safe_receiver);
	    }
	    tmp.mediaState = tmp_0;
	  }
	  protoOf(LegJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(LegJS).c3b = function () {
	    return this.type;
	  };
	  protoOf(LegJS).u3u = function () {
	    return this.direction;
	  };
	  protoOf(LegJS).o2t = function () {
	    return this.conversationId;
	  };
	  protoOf(LegJS).v3u = function () {
	    return this.status;
	  };
	  protoOf(LegJS).w3u = function () {
	    return this.startTime;
	  };
	  protoOf(LegJS).x3u = function () {
	    return this.endTime;
	  };
	  protoOf(LegJS).i3s = function () {
	    return this.from;
	  };
	  protoOf(LegJS).m3u = function () {
	    return this.to;
	  };
	  protoOf(LegJS).y3u = function () {
	    return this.mediaState;
	  };
	  function LegsPageJS(legsPage) {
	    var tmp = this;
	    // Inline function 'kotlin.collections.toTypedArray' call
	    // Inline function 'kotlin.collections.map' call
	    var this_0 = legsPage.a34_1;
	    // Inline function 'kotlin.collections.mapTo' call
	    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
	    var tmp0_iterator = this_0.p();
	    while (tmp0_iterator.q()) {
	      var item = tmp0_iterator.s();
	      // Inline function 'vonage.LegsPageJS.legs.<anonymous>' call
	      var tmp$ret$0 = new LegJS(item);
	      destination.m(tmp$ret$0);
	    }
	    tmp.legs = copyToArray(destination);
	    this.previousCursor = legsPage.b34_1;
	    this.nextCursor = legsPage.c34_1;
	  }
	  protoOf(LegsPageJS).z3u = function () {
	    return this.legs;
	  };
	  protoOf(LegsPageJS).e3s = function () {
	    return this.previousCursor;
	  };
	  protoOf(LegsPageJS).f3s = function () {
	    return this.nextCursor;
	  };
	  function ChannelTypeObj() {
	    this.APP = 'APP';
	    this.PHONE = 'PHONE';
	    this.PSTN = 'PSTN';
	    this.SIP = 'SIP';
	    this.VBC = 'VBC';
	    this.WEBSOCKET = 'WEBSOCKET';
	    this.SMS = 'SMS';
	    this.MMS = 'MMS';
	    this.WHATSAPP = 'WHATSAPP';
	    this.VIBER = 'VIBER';
	    this.MESSENGER = 'MESSENGER';
	  }
	  protoOf(ChannelTypeObj).a3v = function () {
	    return this.APP;
	  };
	  protoOf(ChannelTypeObj).b3v = function () {
	    return this.PHONE;
	  };
	  protoOf(ChannelTypeObj).c3v = function () {
	    return this.PSTN;
	  };
	  protoOf(ChannelTypeObj).d3v = function () {
	    return this.SIP;
	  };
	  protoOf(ChannelTypeObj).e3v = function () {
	    return this.VBC;
	  };
	  protoOf(ChannelTypeObj).f3v = function () {
	    return this.WEBSOCKET;
	  };
	  protoOf(ChannelTypeObj).g3v = function () {
	    return this.SMS;
	  };
	  protoOf(ChannelTypeObj).h3v = function () {
	    return this.MMS;
	  };
	  protoOf(ChannelTypeObj).i3v = function () {
	    return this.WHATSAPP;
	  };
	  protoOf(ChannelTypeObj).j3v = function () {
	    return this.VIBER;
	  };
	  protoOf(ChannelTypeObj).k3v = function () {
	    return this.MESSENGER;
	  };
	  protoOf(ChannelTypeObj).toString = function () {
	    return 'ChannelTypeObj';
	  };
	  protoOf(ChannelTypeObj).hashCode = function () {
	    return 289615710;
	  };
	  protoOf(ChannelTypeObj).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof ChannelTypeObj))
	      return false;
	    other instanceof ChannelTypeObj || THROW_CCE();
	    return true;
	  };
	  var ChannelTypeObj_instance;
	  function ChannelTypeObj_getInstance() {
	    return ChannelTypeObj_instance;
	  }
	  function map_3(_this__u8e3s4) {
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 0:
	        tmp = 'ACTIVE';
	        break;
	      case 1:
	        tmp = 'INACTIVE';
	        break;
	      case 2:
	        tmp = 'DELETED';
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  function map_4(_this__u8e3s4) {
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 0:
	        tmp = 'INVITED';
	        break;
	      case 1:
	        tmp = 'JOINED';
	        break;
	      case 2:
	        tmp = 'LEFT';
	        break;
	      case 3:
	        tmp = 'UNKNOWN';
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  function map_5(_this__u8e3s4) {
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 0:
	        tmp = ChannelTypeObj_instance.APP;
	        break;
	      case 1:
	        tmp = ChannelTypeObj_instance.PHONE;
	        break;
	      case 2:
	        tmp = ChannelTypeObj_instance.PSTN;
	        break;
	      case 3:
	        tmp = ChannelTypeObj_instance.SIP;
	        break;
	      case 4:
	        tmp = ChannelTypeObj_instance.VBC;
	        break;
	      case 5:
	        tmp = ChannelTypeObj_instance.WEBSOCKET;
	        break;
	      case 6:
	        tmp = ChannelTypeObj_instance.SMS;
	        break;
	      case 7:
	        tmp = ChannelTypeObj_instance.MMS;
	        break;
	      case 8:
	        tmp = ChannelTypeObj_instance.WHATSAPP;
	        break;
	      case 9:
	        tmp = ChannelTypeObj_instance.VIBER;
	        break;
	      case 10:
	        tmp = ChannelTypeObj_instance.MESSENGER;
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  function PresentingOrderJS_ASC_getInstance() {
	    PresentingOrderJS_initEntries();
	    return PresentingOrderJS_ASC_instance;
	  }
	  function PresentingOrderJS_DESC_getInstance() {
	    PresentingOrderJS_initEntries();
	    return PresentingOrderJS_DESC_instance;
	  }
	  function OrderByJS_CREATED_getInstance() {
	    OrderByJS_initEntries();
	    return OrderByJS_CREATED_instance;
	  }
	  function OrderByJS_CUSTOM_SORT_KEY_getInstance() {
	    OrderByJS_initEntries();
	    return OrderByJS_CUSTOM_SORT_KEY_instance;
	  }
	  function CSErrorCodesJS() {
	    this.CONVERSATION_DUPLICATE_NAME = 'conversation:error:duplicate-name';
	    this.MEMBER_ALREADY_JOINED = 'conversation:error:member-already-joined';
	    this.MEMBER_ALREADY_INVITED = 'conversation:error:member-already-invited';
	    this.CONVERSATION_NOT_FOUND = 'conversation:error:not-found';
	    this.MEMBER_NOT_FOUND = 'conversation:error:member-not-found';
	    this.USER_NOT_FOUND = 'user:error:not-found';
	    this.INVALID_CURSOR = 'paginator-builder:error:invalid-cursor';
	    this.VALIDATION_FAIL = 'http:error:validation-fail';
	    this.CONVERSATION_MAX_NUMBER_OF_MEMBERS = 'conversation:error:maximum-number-of-members';
	    this.CUSTOM_DATA_OVERALL_LIMIT_EXCEEDED = 'custom-data:error:max-data-sum-limit-exceeded';
	  }
	  protoOf(CSErrorCodesJS).l3v = function () {
	    return this.CONVERSATION_DUPLICATE_NAME;
	  };
	  protoOf(CSErrorCodesJS).m3v = function () {
	    return this.MEMBER_ALREADY_JOINED;
	  };
	  protoOf(CSErrorCodesJS).n3v = function () {
	    return this.MEMBER_ALREADY_INVITED;
	  };
	  protoOf(CSErrorCodesJS).o3v = function () {
	    return this.CONVERSATION_NOT_FOUND;
	  };
	  protoOf(CSErrorCodesJS).p3v = function () {
	    return this.MEMBER_NOT_FOUND;
	  };
	  protoOf(CSErrorCodesJS).q3v = function () {
	    return this.USER_NOT_FOUND;
	  };
	  protoOf(CSErrorCodesJS).r3v = function () {
	    return this.INVALID_CURSOR;
	  };
	  protoOf(CSErrorCodesJS).s3v = function () {
	    return this.VALIDATION_FAIL;
	  };
	  protoOf(CSErrorCodesJS).t3v = function () {
	    return this.CONVERSATION_MAX_NUMBER_OF_MEMBERS;
	  };
	  protoOf(CSErrorCodesJS).u3v = function () {
	    return this.CUSTOM_DATA_OVERALL_LIMIT_EXCEEDED;
	  };
	  var CSErrorCodesJS_instance;
	  function CSErrorCodesJS_getInstance() {
	    return CSErrorCodesJS_instance;
	  }
	  function SessionErrorCodesJS() {
	    this.EMPTY_TOKEN = 'session:error:empty-token';
	    this.FORCED_DISCONNECT = 'session:error:server-forced-disconnect';
	    this.TIMEOUT = 'session:error:timeout';
	    this.INTERNAL_FAILURE = 'session:error:internal-failure';
	    this.NO_ACTIVE_SESSION = 'session:error:no-active-session';
	    this.ALREADY_ACTIVE_SESSION = 'session:error:already-active-session';
	    this.INVALID_TOKEN = 'session:error:invalid-token';
	    this.EXPIRED_TOKEN = 'session:error:expired-token';
	    this.INVALID_USER = 'user:error:invalid-user';
	    this.AUTHORIZATION_ERROR = 'system:error:permission';
	    this.INVALID_SESSION = 'session:error:invalid-session';
	    this.MAX_OPEN_SESSIONS = 'session:error:max-open-sessions-permitted';
	    this.INVALID_SOCKET_TRANSPORT = 'session:error:websocket-transport-invalid';
	    this.CLIENT_DISCONNECT = 'session:disconnect:client-disconnect';
	    this.PING_TIMEOUT_DISCONNECT = 'session:disconnect:ping-timeout';
	    this.TRANSPORT_CLOSED_DISCONNECT = 'session:disconnect:websocket-transport-closed';
	  }
	  protoOf(SessionErrorCodesJS).v3v = function () {
	    return this.EMPTY_TOKEN;
	  };
	  protoOf(SessionErrorCodesJS).w3v = function () {
	    return this.FORCED_DISCONNECT;
	  };
	  protoOf(SessionErrorCodesJS).x3v = function () {
	    return this.TIMEOUT;
	  };
	  protoOf(SessionErrorCodesJS).y3v = function () {
	    return this.INTERNAL_FAILURE;
	  };
	  protoOf(SessionErrorCodesJS).z3v = function () {
	    return this.NO_ACTIVE_SESSION;
	  };
	  protoOf(SessionErrorCodesJS).a3w = function () {
	    return this.ALREADY_ACTIVE_SESSION;
	  };
	  protoOf(SessionErrorCodesJS).b3w = function () {
	    return this.INVALID_TOKEN;
	  };
	  protoOf(SessionErrorCodesJS).c3w = function () {
	    return this.EXPIRED_TOKEN;
	  };
	  protoOf(SessionErrorCodesJS).d3w = function () {
	    return this.INVALID_USER;
	  };
	  protoOf(SessionErrorCodesJS).e3w = function () {
	    return this.AUTHORIZATION_ERROR;
	  };
	  protoOf(SessionErrorCodesJS).f3w = function () {
	    return this.INVALID_SESSION;
	  };
	  protoOf(SessionErrorCodesJS).g3w = function () {
	    return this.MAX_OPEN_SESSIONS;
	  };
	  protoOf(SessionErrorCodesJS).h3w = function () {
	    return this.INVALID_SOCKET_TRANSPORT;
	  };
	  protoOf(SessionErrorCodesJS).i3w = function () {
	    return this.CLIENT_DISCONNECT;
	  };
	  protoOf(SessionErrorCodesJS).j3w = function () {
	    return this.PING_TIMEOUT_DISCONNECT;
	  };
	  protoOf(SessionErrorCodesJS).k3w = function () {
	    return this.TRANSPORT_CLOSED_DISCONNECT;
	  };
	  var SessionErrorCodesJS_instance;
	  function SessionErrorCodesJS_getInstance() {
	    return SessionErrorCodesJS_instance;
	  }
	  function VonageErrorJS(vonageError) {
	    extendThrowable(this, vonageError.message);
	    captureStack(this, VonageErrorJS);
	    this.type = valueOf_3(vonageError.o2y_1.h8_1);
	    this.code = vonageError.p2y_1;
	    this.kmpCause = vonageError.cause;
	  }
	  protoOf(VonageErrorJS).c3b = function () {
	    return this.type;
	  };
	  protoOf(VonageErrorJS).d2o = function () {
	    return this.code;
	  };
	  protoOf(VonageErrorJS).l3w = function () {
	    return this.kmpCause;
	  };
	  var VonageErrorTypeJS_CS_ERROR_instance;
	  var VonageErrorTypeJS_NETWORK_ERROR_instance;
	  var VonageErrorTypeJS_SESSION_ERROR_instance;
	  var VonageErrorTypeJS_INTERNAL_ERROR_instance;
	  var VonageErrorTypeJS_UNKNOWN_ERROR_instance;
	  function values_2() {
	    return [VonageErrorTypeJS_CS_ERROR_getInstance(), VonageErrorTypeJS_NETWORK_ERROR_getInstance(), VonageErrorTypeJS_SESSION_ERROR_getInstance(), VonageErrorTypeJS_INTERNAL_ERROR_getInstance(), VonageErrorTypeJS_UNKNOWN_ERROR_getInstance()];
	  }
	  function valueOf_3(value) {
	    switch (value) {
	      case 'CS_ERROR':
	        return VonageErrorTypeJS_CS_ERROR_getInstance();
	      case 'NETWORK_ERROR':
	        return VonageErrorTypeJS_NETWORK_ERROR_getInstance();
	      case 'SESSION_ERROR':
	        return VonageErrorTypeJS_SESSION_ERROR_getInstance();
	      case 'INTERNAL_ERROR':
	        return VonageErrorTypeJS_INTERNAL_ERROR_getInstance();
	      case 'UNKNOWN_ERROR':
	        return VonageErrorTypeJS_UNKNOWN_ERROR_getInstance();
	      default:
	        VonageErrorTypeJS_initEntries();
	        THROW_IAE('No enum constant value.');
	        break;
	    }
	  }
	  var VonageErrorTypeJS_entriesInitialized;
	  function VonageErrorTypeJS_initEntries() {
	    if (VonageErrorTypeJS_entriesInitialized)
	      return Unit_instance;
	    VonageErrorTypeJS_entriesInitialized = true;
	    VonageErrorTypeJS_CS_ERROR_instance = new VonageErrorTypeJS('CS_ERROR', 0);
	    VonageErrorTypeJS_NETWORK_ERROR_instance = new VonageErrorTypeJS('NETWORK_ERROR', 1);
	    VonageErrorTypeJS_SESSION_ERROR_instance = new VonageErrorTypeJS('SESSION_ERROR', 2);
	    VonageErrorTypeJS_INTERNAL_ERROR_instance = new VonageErrorTypeJS('INTERNAL_ERROR', 3);
	    VonageErrorTypeJS_UNKNOWN_ERROR_instance = new VonageErrorTypeJS('UNKNOWN_ERROR', 4);
	  }
	  function VonageErrorTypeJS(name, ordinal) {
	    Enum.call(this, name, ordinal);
	  }
	  function MediaClientErrorJS() {
	  }
	  protoOf(MediaClientErrorJS).o3w = function () {
	    var tmp;
	    if (this instanceof PeerConnectionNotFoundJS) {
	      tmp = new PeerConnectionNotFound(this.legId);
	    } else {
	      if (this instanceof TrackNotFoundJS) {
	        tmp = new TrackNotFound(this.legId);
	      } else {
	        if (this instanceof ProcessAnswerErrorJS) {
	          tmp = new ProcessAnswerError(this.legId, this.message);
	        } else {
	          if (this instanceof CreateAnswerErrorJS) {
	            tmp = new CreateAnswerError(this.message);
	          } else {
	            if (this instanceof CreateOfferErrorJS) {
	              tmp = new CreateOfferError(this.message);
	            } else {
	              noWhenBranchMatchedException();
	            }
	          }
	        }
	      }
	    }
	    return tmp;
	  };
	  function PeerConnectionNotFoundJS(legId) {
	    MediaClientErrorJS.call(this);
	    this.legId = legId;
	  }
	  protoOf(PeerConnectionNotFoundJS).p3w = function () {
	    return this.legId;
	  };
	  protoOf(PeerConnectionNotFoundJS).o5 = function () {
	    return this.legId;
	  };
	  protoOf(PeerConnectionNotFoundJS).q3w = function (legId) {
	    return new PeerConnectionNotFoundJS(legId);
	  };
	  protoOf(PeerConnectionNotFoundJS).copy = function (legId, $super) {
	    legId = legId === VOID ? this.legId : legId;
	    return this.q3w(legId);
	  };
	  protoOf(PeerConnectionNotFoundJS).toString = function () {
	    return 'PeerConnectionNotFoundJS(legId=' + this.legId + ')';
	  };
	  protoOf(PeerConnectionNotFoundJS).hashCode = function () {
	    return getStringHashCode(this.legId);
	  };
	  protoOf(PeerConnectionNotFoundJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof PeerConnectionNotFoundJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof PeerConnectionNotFoundJS ? other : THROW_CCE();
	    if (!(this.legId === tmp0_other_with_cast.legId))
	      return false;
	    return true;
	  };
	  function TrackNotFoundJS(legId) {
	    MediaClientErrorJS.call(this);
	    this.legId = legId;
	  }
	  protoOf(TrackNotFoundJS).p3w = function () {
	    return this.legId;
	  };
	  protoOf(TrackNotFoundJS).o5 = function () {
	    return this.legId;
	  };
	  protoOf(TrackNotFoundJS).q3w = function (legId) {
	    return new TrackNotFoundJS(legId);
	  };
	  protoOf(TrackNotFoundJS).copy = function (legId, $super) {
	    legId = legId === VOID ? this.legId : legId;
	    return this.q3w(legId);
	  };
	  protoOf(TrackNotFoundJS).toString = function () {
	    return 'TrackNotFoundJS(legId=' + this.legId + ')';
	  };
	  protoOf(TrackNotFoundJS).hashCode = function () {
	    return getStringHashCode(this.legId);
	  };
	  protoOf(TrackNotFoundJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof TrackNotFoundJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof TrackNotFoundJS ? other : THROW_CCE();
	    if (!(this.legId === tmp0_other_with_cast.legId))
	      return false;
	    return true;
	  };
	  function ProcessAnswerErrorJS(legId, message) {
	    message = message === VOID ? null : message;
	    MediaClientErrorJS.call(this);
	    this.legId = legId;
	    this.message = message;
	  }
	  protoOf(ProcessAnswerErrorJS).p3w = function () {
	    return this.legId;
	  };
	  protoOf(ProcessAnswerErrorJS).ab = function () {
	    return this.message;
	  };
	  protoOf(ProcessAnswerErrorJS).o5 = function () {
	    return this.legId;
	  };
	  protoOf(ProcessAnswerErrorJS).p5 = function () {
	    return this.message;
	  };
	  protoOf(ProcessAnswerErrorJS).r3w = function (legId, message) {
	    return new ProcessAnswerErrorJS(legId, message);
	  };
	  protoOf(ProcessAnswerErrorJS).copy = function (legId, message, $super) {
	    legId = legId === VOID ? this.legId : legId;
	    message = message === VOID ? this.message : message;
	    return this.r3w(legId, message);
	  };
	  protoOf(ProcessAnswerErrorJS).toString = function () {
	    return 'ProcessAnswerErrorJS(legId=' + this.legId + ', message=' + this.message + ')';
	  };
	  protoOf(ProcessAnswerErrorJS).hashCode = function () {
	    var result = getStringHashCode(this.legId);
	    result = imul(result, 31) + (this.message == null ? 0 : getStringHashCode(this.message)) | 0;
	    return result;
	  };
	  protoOf(ProcessAnswerErrorJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof ProcessAnswerErrorJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof ProcessAnswerErrorJS ? other : THROW_CCE();
	    if (!(this.legId === tmp0_other_with_cast.legId))
	      return false;
	    if (!(this.message == tmp0_other_with_cast.message))
	      return false;
	    return true;
	  };
	  function CreateAnswerErrorJS(message) {
	    message = message === VOID ? null : message;
	    MediaClientErrorJS.call(this);
	    this.message = message;
	  }
	  protoOf(CreateAnswerErrorJS).ab = function () {
	    return this.message;
	  };
	  protoOf(CreateAnswerErrorJS).o5 = function () {
	    return this.message;
	  };
	  protoOf(CreateAnswerErrorJS).s3w = function (message) {
	    return new CreateAnswerErrorJS(message);
	  };
	  protoOf(CreateAnswerErrorJS).copy = function (message, $super) {
	    message = message === VOID ? this.message : message;
	    return this.s3w(message);
	  };
	  protoOf(CreateAnswerErrorJS).toString = function () {
	    return 'CreateAnswerErrorJS(message=' + this.message + ')';
	  };
	  protoOf(CreateAnswerErrorJS).hashCode = function () {
	    return this.message == null ? 0 : getStringHashCode(this.message);
	  };
	  protoOf(CreateAnswerErrorJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof CreateAnswerErrorJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof CreateAnswerErrorJS ? other : THROW_CCE();
	    if (!(this.message == tmp0_other_with_cast.message))
	      return false;
	    return true;
	  };
	  function CreateOfferErrorJS(message) {
	    message = message === VOID ? null : message;
	    MediaClientErrorJS.call(this);
	    this.message = message;
	  }
	  protoOf(CreateOfferErrorJS).ab = function () {
	    return this.message;
	  };
	  protoOf(CreateOfferErrorJS).o5 = function () {
	    return this.message;
	  };
	  protoOf(CreateOfferErrorJS).s3w = function (message) {
	    return new CreateOfferErrorJS(message);
	  };
	  protoOf(CreateOfferErrorJS).copy = function (message, $super) {
	    message = message === VOID ? this.message : message;
	    return this.s3w(message);
	  };
	  protoOf(CreateOfferErrorJS).toString = function () {
	    return 'CreateOfferErrorJS(message=' + this.message + ')';
	  };
	  protoOf(CreateOfferErrorJS).hashCode = function () {
	    return this.message == null ? 0 : getStringHashCode(this.message);
	  };
	  protoOf(CreateOfferErrorJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof CreateOfferErrorJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof CreateOfferErrorJS ? other : THROW_CCE();
	    if (!(this.message == tmp0_other_with_cast.message))
	      return false;
	    return true;
	  };
	  function VonageErrorTypeJS_CS_ERROR_getInstance() {
	    VonageErrorTypeJS_initEntries();
	    return VonageErrorTypeJS_CS_ERROR_instance;
	  }
	  function VonageErrorTypeJS_NETWORK_ERROR_getInstance() {
	    VonageErrorTypeJS_initEntries();
	    return VonageErrorTypeJS_NETWORK_ERROR_instance;
	  }
	  function VonageErrorTypeJS_SESSION_ERROR_getInstance() {
	    VonageErrorTypeJS_initEntries();
	    return VonageErrorTypeJS_SESSION_ERROR_instance;
	  }
	  function VonageErrorTypeJS_INTERNAL_ERROR_getInstance() {
	    VonageErrorTypeJS_initEntries();
	    return VonageErrorTypeJS_INTERNAL_ERROR_instance;
	  }
	  function VonageErrorTypeJS_UNKNOWN_ERROR_getInstance() {
	    VonageErrorTypeJS_initEntries();
	    return VonageErrorTypeJS_UNKNOWN_ERROR_instance;
	  }
	  function IChatClientJS$createConversation$lambda$lambda($resolve, $reject) {
	    return function (err, cid) {
	      var tmp;
	      if (cid == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(cid);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$createConversation$lambda(this$0, $parameters) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp0_safe_receiver = $parameters;
	      var tmp_0 = tmp0_safe_receiver == null ? null : map_16(tmp0_safe_receiver);
	      tmp.e1f(tmp_0, IChatClientJS$createConversation$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$joinConversation$lambda$lambda($resolve, $reject) {
	    return function (err, mid) {
	      var tmp;
	      if (mid == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(mid);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$joinConversation$lambda(this$0, $cid) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.m1f($cid, IChatClientJS$joinConversation$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$inviteToConversation$lambda$lambda($resolve, $reject) {
	    return function (err, mid) {
	      var tmp;
	      if (mid == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(mid);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$inviteToConversation$lambda(this$0, $cid, $username) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.l1f($cid, $username, IChatClientJS$inviteToConversation$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$leaveConversation$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$leaveConversation$lambda(this$0, $cid) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.n1f($cid, IChatClientJS$leaveConversation$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$deleteConversation$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$deleteConversation$lambda(this$0, $cid) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.f1f($cid, IChatClientJS$deleteConversation$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$getConversations$lambda$lambda($resolve, $reject) {
	    return function (err, page) {
	      var tmp;
	      if (page == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(new ConversationsPageJS(page));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$getConversations$lambda(this$0, $parameters) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp0_safe_receiver = $parameters;
	      var tmp_0 = tmp0_safe_receiver == null ? null : map_18(tmp0_safe_receiver);
	      tmp.k1f(tmp_0, IChatClientJS$getConversations$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$getConversationMembers$lambda$lambda($resolve, $reject) {
	    return function (err, page) {
	      var tmp;
	      if (page == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(new MembersPageJS(page));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$getConversationMembers$lambda(this$0, $cid, $parameters) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp0_safe_receiver = $parameters;
	      var tmp_0 = tmp0_safe_receiver == null ? null : map_20(tmp0_safe_receiver);
	      tmp.j1f($cid, tmp_0, IChatClientJS$getConversationMembers$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$getConversationEvents$lambda$lambda($resolve, $reject) {
	    return function (err, page) {
	      var tmp;
	      if (page == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(new EventsPageJS(page));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$getConversationEvents$lambda(this$0, $cid, $parameters) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp0_safe_receiver = $parameters;
	      var tmp_0 = tmp0_safe_receiver == null ? null : map_19(tmp0_safe_receiver);
	      tmp.s1d($cid, tmp_0, VOID, VOID, IChatClientJS$getConversationEvents$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$getConversationMember$lambda$lambda($resolve, $reject) {
	    return function (err, member) {
	      var tmp;
	      if (member == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(new MemberJS(member));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$getConversationMember$lambda(this$0, $cid, $mid) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.i1f($cid, $mid, IChatClientJS$getConversationMember$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageTextEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageTextEvent$lambda(this$0, $cid, $text) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.t1d($cid, $text, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, IChatClientJS$sendMessageTextEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageCustomEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageCustomEvent$lambda(this$0, $cid, $customData) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.t1d($cid, VOID, VOID, VOID, VOID, VOID, VOID, $customData, VOID, VOID, IChatClientJS$sendMessageCustomEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageImageEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageImageEvent$lambda(this$0, $cid, $imageURL) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp_0 = toString($imageURL);
	      tmp.t1d($cid, VOID, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, IChatClientJS$sendMessageImageEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageVideoEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageVideoEvent$lambda(this$0, $cid, $videoURL) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp_0 = toString($videoURL);
	      tmp.t1d($cid, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, IChatClientJS$sendMessageVideoEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageFileEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageFileEvent$lambda(this$0, $cid, $fileURL) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp_0 = toString($fileURL);
	      tmp.t1d($cid, VOID, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, IChatClientJS$sendMessageFileEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageAudioEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageAudioEvent$lambda(this$0, $cid, $audioURL) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp_0 = toString($audioURL);
	      tmp.t1d($cid, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, VOID, IChatClientJS$sendMessageAudioEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageVCardEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageVCardEvent$lambda(this$0, $cid, $vCardURL) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp_0 = toString($vCardURL);
	      tmp.t1d($cid, VOID, VOID, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, IChatClientJS$sendMessageVCardEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageLocationEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageLocationEvent$lambda(this$0, $cid, $location) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp0_name = $location.name;
	      var tmp1_latitude = $location.latitude;
	      var tmp2_longitude = $location.longitude;
	      var tmp3_address = $location.address;
	      var tmp_0 = new Location(tmp2_longitude, tmp1_latitude, tmp0_name, tmp3_address);
	      tmp.t1d($cid, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, VOID, IChatClientJS$sendMessageLocationEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageTemplateEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageTemplateEvent$lambda(this$0, $cid, $templateObject, $whatsappObject) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp_0 = $templateObject.name;
	      var tmp0_safe_receiver = $templateObject.parameters;
	      var tmp_1 = new Pair(new TemplateObject(tmp_0, tmp0_safe_receiver == null ? null : toList(tmp0_safe_receiver)), new WhatsappObject($whatsappObject.policy, $whatsappObject.locale));
	      tmp.t1d($cid, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_1, IChatClientJS$sendMessageTemplateEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendEphemeralEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendEphemeralEvent$lambda(this$0, $cid, $customData) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.p1f($cid, $customData, IChatClientJS$sendEphemeralEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendCustomEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendCustomEvent$lambda(this$0, $cid, $eventType, $customData) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.o1f($cid, $eventType, $customData, IChatClientJS$sendCustomEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$deleteEvent$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$deleteEvent$lambda(this$0, $id, $conversationId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.g1f($id, $conversationId, IChatClientJS$deleteEvent$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageSeenEvent$lambda$lambda($resolve, $reject) {
	    return function (err, timestamp) {
	      var tmp;
	      if (timestamp == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(timestamp);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$sendMessageSeenEvent$lambda(this$0, $id, $conversationId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.r1f($id, $conversationId, IChatClientJS$sendMessageSeenEvent$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$updateConversation$lambda$lambda($resolve, $reject) {
	    return function (err, cid) {
	      var tmp;
	      if (cid == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(cid);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS$updateConversation$lambda(this$0, $conversationId, $parameters) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp_0 = map_17($parameters);
	      tmp.s1f($conversationId, tmp_0, IChatClientJS$updateConversation$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IChatClientJS() {
	  }
	  function get_DEFAULT_REGION() {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    return DEFAULT_REGION;
	  }
	  var DEFAULT_REGION;
	  var CoreClientConfigRegionJS_AP_instance;
	  var CoreClientConfigRegionJS_EU_instance;
	  var CoreClientConfigRegionJS_US_instance;
	  function values_3() {
	    return [CoreClientConfigRegionJS_AP_getInstance(), CoreClientConfigRegionJS_EU_getInstance(), CoreClientConfigRegionJS_US_getInstance()];
	  }
	  function valueOf_4(value) {
	    switch (value) {
	      case 'AP':
	        return CoreClientConfigRegionJS_AP_getInstance();
	      case 'EU':
	        return CoreClientConfigRegionJS_EU_getInstance();
	      case 'US':
	        return CoreClientConfigRegionJS_US_getInstance();
	      default:
	        CoreClientConfigRegionJS_initEntries();
	        THROW_IAE('No enum constant value.');
	        break;
	    }
	  }
	  var CoreClientConfigRegionJS_entriesInitialized;
	  function CoreClientConfigRegionJS_initEntries() {
	    if (CoreClientConfigRegionJS_entriesInitialized)
	      return Unit_instance;
	    CoreClientConfigRegionJS_entriesInitialized = true;
	    CoreClientConfigRegionJS_AP_instance = new CoreClientConfigRegionJS('AP', 0, ClientConfigRegion_AP_getInstance());
	    CoreClientConfigRegionJS_EU_instance = new CoreClientConfigRegionJS('EU', 1, ClientConfigRegion_EU_getInstance());
	    CoreClientConfigRegionJS_US_instance = new CoreClientConfigRegionJS('US', 2, ClientConfigRegion_US_getInstance());
	  }
	  function CoreClientConfigRegionJS(name, ordinal, coreRegion) {
	    Enum.call(this, name, ordinal);
	    this.coreRegion = coreRegion;
	  }
	  protoOf(CoreClientConfigRegionJS).v3w = function () {
	    return this.coreRegion;
	  };
	  function CoreClientConfigJS(region) {
	    region = region === VOID ? get_DEFAULT_REGION() : region;
	    this.region = region;
	    this.w3w_1 = this.region.coreRegion.i2v_1;
	    this.x3w_1 = this.region.coreRegion.j2v_1;
	    var tmp = this;
	    DefaultConfig_getInstance();
	    tmp.y3w_1 = '/v2/rtc';
	    var tmp_0 = this;
	    DefaultConfig_getInstance();
	    tmp_0.z3w_1 = true;
	    this.a3x_1 = false;
	    this.b3x_1 = false;
	  }
	  protoOf(CoreClientConfigJS).c3x = function () {
	    return this.region;
	  };
	  protoOf(CoreClientConfigJS).d3x = function (_set____db54di) {
	    this.w3w_1 = _set____db54di;
	  };
	  protoOf(CoreClientConfigJS).e3x = function () {
	    return this.w3w_1;
	  };
	  protoOf(CoreClientConfigJS).f3x = function (_set____db54di) {
	    this.x3w_1 = _set____db54di;
	  };
	  protoOf(CoreClientConfigJS).g3x = function () {
	    return this.x3w_1;
	  };
	  protoOf(CoreClientConfigJS).h3x = function (_set____db54di) {
	    this.y3w_1 = _set____db54di;
	  };
	  protoOf(CoreClientConfigJS).i3x = function () {
	    return this.y3w_1;
	  };
	  protoOf(CoreClientConfigJS).j3x = function (_set____db54di) {
	    this.z3w_1 = _set____db54di;
	  };
	  protoOf(CoreClientConfigJS).k3x = function () {
	    return this.z3w_1;
	  };
	  protoOf(CoreClientConfigJS).l3x = function (_set____db54di) {
	    this.a3x_1 = _set____db54di;
	  };
	  protoOf(CoreClientConfigJS).m3x = function () {
	    return this.a3x_1;
	  };
	  protoOf(CoreClientConfigJS).n3x = function () {
	    return this.b3x_1;
	  };
	  function TopicJS(name, tag) {
	    this.name = name;
	    this.tag = tag;
	  }
	  protoOf(TopicJS).j9 = function () {
	    return this.name;
	  };
	  protoOf(TopicJS).o3x = function () {
	    return this.tag;
	  };
	  protoOf(TopicJS).o5 = function () {
	    return this.name;
	  };
	  protoOf(TopicJS).p5 = function () {
	    return this.tag;
	  };
	  protoOf(TopicJS).p3x = function (name, tag) {
	    return new TopicJS(name, tag);
	  };
	  protoOf(TopicJS).copy = function (name, tag, $super) {
	    name = name === VOID ? this.name : name;
	    tag = tag === VOID ? this.tag : tag;
	    return this.p3x(name, tag);
	  };
	  protoOf(TopicJS).toString = function () {
	    return 'TopicJS(name=' + this.name + ', tag=' + this.tag + ')';
	  };
	  protoOf(TopicJS).hashCode = function () {
	    var result = getStringHashCode(this.name);
	    result = imul(result, 31) + getStringHashCode(this.tag) | 0;
	    return result;
	  };
	  protoOf(TopicJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof TopicJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof TopicJS ? other : THROW_CCE();
	    if (!(this.name === tmp0_other_with_cast.name))
	      return false;
	    if (!(this.tag === tmp0_other_with_cast.tag))
	      return false;
	    return true;
	  };
	  var Topics_HTTP_instance;
	  var Topics_WS_instance;
	  var Topics_MEDIA_instance;
	  var Topics_API_instance;
	  var Topics_STORE_instance;
	  var Topics_REDUCER_instance;
	  var Topics_DEFAULT_instance;
	  function values_4() {
	    return [Topics_HTTP_getInstance(), Topics_WS_getInstance(), Topics_MEDIA_getInstance(), Topics_API_getInstance(), Topics_STORE_getInstance(), Topics_REDUCER_getInstance(), Topics_DEFAULT_getInstance()];
	  }
	  function valueOf_5(value) {
	    switch (value) {
	      case 'HTTP':
	        return Topics_HTTP_getInstance();
	      case 'WS':
	        return Topics_WS_getInstance();
	      case 'MEDIA':
	        return Topics_MEDIA_getInstance();
	      case 'API':
	        return Topics_API_getInstance();
	      case 'STORE':
	        return Topics_STORE_getInstance();
	      case 'REDUCER':
	        return Topics_REDUCER_getInstance();
	      case 'DEFAULT':
	        return Topics_DEFAULT_getInstance();
	      default:
	        Topics_initEntries();
	        THROW_IAE('No enum constant value.');
	        break;
	    }
	  }
	  var Topics_entriesInitialized;
	  function Topics_initEntries() {
	    if (Topics_entriesInitialized)
	      return Unit_instance;
	    Topics_entriesInitialized = true;
	    Topics_HTTP_instance = new Topics('HTTP', 0);
	    Topics_WS_instance = new Topics('WS', 1);
	    Topics_MEDIA_instance = new Topics('MEDIA', 2);
	    Topics_API_instance = new Topics('API', 3);
	    Topics_STORE_instance = new Topics('STORE', 4);
	    Topics_REDUCER_instance = new Topics('REDUCER', 5);
	    Topics_DEFAULT_instance = new Topics('DEFAULT', 6);
	  }
	  function Topics(name, ordinal) {
	    Enum.call(this, name, ordinal);
	  }
	  function createVonageLoggerJS(name, minLogLevel, topics, onLog) {
	    minLogLevel = minLogLevel === VOID ? get_DEFAULT_LOGGING_LEVEL() : minLogLevel;
	    var tmp;
	    if (topics === VOID) {
	      // Inline function 'kotlin.arrayOf' call
	      // Inline function 'kotlin.js.unsafeCast' call
	      // Inline function 'kotlin.js.asDynamic' call
	      tmp = [Topics_DEFAULT_getInstance()];
	    } else {
	      tmp = topics;
	    }
	    topics = tmp;
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    return new createVonageLoggerJS$1(name, minLogLevel, topics, onLog);
	  }
	  var LoggingLevelJS_Verbose_instance;
	  var LoggingLevelJS_Debug_instance;
	  var LoggingLevelJS_Info_instance;
	  var LoggingLevelJS_Warn_instance;
	  var LoggingLevelJS_Error_instance;
	  var LoggingLevelJS_Assert_instance;
	  function values_5() {
	    return [LoggingLevelJS_Verbose_getInstance(), LoggingLevelJS_Debug_getInstance(), LoggingLevelJS_Info_getInstance(), LoggingLevelJS_Warn_getInstance(), LoggingLevelJS_Error_getInstance(), LoggingLevelJS_Assert_getInstance()];
	  }
	  function valueOf_6(value) {
	    switch (value) {
	      case 'Verbose':
	        return LoggingLevelJS_Verbose_getInstance();
	      case 'Debug':
	        return LoggingLevelJS_Debug_getInstance();
	      case 'Info':
	        return LoggingLevelJS_Info_getInstance();
	      case 'Warn':
	        return LoggingLevelJS_Warn_getInstance();
	      case 'Error':
	        return LoggingLevelJS_Error_getInstance();
	      case 'Assert':
	        return LoggingLevelJS_Assert_getInstance();
	      default:
	        LoggingLevelJS_initEntries();
	        THROW_IAE('No enum constant value.');
	        break;
	    }
	  }
	  var LoggingLevelJS_entriesInitialized;
	  function LoggingLevelJS_initEntries() {
	    if (LoggingLevelJS_entriesInitialized)
	      return Unit_instance;
	    LoggingLevelJS_entriesInitialized = true;
	    LoggingLevelJS_Verbose_instance = new LoggingLevelJS('Verbose', 0);
	    LoggingLevelJS_Debug_instance = new LoggingLevelJS('Debug', 1);
	    LoggingLevelJS_Info_instance = new LoggingLevelJS('Info', 2);
	    LoggingLevelJS_Warn_instance = new LoggingLevelJS('Warn', 3);
	    LoggingLevelJS_Error_instance = new LoggingLevelJS('Error', 4);
	    LoggingLevelJS_Assert_instance = new LoggingLevelJS('Assert', 5);
	  }
	  function LoggingLevelJS(name, ordinal) {
	    Enum.call(this, name, ordinal);
	  }
	  function get_DEFAULT_LOGGING_LEVEL() {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    return getLoggingLevelJS(Companion_getInstance().r2v_1);
	  }
	  function setDefaultLoggingLevel(level) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    Companion_getInstance().r2v_1 = getLoggingLevel(level);
	  }
	  var SessionErrorReasonJS_EXPIRED_TOKEN_instance;
	  var SessionErrorReasonJS_TRANSPORT_CLOSED_instance;
	  var SessionErrorReasonJS_PING_TIMEOUT_instance;
	  function values_6() {
	    return [SessionErrorReasonJS_EXPIRED_TOKEN_getInstance(), SessionErrorReasonJS_TRANSPORT_CLOSED_getInstance(), SessionErrorReasonJS_PING_TIMEOUT_getInstance()];
	  }
	  function valueOf_7(value) {
	    switch (value) {
	      case 'EXPIRED_TOKEN':
	        return SessionErrorReasonJS_EXPIRED_TOKEN_getInstance();
	      case 'TRANSPORT_CLOSED':
	        return SessionErrorReasonJS_TRANSPORT_CLOSED_getInstance();
	      case 'PING_TIMEOUT':
	        return SessionErrorReasonJS_PING_TIMEOUT_getInstance();
	      default:
	        SessionErrorReasonJS_initEntries();
	        THROW_IAE('No enum constant value.');
	        break;
	    }
	  }
	  var SessionErrorReasonJS_entriesInitialized;
	  function SessionErrorReasonJS_initEntries() {
	    if (SessionErrorReasonJS_entriesInitialized)
	      return Unit_instance;
	    SessionErrorReasonJS_entriesInitialized = true;
	    SessionErrorReasonJS_EXPIRED_TOKEN_instance = new SessionErrorReasonJS('EXPIRED_TOKEN', 0, SessionErrorReason_TokenExpired_getInstance());
	    SessionErrorReasonJS_TRANSPORT_CLOSED_instance = new SessionErrorReasonJS('TRANSPORT_CLOSED', 1, SessionErrorReason_TransportClosed_getInstance());
	    SessionErrorReasonJS_PING_TIMEOUT_instance = new SessionErrorReasonJS('PING_TIMEOUT', 2, SessionErrorReason_PingTimeout_getInstance());
	  }
	  function SessionErrorReasonJS(name, ordinal, reason) {
	    Enum.call(this, name, ordinal);
	    this.reason = reason;
	  }
	  protoOf(SessionErrorReasonJS).m2n = function () {
	    return this.reason;
	  };
	  function ICoreClientJS$createSession$lambda$lambda($resolve, $reject) {
	    return function (err, sessionId) {
	      var tmp;
	      if (sessionId == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(sessionId);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$createSession$lambda(this$0, $token, $sessionId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.t1f($token, $sessionId, ICoreClientJS$createSession$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$deleteSession$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$deleteSession$lambda(this$0) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.u1f(ICoreClientJS$deleteSession$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$refreshSession$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$refreshSession$lambda(this$0, $token) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.v1f($token, ICoreClientJS$refreshSession$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$getConversation$lambda$lambda($resolve, $reject) {
	    return function (err, conversation) {
	      var tmp;
	      if (conversation == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(new ConversationJS(conversation));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$getConversation$lambda(this$0, $conversationIdOrName) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.x1f($conversationIdOrName, ICoreClientJS$getConversation$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$getUser$lambda$lambda($resolve, $reject) {
	    return function (err, user) {
	      var tmp;
	      if (user == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(new UserJS(user));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS$getUser$lambda(this$0, $userIdOrName) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.y1f($userIdOrName, ICoreClientJS$getUser$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function ICoreClientJS() {
	  }
	  function map_6(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    return new TopicJS(_this__u8e3s4.u3g_1, _this__u8e3s4.v3g_1);
	  }
	  function map_7(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 0:
	        tmp = Companion_getInstance_0().s3f_1;
	        break;
	      case 1:
	        tmp = Companion_getInstance_0().t3f_1;
	        break;
	      case 2:
	        tmp = Companion_getInstance_0().u3f_1;
	        break;
	      case 3:
	        tmp = Companion_getInstance_0().v3f_1;
	        break;
	      case 4:
	        tmp = Companion_getInstance_0().w3f_1;
	        break;
	      case 5:
	        tmp = Companion_getInstance_0().x3f_1;
	        break;
	      case 6:
	        tmp = Companion_getInstance_0().y3f_1;
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  function map_8(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    // Inline function 'kotlin.js.unsafeCast' call
	    // Inline function 'kotlin.collections.flatMap' call
	    // Inline function 'kotlin.collections.flatMapTo' call
	    var destination = ArrayList_init_$Create$_0();
	    var inductionVariable = 0;
	    var last = _this__u8e3s4.length;
	    while (inductionVariable < last) {
	      var element = _this__u8e3s4[inductionVariable];
	      inductionVariable = inductionVariable + 1 | 0;
	      // Inline function 'vonage.map.<anonymous>' call
	      var list = map_7(element);
	      addAll(destination, list);
	    }
	    // Inline function 'kotlin.js.asDynamic' call
	    return destination;
	  }
	  function vonageLogger(logger) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp = logger.name;
	    var tmp0_safe_receiver = logger.minLogLevel;
	    var tmp_0 = tmp0_safe_receiver == null ? null : getLoggingLevel(tmp0_safe_receiver);
	    var tmp1_safe_receiver = logger.topics;
	    var tmp_1 = tmp1_safe_receiver == null ? null : map_8(tmp1_safe_receiver);
	    return createVonageLogger(tmp, tmp_0, tmp_1, vonageLogger$lambda(logger));
	  }
	  function map_9(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp;
	    if (_this__u8e3s4 == null) {
	      tmp = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination = ArrayList_init_$Create$(_this__u8e3s4.length);
	      var inductionVariable = 0;
	      var last = _this__u8e3s4.length;
	      while (inductionVariable < last) {
	        var item = _this__u8e3s4[inductionVariable];
	        inductionVariable = inductionVariable + 1 | 0;
	        // Inline function 'vonage.map.<anonymous>' call
	        var tmp$ret$0 = vonageLogger(item);
	        destination.m(tmp$ret$0);
	      }
	      tmp = destination;
	    }
	    var tmp1_elvis_lhs = tmp;
	    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
	  }
	  function getWebsocketUrl(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp2_elvis_lhs = _this__u8e3s4.websocketUrl;
	    var tmp;
	    if (tmp2_elvis_lhs == null) {
	      var tmp0_safe_receiver = _this__u8e3s4.region;
	      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.coreRegion;
	      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j2v_1;
	    } else {
	      tmp = tmp2_elvis_lhs;
	    }
	    var tmp3_elvis_lhs = tmp;
	    return tmp3_elvis_lhs == null ? DefaultConfig_getInstance().p2v_1.j2v_1 : tmp3_elvis_lhs;
	  }
	  function getApiUrl(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp2_elvis_lhs = _this__u8e3s4.apiUrl;
	    var tmp;
	    if (tmp2_elvis_lhs == null) {
	      var tmp0_safe_receiver = _this__u8e3s4.region;
	      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.coreRegion;
	      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i2v_1;
	    } else {
	      tmp = tmp2_elvis_lhs;
	    }
	    var tmp3_elvis_lhs = tmp;
	    return tmp3_elvis_lhs == null ? DefaultConfig_getInstance().p2v_1.i2v_1 : tmp3_elvis_lhs;
	  }
	  function getWebsocketPath(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp0_elvis_lhs = _this__u8e3s4.websocketPath;
	    var tmp;
	    if (tmp0_elvis_lhs == null) {
	      DefaultConfig_getInstance();
	      tmp = '/v2/rtc';
	    } else {
	      tmp = tmp0_elvis_lhs;
	    }
	    return tmp;
	  }
	  function getAutoReconnectMedia(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp0_elvis_lhs = _this__u8e3s4.autoReconnectMedia;
	    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
	  }
	  function getRtcStatsTelemetry(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp0_elvis_lhs = _this__u8e3s4.rtcStatsTelemetry;
	    var tmp;
	    if (tmp0_elvis_lhs == null) {
	      DefaultConfig_getInstance();
	      tmp = true;
	    } else {
	      tmp = tmp0_elvis_lhs;
	    }
	    return tmp;
	  }
	  function getNoiseSuppression(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp0_elvis_lhs = _this__u8e3s4.noiseSuppression;
	    var tmp;
	    if (tmp0_elvis_lhs == null) {
	      DefaultConfig_getInstance();
	      tmp = false;
	    } else {
	      tmp = tmp0_elvis_lhs;
	    }
	    return tmp;
	  }
	  function getLoggingLevel(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    return valueOf(_this__u8e3s4.h8_1);
	  }
	  function getLoggingLevelJS(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    return valueOf_6(_this__u8e3s4.h8_1);
	  }
	  function map_10(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 0:
	        tmp = SessionErrorReasonJS_EXPIRED_TOKEN_getInstance();
	        break;
	      case 1:
	        tmp = SessionErrorReasonJS_TRANSPORT_CLOSED_getInstance();
	        break;
	      case 2:
	        tmp = SessionErrorReasonJS_PING_TIMEOUT_getInstance();
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  function get_jsonNullable(_this__u8e3s4) {
	    _init_properties_ICoreClientJS_kt__j7s52i();
	    return _this__u8e3s4 == null ? null : equals(_this__u8e3s4, undefined) ? null : _this__u8e3s4;
	  }
	  function createVonageLoggerJS$1($name, $minLogLevel, $topics, $onLog) {
	    this.z3x_1 = $onLog;
	    this.w3x_1 = $name;
	    this.x3x_1 = $minLogLevel;
	    this.y3x_1 = $topics;
	  }
	  protoOf(createVonageLoggerJS$1).j9 = function () {
	    return this.w3x_1;
	  };
	  protoOf(createVonageLoggerJS$1).i3g = function () {
	    return this.x3x_1;
	  };
	  protoOf(createVonageLoggerJS$1).a3g = function () {
	    return this.y3x_1;
	  };
	  protoOf(createVonageLoggerJS$1).onLog = function (logLevel, topic, message) {
	    this.z3x_1(logLevel, topic, message);
	  };
	  function vonageLogger$lambda($logger) {
	    return function (logLevel, topic, message, _anonymous_parameter_3__qggqen) {
	      $logger.onLog(getLoggingLevelJS(logLevel).h8_1, map_6(topic), message);
	      return Unit_instance;
	    };
	  }
	  function CoreClientConfigRegionJS_AP_getInstance() {
	    CoreClientConfigRegionJS_initEntries();
	    return CoreClientConfigRegionJS_AP_instance;
	  }
	  function CoreClientConfigRegionJS_EU_getInstance() {
	    CoreClientConfigRegionJS_initEntries();
	    return CoreClientConfigRegionJS_EU_instance;
	  }
	  function CoreClientConfigRegionJS_US_getInstance() {
	    CoreClientConfigRegionJS_initEntries();
	    return CoreClientConfigRegionJS_US_instance;
	  }
	  function Topics_HTTP_getInstance() {
	    Topics_initEntries();
	    return Topics_HTTP_instance;
	  }
	  function Topics_WS_getInstance() {
	    Topics_initEntries();
	    return Topics_WS_instance;
	  }
	  function Topics_MEDIA_getInstance() {
	    Topics_initEntries();
	    return Topics_MEDIA_instance;
	  }
	  function Topics_API_getInstance() {
	    Topics_initEntries();
	    return Topics_API_instance;
	  }
	  function Topics_STORE_getInstance() {
	    Topics_initEntries();
	    return Topics_STORE_instance;
	  }
	  function Topics_REDUCER_getInstance() {
	    Topics_initEntries();
	    return Topics_REDUCER_instance;
	  }
	  function Topics_DEFAULT_getInstance() {
	    Topics_initEntries();
	    return Topics_DEFAULT_instance;
	  }
	  function LoggingLevelJS_Verbose_getInstance() {
	    LoggingLevelJS_initEntries();
	    return LoggingLevelJS_Verbose_instance;
	  }
	  function LoggingLevelJS_Debug_getInstance() {
	    LoggingLevelJS_initEntries();
	    return LoggingLevelJS_Debug_instance;
	  }
	  function LoggingLevelJS_Info_getInstance() {
	    LoggingLevelJS_initEntries();
	    return LoggingLevelJS_Info_instance;
	  }
	  function LoggingLevelJS_Warn_getInstance() {
	    LoggingLevelJS_initEntries();
	    return LoggingLevelJS_Warn_instance;
	  }
	  function LoggingLevelJS_Error_getInstance() {
	    LoggingLevelJS_initEntries();
	    return LoggingLevelJS_Error_instance;
	  }
	  function LoggingLevelJS_Assert_getInstance() {
	    LoggingLevelJS_initEntries();
	    return LoggingLevelJS_Assert_instance;
	  }
	  function SessionErrorReasonJS_EXPIRED_TOKEN_getInstance() {
	    SessionErrorReasonJS_initEntries();
	    return SessionErrorReasonJS_EXPIRED_TOKEN_instance;
	  }
	  function SessionErrorReasonJS_TRANSPORT_CLOSED_getInstance() {
	    SessionErrorReasonJS_initEntries();
	    return SessionErrorReasonJS_TRANSPORT_CLOSED_instance;
	  }
	  function SessionErrorReasonJS_PING_TIMEOUT_getInstance() {
	    SessionErrorReasonJS_initEntries();
	    return SessionErrorReasonJS_PING_TIMEOUT_instance;
	  }
	  var properties_initialized_ICoreClientJS_kt_ipn2no;
	  function _init_properties_ICoreClientJS_kt__j7s52i() {
	    if (!properties_initialized_ICoreClientJS_kt_ipn2no) {
	      properties_initialized_ICoreClientJS_kt_ipn2no = true;
	      DEFAULT_REGION = valueOf_4(DefaultConfig_getInstance().p2v_1.h8_1);
	    }
	  }
	  function LegStatusJSObject() {
	    this.RINGING = 'RINGING';
	    this.ANSWERED = 'ANSWERED';
	    this.COMPLETED = 'COMPLETED';
	  }
	  protoOf(LegStatusJSObject).a3y = function () {
	    return this.RINGING;
	  };
	  protoOf(LegStatusJSObject).b3y = function () {
	    return this.ANSWERED;
	  };
	  protoOf(LegStatusJSObject).c3y = function () {
	    return this.COMPLETED;
	  };
	  protoOf(LegStatusJSObject).toString = function () {
	    return 'LegStatusJSObject';
	  };
	  protoOf(LegStatusJSObject).hashCode = function () {
	    return 1394307204;
	  };
	  protoOf(LegStatusJSObject).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof LegStatusJSObject))
	      return false;
	    other instanceof LegStatusJSObject || THROW_CCE();
	    return true;
	  };
	  var LegStatusJSObject_instance;
	  function LegStatusJSObject_getInstance() {
	    return LegStatusJSObject_instance;
	  }
	  function CallDisconnectReasonJSObject() {
	    this.NetworkChange = 'networkChange';
	  }
	  protoOf(CallDisconnectReasonJSObject).d3y = function () {
	    return this.NetworkChange;
	  };
	  protoOf(CallDisconnectReasonJSObject).toString = function () {
	    return 'CallDisconnectReasonJSObject';
	  };
	  protoOf(CallDisconnectReasonJSObject).hashCode = function () {
	    return 1280862186;
	  };
	  protoOf(CallDisconnectReasonJSObject).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof CallDisconnectReasonJSObject))
	      return false;
	    other instanceof CallDisconnectReasonJSObject || THROW_CCE();
	    return true;
	  };
	  var CallDisconnectReasonJSObject_instance;
	  function CallDisconnectReasonJSObject_getInstance() {
	    return CallDisconnectReasonJSObject_instance;
	  }
	  function HangupReasonJSObject() {
	    this.REMOTE_HANGUP = 'REMOTE_HANGUP';
	    this.REMOTE_REJECT = 'REMOTE_REJECT';
	    this.REMOTE_NO_ANSWER_TIMEOUT = 'REMOTE_NO_ANSWER_TIMEOUT';
	    this.LOCAL_HANGUP = 'LOCAL_HANGUP';
	    this.MEDIA_TIMEOUT = 'MEDIA_TIMEOUT';
	  }
	  protoOf(HangupReasonJSObject).e3y = function () {
	    return this.REMOTE_HANGUP;
	  };
	  protoOf(HangupReasonJSObject).f3y = function () {
	    return this.REMOTE_REJECT;
	  };
	  protoOf(HangupReasonJSObject).g3y = function () {
	    return this.REMOTE_NO_ANSWER_TIMEOUT;
	  };
	  protoOf(HangupReasonJSObject).h3y = function () {
	    return this.LOCAL_HANGUP;
	  };
	  protoOf(HangupReasonJSObject).i3y = function () {
	    return this.MEDIA_TIMEOUT;
	  };
	  protoOf(HangupReasonJSObject).toString = function () {
	    return 'HangupReasonJSObject';
	  };
	  protoOf(HangupReasonJSObject).hashCode = function () {
	    return -1290686563;
	  };
	  protoOf(HangupReasonJSObject).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof HangupReasonJSObject))
	      return false;
	    other instanceof HangupReasonJSObject || THROW_CCE();
	    return true;
	  };
	  var HangupReasonJSObject_instance;
	  function HangupReasonJSObject_getInstance() {
	    return HangupReasonJSObject_instance;
	  }
	  function IVoiceClientJS$serverCall$lambda$lambda($resolve, $reject) {
	    return function (err, callId) {
	      var tmp;
	      if (callId == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(callId);
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$serverCall$lambda(this$0, $typedContext) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.v1d($typedContext, IVoiceClientJS$serverCall$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$reconnectCall$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$reconnectCall$lambda(this$0, $legId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.w1d($legId, IVoiceClientJS$reconnectCall$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$getLeg$lambda$lambda($resolve, $reject) {
	    return function (err, leg) {
	      var tmp;
	      if (leg == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(new LegJS(leg));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$getLeg$lambda(this$0, $legId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.x1d($legId, IVoiceClientJS$getLeg$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$getCallLegs$lambda$lambda($resolve, $reject) {
	    return function (err, legsPage) {
	      var tmp;
	      if (legsPage == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $resolve(new LegsPageJS(legsPage));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp1_safe_receiver = err instanceof VonageError ? err : null;
	        var tmp_1;
	        if (tmp1_safe_receiver == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(new VonageErrorJS(tmp1_safe_receiver));
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $reject(err == null ? newThrowable() : err);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$getCallLegs$lambda(this$0, $callId, $parameters) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp0_safe_receiver = $parameters;
	      var tmp_0 = tmp0_safe_receiver == null ? null : map_21(tmp0_safe_receiver);
	      tmp.y1d($callId, tmp_0, IVoiceClientJS$getCallLegs$lambda$lambda(resolve, reject));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$answer$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$answer$lambda(this$0, $callId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.a1e($callId, IVoiceClientJS$answer$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$reject$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$reject$lambda(this$0, $callId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.z1d($callId, IVoiceClientJS$reject$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$hangup$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$hangup$lambda(this$0, $callId, $reasonText, $reasonCode) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.b1e($callId, $reasonText, $reasonCode, IVoiceClientJS$hangup$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$say$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$say$lambda(this$0, $callId, $params) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      var tmp_0 = $params.text;
	      var tmp0_elvis_lhs = get_jsonNullable($params.level);
	      var tmp_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
	      var tmp1_elvis_lhs = get_jsonNullable($params.loop);
	      var tmp_2 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
	      var tmp2_elvis_lhs = get_jsonNullable($params.queue);
	      var tmp_3 = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
	      var tmp3_elvis_lhs = get_jsonNullable($params.voiceName);
	      var tmp_4 = tmp3_elvis_lhs == null ? 'amy' : tmp3_elvis_lhs;
	      var tmp4_elvis_lhs = get_jsonNullable($params.ssml);
	      var tmp_5 = tmp4_elvis_lhs == null ? true : tmp4_elvis_lhs;
	      tmp.h1e($callId, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, IVoiceClientJS$say$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$mute$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$mute$lambda(this$0, $callId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.c1e($callId, IVoiceClientJS$mute$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$unmute$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$unmute$lambda(this$0, $callId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.d1e($callId, IVoiceClientJS$unmute$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$enableEarmuff$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$enableEarmuff$lambda(this$0, $callId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.e1e($callId, IVoiceClientJS$enableEarmuff$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$disableEarmuff$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$disableEarmuff$lambda(this$0, $callId) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.f1e($callId, IVoiceClientJS$disableEarmuff$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$sendDTMF$lambda$lambda($reject, $resolve) {
	    return function (err) {
	      var tmp0_safe_receiver = err instanceof VonageError ? err : null;
	      var tmp;
	      if (tmp0_safe_receiver == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        $reject(new VonageErrorJS(tmp0_safe_receiver));
	        tmp = Unit_instance;
	      }
	      var tmp2_elvis_lhs = tmp;
	      var tmp_0;
	      if (tmp2_elvis_lhs == null) {
	        var tmp_1;
	        if (err == null) {
	          tmp_1 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          $reject(err);
	          tmp_1 = Unit_instance;
	        }
	        tmp_0 = tmp_1;
	      } else {
	        tmp_0 = tmp2_elvis_lhs;
	      }
	      var tmp_2;
	      if (tmp_0 == null) {
	        tmp_2 = $resolve(null);
	      } else {
	        tmp_2 = Unit_instance;
	      }
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS$sendDTMF$lambda(this$0, $callId, $digits) {
	    return function (resolve, reject) {
	      var tmp = this$0.core;
	      tmp.g1e($callId, $digits, IVoiceClientJS$sendDTMF$lambda$lambda(reject, resolve));
	      return Unit_instance;
	    };
	  }
	  function IVoiceClientJS() {
	  }
	  function VoiceInviteFromInfoJS(id, type) {
	    this.id = id;
	    this.type = type;
	  }
	  protoOf(VoiceInviteFromInfoJS).t27 = function () {
	    return this.id;
	  };
	  protoOf(VoiceInviteFromInfoJS).c3b = function () {
	    return this.type;
	  };
	  protoOf(VoiceInviteFromInfoJS).o5 = function () {
	    return this.id;
	  };
	  protoOf(VoiceInviteFromInfoJS).p5 = function () {
	    return this.type;
	  };
	  protoOf(VoiceInviteFromInfoJS).j3y = function (id, type) {
	    return new VoiceInviteFromInfoJS(id, type);
	  };
	  protoOf(VoiceInviteFromInfoJS).copy = function (id, type, $super) {
	    id = id === VOID ? this.id : id;
	    type = type === VOID ? this.type : type;
	    return this.j3y(id, type);
	  };
	  protoOf(VoiceInviteFromInfoJS).toString = function () {
	    return 'VoiceInviteFromInfoJS(id=' + this.id + ', type=' + this.type + ')';
	  };
	  protoOf(VoiceInviteFromInfoJS).hashCode = function () {
	    var result = this.id == null ? 0 : getStringHashCode(this.id);
	    result = imul(result, 31) + getStringHashCode(this.type) | 0;
	    return result;
	  };
	  protoOf(VoiceInviteFromInfoJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof VoiceInviteFromInfoJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof VoiceInviteFromInfoJS ? other : THROW_CCE();
	    if (!(this.id == tmp0_other_with_cast.id))
	      return false;
	    if (!(this.type === tmp0_other_with_cast.type))
	      return false;
	    return true;
	  };
	  function map_11(_this__u8e3s4) {
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 0:
	        tmp = LegStatusJSObject_instance.RINGING;
	        break;
	      case 1:
	        tmp = LegStatusJSObject_instance.ANSWERED;
	        break;
	      case 2:
	        tmp = LegStatusJSObject_instance.COMPLETED;
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  function map_12(_this__u8e3s4) {
	    var tmp;
	    if (_this__u8e3s4.i8_1 === 0) {
	      tmp = CallDisconnectReasonJSObject_instance.NetworkChange;
	    } else {
	      noWhenBranchMatchedException();
	    }
	    return tmp;
	  }
	  function map_13(_this__u8e3s4) {
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 1:
	        tmp = HangupReasonJSObject_instance.REMOTE_HANGUP;
	        break;
	      case 0:
	        tmp = HangupReasonJSObject_instance.REMOTE_REJECT;
	        break;
	      case 2:
	        tmp = HangupReasonJSObject_instance.REMOTE_NO_ANSWER_TIMEOUT;
	        break;
	      case 3:
	        tmp = HangupReasonJSObject_instance.LOCAL_HANGUP;
	        break;
	      case 4:
	        tmp = HangupReasonJSObject_instance.MEDIA_TIMEOUT;
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  function HttpClientErrorJS(message, cause) {
	    message = message === VOID ? null : message;
	    cause = cause === VOID ? null : cause;
	    extendThrowable(this);
	    captureStack(this, HttpClientErrorJS);
	    this.k3y_1 = message;
	    this.l3y_1 = cause;
	  }
	  protoOf(HttpClientErrorJS).ab = function () {
	    return this.k3y_1;
	  };
	  protoOf(HttpClientErrorJS).bb = function () {
	    return this.l3y_1;
	  };
	  protoOf(HttpClientErrorJS).o3w = function () {
	    var tmp0_elvis_lhs = this.k3y_1;
	    var tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
	    var tmp_0 = this.l3y_1;
	    return new HTTPClientError(tmp, tmp_0 instanceof Exception ? tmp_0 : null);
	  };
	  protoOf(HttpClientErrorJS).o5 = function () {
	    return this.k3y_1;
	  };
	  protoOf(HttpClientErrorJS).p5 = function () {
	    return this.l3y_1;
	  };
	  protoOf(HttpClientErrorJS).m3y = function (message, cause) {
	    return new HttpClientErrorJS(message, cause);
	  };
	  protoOf(HttpClientErrorJS).copy = function (message, cause, $super) {
	    message = message === VOID ? this.k3y_1 : message;
	    cause = cause === VOID ? this.l3y_1 : cause;
	    return this.m3y(message, cause);
	  };
	  protoOf(HttpClientErrorJS).toString = function () {
	    return 'HttpClientErrorJS(message=' + this.k3y_1 + ', cause=' + this.l3y_1 + ')';
	  };
	  protoOf(HttpClientErrorJS).hashCode = function () {
	    var result = this.k3y_1 == null ? 0 : getStringHashCode(this.k3y_1);
	    result = imul(result, 31) + (this.l3y_1 == null ? 0 : hashCode(this.l3y_1)) | 0;
	    return result;
	  };
	  protoOf(HttpClientErrorJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof HttpClientErrorJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof HttpClientErrorJS ? other : THROW_CCE();
	    if (!(this.k3y_1 == tmp0_other_with_cast.k3y_1))
	      return false;
	    if (!equals(this.l3y_1, tmp0_other_with_cast.l3y_1))
	      return false;
	    return true;
	  };
	  function HttpClientResponseJS(statusCode, body) {
	    body = body === VOID ? null : body;
	    this.statusCode = statusCode;
	    this.body = body;
	  }
	  protoOf(HttpClientResponseJS).n3y = function () {
	    return this.statusCode;
	  };
	  protoOf(HttpClientResponseJS).j3s = function () {
	    return this.body;
	  };
	  protoOf(HttpClientResponseJS).o5 = function () {
	    return this.statusCode;
	  };
	  protoOf(HttpClientResponseJS).p5 = function () {
	    return this.body;
	  };
	  protoOf(HttpClientResponseJS).o3y = function (statusCode, body) {
	    return new HttpClientResponseJS(statusCode, body);
	  };
	  protoOf(HttpClientResponseJS).copy = function (statusCode, body, $super) {
	    statusCode = statusCode === VOID ? this.statusCode : statusCode;
	    body = body === VOID ? this.body : body;
	    return this.o3y(statusCode, body);
	  };
	  protoOf(HttpClientResponseJS).toString = function () {
	    return 'HttpClientResponseJS(statusCode=' + this.statusCode + ', body=' + this.body + ')';
	  };
	  protoOf(HttpClientResponseJS).hashCode = function () {
	    var result = this.statusCode;
	    result = imul(result, 31) + (this.body == null ? 0 : getStringHashCode(this.body)) | 0;
	    return result;
	  };
	  protoOf(HttpClientResponseJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof HttpClientResponseJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof HttpClientResponseJS ? other : THROW_CCE();
	    if (!(this.statusCode === tmp0_other_with_cast.statusCode))
	      return false;
	    if (!(this.body == tmp0_other_with_cast.body))
	      return false;
	    return true;
	  };
	  function get_SOCKET_CONNECTED() {
	    return SOCKET_CONNECTED;
	  }
	  var SOCKET_CONNECTED;
	  function get_SOCKET_RECONNECTING() {
	    return SOCKET_RECONNECTING;
	  }
	  var SOCKET_RECONNECTING;
	  function get_SOCKET_DISCONNECTED() {
	    return SOCKET_DISCONNECTED;
	  }
	  var SOCKET_DISCONNECTED;
	  function get_REASON_SERVER_DISCONNECTED() {
	    return REASON_SERVER_DISCONNECTED;
	  }
	  var REASON_SERVER_DISCONNECTED;
	  function get_REASON_CLIENT_DISCONNECTED() {
	    return REASON_CLIENT_DISCONNECTED;
	  }
	  var REASON_CLIENT_DISCONNECTED;
	  function get_REASON_CLIENT_NETWORK_ERROR() {
	    return REASON_CLIENT_NETWORK_ERROR;
	  }
	  var REASON_CLIENT_NETWORK_ERROR;
	  function get_REASON_PING_TIMEOUT() {
	    return REASON_PING_TIMEOUT;
	  }
	  var REASON_PING_TIMEOUT;
	  function CancelReasonJSObject() {
	    this.RemoteCancel = 'RemoteCancel';
	    this.AnsweredElsewhere = 'AnsweredElsewhere';
	    this.RejectedElsewhere = 'RejectedElsewhere';
	    this.RemoteTimeout = 'RemoteTimeout';
	  }
	  protoOf(CancelReasonJSObject).p3y = function () {
	    return this.RemoteCancel;
	  };
	  protoOf(CancelReasonJSObject).q3y = function () {
	    return this.AnsweredElsewhere;
	  };
	  protoOf(CancelReasonJSObject).r3y = function () {
	    return this.RejectedElsewhere;
	  };
	  protoOf(CancelReasonJSObject).s3y = function () {
	    return this.RemoteTimeout;
	  };
	  protoOf(CancelReasonJSObject).toString = function () {
	    return 'CancelReasonJSObject';
	  };
	  protoOf(CancelReasonJSObject).hashCode = function () {
	    return 1773502666;
	  };
	  protoOf(CancelReasonJSObject).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof CancelReasonJSObject))
	      return false;
	    other instanceof CancelReasonJSObject || THROW_CCE();
	    return true;
	  };
	  var CancelReasonJSObject_instance;
	  function CancelReasonJSObject_getInstance() {
	    return CancelReasonJSObject_instance;
	  }
	  function RTCQualityJS(mos_score, quality_percentage, jitter_min_var, jitter_max_var, jitter_loss_rate, jitter_burst_rate, flaw_total, packet_cnt, packet_loss_perc) {
	    this.mos_score = mos_score;
	    this.quality_percentage = quality_percentage;
	    this.jitter_min_var = jitter_min_var;
	    this.jitter_max_var = jitter_max_var;
	    this.jitter_loss_rate = jitter_loss_rate;
	    this.jitter_burst_rate = jitter_burst_rate;
	    this.flaw_total = flaw_total;
	    this.packet_cnt = packet_cnt;
	    this.packet_loss_perc = packet_loss_perc;
	  }
	  protoOf(RTCQualityJS).t3y = function () {
	    return this.mos_score;
	  };
	  protoOf(RTCQualityJS).u3y = function () {
	    return this.quality_percentage;
	  };
	  protoOf(RTCQualityJS).v3y = function () {
	    return this.jitter_min_var;
	  };
	  protoOf(RTCQualityJS).w3y = function () {
	    return this.jitter_max_var;
	  };
	  protoOf(RTCQualityJS).x3y = function () {
	    return this.jitter_loss_rate;
	  };
	  protoOf(RTCQualityJS).y3y = function () {
	    return this.jitter_burst_rate;
	  };
	  protoOf(RTCQualityJS).z3y = function () {
	    return this.flaw_total;
	  };
	  protoOf(RTCQualityJS).a3z = function () {
	    return this.packet_cnt;
	  };
	  protoOf(RTCQualityJS).b3z = function () {
	    return this.packet_loss_perc;
	  };
	  protoOf(RTCQualityJS).o5 = function () {
	    return this.mos_score;
	  };
	  protoOf(RTCQualityJS).p5 = function () {
	    return this.quality_percentage;
	  };
	  protoOf(RTCQualityJS).c3z = function () {
	    return this.jitter_min_var;
	  };
	  protoOf(RTCQualityJS).d3z = function () {
	    return this.jitter_max_var;
	  };
	  protoOf(RTCQualityJS).e3z = function () {
	    return this.jitter_loss_rate;
	  };
	  protoOf(RTCQualityJS).f3z = function () {
	    return this.jitter_burst_rate;
	  };
	  protoOf(RTCQualityJS).g3z = function () {
	    return this.flaw_total;
	  };
	  protoOf(RTCQualityJS).h3z = function () {
	    return this.packet_cnt;
	  };
	  protoOf(RTCQualityJS).i3z = function () {
	    return this.packet_loss_perc;
	  };
	  protoOf(RTCQualityJS).j3z = function (mos_score, quality_percentage, jitter_min_var, jitter_max_var, jitter_loss_rate, jitter_burst_rate, flaw_total, packet_cnt, packet_loss_perc) {
	    return new RTCQualityJS(mos_score, quality_percentage, jitter_min_var, jitter_max_var, jitter_loss_rate, jitter_burst_rate, flaw_total, packet_cnt, packet_loss_perc);
	  };
	  protoOf(RTCQualityJS).copy = function (mos_score, quality_percentage, jitter_min_var, jitter_max_var, jitter_loss_rate, jitter_burst_rate, flaw_total, packet_cnt, packet_loss_perc, $super) {
	    mos_score = mos_score === VOID ? this.mos_score : mos_score;
	    quality_percentage = quality_percentage === VOID ? this.quality_percentage : quality_percentage;
	    jitter_min_var = jitter_min_var === VOID ? this.jitter_min_var : jitter_min_var;
	    jitter_max_var = jitter_max_var === VOID ? this.jitter_max_var : jitter_max_var;
	    jitter_loss_rate = jitter_loss_rate === VOID ? this.jitter_loss_rate : jitter_loss_rate;
	    jitter_burst_rate = jitter_burst_rate === VOID ? this.jitter_burst_rate : jitter_burst_rate;
	    flaw_total = flaw_total === VOID ? this.flaw_total : flaw_total;
	    packet_cnt = packet_cnt === VOID ? this.packet_cnt : packet_cnt;
	    packet_loss_perc = packet_loss_perc === VOID ? this.packet_loss_perc : packet_loss_perc;
	    return this.j3z(mos_score, quality_percentage, jitter_min_var, jitter_max_var, jitter_loss_rate, jitter_burst_rate, flaw_total, packet_cnt, packet_loss_perc);
	  };
	  protoOf(RTCQualityJS).toString = function () {
	    return 'RTCQualityJS(mos_score=' + this.mos_score + ', quality_percentage=' + this.quality_percentage + ', jitter_min_var=' + this.jitter_min_var + ', jitter_max_var=' + this.jitter_max_var + ', jitter_loss_rate=' + this.jitter_loss_rate + ', jitter_burst_rate=' + this.jitter_burst_rate + ', flaw_total=' + this.flaw_total + ', packet_cnt=' + this.packet_cnt + ', packet_loss_perc=' + this.packet_loss_perc + ')';
	  };
	  protoOf(RTCQualityJS).hashCode = function () {
	    var result = getNumberHashCode(this.mos_score);
	    result = imul(result, 31) + getNumberHashCode(this.quality_percentage) | 0;
	    result = imul(result, 31) + getNumberHashCode(this.jitter_min_var) | 0;
	    result = imul(result, 31) + getNumberHashCode(this.jitter_max_var) | 0;
	    result = imul(result, 31) + getNumberHashCode(this.jitter_loss_rate) | 0;
	    result = imul(result, 31) + getNumberHashCode(this.jitter_burst_rate) | 0;
	    result = imul(result, 31) + this.flaw_total | 0;
	    result = imul(result, 31) + this.packet_cnt | 0;
	    result = imul(result, 31) + getNumberHashCode(this.packet_loss_perc) | 0;
	    return result;
	  };
	  protoOf(RTCQualityJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof RTCQualityJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof RTCQualityJS ? other : THROW_CCE();
	    if (!equals(this.mos_score, tmp0_other_with_cast.mos_score))
	      return false;
	    if (!equals(this.quality_percentage, tmp0_other_with_cast.quality_percentage))
	      return false;
	    if (!equals(this.jitter_min_var, tmp0_other_with_cast.jitter_min_var))
	      return false;
	    if (!equals(this.jitter_max_var, tmp0_other_with_cast.jitter_max_var))
	      return false;
	    if (!equals(this.jitter_loss_rate, tmp0_other_with_cast.jitter_loss_rate))
	      return false;
	    if (!equals(this.jitter_burst_rate, tmp0_other_with_cast.jitter_burst_rate))
	      return false;
	    if (!(this.flaw_total === tmp0_other_with_cast.flaw_total))
	      return false;
	    if (!(this.packet_cnt === tmp0_other_with_cast.packet_cnt))
	      return false;
	    if (!equals(this.packet_loss_perc, tmp0_other_with_cast.packet_loss_perc))
	      return false;
	    return true;
	  };
	  function Companion() {
	  }
	  protoOf(Companion).p3r = function (stats) {
	    return new RTCStatsJS(stats.p3l_1, stats.q3l_1, stats.r3l_1, stats.s3l_1, stats.t3l_1, stats.u3l_1, stats.v3l_1, stats.w3l_1, stats.x3l_1);
	  };
	  var Companion_instance_0;
	  function Companion_getInstance_1() {
	    return Companion_instance_0;
	  }
	  function RTCStatsJS(audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter) {
	    this.audioRecvPackets = audioRecvPackets;
	    this.audioRecvPacketsLost = audioRecvPacketsLost;
	    this.audioRecvBytes = audioRecvBytes;
	    this.audioRecvJitter = audioRecvJitter;
	    this.audioSentPackets = audioSentPackets;
	    this.audioSentBytes = audioSentBytes;
	    this.audioSentPacketsLost = audioSentPacketsLost;
	    this.audioRtt = audioRtt;
	    this.audioSentJitter = audioSentJitter;
	  }
	  protoOf(RTCStatsJS).k3z = function () {
	    return this.audioRecvPackets;
	  };
	  protoOf(RTCStatsJS).l3z = function () {
	    return this.audioRecvPacketsLost;
	  };
	  protoOf(RTCStatsJS).m3z = function () {
	    return this.audioRecvBytes;
	  };
	  protoOf(RTCStatsJS).n3z = function () {
	    return this.audioRecvJitter;
	  };
	  protoOf(RTCStatsJS).o3z = function () {
	    return this.audioSentPackets;
	  };
	  protoOf(RTCStatsJS).p3z = function () {
	    return this.audioSentBytes;
	  };
	  protoOf(RTCStatsJS).q3z = function () {
	    return this.audioSentPacketsLost;
	  };
	  protoOf(RTCStatsJS).r3z = function () {
	    return this.audioRtt;
	  };
	  protoOf(RTCStatsJS).s3z = function () {
	    return this.audioSentJitter;
	  };
	  protoOf(RTCStatsJS).t3z = function () {
	    return new RTCStats(numberToLong(this.audioRecvPackets), numberToInt(this.audioRecvPacketsLost), numberToLong(this.audioRecvBytes), numberToDouble(this.audioRecvJitter), numberToLong(this.audioSentPackets), numberToLong(this.audioSentBytes), numberToInt(this.audioSentPacketsLost), numberToDouble(this.audioRtt), numberToDouble(this.audioSentJitter));
	  };
	  protoOf(RTCStatsJS).o5 = function () {
	    return this.audioRecvPackets;
	  };
	  protoOf(RTCStatsJS).p5 = function () {
	    return this.audioRecvPacketsLost;
	  };
	  protoOf(RTCStatsJS).c3z = function () {
	    return this.audioRecvBytes;
	  };
	  protoOf(RTCStatsJS).d3z = function () {
	    return this.audioRecvJitter;
	  };
	  protoOf(RTCStatsJS).e3z = function () {
	    return this.audioSentPackets;
	  };
	  protoOf(RTCStatsJS).f3z = function () {
	    return this.audioSentBytes;
	  };
	  protoOf(RTCStatsJS).g3z = function () {
	    return this.audioSentPacketsLost;
	  };
	  protoOf(RTCStatsJS).h3z = function () {
	    return this.audioRtt;
	  };
	  protoOf(RTCStatsJS).i3z = function () {
	    return this.audioSentJitter;
	  };
	  protoOf(RTCStatsJS).u3z = function (audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter) {
	    return new RTCStatsJS(audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter);
	  };
	  protoOf(RTCStatsJS).copy = function (audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter, $super) {
	    audioRecvPackets = audioRecvPackets === VOID ? this.audioRecvPackets : audioRecvPackets;
	    audioRecvPacketsLost = audioRecvPacketsLost === VOID ? this.audioRecvPacketsLost : audioRecvPacketsLost;
	    audioRecvBytes = audioRecvBytes === VOID ? this.audioRecvBytes : audioRecvBytes;
	    audioRecvJitter = audioRecvJitter === VOID ? this.audioRecvJitter : audioRecvJitter;
	    audioSentPackets = audioSentPackets === VOID ? this.audioSentPackets : audioSentPackets;
	    audioSentBytes = audioSentBytes === VOID ? this.audioSentBytes : audioSentBytes;
	    audioSentPacketsLost = audioSentPacketsLost === VOID ? this.audioSentPacketsLost : audioSentPacketsLost;
	    audioRtt = audioRtt === VOID ? this.audioRtt : audioRtt;
	    audioSentJitter = audioSentJitter === VOID ? this.audioSentJitter : audioSentJitter;
	    return this.u3z(audioRecvPackets, audioRecvPacketsLost, audioRecvBytes, audioRecvJitter, audioSentPackets, audioSentBytes, audioSentPacketsLost, audioRtt, audioSentJitter);
	  };
	  protoOf(RTCStatsJS).toString = function () {
	    return 'RTCStatsJS(audioRecvPackets=' + toString(this.audioRecvPackets) + ', audioRecvPacketsLost=' + toString(this.audioRecvPacketsLost) + ', audioRecvBytes=' + toString(this.audioRecvBytes) + ', audioRecvJitter=' + toString(this.audioRecvJitter) + ', audioSentPackets=' + toString(this.audioSentPackets) + ', audioSentBytes=' + toString(this.audioSentBytes) + ', audioSentPacketsLost=' + toString(this.audioSentPacketsLost) + ', audioRtt=' + toString(this.audioRtt) + ', audioSentJitter=' + toString(this.audioSentJitter) + ')';
	  };
	  protoOf(RTCStatsJS).hashCode = function () {
	    var result = hashCode(this.audioRecvPackets);
	    result = imul(result, 31) + hashCode(this.audioRecvPacketsLost) | 0;
	    result = imul(result, 31) + hashCode(this.audioRecvBytes) | 0;
	    result = imul(result, 31) + hashCode(this.audioRecvJitter) | 0;
	    result = imul(result, 31) + hashCode(this.audioSentPackets) | 0;
	    result = imul(result, 31) + hashCode(this.audioSentBytes) | 0;
	    result = imul(result, 31) + hashCode(this.audioSentPacketsLost) | 0;
	    result = imul(result, 31) + hashCode(this.audioRtt) | 0;
	    result = imul(result, 31) + hashCode(this.audioSentJitter) | 0;
	    return result;
	  };
	  protoOf(RTCStatsJS).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof RTCStatsJS))
	      return false;
	    var tmp0_other_with_cast = other instanceof RTCStatsJS ? other : THROW_CCE();
	    if (!equals(this.audioRecvPackets, tmp0_other_with_cast.audioRecvPackets))
	      return false;
	    if (!equals(this.audioRecvPacketsLost, tmp0_other_with_cast.audioRecvPacketsLost))
	      return false;
	    if (!equals(this.audioRecvBytes, tmp0_other_with_cast.audioRecvBytes))
	      return false;
	    if (!equals(this.audioRecvJitter, tmp0_other_with_cast.audioRecvJitter))
	      return false;
	    if (!equals(this.audioSentPackets, tmp0_other_with_cast.audioSentPackets))
	      return false;
	    if (!equals(this.audioSentBytes, tmp0_other_with_cast.audioSentBytes))
	      return false;
	    if (!equals(this.audioSentPacketsLost, tmp0_other_with_cast.audioSentPacketsLost))
	      return false;
	    if (!equals(this.audioRtt, tmp0_other_with_cast.audioRtt))
	      return false;
	    if (!equals(this.audioSentJitter, tmp0_other_with_cast.audioSentJitter))
	      return false;
	    return true;
	  };
	  function HttpClientJSAdapter(js) {
	    return new HttpClientJSAdapter$1(js);
	  }
	  function map_14(_this__u8e3s4) {
	    var tmp;
	    switch (_this__u8e3s4.i8_1) {
	      case 2:
	        tmp = CancelReasonJSObject_instance.RemoteCancel;
	        break;
	      case 0:
	        tmp = CancelReasonJSObject_instance.AnsweredElsewhere;
	        break;
	      case 1:
	        tmp = CancelReasonJSObject_instance.RejectedElsewhere;
	        break;
	      case 3:
	        tmp = CancelReasonJSObject_instance.RemoteTimeout;
	        break;
	      default:
	        noWhenBranchMatchedException();
	        break;
	    }
	    return tmp;
	  }
	  function map_15(_this__u8e3s4) {
	    return new RTCQualityJS(_this__u8e3s4.r3e_1, _this__u8e3s4.s3e_1, _this__u8e3s4.t3e_1, _this__u8e3s4.u3e_1, _this__u8e3s4.v3e_1, _this__u8e3s4.w3e_1, _this__u8e3s4.x3e_1, _this__u8e3s4.y3e_1, _this__u8e3s4.z3e_1);
	  }
	  function SocketClientJSAdapter(js) {
	    var adapter = new SocketClientJSAdapter$adapter$1(js);
	    js.delegate = new SocketClientJSAdapter$1(adapter);
	    return adapter;
	  }
	  function MediaClientJSAdapter(js) {
	    var adapter = new MediaClientJSAdapter$adapter$1(js);
	    js.delegate = new MediaClientJSAdapter$1(adapter);
	    return adapter;
	  }
	  function coreConnectionState(_this__u8e3s4) {
	    switch (_this__u8e3s4) {
	      case 'new':
	      case 'checking':
	        return MediaConnectionState_New_getInstance();
	      case 'connecting':
	        return MediaConnectionState_Connecting_getInstance();
	      case 'connected':
	        return MediaConnectionState_Connected_getInstance();
	      case 'disconnected':
	        return MediaConnectionState_Disconnected_getInstance();
	      case 'closed':
	        return MediaConnectionState_Closed_getInstance();
	      case 'failed':
	        return MediaConnectionState_Failed_getInstance();
	      default:
	        return MediaConnectionState_Unknown_getInstance();
	    }
	  }
	  function HttpClientJSAdapter$o$request$lambda($callback) {
	    return function (err, response) {
	      var tmp;
	      if (err == null) {
	        var tmp_0;
	        if (response == null) {
	          tmp_0 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          // Inline function 'vonage.<no name provided>.request.<anonymous>.<anonymous>' call
	          tmp_0 = new HTTPClientResponse(response.statusCode, response.body);
	        }
	        tmp = $callback(null, tmp_0);
	      } else {
	        tmp = $callback(err.coreError, null);
	      }
	      return Unit_instance;
	    };
	  }
	  function HttpClientJSAdapter$1($js) {
	    this.v3z_1 = $js;
	  }
	  protoOf(HttpClientJSAdapter$1).z3h = function (verb, url, headers, body, callback) {
	    var tmp = verb.toString();
	    // Inline function 'kotlin.let' call
	    // Inline function 'kotlin.contracts.contract' call
	    // Inline function 'vonage.<no name provided>.request.<anonymous>' call
	    var tmp_0 = fromMap(JSON, headers);
	    this.v3z_1.request(tmp, url, tmp_0, body, HttpClientJSAdapter$o$request$lambda(callback));
	  };
	  function SocketClientJSAdapter$o$emit$lambda($callback) {
	    return function (err, response) {
	      var tmp;
	      if (err == null) {
	        tmp = null;
	      } else {
	        // Inline function 'kotlin.let' call
	        // Inline function 'kotlin.contracts.contract' call
	        // Inline function 'vonage.<no name provided>.emit.<anonymous>.<anonymous>' call
	        tmp = Exception_init_$Create$(err);
	      }
	      $callback(tmp, response);
	      return Unit_instance;
	    };
	  }
	  function SocketClientJSAdapter$adapter$1($js) {
	    this.x3z_1 = $js;
	    this.w3z_1 = null;
	  }
	  protoOf(SocketClientJSAdapter$adapter$1).d3i = function (_set____db54di) {
	    this.w3z_1 = _set____db54di;
	  };
	  protoOf(SocketClientJSAdapter$adapter$1).e3i = function (type, msg, callback) {
	    var tmp;
	    if (msg == null) {
	      tmp = null;
	    } else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.<no name provided>.emit.<anonymous>' call
	      tmp = fromMap(JSON, msg);
	    }
	    var tmp_0 = tmp;
	    this.x3z_1.emit(type, tmp_0, SocketClientJSAdapter$o$emit$lambda(callback));
	  };
	  protoOf(SocketClientJSAdapter$adapter$1).f3i = function (host, path, reconnectionAttempts, reconnectionDelay, randomizationFactor, token, sessionId, query) {
	    this.x3z_1.connect(host, path, reconnectionAttempts, reconnectionDelay, randomizationFactor, token, sessionId, query);
	  };
	  protoOf(SocketClientJSAdapter$adapter$1).g3i = function () {
	    this.x3z_1.disconnect();
	  };
	  protoOf(SocketClientJSAdapter$adapter$1).h3i = function (sessionId, token) {
	    this.x3z_1.setConnectParamsSocketConfig(sessionId, token);
	  };
	  protoOf(SocketClientJSAdapter$adapter$1).i3i = function (sessionId) {
	    this.x3z_1.setSocketSessionId(sessionId);
	  };
	  protoOf(SocketClientJSAdapter$adapter$1).j3i = function (milliseconds, callback) {
	    this.x3z_1.startVerifyResponseTimer(milliseconds, callback);
	  };
	  function SocketClientJSAdapter$1($adapter) {
	    this.y3z_1 = $adapter;
	  }
	  protoOf(SocketClientJSAdapter$1).didReceiveNewSocketEvent = function (body) {
	    var tmp0_safe_receiver = this.y3z_1.w3z_1;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.k3j(new UnknownSocketEvent(body));
	    }
	  };
	  protoOf(SocketClientJSAdapter$1).didReceiveNewSocketConnectionStatusEvent = function (type, reason, timestamp, retryNumber) {
	    var tmp1_safe_receiver;
	    switch (type) {
	      case 'NXMCORE_SOCKET_CONNECTED':
	        tmp1_safe_receiver = SocketConnectionStatus_Connected_getInstance();
	        break;
	      case 'NXMCORE_SOCKET_RECONNECTING':
	        tmp1_safe_receiver = SocketConnectionStatus_Reconnecting_getInstance();
	        break;
	      case 'NXMCORE_SOCKET_DISCONNECTED':
	        tmp1_safe_receiver = SocketConnectionStatus_Disconnected_getInstance();
	        break;
	      default:
	        tmp1_safe_receiver = null;
	        break;
	    }
	    if (tmp1_safe_receiver == null)
	      null;
	    else {
	      // Inline function 'kotlin.let' call
	      // Inline function 'kotlin.contracts.contract' call
	      // Inline function 'vonage.<no name provided>.didReceiveNewSocketConnectionStatusEvent.<anonymous>' call
	      var it = tmp1_safe_receiver;
	      var tmp;
	      switch (reason) {
	        case 'NXMCORE_REASON_SERVER_DISCONNECTED':
	          var tmp1_safe_receiver_0 = this.y3z_1.w3z_1;
	          var tmp_0;
	          if (tmp1_safe_receiver_0 == null) {
	            tmp_0 = null;
	          } else {
	            tmp1_safe_receiver_0.l3j(it, SocketConnectionFailedReason_ServerDisconnected_getInstance(), timestamp, retryNumber);
	            tmp_0 = Unit_instance;
	          }

	          tmp = tmp_0;
	          break;
	        case 'NXMCORE_REASON_CLIENT_DISCONNECTED':
	          var tmp2_safe_receiver = this.y3z_1.w3z_1;
	          var tmp_1;
	          if (tmp2_safe_receiver == null) {
	            tmp_1 = null;
	          } else {
	            tmp2_safe_receiver.l3j(it, SocketConnectionFailedReason_ClientDisconnected_getInstance(), timestamp, retryNumber);
	            tmp_1 = Unit_instance;
	          }

	          tmp = tmp_1;
	          break;
	        case 'NXMCORE_CLIENT_NETWORK_ERROR':
	          var tmp3_safe_receiver = this.y3z_1.w3z_1;
	          var tmp_2;
	          if (tmp3_safe_receiver == null) {
	            tmp_2 = null;
	          } else {
	            tmp3_safe_receiver.l3j(it, SocketConnectionFailedReason_ClientNetworkError_getInstance(), timestamp, retryNumber);
	            tmp_2 = Unit_instance;
	          }

	          tmp = tmp_2;
	          break;
	        case 'NXMCORE_REASON_PING_TIMEOUT':
	          var tmp4_safe_receiver = this.y3z_1.w3z_1;
	          var tmp_3;
	          if (tmp4_safe_receiver == null) {
	            tmp_3 = null;
	          } else {
	            tmp4_safe_receiver.l3j(it, SocketConnectionFailedReason_PingTimeout_getInstance(), timestamp, retryNumber);
	            tmp_3 = Unit_instance;
	          }

	          tmp = tmp_3;
	          break;
	        default:
	          var tmp5_safe_receiver = this.y3z_1.w3z_1;
	          var tmp_4;
	          if (tmp5_safe_receiver == null) {
	            tmp_4 = null;
	          } else {
	            tmp5_safe_receiver.l3j(it, null, timestamp, retryNumber);
	            tmp_4 = Unit_instance;
	          }

	          tmp = tmp_4;
	          break;
	      }
	    }
	  };
	  function MediaClientJSAdapter$o$processAnswer$lambda($closure) {
	    return function (it) {
	      $closure(it == null ? null : it.o3w());
	      return Unit_instance;
	    };
	  }
	  function MediaClientJSAdapter$o$disableMedia$lambda($closure) {
	    return function (it) {
	      $closure(it == null ? null : it.o3w());
	      return Unit_instance;
	    };
	  }
	  function MediaClientJSAdapter$o$mute$lambda($closure) {
	    return function (it) {
	      $closure(it == null ? null : it.o3w());
	      return Unit_instance;
	    };
	  }
	  function MediaClientJSAdapter$o$unmute$lambda($closure) {
	    return function (it) {
	      $closure(it == null ? null : it.o3w());
	      return Unit_instance;
	    };
	  }
	  function MediaClientJSAdapter$o$enableRtcStatsCollection$lambda($closure) {
	    return function (it) {
	      $closure(it == null ? null : it.o3w());
	      return Unit_instance;
	    };
	  }
	  function MediaClientJSAdapter$adapter$1($js) {
	    this.a40_1 = $js;
	    this.z3z_1 = null;
	  }
	  protoOf(MediaClientJSAdapter$adapter$1).m3i = function (_set____db54di) {
	    this.z3z_1 = _set____db54di;
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).n3i = function () {
	    return this.z3z_1;
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).o3i = function (closure) {
	    this.a40_1.enableMediaOutbound(closure);
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).b40 = function (rtcId, offerSDP, closure) {
	    this.a40_1.enableMediaInbound(rtcId, offerSDP, closure);
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).p3i = function (rtcId, offerSDP, closure) {
	    return this.b40(rtcId, offerSDP, closure);
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).q3i = function (id, sdp, closure) {
	    this.a40_1.processAnswer(id, sdp, MediaClientJSAdapter$o$processAnswer$lambda(closure));
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).r3i = function (id, closure) {
	    this.a40_1.disableMedia(id, MediaClientJSAdapter$o$disableMedia$lambda(closure));
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).s3i = function (id, closure) {
	    this.a40_1.mute(id, MediaClientJSAdapter$o$mute$lambda(closure));
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).t3i = function (id, closure) {
	    this.a40_1.unmute(id, MediaClientJSAdapter$o$unmute$lambda(closure));
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).v3i = function (id, closure) {
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).w3i = function (id, closure) {
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).u3i = function (id, interval, closure) {
	    this.a40_1.enableRtcStatsCollection(id, interval, MediaClientJSAdapter$o$enableRtcStatsCollection$lambda(closure));
	  };
	  protoOf(MediaClientJSAdapter$adapter$1).x3i = function (id) {
	    return coreConnectionState(this.a40_1.getMediaConnectionState(id));
	  };
	  function MediaClientJSAdapter$1($adapter) {
	    this.c40_1 = $adapter;
	  }
	  protoOf(MediaClientJSAdapter$1).onRtcStats = function (id, rtcStats) {
	    var tmp0_safe_receiver = this.c40_1.z3z_1;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.o3j(id, rtcStats.t3z());
	    }
	  };
	  protoOf(MediaClientJSAdapter$1).onConnectionChange = function (id, state) {
	    var tmp0_safe_receiver = this.c40_1.z3z_1;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.p3j(id, coreConnectionState(state));
	    }
	  };
	  protoOf(MediaClientJSAdapter$1).onMediaError = function (id, error) {
	    var tmp0_safe_receiver = this.c40_1.z3z_1;
	    if (tmp0_safe_receiver == null)
	      null;
	    else {
	      tmp0_safe_receiver.q3j(id, error.o3w());
	    }
	  };
	  function invoke(_this__u8e3s4, optionJS) {
	    var tmp;
	    if (optionJS instanceof None) {
	      tmp = none();
	    } else {
	      if (optionJS instanceof Some) {
	        tmp = some(optionJS.value);
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  }
	  function invoke_0(_this__u8e3s4, optionJS) {
	    var tmp;
	    if (optionJS instanceof None) {
	      tmp = none();
	    } else {
	      if (optionJS instanceof Some) {
	        tmp = some(numberToInt(optionJS.value));
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  }
	  function map_16(_this__u8e3s4) {
	    var tmp1_name = _this__u8e3s4.name;
	    var tmp2_displayName = _this__u8e3s4.displayName;
	    var tmp3_imageUrl = _this__u8e3s4.imageUrl;
	    var tmp0_safe_receiver = _this__u8e3s4.ttl;
	    var tmp4_ttl = tmp0_safe_receiver == null ? null : numberToInt(tmp0_safe_receiver);
	    var tmp5_customData = _this__u8e3s4.customData;
	    var tmp6_customSortKey = _this__u8e3s4.customSortKey;
	    return new CreateConversationParameters(tmp1_name, tmp2_displayName, tmp3_imageUrl, tmp4_ttl, tmp6_customSortKey, tmp5_customData);
	  }
	  function map_17(_this__u8e3s4) {
	    var tmp0_name = invoke(Companion_instance, _this__u8e3s4.name);
	    var tmp1_displayName = invoke(Companion_instance, _this__u8e3s4.displayName);
	    var tmp2_imageUrl = invoke(Companion_instance, _this__u8e3s4.imageUrl);
	    var tmp3_ttl = invoke_0(Companion_instance, _this__u8e3s4.ttl);
	    var tmp4_customData = invoke(Companion_instance, _this__u8e3s4.customData);
	    var tmp5_customSortKey = invoke(Companion_instance, _this__u8e3s4.customSortKey);
	    return new UpdateConversationParameters(tmp0_name, tmp1_displayName, tmp2_imageUrl, tmp3_ttl, tmp5_customSortKey, tmp4_customData);
	  }
	  function map_18(_this__u8e3s4) {
	    var tmp0_safe_receiver = _this__u8e3s4.order;
	    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.corePresentingOrder;
	    var tmp1_safe_receiver = _this__u8e3s4.pageSize;
	    var tmp_0 = tmp1_safe_receiver == null ? null : numberToInt(tmp1_safe_receiver);
	    var tmp_1 = _this__u8e3s4.cursor;
	    var tmp_2 = _this__u8e3s4.includeCustomData;
	    var tmp2_safe_receiver = _this__u8e3s4.orderBy;
	    return new GetConversationsParameters(tmp, tmp_0, tmp_1, tmp_2, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.coreOrderBy);
	  }
	  function map_19(_this__u8e3s4) {
	    var tmp0_safe_receiver = _this__u8e3s4.order;
	    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.corePresentingOrder;
	    var tmp1_safe_receiver = _this__u8e3s4.pageSize;
	    var tmp_0 = tmp1_safe_receiver == null ? null : numberToInt(tmp1_safe_receiver);
	    var tmp_1 = _this__u8e3s4.cursor;
	    var tmp2_safe_receiver = _this__u8e3s4.eventFilter;
	    var tmp_2;
	    if (tmp2_safe_receiver == null) {
	      tmp_2 = null;
	    } else {
	      // Inline function 'kotlin.collections.map' call
	      // Inline function 'kotlin.collections.mapTo' call
	      var destination = ArrayList_init_$Create$(tmp2_safe_receiver.length);
	      var inductionVariable = 0;
	      var last = tmp2_safe_receiver.length;
	      while (inductionVariable < last) {
	        var item = tmp2_safe_receiver[inductionVariable];
	        inductionVariable = inductionVariable + 1 | 0;
	        // Inline function 'vonage.map.<anonymous>' call
	        destination.m(item);
	      }
	      tmp_2 = destination;
	    }
	    var tmp_3 = tmp_2;
	    var tmp_4 = _this__u8e3s4.includeDeletedEvents;
	    var tmp3_safe_receiver = _this__u8e3s4.startId;
	    return new GetConversationEventsParameters(tmp, tmp_0, tmp_1, tmp_3, tmp_4, tmp3_safe_receiver == null ? null : numberToInt(tmp3_safe_receiver));
	  }
	  function map_20(_this__u8e3s4) {
	    var tmp0_safe_receiver = _this__u8e3s4.order;
	    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.corePresentingOrder;
	    var tmp1_safe_receiver = _this__u8e3s4.pageSize;
	    return new GetConversationMembersParameters(tmp, tmp1_safe_receiver == null ? null : numberToInt(tmp1_safe_receiver), _this__u8e3s4.cursor);
	  }
	  function map_21(_this__u8e3s4) {
	    var tmp0_safe_receiver = _this__u8e3s4.order;
	    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.corePresentingOrder;
	    var tmp1_safe_receiver = _this__u8e3s4.pageSize;
	    return new GetCallLegsParameters(tmp, tmp1_safe_receiver == null ? null : numberToInt(tmp1_safe_receiver), _this__u8e3s4.cursor);
	  }
	  function entriesOf(jsObject) {
	    // Inline function 'kotlin.collections.map' call
	    var tmp = Object.entries;
	    var this_0 = ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(jsObject);
	    // Inline function 'kotlin.collections.mapTo' call
	    var destination = ArrayList_init_$Create$(this_0.length);
	    var inductionVariable = 0;
	    var last = this_0.length;
	    while (inductionVariable < last) {
	      var item = this_0[inductionVariable];
	      inductionVariable = inductionVariable + 1 | 0;
	      // Inline function 'vonage.utils.entriesOf.<anonymous>' call
	      var tmp_0 = item[0];
	      var tmp$ret$0 = to((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE(), item[1]);
	      destination.m(tmp$ret$0);
	    }
	    return destination;
	  }
	  function toMap_0(_this__u8e3s4) {
	    return toMap(entriesOf(_this__u8e3s4));
	  }
	  function fromMap(_this__u8e3s4, m) {
	    // Inline function 'kotlin.collections.toTypedArray' call
	    // Inline function 'kotlin.collections.map' call
	    // Inline function 'kotlin.apply' call
	    // Inline function 'kotlin.collections.mutableMapOf' call
	    var this_0 = LinkedHashMap_init_$Create$_0();
	    // Inline function 'kotlin.contracts.contract' call
	    // Inline function 'vonage.utils.fromMap.<anonymous>' call
	    // Inline function 'kotlin.collections.forEach' call
	    // Inline function 'kotlin.collections.iterator' call
	    var tmp0_iterator = m.u1().p();
	    while (tmp0_iterator.q()) {
	      var element = tmp0_iterator.s();
	      // Inline function 'vonage.utils.fromMap.<anonymous>.<anonymous>' call
	      // Inline function 'kotlin.collections.component1' call
	      var k = element.v1();
	      // Inline function 'kotlin.collections.component2' call
	      var v = element.w1();
	      if (!(k == null) ? typeof k === 'string' : false) {
	        // Inline function 'kotlin.collections.set' call
	        this_0.s1(k, v);
	      }
	    }
	    // Inline function 'kotlin.collections.mapTo' call
	    var destination = ArrayList_init_$Create$(this_0.u());
	    // Inline function 'kotlin.collections.iterator' call
	    var tmp0_iterator_0 = this_0.u1().p();
	    while (tmp0_iterator_0.q()) {
	      var item = tmp0_iterator_0.s();
	      // Inline function 'vonage.utils.fromMap.<anonymous>' call
	      var tmp = item.v1();
	      var tmp0_subject = item.w1();
	      var tmp_0;
	      var tmp_1;
	      var tmp_2;
	      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
	        tmp_2 = true;
	      } else {
	        tmp_2 = !(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false;
	      }
	      if (tmp_2) {
	        tmp_1 = true;
	      } else {
	        tmp_1 = !(tmp0_subject == null) ? typeof tmp0_subject === 'number' : false;
	      }
	      if (tmp_1) {
	        tmp_0 = item.w1();
	      } else {
	        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map) : false) {
	          var tmp_3;
	          try {
	            var tmp_4 = JSON;
	            var tmp_5 = item.w1();
	            tmp_3 = fromMap(tmp_4, (!(tmp_5 == null) ? isInterface(tmp_5, Map) : false) ? tmp_5 : THROW_CCE());
	          } catch ($p) {
	            var tmp_6;
	            if ($p instanceof Exception) {
	              var error = $p;
	              tmp_6 = null;
	            } else {
	              throw $p;
	            }
	            tmp_3 = tmp_6;
	          }
	          tmp_0 = tmp_3;
	        } else {
	          tmp_0 = null;
	        }
	      }
	      var tmp$ret$6 = new Pair(tmp, tmp_0);
	      destination.m(tmp$ret$6);
	    }
	    var tmp$ret$9 = copyToArray(destination);
	    return json(tmp$ret$9.slice());
	  }
	  function parseCustomJson(value) {
	    var tmp = JSON.parse;
	    return ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(value);
	  }
	  function toJsObject(_this__u8e3s4) {
	    var jsObject = {};
	    // Inline function 'kotlin.collections.forEach' call
	    // Inline function 'kotlin.collections.iterator' call
	    var tmp0_iterator = _this__u8e3s4.u1().p();
	    while (tmp0_iterator.q()) {
	      var element = tmp0_iterator.s();
	      // Inline function 'vonage.utils.toJsObject.<anonymous>' call
	      // Inline function 'kotlin.collections.component1' call
	      var key = element.v1();
	      // Inline function 'kotlin.collections.component2' call
	      var value = element.w1();
	      jsObject[key] = value;
	    }
	    return jsObject;
	  }
	  function None() {
	    OptionJS.call(this);
	  }
	  function Some(value) {
	    OptionJS.call(this);
	    this.value = value;
	  }
	  protoOf(Some).w1 = function () {
	    return this.value;
	  };
	  protoOf(Some).o5 = function () {
	    return this.value;
	  };
	  protoOf(Some).d40 = function (value) {
	    return new Some(value);
	  };
	  protoOf(Some).copy = function (value, $super) {
	    value = value === VOID ? this.value : value;
	    return this.d40(value);
	  };
	  protoOf(Some).toString = function () {
	    return 'Some(value=' + this.value + ')';
	  };
	  protoOf(Some).hashCode = function () {
	    return this.value == null ? 0 : hashCode(this.value);
	  };
	  protoOf(Some).equals = function (other) {
	    if (this === other)
	      return true;
	    if (!(other instanceof Some))
	      return false;
	    var tmp0_other_with_cast = other instanceof Some ? other : THROW_CCE();
	    if (!equals(this.value, tmp0_other_with_cast.value))
	      return false;
	    return true;
	  };
	  function Companion_0() {
	  }
	  protoOf(Companion_0).of = function (value) {
	    return value == null ? new None() : new Some(value);
	  };
	  var Companion_instance_1;
	  function Companion_getInstance_2() {
	    return Companion_instance_1;
	  }
	  function OptionJS() {
	  }
	  protoOf(OptionJS).orNull = function () {
	    var tmp;
	    if (this instanceof None) {
	      tmp = null;
	    } else {
	      if (this instanceof Some) {
	        tmp = this.value;
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  };
	  protoOf(OptionJS).contains = function (value) {
	    var tmp;
	    if (this instanceof None) {
	      tmp = false;
	    } else {
	      if (this instanceof Some) {
	        tmp = equals(this.value, value);
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  };
	  protoOf(OptionJS).map = function (f) {
	    var tmp;
	    if (this instanceof None) {
	      tmp = new None();
	    } else {
	      if (this instanceof Some) {
	        tmp = new Some(f(this.value));
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  };
	  protoOf(OptionJS).mapOr = function (default_0, f) {
	    var tmp;
	    if (this instanceof None) {
	      tmp = default_0;
	    } else {
	      if (this instanceof Some) {
	        tmp = f(this.value);
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  };
	  protoOf(OptionJS).mapOrElse = function (default_0, f) {
	    var tmp;
	    if (this instanceof None) {
	      tmp = default_0();
	    } else {
	      if (this instanceof Some) {
	        tmp = f(this.value);
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  };
	  protoOf(OptionJS).mapNotNull = function (f) {
	    var tmp;
	    if (this instanceof None) {
	      tmp = new None();
	    } else {
	      if (this instanceof Some) {
	        var tmp1_safe_receiver = this.value;
	        var tmp_0;
	        if (tmp1_safe_receiver == null) {
	          tmp_0 = null;
	        } else {
	          // Inline function 'kotlin.let' call
	          // Inline function 'kotlin.contracts.contract' call
	          // Inline function 'vonage.utils.OptionJS.mapNotNull.<anonymous>' call
	          tmp_0 = new Some(f(tmp1_safe_receiver));
	        }
	        var tmp2_elvis_lhs = tmp_0;
	        tmp = tmp2_elvis_lhs == null ? some_0(null) : tmp2_elvis_lhs;
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  };
	  protoOf(OptionJS).unwrapOr = function (default_0) {
	    var tmp;
	    if (this instanceof None) {
	      tmp = default_0;
	    } else {
	      if (this instanceof Some) {
	        tmp = this.value;
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  };
	  protoOf(OptionJS).equals = function (other) {
	    var tmp;
	    if (other instanceof None) {
	      tmp = this instanceof None;
	    } else {
	      if (other instanceof Some) {
	        var tmp_0;
	        if (this instanceof Some) {
	          tmp_0 = equals(this.value, other.value);
	        } else {
	          tmp_0 = false;
	        }
	        tmp = tmp_0;
	      } else {
	        tmp = false;
	      }
	    }
	    return tmp;
	  };
	  protoOf(OptionJS).hashCode = function () {
	    var tmp;
	    if (this instanceof None) {
	      tmp = 0;
	    } else {
	      if (this instanceof Some) {
	        // Inline function 'kotlin.hashCode' call
	        var tmp0_safe_receiver = this.value;
	        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
	        tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
	      } else {
	        noWhenBranchMatchedException();
	      }
	    }
	    return tmp;
	  };
	  function some_0(value) {
	    return new Some(value);
	  }
	  //region block: post-declaration
	  protoOf(CombinedClientJS).createConversation = createConversation;
	  protoOf(CombinedClientJS).joinConversation = joinConversation;
	  protoOf(CombinedClientJS).inviteToConversation = inviteToConversation;
	  protoOf(CombinedClientJS).leaveConversation = leaveConversation;
	  protoOf(CombinedClientJS).deleteConversation = deleteConversation;
	  protoOf(CombinedClientJS).getConversations = getConversations;
	  protoOf(CombinedClientJS).getConversationMembers = getConversationMembers;
	  protoOf(CombinedClientJS).getConversationEvents = getConversationEvents;
	  protoOf(CombinedClientJS).getConversationMember = getConversationMember;
	  protoOf(CombinedClientJS).sendMessageTextEvent = sendMessageTextEvent;
	  protoOf(CombinedClientJS).sendMessageCustomEvent = sendMessageCustomEvent;
	  protoOf(CombinedClientJS).sendMessageImageEvent = sendMessageImageEvent;
	  protoOf(CombinedClientJS).sendMessageVideoEvent = sendMessageVideoEvent;
	  protoOf(CombinedClientJS).sendMessageFileEvent = sendMessageFileEvent;
	  protoOf(CombinedClientJS).sendMessageAudioEvent = sendMessageAudioEvent;
	  protoOf(CombinedClientJS).sendMessageVCardEvent = sendMessageVCardEvent;
	  protoOf(CombinedClientJS).sendMessageLocationEvent = sendMessageLocationEvent;
	  protoOf(CombinedClientJS).sendMessageTemplateEvent = sendMessageTemplateEvent;
	  protoOf(CombinedClientJS).sendEphemeralEvent = sendEphemeralEvent;
	  protoOf(CombinedClientJS).sendCustomEvent = sendCustomEvent;
	  protoOf(CombinedClientJS).deleteEvent = deleteEvent;
	  protoOf(CombinedClientJS).sendMessageSeenEvent = sendMessageSeenEvent;
	  protoOf(CombinedClientJS).updateConversation = updateConversation;
	  protoOf(CombinedClientJS).setConfig = setConfig;
	  protoOf(CombinedClientJS).createSession = createSession;
	  protoOf(CombinedClientJS).deleteSession = deleteSession;
	  protoOf(CombinedClientJS).refreshSession = refreshSession;
	  protoOf(CombinedClientJS).getConversation = getConversation;
	  protoOf(CombinedClientJS).getUser = getUser;
	  protoOf(CombinedClientJS).getPeerConnection = getPeerConnection;
	  protoOf(CombinedClientJS).getAudioOutputElement = getAudioOutputElement;
	  protoOf(CombinedClientJS).serverCall = serverCall;
	  protoOf(CombinedClientJS).reconnectCall = reconnectCall;
	  protoOf(CombinedClientJS).getLeg = getLeg;
	  protoOf(CombinedClientJS).getCallLegs = getCallLegs;
	  protoOf(CombinedClientJS).answer = answer;
	  protoOf(CombinedClientJS).reject = reject;
	  protoOf(CombinedClientJS).hangup = hangup;
	  protoOf(CombinedClientJS).say = say;
	  protoOf(CombinedClientJS).mute = mute;
	  protoOf(CombinedClientJS).unmute = unmute;
	  protoOf(CombinedClientJS).enableEarmuff = enableEarmuff;
	  protoOf(CombinedClientJS).disableEarmuff = disableEarmuff;
	  protoOf(CombinedClientJS).sendDTMF = sendDTMF;
	  defineProp(protoOf(CombinedClientJS), 'media', function () {
	    return this.r3r();
	  });
	  defineProp(protoOf(CombinedClientJS), 'core', function () {
	    return this.s3r();
	  });
	  defineProp(protoOf(EventStateTypeJS), 'name', protoOf(EventStateTypeJS).j9);
	  defineProp(protoOf(EventStateTypeJS), 'ordinal', protoOf(EventStateTypeJS).k9);
	  defineProp(protoOf(PresentingOrderJS), 'name', protoOf(PresentingOrderJS).j9);
	  defineProp(protoOf(PresentingOrderJS), 'ordinal', protoOf(PresentingOrderJS).k9);
	  defineProp(protoOf(OrderByJS), 'name', protoOf(OrderByJS).j9);
	  defineProp(protoOf(OrderByJS), 'ordinal', protoOf(OrderByJS).k9);
	  defineProp(protoOf(VonageErrorTypeJS), 'name', protoOf(VonageErrorTypeJS).j9);
	  defineProp(protoOf(VonageErrorTypeJS), 'ordinal', protoOf(VonageErrorTypeJS).k9);
	  defineProp(protoOf(CoreClientConfigRegionJS), 'name', protoOf(CoreClientConfigRegionJS).j9);
	  defineProp(protoOf(CoreClientConfigRegionJS), 'ordinal', protoOf(CoreClientConfigRegionJS).k9);
	  defineProp(protoOf(CoreClientConfigJS), 'apiUrl', function () {
	    return this.e3x();
	  }, function (value) {
	    this.d3x(value);
	  });
	  defineProp(protoOf(CoreClientConfigJS), 'websocketUrl', function () {
	    return this.g3x();
	  }, function (value) {
	    this.f3x(value);
	  });
	  defineProp(protoOf(CoreClientConfigJS), 'websocketPath', function () {
	    return this.i3x();
	  }, function (value) {
	    this.h3x(value);
	  });
	  defineProp(protoOf(CoreClientConfigJS), 'rtcStatsTelemetry', function () {
	    return this.k3x();
	  }, function (value) {
	    this.j3x(value);
	  });
	  defineProp(protoOf(CoreClientConfigJS), 'autoReconnectMedia', function () {
	    return this.m3x();
	  }, function (value) {
	    this.l3x(value);
	  });
	  defineProp(protoOf(CoreClientConfigJS), 'noiseSuppression', function () {
	    return this.n3x();
	  });
	  defineProp(protoOf(Topics), 'name', protoOf(Topics).j9);
	  defineProp(protoOf(Topics), 'ordinal', protoOf(Topics).k9);
	  defineProp(protoOf(LoggingLevelJS), 'name', protoOf(LoggingLevelJS).j9);
	  defineProp(protoOf(LoggingLevelJS), 'ordinal', protoOf(LoggingLevelJS).k9);
	  defineProp(protoOf(SessionErrorReasonJS), 'name', protoOf(SessionErrorReasonJS).j9);
	  defineProp(protoOf(SessionErrorReasonJS), 'ordinal', protoOf(SessionErrorReasonJS).k9);
	  defineProp(protoOf(createVonageLoggerJS$1), 'name', function () {
	    return this.j9();
	  });
	  defineProp(protoOf(createVonageLoggerJS$1), 'minLogLevel', function () {
	    return this.i3g();
	  });
	  defineProp(protoOf(createVonageLoggerJS$1), 'topics', function () {
	    return this.a3g();
	  });
	  defineProp(protoOf(HttpClientErrorJS), 'message', function () {
	    return this.ab();
	  });
	  defineProp(protoOf(HttpClientErrorJS), 'cause', function () {
	    return this.bb();
	  });
	  defineProp(protoOf(HttpClientErrorJS), 'coreError', protoOf(HttpClientErrorJS).o3w);
	  protoOf(HttpClientJSAdapter$1).a3i = clear;
	  //endregion
	  //region block: init
	  VoiceChannelTypeObject_instance = new VoiceChannelTypeObject();
	  SystemJS_instance = new SystemJS();
	  ConversationStateJS_instance = new ConversationStateJS();
	  MemberStateJSObj_instance = new MemberStateJSObj();
	  ChannelTypeObj_instance = new ChannelTypeObj();
	  CSErrorCodesJS_instance = new CSErrorCodesJS();
	  SessionErrorCodesJS_instance = new SessionErrorCodesJS();
	  LegStatusJSObject_instance = new LegStatusJSObject();
	  CallDisconnectReasonJSObject_instance = new CallDisconnectReasonJSObject();
	  HangupReasonJSObject_instance = new HangupReasonJSObject();
	  SOCKET_CONNECTED = 'NXMCORE_SOCKET_CONNECTED';
	  SOCKET_RECONNECTING = 'NXMCORE_SOCKET_RECONNECTING';
	  SOCKET_DISCONNECTED = 'NXMCORE_SOCKET_DISCONNECTED';
	  REASON_SERVER_DISCONNECTED = 'NXMCORE_REASON_SERVER_DISCONNECTED';
	  REASON_CLIENT_DISCONNECTED = 'NXMCORE_REASON_CLIENT_DISCONNECTED';
	  REASON_CLIENT_NETWORK_ERROR = 'NXMCORE_CLIENT_NETWORK_ERROR';
	  REASON_PING_TIMEOUT = 'NXMCORE_REASON_PING_TIMEOUT';
	  CancelReasonJSObject_instance = new CancelReasonJSObject();
	  Companion_instance_0 = new Companion();
	  Companion_instance_1 = new Companion_0();
	  //endregion
	  //region block: exports
	  function $jsExportAll$(_) {
	    var $vonage = _.vonage || (_.vonage = {});
	    defineProp($vonage, 'VoiceChannelTypeObject', VoiceChannelTypeObject_getInstance);
	    $vonage.CombinedClientJS = CombinedClientJS;
	    var $vonage = _.vonage || (_.vonage = {});
	    $vonage.EventStateTypeJS = EventStateTypeJS;
	    $vonage.EventStateTypeJS.values = values;
	    $vonage.EventStateTypeJS.valueOf = valueOf_0;
	    defineProp($vonage.EventStateTypeJS, 'SEEN', EventStateTypeJS_SEEN_getInstance);
	    defineProp($vonage.EventStateTypeJS, 'DELIVERED', EventStateTypeJS_DELIVERED_getInstance);
	    defineProp($vonage.EventStateTypeJS, 'SUBMITTED', EventStateTypeJS_SUBMITTED_getInstance);
	    defineProp($vonage.EventStateTypeJS, 'REJECTED', EventStateTypeJS_REJECTED_getInstance);
	    defineProp($vonage.EventStateTypeJS, 'UNDELIVERABLE', EventStateTypeJS_UNDELIVERABLE_getInstance);
	    defineProp($vonage.EventStateTypeJS, 'NONE', EventStateTypeJS_NONE_getInstance);
	    $vonage.EventStateJS = EventStateJS;
	    $vonage.EventsPageJS = EventsPageJS;
	    $vonage.EmbeddedInfoJS = EmbeddedInfoJS;
	    defineProp($vonage, 'SystemJS', SystemJS_getInstance);
	    $vonage.MemberEventBodyJS = MemberEventBodyJS;
	    $vonage.MemberInvitedEventJS = MemberInvitedEventJS;
	    $vonage.MemberJoinedEventJS = MemberJoinedEventJS;
	    $vonage.MemberLeftEventJS = MemberLeftEventJS;
	    $vonage.CustomConversationEventJS = CustomConversationEventJS;
	    $vonage.EphemeralConversationEventJS = EphemeralConversationEventJS;
	    $vonage.EventStateBodyJS = EventStateBodyJS;
	    $vonage.EventDeleteConversationEventJS = EventDeleteConversationEventJS;
	    $vonage.MessageDeliveredEventJS = MessageDeliveredEventJS;
	    $vonage.MessageRejectedEventJS = MessageRejectedEventJS;
	    $vonage.MessageUndeliverableEventJS = MessageUndeliverableEventJS;
	    $vonage.MessageSubmittedEventJS = MessageSubmittedEventJS;
	    $vonage.MessageSeenEventJS = MessageSeenEventJS;
	    var $vonage = _.vonage || (_.vonage = {});
	    $vonage.MessageTextEventJS = MessageTextEventJS;
	    $vonage.MessageTextEventJS.MessageTextEventBody = MessageTextEventBody;
	    $vonage.MessageCustomEventJS = MessageCustomEventJS;
	    $vonage.MessageCustomEventJS.MessageCustomEventBody = MessageCustomEventBody;
	    $vonage.MessageAudioEventJS = MessageAudioEventJS;
	    $vonage.MessageAudioEventJS.MessageAudioEventBody = MessageAudioEventBody;
	    $vonage.MessageVideoEventJS = MessageVideoEventJS;
	    $vonage.MessageVideoEventJS.MessageVideoEventBody = MessageVideoEventBody;
	    $vonage.MessageImageEventJS = MessageImageEventJS;
	    $vonage.MessageImageEventJS.MessageImageEventBody = MessageImageEventBody;
	    $vonage.MessageFileEventJS = MessageFileEventJS;
	    $vonage.MessageFileEventJS.MessageFileEventBody = MessageFileEventBody;
	    $vonage.MessageVCardEventJS = MessageVCardEventJS;
	    $vonage.MessageVCardEventJS.MessageVCardEventBody = MessageVCardEventBody;
	    $vonage.MessageLocationEventJS = MessageLocationEventJS;
	    $vonage.MessageLocationEventJS.MessageLocationEventBody = MessageLocationEventBody;
	    $vonage.MessageLocationEventJS.Location = Location_0;
	    $vonage.MessageTemplateEventJS = MessageTemplateEventJS;
	    $vonage.MessageTemplateEventJS.MessageTemplateEventBody = MessageTemplateEventBody;
	    $vonage.MessageTemplateEventJS.TemplateObject = TemplateObject_0;
	    $vonage.MessageTemplateEventJS.WhatsappObject = WhatsappObject_0;
	    var $vonage = _.vonage || (_.vonage = {});
	    $vonage.PresentingOrderJS = PresentingOrderJS;
	    $vonage.PresentingOrderJS.values = values_0;
	    $vonage.PresentingOrderJS.valueOf = valueOf_1;
	    defineProp($vonage.PresentingOrderJS, 'ASC', PresentingOrderJS_ASC_getInstance);
	    defineProp($vonage.PresentingOrderJS, 'DESC', PresentingOrderJS_DESC_getInstance);
	    $vonage.OrderByJS = OrderByJS;
	    $vonage.OrderByJS.values = values_1;
	    $vonage.OrderByJS.valueOf = valueOf_2;
	    defineProp($vonage.OrderByJS, 'CREATED', OrderByJS_CREATED_getInstance);
	    defineProp($vonage.OrderByJS, 'CUSTOM_SORT_KEY', OrderByJS_CUSTOM_SORT_KEY_getInstance);
	    $vonage.ConversationJS = ConversationJS;
	    $vonage.ConversationJS.Properties = Properties;
	    defineProp($vonage, 'ConversationStateJS', ConversationStateJS_getInstance);
	    $vonage.ConversationTimestampJS = ConversationTimestampJS;
	    $vonage.ConversationsPageJS = ConversationsPageJS;
	    $vonage.MemberJS = MemberJS;
	    defineProp($vonage, 'MemberStateJSObj', MemberStateJSObj_getInstance);
	    $vonage.MemberTimestampJS = MemberTimestampJS;
	    $vonage.MembersPageJS = MembersPageJS;
	    $vonage.UserJS = UserJS;
	    $vonage.UserTimestampJS = UserTimestampJS;
	    $vonage.UserChannelsJS = UserChannelsJS;
	    $vonage.MemberChannelJS = MemberChannelJS;
	    $vonage.ChannelJS = ChannelJS;
	    $vonage.LegChannelJS = LegChannelJS;
	    $vonage.MediaStateJS = MediaStateJS;
	    $vonage.LegJS = LegJS;
	    $vonage.LegsPageJS = LegsPageJS;
	    defineProp($vonage, 'ChannelTypeObj', ChannelTypeObj_getInstance);
	    var $vonage = _.vonage || (_.vonage = {});
	    defineProp($vonage, 'CSErrorCodesJS', CSErrorCodesJS_getInstance);
	    defineProp($vonage, 'SessionErrorCodesJS', SessionErrorCodesJS_getInstance);
	    var $vonage = _.vonage || (_.vonage = {});
	    $vonage.VonageErrorJS = VonageErrorJS;
	    $vonage.VonageErrorTypeJS = VonageErrorTypeJS;
	    $vonage.VonageErrorTypeJS.values = values_2;
	    $vonage.VonageErrorTypeJS.valueOf = valueOf_3;
	    defineProp($vonage.VonageErrorTypeJS, 'CS_ERROR', VonageErrorTypeJS_CS_ERROR_getInstance);
	    defineProp($vonage.VonageErrorTypeJS, 'NETWORK_ERROR', VonageErrorTypeJS_NETWORK_ERROR_getInstance);
	    defineProp($vonage.VonageErrorTypeJS, 'SESSION_ERROR', VonageErrorTypeJS_SESSION_ERROR_getInstance);
	    defineProp($vonage.VonageErrorTypeJS, 'INTERNAL_ERROR', VonageErrorTypeJS_INTERNAL_ERROR_getInstance);
	    defineProp($vonage.VonageErrorTypeJS, 'UNKNOWN_ERROR', VonageErrorTypeJS_UNKNOWN_ERROR_getInstance);
	    $vonage.MediaClientErrorJS = MediaClientErrorJS;
	    $vonage.PeerConnectionNotFoundJS = PeerConnectionNotFoundJS;
	    $vonage.TrackNotFoundJS = TrackNotFoundJS;
	    $vonage.ProcessAnswerErrorJS = ProcessAnswerErrorJS;
	    $vonage.CreateAnswerErrorJS = CreateAnswerErrorJS;
	    $vonage.CreateOfferErrorJS = CreateOfferErrorJS;
	    var $vonage = _.vonage || (_.vonage = {});
	    var $vonage = _.vonage || (_.vonage = {});
	    defineProp($vonage, 'DEFAULT_REGION', get_DEFAULT_REGION);
	    $vonage.CoreClientConfigRegionJS = CoreClientConfigRegionJS;
	    $vonage.CoreClientConfigRegionJS.values = values_3;
	    $vonage.CoreClientConfigRegionJS.valueOf = valueOf_4;
	    defineProp($vonage.CoreClientConfigRegionJS, 'AP', CoreClientConfigRegionJS_AP_getInstance);
	    defineProp($vonage.CoreClientConfigRegionJS, 'EU', CoreClientConfigRegionJS_EU_getInstance);
	    defineProp($vonage.CoreClientConfigRegionJS, 'US', CoreClientConfigRegionJS_US_getInstance);
	    $vonage.CoreClientConfigJS = CoreClientConfigJS;
	    $vonage.TopicJS = TopicJS;
	    $vonage.Topics = Topics;
	    $vonage.Topics.values = values_4;
	    $vonage.Topics.valueOf = valueOf_5;
	    defineProp($vonage.Topics, 'HTTP', Topics_HTTP_getInstance);
	    defineProp($vonage.Topics, 'WS', Topics_WS_getInstance);
	    defineProp($vonage.Topics, 'MEDIA', Topics_MEDIA_getInstance);
	    defineProp($vonage.Topics, 'API', Topics_API_getInstance);
	    defineProp($vonage.Topics, 'STORE', Topics_STORE_getInstance);
	    defineProp($vonage.Topics, 'REDUCER', Topics_REDUCER_getInstance);
	    defineProp($vonage.Topics, 'DEFAULT', Topics_DEFAULT_getInstance);
	    $vonage.createVonageLoggerJS = createVonageLoggerJS;
	    $vonage.LoggingLevelJS = LoggingLevelJS;
	    $vonage.LoggingLevelJS.values = values_5;
	    $vonage.LoggingLevelJS.valueOf = valueOf_6;
	    defineProp($vonage.LoggingLevelJS, 'Verbose', LoggingLevelJS_Verbose_getInstance);
	    defineProp($vonage.LoggingLevelJS, 'Debug', LoggingLevelJS_Debug_getInstance);
	    defineProp($vonage.LoggingLevelJS, 'Info', LoggingLevelJS_Info_getInstance);
	    defineProp($vonage.LoggingLevelJS, 'Warn', LoggingLevelJS_Warn_getInstance);
	    defineProp($vonage.LoggingLevelJS, 'Error', LoggingLevelJS_Error_getInstance);
	    defineProp($vonage.LoggingLevelJS, 'Assert', LoggingLevelJS_Assert_getInstance);
	    defineProp($vonage, 'DEFAULT_LOGGING_LEVEL', get_DEFAULT_LOGGING_LEVEL);
	    $vonage.setDefaultLoggingLevel = setDefaultLoggingLevel;
	    $vonage.SessionErrorReasonJS = SessionErrorReasonJS;
	    $vonage.SessionErrorReasonJS.values = values_6;
	    $vonage.SessionErrorReasonJS.valueOf = valueOf_7;
	    defineProp($vonage.SessionErrorReasonJS, 'EXPIRED_TOKEN', SessionErrorReasonJS_EXPIRED_TOKEN_getInstance);
	    defineProp($vonage.SessionErrorReasonJS, 'TRANSPORT_CLOSED', SessionErrorReasonJS_TRANSPORT_CLOSED_getInstance);
	    defineProp($vonage.SessionErrorReasonJS, 'PING_TIMEOUT', SessionErrorReasonJS_PING_TIMEOUT_getInstance);
	    var $vonage = _.vonage || (_.vonage = {});
	    defineProp($vonage, 'LegStatusJSObject', LegStatusJSObject_getInstance);
	    defineProp($vonage, 'CallDisconnectReasonJSObject', CallDisconnectReasonJSObject_getInstance);
	    defineProp($vonage, 'HangupReasonJSObject', HangupReasonJSObject_getInstance);
	    $vonage.VoiceInviteFromInfoJS = VoiceInviteFromInfoJS;
	    var $vonage = _.vonage || (_.vonage = {});
	    $vonage.HttpClientErrorJS = HttpClientErrorJS;
	    $vonage.HttpClientResponseJS = HttpClientResponseJS;
	    defineProp($vonage, 'SOCKET_CONNECTED', get_SOCKET_CONNECTED);
	    defineProp($vonage, 'SOCKET_RECONNECTING', get_SOCKET_RECONNECTING);
	    defineProp($vonage, 'SOCKET_DISCONNECTED', get_SOCKET_DISCONNECTED);
	    defineProp($vonage, 'REASON_SERVER_DISCONNECTED', get_REASON_SERVER_DISCONNECTED);
	    defineProp($vonage, 'REASON_CLIENT_DISCONNECTED', get_REASON_CLIENT_DISCONNECTED);
	    defineProp($vonage, 'REASON_CLIENT_NETWORK_ERROR', get_REASON_CLIENT_NETWORK_ERROR);
	    defineProp($vonage, 'REASON_PING_TIMEOUT', get_REASON_PING_TIMEOUT);
	    defineProp($vonage, 'CancelReasonJSObject', CancelReasonJSObject_getInstance);
	    $vonage.RTCQualityJS = RTCQualityJS;
	    $vonage.RTCStatsJS = RTCStatsJS;
	    defineProp($vonage.RTCStatsJS, 'Companion', Companion_getInstance_1);
	    var $vonage = _.vonage || (_.vonage = {});
	    var $vonage = _.vonage || (_.vonage = {});
	    var $vonage$utils = $vonage.utils || ($vonage.utils = {});
	    $vonage$utils.OptionJS = OptionJS;
	    $vonage$utils.OptionJS.None = None;
	    $vonage$utils.OptionJS.Some = Some;
	    defineProp($vonage$utils.OptionJS, 'Companion', Companion_getInstance_2);
	  }
	  $jsExportAll$(_);
	  //endregion
	  return _;
	}));

	
} (clientsdkClientcore_js$1, clientsdkClientcore_jsExports));

var clientsdkClientcore_js = clientsdkClientcore_jsExports;

class HttpClient {
    request(verb, url, headers, body, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: verb.toUpperCase(),
                headers: Object.entries(headers).reduce((acc, [key, value]) => {
                    acc.append(key, value.toString());
                    return acc;
                }, new Headers()),
                body: body == '' || body == null ? undefined : body
            };
            try {
                const response = yield fetch(url, options);
                const coreResponse = new clientsdkClientcore_jsExports.vonage.HttpClientResponseJS(response.status, yield response.text());
                // no need to check for status ok, as we pipe all responses through to core
                callback(null, coreResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    const httpClientError = new clientsdkClientcore_jsExports.vonage.HttpClientErrorJS(error.message, error);
                    callback(httpClientError, null);
                    return;
                }
                const httpClientError = new clientsdkClientcore_jsExports.vonage.HttpClientErrorJS('Unknown Error', null);
                callback(httpClientError, null);
            }
        });
    }
}

const waitFirstICEGatheringComplete = (peerConnection) => __awaiter(void 0, void 0, void 0, function* () {
    let offer_sent = false;
    return new Promise((resolve) => {
        peerConnection.onicecandidate = (event) => {
            if (event.candidate && !offer_sent) {
                offer_sent = true;
                resolve();
            }
        };
    });
});
function createDummyCandidateSDP(pc) {
    const candidates = [
        {
            foundation: '1176891032',
            component: 1,
            transport: 'udp',
            priority: 2122260223,
            ip: '0.0.0.0',
            port: 9,
            type: 'host',
            generation: 0,
            'network-id': 1,
            'network-cost': 50
        }
    ];
    if (pc instanceof RTCPeerConnection &&
        pc.localDescription instanceof RTCSessionDescription) {
        const sdpNewObj = sdptransform.parse(pc.localDescription.sdp);
        sdpNewObj.media[0].candidates = candidates;
        return sdptransform.write(sdpNewObj);
    }
    else {
        throw Error('(PC || localDescription) == Undefined');
    }
}
// [RTCPeerConnection, RTCSessionDescription['sdp']]
const createRtcAudioConnection = () => __awaiter(void 0, void 0, void 0, function* () {
    const localStream = yield navigator.mediaDevices.getUserMedia({
        video: false,
        audio: true
    });
    const peerConnection = new RTCPeerConnection({
        // iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
        iceTransportPolicy: 'all',
        bundlePolicy: 'balanced',
        rtcpMuxPolicy: 'require',
        iceCandidatePoolSize: 0
    });
    localStream.getTracks().forEach((track) => {
        peerConnection.addTrack(track, localStream);
    });
    return peerConnection;
});
const createOffer = (peerConnection) => __awaiter(void 0, void 0, void 0, function* () {
    const offer = yield peerConnection.createOffer();
    peerConnection.setLocalDescription(offer);
    yield waitFirstICEGatheringComplete(peerConnection);
    return createDummyCandidateSDP(peerConnection);
});
const createAnswer = (peerConnection, sdp) => __awaiter(void 0, void 0, void 0, function* () {
    yield peerConnection.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp }));
    const sessionDescription = yield peerConnection.createAnswer();
    peerConnection.setLocalDescription(sessionDescription);
    yield waitFirstICEGatheringComplete(peerConnection);
    return createDummyCandidateSDP(peerConnection);
});

function iterateReports$2(stats, fn) {
  if (typeof stats[Symbol.iterator] === "function") {
    for (const el of stats) {
      const report = Array.isArray(el) ? el[1] : el;
      fn(report);
    }
  } else {
    for (const key in stats) {
      if (stats.hasOwnProperty(key)) {
        const report = stats[key];
        fn(report);
      }
    }
  }
}

var utils = {
    iterateReports: iterateReports$2
};

/**
 * Rules to map different types of reports combined by report name
 * On the left - name of the field in a report
 * On the rirgh - new name
 */

const rules = {
  "outbound-rtp": {
    packetsSent: "audioSentPackets",
    bytesSent: "audioSentBytes",
  },
  "inbound-rtp": {
    packetsReceived: "audioRecvPackets",
    packetsLost: "audioRecvPacketsLost",
    bytesReceived: "audioRecvBytes",
    jitter: "audioRecvJitter"
  },
  "remote-inbound-rtp": {
    packetsLost: "audioSentPacketsLost",
    roundTripTime: "audioRtt",
    jitter: "audioSentJitter"
  },
};

// Additional logic to parse values can be done here
const parsers$1 = {
  "remote-candidate": function (report) {
    return mapKeys(report);
  },
  "inbound-rtp": function (report) {
    return mapKeys(report);
  },
  "outbound-rtp": function (report) {
    return mapKeys(report);
  },
  "remote-inbound-rtp": function (report) {
    return mapKeys(report);
  },
};

const mapKeys = (report) => {
  const { type } = report;
  const mapping = rules[type];
  const result = {};

  for (let field in mapping) {
    if (field in report) {
      let mappedName;

      if (typeof mapping[field] === "function") {
        mappedName = mapping[field](report);
      } else {
        mappedName = mapping[field];
      }
      result[mappedName] = report[field];
    } else {
      result[mapping[field]] = null;
    }
  }

  return result;
};

var newApi = {
  rules,
  parsers: parsers$1,
};

const { iterateReports: iterateReports$1 } = utils;

function calculateMos$1(reports) {
  let jitter_time = 0;
  let recv_pkts = 0;
  let lost_pkts = 0;
  let average = 100.0;
  let packet_loss = 0.0;
  let effective_latency;
  let r_value;
  let mos;

  iterateReports$1(reports, (report) => {
    if (report.type === "inbound-rtp") {
      jitter_time = report.jitter;
      lost_pkts = report.packetsLost;
      recv_pkts = report.packetsReceived;
    }
  });

  if (recv_pkts + lost_pkts > 0) {
    packet_loss = 100.0 * (lost_pkts / (recv_pkts + lost_pkts));
  }
  effective_latency = average + jitter_time * 2 + 10;
  if (effective_latency < 160) {
    r_value = 93.2 - effective_latency / 40;
  } else {
    r_value = 93.2 - (effective_latency - 120) / 10;
  }
  r_value = r_value - packet_loss * 2.5;

  if (r_value < 1) {
    r_value = 1;
  }
  mos =
    1 + 0.035 * r_value + 0.000007 * r_value * (r_value - 60) * (100 - r_value);

  return parseFloat(mos).toFixed(6);
}

var calculateMos_1 = calculateMos$1;

const { iterateReports } = utils;
const { parsers } = newApi;
const calculateMos = calculateMos_1;

function parse(reports) {
  const result = {};

  iterateReports(reports, (report) => {
    if (report.type in parsers) {
      const mappedReport = parsers[report.type](report);

      Object.assign(result, mappedReport);
    }
  });

  result.networkMos = parseFloat(calculateMos(reports));

  return result;
}

var rtcStatsAdapter = parse;

var RTCStatsJS = clientsdkClientcore_jsExports.vonage.RTCStatsJS;
class MediaClient {
    constructor() {
        this.pcs = new Map();
        this.audio = undefined;
    }
    enableRtcStatsCollection(id, interval, closure) {
        const pc = this.pcs.get(id);
        if (!pc) {
            return closure(new clientsdkClientcore_jsExports.vonage.PeerConnectionNotFoundJS(id));
        }
        this.intervalId = setInterval(() => {
            if (pc.connectionState != 'connected') {
                clearTimeout(this.intervalId);
                return;
            }
            pc.getStats().then((result) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                const stats = rtcStatsAdapter(result);
                (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onRtcStats(id, 
                // Default values to 0 because Kotlin maps numbers to any,
                // hence undefined are allowed in this context
                new RTCStatsJS((_b = stats.audioRecvPackets) !== null && _b !== void 0 ? _b : 0, (_c = stats.audioRecvPacketsLost) !== null && _c !== void 0 ? _c : 0, (_d = stats.audioRecvBytes) !== null && _d !== void 0 ? _d : 0, (_e = stats.audioRecvJitter) !== null && _e !== void 0 ? _e : 0, (_f = stats.audioSentPackets) !== null && _f !== void 0 ? _f : 0, (_g = stats.audioSentBytes) !== null && _g !== void 0 ? _g : 0, (_h = stats.audioSentPacketsLost) !== null && _h !== void 0 ? _h : 0, (_j = stats.audioRtt) !== null && _j !== void 0 ? _j : 0, (_k = stats.audioSentJitter) !== null && _k !== void 0 ? _k : 0));
            });
        }, interval);
        closure(null);
    }
    enableMediaInbound(rtcId, offerSDP, closure) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const pc = yield this.getNewPC();
                pc.onconnectionstatechange = () => {
                    var _a;
                    (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onConnectionChange(rtcId, pc.connectionState);
                };
                this.pcs.set(rtcId, pc);
                const sdp = yield createAnswer(pc, offerSDP);
                closure(null, sdp);
            }
            catch (err) {
                const message = err instanceof Error ? err.message : null;
                closure(new clientsdkClientcore_jsExports.vonage.CreateAnswerErrorJS(message), null);
            }
        });
    }
    enableMediaOutbound(closure) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const pc = yield this.getNewPC();
                const sdp = yield createOffer(pc);
                closure(null, sdp, (legId) => {
                    this.pcs.set(legId, pc);
                    pc.onconnectionstatechange = () => {
                        var _a;
                        (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onConnectionChange(legId, pc.connectionState);
                    };
                });
            }
            catch (err) {
                const message = err instanceof Error ? err.message : null;
                closure(new clientsdkClientcore_jsExports.vonage.CreateOfferErrorJS(message), null, () => {
                    throw new Error('Callback not implemented, and should never get called');
                });
            }
        });
    }
    getNewPC() {
        return __awaiter(this, void 0, void 0, function* () {
            const pc = yield createRtcAudioConnection();
            pc.ontrack = (evt) => {
                const stream = evt.streams[0];
                if (stream) {
                    const audio = new Audio();
                    audio.srcObject = stream;
                    audio.autoplay = true;
                    this.audio = audio;
                }
            };
            return pc;
        });
    }
    mute(id, closure) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setMediaTracksEnabled(id, false);
                closure(null);
            }
            catch (err) {
                closure(new clientsdkClientcore_jsExports.vonage.TrackNotFoundJS(id));
            }
        });
    }
    unmute(id, closure) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setMediaTracksEnabled(id, true);
                closure(null);
            }
            catch (err) {
                closure(new clientsdkClientcore_jsExports.vonage.TrackNotFoundJS(id));
            }
        });
    }
    getAudioOutputElement() {
        return this.audio;
    }
    getPeerConnection(id) {
        const pc = this.pcs.get(id);
        return pc;
    }
    getMediaConnectionState(id) {
        var _a;
        const pc = this.pcs.get(id);
        return (_a = pc === null || pc === void 0 ? void 0 : pc.connectionState) !== null && _a !== void 0 ? _a : 'unknown';
    }
    // async getLocalStream(): Promise<MediaStream> {
    //   return await navigator.mediaDevices.getUserMedia({
    //     video: false,
    //     audio: true
    //   });
    // }
    processAnswer(id, sdp, closure) {
        const remoteDescription = new RTCSessionDescription({
            type: 'answer',
            sdp
        });
        const pc = this.pcs.get(id);
        if (!pc) {
            return closure(new clientsdkClientcore_jsExports.vonage.PeerConnectionNotFoundJS(id));
        }
        try {
            pc.setRemoteDescription(remoteDescription);
            closure(null);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : null;
            closure(new clientsdkClientcore_jsExports.vonage.ProcessAnswerErrorJS(id, message));
        }
    }
    disableMedia(id, closure) {
        var _a, _b;
        const pc = this.pcs.get(id);
        if (!pc) {
            // Media Already Disabled
            return closure(null);
        }
        pc.close();
        // trigger state change manually
        (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onConnectionChange(id, 'closed');
        this.pcs.delete(id);
        pc.getSenders().forEach((sender) => {
            var _a;
            (_a = sender.track) === null || _a === void 0 ? void 0 : _a.stop();
        });
        pc.getReceivers().forEach((receiver) => {
            var _a;
            (_a = receiver.track) === null || _a === void 0 ? void 0 : _a.stop();
        });
        if (this.pcs.size == 0) {
            (_b = this.audio) === null || _b === void 0 ? void 0 : _b.pause();
            this.audio = undefined;
        }
        closure(null);
    }
    disableNoiseSuppression(id, closure) {
        console.log(id);
        // TODO: Not yet implemented
        closure(null);
    }
    enableNoiseSuppression(id, closure) {
        console.log(id);
        // TODO: Not yet implemented
        closure(null);
    }
    // Private Methods
    setMediaTracksEnabled(id, value) {
        const pc = this.pcs.get(id);
        const transceiver = pc === null || pc === void 0 ? void 0 : pc.getTransceivers();
        const tracks = transceiver === null || transceiver === void 0 ? void 0 : transceiver.map((t) => t.sender.track);
        tracks === null || tracks === void 0 ? void 0 : tracks.forEach((t) => {
            if (t) {
                t.enabled = value;
            }
        });
    }
}

// import { SocketConfig } from './NexmoClient';
class SocketClient {
    setQuery(sessionId, token) {
        if (this.socket != null) {
            this.socket.io.opts.query = {
                token: token,
                session_id: sessionId
            };
        }
    }
    emit(type, msg, _callback) {
        var _a;
        (_a = this.socket) === null || _a === void 0 ? void 0 : _a.emit(type, msg);
        _callback(null, ''); // WHAT DO I NEED TODO HERE?
    }
    connect(host, path, reconnectionAttempts, reconnectionDelay, randomizationFactor, token, sessionId, query) {
        const config = {
            transports: ['websocket'],
            autoConnect: true,
            reconnection: true,
            forceNew: true,
            path,
            reconnectionAttempts,
            reconnectionDelay: reconnectionDelay * 1000,
            randomizationFactor,
            query
        };
        this.socket = socket_io.connect(host, config);
        this.token = token;
        this.sessionId = sessionId;
        this.socket.on('connect', () => {
            var _a;
            (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.didReceiveNewSocketConnectionStatusEvent(clientsdkClientcore_jsExports.vonage.SOCKET_CONNECTED, null, Date.now(), null);
        });
        this.socket.io.on('reconnect_attempt', (retry_number) => {
            var _a;
            (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.didReceiveNewSocketConnectionStatusEvent(clientsdkClientcore_jsExports.vonage.SOCKET_RECONNECTING, null, Date.now(), retry_number);
        });
        this.socket.io.on('reconnect_failed', () => {
            var _a;
            (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.didReceiveNewSocketConnectionStatusEvent(clientsdkClientcore_jsExports.vonage.SOCKET_DISCONNECTED, clientsdkClientcore_jsExports.vonage.REASON_CLIENT_NETWORK_ERROR, Date.now(), null);
        });
        this.socket.on('disconnect', (reason) => {
            var _a, _b;
            if (reason === 'io client disconnect') {
                (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.didReceiveNewSocketConnectionStatusEvent(clientsdkClientcore_jsExports.vonage.SOCKET_DISCONNECTED, clientsdkClientcore_jsExports.vonage.REASON_CLIENT_DISCONNECTED, Date.now(), null);
            }
            else if (reason === 'io server disconnect') {
                (_b = this.delegate) === null || _b === void 0 ? void 0 : _b.didReceiveNewSocketConnectionStatusEvent(clientsdkClientcore_jsExports.vonage.SOCKET_DISCONNECTED, clientsdkClientcore_jsExports.vonage.REASON_SERVER_DISCONNECTED, Date.now(), null);
            }
        });
        this.socket.io.on('packet', (packet) => {
            var _a;
            if (packet.type !== 2)
                return;
            if (packet.data[0] === 'echo')
                return; // ignore echo event
            const [type, body] = packet.data;
            // Invoke ackCallback if present
            const ackCallback = packet.data[2];
            if (ackCallback && ackCallback instanceof Function) {
                ackCallback();
            }
            if (typeof type == 'string' && body instanceof Object) {
                (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.didReceiveNewSocketEvent(JSON.stringify(Object.assign(body, { type })));
            }
        });
    }
    disconnect() {
        var _a;
        (_a = this.socket) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    startVerifyResponseTimer(milliseconds, callback) {
        setTimeout(() => {
            callback();
        }, milliseconds);
    }
    setConnectParamsSocketConfig(sessionId, token) {
        if (this.socket != null) {
            this.sessionId = sessionId;
            this.token = token;
            this.setQuery(this.sessionId, this.token);
        }
    }
    setSocketSessionId(sessionId) {
        if (this.socket != null) {
            this.sessionId = sessionId;
            this.setQuery(this.sessionId, this.token);
        }
    }
    setSocketToken(token) {
        if (this.socket != null) {
            this.token = token;
            this.setQuery(this.sessionId, this.token);
        }
    }
}

/**
 * A group of Topics that a {@link VonageLogger} can subscribe to
 */
const Topics = clientsdkClientcore_jsExports.vonage.Topics;
const Topic = clientsdkClientcore_jsExports.vonage.TopicJS;
/**
 * The Client Logging Level.
 *
 * It can be set for the internal logger via {@link ClientInitConfigObject.loggingLevel}
 * as well as for a custom logger via {@link VonageLogger.minLogLevel}.
 *
 * @enum
 */
const LoggingLevel = {
    Verbose: 'Verbose',
    Debug: 'Debug',
    Info: 'Info',
    Warn: 'Warn',
    Error: 'Error',
    Assert: 'Assert'
};
/**
 * @deprecated Use {@link ClientInitConfigObject.loggingLevel} instead.
 * @param level - The logging level to set.
 */
const setDefaultLoggingLevel = (level) => {
    clientsdkClientcore_jsExports.vonage.setDefaultLoggingLevel(level instanceof clientsdkClientcore_jsExports.vonage.LoggingLevelJS
        ? level
        : clientsdkClientcore_jsExports.vonage.LoggingLevelJS[level]);
};
/**
 * @deprecated Use {@link ClientInitConfigObject.loggingLevel} instead.
 * @param level - The logging level to set.
 */
const setVonageClientLoggingLevel = setDefaultLoggingLevel;
const convertLogger = (logger) => {
    var _a;
    if (logger.minLogLevel instanceof clientsdkClientcore_jsExports.vonage.LoggingLevelJS)
        return logger;
    return Object.assign(Object.assign({}, logger), { minLogLevel: logger.minLogLevel
            ? clientsdkClientcore_jsExports.vonage.LoggingLevelJS[logger.minLogLevel]
            : undefined, topics: (_a = logger.topics) === null || _a === void 0 ? void 0 : _a.map((topic) => topic instanceof Topics ? topic : Topics[topic]) });
};
const createVonageLogger = (name, onLog, minLogLevel, topics) => clientsdkClientcore_jsExports.vonage.createVonageLoggerJS(name, minLogLevel instanceof clientsdkClientcore_jsExports.vonage.LoggingLevelJS
    ? minLogLevel
    : minLogLevel
        ? clientsdkClientcore_jsExports.vonage.LoggingLevelJS[minLogLevel]
        : undefined, topics === null || topics === void 0 ? void 0 : topics.map((topic) => (topic instanceof Topics ? topic : Topics[topic])), (level, topic, message) => onLog(level, topic, message));

const ConfigRegion = clientsdkClientcore_jsExports.vonage.CoreClientConfigRegionJS;
class ClientConfig extends clientsdkClientcore_jsExports.vonage.CoreClientConfigJS {
    /**
     * Constructs a new instance of the class.
     *
     * @param region The region where the API and WebSocket URLs should be configured.
     *                        Valid values are "EU" (Europe), "US" (United States), or "AP" (Asia Pacific).
     *                        The URLs will be automatically set based on the selected region.
     *                        Defaults to "US" if no region is specified.
     */
    constructor(region = clientsdkClientcore_jsExports.vonage.DEFAULT_REGION) {
        super(region instanceof ConfigRegion ? region : ConfigRegion[region]);
    }
}
class ClientInitConfig {
    /**
     * Constructs a new instance of the class.
     */
    constructor(loggingLevel = clientsdkClientcore_jsExports.vonage.DEFAULT_LOGGING_LEVEL, region = clientsdkClientcore_jsExports.vonage.DEFAULT_REGION, customLoggers) {
        this.customLoggers = [];
        this.disableInternalLogger = false;
        this.loggingLevel =
            loggingLevel instanceof clientsdkClientcore_jsExports.vonage.LoggingLevelJS
                ? loggingLevel
                : clientsdkClientcore_jsExports.vonage.LoggingLevelJS[loggingLevel];
        this.region =
            region instanceof ConfigRegion ? region : ConfigRegion[region];
        if (customLoggers) {
            this.customLoggers = customLoggers.map(convertLogger);
        }
    }
}
const convertInitConfig = (config) => {
    if (config instanceof ClientInitConfig)
        return config;
    return Object.assign(Object.assign({}, config), { loggingLevel: config.loggingLevel instanceof clientsdkClientcore_jsExports.vonage.LoggingLevelJS
            ? config.loggingLevel
            : config.loggingLevel
                ? clientsdkClientcore_jsExports.vonage.LoggingLevelJS[config.loggingLevel]
                : null, region: config.region instanceof ConfigRegion
            ? config.region
            : config.region
                ? ConfigRegion[config.region]
                : null, customLoggers: config.customLoggers
            ? config.customLoggers.map(convertLogger)
            : null });
};

/**
 * The type of a {@link MemberChannel}
 *
 * @enum
 */
const ChannelType = {
    APP: 'APP',
    PHONE: 'PHONE',
    PSTN: 'PSTN',
    sip: 'sip',
    VBC: 'VBC',
    WEBSOCKET: 'WEBSOCKET',
    SMS: 'SMS',
    MMS: 'MMS',
    WHATSAPP: 'WHATSAPP',
    VIBER: 'VIBER',
    MESSENGER: 'MESSENGER'
};

const VonageError = clientsdkClientcore_jsExports.vonage.VonageErrorJS;
const VonageErrorType = clientsdkClientcore_jsExports.vonage.VonageErrorTypeJS;
const CSErrorCodes = clientsdkClientcore_jsExports.vonage.CSErrorCodesJS;
const SessionErrorCodes = clientsdkClientcore_jsExports.vonage.SessionErrorCodesJS;

/**
 * The order in which paginated objects are presented.
 * @group Chat
 * @enum
 * @property ASC Ascending order
 * @property DESC Descending order
 */
const PresentingOrder = {
    ASC: 'asc',
    DESC: 'desc'
};
/**
 * The sorting strategy used for paginated objects.
 * @group Chat
 * @enum
 */
const OrderBy = {
    CREATED: 'created',
    CUSTOM_SORT_KEY: 'custom_sort_key'
};

const Option = clientsdkClientcore_jsExports.vonage.utils.OptionJS;
const mapOption = (value) => {
    if (value == null)
        return new Option.Some(null);
    if (value == undefined)
        return new Option.None();
    return new Option.Some(value);
};
/**
 * @param value The wrapped value
 * @returns An {@link Option.Some}
 */
const some = (value) => new Option.Some(value);
/**
 *
 * @returns An {@link Option.None}
 */
const none = () => new Option.None();

/**
 * Hangup reasons for a call
 * @enum
 */
const HangupReason = {
    REMOTE_HANGUP: 'REMOTE_HANGUP',
    REMOTE_REJECT: 'REMOTE_REJECT',
    REMOTE_NO_ANSWER_TIMEOUT: 'REMOTE_NO_ANSWER_TIMEOUT',
    LOCAL_HANGUP: 'LOCAL_HANGUP',
    MEDIA_TIMEOUT: 'MEDIA_TIMEOUT'
};
/**
 * Leg status for a call
 * @enum
 */
const LegStatus = {
    RINGING: 'RINGING',
    ANSWERED: 'ANSWERED',
    COMPLETED: 'COMPLETED'
};
/**
 * Call disconnect reasons
 * @enum
 */
const CallDisconnectReason = {
    networkChange: 'networkChange'
};
/**
 * Call Invite cancel reasons
 * @enum
 */
const CancelReason = {
    RemoteCancel: 'RemoteCancel',
    RejectedElsewhere: 'RejectedElsewhere',
    RemoteTimeout: 'RemoteTimeout',
    AnsweredElsewhere: 'AnsweredElsewhere'
};
/**
 * Voice Channel Types
 * @enum
 */
const VoiceChannelType = {
    app: 'app',
    phone: 'phone',
    sip: 'sip',
    websocket: 'websocket'
};

const isKotlinType = (type, value) => value instanceof type;
// converts a js enum value to a kotlin enum value
// e.g. jsEnumToVonageObject(vonage.PresentingOrderJS, 'asc') => vonage.PresentingOrderJS.Asc
const jsEnumToVonageObject = (kotlinType, value) => {
    if (value == null)
        return null;
    if (value == undefined)
        return undefined;
    if (isKotlinType(kotlinType, value))
        return value;
    const enumVal = kotlinType[value.toUpperCase()];
    if (!enumVal) {
        console.warn(`Invalid parameter ${value}`);
    }
    return enumVal;
};

const SessionErrorReason = clientsdkClientcore_jsExports.vonage.SessionErrorReasonJS;
/**
 * VonageClient is the main entry point for the Vonage Client SDK.
 *
 * @privateRemarks
 * This class is a wrapper around the KMP `CombinedClientJS` class.
 * It provides a more JS-like API, and also provides a proxy object
 * to allow for registering callbacks via `on()`.
 *
 * Minimal Interface built on top of KMP export
 * DO NOT ADD CODE HERE UNLESS REALLY NEEDEED!!111!
 */
class VonageClient extends clientsdkClientcore_jsExports.vonage.CombinedClientJS {
    /**
     * @internal
     */
    get core() {
        return super.core;
    }
    /**
     * @internal
     */
    get media() {
        return super.media;
    }
    /**
     * @internal
     */
    get emitter() {
        return super.emitter;
    }
    /**
     * @internal
     */
    set emitter(value) {
        super.emitter = value;
    }
    constructor(config = new ClientInitConfig()) {
        super(convertInitConfig(config), new HttpClient(), new SocketClient(), new MediaClient());
        /**
         * Proxy object to allow for registering callbacks via `on()`
         * @internal
         */
        this.callbacks = new Map();
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        this.emitter = new Proxy(Object(), {
            get(_, prop) {
                // NOTE: with great power comes great responsiblity ...
                // We skip ts checks here, but enforce safety via on() generic type constraints.
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                const callbacks = _this.callbacks.get(prop) || [];
                return (...args) => {
                    // check if the event is a conversation event
                    callbacks.forEach((callback) => {
                        try {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            callback(...args);
                        }
                        catch (e) {
                            console.error(e);
                        }
                    });
                };
            }
        });
        this.setConfig(config);
    }
    /**
     * Set a configuration for the client SDK
     *
     * @example
     * [[include: snippet_SetClientConfig.txt]]
     *
     * @param config - A configuration object
     * @returns void
     */
    setConfig(config) {
        if (config instanceof ClientInitConfig || config instanceof ClientConfig) {
            super.setConfig(config);
            return;
        }
        const { region } = config, rest = __rest(config, ["region"]);
        const configRegion = region instanceof ConfigRegion
            ? region
            : region
                ? ConfigRegion[region]
                : clientsdkClientcore_jsExports.vonage.DEFAULT_REGION;
        super.setConfig(Object.assign({ region: configRegion }, rest));
    }
    /**
     * Register a callback for an event.
     *
     * @example
     * [[include: snippet_OnConversationEventListener.txt]]
     *
     * @param event - the event to register for (e.g. 'legStatusUpdate')
     * @param callback - the callback to register for the event
     * @returns a symbol that can be used to unregister the callback
     * @remarks
     * Be sure to store the symbol returned by this method so you can unregister the callback later.
     * We recommend unregistering callbacks when you no longer need them. See {@link off}.
     */
    on(event, callback) {
        const callbackSymbol = Symbol(event);
        const callbacks = this.callbacks.get(event) || new Map();
        callbacks.set(callbackSymbol, callback);
        this.callbacks.set(event, callbacks);
        return callbackSymbol;
    }
    /**
     * Unregister a callback for an event.
     *
     * @example
     * [[include: snippet_UnregisterListener.txt]]
     *
     * @param event - the event to register for (e.g. 'legStatusUpdate')
     * @param callbackSymbol - the callback symbol to unregister
     * @returns true if the callback was unregistered, false otherwise
     * @remarks
     * We recommend deregistering callbacks when you no longer need them.
     */
    off(event, callbackSymbol) {
        const callbacks = this.callbacks.get(event);
        if (!callbacks)
            return false;
        return callbacks.delete(callbackSymbol);
    }
    /**
     * Clear all callbacks for an event.
     *
     * @example
     * [[include: snippet_ClearCallbacks.txt]]
     *
     * @param event - the event to unregister from (e.g. 'legStatusUpdate')
     * @returns void
     *
     * @remarks
     * This is useful for cleaning up callbacks when you no longer need them.
     *
     */
    clearCallbacks(event) {
        const callbacks = this.callbacks.get(event);
        if (!callbacks)
            return;
        callbacks.clear();
    }
    /**
     * Create a session with a token and optional sessionId
     * If no sessionId is provided, a new one will be generated
     * and returned. If a sessionId is provided, it will be used
     * to resume an existing session.
     *
     * @example
     * [[include: snippet_SessionCreate.txt]]
     *
     * @param token
     * @param sessionId - optional sessionId to use
     * @returns the `sessionId` of the session
     */
    createSession(token, sessionId) {
        const _super = Object.create(null, {
            createSession: { get: () => super.createSession }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.createSession.call(this, token, sessionId || null);
        });
    }
    /**
     * Get the Peer Connection for a call
     *
     * @experimental
     * @group Voice
     * @param id - The Call Id
     */
    getPeerConnection(id) {
        return super.getPeerConnection(id);
    }
    /**
     * Get the HTML Audio Element for the SDK.
     * It can be used to route output to other devices.
     *
     * @experimental
     * @group Voice
     */
    getAudioOutputElement() {
        return super.getAudioOutputElement();
    }
    /**
     * Get the Leg for a call
     *
     * @group Voice
     * @param legId - The Leg Id
     */
    getLeg(legId) {
        const _super = Object.create(null, {
            getLeg: { get: () => super.getLeg }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.getLeg.call(this, legId);
        });
    }
    /**
     * Get a Call's Legs
     *
     * @example
     * [[include: snippet_GetCallLegs.txt]]
     *
     * @group Voice
     * @param id - the Call's id
     * @param parameters - A {@link GetCallLegsParameters} object containing the parameters for the request.
     * @returns a `LegsPage` containing the legs
     */
    getCallLegs(callId, parameters) {
        const _super = Object.create(null, {
            getCallLegs: { get: () => super.getCallLegs }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return (yield _super.getCallLegs.call(this, callId, Object.assign(Object.assign({}, parameters), { order: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.PresentingOrderJS, parameters === null || parameters === void 0 ? void 0 : parameters.order) })));
        });
    }
    /**
     * Make a server call to the Vonage API.
     * This is used to initiate a call using the Voice API and NCCO.
     *
     * @example
     * [[include: snippet_OutboundCall.txt]]
     *
     * @group Voice
     * @param context - the context to send to the server passed as Custom data to the voice answer webhook
     * @returns the `callId` of the call
     */
    serverCall(context) {
        const _super = Object.create(null, {
            serverCall: { get: () => super.serverCall }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.serverCall.call(this, context || null);
        });
    }
    /**
     * Hangup a call.
     *
     * @example
     * [[include: snippet_CallHangup.txt]]
     *
     * @group Voice
     * @param callId - the `callId` of the call to hangup
     * @param reasonText - optional reason text to send to the other party
     * @param reasonCode - optional reason code to send to the other party
     * @returns void
     */
    hangup(callId, reasonText, reasonCode) {
        const _super = Object.create(null, {
            hangup: { get: () => super.hangup }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.hangup.call(this, callId, reasonText || null, reasonCode || null);
        });
    }
    say(callId, params) {
        const _super = Object.create(null, {
            say: { get: () => super.say }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const defaultParams = {
                voiceName: null,
                loop: null,
                level: null,
                ssml: null,
                queue: null
            };
            return _super.say.call(this, callId, Object.assign(Object.assign({}, defaultParams), (typeof params === 'string' ? { text: params } : params)));
        });
    }
    getConversations(orderOrParams, pageSize, cursor, includeCustomData = false, orderBy) {
        const _super = Object.create(null, {
            getConversations: { get: () => super.getConversations }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (orderOrParams &&
                (typeof orderOrParams === 'string' ||
                    orderOrParams instanceof clientsdkClientcore_jsExports.vonage.PresentingOrderJS)) {
                // Handle the case where individual parameters are provided
                return (yield _super.getConversations.call(this, {
                    order: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.PresentingOrderJS, orderOrParams),
                    pageSize,
                    cursor,
                    includeCustomData,
                    orderBy: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.OrderByJS, orderBy)
                }));
            }
            // Handle the case where GetConversationsParameters object is provided
            return (yield _super.getConversations.call(this, Object.assign(Object.assign({}, orderOrParams), { order: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.PresentingOrderJS, orderOrParams === null || orderOrParams === void 0 ? void 0 : orderOrParams.order), orderBy: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.OrderByJS, orderOrParams === null || orderOrParams === void 0 ? void 0 : orderOrParams.orderBy) })));
        });
    }
    getConversationEvents(id, orderOrParams, pageSize, cursor, eventFilter, includeDeletedEvents = false, startId) {
        const _super = Object.create(null, {
            getConversationEvents: { get: () => super.getConversationEvents }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (orderOrParams &&
                (typeof orderOrParams === 'string' ||
                    orderOrParams instanceof clientsdkClientcore_jsExports.vonage.PresentingOrderJS)) {
                // Handle the case where individual parameters are provided
                return (yield _super.getConversationEvents.call(this, id, {
                    order: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.PresentingOrderJS, orderOrParams),
                    pageSize,
                    cursor,
                    eventFilter,
                    includeDeletedEvents,
                    startId
                }));
            }
            else {
                // Handle the case where GetConversationEventsParameters object is provided
                return (yield _super.getConversationEvents.call(this, id, Object.assign(Object.assign({}, orderOrParams), { order: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.PresentingOrderJS, orderOrParams === null || orderOrParams === void 0 ? void 0 : orderOrParams.order) })));
            }
        });
    }
    getConversationMembers(id, orderOrParams, pageSize, cursor) {
        const _super = Object.create(null, {
            getConversationMembers: { get: () => super.getConversationMembers }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (orderOrParams &&
                (typeof orderOrParams === 'string' ||
                    orderOrParams instanceof clientsdkClientcore_jsExports.vonage.PresentingOrderJS)) {
                // Handle the case where individual parameters are provided
                return (yield _super.getConversationMembers.call(this, id, {
                    order: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.PresentingOrderJS, orderOrParams),
                    pageSize,
                    cursor
                }));
            }
            else {
                // Handle the case where GetConversationMembersParameters object is provided
                return (yield _super.getConversationMembers.call(this, id, Object.assign(Object.assign({}, orderOrParams), { order: jsEnumToVonageObject(clientsdkClientcore_jsExports.vonage.PresentingOrderJS, orderOrParams === null || orderOrParams === void 0 ? void 0 : orderOrParams.order) })));
            }
        });
    }
    createConversation(nameOrParams, displayName) {
        const _super = Object.create(null, {
            createConversation: { get: () => super.createConversation }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof nameOrParams === 'string') {
                // Handle the case where name and displayName are provided as separate arguments
                const parameters = {
                    name: nameOrParams,
                    displayName
                };
                return _super.createConversation.call(this, parameters);
            }
            else {
                // Handle the case where a single CreateConversationParameters object is provided
                const parameters = nameOrParams !== null && nameOrParams !== void 0 ? nameOrParams : {};
                const { customData = undefined } = parameters, rest = __rest(parameters, ["customData"]);
                return _super.createConversation.call(this, Object.assign(Object.assign({}, rest), { customData: customData
                        ? typeof customData === 'string'
                            ? customData
                            : JSON.stringify(customData)
                        : undefined }));
            }
        });
    }
    /**
     * Get a Conversation
     *
     * @example
     * [[include: snippet_GetConversation.txt]]
     *
     * @param conversationIdOrName - the Conversation's id or conversation name
     * @returns the `Conversation`
     */
    getConversation(conversationIdOrName) {
        const _super = Object.create(null, {
            getConversation: { get: () => super.getConversation }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return (yield _super.getConversation.call(this, conversationIdOrName));
        });
    }
    /**
     * Updates a conversation object identified by its unique conversation ID.
     *
     * This method overrides the conversation properties to the provided parameters and rest remains as it is.
     *
     * @example
     * [[include: snippet_UpdateConversation.txt]]
     *
     * @param conversationId - the Conversation's id.
     * @param parameters - The properties of the conversation. These will replace existing values to the provided ones, rest will remain as they are.
     * @returns `conversation`, this object will contain the updated conversation properties if the update is successful.
     */
    updateConversation(conversationId, parameters) {
        const _super = Object.create(null, {
            updateConversation: { get: () => super.updateConversation }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const mappedParams = Object.entries(parameters).reduce((acc, [key, value]) => {
                if (key == 'customData' && value instanceof Option) {
                    acc[key] = value.mapNotNull((v) => typeof v == 'string' ? v : JSON.stringify(v));
                }
                else if (key == 'customData' && typeof value != 'string' && value) {
                    acc[key] = mapOption(JSON.stringify(value));
                }
                else if (value instanceof Option) {
                    acc[key] = value;
                }
                else {
                    acc[key] = mapOption(value);
                }
                return acc;
            }, {
                name: new Option.None(),
                displayName: new Option.None(),
                imageUrl: new Option.None(),
                ttl: new Option.None(),
                customSortKey: new Option.None(),
                customData: new Option.None()
            });
            return (yield _super.updateConversation.call(this, conversationId, mappedParams));
        });
    }
    /**
     * Leave a Conversation
     *
     * @example
     * [[include: snippet_LeaveConversation.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @returns void
     */
    leaveConversation(id) {
        const _super = Object.create(null, {
            leaveConversation: { get: () => super.leaveConversation }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.leaveConversation.call(this, id);
        });
    }
    /**
     * Join a Conversation
     *
     * @example
     * [[include: snippet_JoinConversation.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @returns the `memberId` of the member
     */
    joinConversation(id) {
        const _super = Object.create(null, {
            joinConversation: { get: () => super.joinConversation }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.joinConversation.call(this, id);
        });
    }
    /**
     * Delete a Conversation
     *
     * @example
     * [[include: snippet_DeleteConversation.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @returns void
     */
    deleteConversation(id) {
        const _super = Object.create(null, {
            deleteConversation: { get: () => super.deleteConversation }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.deleteConversation.call(this, id);
        });
    }
    /**
     * Invite a user to a Conversation by user's `name`
     *
     * @example
     * [[include: snippet_InviteToConversation.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param name - the name of the user to invite
     * @returns the `memberId` of the member
     */
    inviteToConversation(id, name) {
        const _super = Object.create(null, {
            inviteToConversation: { get: () => super.inviteToConversation }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.inviteToConversation.call(this, id, name);
        });
    }
    /**
     * Send a text message to a Conversation
     *
     * @example
     * [[include: snippet_SendTextMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param text - the Body of the message
     * @returns the `timestamp` of the message
     */
    sendMessageTextEvent(id, text) {
        const _super = Object.create(null, {
            sendMessageTextEvent: { get: () => super.sendMessageTextEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageTextEvent.call(this, id, text);
        });
    }
    /**
     * Send a custom message to a Conversation
     *
     * @example
     * [[include: snippet_SendCustomMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param customData - the body of the message
     * @returns the `timestamp` of the message
     */
    sendMessageCustomEvent(id, customData) {
        const _super = Object.create(null, {
            sendMessageCustomEvent: { get: () => super.sendMessageCustomEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof customData === 'string') {
                return yield _super.sendMessageCustomEvent.call(this, id, customData);
            }
            return yield _super.sendMessageCustomEvent.call(this, id, JSON.stringify(customData));
        });
    }
    /**
     * Send a Image message to a Conversation.
     *
     * @example
     * [[include: snippet_SendImageMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param imageUrl - the url of the image resource.
     * @returns the `timestamp` of the message
     */
    sendMessageImageEvent(id, imageUrl) {
        const _super = Object.create(null, {
            sendMessageImageEvent: { get: () => super.sendMessageImageEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageImageEvent.call(this, id, imageUrl);
        });
    }
    /**
     * Send a Vidoe message to a Conversation.
     *
     * @example
     * [[include: snippet_SendVideoMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param videoUrl - the url of the video resource.
     * @returns the `timestamp` of the message
     */
    sendMessageVideoEvent(id, videoUrl) {
        const _super = Object.create(null, {
            sendMessageVideoEvent: { get: () => super.sendMessageVideoEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageVideoEvent.call(this, id, videoUrl);
        });
    }
    /**
     * Send a file message to a Conversation.
     *
     * @example
     * [[include: snippet_SendFileMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param fileUrl - the url of the file resource.
     * @returns the `timestamp` of the message
     */
    sendMessageFileEvent(id, fileUrl) {
        const _super = Object.create(null, {
            sendMessageFileEvent: { get: () => super.sendMessageFileEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageFileEvent.call(this, id, fileUrl);
        });
    }
    /**
     * Send a audio message to a Conversation.
     *
     * @example
     * [[include: snippet_SendAudioMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param audioUrl - the url of the audio resource.
     * @returns the `timestamp` of the message
     */
    sendMessageAudioEvent(id, audioUrl) {
        const _super = Object.create(null, {
            sendMessageAudioEvent: { get: () => super.sendMessageAudioEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageAudioEvent.call(this, id, audioUrl);
        });
    }
    /**
     * Send a vcard message to a Conversation.
     *
     * @example
     * [[include: snippet_SendVcardMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param vCardUrl - the url of the vCardUrl resource.
     * @returns the `timestamp` of the message
     */
    sendMessageVCardEvent(id, vCardUrl) {
        const _super = Object.create(null, {
            sendMessageVCardEvent: { get: () => super.sendMessageVCardEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageVCardEvent.call(this, id, vCardUrl);
        });
    }
    /**
     * Send a Location message to a Conversation.
     *
     * @example
     * [[include: snippet_SendLocationMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param location - the description of the location.
     * @returns the `timestamp` of the message
     */
    sendMessageLocationEvent(id, location) {
        const _super = Object.create(null, {
            sendMessageLocationEvent: { get: () => super.sendMessageLocationEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageLocationEvent.call(this, id, location);
        });
    }
    /**
     * Send a template message to a Conversation.
     *
     * @example
     * [[include: snippet_SendTemplateMessage.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param whatsappObject - the description(locale and policies of business account) of the location.
     * @param templateObject - the description(name and paramters) of the template.
     * @returns the `timestamp` of the message
     */
    sendMessageTemplateEvent(id, templateObject, whatsappObject) {
        const _super = Object.create(null, {
            sendMessageTemplateEvent: { get: () => super.sendMessageTemplateEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageTemplateEvent.call(this, id, templateObject, whatsappObject);
        });
    }
    /**
     * Send an ephemeral event to a Conversation
     *
     * @example
     * [[include: snippet_SendEphemeralEvent.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param customData - the body of the event
     * @returns the `timestamp` of the message
     */
    sendEphemeralEvent(id, customData) {
        const _super = Object.create(null, {
            sendEphemeralEvent: { get: () => super.sendEphemeralEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof customData === 'string') {
                return yield _super.sendEphemeralEvent.call(this, id, customData);
            }
            return yield _super.sendEphemeralEvent.call(this, id, JSON.stringify(customData));
        });
    }
    /**
     * Send a Custom event to a Conversation
     *
     * @example
     * [[include: snippet_SendCustomEvent.txt]]
     *
     * @group Chat
     * @param id - the Conversation's id
     * @param evenType - the type of the custom event. Type must start with `custom:<...>`
     * @param customData - the body of the event
     * @returns the `timestamp` of the message
     */
    sendCustomEvent(id, eventType, customData) {
        const _super = Object.create(null, {
            sendCustomEvent: { get: () => super.sendCustomEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof customData === 'string') {
                return yield _super.sendCustomEvent.call(this, id, eventType, customData);
            }
            return yield _super.sendCustomEvent.call(this, id, eventType, JSON.stringify(customData));
        });
    }
    /**
     * Delete an Event in a Conversation
     *
     * @example
     * [[include:snippet_DeleteEvent.txt]]
     *
     * @group Chat
     * @param id - the id for the Event to be deleted
     * @param conversationId - the id for the conversation, the event belongs to.
     * @returns void
     */
    deleteEvent(id, conversationId) {
        const _super = Object.create(null, {
            deleteEvent: { get: () => super.deleteEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.deleteEvent.call(this, id, conversationId);
        });
    }
    /**
     * Send a message seen event to a Conversation
     *
     * @example
     * [[include: snippet_SendMessageSeenEvent.txt]]
     *
     * @group Chat
     * @param id - the event id
     * @param conversationId - the conversation id
     * @returns the `timestamp` of the message
     */
    sendMessageSeenEvent(id, conversationId) {
        const _super = Object.create(null, {
            sendMessageSeenEvent: { get: () => super.sendMessageSeenEvent }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.sendMessageSeenEvent.call(this, id, conversationId);
        });
    }
}

export { CSErrorCodes, CallDisconnectReason, CancelReason, ChannelType, ClientConfig, ClientInitConfig, ConfigRegion, HangupReason, LegStatus, LoggingLevel, Option, OrderBy, PresentingOrder, SessionErrorCodes, SessionErrorReason, Topics, VoiceChannelType, VonageClient, VonageError, VonageErrorType, convertInitConfig, createVonageLogger, VonageClient as default, mapOption, none, setDefaultLoggingLevel, setVonageClientLoggingLevel, some };
